import React__default, { Component, createContext, Fragment, cloneElement, PureComponent } from 'react';
import { Icon, Popup, Grid, Dropdown, Search, Table, Input as Input$1, Checkbox, Radio, Button, List, Message, Form, TextArea, Modal, Segment, Dimmer, Loader, Image, Statistic, Label, Select, Confirm, Header, Accordion, Menu, Container, Tab, Card, CardContent, CardHeader, CardDescription, FormGroup } from 'semantic-ui-react';
import _$1, { get, isEmpty, isString, isUndefined, isEqual, isBoolean, set, upperFirst, lowerCase, debounce, isArray, groupBy, split, cloneDeep, find } from 'lodash-es';
import axios from 'axios';
import moment from 'moment-timezone';
import { Input, RadioGroup, RadioButton } from 'kx-common-components';
import moment$1 from 'moment';
import 'react-semantic-ui-datepickers';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { isValid, parse } from 'date-fns';
import { Document, Page, pdfjs } from 'react-pdf';
import ReactModal from 'react-modal';
import GoogleMap from 'google-map-react';
import 'react-dom';

// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' ||
// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".drayage_short_table {\n  text-align: left;\n  width: 100%;\n  margin-top: 5px;\n  border-bottom: 2px solid #B9B8B9;\n  text-transform: uppercase; }\n  .drayage_short_table tr:not(.drayage_short_table_header) td {\n    color: #2F4A97;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 16px;\n    word-break: break-word !important;\n    padding-right: 14px; }\n  .drayage_short_table tr:not(.drayage_short_table_header) td:first-child {\n    padding-left: 10px; }\n\n.drayage_short_table_header {\n  background-color: #F1F0F2;\n  opacity: 0.69;\n  color: #5C5C5C;\n  font-size: 9px;\n  letter-spacing: 0;\n  line-height: 23px; }\n  .drayage_short_table_header th {\n    height: 23px !important;\n    font-size: 9px !important;\n    text-transform: uppercase; }\n  .drayage_short_table_header .stop-svg-icon {\n    width: 20px;\n    margin-left: 5px; }\n";
styleInject(css_248z);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var RepeatingHeaderTable = function (_React$Component) {
  inherits(RepeatingHeaderTable, _React$Component);

  function RepeatingHeaderTable(props) {
    classCallCheck(this, RepeatingHeaderTable);

    var _this = possibleConstructorReturn(this, (RepeatingHeaderTable.__proto__ || Object.getPrototypeOf(RepeatingHeaderTable)).call(this, props));

    _this.state = {
      selectedShipmentID: ""
    };
    return _this;
  }

  createClass(RepeatingHeaderTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          header = _props.header,
          icon = _props.icon,
          isHypercare = _props.isHypercare;

      var data = this.props.data && [this.props.data[0]] || [];
      var warning = this.props.data && this.props.data[1] || "";

      var inconsistentShipmentId = this.props.data && this.props.data[2] || "";

      return data.map(function (item, index1) {
        return React__default.createElement(
          "table",
          {
            className: "drayage_short_table",
            style: get(_this2.props, "isHot", false) ? { border: "3px solid red" } : null,
            onClick: function onClick(e) {
              var hightedAlready = document.querySelector(".highlight_background");
              if (hightedAlready) hightedAlready.classList.remove("highlight_background");
              e.target.closest("table").classList.add("highlight_background");

              _this2.props.onTableClick(data[index1][0], data[index1][4]);
            }
          },
          React__default.createElement(
            "tr",
            { className: "drayage_short_table_header" },
            header.map(function (item, index2) {
              return React__default.createElement(
                "td",
                { className: "drayage_short_table_header_P44" },
                (header[index2] == "P44 ETA" || header[index2] == "P44 ATA") && icon ? React__default.createElement(
                  "div",
                  { style: { display: "flex" } },
                  header[index2],
                  icon
                ) : header[index2]
              );
            })
          ),
          warning && React__default.createElement(
            "span",
            {
              className: "ui warning-sign",
              "data-tooltip": "Vessel names do not match.",
              "data-position": "top left"
            },
            React__default.createElement(Icon, { name: "warning sign", color: "red" })
          ),
          data[index1][0] === inconsistentShipmentId && React__default.createElement(
            "span",
            {
              className: "inconsistancy-warning",
              "data-tooltip": "Inconsistency in tt-eta",
              "data-position": "top left"
            },
            React__default.createElement(Icon, { name: "warning sign", color: "red" })
          ),
          isHypercare && React__default.createElement(
            "span",
            {
              className: "ui hypercare-sign",
              "data-tooltip": "HyperCare Shipment",
              "data-position": "top left"
            },
            React__default.createElement(Icon, { name: "heartbeat", color: "red" })
          ),
          React__default.createElement(
            "tr",
            null,
            data[index1].map(function (item, index2) {
              return React__default.createElement(
                "td",
                null,
                data[index1][index2]
              );
            })
          ),
          React__default.createElement(
            "svg",
            {
              onClick: function onClick() {
                _this2.setState({ selectedShipmentID: item[0] }, function () {
                  _this2.props.historyModalClick(item[0]);
                });
              },
              style: { position: "absolute", top: "25px", left: "-30" },
              xmlns: "http://www.w3.org/2000/svg",
              height: "16px",
              viewBox: "0 0 24 24",
              width: "24px",
              fill: "#000000"
            },
            React__default.createElement(
              "title",
              null,
              "Modification history"
            ),
            React__default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
            React__default.createElement("path", { d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" })
          )
        );
      });
    }
  }]);
  return RepeatingHeaderTable;
}(React__default.Component);

var css_248z$1 = ".accordian_item_title {\n  width: calc( 20% - 26px);\n  color: #020303;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0.9px;\n  line-height: 21px;\n  display: flex; }\n\n.accordian_item_imo {\n  margin-left: 10px; }\n\n.accordian_item_imo:hover {\n  color: #fff;\n  background-color: #2F4A97; }\n\n.accordian_item_header {\n  text-transform: uppercase;\n  display: flex;\n  flex-direction: row;\n  cursor: pointer;\n  border-bottom: 1px solid #B9B8B9; }\n\n.accordian_item_heading_wrapper {\n  display: flex;\n  width: 80%;\n  flex-direction: row;\n  justify-content: space-between; }\n\n.drayage_accordian_body {\n  display: flex;\n  flex-direction: row;\n  max-height: 0;\n  transition: max-height 0.15s ease-out;\n  overflow: hidden; }\n  .drayage_accordian_body.blockDisplay {\n    display: block; }\n\n.accordian_item_header.expanded + .drayage_accordian_body {\n  max-height: 8800px;\n  transition: max-height 0.5s ease-in;\n  overflow-y: auto; }\n\ni.minus.outline, i.plus.outline {\n  float: left;\n  color: #1A9699;\n  margin-right: 10px;\n  margin-top: 3px; }\n\n.drayage_accordian_item {\n  margin-bottom: 15px; }\n\n.error_msg {\n  color: red;\n  margin-left: 20px;\n  font-size: 12px; }\n\n.accordian_item_header[data-shipmentcount=\"0\"] {\n  filter: grayscale(1); }\n";
styleInject(css_248z$1);

var Accordian = function (_React$Component) {
  inherits(Accordian, _React$Component);

  function Accordian(props) {
    classCallCheck(this, Accordian);

    var _this = possibleConstructorReturn(this, (Accordian.__proto__ || Object.getPrototypeOf(Accordian)).call(this, props));

    _this.state = {
      accordianState: props.accordianState
    };
    return _this;
  }

  // makeArray = (index) => {
  //     let {accordianState} = this.state;
  //     accordianState[index] = !accordianState[index];
  //     return (accordianState);
  // }

  createClass(Accordian, [{
    key: "onClick",
    value: function onClick() {
      var shipmentCount = this.props.shipmentCount;

      if (!shipmentCount) return;
      var _props = this.props,
          index = _props.index,
          toggleAccordian = _props.toggleAccordian,
          accordianState = _props.accordianState;

      this.setState({ accordianState: !accordianState });
      toggleAccordian(index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          accordianBody = _props2.accordianBody,
          accordianHeader = _props2.accordianHeader,
          accordianTitle = _props2.accordianTitle,
          loading = _props2.loading,
          noPorts = _props2.noPorts,
          shipmentCount = _props2.shipmentCount,
          _props2$additionalBod = _props2.additionalBodyClass,
          additionalBodyClass = _props2$additionalBod === undefined ? "" : _props2$additionalBod,
          inconsistent = _props2.inconsistent,
          hasP44VesselDiff = _props2.hasP44VesselDiff,
          hasP44EtaTtEtaDiff = _props2.hasP44EtaTtEtaDiff,
          isP44Tracking = _props2.isP44Tracking,
          isP44EtaDiff = _props2.isP44EtaDiff,
          isP44EtdDiff = _props2.isP44EtdDiff,
          hasP44EtdTtEtdDiff = _props2.hasP44EtdTtEtdDiff,
          imo = _props2.imo,
          isHot = _props2.isHot,
          isHypercare = _props2.isHypercare;
      var accordianState = this.state.accordianState;

      return React__default.createElement(
        "div",
        { className: "drayage_accordian_item" },
        React__default.createElement(
          "div",
          {
            "data-shipmentCount": shipmentCount ? shipmentCount : 0,
            className: "accordian_item_header" + (accordianState ? " expanded" : " collapsed"),
            onClick: function onClick() {
              return _this2.onClick();
            }
          },
          shipmentCount && !loading && accordianState && React__default.createElement(Icon, { name: "minus square outline" }),
          (!shipmentCount || !loading && !accordianState) && React__default.createElement(Icon, { name: "plus square outline" }),
          shipmentCount && loading && React__default.createElement("img", {
            src: "/images/loader.gif",
            style: { width: "20px", marginRight: "6px" },
            alt: ""
          }),
          React__default.createElement(
            "div",
            { className: "accordian_item_title", style: isHot ? { color: "red" } : null },
            accordianTitle,
            React__default.createElement(
              "span",
              {
                className: "accordian_item_imo",
                onClick: function onClick() {
                  return window.open("https://www.marinetraffic.com/en/ais/details/ships/imo:" + imo, '_blank');
                }
              },
              "(" + imo + ")"
            ),
            hasP44VesselDiff,
            " ",
            hasP44EtaTtEtaDiff,
            " ",
            isP44Tracking,
            " ",
            isP44EtaDiff,
            " ",
            isP44EtdDiff,
            " ",
            hasP44EtdTtEtdDiff,
            inconsistent && React__default.createElement(
              "span",
              { className: "error_msg",
                "data-tooltip": "Inconsistency in tt-eta",
                "data-position": "top left" },
              React__default.createElement(Icon, { name: "warning sign" })
            ),
            !shipmentCount && React__default.createElement(
              "span",
              { className: "error_msg" },
              React__default.createElement(Icon, { name: "warning sign" }),
              " No current shipments"
            ),
            isHypercare && React__default.createElement(
              "span",
              { "data-tooltip": "HyperCare", "data-position": "top left" },
              React__default.createElement(Icon, { name: "heartbeat", color: "red" })
            )
          ),
          React__default.createElement(
            "div",
            { className: "accordian_item_heading_wrapper" },
            accordianHeader
          )
        ),
        React__default.createElement(
          "div",
          { className: "drayage_accordian_body " + additionalBodyClass },
          this.props.accordianBody
        )
      );
    }
  }]);
  return Accordian;
}(React__default.Component);

var css_248z$2 = ".small_accordian_body {\n  display: flex;\n  flex-direction: row;\n  max-height: 0;\n  transition: max-height 0.15s ease-out;\n  overflow: hidden; }\n\n.small_accordian_header.expanded + .small_accordian_body {\n  max-height: 1000px;\n  transition: max-height 0.5s ease-in; }\n\n.expand_collapse {\n  margin: 4px 10px 20px;\n  display: block;\n  text-align: center;\n  text-transform: none; }\n";
styleInject(css_248z$2);

var SmallAccordian = function (_React$Component) {
  inherits(SmallAccordian, _React$Component);

  function SmallAccordian(props) {
    classCallCheck(this, SmallAccordian);

    var _this = possibleConstructorReturn(this, (SmallAccordian.__proto__ || Object.getPrototypeOf(SmallAccordian)).call(this, props));

    _this.state = {
      smallAccordianState: false
    };
    return _this;
  }

  // makeArray = (index) => {
  //     let {accordianState} = this.state;
  //     accordianState[index] = !accordianState[index];
  //     return (accordianState);
  // }

  createClass(SmallAccordian, [{
    key: "onClick",
    value: function onClick() {
      var _state = this.state,
          index = _state.index,
          toggleAccordian = _state.toggleAccordian,
          smallAccordianState = _state.smallAccordianState;

      this.setState({ smallAccordianState: !smallAccordianState });
      // toggleAccordian(index)
    }

    // checkIfExpandable(key) {
    //     console.log("key", key, document.querySelector(`[data-key='${key}'] [data-type="expandable"] tbody tr`))
    //     return 1
    //     // return document.querySelector(`[data-key='${key}'] [data-type="expandable"] tbody tr`).length > 0
    // }

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          smallAccordianBody = _props.smallAccordianBody,
          smallAccordianHeader = _props.smallAccordianHeader;
      var smallAccordianState = this.state.smallAccordianState;

      return React__default.createElement(
        "div",
        { className: "small_accordian", "data-key": this.props.id },
        React__default.createElement(
          "div",
          {
            className: "small_accordian_header" + (smallAccordianState ? " expanded" : " collapsed"),
            onClick: function onClick() {
              return _this2.onClick();
            }
          },
          React__default.createElement(
            "div",
            { className: "small_accordian_title" },
            smallAccordianHeader
          )
        ),
        React__default.createElement(
          "div",
          { className: "small_accordian_body", "data-type": "expandable" },
          smallAccordianBody
        ),
        this.props.count > 0 && React__default.createElement(
          "a",
          {
            href: "/#",
            className: "expand_collapse",
            onClick: function onClick() {
              return _this2.onClick();
            }
          },
          smallAccordianState ? "Hide Details" : "Show Details"
        )
      );
    }
  }]);
  return SmallAccordian;
}(React__default.Component);

var css_248z$3 = ".smart_accordian {\n  /* temp */\n  /* form input */\n  /* Form */\n  /* bid selection modal */\n  /* might need to remove */ }\n  .smart_accordian body,\n  .smart_accordian h1,\n  .smart_accordian h2,\n  .smart_accordian h3,\n  .smart_accordian h4,\n  .smart_accordian h5,\n  .smart_accordian h6 {\n    font-family: \"Open Sans\", sans-serif !important; }\n  .smart_accordian .sm_accordian_others {\n    border: 1px solid #dcdcdc; }\n  .smart_accordian .sm_accordian_item {\n    box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5);\n    border-radius: 3px;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    background-color: white;\n    margin: 0 10px; }\n  .smart_accordian .sm_accordian_header {\n    display: flex; }\n    .smart_accordian .sm_accordian_header h1 {\n      margin: 0 !important;\n      font-size: 24px; }\n  .smart_accordian .arrow_icon {\n    line-height: 63px;\n    margin: 15px 16px 15px 22px; }\n  .smart_accordian .sm_subheading {\n    display: flex;\n    color: #969696;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16px; }\n    .smart_accordian .sm_subheading .date2 {\n      margin-left: 30px; }\n  .smart_accordian .text_section {\n    width: calc(80% - 58px);\n    padding-top: 14px; }\n  .smart_accordian .views_section {\n    width: 20%; }\n    .smart_accordian .views_section .views_line {\n      color: #6c6d6e;\n      font-size: 12px;\n      margin-top: 8px; }\n  .smart_accordian .smart_label {\n    line-height: 21px;\n    color: #fbfbfb;\n    font-size: 18px;\n    letter-spacing: 0;\n    border-radius: 2px;\n    background-color: #2e6cc2;\n    font-weight: bold;\n    padding: 2px 6px;\n    width: max-content; }\n  .smart_accordian h1 {\n    color: #000000;\n    font-size: 15px;\n    font-weight: bold;\n    line-height: 20px;\n    text-transform: capitalize; }\n  .smart_accordian .sm_accordian_expansion {\n    padding: 10px 58px; }\n    .smart_accordian .sm_accordian_expansion .results.transition {\n      max-height: 250px;\n      overflow: auto;\n      width: 100%; }\n    .smart_accordian .sm_accordian_expansion #customerName {\n      border-radius: 2px;\n      border: 1px solid #1765ae; }\n  .smart_accordian .single_destination {\n    background-color: #f1f1f1;\n    padding: 10px 20px;\n    margin-top: 10px; }\n  .smart_accordian .custom_delivery_address,\n  .smart_accordian .bidding_info {\n    background-color: #fff; }\n  .smart_accordian .address-flex-row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%; }\n  .smart_accordian .address-flex-row .close.icon {\n    display: none; }\n  .smart_accordian .address-text-input-conatiner {\n    display: flex;\n    flex-direction: column;\n    margin-left: 50px; }\n  .smart_accordian .address-text-input {\n    font-size: 14px;\n    font-weight: 600;\n    height: 22px;\n    color: #000000;\n    letter-spacing: 1.14px;\n    border-width: 0px !important;\n    margin-top: 2px;\n    height: 25px !important;\n    background-color: #f0f4ff !important;\n    width: 320px; }\n  .smart_accordian #portNameSearch,\n  .smart_accordian #delAddressSearch {\n    border-radius: 2px;\n    border: 1px solid #1765ae; }\n  .smart_accordian .portNameDD .results {\n    height: 400px;\n    overflow: auto; }\n  .smart_accordian .portNameDD > div {\n    width: 100%;\n    margin-bottom: 10px; }\n  .smart_accordian .delAddressDD > div {\n    width: 100%; }\n  .smart_accordian .submit_address {\n    float: right; }\n  .smart_accordian .select_custom_add {\n    text-transform: none !important;\n    display: block;\n    margin-bottom: 10px; }\n    .smart_accordian .select_custom_add a {\n      text-transform: uppercase; }\n  .smart_accordian .marketplace-wrapper .marketplace-map-wrapper {\n    display: none; }\n  .smart_accordian .drayage_form .column {\n    border: 1px solid #286084;\n    border-radius: 2px 0 0 0; }\n    .smart_accordian .drayage_form .column .field,\n    .smart_accordian .drayage_form .column .input,\n    .smart_accordian .drayage_form .column textarea {\n      width: 100% !important; }\n    .smart_accordian .drayage_form .column input,\n    .smart_accordian .drayage_form .column textarea {\n      border: 0 !important; }\n    .smart_accordian .drayage_form .column textarea {\n      height: 68px; }\n    .smart_accordian .drayage_form .column .close.icon {\n      display: none; }\n    .smart_accordian .drayage_form .column > div > div:first-child {\n      color: #606060;\n      font-size: 12px;\n      font-weight: 500;\n      line-height: 17px;\n      font-size: 12px !important;\n      padding-left: 10px; }\n    .smart_accordian .drayage_form .column > [label] {\n      padding: 0 6px; }\n      .smart_accordian .drayage_form .column > [label] > [label]:first-child {\n        color: #606060;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 17px; }\n      .smart_accordian .drayage_form .column > [label] > [label]:nth-child(2) {\n        padding-top: 0 !important; }\n        .smart_accordian .drayage_form .column > [label] > [label]:nth-child(2) [label]:first-child {\n          margin-right: -42px; }\n      .smart_accordian .drayage_form .column > [label] input[type=\"radio\"] + label {\n        color: #000000;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 22px; }\n    .smart_accordian .drayage_form .column input[type=\"text\"] {\n      background-color: #f0f4ff;\n      margin: 22px 0px 3px 0px;\n      padding: 0;\n      height: 19px;\n      z-index: 2;\n      max-width: 100%; }\n  .smart_accordian .form_heading {\n    color: #606060;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 17px; }\n  .smart_accordian .add_destination,\n  .smart_accordian .add_port,\n  .smart_accordian .select_from_dropdown {\n    color: #1765ae;\n    cursor: pointer; }\n    .smart_accordian .add_destination img,\n    .smart_accordian .add_port img,\n    .smart_accordian .select_from_dropdown img {\n      margin-right: 6px;\n      position: relative;\n      top: 2px; }\n  .smart_accordian .add_destination {\n    display: block;\n    margin-top: 10px; }\n  .smart_accordian .add_port {\n    margin-bottom: 10px;\n    display: block;\n    margin: 5px 10px 10px 15px; }\n  .smart_accordian .custom_delivery_address {\n    border: 1px solid #1765ae; }\n  .smart_accordian .tab_wrapper {\n    width: 1034px; }\n  .smart_accordian .simpleButton {\n    padding: 15px 38px;\n    border: none;\n    font-size: 16px;\n    letter-spacing: 0.53px;\n    box-sizing: border-box;\n    border-radius: 3px;\n    text-transform: uppercase;\n    color: #008b8f;\n    font-weight: 500;\n    margin: 3px !important;\n    cursor: pointer;\n    font-family: \"Open Sans\", sans-serif !important; }\n  .smart_accordian .primaryButton {\n    line-height: 19px;\n    color: white;\n    background-color: #0a8b8f; }\n  .smart_accordian .secondaryButton {\n    line-height: 15px;\n    box-sizing: border-box;\n    background-color: #ffffff;\n    padding: 15px 36px;\n    border: 2px solid #008b8f;\n    margin-left: 20px !important; }\n  .smart_accordian .smallButton {\n    height: 14px;\n    line-height: 0px;\n    font-size: 13px;\n    padding: 13px; }\n  .smart_accordian .floating_label {\n    position: absolute;\n    color: #606060;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 17px;\n    margin: 2px 0 0 7px; }\n  .smart_accordian .floating_label-cust {\n    position: absolute;\n    color: #606060;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 17px;\n    margin: 2px 0 0 7px;\n    left: 0;\n    top: unset;\n    right: unset;\n    left: unset;\n    top: 238px; }\n  .smart_accordian .drayage_form .opportunity_dates_wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n    .smart_accordian .drayage_form .opportunity_dates_wrapper .opportunity_dates {\n      flex-grow: 1;\n      position: relative;\n      border: 1px solid #286084;\n      border-radius: 2px 0 0 0; }\n      .smart_accordian .drayage_form .opportunity_dates_wrapper .opportunity_dates label {\n        z-index: 2; }\n      .smart_accordian .drayage_form .opportunity_dates_wrapper .opportunity_dates .field {\n        width: 100%; }\n        .smart_accordian .drayage_form .opportunity_dates_wrapper .opportunity_dates .field .ui.icon.input i.icon {\n          top: -12px; }\n        .smart_accordian .drayage_form .opportunity_dates_wrapper .opportunity_dates .field .ui.input {\n          width: 100%; }\n          .smart_accordian .drayage_form .opportunity_dates_wrapper .opportunity_dates .field .ui.input input {\n            border: none; }\n  .smart_accordian .drayage_form .column.computer textarea {\n    margin-top: 20px;\n    font-style: normal;\n    margin-left: 7px;\n    width: calc(100% - 20px) !important; }\n  .smart_accordian .drayage_form .calendar.icon {\n    height: 20px !important;\n    margin-top: 22px !important;\n    margin-right: 4px !important; }\n  .smart_accordian .drayage_form input {\n    color: #000000;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 22px; }\n  .smart_accordian .submission_status {\n    color: black;\n    margin: 20px auto;\n    position: absolute;\n    top: calc(50% - 50px);\n    background-color: #ccc;\n    font-weight: bold;\n    font-size: 20px;\n    padding: 22px;\n    width: 263px;\n    text-align: center;\n    line-height: 26px;\n    border-radius: 5px;\n    left: calc(50% - 132px);\n    border: 2px solid black; }\n  .smart_accordian .sales_app .marketplace-wrapper {\n    position: relative; }\n  .smart_accordian .delete_portdestination {\n    display: block;\n    clear: both;\n    cursor: pointer; }\n    .smart_accordian .delete_portdestination p {\n      position: relative;\n      top: 6px;\n      text-transform: capitalize; }\n    .smart_accordian .delete_portdestination img {\n      margin: 4px;\n      height: 26px;\n      width: 26px;\n      padding: 4px;\n      border: 1px solid #1765ae;\n      border-radius: 12.5px;\n      background-color: #ffffff;\n      float: left; }\n  .smart_accordian .selection.dropdown {\n    box-sizing: border-box;\n    height: 41px;\n    border: 1px solid #1765ae !important;\n    border-radius: 0 !important; }\n  .smart_accordian .bidSelectionModal_inner {\n    height: 100%;\n    position: relative; }\n    .smart_accordian .bidSelectionModal_inner .bid-logo {\n      position: absolute;\n      top: -44px;\n      left: 50%;\n      transform: translateX(-50%); }\n  .smart_accordian .closeModal {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    color: #008b8f; }\n  .smart_accordian .submitted_successfully {\n    color: red; }\n  .smart_accordian .bidSelectionModal {\n    width: calc(100% - 300px);\n    min-width: 1200px;\n    max-height: 75%;\n    position: absolute;\n    top: 20%;\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: 6px;\n    background-color: #ffffff;\n    box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5); }\n    .smart_accordian .bidSelectionModal td + td {\n      width: auto; }\n    .smart_accordian .bidSelectionModal::-webkit-scrollbar-track {\n      box-shadow: inset 0 0 5px grey;\n      border-radius: 6px; }\n    .smart_accordian .bidSelectionModal h1 {\n      text-align: center;\n      margin: 20px 0;\n      font-size: 20px;\n      font-weight: 600; }\n    .smart_accordian .bidSelectionModal .modal_close_icon {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      color: #008b8f;\n      font-size: 20px;\n      cursor: pointer; }\n    .smart_accordian .bidSelectionModal .bidSelectionModal_inner {\n      padding: 34px; }\n    .smart_accordian .bidSelectionModal tbody > tr td:nth-child(n + 3) {\n      background-color: #d8dfe8;\n      border-bottom: 3px solid white;\n      height: 50px; }\n    .smart_accordian .bidSelectionModal table {\n      width: 100%;\n      border-collapse: collapse; }\n    .smart_accordian .bidSelectionModal thead {\n      height: 48px;\n      vertical-align: baseline;\n      text-align: center; }\n    .smart_accordian .bidSelectionModal .port_row {\n      position: relative;\n      display: flex;\n      height: 56px; }\n      .smart_accordian .bidSelectionModal .port_row > img:first-child {\n        width: 48px;\n        padding: 8px 16px 0px; }\n      .smart_accordian .bidSelectionModal .port_row .arrow-img {\n        position: absolute;\n        top: 10px;\n        right: 5px;\n        cursor: pointer; }\n    .smart_accordian .bidSelectionModal td {\n      font-weight: bold;\n      text-align: center; }\n      .smart_accordian .bidSelectionModal td .ui.dropdown {\n        width: 64px;\n        border: 1px solid #286084;\n        padding: 5px;\n        height: 26px !important;\n        min-height: auto;\n        margin: auto;\n        border-radius: 0px;\n        font-size: 14px; }\n      .smart_accordian .bidSelectionModal td .dropdown.icon {\n        padding: 5px !important; }\n    .smart_accordian .bidSelectionModal th:nth-child(1) img,\n    .smart_accordian .bidSelectionModal td:nth-child(1) img {\n      width: 48px;\n      padding: 0px 16px; }\n    .smart_accordian .bidSelectionModal th:nth-child(2),\n    .smart_accordian .bidSelectionModal td:nth-child(2) {\n      text-align: left; }\n    .smart_accordian .bidSelectionModal td:nth-child(7) {\n      background-color: rgba(17, 88, 186, 0.35) !important; }\n    .smart_accordian .bidSelectionModal td:nth-child(9) {\n      background-color: #1158ba !important;\n      color: white; }\n    .smart_accordian .bidSelectionModal .big_label {\n      font-size: 24px;\n      font-weight: bold; }\n    .smart_accordian .bidSelectionModal .light_label {\n      color: #818181;\n      font-size: 11px; }\n    .smart_accordian .bidSelectionModal .bid_dest_label {\n      font-size: 18px;\n      font-weight: bold; }\n  .smart_accordian .primary_button_d {\n    border-radius: 3px;\n    background-color: #008b8f;\n    padding: 11px 30px;\n    color: white;\n    text-transform: uppercase;\n    border: 0;\n    cursor: pointer;\n    margin: 20px; }\n  .smart_accordian .secondary_button_d {\n    border: 1px solid #01a1a5;\n    border-radius: 2px;\n    background-color: #ffffff;\n    padding: 10px 30px;\n    text-transform: uppercase;\n    margin: 20px;\n    color: #077c7f;\n    cursor: pointer; }\n  .smart_accordian .port_accordian {\n    border: 1px solid #dcdcdc;\n    border-radius: 3px;\n    background-color: #ffffff;\n    padding: 0px 5px 0px 20px; }\n  .smart_accordian .custom_label {\n    color: #606060;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 17px;\n    margin-left: 5px; }\n  .smart_accordian .drayage_form .ui.dropdown {\n    padding: 0 !important;\n    border: 0 !important;\n    background-color: #f0f4ff !important;\n    margin-left: 6px;\n    width: calc(100% - 12px) !important;\n    height: 21px;\n    padding-left: 8px !important;\n    min-height: auto !important;\n    line-height: 21px !important; }\n  .smart_accordian .drayage_form .dropdown.icon {\n    padding: 4px !important; }\n  .smart_accordian .including_kn_margin {\n    display: block;\n    font-weight: normal;\n    font-size: 10px;\n    color: red;\n    padding: 0px; }\n  .smart_accordian .per_cont {\n    display: block;\n    font-weight: normal;\n    font-size: 12px;\n    color: #6c6d6e;\n    padding: 0px; }\n  .smart_accordian .port_accordian {\n    margin-top: 10px; }\n  .smart_accordian [data-tab-container=\"SALES_ACCEPTED\"] [bid-status-sales=\"SALES_ACCEPTED\"] .partner-bid,\n  .smart_accordian [data-tab-container=\"SALES_ACCEPTED\"] [bid-status-sales=\"SALES_ACCEPTED\"] .partner-bid-total,\n  .smart_accordian [data-tab-container=\"SALES_ACCEPTED\"] [bid-status-customer=\"CUSTOMER_ACCEPTED\"] .partner-bid,\n  .smart_accordian [data-tab-container=\"SALES_ACCEPTED\"] [bid-status-customer=\"CUSTOMER_ACCEPTED\"] .partner-bid-total {\n    border: 1px solid #2dab1a; }\n  .smart_accordian [data-tab-container=\"SALES_REJECTED\"] [bid-status-sales=\"SALES_REJECTED\"] .partner-bid,\n  .smart_accordian [data-tab-container=\"SALES_REJECTED\"] [bid-status-sales=\"SALES_REJECTED\"] .partner-bid-total,\n  .smart_accordian [data-tab-container=\"SALES_REJECTED\"] [bid-status-customer=\"CUSTOMER_REJECTED\"] .partner-bid,\n  .smart_accordian [data-tab-container=\"SALES_REJECTED\"] [bid-status-customer=\"CUSTOMER_REJECTED\"] .partner-bid-total {\n    border: 1px solid #ff9494 !important;\n    background-color: #edc7be !important; }\n  .smart_accordian [data-tab-container=\"SALES_ARCHIVED\"] .expiry-date {\n    font-weight: bold;\n    color: #de0f0f; }\n  .smart_accordian .customerAccepted,\n  .smart_accordian .customerRejected {\n    font-size: 12px;\n    font-weight: bold;\n    width: 100%;\n    height: 16px;\n    overflow: hidden;\n    top: -16px;\n    line-height: 16px;\n    position: relative;\n    background-color: rgba(0, 0, 0, 0.08); }\n  .smart_accordian .customerAccepted {\n    color: #1ea507; }\n  .smart_accordian .customerRejected {\n    color: #fa0707; }\n  .smart_accordian .lowest-bid {\n    background-color: #fff5c9 !important; }\n  .smart_accordian .low_bid_arrow {\n    position: absolute;\n    bottom: 5px;\n    right: 0;\n    color: #65e181 !important; }\n  .smart_accordian .sales_app .marketplace-wrapper {\n    padding: 10px 26px; }\n  .smart_accordian .static_value {\n    margin: 2px 7px 3px 7px;\n    padding: 0;\n    height: 19px;\n    background-color: #cccccc57;\n    color: #606060; }\n  .smart_accordian .address_add_status {\n    color: red;\n    text-align: center;\n    text-transform: initial;\n    margin-top: 14px; }\n  .smart_accordian .address_add_status.success {\n    color: #22BB33; }\n  .smart_accordian .bidSelectionModal[data-type=\"JUST_A_NOTIFICATION\"] {\n    width: 500px;\n    min-width: auto;\n    bottom: 40%;\n    height: auto;\n    min-height: auto;\n    z-index: 2;\n    top: auto;\n    box-shadow: 0 2px 4px 0 #929292;\n    border: 4px solid #ccc;\n    text-align: left; }\n    .smart_accordian .bidSelectionModal[data-type=\"JUST_A_NOTIFICATION\"] .primary_button_d {\n      margin: 20px 0 0 0; }\n    .smart_accordian .bidSelectionModal[data-type=\"JUST_A_NOTIFICATION\"] .bidSelectionModal_inner {\n      position: static;\n      overflow-y: auto;\n      overflow-x: auto; }\n  .smart_accordian [data-tab-container=\"SALES_NEW\"] {\n    position: relative; }\n  .smart_accordian .lane_already_exists {\n    color: red;\n    float: right; }\n  .smart_accordian .sales_app iframe {\n    display: none; }\n  .smart_accordian .arrow_icon_rotate {\n    transform: rotate(90deg); }\n  .smart_accordian .destination_table {\n    font-size: 16px;\n    text-align: center;\n    border-top: 1px solid #dcdcdc; }\n    .smart_accordian .destination_table thead {\n      font-size: 12px;\n      letter-spacing: 0;\n      line-height: 16px;\n      text-align: right; }\n      .smart_accordian .destination_table thead th {\n        padding-top: 4px; }\n    .smart_accordian .destination_table tr th:nth-child(1),\n    .smart_accordian .destination_table tr td:nth-child(1) {\n      text-align: left; }\n    .smart_accordian .destination_table tr th:nth-child(2),\n    .smart_accordian .destination_table tr td:nth-child(2) {\n      color: #1158ba;\n      text-align: left; }\n    .smart_accordian .destination_table tr th:nth-child(3),\n    .smart_accordian .destination_table tr td:nth-child(3) {\n      text-align: left; }\n    .smart_accordian .destination_table tr th:nth-child(4),\n    .smart_accordian .destination_table tr td:nth-child(4) {\n      text-align: right; }\n    .smart_accordian .destination_table tr th:nth-child(5),\n    .smart_accordian .destination_table tr td:nth-child(5) {\n      text-align: right; }\n    .smart_accordian .destination_table tr th:nth-child(7),\n    .smart_accordian .destination_table tr td:nth-child(7),\n    .smart_accordian .destination_table tr th:nth-child(8),\n    .smart_accordian .destination_table tr td:nth-child(8),\n    .smart_accordian .destination_table tr th:nth-child(9),\n    .smart_accordian .destination_table tr td:nth-child(9),\n    .smart_accordian .destination_table tr th:nth-child(10),\n    .smart_accordian .destination_table tr td:nth-child(10) {\n      text-align: center; }\n    .smart_accordian .destination_table tr th:nth-child(11),\n    .smart_accordian .destination_table tr td:nth-child(11) {\n      text-align: right; }\n    .smart_accordian .destination_table tr th:nth-child(12),\n    .smart_accordian .destination_table tr td:nth-child(12) {\n      text-align: right;\n      font-size: 12px; }\n  .smart_accordian .tac {\n    text-align: center; }\n  .smart_accordian .submission-comment {\n    color: #606060;\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 22px;\n    margin-top: 10px;\n    margin-left: 4px; }\n  .smart_accordian .react-datepicker__input-container input {\n    width: 100%;\n    font-family: 'Open Sans';\n    padding-top: 20px;\n    padding-left: 7px;\n    border: none; }\n\n.address-text-input-conatiner .ui input {\n  background-color: #F0F4FF !important;\n  border: none !important; }\n\n.address-text-input-conatiner > .dropdown-control2.country-dropdown .text {\n  font-size: 9px !important; }\n\n.container::after {\n  position: static !important;\n  border: none !important; }\n\n.simpleButton {\n  padding: 15px 38px;\n  border: none;\n  font-size: 16px;\n  letter-spacing: 0.53px;\n  box-sizing: border-box;\n  border-radius: 3px;\n  text-transform: uppercase;\n  color: #008b8f;\n  font-weight: 500;\n  margin: 3px !important;\n  cursor: pointer;\n  font-family: \"Open Sans\", sans-serif !important; }\n\n.primaryButton {\n  line-height: 19px;\n  color: white;\n  background-color: #0a8b8f; }\n\n.secondaryButton {\n  line-height: 15px;\n  box-sizing: border-box;\n  background-color: #ffffff;\n  padding: 15px 36px;\n  border: 2px solid #008b8f;\n  margin-left: 20px !important; }\n\n.location-type-input-container {\n  display: flex;\n  margin: 5px 0px 10px 0px;\n  align-items: center;\n  justify-content: flex-start; }\n  .location-type-input-container .location-type-label {\n    color: #606060; }\n  .location-type-input-container label {\n    color: #606060 !important;\n    font-size: 12px !important; }\n";
styleInject(css_248z$3);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var lodash = createCommonjsModule(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set$$1) {
    var index = -1,
        result = Array(set$$1.size);

    set$$1.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set$$1) {
    var index = -1,
        result = Array(set$$1.size);

    set$$1.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray$$1(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray$$1(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray$$1(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get$$1(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray$$1(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray$$1(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray$$1(object),
          othIsArr = isArray$$1(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray$$1(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get$$1(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray$$1(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray$$1(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray$$1(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray$$1(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set$$1 = iteratee ? null : createSet(array);
        if (set$$1) {
          return setToArray(set$$1);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray$$1(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray$$1(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray$$1(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray$$1(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray$$1(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray$$1(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray$$1(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray$$1(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray$$1(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find$$1 = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray$$1(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray$$1(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy$$1 = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString$$1(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray$$1(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray$$1(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray$$1(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray$$1(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray$$1(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray$$1(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray$$1(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray$$1(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray$$1(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString$$1(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray$$1(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce$$1(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray$$1(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce$$1(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray$$1(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep$$1(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray$$1 = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean$$1(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty$$1(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray$$1(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual$$1(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString$$1(value) {
      return typeof value == 'string' ||
        (!isArray$$1(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined$$1(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString$$1(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get$$1(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set$$1(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray$$1(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst$$1(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase$$1 = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split$$1(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst$$1(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst$$1 = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray$$1(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce$$1;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy$$1;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set$$1;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split$$1;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep$$1;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find$$1;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get$$1;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray$$1;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean$$1;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty$$1;
    lodash.isEqual = isEqual$$1;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString$$1;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined$$1;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase$$1;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst$$1;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray$$1(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray$$1(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray$$1(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
});
var lodash_1 = lodash.get;
var lodash_2 = lodash.isEmpty;
var lodash_3 = lodash.isEqual;

/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */
//  import "./env-config"

// import { parseUrlFromProxy } from "../util";

var getTokenName = function getTokenName() {
  switch (window._env_.APP_NAME || window.APP_NAME) {
    case "Partner":
      return "kxPartnerToken";
    case "Customer":
      return "kxCustomerToken";
    case "Sales":
      return "kxSalesToken";
    case "Ops":
      return "kxSupervisorToken";
    default:
      break;
  }
  return "kxCustomerToken";
};

var getCookieValue = function getCookieValue(name) {
  //  var b = document.cookie.match("(^|;)\\s*" + "kxCommonToken" + "\\s*=\\s*([^;]+)");
  var b = document.cookie.match("(^|;)\\s*" + getTokenName() + "\\s*=\\s*([^;]+)");

  return b ? b.pop() : "";
};

var parseUrlFromProxy = function parseUrlFromProxy() {
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var token = urlParams.get("token");
  if (!token) return;
  var domain = window.location.hostname;
  domain = domain.split(".");
  domain = "." + domain[1] + "." + domain[2];
  var tokenName = getTokenName();
  document.cookie = tokenName + "=" + token + ";domain=" + domain + ";path=/";
  window.location = window._env_.REACT_APP_LOGIN_URL_CUSTOMER;

  return token;
};

var noTokenValue = "_BLANK_";
var SERVERURL = window.BASE_URL || window._env_.REACT_APP_API_URL;

// let  tmpToken = "eyJhbGciOiJBMTI4S1ciLCJlbmMiOiJBMTI4Q0JDLUhTMjU2In0.q_H2Ma0cO7hrr-77wNwDgxKbkYGRnlnInyXuf7qk5sBzt22apNx6mA.8jc_y_ODKJvIl8kqCUxpRQ.ysTlYRr5U1wRdyVtjHL62_qp9uka8uKZl7VtF-C9wKR1oFZGAOPn7FO27Sq_BBOv-M8GZinOqUcIHyUfJXc2QNRDmo5EPkg7EtXMpr4ezr_KA_LN6i8DLw0zjR5Jtz3tkjeTxqbKQwH99d7VJOY-5_jMwWoI3krxY2otex0kGbb9a5Vy2_MazMUqHohXRaoptEdPWAasEjAu0P3JebMNmUlg0_eVVc47uCHBEbSnzHzt-t1_A96ceoBZweVpq-o0IDRc9p0iL0Q8CPN2cBTgXNPTyuQwTpyIixVaT55zrFF3f54O0yM1h9TYoIYyVGKhcE6Jy5hWr-PlsTerflExbkeO-jouEyP6orq1SoIY89NBwZryuIpdGVrA2eFuxyPv070z-lGgT00GuaQ4aivSkFv8h3rE1X9NL0Uyt4i4Q7Ioozyqyq2glIgugmV50fB-c572FlY4v6ylob6eVf3tZq89BX9tXXhSttupoIZsLg_ER9GPBiMZbEseh5FFeuzzkvnFeJ8wfxmMhC5aH8XmRG8JCWEIavwDFI61tERl89B-fZ3UDa3Gihmf37qMlSoJRVkAKL2o3Wdyzcxdt7alYcWFxOHGo6VV4qvRbCIAMAHn80tfsUYh9gNRdI_5wDQorqPrPzYWM5szXO72svRBwcpIK8aJqDqfY6Uhd-ZwnME8vn_YogWJr8y4Nh9xzCuMenEwejYVZObiFSBOc0wb7vAgUUIRa18bjuGXmQ27srNfUV2C9ELfBtvuUyZt7Kh1lxgVUl7taGbqYvIcwVTwejt4aYdZrtN1Sum7OeIR_t7e6O_nvBrlbpdNdFFFxsNADgggCigSlKtN9G_9aCT_2ifpI-tGPT42DMjFbnb1HFiHHb12LZLvfdJnwA2vbLtq57XQjoKAkIhf2ta3LwrSExAU3rea_ZiBiZnPh9J-LR1QfShDhRtIYhXX4Vkko8HQk88vNyzPYKN0SWxu4h66eSPp-rZJBT5V987mEXYI6rYu_QuhEb5_PTcjBPc-pqem.rU_MfnmZy1etMyjpvRdZPw"
// https://customer-dev.klearnow.com"
// let tmpToken = "eyJhbGciOiJBMTI4S1ciLCJlbmMiOiJBMTI4Q0JDLUhTMjU2In0.8S5_c9hVc9b-RsVKPwdgOr1JjFDky3QxvvcVVvK-9Dx0lgasAsDfWA.WBc4iBZ4Rn7WmEDVGA-30Q.R7-f38yUeQdQ54-w-NTCA3aje9m56K4Pvd7qS5dhXcDT32M7kfGtgWErI7YgorPXOooI5K1vvT_OpFJL8HdkJz-z6OQcYBCxUP0rDQT5Mm3XYhGj6N7OrXIzv4hbrosn9js35oko8NalisSyno4Cl5acT7AiFzNs0Ryr3b4M6zS-EdmKj506Ho-BMuzVHnfxPuVpVyakS5APxwvB0J3VvulRYU00Xk-3c_0pOR4Ue0IzwEWmS0WXTqYrv9f_cLjuoC-ZO1e0C7wuX9GrJNWwIYiuoDuvCgDLEaGk5Xr2dZwKANmGCZxznb3H8epFWzvWdNHeanRXKEZ1wRLr-agsV3uTpoGyWGGXjo4HGECPoxyDM4VPKzULIqljuu07NGlg2BI1QvyYovUMPKVnlSCkX1pOowqi6siRDf4geZuHlOhcchYd3Ze99K3lHE2B_6CAuT7TnwQxCwpBsoTaRoolepnW0Ncz96utaYstb3xXv0yhFipHgEBqiYLofAUUFUcBX4CfT0ERUBZgrfO2BUSTHnRc6AOuyzi1a7fMCCD-8Pr4_vLtH0C2gyu35w8mZpHXiR73CR4vfccga7GbPxKOFQrV84w5JvWqFDCGclSWg0o6v0X7nP9_0SWhoYIYspfl2YJKS7ZGEffrS8j1biILL9Xj3YdYgkaz3QY2LoDgulu-6sWKme_6xtBBfpKEFbYSYOs1-kzLwMGpHxBIjn8SoBsDwTo5k-PC-dyO9KMzfdv0OTQukoINiUcsEJ3cbaaBJQJ32OSb4o1fXxqLP0lkug.yukMp_9lfolkU14Q5WD-Ng"
//tmpToken="eyJhbGciOiJBMTI4S1ciLCJlbmMiOiJBMTI4Q0JDLUhTMjU2In0.jIR9ojAeR0PVYVQlF6vf31BDVfGASsl4mYwWJwVHOpnEefQs1LW89A.snKG-BygP0a0YPhWzoB_0w.bEWdlQEpy7-viT3VzXuKHoVc_et7LIJ_DUol0uxmkBNGaVQVY8jwyB4KsQDbtc5MbyYsCWzqHB2QcOAGhRIkJVdEIy2PreOFINkH6lbiQwJEcm0OBv41rDOALtPnvYIESv8XlUBF9qmzwk0kWxxvrXTC_eJnUHk-IzOhBgoC1_gPlBp91xfYh5yG7y8LFiql3if8XCBGyO5LtTFPgn4ZwmCrvvOUz0ojXvMfOejebuu8yj2C2qGFm3rERUjWKcVWx2HXVCyctdbdRraAVG79eteiBFGIuQ8rQdL0ch6d0fef1lPYdZqA_2oDN0UhRFE3Dz1hILYuOa1PtT1DqK2o4EMpAn2ffRUibMKPwmQummEmtVYVBlNXUEolU7HD4e8IlWOfiiuoEcWu-yfehac7UgJRwhy0jEyEZAhNALi7XrOJgHynmlIP5EYb0oArwAIdHs9woDMsOqk6YIFx__NuBS1uWuWl2r13kHXfb3ZVBHqXhn0gA1bct6fMNb5sZy8M8Lnd72rNtj3y-DomFEfZaLXScjZFQ_pYcrIJ6Fva3Qxqdyul7GdxoNwP4tLC3zeM_JDrExed3OaJlXO-wxX83HM3dq5gysjWsWRm48nwOlShsP1bqdyVELyz7TEmqHxhGID7ehO_GVJM5lEfQCknHhYuyqVr7a_AeAQrdyK4ix6re9VBc6PL7zuPmOwU6GqF-geu_UciRMHZ8_JLjLUK4XBCT58QejTfVsZZGVpuZP51HEozkM7_fX7Okjs15_05EWcl0G5G3KQGNBYpbKBGMg.YwF6Y8338t-9EAuod18z9A"
//partner
// noTokenValue = "eyJhbGciOiJBMTI4S1ciLCJlbmMiOiJBMTI4Q0JDLUhTMjU2In0.eX1RfD7p0osplWcdzzhIX8dAJm8XOMssStyFpTVpEWF_5gw2PC0q4Q.YNVhgWffzCTnbXPYIjDRhg.dVS50f_vHKcj2G-ajUcca_jm7Vhc_C71c6JW240Af9eMpzKSI588kD3kzXR_mTVa8SsNwwoQoMLyBOi0gJgK8elrogUFge_YowYZS6WUkCGAoVLHdxIhjrb8qEemjL28EI9SaP58TlRD8cjOb2rCPzrOig2UqYVvFgk2_fbkdBUBZ03tykAt3oRGn_X7mHv3TXDSDcMk99Wfie9micjMK53KbCllChVq_rrjHsP303V4VsR5mgwOjov7_KyJiOOkQ2NFZOrNAiSi6Xd3WycLbkNmv8nQ-0zBs0uuU9dte5hOsODG837igHDBawlvOu9yit8rfjWg0ijtk6U-ERECAIjaxV4-WuJNTDdf-sfa1aHCMObEB_8NvCqncNQMnzlZt1kD77y7kUWFQUHk_HhJB50zVlfzQVL4Di6HAmxy0uAhp8kKtNQMe0iJIFdxQxtF6lawQPDlkbKBOmaL8km4Nf1PVRJkAsdQiEr_Q8nkJdNglYWzjEUPw_Ol7-hglgBcM17H-iWTtmlgg8zLsm7yNzFaPSbgLTMkrlPjxVlbSdNpui6wqdzjnpVQYXwIbLZ3uVi12MZwVvlT1QNCUQLDp8JlCx_AJmop7UHf0qsSz2MoslOSK7six1bQShoax8VR8xtFjIw9qBLAKfnA9k0HfdiwPasYjwwEFqNn2FVWkNbacTe2B9UgzE6rHGFyGoXnIXRUwz8G6uc6VToOtQW7-vnBY1MI6cg-LKGhfSWjvjcP9sKypTxH1I4NjhdBTOCyrykA2RIqZtm0MDGuLmRGFjTkisp-Z3sK1KOx8W3sdBgL8M_jY_L75u8xRTI-_-x9.rCEikS-giH5nYsxpNae6_Q"

axios.defaults.method = "post";
axios.defaults.baseURL = SERVERURL; //window._env_.REACT_APP_API_URL;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["kxToken"] = getCookieValue("kxCustomerToken") || noTokenValue;
// console.log("Use token : ", axios.defaults.headers.common['kxToken'])
var baseUrl = SERVERURL; //window._env_.REACT_APP_API_URL;
parseUrlFromProxy();

var logout = function logout() {
  var domain = window.location.hostname;
  document.cookie = getTokenName() + "=;domain=" + domain + ";path=/";
  var dt = new Date();
  dt.setTime(dt.getTime() - 24 * 60 * 60 * 1000);
  document.cookie = getTokenName() + "=0; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  window.location = "/";
  return true;
};

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  console.error("2error", error);
  var msg = lodash_1(error, "response.data.msg", null);
  if (msg === "Expired Token" || msg === "Event not allowed without valid token" || msg === "Failed to decrypt") {
    // Send user to login URL
    //  window.location = window._env_.REACT_APP_LOGOUT_URL_CUSTOMER;
    logout();
  } else {
    return Promise.reject(error);
  }
});

var post = function post() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return axios.post(url, data, config);
};

var custom = function custom() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  console.log("APP NAME ", window._env_.APP_NAME);
  axios.defaults.baseURL = window.BASE_URL || window._env_.REACT_APP_API_URL;
  config.method = "post";
  axios.defaults.headers.common["Accept"] = "application/json";
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.defaults.headers.common["kxToken"] = getCookieValue("kxCustomerToken") || noTokenValue;
  // console.log("Use token : ", axios.defaults.headers.common['kxToken'])
  return axios(config);
};

var mockCustom = function mockCustom(url) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  config.method = "get";
  axios.defaults.baseURL = url;
  return axios(config);
};

var addDoc = function addDoc() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  config.method = "post";
  axios.defaults.baseURL = (window.BASE_URL || window._env_.REACT_APP_API_URL) + "?timeout=10000";
  return axios(config);
};

// const get = (url) => {
//   return axios(url)
// }

var put = function put() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return axios.put(url, data, config);
};

var del = function del() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return axios.delete(url, config);
};

var fileUploadCustom = function fileUploadCustom() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return axios(config);
};

var HttpClient = {
  post: post,
  get: lodash_1,
  put: put,
  delete: del,
  custom: custom,
  baseUrl: baseUrl,
  // url,
  addDoc: addDoc,
  mockCustom: mockCustom,
  fileUploadCustom: fileUploadCustom,
  server: window.BASE_URL || window._env_.REACT_APP_API_URL
};

var modalIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2212px%22%20height%3D%2212px%22%20viewBox%3D%220%200%2012%2012%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3E4B72C708-19D7-4FAA-953F-44B17CC85520%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Ops-K-Model--ocean%22%20transform%3D%22translate%28-784.000000%2C%20-989.000000%29%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-6%22%20transform%3D%22translate%2829.000000%2C%20874.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-13%22%20transform%3D%22translate%28588.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22cms%22%20transform%3D%22translate%28167.000000%2C%20115.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10.9453125%2C0%20L1.0546875%2C0%20C0.473144531%2C0%200%2C0.473144531%200%2C1.0546875%20L0%2C8.0859375%20C0%2C8.66748047%200.473144531%2C9.140625%201.0546875%2C9.140625%20L4.10595703%2C9.140625%20L3.63720703%2C10.546875%20L2.484375%2C10.546875%20C2.29019166%2C10.546875%202.1328125%2C10.7042542%202.1328125%2C10.8984375%20C2.1328125%2C11.0926208%202.29019166%2C11.25%202.484375%2C11.25%20L9.515625%2C11.25%20C9.70980834%2C11.25%209.8671875%2C11.0926208%209.8671875%2C10.8984375%20C9.8671875%2C10.7042542%209.70980834%2C10.546875%209.515625%2C10.546875%20L8.36279297%2C10.546875%20L7.89404297%2C9.140625%20L10.9453125%2C9.140625%20C11.5268555%2C9.140625%2012%2C8.66748047%2012%2C8.0859375%20L12%2C1.0546875%20C12%2C0.473144531%2011.5268555%2C0%2010.9453125%2C0%20Z%20M4.37841797%2C10.546875%20L4.84716797%2C9.140625%20L7.15283203%2C9.140625%20L7.62158203%2C10.546875%20L4.37841797%2C10.546875%20Z%20M11.296875%2C8.0859375%20C11.296875%2C8.27975463%2011.1391296%2C8.4375%2010.9453125%2C8.4375%20C9.92385865%2C8.4375%202.08676147%2C8.4375%201.0546875%2C8.4375%20C0.860870367%2C8.4375%200.703125%2C8.27975463%200.703125%2C8.0859375%20L0.703125%2C7.734375%20L11.296875%2C7.734375%20L11.296875%2C8.0859375%20Z%20M3.8338623%2C5.01068114%20L3.51406861%2C4.69097902%20L4.01119995%2C4.19375611%20L4.33099364%2C4.5135498%20C4.44433594%2C4.62689208%204.62002564%2C4.64923097%204.75817871%2C4.56774902%20C4.9557495%2C4.45129395%205.166687%2C4.36349487%205.38504029%2C4.30691529%20C5.54013061%2C4.26681518%205.6484375%2C4.12683105%205.6484375%2C3.96661378%20L5.6484375%2C3.515625%20L6.3515625%2C3.515625%20L6.3515625%2C3.96661378%20C6.3515625%2C4.12683105%206.45986939%2C4.26681518%206.61495971%2C4.30691529%20C6.83322143%2C4.36349487%207.04415893%2C4.45129395%207.24172974%2C4.56784057%20C7.37988281%2C4.64923097%207.55557252%2C4.62689208%207.66891479%2C4.5135498%20L7.98870848%2C4.19375611%20L8.48593139%2C4.69097902%20L8.1661377%2C5.01077271%20C8.05279542%2C5.12411498%208.03045653%2C5.29980469%208.11193848%2C5.43786621%20C8.2284851%2C5.63552857%208.31619263%2C5.84646607%208.37277221%2C6.06472779%20C8.41287232%2C6.21981811%208.55285645%2C6.328125%208.71307372%2C6.328125%20L9.1640625%2C6.328125%20L9.1640625%2C7.03125%20L7.72229004%2C7.03125%20C7.74572754%2C6.91607667%207.7578125%2C6.7982483%207.7578125%2C6.6796875%20C7.7578125%2C5.7104187%206.9692688%2C4.921875%206%2C4.921875%20C5.0307312%2C4.921875%204.2421875%2C5.7104187%204.2421875%2C6.6796875%20C4.2421875%2C6.7982483%204.25427246%2C6.91607667%204.27770996%2C7.03125%20L2.8359375%2C7.03125%20L2.8359375%2C6.328125%20L3.28692628%2C6.328125%20C3.44714355%2C6.328125%203.58712768%2C6.21981811%203.62731934%2C6.06472779%20C3.68380737%2C5.84646607%203.77160645%2C5.63552857%203.88806152%2C5.43786621%20C3.9694519%2C5.29980469%203.94720458%2C5.12411498%203.8338623%2C5.01068114%20L3.8338623%2C5.01068114%20Z%20M7.0546875%2C6.6796875%20C7.0546875%2C6.80007935%207.03381348%2C6.91900636%206.9942627%2C7.03125%20L5.0057373%2C7.03125%20C4.96618652%2C6.91900636%204.9453125%2C6.80007935%204.9453125%2C6.6796875%20C4.9453125%2C6.09814453%205.41845703%2C5.625%206%2C5.625%20C6.58154297%2C5.625%207.0546875%2C6.09814453%207.0546875%2C6.6796875%20Z%20M11.296875%2C7.03125%20L9.8671875%2C7.03125%20L9.8671875%2C5.9765625%20C9.8671875%2C5.78237916%209.70980834%2C5.625%209.515625%2C5.625%20L8.97253418%2C5.625%20C8.9360962%2C5.52282715%208.89425659%2C5.4223938%208.84719849%2C5.32397461%20L9.23171998%2C4.93954467%20C9.36895753%2C4.80221557%209.36895753%2C4.57965089%209.23162841%2C4.44232177%20L8.23727416%2C3.44796752%20C8.1713562%2C3.38204955%208.08190918%2C3.34506225%207.98870848%2C3.34506225%20C7.89550781%2C3.34506225%207.8060608%2C3.38204955%207.74014283%2C3.44796752%20L7.35571289%2C3.83248901%20C7.2572937%2C3.78543091%207.15686035%2C3.7435913%207.0546875%2C3.70724487%20L7.0546875%2C3.1640625%20C7.0546875%2C2.96987916%206.89730834%2C2.8125%206.703125%2C2.8125%20L5.296875%2C2.8125%20C5.10269166%2C2.8125%204.9453125%2C2.96987916%204.9453125%2C3.1640625%20L4.9453125%2C3.70724487%20C4.84313965%2C3.7435913%204.7427063%2C3.78543091%204.64428711%2C3.83248901%20L4.25985717%2C3.44796752%20C4.1939392%2C3.38204955%204.10449219%2C3.34506225%204.01129152%2C3.34506225%20C3.91799927%2C3.34506225%203.8286438%2C3.38204955%203.76263427%2C3.44796752%20L2.76837159%2C4.44232177%20C2.63104247%2C4.57965089%202.63104247%2C4.80221557%202.76837159%2C4.93954467%20L3.15280151%2C5.32406616%20C3.10574341%2C5.4223938%203.06399537%2C5.52282715%203.02755737%2C5.625%20L2.484375%2C5.625%20C2.29019166%2C5.625%202.1328125%2C5.7824707%202.1328125%2C5.9765625%20L2.1328125%2C7.03125%20L0.703125%2C7.03125%20L0.703125%2C1.0546875%20C0.703125%2C0.860870367%200.860870367%2C0.703125%201.0546875%2C0.703125%20L10.9453125%2C0.703125%20C11.1391296%2C0.703125%2011.296875%2C0.860870367%2011.296875%2C1.0546875%20L11.296875%2C7.03125%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9.515625%2C1.40625%20C8.93408203%2C1.40625%208.4609375%2C1.87939453%208.4609375%2C2.4609375%20C8.4609375%2C3.04248047%208.93408203%2C3.515625%209.515625%2C3.515625%20C10.097168%2C3.515625%2010.5703125%2C3.04248047%2010.5703125%2C2.4609375%20C10.5703125%2C1.87939453%2010.097168%2C1.40625%209.515625%2C1.40625%20Z%20M9.515625%2C2.8125%20C9.32180787%2C2.8125%209.1640625%2C2.65475463%209.1640625%2C2.4609375%20C9.1640625%2C2.26712037%209.32180787%2C2.109375%209.515625%2C2.109375%20C9.70944213%2C2.109375%209.8671875%2C2.26712037%209.8671875%2C2.4609375%20C9.8671875%2C2.65475463%209.70944213%2C2.8125%209.515625%2C2.8125%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var portIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2219px%22%20height%3D%2219px%22%20viewBox%3D%220%200%2019%2019%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3ECD4AA43E-7114-49B8-A3A6-5C97FBE08955%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20opacity%3D%220.593386628%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.-Ops-D-Model---Container%22%20transform%3D%22translate%28-473.000000%2C%20-72.000000%29%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%28331.000000%2C%2062.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22port%22%20transform%3D%22translate%28142.000000%2C%2010.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12.0118811%2C6.00595817%20C11.8317028%2C6.00595817%2011.7115956%2C6.12606537%2011.7115956%2C6.30624376%20L11.7115956%2C6.90685013%20C11.7115956%2C7.08702853%2011.8317028%2C7.20713572%2012.0118811%2C7.20713572%20C12.1920595%2C7.20713572%2012.3121667%2C7.08702853%2012.3121667%2C6.90685013%20L12.3121667%2C6.30624376%20C12.3122019%2C6.12606537%2012.1920595%2C6.00595817%2012.0118811%2C6.00595817%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12.9127731%2C6.00595817%20C12.7325947%2C6.00595817%2012.6124875%2C6.12606537%2012.6124875%2C6.30624376%20L12.6124875%2C6.90685013%20C12.6124875%2C7.08702853%2012.7325947%2C7.20713572%2012.9127731%2C7.20713572%20C13.0929515%2C7.20713572%2013.2130587%2C7.08702853%2013.2130587%2C6.90685013%20L13.2130587%2C6.30624376%20C13.2130939%2C6.12606537%2013.0929515%2C6.00595817%2012.9127731%2C6.00595817%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M13.8136651%2C6.00595817%20C13.6334867%2C6.00595817%2013.5133795%2C6.12606537%2013.5133795%2C6.30624376%20L13.5133795%2C6.90685013%20C13.5133795%2C7.08702853%2013.6334867%2C7.20713572%2013.8136651%2C7.20713572%20C13.9938435%2C7.20713572%2014.1139507%2C7.08702853%2014.1139507%2C6.90685013%20L14.1139507%2C6.30624376%20C14.1139859%2C6.12606537%2013.9938435%2C6.00595817%2013.8136651%2C6.00595817%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M17.9878213%2C13.6635399%20C17.8977321%2C13.2731651%2017.6274645%2C12.9428263%2017.2671077%2C12.7626479%20L16.7514527%2C12.4910079%20L17.0551166%2C9.90981162%20L17.1169473%2C9.90981162%20C17.2971257%2C9.90981162%2017.4172329%2C9.78970442%2017.4172329%2C9.60952603%20L17.4172329%2C7.8077421%20C17.4172329%2C7.62756371%2017.2971257%2C7.50745651%2017.1169473%2C7.50745651%20L15.0148778%2C7.50745651%20L15.0148778%2C5.40538698%20C15.0148778%2C5.22520859%2014.8947706%2C5.10510139%2014.7145922%2C5.10510139%20L14.5193872%2C5.10510139%20L13.2130939%2C4.06006671%20L13.2130939%2C2.97392884%20C13.9056898%2C2.83809122%2014.4142714%2C2.23920921%2014.4142714%2C1.50149834%20C14.4142714%2C0.660677569%2013.7536291%2C-1.000191e-15%2012.9127731%2C-1.000191e-15%20C12.1346629%2C-1.000191e-15%2011.5112879%2C0.565907957%2011.4225359%2C1.31667472%20L3.80250311%2C6.00595817%20L0.300285591%2C6.00595817%20C0.120107198%2C6.00595817%200%2C6.12606537%200%2C6.30624376%20L0%2C8.10802769%20C0%2C8.16809888%200.0300180018%2C8.22813489%200.0600711947%2C8.28820608%20L0.660677569%2C9.18909805%20C0.720748764%2C9.24916924%200.81083796%2C9.30920525%200.900927157%2C9.30920525%20L2.4024255%2C9.30920525%20L2.4024255%2C10.4703705%20L1.55488323%2C12.7305184%20C1.52792685%2C12.7690879%201.51047207%2C12.815892%201.50431363%2C12.8691362%20C1.49804961%2C12.8989782%201.49738098%2C12.9271311%201.50153353%2C12.9540875%20L1.50153353%2C17.7175537%20C1.50153353%2C17.8977321%201.62164073%2C18.0178393%201.80181912%2C18.0178393%20L6.60656454%2C18.0178393%20C6.78674293%2C18.0178393%206.90685013%2C17.8977321%206.90685013%2C17.7175537%20L6.90685013%2C12.9128083%20C6.90685013%2C12.8412296%206.8876358%2C12.7793989%206.85350044%2C12.7305184%20L6.00595817%2C10.4703705%20L6.00595817%2C8.25818808%20L12.6124875%2C3.30328227%20L12.6124875%2C4.06003152%20L11.3061942%2C5.1050662%20L11.1109892%2C5.1050662%20C10.9308108%2C5.1050662%2010.8107036%2C5.2251734%2010.8107036%2C5.40535179%20L10.8107036%2C7.50742132%20L8.70863406%2C7.50742132%20C8.52845567%2C7.50742132%208.40834847%2C7.62752851%208.40834847%2C7.80770691%20L8.40834847%2C9.60949084%20C8.40834847%2C9.78966923%208.52845567%2C9.90977643%208.70863406%2C9.90977643%20L9.03781154%2C9.90977643%20L9.31934028%2C12.5458356%20L8.91886565%2C12.7626127%20C8.55850886%2C12.9427911%208.28824127%2C13.2731299%208.16813408%2C13.6635047%20C8.04802688%2C14.0538795%208.10806288%2C14.4743075%208.34831247%2C14.8046462%20L10.2702036%2C17.8676789%20C10.3002216%2C17.9577681%2010.420364%2C18.0178393%2010.5104532%2C18.0178393%20L15.6155194%2C18.0178393%20C15.7056086%2C18.0178393%2015.8257158%2C17.9577681%2015.885787%2C17.8977321%20L16.9368393%2C16.1860374%20C16.9456371%2C16.1684418%2016.9542589%2C16.148031%2016.9615435%2C16.1260366%20L17.7776953%2C14.8046814%20C18.0178393%2C14.4743426%2018.0779105%2C14.0539147%2017.9878213%2C13.6635399%20Z%20M13.9037543%2C10.990882%20C13.7022501%2C10.8823878%2013.4125218%2C10.8144338%2013.0969281%2C10.8107036%20C12.7928067%2C10.8031727%2012.4623975%2C10.855713%2012.1620415%2C10.990882%20L9.87979362%2C12.2221127%20L9.64267604%2C9.93986481%20L16.456305%2C9.93986481%20L16.189275%2C12.1948748%20L13.9037543%2C10.990882%20Z%20M12.9127731%2C0.600606374%20C13.4232903%2C0.600606374%2013.8136651%2C0.990981162%2013.8136651%2C1.50149834%20C13.8136651%2C2.01201552%2013.4232903%2C2.40239031%2012.9127731%2C2.40239031%20C12.4022559%2C2.40239031%2012.0118811%2C2.01201552%2012.0118811%2C1.50149834%20C12.0118811%2C0.990981162%2012.4022911%2C0.600606374%2012.9127731%2C0.600606374%20Z%20M0.600606374%2C8.01793849%20L0.600606374%2C6.60652935%20L3.60356786%2C6.60652935%20L3.60356786%2C8.10802769%20L3.60356786%2C8.70863406%20L2.7026759%2C8.70863406%20L1.05105236%2C8.70863406%20L0.600606374%2C8.01793849%20Z%20M3.90385345%2C9.30924044%20C4.08403185%2C9.30924044%204.20413905%2C9.18913324%204.20413905%2C9.00895485%20L4.20413905%2C8.40834847%20L5.40535179%2C8.40834847%20L5.40535179%2C10.2101324%20L3.00296149%2C10.2101324%20L3.00296149%2C9.30924044%20L3.90385345%2C9.30924044%20Z%20M6.30624376%2C17.4172681%20L2.10206952%2C17.4172681%20L2.10206952%2C16.8166618%20L3.60356786%2C16.8166618%20C3.78374626%2C16.8166618%203.90385345%2C16.6965546%203.90385345%2C16.5163762%20C3.90385345%2C16.3361978%203.78374626%2C16.2160906%203.60356786%2C16.2160906%20L2.10206952%2C16.2160906%20L2.10206952%2C15.6154842%20L3.00296149%2C15.6154842%20C3.18313988%2C15.6154842%203.30324708%2C15.495377%203.30324708%2C15.3151986%20C3.30324708%2C15.1350202%203.18313988%2C15.014913%203.00296149%2C15.014913%20L2.10206952%2C15.014913%20L2.10206952%2C13.2131291%20L6.30624376%2C13.2131291%20L6.30624376%2C17.4172681%20Z%20M2.22221191%2C12.6124875%20L2.91290748%2C10.8107036%20L5.49547618%2C10.8107036%20L6.15611856%2C12.6124875%20L2.22221191%2C12.6124875%20Z%20M5.61554819%2C7.8077421%20L4.20413905%2C7.8077421%20L4.20413905%2C6.48642215%20L11.471346%2C2.01201552%20C11.6215064%2C2.3723723%2011.8917739%2C2.67265789%2012.2220775%2C2.85283629%20L5.61554819%2C7.8077421%20Z%20M12.9127731%2C4.58856654%20L13.5584241%2C5.1050662%20L12.2671573%2C5.1050662%20L12.9127731%2C4.58856654%20Z%20M11.41131%2C5.70567258%20L14.4142714%2C5.70567258%20L14.4142714%2C7.50745651%20L11.41131%2C7.50745651%20L11.41131%2C5.70567258%20L11.41131%2C5.70567258%20Z%20M9.00891966%2C8.10802769%20L11.1109892%2C8.10802769%20L14.714557%2C8.10802769%20L16.8166266%2C8.10802769%20L16.8166266%2C9.30920525%20L9.30920525%2C9.30920525%20L9.00891966%2C9.30920525%20L9.00891966%2C8.10802769%20Z%20M10.6905964%2C17.4172681%20L9.87979362%2C16.1260014%20L12.4923803%2C14.8347346%20C12.8827551%2C14.6545562%2013.3332011%2C14.6545562%2013.6935579%2C14.8347346%20L16.2460734%2C16.1260014%20L15.4652886%2C17.4172681%20L10.6905964%2C17.4172681%20Z%20M17.2971257%2C14.4743426%20L16.5707112%2C15.6413497%20L13.9638255%2C14.3241823%20C13.4232903%2C14.0539147%2012.8226839%2C14.0539147%2012.2521307%2C14.3241823%20L9.57261057%2C15.6501122%20L8.82874126%2C14.4743075%20C8.67858087%2C14.2941291%208.64856287%2C14.0538795%208.70863406%2C13.8136651%20C8.76870526%2C13.6034687%208.91883046%2C13.4232903%209.15908005%2C13.3031479%20L9.72041316%2C12.999308%20C9.74029613%2C12.9962112%209.75412623%2C12.9900527%209.75799725%2C12.9789676%20L12.4323091%2C11.5314172%20C12.6007337%2C11.45368%2012.7970648%2C11.4208467%2012.9876246%2C11.4180667%20C13.2278038%2C11.4185593%2013.4559476%2C11.4658562%2013.6034687%2C11.5314172%20L16.3061446%2C12.9428263%20C16.3306728%2C12.9591902%2016.3552362%2C12.9706625%2016.3797643%2C12.978123%20L16.9968401%2C13.3031831%20C17.2070365%2C13.3932723%2017.3571969%2C13.5734507%2017.4172681%2C13.8137003%20C17.4773041%2C14.0238967%2017.4472861%2C14.2641462%2017.2971257%2C14.4743426%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12.9127731%2C1.80178393%20C13.0929515%2C1.80178393%2013.2130587%2C1.68167673%2013.2130587%2C1.50149834%20C13.2130587%2C1.32131995%2013.0929515%2C1.20121275%2012.9127731%2C1.20121275%20C12.7325947%2C1.20121275%2012.6124875%2C1.32131995%2012.6124875%2C1.50149834%20C12.6124875%2C1.68167673%2012.7325947%2C1.80178393%2012.9127731%2C1.80178393%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var vesselIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2228px%22%20height%3D%2217px%22%20viewBox%3D%220%200%2028%2017%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3E30E8A36A-37F1-46A0-AD0A-E712CD0727C2%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20opacity%3D%220.593386628%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.-Ops-D-Model---Container%22%20transform%3D%22translate%28-350.000000%2C%20-73.000000%29%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%28331.000000%2C%2062.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22ship%22%20transform%3D%22translate%2819.000000%2C%2011.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M22.9148875%2C10.3906125%20C22.613505%2C10.3906125%2022.3679584%2C10.6361591%2022.3679584%2C10.9374868%20C22.3679584%2C11.2388146%2022.613505%2C11.4843612%2022.9148875%2C11.4843612%20C23.2162152%2C11.4843612%2023.4618165%2C11.2388146%2023.4618165%2C10.9374868%20C23.4618165%2C10.6361591%2023.2162152%2C10.3906125%2022.9148875%2C10.3906125%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M27.8848268%2C8.4233961%20C27.7851316%2C8.29203688%2027.6296552%2C8.20311511%2027.4542179%2C8.20311511%20L25.7041107%2C8.20311511%20L25.7041107%2C4.37499473%20C25.7041107%2C4.07301072%2025.459275%2C3.82812039%2025.1571816%2C3.82812039%20L12.0314865%2C3.82812039%20C11.7294478%2C3.82812039%2011.4845575%2C4.07301072%2011.4845575%2C4.37499473%20L11.4845575%2C10.3906125%20L10.3907541%2C10.3906125%20L10.3907541%2C2.84374657%20C10.3907541%2C2.54176256%2010.1459185%2C2.29687223%209.84382509%2C2.29687223%20L9.51570048%2C2.29687223%20L9.51570048%2C0.546874341%20C9.51570048%2C0.24489033%209.27086484%2C0%208.96877145%2C0%20L6.23423569%2C0%20C5.93219699%2C0%205.68730666%2C0.24489033%205.68730666%2C0.546874341%20L5.68730666%2C2.29687223%20L4.37480824%2C2.29687223%20C4.07276954%2C2.29687223%203.82787921%2C2.54176256%203.82787921%2C2.84374657%20L3.82787921%2C4.48436959%20L2.73407584%2C4.48436959%20C2.43203714%2C4.48436959%202.18714681%2C4.72925992%202.18714681%2C5.03124394%20L2.18714681%2C8.85936432%20C2.18714681%2C8.85936432%200.553523783%2C8.85936432%200.546469104%2C8.85936432%20C0.228078863%2C8.85936432%20-0.0381942533%2C9.16528583%200.00451663275%2C9.47973857%20L0.879570265%2C15.9328558%20C0.916320221%2C16.2039961%201.14786682%2C16.4062302%201.42152274%2C16.4062302%20L21.8126075%2C16.4062302%20C24.1130344%2C16.4062302%2026.1548445%2C14.9425211%2026.8933983%2C12.7639377%20C26.8965155%2C12.7548049%2026.8993592%2C12.7456174%2026.9019295%2C12.7363206%20C26.9019295%2C12.7363206%2027.9761001%2C8.91437988%2027.9806938%2C8.89797365%20C28.0283813%2C8.7284426%2027.9844673%2C8.55475531%2027.8848268%2C8.4233961%20Z%20M21.3288425%2C4.92186907%20L24.6102526%2C4.92186907%20L24.6102526%2C6.01561775%20L21.3288425%2C6.01561775%20L21.3288425%2C4.92186907%20Z%20M21.3288425%2C7.10936643%20L24.6102526%2C7.10936643%20L24.6102526%2C8.20311511%20L21.3288425%2C8.20311511%20L21.3288425%2C7.10936643%20Z%20M16.953629%2C4.92186907%20L20.2350391%2C4.92186907%20L20.2350391%2C6.01561775%20L16.953629%2C6.01561775%20L16.953629%2C4.92186907%20Z%20M16.953629%2C7.10936643%20L20.2350391%2C7.10936643%20L20.2350391%2C8.20311511%20L16.953629%2C8.20311511%20L16.953629%2C7.10936643%20Z%20M16.953629%2C9.29686379%20L19.4615947%2C9.29686379%20L18.3677914%2C10.3906125%20L16.953629%2C10.3906125%20L16.953629%2C9.29686379%20Z%20M12.5783609%2C4.92186907%20L15.859771%2C4.92186907%20L15.859771%2C6.01561775%20L12.5783609%2C6.01561775%20L12.5783609%2C4.92186907%20Z%20M12.5783609%2C7.10936643%20L15.859771%2C7.10936643%20L15.859771%2C8.20311511%20L12.5783609%2C8.20311511%20L12.5783609%2C7.10936643%20Z%20M12.5783609%2C9.29686379%20L15.859771%2C9.29686379%20L15.859771%2C10.3906125%20L12.5783609%2C10.3906125%20L12.5783609%2C9.29686379%20Z%20M6.78116471%2C1.09374868%20L6.7812194%2C1.09374868%20L8.42189711%2C1.09374868%20L8.42189711%2C2.29687223%20L6.78116471%2C2.29687223%20L6.78116471%2C1.09374868%20L6.78116471%2C1.09374868%20Z%20M4.92173727%2C3.39062091%20L9.29695074%2C3.39062091%20L9.29695074%2C4.48436959%20L4.92173727%2C4.48436959%20L4.92173727%2C3.39062091%20Z%20M3.28100487%2C5.57811828%20L9.29695074%2C5.57811828%20L9.29695074%2C10.3906125%20L6.83585215%2C10.3906125%20L6.83585215%2C9.40623866%20C6.83585215%2C9.10425465%206.59101651%2C8.85936432%206.28892312%2C8.85936432%20L3.28100487%2C8.85936432%20L3.28100487%2C5.57811828%20Z%20M25.8529152%2C12.4261881%20C25.2611971%2C14.1531626%2023.6393319%2C15.3124815%2021.8126075%2C15.3124815%20L1.89927216%2C15.3124815%20L1.17253085%2C9.953113%20L5.74204878%2C9.953113%20L5.74204878%2C10.9374868%20C5.74204878%2C11.2394708%205.98688442%2C11.4843612%206.28897781%2C11.4843612%20L20.7272807%2C11.4843612%20C21.0286085%2C11.4843612%2021.2742097%2C11.2388146%2021.2742097%2C10.9374868%20C21.2742097%2C10.6361591%2021.0286632%2C10.3906125%2020.7272807%2C10.3906125%20L19.9147348%2C10.3906125%20L21.0085382%2C9.29686379%20L26.7324532%2C9.29686379%20L25.8529152%2C12.4261881%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var containerIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2223px%22%20height%3D%2215px%22%20viewBox%3D%220%200%2023%2015%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EBC286874-B61F-40C7-B6E6-49E23EBA905C%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20opacity%3D%220.593386628%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%221A.-Ops-D-Model---Container-On-Hover%22%20transform%3D%22translate%28-603.000000%2C%20-75.000000%29%22%20fill%3D%22%23000000%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%28331.000000%2C%2062.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22container-new%22%20transform%3D%22translate%28272.000000%2C%2013.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M22.6444441%2C3.10003276%20L10.2363726%2C0.0115400803%20C10.2361929%2C0.0114876254%2010.2359683%2C0.0114876254%2010.2357886%2C0.0114351705%20C10.2198863%2C0.00755350712%2010.2036695%2C0.00451112231%2010.1871832%2C0.00262274553%20C10.1841285%2C0.00225556115%2010.1810739%2C0.00236047097%2010.1780192%2C0.00209819642%20C10.1663395%2C0.0009966433%2010.1546599%2C0%2010.1427556%2C0%20L0.449217873%2C0%20C0.201114842%2C0%200%2C0.234893089%200%2C0.524549105%20L0%2C4.92960758%20C0%2C5.2192636%200.201114842%2C5.45415669%200.449217873%2C5.45415669%20C0.697320904%2C5.45415669%200.898435745%2C5.2192636%200.898435745%2C4.92960758%20L0.898435745%2C1.04909821%20L4.84679131%2C1.04909821%20L4.84679131%2C3.7029495%20L4.5383134%2C3.7029495%20C4.29021037%2C3.7029495%204.08909553%2C3.93784259%204.08909553%2C4.22749861%20C4.08909553%2C4.51715462%204.29021037%2C4.75204771%204.5383134%2C4.75204771%20L4.84679131%2C4.75204771%20L4.84679131%2C9.3035603%20L4.5383134%2C9.3035603%20C4.29021037%2C9.3035603%204.08909553%2C9.53840093%204.08909553%2C9.8281094%20C4.08909553%2C10.1177654%204.29021037%2C10.3526585%204.5383134%2C10.3526585%20L4.84679131%2C10.3526585%20L4.84679131%2C13.0065098%20L0.898435745%2C13.0065098%20L0.898435745%2C9.12594797%20C0.898435745%2C8.83629196%200.697320904%2C8.60139887%200.449217873%2C8.60139887%20C0.201114842%2C8.60139887%200%2C8.83629196%200%2C9.12594797%20L0%2C13.5310065%20C0%2C13.8206625%200.201114842%2C14.0555556%200.449217873%2C14.0555556%20L10.1427107%2C14.0555556%20L22.5507821%2C14.0555556%20C22.7988852%2C14.0555556%2023%2C13.8206625%2023%2C13.5310065%20L23%2C3.61304178%20C23%2C3.36545461%2022.851803%2C3.15164839%2022.6444441%2C3.10003276%20Z%20M5.74522706%2C10.3526061%20L6.05370497%2C10.3526061%20C6.301808%2C10.3526061%206.50292285%2C10.117713%206.50292285%2C9.82805695%20C6.50292285%2C9.53834848%206.301808%2C9.30350784%206.05370497%2C9.30350784%20L5.74522706%2C9.30350784%20L5.74522706%2C4.75199526%20L6.05370497%2C4.75199526%20C6.301808%2C4.75199526%206.50292285%2C4.51710217%206.50292285%2C4.22744615%20C6.50292285%2C3.93779013%206.301808%2C3.70289705%206.05370497%2C3.70289705%20L5.74522706%2C3.70289705%20L5.74522706%2C1.04904576%20L9.69353771%2C1.04904576%20L9.69353771%2C13.0064049%20L5.74522706%2C13.0064049%20L5.74522706%2C10.3526061%20L5.74522706%2C10.3526061%20Z%20M22.1015643%2C13.0064573%20L10.5919285%2C13.0064573%20L10.5919285%2C1.17268198%20L22.1015643%2C4.03750692%20L22.1015643%2C13.0064573%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16.9625%2C12.2986111%20C17.1212862%2C12.2986111%2017.25%2C12.0314619%2017.25%2C11.7020296%20L17.25%2C4.11047039%20C17.25%2C3.78097843%2017.1212862%2C3.51388889%2016.9625%2C3.51388889%20C16.8037137%2C3.51388889%2016.675%2C3.78097843%2016.675%2C4.11047039%20L16.675%2C11.7020296%20C16.675%2C12.0314619%2016.8037137%2C12.2986111%2016.9625%2C12.2986111%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M19.8375%2C12.2986111%20C19.9962862%2C12.2986111%2020.125%2C12.0659108%2020.125%2C11.7789588%20L20.125%2C5.79048564%20C20.125%2C5.50353364%2019.9962862%2C5.27083333%2019.8375%2C5.27083333%20C19.6787137%2C5.27083333%2019.55%2C5.50353364%2019.55%2C5.79048564%20L19.55%2C11.7789068%20C19.55%2C12.0659108%2019.6787137%2C12.2986111%2019.8375%2C12.2986111%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15.8125%2C12.2986111%20C15.9712863%2C12.2986111%2016.1%2C12.051611%2016.1%2C11.7470252%20L16.1%2C4.06547477%20C16.1%2C3.76083389%2015.9712863%2C3.51388889%2015.8125%2C3.51388889%20C15.6537137%2C3.51388889%2015.525%2C3.76083389%2015.525%2C4.06547477%20L15.525%2C11.7470252%20C15.525%2C12.051611%2015.6537137%2C12.2986111%2015.8125%2C12.2986111%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12.3625%2C12.2986111%20C12.5212863%2C12.2986111%2012.65%2C12.0689338%2012.65%2C11.7857095%20L12.65%2C4.02679049%20C12.65%2C3.74356623%2012.5212863%2C3.51388889%2012.3625%2C3.51388889%20C12.2037138%2C3.51388889%2012.075%2C3.74356623%2012.075%2C4.02679049%20L12.075%2C11.7856582%20C12.075%2C12.0689338%2012.2037138%2C12.2986111%2012.3625%2C12.2986111%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.287485626%2C7.02777778%20C0.445832708%2C7.02777778%200.575%2C6.89621192%200.575%2C6.7349537%20C0.575%2C6.5736662%200.445832708%2C6.44212963%200.287485626%2C6.44212963%20C0.129138543%2C6.44212963%204.64987616e-13%2C6.5736662%204.64987616e-13%2C6.7349537%20C4.64987616e-13%2C6.89621192%200.129138543%2C7.02777778%200.287485626%2C7.02777778%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var plane = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2232px%22%20height%3D%2232px%22%20viewBox%3D%220%200%2032%2032%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3E4B1F5003-767D-4F56-8BEC-1444A8D9E7F0%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20sketchtool.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%221A.Ops-intake-PARTY-tab-US--AIR%22%20transform%3D%22translate%28-1120.000000%2C%20-69.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22AIR%22%20transform%3D%22translate%281121.000000%2C%2070.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20stroke%3D%22%230A86B8%22%20fill%3D%22%23FFFFFF%22%20cx%3D%2215%22%20cy%3D%2215%22%20r%3D%2215%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22travel%22%20transform%3D%22translate%284.000000%2C%206.000000%29%22%20fill%3D%22%230A86B8%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M17.7327007%2C7.42018415%20L19.3086329%2C6.01905701%20L19.3146315%2C6.01408661%20C20.5817186%2C4.84022485%2021.1916961%2C3.11910939%2020.9467796%2C1.40913433%20L20.8895353%2C1.00310739%20C20.8208078%2C0.541549547%2020.4584891%2C0.179056084%2019.9969356%2C0.110156597%20L19.5939974%2C0.0532545953%20C17.8806104%2C-0.192178324%2016.156083%2C0.420375602%2014.9810324%2C1.69141647%20L13.5799182%2C3.26753458%20L12.8227167%2C2.83185685%20C10.8292782%2C1.68850283%208.57069931%2C1.08863186%206.27270064%2C1.09188827%20L5.6210754%2C1.09428778%20C4.99635843%2C1.09720143%204.41997346%2C1.43124389%204.10684371%2C1.9718133%20L3.98412843%2C2.18502458%20C3.88746436%2C2.35281707%203.94488006%2C2.56722806%204.11249962%2C2.6640644%20L10.7999706%2C6.5251767%20L5.57411453%2C12.4460745%20L5.17391859%2C12.9605924%20C4.08867638%2C12.3660346%202.87129237%2C12.0537589%201.63368436%2C12.0525591%20L1.10511724%2C12.0501596%20C0.730972605%2C12.0544444%200.386135691%2C12.2541158%200.196406822%2C12.576675%20L0.0471260638%2C12.83222%20C0.000507943508%2C12.9127741%20-0.0121749382%2C13.0087534%200.011991101%2C13.0987341%20C0.0359856734%2C13.1887147%200.0949438733%2C13.2654982%200.175668629%2C13.3119453%20L3.58033327%2C15.2776368%20C3.48384067%2C15.4642824%203.39231833%2C15.6514421%203.30902275%2C15.8437436%20C3.12597811%2C16.2773646%203.1708823%2C16.773715%203.42882445%2C17.1674017%20C3.68676657%2C17.5610885%204.12381134%2C17.8005227%204.59444862%2C17.8060072%20C4.78760529%2C17.8056644%204.97870524%2C17.7659016%205.15609402%2C17.6894608%20C5.16500631%2C17.6858616%205.17391859%2C17.6817482%205.1823167%2C17.6771206%20C5.35782018%2C17.6017083%205.53863676%2C17.5129274%205.72219559%2C17.4181478%20L7.68786882%2C20.822844%20C7.73414417%2C20.9039122%207.81075552%2C20.9633852%207.90090674%2C20.9877228%20C7.99105792%2C21.0122318%208.08720776%2C20.9997202%208.1681039%2C20.9531017%20L8.42604606%2C20.8039909%20L8.42810274%2C20.8039909%20C8.75048754%2C20.6125463%208.94930007%2C20.2661637%208.95187093%2C19.8913301%20L8.94947145%2C19.3692709%20C8.94792895%2C18.1306231%208.6347992%2C16.9121995%208.03887577%2C15.8262617%20L8.54601914%2C15.4317179%20L14.4714896%2C10.1996434%20L18.3346228%2C16.8880333%20C18.4316297%2C17.0556543%2018.6460387%2C17.1132419%2018.8138296%2C17.016577%20L19.0268675%2C16.8940319%20C19.5676033%2C16.5807279%2019.9016427%2C16.0041662%2019.9043849%2C15.3791007%20L19.9064416%2C14.7283264%20C19.915868%2C12.4296209%2019.3156598%2C10.1693071%2018.1671747%2C8.17807828%20L17.7327007%2C7.42018415%20Z%20M5.62364626%2C1.7963082%20L6.27510008%2C1.79387634%20C8.44952649%2C1.78893834%2010.5867612%2C2.35675909%2012.4720525%2C3.44012603%20L13.112366%2C3.80844679%20L11.2682083%2C5.98752093%20L4.77132322%2C2.23541372%20C4.96893602%2C1.96135842%205.28566495%2C1.79819352%205.62364626%2C1.7963082%20Z%20M1.10683112%2C12.7521801%20L1.63334155%2C12.7545795%20C2.71584157%2C12.7547509%203.78205947%2C13.0176658%204.740473%2C13.5208718%20L4.52006529%2C13.8048679%20C4.39255104%2C13.9659761%204.27154964%2C14.1361681%204.15363324%2C14.3109876%20C4.11849828%2C14.3615481%204.0869625%2C14.4131371%204.05354142%2C14.464726%20C4.01035111%2C14.5317401%203.96510412%2C14.5963548%203.92328493%2C14.6650829%20L0.834492235%2C12.8829519%20C0.901334402%2C12.8010267%201.00108343%2C12.753037%201.10683112%2C12.7521801%20L1.10683112%2C12.7521801%20Z%20M8.24557228%2C19.3697851%20L8.24814309%2C19.8884164%20C8.24814309%2C19.995879%208.1998111%2C20.0975143%208.11685829%2C20.1653854%20L6.33508664%2C17.0765641%20C6.40312851%2C17.0350873%206.46705701%2C16.9908683%206.53338499%2C16.9480203%20C6.58565897%2C16.9130564%206.63878993%2C16.8810062%206.69003554%2C16.8462136%20C6.86022596%2C16.7318954%207.02561741%2C16.6143207%207.18141101%2C16.4917757%20L7.1918658%2C16.484063%20L7.47980119%2C16.2600541%20C7.983174%2C17.2193334%208.24591503%2C18.2864181%208.24557228%2C19.3697851%20Z%20M8.09783397%2C14.8911485%20L7.37542462%2C15.4527991%20C7.37371074%2C15.4527991%207.37131126%2C15.4527991%207.36959738%2C15.4558842%20L6.75739189%2C15.9333815%20C6.41906778%2C16.1985244%206.06017689%2C16.4365875%205.68397558%2C16.6448284%20C5.42414816%2C16.7920539%205.1566082%2C16.9253966%204.88272678%2C17.0443425%20C4.87484285%2C17.0474275%204.86747307%2C17.0508554%204.85976052%2C17.0547974%20C4.59564836%2C17.1567755%204.2960584%2C17.0907896%204.09913117%2C16.8875191%20C3.90203255%2C16.6840771%203.84564522%2C16.3825991%203.95602041%2C16.121741%20C4.07565073%2C15.8458003%204.20967778%2C15.5763725%204.35793026%2C15.314486%20C4.56651202%2C14.9365673%204.80491569%2C14.5759592%205.07108452%2C14.2362608%20L5.54497818%2C13.628163%20C5.54497818%2C13.628163%205.54497818%2C13.6243924%205.54772043%2C13.6226785%20L6.11467893%2C12.8925499%20L15.5006872%2C2.16325782%20C16.3634651%2C1.23242951%2017.5746791%2C0.702657748%2018.8439942%2C0.701286615%20C19.0613169%2C0.701286615%2019.2782968%2C0.716883271%2019.4933914%2C0.74824792%20L19.8963296%2C0.805149965%20C20.0502379%2C0.827945095%2020.1715821%2C0.948433429%2020.1948912%2C1.10251458%20L20.2521354%2C1.50819875%20C20.4636309%2C2.98885169%2019.9354065%2C4.47910252%2018.8386811%2C5.49596948%20L8.09783397%2C14.8911485%20Z%20M19.2037421%2C15.377044%20C19.2018568%2C15.7146856%2019.038522%2C16.0312461%2018.7642979%2C16.228518%20L15.0127396%2C9.72985874%20L17.1924791%2C7.88739795%20L17.5613106%2C8.52840292%20C18.647924%2C10.4130261%2019.2153966%2C12.5521659%2019.2057988%2C14.7276408%20L19.2037421%2C15.377044%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M17.5657305%2C1.90221571%20C18.0054532%2C1.64188439%2018.5657127%2C1.71275134%2018.9267769%2C2.07437326%20C19.2878412%2C2.4361773%2019.3583061%2C2.9965546%2019.0975678%2C3.43633051%20C18.9925077%2C3.61358903%2019.0509554%2C3.84240368%2019.2279369%2C3.94770213%20C19.4051006%2C4.0528184%2019.6339748%2C3.99452167%2019.7390349%2C3.8172632%20C20.1734773%2C3.08454623%2020.056582%2C2.15034117%2019.4548083%2C1.54733438%20C18.8530346%2C0.944509795%2017.9195115%2C0.826094544%2017.1864583%2C1.2596765%20C17.0702914%2C1.32671774%2016.9990982%2C1.45114478%2017%2C1.58522725%20C17.0007369%2C1.71949189%2017.0735688%2C1.84282594%2017.1906461%2C1.90840976%20C17.3077234%2C1.97399357%2017.4510203%2C1.97162524%2017.5657305%2C1.90221571%20L17.5657305%2C1.90221571%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var ship = "data:image/svg+xml,%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2024%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%221A.-Landing-page-%22%20transform%3D%22translate%28-39.000000%2C%20-437.000000%29%22%20fill%3D%22%230AB88A%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-3%22%20transform%3D%22translate%2836.000000%2C%20435.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22ship%22%20transform%3D%22translate%283.000000%2C%202.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%225.64705882%22%20y%3D%227.05882353%22%20width%3D%2212.7058824%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2216.9411765%22%20y%3D%229.88235294%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%225.64705882%22%20y%3D%229.88235294%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2211.2941176%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2212.7058824%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%229.88235294%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%228.47058824%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%2214.1176471%22%20y%3D%224.23529412%22%20width%3D%221.41176471%22%20height%3D%221.41176471%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M21.7490551%2C22.4961123%20C21.2810986%2C22.7402837%2020.8753861%2C22.9511739%2020.0292213%2C22.9560489%20L23.1727145%2C13.7301763%20C23.2592045%2C13.4762081%2023.1351477%2C13.199318%2022.8855964%2C13.0894432%20L20.0000399%2C11.8192269%20L20.0000399%2C6.78261175%20C20.0000399%2C5.91955094%2019.2822925%2C5.21741168%2018.4000463%2C5.21741168%20L17.6000256%2C5.21741168%20L17.6000256%2C2.6086824%20C17.6000256%2C2.32054234%2017.3612556%2C2.08696467%2017.0667103%2C2.08696467%20L12.5332913%2C2.08696467%20L12.5332913%2C0%20L11.4666608%2C0%20L11.4666608%2C2.08696467%20L6.93328968%2C2.08696467%20C6.63874442%2C2.08696467%206.39997444%2C2.32054234%206.39997444%2C2.6086824%20L6.39997444%2C5.21736481%20L5.59995368%2C5.21736481%20C4.7177075%2C5.21736481%203.99996007%2C5.91950406%203.99996007%2C6.78256488%20L3.99996007%2C11.8188519%20L1.11435571%2C13.0893963%20C0.864756512%2C13.1992711%200.740747544%2C13.4761612%200.827333404%2C13.7301294%20L3.97082659%2C22.9559552%20C3.12461392%2C22.9510802%202.71894934%2C22.7402368%202.25099278%2C22.4960654%20C1.72711718%2C22.2227847%201.1333308%2C21.9129885%200%2C21.9129885%20L0%2C22.9564708%20C0.866673189%2C22.9564708%201.27559612%2C23.1697985%201.74901521%2C23.4168293%20C2.27284289%2C23.6901569%202.86658135%2C24%203.99996007%2C24%20C4.29996786%2C24%204.55589208%2C23.9805469%204.78205991%2C23.9407501%20C5.43650909%2C23.8400159%205.86905506%2C23.6145945%206.25076118%2C23.4156105%20C6.7234136%2C23.169236%207.13156986%2C22.9564708%207.99484095%2C22.9564708%20C8.86151413%2C22.9564708%209.27038915%2C23.1697985%209.74385615%2C23.4168293%20C10.2676838%2C23.6901569%2010.8614702%2C24%2011.994801%2C24%20C13.1281318%2C24%2013.7219182%2C23.6901569%2014.2457938%2C23.4168761%20C14.7192129%2C23.1698454%2015.1281358%2C22.9565177%2015.994809%2C22.9565177%20C16.8610989%2C22.9565177%2017.2705489%2C23.1692829%2017.7446388%2C23.4157043%20C18.1275428%2C23.6146414%2018.5612867%2C23.8400628%2019.2180838%2C23.940797%20C19.4441558%2C23.9806407%2019.6999842%2C24%2020%2C24%20C21.1333228%2C24%2021.7271092%2C23.6902037%2022.2509848%2C23.416923%20C22.7244518%2C23.1698922%2023.1333268%2C22.9565645%2024%2C22.9565645%20L24%2C21.9130822%20C22.8667171%2C21.9129885%2022.2729307%2C22.2227847%2021.7490551%2C22.4961123%20Z%20M22.0083335%2C13.8474573%20L21.6259087%2C14.9697833%20L12.5332913%2C10.8829006%20L12.5332913%2C9.67643423%20L22.0083335%2C13.8474573%20Z%20M7.46660491%2C3.13044701%20L16.5332993%2C3.13044701%20L16.5332993%2C5.21741168%20L7.46660491%2C5.21741168%20L7.46660491%2C3.13044701%20Z%20M5.0664947%2C6.78261175%20C5.0664947%2C6.49494044%205.30583967%2C6.26089402%205.59990576%2C6.26089402%20L6.93324176%2C6.26089402%20L17.0666145%2C6.26089402%20L18.3999505%2C6.26089402%20C18.6940166%2C6.26089402%2018.9332657%2C6.49494044%2018.9332657%2C6.78261175%20L18.9332657%2C11.3495872%20L12.2187167%2C8.39379611%20C12.0795181%2C8.33248373%2011.9201465%2C8.33243685%2011.7809958%2C8.39379611%20L5.0664947%2C11.3493528%20L5.0664947%2C6.78261175%20L5.0664947%2C6.78261175%20Z%20M1.99166645%2C13.8474573%20L11.4666608%2C9.6764811%20L11.4666608%2C10.8829475%20L2.37404341%2C14.9697833%20L1.99166645%2C13.8474573%20Z%20M18.954445%2C22.8103617%20C18.6953582%2C22.7279087%2018.4807384%2C22.6166746%2018.2449872%2C22.4941904%20C17.720872%2C22.2218003%2017.1267502%2C21.9130353%2015.9947611%2C21.9130353%20C14.8614303%2C21.9130353%2014.2676439%2C22.2228316%2013.7437683%2C22.4961123%20C13.2702534%2C22.7431431%2012.8614263%2C22.9565177%2011.9947531%2C22.9565177%20C11.1280799%2C22.9565177%2010.719157%2C22.74319%2010.2457379%2C22.4961123%20C9.72191021%2C22.2228316%209.12807592%2C21.9130353%207.99474511%2C21.9130353%20C6.86505599%2C21.9130353%206.27218004%2C22.2220816%205.74911903%2C22.4947061%20C5.51509283%2C22.6166746%205.3019584%2C22.72744%205.04526751%2C22.8096586%20L2.71329515%2C15.9655938%20L11.4666129%2C12.031289%20L11.4666129%2C18.2608237%20L12.5332913%2C18.2608237%20L12.5332913%2C12.031289%20L21.286609%2C15.9656407%20L18.954445%2C22.8103617%20Z%22%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var callSplit = "data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M6.16683%2013.6667V7.33334L2.00016%203.16667V5.33334H0.333496V0.333336H5.3335V2H3.16683L7.8335%206.66667V13.6667H6.16683ZM9.37516%205.83334L8.16683%204.625L10.8335%202H8.66683V0.333336H13.6668V5.33334H12.0002V3.16667L9.37516%205.83334Z%22%20fill%3D%22%230A0A0A%22%2F%3E%3C%2Fsvg%3E";

var iconStatusMapping = {
  scheduled: {
    name: "circle",
    color: "white",
    progressLineColor: "green"
  },
  success: {
    name: "check circle",
    color: "green",
    progressLineColor: "green"
  },
  failure: {
    name: "times circle",
    color: "red",
    progressLineColor: "green"
  },
  ENTITY_SOURCE_NONE: {
    name: "circle",
    color: "white",
    progressLineColor: "grey"
  },
  HOLD_NONE: {
    name: "circle",
    color: "white",
    progressLineColor: "grey"
  },
  TMODAL: {
    name: "check circle",
    color: "green",
    progressLineColor: "green"
  },
  OPS: {
    name: "check circle",
    color: "green",
    progressLineColor: "green"
  },
  P44: {
    name: "check circle",
    color: "green",
    progressLineColor: "green"
  },
  EMODAL: {
    name: "check circle",
    color: "green",
    progressLineColor: "green"
  },
  NO_HOLD: {
    name: "check circle",
    color: "green",
    progressLineColor: "green"
  },
  ON_HOLD: {
    name: "times circle",
    color: "red",
    progressLineColor: "green"
  },
  HOLD_REMOVED: {
    name: "check circle",
    color: "green",
    progressLineColor: "green"
  },
  FEES_NONE: {
    name: "circle",
    color: "white",
    progressLineColor: "grey"
  },
  NO_DUES: {
    name: "check circle",
    color: "green",
    progressLineColor: "green"
  },
  FEES_DUE: {
    name: "times circle",
    color: "red",
    progressLineColor: "green"
  },
  FEES_PAID: {
    name: "check circle",
    color: "green",
    progressLineColor: "green"
  }
};

var statesMapping = {
  grounded: {
    identifier: "showGroundPopuop"
  },
  carrierReleased: {
    identifier: "showLineReleasePopuop"
  },
  readyForPickup: {
    identifier: "showReadyPickup"
  },
  gateOut: {
    identifier: "showGateOut"
  },
  gateIn: {
    identifier: "showGateIn"
  }
};

var statusTextMapping = {
  NO_HOLD: "No hold",
  HOLD_REMOVED: "Hold removed",
  ON_HOLD: "Remove Holds",
  NO_DUES: "No dues",
  FEES_DUE: "Fees paid",
  FEES_PAID: "Fees paid"
};

var tableHeaders = ["Date", "Source", "Action"];

var styles = {
  dropdownText: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#1F1F1F"
  },
  label: {
    fontWeight: "400",
    color: "#7A7A7A"
  },
  selectedOption: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    fontWeight: "500"
  }
};

var stringTypeFields = {
  fees: true,
  holds: true,
  readyForPickup: true,
  purchaseOrder: true
  // eta: true,
  // doCreated: true,
  // anRecieved: true,
  // doPublished: true,
  // berthingDate: true,
};

var rowHeaders = [{
  displayName: "GROUNDED",
  dataType: "timestamp",
  fieldName: "grounded",
  status: "ENTITY_SOURCE_NONE",
  dataList: [],
  compactName: "GRD"
}, {
  displayName: "CUSTOMS REL",
  dataType: "timestamp",
  fieldName: "customReleased",
  status: "ENTITY_SOURCE_NONE",
  dataList: [],
  compactName: "C REL"
}, {
  displayName: "LINE RELEASE",
  dataType: "timestamp",
  fieldName: "carrierReleased",
  status: "ENTITY_SOURCE_NONE",
  dataList: [],
  compactName: "L REL"
}, {
  displayName: "HOLD",
  dataType: "timestamp",
  fieldName: "holds",
  status: "HOLD_NONE",
  dataList: [],
  compactName: "HOLD",
  showInToolTip: true
}, {
  displayName: "FEES",
  dataType: "string",
  fieldName: "fees",
  status: "ENTITY_SOURCE_NONE",
  dataList: [],
  compactName: "FEES"
}, {
  displayName: "READY FOR PICKUP",
  dataType: "timestamp",
  fieldName: "readyForPickup",
  status: "ENTITY_SOURCE_NONE",
  dataList: [],
  compactName: "RFP"
}, {
  displayName: "TERM APPT",
  dataType: "timestamp",
  fieldName: "terminalPickupAppointment", //terminalAppointment
  status: "ENTITY_SOURCE_NONE",
  dataList: [],
  compactName: "TER APP"
}, {
  displayName: "GATE OUT",
  dataType: "timestamp",
  fieldName: "gateOut",
  status: "ENTITY_SOURCE_NONE",
  dataList: [],
  compactName: "G OUT"
}, {
  displayName: "DEL APPT",
  dataType: "timestamp",
  status: "ENTITY_SOURCE_NONE",
  fieldName: "terminalDropAppointment", //deliveryAppointment
  dataList: [],
  compactName: "DEL APP"
}, {
  displayName: "ACTUAL DELIVERY",
  dataType: "timestamp",
  status: "ENTITY_SOURCE_NONE",
  fieldName: "warehouseDropAppointment", //actualDelivery
  dataList: [],
  compactName: "ACT DEL"
}, {
  displayName: "TERM RETURN APP",
  dataType: "timestamp",
  status: "ENTITY_SOURCE_NONE",
  fieldName: "warehousePickupAppointment", //terminalReturnApp
  dataList: [],
  compactName: "TRP"
}, {
  displayName: "GATE IN",
  dataType: "timestamp",
  fieldName: "gateIn",
  status: "ENTITY_SOURCE_NONE",
  dataList: [],
  compactName: "G IN"
}];

var containerModalHeaderOnly = [{
  displayName: "INLAND ETA",
  fieldName: "p44DestinationEta"
}];

var metaData = [{
  displayName: "VESSEL",
  dataType: "string",
  fieldName: "carrierName",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "VESSEL"
}, {
  displayName: "AN RECEIVED",
  dataType: "isoTimestamp",
  fieldName: "arrivalNoticeReceived",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "AN RECV"
}, {
  displayName: "DO CREATED",
  dataType: "isoTimestamp",
  fieldName: "doCreated",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "DO CRE"
}, {
  displayName: "ETA",
  dataType: "timestamp",
  fieldName: "eta",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "ETA"
}, {
  displayName: "BERTHING DATE",
  dataType: "timestamp",
  fieldName: "berthed",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "BERTH DATE"
}, {
  displayName: "SHIPMENT",
  dataType: "string",
  fieldName: "shipmentId",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "SHIP"
}, {
  displayName: "MBOL",
  dataType: "string",
  fieldName: "masterBolNumber",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "MBOL"
}, {
  displayName: "HBOL",
  dataType: "string",
  fieldName: "bolDocNumber",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "HBOL"
}, {
  displayName: "PO",
  dataType: "string",
  fieldName: "purchaseOrder",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "PO"
},
// {
//   displayName: 'FINAL DELIVERY',
//   dataType: 'string',
//   fieldName: 'finalDelivery',
//   // status: 'ENTITY_SOURCE_NONE',
//   dataList: [],
//   compactName: 'FIN DEL',
// },

// {
//   displayName: 'SEAL',
//   dataType: 'string',
//   fieldName: 'seal',
//   // status: 'ENTITY_SOURCE_NONE',
//   dataList: [],
//   compactName: 'SEAL',
// },
{
  displayName: "DO PUBLISHED",
  dataType: "timestamp",
  fieldName: "doPublished",
  // status: 'ENTITY_SOURCE_NONE',
  dataList: [],
  compactName: "DO PUB"
}];

var containerFilters = [{
  displayName: "Vessel",
  fieldName: "vessel",
  alt: "Vessel Icon"
}, {
  displayName: "Port",
  fieldName: "port",
  alt: "port Icon"
}, {
  displayName: "Container",
  fieldName: "container",
  alt: "container Icon"
}];

var checkBoxFilters = [{
  labelName: "Show Unprocessed Only",
  fieldName: "excludeprocessed",
  showFor: ["Ops"]
}, {
  labelName: "Drayage Ready Containers",
  fieldName: "showDrayageOnly",
  showFor: ["Ops"]
}, {
  labelName: "Active Drayage Containers",
  fieldName: "activeDrayageContainers",
  showFor: ["Ops"]
}, {
  labelName: "History Mode",
  fieldName: "historyMode",
  showFor: ["Ops"]
}, {
  labelName: "Containers Pending Assignment",
  fieldName: "containersPendingAssignment",
  showFor: ["Ops"]
}, {
  labelName: "P44 Non tracking",
  fieldName: "p44NonTracking",
  showFor: ["Ops"]
}, {
  labelName: "TModal vs P44 differences",
  fieldName: "TModalVSP44differences",
  showFor: ["Ops"]
}, {
  labelName: "Comments Only",
  fieldName: "filterContainerComment",
  showFor: ["Ops"]
}, {
  labelName: "Hot Containers",
  fieldName: "hotContainers",
  showFor: ["Ops"]
}, {
  labelName: "HyperCare Containers",
  fieldName: "hyperCareContainers",
  showFor: ["Ops"]
}, {
  labelName: "Invoice Not Submitted",
  fieldName: "invoiceNotSubmitted",
  showFor: ["Ops"]
}];

var containerHeaderDataOPS = [{
  label: 'CUSTOMER',
  fieldName: 'customer'
}, {
  label: 'PODINLAND',
  fieldName: 'isPodInland'
}, {
  label: 'D-CARRIER',
  fieldName: 'drayagePartner'
}, {
  label: 'PORT',
  fieldName: 'portName'
}, {
  label: 'TERMINAL',
  fieldName: 'terminal'
}, {
  label: 'SIZE',
  fieldName: 'sizeType'
}, {
  label: 'DELIVERY ADDRESS',
  fieldName: 'finalDestinationInfo'
}];

var containerHeaderDataDrayage = [{
  label: 'PORT',
  fieldName: 'portName'
}, {
  label: 'TERMINAL',
  fieldName: 'terminal'
}, {
  label: 'SIZE',
  fieldName: 'sizeType'
}, {
  label: 'DELIVERY ADDRESS',
  fieldName: 'finalDestinationInfo'
}];

var toTitleCase = function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

var salesMultiCountryRadio = [{ label: "USA", value: "US", text: "US", name: "customerCountryRadioGroup", key: "US" }, { label: "Canada", value: "CA", text: "CA", name: "customerCountryRadioGroup", key: "CA" }];

var salesMultiMOTRadio = [{ label: "Ocean", value: "MOT_OCEAN", text: "Ocean", name: "motRadioGroup", key: "MOT_OCEAN" }, { label: "Air", value: "MOT_AIR", text: "Air", name: "motRadioGroup", key: "MOT_AIR" }];

var salesOpportunityFilters = [{ text: "--Select--", value: "Select", key: "Select" }, { text: "Destination", value: "DRAYAGE_DESTINATION", key: "DRAYAGE_DESTINATION" }, { text: "Opportunity Name", value: "DRAYAGE_OPPORTUNITY_NAME", key: "DRAYAGE_OPPORTUNITY_NAME" }, { text: "Source", value: "DRAYAGE_SOURCE", key: "DRAYAGE_SOURCE" }, { text: "Customer Name", value: "DRAYAGE_CUSTOMER", key: "DRAYAGE_CUSTOMER" }, { text: "Container Number", value: "DRAYAGE_CONTAINER_NUMBER", key: "DRAYAGE_CONTAINER_NUMBER" }];

var partnerOpportunityFilters = [{ text: "--Select--", value: "Select", key: "Select" }, { text: "Destination", value: "DRAYAGE_DESTINATION", key: "DRAYAGE_DESTINATION" }, { text: "Opportunity Name", value: "DRAYAGE_OPPORTUNITY_NAME", key: "DRAYAGE_OPPORTUNITY_NAME" }, { text: "Source", value: "DRAYAGE_SOURCE", key: "DRAYAGE_SOURCE" }, { text: "Container Number", value: "DRAYAGE_CONTAINER_NUMBER", key: "DRAYAGE_CONTAINER_NUMBER" }];

var salesPortalTabs = {
  SALES_NEW: "SALES_NEW",
  SALES_CUSTOMER_REQUESTED: "SALES_CUSTOMER_REQUESTED",
  SALES_PUBLISHED: "SALES_PUBLISHED",
  SALES_PENDING_APPROVAL: "SALES_PENDING_APPROVAL",
  SALES_ACCEPTED: "SALES_ACCEPTED",
  SALES_REJECTED: "SALES_REJECTED",
  SALES_ARCHIVED: "SALES_ARCHIVED"
};

var DRAYAGE_SOURCE_TYPES = {
  PORT: "PORT",
  CUSTOMER_WAREHOUSE: "CUSTOMER_WAREHOUSE"
};

var DRAYAGE_DESTINATION_TYPES = {
  PORT: "PORT",
  CUSTOMER_WAREHOUSE: "CUSTOMER_WAREHOUSE"
};

var DRAYAGE_CURRENCY_OPTIONS = [{ id: 1, key: 'USD', value: 'USD', text: 'USD', label: 'USD $', icon: "$" }, { id: 2, key: 'CAD', value: 'CAD', text: 'CAD', label: 'CAD $', icon: "$" }, { id: 3, key: 'EUR', value: 'EUR', text: 'EUR', label: 'EUR €', icon: "€" }, { id: 4, key: 'GBP', value: 'GBP', text: 'GBP', label: 'GBP £', icon: "£" }, { id: 5, key: 'INR', value: 'INR', text: 'INR', label: 'INR ₹', icon: "₹" }];

var DRAYAGE_CURRENCY_TYPES = {
  AP_CURRENCY: "apCurrencyCode",
  AR_CURRENCY: "arCurrencyCode"
};

var DRAYAGE_CURRENCY_COLUMNS = {
  SUGGESTED_BID: DRAYAGE_CURRENCY_TYPES.AP_CURRENCY,
  SALES_PENDING_APPROVAL: DRAYAGE_CURRENCY_TYPES.AP_CURRENCY,
  SALES_ACCEPTED: DRAYAGE_CURRENCY_TYPES.AP_CURRENCY,
  SALES_REJECTED: DRAYAGE_CURRENCY_TYPES.AP_CURRENCY,
  SALES_ARCHIVED: DRAYAGE_CURRENCY_TYPES.AP_CURRENCY,
  KN_CHARGES: DRAYAGE_CURRENCY_TYPES.AR_CURRENCY,
  AR_WITHOUT_AP: DRAYAGE_CURRENCY_TYPES.AR_CURRENCY,
  DRAYAGE_NEW: DRAYAGE_CURRENCY_TYPES.AP_CURRENCY,
  DRAYAGE_SUBMITTED: DRAYAGE_CURRENCY_TYPES.AP_CURRENCY,
  DRAYAGE_ACTIVE: DRAYAGE_CURRENCY_TYPES.AP_CURRENCY,
  DRAYAGE_REJECTED: DRAYAGE_CURRENCY_TYPES.AP_CURRENCY,
  CUSTOMER_NEW: DRAYAGE_CURRENCY_TYPES.AR_CURRENCY,
  CUSTOMER_REQUESTED: DRAYAGE_CURRENCY_TYPES.AR_CURRENCY,
  CUSTOMER_ACTIVE: DRAYAGE_CURRENCY_TYPES.AR_CURRENCY,
  CUSTOMER_REJECTED: DRAYAGE_CURRENCY_TYPES.AR_CURRENCY
};

var multipleDocUploadList = [{ text: "POD", id: 0 }, { text: "EIR", id: 1 }];
var CountryCurrencyMap = {
  US: "$",
  CA: "CA$",
  CANADA: "CA$",
  GB: "£",
  UK: "£",
  NL: "€",
  ES: "€"
};
// export const sampleResponses = {
//   data: [
//     {
//       label: 'CUSTOMER',
//       value: 'Lifestyle'
//     },{
//       label: 'PORT',
//       value: 'Los Angeles'
//     },{
//       label: 'TERMINAL',
//       value: 'Fenix Marine'
//     },{
//       label: 'SIZE',
//       value: '40HC'
//     },{
//       label: 'WEIGHT',
//       value: '4.5T'
//     }
//     // ,{
//     //   label: 'TOTAL FEES',
//     //   value: '$2000'
//     // }
//   ],

//   searchLevel1Vessel: {
//     data: {
//       "eventId": "ffffffff-875d-6a5f-7b72-bc089d139247----ffffffff-e3f8-00ea-1c61-57a452098bed",
//       "eventType": "ETA_SEARCH_LEVEL1",
//       "eventMessage": {
//         "ports": [],
//         "vessels": [
//         {
//           "imo": "8201624",
//           "name": "MSC IRIS"
//         },
//         {
//           "imo": "9302140",
//           "name": "ONE HUMBER"
//         },
//         // {
//         //   "imo": "9424924",
//         //   "name": "ONE MATRIX"
//         // },
//         // {
//         //   "imo": "9454400",
//         //   "activeShipmentCount": 2
//         // },
//         // {
//         //   "imo": "9475648",
//         //   "name": "ONE MANEUVER",
//         //   "activeShipmentCount": 1
//         // },
//         // {
//         //   "imo": "9604081",
//         //   "name": "EVER LOGIC",
//         //   "activeShipmentCount": 2
//         // },
//         // {
//         //   "imo": "9606338",
//         //   "name": "MSC AMSTERDAM"
//         // }
//         ]
//       },
//       "responseTopic": "service_event_response_ops",
//       "eventTime": 1631617286561,
//       "tenantID": "TENANT_DEFAULT",
//       "typeOfUser": "OPS_SUPER_VISOR",
//       "userIPaddress": "171.50.166.154",
//       "userAgentname": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/93.0.4577.63 Safari/537.36"
//     }
//   },
//   searchLevel2Vessel : {
//     data: {
//       "eventId": "ffffffff-875d-6a5f-7b72-bc089d139247----ffffffff-e405-0331-1c61-57a452098cc0",
//       "eventType": "EED_SEARCH_ENTITY",
//       "eventMessage": {
//         "list": [
//           {
//             "unloc": "USOAK",
//             "name": "Oakland, USA",
//             "containers": [
//               {
//             "entityId": "OOCU6857310",
//             "entityType": "WORKFLOW_ENTITY_TYPE_CONTAINER",
//             "entityTimezone": "America/New_York",
//             "entityShipmentList": [
//               {
//                 "portOfUnlading": "New York, USA",
//                 "shipmentId": "KX-J2J1-2881",
//                 "terminalName": "TEST",
//                 "bolDocNumber": "OOLU2622447180",
//                 "masterBolNumber": "OOLU2622447180",
//                 "scaccode": "OOLU",
//                 "customerEmail": "lifestyle@shipment.klearexpress.com",
//                 "purchaseOrder": "WHS-5252-4393782",
//                 "drayageEnabled": 2
//               },
//               {
//                 "portOfUnlading": "New York, USA",
//                 "shipmentId": "KX-T0C0-1183",
//                 "bolDocNumber": "OOLU2622447180",
//                 "masterBolNumber": "OOLU2622447180",
//                 "scaccode": "OOLU",
//                 "customerEmail": "wayfair@shipment.klearexpress.com",
//                 "purchaseOrder": "WHS-5252-4393782",
//                 "drayageEnabled": 2
//               },
//               {
//                 "portOfUnlading": "New York, USA",
//                 "shipmentId": "KX-J2J1-2881",
//                 "terminalName": "TEST",
//                 "bolDocNumber": "OOLU2622447180",
//                 "masterBolNumber": "OOLU2622447180",
//                 "scaccode": "OOLU",
//                 "customerEmail": "lifestyle@shipment.klearexpress.com",
//                 "purchaseOrder": "WHS-5252-4393782",
//                 "drayageEnabled": 2
//               },
//               {
//                 "portOfUnlading": "New York, USA",
//                 "shipmentId": "KX-T0C0-1183",
//                 "bolDocNumber": "OOLU2622447180",
//                 "masterBolNumber": "OOLU2622447180",
//                 "scaccode": "OOLU",
//                 "customerEmail": "wayfair@shipment.klearexpress.com",
//                 "purchaseOrder": "WHS-5252-4393782",
//                 "drayageEnabled": 2
//               }
//             ],
//             "grounded": {
//               "eventName": "UNLOAD_FROM_VESSEL",
//               "eventDescription": "UNLOAD_FROM_VESSEL",
//               "sourceSelected": "OPS",
//               "OPSTime": "1577817000000",
//               "createdDate": "2020-01-21 13:07:18",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "customReleased": {
//               "eventName": "CUSTOM_RELEASED",
//               "eventDescription": "CUSTOM_RELEASED",
//               "sourceSelected": "OPS",
//               "OPSTime": "1577989800000",
//               "createdDate": "2020-01-21 13:14:35",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "carrierReleased": {
//               "eventName": "CARRIER_RELEASED",
//               "eventDescription": "CARRIER_RELEASED",
//               "sourceSelected": "OPS",
//               "OPSTime": "1577989800000",
//               "createdDate": "2020-01-21 13:14:35",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "holds": {
//               "eventName": "CONTAINER_HOLDS",
//               "eventDescription": " ",
//               "sourceSelected": "OPS",
//               "holdStatus": "NO_HOLD",
//               "createdDate": "2020-01-22 05:25:13",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "fees": {
//               "eventName": "CONTAINER_FEES",
//               "eventDescription": " ",
//               "sourceSelected": "OPS",
//               "feesStatus": "NO_DUES",
//               "createdDate": "2020-01-22 05:25:13",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "readyForPickup": {
//               "eventName": "READY_FOR_PICKUP",
//               "eventDescription": "READY_FOR_PICKUP",
//               "sourceSelected": "OPS",
//               "OPSTime": "1579026600000",
//               "OPSTime2": "1579026600000",
//               "createdDate": "2020-01-21 13:20:23",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "gateOut": {
//               "eventName": "GATE_OUT",
//               "eventDescription": "GATE_OUT",
//               "sourceSelected": "OPS",
//               "OPSTime": "1579080600000",
//               "createdDate": "2020-01-22 04:58:29",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "gateIn": {
//               "eventName": "GATE_IN",
//               "eventDescription": "GATE_IN",
//               "sourceSelected": "OPS",
//               "OPSTime": "1579545000000",
//               "createdDate": "2020-01-22 05:25:13",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "done": {
//               "eventName": "CONTAINER_DONE",
//               "eventDescription": "DONE",
//               "sourceSelected": "ENTITY_SOURCE_NONE",
//               "createdDate": "2020-01-21 13:07:18",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "shipmentIds": "KX-J2J1-2881,KX-T0C0-1183,KX-J2J1-2881,KX-T0C0-1183"
//           },
//               {
//             "entityId": "DPAB1111222",
//             "entityType": "WORKFLOW_ENTITY_TYPE_CONTAINER",
//             "entityShipmentList": [
//               {
//                 "shipmentId": "KX-J2J1-1988",
//                 "customerEmail": "lifestyle@shipment.klearexpress.com",
//                 "drayageEnabled": 2
//               }
//             ],
//             "grounded": {
//               "eventName": "UNLOAD_FROM_VESSEL",
//               "eventDescription": "UNLOAD FROM VESSEL",
//               "sourceSelected": "OPS",
//               "eModalTime": "1600618764000",
//               "OPSTime": "1598009400000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-10-07 19:12:39"
//             },
//             "customReleased": {
//               "eventName": "CUSTOM_RELEASED",
//               "eventDescription": "CUSTOM RELEASED",
//               "sourceSelected": "OPS",
//               "OPSTime": "15985373170000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 14:09:36"
//             },
//             "carrierReleased": {
//               "eventName": "CARRIER_RELEASED",
//               "eventDescription": "LINE_RELEASED",
//               "sourceSelected": "OPS",
//               "OPSTime": "1598020200000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-31 13:56:59"
//             },
//             "holds": {
//               "eventName": "CONTAINER_HOLDS",
//               "sourceSelected": "OPS",
//               "holdStatus": "NO_HOLD",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 16:12:20"
//             },
//             "fees": {
//               "eventName": "CONTAINER_FEES",
//               "sourceSelected": "OPS",
//               "feesStatus": "NO_DUES",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 16:12:28"
//             },
//             "readyForPickup": {
//               "eventName": "READY_FOR_PICKUP",
//               "eventDescription": "READY_FOR_PICKUP",
//               "sourceSelected": "OPS",
//               "OPSTime": "1598545800000",
//               "OPSTime2": "1598545800000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 16:15:08"
//             },
//             "gateOut": {
//               "eventName": "GATE_OUT",
//               "eventDescription": "GATE_OUT",
//               "sourceSelected": "EMODAL",
//               "eModalTime": "1598533270000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 16:14:20"
//             },
//             "gateIn": {
//               "eventName": "GATE_IN",
//               "eventDescription": "GATE_IN",
//               "sourceSelected": "OPS",
//               "OPSTime": "1599827400705",
//               "createdDate": "2020-09-11 12:00:50",
//               "updatedDate": "2021-02-02 11:50:47"
//             },
//             "done": {
//               "eventName": "CONTAINER_DONE",
//               "eventDescription": "DONE",
//               "sourceSelected": "ENTITY_SOURCE_NONE",
//               "createdDate": "2021-02-02 11:49:26",
//               "updatedDate": "2021-02-02 11:49:26"
//             },
//             "shipmentIds": "KX-J2J1-1988"
//           }
//             ]
//           },
//           {
//             "unloc": "STKN",
//             "name": "STOCKHTON, USA",
//             "containers": [
//               {
//             "entityId": "OOCU6857310",
//             "entityType": "WORKFLOW_ENTITY_TYPE_CONTAINER",
//             "entityTimezone": "America/New_York",
//             "entityShipmentList": [
//               {
//                 "portOfUnlading": "New York, USA",
//                 "shipmentId": "KX-J2J1-2881",
//                 "terminalName": "TEST",
//                 "bolDocNumber": "OOLU2622447180",
//                 "masterBolNumber": "OOLU2622447180",
//                 "scaccode": "OOLU",
//                 "customerEmail": "lifestyle@shipment.klearexpress.com",
//                 "purchaseOrder": "WHS-5252-4393782",
//                 "drayageEnabled": 2
//               },
//               {
//                 "portOfUnlading": "New York, USA",
//                 "shipmentId": "KX-T0C0-1183",
//                 "bolDocNumber": "OOLU2622447180",
//                 "masterBolNumber": "OOLU2622447180",
//                 "scaccode": "OOLU",
//                 "customerEmail": "wayfair@shipment.klearexpress.com",
//                 "purchaseOrder": "WHS-5252-4393782",
//                 "drayageEnabled": 2
//               },
//               {
//                 "portOfUnlading": "New York, USA",
//                 "shipmentId": "KX-J2J1-2881",
//                 "terminalName": "TEST",
//                 "bolDocNumber": "OOLU2622447180",
//                 "masterBolNumber": "OOLU2622447180",
//                 "scaccode": "OOLU",
//                 "customerEmail": "lifestyle@shipment.klearexpress.com",
//                 "purchaseOrder": "WHS-5252-4393782",
//                 "drayageEnabled": 2
//               },
//               {
//                 "portOfUnlading": "New York, USA",
//                 "shipmentId": "KX-T0C0-1183",
//                 "bolDocNumber": "OOLU2622447180",
//                 "masterBolNumber": "OOLU2622447180",
//                 "scaccode": "OOLU",
//                 "customerEmail": "wayfair@shipment.klearexpress.com",
//                 "purchaseOrder": "WHS-5252-4393782",
//                 "drayageEnabled": 2
//               }
//             ],
//             "grounded": {
//               "eventName": "UNLOAD_FROM_VESSEL",
//               "eventDescription": "UNLOAD_FROM_VESSEL",
//               "sourceSelected": "OPS",
//               "OPSTime": "1577817000000",
//               "createdDate": "2020-01-21 13:07:18",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "customReleased": {
//               "eventName": "CUSTOM_RELEASED",
//               "eventDescription": "CUSTOM_RELEASED",
//               "sourceSelected": "OPS",
//               "OPSTime": "1577989800000",
//               "createdDate": "2020-01-21 13:14:35",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "carrierReleased": {
//               "eventName": "CARRIER_RELEASED",
//               "eventDescription": "CARRIER_RELEASED",
//               "sourceSelected": "OPS",
//               "OPSTime": "1577989800000",
//               "createdDate": "2020-01-21 13:14:35",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "holds": {
//               "eventName": "CONTAINER_HOLDS",
//               "eventDescription": " ",
//               "sourceSelected": "OPS",
//               "holdStatus": "NO_HOLD",
//               "createdDate": "2020-01-22 05:25:13",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "fees": {
//               "eventName": "CONTAINER_FEES",
//               "eventDescription": " ",
//               "sourceSelected": "OPS",
//               "feesStatus": "NO_DUES",
//               "createdDate": "2020-01-22 05:25:13",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "readyForPickup": {
//               "eventName": "READY_FOR_PICKUP",
//               "eventDescription": "READY_FOR_PICKUP",
//               "sourceSelected": "OPS",
//               "OPSTime": "1579026600000",
//               "OPSTime2": "1579026600000",
//               "createdDate": "2020-01-21 13:20:23",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "gateOut": {
//               "eventName": "GATE_OUT",
//               "eventDescription": "GATE_OUT",
//               "sourceSelected": "OPS",
//               "OPSTime": "1579080600000",
//               "createdDate": "2020-01-22 04:58:29",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "gateIn": {
//               "eventName": "GATE_IN",
//               "eventDescription": "GATE_IN",
//               "sourceSelected": "OPS",
//               "OPSTime": "1579545000000",
//               "createdDate": "2020-01-22 05:25:13",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "done": {
//               "eventName": "CONTAINER_DONE",
//               "eventDescription": "DONE",
//               "sourceSelected": "ENTITY_SOURCE_NONE",
//               "createdDate": "2020-01-21 13:07:18",
//               "updatedDate": "2020-09-16 12:55:11"
//             },
//             "shipmentIds": "KX-J2J1-2881,KX-T0C0-1183,KX-J2J1-2881,KX-T0C0-1183"
//           },
//               {
//             "entityId": "DPAB1111222",
//             "entityType": "WORKFLOW_ENTITY_TYPE_CONTAINER",
//             "entityShipmentList": [
//               {
//                 "shipmentId": "KX-J2J1-1988",
//                 "customerEmail": "lifestyle@shipment.klearexpress.com",
//                 "drayageEnabled": 2
//               }
//             ],
//             "grounded": {
//               "eventName": "UNLOAD_FROM_VESSEL",
//               "eventDescription": "UNLOAD FROM VESSEL",
//               "sourceSelected": "OPS",
//               "eModalTime": "1600618764000",
//               "OPSTime": "1598009400000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-10-07 19:12:39"
//             },
//             "customReleased": {
//               "eventName": "CUSTOM_RELEASED",
//               "eventDescription": "CUSTOM RELEASED",
//               "sourceSelected": "OPS",
//               "OPSTime": "15985373170000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 14:09:36"
//             },
//             "carrierReleased": {
//               "eventName": "CARRIER_RELEASED",
//               "eventDescription": "LINE_RELEASED",
//               "sourceSelected": "OPS",
//               "OPSTime": "1598020200000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-31 13:56:59"
//             },
//             "holds": {
//               "eventName": "CONTAINER_HOLDS",
//               "sourceSelected": "OPS",
//               "holdStatus": "NO_HOLD",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 16:12:20"
//             },
//             "fees": {
//               "eventName": "CONTAINER_FEES",
//               "sourceSelected": "OPS",
//               "feesStatus": "NO_DUES",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 16:12:28"
//             },
//             "readyForPickup": {
//               "eventName": "READY_FOR_PICKUP",
//               "eventDescription": "READY_FOR_PICKUP",
//               "sourceSelected": "OPS",
//               "OPSTime": "1598545800000",
//               "OPSTime2": "1598545800000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 16:15:08"
//             },
//             "gateOut": {
//               "eventName": "GATE_OUT",
//               "eventDescription": "GATE_OUT",
//               "sourceSelected": "EMODAL",
//               "eModalTime": "1598533270000",
//               "createdDate": "2020-08-24 18:51:40",
//               "updatedDate": "2020-08-27 16:14:20"
//             },
//             "gateIn": {
//               "eventName": "GATE_IN",
//               "eventDescription": "GATE_IN",
//               "sourceSelected": "OPS",
//               "OPSTime": "1599827400705",
//               "createdDate": "2020-09-11 12:00:50",
//               "updatedDate": "2021-02-02 11:50:47"
//             },
//             "done": {
//               "eventName": "CONTAINER_DONE",
//               "eventDescription": "DONE",
//               "sourceSelected": "ENTITY_SOURCE_NONE",
//               "createdDate": "2021-02-02 11:49:26",
//               "updatedDate": "2021-02-02 11:49:26"
//             },
//             "shipmentIds": "KX-J2J1-1988"
//           }
//             ]
//           }
//         ]
//       }
//     }
//   },

//   containerDataSample : [{
//     "entityId": "OOLU9502347",
//     "entityType": "WORKFLOW_ENTITY_TYPE_CONTAINER",
//     "entityTimezone": "America/Los_Angeles",
//     "entityShipmentList": [
//         {
//             "portOfUnlading": "Oakland, USA",
//             "shipmentId": "KX-J2J1-3306",
//             "terminalName": "BEN.E NUTTER",
//             "bolDocNumber": "EGLV23590581111",
//             "masterBolNumber": "EGLV235900581111",
//             "scaccode": "EGLV",
//             "customerEmail": "lifestyle@shipment.klearexpress.com",
//             "purchaseOrder": "29452,2,2945",
//             "drayageEnabled": 1,
//             'vesselName': "One Maneuver",
//             'finalDelivery': "Sep 25th 2021, 6:00pm",
//             'seal': "35HC00",
//             'eta': 1629939600000,
//             'anRecieved': 1629939600000,
//             'doCreated': 1629939600000,
//             'doPublished': 1629939600000,
//             'berthingDate': 1629939600000
//         }
//     ],
//     "grounded": {
//         "eventName": "UNLOAD_FROM_VESSEL",
//         "sourceSelected": "OPS",
//         "OPSTime": "1629939600000",
//         "createdDate": "2020-08-29 16:51:09",
//         "updatedDate": "2021-08-23 11:50:48"
//     },
//     "customReleased": {
//         "eventName": "CUSTOM_RELEASED",
//         "eventDescription": "CUSTOM_RELEASED",
//         "sourceSelected": "OPS",
//         "OPSTime": "1629939600000",
//         "createdDate": "2021-03-22 12:39:14",
//         "updatedDate": "2021-03-23 21:29:29"
//     },
//     "carrierReleased": {
//         "eventName": "CARRIER_RELEASED",
//         "eventDescription": "LINE_RELEASED",
//         "sourceSelected": "OPS",
//         "OPSTime": "1598860800000",
//         "createdDate": "2021-08-26 06:43:27",
//         "updatedDate": "2021-08-26 06:43:27"
//     },
//     "holds": {
//         "eventName": "CONTAINER_HOLDS",
//         "sourceSelected": "OPS",
//         "holdStatus": "ON_HOLD",
//         "eventDescription": "Some message comes here.",
//         "createdDate": "2021-08-24 08:06:22",
//         "updatedDate": "2021-08-26 08:05:13"
//     },
//     // "fees": {
//     //     "eventName": "CONTAINER_FEES",
//     //     "sourceSelected": "OPS",
//     //     "feesStatus": "NO_DUES",
//     //     "createdDate": "2021-08-26 08:05:16",
//     //     "updatedDate": "2021-08-26 08:05:16"
//     // },
//     // "readyForPickup": {
//     //     "eventName": "READY_FOR_PICKUP",
//     //     "eventDescription": "READY_FOR_PICKUP",
//     //     "sourceSelected": "OPS",
//     //     "tModalTime": "1615519800000",
//     //     "OPSTime": "1628983800000",
//     //     "OPSTime2": "1632534300000",
//     //     "createdDate": "2021-03-22 12:39:14",
//     //     "updatedDate": "2021-08-26 11:30:24"
//     // },
//     // "terminalAppointment": {
//     //   "eventName": "UNLOAD_FROM_VESSEL",
//     //   "sourceSelected": "OPS",
//     //   "OPSTime": "1629939600000",
//     //   "createdDate": "2020-08-29 16:51:09",
//     //   "updatedDate": "2021-08-23 11:50:48"
//     // },
//     // "gateOut": {
//     //     "eventName": "GATE_OUT",
//     //     "eventDescription": "GATE_OUT",
//     //     "sourceSelected": "OPS",
//     //     "OPSTime": "1632531600000",
//     //     "createdDate": "2021-09-16 12:28:12",
//     //     "updatedDate": "2021-09-16 12:28:18"
//     // },
//     // "deliveryAppointment": {
//     //   "eventName": "UNLOAD_FROM_VESSEL",
//     //   "sourceSelected": "OPS",
//     //   "OPSTime": "1629939600000",
//     //   "createdDate": "2020-08-29 16:51:09",
//     //   "updatedDate": "2021-08-23 11:50:48"
//     // },
//     // "actualDelivery": {
//     //   "eventName": "UNLOAD_FROM_VESSEL",
//     //   "sourceSelected": "OPS",
//     //   "OPSTime": "1629939600000",
//     //   "createdDate": "2020-08-29 16:51:09",
//     //   "updatedDate": "2021-08-23 11:50:48"
//     // },
//     // "terminalReturnApp": {
//     //   "eventName": "UNLOAD_FROM_VESSEL",
//     //   "sourceSelected": "OPS",
//     //   "OPSTime": "1629939600000",
//     //   "createdDate": "2020-08-29 16:51:09",
//     //   "updatedDate": "2021-08-23 11:50:48"
//     // },
//     // "gateIn": {
//     //     "eventName": "GATE_IN",
//     //     "eventDescription": "GATE_IN",
//     //     "sourceSelected": "ENTITY_SOURCE_NONE",
//     //     "createdDate": "2020-08-29 16:51:09",
//     //     "updatedDate": "2021-08-23 11:50:48"
//     // },
//     // "done": {
//     //     "eventName": "CONTAINER_DONE",
//     //     "eventDescription": "DONE",
//     //     "sourceSelected": "ENTITY_SOURCE_NONE",
//     //     "createdDate": "2020-08-29 16:51:09",
//     //     "updatedDate": "2021-08-23 11:50:48"
//     // },
//     "shipmentIds": "KX-J2J1-3306"
// },
// {
//   "entityId": "OOLU9502347",
//   "entityType": "WORKFLOW_ENTITY_TYPE_CONTAINER",
//   "entityTimezone": "America/Los_Angeles",
//   "entityShipmentList": [
//       {
//           "portOfUnlading": "Oakland, USA",
//           "shipmentId": "KX-J2J1-3306",
//           "terminalName": "BEN.E NUTTER",
//           "bolDocNumber": "EGLV23590581111",
//           "masterBolNumber": "EGLV235900581111",
//           "scaccode": "EGLV",
//           "customerEmail": "lifestyle@shipment.klearexpress.com",
//           "purchaseOrder": "29452,2,2945",
//           "drayageEnabled": 1,
//           'vesselName': "One Maneuver",
//           'finalDelivery': "Sep 25th 2021, 6:00pm",
//           'seal': "35HC00",
//           'eta': 1629939600000,
//           'anRecieved': 1629939600000,
//           'doCreated': 1629939600000,
//           'doPublished': 1629939600000,
//           'berthingDate': 1629939600000
//       }
//   ],
//   "grounded": {
//       "eventName": "UNLOAD_FROM_VESSEL",
//       "sourceSelected": "OPS",
//       "OPSTime": "1629939600000",
//       "createdDate": "2020-08-29 16:51:09",
//       "updatedDate": "2021-08-23 11:50:48"
//   },
//   "customReleased": {
//       "eventName": "CUSTOM_RELEASED",
//       "eventDescription": "CUSTOM_RELEASED",
//       "sourceSelected": "OPS",
//       "OPSTime": "1629939600000",
//       "createdDate": "2021-03-22 12:39:14",
//       "updatedDate": "2021-03-23 21:29:29"
//   },
//   "carrierReleased": {
//       "eventName": "CARRIER_RELEASED",
//       "eventDescription": "LINE_RELEASED",
//       "sourceSelected": "OPS",
//       "OPSTime": "1598860800000",
//       "createdDate": "2021-08-26 06:43:27",
//       "updatedDate": "2021-08-26 06:43:27"
//   },
//   "holds": {
//       "eventName": "CONTAINER_HOLDS",
//       "sourceSelected": "OPS",
//       "holdStatus": "NO_HOLD",
//       // "eventDescription": "Some message comes here.",
//       "createdDate": "2021-08-24 08:06:22",
//       "updatedDate": "2021-08-26 08:05:13"
//   },
//   "fees": {
//       "eventName": "CONTAINER_FEES",
//       "sourceSelected": "OPS",
//       "feesStatus": "NO_DUES",
//       "createdDate": "2021-08-26 08:05:16",
//       "updatedDate": "2021-08-26 08:05:16"
//   },
//   "readyForPickup": {
//       "eventName": "READY_FOR_PICKUP",
//       "eventDescription": "READY_FOR_PICKUP",
//       "sourceSelected": "OPS",
//       "tModalTime": "1615519800000",
//       "OPSTime": "1628983800000",
//       "OPSTime2": "1632534300000",
//       "createdDate": "2021-03-22 12:39:14",
//       "updatedDate": "2021-08-26 11:30:24"
//   },
//   "terminalAppointment": {
//     "eventName": "UNLOAD_FROM_VESSEL",
//     "sourceSelected": "OPS",
//     "OPSTime": "1629939600000",
//     "createdDate": "2020-08-29 16:51:09",
//     "updatedDate": "2021-08-23 11:50:48"
//   },
//   "gateOut": {
//       "eventName": "GATE_OUT",
//       "eventDescription": "GATE_OUT",
//       "sourceSelected": "OPS",
//       "OPSTime": "1632531600000",
//       "createdDate": "2021-09-16 12:28:12",
//       "updatedDate": "2021-09-16 12:28:18"
//   },
//   "deliveryAppointment": {
//     "eventName": "UNLOAD_FROM_VESSEL",
//     "sourceSelected": "OPS",
//     "OPSTime": "1629939600000",
//     "createdDate": "2020-08-29 16:51:09",
//     "updatedDate": "2021-08-23 11:50:48"
//   },
//   "actualDelivery": {
//     "eventName": "UNLOAD_FROM_VESSEL",
//     "sourceSelected": "OPS",
//     "OPSTime": "1629939600000",
//     "createdDate": "2020-08-29 16:51:09",
//     "updatedDate": "2021-08-23 11:50:48"
//   },
//   "terminalReturnApp": {
//     "eventName": "UNLOAD_FROM_VESSEL",
//     "sourceSelected": "OPS",
//     "OPSTime": "1629939600000",
//     "createdDate": "2020-08-29 16:51:09",
//     "updatedDate": "2021-08-23 11:50:48"
//   },
//   "gateIn": {
//       "eventName": "GATE_IN",
//       "eventDescription": "GATE_IN",
//       "sourceSelected": "ENTITY_SOURCE_NONE",
//       "createdDate": "2020-08-29 16:51:09",
//       "updatedDate": "2021-08-23 11:50:48"
//   },
//   "done": {
//       "eventName": "CONTAINER_DONE",
//       "eventDescription": "DONE",
//       "sourceSelected": "ENTITY_SOURCE_NONE",
//       "createdDate": "2020-08-29 16:51:09",
//       "updatedDate": "2021-08-23 11:50:48"
//   },
//   "shipmentIds": "KX-J2J1-3306"
// },
// {
// "entityId": "OOLU9502347",
// "entityType": "WORKFLOW_ENTITY_TYPE_CONTAINER",
// "entityTimezone": "America/Los_Angeles",
// "entityShipmentList": [
//     {
//         "portOfUnlading": "Oakland, USA",
//         "shipmentId": "KX-J2J1-3306",
//         "terminalName": "BEN.E NUTTER",
//         "bolDocNumber": "EGLV23590581111",
//         "masterBolNumber": "EGLV235900581111",
//         "scaccode": "EGLV",
//         "customerEmail": "lifestyle@shipment.klearexpress.com",
//         "purchaseOrder": "29452,2,2945,43243,32534,54234,42234,2222",
//         "drayageEnabled": 1,
//         'vesselName': "One Maneuver",
//         'finalDelivery': "Sep 25th 2021, 6:00pm",
//         'seal': "35HC00",
//         'eta': 1629939600000,
//         'anRecieved': 1629939600000,
//         'doCreated': 1629939600000,
//         'doPublished': 1629939600000,
//         'berthingDate': 1629939600000
//     }
// ],
// "grounded": {
//     "eventName": "UNLOAD_FROM_VESSEL",
//     "sourceSelected": "OPS",
//     "OPSTime": "1629939600000",
//     "createdDate": "2020-08-29 16:51:09",
//     "updatedDate": "2021-08-23 11:50:48"
// },
// "customReleased": {
//     "eventName": "CUSTOM_RELEASED",
//     "eventDescription": "CUSTOM_RELEASED",
//     "sourceSelected": "OPS",
//     "OPSTime": "1629939600000",
//     "createdDate": "2021-03-22 12:39:14",
//     "updatedDate": "2021-03-23 21:29:29"
// },
// "carrierReleased": {
//     "eventName": "CARRIER_RELEASED",
//     "eventDescription": "LINE_RELEASED",
//     "sourceSelected": "OPS",
//     "OPSTime": "1598860800000",
//     "createdDate": "2021-08-26 06:43:27",
//     "updatedDate": "2021-08-26 06:43:27"
// },
// "holds": {
//     "eventName": "CONTAINER_HOLDS",
//     "sourceSelected": "OPS",
//     "holdStatus": "NO_HOLD",
//     // "eventDescription": "Some message comes here.",
//     "createdDate": "2021-08-24 08:06:22",
//     "updatedDate": "2021-08-26 08:05:13"
// },
// "fees": {
//     "eventName": "CONTAINER_FEES",
//     "sourceSelected": "OPS",
//     "feesStatus": "NO_DUES",
//     "createdDate": "2021-08-26 08:05:16",
//     "updatedDate": "2021-08-26 08:05:16"
// },
// "readyForPickup": {
//     "eventName": "READY_FOR_PICKUP",
//     "eventDescription": "READY_FOR_PICKUP",
//     "sourceSelected": "OPS",
//     "tModalTime": "1615519800000",
//     "OPSTime": "1628983800000",
//     "OPSTime2": "1632534300000",
//     "createdDate": "2021-03-22 12:39:14",
//     "updatedDate": "2021-08-26 11:30:24"
// },
// "terminalAppointment": {
//   "eventName": "UNLOAD_FROM_VESSEL",
//   "sourceSelected": "OPS",
//   "OPSTime": "1629939600000",
//   "createdDate": "2020-08-29 16:51:09",
//   "updatedDate": "2021-08-23 11:50:48"
// },
// "gateOut": {
//     "eventName": "GATE_OUT",
//     "eventDescription": "GATE_OUT",
//     "sourceSelected": "OPS",
//     "OPSTime": "1632531600000",
//     "createdDate": "2021-09-16 12:28:12",
//     "updatedDate": "2021-09-16 12:28:18"
// },
// "deliveryAppointment": {
//   "eventName": "UNLOAD_FROM_VESSEL",
//   "sourceSelected": "OPS",
//   "OPSTime": "1629939600000",
//   "createdDate": "2020-08-29 16:51:09",
//   "updatedDate": "2021-08-23 11:50:48"
// },
// "actualDelivery": {
//   "eventName": "UNLOAD_FROM_VESSEL",
//   "sourceSelected": "OPS",
//   "OPSTime": "1629939600000",
//   "createdDate": "2020-08-29 16:51:09",
//   "updatedDate": "2021-08-23 11:50:48"
// },
// "terminalReturnApp": {
//   "eventName": "UNLOAD_FROM_VESSEL",
//   "sourceSelected": "OPS",
//   "OPSTime": "1629939600000",
//   "createdDate": "2020-08-29 16:51:09",
//   "updatedDate": "2021-08-23 11:50:48"
// },
// "gateIn": {
//     "eventName": "GATE_IN",
//     "eventDescription": "GATE_IN",
//     "sourceSelected": "ENTITY_SOURCE_NONE",
//     "createdDate": "2020-08-29 16:51:09",
//     "updatedDate": "2021-08-23 11:50:48"
// },
// "done": {
//     "eventName": "CONTAINER_DONE",
//     "eventDescription": "DONE",
//     "sourceSelected": "ENTITY_SOURCE_NONE",
//     "createdDate": "2020-08-29 16:51:09",
//     "updatedDate": "2021-08-23 11:50:48"
// },
// "shipmentIds": "KX-J2J1-3306"
// },
// {
// "entityId": "OOLU9502347",
// "entityType": "WORKFLOW_ENTITY_TYPE_CONTAINER",
// "entityTimezone": "America/Los_Angeles",
// "entityShipmentList": [
//   {
//       "portOfUnlading": "Oakland, USA",
//       "shipmentId": "KX-J2J1-3306",
//       "terminalName": "BEN.E NUTTER",
//       "bolDocNumber": "EGLV23590581111",
//       "masterBolNumber": "EGLV235900581111",
//       "scaccode": "EGLV",
//       "customerEmail": "lifestyle@shipment.klearexpress.com",
//       "purchaseOrder": "29452,2,2945",
//       "drayageEnabled": 1,
//       'vesselName': "One Maneuver",
//       'finalDelivery': "Sep 25th 2021, 6:00pm",
//       'seal': "35HC00",
//       'eta': 1629939600000,
//       'anRecieved': 1629939600000,
//       'doCreated': 1629939600000,
//       'doPublished': 1629939600000,
//       'berthingDate': 1629939600000
//   }
// ],
// "grounded": {
//   "eventName": "UNLOAD_FROM_VESSEL",
//   "sourceSelected": "OPS",
//   "OPSTime": "1629939600000",
//   "createdDate": "2020-08-29 16:51:09",
//   "updatedDate": "2021-08-23 11:50:48"
// },
// "customReleased": {
//   "eventName": "CUSTOM_RELEASED",
//   "eventDescription": "CUSTOM_RELEASED",
//   "sourceSelected": "OPS",
//   "OPSTime": "1629939600000",
//   "createdDate": "2021-03-22 12:39:14",
//   "updatedDate": "2021-03-23 21:29:29"
// },
// "carrierReleased": {
//   "eventName": "CARRIER_RELEASED",
//   "eventDescription": "LINE_RELEASED",
//   "sourceSelected": "OPS",
//   "OPSTime": "1598860800000",
//   "createdDate": "2021-08-26 06:43:27",
//   "updatedDate": "2021-08-26 06:43:27"
// },
// "holds": {
//   "eventName": "CONTAINER_HOLDS",
//   "sourceSelected": "OPS",
//   "holdStatus": "NO_HOLD",
//   // "eventDescription": "Some message comes here.",
//   "createdDate": "2021-08-24 08:06:22",
//   "updatedDate": "2021-08-26 08:05:13"
// },
// "fees": {
//   "eventName": "CONTAINER_FEES",
//   "sourceSelected": "OPS",
//   "feesStatus": "NO_DUES",
//   "createdDate": "2021-08-26 08:05:16",
//   "updatedDate": "2021-08-26 08:05:16"
// },
// "readyForPickup": {
//   "eventName": "READY_FOR_PICKUP",
//   "eventDescription": "READY_FOR_PICKUP",
//   "sourceSelected": "OPS",
//   "tModalTime": "1615519800000",
//   "OPSTime": "1628983800000",
//   "OPSTime2": "1632534300000",
//   "createdDate": "2021-03-22 12:39:14",
//   "updatedDate": "2021-08-26 11:30:24"
// },
// "terminalAppointment": {
//   "eventName": "UNLOAD_FROM_VESSEL",
//   "sourceSelected": "OPS",
//   "OPSTime": "1629939600000",
//   "createdDate": "2020-08-29 16:51:09",
//   "updatedDate": "2021-08-23 11:50:48"
// },
// "gateOut": {
//   "eventName": "GATE_OUT",
//   "eventDescription": "GATE_OUT",
//   "sourceSelected": "OPS",
//   "OPSTime": "1632531600000",
//   "createdDate": "2021-09-16 12:28:12",
//   "updatedDate": "2021-09-16 12:28:18"
// },
// "deliveryAppointment": {
// "eventName": "UNLOAD_FROM_VESSEL",
// "sourceSelected": "OPS",
// "OPSTime": "1629939600000",
// "createdDate": "2020-08-29 16:51:09",
// "updatedDate": "2021-08-23 11:50:48"
// },
// "actualDelivery": {
// "eventName": "UNLOAD_FROM_VESSEL",
// "sourceSelected": "OPS",
// "OPSTime": "1629939600000",
// "createdDate": "2020-08-29 16:51:09",
// "updatedDate": "2021-08-23 11:50:48"
// },
// "terminalReturnApp": {
// "eventName": "UNLOAD_FROM_VESSEL",
// "sourceSelected": "OPS",
// "OPSTime": "1629939600000",
// "createdDate": "2020-08-29 16:51:09",
// "updatedDate": "2021-08-23 11:50:48"
// },
// "gateIn": {
//   "eventName": "GATE_IN",
//   "eventDescription": "GATE_IN",
//   "sourceSelected": "ENTITY_SOURCE_NONE",
//   "createdDate": "2020-08-29 16:51:09",
//   "updatedDate": "2021-08-23 11:50:48"
// },
// "done": {
//   "eventName": "CONTAINER_DONE",
//   "eventDescription": "DONE",
//   "sourceSelected": "ENTITY_SOURCE_NONE",
//   "createdDate": "2020-08-29 16:51:09",
//   "updatedDate": "2021-08-23 11:50:48"
// },
// "shipmentIds": "KX-J2J1-3306"
// }
// ]

// }

var _this = undefined;
// import moment from "moment";
// import "moment-timezone";

var isCustomerNewTab = function isCustomerNewTab(props) {
  return props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && props.tab === SELECTED_TABS.CUSTOMER_NEW;
};

var formatDate = function formatDate(date) {
  if (date) {
    return moment.unix(date / 1000).format("ddd, MMM DD, YYYY");
  } else {
    return "";
  }
};

var formatDateTypeSecond = function formatDateTypeSecond(date) {
  return moment.unix(date / 1000).format("YYYY-MM-DD");
};

var formatDateTime = function formatDateTime(date) {
  return moment.unix(date / 1000).format("ddd, MMM DD, YYYY, h:mm A");
};

var convertDateToEpoch = function convertDateToEpoch(date) {
  var isoDate = moment(date).format("YYYY-MM-DD");
  var epochDate = moment(isoDate).utc(true).valueOf().toString();
  console.log('formateDateToEpoch', epochDate);
  return epochDate;
};
var isCustomerActiveTab = function isCustomerActiveTab(props) {
  return props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && props.tab === SELECTED_TABS.CUSTOMER_ACTIVE;
};

var isCustomerRejectedTab = function isCustomerRejectedTab(props) {
  return props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && props.tab === SELECTED_TABS.CUSTOMER_REJECTED;
};

var extractAddressToDisplay = function extractAddressToDisplay(addressInfo) {
  var postalCode = "";
  var cityName = "";
  var stateName = "";
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = addressInfo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var address = _step.value;

      if (address.type === "POSTAL_CODE") {
        postalCode = address.information;
      } else if (address.type === "COUNTRY_SUB_ENTITY") {
        stateName = address.information && address.information.length > 0 ? address.information : "";
      } else if (address.type === "CITY") {
        cityName = address.information && address.information.length > 0 ? address.information : "";
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var addressName = cityName.toUpperCase() + ", " + stateName.toUpperCase();
  if (postalCode && postalCode.length > 0) {
    addressName += " (" + postalCode + ")";
  }
  return addressName;
};

var getOpenedOppotunityKey = function getOpenedOppotunityKey(id, tab) {
  return tab + "-" + id;
};

var getOpenedOpportunityStatus = function getOpenedOpportunityStatus(openedOpportunities, tab, opporId) {
  //console.log("getOpenedOpportunityStatus >>>", openedOpportunities, tab, opporId)
  if (!opporId || !tab || opporId.length === 0 || tab.length === 0) {
    return false;
  }

  var key = getOpenedOppotunityKey(opporId, tab);
  //Return false if key does not exist or is false, else return true
  if (!openedOpportunities.has(key)) {
    return false;
  }
  return openedOpportunities.get(key);
};

var getIsOpportunityOpenedAnyTab = function getIsOpportunityOpenedAnyTab(openedOpportunities, tab, opporId) {
  if (!opporId || !tab || opporId.length === 0 || tab.length === 0) {
    return false;
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = openedOpportunities[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref = _step2.value;

      var _ref2 = slicedToArray(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];

      if (key.includes("-" + opporId) && value) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return false;
};

var setOpenedOpportunityStatus = function setOpenedOpportunityStatus(openedOpportunities, tab, opporId, isOpened) {
  if (!opporId || !tab || opporId.length === 0 || tab.length === 0) {
    return;
  }

  var key = getOpenedOppotunityKey(opporId, tab);
  //Return false if key does not exist or is false, else return true
  openedOpportunities.set(key, isOpened);
};

var timeoutPromise = function () {
  var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ms, promise) {
    var timeout;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (promise) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.resolve(null));

          case 2:
            timeout = new Promise(function (resolve, reject) {
              var id = setTimeout(function () {
                clearTimeout(id);
                resolve(null);
              }, ms);
            });

            // Returns a race between our timeout and the passed in promise

            return _context.abrupt("return", Promise.race([promise, timeout]));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function timeoutPromise(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();

var addressObjectToString = function addressObjectToString(_ref5) {
  var value = _ref5.value,
      format = _ref5.format;

  var string = "";
  format.forEach(function (v, k) {
    var a = get(value, v, "");
    if (v) {
      string += a;
    }
    if (format.length - 1 !== k && a) {
      string += ", ";
    }
  });
  return string;
};

/*
 * API responses
 */
var DRAYAGE_API_RESPONSE = {
  NONE: "NONE",
  SUCCESS: "SUCCESS",
  ERROR_IN_SEND: "ERROR_IN_SEND",
  ERROR_IN_RESPONSE: "ERROR_IN_RESPONSE"
};

function enhanceFormatter(epoch) {
  // debugger
  var time = moment.unix(epoch / 1000).format("MMM DD, YYYY");
  if (time === "Invalid date") return "";
  return time;
}

function dateFormatter(seconds) {
  var time = moment.unix(seconds).format("MMMM Do, YYYY");
  if (time === "Invalid date") return null;
  return time;
}

function shortDateFormatter(seconds) {
  var time = moment.unix(seconds).format("MM/DD/YYYY");
  if (time === "Invalid date") return null;
  return time;
}

function longDateFormatter(seconds) {
  var time = moment.unix(seconds).format("dddd, MMMM Do YYYY, h:mm:ss a");
  if (time === "Invalid date") return null;
  return time;
}

function midDateFormatter(seconds) {
  var time = moment.unix(seconds).format("MMM, Do YYYY, h:mm a");
  if (time === "Invalid date") return null;
  return time;
}

var convertEpochToDate = function convertEpochToDate(epoch) {
  var shortFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var longDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var midDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!epoch || epoch === "TBD") return null;
  if (shortFormat) return shortDateFormatter(epoch / 1000);
  if (midDate) return midDateFormatter(epoch / 1000);
  if (longDate) return longDateFormatter(epoch / 1000);
  return dateFormatter(epoch / 1000);
};

var isPartnerApp = function isPartnerApp(drayageApp) {
  return drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER;
};

var isSalesApp = function isSalesApp(drayageApp) {
  return drayageApp === DRAYAGE_APP.KLEARDRAY_SALES;
};
/*
 * Tabs for opened opportunity
 */
var SELECTED_TABS = {
  // NEW_SALES: "NEW",
  // PUBLISHED_SALES: "PUBLISHED",
  // SALES_PENDING_APPROVAL: "PENDING APPROVAL",
  // SALES_ACCEPTED: "ACCEPTED",
  // SALES_REJECTED: "REJECTED",
  // NEW: "NEW",
  // SUBMITTED: "SUBMITTED",
  // DRAYAGE_SUBMITTED: "DRAYAGE_SUBMITTED",
  // ACTIVE: "ACCEPTED",
  // DRAYAGE_ACTIVE: "DRAYAGE_ACCEPTED",
  // REJECTED: "REJECTED",
  // DRAYAGE_REJECTED: "DRAYAGE_REJECTED",

  //Drayage partner tabs
  PARTNER_NEW: "DRAYAGE_NEW",
  PARTNER_SUBMITTED: "DRAYAGE_SUBMITTED",
  PARTNER_ACTIVE: "DRAYAGE_ACTIVE",
  PARTNER_REJECTED: "DRAYAGE_REJECTED",
  PARTNER_ARCHIVED: "DRAYAGE_ARCHIVED",

  //Sales tabs
  SALES_NEW: "NEW",
  SALES_PUBLISHED: "PUBLISHED",
  SALES_PENDING_APPROVAL: "PENDING APPROVAL",
  SALES_ACCEPTED: "ACCEPTED",
  SALES_REJECTED: "REJECTED",
  SALES_ARCHIVED: "ARCHIVED",

  //Customer Tabs
  CUSTOMER_NEW: "DRAYAGE_NEW",
  CUSTOMER_REQUESTED: "DRAYAGE_REQUESTED",
  CUSTOMER_ACTIVE: "DRAYAGE_ACTIVE",
  CUSTOMER_REJECTED: "DRAYAGE_REJECTED",
  CUSTOMER_ARCHIVED: "DRAYAGE_ARCHIVED"
};

var tabType = {
  //Sales tabs
  SALES_NEW: "DRAYAGE_NEW",
  SALES_PUBLISHED: "DRAYAGE_PUBLISHED",
  SALES_PENDING_APPROVAL: "DRAYAGE_PENDING_APPROVAL",
  SALES_ACCEPTED: "DRAYAGE_ACCEPTED",
  SALES_REJECTED: "DRAYAGE_REJECTED",
  SALES_ARCHIVED: "DRAYAGE_ARCHIVED"
};

var opportunityStateMap = {
  SALES_AR_PENDING: "AR PENDING",
  SALES_AR_GENERATED: "AR GENERATED",
  CUSTOMER_ACTIVE: "AR ACCEPTED",
  CUSTOMER_REJECTED: 'AR REJECTED',
  SALES_PUBLISHED: ' AR PUBLISHED'
};

var opportunityStateMapColor = {
  SALES_AR_PENDING: { label: "AR Pending", color: "#3BBA50" },
  SALES_AR_GENERATED: { label: "AR Generated", color: "#3BBA50" },
  CUSTOMER_ACTIVE: { label: "AR Accepted", color: "#3BBA50" },
  CUSTOMER_REJECTED: { label: 'AR Rejected', color: "#de0f0f" },
  SALES_PUBLISHED: { label: ' AR Published', color: "#3BBA50" }
};

var showOpprotunityStateStatus = function showOpprotunityStateStatus(_ref6) {
  var tab = _ref6.tab;

  var data = tab === "SALES_" + SELECTED_TABS.SALES_PUBLISHED || tab === "SALES_PENDING_APPROVAL" || tab === "SALES_" + SELECTED_TABS.SALES_ACCEPTED || tab === "SALES_" + SELECTED_TABS.SALES_REJECTED;
  return data;
};

var serviceAreasOptions = [{ key: "West-key", value: "West", text: "West" }, { key: "Southeast-key", value: "Southeast", text: "Southeast" }, { key: "Southwest-key", value: "Southwest", text: "Southwest" }, { key: "Midwest-key", value: "Midwest", text: "Midwest" }, { key: "Northeast-key", value: "Northeast", text: "Northeast" }];
var filterByOptions = [{
  key: "serviceArea-key",
  value: "serviceArea",
  text: "Filter by service area"
}];

var tabDisplayName = {
  DRAYAGE_NEW: "NEW",
  DRAYAGE_SUBMITTED: "SUBMITTED",
  DRAYAGE_ACTIVE: "ACTIVE",
  DRAYAGE_REJECTED: "REJECTED",
  SALES_NEW: "NEW",
  SALES_PUBLISHED: "PUBLISHED",
  SALES_PENDING_APPROVAL: "PENDING APPROVAL",
  SALES_ACCEPTED: "ACCEPTED",
  SALES_REJECTED: "REJECTED",
  SALES_ARCHIVED: "ARCHIVED",
  SALES_CUSTOMER_REQUESTED: "CUSTOMER REQUESTED",
  DRAYAGE_REQUESTED: "REQUESTED",
  DRAYAGE_ARCHIVED: "ARCHIVED"
};

var DRAYAGE_APP = {
  KLEARDRAY_CUSTOMER: "KLEARDRAY_CUSTOMER",
  KLEARDRAY_PARTNER: "KLEARDRAY_PARTNER",
  KLEARDRAY_SALES: "KLEARDRAY_SALES"
};

var OPPORTUNITY_STATE = {
  SALES_AR_PENDING: "SALES_AR_PENDING",
  SALES_AR_GENERATED: "SALES_AR_GENERATED",
  CUSTOMER_ACTIVE: "CUSTOMER_ACTIVE",
  CUSTOMER_REJECTED: "CUSTOMER_REJECTED",
  SALES_PUBLISHED: 'SALES_PUBLISHED'
};

var amountExact = function amountExact(amount, isPrice) {
  if (!amount) {
    if (isPrice) {
      return "$0";
    } else {
      return "";
    }
  }
  if (isPrice) {
    return "$" + amount.toString();
  }
  return amount.toString();
};

var amountRound = function amountRound(amount) {
  return Math.round(amount);
};

var amountTotal = function amountTotal(price, exactPrice, volume, exactVolume) {
  if (exactPrice && exactVolume) {
    return price * volume;
  }
  if (exactPrice && !exactVolume) {
    return price * amountRound(volume);
  }
  if (!exactPrice && exactVolume) {
    return amountRound(price) * volume;
  }
  if (!exactPrice && !exactVolume) {
    return amountRound(price) * amountRound(volume);
  }
};

var toISODateFormat = function toISODateFormat(date) {
  return date ? date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() : "";
};
/*
 * Amount transformation and displays
 */

//Converts a amount to short string
//if < 1000.0 , return as it is un string
//if > 1000 and < 1000000, return "xK", where x is amount/1000
//if > 1000000, return "yK", where y is amount/1000000

var getAmountInDecimalPlace = function getAmountInDecimalPlace(amount, divider) {
  if (amount % divider === 0) {
    return (amount / divider).toFixed(2);
  }
  return (amount / divider).toFixed(2);
};

// export const  amountToTwoDecimal=(amount,isPrice)=>{
//   let result="";
//   let exact =""
//   if (isPrice){
//     result="$"
//   }
//   if(!amount || amount.length ===0){
//     return ""
//   }
//   if(amount>0 && isPrice){
//     result= amount.toFixed(2)
//     exact= formatter.format(result)
//     console.log(" amountToTwoDecimal exact",exact)
//     return exact

//   }


//}
var amountToTwoDecimal = function amountToTwoDecimal(amount, isPrice) {
  console.log("computeAmountDisplay >>> amountToTwoDecimal >>> ", amount, isPrice);
  var result = "";
  var exact = "";
  // if (isPrice) {
  //   result = "$";
  // }
  if (!amount || amount.length === 0) {
    return "";
  }
  amount = "" + amount;
  if (amount.length > 0 && isPrice) {
    amount = parseInt(amount);
    console.log(" amountToTwoDecimal exact 1", amount, typeof amount === "undefined" ? "undefined" : _typeof(amount));

    result = amount.toFixed(2);
    // exact = formatter.format(result);
    exact = result;
    console.log(" amountToTwoDecimal exact 2", exact, typeof exact === "undefined" ? "undefined" : _typeof(exact));

    return exact;
  }
};
var amountToTwoDecimalWithoutSplit = function amountToTwoDecimalWithoutSplit(amount, isPrice, currencyType) {
  console.log("computeAmountDisplay >>> amountToTwoDecimal >>> ", amount, isPrice);
  var result = "";
  var exact = "";
  // if (isPrice) {
  //   result = "$";
  // }
  if (!amount || amount.length === 0) {
    return "";
  }
  amount = "" + amount;
  if (amount.length > 0 && isPrice) {
    amount = parseInt(amount);
    console.log(" amountToTwoDecimal exact 1", amount, typeof amount === "undefined" ? "undefined" : _typeof(amount));

    result = amount.toFixed(2);
    // exact = formatter.format(result);
    if (currencyType) exact = currencyType + " " + result;
    console.log(" amountToTwoDecimal exact 2", exact, typeof exact === "undefined" ? "undefined" : _typeof(exact));

    return exact;
  }
};

//Abbreviates
var amountToShortString = function amountToShortString(amount, isPrice) {
  var result = "";

  if (isPrice) {
    result = "$";
  }

  if (!amount || amount.length === 0) {
    return "";
  }
  console.log(" amountToShortString exact 1", amount, typeof amount === "undefined" ? "undefined" : _typeof(amount));
  //  let amount=amount > 1000 ? parseFloat(totalPrice / 1000).toFixed(2) + "K" : totalPrice;
  if (amount < 1000) {
    result += amount;
    return result;
  } else if (amount >= 1000 && amount < 1000000) {
    //result += parseFloat(amount / 1000).toFixed(2) + "K"
    result += getAmountInDecimalPlace(amount, 1000) + "K";
    return result;
  } else if (amount >= 1000000) {
    //result += parseFloat(amount / 1000000).toFixed(2) + "M"
    result += getAmountInDecimalPlace(amount, 1000000) + "M";
    return result;
  }
};

function toFixed(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  return num.toString().match(re)[0];
}

//Separates the amount to
var amountToCommaSeparated = function amountToCommaSeparated(amount, isPrice, decimalPlaces) {

  console.log("Testing .... >>> ", amount);
  var result = "";
  if (isPrice) {
    result = "$";
  }

  if (!amount || amount === 0) {
    return "";
  }

  // let x = amount.toString()
  // console.trace(
  //   "amountToCommaSeparated :: ",
  //   amount,
  //   amount.toLocaleString("en-US")
  // );

  var suffixes = ["", "K", "M", "B", "T"];
  var suffixNum = Math.floor((("" + amount).length - 1) / 3);
  console.log("Testing .... 2>>> ", suffixNum, "" + amount);
  var shortValue = parseFloat(suffixNum !== 0 ? amount / Math.pow(1000, suffixNum) : amount);
  if (shortValue % 1 !== 0) {
    shortValue = shortValue.toFixed(decimalPlaces ? decimalPlaces : 1);
  }
  return result + shortValue + suffixes[suffixNum];
};

//Separates the amount to commas for BidSelectionModal
var amountToCommaSeparatedBidSelectionModal = function amountToCommaSeparatedBidSelectionModal(amount, isPrice) {
  var result = "";
  if (isPrice) {
    result = "$";
  }

  if (!amount || amount === 0) {
    return "";
  }

  // let x = amount.toString()
  console.log("amountToCommaSeparated :: ", amount, amount.toLocaleString("en-US"));

  var suffixes = ["", "K", "M", "B", "T"];
  var suffixNum = Math.floor((("" + amount).length - 1) / 3);
  var shortValue = parseFloat(suffixNum !== 0 && amount >= 1000 ? amount / Math.pow(1000, suffixNum) : amount);
  if (shortValue % 1 !== 0) {
    shortValue = toFixed(shortValue, 2);
  }
  if (suffixes[suffixNum] === "K" && shortValue * 1000 < 1000) {
    shortValue = shortValue * 1000;
    suffixNum = 0;
  }
  return result + shortValue + suffixes[suffixNum];
};

// export const epochToDate =(epoch)=>{
//   if(!epoch){
//     return""
//   }else{
//     let eDate = parseInt(epoch);
//   let date = moment.utc(moment(eDate).utc()).toDate();
//   let customerEndDate = date.toLocaleDateString("en-US", options).toUpperCase();
//   return customerEndDate
//   }
// }

/*
 * Header for tabs from various apps in OpportunityOpened
 */

var OpportunityOpenedColumnValuesContainers = {
  KLEARDRAY_CUSTOMER: {
    NEW: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: " ",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountExact,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }, {
      name: "Details",
      classname1: "data-other-col",
      classname2: "price",
      amountCalculationFunc: amountExact,
      // amountDisplayFunc: amountExact,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }],
    DRAYAGE_NEW: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact
    },

    // {
    //   name: "Capacity",
    //   classname1: "data-other-col",
    //   classname2: "cont-num",
    //   isPrice: false,
    //   amountCalculationFunc: amountExact,
    //   amountDisplayFunc: amountToShortString,
    // },

    {
      name: "TotalBaseCharge",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.CUSTOMER_NEW
    },
    //ASSUMING THIS IS THE VALUE of POTENTIAL TOTAL CHARGES
    {
      name: "UnitPrice",
      classname1: "data-other-col",
      classname2: "price",
      amountCalculationFunc: amountExact,
      // amountDisplayFunc : amountExact,
      isPrice: true,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.CUSTOMER_NEW
    }, {
      name: "Estimated Time of Arrival",
      classname1: "data-other-col",
      classname2: "cont-num-renewal-date",
      isPrice: false,
      amountCalculationFunc: enhanceFormatter,
      amountDisplayFunc: enhanceFormatter
    }],
    DRAYAGE_REQUESTED: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }],
    DRAYAGE_ACTIVE: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "UnitPrice",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      // amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.CUSTOMER_ACTIVE
    }, {
      name: "Estimated Time of Arrival",
      classname1: "data-other-col",
      classname2: "cont-num-renewal-date",
      isPrice: false,
      amountCalculationFunc: enhanceFormatter,
      amountDisplayFunc: enhanceFormatter
    }],
    DRAYAGE_REJECTED: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "UnitPrice",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.CUSTOMER_REJECTED
    }]
  },

  KLEARDRAY_PARTNER: {
    DRAYAGE_NEW: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      // classname2: "cont-num-2",
      classname2: "containerDataTxt",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "data-other-col",
      // classname2: "price-2",
      classname2: "containerDataTxt",
      isPrice: true,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    },
    // commented for CONTAINER PARTNER  NEW TAB ApproxTotalBusiness
    {
      name: "ApproxTotalBusiness ",
      classname1: "data-other-col",
      classname2: "price-total",
      isPrice: true,
      amountCalculationFunc: amountTotal,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountRound
    }],
    NEW: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num-2",
      isPrice: false
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true
    }],
    DRAYAGE_SUBMITTED: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    },
    // commented for CONTAINER PARTNER values NEW TAB ApproxTotalBusiness 
    // {
    //   name: "ApproxTotalBusiness",
    //   classname1: "data-other-col",
    //   classname2: "price-total",
    //   isPrice: true,
    //   amountCalculationFunc: amountTotal,
    //   amountDisplayFunc: amountToShortString,
    //   amountRoundingFunc: amountRound,
    // },
    {
      name: "SubmittedBid",
      classname1: "data-other-col-blue",
      classname2: "price-total-white",
      classname3: "data-other-col-lightblue",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.DRAYAGE_SUBMITTED
    }],
    DRAYAGE_ACTIVE: [{
      name: "CapacityAccepted",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      //amountDisplayFunc:amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    },
    // commented for CONTAINER PARTNER  VALUES ACTIVE  TAB ApproxTotalBusiness 
    // {
    //   name: "ApproxTotalBusiness",
    //   classname1: "data-other-col",
    //   classname2: "price-total",
    //   isPrice: true,
    //   amountCalculationFunc: amountTotal,
    //   amountDisplayFunc: amountToShortString,
    //   amountRoundingFunc: amountRound,
    // },
    {
      name: "SubmittedBid",
      classname1: "data-other-col",
      classname2: "price-total",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.DRAYAGE_ACTIVE
    }],
    DRAYAGE_REJECTED: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    },
    // commented for CONTAINER PARTNER  NEW TAB ApproxTotalBusiness
    // {
    //   name: "ApproxTotalBusiness",
    //   classname1: "data-other-col",
    //   classname2: "price-total",
    //   isPrice: true,
    //   amountCalculationFunc: amountTotal,
    //   amountDisplayFunc: amountToShortString,
    //   amountRoundingFunc: amountRound,
    // },
    {
      name: "SubmittedBid",
      classname1: "data-other-col",
      classname2: "price-total",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.DRAYAGE_REJECTED
    }]
  },

  KLEARDRAY_SALES: {
    SALES_PUBLISHED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    }],
    SALES_CUSTOMER_REQUESTED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      //amountDisplayFunc:amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }],
    SALES_PENDING_APPROVAL: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      //amountDisplayFunc:amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }],
    SALES_ACCEPTED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }],
    SALES_REJECTED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }],
    SALES_ARCHIVED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      //amountDisplayFunc:amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }],
    SALES_NEW: []
  }
};

var OpportunityOpenedColumnValues = { //lane
  KLEARDRAY_CUSTOMER: {
    NEW: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: " ",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountExact,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }, {
      name: "Details",
      classname1: "data-other-col",
      classname2: "price",
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountExact,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }],
    DRAYAGE_NEW: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact
    },

    // {
    //   name: "Capacity",
    //   classname1: "data-other-col",
    //   classname2: "cont-num",
    //   isPrice: false,
    //   amountCalculationFunc: amountExact,
    //   amountDisplayFunc: amountToShortString,
    // },

    {
      name: "TotalBaseCharge",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.CUSTOMER_NEW
    }, {
      name: "UnitPrice",
      classname1: "data-other-col",
      classname2: "price",
      amountCalculationFunc: amountExact,
      // amountDisplayFunc : amountExact,
      isPrice: true,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.CUSTOMER_NEW
    }, {
      name: "RenewalDate",
      classname1: "data-other-col",
      classname2: "cont-num-renewal-date",
      isPrice: false,
      amountCalculationFunc: enhanceFormatter,
      amountDisplayFunc: enhanceFormatter
    }],
    //commenting for customer value
    DRAYAGE_REQUESTED: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.CUSTOMER_REQUESTED
    }],
    DRAYAGE_ACTIVE: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "UnitPrice",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.CUSTOMER_ACTIVE
    }, {
      name: "RenewalDate",
      classname1: "data-other-col",
      classname2: "cont-num-renewal-date",
      isPrice: false,
      amountCalculationFunc: enhanceFormatter,
      amountDisplayFunc: enhanceFormatter
    }],
    DRAYAGE_REJECTED: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "UnitPrice",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.CUSTOMER_REJECTED
    }]
  },

  KLEARDRAY_PARTNER: {
    DRAYAGE_NEW: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      // amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,

      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    }],
    NEW: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true
    }, {
      name: "ApproxTotalBusiness",
      classname1: "fourth-col",
      classname2: "price-total",
      isPrice: true
    }],
    DRAYAGE_SUBMITTED: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountToTwoDecimal, // amountToCommaSeparated,
      //amountDisplayFunc:amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    },
    //commented here for value approx total business partner submitted tab
    // {
    //   name: "ApproxTotalBusiness",
    //   classname1: "data-other-col",
    //   classname2: "price-total",
    //   isPrice: true,
    //   amountCalculationFunc: amountTotal,
    //   amountDisplayFunc: amountToShortString,
    //   amountRoundingFunc: amountRound,
    // },
    {
      name: "SubmittedBid",
      classname1: "data-other-col-blue",
      classname2: "price-total-white",
      classname3: "data-other-col-lightblue",
      isPrice: true,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountToTwoDecimal, //amountToCommaSeparated,
      //amountDisplayFunc:amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.DRAYAGE_SUBMITTED
    }],
    DRAYAGE_ACTIVE: [{
      name: "CapacityAccepted",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      // amountDisplayFunc:amountToTwoDecimal,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //  amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    },
    //commented here for value approx total business Active tab lane
    // {
    //   name: "ApproxTotalBusiness",
    //   classname1: "data-other-col",
    //   classname2: "price-total",
    //   isPrice: true,
    //   amountCalculationFunc: amountTotal,
    //   amountDisplayFunc: amountToShortString,
    //   amountRoundingFunc: amountRound,
    // },
    {
      name: "SubmittedBid",
      classname1: "data-other-col",
      classname2: "price-total",
      isPrice: true,
      amountCalculationFunc: amountExact,
      // amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.DRAYAGE_ACTIVE
    },
    // //commented here for value approx Total Partner Active tab lane
    // {
    //   name: "Total",
    //   classname1: "data-other-col",
    //   classname2: "price-total",
    //   isPrice: true,
    //   amountCalculationFunc: amountTotal,
    //   amountDisplayFunc: amountToShortString,
    //   amountRoundingFunc: amountRound,
    // },
    {
      name: "RenewalDateActive",
      classname1: "data-other-col",
      classname2: "cont-num-renewal-date",
      isPrice: false,
      amountCalculationFunc: enhanceFormatter,
      amountDisplayFunc: enhanceFormatter
    }],
    DRAYAGE_REJECTED: [{
      name: "ApproxVolume",
      classname1: "data-other-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "data-other-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      // amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    },
    //commented here for value approx total business Rejected tab lane
    // {
    //   name: "ApproxTotalBusiness",
    //   classname1: "data-other-col",
    //   classname2: "price-total",
    //   isPrice: true,
    //   amountCalculationFunc: amountTotal,
    //   amountDisplayFunc: amountToShortString,
    //   amountRoundingFunc: amountRound,
    // },
    {
      name: "SubmittedBid",
      classname1: "data-other-col",
      classname2: "price-total",
      isPrice: true,
      amountCalculationFunc: amountExact,
      // amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.DRAYAGE_REJECTED
    }]
  },

  KLEARDRAY_SALES: {
    SALES_PUBLISHED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    }],
    SALES_CUSTOMER_REQUESTED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountToTwoDecimal,

      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    }],
    SALES_PENDING_APPROVAL: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    }],
    SALES_ACCEPTED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      // amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    }],
    SALES_REJECTED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    }],
    SALES_ARCHIVED: [{
      name: "ApproxVolume",
      classname1: "sec-col",
      classname2: "cont-num",
      isPrice: false,
      amountCalculationFunc: amountExact,
      amountDisplayFunc: amountExact,
      amountRoundingFunc: amountExact
    }, {
      name: "SuggestedBid",
      classname1: "third-col",
      classname2: "price",
      isPrice: true,
      amountCalculationFunc: amountExact,
      //amountDisplayFunc: amountToCommaSeparated,
      amountDisplayFunc: amountToTwoDecimal,
      amountRoundingFunc: amountExact,
      currencyType: DRAYAGE_CURRENCY_COLUMNS.SUGGESTED_BID
    }],
    SALES_NEW: []
  }
};

var getExtraHeader = function getExtraHeader(_ref7) {
  var drayageApp = _ref7.drayageApp,
      tab = _ref7.tab,
      arWithoutAP = _ref7.arWithoutAP,
      opportunityState = _ref7.opportunityState;

  var extraHeader = [];
  switch (true) {
    case drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && tab === "SALES_PUBLISHED":
      if (arWithoutAP && (opportunityState === OPPORTUNITY_STATE.CUSTOMER_ACTIVE || opportunityState === OPPORTUNITY_STATE.SALES_AR_GENERATED)) {
        extraHeader.push({
          upper: "Price",
          containerUpper: "Price",
          lower: "(Generated AR)",
          containerLower: "(Generated AR)",
          classLevel1: "oppor-header-sec",
          classLevel2: "sec-col-header-text",
          classLevel3: "lower"
        });
      }
      break;

    case drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && tab === "SALES_REJECTED":
      if (arWithoutAP && opportunityState === OPPORTUNITY_STATE.CUSTOMER_REJECTED) {
        extraHeader.push({
          upper: "Price",
          containerUpper: "Price",
          lower: "(Generated AR)",
          containerLower: "(Generated AR)",
          classLevel1: "oppor-header-sec",
          classLevel2: "sec-col-header-text",
          classLevel3: "lower"
        });
      }
      break;

    default:
      break;
  }
  return extraHeader;
};

var getExtraLaneColumn = function getExtraLaneColumn(_ref8) {
  var drayageApp = _ref8.drayageApp,
      tab = _ref8.tab,
      arWithoutAP = _ref8.arWithoutAP,
      opportunityState = _ref8.opportunityState;

  var extraLaneColumn = [];
  switch (true) {
    case drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && tab === "SALES_PUBLISHED":
      if (arWithoutAP && (opportunityState === OPPORTUNITY_STATE.CUSTOMER_ACTIVE || opportunityState === OPPORTUNITY_STATE.SALES_AR_GENERATED)) {
        extraLaneColumn.push({
          name: "UnitPrice",
          classname1: "data-other-col",
          classname2: "price",
          amountCalculationFunc: amountExact,
          isPrice: true,
          amountDisplayFunc: amountToTwoDecimal,
          amountRoundingFunc: amountExact
        });
      }
      break;

    case drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && tab === "SALES_REJECTED":
      if (arWithoutAP && opportunityState === OPPORTUNITY_STATE.CUSTOMER_REJECTED) {
        extraLaneColumn.push({
          name: "UnitPrice",
          classname1: "data-other-col",
          classname2: "price",
          amountCalculationFunc: amountExact,
          isPrice: true,
          amountDisplayFunc: amountToTwoDecimal,
          amountRoundingFunc: amountExact
        });
      }
      break;

    default:
      break;
  }
  return extraLaneColumn;
};

var OpportunityOpenedHeaader = {
  KLEARDRAY_CUSTOMER: {
    // // NEW: [
    // //   {
    // //     upper: "NEVER ENDING Volume",
    // //     lower: "Cont.Per Month",
    // //     classLevel1: "oppor-header-sec",
    // //     classLevel2: "sec-col-header-text",
    // //     classLevel3: "lower",
    // //   },
    // //   {
    // //     upper: "Price",
    // //     lower: "Per Container",
    // //     classLevel1: "oppor-header-sec",
    // //     classLevel2: "sec-col-header-text",
    // //     classLevel3: "lower",
    // //   },npm
    // ],
    DRAYAGE_NEW: [{
      upper: "Approx Volume",
      lower: "Cont.Per Month",
      containerUpper: "Volume",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Base Fee",
      lower: "Per Container",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    },
    //ADDED lower: "Per Container"
    {
      upper: "Potential  Charges",
      lower: "Per Container",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Renewal Date",
      containerUpper: "Estimated Time of Arrival",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    DRAYAGE_REQUESTED: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      // classLevel1: "data-header-others",
      classLevel1: "data-header-container",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      // classLevel1: "data-header-others",
      classLevel1: "data-header-container",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }],
    DRAYAGE_ACTIVE: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Bid",
      lower: "Per Container",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Renewal Date",
      containerUpper: "Estimated Time of Arrival",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    DRAYAGE_REJECTED: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Bid",
      lower: "Per Container",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }]
  },

  KLEARDRAY_PARTNER: {
    NEW: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    DRAYAGE_NEW: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }],
    DRAYAGE_SUBMITTED: [{
      upper: "Approx. Volume",
      lower: "Cont.Per Month",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    },
    //commented here for header approx total business Partner Submitted tab
    // {
    //   upper: "Approx Total Business",
    //   lower: "",
    //   classLevel1: "data-header-others",
    //   classLevel2: "sec-col-header-text",
    //   classLevel3: "data-header-lower",
    // },
    {
      upper: "Submitted Bid",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }],
    DRAYAGE_ACTIVE: [{
      upper: "Your Volume",
      lower: "Cont.Per Month",
      containerUpper: "Volume",
      containerLower: " ",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    },
    //commented here for header approx total business Partner Active tab
    // {
    //   upper: "Approx Total Business",
    //   lower: "",
    //   classLevel1: "data-header-others",
    //   classLevel2: "sec-col-header-text",
    //   classLevel3: "data-header-lower",
    // },
    {
      upper: "Submitted Bid",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    },
    //commented here for header approx Total Partner Active tab
    // {
    //   upper: "Total",
    //   lower: "",
    //   classLevel1: "data-header-others",
    //   classLevel2: "sec-col-header-text",
    //   classLevel3: "data-header-lower",
    // },
    {
      upper: "Renewal Date",
      containerUpper: "Estimated Time of Arrival",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }],
    DRAYAGE_REJECTED: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    },
    //commented here for header approx total business Partner Rejected tab
    // {
    //   upper: "Approx Total Business",
    //   lower: "",
    //   classLevel1: "data-header-others",
    //   classLevel2: "sec-col-header-text",
    //   classLevel3: "data-header-lower",
    // },
    {
      upper: "Submitted Bid",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }]
  },

  KLEARDRAY_SALES: {
    SALES_PUBLISHED: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    SALES_CUSTOMER_REQUESTED: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    SALES_PENDING_APPROVAL: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],

    SALES_ACCEPTED: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    SALES_REJECTED: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    SALES_ARCHIVED: [{
      upper: "Approx Volume",
      containerUpper: "Volume",
      lower: "Cont.Per Month",
      containerLower: " ",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }]
  }
};

var OpportunityOpenedHeaaderContainer = {
  KLEARDRAY_CUSTOMER: {
    // // NEW: [
    // //   {
    // //     upper: "NEVER ENDING Volume",
    // //     lower: "Cont.Per Month",
    // //     classLevel1: "oppor-header-sec",
    // //     classLevel2: "sec-col-header-text",
    // //     classLevel3: "lower",
    // //   },
    // //   {
    // //     upper: "Price",
    // //     lower: "Per Container",
    // //     classLevel1: "oppor-header-sec",
    // //     classLevel2: "sec-col-header-text",
    // //     classLevel3: "lower",
    // //   },npm
    // ],
    DRAYAGE_NEW: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Base Fee",
      lower: "Per Container",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    },
    //commenting total potential charges for customerCONTAINER HEADER
    {
      upper: "Potential Charges",
      // lower: "Before FSC",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Estimated Time of Arrival",
      containerUpper: "Estimated Time of Arrival",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    DRAYAGE_REQUESTED: [{
      upper: "Volume",
      lower: "",
      // classLevel1: "data-header-others",
      classLevel1: "data-header-container",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }],
    DRAYAGE_ACTIVE: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Bid",
      lower: "Per Container",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Estimated Time of Arrival",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    DRAYAGE_REJECTED: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Bid",
      lower: "Per Container",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }]
  },

  KLEARDRAY_PARTNER: {
    NEW: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    DRAYAGE_NEW: [{
      upper: "Volume",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }],
    DRAYAGE_SUBMITTED: [{
      upper: "Volume",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    },
    //commented out for PARTNER APP CONTAINER HEADER Submitted TAB  Approx Total Business
    // {
    //   upper: "Approx Total Business",
    //   lower: "",
    //   classLevel1: "data-header-others",
    //   classLevel2: "sec-col-header-text",
    //   classLevel3: "data-header-lower",
    // },
    {
      upper: "Submitted Bid",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }],
    DRAYAGE_ACTIVE: [{
      upper: "Your Volume",
      lower: "Cont.Per Month",
      containerUpper: "Volume",
      containerLower: " ",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    },
    //Commented for CONTAINER  HEADER TOTAL BUSINESS ACTIVE TAB  TOTAL BUSINESS
    // {
    //   upper: "Total Business",
    //   lower: "",
    //   classLevel1: "data-header-others",
    //   classLevel2: "sec-col-header-text",
    //   classLevel3: "data-header-lower",
    // },
    {
      upper: "Submitted Bid",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }],
    DRAYAGE_REJECTED: [{
      upper: "Volume",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    },
    //Commented for CONTAINER  HEADER TOTAL BUSINESS REJECTED  TAB 
    // {
    //   upper: "Total Business",
    //   lower: "",
    //   classLevel1: "data-header-others",
    //   classLevel2: "sec-col-header-text",
    //   classLevel3: "data-header-lower",
    // },
    {
      upper: "Submitted Bid",
      lower: "",
      classLevel1: "data-header-others",
      classLevel2: "sec-col-header-text",
      classLevel3: "data-header-lower"
    }]
  },

  KLEARDRAY_SALES: {
    SALES_PUBLISHED: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    SALES_CUSTOMER_REQUESTED: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    SALES_PENDING_APPROVAL: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],

    SALES_ACCEPTED: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    SALES_REJECTED: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }],
    SALES_ARCHIVED: [{
      upper: "Volume",
      lower: "",
      classLevel1: "oppor-header-sec",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }, {
      upper: "Suggested Bid",
      lower: "Per Cont.",
      classLevel1: "",
      classLevel2: "sec-col-header-text",
      classLevel3: "lower"
    }]
  }
};
var getWidthPartyNameWrapper = function getWidthPartyNameWrapper(app, tab) {
  switch (app) {
    case DRAYAGE_APP.KLEARDRAY_PARTNER:
      switch (tab) {
        case SELECTED_TABS.PARTNER_NEW:
          return {
            width: "777px",
            marginLeft: "0px"
          };
        case SELECTED_TABS.PARTNER_SUBMITTED:
          return {
            width: "960px",
            marginLeft: "-90px"
          };
        case SELECTED_TABS.PARTNER_ACTIVE:
          return {
            width: "960px",
            marginLeft: "-90px"
          };
        case SELECTED_TABS.PARTNER_REJECTED:
          return {
            width: "960px",
            marginLeft: "-90px"
          };
      }
    case DRAYAGE_APP.KLEARDRAY_CUSTOMER:
      switch (tab) {
        case SELECTED_TABS.CUSTOMER_NEW:
          return {
            width: "777px"
          };
        case SELECTED_TABS.CUSTOMER_REQUESTED:
          return {
            width: "777px"
          };
        case SELECTED_TABS.CUSTOMER_ACTIVE:
          return {
            width: "777px"
          };
        case SELECTED_TABS.CUSTOMER_REJECTED:
          return {
            width: "777px"
          };
      }
  }

  return {
    leftSideWidth: "50.5%",
    rightSideWidth: "49.5%"
  };
};
var getWidthGrandAction = function getWidthGrandAction(app, tab) {
  switch (app) {
    case DRAYAGE_APP.KLEARDRAY_PARTNER:
      switch (tab) {
        case SELECTED_TABS.PARTNER_NEW:
          return {
            width: "779px"
          };
        case SELECTED_TABS.PARTNER_SUBMITTED:
          return {
            width: "965px"
          };
        case SELECTED_TABS.PARTNER_ACTIVE:
          return {
            width: "965px"
          };
        case SELECTED_TABS.PARTNER_REJECTED:
          return {
            width: "965px"
          };
      }
    case DRAYAGE_APP.KLEARDRAY_CUSTOMER:
      switch (tab) {
        case SELECTED_TABS.CUSTOMER_NEW:
          return {
            width: "779px",
            height: "54px"
          };
        case SELECTED_TABS.CUSTOMER_REQUESTED:
          return {
            width: "779px",
            height: "54px"
          };
        case SELECTED_TABS.CUSTOMER_ACTIVE:
          return {
            width: "779px"
          };
        case SELECTED_TABS.CUSTOMER_REJECTED:
          return {
            width: "779px"
          };
      }
  }
  return {
    leftSideWidth: "51.5%",
    rightSideWidth: "48.5%"
  };
};
var getWidthMarketPlaceWrapper = function getWidthMarketPlaceWrapper(app, tab) {
  switch (app) {
    case DRAYAGE_APP.KLEARDRAY_PARTNER:
      switch (tab) {
        case SELECTED_TABS.PARTNER_NEW:
          return {
            // width:"780px",
            width: "55.5%"
          };
        case SELECTED_TABS.PARTNER_SUBMITTED:
          return {
            // width:"1030px",
            width: "60.00%"
          };
        case SELECTED_TABS.PARTNER_ACTIVE:
          return {
            width: "1030px"
          };
        case SELECTED_TABS.PARTNER_REJECTED:
          return {
            width: "1030px"
          };
      }
    case DRAYAGE_APP.KLEARDRAY_CUSTOMER:
      switch (tab) {
        case SELECTED_TABS.CUSTOMER_NEW:
          return {
            // width:"870px",
            width: "50%"
          };
        case SELECTED_TABS.CUSTOMER_REQUESTED:
          return {
            // width:"870px",
            width: "55.5%"
          };
        case SELECTED_TABS.CUSTOMER_ACTIVE:
          return {
            //width:"870px",
            width: "60%"
          };
        case SELECTED_TABS.CUSTOMER_REJECTED:
          return {
            // width:"870px",
            width: "60%"
          };
      }
  }
  return {
    leftSideWidth: "51.5%",
    rightSideWidth: "48.5%"
  };
};
var getWidthPartnerTopHeader = function getWidthPartnerTopHeader(app, tab) {
  switch (app) {
    case DRAYAGE_APP.KLEARDRAY_PARTNER:
      switch (tab) {
        case SELECTED_TABS.PARTNER_NEW:
          return {
            width: "878px"
            // width:"60%"
          };
        case SELECTED_TABS.PARTNER_SUBMITTED:
          return {
            width: "1030px"
          };
        case SELECTED_TABS.PARTNER_ACTIVE:
          return {
            width: "1030px"
          };
        case SELECTED_TABS.PARTNER_REJECTED:
          return {
            width: "1030px"
          };
      }
    case DRAYAGE_APP.KLEARDRAY_CUSTOMER:
      switch (tab) {
        case SELECTED_TABS.CUSTOMER_NEW:
          return {
            //width:"878px",
            width: "100%"
            // leftSideWidth: "47%",
          };
        case SELECTED_TABS.CUSTOMER_REQUESTED:
          return {
            //width:"878px",
            width: "100%"
            // leftSideWidth: "47%",
          };
        case SELECTED_TABS.CUSTOMER_ACTIVE:
          return {
            width: "100%"
            //width:"60%"
          };
        case SELECTED_TABS.CUSTOMER_REJECTED:
          return {
            width: "100%"
            //width:"60%"
          };
        case SELECTED_TABS.CUSTOMER_ARCHIVED:
          return {
            width: "100%"
            //width:"60%"
          };
      }
  }
  // return {
  //   leftSideWidth: "50.5%",
  //   rightSideWidth: "49.5%",
  // };
};
var getWidth = function getWidth(app, tab) {
  switch (app) {
    case DRAYAGE_APP.KLEARDRAY_PARTNER:
      switch (tab) {
        case SELECTED_TABS.PARTNER_NEW:
          return {
            leftSideWidth: "49%",
            rightSideWidth: "51%"
          };
        case SELECTED_TABS.PARTNER_SUBMITTED:
          return {
            leftSideWidth: "60%",
            rightSideWidth: "40%"
          };
        case SELECTED_TABS.PARTNER_ACTIVE:
          return {
            leftSideWidth: "60%",
            rightSideWidth: "40%"
          };
        case SELECTED_TABS.PARTNER_REJECTED:
          return {
            leftSideWidth: "60%",
            rightSideWidth: "40%"
          };
        default:
          return {
            leftSideWidth: "100%",
            rightSideWidth: "0%"
          };
      }
    case DRAYAGE_APP.KLEARDRAY_CUSTOMER:
      switch (tab) {
        case SELECTED_TABS.CUSTOMER_NEW:
          return {
            leftSideWidth: "60%",
            rightSideWidth: "40%"
          };
        case SELECTED_TABS.CUSTOMER_REQUESTED:
          return {
            leftSideWidth: "60%",
            rightSideWidth: "40%"
          };
        case SELECTED_TABS.CUSTOMER_ACTIVE:
          return {
            leftSideWidth: "60%",
            rightSideWidth: "40%"
          };
        case SELECTED_TABS.CUSTOMER_REJECTED:
          return {
            leftSideWidth: "60%",
            rightSideWidth: "40%"
          };
        default:
          return {
            leftSideWidth: "60%",
            rightSideWidth: "40%"
          };
      }
    case DRAYAGE_APP.KLEARDRAY_SALES:
      return {
        leftSideWidth: "100%",
        rightSideWidth: "0"
      };
    default:
      return {
        leftSideWidth: "100%",
        rightSideWidth: "0"
      };
  }
};
var getTableDataForTab = function getTableDataForTab(app, tab, destinationData) {
  switch (app) {
    case DRAYAGE_APP.KLEARDRAY_PARTNER:
      switch (tab) {
        case SELECTED_TABS.NEW:
          return [{
            class1: "sec-col",
            class2: "cont-num",
            value: destinationData.approxVolume
          }, {}];
      }

    // case DRAYAGE_APP.KLEARDRAY_SALES:
    //   switch (tab) {
    //     case SELECTED_TABS.SALES_PUBLISHED:
    //       return [
    //         {
    //           class1: "sec-col",
    //           class2: "cont-num",
    //           value: destinationData.approxVolume,
    //         },
    //         {},
    //       ];
    //   }
  }
};

var getTokenName$1 = function getTokenName() {
  console.trace("APP NAME :: getTokenName", window._env_.APP_NAME);
  switch (window._env_.APP_NAME) {
    case "Partner":
      return "kxPartnerToken";
    case "Customer":
      return "kxCustomerToken";
    case "Sales":
      return "kxSalesToken";
  }
  return "kxCustomerToken";
};

var logout$1 = function logout() {
  var domain = window.location.hostname;
  document.cookie = getTokenName$1() + "=;domain=" + domain + ";path=/";
  var dt = new Date();
  dt.setTime(dt.getTime() - 24 * 60 * 60 * 1000);
  document.cookie = getTokenName$1() + "=0; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  window.location = "/";
  console.log("Logging out due to inactivity.");
  return true;
};

var getMOTImage = function getMOTImage(mot) {
  if (typeof mot !== 'string' || mot === '') {
    return null;
  }

  var imageMap = {
    OCEAN: ship,
    AIR: plane
  };

  var type = mot.indexOf('MOT_') === 0 ? mot.substring(4) : mot;

  if (imageMap[type]) {
    return React__default.createElement("img", { style: { width: "20px" }, src: imageMap[type], alt: mot });
  }

  // Return Semantic UI Icon if mot is unknown
  return React__default.createElement(Icon, { name: "question circle outline", color: "grey", size: "large" });
};

/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

// {
//   "eventMessage": {
//       "searchType": "SEARCH_TYPE_CUSTOMER",
//       "filters": [
//           {
//               "key": "SEARCH_FILTERS_MODE",
//               "value": [
//                   "AIR","TRUCK", "OCEAN"
//               ]
//           },
//           {
//               "key": "SEARCH_FILTERS_KXEMAIL",
//               "value": [
//                   "lifestyle@klearexpress.us"
//               ]
//           }
//       ],
//       "pageNumber": 1,
//       "searchOrder": {
//           "searchTab": "SEARCH_TAB_NEW_ISF",
//           "direction": "DESC"
//       }
//   },
//   "eventType": "SEARCH_SHIPMENTS_CUSTOMER",
//   "eventTime": 1604110056356
// }

var getCookie = function getCookie() {
  var cname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "kxCommonToken";

  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

//  getHistoryTabResults: function (shipmentIds) {
//   const data = {
//     eventMessage: {
//       shipmentIds
//     },
//     eventTime: Date.now()
//   };
//   return HttpClient.mockCustom("/api/changeLog.json", {
//     data
//   });
// },
var kxToken = getCookie("kxCommonToken");

var submitCustomerBidApprovalAPI = function submitCustomerBidApprovalAPI(opportunityId, selectedLanes) {
  var data = {};
  data = {
    eventMessage: {
      opportunityId: opportunityId,
      selectedLanes: selectedLanes,
      isMock: "false"
    },
    eventType: "DRAYAGE_CUSTOMER_BID",
    eventTime: Date.now()
  };

  // return HttpClient.mockCustom("/api/getOpportunityDetail.json", {

  return HttpClient.custom({
    data: data
  });
};

var getDrayageOpportunities = function getDrayageOpportunities(tab) {
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isKH360AssociatedUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  console.log("getDrayageOpportunities :: ", tab);
  switch (tab) {
    case "SALES_PUBLISHED":
      tab = "DRAYAGE_PUBLISHED";
      break;
    case "SALES_CUSTOMER_REQUESTED":
      tab = "DRAYAGE_CUSTOMER_REQUESTED";
      break;

    case "SALES_PENDING_APPROVAL":
      tab = "DRAYAGE_PENDING_APPROVAL";
      break;

    case "SALES_ACCEPTED":
      tab = "DRAYAGE_ACCEPTED";
      break;

    case "SALES_REJECTED":
      tab = "DRAYAGE_REJECTED";
      break;

    case "SALES_ARCHIVED":
      tab = "DRAYAGE_ARCHIVED";
      break;
    default:
      break;
  }
  var data = {};
  data = {
    eventMessage: {
      tabType: tab, //"DRAYAGE_" + tab.split(" ").join("_"),//tab
      //tabType:"PUBLISHED",
      filters: filters,
      isMock: "false",
      isKH360AssociatedUser: isKH360AssociatedUser
    },
    eventType: "DRAYAGE_GET_OPPORTUNITIES",
    eventTime: Date.now()
  };

  //    return HttpClient.custom({
  //      data,
  //    });

  //  return HttpClient.mockCustom("api/getDrayage.json", {
  return HttpClient.custom({
    data: data
  });
};

var getDrayageOpportunityDetails = function getDrayageOpportunityDetails(opportunityId, tabType$$1) {
  var data = {};
  data = {
    eventMessage: {
      opportunityId: opportunityId,
      tabType: tabType$$1,
      isMock: "false"
    },
    eventType: "DRAYAGE_GET_OPPORTUNITY_DETAILS",
    eventTime: Date.now()
  };

  // return HttpClient.mockCustom("/api/getOpportunityDetail.json", {

  return HttpClient.custom({
    data: data
  });
};

var getDrayageOpportunityDetailsForInvoiceContainer = function getDrayageOpportunityDetailsForInvoiceContainer(containerId) {
  var data = {};
  data = {
    "eventMessage": {
      //  "containerId": "CN-J8J3-183-3"
      "containerId": containerId
    },
    "eventType": "DRAYAGE_GET_OPPORTUNITY_DETAILS",
    "eventTime": Date.now()
  };
  return HttpClient.custom({ data: data });
};

var getDrayageAdditionalCharges = function getDrayageAdditionalCharges(partnerId) {
  console.log("getDrayageAdditionalCharges :: ", partnerId);
  // let tmpMap = {
  //   "c5892a08-67ea-61cb-c94a-d004e54e1dae" : "DPY4E7",
  //   "abebfe0a-67eb-bf69-c94a-d004e54e1db1" : "DPY4E8",
  //   "baea25d3-670b-df54-c94a-d004e54e1da3" : "DPZ1G8"
  // }
  var data = {};
  data = {
    //Y4E7
    eventMessage: {
      partnerId: partnerId,
      // "partnerId":tmpMap[partnerId],
      isMock: "false"
    },
    eventType: "DRAYAGE_GET_PARTNER_CHARGES",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var getKxUser = function getKxUser() {
  var data = {};
  data = {
    eventType: "GET_KXUSER",
    eventMessage: {},
    eventTime: Date.now()
  };
  return HttpClient.custom({ data: data });
};

//DRAYAGE_CUSTOMER_SELECT_LANE_PRICE
var setCustomerLanePriceSelectedAPI = function setCustomerLanePriceSelectedAPI(opportunityId, laneId, selected) {
  var data = {};
  data = {
    eventMessage: {
      opportunityId: opportunityId,
      laneId: laneId,
      selected: selected ? "YES" : "NO",
      isMock: "false"
    },
    eventType: "DRAYAGE_CUSTOMER_SELECT_LANE_PRICE",
    eventTime: Date.now()
  };
  return HttpClient.custom({ data: data });
};

var getCustomerLanePriceApi = function getCustomerLanePriceApi(opportunityId, laneId, sourceId, partnerId, isSelected) {
  var data = {};
  console.log("getCustomerLanePriceApi >> ", opportunityId, laneId, sourceId, partnerId, isSelected);

  data = {
    eventMessage: {
      opportunityId: opportunityId,
      laneId: laneId,
      sourceId: sourceId,
      partnerId: partnerId,
      selected: isSelected ? "YES" : undefined,
      isMock: "false"
    },
    eventType: "DRAYAGE_CHARGE_DETAILS",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

// {
//   "opportunityId": "wewq12312",
//   "partnerId": "partnerCode1/can also pick from guid",
//   "sourceList": [
//     {
//       "sourceId": "knLocid",
//       "laneList": [
//         {
//           "laneId": "lane1",
//           "baseFees": "100",
//           "fuelCharge": "20%",
//           "notes": "as",
//           "laneChargeList": [
//             {
//               "glCode": 345578,
//               "amount": "120",
//               "unit": "day",
//               "quantity": 2
//             },
//             {
//               "glCode": 345579,
//               "amount": "50",
//               "unit": "hr",
//               "quantity": 2
//             },
//             {
//               "glCode": 345578,
//               "amount": "120",
//               "unit": "day",
//               "quantity": 2
//             },
//             {
//               "glCode": 345578,
//               "amount": "120",
//               "unit": "day",
//               "quantity": 2
//             }
//           ]
//         },
//         {
//           "laneId": "lane2",
//           "bidValue": "332",
//           "baseFees": "100",
//           "fuelCharge": "20%",
//           "notes": "as",
//           "laneChargeList": [
//             {
//               "glCode": 345578,
//               "amount": "120",
//               "unit": "day",
//               "quantity": 2
//             },
//             {
//               "glCode": 345579,
//               "amount": "50",
//               "unit": "hr",
//               "quantity": 2
//             },
//             {
//               "glCode": 345578,
//               "amount": "120",
//               "unit": "day",
//               "quantity": 2
//             },
//             {
//               "glCode": 345578,
//               "amount": "120",
//               "unit": "day",
//               "quantity": 2
//             }
//           ]
//         }
//       ],
//       "sourceChargeList": [
//         {
//           "glCode": 345578,
//           "amount": "120",
//           "unit": "day",
//           "quantity": 2
//         },
//         {
//           "glCode": 345579,
//           "amount": "50",
//           "unit": "hr",
//           "quantity": 2
//         }
//       ]
//     }
//   ]
// }

var formOpportunitySubmitMessage = function formOpportunitySubmitMessage(opportunityId, opportunityData, partnerId, isFromEdit, bidOperationType, drayageApp) {
  var isPartner = isPartnerApp(drayageApp);
  var data = opportunityData.get(opportunityId);
  if (!data) {
    console.log("No data for opportunity ", opportunityId);
    return;
  }

  var portData = data.portData;
  if (!portData) {
    console.log("No port data in opportunity ", opportunityId);
    return;
  }

  console.log("formOpportunitySubmitMessage ::", data, portData, partnerId);

  var sourceList = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = portData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = slicedToArray(_ref, 2);

      var _sourceId = _ref2[0];
      var value = _ref2[1];

      console.log("formOpportunitySubmitMessage :: value ", value);
      var onePortData = {};

      onePortData.sourceId = _sourceId;
      onePortData.sourceType = value.sourceType;
      onePortData.laneList = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = value.destinations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var destination = _step2.value;

          var lane = {};

          lane.laneId = destination.laneId;
          var destinationBidData = destination.destinationBidData;
          var isFuelAdded = false;

          if (destinationBidData) {
            isFuelAdded = destinationBidData.yesRadioButton;
            lane.baseFees = destinationBidData.baseFees;
            lane.basefeesGlCode = destinationBidData.basefeesGlCode;
            lane.fuelChargeGlCode = destinationBidData.fuelChargeGlCode;
            lane.fuelCharge = destinationBidData.fuelCharges;
            lane.chasisRentalperday = destinationBidData.chasisRentalperday;
            lane.minReqDays = destinationBidData.minReqDays;
            lane.notes = destinationBidData.notes;
            lane.capacityPerMonth = destinationBidData.capacityPerMonth;
            lane.rateValidUntilDate = destinationBidData.rateValidUntilDate;
            lane.apCurrencyCode = destinationBidData.apCurrencyCode;
          }

          var tmp = _extends({
            laneId: lane.laneId
          }, isPartner && {
            questionsAboutBid: lane.notes,
            capacityPerMonth: lane.capacityPerMonth,
            apCurrencyCode: lane.apCurrencyCode
          }, {
            rateValidUntilDate: toISODateFormat(lane.rateValidUntilDate),

            laneChargeList: [{
              glCode: 60001,
              chargeName: "BASE CHARGE",
              unitPrice: lane.baseFees,
              unitMeasurement: "",
              quantity: 1
            }].concat(toConsumableArray(isFuelAdded ? [{
              glCode: 60002,
              chargeName: "FUEL SURCHARGE",
              unitPrice: lane.fuelCharge,
              unitMeasurement: "",
              quantity: 1
            }] : []))
          });
          var laneAdditionalCharge = destination.destinationAdditionalCharges;
          if (laneAdditionalCharge) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = laneAdditionalCharge[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _ref3 = _step3.value;

                var _ref4 = slicedToArray(_ref3, 2);

                var glCode = _ref4[0];
                var _value = _ref4[1];

                if (parseInt(_value.reqQuantityUsed) > 0) {
                  var additonalCharge = {
                    glCode: glCode,
                    chargeName: _value.chargeName,
                    unitPrice: _value.unitPrice,
                    unitMeasurement: _value.unitMeasurement,
                    quantity: parseInt(_value.reqQuantityUsed)
                  };
                  tmp.laneChargeList.push(additonalCharge);
                }
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
          /*
               * Add base charges and lane level additional charfes
                  "glCode": 345578,
          "chargeName": "CHASSIS_RENTAL",
          "amount": "120",
          "unit": "day",
          "quantity": 2
               */

          // onePortData.laneList.push(lane)
          onePortData.laneList.push(tmp);
        }
        // onePortData.sourceChargeList = [];

        // let portAdditionalCharges = value.portAdditionalCharges;
        // if (portAdditionalCharges) {
        //   for (let [glCode, value] of portAdditionalCharges) {
        //     if (parseInt(value.reqQuantityUsed) > 0) {
        //       let additonalCharge = {
        //         glCode: glCode,
        //         chargeName: value.chargeName,
        //         unitPrice: parseInt(value.unitPrice),
        //         unitMeasurement: value.unitMeasurement,
        //         quantity: parseInt(value.reqQuantityUsed),
        //       };
        //       onePortData.sourceChargeList.push(additonalCharge);
        //     }
        //   }
        // }
        // onePortData.sourceChargeList = new Map(portAdditionalCharges)

        /*
         * Add port level additional chargesq
         */
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      sourceList.push(onePortData);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var msg = _extends({
    isMock: "true",
    opportunityId: opportunityId,
    sourceList: sourceList
  }, isPartner && {
    partnerId: partnerId,
    operationType: isFromEdit ? bidOperationType : null
  });

  var eventType = isPartner ? 'DRAYAGE_PARTNER_SUBMIT_BID' : 'DRAYAGE_GENERATE_AR';
  data = {
    eventMessage: msg,
    eventType: eventType,
    eventTime: Date.now()
  };

  console.log("Submit bid message : ", data);
  return HttpClient.custom({ data: data });
};

// {
// 	"opportunityId": "1",
// 	"partnerId": "partnerCode3",
// 	"sourceList": []
// }
// export const declineOpportunity=(opportunityId,partnerId)=>{
//   let data={}
//   data={

//     eventMessage:{
//       "partnerId":partnerId,
//       "isMock": "false" ,

//     },
//     eventType: "DRAYAGE_GET_PARTNER_CHARGES",
//     eventTime: Date.now(),
//   }
//   return HttpClient.custom({
//         data,})
// }

// }

//  export default {getDrayageOpportunities, getDrayageOpportunityDetails}

//  {
//   "eventMessage":  {
//    "opportunityId": "wewq12312"
//  },
//   "eventType": "DRAYAGE_GET_OPPORTUNITY_DETAILS",
//   "eventTime": 1539730411376
//  }

var getExistingCustomerList = function getExistingCustomerList() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var data = {
    eventType: "LIST_OF_CUSTOMERS",
    eventMessage: _extends({
      filter: "US",
      sortByEmail: true
    }, payload)
  };
  return HttpClient.custom({
    data: data
  });
};

var getPortsList = function getPortsList(query, country) {
  var entityType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "PORT";

  // let countryOfDestination = "United States"
  // if(country && country === "CA"){
  //   countryOfDestination = "Canada"
  // }

  var data = {
    eventType: "GET_ENTITY_LIST",

    eventMessage: {
      condition: country,
      entityType: entityType,
      searchValue: query,
      countries: ["US", "UK", "CA"]
    }
  };
  return HttpClient.custom({
    data: data
  });
};

var getAddressList = function getAddressList(eventMessage) {
  var data = {
    eventType: "GET_CUSTOMER_DESTINATIONS",
    eventMessage: eventMessage
  };
  return HttpClient.custom({
    data: data
  });
};

var getDPList = function getDPList() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var activeFilter = {
    key: "DRAYAGE_STATUS",
    values: ["ACTIVE"]
  };

  var newFilters = [].concat(toConsumableArray(filters), [activeFilter]);

  var data = {
    eventType: "DRAYAGE_GET_PARTNERS",

    eventMessage: {
      partners: "",
      filters: newFilters
    }
  };
  return HttpClient.custom({
    data: data
  });
};

var createOppurtunity = function createOppurtunity(obj) {
  var data = {
    eventType: "DRAYAGE_CREATE_OPPORTUNITY",
    eventMessage: obj
  };
  return HttpClient.custom({
    data: data
  });
};

var republishOppurtunity = function republishOppurtunity(obj) {
  var data = {
    eventType: "DRAYAGE_CREATE_OPPORTUNITY",
    eventMessage: obj
  };
  return HttpClient.custom({
    data: data
  });
};

var addCustomerDestination = function addCustomerDestination(obj) {
  var data = {
    eventType: "ADD_CUSTOMER_DESTINATION",
    eventMessage: obj
  };
  return HttpClient.custom({
    data: data
  });
};

var checkLaneExistence = function checkLaneExistence(obj) {
  var data = {
    eventType: "DRAYAGE_GET_LANE_STATUS",
    eventMessage: obj
  };
  return HttpClient.custom({
    data: data
  });
};

var updateOpportunityData = function updateOpportunityData(eventData) {
  var data = {
    eventType: "DRAYAGE_UPDATE_OPPORTUNITY_DATA",
    eventMessage: eventData
  };
  return HttpClient.custom({
    data: data
  });
};

var getOpportunityUpdationLogs = function getOpportunityUpdationLogs(eventData) {
  var data = {
    eventType: "DRAYAGE_OPPORTUNITY_CHANGE_LOG",
    eventMessage: eventData
  };
  return HttpClient.custom({
    data: data
  });
};

/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

// const API_URL= process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;
var API_URL = window._env_.REACT_APP_API_URL;

var apis = {
  //login

  login: function login(email, password) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          email: email,
          hashedPassword: password,
          typeOfUser: "FREIGHT_FORWARDER"
        },
        eventType: "KXUSER_LOGIN",
        eventTime: Date.now()
      })
    });
  },

  getCountryList: function getCountryList(type, input) {
    var data = {
      eventType: "GET_HS_MASTER_HS",
      eventMessage: {
        country: "US",
        hsVersion: "2019Rev2.0",
        itemType: "COUNTRY_LIST",
        itemId: "",
        itemEdi: "",
        carrierDesc: input
      },
      eventTime: Date.now()
    };

    return HttpClient.custom({
      data: data
    });
  },

  getContainerTypeOptions: function getContainerTypeOptions() {
    var data = {
      eventType: "GET_CONTAINER_TYPES",
      eventMessage: {},
      eventTime: Date.now()
    };

    return HttpClient.custom({
      data: data
    });
  }

  // inquiry: function(fullName, companyName, email, jobTitle, shipmentNumber, phoneNumber) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json"
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         userBasicInfo: {
  //           fullName: fullName,
  //           companyName: companyName,
  //           email: email,
  //           typeOfUser: "PROSPECT_USER",
  //           role: "USER_ADMIN",
  //           jobTitle: jobTitle
  //         },
  //         userInfo: {
  //           shippingInformation: {
  //             numberOfShipmentImported: shipmentNumber
  //           }
  //         },
  //         phone: {
  //           typeOfPhone: 3,
  //           isdCode: "1",
  //           phoneNo: phoneNumber
  //         }
  //       },
  //       eventType: "CREATE_KXUSER",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // createCustomer: function(companyName, email, typeOfUser, contactName) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json"
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         userBasicInfo: {
  //           role: "USER_ADMIN",
  //           companyName: companyName,
  //           email: email,
  //           typeOfUser: typeOfUser,
  //           contactName: contactName
  //         }
  //       },
  //       eventType: "CREATE_KXUSER",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // termsOfService: function(tempToken) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: tempToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         date: {
  //           epochs: Date.now()
  //         }
  //       },

  //       eventType: "GET_KXUSER_SIGNUP_DETAILS",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // //basic-info.js

  // updateProfile: function(tempToken, companyName, email, contactName, password, phone) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: tempToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         userBasicInfo: {
  //           companyName: companyName,
  //           email: email,
  //           contactName: contactName,
  //           hashedPassword: password,
  //           additionalEmail: "",
  //           typeOfUser: "FREIGHT_FORWARDER",
  //           displayImage: ""
  //         },
  //         phone: [
  //           {
  //             typeOfPhone: "WORK",
  //             isdCode: "1",
  //             phoneNo: phone
  //           }
  //         ]
  //       },
  //       eventType: "KXUSER_UPDATE_PERSONAL_PROFILE",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // //basic-info-company.js

  // companyInfo: function(kxCustomerToken, businessName, businessAddress1, businessAddress2, city, state, country, businessType, businessIncorporation, type, importerNumber) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: kxCustomerToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         userInfo: {
  //           companyInformation: {
  //             businessName: businessName,
  //             businessAddress: {
  //               address1: businessAddress1,
  //               address2: businessAddress2,
  //               city: city,
  //               state: state,
  //               country: country
  //             },
  //             businessType: businessType,
  //             businessIncorporation: businessIncorporation,
  //             importerNumber: {
  //               type: type,
  //               number: importerNumber
  //             }
  //           }
  //         }
  //       },
  //       eventType: "KXUSER_UPDATE_COMPANY_INFO",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // busSize: function(kxCustomerToken, number, frequency) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: kxCustomerToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         userInfo: {
  //           businessSize: {
  //             shipments: number,
  //             shipmentFrequency: frequency
  //           }
  //         }
  //       },
  //       eventType: "KXUSER_UPDATE_BUSINESS_SIZE",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // shippingInfo: function(kxCustomerToken, incoterms, freightForwarders, carriers, brokerData) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: kxCustomerToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         userInfo: {
  //           shippingInformation: {
  //             incoterms: incoterms,
  //             freightForwarders: freightForwarders,
  //             carriers: carriers,
  //             customerBrokers: brokerData
  //           }
  //         }
  //       },
  //       eventType: "KXUSER_UPDATE_SHIPPING_INFO",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // poa: function() {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json"
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         user: {
  //           email: "test7@klearexpress.com"
  //         },

  //         userInfo: {
  //           poa: {
  //             BII: "Delveras, USA",
  //             DBA: "Delveras, USA",
  //             businessAddress: {
  //               streetAddress: "ljkdlc",
  //               city: "San Jose",
  //               state: "California",
  //               zipcode: "12345",
  //               country: "USA"
  //             },
  //             ports: [],
  //             eSignature: "...",
  //             title: "..",
  //             timestamp: "..."
  //           }
  //         }
  //       },
  //       eventType: "KXUSER_UPDATE_POA",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // bondInfo: function(kxCustomerToken, number, amount, ownership, type) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: kxCustomerToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         userInfo: {
  //           bondInfo: {
  //             bondNumber: number,
  //             bondAmount: amount,
  //             bondOwnership: ownership,
  //             bondType: type
  //           }
  //         }
  //       },
  //       eventType: "KXUSER_UPDATE_BOND_INFO",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // notifications: function(kxCustomerToken, language, emailNotify, textNotify, shipmentNotify, docChangeNotify, customsNotify, logisticsNotify, brokerNotify) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: kxCustomerToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         userInfo: {
  //           preferences: {
  //             preferredLanguage: language,
  //             emailCommunication: emailNotify,
  //             textCommunication: textNotify,
  //             shipmentNotification: shipmentNotify,
  //             docChangeNotification: docChangeNotify,
  //             customsResponseNotification: customsNotify,
  //             logisticsTrackingNotification: logisticsNotify,
  //             brokerNotification: brokerNotify
  //           }
  //         }
  //       },
  //       eventType: "KXUSER_UPDATE_PREFERENCES",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // getCustomerInfo: function(kxCustomerToken) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: kxCustomerToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventType: "GET_KXUSER",
  //       eventMessage: {},
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // addACHPayment: function(email, type, fullName, bankName, accountNumber, bankCity, state, country) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json"
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         user: {
  //           email: "tamhong.sd@gmail.com"
  //         },

  //         bankDetails: [
  //           {
  //             type: type,
  //             fullName: fullName,
  //             bankName: bankName,
  //             accountNumber: accountNumber,
  //             bankCity: bankCity,
  //             state: state,
  //             country: country
  //           }
  //         ]
  //       },
  //       eventType: "KXUSER_UPDATE_BANK_DETAILS",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // addCCPayment: function(email, type, fullName, cardNumber, cvv, expMonth, expYear) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json"
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         user: {
  //           email: email
  //         },
  //         creditCardDetails: [
  //           {
  //             type: type,
  //             fullName: fullName,
  //             cardNumber: cardNumber,
  //             cvv: cvv,
  //             expMonth: expMonth,
  //             expYear: expYear
  //           }
  //         ]
  //       },
  //       eventType: "KXUSER_UPDATE_BANK_DETAILS",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // addTeam: function(kxCustomerToken, data) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: kxCustomerToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         customerInfo: {
  //           teamMember: [data]
  //         }
  //       },
  //       eventType: "KXUSER_UPDATE_ADD_TEAM_MEMBER",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // forgotPassword: function(email) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json"
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         email: email,
  //         typeOfUser: "CUSTOMER_USER"
  //       },
  //       eventType: "RESET_PASSWORD",
  //       eventTime: Date.now()
  //     })
  //   });
  // },

  // resetPassword: function(kxCustomerToken, password) {
  //   return fetch(API_URL, {
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       kxToken: kxCustomerToken
  //     },
  //     method: "post",
  //     body: JSON.stringify({
  //       eventMessage: {
  //         userBasicInfo: {
  //           typeOfUser: "CUSTOMER_USER",
  //           hashedPassword: password
  //         }
  //       },
  //       eventType: "UPDATE_PASSWORD",
  //       eventTime: Date.now()
  //     })
  //   });
  // }
};

var css_248z$4 = ".drayage_form {\n  margin: 5px !important;\n  /* Form */ }\n  .drayage_form .ARWithoutAPCheckbox {\n    padding: 10px 0; }\n  .drayage_form .inputWrapper .close.icon {\n    width: 17px;\n    height: 17px !important;\n    background-size: 100%;\n    margin-right: 3px;\n    border-radius: 2px 0 0 0;\n    position: absolute;\n    top: 18px;\n    right: 7px; }\n  .drayage_form .inputWrapper .close.icon:before {\n    content: \"\"; }\n  .drayage_form .inputWrapper {\n    height: 54px;\n    border: 1px solid #286084;\n    border-radius: 2px 0 0 0; }\n  .drayage_form .inputEl {\n    color: #000;\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: 1.14px;\n    line-height: 22px;\n    text-transform: uppercase;\n    border: none;\n    padding: 0;\n    height: 19px;\n    margin: 20px 13px 17px;\n    background: none !important; }\n  .drayage_form .typingInProgress input {\n    background-color: #f0f4ff !important;\n    color: #000000; }\n  .drayage_form .inputFocussed {\n    box-shadow: inset 0 0 2px 2px #8ed8ea; }\n  .drayage_form .errorMessage {\n    color: #ca443b;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 17px;\n    font-style: normal;\n    text-transform: uppercase;\n    margin-top: 5px;\n    float: right;\n    margin-right: 40px; }\n  .drayage_form .labelEl {\n    margin: 5px;\n    color: #595959;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 17px;\n    text-transform: uppercase;\n    display: inline-block; }\n  .drayage_form .inputWrapperWithError {\n    border: 1px solid #ca443b;\n    background-color: #ffffff;\n    box-shadow: inset 0 0 2px 2px #fcdcdc; }\n  .drayage_form .labelWrapper {\n    width: 100%;\n    display: block; }\n  .drayage_form .lockIcon {\n    width: 12px;\n    position: absolute;\n    top: 10px;\n    right: 20px; }\n  .drayage_form .errorIcon {\n    width: 16px;\n    position: absolute;\n    top: 6px;\n    right: 32px;\n    padding-right: 14px; }\n  .drayage_form .ui.popup .content {\n    font-family: Roboto, sans-serif;\n    font-size: 12px;\n    letter-spacing: 0;\n    line-height: 14px;\n    text-transform: uppercase;\n    background-color: white !important; }\n  .drayage_form .ui.popup {\n    padding: 5px 8px !important;\n    background-color: white !important; }\n  .drayage_form .inputEl {\n    padding: 0;\n    height: 22px;\n    margin-top: 27px;\n    margin-left: 12px;\n    margin-bottom: 0;\n    width: calc(100% - 45px); }\n  .drayage_form .inputWrapper,\n  .drayage_form .inputWrapper .inputEl {\n    font-family: Open sans, sans-serif !important; }\n  .drayage_form .inputWrapper .labelWrapper {\n    margin-top: 0;\n    transition: margin-top 0.2s; }\n  .drayage_form .inputWrapper .labelEl {\n    font-size: 12px; }\n  .drayage_form .inputWrapper[data-input-ready=\"false\"] .labelWrapper {\n    margin-top: 10px; }\n  .drayage_form .inputWrapper[data-input-ready=\"false\"] .labelEl {\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: 1.14px;\n    line-height: 22px; }\n  .drayage_form .column {\n    padding: 0 !important; }\n  .drayage_form .column,\n  .drayage_form .row {\n    padding: 0 !important; }\n\n.float-left {\n  float: left; }\n\n.ui.list .float-left:last-child {\n  margin-left: 5px; }\n";
styleInject(css_248z$4);

var ShowNotification = function (_Component) {
  inherits(ShowNotification, _Component);

  function ShowNotification(props) {
    classCallCheck(this, ShowNotification);

    var _this = possibleConstructorReturn(this, (ShowNotification.__proto__ || Object.getPrototypeOf(ShowNotification)).call(this, props));

    _this.state = {
      marginAmounts: [],
      submittedStatus: ""
    };
    _this.reqPayload = {};
    return _this;
  }

  createClass(ShowNotification, [{
    key: "render",
    value: function render() {
      var type = this.props.type;


      return React__default.createElement(
        "div",
        { className: "bidSelectionModal", "data-type": type },
        React__default.createElement(
          "div",
          { className: "bidSelectionModal_inner" },
          React__default.createElement(
            "div",
            { className: "notification-text" },
            this.props.text
          ),
          React__default.createElement(
            "div",
            { className: "tac" },
            React__default.createElement(
              "button",
              {
                onClick: this.props.closeModal,
                className: "primary_button_d"
              },
              "Ok"
            )
          )
        )
      );
    }
  }]);
  return ShowNotification;
}(Component);

var BiddingInfo = function (_Component) {
    inherits(BiddingInfo, _Component);

    function BiddingInfo(props) {
        classCallCheck(this, BiddingInfo);
        return possibleConstructorReturn(this, (BiddingInfo.__proto__ || Object.getPrototypeOf(BiddingInfo)).call(this, props));
    }

    createClass(BiddingInfo, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var destinationIndex = this.props.destinationIndex;
            var portIndex = this.props.portIndex;
            var singleDestination = this.props.singleDestination;
            var containerNumber = this.props.containerNumber;
            var port = lodash_1(this.props, 'contaninerDetails.port', '');
            var contaninerDetails = this.props.contaninerDetails;
            var isCustomerContainerRequest = this.props.isCustomerContainerRequest;
            console.log("BiddingInfo >>> constructor", contaninerDetails);

            // containerData[containerNumber].containerType  = get(container, 'containerType', "40HC")
            //     containerData[containerNumber].  = get(container, 'containerLoadType', "LCL")
            //     containerData[containerNumber].  = get(container, 'dropAndPullTRansport', "YES")
            //     containerData[containerNumber].  = get(container, 'warehouseAppointment', "YES")
            //     containerData[containerNumber].  = get(container, 'hazmat', "NO")
            //     containerData[containerNumber].  = get(container, 'overweight', "NO")

            var containerType = isCustomerContainerRequest ? contaninerDetails.containerType : singleDestination.bidingInfo.containerType;
            var arCurrencyCode = lodash_1(singleDestination.bidingInfo, 'arCurrencyCode', '');
            var containerLoadType = isCustomerContainerRequest ? contaninerDetails.containerLoadType : singleDestination.bidingInfo.containerLoadType;
            var dropAndPullTransport = isCustomerContainerRequest ? contaninerDetails.dropAndPullTransport : singleDestination.bidingInfo.dropAndPullTransport;
            var warehouseAppointment = isCustomerContainerRequest ? contaninerDetails.warehouseAppointment : singleDestination.bidingInfo.warehouseAppointment;
            var hazmat = isCustomerContainerRequest ? contaninerDetails.hazmat : singleDestination.bidingInfo.hazmat;
            var overweight = isCustomerContainerRequest ? contaninerDetails.overweight : singleDestination.bidingInfo.overweight;
            // let drayageRequested = isCustomerContainerRequest ? contaninerDetails.drayageRequested === "YES" : false
            var drayageRequested = isCustomerContainerRequest ? contaninerDetails.drayageRequested === "NOT_REQUESTED" ? false : true : false;

            if (!containerType) {
                containerType = "40HC";
            }
            // console.log("BiddingInfo >>> containerType", containerType,isCustomerContainerRequest )

            return React__default.createElement(
                "div",
                null,
                React__default.createElement(
                    Grid,
                    { container: true, className: "drayage_form bidding_info" },
                    !this.props.isCustomerContainerRequest && React__default.createElement(
                        Grid.Row,
                        null,
                        React__default.createElement(
                            Grid.Column,
                            { computer: 5 },
                            React__default.createElement(Input, {
                                label: "SUGGESTED PRICE PER CONT. (OPTIONAL)",
                                title: "Only numbers are allowed",
                                pattern: "[0-9]*",
                                numbersOnly: true,
                                onChange: function onChange(e) {
                                    return _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.proposedBid", portIndex, e);
                                },
                                value: singleDestination.bidingInfo.proposedBid
                            })
                        ),
                        React__default.createElement(
                            Grid.Column,
                            { computer: 5 },
                            React__default.createElement(Input, {
                                required: true,
                                label: this.props.publishOpp ? "VOLUME" : "VOLUME PER MONTH",
                                numbersOnly: true,
                                title: "Only more than 0 numbers are allowed",
                                pattern: "[1-9][0-9]*",
                                onChange: function onChange(e) {
                                    return _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.approxVolume", portIndex, e);
                                },
                                value: singleDestination.bidingInfo.approxVolume,
                                disabled: this.props.isCustomerNewContainerDrayageRequest ? true : false
                            })
                        ),
                        React__default.createElement(
                            Grid.Column,
                            { computer: 6 },
                            React__default.createElement(
                                "label",
                                { className: "custom_label" },
                                "AR Currency"
                            ),
                            React__default.createElement(Dropdown, {
                                fluid: true,
                                selection: true,
                                options: DRAYAGE_CURRENCY_OPTIONS,
                                defaultValue: arCurrencyCode,
                                onChange: drayageRequested ? null : function (e, data) {
                                    _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.arCurrencyCode", portIndex, data.value);
                                }
                            })
                        )
                    ),
                    React__default.createElement(
                        Grid.Row,
                        null,
                        React__default.createElement(
                            Grid.Column,
                            { computer: 5 },
                            React__default.createElement(
                                RadioGroup,
                                {
                                    horizontal: true,
                                    label: "LCL/FCL",
                                    spacing: 70,
                                    outerBox: true,
                                    style: { marginTop: "10px" }
                                },
                                React__default.createElement(RadioButton, {
                                    checked: containerLoadType === "LCL",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.containerLoadType", portIndex, "LCL");
                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "containerLoadType", "LCL");
                                        }
                                    },
                                    label: "LCL"
                                }),
                                React__default.createElement(RadioButton, {
                                    checked: containerLoadType === "FCL",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.containerLoadType", portIndex, "FCL");
                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "containerLoadType", "FCL");
                                        }
                                    },
                                    label: "FCL"
                                })
                            )
                        ),
                        React__default.createElement(
                            Grid.Column,
                            { computer: 5 },
                            React__default.createElement(
                                RadioGroup,
                                {
                                    horizontal: true,
                                    label: "DROP AND PULL",
                                    spacing: 70,
                                    outerBox: true
                                },
                                React__default.createElement(RadioButton, {
                                    checked: dropAndPullTransport === "YES",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.dropAndPullTransport", portIndex, "YES");
                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "dropAndPullTransport", "YES");
                                        }
                                    },
                                    label: "YES"
                                }),
                                React__default.createElement(RadioButton, {
                                    checked: dropAndPullTransport === "NO",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.dropAndPullTransport", portIndex, "NO");

                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "dropAndPullTransport", "NO");
                                        }
                                    },
                                    label: "NO"
                                })
                            )
                        ),
                        React__default.createElement(
                            Grid.Column,
                            { computer: 6 },
                            React__default.createElement(
                                RadioGroup,
                                {
                                    horizontal: true,
                                    label: "WAREHOUSE APP. MANDATORY",
                                    spacing: 70,
                                    outerBox: true
                                },
                                React__default.createElement(RadioButton, {
                                    checked: warehouseAppointment === "YES",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.warehouseAppointment", portIndex, "YES");

                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "warehouseAppointment", "YES");
                                        }
                                    },
                                    label: "YES"
                                }),
                                React__default.createElement(RadioButton, {
                                    checked: warehouseAppointment === "NO",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.warehouseAppointment", portIndex, "NO");
                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "warehouseAppointment", "NO");
                                        }
                                    },
                                    label: "NO"
                                })
                            )
                        )
                    ),
                    React__default.createElement(
                        Grid.Row,
                        null,
                        React__default.createElement(
                            Grid.Column,
                            { computer: 5 },
                            React__default.createElement(
                                RadioGroup,
                                {
                                    horizontal: true,
                                    label: "OVERWEIGHT",
                                    spacing: 70,
                                    outerBox: true
                                },
                                React__default.createElement(RadioButton, {
                                    checked: overweight === "YES",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.overweight", portIndex, "YES");
                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "overweight", "YES");
                                        }
                                    },
                                    label: "YES"
                                }),
                                React__default.createElement(RadioButton, {
                                    checked: overweight === "NO",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.overweight", portIndex, "NO");
                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "overweight", "NO");
                                        }
                                    },
                                    label: "NO"
                                })
                            )
                        ),
                        React__default.createElement(
                            Grid.Column,
                            { computer: 5 },
                            React__default.createElement(
                                RadioGroup,
                                {
                                    horizontal: true,
                                    label: "HAZMAT",
                                    spacing: 70,
                                    outerBox: true
                                },
                                React__default.createElement(RadioButton, {
                                    checked: hazmat === "YES",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.hazmat", portIndex, "YES");
                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "hazmat", "YES");
                                        }
                                    },
                                    label: "YES"
                                }),
                                React__default.createElement(RadioButton, {
                                    checked: hazmat === "NO",
                                    onChange: drayageRequested ? null : function () {
                                        _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.hazmat", portIndex, "NO");
                                        if (_this2.props.valueChangeHandler) {
                                            _this2.props.valueChangeHandler(port, containerNumber, "hazmat", "NO");
                                        }
                                    },
                                    label: "NO"
                                })
                            )
                        ),
                        React__default.createElement(
                            Grid.Column,
                            { computer: 6 },
                            React__default.createElement(
                                "label",
                                { className: "custom_label" },
                                "CONTAINER TYPE"
                            ),
                            React__default.createElement(Dropdown, {
                                fluid: true,
                                selection: true,
                                options: this.props.containerTypeOptions
                                // value={marginAmounts[lane.laneId]?.margin}
                                // defaultValue="40'HC"
                                , defaultValue: containerType,
                                onChange: drayageRequested ? null : function (e, data) {
                                    _this2.props.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].bidingInfo.containerType", portIndex, data.value);

                                    if (_this2.props.valueChangeHandler) {
                                        _this2.props.valueChangeHandler(port, containerNumber, "containerType", data.value);
                                    }

                                    // marginAmounts[lane.laneId].margin = data.value;
                                    // marginAmounts[lane.laneId].bidAmountWithMargin = this.roundOff(lane.bidAmount / (1-(data.value/100)))
                                    // marginAmounts[lane.laneId].totalAmount = marginAmounts[lane.laneId].bidAmountWithMargin * lane.approxVolume;
                                    // this.setState({marginAmounts});
                                }
                            })
                        )
                    )
                )
            );
        }
    }]);
    return BiddingInfo;
}(Component);

var css_248z$5 = ".filterLabel {\n    margin-top: 5px;\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    padding: 3px\n}";
styleInject(css_248z$5);

var KnCrossFilter = function (_Component) {
  inherits(KnCrossFilter, _Component);

  function KnCrossFilter() {
    classCallCheck(this, KnCrossFilter);
    return possibleConstructorReturn(this, (KnCrossFilter.__proto__ || Object.getPrototypeOf(KnCrossFilter)).apply(this, arguments));
  }

  createClass(KnCrossFilter, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          filterByOptions = _props.filterByOptions,
          serviceAreasOptions = _props.serviceAreasOptions,
          filtersOfDpList = _props.filtersOfDpList,
          setFilterBy = _props.setFilterBy,
          filterOptionOnChangeHandler = _props.filterOptionOnChangeHandler,
          removeElement = _props.removeElement;

      return React__default.createElement(
        "div",
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(Dropdown, {
            id: "filterBy",
            placeholder: "FILTER BY",
            search: true,
            selection: true,
            options: filterByOptions,
            style: { width: "30%" },
            value: "serviceArea",
            onChange: function onChange(e, data) {
              setFilterBy(data.value);
            }
          }),
          React__default.createElement(Dropdown, {
            id: "serviceAreas",
            value: "",
            search: true,
            selection: true,
            placeholder: "SERVICE AREAS",
            style: { width: "70%" },
            options: serviceAreasOptions,
            onChange: function onChange(e, data) {
              filterOptionOnChangeHandler({
                value: data.value,
                applyFilter: true
              });
            }
          })
        ),
        React__default.createElement(
          "div",
          { className: "filterLabel" },
          filtersOfDpList.map(function (e, i) {
            return React__default.createElement(
              "span",
              { "class": "ui label", style: { margin: "3px" } },
              e,
              React__default.createElement("i", {
                onClick: function onClick(e) {
                  return removeElement(e, { index: i, applyFilter: true });
                },
                "aria-hidden": "true",
                "class": "delete icon"
              })
            );
          })
        )
      );
    }
  }]);
  return KnCrossFilter;
}(Component);

var KnInput = function (_Component) {
    inherits(KnInput, _Component);

    function KnInput() {
        classCallCheck(this, KnInput);
        return possibleConstructorReturn(this, (KnInput.__proto__ || Object.getPrototypeOf(KnInput)).apply(this, arguments));
    }

    createClass(KnInput, [{
        key: 'render',
        value: function render() {
            return React__default.createElement(Input, {
                id: 'opportunityName',
                required: true,
                label: this.props.label,
                value: this.props.opportunityName,
                style: { paddingLeft: "2px", marginLeft: "12px" },
                onChange: this.props.onChangeFn
            });
        }
    }]);
    return KnInput;
}(Component);

var SourceSearchInput = function (_Component) {
  inherits(SourceSearchInput, _Component);

  function SourceSearchInput(props) {
    classCallCheck(this, SourceSearchInput);
    return possibleConstructorReturn(this, (SourceSearchInput.__proto__ || Object.getPrototypeOf(SourceSearchInput)).call(this, props));
  }

  createClass(SourceSearchInput, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          allPorts = _props.allPorts,
          portIndex = _props.portIndex,
          portNameQuery = _props.portNameQuery,
          portNameList = _props.portNameList,
          lastPortQuery = _props.lastPortQuery,
          loadingsourceList = _props.loadingsourceList,
          updateArrayState = _props.updateArrayState,
          updatePortsObj = _props.updatePortsObj,
          checkLane = _props.checkLane,
          fetchsourceList = _props.fetchsourceList,
          onSearchValueChange = _props.onSearchValueChange,
          isSearchingCustomerDestination = _props.isSearchingCustomerDestination,
          fetchDelAddressList = _props.fetchDelAddressList;


      return React__default.createElement(Search, {
        fluid: true
        // key={portNameQuery[portIndex +":"]}
        , placeholder: "Min. 2 characters",
        id: "portNameSearch",
        name: "portNameSearch",
        value: portNameQuery[portIndex + ":"],
        results: portNameList[lastPortQuery] || [],
        className: "portNameDD",
        noResultsMessage: (loadingsourceList || portNameQuery[portIndex + ":"]) && portNameQuery[portIndex + ":"].length < 2 ? "" : "No results found.",
        onResultSelect: function onResultSelect(e, data) {
          updateArrayState("selectedPortName", portIndex, "", data.result.title);
          updateArrayState("portNameQuery", portIndex, "", data.result.title);
          // this.setState({
          //   selectedPortName: data.result.title,
          //   portNameQuery: ""
          // })

          updatePortsObj("sourceId", portIndex, data.result.value);
          allPorts[portIndex].destinationAndBidingInfo.forEach(function (dest) {
            if (dest.destinationIndex) checkLane(portIndex, dest.destinationIndex);
          });
        },
        onSearchChange: function onSearchChange(e, data) {
          if (!data.value) updatePortsObj("sourceId", portIndex, "");
          isSearchingCustomerDestination ? fetchDelAddressList(e, data, true) : fetchsourceList(e, data);
          updateArrayState("portNameQuery", portIndex, "", data.value);
          //   this.lastPortQuery = data.value; //always has the last query made. Used to fetch the results for the last api call
          onSearchValueChange(data);
        }
      });
    }
  }]);
  return SourceSearchInput;
}(Component);

var DestinationSearchInput = function (_Component) {
  inherits(DestinationSearchInput, _Component);

  function DestinationSearchInput(props) {
    classCallCheck(this, DestinationSearchInput);
    return possibleConstructorReturn(this, (DestinationSearchInput.__proto__ || Object.getPrototypeOf(DestinationSearchInput)).call(this, props));
  }

  createClass(DestinationSearchInput, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          portIndex = _props.portIndex,
          updateArrayState = _props.updateArrayState,
          updatePortsObj = _props.updatePortsObj,
          checkLane = _props.checkLane,
          destinationIndex = _props.destinationIndex,
          delAddressQuery = _props.delAddressQuery,
          delAddressList = _props.delAddressList,
          lastDelQuery = _props.lastDelQuery,
          loadingAddressList = _props.loadingAddressList,
          destinationValueChangeHandler = _props.destinationValueChangeHandler,
          fetchDelAddressList = _props.fetchDelAddressList,
          onDestSearchValueChange = _props.onDestSearchValueChange,
          isSearchingPort = _props.isSearchingPort,
          fetchsourceList = _props.fetchsourceList;


      return React__default.createElement(Search, {
        key: destinationIndex,
        fluid: true,
        id: "delAddressSearch"
        // key={delAddressQuery[portIndex +":"+ destinationIndex]}
        , name: "delAddressSearch",
        value:
        // this.props.destinationAddressName
        delAddressQuery[portIndex + ":" + destinationIndex],
        placeholder: "Select a Delivery Address",
        results: delAddressList[lastDelQuery] || [],
        className: "delAddressDD",
        noResultsMessage: loadingAddressList ? "" : "No results found.",
        onResultSelect: function onResultSelect(e, data) {
          console.log("onSearchChange >>> onResultSelect ", portIndex, destinationIndex, data);
          updateArrayState("selectedDelAddress", portIndex, destinationIndex, data.result.title);
          updateArrayState("delAddressQuery", portIndex, destinationIndex, data.result.title);
          updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].destinationId", portIndex, data.result.value);
          updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].destinationAddress", portIndex, data.result.title);
          console.log("BiddingInfo >>> Destination address change ", data.result.value);
          if (destinationValueChangeHandler) {
            destinationValueChangeHandler(data);
          }
          checkLane(portIndex, destinationIndex);
        },
        onSearchChange: function onSearchChange(e, data) {
          console.log("onSearchChange >>> ", data);
          if (!data.value) {
            updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].destinationId", portIndex, "");
          }

          isSearchingPort ? fetchsourceList(e, data, true) : fetchDelAddressList(e, data);
          updateArrayState("delAddressQuery", portIndex, destinationIndex, data.value);
          onDestSearchValueChange(data);
        },
        resultRenderer: function resultRenderer(props) {
          return React__default.createElement(
            React__default.Fragment,
            null,
            React__default.createElement(
              "strong",
              null,
              props.title.split("-")[0]
            ),
            React__default.createElement(
              "span",
              null,
              props.title.split("-")[1]
            )
          );
        }
        //disabled={isCustomerContainerRequest}
      });
    }
  }]);
  return DestinationSearchInput;
}(Component);

var CustomAddressInput = function (_Component) {
  inherits(CustomAddressInput, _Component);

  function CustomAddressInput(props) {
    classCallCheck(this, CustomAddressInput);
    return possibleConstructorReturn(this, (CustomAddressInput.__proto__ || Object.getPrototypeOf(CustomAddressInput)).call(this, props));
  }

  createClass(CustomAddressInput, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          drayageApp = _props.drayageApp,
          updateArrayState = _props.updateArrayState,
          portIndex = _props.portIndex,
          destinationIndex = _props.destinationIndex,
          countryList = _props.countryList,
          addDestination = _props.addDestination,
          customAddressMsg = _props.customAddressMsg,
          customAddressSuccessMsg = _props.customAddressSuccessMsg;


      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          {
            className: "custom_delivery_address",
            style: drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { marginTop: "5px" } : { marginTop: "5px", padding: "5px" }
          },
          React__default.createElement(
            "span",
            { className: "form_heading" },
            "ADDRESS"
          ),
          React__default.createElement(
            "div",
            { className: "address-flex-row" },
            React__default.createElement(
              "div",
              { className: "address-text-input-conatiner" },
              React__default.createElement(Input$1, {
                required: true,
                className: "address-text-input",
                name: "addressName",
                onChange: function onChange(e) {
                  updateArrayState("addAddressName", portIndex, destinationIndex, e.target ? e.target.value : "");
                }
              }),
              React__default.createElement(
                "span",
                {
                  style: {
                    color: "#606060",
                    fontSize: "8px",
                    fontWeight: "600",
                    alignSelf: "center"
                  }
                },
                "ADDRESS NAME"
              )
            ),
            React__default.createElement(
              "div",
              { className: "address-text-input-conatiner" },
              React__default.createElement(Input$1, {
                required: true,
                className: "address-text-input",
                name: "referenceCode",
                onChange: function onChange(e) {
                  updateArrayState("addReferenceCode", portIndex, destinationIndex, e.target ? e.target.value : "");
                }
              }),
              React__default.createElement(
                "span",
                {
                  style: {
                    color: "#606060",
                    fontSize: "8px",
                    fontWeight: "600",
                    alignSelf: "center"
                  }
                },
                "REFERENCE CODE"
              )
            )
          ),
          React__default.createElement(
            "div",
            { className: "address-flex-row" },
            React__default.createElement(
              "div",
              { className: "address-text-input-conatiner" },
              React__default.createElement(Input$1, {
                required: true,
                className: "address-text-input",
                name: "addressLine1"
                // value={addressLine1}
                , onChange: function onChange(e) {
                  updateArrayState("addAddressLine1", portIndex, destinationIndex, e.target ? e.target.value : "");
                }
              }),
              React__default.createElement(
                "span",
                {
                  style: {
                    color: "#606060",
                    fontSize: "8px",
                    fontWeight: "600",
                    alignSelf: "center"
                  }
                },
                "ADDRESS LINE 1"
              )
            ),
            React__default.createElement(
              "div",
              { className: "address-text-input-conatiner" },
              React__default.createElement(Input$1, {
                className: "address-text-input",
                name: "addAddressLine2",
                required: true,
                style: {}
                //value={addressLine2}
                , onChange: function onChange(e) {
                  updateArrayState("addAddressLine2", portIndex, destinationIndex, e.target ? e.target.value : "");
                }
              }),
              React__default.createElement(
                "span",
                {
                  style: {
                    color: "#606060",

                    fontSize: "8px",
                    fontWeight: "600",
                    alignSelf: "center"

                    // marginRight:"10px "
                  }
                },
                "ADDRESS LINE 2"
              )
            )
          ),
          React__default.createElement(
            "div",
            { className: "address-flex-row", style: { marginTop: "5px" } },
            React__default.createElement(
              "div",
              {
                className: "address-text-input-conatiner"
                //style={{ width: "20%", }}
              },
              React__default.createElement(Input$1, {
                className: "address-text-input",
                name: "addCity",
                required: true
                //value={city}
                , onChange: function onChange(e) {
                  updateArrayState("addCity", portIndex, destinationIndex, e.target ? e.target.value : "");
                }
              }),
              React__default.createElement(
                "span",
                {
                  style: {
                    color: "#606060",
                    fontSize: "8px",
                    fontWeight: "600",
                    alignSelf: "center"
                  }
                },
                "CITY"
              )
            ),
            React__default.createElement(
              "div",
              {
                className: "address-text-input-conatiner",
                style: { width: "18%" }
              },
              React__default.createElement(Input$1, {
                className: "address-text-input",
                name: "addState",
                required: true
                //value={state}
                , onChange: function onChange(e) {
                  updateArrayState("addState", portIndex, destinationIndex, e.target ? e.target.value : "");
                }
              }),
              React__default.createElement(
                "span",
                {
                  style: {
                    color: "#606060",
                    fontSize: "8px",
                    fontWeight: "600",
                    alignSelf: "center",
                    paddingLeft: "180px"
                  }
                },
                "STATE/PROVINCE"
              )
            )
          ),
          React__default.createElement(
            "div",
            { className: "address-flex-row" },
            React__default.createElement(
              "div",
              { className: "address-text-input-conatiner" },
              React__default.createElement(Input$1, {
                className: "address-text-input",
                name: "addZip",
                required: true,
                numbersOnly: true
                //value={zipCode}
                , onChange: function onChange(e) {
                  updateArrayState("addZip", portIndex, destinationIndex, e.target ? e.target.value : "");
                }
              }),
              React__default.createElement(
                "span",
                {
                  style: {
                    color: "#606060",
                    fontSize: "8px",
                    fontWeight: "600",
                    alignSelf: "center"
                  }
                },
                "ZIPCODE"
              )
            ),
            React__default.createElement(
              "div",
              {
                className: "address-text-input-conatiner",
                style: { width: "37%", fontSize: "8px" }
              },
              React__default.createElement(Dropdown, {
                className: "dropdown-control2 country-dropdown",
                name: "addCountry",
                required: true,
                options: countryList,
                style: drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { marginTop: "5px" } : { marginTop: "-12px" }
                //value={country}
                , onChange: function onChange(e, data) {
                  updateArrayState("addCountry", portIndex, destinationIndex, data.value);
                }
                // text={this.findFullCountry(country)}
                , search: true
              }),
              React__default.createElement(
                "span",
                {
                  style: {
                    color: "#606060",
                    fontSize: "8px",
                    fontWeight: "600",
                    alignSelf: "center"
                  }
                },
                "COUNTRY"
              )
            )
          )
        ),
        React__default.createElement(
          "button",
          {
            className: "submit_address simpleButton primaryButton smallButton",
            onClick: function onClick(e) {
              e.preventDefault();
              addDestination(e, portIndex, destinationIndex);
            }
          },
          "Add Address"
        ),
        React__default.createElement(
          "b",
          { className: "select_custom_add" },
          React__default.createElement(
            "a",
            {
              href: "/#",
              className: "select_from_dropdown",
              onClick: function onClick() {
                return updateArrayState("giveCustomAddress", portIndex, destinationIndex, false);
              }
            },
            "SELECT FROM THE DROPDOWN"
          )
        ),
        customAddressMsg[portIndex + ":" + destinationIndex] && React__default.createElement(
          "p",
          { className: "address_add_status" },
          customAddressMsg[portIndex + ":" + destinationIndex]
        ),
        customAddressSuccessMsg[portIndex + ":" + destinationIndex] && React__default.createElement(
          "p",
          { className: "address_add_status success" },
          customAddressSuccessMsg[portIndex + ":" + destinationIndex]
        )
      );
    }
  }]);
  return CustomAddressInput;
}(Component);

var SmartAccordian = function (_React$Component) {
  inherits(SmartAccordian, _React$Component);

  function SmartAccordian(props) {
    classCallCheck(this, SmartAccordian);

    var _this = possibleConstructorReturn(this, (SmartAccordian.__proto__ || Object.getPrototypeOf(SmartAccordian)).call(this, props));

    _initialiseProps.call(_this);

    var currentDate = new Date();
    var closeDate = _this.getNextBidCloseDate(currentDate);
    var renewalDate = _this.getNextRenewalDate(currentDate);
    var isCustomerContainerRequest = _this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && _this.props.customerSource === "DrayageContainerRequest";

    _this.lastPortQuery = "";
    _this.sourceList = [];
    _this.addressList = [];
    _this.state = {
      accordianState: [true, true, true, true, true],
      newProspect: false,
      existingCustomer: true,
      selectedCustomerValue: null,
      fullCustList: [],
      selectedCustomerName: "",
      selectedCustomerCode: lodash_1(props, 'customerData.customerCode', ''),
      selectedKxEmail: "",
      value: undefined,
      opportunityId: null,
      opportunityStartDate: currentDate,
      // opportunityStartDateObj: null,
      opportunityEndDate: closeDate,
      eta: "",
      opportunityExpiryDate: _this.getNextRenewalDate(currentDate),
      opportunityName: "",
      selectedPortName: [],
      customerStartDate: currentDate,
      customerCloseDate: closeDate,
      customerRenewalDate: _this.getNextRenewalDate(currentDate),
      portNameQuery: [],
      publishOpp: false,
      // addressList: [],
      portNameList: { "": [] },
      custSearchQuery: "",
      delAddressQuery: [],
      delAddressList: { "": [] },
      dpList: [],
      dpListApi: [],
      opportunityDescription: "",
      selectedDelAddress: [],
      addAddressName: [],
      addAddressLine1: [],
      addAddressLine2: [],
      addCity: [],
      addState: [],
      addZip: [],
      addCountry: [],
      giveCustomAddress: [],
      showLaneError: [],
      customAddressMsg: [],
      customAddressSuccessMsg: [],
      countryList: [],
      containerTypeOptions: [],
      validationMessage: "",
      addReferenceCode: [],
      loadingsourceList: false,
      loadingAddressList: false,
      opportunityType: isCustomerContainerRequest ? "DRAYAGE_CONTAINER" : "DRAYAGE_LANE",
      isCustomerContainerRequest: isCustomerContainerRequest,
      allPorts: [{
        sourceId: props.sourceId ? props.sourceId : '',
        sourceType: DRAYAGE_SOURCE_TYPES.PORT,
        destinationAndBidingInfo: [{
          destinationId: props.destinationId ? props.destinationId : '',
          destinationType: DRAYAGE_DESTINATION_TYPES.CUSTOMER_WAREHOUSE,
          destinationAddress: '',
          bidingInfo: {
            proposedBid: "",
            approxVolume: lodash_1(_this.props.requestDrayage, 'isNewCont', false) ? 1 : "",
            hazmat: "NO",
            overweight: "NO",
            containerType: "40'HC",
            containerLoadType: "FCL",
            dropAndPullTransport: "NO",
            warehouseAppointment: "YES",
            arCurrencyCode: "USD"
          }
        }]
      }],
      filters: {},
      filterBy: 'serviceArea',
      isOpprotunityCreated: false,
      ARWithoutAP: false,
      searchTerm: '',
      searchResults: [],
      isLoading: false,
      searchCustomerNameSelected: '',
      searchCustomerCodeSelected: ''
    };

    _this.addDestination = lodash.debounce(_this.addDestination, 5000, {
      'leading': true,
      'trailing': false
    });

    _this.debounceSearchCustomerApi = lodash.debounce(_this.searchCustomerList, 1000);
    return _this;
  }

  //DatePicker sometimes does not attach the time with date resulting some conflicts


  createClass(SmartAccordian, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var requestDrayage = this.props.requestDrayage;
      // this.setValidationMessage("I am just testing this out!")

      if (this.props.customerData) {
        this.setState({
          // selectedCustomerCode: this.props.customerData.customerCode,
          // selectedCustomerName: this.props.customerData.customerName,
          selectedKxEmail: this.props.customerData.kxEmail
        });
      }
      if (requestDrayage) {
        var delAddressQuery = [];
        var portNameQuery = [];
        var containerData = requestDrayage.containerData;

        portNameQuery[0 + ":"] = containerData.sourceName + " (" + containerData.sourceId + ")";
        if (containerData.destinationId && containerData.destinationId !== "0") {
          // delAddressQuery[0 + ":" + 0] = this.getFullAddress(
          //   get(containerData, 'destinationAddress.address.value', []),
          //   get(containerData, 'destinationAddress.addressName.value', []),
          // )
          delAddressQuery[0 + ":" + 0] = containerData.destinationName;
        }

        this.setState({ portNameQuery: portNameQuery, delAddressQuery: delAddressQuery });
        this.updatePortsObj("destinationAndBidingInfo[0].destination", 0, delAddressQuery[0 + ":" + 0]);
      }

      if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES) {
        var selectedKxEmail = null;
        var opportunityEndDate = null;
        var eta = null;
        var opportunityType = null;
        var opportunityStartDate = new Date();
        var opportunityExpiryDate = this.getNextBidCloseDate(new Date());
        var opportunityName = null;
        var opportunityDescription = '';
        var allPorts = null;
        var opportunityId = null;
        var _delAddressQuery = [];
        var _portNameQuery = [];
        var searchCustomerCodeSelected = '',
            searchCustomerNameSelected = '',
            searchTerm = '';

        if (this.props.prefillNewTabData) {
          var _props$prefillNewTabD = this.props.prefillNewTabData,
              customerDetails = _props$prefillNewTabD.customerDetails,
              opportunityDetails = _props$prefillNewTabD.opportunityDetails,
              sourceList = _props$prefillNewTabD.sourceList;

          if (opportunityDetails.opportunityId && opportunityDetails.eta) {
            this.setState({ publishOpp: true });
          }

          selectedKxEmail = customerDetails.customerKxEmail;
          searchCustomerNameSelected = customerDetails.customerName;
          searchCustomerCodeSelected = customerDetails.customerCode;
          searchTerm = customerDetails.customerName;
          opportunityEndDate = opportunityDetails.endDate && opportunityDetails.opportunityId ? new Date(parseInt(opportunityDetails.endDate)) : this.getNextBidCloseDate(opportunityStartDate);
          eta = opportunityDetails.eta ? new Date(parseInt(opportunityDetails.eta)) : "";
          opportunityStartDate = opportunityDetails.startDate && opportunityDetails.opportunityId ? new Date(parseInt(opportunityDetails.startDate)) : opportunityStartDate;
          opportunityExpiryDate = opportunityDetails.opportunityExpiryDate && opportunityDetails.opportunityId ? new Date(parseInt(opportunityDetails.opportunityExpiryDate)) : this.getNextRenewalDate(opportunityStartDate);
          opportunityName = opportunityDetails.opportunityName ? opportunityDetails.opportunityName : "";
          opportunityType = opportunityDetails.opportunityType ? opportunityDetails.opportunityType : "";
          opportunityId = opportunityDetails.opportunityId ? opportunityDetails.opportunityId : null;
          opportunityName = opportunityDetails.opportunityName ? opportunityDetails.opportunityName : "";
          opportunityName = opportunityDetails.opportunityName ? opportunityDetails.opportunityName : "";
          opportunityDescription = opportunityDetails.description ? opportunityDetails.description : "";
          allPorts = sourceList ? sourceList.map(function (port) {
            return _this2.createAddressObj(port);
          }) : [];
          sourceList ? sourceList.forEach(function (port, portIndex) {
            port.destinations.forEach(function (destination, destinationIndex) {
              // debugger
              // delAddressQuery[portIndex + ":" + destinationIndex] = this.getFullAddress(
              //   destination.destinationAddress.address.values,
              //   destination.destinationAddress.addressName.value
              // )
              _delAddressQuery[portIndex + ":" + destinationIndex] = destination.destination;
            });
            _portNameQuery[portIndex + ":"] = port.source + " (" + port.sourceId + ")";
          }) : [];

          this.setState({
            selectedKxEmail: selectedKxEmail,
            opportunityEndDate: opportunityEndDate,
            opportunityType: opportunityType,
            opportunityStartDate: opportunityStartDate,
            eta: eta,
            opportunityExpiryDate: opportunityExpiryDate,
            opportunityName: opportunityName,
            opportunityDescription: opportunityDescription,
            allPorts: allPorts,
            delAddressQuery: _delAddressQuery,
            portNameQuery: _portNameQuery,
            searchCustomerCodeSelected: searchCustomerCodeSelected,
            searchCustomerNameSelected: searchCustomerNameSelected,
            searchTerm: searchTerm
          });
        }
      } else {
        getExistingCustomerList().then(function (res) {
          var fullCustList = [];

          res.data.eventMessage.customers && res.data.eventMessage.customers.forEach(function (customer, index) {
            fullCustList[index] = {
              key: customer.customerCode,
              text: customer.companyNameUS,
              value: customer.customerCode + ":::" + customer.companyNameUS + ":::" + customer.kxEmail
            };
          });
          var selectedCustomerValue = null;
          var selectedCustomerCode = null;
          var selectedCustomerName = null;
          var selectedKxEmail = null;
          var opportunityEndDate = null;
          var eta = null;
          var opportunityType = null;
          var opportunityStartDate = new Date();
          var opportunityExpiryDate = _this2.getNextBidCloseDate(new Date());
          var opportunityName = null;
          var opportunityDescription = '';
          var allPorts = null;
          var opportunityId = null;
          var delAddressQuery = [];
          var portNameQuery = [];
          if (_this2.props.prefillNewTabData) {
            var _props$prefillNewTabD2 = _this2.props.prefillNewTabData,
                _customerDetails = _props$prefillNewTabD2.customerDetails,
                _opportunityDetails = _props$prefillNewTabD2.opportunityDetails,
                _sourceList = _props$prefillNewTabD2.sourceList;

            if (_opportunityDetails.opportunityId && _opportunityDetails.eta) {
              _this2.setState({ publishOpp: true });
            }
            selectedCustomerValue = _customerDetails.customerCode + ":::" + _customerDetails.customerName + ":::" + _customerDetails.customerKxEmail;
            // console.log("TYPE here",typeof(selectedCustomerValue))
            selectedCustomerCode = _customerDetails.customerCode;
            selectedCustomerName = _customerDetails.customerName;
            selectedKxEmail = _customerDetails.customerKxEmail;
            opportunityEndDate = _opportunityDetails.endDate && _opportunityDetails.opportunityId ? new Date(parseInt(_opportunityDetails.endDate)) : _this2.getNextBidCloseDate(opportunityStartDate);
            eta = _opportunityDetails.eta ? new Date(parseInt(_opportunityDetails.eta)) : "";
            opportunityStartDate = _opportunityDetails.startDate && _opportunityDetails.opportunityId ? new Date(parseInt(_opportunityDetails.startDate)) : opportunityStartDate;
            opportunityExpiryDate = _opportunityDetails.opportunityExpiryDate && _opportunityDetails.opportunityId ? new Date(parseInt(_opportunityDetails.opportunityExpiryDate)) : _this2.getNextRenewalDate(opportunityStartDate);
            opportunityName = _opportunityDetails.opportunityName ? _opportunityDetails.opportunityName : "";
            opportunityType = _opportunityDetails.opportunityType ? _opportunityDetails.opportunityType : "";
            opportunityId = _opportunityDetails.opportunityId ? _opportunityDetails.opportunityId : null;
            opportunityName = _opportunityDetails.opportunityName ? _opportunityDetails.opportunityName : "";
            opportunityName = _opportunityDetails.opportunityName ? _opportunityDetails.opportunityName : "";
            opportunityDescription = _opportunityDetails.description ? _opportunityDetails.description : "";
            allPorts = _sourceList ? _sourceList.map(function (port) {
              return _this2.createAddressObj(port);
            }) : [];
            _sourceList ? _sourceList.forEach(function (port, portIndex) {
              port.destinations.forEach(function (destination, destinationIndex) {
                // debugger
                // delAddressQuery[portIndex + ":" + destinationIndex] = this.getFullAddress(
                //   destination.destinationAddress.address.values,
                //   destination.destinationAddress.addressName.value
                // )
                delAddressQuery[portIndex + ":" + destinationIndex] = destination.destination;
              });
              portNameQuery[portIndex + ":"] = port.source + " (" + port.sourceId + ")";
            }) : [];
            console.log(delAddressQuery, 'delAddressQuery');
            _this2.setState({
              fullCustList: fullCustList,
              selectedCustomerValue: selectedCustomerValue,
              selectedCustomerCode: selectedCustomerCode,
              selectedCustomerName: selectedCustomerName,
              selectedKxEmail: selectedKxEmail,
              opportunityEndDate: opportunityEndDate,
              opportunityType: opportunityType,
              opportunityStartDate: opportunityStartDate,
              eta: eta,
              opportunityExpiryDate: opportunityExpiryDate,
              opportunityName: opportunityName,
              opportunityDescription: opportunityDescription,
              allPorts: allPorts,
              delAddressQuery: delAddressQuery,
              portNameQuery: portNameQuery
            });
            return;
          }
          _this2.setState({
            fullCustList: fullCustList
          });
        });
      }

      var res1 = {},
          res2 = {};
      apis.getCountryList().then(function () {
        var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
          var countryList;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  res1 = response.data.eventMessage;
                  countryList = res1.itemList.map(function (item, index) {
                    return {
                      key: item.id,
                      value: item.id,
                      text: item.id + " - " + item.description
                    };
                  });


                  _this2.setState({ countryList: countryList });

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        return console.log("ERROR:", err);
      });

      apis.getContainerTypeOptions().then(function () {
        var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(response) {
          var containerTypeOptions;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  res2 = response.data.eventMessage;
                  containerTypeOptions = res2.containerType.map(function (item, index) {
                    return {
                      key: item,
                      value: item,
                      text: item
                    };
                  });


                  _this2.setState({ containerTypeOptions: containerTypeOptions });

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (err) {
        return console.log("ERROR:", err);
      });

      this.fetchDPList();

      // let data = {value:get(this.props,"contaninerDetails.destinationAddressName", null)}
      // console.log("componentDidMount >>>> ", data)
      // if (data) {
      //   this.fetchDelAddressList(null, data, null);
      // }
      if (this.state.isCustomerContainerRequest) {
        this.updateArrayState("delAddressQuery", 0, 0, this.getFullAddress(this.props.destinationAddressDetail, this.props.destinationAddressName));
        this.updateArrayState("selectedDelAddress", 0, 0, this.props.destinationAddressName);
        this.updatePortsObj("destinationAndBidingInfo[" + 0 + "].destinationId", 0, this.props.destinationAddressId);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.countrySelected !== prevProps.countrySelected) {
        this.fetchDPList();
        this.resetAllFields();
      }

      if (this.state.searchTerm !== prevState.searchTerm && prevState.searchTerm) {
        this.setState({
          ARWithoutAP: false,
          opportunityName: "",
          opportunityDescription: "",
          portNameQuery: [],
          portNameList: { "": [] },
          delAddressQuery: [],
          delAddressList: { "": [] }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setRenewdata && this.props.setRenewdata(null, true);
      this.debounceSearchCustomerApi.cancel();
      // this.props.resetOpportunityDetailData()
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          fullCustList = _state.fullCustList,
          portNameList = _state.portNameList,
          portNameQuery = _state.portNameQuery,
          selectedCustomerCode = _state.selectedCustomerCode,
          opportunityName = _state.opportunityName,
          opportunityStartDate = _state.opportunityStartDate,
          opportunityEndDate = _state.opportunityEndDate,
          opportunityExpiryDate = _state.opportunityExpiryDate,
          eta = _state.eta,
          opportunityDescription = _state.opportunityDescription,
          delAddressList = _state.delAddressList,
          delAddressQuery = _state.delAddressQuery,
          dpList = _state.dpList,
          allPorts = _state.allPorts,
          giveCustomAddress = _state.giveCustomAddress,
          validationMessage = _state.validationMessage,
          customAddressMsg = _state.customAddressMsg,
          customAddressSuccessMsg = _state.customAddressSuccessMsg,
          showLaneError = _state.showLaneError,
          loadingsourceList = _state.loadingsourceList,
          loadingAddressList = _state.loadingAddressList,
          filters = _state.filters,
          filterBy = _state.filterBy,
          isOpprotunityCreated = _state.isOpprotunityCreated,
          ARWithoutAP = _state.ARWithoutAP,
          searchResults = _state.searchResults,
          isLoading = _state.isLoading,
          searchTerm = _state.searchTerm,
          searchCustomerCodeSelected = _state.searchCustomerCodeSelected;
      var _props = this.props,
          drayageApp = _props.drayageApp,
          selectTab = _props.selectTab,
          newDrayageLaneRequestHandler = _props.newDrayageLaneRequestHandler,
          prefillNewTabData = _props.prefillNewTabData,
          requestDrayage = _props.requestDrayage,
          customerData = _props.customerData;

      var renewalType = lodash_1(prefillNewTabData, 'renewalType', '');
      var isSales = isSalesApp(drayageApp);
      var userType = lodash_1(customerData, 'userType', '');
      var customersConnected = lodash_1(this.props, "userModalData.userInitialData.channelConnections.customersConnected");
      console.log("ObjectCreateCommon state and props:", this.state, this.props);
      var customerMap = [];

      if (customersConnected) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = customersConnected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var customer = _step.value;

            //let customerCode = customer["customerCode"]
            //let customerName = customer["name"]
            //customerMap[customerCode] = customerName

            //customerMap[customer["customerCode"]] = customer["name"]
            var customerDetails = {};
            customerDetails["key"] = customer["customerCode"];
            customerDetails["text"] = customer["companyName"] + "(" + customer["customerCode"] + ")";
            customerDetails["value"] = customer["customerCode"] + ":::" + customer["companyName"] + ":::" + customer["customerKxEmail"];
            customerMap.push(customerDetails);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      // selectedCustomerValue = `${customerDetails.customerCode}:::${customerDetails.customerName}:::${customerDetails.customerKxEmail}`
      //     console.log("TYPE here",typeofselectedCustomerValue)
      //     selectedCustomerCode = customerDetails.customerCode
      //     selectedCustomerName = customerDetails.customerName
      //     selectedKxEmail = customerDetails.customerKxEmail

      //{key: 'M0D5', text: 'Martin 29 Company', value: 'M0D5:::Martin 29 Company:::undefined'}

      console.log("SmartAccord state,customerMap", customerMap);
      console.log("here SmartAccord", Object.keys(customerMap), Object.values(customerMap));

      var custStartDate = new Date();

      var filtersOfDpList = lodash.get(filters, filterBy, []);
      custStartDate = moment$1(custStartDate).format('ll');

      var currentDate = this.state.customerStartDate;
      //let closeDate= currentDate.setDate(currentDate.getDate() + 7)


      var isCustomerContainerRequest = this.state.isCustomerContainerRequest;
      console.log("OpportunityCreateCommon :: ", this.props, giveCustomAddress, delAddressQuery);
      var addressLine1 = "";
      var addressLine2 = "";
      var city = "";
      var state = "";
      var country = "";
      var zipCode = "";

      if (this.props.destinationAddressDetail) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.props.destinationAddressDetail[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var address = _step2.value;

            switch (address.type) {
              case "STREET_NUMBER":
                addressLine1 = address.information;
                break;
              case "STREET_NAME":
                addressLine2 = address.information;
                break;
              case "CITY":
                city = address.information;
                break;
              case "COUNTRY_SUB_ENTITY":
                state = address.information;
                break;
              case "COUNTRY":
                country = address.information;
                break;
              case "POSTAL_CODE":
                zipCode = address.information;
                break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      var myOptions = void 0;
      if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES) {
        myOptions = fullCustList;
        console.log("myValue sales: ", myOptions);
      }
      if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && (userType === "FREIGHT_FORWARDER" || userType === "SUPER_FREIGHT_FORWARDER")) {
        myOptions = customerMap;
        console.log("myValue customer", myOptions, this.state.selectedCustomerCode);
      }

      var fromContainer = lodash_1(this.props, "fromContainer", false);
      var minBidStartDate = new Date();
      var minBidCloseDate = opportunityStartDate;
      var requestDrayageActionButtons = lodash_1(requestDrayage, 'actionButtons', []);

      return React__default.createElement(
        "form",
        { className: "smart_accordian", id: "smart_accordian", onSubmit: this.submitForm, style: isCustomerContainerRequest ? { marginLeft: isCustomerContainerRequest ? "0px" : "-300px", width: isCustomerContainerRequest ? "100%" : "100%", marginRight: "10px" } : {} },
        React__default.createElement(
          "div",
          { style: fromContainer ? { overflowY: 'scroll', overflowX: 'hidden' } : { height: '75vh', overflowY: 'scroll', overflowX: 'hidden' } },
          this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && React__default.createElement(
            "div",
            { className: isCustomerContainerRequest ? "sm_accordian_item  is-collapsed" : "sm_accordian_item  is-collapsed sm_accordian_others" },
            this.makeHeader("Customer", 0),
            this.state.accordianState[0] && !isCustomerContainerRequest && React__default.createElement(
              "div",
              { className: "sm_accordian_expansion " + (renewalType === 'CUSTOMER_REQUESTED' ? 'disabled' : '') },
              React__default.createElement(Search, {
                id: "customerName",
                input: { fluid: true },
                loading: isLoading,
                onSearchChange: this.handleSearchChange,
                value: searchTerm,
                results: searchResults,
                onResultSelect: this.handleSearchResult,
                placeholder: "Customer (Min 3 characters...)",
                resultRenderer: this.handleRenderResult
              })
            )
          ),
          this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && (userType === "FREIGHT_FORWARDER" || userType === "SUPER_FREIGHT_FORWARDER") && React__default.createElement(
            "div",
            { className: isCustomerContainerRequest ? "sm_accordian_item  is-collapsed" : "sm_accordian_item  is-collapsed sm_accordian_others" },
            this.makeHeader("Customer", 0),
            this.state.accordianState[0] && !isCustomerContainerRequest && React__default.createElement(
              "div",
              { className: "sm_accordian_expansion " + (renewalType === 'CUSTOMER_REQUESTED' ? 'disabled' : '') },
              React__default.createElement(Dropdown, {
                id: "customerName",
                fluid: true,
                onChange: this.handleCustChange,
                options: myOptions,
                placeholder: "Customer",
                value: this.state.selectedCustomerValue,

                search: true,
                selection: true
              })
            )
          ),
          !isCustomerContainerRequest && React__default.createElement(
            "div",
            { className: isCustomerContainerRequest ? "sm_accordian_item  is-collapsed" : "sm_accordian_item  is-collapsed sm_accordian_others" },
            this.makeHeader("Opportunity", 1),
            this.state.accordianState[1] && React__default.createElement(
              "div",
              { className: "sm_accordian_expansion" },
              React__default.createElement(
                Grid,
                { container: true, className: "drayage_form" },
                isSales && !prefillNewTabData && React__default.createElement(
                  Grid.Row,
                  null,
                  React__default.createElement(
                    Grid.Column,
                    { mobile: 16, tablet: 8, computer: 16 },
                    React__default.createElement(Checkbox, {
                      className: "ARWithoutAPCheckbox",
                      checked: ARWithoutAP,
                      label: "To generate customer quote without drayage partner bids",
                      onChange: function onChange(event, data) {
                        _this3.setState({ ARWithoutAP: data.checked });
                      } })
                  )
                ),
                React__default.createElement(
                  Grid.Row,
                  null,
                  React__default.createElement(
                    Grid.Column,
                    { mobile: 16, tablet: 8, computer: 16 },
                    React__default.createElement(KnInput
                    // required={true}
                    , { label: "Opportunity Name",
                      opportunityName: opportunityName
                      // style={{ paddingLeft: "2px", marginLeft: "12px", }}
                      , onChangeFn: function onChangeFn(e) {
                        return _this3.setState({ opportunityName: e });
                      }
                    })
                  )
                ),
                this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? React__default.createElement(
                  Grid.Row,
                  { className: "opportunity_dates_wrapper" },
                  React__default.createElement(
                    "div",
                    { className: "opportunity_dates" },
                    React__default.createElement(
                      "label",
                      { className: "floating_label" },
                      "Bid Start Date"
                    ),
                    React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(DatePicker
                      // placeholderText="BID START DATE"
                      , { id: "opportunityStartDate",
                        name: "opportunityStartDate",
                        selected: opportunityStartDate,
                        value: opportunityStartDate,
                        dateFormat: "MMM dd, yyyy",
                        onChange: function onChange(value) {
                          _this3.setState({
                            opportunityStartDate: value,
                            opportunityEndDate: _this3.getNextBidCloseDate(value),
                            opportunityExpiryDate: _this3.getNextRenewalDate(value)
                          });
                        },
                        minDate: minBidStartDate
                      })
                    )
                  ),
                  React__default.createElement(
                    "div",
                    { className: "opportunity_dates" },
                    React__default.createElement(
                      "label",
                      { className: "floating_label" },
                      "Bid Close Date"
                    ),
                    React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(DatePicker, {
                        placeholderText: "BID CLOSE DATE",
                        id: "opportunityEndDate",
                        name: "opportunityEndDate",
                        minDate: minBidCloseDate,
                        selected: opportunityEndDate,
                        onChange: function onChange(value) {
                          _this3.setState({ opportunityEndDate: value });
                        },
                        dateFormat: "MMM dd, yyyy",
                        value: opportunityEndDate
                      })
                    )
                  ),
                  this.state.publishOpp ? React__default.createElement(
                    "div",
                    { className: "opportunity_dates" },
                    React__default.createElement(
                      "label",
                      { className: "floating_label" },
                      "Estimated Time of Arrival"
                    ),
                    React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(DatePicker, {

                        placeholderText: "Expected time of Arrival",
                        id: "opportunityRenewalDate",
                        name: "opportunityRenewalDate",
                        selected: eta,
                        onChange: function onChange(value) {
                          _this3.setState({ opportunityExpiryDate: value });
                        },

                        dateFormat: "MMM dd, yyyy",
                        disabled: true,

                        minDate: eta
                      })
                    )
                  ) : React__default.createElement(
                    "div",
                    { className: "opportunity_dates" },
                    React__default.createElement(
                      "label",
                      { className: "floating_label" },
                      "Bid Renewal Date"
                    ),
                    React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(DatePicker, {

                        placeholderText: "BID RENEWAL DATE",
                        id: "opportunityRenewalDate",
                        name: "opportunityRenewalDate",
                        selected: opportunityExpiryDate,
                        onChange: function onChange(value) {
                          _this3.setState({ opportunityExpiryDate: value });
                        },
                        dateFormat: "MMM dd, yyyy",
                        minDate: this.getNextRenewalDate(opportunityStartDate)

                      })
                    )
                  )
                ) : React__default.createElement(
                  Grid.Row,
                  { className: "opportunity_dates_wrapper" },
                  React__default.createElement(
                    "div",
                    { className: "opportunity_dates" },
                    React__default.createElement(
                      "label",
                      { className: "floating_label" },
                      "Bid Start Date"
                    ),
                    React__default.createElement(DatePicker
                    // placeholderText="BID START DATE"
                    , { id: "opportunityStartDate",
                      name: "opportunityStartDate",
                      minDate: new Date(),
                      selected: this.state.customerStartDate,
                      value: this.state.customerStartDate,
                      dateFormat: "MMM dd, yyyy",
                      onChange: function onChange(value) {
                        _this3.setState({
                          customerStartDate: value, customerCloseDate: _this3.getNextBidCloseDate(value),
                          opportunityEndDate: _this3.getNextBidCloseDate(value),
                          customerRenewalDate: _this3.getNextRenewalDate(value)
                        });
                      }
                    })
                  ),
                  React__default.createElement(
                    "div",
                    { className: "opportunity_dates" },
                    React__default.createElement(
                      "label",
                      { className: "floating_label" },
                      "Bid Close Date"
                    ),
                    React__default.createElement(DatePicker, {
                      style: { paddingTop: "10px" }

                      //  placeholderText="BID CLOSE DATE"
                      , id: "opportunityEndDate",
                      name: "opportunityEndDate",
                      minDate: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? this.state.customerCloseDate : this.state.opportunityEndDate,

                      selected: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? this.state.customerCloseDate : this.state.opportunityEndDate,

                      onChange: function onChange(value) {
                        _this3.setState({ opportunityEndDate: value, customerCloseDate: value });
                      },

                      dateFormat: "MMM dd, yyyy"
                      //disabled={isfDisabled}

                      , value: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? this.state.customerCloseDate : this.state.opportunityEndDate

                    })
                  ),
                  !lodash_1(requestDrayage, 'isNewCont', false) && React__default.createElement(
                    "div",
                    { className: "opportunity_dates" },
                    React__default.createElement(
                      "label",
                      { className: "floating_label" },
                      "Bid Renewal Date"
                    ),
                    React__default.createElement(DatePicker

                    // placeholderText="BID RENEWAL DATE"
                    , { id: "opportunityExpiryDate",
                      name: "opportunityExpiryDate",
                      selected: this.state.customerRenewalDate,
                      onChange: function onChange(value) {
                        _this3.setState({ opportunityExpiryDate: value, customerRenewalDate: value });
                      },

                      dateFormat: "MMM dd, yyyy",
                      minDate: this.state.customerRenewalDate
                    })
                  )
                ),
                React__default.createElement(
                  Grid.Row,
                  null,
                  React__default.createElement(
                    Grid.Column,
                    { mobile: 16, tablet: 16, computer: 16 },
                    React__default.createElement(
                      "label",
                      { className: "floating_label" },
                      "DESCRIPTION"
                    ),
                    React__default.createElement("textarea", {
                      id: "description",
                      placeholder: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? "FOR INTERNAL ONLY" : "",
                      value: opportunityDescription,
                      onChange: function onChange(e) {
                        return _this3.setState({
                          opportunityDescription: e.target.value
                        });
                      }
                    })
                  )
                )
              )
            )
          ),
          allPorts.map(function (singlePort, portIndex) {
            return React__default.createElement(
              "div",
              { key: portIndex, className: isCustomerContainerRequest ? "sm_accordian_item  is-collapsed" : "sm_accordian_item  is-collapsed sm_accordian_others" },
              !isCustomerContainerRequest && _this3.makeHeader("Pickup and Delivery", 2),
              _this3.state.accordianState[2] && React__default.createElement(
                "div",
                { className: "sm_accordian_expansion" },
                portIndex > 0 && React__default.createElement(
                  "a",
                  {
                    href: "/#",
                    className: "delete_portdestination",
                    onClick: function onClick() {
                      return _this3.deletePort(portIndex);
                    }
                  },
                  React__default.createElement("img", {
                    src: "../images/delete_icon.svg",
                    className: "",
                    alt: ""
                  }),
                  React__default.createElement(
                    "p",
                    null,
                    "Delete Port"
                  )
                ),
                React__default.createElement("br", null),
                React__default.createElement(
                  "b",
                  null,
                  "Pickup Location ",
                  DRAYAGE_APP.KLEARDRAY_SALES && ": " + (singlePort.sourceType === DRAYAGE_SOURCE_TYPES.PORT ? 'Port' : 'Address')
                ),
                React__default.createElement("br", null),
                DRAYAGE_APP.KLEARDRAY_SALES && React__default.createElement(
                  "div",
                  { className: "location-type-input-container" },
                  React__default.createElement(
                    "label",
                    { className: "location-type-label" },
                    "Port"
                  ),
                  React__default.createElement(Radio, {
                    toggle: true,
                    label: 'Address',
                    checked: singlePort.sourceType === DRAYAGE_SOURCE_TYPES.CUSTOMER_WAREHOUSE,
                    onChange: function onChange(e, data) {
                      _this3.updatePortsObj("sourceType", portIndex, data.checked ? DRAYAGE_SOURCE_TYPES.CUSTOMER_WAREHOUSE : DRAYAGE_SOURCE_TYPES.PORT);
                      _this3.updateArrayState("selectedPortName", portIndex, "", "");
                      _this3.updateArrayState("portNameQuery", portIndex, "", "");
                      _this3.updatePortsObj("sourceId", portIndex, "");
                    }
                  })
                ),
                !isCustomerContainerRequest && React__default.createElement(
                  React__default.Fragment,
                  null,
                  (!giveCustomAddress[portIndex + ":" + ''] || singlePort.sourceType === DRAYAGE_SOURCE_TYPES.PORT) && React__default.createElement(
                    React__default.Fragment,
                    null,
                    React__default.createElement(SourceSearchInput, { allPorts: allPorts,
                      portIndex: portIndex,
                      portNameQuery: portNameQuery,
                      portNameList: portNameList,
                      lastPortQuery: _this3.lastPortQuery,
                      loadingsourceList: loadingsourceList,
                      updateArrayState: _this3.updateArrayState,
                      updatePortsObj: _this3.updatePortsObj,
                      checkLane: _this3.checkLane,
                      fetchsourceList: _this3.fetchsourceList,
                      onSearchValueChange: function onSearchValueChange(data) {
                        _this3.lastPortQuery = data.value; //always has the last query made. Used to fetch the results for the last api call
                      },
                      isSearchingCustomerDestination: singlePort.sourceType === DRAYAGE_SOURCE_TYPES.CUSTOMER_WAREHOUSE,
                      fetchDelAddressList: _this3.fetchDelAddressList
                    }),
                    !requestDrayage && singlePort.sourceType === DRAYAGE_SOURCE_TYPES.CUSTOMER_WAREHOUSE && React__default.createElement(
                      "b",
                      { className: "select_custom_add" },
                      "Not in the list? \xA0",
                      React__default.createElement(
                        "a",
                        { href: "javascript:;", onClick: function onClick() {
                            return _this3.updateArrayState("giveCustomAddress", portIndex, '', true);
                          }
                        },
                        "ADD"
                      )
                    )
                  ),
                  giveCustomAddress[portIndex + ":" + ''] && singlePort.sourceType === DRAYAGE_SOURCE_TYPES.CUSTOMER_WAREHOUSE && React__default.createElement(CustomAddressInput, { drayageApp: _this3.props.drayageApp,
                    updateArrayState: _this3.updateArrayState,
                    portIndex: portIndex,
                    destinationIndex: "",
                    countryList: _this3.state.countryList,
                    addDestination: _this3.addDestination,
                    customAddressMsg: customAddressMsg,
                    customAddressSuccessMsg: customAddressSuccessMsg
                  })
                ),
                singlePort.destinationAndBidingInfo.map(function (singleDestination, destinationIndex) {
                  return React__default.createElement(
                    "div",
                    {
                      key: destinationIndex,
                      className: "single_destination"
                    },
                    destinationIndex > 0 && React__default.createElement(
                      "a",
                      {
                        href: "/#",
                        className: "delete_portdestination",
                        onClick: function onClick() {
                          return _this3.deleteDestination(portIndex, destinationIndex);
                        }
                      },
                      _this3.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? React__default.createElement("img", {
                        src: "../images/delete_icon.svg" }) : React__default.createElement("img", {
                        src: "images/files/delete_icon.svg" }),
                      React__default.createElement(
                        "p",
                        null,
                        "Delete Delivery Location"
                      )
                    ),
                    React__default.createElement("br", null),
                    React__default.createElement(
                      "b",
                      null,
                      "Delivery Location ",
                      DRAYAGE_APP.KLEARDRAY_SALES && ": " + (singleDestination.destinationType === DRAYAGE_DESTINATION_TYPES.PORT ? 'Port' : 'Address')
                    ),
                    React__default.createElement("br", null),
                    DRAYAGE_APP.KLEARDRAY_SALES && React__default.createElement(
                      "div",
                      { className: "location-type-input-container" },
                      React__default.createElement(
                        "label",
                        { className: "location-type-label" },
                        "Port"
                      ),
                      React__default.createElement(Radio, {
                        toggle: true,
                        label: 'Address',
                        checked: singleDestination.destinationType === DRAYAGE_DESTINATION_TYPES.CUSTOMER_WAREHOUSE,
                        onChange: function onChange(e, data) {
                          _this3.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].destinationType", portIndex, data.checked ? DRAYAGE_DESTINATION_TYPES.CUSTOMER_WAREHOUSE : DRAYAGE_DESTINATION_TYPES.PORT);
                          _this3.updateArrayState("selectedDelAddress", portIndex, destinationIndex, "");
                          _this3.updateArrayState("delAddressQuery", portIndex, destinationIndex, "");
                          _this3.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].destinationId", portIndex, "");
                          _this3.updatePortsObj("destinationAndBidingInfo[" + destinationIndex + "].destinationAddress", portIndex, "");
                        }
                      })
                    ),
                    (!giveCustomAddress[portIndex + ":" + destinationIndex] || singleDestination.destinationType === DRAYAGE_DESTINATION_TYPES.PORT) && React__default.createElement(
                      React__default.Fragment,
                      null,
                      React__default.createElement(DestinationSearchInput, {
                        portIndex: portIndex,
                        updateArrayState: _this3.updateArrayState,
                        updatePortsObj: _this3.updatePortsObj,
                        checkLane: _this3.checkLane
                        //destination specific props -
                        , destinationIndex: destinationIndex,
                        delAddressQuery: delAddressQuery,
                        delAddressList: delAddressList,
                        lastDelQuery: _this3.lastDelQuery,
                        loadingAddressList: loadingAddressList,
                        destinationValueChangeHandler: function destinationValueChangeHandler(data) {
                          if (_this3.props.valueChangeHandler) {
                            _this3.props.valueChangeHandler(lodash_1(_this3.props.contaninerDetails, 'port', ''), _this3.props.containerNumber, "destinationId", data.result.value);
                            _this3.props.valueChangeHandler(lodash_1(_this3.props.contaninerDetails, 'port', ''), _this3.props.containerNumber, "destinationAddressName", data.result.title);
                          }
                        },
                        fetchDelAddressList: _this3.fetchDelAddressList,
                        onDestSearchValueChange: function onDestSearchValueChange(data) {
                          _this3.lastDelQuery = _this3.state.selectedKxEmail + "," + data.value; //always has the last query made. Used to fetch the results for the last api call
                        },
                        isSearchingPort: singleDestination.destinationType === DRAYAGE_DESTINATION_TYPES.PORT,
                        fetchsourceList: _this3.fetchsourceList
                      }),
                      !isCustomerContainerRequest && React__default.createElement(
                        "div",
                        null,
                        !requestDrayage && singleDestination.destinationType === DRAYAGE_DESTINATION_TYPES.CUSTOMER_WAREHOUSE && React__default.createElement(
                          "b",
                          { className: "select_custom_add" },
                          "Not in the list? \xA0",
                          React__default.createElement(
                            "a",
                            { href: "javascript:;", onClick: function onClick() {
                                return _this3.updateArrayState("giveCustomAddress", portIndex, destinationIndex, true);
                              }
                            },
                            "ADD"
                          )
                        ),
                        React__default.createElement(
                          "b",
                          null,
                          showLaneError[portIndex + ":" + destinationIndex] && React__default.createElement(
                            "p",
                            { className: "lane_already_exists" },
                            "Lane with this port and the destination is already",
                            " ",
                            showLaneError[portIndex + ":" + destinationIndex],
                            "."
                          )
                        )
                      )
                    ),
                    giveCustomAddress[portIndex + ":" + destinationIndex] && singleDestination.destinationType === DRAYAGE_DESTINATION_TYPES.CUSTOMER_WAREHOUSE && React__default.createElement(CustomAddressInput, { drayageApp: _this3.props.drayageApp,
                      updateArrayState: _this3.updateArrayState,
                      portIndex: portIndex,
                      destinationIndex: destinationIndex,
                      countryList: _this3.state.countryList,
                      addDestination: _this3.addDestination,
                      customAddressMsg: customAddressMsg,
                      customAddressSuccessMsg: customAddressSuccessMsg
                    }),
                    React__default.createElement(
                      "b",
                      null,
                      isCustomerContainerRequest ? "Requested price and other details" : "Bidding Info"
                    ),
                    React__default.createElement(BiddingInfo, {
                      isCustomerContainerRequest: isCustomerContainerRequest,
                      destinationIndex: destinationIndex,
                      portIndex: portIndex,
                      publishOpp: _this3.state.publishOpp,
                      singleDestination: singleDestination,
                      updatePortsObj: _this3.updatePortsObj,
                      containerTypeOptions: _this3.state.containerTypeOptions,
                      valueChangeHandler: _this3.props.valueChangeHandler,
                      containerNumber: _this3.props.containerNumber,
                      contaninerDetails: _this3.props.contaninerDetails,
                      isCustomerNewContainerDrayageRequest: lodash_1(requestDrayage, 'isNewCont', false)
                    })
                  );
                }),
                !ARWithoutAP && !requestDrayage ? React__default.createElement(
                  "a",
                  {
                    href: "javascript:;",
                    className: "add_destination",
                    onClick: function onClick() {
                      return _this3.addDestinationForm(portIndex);
                    }
                  },
                  !isCustomerContainerRequest && React__default.createElement("img", {
                    src: "../images/add-document.svg",
                    className: "add_document",
                    alt: ""
                  }),
                  _this3.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? "ADD DELIVERY ADDRESS AND BIDDING INFO" : !isCustomerContainerRequest ? "ADD DELIVERY ADDRESS AND OTHER INFO" : ""
                ) : null
              )
            );
          }),
          !isCustomerContainerRequest && !requestDrayage && (selectedCustomerCode || searchCustomerCodeSelected) && !ARWithoutAP && React__default.createElement(
            "a",
            { href: "javascript:;", className: "add_port", onClick: function onClick() {
                return _this3.addPort();
              } },
            React__default.createElement("img", {
              src: "../images/add-document.svg",
              className: "add_document",
              alt: ""
            }),
            "ADD PORT"
          ),
          this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && !ARWithoutAP && React__default.createElement(
            "div",
            { className: isCustomerContainerRequest ? "sm_accordian_item  is-collapsed" : "sm_accordian_item  is-collapsed sm_accordian_others" },
            this.makeHeader("Drayage Partners", 3),
            this.state.accordianState[3] && React__default.createElement(
              "div",
              { className: "sm_accordian_expansion" },
              React__default.createElement(KnCrossFilter, { filterByOptions: filterByOptions, serviceAreasOptions: serviceAreasOptions, filtersOfDpList: filtersOfDpList, setFilterBy: function setFilterBy(value) {
                  return _this3.setState({ filterBy: value });
                }, filterOptionOnChangeHandler: this.filterOptionOnChangeHandler, removeElement: this.removeElement }),
              React__default.createElement(
                Table,
                { celled: true },
                React__default.createElement(
                  Table.Header,
                  null,
                  React__default.createElement(
                    Table.Row,
                    null,
                    React__default.createElement(
                      Table.HeaderCell,
                      null,
                      React__default.createElement("input", {
                        id: "selectAllPartner",
                        type: "checkbox",
                        value: "all",
                        checked: dpList.length && dpList.every(function (dp) {
                          return dp.checked;
                        }),
                        onChange: this.addPartnerId,
                        className: "partner_cb"
                      })
                    ),
                    React__default.createElement(
                      Table.HeaderCell,
                      null,
                      "PARTNER NAME"
                    ),
                    React__default.createElement(
                      Table.HeaderCell,
                      null,
                      "SERVICE AREAS"
                    ),
                    React__default.createElement(
                      Table.HeaderCell,
                      null,
                      "ADDRESS"
                    )
                  )
                ),
                React__default.createElement(
                  Table.Body,
                  null,
                  dpList.map(function (dp) {
                    return React__default.createElement(
                      Table.Row,
                      { key: dp.partnerId },
                      React__default.createElement(
                        Table.Cell,
                        null,
                        React__default.createElement("input", {
                          type: "checkbox",
                          checked: dp.checked,
                          value: dp.partnerId,
                          onChange: _this3.addPartnerId,
                          className: "partner_cb"
                        })
                      ),
                      React__default.createElement(
                        Table.Cell,
                        null,
                        dp.name
                      ),
                      React__default.createElement(
                        Table.Cell,
                        null,
                        dp.territory
                      ),
                      React__default.createElement(
                        Table.Cell,
                        null,
                        dp.address
                      )
                    );
                  })
                )
              )
            )
          ),
          validationMessage && React__default.createElement(ShowNotification, {
            type: "JUST_A_NOTIFICATION",
            text: validationMessage,
            closeModal: function closeModal() {
              _this3.setState({ validationMessage: "" });
              if (!isOpprotunityCreated) {
                return;
              }
              switch (drayageApp) {
                case DRAYAGE_APP.KLEARDRAY_CUSTOMER:
                  !requestDrayage && selectTab(SELECTED_TABS.CUSTOMER_REQUESTED);
                  newDrayageLaneRequestHandler();
                  break;

                case DRAYAGE_APP.KLEARDRAY_SALES:
                  selectTab('SALES_' + SELECTED_TABS.SALES_PUBLISHED);
                  break;

                default:
                  break;
              }

              // const { validationMessage } = this.state;

              // if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER) {
              //   this.props.selectTab(SELECTED_TABS.CUSTOMER_REQUESTED)
              //   this.props.newDrayageLaneRequestHandler()
              // }
              // this.setState({ validationMessage: "" });
              // if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && this.state.validationMessage === "You have not selected any Partners") {
              //   document
              //     .querySelector(".partner-top-header > .tab-btn:nth-child(1)")
              //     .click();

              // } else if(this.state.validationMessage !== ""){
              //   document
              //     .querySelector(".partner-top-header > .tab-btn:nth-child(3)")
              //     .click();
              // } else {
              //   document
              //     .querySelector(".partner-top-header > .tab-btn:nth-child(2)")
              //     .click();
              // }
            }
          })
        ),
        !isCustomerContainerRequest && !requestDrayage && React__default.createElement(
          "div",
          { className: "general-centered " },
          React__default.createElement(
            "button",
            {
              // onClick={this.submitForm}
              className: "simpleButton primaryButton",
              type: "submit",
              id: "newOpproSubmitButton"
            },
            "Submit"
          ),
          React__default.createElement(
            "button",
            {
              onClick: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? this.cancelFormSubmit : this.props.cancelHandlerCustomerLaneRequest,
              className: "simpleButton secondaryButton",
              id: "newOpproCancelButton"
            },
            "Cancel"
          )
        ),
        requestDrayageActionButtons.length > 0 && React__default.createElement(
          "div",
          { className: "general-centered " },
          requestDrayageActionButtons.map(function (v) {
            return React__default.createElement(
              "button",
              { className: "simpleButton " + v.className, id: "", type: "button", onClick: function onClick() {
                  return v.onClick(_this3.state);
                } },
              v.name
            );
          })
        )
      );
    }
  }]);
  return SmartAccordian;
}(React__default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getNextBidCloseDate = function (currentDate) {
    var tmp = new Date(currentDate);
    tmp.setDate(currentDate && currentDate.getDate() + 7);
    return tmp;
  };

  this.getNextRenewalDate = function (currentDate) {
    var tmp = new Date(currentDate);
    if (currentDate) {
      tmp.setDate(currentDate.getDate() + 90);
      return tmp;
    }
  };

  this.formatDateTime = function (currentDate) {
    var now = new Date();
    var tmp = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), currentDate.getHours() ? currentDate.getHours() : now.getHours(), currentDate.getMinutes() ? currentDate.getMinutes() : now.getMinutes(), currentDate.getSeconds() ? currentDate.getSeconds() : now.getSeconds());
    return tmp;
  };

  this.handelApplyFilterDpList = function () {
    var _state2 = _this4.state,
        dpListApi = _state2.dpListApi,
        filters = _state2.filters;

    var dpList = JSON.parse(JSON.stringify(dpListApi));
    if (filters.serviceArea.length > 0) {
      dpList = dpList.filter(function (v) {
        return filters.serviceArea.some(function (v2) {
          return v.serviceAreas.includes(v2.toUpperCase());
        });
      });
    }
    // add another if here when many filterBy come

    _this4.setState({ dpList: dpList });
  };

  this.filterOptionOnChangeHandler = function (_ref3) {
    var value = _ref3.value,
        applyFilter = _ref3.applyFilter;
    var _state3 = _this4.state,
        filters = _state3.filters,
        filterBy = _state3.filterBy;

    var filterByValue = lodash_1(filters, filterBy, []);
    var newFilter = void 0;
    if (!filterByValue.includes(value)) {
      newFilter = _extends({}, filters, defineProperty({}, filterBy, [].concat(toConsumableArray(filterByValue), [value])));
    } else {
      newFilter = _extends({}, filters);
    }

    _this4.setState({ filters: newFilter }, function () {
      applyFilter && _this4.handelApplyFilterDpList();
    });
  };

  this.removeElement = function (e, _ref4) {
    var index = _ref4.index,
        applyFilter = _ref4.applyFilter;
    var _state4 = _this4.state,
        filters = _state4.filters,
        filterBy = _state4.filterBy;

    var filtersOfDpList = lodash.get(filters, filterBy, []);
    filtersOfDpList.splice(index, 1);
    filters = _extends({}, filters, defineProperty({}, filterBy, filtersOfDpList));
    _this4.setState({ filters: filters }, function () {
      applyFilter && _this4.handelApplyFilterDpList();
    });
  };

  this.setValidationMessage = function (msg) {
    _this4.setState({ validationMessage: msg });
  };

  this.findFullCountry = function (country) {
    var countryList = _this4.state.countryList;

    for (var i = 0; i < countryList.length; i++) {
      if (countryList[i].value === country) return countryList[i].text;
    }
  };

  this.isFormValid = function () {
    var _state5 = _this4.state,
        opportunityStartDate = _state5.opportunityStartDate,
        opportunityEndDate = _state5.opportunityEndDate,
        opportunityExpiryDate = _state5.opportunityExpiryDate,
        selectedCustomerName = _state5.selectedCustomerName,
        allPorts = _state5.allPorts,
        dpList = _state5.dpList,
        ARWithoutAP = _state5.ARWithoutAP,
        searchCustomerCodeSelected = _state5.searchCustomerCodeSelected,
        searchCustomerNameSelected = _state5.searchCustomerNameSelected;


    if (!selectedCustomerName && !_this4.props.customerData && !(_this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES)) {
      _this4.setValidationMessage("You have not selected a Customer Name");
      return false;
    }

    if (!_this4.props.customerData && !searchCustomerNameSelected && _this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES) {
      _this4.setValidationMessage("You have not selected a Customer Name");
      return false;
    }

    if (!opportunityStartDate && !_this4.state.customerStartDate) {
      _this4.setValidationMessage("You have not enter the Opportunity Start Date");
      return false;
    }

    if (!opportunityEndDate && !_this4.state.customerCloseDate) {
      _this4.setValidationMessage("You have not enter the Opportunity End Date");
      return false;
    }

    if (!opportunityExpiryDate && !_this4.state.customerRenewalDate) {
      _this4.setValidationMessage("You have not enter the Opportunity Renewal Date");
      return false;
    }

    var arePortsSelected = true;
    var areDestinationsSelected = true;

    allPorts.forEach(function (port) {
      if (!port.sourceId) arePortsSelected = false;

      port.destinationAndBidingInfo.forEach(function (destination) {
        if (!destination.destinationId || destination.destinationId === "0") areDestinationsSelected = false;
      });
    });

    if (!arePortsSelected) {
      _this4.setValidationMessage("You have not added all Ports details");
      return false;
    }

    if (!areDestinationsSelected) {
      _this4.setValidationMessage("You have not added all Destinations details");
      return false;
    }
    if (_this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && !ARWithoutAP) {
      if (dpList.every(function (dp) {
        return !dp.checked;
      })) {
        _this4.setValidationMessage("You have not selected any Partners");
        return false;
      }
    }

    _this4.setValidationMessage("");
    return true;
  };

  this.cancelFormSubmit = function (e) {
    var dpListApi = _this4.state.dpListApi;

    if (e) e.preventDefault();
    _this4.setState({
      allPorts: [{
        sourceId: "",
        destinationAndBidingInfo: [{
          destinationId: "",
          bidingInfo: {
            proposedBid: "",
            approxVolume: "",
            hazmat: "NO",
            overweight: "NO",
            containerType: "40'HC",
            containerLoadType: "LCL",
            dropAndPullTransport: "NO",
            warehouseAppointment: "YES"
          }
        }]
      }],
      opportunityName: "",
      opportunityDescription: "",
      opportunityStartDate: "",
      opportunityEndDate: "",
      opportunityExpiryDate: "",
      selectedCustomerCode: "",
      selectedKxEmail: "",
      selectedCustomerName: "",
      selectedCustomerValue: '',
      searchCustomerCodeSelected: '',
      searchCustomerNameSelected: '',
      searchTerm: '',
      portNameQuery: [],
      delAddressQuery: [],
      filtersOfDpList: [],
      dpList: JSON.parse(JSON.stringify(dpListApi)),
      filters: {},
      ARWithoutAP: false
    });

    // Array.from(document.querySelectorAll(".partner_cb:checked")).forEach(
    //   (ele) => {
    //     ele.checked = false;
    //   }
    // );
    //uncheck partner checkboxes
  };

  this.submitForm = function (e) {
    e.preventDefault();
    var _state6 = _this4.state,
        opportunityName = _state6.opportunityName,
        opportunityStartDate = _state6.opportunityStartDate,
        opportunityEndDate = _state6.opportunityEndDate,
        opportunityExpiryDate = _state6.opportunityExpiryDate,
        selectedCustomerCode = _state6.selectedCustomerCode,
        selectedCustomerName = _state6.selectedCustomerName,
        allPorts = _state6.allPorts,
        opportunityDescription = _state6.opportunityDescription,
        hazmat = _state6.hazmat,
        overweight = _state6.overweight,
        dpList = _state6.dpList,
        opportunityType = _state6.opportunityType,
        operationType = _state6.operationType,
        ARWithoutAP = _state6.ARWithoutAP,
        searchCustomerNameSelected = _state6.searchCustomerNameSelected,
        searchCustomerCodeSelected = _state6.searchCustomerCodeSelected;
    var _props2 = _this4.props,
        countrySelected = _props2.countrySelected,
        motSelected = _props2.motSelected;


    if (!_this4.isFormValid()) {
      return false;
    }

    var selectedPartnerIds = dpList.reduce(function (accumulator, dp) {
      if (dp.checked) accumulator.push(dp.partnerId);
      return accumulator;
    }, []);

    var totalPrice = 0,
        totalVol = 0;

    console.log("allPorts >> ", allPorts);
    allPorts.forEach(function (port, portIndex) {
      port.destinationAndBidingInfo.forEach(function (dest) {
        totalPrice += dest.bidingInfo.proposedBid ? Number(dest.bidingInfo.proposedBid * dest.bidingInfo.approxVolume) : 0;
        totalVol += dest.bidingInfo.approxVolume ? Number(dest.bidingInfo.approxVolume) : 0;
      });

      //For Container drayage request there is only one port
      if (_this4.state.isCustomerContainerRequest) {

        port.containerBidInfo = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = Object.keys(_this4.props.contaninerDetails)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var containerNumber = _step3.value;

            var contaierDetail = _this4.props.contaninerDetails[containerNumber];
            port.containerBidInfo.push({
              "destinationId": contaierDetail.destinationId,
              "containerType": contaierDetail.containerType,
              "containerLoadType": contaierDetail.containerLoadType,
              "dropAndPullTransport": contaierDetail.dropAndPullTransport,
              "warehouseAppointment": contaierDetail.warehouseAppointment,
              "hazmat": contaierDetail.hazmat,
              "overweight": contaierDetail.overweight,
              "containerNumber": contaierDetail.containerNumber,
              "containerId": contaierDetail.containerId
            });
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    });

    var userType = lodash_1(_this4.props, "userModalData.userInitialData.userBasicInfo.typeOfUser");
    var ffCustCode = null;
    if (userType === "FREIGHT_FORWARDER") {
      ffCustCode = lodash_1(_this4.props, "userModalData.userInitialData.userInfo.customerCode");
    }
    var submitObj = {
      opportunityDetails: {
        opportunityName: opportunityName,
        arWithoutAP: ARWithoutAP ? 1 : 0,
        description: opportunityDescription,
        startDate: _this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? _this4.formatDateTime(opportunityStartDate) : _this4.formatDateTime(_this4.state.customerStartDate),
        endDate: _this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? _this4.formatDateTime(opportunityEndDate) : _this4.formatDateTime(_this4.state.customerCloseDate),
        opportunityExpiryDate: _this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? _this4.formatDateTime(opportunityExpiryDate) : _this4.formatDateTime(_this4.state.customerRenewalDate),
        grandTotalAmount: String(totalPrice),
        grandTotalVolume: String(totalVol),
        hazmat: hazmat,
        overweight: overweight,
        opportunityType: opportunityType,
        opportunityCountry: !lodash.isEmpty(countrySelected) ? countrySelected[0] : "US",
        modeOfTransport: !lodash.isEmpty(motSelected) ? motSelected[0] : "MOT_OCEAN"
      },
      operationType: operationType,
      customerDetails: {
        customerType: userType,
        customerCode: _this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? searchCustomerCodeSelected || _this4.props.customerData.customerCode : selectedCustomerCode || _this4.props.customerData.customerCode,
        customerName: _this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? searchCustomerNameSelected : selectedCustomerName,
        ffCustomerCode: ffCustCode
      },
      sourceList: allPorts,
      drayagePartners: selectedPartnerIds,
      isMock: "false"
    };

    if (_this4.props.prefillNewTabData) {
      var opportunityDetails = _this4.props.prefillNewTabData.opportunityDetails;

      var opportunityId = opportunityDetails.opportunityId;
      submitObj.opportunityDetails['opportunityId'] = opportunityId;
      if (_this4.state.publishOpp) {
        submitObj.opportunityDetails.eta = _this4.state.eta;
      }
    }

    // console.log('laneOpportunityData:', submitObj)
    createOppurtunity(submitObj).then(function (res) {

      var isException = lodash_1(res, 'data.eventMessage.code', false);
      if (isException) {
        var exceptionMsg = lodash_1(res, 'data.eventMessage.msg', 'Exception occured');
        _this4.setValidationMessage(exceptionMsg);
        return;
      }
      var message = res.data.eventMessage.results.map(function (data, i) {
        return React__default.createElement(
          "text",
          null,
          " ",
          "\u2022 " + data.message,
          " ",
          React__default.createElement("br", null),
          " "
        );
      });

      var opportunityId = lodash_1(res, 'data.eventMessage.opportunityId', '');
      if (!opportunityId) {
        _this4.setValidationMessage(message);
        return;
      }
      _this4.setValidationMessage(message);
      var isOpprotunityCreated = true; // for now backend not providing any key that denote success so we assuming promise then as a success after checking exception object and opportunityId
      _this4.setState({ isOpprotunityCreated: isOpprotunityCreated });

      if (_this4.props.prefillNewTabData) {
        _this4.props.setRenewdata(null, true);
      }
    });
  };

  this.createAddressObj = function (data) {
    var obj = {};
    obj.sourceId = data.sourceId;
    obj.destinationAndBidingInfo = data.destinations.map(function (destination) {
      var dest = {};
      dest.destinationId = destination.destinationId;
      dest.laneId = destination.laneId;
      dest.bidingInfo = {
        proposedBid: destination.proposedBid,
        approxVolume: destination.approxVolume,
        hazmat: destination.hazmat,
        overweight: destination.overweight,
        containerType: destination.containerType,
        containerLoadType: destination.containerLoadType,
        dropAndPullTransport: destination.dropAndPullTransport,
        warehouseAppointment: destination.warehouseAppointment
      };
      return dest;
    });
    return obj;
  };

  this.toggleAccordian = function (index) {
    var accordianState = _this4.state.accordianState;

    accordianState[index] = !accordianState[index];
    _this4.setState({ accordianState: accordianState });
  };

  this.deleteDestination = function (portIndex, destinationIndex) {
    var allPorts = _this4.state.allPorts;

    allPorts[portIndex].destinationAndBidingInfo.splice(destinationIndex, 1);
    _this4.setState({ allPorts: allPorts });
  };

  this.deletePort = function (portIndex) {
    var allPorts = _this4.state.allPorts;

    allPorts.splice(portIndex, 1);
    _this4.setState({ allPorts: allPorts });
  };

  this.makeHeader = function (heading, index) {
    var accordianState = _this4.state.accordianState;

    return React__default.createElement(
      "div",
      {
        className: "sm_accordian_header",
        onClick: function onClick() {
          _this4.toggleAccordian(index);
        }
      },
      React__default.createElement("img", {
        src: "../images/files/sideArrow.svg",
        className: accordianState[index] ? "arrow_icon arrow_icon_rotate" : "arrow_icon",
        alt: ""
      }),
      React__default.createElement(
        "h1",
        { className: "text_section" },
        heading
      )
    );
  };

  this.handleInputChange = function (e) {
    var target = e.target;

    var value = target.type === "checkbox" ? target.checked : target.value;
    var name = target.name;

    _this4.setState(defineProperty({}, name, value));
  };

  this.handleCustChange = function (e, _ref5) {
    var value = _ref5.value;

    console.log("handleCustChange >>> ", value);
    _this4.setState({

      selectedCustomerCode: value.split(/:::/)[0],
      selectedCustomerName: value.split(/:::/)[1],
      selectedKxEmail: value.split(/:::/)[2],
      selectedCustomerValue: value
    });
  };

  this.fetchsourceList = function (e, data, isSearchingDestination) {
    var countrySelected = _this4.props.countrySelected;

    var country = "";
    if (lodash.isArray(countrySelected) && !lodash.isEmpty(countrySelected)) country = countrySelected.join(',');

    var identifier = _this4.state.selectedKxEmail + "," + data.value;

    if (data.value.length >= 2) {

      if (isSearchingDestination) {
        // if (this.addressList[identifier]) return;
        _this4.setState({ loadingAddressList: true });
      } else {
        // if (this.sourceList[data.value]) return;
        _this4.setState({ loadingsourceList: true });
      }

      getPortsList(data.value, country).then(function (res) {
        _this4.setState({ loadingsourceList: false });
        _this4.sourceList[data.value] = [];

        if (isSearchingDestination) {
          _this4.setState({ loadingAddressList: false });
          _this4.addressList[identifier] = [];
          res.data.eventMessage.ports && res.data.eventMessage.ports.list && res.data.eventMessage.ports.list.forEach(function (port, index) {
            _this4.addressList[identifier][index] = {
              title: port.payload,
              value: port.portKxId
              // key: Math.floor((Math.random() * 100000) + 1),
            };
          });
          _this4.setState({ delAddressList: _this4.addressList });
        } else {
          res.data.eventMessage.ports && res.data.eventMessage.ports.list && res.data.eventMessage.ports.list.forEach(function (port, index) {
            var country = lodash.isArray(_this4.props.countrySelected) && !lodash.isEmpty(_this4.props.countrySelected) ? _this4.props.countrySelected[0] : "US";
            if (_this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && country === "CA") ;
            _this4.sourceList[data.value][index] = {
              title: port.payload,
              //   port.portName +
              //   ", " +
              //   port.portCountry +
              //   " (" +
              //   port.portKxId +
              //   ") - " +
              //   port[`${portCode}`],
              value: port.portKxId,
              key: Math.floor(Math.random() * 100000 + 1)
            };
          });
          _this4.setState({ portNameList: _this4.sourceList });
        }
      }).catch(function () {
        _this4.setState({ loadingsourceList: false });
      });
    }

    // this.setState({portNameQuery: data.value})
  };

  this.getFullAddress = function (address, addressName) {
    var streetNumber = lodash.find(address, function (item) {
      return item.type === "STREET_NUMBER";
    });

    streetNumber = streetNumber ? " - " + streetNumber.information : "";

    var streetName = lodash.find(address, function (item) {
      return item.type === "STREET_NAME";
    });

    streetName = streetName ? streetName.information + ", " : "";

    var postalCode = lodash.find(address, function (item) {
      return item.type === "POSTAL_CODE";
    });

    postalCode = postalCode ? postalCode.information + ", " : "";

    var city = lodash.find(address, function (item) {
      return item.type === "CITY";
    });

    city = city ? city.information : "";

    var countrySubEntity = lodash.find(address, function (item) {
      return item.type === "COUNTRY_SUB_ENTITY";
    });

    countrySubEntity = countrySubEntity ? countrySubEntity.information + ", " : "";

    var country = lodash.find(address, function (item) {
      return item.type === "COUNTRY";
    });

    country = country ? country.information : "";

    // return `${addressName} - ${streetNumber} ${streetName}, ${city} ${postalCode}, ${countrySubEntity}, ${country}`;
    return "" + (addressName + streetNumber + streetName + city + postalCode + countrySubEntity + country);
  };

  this.fetchDelAddressList = function (e, data, isSearchingSource) {
    var selectedKxEmail = _this4.state.selectedKxEmail;

    var identifier = selectedKxEmail + "," + data.value;

    console.log("onSearchChange >>> fetchDelAddressList request", identifier, _this4.addressList[identifier], _this4.state);

    if (isSearchingSource) {
      // if (this.sourceList[data.value]) return;
      _this4.setState({ loadingsourceList: true });
    } else {
      // if (this.addressList[identifier]) return;
      _this4.setState({ loadingAddressList: true });
    }

    getAddressList(identifier).then(function (res) {
      _this4.setState({ loadingAddressList: false });
      _this4.addressList[identifier] = [];

      console.log("onSearchChange >>> fetchDelAddressList response", res.data.eventMessage);

      if (isSearchingSource) {
        if (_this4.sourceList[data.value]) return;
        _this4.setState({ loadingsourceList: false });
        _this4.sourceList[data.value] = [];
        res.data.eventMessage.customerAddressInfo && res.data.eventMessage.customerAddressInfo.forEach(function (address, index) {
          _this4.sourceList[data.value][index] = {
            title: _this4.getFullAddress(address.address.values, address.addressName.value),
            value: address.addressId.value,
            key: Math.floor(Math.random() * 100000 + 1)
          };
        });
        console.log("onSearchChange >>> fetchDelAddressList:source", isSearchingSource);
        _this4.setState({ portNameList: _this4.sourceList });
      } else {
        res.data.eventMessage.customerAddressInfo && res.data.eventMessage.customerAddressInfo.forEach(function (address, index) {
          _this4.addressList[identifier][index] = {
            title: _this4.getFullAddress(address.address.values, address.addressName.value),
            value: address.addressId.value
            // key: Math.floor((Math.random() * 100000) + 1)
          };
        });
        _this4.setState({ delAddressList: _this4.addressList });
      }
    }).catch(function () {
      _this4.setState({ loadingAddressList: false });
    });
  };

  this.fetchDPList = function () {
    var countrySelected = _this4.props.countrySelected;

    var filters = [];

    if (lodash.isArray(countrySelected) && !lodash.isEmpty(countrySelected)) {
      filters.push({
        key: "DRAYAGE_COUNTRY",
        values: countrySelected
      });
    }
    getDPList(filters).then(function (res) {
      var dpList = [];

      res.data.eventMessage.drayagePartners && res.data.eventMessage.drayagePartners.forEach(function (dp, index) {
        var _dp$companyProfile$en = dp.companyProfile.entityAddress,
            addressLine1 = _dp$companyProfile$en.addressLine1,
            addressLine2 = _dp$companyProfile$en.addressLine2,
            city = _dp$companyProfile$en.city,
            state = _dp$companyProfile$en.state,
            zip = _dp$companyProfile$en.zip,
            country = _dp$companyProfile$en.country;

        dpList[index] = {
          name: dp.companyProfile.name,
          territory: dp.serviceAreas && dp.serviceAreas[0].regions.join(", "), //dp.serviceAreas[0].country
          serviceAreas: lodash.get(dp, 'serviceAreas[0].regions', []),
          address: addressLine1 + ", " + addressLine2 + ", " + city + ", " + state + " " + zip + (country ? "," + country : ""),
          partnerId: dp.companyProfile.partnerId,
          checked: false
        };
      });
      _this4.setState({ dpList: dpList, dpListApi: JSON.parse(JSON.stringify(dpList)) });
    });
  };

  this.updateArrayState = function (stateVariable, portIndex, destinationIndex, newVal, isDisapear) {
    // console.log("updateArrayState >>> ", stateVariable, portIndex, destinationIndex, newVal)

    // debugger
    var stateArray = _this4.state[stateVariable];
    stateArray[portIndex + ":" + destinationIndex] = newVal;
    _this4.setState({ stateVariable: stateArray }, function () {
      if (isDisapear) {
        setTimeout(function () {
          stateArray[portIndex + ":" + destinationIndex] = false;
          _this4.setState({ stateVariable: stateArray });
        }, 5000);
      }
    });
  };

  this.addPort = function () {
    var allPorts = _this4.state.allPorts;


    allPorts[allPorts.length] = {
      sourceId: "",
      destinationAndBidingInfo: [{
        destinationId: "",
        bidingInfo: {
          proposedBid: "",
          approxVolume: "",
          hazmat: "NO",
          overweight: "NO",
          containerType: "40'HC",
          containerLoadType: "LCL",
          dropAndPullTransport: "NO",
          warehouseAppointment: "YES"
        }
      }]
    };

    _this4.setState({ allPorts: allPorts });
  };

  this.addDestinationForm = function (portIndex) {
    var allPorts = _this4.state.allPorts;
    var destinationAndBidingInfo = allPorts[portIndex].destinationAndBidingInfo;


    destinationAndBidingInfo[destinationAndBidingInfo.length] = {
      destinationId: "",
      bidingInfo: {
        proposedBid: "",
        approxVolume: "",
        hazmat: "NO",
        overweight: "NO",
        containerType: "40'HC",
        containerLoadType: "LCL",
        dropAndPullTransport: "NO",
        warehouseAppointment: "YES"
      }
    };

    _this4.setState({ allPorts: allPorts });
  };

  this.addDestination = function (e, portIndex, destinationIndex) {
    // e.preventDefault();
    var _state7 = _this4.state,
        selectedKxEmail = _state7.selectedKxEmail,
        addAddressName = _state7.addAddressName,
        addAddressLine1 = _state7.addAddressLine1,
        addAddressLine2 = _state7.addAddressLine2,
        addCity = _state7.addCity,
        addState = _state7.addState,
        addZip = _state7.addZip,
        addCountry = _state7.addCountry,
        addReferenceCode = _state7.addReferenceCode;

    // console.log("addDestination >>> ", this.state)

    var errorField = void 0;
    var addressLine1 = lodash.get(addAddressLine1, portIndex + ":" + destinationIndex, '').replace(/\s+/g, ' ').trim().split(' ');
    var streetNumber = addressLine1[0];
    addressLine1.shift(); // remove street number
    var streetName = addressLine1.join(" ").toString();

    if (!addAddressLine1[portIndex + ":" + destinationIndex]) {
      errorField = "Address Line 1";
    } else if (!streetNumber) {
      errorField = "In Address Line 1 Street Number";
    } else if (!streetName) {
      errorField = "In Address Line 1 Street Name";
    } else if (!addCity[portIndex + ":" + destinationIndex]) {
      errorField = "City";
    } else if (!addCountry[portIndex + ":" + destinationIndex]) {
      errorField = "Country";
    } else if ((addCountry[portIndex + ":" + destinationIndex] === "CA" || addCountry[portIndex + ":" + destinationIndex] === "US") && !addState[portIndex + ":" + destinationIndex]) {
      errorField = "State";
    } else if (!addZip[portIndex + ":" + destinationIndex]) {
      errorField = "Zip Code";
    } else if (!addAddressName[portIndex + ":" + destinationIndex]) {
      errorField = "Address Name";
    } else if (!addReferenceCode[portIndex + ":" + destinationIndex]) {
      errorField = "Reference Code";
    } else if (!selectedKxEmail) {
      errorField = "Customer Name";
    }

    if (errorField) {
      _this4.updateArrayState("customAddressMsg", portIndex, destinationIndex, errorField + " missing. Address not added.", true);
      return;
    }

    var obj = {
      customer: {
        value: selectedKxEmail
      },
      address: {
        values: [{
          type: "STREET_NUMBER",
          information: streetNumber
        }, {
          type: "STREET_NAME",
          information: streetName
        }, {
          type: "UNSTRUCTURED_STREET_ADDRESS",
          information: lodash_1(addAddressLine2, portIndex + ":" + destinationIndex, "").trim()
        }, {
          type: "CITY",
          information: lodash_1(addCity, portIndex + ":" + destinationIndex, "").trim()
        }, {
          type: "COUNTRY",
          information: lodash_1(addCountry, portIndex + ":" + destinationIndex, "").trim()
        }, {
          type: "COUNTRY_CODE",
          information: lodash_1(addCountry, portIndex + ":" + destinationIndex, "").trim()
        }, {
          type: "COUNTRY_SUB_ENTITY",
          information: lodash_1(addState, portIndex + ":" + destinationIndex, "").trim()
        }, {
          type: "POSTAL_CODE",
          information: lodash_1(addZip, portIndex + ":" + destinationIndex, "").trim()
        }]
      },
      addressName: {
        value: lodash_1(addAddressName, portIndex + ":" + destinationIndex, "").trim()
      },
      refCode: lodash_1(addReferenceCode, portIndex + ":" + destinationIndex, "").trim()
    };

    addCustomerDestination(obj).then(function (res) {
      console.log("RES of address", res.data.eventMessage.code, res.data.eventMessage.msg);
      if (res.data.eventMessage.code === 400) {
        if (res.data.eventMessage.msg === "Error: Delivery code already exists") {
          _this4.updateArrayState("customAddressMsg", portIndex, destinationIndex, "Reference code already exists", true);
        } else {
          _this4.updateArrayState("customAddressMsg", portIndex, destinationIndex, "Some error occured", true);
        }
      } else {
        setTimeout(function () {
          _this4.updateArrayState("giveCustomAddress", portIndex, destinationIndex, false);
        }, 1500);
        _this4.updateArrayState("customAddressSuccessMsg", portIndex, destinationIndex, "Address added successfully", true);
      }
    });
  };

  this.checkLane = function (portIndex, destinationIndex) {
    var _state8 = _this4.state,
        allPorts = _state8.allPorts,
        selectedCustomerCode = _state8.selectedCustomerCode,
        searchCustomerCodeSelected = _state8.searchCustomerCodeSelected;


    var obj = {
      sourceId: allPorts[portIndex].sourceId,
      destinationId: allPorts[portIndex].destinationAndBidingInfo[destinationIndex].destinationId,
      customerCode: _this4.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? searchCustomerCodeSelected : selectedCustomerCode
    };

    checkLaneExistence(obj).then(function (res) {
      if (res.data.eventMessage.status === "DRAYAGE_LANE_ACTIVE") {
        _this4.updateArrayState("showLaneError", portIndex, destinationIndex, "active", true);
        _this4.updateArrayState("delAddressQuery", portIndex, destinationIndex, "");
        _this4.updateArrayState("selectedDelAddress", portIndex, destinationIndex, "");
      } else if (res.data.eventMessage.status === "DRAYAGE_LANE_EXISTS") {
        _this4.updateArrayState("showLaneError", portIndex, destinationIndex, "created", true);
        _this4.updateArrayState("delAddressQuery", portIndex, destinationIndex, "");
        _this4.updateArrayState("selectedDelAddress", portIndex, destinationIndex, "");
      } else _this4.updateArrayState("showLaneError", portIndex, destinationIndex, "");
    });
  };

  this.updatePortsObj = function (path, portIndex, e) {
    var allPorts = _this4.state.allPorts;

    eval("allPorts[" + portIndex + "]." + path + "=" + ("\"" + e + "\""));
    _this4.setState({ allPorts: allPorts });
  };

  this.addPartnerId = function (e) {
    var dpList = [].concat(toConsumableArray(_this4.state.dpList));
    var _e$target = e.target,
        value = _e$target.value,
        checked = _e$target.checked;


    if (value === "all") {
      if (checked) dpList.forEach(function (dp) {
        return dp.checked = true;
      });else dpList.forEach(function (dp) {
        return dp.checked = false;
      });
    } else {
      var index = dpList.findIndex(function (dp) {
        return dp.partnerId === value;
      });
      dpList[index].checked = checked;
    }

    _this4.setState({ dpList: dpList });
  };

  this.searchCustomerList = function (keyword) {
    var countrySelected = _this4.props.countrySelected;

    var country = "";
    if (lodash.isArray(countrySelected) && !lodash.isEmpty(countrySelected)) {
      country = countrySelected.join(",");
    }
    var payload = {
      keyword: keyword,
      filter: country
    };

    getExistingCustomerList(payload).then(function (res) {
      var customerResponse = lodash_1(res, "data.eventMessage.customers", []);

      if (lodash.isArray(customerResponse) && !lodash.isEmpty(customerResponse)) {
        var customerSearchResults = customerResponse.map(function (result, index) {
          var companyName = country == "CA" ? lodash_1(result, "companyNameCanada", "") : lodash_1(result, "companyNameUS", "");
          companyName = companyName && companyName.trim();
          var customerCode = lodash_1(result, "customerCode", "") && lodash_1(result, "customerCode", "").trim();
          var customerEmail = lodash_1(result, "kxEmail", "") && lodash_1(result, "kxEmail", "").trim();
          return {
            title: companyName,
            description: customerCode,
            value: customerEmail,
            disabled: customerEmail ? false : true,
            id: index
          };
        });

        _this4.setState({
          searchResults: customerSearchResults,
          isLoading: false
        });
      }
    }).catch(function (error) {
      console.error('Error fetching search results:', error);
      _this4.setState({ isLoading: false });
    }).finally(function () {
      _this4.setState({ isLoading: false });
    });
  };

  this.handleSearchChange = function (event, _ref6) {
    var value = _ref6.value;

    _this4.setState({ searchTerm: value });

    if (_this4.debounceSearchCustomerApi) {
      _this4.debounceSearchCustomerApi.cancel();
    }

    if (value.trim().length >= 3) {
      _this4.debounceSearchCustomerApi(value);
    } else {
      _this4.setState({ searchResults: [], isLoading: false });
    }
  };

  this.handleSearchResult = function (event, _ref7) {
    var result = _ref7.result;
    var disabled = result.disabled;


    var selectedCode = lodash_1(result, "description", "");
    var selectedName = lodash_1(result, "title", "");
    var selectedKxEmail = lodash_1(result, "value", "");

    if (disabled) {
      return;
    }

    _this4.setState({ searchCustomerNameSelected: selectedName, searchCustomerCodeSelected: selectedCode, selectedKxEmail: selectedKxEmail, searchTerm: selectedName });
  };

  this.handleRenderResult = function (_ref8) {
    var title = _ref8.title,
        id = _ref8.id,
        description = _ref8.description,
        disabled = _ref8.disabled;

    var resultStyle = {
      cursor: disabled ? 'not-allowed' : 'pointer'
    };

    var key = id + "-" + (disabled ? 'disabled' : 'enabled');

    return React__default.createElement(
      "div",
      { key: key, style: resultStyle },
      disabled ? React__default.createElement(Popup, { content: "KxEmail not found.",
        trigger: React__default.createElement(
          "div",
          { style: { display: "flex", justifyContent: "space-between", gap: "10px" } },
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "div",
              { style: { fontWeight: "500" } },
              title
            ),
            React__default.createElement(
              "div",
              { style: { fontWeight: "200", color: "grey" } },
              description
            )
          ),
          React__default.createElement(
            "div",
            { style: { color: "red" } },
            "Disabled"
          )
        )
      }) : React__default.createElement(
        "div",
        null,
        React__default.createElement(
          "div",
          { style: { fontWeight: "500" } },
          title
        ),
        React__default.createElement(
          "div",
          { style: { fontWeight: "200", color: "grey" } },
          description
        )
      )
    );
  };

  this.resetAllFields = function () {
    _this4.setState({
      searchTerm: "",
      searchResults: [],
      ARWithoutAP: false,
      opportunityName: "",
      opportunityDescription: "",
      portNameQuery: [],
      portNameList: { "": [] },
      delAddressQuery: [],
      delAddressList: { "": [] }
    });
  };
};

var css_248z$6 = ".accordian_item_heading .PodInland {\n  background-color: #008b8f;\n  border-radius: 8px;\n  padding: 5px;\n  color: #fff;\n  font-size: 1rem; }\n\n.accordian_item_heading .heading_label {\n  margin-right: 5px; }\n\n.heading_label {\n  color: #979797;\n  font-size: 13px;\n  font-weight: bold;\n  letter-spacing: 0.7px;\n  line-height: 16px;\n  text-align: center;\n  display: inline; }\n\n.heading_value {\n  color: #2f4a97;\n  font-size: 13px;\n  font-weight: bold;\n  letter-spacing: 0.7px;\n  line-height: 16px;\n  text-align: center;\n  display: inline; }\n\n.terminalWithLink:hover {\n  background-color: #2F4A97;\n  color: #fff; }\n\n.flexUniformDisplay {\n  display: flex;\n  justify-content: space-between; }\n  .flexUniformDisplay.blockHeaderMargin {\n    margin-bottom: 9px; }\n";
styleInject(css_248z$6);

var ViewMorePopup = function (_Component) {
    inherits(ViewMorePopup, _Component);

    function ViewMorePopup() {
        classCallCheck(this, ViewMorePopup);
        return possibleConstructorReturn(this, (ViewMorePopup.__proto__ || Object.getPrototypeOf(ViewMorePopup)).apply(this, arguments));
    }

    createClass(ViewMorePopup, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                content = _props.content,
                triggerColor = _props.triggerColor,
                triggerContent = _props.triggerContent;

            return React__default.createElement(Popup, {
                content: content,
                trigger: React__default.createElement(
                    "b",
                    null,
                    React__default.createElement(
                        "a",
                        { style: { color: triggerColor } },
                        triggerContent
                    )
                )
            });
        }
    }]);
    return ViewMorePopup;
}(Component);

var BlockHeader = function (_React$Component) {
    inherits(BlockHeader, _React$Component);

    function BlockHeader(props) {
        classCallCheck(this, BlockHeader);

        var _this = possibleConstructorReturn(this, (BlockHeader.__proto__ || Object.getPrototypeOf(BlockHeader)).call(this, props));

        _this.state = {};
        return _this;
    }

    createClass(BlockHeader, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                data = _props.data,
                terminalLink = _props.terminalLink,
                isPodInland = _props.isPodInland;


            return React__default.createElement(
                'div',
                { className: 'flexUniformDisplay blockHeaderMargin' },
                data.map(function (item) {
                    return item.value && React__default.createElement(
                        'div',
                        { className: 'accordian_item_heading' },
                        item.label === "PODINLAND" && isPodInland && React__default.createElement(
                            'span',
                            { className: 'PodInland' },
                            'POD is Inland'
                        ),
                        item.label !== "PODINLAND" && React__default.createElement(
                            'div',
                            { className: 'heading_label' },
                            item.label,
                            ':'
                        ),
                        item.label === "TERMINAL" && terminalLink !== undefined ? React__default.createElement(
                            'div',
                            {
                                className: 'heading_value terminalWithLink',
                                onClick: function onClick() {
                                    return window.open('' + terminalLink, '_blank');
                                }
                            },
                            item.value
                        ) : item.label === "DELIVERY ADDRESS" ? React__default.createElement(
                            'div',
                            { className: 'heading_value' },
                            item.value,
                            item.valueLong && React__default.createElement(ViewMorePopup, { content: item.valueLong, triggerColor: '#0A8B8F', triggerContent: '...' })
                        ) : React__default.createElement(
                            'div',
                            { className: 'heading_value' },
                            item.value
                        )
                    );
                })
            );
        }
    }]);
    return BlockHeader;
}(React__default.Component);

var css_248z$7 = "/* filters */\n.ui.dropdown.dropdown .menu > .input.drayage_filter {\n  display: none; }\n\n.ui.dropdown .menu > .item:hover {\n  z-index: 1 !important; }\n\n.dropdown_filter > .Divider {\n  width: 235px !important; }\n\n.ui.dropdown .menu > .divider {\n  clear: left; }\n\n.close.search-close-icon {\n  width: 33px;\n  position: absolute;\n  height: 0px !important;\n  z-index: 1;\n  top: 40px !important;\n  right: 7px !important;\n  cursor: pointer; }\n\n.drayage_filter_dropdown input {\n  position: static !important;\n  font-size: 0.9rem !important; }\n\n.small_button {\n  float: right;\n  min-width: 0 !important; }\n  .small_button input {\n    background-color: #008b8f !important;\n    color: white !important;\n    text-transform: uppercase !important;\n    border: 1px solid #008b8f !important;\n    padding: 2px 10px !important;\n    width: 75px !important;\n    cursor: pointer; }\n\n.drayage_filter_dropdown {\n  height: 23px !important;\n  border: 1px solid #008B8F !important;\n  border-radius: 2px !important;\n  background-color: #fff !important;\n  width: 72px  !important; }\n  .drayage_filter_dropdown div.text:first-child {\n    color: #008B8F;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 16px;\n    margin-left: 5px; }\n  .drayage_filter_dropdown .dropdown.icon {\n    margin-left: 7px !important; }\n  .drayage_filter_dropdown .text {\n    height: 19px;\n    color: #040404;\n    font-size: 16px;\n    letter-spacing: 0;\n    line-height: 19px; }\n  .drayage_filter_dropdown input[type=\"text\"] {\n    position: static; }\n  .drayage_filter_dropdown .set_filter_CustomDates {\n    display: flex;\n    align-items: center;\n    font-size: 0.9rem !important; }\n  .drayage_filter_dropdown .set_filter_CustomDates a {\n    margin-left: 5px !important; }\n  .drayage_filter_dropdown .set_filter_CustomDates .filterDatePicker {\n    width: 100px !important;\n    border: 1px solid #cccccc85 !important;\n    font-family: \"Open Sans\", sans-serif !important;\n    box-shadow: none !important; }\n\n.ui.dropdown.drayage_filter_dropdown .menu > .item {\n  width: 235px !important;\n  padding: 6px 10px !important; }\n\n.drayage_filter {\n  margin: 4px 10px !important; }\n\n.drayage_filter_dropdown input[type=\"radio\"] {\n  float: left;\n  margin-top: 2px;\n  margin-right: 2px;\n  margin-left: 8px; }\n\n.drayage_filter_dropdown label {\n  color: black !important;\n  text-transform: none !important;\n  font-weight: normal !important;\n  float: left; }\n\n.checkbox_label input {\n  margin-left: 5px;\n  margin-right: 5px; }\n\n.drayage_filter_sortByClass {\n  display: flex;\n  margin-top: 6px;\n  width: 350px !important; }\n  .drayage_filter_sortByClass .sortByLabel {\n    width: 60px;\n    margin: auto;\n    color: black !important; }\n  .drayage_filter_sortByClass .sortByDropdown.ui.fluid.dropdown {\n    width: 250px !important; }\n  .drayage_filter_sortByClass .sortByReset {\n    margin: auto; }\n    .drayage_filter_sortByClass .sortByReset .resetLink {\n      float: right !important;\n      margin-top: 5px !important;\n      margin-left: -35px !important;\n      font-size: 15px !important; }\n\n.Country_filter {\n  box-shadow: 0 2px 4px 0 rgba(34, 36, 38, 0.12), 0 2px 10px 0 rgba(34, 36, 38, 0.15) !important;\n  border: 1px solid rgba(34, 36, 38, 0.15) !important;\n  position: absolute !important;\n  background: #fff !important;\n  left: 0px !important;\n  top: 40px !important;\n  width: 150px !important;\n  z-index: 99 !important;\n  border-radius: 5px !important; }\n  .Country_filter .country-item-list {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    padding: 5px;\n    line-height: 1; }\n    .Country_filter .country-item-list input {\n      cursor: pointer; }\n    .Country_filter .country-item-list label {\n      margin-left: 15px;\n      color: #9b9b9b !important;\n      font-size: 15px !important;\n      font-weight: 600 !important;\n      margin: 5px !important; }\n\n.motFilter {\n  box-shadow: 0 2px 4px 0 rgba(34, 36, 38, 0.12), 0 2px 10px 0 rgba(34, 36, 38, 0.15) !important;\n  border: 1px solid rgba(34, 36, 38, 0.15) !important;\n  position: absolute !important;\n  background: #fff !important;\n  width: 150px !important;\n  z-index: 99 !important;\n  border-radius: 5px !important;\n  padding: 6px; }\n\n.resetLink2 {\n  margin-top: 20px !important;\n  float: right !important;\n  margin-left: 5px !important; }\n";
styleInject(css_248z$7);

var searchByParameters = {
    Container: "SEARCH_FILTER_ENTITY_IDS",
    Shipment: "SEARCH_FILTER_ENTITY_SHIPMENT_IDS",
    MBOL: "SEARCH_FILTER_ENTITY_BOL",
    Customer: "SEARCH_FILTER_ENTITY_CUSTOMER_NAME",
    Vessel: "SEARCH_FILTER_ENTITY_CARRIER_NAME",
    Terminal: "SEARCH_FILTER_ENTITY_TERMINAL_ARRIVAL_NOTICE",
    Dcarrier: "SEARCH_FILTER_ENTITY_DRAYAGE_CARRIER",
    etaBefore: "SEARCH_FILTER_ENTITY_ETA_BEFORE",
    etaAfter: "SEARCH_FILTER_ENTITY_ETA_AFTER",
    GOTBefore: "SEARCH_FILTER_ENTITY_PDT_BEFORE",
    GOTAfter: "SEARCH_FILTER_ENTITY_PDT_AFTER",
    countries: "SEARCH_FILTER_ENTITY_COUNTRY_OF_DESTINATION",
    cityOFDeliveryAddress: "SEARCH_FILTER_CITY_OF_DELIVERY",
    PO: "SEARCH_FILTER_ENTITY_PO_NUMBER",
    mot: "SEARCH_FILTER_ENTITY_MODE_OF_TRANSPORT"
};

var countryFilterParams = [{ text: 'USA', value: 'US', isChecked: false }, { text: 'UK', value: 'GB', isChecked: false }, { text: 'Canada', value: 'CA', isChecked: false }, { text: 'Spain', value: 'ES', isChecked: false }, { text: 'Netherland', value: 'NL', isChecked: false }];

var defaultCountry = { key: 'SEARCH_FILTER_ENTITY_COUNTRY_OF_DESTINATION', value: ['US', 'CA'] };

var convertToUTC = function convertToUTC(date) {
    if (date) {
        return moment$1(date).utc(true).valueOf().toString();
    }
};

var defaultDates = {
    "etdbefore": convertToUTC(moment$1(new Date().getTime() + 14 * 24 * 3600 * 1000).format("YYYY-MM-DD")),
    "etaafter": convertToUTC(moment$1(new Date().getTime() - 14 * 24 * 3600 * 1000).format("YYYY-MM-DD"))
};

var options = [{ key: 'eta descending', text: 'ETA Descending', value: 'ETA_DESCENDING' }, { key: 'lfd', text: 'LFD', value: 'DEMURRAGE' }, { key: 'lrd', text: 'LRD', value: 'PER_DIEM' }];

var optionForHistoryMode = [{ key: 'recentDone', text: 'Recent Done', value: 'RECENT DONE' }];

var motFilterParams = [{ text: 'OCEAN', value: 'MOT_OCEAN', isChecked: false }, { text: 'AIR', value: 'MOT_AIR', isChecked: false }];

var defaultMOT = { key: 'SEARCH_FILTER_ENTITY_MODE_OF_TRANSPORT', value: ['MOT_OCEAN'] };

var FilterDropdown = function (_React$Component) {
    inherits(FilterDropdown, _React$Component);

    function FilterDropdown(props) {
        var _this2 = this;

        classCallCheck(this, FilterDropdown);

        var _this = possibleConstructorReturn(this, (FilterDropdown.__proto__ || Object.getPrototypeOf(FilterDropdown)).call(this, props));

        _this.componentDidMount = function () {
            var filterValues = _this.state.filterValues;

            var shipmentId = filterValues.shipmentId ? filterValues.shipmentId : "";
            var multiMBOL = filterValues.MBOL ? filterValues.MBOL : "";
            _this.setState({ shipmentId: shipmentId, multiMBOL: multiMBOL });
            setTimeout(function () {
                _this.setState({
                    countryValues: [{ text: 'USA', value: 'US', isChecked: true }, { text: 'UK', value: 'GB', isChecked: false }, { text: 'Canada', value: 'CA', isChecked: true }, { text: 'Spain', value: 'ES', isChecked: false }, { text: 'Netherland', value: 'NL', isChecked: false }],
                    motValues: [{ text: 'OCEAN', value: 'MOT_OCEAN', isChecked: true }, { text: 'AIR', value: 'MOT_AIR', isChecked: false }]
                });
            }, 1000);
        };

        _this.componentDidUpdate = function () {
            if (_this.props.resetClicked) {
                _this.setState({
                    filterValues: _this.props.type === "VESSEL_ON_WATER" ? _extends({}, defaultDates, _this.props.filterValues) : {},
                    currentETD: new Date().getTime() + 14 * 24 * 3600 * 1000,
                    currentETA: new Date().getTime() - 14 * 24 * 3600 * 1000,
                    shipmentId: '',
                    multiMBOL: ''
                });
                _this.props.setResetClicked(false);
            }

            if (_this.props.resetMultiFilters2) {
                _this.setState({
                    multiFilterValues: {}, Container: '', cityOFDeliveryAddress: '', Shipment: '', MBOL: '', Customer: '', Vessel: '', PO: '',
                    Terminal: '', Dcarrier: '', ETAbefore: '', ETAafter: '', filterValues: {}, countryValues: [].concat(countryFilterParams), checked: new Map(), GOTAfter: '', GOTBefore: '', motValues: [].concat(motFilterParams)
                });
                _this.props.setResetClicked2(false);
            }
        };

        _this.handleFilterActivation = function (e, filterId) {
            e.stopPropagation();
            var el = document.querySelector(".drayage_filter_" + filterId);
            _this.setState({ isCountryFilterActive: false, isMOTFilterActive: false });

            if (window.getComputedStyle(el).display === 'block') {
                el.style.display = "none";
                var filterValues = _this.state.filterValues;

                var filters = _extends({}, filterValues);
                delete filters[filterId];
                filters[filterId] = "";
                // console.log("filters1", filters)
                _this.setState({ filterValues: filters });
            } else {
                el.style.display = "block";
            }
        };

        _this.handleFilterChange = function (filterId, value, eta) {
            if (eta === "beforeInc") {
                _this.setState({ etdbefore: _this.state.etdbefore + 1 });
            } else if (eta === "beforeDec") {
                _this.setState({ etdbefore: _this.state.etdbefore - 1 });
            } else {
                _this.setState({ etdbefore: _this.state.etdbefore });
            }

            var type = _this.props.type;
            var filterValues = _this.state.filterValues;

            var filters = _extends({}, filterValues);
            delete filters[filterId];

            filters[filterId] = value.trimStart();

            //Adding Multi Support for Vessel On Water
            if (type === "VESSEL_ON_WATER" && (filterId === "MBOL" || filterId === "shipmentId")) {
                var searchText = value.trimStart();
                if (filterId === "MBOL") _this.setState({ multiMBOL: searchText });else _this.setState(defineProperty({}, filterId, searchText));

                var searchTextArray = searchText.includes(";") ? searchText.split(";").map(function (id) {
                    return id.trim();
                }).filter(function (id2) {
                    return id2 !== "";
                }) : searchText.includes(",") ? searchText.split(",").map(function (id) {
                    return id.trim();
                }).filter(function (id2) {
                    return id2 !== "";
                }) : searchText.split(/\s+/).filter(function (id) {
                    return id !== "";
                });

                var newSearchTextArray = Array.isArray(searchTextArray) && searchTextArray.slice(0, 10);

                var newFilterVal = newSearchTextArray.join(',');

                filters[filterId] = newFilterVal;
            }

            _this.setState({ filterValues: filters, sortDefaultVal: value }, asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.props.setResetClicked(false);

                            case 2:
                                _this.props.filtersSubmitted(_this.state.filterValues);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            })));
        };

        _this.toggleDatePicker = function (e, type) {
            e.stopPropagation();
            _this.setState({ isCountryFilterActive: false, isMOTFilterActive: false });

            if (type === "etdbefore") {
                _this.setState({
                    showETD: !_this.state.showETD
                });
            } else if (type === "etdafterdatefilter") {
                _this.setState({
                    showETDAfter: !_this.state.showETDAfter
                });
            } else if (type === "etabeforedatefilter") {
                _this.setState({
                    showETABefore: !_this.state.showETABefore
                });
            } else {
                _this.setState({
                    showETA: !_this.state.showETA
                });
            }
        };

        _this.handleKeyPress = function (event) {
            var _this$state = _this.state,
                filterValues = _this$state.filterValues,
                multiFilterValues = _this$state.multiFilterValues;

            var newfilterValues = _this.props.type === "drayage_multisearch_filter" ? multiFilterValues : filterValues;
            if (event.keyCode === 13) {
                _this.props.filtersSubmitted(newfilterValues);
            }
        };

        _this.handleMultiFilterChange = function (filterId, searchText) {

            _this.setState(defineProperty({}, filterId, searchText.trimStart()));

            var searchText2 = filterId === "Terminal" ? [searchText] : searchText.includes(";") ? searchText.split(";").map(function (id) {
                return id.trim();
            }).filter(function (id2) {
                return id2 !== "";
            }) : searchText.includes(",") ? searchText.split(",").map(function (id) {
                return id.trim();
            }).filter(function (id2) {
                return id2 !== "";
            }) : searchText.split(/\s+/).filter(function (id) {
                return id !== "";
            });

            var newSearchTextArray = filterId === "Terminal" ? searchText2 : searchText2.slice(0, 10);
            var multiFilterValues = _this.state.multiFilterValues;


            var parameter = searchByParameters[filterId];
            multiFilterValues = multiFilterValues.length > 0 && multiFilterValues.filter(function (param) {
                return param.key !== parameter;
            });
            var filters = { key: parameter, value: newSearchTextArray.length > 0 ? newSearchTextArray : null };
            var newValues = [].concat(toConsumableArray(multiFilterValues), [filters]);
            // console.log("filters1", newValues)
            _this.setState({ multiFilterValues: newValues });
            _this.props.setResetClicked2(false);
        };

        _this.onSelectingEtaBefore = function (filterId, data) {
            var inToEpoch = void 0;
            if (data) {
                var isoDate = moment$1(data).format("YYYY-MM-DD");
                inToEpoch = moment$1(isoDate).utc(true).valueOf().toString();
            } else {
                inToEpoch = '';
            }

            _this.setState(defineProperty({}, filterId, data));
            var multiFilterValues = _this.state.multiFilterValues;

            var parameter = searchByParameters[filterId];
            debugger;
            multiFilterValues = multiFilterValues.length > 0 && multiFilterValues.filter(function (param) {
                return param.key !== parameter;
            });
            var filters = { key: parameter, value: data !== '' ? [inToEpoch] : null };
            var newValues = [].concat(toConsumableArray(multiFilterValues), [filters]);

            _this.setState({ multiFilterValues: newValues });
            _this.props.setResetClicked2(false);
        };

        _this.toggleFilters = function (e, filterKey) {
            e.stopPropagation();
            var filterKeys = ["isCountryFilterActive", "isMOTFilterActive"];
            var newState = filterKeys.reduce(function (acc, key) {
                acc[key] = false;
                return acc;
            }, {});
            newState[filterKey] = !_this.state[filterKey];

            _this.setState(newState);
            // if (this.state[type] === false) {
            //     this.setState({ [type]: true })
            // } else {
            //     this.setState({ [type]: false })
            // }
        };

        _this.handleCountryFilter = function (e) {
            var countryValues = _this.state.countryValues;


            var checkBoxStatus = e.target.checked;
            var value = e.target.name;

            var updatedList = [].concat(toConsumableArray(countryValues));
            if (checkBoxStatus) {
                updatedList = countryValues.map(function (country) {
                    return country.value === value ? _extends({}, country, { isChecked: checkBoxStatus }) : country;
                });
            } else {
                updatedList = countryValues.map(function (country) {
                    return country.value === value ? _extends({}, country, { isChecked: false }) : country;
                });
            }

            _this.setState({ countryValues: updatedList });
            var multiFilterValues = _this.state.multiFilterValues;

            var parameter = searchByParameters["countries"];

            multiFilterValues = multiFilterValues.length > 0 && multiFilterValues.filter(function (param) {
                return param.key !== parameter;
            });
            var filters = { key: parameter, value: updatedList.length > 0 ? updatedList.filter(function (country) {
                    return country.isChecked;
                }).map(function (data) {
                    return data.value;
                }) : null };
            var newValues = [].concat(toConsumableArray(multiFilterValues), [filters]);
            // console.log("filters1", newValues)
            _this.setState({ multiFilterValues: newValues });
            _this.props.setResetClicked2(false);
        };

        _this.handleMOTFilter = function (e) {
            var motValues = _this.state.motValues;


            var checkBoxStatus = e.target.checked;
            var value = e.target.name;

            var updatedList = motValues.map(function (mot) {
                return mot.value === value ? _extends({}, mot, { isChecked: checkBoxStatus }) : mot;
            });

            if (!checkBoxStatus && updatedList.filter(function (mot) {
                return mot.isChecked;
            }).length === 0) {
                updatedList = motValues.map(function (mot) {
                    return mot.value === value ? _extends({}, mot, { isChecked: true }) : mot;
                });
            }
            _this.setState({ motValues: updatedList });

            var multiFilterValues = _this.state.multiFilterValues;

            var parameter = searchByParameters["mot"];

            multiFilterValues = multiFilterValues.length > 0 && multiFilterValues.filter(function (param) {
                return param.key !== parameter;
            });

            var filters = {
                key: parameter,
                value: updatedList.length > 0 ? updatedList.filter(function (mot) {
                    return mot.isChecked;
                }).map(function (data) {
                    return data.value;
                }) : null
            };

            var newValues = [].concat(toConsumableArray(multiFilterValues), [filters]);
            _this.setState({ multiFilterValues: newValues });
            _this.props.setResetClicked2(false);
        };

        _this.renderIcon = function (key) {
            return React__default.createElement(
                React__default.Fragment,
                null,
                React__default.createElement(Icon, { name: 'search', className: 'search_icon' }),
                React__default.createElement(
                    'div',
                    { className: 'close_icon', onClick: function onClick(e) {
                            e.stopPropagation();
                            _this.setState(defineProperty({}, key, ''), function () {
                                _this.handleMultiFilterChange(key, _this.state[key]);
                            });
                        } },
                    React__default.createElement(Icon, { name: 'close', link: true })
                )
            );
        };

        var defaultEtaAfter = { key: searchByParameters['etaAfter'], value: ['' + _this.props.etaAfterDate] };
        _this.props.defaultFilterValues && _this.props.defaultFilterValues(defaultDates);
        if (_this.props.defaultCountryFilterValues && _this.props.etaAfterDate) {
            _this.props.defaultCountryFilterValues([defaultCountry, defaultEtaAfter, defaultMOT]);
        } else if (_this.props.defaultCountryFilterValues && !_this.props.etaAfterDate) {
            _this.props.defaultCountryFilterValues([defaultCountry, defaultMOT]);
        }
        _this.state = {
            filterValues: _this.props.type === "VESSEL_ON_WATER" ? _extends({}, defaultDates, props.filterValues) : {},
            currentETD: '',
            currentETA: '',
            showETD: false,
            showETA: false,
            etdbefore: 14,
            etaafter: 14,
            sortDefaultVal: "ETA_DESCENDING",
            ETABeforeDateFilter: '',
            ETDAfterDateFilter: '',
            showETDAfter: false,
            showETABefore: false,

            // Multi-Search Filter for D-Modal 
            multiFilterValues: _this.props.etaAfterDate ? [_extends({}, defaultCountry), _extends({}, defaultEtaAfter), _extends({}, defaultMOT)] : [_extends({}, defaultCountry), _extends({}, defaultMOT)],
            Container: '',
            Shipment: '',
            MBOL: '',
            PO: '',
            Customer: '',
            Vessel: '',
            Terminal: '',
            Dcarrier: '',
            ETAbefore: '',
            ETAafter: '',
            GOTAfter: '',
            GOTBefore: '',
            showETA2: false,
            showGOTAfter: false,
            showGOTBefore: false,
            isCountryFilterActive: false,
            cityOFDeliveryAddress: "",
            checked: new Map(),
            displayDropdown: false,
            showFilter: false,
            countryValues: [].concat(countryFilterParams),
            motValues: [].concat(motFilterParams),
            isMOTFilterActive: false,
            shipmentId: '',
            multiMBOL: ''
        };
        return _this;
    }

    createClass(FilterDropdown, [{
        key: 'onSelectingDate',
        value: function onSelectingDate(filterId, data) {
            var inToEpoch = void 0;
            if (data) {
                var isoDate = moment$1(data).format("YYYY-MM-DD");
                inToEpoch = moment$1(isoDate).utc(true).valueOf().toString();
            } else {
                inToEpoch = '';
            }

            var filterValues = this.state.filterValues;

            var filters = _extends({}, filterValues);
            delete filters[filterId];
            filters[filterId] = inToEpoch;
            console.log("filters2", filters);
            this.setState({ filterValues: filters });
            this.props.setResetClicked(false);
        }

        // Multi-Search Filter for D-Modal 

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                filterValues = _state.filterValues,
                currentETD = _state.currentETD,
                currentETA = _state.currentETA,
                showETD = _state.showETD,
                showETA = _state.showETA,
                showETA2 = _state.showETA2,
                multiFilterValues = _state.multiFilterValues,
                cityOFDeliveryAddress = _state.cityOFDeliveryAddress,
                ETABeforeDateFilter = _state.ETABeforeDateFilter,
                showETABefore = _state.showETABefore,
                ETDAfterDateFilter = _state.ETDAfterDateFilter,
                showETDAfter = _state.showETDAfter,
                showFilter = _state.showFilter,
                Container$$1 = _state.Container,
                Shipment = _state.Shipment,
                MBOL = _state.MBOL,
                PO = _state.PO,
                Customer = _state.Customer,
                Vessel = _state.Vessel,
                Terminal = _state.Terminal,
                Dcarrier = _state.Dcarrier,
                ETAbefore = _state.ETAbefore,
                ETAafter = _state.ETAafter,
                isCountryFilterActive = _state.isCountryFilterActive,
                checked = _state.checked,
                showGOTAfter = _state.showGOTAfter,
                showGOTBefore = _state.showGOTBefore,
                GOTAfter = _state.GOTAfter,
                GOTBefore = _state.GOTBefore,
                shipmentId = _state.shipmentId,
                multiMBOL = _state.multiMBOL,
                isMOTFilterActive = _state.isMOTFilterActive;
            var _props = this.props,
                type = _props.type,
                historyMode = _props.historyMode,
                userType = _props.userType;


            var newfilterValues = type === "drayage_multisearch_filter" ? multiFilterValues : filterValues;
            newfilterValues = Array.isArray(newfilterValues) ? newfilterValues.filter(function (param) {
                return param.value !== null;
            }) : newfilterValues;

            return React__default.createElement(
                React__default.Fragment,
                null,
                type !== "container_app" ? React__default.createElement(
                    Dropdown,
                    {
                        text: type === "drayage_multisearch_filter" ? "Multisearch Filter" : type === "container_app" ? null : 'Filters',
                        floating: true,
                        labeled: true,
                        className: 'icon drayage_filter_dropdown',
                        onClick: function onClick(e) {
                            e.stopPropagation();
                            _this3.setState({ displayDropdown: true });
                        }
                    },
                    React__default.createElement(
                        Dropdown.Menu,
                        { style: { contentVisibility: this.state.displayDropdown === false && "hidden" }, className: 'dropdown_filter' },
                        type === "container_app" ? null : type === "drayage_multisearch_filter" ? React__default.createElement(
                            React__default.Fragment,
                            null,
                            React__default.createElement(Dropdown.Item, {
                                text: 'Country Filter',
                                onClick: function onClick(e) {
                                    return _this3.toggleFilters(e, 'isCountryFilterActive');
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: 'Country_filter',
                                    style: { display: isCountryFilterActive ? "block" : "none" }
                                },
                                this.state.countryValues.map(function (_ref2, index) {
                                    var value = _ref2.value,
                                        text = _ref2.text,
                                        isChecked = _ref2.isChecked;
                                    return React__default.createElement(
                                        'div',
                                        { className: 'country-item-list', key: text },
                                        React__default.createElement(Input$1, {
                                            type: 'checkbox',
                                            id: text,
                                            name: value,
                                            checked: isChecked,
                                            className: 'country-check-list',
                                            onChange: _this3.handleCountryFilter
                                        }),
                                        React__default.createElement(
                                            'label',
                                            { htmlFor: text, value: value },
                                            React__default.createElement(
                                                'span',
                                                null,
                                                text,
                                                ' '
                                            )
                                        )
                                    );
                                })
                            ),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'MOT Filter',
                                onClick: function onClick(e) {
                                    return _this3.toggleFilters(e, 'isMOTFilterActive');
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: 'motFilter',
                                    style: { display: this.state.isMOTFilterActive ? "block" : "none" }
                                },
                                this.state.motValues.map(function (_ref3, index) {
                                    var value = _ref3.value,
                                        text = _ref3.text,
                                        isChecked = _ref3.isChecked;
                                    return React__default.createElement(
                                        'div',
                                        { style: { display: "flex" }, key: value },
                                        React__default.createElement(Input$1, {
                                            type: 'checkbox',
                                            id: value,
                                            name: value,
                                            checked: isChecked,
                                            className: 'mot-check-list',
                                            onChange: function onChange(e) {
                                                return _this3.handleMOTFilter(e, value);
                                            }
                                        }),
                                        React__default.createElement(
                                            'label',
                                            { htmlFor: value, value: value },
                                            React__default.createElement(
                                                'span',
                                                null,
                                                text
                                            )
                                        )
                                    );
                                })
                            ),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'Container No.',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "Container");
                                }
                            }),
                            React__default.createElement(Input$1, { name: 'Container No.', className: 'drayage_filter drayage_filter_Container', placeholder: 'Search maximum 10 Containers',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleMultiFilterChange("Container", e.target.value);
                                },
                                value: Container$$1 || "",
                                autoComplete: 'off',
                                onKeyDown: this.handleKeyPress,
                                icon: this.renderIcon('Container')
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'City of Delivery Address',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "cityOFDeliveryAddress");
                                }
                            }),
                            React__default.createElement(Input$1, { name: 'City of Delivery Address', className: 'drayage_filter drayage_filter_cityOFDeliveryAddress', placeholder: 'Search City of Delivery Address',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleMultiFilterChange("cityOFDeliveryAddress", e.target.value);
                                },
                                value: cityOFDeliveryAddress || "",
                                autoComplete: 'off',
                                onKeyDown: this.handleKeyPress,
                                icon: this.renderIcon('cityOFDeliveryAddress')
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'Shipment',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "shipment");
                                }
                            }),
                            React__default.createElement(Input$1, { name: 'shipment', className: 'drayage_filter drayage_filter_shipment', placeholder: 'Search maximum 10 Shipments',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleMultiFilterChange("Shipment", e.target.value);
                                },
                                value: Shipment || "",
                                autoComplete: 'off',
                                onKeyDown: this.handleKeyPress,
                                icon: this.renderIcon('Shipment')
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'MBOL',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "MBOL");
                                }
                            }),
                            React__default.createElement(Input$1, { name: 'MBOL', className: 'drayage_filter drayage_filter_MBOL', placeholder: 'Search maximum 10 MBOL',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleMultiFilterChange("MBOL", e.target.value);
                                },
                                value: MBOL || "",
                                autoComplete: 'off',
                                onKeyDown: this.handleKeyPress,
                                icon: this.renderIcon('MBOL')
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'PO',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "PO");
                                }
                            }),
                            React__default.createElement(Input$1, { name: 'PO', className: 'drayage_filter drayage_filter_PO', placeholder: 'Search maximum 10 PO',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleMultiFilterChange("PO", e.target.value);
                                },
                                value: PO || "",
                                autoComplete: 'off',
                                onKeyDown: this.handleKeyPress,
                                icon: this.renderIcon('PO')
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            userType !== "CUSTOMER" && React__default.createElement(Dropdown.Item, {
                                text: 'Customer',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "Customer");
                                }
                            }),
                            userType !== "CUSTOMER" && React__default.createElement(Input$1, { name: 'Customer', className: 'drayage_filter drayage_filter_Customer', placeholder: 'Search maximum 10 Customers',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleMultiFilterChange("Customer", e.target.value);
                                },
                                value: Customer || "",
                                autoComplete: 'off',
                                onKeyDown: this.handleKeyPress,
                                icon: this.renderIcon('Customer')
                            }),
                            userType !== "CUSTOMER" && React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'Vessel',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "Vessel");
                                }
                            }),
                            React__default.createElement(Input$1, { name: 'Vessel', className: 'drayage_filter drayage_filter_Vessel', placeholder: 'Search Vessel',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleMultiFilterChange("Vessel", e.target.value);
                                },
                                value: Vessel || "",
                                autoComplete: 'off',
                                onKeyDown: this.handleKeyPress,
                                icon: this.renderIcon('Vessel')
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'Terminal',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "Terminal");
                                }
                            }),
                            React__default.createElement(Input$1, { name: 'Terminal', className: 'drayage_filter drayage_filter_Terminal', placeholder: 'Search Terminal',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleMultiFilterChange("Terminal", e.target.value);
                                },
                                value: Terminal || "",
                                autoComplete: 'off',
                                onKeyDown: this.handleKeyPress,
                                icon: this.renderIcon('Terminal')
                            }),
                            window._env_.APP_NAME !== "Partner" && React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            window._env_.APP_NAME !== "Partner" && React__default.createElement(Dropdown.Item, {
                                text: 'D-Carrier',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "Dcarrier");
                                }
                            }),
                            window._env_.APP_NAME !== "Partner" && React__default.createElement(Input$1, { name: 'D-Carrier', className: 'drayage_filter drayage_filter_Dcarrier', placeholder: 'Search D-Carrier',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleMultiFilterChange("Dcarrier", e.target.value);
                                },
                                value: Dcarrier || "",
                                autoComplete: 'off',
                                onKeyDown: this.handleKeyPress,
                                icon: this.renderIcon('Dcarrier')
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'ETA Before',
                                onClick: function onClick(e) {
                                    return _this3.toggleDatePicker(e, "etabefore");
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: ' drayage_filter'
                                },
                                React__default.createElement(
                                    'div',
                                    { style: { display: showETA ? "block" : "none" } },
                                    React__default.createElement(
                                        'div',
                                        { className: 'set_filter_CustomDates' },
                                        React__default.createElement(DatePicker, {
                                            className: 'filterDatePicker',
                                            dateFormat: 'MMM d, yyyy',
                                            placeholderText: 'Select Date',
                                            onChange: function onChange(date) {

                                                _this3.setState({ ETAbefore: date });

                                                _this3.onSelectingEtaBefore("etaBefore", date);
                                            },
                                            onKeyDown: this.handleKeyPress,
                                            selected: ETAbefore
                                        }),
                                        ETAbefore !== '' && React__default.createElement(
                                            'a',
                                            {
                                                className: 'resetLink',
                                                onClick: function onClick() {
                                                    return _this3.setState({ ETAbefore: '', showETA: false }, function () {
                                                        return _this3.onSelectingEtaBefore("etaBefore", '');
                                                    });
                                                }
                                            },
                                            'Reset'
                                        )
                                    )
                                )
                            ),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'ETA After',
                                onClick: function onClick(e) {
                                    return _this3.toggleFilters(e, "showETA2");
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: ' drayage_filter'
                                },
                                React__default.createElement(
                                    'div',
                                    { style: { display: showETA2 ? "block" : "none" } },
                                    React__default.createElement(
                                        'div',
                                        { className: 'set_filter_CustomDates' },
                                        React__default.createElement(DatePicker, {
                                            className: 'filterDatePicker',
                                            dateFormat: 'MMM d, yyyy',
                                            placeholderText: 'Select Date',
                                            onChange: function onChange(date) {

                                                _this3.setState({ ETAafter: date });

                                                _this3.onSelectingEtaBefore("etaAfter", date);
                                            },
                                            onKeyDown: this.handleKeyPress,
                                            selected: ETAafter
                                        }),
                                        ETAafter !== '' && React__default.createElement(
                                            'a',
                                            {
                                                className: 'resetLink',
                                                onClick: function onClick() {
                                                    return _this3.setState({ ETAafter: '', showETA2: false }, function () {
                                                        return _this3.onSelectingEtaBefore("etaAfter", '');
                                                    });
                                                }
                                            },
                                            'Reset'
                                        )
                                    )
                                )
                            ),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'Per Diem Time Before',
                                onClick: function onClick(e) {
                                    return _this3.toggleFilters(e, "showGOTBefore");
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: ' drayage_filter'
                                },
                                React__default.createElement(
                                    'div',
                                    { style: { display: showGOTBefore ? "block" : "none" } },
                                    React__default.createElement(
                                        'div',
                                        { className: 'set_filter_CustomDates' },
                                        React__default.createElement(DatePicker, {
                                            className: 'filterDatePicker',
                                            dateFormat: 'MMM d, yyyy',
                                            placeholderText: 'Select Date',
                                            onChange: function onChange(date) {

                                                _this3.setState({ GOTBefore: date });

                                                _this3.onSelectingEtaBefore("GOTBefore", date);
                                            },
                                            onKeyDown: this.handleKeyPress,
                                            selected: GOTBefore
                                        }),
                                        GOTBefore !== '' && React__default.createElement(
                                            'a',
                                            {
                                                className: 'resetLink',
                                                onClick: function onClick() {
                                                    return _this3.setState({ GOTBefore: '', showGOTBefore: false }, function () {
                                                        return _this3.onSelectingEtaBefore("GOTBefore", '');
                                                    });
                                                }
                                            },
                                            'Reset'
                                        )
                                    )
                                )
                            ),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'Per Diem Time After',
                                onClick: function onClick(e) {
                                    return _this3.toggleFilters(e, "showGOTAfter");
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: ' drayage_filter'
                                },
                                React__default.createElement(
                                    'div',
                                    { style: { display: showGOTAfter ? "block" : "none" } },
                                    React__default.createElement(
                                        'div',
                                        { className: 'set_filter_CustomDates' },
                                        React__default.createElement(DatePicker, {
                                            className: 'filterDatePicker',
                                            dateFormat: 'MMM d, yyyy',
                                            placeholderText: 'Select Date',
                                            onChange: function onChange(date) {

                                                _this3.setState({ GOTAfter: date });

                                                _this3.onSelectingEtaBefore("GOTAfter", date);
                                            },
                                            onKeyDown: this.handleKeyPress,
                                            selected: GOTAfter
                                        }),
                                        GOTAfter !== '' && React__default.createElement(
                                            'a',
                                            {
                                                className: 'resetLink',
                                                onClick: function onClick() {
                                                    return _this3.setState({ GOTAfter: '', showGOTAfter: false }, function () {
                                                        return _this3.onSelectingEtaBefore("GOTAfter", '');
                                                    });
                                                }
                                            },
                                            'Reset'
                                        )
                                    )
                                )
                            )
                        ) : React__default.createElement(
                            React__default.Fragment,
                            null,
                            React__default.createElement(Dropdown.Item, {
                                text: 'Shipment ID',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "shipmentId");
                                }
                            }),
                            React__default.createElement(Input$1, { icon: 'search', iconPosition: 'left', name: 'shipmentId', className: 'drayage_filter drayage_filter_shipmentId', placeholder: type === "VESSEL_ON_WATER" ? "Search maximum 10 Shipments" : "Shipment ID",
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleFilterChange("shipmentId", e.target.value);
                                },
                                value: type === "VESSEL_ON_WATER" ? shipmentId || "" : filterValues.shipmentId ? filterValues.shipmentId : "",
                                onKeyDown: this.handleKeyPress
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'MBOL',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "MBOL");
                                }
                            }),
                            React__default.createElement(Input$1, { icon: 'search', iconPosition: 'left', name: 'MBOL', className: ' drayage_filter drayage_filter_MBOL', placeholder: type === "VESSEL_ON_WATER" ? "Search maximum 10 MBOL" : "MBOL",
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleFilterChange("MBOL", e.target.value);
                                },
                                value: type === "VESSEL_ON_WATER" ? multiMBOL || "" : filterValues.MBOL ? filterValues.MBOL : "",
                                onKeyDown: this.handleKeyPress
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'Customer',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "customer");
                                }
                            }),
                            React__default.createElement(Input$1, { icon: 'search', iconPosition: 'left', name: 'customer', className: ' drayage_filter drayage_filter_customer', placeholder: 'Customer',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleFilterChange("customer", e.target.value);
                                },
                                value: filterValues.customer ? filterValues.customer : "",
                                onKeyDown: this.handleKeyPress
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'IMO',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "imo");
                                }
                            }),
                            React__default.createElement(Input$1, { name: 'imo', className: ' drayage_filter drayage_filter_imo', placeholder: 'IMO',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleFilterChange("imo", e.target.value);
                                },
                                value: filterValues.imo ? filterValues.imo : "",
                                onKeyDown: this.handleKeyPress
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'Port',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "port");
                                }
                            }),
                            React__default.createElement(Input$1, { icon: 'search', iconPosition: 'left', name: 'port', className: ' drayage_filter drayage_filter_port', placeholder: 'Port',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleFilterChange("port", e.target.value);
                                },
                                value: filterValues.port ? filterValues.port : "",
                                onKeyDown: this.handleKeyPress
                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'Vessel Name',
                                onClick: function onClick(e) {
                                    return _this3.handleFilterActivation(e, "vesselName");
                                }
                            }),
                            React__default.createElement(Input$1, { icon: 'search', iconPosition: 'left', name: 'vesselName', className: ' drayage_filter drayage_filter_vesselName', placeholder: 'Vessel Name',
                                onClick: function onClick(e) {
                                    return e.stopPropagation();
                                },
                                onChange: function onChange(e) {
                                    return _this3.handleFilterChange("vesselName", e.target.value);
                                },
                                value: filterValues.vesselName ? filterValues.vesselName : "",
                                onKeyDown: this.handleKeyPress

                            }),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'ETD Before',
                                onClick: function onClick(e) {
                                    return _this3.toggleDatePicker(e, "etdbefore");
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: ' drayage_filter'
                                },
                                React__default.createElement(
                                    'div',
                                    { style: { display: showETD ? "block" : "none" } },
                                    React__default.createElement(
                                        'div',
                                        { className: 'set_filter_CustomDates' },
                                        React__default.createElement(DatePicker, {
                                            className: 'filterDatePicker',
                                            dateFormat: 'MMM d, yyyy',
                                            onChange: function onChange(date) {

                                                _this3.setState({ currentETD: date });

                                                _this3.onSelectingDate("etdbefore", date);
                                            },
                                            onKeyDown: this.handleKeyPress,
                                            selected: currentETD ? currentETD : new Date().getTime() + 14 * 24 * 60 * 60 * 1000
                                        }),
                                        React__default.createElement(
                                            'p',
                                            null,
                                            '(midnight GMT)'
                                        )
                                    )
                                )
                            ),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'ETA After',
                                onClick: function onClick(e) {
                                    return _this3.toggleDatePicker(e, "etaafter");
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: ' drayage_filter'
                                },
                                React__default.createElement(
                                    'div',
                                    { style: { display: showETA ? "block" : "none" } },
                                    React__default.createElement(
                                        'div',
                                        { className: 'set_filter_CustomDates' },
                                        React__default.createElement(DatePicker, {
                                            className: 'filterDatePicker',
                                            dateFormat: 'MMM d, yyyy',
                                            onChange: function onChange(date) {

                                                _this3.setState({ currentETA: date });

                                                _this3.onSelectingDate("etaafter", date);
                                            },
                                            onKeyDown: this.handleKeyPress,
                                            selected: currentETA ? currentETA : new Date().getTime() - 14 * 24 * 60 * 60 * 1000
                                        }),
                                        React__default.createElement(
                                            'p',
                                            null,
                                            '(midnight GMT)'
                                        )
                                    )
                                )
                            ),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'ETD After',
                                onClick: function onClick(e) {
                                    return _this3.toggleDatePicker(e, "etdafterdatefilter");
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: ' drayage_filter'
                                },
                                React__default.createElement(
                                    'div',
                                    { style: { display: showETDAfter ? "block" : "none" } },
                                    React__default.createElement(
                                        'div',
                                        { className: 'set_filter_CustomDates' },
                                        React__default.createElement(DatePicker, {
                                            className: 'filterDatePicker',
                                            dateFormat: 'MMM d, yyyy',
                                            onChange: function onChange(date) {

                                                _this3.setState({ ETDAfterDateFilter: date });

                                                _this3.onSelectingDate("etdafterdatefilter", date);
                                            },
                                            onKeyDown: this.handleKeyPress,
                                            selected: ETDAfterDateFilter
                                        }),
                                        React__default.createElement(
                                            'p',
                                            null,
                                            '(midnight GMT)'
                                        )
                                    )
                                )
                            ),
                            React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                            React__default.createElement(Dropdown.Item, {
                                text: 'ETA Before',
                                onClick: function onClick(e) {
                                    return _this3.toggleDatePicker(e, "etabeforedatefilter");
                                }
                            }),
                            React__default.createElement(
                                'div',
                                {
                                    onClick: function onClick(e) {
                                        return e.stopPropagation();
                                    },
                                    className: ' drayage_filter'
                                },
                                React__default.createElement(
                                    'div',
                                    { style: { display: showETABefore ? "block" : "none" } },
                                    React__default.createElement(
                                        'div',
                                        { className: 'set_filter_CustomDates' },
                                        React__default.createElement(DatePicker, {
                                            className: 'filterDatePicker',
                                            dateFormat: 'MMM d, yyyy',
                                            onChange: function onChange(date) {

                                                _this3.setState({ ETABeforeDateFilter: date });

                                                _this3.onSelectingDate("etabeforedatefilter", date);
                                            },
                                            onKeyDown: this.handleKeyPress,
                                            selected: ETABeforeDateFilter
                                        }),
                                        React__default.createElement(
                                            'p',
                                            null,
                                            '(midnight GMT)'
                                        )
                                    )
                                )
                            )
                        ),
                        React__default.createElement(Dropdown.Divider, { className: 'Divider' }),
                        React__default.createElement(Input$1, {
                            type: 'submit',
                            className: 'drayage_filter_submit small_button',
                            onClick: function onClick(e) {
                                e.stopPropagation();
                                _this3.props.filtersSubmitted(newfilterValues);
                                _this3.setState({ displayDropdown: false });
                            },
                            value: 'Submit'
                        }),
                        React__default.createElement(
                            'a',
                            { className: 'resetLink2', style: { marginLeft: "70%" }, onClick: function onClick(e) {
                                    e.stopPropagation();
                                    _this3.setState({ showETA: false, showETA2: false, showGOTAfter: false, showGOTBefore: false, isCountryFilterActive: false, isMOTFilterActive: false, multiFilterValues: {}, Container: '', Shipment: '', MBOL: '', PO: '', Customer: '', Vessel: '', Terminal: '', Dcarrier: '', ETAbefore: '', ETAafter: '', GOTAfter: '', GOTBefore: '', ETABeforeDateFilter: '', ETDAfterDateFilter: '', filterValues: _this3.props.type === "VESSEL_ON_WATER" ? _extends({}, defaultDates, _this3.props.filterValues) : {}, countryValues: [].concat(countryFilterParams), checked: new Map(), multiMBOL: '', shipmentId: '', motValues: [].concat(motFilterParams) });
                                    type === "drayage_multisearch_filter" ? _this3.props.resetMultiFilters() : _this3.props.resetFilters();
                                    // to collapsed the all old fashioned collapsables
                                    var el = document.querySelectorAll('.drayage_filter_Container, .drayage_filter_cityOFDeliveryAddress, .drayage_filter_shipment, .drayage_filter_MBOL, .drayage_filter_Customer, .drayage_filter_Vessel, .drayage_filter_Terminal, .drayage_filter_Dcarrier');
                                    el.forEach(function (element) {
                                        element.style.display = 'none';
                                    });
                                } },
                            'Reset'
                        )
                    )
                ) : React__default.createElement(
                    'div',
                    { className: 'drayage_filter_sortByClass' },
                    React__default.createElement(Dropdown, {
                        value: historyMode ? "RECENT DONE" : this.state.sortDefaultVal,
                        onChange: function onChange(e, data) {
                            return _this3.handleFilterChange("sortBy", data.value);
                        },
                        fluid: true,
                        search: true,
                        selection: true,
                        options: historyMode ? optionForHistoryMode : options,
                        disabled: historyMode,
                        className: 'sortByDropdown'
                    }),
                    React__default.createElement(
                        'label',
                        { className: 'checkbox_label sortByReset' },
                        React__default.createElement(
                            'a',
                            { className: 'resetLink', onClick: function onClick(e) {
                                    e.stopPropagation();
                                    _this3.setState({ filterValues: {} });
                                    _this3.handleFilterChange("sortBy", "ETA_DESCENDING");
                                } },
                            this.state.sortDefaultVal !== "ETA_DESCENDING" && "Reset"
                        )
                    )
                )
            );
        }
    }]);
    return FilterDropdown;
}(React__default.Component);

var css_248z$8 = ".tableWrapper {\n  position: relative;\n  overflow: visible;\n  flex-grow: 1; }\n  .tableWrapper > .flexDisplay > .flexDisplay {\n    flex-grow: 1; }\n  .tableWrapper > .flexDisplay:not(.metaTable) > .flexDisplay:nth-child(2) {\n    border-left: 1px dashed #61545485;\n    border-bottom: 1px dashed #61545485; }\n  .tableWrapper > .flexDisplay:not(.metaTable) > .flexDisplay:nth-child(3) {\n    border-bottom: 1px dashed #61545485; }\n  .tableWrapper > .flexDisplay:not(.metaTable) > .flexDisplay:nth-child(4) {\n    border-bottom: 1px dashed #61545485; }\n  .tableWrapper > .flexDisplay:not(.metaTable) > .flexDisplay:nth-child(5) {\n    border-bottom: 1px dashed #61545485;\n    border-right: 1px dashed #61545485; }\n  .tableWrapper .rowSpacing {\n    margin-bottom: 0.5%; }\n  .tableWrapper .metaTable > .flexDisplay {\n    flex-basis: 0; }\n  .tableWrapper .rowHeader {\n    background-color: #F1F0F2;\n    height: 23px; }\n    .tableWrapper .rowHeader i.icon {\n      width: 27px;\n      height: 27px; }\n    .tableWrapper .rowHeader.iconClass {\n      display: inline-flex; }\n      .tableWrapper .rowHeader.iconClass.white i.icon.circle:before {\n        color: #FFFFFF; }\n      .tableWrapper .rowHeader.iconClass.green i.icon.circle:before {\n        color: #78E100; }\n      .tableWrapper .rowHeader.iconClass.red i.icon.circle:before {\n        color: #ED4D3F; }\n    .tableWrapper .rowHeader .headerText {\n      font-size: 9px;\n      font-weight: 600;\n      white-space: nowrap; }\n      .tableWrapper .rowHeader .headerText.lastChildMetaHeader {\n        padding-right: 46px; }\n  .tableWrapper .dataDisplay {\n    color: #2F4A97;\n    font-size: 10px; }\n    .tableWrapper .dataDisplay.firstState {\n      margin-left: -17px; }\n  .tableWrapper .dataDisplay:hover {\n    cursor: pointer; }\n  .tableWrapper .maxContentWidth {\n    width: max-content;\n    flex-grow: 1; }\n    .tableWrapper .maxContentWidth .rowWrapper {\n      display: flex;\n      background-color: #F1F0F2; }\n  .tableWrapper .verticalCentreAlign {\n    display: flex;\n    align-items: center; }\n  .tableWrapper .isUnprocessed {\n    border: 1px solid #979797;\n    border-radius: 2px;\n    box-shadow: 2px 2px 4px 0 rgba(165, 163, 163, 0.5);\n    padding-bottom: 5px;\n    margin: 0 1px; }\n\n.horizantalDivider {\n  width: 100%;\n  position: absolute; }\n\n.failedState {\n  color: #ED4D3F; }\n\n.infoStyle {\n  height: 12px;\n  margin-bottom: 4px; }\n\n.progressLine {\n  height: 3.75px;\n  min-width: 6px;\n  width: 100%;\n  margin-top: 10px;\n  margin-left: 4px; }\n  .progressLine.green {\n    background: #78E100; }\n  .progressLine.grey {\n    background: #AAAAAA; }\n\n.masterBolNumber2:hover {\n  font-weight: 900; }\n\n.lineBackground {\n  height: 23px;\n  background-color: #F1F0F2;\n  flex-grow: 1; }\n\n.highlight_border {\n  border-radius: 50%;\n  border: 6px solid #008b8f; }\n\n.gate_in_icons {\n  margin-top: 10px;\n  display: flex;\n  gap: 5px;\n  justify-content: flex-end; }\n  .gate_in_icons .viewFile {\n    pointer-events: all; }\n";
styleInject(css_248z$8);

var handleFileUrl = function handleFileUrl() {
    var entityEventID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var entityId = arguments[1];
    var shipmentIds = arguments[2];
    var attachmentAction = arguments[3];
    var attachmentType = arguments[4];

    var data = {};
    var eventMessage = {
        attachmentAction: attachmentAction,
        attachmentType: attachmentType
    };
    if (entityEventID) {
        eventMessage["entityEventID"] = entityEventID;
    } else {
        eventMessage["shipmentIds"] = shipmentIds;
        eventMessage["containerNumber"] = entityId;
    }
    data = {
        eventMessage: eventMessage,
        eventType: "EED_ATTACHMENT",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var handleDoDocument = function handleDoDocument(shipmentIds) {
    var data = {};
    var eventMessage = {
        id: shipmentIds
    };
    data = {
        eventMessage: eventMessage,
        eventType: "GET_SHIPMENT_DOCUMENTS",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var getUrl = function getUrl(urlData) {
    var data = {};
    var eventMessage = urlData;
    data = {
        eventMessage: eventMessage,
        eventType: "GET_SIGNED_URLS",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var getDocUrl = function getDocUrl(documentId) {
    var data = {};
    var eventMessage = {
        documentId: documentId,
        getDocRequestSource: "1"
    };
    data = {
        eventMessage: eventMessage,
        eventType: "GET_DOCUMENT_BY_ID",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var uploadImageFileData = function uploadImageFileData(formData, uploadTo, setProgress) {
    return HttpClient.fileUploadCustom({
        url: window._env_.REACT_APP_MEDIA_URL + "/" + uploadTo,
        headers: {
            "Content-type": "application/json",
            "Accept": "application/json"
        },
        data: formData,
        onUploadProgress: function onUploadProgress(data) {
            //Set the progress value to show the progress bar
            setProgress(Math.round(100 * data.loaded / data.total));
        },
        method: "post"
    });
};

var uploadImageFileDataDrayage = function uploadImageFileDataDrayage(formData, uploadTo) {
    return HttpClient.fileUploadCustom({
        url: window._env_.REACT_APP_MEDIA_URL + "/" + uploadTo,
        headers: {
            "Content-type": "application/json",
            "Accept": "application/json"
        },
        data: formData,
        method: "post"
    });
};

var insertDrayageDocument = function insertDrayageDocument(containerId, actualFileName, displayName, isReplaceDocument, documentType) {

    var data = {};

    data = {
        eventMessage: {
            containerId: containerId,
            chargeNames: [{
                "glCode": "60001",
                "chargeName": "BASE CHARGE"
            }],
            actualFileName: actualFileName,
            displayName: displayName,
            isCustomerVisibility: true,
            isReplaceDocument: isReplaceDocument,
            documentType: documentType
        },
        eventType: "INSERT_DRAYAGE_DOCUMENT",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var updateDrayagePartnerGateInFileData = function updateDrayagePartnerGateInFileData(attachmentAction, attachmentType, entityId, containerNumber, shipmentId, isArchived, finalString) {
    var data = {};
    data = {
        eventType: "EED_ATTACHMENT",
        eventTime: Date.now(),
        eventMessage: {
            fileName: finalString,
            shipmentIds: shipmentId,
            containerNumber: containerNumber,
            entityEventID: entityId,
            attachmentType: attachmentType,
            isArchived: isArchived,
            attachmentAction: attachmentAction
        }
    };

    return HttpClient.custom({
        data: data
    });
};

var archiveDrayageDocument = function archiveDrayageDocument(payload) {
    var data = {
        eventMessage: _extends({}, payload, {
            chargeNames: [{
                "glCode": "60001"
            }]
        }),
        eventType: "ARCHIVE_DRAYAGE_DOCUMENT",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var getArchieveDocument = function getArchieveDocument(containerId) {
    var data = {
        eventMessage: {
            containerId: containerId
        },
        eventType: "GET_DRAYAGE_DOCUMENTS",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var updatePartnerContDrayageStatus = function updatePartnerContDrayageStatus(payload) {
    var containerNumber = payload.containerNumber,
        shipmentIds = payload.shipmentIds,
        partnerContainerStatus = payload.partnerContainerStatus;

    var data = {
        eventMessage: {
            containerNumber: containerNumber, //ASDU7877777,
            shipmentIds: shipmentIds, //["KX-I5H7-19739","KX-I5H7-19732"],
            partnerContainerStatus: partnerContainerStatus //"CONTAINER_ACCEPTED"/"CONTAINER_REJECTED",
        },
        eventType: "DRAYAGE_UPDATE_PARTNER_CONTAINER",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var sendDrayageDoEmail = function sendDrayageDoEmail(payload) {
    var containerNumber = payload.containerNumber,
        shipmentIds = payload.shipmentIds,
        communicationParams = payload.communicationParams,
        comment = payload.comment;
    var toEmail = communicationParams.toEmail,
        cc = communicationParams.cc,
        bcc = communicationParams.bcc;

    var data = {
        eventMessage: {
            communicationParams: {
                to_email: toEmail,
                cc: cc,
                bcc: bcc
            },
            comment: comment,
            containerNumber: containerNumber, //ASDU7877777,
            shipmentIds: shipmentIds, //["KX-I5H7-19739","KX-I5H7-19732"],
            notificationType: "DRAYAGE_DO_SEND"
        },
        eventType: "DRAYAGE_NOTIFICATION",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var downloadDrayageDo = function downloadDrayageDo(payload) {
    var containerNumber = payload.containerNumber,
        shipmentIds = payload.shipmentIds;

    var data = {
        eventMessage: {
            containerNumber: containerNumber,
            shipmentIds: shipmentIds //[],
        },
        eventType: "DRAYAGE_GET_DO",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var getDrayageChildContainers = function getDrayageChildContainers(payload) {
    var containerNumber = payload.containerNumber,
        shipmentIds = payload.shipmentIds;

    var data = {
        eventMessage: {
            containerNumber: containerNumber,
            shipmentIds: shipmentIds
        },
        eventType: "DRAYAGE_GET_CHILD_CONTAINERS",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var setDrayageSplitContainers = function setDrayageSplitContainers(payload) {
    var data = {
        eventMessage: _extends({}, payload),
        eventType: "DRAYAGE_SPLIT_CONTAINERS",
        eventTime: Date.now()
    };

    return HttpClient.custom({
        data: data
    });
};

var DMODAL_USERS = {
  DRAYAGE_PARTNER: "DRAY_PARTNER",
  DRAY_OPS: "DRAY_OPS_USER",
  OPERATIONS: "OPS_USER",
  OPERATIONS_SUPERVISOR: "OPS_SUPER_VISOR",
  OPERATIONS_ADMIN: "ADMINISTRATOR",
  SALES: "DRAY_OPS_USER",
  CUSTOMER: "CUSTOMER" //read only mode
};

var CONTAINER_DRAY_ASSIGN_STATUS = {
  CONTAINER_ACCEPTED: {
    value: "CONTAINER_ACCEPTED",
    label: "Container Assignment Accepted",
    color: "#78E100",
    modalheader: "Accept Container Assignment",
    modalContent: "Are you sure you want to accept the container assignment?"
  },
  CONTAINER_REJECTED: {
    value: "CONTAINER_REJECTED",
    label: "Container Assignment Rejected",
    color: "#db2828",
    modalheader: "Reject Container Assignment",
    modalContent: "Are you sure you want to reject the container assignment?"
  },
  CONTAINER_PENDING: {
    value: "CONTAINER_PENDING",
    label: "Container Acceptance Pending",
    color: "#FFD525"
  },
  CONTAINER_REMOVED: {
    value: "CONTAINER_REMOVED",
    label: "Container Removed",
    color: "#db2828"
  }
};

var CONTAINER_MENU_ACTIONS = {
  SPLIT_CONTAINER: "SPLIT_CONTAINER",
  EMAIL_DO: "EMAIL_DO",
  DOWNLOAD_DO: "DOWNLOAD_DO"
};

var CONTAINER_MENU_OPTIONS = [{
  id: 1,
  label: "Email Document",
  icon: React__default.createElement(Icon, {
    name: "mail outline",
    style: { marginRight: 10, fontSize: 18, color: "#000" }
  }),
  action: CONTAINER_MENU_ACTIONS.EMAIL_DO,
  onClick: function onClick() {
    console.log("email DO");
  },
  display: true
}, {
  id: 2,
  label: "Download Document",
  icon: React__default.createElement(Icon, {
    name: "download",
    style: { marginRight: 10, fontSize: 18, color: "#000" }
  }),
  action: CONTAINER_MENU_ACTIONS.DOWNLOAD_DO,
  onClick: function onClick() {
    console.log("download DO");
  },
  display: true
}];

var showContainerStatus = function showContainerStatus(userType) {
  if (userType === DMODAL_USERS.CUSTOMER || userType === DMODAL_USERS.DRAYAGE_PARTNER) return false;else return true;
};

var formatDateTimeToMonDateTime = function formatDateTimeToMonDateTime(date) {
  return moment(date).format("MMMM Do YYYY, h:mm:ss a");
};

var getPartnersContDataFromShipmentList = function getPartnersContDataFromShipmentList(shipmentList) {
  var partnersContainerData = new Map([]);

  for (var i = 0; i < shipmentList.length; i++) {
    var partnerId = shipmentList[i].drayPartnerId;
    if (partnersContainerData.has(partnerId)) {
      var partnerData = [].concat(toConsumableArray(partnersContainerData.get(partnerId)));
      partnerData.push(shipmentList[i]);
      partnersContainerData.set(partnerId, partnerData);
    } else partnersContainerData.set(partnerId, [shipmentList[i]]);
  }
  return partnersContainerData;
};

var getCustomersContDataFromShipmentList = function getCustomersContDataFromShipmentList(shipmentList) {
  var customersContainerData = new Map([]);

  for (var i = 0; i < shipmentList.length; i++) {
    var customer = shipmentList[i].shipmentId.split("-")[1];
    if (customersContainerData.has(customer)) {
      var contData = [].concat(toConsumableArray(customersContainerData.get(customer)));
      contData.push(shipmentList[i]);
      customersContainerData.set(customer, contData);
    } else customersContainerData.set(customer, [shipmentList[i]]);
  }
  return customersContainerData;
};

var getContMenuOptions = function getContMenuOptions(_ref) {
  var onSplitContainerClick = _ref.onSplitContainerClick,
      onEmailDoClick = _ref.onEmailDoClick,
      onDowloadDoClick = _ref.onDowloadDoClick,
      userType = _ref.userType,
      containerInfo = _ref.containerInfo;
  var entityId = containerInfo.entityId,
      splitCount = containerInfo.splitCount;

  return [{
    id: 1,
    label: "Split Containers",
    icon: React__default.createElement("img", {
      src: callSplit,
      alt: "split container",
      style: { marginRight: 10, fontSize: 18, color: "#000" }
    }),
    onClick: function onClick() {
      onSplitContainerClick();
    },
    display: userType === DMODAL_USERS.DRAY_OPS,
    action: CONTAINER_MENU_ACTIONS.SPLIT_CONTAINER,
    extraInfo: React__default.createElement(
      "span",
      {
        style: {
          fontSize: 12,
          backgroundColor: "#e3f2f9",
          padding: "2px 8px",
          borderRadius: 12,
          color: "#007b8f",
          whiteSpace: "nowrap"
        }
      },
      splitCount ? splitCount + " Split Container" + (splitCount > 2 ? "s" : "") : "No Split"
    )
  }, {
    id: 2,
    label: "Email Document",
    icon: React__default.createElement(Icon, {
      name: "mail outline",
      style: { marginRight: 10, fontSize: 18, color: "#000" }
    }),
    onClick: function onClick() {
      onEmailDoClick();
    },
    display: true,
    action: CONTAINER_MENU_ACTIONS.EMAIL_DO
  }, {
    id: 3,
    label: "Download Document",
    icon: React__default.createElement(Icon, {
      name: "download",
      style: { marginRight: 10, fontSize: 18, color: "#000" }
    }),
    onClick: function onClick() {
      onDowloadDoClick();
    },
    display: true,
    action: CONTAINER_MENU_ACTIONS.DOWNLOAD_DO
  }];
};

var downloadMultipleFiles = function downloadMultipleFiles(fileList) {
  // Iterate through the list of URLs
  fileList.forEach(function (file) {
    var url = file.url,
        fileName = file.fileName; // Assuming fileList is an array of objects with { url, fileName }

    // Create a temporary anchor element

    var link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.download = fileName;

    // Append the anchor element to the document body
    document.body.appendChild(link);

    // Trigger a click event on the anchor element to start downloading
    link.click();

    // Clean up - remove the anchor element from the document body after download starts
    document.body.removeChild(link);
  });
};

var isDrayageContainer = function isDrayageContainer(shipmentList) {
  return shipmentList.some(function (shipment) {
    return shipment.drayPartnerId;
  });
};

var ContainerTable = function (_Component) {
  inherits(ContainerTable, _Component);

  function ContainerTable(props) {
    var _this2 = this;

    classCallCheck(this, ContainerTable);

    var _this = possibleConstructorReturn(this, (ContainerTable.__proto__ || Object.getPrototypeOf(ContainerTable)).call(this, props));

    _this.handleState = function (e, key, value, id) {
      var _this$setState;

      var handleParentState = _this.props.handleParentState;

      e.preventDefault();
      e.stopPropagation();
      _this.setState((_this$setState = {}, defineProperty(_this$setState, key, value), defineProperty(_this$setState, "entityId", id), _this$setState));
      handleParentState(id);
    };

    _this.renderDateTime = function (_ref) {
      var data = _ref.data;
      return data.map(function (info) {
        return React__default.createElement(
          "div",
          { className: "infoStyle" },
          info
        );
      });
    };

    _this.renderDoDocument = function (_ref2) {
      var displayName = _ref2.displayName,
          containerInfo = _ref2.containerInfo,
          dataList = _ref2.dataList;
      var shipmentIds = containerInfo.shipmentIds;

      var viewDoc = function viewDoc() {
        var resultShipment = shipmentIds.split(",");
        handleDoDocument(resultShipment[0]).then(function (response) {
          var doc = response.data.eventMessage.documents;
          // console.log("resp",doc)
          doc.map(function (document) {
            console.log("res", document);
            if (document.documentType === "DELIVERY_ORDER") {
              _this.props.handelDoUrl(document);
            }
          });
        });
      };

      var published = containerInfo.hasOwnProperty("isDOPresent");
      if (published === true) {
        return displayName === "DO CREATED" && React__default.createElement(
          "div",
          null,
          React__default.createElement(
            "a",
            { onClick: viewDoc },
            "Do Document"
          )
        );
      }
    };

    _this.splitProofOfGateIn = function (doc) {
      var stringArray = doc && isString(doc) ? doc.split(",") : [];
      var eirDoc = null,
          podDoc = null;


      if (!isEmpty(stringArray)) {
        var newArr = stringArray.map(function (str) {
          if (str && str.startsWith("EQUIPMENT_INTERCHANGE_RECEIPT:")) {
            eirDoc = str.split(":")[1];
          }
          if (str && str.startsWith("PROOF_OF_GATE_IN:")) {
            podDoc = str.split(":")[1];
          }
        });
      }

      return [eirDoc, podDoc];
    };

    _this.renderData = function (_ref3) {
      var status = _ref3.status,
          dataList = _ref3.dataList,
          fieldName = _ref3.fieldName,
          blockType = _ref3.blockType,
          allShipmentInfo = _ref3.allShipmentInfo,
          isGateInEnable = _ref3.isGateInEnable,
          containerInfo = _ref3.containerInfo,
          isAirMode = _ref3.isAirMode;
      var entityId = containerInfo.entityId,
          shipmentIds = containerInfo.shipmentIds,
          entityEventID = containerInfo.gateIn.entityEventID,
          proofOfGateIn = containerInfo.proofOfGateIn;
      var historyMode = _this.props.historyMode;
      var eirDoc = null,
          podDoc = null;

      if (proofOfGateIn || _this.props.proofOfGateIn) {
        var _this$splitProofOfGat = _this.splitProofOfGateIn(proofOfGateIn);

        var _this$splitProofOfGat2 = slicedToArray(_this$splitProofOfGat, 2);

        eirDoc = _this$splitProofOfGat2[0];
        podDoc = _this$splitProofOfGat2[1];
      }

      if (fieldName === "gateIn" && ( /* isGateInEnable && */proofOfGateIn || _this.props.proofOfGateIn)) {
        var uploadIconMsg = "Attachment";
        // }

        var getFileUrl = function () {
          var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var attachmentAction, attachmentType, resp;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;

                    if (!(proofOfGateIn || _this.props.proofOfGateIn)) {
                      _context.next = 9;
                      break;
                    }

                    attachmentAction = 2;
                    attachmentType = 0;

                    if (!(entityEventID || shipmentIds && entityId)) {
                      _context.next = 9;
                      break;
                    }

                    _context.next = 7;
                    return handleFileUrl(entityEventID, entityId, shipmentIds, attachmentAction, attachmentType);

                  case 7:
                    resp = _context.sent;

                    if (resp.status == 200) {
                      _this.props.showDragAndDropModal(true, "view", resp.data.eventMessage.url);
                    }

                  case 9:
                    _context.next = 14;
                    break;

                  case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](0);

                    console.error(_context.t0);

                  case 14:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this2, [[0, 11]]);
          }));

          return function getFileUrl() {
            return _ref4.apply(this, arguments);
          };
        }();
        return React__default.createElement(
          React__default.Fragment,
          null,
          dataList[0] && _this.renderDateTime({ data: dataList[0].split(";") }),
          React__default.createElement(
            "div",
            { className: "gate_in_icons" },
            isDrayageContainer(get(_this.props, "containerInfo.entityShipmentList", [])) && (eirDoc || isAirMode) && podDoc && React__default.createElement(
              "span",
              {
                className: "viewFile",
                "data-tooltip": "" + uploadIconMsg,
                "data-position": "bottom right",
                onClick: function onClick() {
                  return (eirDoc || isAirMode) && podDoc && _this.props.showDragAndDropModal(true, "attach", proofOfGateIn);
                }
              },
              React__default.createElement(Icon, { name: "attach", color: "black", size: "large" })
            )
          )
        );
      }
      if (fieldName === "fees") {
        var whatToDisplay = dataList[0];
        if (status === "FEES_DUE") {
          var value = dataList[1];
          whatToDisplay = !isNaN(Number(value)) ? "$" + (Number(value) / 100).toFixed(2) : value;
        }

        return React__default.createElement(
          React__default.Fragment,
          null,
          whatToDisplay
        );
      }
      if (fieldName === "holds") {
        var _whatToDisplay = dataList[0];

        return React__default.createElement(
          React__default.Fragment,
          null,
          _whatToDisplay,
          " ",
          dataList[1] && dataList[1].trim() && React__default.createElement(Popup, {
            trigger: React__default.createElement(Icon, { name: "warning sign", color: "red" }),
            content: dataList[1],
            position: "top left"
          })
        );
      }

      var getAllShipmentId = "";
      if (allShipmentInfo && fieldName === "shipmentId") {
        for (var i = 0; i < allShipmentInfo.length; i++) {
          var getShipmentId = allShipmentInfo[i].shipmentId;
          if (i < allShipmentInfo.length - 1) getAllShipmentId += getShipmentId + ", ";else getAllShipmentId += getShipmentId;
        }
        return React__default.createElement(
          React__default.Fragment,
          null,
          allShipmentInfo[0].shipmentId,
          allShipmentInfo.length > 1 ? React__default.createElement(Popup, {
            content: getAllShipmentId,
            trigger: React__default.createElement(
              "b",
              null,
              React__default.createElement(
                "a",
                { style: { color: "#0A8B8F" } },
                "..."
              )
            )
          }) : ""
        );
      }

      var copyToClipBoard = function copyToClipBoard(data) {
        navigator.clipboard.writeText(data.trim());
      };

      return dataList.map(function (data) {
        var entityId = _this.props.entityId;

        var whatToDisplay = "";

        if (isEmpty(data)) whatToDisplay = "";else {
          if (stringTypeFields[fieldName]) whatToDisplay = data;else {
            // if(fieldName === "purchaseOrder")
            //   data = data.replace(",", ", ")

            if (blockType === "timelineTable") whatToDisplay = _this.renderDateTime({ data: data.split(";") });else whatToDisplay = _this.renderDateTime({
              data: [data.replace(";", ",")]
            });
          }
        }

        var firstPart = whatToDisplay;

        if (stringTypeFields[fieldName] && blockType === "metaTable") firstPart = whatToDisplay.substring(0, 16);

        var mbolLink = Array.isArray(allShipmentInfo) && allShipmentInfo.filter(function (data) {
          return data.masterBolLink;
        });
        var MasterMBOLlink = mbolLink[0] && mbolLink[0].masterBolLink;

        var newFirstPart = fieldName === "masterBolNumber" && data && MasterMBOLlink === undefined ? React__default.createElement(
          "span",
          {
            className: "masterBolNumber2"
            // onClick={() => window.open(`https://www.maersk.com/tracking/${entityId}`, '_blank')} 
          },
          firstPart
        ) : fieldName === "masterBolNumber" && data && MasterMBOLlink !== undefined ? React__default.createElement(
          "span",
          {
            className: "masterBolNumber2",
            onClick: function onClick() {
              copyToClipBoard(data);
              setTimeout(function () {
                window.open("" + MasterMBOLlink, '_blank');
              }, 500);
            }
          },
          firstPart
        ) : React__default.createElement(
          "span",
          null,
          firstPart
        );

        return React__default.createElement(
          "div",
          {
            className: status === "FEES_DUE" || stringTypeFields[fieldName] ? "infoStyle" : ""
          },
          newFirstPart,
          stringTypeFields[fieldName] && blockType === "metaTable" && whatToDisplay.length > 16 ? React__default.createElement(Popup, {
            content: whatToDisplay,
            trigger: React__default.createElement(
              "b",
              null,
              React__default.createElement(
                "a",
                { style: { color: "#0A8B8F" } },
                "..."
              )
            )
          }) : ""
        );
      });
    };

    _this.openContainerPopup = function (e, identifier, isEnable, id) {
      // console.log({ identifier });
      var _this$props = _this.props,
          handleParentState = _this$props.handleParentState,
          archived = _this$props.archived;
      // e.preventDefault();
      // e.stopPropagation()

      _this.setState({ entityId: id });
      handleParentState(id);
      _this.setState({
        showGroundPopuop: false,
        showLineReleasePopuop: false,
        showReadyPickup: false,
        showGateOut: false,
        showGateIn: false
      });
      if (isEnable && !archived) {
        if (identifier === "showGroundPopuop") {
          _this.setState({
            showGroundPopuop: true,
            showLineReleasePopuop: false,
            showReadyPickup: false,
            showGateOut: false,
            showGateIn: false
          });
        } else if (identifier === "showLineReleasePopuop") {
          _this.setState({
            showGroundPopuop: false,
            showLineReleasePopuop: true,
            showReadyPickup: false,
            showGateOut: false,
            showGateIn: false
          });
        } else if (identifier === "showReadyPickup") {
          _this.setState({
            showGroundPopuop: false,
            showLineReleasePopuop: false,
            showReadyPickup: true,
            showGateOut: false,
            showGateIn: false
          });
        } else if (identifier === "showGateOut") {
          _this.setState({
            showGroundPopuop: false,
            showLineReleasePopuop: false,
            showReadyPickup: false,
            showGateOut: true,
            showGateIn: false
          });
        } else {
          _this.setState({
            showGroundPopuop: false,
            showLineReleasePopuop: false,
            showReadyPickup: false,
            showGateOut: false,
            showGateIn: true
          });
        }
      }
    };

    _this.isEnabledField = function (fieldName, isSourceSelected, isCustomReleased, isCarrierReleased, isHold, isFees, isReadyForPickup, isReadyForPickupEnable, isTerminalAppointmentEnable, isGateOutEnable, isDeliveryAppointmentEnable, isActualDeliveryEnable, isTerminalReturnAppEnable, isGateInEnable, isGateOut, isGateOutP44Unable, isGateIn) {
      switch (fieldName) {
        case "grounded":
          return "highlight_border";

        case "carrierReleased":
          return "highlight_border";

          return "";
        case "holds":
          if (isHold) return "highlight_border";

          return "";
        case "fees":
          if (isFees) return "highlight_border";

          return "";
        case "readyForPickup":
          if (isSourceSelected) return "highlight_border";

          return "";
        case "terminalPickupAppointment":
          if (isReadyForPickup) return "highlight_border";

          return "";
        case "gateOut":
          if (isReadyForPickup) return "highlight_border";

          return "";
        case "terminalDropAppointment":
          if (isDeliveryAppointmentEnable) return "highlight_border";

          return "";
        case "warehouseDropAppointment":
          if (isGateOutP44Unable) return "highlight_border";

          return "";
        case "warehousePickupAppointment":
          if (isGateOutP44Unable) return "highlight_border";

          return "";
        case "gateIn":
          if (isCarrierReleased && isGateOut) return "highlight_border";

          return "";
        default:
          return "";
      }
    };

    _this.renderRowHeaders = function (_ref5) {
      var tableData = _ref5.tableData,
          rowHeadersLength = _ref5.rowHeadersLength,
          entityId = _ref5.entityId,
          showContainerModal = _ref5.showContainerModal,
          _ref5$showProgressIco = _ref5.showProgressIcons,
          showProgressIcons = _ref5$showProgressIco === undefined ? false : _ref5$showProgressIco,
          blockType = _ref5.blockType,
          allShipmentInfo = _ref5.allShipmentInfo,
          containerInfo = _ref5.containerInfo;

      return tableData.map(function (_ref6, index) {
        var displayName = _ref6.displayName,
            status = _ref6.status,
            dataList = _ref6.dataList,
            fieldName = _ref6.fieldName,
            compactName = _ref6.compactName;

        if (!containerInfo) return null;
        var _containerInfo$ground = containerInfo.grounded,
            grounded = _containerInfo$ground === undefined ? {} : _containerInfo$ground,
            _containerInfo$custom = containerInfo.customReleased,
            customReleased = _containerInfo$custom === undefined ? {} : _containerInfo$custom,
            _containerInfo$carrie = containerInfo.carrierReleased,
            carrierReleased = _containerInfo$carrie === undefined ? {} : _containerInfo$carrie,
            _containerInfo$holds = containerInfo.holds,
            holds = _containerInfo$holds === undefined ? {} : _containerInfo$holds,
            _containerInfo$fees = containerInfo.fees,
            fees = _containerInfo$fees === undefined ? {} : _containerInfo$fees,
            _containerInfo$readyF = containerInfo.readyForPickup,
            readyForPickup = _containerInfo$readyF === undefined ? {} : _containerInfo$readyF,
            _containerInfo$termin = containerInfo.terminalPickupAppointment,
            _containerInfo$termin2 = containerInfo.terminalDropAppointment,
            _containerInfo$wareho = containerInfo.warehouseDropAppointment,
            warehouseDropAppointment = _containerInfo$wareho === undefined ? {} : _containerInfo$wareho,
            _containerInfo$wareho2 = containerInfo.warehousePickupAppointment,
            _containerInfo$gateOu = containerInfo.gateOut,
            gateOut = _containerInfo$gateOu === undefined ? {} : _containerInfo$gateOu,
            _containerInfo$gateIn = containerInfo.gateIn,
            gateIn = _containerInfo$gateIn === undefined ? {} : _containerInfo$gateIn,
            _containerInfo$done = containerInfo.done,
            _containerInfo$proofO = containerInfo.proofOfGateIn,
            proofOfGateIn = _containerInfo$proofO === undefined ? "" : _containerInfo$proofO;

        var isSourceSelected = grounded.sourceSelected !== "ENTITY_SOURCE_NONE" && grounded.OPSTime;
        var isCustomReleased = customReleased.sourceSelected && customReleased.sourceSelected !== "ENTITY_SOURCE_NONE";
        var isCarrierReleased = carrierReleased.sourceSelected && carrierReleased.sourceSelected !== "ENTITY_SOURCE_NONE";
        var isHold = holds.holdStatus != "NO_HOLD" && holds.holdStatus != "HOLD_REMOVED";
        var isFees = fees.feesStatus != "FEES_PAID" && fees.feesStatus != "NO_DUES";

        var isReadyForPickup = readyForPickup.sourceSelected && readyForPickup.sourceSelected !== "ENTITY_SOURCE_NONE";
        var isGateOut = gateOut.sourceSelected && gateOut.sourceSelected !== "ENTITY_SOURCE_NONE";

        var isGroundedP44 = grounded.sourceSelected && grounded.sourceSelected !== "ENTITY_SOURCE_NONE" && grounded.OPSTime === undefined;

        var isGateOutP44Unable = gateOut.sourceSelected && gateOut.sourceSelected !== "ENTITY_SOURCE_NONE" && gateOut.OPSTime !== undefined;

        var isGateOutP44 = gateOut.sourceSelected && gateOut.sourceSelected === "P44" && gateOut.OPSTime === undefined;

        var warehouseDropAppointmentP44 = warehouseDropAppointment.sourceSelected && warehouseDropAppointment.sourceSelected === "P44" && warehouseDropAppointment.OPSTime === undefined;

        var isGateInP44 = gateIn.sourceSelected && gateIn.sourceSelected === "P44" && gateIn.OPSTime === undefined;

        var isReadyForPickupEnable = isSourceSelected && (isCustomReleased || isSplitChildContainer) && (isCarrierReleased || isAirMode || isSplitChildContainer) && (holds.holdStatus === "NO_HOLD" || holds.holdStatus === "HOLD_REMOVED") && (fees.feesStatus === "FEES_PAID" || fees.feesStatus === "NO_DUES");

        var _this$splitProofOfGat3 = _this.splitProofOfGateIn(proofOfGateIn),
            _this$splitProofOfGat4 = slicedToArray(_this$splitProofOfGat3, 2),
            eirDoc = _this$splitProofOfGat4[0],
            podDoc = _this$splitProofOfGat4[1];

        var isTerminalAppointmentEnable = isReadyForPickupEnable && isReadyForPickup;
        var isGateOutEnable = isReadyForPickupEnable && isReadyForPickup;
        var isDeliveryAppointmentEnable = _this.props.userType === "DRAY_OPS_USER" && isDrayageContainer(get(_this.props, "containerInfo.entityShipmentList", [])) ? isReadyForPickup : isGateOutP44Unable;
        var isActualDeliveryEnable = isGateOut && isGateOutEnable;
        var isTerminalReturnAppEnable = isGateOut && isGateOutEnable;
        var isGateInEnable = isGateOutEnable && isGateOut;
        var isGateIn = (isAirMode || eirDoc) && podDoc && gateIn.sourceSelected && gateIn.sourceSelected !== "ENTITY_SOURCE_NONE";
        var drayagePartner = get(containerInfo, "drayagePartner", null);
        // console.log("checking containerInfo", containerInfo);

        var getProgressStatusColor = function getProgressStatusColor(displayName) {
          if (displayName === "GROUNDED" && isGroundedP44) return "white";
          if (displayName === "GATE OUT" && isGateOutP44) return "white";
          if (displayName === "ACTUAL DELIVERY" && warehouseDropAppointmentP44) return "white";
          if (displayName === "GATE IN") {
            if (drayagePartner && drayagePartner !== "None" && !isGateIn) return "white";else if (isGateInP44) return "white";
          }
          return iconStatusMapping[status].color;
        };

        var checkProgressStatus = function checkProgressStatus(displayName) {
          if (displayName === "GROUNDED" && isGroundedP44) return "circle icon";
          if (displayName === "GATE OUT" && isGateOutP44) return "circle icon";
          if (displayName === "ACTUAL DELIVERY" && warehouseDropAppointmentP44) return "circle icon";
          if (displayName === "GATE IN" && drayagePartner && drayagePartner !== "None") {
            if (!isGateIn && isGateOut && isGateInEnable) {
              return "circle icon highlight_border";
            } else if (!isGateInEnable) {
              return "circle icon";
            }
          } else if (displayName === "GATE IN" && isGateInP44) return "circle icon";
          return iconStatusMapping[status] !== undefined && iconStatusMapping[status].name;
        };

        var isUnprocessed = false;
        if (tableData[index].status === "ENTITY_SOURCE_NONE") {
          if (tableData[index].eModalTime || tableData[index].tModalTime || tableData[index].p44Time) {
            isUnprocessed = true;
          }
        }

        var isUnconfirmed = function isUnconfirmed(displayName) {
          if (displayName === "GATE OUT" && tableData[index].status === "P44" && gateOut.OPSTime === undefined) {
            if (tableData[index].eModalTime || tableData[index].tModalTime || tableData[index].p44Time) {
              return "isUnprocessed";
            }
          }
          if (displayName === "GATE IN" && tableData[index].status === "P44" && gateIn.OPSTime === undefined) {
            if (tableData[index].eModalTime || tableData[index].tModalTime || tableData[index].p44Time) {
              return "isUnprocessed";
            }
          }
          if (displayName === "ACTUAL DELIVERY" && tableData[index].status === "P44" && warehouseDropAppointment.OPSTime === undefined) {
            if (tableData[index].eModalTime || tableData[index].tModalTime || tableData[index].p44Time) {
              return "isUnprocessed";
            }
          }
          if (displayName === "GROUNDED" && tableData[index].status === "P44" && grounded.OPSTime === undefined) {
            if (tableData[index].eModalTime || tableData[index].tModalTime || tableData[index].p44Time) {
              return "isUnprocessed";
            }
          }
        };

        var progressLineStatus = function progressLineStatus() {
          if (displayName === "GATE OUT" && tableData[index].status === "P44" && gateOut.OPSTime === undefined) {
            if (tableData[index].eModalTime || tableData[index].tModalTime || tableData[index].p44Time) {
              return "grey";
            }
          }
          if (displayName === "ACTUAL DELIVERY" && tableData[index].status === "P44" && warehouseDropAppointment.OPSTime === undefined) {
            if (tableData[index].eModalTime || tableData[index].tModalTime || tableData[index].p44Time) {
              return "grey";
            }
          }
          if (displayName === "GROUNDED" && tableData[index].status === "P44" && grounded.OPSTime === undefined) {
            if (tableData[index].eModalTime || tableData[index].tModalTime || tableData[index].p44Time) {
              return "grey";
            }
          }
        };

        var isAirMode = get(containerInfo, "mot", "") === "MOT_AIR";
        var isSplitChildContainer = get(containerInfo, "parentContainerId", "") === "MOT_AIR";

        return React__default.createElement(
          "div",
          {
            className: "flexDisplay " + isUnconfirmed(displayName) + " " + (isUnprocessed ? "isUnprocessed" : ""),
            onClick: function onClick(e) {
              return !isEmpty(statesMapping[fieldName]) && _this.openContainerPopup(e, statesMapping[fieldName].identifier, true, entityId);
            }
          },
          showProgressIcons && React__default.createElement(
            "div",
            {
              className: iconStatusMapping[status] !== undefined && "rowHeader iconClass verticalCentreAlign " + getProgressStatusColor(displayName)
            },
            React__default.createElement(Icon, {
              name: checkProgressStatus(displayName),
              id: fieldName,
              className: _this.isEnabledField(fieldName, isSourceSelected, isCustomReleased || isSplitChildContainer, isCarrierReleased || isAirMode || isSplitChildContainer, isHold || isAirMode || isSplitChildContainer, isFees || isAirMode || isSplitChildContainer, isReadyForPickup, isReadyForPickupEnable, isTerminalAppointmentEnable || isAirMode, isGateOutEnable, isDeliveryAppointmentEnable, isActualDeliveryEnable, isTerminalReturnAppEnable, isGateInEnable, isGateOut, isGateOutP44Unable, isGateIn) + " verticalCentreAlign"
            })
          ),
          React__default.createElement(
            "div",
            { className: "maxContentWidth" },
            React__default.createElement(
              "div",
              { className: "rowWrapper" },
              React__default.createElement(
                "div",
                { className: "rowHeader verticalCentreAlign" },
                React__default.createElement(
                  "div",
                  {
                    className: "headerText" + (showProgressIcons && iconStatusMapping[status] !== undefined && iconStatusMapping[status].color === "red" ? " failedState" : !showProgressIcons ? index !== rowHeadersLength ? " metaHeaderText" : " lastChildMetaHeader" : "")
                  },
                  displayName
                )
              ),
              showProgressIcons && index !== rowHeadersLength && React__default.createElement(
                "div",
                { className: "lineBackground" },
                React__default.createElement("div", {
                  className: iconStatusMapping[status] !== undefined && "progressLine " + progressLineStatus(displayName) + " " + iconStatusMapping[status].progressLineColor
                })
              )
            ),
            React__default.createElement(
              "div",
              {
                className: "dataDisplay" + (index === 0 && showProgressIcons ? " firstState" : "")
              },
              _this.renderData({
                status: status,
                dataList: dataList,
                fieldName: fieldName,
                blockType: blockType,
                allShipmentInfo: allShipmentInfo,
                isGateInEnable: isGateInEnable,
                containerInfo: containerInfo,
                isAirMode: isAirMode
              })
            ),
            React__default.createElement(
              "div",
              {
                className: "dataDisplay" + (index === 0 && showProgressIcons ? " firstState" : "")
              },
              _this.renderDoDocument({
                displayName: displayName,
                containerInfo: containerInfo,
                dataList: dataList
              })
            )
          )
        );
      });

      // return tableData.map(({ displayName, status, dataList, fieldName, compactName }, index) => (

      //   <div className={`flexDisplay ${tableData[index].status === "ENTITY_SOURCE_NONE" && (tableData[index].eModalTime || tableData[index].tModalTime) ? "isUnprocessed" : ""}`} onClick={(e) => !isEmpty(statesMapping[fieldName]) && this.openContainerPopup(e, statesMapping[fieldName].identifier, true, entityId)}>
      //     {/* {!iconStatusMapping[status] && console.log({ displayName, status })} */}
      //     {console.log("displayname12:",dataList)}
      //     {console.log("irsh:",tableData[index].status)}
      //     {showProgressIcons &&
      //       <div className={`rowHeader iconClass verticalCentreAlign ${iconStatusMapping[status].color}`}>
      //         <Icon name={iconStatusMapping[status].name} className={`${dataList.length>0 && (fieldName !='holds' && fieldName !='fees') ? 'highlight_border':''} verticalCentreAlign`} />
      //       </div>
      //     }
      //     <div className="maxContentWidth">
      //       <div className="rowWrapper">
      //         <div className='rowHeader verticalCentreAlign'>
      //           <div className={`headerText${showProgressIcons && iconStatusMapping[status].color === 'red' ? ' failedState' : !showProgressIcons ? index !== rowHeadersLength ? ' metaHeaderText' : ' lastChildMetaHeader' : ''}`}>
      //             {/* {showContainerModal ? compactName : displayName} */}
      //             {displayName}
      //           </div>
      //           {/* {showProgressIcons && index !== rowHeadersLength && <div className={`progressLine ${iconStatusMapping[status].progressLineColor}`} />} */}
      //         </div>
      //         {showProgressIcons && index !== rowHeadersLength && <div className="lineBackground"><div className={`progressLine ${iconStatusMapping[status].progressLineColor}`} /></div>}
      //       </div>
      //       <div className={`dataDisplay${index === 0 && showProgressIcons ? ' firstState' : ''}`}>
      //         {this.renderData({ status, dataList, fieldName, blockType, allShipmentInfo })}
      //       </div>
      //     </div>

      //   </div>
      // ))
    };

    _this.state = {
      showGroundPopuop: false,
      showLineReleasePopuop: false,
      showReadyPickup: false,
      showGateOut: false,
      showGateIn: false,
      isNewLoading: false,
      isMarkDone: false,
      isMarkDisable: false,
      doneTime: null,
      gateInIcon: false
    };
    return _this;
  }

  createClass(ContainerTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          tableData = _props.tableData,
          data = _props.data,
          showContainerModal = _props.showContainerModal,
          entityId = _props.entityId,
          metaData$$1 = _props.metaData,
          allShipmentInfo = _props.allShipmentInfo,
          containerInfo = _props.containerInfo,
          isSourceSelected = _props.isSourceSelected,
          terminalLink = _props.terminalLink,
          isPodInland = _props.isPodInland;

      return React__default.createElement(
        Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "tableWrapper" },
          React__default.createElement(BlockHeader, { data: data, terminalLink: terminalLink, isPodInland: isPodInland }),
          React__default.createElement("hr", null),
          React__default.createElement(
            "div",
            { className: "flexDisplay rowSpacing" },
            this.renderRowHeaders({
              tableData: tableData,
              rowHeadersLength: tableData.length - 1,
              entityId: entityId,
              showContainerModal: showContainerModal,
              showProgressIcons: true,
              blockType: "timelineTable",
              containerInfo: containerInfo,
              isSourceSelected: isSourceSelected
            })
          ),
          React__default.createElement("hr", { className: "horizantalDivider" }),
          React__default.createElement(
            "div",
            { className: "flexDisplay rowSpacing metaTable" },
            this.renderRowHeaders({
              tableData: metaData$$1,
              rowHeadersLength: metaData$$1.length - 1,
              entityId: entityId,
              showContainerModal: showContainerModal,
              showProgressIcons: false,
              blockType: "metaTable",
              allShipmentInfo: allShipmentInfo,
              containerInfo: containerInfo,
              isSourceSelected: isSourceSelected
            })
          ),
          React__default.createElement("hr", { className: "horizantalDivider" })
        )
      );
    }
  }]);
  return ContainerTable;
}(Component);

var css_248z$9 = ".popup-calendor {\n  display: flex; }\n  .popup-calendor .topSpace {\n    padding-top: 5%; }\n  .popup-calendor .system-time-picker span {\n    margin: 0 2px;\n    display: inline-block; }\n  .popup-calendor .system-time-picker .or-or-text {\n    font-weight: 500;\n    vertical-align: super; }\n  .popup-calendor .system-time-picker .select-system-time {\n    background: #008B8F;\n    width: 27px;\n    height: 28px;\n    border-radius: 3px;\n    border: 1px solid #305E85;\n    display: flex;\n    justify-content: space-evenly;\n    flex-wrap: wrap; }\n  .popup-calendor .system-time-picker.is-disable {\n    cursor: auto;\n    pointer-events: none; }\n    .popup-calendor .system-time-picker.is-disable .select-system-time {\n      background: #008B8F;\n      background: #bdc6c6;\n      border: 1px solid #9099a1; }\n  .popup-calendor .react-datepicker__time-container {\n    width: 90px !important; }\n  .popup-calendor .system-time-picker:hover {\n    cursor: pointer; }\n  .popup-calendor .row-1 .topSpace, .popup-calendor .row-2 .topSpace {\n    padding-top: 8%; }\n";
styleInject(css_248z$9);

var Calendar = function (_Component) {
  inherits(Calendar, _Component);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

    _this.findUtcOffset = function (timezone) {
      var s = timezone.substr(3); // Get rid of UTC, s= "+05:00"
      var sign = s[0]; // "+""
      var x = s.substr(1, 2) * 60 + parseInt(s.substr(4, 5));
      return sign + x;
    };

    _this.timeZoneConverter = function (value, source) {
      var entityTimezone = _this.props.entityTimezone;

      var time = new Date(value).getTime();
      // console.log({ value, source, entityTimezone, time});

      if (!isEmpty(entityTimezone)) {
        // let utcOffset = Number(this.findUtcOffset(entityTimezone))
        // let now = new Date(value);
        // let localOffset =  -now.getTimezoneOffset();  

        // let hoursDiff = +(localOffset) - (utcOffset)
        // let currentTzMiliSec = now.getTime() +  hoursDiff*60*1000;


        var localTime = moment$1(value);
        // console.log({ localTime, entityTimezone });
        var timeZoneTime = moment$1(value).tz(entityTimezone);
        var modifiedDate = moment$1(value);

        modifiedDate.subtract(-localTime.utcOffset() + timeZoneTime.utcOffset(), 'minutes');

        if (source === 'OPS') {
          _this.setState({ opsTime: value, currentDate: time });
        } else {
          _this.setState({ demurrageTime: value, currentDate2: time });
        }
      } else {
        // console.log('addadasd', value.getTime());
        if (source === 'OPS') {
          _this.setState({ opsTime: time, currentDate: time });
        } else {
          _this.setState({ currentDate2: time });
        }
      }
    };

    _this.timeZoneReverse = function (value) {
      if (!isEmpty(value) && !isUndefined(value)) {
        var entityTimezone = _this.props.entityTimezone;

        if (!isEmpty(entityTimezone)) {
          var parsedTime = parseInt(value);

          // UTC logic to convert time zone
          // let utcOffset = Number(this.findUtcOffset(entityTimezone))
          // let localOffset =  - new Date().getTimezoneOffset();
          // let hoursDiff = +(localOffset) - (utcOffset)
          // let currentTzMiliSec = value -  hoursDiff*60*1000;

          // string time zone logic 
          var localTime = moment$1(parsedTime);
          var timeZoneTime = moment$1(parsedTime).tz(entityTimezone);
          var modifiedDate = moment$1(parsedTime);
          modifiedDate.subtract(localTime.utcOffset() - timeZoneTime.utcOffset(), 'minutes');
          return modifiedDate.valueOf();
        }
      }
    };

    _this.renderSystemTimePicker = function (_ref) {
      var enableModel = _ref.enableModel,
          showSystemTimeFunc = _ref.showSystemTimeFunc;
      return React__default.createElement(
        'div',
        { className: 'system-time-picker ' + (enableModel ? '' : 'is-disable') },
        React__default.createElement(
          'span',
          { className: 'select-system-time', onClick: showSystemTimeFunc },
          React__default.createElement('img', { src: modalIcon, alt: 'modal icon' })
        )
      );
    };

    _this.isValidDate = function (dateString, dateFormat) {
      try {
        var parsedDate = parse(dateString, dateFormat, new Date(), { awareOfUnicodeTokens: true });

        if (isValid(parsedDate)) {
          var year = parsedDate.getFullYear();

          var minYear = 1900;
          var maxYear = 2100;

          if (year >= minYear && year <= maxYear) {
            return true;
          }
        }
      } catch (error) {
        console.error('Error parsing or validating date:', error);
      }

      return false;
    };

    var _props$selectedDate = props.selectedDate,
        selectedDate = _props$selectedDate === undefined ? null : _props$selectedDate,
        _props$selectedDate2 = props.selectedDate2,
        selectedDate2 = _props$selectedDate2 === undefined ? null : _props$selectedDate2;

    _this.state = {
      opsTime: selectedDate,
      demurrageTime: selectedDate2,
      currentDate: null,
      currentDate2: null,
      currentDate3: null,
      showErrorForDocument: false,
      isOnGateInGreaterThanGateOut: false,
      isOnGateOutGreaterThanGateIn: false
    };
    //console.log("gateOut ===", this.props.gateOut)
    return _this;
  }

  createClass(Calendar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          selectedDate = _props.selectedDate,
          selectedDate2 = _props.selectedDate2,
          selectedDate3 = _props.selectedDate3,
          triggerApiCall = _props.triggerApiCall,
          eventName = _props.eventName,
          calendarIdentifire = _props.calendarIdentifire,
          OPSTime = _props.OPSTime,
          OPSTime2 = _props.OPSTime2,
          eModalTime = _props.eModalTime,
          tModalTime = _props.tModalTime,
          p44Time = _props.p44Time,
          entityId = _props.entityId,
          _props$entityTimezone = _props.entityTimezone,
          entityTimezone = _props$entityTimezone === undefined ? "" : _props$entityTimezone,
          entityType = _props.entityType,
          showSystemTimeFunc = _props.showSystemTimeFunc,
          holdStatus = _props.holdStatus,
          feesStatus = _props.feesStatus,
          renderApiCallForHoldFees = _props.renderApiCallForHoldFees,
          commentEntityEventId = _props.commentEntityEventId,
          displayName = _props.displayName,
          isArchived = _props.isArchived,
          proofOfGateIn = _props.proofOfGateIn,
          epochToUtc = _props.epochToUtc,
          drayagePartner = _props.drayagePartner,
          _state = this.state,
          opsTime = _state.opsTime,
          currentDate = _state.currentDate,
          currentDate2 = _state.currentDate2,
          currentDate3 = _state.currentDate3,
          showErrorForDocument = _state.showErrorForDocument,
          isOnGateInGreaterThanGateOut = _state.isOnGateInGreaterThanGateOut,
          isOnGateOutGreaterThanGateIn = _state.isOnGateOutGreaterThanGateIn;


      var enableModel = !isEmpty(OPSTime) || !isEmpty(eModalTime) || !isEmpty(tModalTime) || !isEmpty(p44Time);
      var incomingDate = !isEmpty(entityTimezone) ? this.timeZoneReverse(selectedDate) : parseInt(selectedDate);
      var incomingDate2 = !isEmpty(entityTimezone) ? this.timeZoneReverse(selectedDate2) : parseInt(selectedDate2);
      var incomingDate3 = !isEmpty(entityTimezone) ? this.timeZoneReverse(selectedDate3) : parseInt(selectedDate3);

      var opsSelectedTime = currentDate || incomingDate;
      var demurrageSelectedTime = currentDate2 || incomingDate2;
      var lfdSelectedTime = currentDate3 || incomingDate3;

      return React__default.createElement(
        Fragment,
        null,
        calendarIdentifire === 'readyForPickup' || calendarIdentifire === 'gateOut' ? React__default.createElement(
          'div',
          { className: 'popup-calendor' },
          React__default.createElement(
            'div',
            { className: 'conta-1' },
            React__default.createElement(
              'div',
              { className: 'row-1 flexDisplay' },
              React__default.createElement(
                'div',
                { className: 'popup-date-picker' },
                React__default.createElement(
                  'p',
                  null,
                  'Ops time'
                ),
                React__default.createElement(DatePicker, {
                  title: 'Select time',
                  placeholderText: 'Select time',
                  id: "vessel-departure-date",
                  name: 'etd',
                  selected: opsSelectedTime,
                  onChange: function onChange(value) {
                    if (_this2.isValidDate(value, "MMMM d, yyyy h:mm aa")) {
                      _this2.timeZoneConverter(value, 'OPS');
                    } else {
                      console.error('Invalid date format selected ops.');
                    }
                  },
                  showTimeSelect: true,
                  timeFormat: 'hh:mm a',
                  timeIntervals: 15,
                  timeCaption: 'time',
                  dateCaption: 'Select time',
                  dateFormat: 'MMMM d, yyyy h:mm aa',
                  disabled: isArchived,
                  peekNextMonth: true,
                  showMonthDropdown: true,
                  showYearDropdown: true,
                  dropdownMode: "select",
                  popperPlacement: 'bottom-end',
                  onKeyDown: function onKeyDown(e) {
                    var data = {
                      entityId: entityId,
                      eventName: eventName,
                      entityType: entityType,
                      eventCode: '',
                      eventDescription: '',
                      sourceSelected: 'OPS',
                      selectedTime: epochToUtc(opsSelectedTime),
                      selectedTime2: demurrageSelectedTime,
                      commentEntityEventId: commentEntityEventId
                    };
                    if (e.keyCode === 13) {
                      if (eventName === 'GATE_OUT') {
                        console.log("this.props.gateInInfo ", _this2.props.gateInInfo);
                        console.log("opsSelectedTime ", opsSelectedTime);
                        if (_this2.props.gateInInfo && _this2.props.gateInInfo.OPSTime && data.selectedTime > _this2.props.gateInInfo.OPSTime) {
                          _this2.setState({ "isOnGateOutGreaterThanGateIn": true });
                          return;
                        } else {
                          _this2.setState({ "isOnGateOutGreaterThanGateIn": false });
                        }
                      }
                      if (opsSelectedTime && demurrageSelectedTime) {
                        triggerApiCall(e, data);
                      }
                    }
                  },
                  popperProps: {
                    positionFixed: true // prevents the popper from hiding behind overflow parent
                  },
                  popperModifiers: {
                    flip: {
                      behavior: ["bottom"] // don't allow it to flip to be above
                    },
                    preventOverflow: {
                      enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                    },
                    hide: {
                      enabled: false // turn off since needs preventOverflow to be enabled
                    }
                  }
                })
              ),
              React__default.createElement(
                'div',
                { className: 'topSpace flexDisplay' },
                React__default.createElement(
                  'div',
                  { className: 'button-container' },
                  React__default.createElement(
                    'button',
                    {
                      className: 'ui primary button',
                      disabled: isArchived,
                      onClick: function onClick(e) {
                        var data = {
                          entityId: entityId,
                          eventName: eventName,
                          entityType: entityType,
                          eventCode: '',
                          eventDescription: '',
                          sourceSelected: 'OPS',
                          selectedTime: epochToUtc(opsSelectedTime),
                          selectedTime2: demurrageSelectedTime,
                          commentEntityEventId: commentEntityEventId
                        };
                        if (eventName === 'GATE_OUT') {
                          console.log("this.props.gateInInfo ", _this2.props.gateInInfo);
                          console.log("opsSelectedTime ", opsSelectedTime);
                          if (_this2.props.gateInInfo && _this2.props.gateInInfo.OPSTime && data.selectedTime > _this2.props.gateInInfo.OPSTime) {
                            _this2.setState({ "isOnGateOutGreaterThanGateIn": true });
                            return;
                          } else {
                            _this2.setState({ "isOnGateOutGreaterThanGateIn": false });
                          }
                        }
                        if (opsSelectedTime && demurrageSelectedTime) {
                          triggerApiCall(e, data);
                        }
                      }
                    },
                    'Y'
                  )
                ),
                this.renderSystemTimePicker({ enableModel: enableModel, showSystemTimeFunc: showSystemTimeFunc })
              )
            ),
            isOnGateOutGreaterThanGateIn && React__default.createElement(Message, {
              header: '',
              content: 'The Gate-Out Date must be earlier than or equal to the Gate-In Date. Please adjust the Gate-In Date accordingly',
              color: 'red',
              className: 'update_popup_error_doc'
            }),
            React__default.createElement(
              'div',
              { className: 'row-2 flexDisplay' },
              React__default.createElement(
                'div',
                { className: 'popup-date-picker' },
                React__default.createElement(
                  'p',
                  null,
                  calendarIdentifire === 'readyForPickup' ? "Demurrage time" : "Per Diem time"
                ),
                React__default.createElement(DatePicker, {
                  title: 'Select time',
                  placeholderText: 'Select time',
                  id: "vessel-departure-date2",
                  name: 'etd',
                  selected: demurrageSelectedTime,
                  onChange: function onChange(value) {
                    if (_this2.isValidDate(value, "MMMM d, yyyy h:mm aa")) {
                      _this2.timeZoneConverter(value, 'DEM');
                    } else {
                      console.error('Invalid date format selected DEM.');
                    }
                  },
                  showTimeSelect: true,
                  timeFormat: 'hh:mm a',
                  timeIntervals: 15,
                  timeCaption: 'time',
                  dateCaption: 'Select time',
                  dateFormat: 'MMMM d, yyyy h:mm aa',
                  disabled: isArchived,
                  peekNextMonth: true,
                  showMonthDropdown: true,
                  showYearDropdown: true,
                  dropdownMode: "select",
                  popperPlacement: 'bottom-end',
                  onKeyDown: function onKeyDown(e) {
                    if (e.keyCode === 13) {
                      if (opsSelectedTime && demurrageSelectedTime) {
                        triggerApiCall(e, {
                          entityId: entityId,
                          eventName: eventName,
                          entityType: entityType,
                          eventCode: '',
                          eventDescription: '',
                          sourceSelected: 'OPS',
                          selectedTime: epochToUtc(opsSelectedTime),
                          selectedTime2: demurrageSelectedTime,
                          commentEntityEventId: commentEntityEventId
                        });
                      }
                    }
                  },
                  popperProps: {
                    positionFixed: true // prevents the popper from hiding behind overflow parent
                  }
                })
              ),
              React__default.createElement(
                'div',
                { className: 'topSpace flexDisplay' },
                React__default.createElement(
                  'div',
                  { className: 'button-container' },
                  React__default.createElement(
                    'button',
                    {
                      className: 'ui primary button',
                      disabled: isArchived,
                      onClick: function onClick(e) {
                        if (opsSelectedTime && demurrageSelectedTime) {
                          triggerApiCall(e, {
                            entityId: entityId,
                            eventName: eventName,
                            entityType: entityType,
                            eventCode: '',
                            eventDescription: '',
                            sourceSelected: 'OPS',
                            selectedTime: epochToUtc(opsSelectedTime),
                            selectedTime2: demurrageSelectedTime,
                            commentEntityEventId: commentEntityEventId
                          });
                        }
                      }
                    },
                    'Y'
                  )
                ),
                this.renderSystemTimePicker({ enableModel: enableModel, showSystemTimeFunc: showSystemTimeFunc })
              )
            ),
            calendarIdentifire === "readyForPickup" && selectedDate3 && React__default.createElement(
              'div',
              { className: 'row-2 flexDisplay' },
              React__default.createElement(
                'div',
                { className: 'popup-date-picker' },
                React__default.createElement(
                  'p',
                  null,
                  calendarIdentifire === 'readyForPickup' && "LFD time"
                ),
                React__default.createElement(DatePicker, {
                  disabled: isArchived
                  // title="Select time"
                  , placeholderText: 'Select time',
                  id: "vessel-departure-date2",
                  name: 'etd',
                  selected: lfdSelectedTime
                  /* onChange={(value) => {
                    this.timeZoneConverter(value, 'DEM')
                  }} */
                  , showTimeSelect: true,
                  timeFormat: 'hh:mm a',
                  timeIntervals: 15,
                  timeCaption: 'time',
                  dateCaption: 'Select time',
                  dateFormat: 'MMMM d, yyyy h:mm aa'
                  //disabled={isfDisabled}
                  , peekNextMonth: true,
                  showMonthDropdown: true,
                  showYearDropdown: true,
                  dropdownMode: "select",
                  popperPlacement: 'bottom-end',
                  popperProps: {
                    positionFixed: true // prevents the popper from hiding behind overflow parent
                  }
                })
              )
            )
          )
        ) : React__default.createElement(
          'div',
          { className: 'popup-calendor' },
          React__default.createElement(
            'div',
            { className: 'popup-date-picker' },
            React__default.createElement(
              'p',
              null,
              'Ops time'
            ),
            React__default.createElement(DatePicker, {
              title: 'Select time',
              placeholderText: 'Select time',
              id: "vessel-departure-date",
              name: 'etd',
              selected: opsSelectedTime,
              onChange: function onChange(value) {
                if (_this2.isValidDate(value, "MMM d, yyyy h:mm aa")) {
                  _this2.timeZoneConverter(value, 'OPS');
                } else {
                  console.error('Invalid date format selected.');
                }
              },
              showTimeSelect: 'true',
              timeFormat: 'hh:mm a',
              timeIntervals: 15,
              timeCaption: 'time',
              dateCaption: 'Select time',
              dateFormat: 'MMM d, yyyy h:mm aa',
              disabled: displayName !== "GATE IN" && isArchived,
              peekNextMonth: true,
              showMonthDropdown: true,
              showYearDropdown: true,
              dropdownMode: "select",
              popperPlacement: 'bottom-end',
              onKeyDown: function () {
                var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                  var data;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(e.keyCode === 13)) {
                            _context.next = 19;
                            break;
                          }

                          if (!opsTime) {
                            _context.next = 19;
                            break;
                          }

                          if (!(displayName == "GATE IN" && drayagePartner && !proofOfGateIn)) {
                            _context.next = 5;
                            break;
                          }

                          _this2.setState({ showErrorForDocument: true });
                          return _context.abrupt('return');

                        case 5:
                          data = { entityId: entityId, eventName: eventName, eventCode: '', eventDescription: '', sourceSelected: 'OPS', selectedTime: epochToUtc(opsTime), entityType: entityType, commentEntityEventId: commentEntityEventId };

                          if (!(displayName == "GATE IN")) {
                            _context.next = 14;
                            break;
                          }

                          data["archived"] = true;
                          console.log("gateOutInfo ===", _this2.props.gateOutInfo);
                          console.log("gateIn ===", data);

                          if (!(_this2.props.gateOutInfo && data.selectedTime < _this2.props.gateOutInfo.OPSTime)) {
                            _context.next = 13;
                            break;
                          }

                          _this2.setState({ "isOnGateInGreaterThanGateOut": true });
                          return _context.abrupt('return');

                        case 13:
                          _this2.setState({ "isOnGateInGreaterThanGateOut": false });

                        case 14:
                          console.log("GATE OUT", _this2.props.gateOut);
                          // alert("Calender")
                          _context.next = 17;
                          return triggerApiCall(e, data);

                        case 17:
                          _this2.setState({ currentDate: null });

                          holdStatus === "NO_HOLD" || holdStatus === "ON_HOLD" || feesStatus === "NO_DUES" || feesStatus === "FEES_DUE" || feesStatus === "FEES_PAID" || calendarIdentifire === "terminalPickupAppointment" || calendarIdentifire === "terminalDropAppointment" || calendarIdentifire === "warehouseDropAppointment" || calendarIdentifire === "warehousePickupAppointment" || calendarIdentifire === "gateIn" ? "" : renderApiCallForHoldFees(e, { commentEntityEventId: commentEntityEventId, entityId: entityId });

                        case 19:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }(),
              popperProps: {
                positionFixed: true // prevents the popper from hiding behind overflow parent
              },
              popperModifiers: calendarIdentifire !== 'gateOut' && calendarIdentifire !== 'gateIn' && {
                flip: {
                  behavior: ["bottom"] // don't allow it to flip to be above
                },
                preventOverflow: {
                  enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                },
                hide: {
                  enabled: false // turn off since needs preventOverflow to be enabled
                }
              }
            })
          ),
          React__default.createElement(
            'div',
            { className: 'topSpace flexDisplay' },
            React__default.createElement(
              'div',
              { className: 'button-container' },
              React__default.createElement(
                'button',
                { className: 'ui primary button',
                  disabled: displayName !== "GATE IN" && isArchived,
                  onClick: function () {
                    var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
                      var data;
                      return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              //alert(displayName);
                              e.persist();

                              if (!opsTime) {
                                _context2.next = 18;
                                break;
                              }

                              if (!(displayName == "GATE IN" && drayagePartner && !proofOfGateIn)) {
                                _context2.next = 5;
                                break;
                              }

                              _this2.setState({ showErrorForDocument: true });
                              return _context2.abrupt('return');

                            case 5:
                              data = { entityId: entityId, eventName: eventName, eventCode: '', eventDescription: '', sourceSelected: 'OPS', selectedTime: epochToUtc(opsTime), entityType: entityType, commentEntityEventId: commentEntityEventId };

                              if (!(displayName == "GATE IN")) {
                                _context2.next = 14;
                                break;
                              }

                              data["archived"] = true;
                              console.log("gateOutInfo ===", _this2.props.gateOutInfo);
                              console.log("gateIn ===", data);

                              if (!(_this2.props.gateOutInfo && data.selectedTime < _this2.props.gateOutInfo.OPSTime)) {
                                _context2.next = 13;
                                break;
                              }

                              _this2.setState({ "isOnGateInGreaterThanGateOut": true });
                              return _context2.abrupt('return');

                            case 13:
                              _this2.setState({ "isOnGateInGreaterThanGateOut": false });

                            case 14:
                              _context2.next = 16;
                              return triggerApiCall(e, data);

                            case 16:
                              _this2.setState({ currentDate: null });

                              holdStatus === "NO_HOLD" || holdStatus === "ON_HOLD" || feesStatus === "NO_DUES" || feesStatus === "FEES_DUE" || feesStatus === "FEES_PAID" || calendarIdentifire === "terminalPickupAppointment" || calendarIdentifire === "terminalDropAppointment" || calendarIdentifire === "warehouseDropAppointment" || calendarIdentifire === "warehousePickupAppointment" || calendarIdentifire === "gateIn" ? "" : renderApiCallForHoldFees(e, { commentEntityEventId: commentEntityEventId, entityId: entityId });

                            case 18:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this2);
                    }));

                    return function (_x2) {
                      return _ref3.apply(this, arguments);
                    };
                  }() },
                'Y '
              )
            ),
            calendarIdentifire !== 'carrierReleased' ? this.renderSystemTimePicker({ enableModel: enableModel, showSystemTimeFunc: showSystemTimeFunc }) : null
          )
        ),
        showErrorForDocument && React__default.createElement(Message, {
          header: '',
          content: 'Document not uploaded.',
          color: 'red',
          className: 'update_popup_error_doc'
        }),
        isOnGateInGreaterThanGateOut && React__default.createElement(Message, {
          header: '',
          content: 'The Gate-In Date must be later than or equal to the Gate-Out Date. Please adjust the Gate-In Date accordingly',
          color: 'red',
          className: 'update_popup_error_doc'
        })
      );
    }
  }]);
  return Calendar;
}(Component);

var css_248z$a = ".popup-calendor.demTopSpace {\n  margin-top: 3%; }\n\n.tableStyle.ui.table {\n  margin: 0; }\n\n.goBackIcon.ui.button {\n  background: #008B8F;\n  width: 27px;\n  height: 28px;\n  border: 1px solid #305E85;\n  margin-left: 7%; }\n\n.goBackIcon.ui.icon.button > .icon, .goBackIcon.ui.icon.buttons .goBackIcon.button > .icon {\n  color: #FFFFFF; }\n\n.action {\n  border: 1px solid black;\n  padding: 1px 6px;\n  cursor: pointer; }\n\n.popup-title, .or-or-text, .popup-source-section p {\n  color: #020303;\n  font-weight: 700;\n  margin: 0 auto;\n  font-size: 12px; }\n";
styleInject(css_248z$a);

var StateTimeSeriesModal = function (_Component) {
  inherits(StateTimeSeriesModal, _Component);

  function StateTimeSeriesModal(props) {
    classCallCheck(this, StateTimeSeriesModal);

    var _this = possibleConstructorReturn(this, (StateTimeSeriesModal.__proto__ || Object.getPrototypeOf(StateTimeSeriesModal)).call(this, props));

    _this.findUtcOffset = function (timezone) {
      var s = timezone.substr(3); // Get rid of UTC, s= "+05:00"
      var sign = s[0]; // "+""
      var x = s.substr(1, 2) * 60 + parseInt(s.substr(4, 5));
      return sign + x;
    };

    _this.timeZoneConverter = function (value) {
      var entityTimezone = _this.props.entityTimezone;

      var time = new Date(value).getTime();

      if (!isEmpty(entityTimezone)) {
        _this.setState({ modelEvent: "OPS" });
        var localTime = moment$1(value);
        var timeZoneTime = moment$1(value).tz(entityTimezone);
        var modifiedDate = moment$1(value);

        modifiedDate.subtract(-localTime.utcOffset() + timeZoneTime.utcOffset(), 'minutes');
        // if(source === 'OPS') {
        //   this.setState({opsTime:modifiedDate.valueOf(), newOpsTime:time})
        // } else {
        _this.setState({ demurrageTime: modifiedDate.valueOf(), newDemurrageTime: time });
        // }
      } else {
        // if(source === 'OPS') {
        //   this.setState({ opsTime: time, currentDate: time });
        // } else {
        _this.setState({ currentDate2: time });
        // }
        // this.setState({opsTime:time})
      }
    };

    _this.timeZoneReverse = function (value) {
      if (!isEmpty(value) && !isUndefined(value)) {
        var entityTimezone = _this.props.entityTimezone;

        if (!isEmpty(entityTimezone)) {
          var parsedTime = parseInt(value);
          // string time zone logic 
          var localTime = moment$1(parsedTime);
          var timeZoneTime = moment$1(parsedTime).tz(entityTimezone);
          var modifiedDate = moment$1(parsedTime);
          modifiedDate.subtract(localTime.utcOffset() - timeZoneTime.utcOffset(), 'minutes');
          return modifiedDate.valueOf();
        }
      }
    };

    _this.renderRow = function (_ref) {
      var OPSTime = _ref.OPSTime,
          time = _ref.time,
          text = _ref.text,
          sourceSelected = _ref.sourceSelected,
          type = _ref.type,
          convertEpochToDate = _ref.convertEpochToDate,
          selectModelTime = _ref.selectModelTime,
          entityId = _ref.entityId,
          eventName = _ref.eventName,
          entityType = _ref.entityType,
          selectedField = _ref.selectedField,
          entityTimezone = _ref.entityTimezone,
          openDateCalendar = _ref.openDateCalendar,
          commentEntityEventId = _ref.commentEntityEventId;
      return React__default.createElement(
        Table.Row,
        null,
        React__default.createElement(
          Table.Cell,
          null,
          convertEpochToDate(time, false, true, entityTimezone)
        ),
        React__default.createElement(
          Table.Cell,
          null,
          text,
          " ",
          sourceSelected === type && OPSTime && '*'
        ),
        React__default.createElement(
          Table.Cell,
          null,
          React__default.createElement(
            "div",
            { className: "flexDisplay" },
            React__default.createElement(
              "span",
              { className: "action", onClick: function onClick(e) {
                  var _this$props = _this.props,
                      holdStatus = _this$props.holdStatus,
                      feesStatus = _this$props.feesStatus;


                  if (selectedField === 'readyForPickup' || selectedField === 'gateOut') {
                    _this.setState({ modelEvent: type, modelTime: time, eventName: eventName, skipTzConversion: true });
                  } else {
                    if (selectedField === 'gateIn' && !_this.props.proofOfGateIn && _this.props.isDray) {
                      _this.setState({ errorMessage: 'Gate In proof of documents are required.' });
                      setTimeout(function () {
                        _this.setState({ errorMessage: '' });
                        openDateCalendar();
                      }, 2000);
                      return;
                    }
                    selectModelTime(e, { entityId: entityId, type: type, time: time, eventName: eventName, entityType: entityType, entityTimezone: entityTimezone, selectedType: selectedField, holdStatus: holdStatus, feesStatus: feesStatus, commentEntityEventId: commentEntityEventId });
                    _this.setState({ skipTzConversion: false });
                  }
                }
              },
              "Y"
            ),
            React__default.createElement(Button, {
              icon: "angle double left",
              className: "goBackIcon",
              onClick: openDateCalendar
            })
          )
        )
      );
    };

    _this.renderTableBody = function (_ref2) {
      var eModalTime = _ref2.eModalTime,
          OPSTime = _ref2.OPSTime,
          tModalTime = _ref2.tModalTime,
          p44Time = _ref2.p44Time,
          sourceSelected = _ref2.sourceSelected,
          convertEpochToDate = _ref2.convertEpochToDate,
          selectedField = _ref2.selectedField,
          entityTimezone = _ref2.entityTimezone,
          commentEntityEventId = _ref2.commentEntityEventId;
      var _this$props2 = _this.props,
          entityId = _this$props2.entityId,
          eventName = _this$props2.eventName,
          selectModelTime = _this$props2.selectModelTime,
          entityType = _this$props2.entityType,
          openDateCalendar = _this$props2.openDateCalendar;

      if (!isEmpty(eModalTime) || !isEmpty(OPSTime) || !isEmpty(tModalTime) || !isEmpty(p44Time)) {
        return React__default.createElement(
          Table.Body,
          null,
          !isEmpty(eModalTime) && _this.renderRow({ OPSTime: OPSTime, time: eModalTime, text: 'E-Modal', sourceSelected: sourceSelected, type: 'EMODAL', convertEpochToDate: convertEpochToDate, selectModelTime: selectModelTime, entityId: entityId, eventName: eventName, entityType: entityType, selectedField: selectedField, entityTimezone: entityTimezone, openDateCalendar: openDateCalendar, commentEntityEventId: commentEntityEventId }),
          !isEmpty(tModalTime) && _this.renderRow({ OPSTime: OPSTime, time: tModalTime, text: 'T-Modal', sourceSelected: sourceSelected, type: 'TMODAL', convertEpochToDate: convertEpochToDate, selectModelTime: selectModelTime, entityId: entityId, eventName: eventName, entityType: entityType, selectedField: selectedField, entityTimezone: entityTimezone, openDateCalendar: openDateCalendar, commentEntityEventId: commentEntityEventId }),
          !isEmpty(OPSTime) && _this.renderRow({ OPSTime: OPSTime, time: OPSTime, text: 'Ops', sourceSelected: sourceSelected, type: 'OPS', convertEpochToDate: convertEpochToDate, selectModelTime: selectModelTime, entityId: entityId, eventName: eventName, entityType: entityType, selectedField: selectedField, entityTimezone: entityTimezone, openDateCalendar: openDateCalendar, commentEntityEventId: commentEntityEventId }),
          !isEmpty(p44Time) && _this.renderRow({ OPSTime: OPSTime, time: p44Time, text: 'P44', sourceSelected: sourceSelected, type: 'P44', convertEpochToDate: convertEpochToDate, selectModelTime: selectModelTime, entityId: entityId, eventName: eventName, entityType: entityType, selectedField: selectedField, entityTimezone: entityTimezone, openDateCalendar: openDateCalendar, commentEntityEventId: commentEntityEventId })
        );
      }
    };

    _this.renderTableHeaders = function () {
      return React__default.createElement(
        Table.Header,
        null,
        React__default.createElement(
          Table.Row,
          null,
          " ",
          tableHeaders.map(function (header) {
            return React__default.createElement(
              Table.HeaderCell,
              null,
              header
            );
          }),
          " "
        )
      );
    };

    var _props$selectedDate = props.selectedDate2,
        selectedDate2 = _props$selectedDate === undefined ? null : _props$selectedDate;

    _this.state = {
      modelTime: null,
      modelEvent: null,
      sourceName: null,
      demurrageTime: selectedDate2,
      newDemurrageTime: '',
      currentDate2: null,
      errorMessage: '',
      skipTzConversion: false
    };
    return _this;
  }

  createClass(StateTimeSeriesModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          eModalTime = _props.eModalTime,
          tModalTime = _props.tModalTime,
          OPSTime = _props.OPSTime,
          p44Time = _props.p44Time,
          eventName = _props.eventName,
          modalIdentifire = _props.modalIdentifire,
          convertEpochToDate = _props.convertEpochToDate,
          selectedDate2 = _props.selectedDate2,
          triggerApiCall = _props.triggerApiCall,
          sourceSelected = _props.sourceSelected,
          entityId = _props.entityId,
          _props$entityTimezone = _props.entityTimezone,
          entityTimezone = _props$entityTimezone === undefined ? "" : _props$entityTimezone,
          selectedField = _props.selectedField,
          entityType = _props.entityType,
          openDateCalendar = _props.openDateCalendar,
          commentEntityEventId = _props.commentEntityEventId,
          _state = this.state,
          modelEvent = _state.modelEvent,
          modelTime = _state.modelTime,
          newDemurrageTime = _state.newDemurrageTime,
          currentDate2 = _state.currentDate2,
          skipTzConversion = _state.skipTzConversion;


      var incomingDate2 = !isEmpty(entityTimezone) ? this.timeZoneReverse(selectedDate2) : parseInt(selectedDate2);
      var demurrageSelectedTime = currentDate2 || newDemurrageTime || incomingDate2;

      return React__default.createElement(
        Fragment,
        null,
        (modalIdentifire === 'readyForPickup' || modalIdentifire === 'gateOut') && React__default.createElement(
          "div",
          { className: "popup-source-section" },
          React__default.createElement(
            "div",
            { className: "popup-calendor demTopSpace" },
            React__default.createElement(
              "div",
              { className: "popup-date-picker" },
              modalIdentifire === 'readyForPickup' ? React__default.createElement(
                "p",
                null,
                "Demurrage time"
              ) : React__default.createElement(
                "p",
                null,
                "PD time"
              ),
              React__default.createElement(DatePicker, {
                title: modalIdentifire === 'readyForPickup' ? "Select demurrage time" : "Select PD time",
                placeholderText: modalIdentifire === 'readyForPickup' ? "Select demurrage time" : "Select PD time",
                id: "vessel-departure-date2",
                name: "etd",
                selected: demurrageSelectedTime,
                onChange: function onChange(value) {
                  _this2.timeZoneConverter(value, 'DEM');
                },
                showTimeSelect: true,
                timeFormat: "hh:mm a",
                timeIntervals: 15,
                timeCaption: "time",
                dateCaption: "Select time",
                dateFormat: "MMMM d, yyyy h:mm aa"
                //disabled={isfDisabled}
                , peekNextMonth: true,
                showMonthDropdown: true,
                showYearDropdown: true,
                dropdownMode: "select",
                popperPlacement: "top-end",
                popperProps: {
                  positionFixed: true // prevents the popper from hiding behind overflow parent
                }
              })
            ),
            React__default.createElement(
              "div",
              { className: "button-container topSpace" },
              React__default.createElement(
                "button",
                {
                  className: "ui primary button " + (modelTime ? '' : 'is-disable'),
                  onClick: function onClick(e) {
                    if (demurrageSelectedTime && modelTime) {
                      triggerApiCall(e, {
                        entityId: entityId,
                        eventName: eventName,
                        entityType: entityType,
                        eventCode: '',
                        eventDescription: '',
                        sourceSelected: modelEvent,
                        selectedTime: modelTime,
                        selectedTime2: demurrageSelectedTime,
                        skipTzConversion: skipTzConversion,
                        commentEntityEventId: commentEntityEventId
                      });
                      openDateCalendar();
                    }
                  },
                  disabled: !modelTime
                },
                "Y"
              )
            )
          )
        ),
        React__default.createElement(
          Table,
          { className: "tableStyle", celled: true, compact: true, size: "small" },
          this.renderTableHeaders(),
          this.renderTableBody({ eModalTime: eModalTime, OPSTime: OPSTime, tModalTime: tModalTime, p44Time: p44Time, sourceSelected: sourceSelected, convertEpochToDate: convertEpochToDate, selectedField: selectedField, entityTimezone: entityTimezone, commentEntityEventId: commentEntityEventId })
        ),
        this.state.errorMessage && React__default.createElement(Message, {
          header: "",
          content: this.state.errorMessage,
          color: "red",
          className: "update_popup_error_doc"
        })
      );
    }
  }]);
  return StateTimeSeriesModal;
}(Component);

var css_248z$b = ".newContainerModal {\n  position: fixed;\n  height: calc( 100vh - 281px);\n  width: 330px;\n  background-color: #FFFFFF;\n  z-index: 2;\n  right: 0;\n  border: 1px solid #979797;\n  border-radius: 2px;\n  box-shadow: 2px 2px 4px 0 rgba(165, 163, 163, 0.5);\n  margin-right: 0.5%;\n  overflow-y: scroll;\n  padding-bottom: 161px; }\n  .newContainerModal .crossIcon {\n    float: right;\n    color: #008B8F;\n    margin: 8px 5px;\n    position: fixed;\n    right: 8px; }\n  .newContainerModal .statesInfo {\n    margin-top: 44px;\n    margin-left: 8%; }\n    .newContainerModal .statesInfo .state {\n      margin-bottom: 5%; }\n    .newContainerModal .statesInfo .header {\n      font-size: 12px;\n      font-weight: bold;\n      margin: 18px 0 3px; }\n    .newContainerModal .statesInfo .reqCancelHeader {\n      font-size: 15px;\n      font-weight: bold;\n      margin: 18px 0 3px; }\n    .newContainerModal .statesInfo .selectDropdown {\n      margin-top: 10px !important;\n      margin-bottom: 10px !important; }\n    .newContainerModal .statesInfo .selectcarrier {\n      margin-bottom: 15px; }\n    .newContainerModal .statesInfo .inputComment {\n      margin-left: 0px !important;\n      width: 250px !important;\n      margin-bottom: 10px !important;\n      height: 40px !important; }\n    .newContainerModal .statesInfo .container-go-back {\n      font-weight: 700; }\n    .newContainerModal .statesInfo .container-go-back:hover {\n      text-decoration: underline;\n      cursor: pointer; }\n    .newContainerModal .statesInfo .holds-reason .headerLabel {\n      color: #020303;\n      font-weight: 700;\n      font-size: 12px;\n      font-size: 12px; }\n    .newContainerModal .statesInfo .holds-reason input {\n      height: 27px;\n      border: 1px solid green;\n      padding: 4px;\n      border-radius: 3px;\n      width: 138px; }\n    .newContainerModal .statesInfo .holds-reason .iconClass {\n      background: #008B8F;\n      width: 27px;\n      height: 28px;\n      border: 1px solid #305E85; }\n    .newContainerModal .statesInfo .holds-reason .ui.icon.button > .icon, .newContainerModal .statesInfo .holds-reason .ui.icon.buttons .button > .icon {\n      color: #FFFFFF; }\n    .newContainerModal .statesInfo .rightSpace {\n      margin-right: 5px; }\n      .newContainerModal .statesInfo .rightSpace.textStyle {\n        font-size: 12px; }\n\n.popup-date-picker p {\n  font-family: \"Open Sans\", \"sans-serif\" !important; }\n\n.small_font {\n  font-size: 12px; }\n\n.undo-action, .mark-as-done {\n  top: 4px;\n  position: relative;\n  font-size: 10px;\n  margin-left: 2px;\n  cursor: pointer;\n  color: #008B8F;\n  margin-bottom: 2px; }\n  .undo-action:hover, .mark-as-done:hover {\n    color: #02595b;\n    transition: all 0.5s linear; }\n  .undo-action:visited, .mark-as-done:visited {\n    color: #1e008f; }\n  .undo-action.disabled, .mark-as-done.disabled {\n    opacity: 0.5;\n    pointer-events: none; }\n\n.modal_header {\n  padding-left: 8%;\n  padding-right: 15%;\n  word-break: break-all; }\n\n.detail-placeholder .line {\n  height: unset;\n  width: unset;\n  border: unset;\n  margin-top: unset;\n  margin-right: unset; }\n\n.update_popup {\n  width: 17% !important; }\n\n.update_popup_error {\n  width: 80% !important;\n  padding-left: 5% !important;\n  margin-left: 1rem !important;\n  margin-bottom: -25px !important; }\n\n.update_popup_error_doc {\n  width: 80% !important;\n  padding-left: 5% !important;\n  padding-top: 0.5% !important;\n  margin-left: 0rem !important;\n  margin-bottom: 1em !important; }\n\n.commentBox {\n  margin: 40px 22px !important;\n  position: relative; }\n  .commentBox .saveComment-btn {\n    background-color: #008b8f !important;\n    padding: 5px 10px !important;\n    color: #fff !important;\n    margin-top: 1rem;\n    margin-left: 234px; }\n  .commentBox .ui.green.message {\n    width: 98% !important; }\n  .commentBox .commentSavingSuccessMsg {\n    width: 98% !important; }\n\n.modalBtn {\n  background-color: #008b8f !important;\n  padding: 6px 10px !important;\n  color: #fff !important;\n  margin-right: 7px !important;\n  font-weight: 400;\n  border: none;\n  cursor: pointer; }\n\n.popup .content {\n  font-size: 14px;\n  padding: 6px;\n  color: #555;\n  line-height: 18px; }\n";
styleInject(css_248z$b);

/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2021 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

// Opportinity

// export const APPLICATION_CLICKED = "APPLICATION_CLICKED"


// export const OPPORTUNITY_ARROW_CLICKED = "OPPORTUNITY_ARROW_CLICKED"

// export const OPPORTUNITY_BID_CLICKED = "OPPORTUNITY_BID_CLICKED";

// export const ADDITONAL_CHARGE_DONE_CLICKED = "ADDITONAL_CHARGE_DONE_CLICKED";
// export const ADDITONAL_CHARGE_CANCEL_CLICKED = "ADDITONAL_CHARGE_CANCEL_CLICKED";


// export const OPPORTUNITY_BID_MODAL_BID_CLICKED = "OPPORTUNITY_BID_MODAL_BID_CLICKED";
// export const OPPORTUNITY_BID_MODAL_PORT_ADDITIONAL_CHARGE_CLICKED = "OPPORTUNITY_BID_MODAL_PORT_ADDITIONAL_CHARGE_CLICKED";
// export const OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED = "OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED";
// export const OPPORTUNITY_BID_MODAL_CANCEL_CLICKED = "OPPORTUNITY_BID_MODAL_CANCEL_CLICKED";


// export const LANE_BID_DONE_CLICKED = "LANE_BID_DONE_CLICKED";
// export const LANE_BID_CANCEL_CLICKED = "LANE_BID_CANCEL_CLICKED";
// export const LANE_BID_ADDITIONAL_CHARGE_CLICKED = "LANE_BID_ADDITIONAL_CHARGE_CLICKED";


// //Standard additional charges
// export const PARTNER_STANDARD_ADDITIONAL_CHARGES = "PARTNER_STANDARD_ADDITIONAL_CHARGES";

// //API

// export const API_GET_OPPORTINITY_LIST = "API_GET_OPPORTINITY_LIST";
// export const API_GET_OPPORTINITY_DETAILS = "API_GET_OPPORTINITY_DETAILS";

// //Internal bid data storage - when user enters bid info in any form for a given opportunity
// export const SET_OPPORTUNITY_BID_DATA = "SET_OPPORTUNITY_BID_DATA";

// export const LANE_BID_SELECT_CLICKED = "LANE_BID_SELECT_CLICKED";

var OPPORTUNITY_BID_CLICKED = "OPPORTUNITY_BID_CLICKED";
var OPPORTUNITY_ARROW_CLICKED = "OPPORTUNITY_ARROW_CLICKED";
var OPPORTUNITY_UPDATE_CLICKED = "OPPORTUNITY_UPDATE_CLICKED";

var ADDITONAL_CHARGE_DONE_CLICKED = "ADDITONAL_CHARGE_DONE_CLICKED";
var ADDITONAL_CHARGE_CANCEL_CLICKED = "ADDITONAL_CHARGE_CANCEL_CLICKED";

var OPPORTUNITY_BID_MODAL_BID_CLICKED = "OPPORTUNITY_BID_MODAL_BID_CLICKED";
var OPPORTUNITY_BID_MODAL_PORT_ADDITIONAL_CHARGE_CLICKED = "OPPORTUNITY_BID_MODAL_PORT_ADDITIONAL_CHARGE_CLICKED";
var OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED = "OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED";
var OPPORTUNITY_BID_MODAL_CANCEL_CLICKED = "OPPORTUNITY_BID_MODAL_CANCEL_CLICKED";

var LANE_BID_DONE_CLICKED = "LANE_BID_DONE_CLICKED";
var LANE_BID_CANCEL_CLICKED = "LANE_BID_CANCEL_CLICKED";
var LANE_BID_ADDITIONAL_CHARGE_CLICKED = "LANE_BID_ADDITIONAL_CHARGE_CLICKED";

//Standard additional charges
var PARTNER_STANDARD_ADDITIONAL_CHARGES = "PARTNER_STANDARD_ADDITIONAL_CHARGES";

//API

var API_GET_OPPORTINITY_LIST = "API_GET_OPPORTINITY_LIST";
var API_GET_OPPORTINITY_DETAILS = "API_GET_OPPORTINITY_DETAILS";

//Internal bid data storage - when user enters bid info in any form for a given opportunity
var SET_OPPORTUNITY_BID_DATA = "SET_OPPORTUNITY_BID_DATA";

//OPPORTUNITY data when updated by sales through edit modal
var OPPORTUNITY_DATA_UPDATED = "OPPORTUNITY_DATA_UPDATED";

//All the reducer actions
var opportunity_actions = {
  OPPORTUNITY_BID_CLICKED: "OPPORTUNITY_BID_CLICKED",
  OPPORTUNITY_ARROW_CLICKED: "OPPORTUNITY_ARROW_CLICKED",
  ADDITONAL_CHARGE_DONE_CLICKED: "ADDITONAL_CHARGE_DONE_CLICKED",
  ADDITONAL_CHARGE_CANCEL_CLICKED: "ADDITONAL_CHARGE_CANCEL_CLICKED",
  OPPORTUNITY_BID_MODAL_BID_CLICKED: "OPPORTUNITY_BID_MODAL_BID_CLICKED",
  OPPORTUNITY_BID_MODAL_PORT_ADDITIONAL_CHARGE_CLICKED: "OPPORTUNITY_BID_MODAL_PORT_ADDITIONAL_CHARGE_CLICKED",
  OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED: "OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED",
  LANE_BID_DONE_CLICKED: "LANE_BID_DONE_CLICKED",
  LANE_BID_CANCEL_CLICKED: "LANE_BID_CANCEL_CLICKED",
  LANE_BID_ADDITIONAL_CHARGE_CLICKED: "LANE_BID_ADDITIONAL_CHARGE_CLICKED",
  PARTNER_STANDARD_ADDITIONAL_CHARGES: "PARTNER_STANDARD_ADDITIONAL_CHARGES",
  API_GET_OPPORTINITY_LIST: "API_GET_OPPORTINITY_LIST",
  API_GET_OPPORTINITY_DETAILS: "API_GET_OPPORTINITY_DETAILS",
  SET_OPPORTUNITY_BID_DATA: "SET_OPPORTUNITY_BID_DATA",
  CUSTOMER_LANE_PRICE_SELECT: "CUSTOMER_LANE_PRICE_SELECT",
  PARTNER_SET_ID: "PARTNER_SET_ID",
  OPPORTUNITY_DATA_UPDATED: "OPPORTUNITY_DATA_UPDATED"
};

var _this$1 = undefined;

var MAX_TIMOUTOUT = 10000;

var setPartnerIdInStore = function setPartnerIdInStore(partnerId) {
  return function () {
    var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(setPartnerId(partnerId));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this$1);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

// setCustomerLanePriceSelected
var setCustomerLanePriceSelected = function setCustomerLanePriceSelected(opporunityId, laneId, selected, tab) {
  var msgToSend = setCustomerLanePriceSelectedAPI(opporunityId, laneId, selected);

  return function () {
    var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var res, exception, success;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return timeoutPromise(MAX_TIMOUTOUT, msgToSend);

            case 2:
              res = _context2.sent;


              console.log(" setCustomerLanePriceSelected :: Success ", res);
              exception = lodash_1(res.data, "eventMessage.exceptionDetails", null);

              if (!exception) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return", DRAYAGE_API_RESPONSE.ERROR_IN_RESPONSE);

            case 7:
              success = lodash_1(res.data, "eventMessage.response");

              console.log(" setCustomerLanePriceSelected :: Success ", success);

              return _context2.abrupt("return", DRAYAGE_API_RESPONSE.SUCCESS);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this$1);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var fetchCustomerLanePriceDetails = function () {
  var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(opporunityId, laneId, sourceId, partnerId, isSelectedBid) {
    var request, opportynityPriceDetails;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // return async (dispatch, getState) => {
            request = getCustomerLanePriceApi(opporunityId, laneId, sourceId, partnerId, isSelectedBid);
            _context3.next = 3;
            return timeoutPromise(MAX_TIMOUTOUT, request);

          case 3:
            opportynityPriceDetails = _context3.sent;

            console.log("getCustomerLanePriceDetails >> 2");

            // let opportynityPriceDetails = get(opportunityListResponse, "data.eventMessage", {});
            console.log("getOpportunityListApi :: ", opportynityPriceDetails);
            return _context3.abrupt("return", lodash_1(opportynityPriceDetails, "data.eventMessage", {}));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, _this$1);
  }));

  return function fetchCustomerLanePriceDetails(_x5, _x6, _x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchCustomerOpporunityPriceDetails = function () {
  var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(opporunityId) {
    var request, opportynityPriceDetails, sourceList, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, portPriceData;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            console.log("fetchCustomerOpporunityPriceDetails >> 2");
            request = getCustomerLanePriceApi(opporunityId, null, null, null, false);
            _context4.next = 4;
            return timeoutPromise(MAX_TIMOUTOUT, request);

          case 4:
            opportynityPriceDetails = _context4.sent;


            console.log("getOpportunityListApi :: ", opportynityPriceDetails);

            sourceList = lodash_1(opportynityPriceDetails, "sourceList", []);
            result = {}; //map of srcPort -> laneId -> destinationBidData
            // {
            // "port1" : {"lane1" : {}, "lane2" : {} },
            // "port2" :  {"lane3" : {}, "lane4" : {} },
            // }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context4.prev = 11;
            for (_iterator = sourceList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              // let portId = get(portPriceData,"sourceId","")
              // let destinations = get(portPriceData,"destinations",[])
              // if (portId === "") {
              //   continue
              // }
              // //Update additional charge for port
              // let portAdditionalChargeList = get(portPriceData,"portChargeList",[])
              // let data = {opportunuityId,  portId, source: "PORT_ADDITIONAL_CHARGE", charges:portAdditionalChargeList}
              // // updateOpportunityAdditionalCharges(state, data)
              // result[portId] = {}
              // for (let destination of destinations) {
              //   let laneId = get(destination, "laneId", "")
              //   let chargeDetails = get(destination, "chargeDetails", {})
              //   bidData  =  buildDestinationBidData(chargeDetails)
              //   result[portId][laneId] = bidData
              // }

              portPriceData = _step.value;
            }

            _context4.next = 19;
            break;

          case 15:
            _context4.prev = 15;
            _context4.t0 = _context4["catch"](11);
            _didIteratorError = true;
            _iteratorError = _context4.t0;

          case 19:
            _context4.prev = 19;
            _context4.prev = 20;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 22:
            _context4.prev = 22;

            if (!_didIteratorError) {
              _context4.next = 25;
              break;
            }

            throw _iteratorError;

          case 25:
            return _context4.finish(22);

          case 26:
            return _context4.finish(19);

          case 27:
            console.log("fetchCustomerOpporunityPriceDetails >> result ", result);

            return _context4.abrupt("return", result);

          case 29:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, _this$1, [[11, 15, 19, 27], [20,, 22, 26]]);
  }));

  return function fetchCustomerOpporunityPriceDetails(_x10) {
    return _ref4.apply(this, arguments);
  };
}();

// export const getCustomerLanePriceDetails = (opportunityId, laneId) => {
//   let result = DRAYAGE_API_RESPONSE.NONE;
//   let msgToSend = getCustomerLanePriceApi(opportunityId, laneId);

//   return async (dispatch, getState) => {
//     const [res] = [await timeoutPromise(MAX_TIMOUTOUT, msgToSend)];

//     console.trace(" getCustomerLanePriceDetails :: success response ", res);
//     let exception = get(res.data, "eventMessage.exceptionDetails", null);
//     if (exception) {
//       return DRAYAGE_API_RESPONSE.ERROR_IN_RESPONSE;
//     }
//     let success = get(res.data, "eventMessage.response");
//     console.log("getCustomerLanePriceDetails", success);
//     return DRAYAGE_API_RESPONSE.SUCCESS;
//   };
// };

//setCustomerlanePriceSelect
var setLanePriceSelected = function setLanePriceSelected(opporunityId, portId, laneId, selected) {
  console.log("setLanePriceSelected :: ", opporunityId, portId, laneId, selected);
  return function (dispatch, getState) {
    dispatch(setCustomerlanePriceSelect(opporunityId, portId, laneId, selected));
  };
};

var handleOpenBidModal = function handleOpenBidModal(opporunityId, opp_key) {
  console.log("handleOpenBidModal", handleOpenBidModal);
  return function (dispatch, getState) {
    dispatch(setOpenBidModal(opporunityId, opp_key));
  };
};

var handleSetChargeForEdit = function handleSetChargeForEdit(opporunityId, opp_key) {
  console.log("handleSetChargeForEdit", handleOpenBidModal);
  return function (dispatch, getState) {
    dispatch(setChargesForEdit(opporunityId, opp_key));
  };
};

var handleOpporunityOpenArrow = function handleOpporunityOpenArrow(opporunityId) {
  console.log("handleOpporunityOpenArrow :: ", opporunityId);
  return function (dispatch, getState) {
    dispatch(setOpporunityOpenArrow(opporunityId));
  };
};

//If called at port level,
//  source - "PORT_ADDITIONAL_CHARGE", opportunuityId, portId, charges are provided, destinationId is null
//If called at lane level,
//  source - "LANE_ADDITIONAL_CHARGE", opportunuityId, portId, destinationId, charges are provided
//
var submitOpportunityBidData = function submitOpportunityBidData(opportunityId, opportunityData, partnerId, isFromEdit, bidOperationType, drayageApp) {
  console.log("submitOpportunityBidData : CC", opportunityId, opportunityData, partnerId);
  var msgToSend = formOpportunitySubmitMessage(opportunityId, opportunityData, partnerId, isFromEdit, bidOperationType, drayageApp);
  console.log("submitOpportunityBidData : CC message to send", msgToSend);

  // return

  return function () {
    var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var res, exception, success;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              /*
               * Fetch new and regular shipments
               */
              _context5.next = 3;
              return timeoutPromise(MAX_TIMOUTOUT, msgToSend);

            case 3:
              res = _context5.sent;


              console.log(" submitOpportunityBidData :: Success ", res);
              exception = lodash_1(res.data, "eventMessage.exceptionDetails", null);

              if (!exception) {
                _context5.next = 8;
                break;
              }

              return _context5.abrupt("return", DRAYAGE_API_RESPONSE.ERROR_IN_RESPONSE);

            case 8:
              success = lodash_1(res.data, "eventMessage.response");
              // dispatch(setStandardPartnerAdditionalChargesInStore(success))

              //  msgToSend.then(res=>{
              //     let resp = await resz
              //     console.log(" submitOpportunityBidData :: Success ",res)
              //     let exception = get(res.data, "eventMessage.exceptionDetails", null)
              //     if (exception) {
              //         result =  DRAYAGE_API_RESPONSE.ERROR_IN_RESPONSE
              //     }
              //     let success = get(res.data,"eventMessage.response")
              //     // dispatch(setStandardPartnerAdditionalChargesInStore(success))

              //     result =  DRAYAGE_API_RESPONSE.SUCCESS

              // }).catch(err=>{
              //     console.log("getDrayageAdditionalCharges",err)
              //     result =  DRAYAGE_API_RESPONSE.ERROR_IN_SEND
              // })

              return _context5.abrupt("return", DRAYAGE_API_RESPONSE.SUCCESS);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this$1);
    }));

    return function (_x11, _x12) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var getStandardPartnerAdditionalCharges = function getStandardPartnerAdditionalCharges(userGuid, partnerId) {
  console.log("getStandardPartnerAdditionalCharges :: ", partnerId);
  return function (dispatch, getState) {
    // let state = store.getState();
    // let partnerId = state.partnerId

    getDrayageAdditionalCharges(partnerId).then(function (res) {
      console.log(" getDrayageAdditionalCharges :: Success ", res);
      var additionalCharges = lodash_1(res.data, "eventMessage.chargeList");
      dispatch(setStandardPartnerAdditionalChargesInStore(additionalCharges));
    }).catch(function (err) {
      console.log("getDrayageAdditionalCharges", err);
    });
  };
};

var setAdditionalChargesInStore = function setAdditionalChargesInStore(source, opportunuityId, portId, destinationId, charges) {
  return function (dispatch, getState) {
    dispatch(setAdditionalCharges(source, opportunuityId, portId, destinationId, charges));
  };
};
//function to take the laneBid charges in the reducer
var setLaneBidChargesInStore = function setLaneBidChargesInStore(opportunuityId, portId, laneId, bidData
// dispatch
) {
  console.log("MessageToReducer :: setLaneBidChargesInStore : ", opportunuityId, portId, laneId, bidData);
  return function (dispatch, getState) {
    dispatch(setLaneBidCharges(opportunuityId, portId, laneId, bidData));
  };
};
var getOpportunityList = function getOpportunityList(tab, filters, isKH360AssociatedUser) {
  return function (dispatch, getState) {
    dispatch(getOpportunityListApi(tab, filters, isKH360AssociatedUser));
  };
};

var getOpportunityListApi = function getOpportunityListApi(tab, filters, isKH360AssociatedUser) {
  return function () {
    var _ref6 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var drayageOpportunityRequest, opportunityListResponse, opportynityData;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              //   let state = store.getState();

              // console.log('1111 state', state)
              //   let {tab} = state.opportunityReducer.tab;
              drayageOpportunityRequest = getDrayageOpportunities(tab, filters, isKH360AssociatedUser);

              /*
               * Fetch new and regular shipments
               */

              _context6.next = 3;
              return timeoutPromise(MAX_TIMOUTOUT, drayageOpportunityRequest);

            case 3:
              opportunityListResponse = _context6.sent;
              opportynityData = lodash_1(opportunityListResponse, "data.eventMessage", {});

              console.log("getOpportunityListApi :: ", tab, opportynityData);

              dispatch(setOpportunityList(tab, opportynityData));

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this$1);
    }));

    return function (_x13, _x14) {
      return _ref6.apply(this, arguments);
    };
  }();
};

/*
 * Extract opportunity data for all apps column here and use it for display in apps page
 */
var extractOpportunityLaneColumns = function extractOpportunityLaneColumns(sourceListDetail) {
  /*
   * Prepare following columns
   *
   *             ApproxVolume             SuggestedBid      ApproxTotalBusiness    SubmittedBid     BidPerContainer       Total         ActiveBid      RejectedBid
   * Customer   New/Active/Rejected                                                                           New/Active
   * Sales
   * Partner     New/Submitted/Active      New/Submitted/Active  New/Submitted/Active    Active             Submitted      Submitted         Active
   *
   * For ith lane:
   * ApproxVolume  :    destinations[i].approxVolume
   * SuggestedBid  :    destinations[i].proposedBid
   * ApproxTotalBusiness :   destinations[i].totalProposedAmount
   * SubmittedBid   :destinations[i].partnerBids[j].bidAmount     j=0 for customer/partner
   * BidPerContainer :    destinations[i].partnerBids[j].bidAmount j=0 for customer/partner
   * Total   :      destinations[i].partnerBids[j].totalBidAmount j=0 for customer/partner
   * ActiveBid :    destinations[i].partnerBids[j].bidAmount   j=0 for customer/partner
   * RejectedBid :  destinations[i].partnerBids[j].bidAmount   j=0 for customer/partner
   *
   */

  var columnData = new Map();

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = sourceListDetail[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var port = _step2.value;

      var lanes = new Map();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = port.destinations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var destination = _step3.value;

          var data = new Map();
          data.set("ApproxVolume", destination.approxVolume);
          data.set("SuggestedBid", destination.proposedBid);
          data.set("ApproxTotalBusiness", destination.totalProposedAmount);
          data.set("UnitPrice", destination.unitPrice);
          data.set("Capacity", destination.knCapacity);
          data.set("RenewalDate", destination.rateValidUntilDate);
          data.set("TotalBaseCharge", destination.totalBaseCharge);
          data.set("CustomerStatus", destination.customerStatus);
          data.set("CapacityAccepted", destination.capacityAccepted);
          data.set("Estimated Time of Arrival", destination.eta);
          data.set("apCurrencyCode", destination.apCurrencyCode);
          data.set("arCurrencyCode", destination.arCurrencyCode);
          //data.set("opportunityExpiryDate",destionation.opportunityExpiryDate)

          //Bidding info is per partner for sales. For partner/customer it will be one.
          var SubmittedBid = [];
          var BidPerContainer = [];
          var Total = [];
          var ActiveBid = [];
          var RejectedBid = [];
          var PartnerStatus = [];
          var RateValidUntilDate = [];
          var CapacityAccepted = [];

          var numOfBids = destination.partnerBids && destination.partnerBids.length >= 0 ? 1 : 0; // For partner and customer, for sales it needs to read destination.partnerBids.length

          for (var j = 0; j < numOfBids; j++) {
            var bid = destination.partnerBids[j];

            SubmittedBid.push(bid && bid.bidAmount);
            BidPerContainer.push(bid && bid.bidAmount);
            Total.push(bid && bid.totalBidAmount);
            ActiveBid.push(bid && bid.bidAmount);
            RejectedBid.push(bid && bid.bidAmount);
            PartnerStatus.push(bid && bid.partnerStatus);
            RateValidUntilDate.push(bid && bid.rateValidUntilDate);
            CapacityAccepted.push(bid && bid.capacityAccepted);
          }

          data.set("SubmittedBid", SubmittedBid);
          data.set("BidPerContainer", BidPerContainer);
          data.set("Total", Total);
          data.set("ActiveBid", ActiveBid);
          data.set("RejectedBid", RejectedBid);
          data.set("PartnerStatus", PartnerStatus);
          data.set("RenewalDateActive", RateValidUntilDate);
          data.set("CapacityAccepted", CapacityAccepted);

          lanes.set(destination.laneId, data);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      columnData.set(port.sourceId, lanes);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  console.log("extractOpportunityLaneColumns :: ", columnData);

  return columnData;
};

var processForSales = function processForSales(opportunityPortsData, tab) {
  if (opportunityPortsData) {
    //filter out un-needed partnerBids
    console.log("processForSales opportunityPortsData1", opportunityPortsData);
    console.log("opportunityPortsData", opportunityPortsData.keys());

    opportunityPortsData.forEach(function (value1, key1) {
      console.log("key1, value1", key1, value1);

      value1.destinations.forEach(function (value2, key2) {
        console.log("key2, value2", key2, value2);
        var partBids = lodash_1(value2, "partnerBids", []);
        var partnersNotSubmittedBids = [];
        for (var i = partBids.length - 1; i >= 0; i--) {
          var _value2$partnerBids$i = value2.partnerBids[i],
              partnerStatus = _value2$partnerBids$i.partnerStatus,
              salesStatus = _value2$partnerBids$i.salesStatus,
              bidAmount = _value2$partnerBids$i.bidAmount;

          if (!bidAmount) {
            partnersNotSubmittedBids.push(partBids[i]);
            value2.partnerBids.splice(i, 1);
            continue;
            // console.log("deleted partnerBids", value2.partnerBids[i].partnerName)
          }

          if (tab === "SALES_PENDING_APPROVAL" && salesStatus !== "SALES_PENDING_APPROVAL") {
            value2.partnerBids.splice(i, 1);
            // console.log("deleted partnerBids", value2.partnerBids[i].partnerName)
          }
        }
        value2.partnersNotSubmittedBids = partnersNotSubmittedBids;
      });
    });
  }
  console.log("processForSales opportunityPortsData2", opportunityPortsData);
  return opportunityPortsData;
};

// export const getOpportunityDetailsApi = (
//   opportunityId,
//   tab,
//   tabType,
//   isAlreadyOpened
// ) => {
//   // debugger
//   // tabType = getDrayageOpportunities(tabType)
//   switch (tabType) {
//     case "SALES_PUBLISHED":
//       tabType = "DRAYAGE_PUBLISHED";
//       break;
//     case "SALES_CUSTOMER_REQUESTED":
//       tabType = "DRAYAGE_CUSTOMER_REQUESTED";
//       break;

//     case "SALES_PENDING_APPROVAL":
//       tabType = "DRAYAGE_PENDING_APPROVAL";
//       break;

//     case "SALES_ACCEPTED":
//       tabType = "DRAYAGE_ACCEPTED";
//       break;

//     case "SALES_REJECTED":
//       tabType = "DRAYAGE_REJECTED";
//       break;

//     case "SALES_ARCHIVED":
//       tabType = "DRAYAGE_ARCHIVED";
//       break;
//     default:
//       break;
//   }
//   console.log(
//     "getOpportunityDetailsApi : CC start",
//     opportunityId,
//     tab,
//     tabType,
//     isAlreadyOpened
//   );
//   return async (dispatch, getState) => {
//     if (isAlreadyOpened) {
//       return dispatch(
//         setOpportunityDetails(opportunityId, null, null, null, isAlreadyOpened)
//       );
//     }

//     // let state = store.getState();

//     console.log(
//       "getOpportunityDetailsApi : CC",
//       opportunityId,
//       tab,
//       isAlreadyOpened
//     );
//     // let { partnerId, tab } = state.opportunityReducer.partnerId;

//     getDrayageOpportunityDetails(opportunityId,tabType)
//       .then((res) => {
//         console.log("getOpportunityDetailsApi : response", res);

//         let opportunityDetailData = get(res.data, "eventMessage", {});
//         let opportunityPortsData = new Map();

//         console.log(
//           "getOpportunityDetailsData :",
//           opportunityDetailData,
//           typeof opportunityDetailData
//         );
//         let opportunityDetails = opportunityDetailData.opportunityDetails;
//         console.log("opportunityDetails", opportunityDetails);

//         let sourceListDetail = opportunityDetailData.sourceList; //array of obj
//         console.log(sourceListDetail, "sourceListDetail");
//         for (let port of sourceListDetail) {
//           let destinationData = new Map();

//           opportunityPortsData = opportunityPortsData.set(
//             port.sourceId,
//             port
//           );
//           console.log("opportunityPortsData : ", opportunityPortsData);

//           if (
//             tab === "SALES_PENDING_APPROVAL" ||
//             tab === "SALES_ACCEPTED" ||
//             tab === "SALES_REJECTED" ||
//             tab === "SALES_ARCHIVED"
//           )
//             opportunityPortsData = processForSales(opportunityPortsData, tab);

//           let destinations = opportunityPortsData.get(port.sourceId)
//             .destinations; //as an array of obj

//           let source = opportunityPortsData.get(port.sourceId)
//             .source;
//           console.log("source", source);

//           console.log("destinations", destinations);

//           for (let destination of destinations) {
//             destinationData = destinationData.set(
//               destination.destinationId,
//               destination
//             );
//             console.log("destinationData", destinationData);
//             let destinationIds = Array.from(destinationData.keys());
//             console.log("destinationIds", destinationIds);
//             let destinationAddress = destinationData.get(
//               destination.destinationId
//             ).destinationAddress;
//             console.log(
//               "destinationAddress Opportunity.js  CC",
//               destinationAddress
//             );
//             let approxVolume = destinationData.get(destination.destinationId)
//               .approxVolume;
//             console.log(" approxVolume", approxVolume);
//             let laneId = destinationData.get(destination.destinationId).laneId;
//             console.log(" laneIde", laneId);
//           }
//           destinationData = port["destinations"];
//         }

//         console.log(
//           "getOpportunityDetailsApi :: Done fetchinng data, sending to reducer",
//           opportunityPortsData
//         );

//         let columnData = extractOpportunityLaneColumns(sourceListDetail);

//         return dispatch(
//           setOpportunityDetails(
//             opportunityId,
//             opportunityDetails,
//             opportunityPortsData,
//             columnData,
//             isAlreadyOpened,
//             opportunityDetailData,
//             tabType

//           )
//         );
//       })
//       .catch((err) => {
//         console.log("getOpportunityDetailsData err", err);
//       });
//     let opportynityDetailData = {};
//     /*
//      * Fetch new and regular shipments
//      */
//     // console.log("Shipment API responses  : New Shipments", newShipmentRes, " Shipments ",  shipmentDetails)
//   };
// };

var getDestinationBidDataFromOpportunity = function getDestinationBidDataFromOpportunity(partnerBids) {
  console.log("partnerBids :: ", partnerBids);
  //bidData = {
  //   baseFees: this.state.baseFees,
  //   basefeesGlCode: this.state.basefeesGlCode,
  //   fuelChargeGlCode: this.state.fuelChargeGlCode,
  //   fuelCharges: this.state.fuelCharges,
  //   chasisRentalperday: this.state.chasisRentalperday,
  //   minReqDays: this.state.minReqDays,
  //   bidBaseTotal: totalBidAmountForLane(this.state),
  //   yesRadioButton: this.state.yesRadioButton,
  //   notes: this.state.notes,
  //   capacityPerMonth: this.state.capacityPerMonth,
  //   rateValidUntilDate: this.state.rateValidUntilDate,
  // }

  if (partnerBids.length == 0) {
    return {};
  }

  var bidData = partnerBids[0];
  var baseFees = lodash_1(bidData, "bidAmount", 0);
  var fuelCharges = lodash_1(bidData, "fuel", 0);

  return {
    // baseFees: baseFees,
    capacityPerMonth: lodash_1(bidData, "capacityPerMonth", 0),
    bidBaseTotal: lodash_1(bidData, "bidAmount", 0)
    // fuelCharges:fuelCharges,
    // bidBaseTotal : baseFees + fuelCharges,
    // yesRadioButton : fuelCharges > 0
  };
};
var getOpportunityDetailsApi = function getOpportunityDetailsApi(opportunityId, tab, isAlreadyOpened, tabType$$1, isEdit) {
  console.log("getOpportunityDetailsApi : get opportunity details ", opportunityId, tab, isAlreadyOpened, tabType$$1, isEdit);

  // opportunuityId,
  // opportunityDetails,
  // opportunityPortsData,
  // columnData,
  // isAlreadyOpened,
  // opportunityDetailData,
  // tabType
  return function () {
    var _ref7 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      var request, reques2, res, chargeResponse, opportunityDetailData, opportunityPortsData, opportunityDetails, sourceListDetail, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, port, destinationData, destinations, source, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, destination, destinationIds, destinationAddress, approxVolume, laneId, bidData, columnData;

      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              console.log("getOpportunityDetailsApi : CC", opportunityId, tab, isAlreadyOpened, tabType$$1);

              if (!isAlreadyOpened) {
                _context7.next = 3;
                break;
              }

              return _context7.abrupt("return", dispatch(setOpportunityDetails(opportunityId, null, null, null, isAlreadyOpened, null, tab, isEdit, {})));

            case 3:

              // let state = store.getState();

              // let { partnerId, tab } = state.opportunityReducer.partnerId;

              request = getDrayageOpportunityDetails(opportunityId, tab);
              reques2 = getCustomerLanePriceApi(opportunityId, null, null, null, false);
              _context7.next = 7;
              return timeoutPromise(MAX_TIMOUTOUT, request);

            case 7:
              res = _context7.sent;
              _context7.next = 10;
              return timeoutPromise(MAX_TIMOUTOUT, reques2);

            case 10:
              chargeResponse = _context7.sent;


              console.log("getOpportunityDetailsApi : response", res, chargeResponse);

              opportunityDetailData = lodash_1(res.data, "eventMessage", {});
              opportunityPortsData = new Map();


              console.log("getOpportunityDetailsData :", opportunityDetailData, typeof opportunityDetailData === "undefined" ? "undefined" : _typeof(opportunityDetailData));
              opportunityDetails = opportunityDetailData.opportunityDetails;

              console.log("opportunityDetails", opportunityDetails);

              sourceListDetail = opportunityDetailData.sourceList; //array of obj

              console.log(sourceListDetail, "sourceListDetail");
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context7.prev = 22;
              _iterator4 = sourceListDetail[Symbol.iterator]();

            case 24:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context7.next = 57;
                break;
              }

              port = _step4.value;
              destinationData = new Map();


              opportunityPortsData = opportunityPortsData.set(port.sourceId, port);
              console.log("opportunityPortsData : ", opportunityPortsData);

              if (tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED") opportunityPortsData = processForSales(opportunityPortsData, tab);

              destinations = opportunityPortsData.get(port.sourceId).destinations; //as an array of obj

              source = opportunityPortsData.get(port.sourceId).source;

              console.log("source", source);

              console.log("destinations", destinations);

              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              _context7.prev = 37;
              for (_iterator5 = destinations[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                destination = _step5.value;

                destination.partBids = lodash_1(destination, "partnerBids", []);
                destination.eta = opportunityDetails.eta;
                destinationData = destinationData.set(destination.destinationId, destination);
                console.log("destinationData", destinationData);
                destinationIds = Array.from(destinationData.keys());

                console.log("destinationIds", destinationIds);
                destinationAddress = destinationData.get(destination.destinationId).destinationAddress;

                console.log("destinationAddress Opportunity.js  CC", destinationAddress);
                approxVolume = destinationData.get(destination.destinationId).approxVolume;

                console.log(" approxVolume", approxVolume);
                laneId = destinationData.get(destination.destinationId).laneId;

                console.log(" laneIde", laneId);

                // Create map : from API response to below  from parnerBid data

                bidData = getDestinationBidDataFromOpportunity(destination.partBids);

                destination.destinationBidData = bidData;
                // console.log("bidDatadestination ",bidData )
                // setLaneBidChargesInStore(opportunityId,port.sourceId,laneId,bidData,dispatch)
              }
              _context7.next = 45;
              break;

            case 41:
              _context7.prev = 41;
              _context7.t0 = _context7["catch"](37);
              _didIteratorError5 = true;
              _iteratorError5 = _context7.t0;

            case 45:
              _context7.prev = 45;
              _context7.prev = 46;

              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }

            case 48:
              _context7.prev = 48;

              if (!_didIteratorError5) {
                _context7.next = 51;
                break;
              }

              throw _iteratorError5;

            case 51:
              return _context7.finish(48);

            case 52:
              return _context7.finish(45);

            case 53:
              destinationData = port["destinations"];

            case 54:
              _iteratorNormalCompletion4 = true;
              _context7.next = 24;
              break;

            case 57:
              _context7.next = 63;
              break;

            case 59:
              _context7.prev = 59;
              _context7.t1 = _context7["catch"](22);
              _didIteratorError4 = true;
              _iteratorError4 = _context7.t1;

            case 63:
              _context7.prev = 63;
              _context7.prev = 64;

              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }

            case 66:
              _context7.prev = 66;

              if (!_didIteratorError4) {
                _context7.next = 69;
                break;
              }

              throw _iteratorError4;

            case 69:
              return _context7.finish(66);

            case 70:
              return _context7.finish(63);

            case 71:

              console.log("MessageToReducer :: getOpportunityDetailsApi :: Done fetchinng data, sending to reducer", opportunityPortsData);

              columnData = extractOpportunityLaneColumns(sourceListDetail);


              dispatch(setOpportunityDetails(opportunityId, opportunityDetails, opportunityPortsData, columnData, isAlreadyOpened, opportunityDetailData, tab, isEdit, lodash_1(chargeResponse, "data.eventMessage", {})));
              // dispatch(setChargesForEdit(opportunityId, get(chargeResponse, "data.eventMessage", {})))
              // let bidData = getDestinationBidDataFromOpportunity(destination.partBids)
              // dispatch(setLaneBidChargesInStore(opportunityId,port.sourceId,laneId,bidData))
              // })
              // .catch((err) => {
              //   console.log("getOpportunityDetailsData err", err);
              // });
              // let opportynityDetailData = {};
              /*
               * Fetch new and regular shipments
               */
              // console.log("Shipment API responses  : New Shipments", newShipmentRes, " Shipments ",  shipmentDetails)

            case 74:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this$1, [[22, 59, 63, 71], [37, 41, 45, 53], [46,, 48, 52], [64,, 66, 70]]);
    }));

    return function (_x15, _x16) {
      return _ref7.apply(this, arguments);
    };
  }();
};

var getOpportunityDetailsApiForSales = function getOpportunityDetailsApiForSales(opportunityId, tab, isAlreadyOpened) {
  console.log("getOpportunityDetailsApi : CC start", opportunityId, tab, isAlreadyOpened);
  return function () {
    var _ref8 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!isAlreadyOpened) {
                _context8.next = 2;
                break;
              }

              return _context8.abrupt("return", dispatch(setOpportunityDetails(opportunityId, null, null, null, isAlreadyOpened, false, {})));

            case 2:

              // let state = store.getState();

              console.log("getOpportunityDetailsApi : CC", opportunityId, tab, isAlreadyOpened);
              // let { partnerId, tab } = state.opportunityReducer.partnerId;

              getDrayageOpportunityDetails(opportunityId, tabType[tab]).then(function (res) {
                console.log("getOpportunityDetailsApi : response", res);

                var opportunityDetailData = lodash_1(res.data, "eventMessage", {});
                var opportunityPortsData = new Map();

                console.log("getOpportunityDetailsData :", opportunityDetailData, typeof opportunityDetailData === "undefined" ? "undefined" : _typeof(opportunityDetailData));
                var opportunityDetails = opportunityDetailData.opportunityDetails;
                console.log("opportunityDetails", opportunityDetails);

                var sourceListDetail = opportunityDetailData.sourceList; //array of obj
                console.log(sourceListDetail, "sourceListDetail");
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                  for (var _iterator6 = sourceListDetail[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var port = _step6.value;

                    var destinationData = new Map();

                    opportunityPortsData = opportunityPortsData.set(port.sourceId, port);
                    console.log("opportunityPortsData : ", opportunityPortsData);

                    if (tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED") opportunityPortsData = processForSales(opportunityPortsData, tab);

                    var destinations = opportunityPortsData.get(port.sourceId).destinations; //as an array of obj

                    var source = opportunityPortsData.get(port.sourceId).source;
                    console.log("source", source);

                    console.log("destinations", destinations);

                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                      for (var _iterator7 = destinations[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var destination = _step7.value;

                        destinationData = destinationData.set(destination.destinationId, destination);
                        console.log("destinationData", destinationData);
                        var destinationIds = Array.from(destinationData.keys());
                        console.log("destinationIds", destinationIds);
                        var destinationAddress = destinationData.get(destination.destinationId).destinationAddress;
                        console.log("destinationAddress Opportunity.js  CC", destinationAddress);
                        var approxVolume = destinationData.get(destination.destinationId).approxVolume;
                        console.log(" approxVolume", approxVolume);
                        var laneId = destinationData.get(destination.destinationId).laneId;
                        console.log(" laneIde", laneId);
                      }
                    } catch (err) {
                      _didIteratorError7 = true;
                      _iteratorError7 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                          _iterator7.return();
                        }
                      } finally {
                        if (_didIteratorError7) {
                          throw _iteratorError7;
                        }
                      }
                    }

                    destinationData = port["destinations"];
                  }
                } catch (err) {
                  _didIteratorError6 = true;
                  _iteratorError6 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                      _iterator6.return();
                    }
                  } finally {
                    if (_didIteratorError6) {
                      throw _iteratorError6;
                    }
                  }
                }

                console.log("getOpportunityDetailsApi :: Done fetchinng data, sending to reducer", opportunityPortsData);

                var columnData = extractOpportunityLaneColumns(sourceListDetail);

                dispatch(setOpportunityDetails(opportunityId, opportunityDetails, opportunityPortsData, columnData, isAlreadyOpened, opportunityDetailData, false, {}));
              }).catch(function (err) {
                console.log("getOpportunityDetailsData err", err);
              });

              /*
               * Fetch new and regular shipments
               */
              // console.log("Shipment API responses  : New Shipments", newShipmentRes, " Shipments ",  shipmentDetails)

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this$1);
    }));

    return function (_x17, _x18) {
      return _ref8.apply(this, arguments);
    };
  }();
};

var setSalesOpportunityUpdatedData = function setSalesOpportunityUpdatedData(dataObj) {
  return function (dispatch, getState) {
    dispatch(setSalesOpportunityUpdatedDataInStore(dataObj));
  };
};

var setOpporunityOpenArrow = function setOpporunityOpenArrow(opportunuityId) {
  return {
    type: OPPORTUNITY_ARROW_CLICKED,
    payload: opportunuityId
  };
};

var setOpenBidModal = function setOpenBidModal(opportunuityId, opp_key) {
  console.log("setOpenBidModal >> ", opportunuityId);
  return {
    type: OPPORTUNITY_BID_CLICKED,
    payload: { opportunuityId: opportunuityId, opp_key: opp_key }
  };
};

var setChargesForEdit = function setChargesForEdit(opportunuityId, data) {
  console.log("setChargesForEdit >> id and data", opportunuityId, data);
  return {
    type: OPPORTUNITY_UPDATE_CLICKED,
    payload: { opportunuityId: opportunuityId, data: data }
  };
};

var setStandardPartnerAdditionalChargesInStore = function setStandardPartnerAdditionalChargesInStore(additionalCharges) {
  return {
    type: PARTNER_STANDARD_ADDITIONAL_CHARGES,
    payload: additionalCharges
  };
};

var setAdditionalCharges = function setAdditionalCharges(source, opportunuityId, portId, laneId, charges) {
  return {
    type: ADDITONAL_CHARGE_DONE_CLICKED,
    payload: { source: source, opportunuityId: opportunuityId, portId: portId, laneId: laneId, charges: charges }
  };
};
var setLaneBidCharges = function setLaneBidCharges(opportunuityId, portId, laneId, bidData) {
  console.log("setLaneBidCharges :: ", bidData);
  return {
    type: LANE_BID_DONE_CLICKED,
    payload: { opportunuityId: opportunuityId, portId: portId, laneId: laneId, bidData: bidData }
  };
};

var setSalesOpportunityUpdatedDataInStore = function setSalesOpportunityUpdatedDataInStore(dataObj) {
  console.log("setSalesOpportunityUpdatedDataInStore :: ", dataObj);
  return {
    type: OPPORTUNITY_DATA_UPDATED,
    payload: dataObj
  };
};

var setOpportunityList = function setOpportunityList(tab, opportynityData) {
  console.log("setOpportunityList", tab);
  return {
    type: API_GET_OPPORTINITY_LIST,
    payload: opportynityData,
    tab: tab
  };
};

var setOpportunityDetails = function setOpportunityDetails(opportunuityId, opportunityDetails, opportunityPortsData, columnData, isAlreadyOpened, opportunityDetailData, tabType$$1, isEdit, chargeResponse) {
  console.log("MessageToReducer :: setOpportunityDetails :: ", tabType$$1);
  return {
    type: API_GET_OPPORTINITY_DETAILS,
    payload: {
      opportunuityId: opportunuityId,
      opportunityDetails: opportunityDetails,
      opportunityPortsData: opportunityPortsData,
      columnData: columnData,
      isAlreadyOpened: isAlreadyOpened,
      opportunityDetailData: opportunityDetailData,
      tabType: tabType$$1,
      isEdit: isEdit,
      chargeResponse: chargeResponse
    }
  };
};

var setCustomerlanePriceSelect = function setCustomerlanePriceSelect(opportunuityId, portId, laneId, selected) {
  return {
    type: opportunity_actions.CUSTOMER_LANE_PRICE_SELECT,
    payload: {
      opportunuityId: opportunuityId,
      portId: portId,
      laneId: laneId,
      selected: selected
    }
  };
};

var setPartnerId = function setPartnerId(partnerId) {
  return {
    type: opportunity_actions.PARTNER_SET_ID,
    payload: {
      partnerId: partnerId
    }
  };
};

var requestCancellation = function requestCancellation(entityId, shipmentId, reason, comment, portName) {
  var data = {};
  data = {
    eventMessage: {
      containerNumber: entityId,
      shipmentId: shipmentId,
      reason: reason,
      comment: comment,
      portName: portName
    },
    eventType: "DRAYAGE_REQUEST_CANCELLATION_EDIT_PARTNER",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var fetchCancellationDetails = function fetchCancellationDetails(entityId, shipmentId) {
  var data = {};
  data = {
    eventMessage: {
      containerNumber: entityId,
      shipmentId: shipmentId
    },
    eventType: "DRAYAGE_FETCH_CANCELLATION_DETAILS",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var editPartner = function editPartner(entityId, shipmentId, opportunityPartnerId) {
  var data = {};
  data = {
    eventMessage: {
      containerNumber: entityId,
      shipmentId: shipmentId,
      opportunityPartnerId: opportunityPartnerId
    },
    eventType: "DRAYAGE_REQUEST_CANCELLATION_EDIT_PARTNER",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var requestTruckers = function requestTruckers() {
  var data = {};
  data = {
    eventMessage: {
      filter: "ALL"
    },
    eventType: "GET_DRAYAGE_PARTNER_TRUCKERS",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var assignTruckers = function assignTruckers(shipmentId, containerNumber, truckerGuid, tripType) {
  var data = {};
  data = {
    eventMessage: {
      shipmentId: shipmentId,
      containerNumber: containerNumber,
      truckerGuid: truckerGuid,
      tripType: tripType
    },
    eventType: "TRUCKER_CONTAINER_ASSIGNMENT",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var requestPartner = function requestPartner(shipmentId, containerNumber) {
  var data = {};
  data = {
    eventMessage: {
      shipmentId: shipmentId,
      containerNumber: containerNumber
    },
    eventType: "DRAYAGE_FETCH_ACTIVE_PARTNERS",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var assignPartner = function assignPartner(shipmentId, containerNumber, selectedPartnerInfo) {
  var data = {};
  var opportunityPartnerId = lodash_1(selectedPartnerInfo, "opportunityPartnerId", "");
  var destinationId = lodash_1(selectedPartnerInfo, "destinationId", "");
  var sourceId = lodash_1(selectedPartnerInfo, "sourceId", "");
  data = {
    eventMessage: {
      shipmentId: shipmentId,
      containerNumber: containerNumber,
      opportunityPartnerId: opportunityPartnerId,
      destinationId: destinationId,
      sourceId: sourceId
    },
    eventType: "DRAYAGE_ASSIGN_CONTAINER_TO_PARTNER",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var setInlandTime = function setInlandTime() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var data = {
    eventType: "EED_SELECT_STOP_TIME",
    eventMessage: _extends({}, payload),
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var CommentBox = function (_Component) {
  inherits(CommentBox, _Component);

  function CommentBox(props) {
    classCallCheck(this, CommentBox);

    var _this = possibleConstructorReturn(this, (CommentBox.__proto__ || Object.getPrototypeOf(CommentBox)).call(this, props));

    _this.componentDidMount = function () {
      var containerComment = _this.props.containerComment;

      if (containerComment) _this.setState({ commentsForContainer: containerComment.comment });
    };

    _this.triggerComments = function () {
      var commentsForContainer = _this.state.commentsForContainer,
          _this$props = _this.props,
          getListOfContainers = _this$props.getListOfContainers,
          getCommentPerContainer = _this$props.getCommentPerContainer,
          entityId = _this$props.entityId,
          commentEntityEventId = _this$props.commentEntityEventId,
          drayagePartner = _this$props.drayagePartner;


      var isDray = drayagePartner && drayagePartner !== "None" ? true : false;

      var params = {
        entityId: entityId,
        commentEntityEventId: commentEntityEventId,
        eventName: "CONTAINER_COMMENT",
        entityType: "WORKFLOW_ENTITY_TYPE_CONTAINER",
        eventCode: "",
        eventDescription: commentsForContainer,
        sourceSelected: "OPS",
        isDray: isDray
      };

      getCommentPerContainer(params).then(function () {
        return _this.setState({ isSaved: true });
      }, function () {
        setTimeout(function () {
          _this.setState({ isSaved: false });
        }, 2500);
      });
      getListOfContainers();

      setTimeout(function () {
        _this.setState({ isSaved: false });
      }, 2500);
    };

    _this.handleDismiss = function () {
      _this.setState({ isSaved: false });
    };

    _this.state = {
      commentsForContainer: "",
      isSaved: false
    };
    return _this;
  }

  // componentWillReceiveProps = (props) => {
  //   const { commentsForContainer } = this.state;
  //   if(!props.containerComment) this.setState({ commentsForContainer: "" })
  //   else if(!isEqual(props.containerComment.comment, commentsForContainer)) {
  //     this.setState({ commentsForContainer: props.containerComment.comment })
  //   } 
  // }

  createClass(CommentBox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          commentsForContainer = _state.commentsForContainer,
          isSaved = _state.isSaved,
          entityId = this.props.entityId;


      return React__default.createElement(
        "div",
        {
          className: "commentBox",
          "data-id": entityId
        },
        React__default.createElement(
          Form,
          { style: { marginTop: "0.5rem" } },
          React__default.createElement(TextArea, {
            value: commentsForContainer,
            onChange: function onChange(e, data) {
              return _this2.setState({ commentsForContainer: data.value });
            },
            placeholder: "Add Comment...",
            style: { minHeight: 200 },
            className: "textArea"
          })
        ),
        React__default.createElement(
          Button,
          {
            className: "saveComment-btn",
            onClick: this.triggerComments,
            disabled: commentsForContainer === ""
          },
          "Save"
        ),
        isSaved && React__default.createElement(Message, {
          onDismiss: this.handleDismiss,
          header: "",
          content: "Comment saved for: " + entityId,
          color: "green",
          className: "commentSavingSuccessMsg",
          style: { position: "absolute", marginLeft: "3px" }
        })
      );
    }
  }]);
  return CommentBox;
}(Component);

var css_248z$c = ".comment-historyModal {\n  width: 70% !important;\n  margin-top: -100px !important;\n  max-height: 750px;\n  font-size: 1.2rem !important; }\n  .comment-historyModal .comment-modal-header {\n    display: flex !important;\n    justify-content: space-between !important; }\n  .comment-historyModal .comment-history-table {\n    overflow: auto;\n    width: 100%;\n    max-height: 650px; }\n    .comment-historyModal .comment-history-table::-webkit-scrollbar {\n      display: block;\n      width: 10px !important;\n      background: aliceblue; }\n    .comment-historyModal .comment-history-table::-webkit-scrollbar-track {\n      box-shadow: inset 0 0 5px grey;\n      border-radius: 6px; }\n    .comment-historyModal .comment-history-table thead {\n      background-color: #fff;\n      position: sticky;\n      top: 0;\n      z-index: 1; }\n    .comment-historyModal .comment-history-table th {\n      padding: 5px;\n      cursor: pointer;\n      font-size: 15px; }\n";
styleInject(css_248z$c);

var CommentHistoryModal = function (_Component) {
  inherits(CommentHistoryModal, _Component);

  function CommentHistoryModal(props) {
    classCallCheck(this, CommentHistoryModal);

    var _this = possibleConstructorReturn(this, (CommentHistoryModal.__proto__ || Object.getPrototypeOf(CommentHistoryModal)).call(this, props));

    _this.sortFun = function (arr, type) {
      if (!arr) return "";
      var _this$state = _this.state,
          changeByComment = _this$state.changeByComment,
          changeByEmail = _this$state.changeByEmail,
          changeByDate = _this$state.changeByDate,
          changeByUser = _this$state.changeByUser;


      var newArr = [].concat(toConsumableArray(arr));

      var status = type == 0 ? changeByComment : type == 1 ? changeByEmail : type == 2 ? changeByDate : type == 3 ? changeByUser : "";

      var sortType = type == 0 ? "comment" : type == 1 ? "commentByEmail" : type == 2 ? "commentDate" : type == 3 ? "commentUserType" : "";

      newArr.sort(function (a, b) {
        if (typeof a[sortType] === "undefined") return 1;
        if (typeof b[sortType] === "undefined") return -1;

        if (status == false) {
          return a[sortType] < b[sortType] ? -1 : a[sortType] == b[sortType] ? 0 : 1;
        } else if (status == true) {
          return a[sortType] < b[sortType] ? 1 : a[sortType] == b[sortType] ? 0 : -1;
        }
      });
      _this.setState({ containerComments: newArr });
    };

    _this.state = {
      containerComments: [],
      changeByComment: true,
      changeByEmail: true,
      changeByUser: true,
      changeByDate: true
    };
    return _this;
  }

  createClass(CommentHistoryModal, [{
    key: "componentDidMount",
    value: function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _props, entityId, commentEntityEventId, getCommentHistoryPerContainer, params;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, entityId = _props.entityId, commentEntityEventId = _props.commentEntityEventId, getCommentHistoryPerContainer = _props.getCommentHistoryPerContainer;
                params = {
                  entityId: entityId,
                  commentEntityEventId: commentEntityEventId,
                  eventName: "CONTAINER_COMMENT_HISTORY",
                  entityType: "WORKFLOW_ENTITY_TYPE_CONTAINER",
                  eventCode: "",
                  eventDescription: "",
                  sourceSelected: "OPS"
                };
                _context.next = 4;
                return getCommentHistoryPerContainer(params).then(function (res) {
                  return _this2.setState({ containerComments: res.data.eventMessage.list });
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          entityId = _props2.entityId,
          closeHistoryPopup = _props2.closeHistoryPopup,
          userInitialData = _props2.userInitialData,
          containerComments = this.state.containerComments;


      return React__default.createElement(
        Modal,
        {
          onClose: function onClose() {
            return closeHistoryPopup();
          },
          open: true,
          className: "comment-historyModal",
          id: "comment-historyModal-main"
        },
        React__default.createElement(
          Modal.Header,
          { className: "comment-modal-header" },
          "Container comment history: " + entityId,
          React__default.createElement(
            "button",
            {
              type: "button",
              className: "close",
              style: { border: "none", background: "none", cursor: "pointer" },
              onClick: function onClick() {
                return closeHistoryPopup();
              }
            },
            "\xD7"
          )
        ),
        React__default.createElement(
          Modal.Content,
          { image: true, className: "comment-historyModal-container" },
          React__default.createElement(
            "div",
            { className: "comment-history-table" },
            React__default.createElement(
              "table",
              { style: { width: "100%" } },
              React__default.createElement(
                "thead",
                null,
                React__default.createElement(
                  "tr",
                  null,
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this3.setState({ changeByComment: !_this3.state.changeByComment });
                        _this3.sortFun(containerComments, 0);
                      }
                    },
                    "Comment",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute", top: "8px" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this3.setState({ changeByEmail: !_this3.state.changeByEmail });
                        _this3.sortFun(containerComments, 1);
                      }
                    },
                    "Comment By Email",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute", top: "8px" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this3.setState({ changeByDate: !_this3.state.changeByDate });
                        _this3.sortFun(containerComments, 2);
                      }
                    },
                    "Comment Date",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute", top: "8px" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this3.setState({ changeByUser: !_this3.state.changeByUser });
                        _this3.sortFun(containerComments, 3);
                      }
                    },
                    "Comment User",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute", top: "8px" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  )
                )
              ),
              React__default.createElement(
                "tbody",
                null,
                containerComments && containerComments.map(function (_ref2) {
                  var comment = _ref2.comment,
                      commentByEmail = _ref2.commentByEmail,
                      commentDate = _ref2.commentDate,
                      commentUserType = _ref2.commentUserType;

                  var customerEmailType = ["CUSTOMER_USER"];

                  if (_this3.props.userType === "CUSTOMER") {
                    if (!commentUserType.includes(customerEmailType)) {
                      commentByEmail = 'KN SYSTEM';
                    } else if (commentUserType === "CUSTOMER_USER" && get(userInitialData, "userBasicInfo.email", "") !== commentByEmail) {
                      commentByEmail = 'KN CUSTOMER';
                    }
                  }
                  return React__default.createElement(
                    "tr",
                    null,
                    React__default.createElement(
                      "td",
                      { style: { width: "400px", padding: "5px" } },
                      comment
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      commentByEmail
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      " ",
                      moment$1(commentDate).format("MMM Do YYYY, hh:mm:ss a")
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      commentUserType
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return CommentHistoryModal;
}(Component);

var css_248z$d = ".historyModal {\n  width: 97% !important;\n  margin-top: -135px !important;\n  max-height: 650px; }\n  .historyModal .modal-header {\n    display: flex !important;\n    justify-content: space-between !important; }\n    .historyModal .modal-header span {\n      font-weight: 100;\n      font-size: 13px; }\n  .historyModal .history-table {\n    overflow: auto;\n    width: 100%;\n    max-height: 500px; }\n    .historyModal .history-table::-webkit-scrollbar {\n      display: block;\n      width: 10px !important;\n      background: aliceblue; }\n    .historyModal .history-table::-webkit-scrollbar-track {\n      box-shadow: inset 0 0 5px grey;\n      border-radius: 6px; }\n    .historyModal .history-table thead {\n      background-color: #fff;\n      position: sticky;\n      top: 0;\n      z-index: 1; }\n    .historyModal .history-table th {\n      font-size: 14px; }\n";
styleInject(css_248z$d);

var requestdType = {
  EED_SELECT_ENTITY_TIME: "Container updated",
  UNDO_ENTITY_EVENTS: "Container event undone",
  REGISTER_ENTITY: "Container registered",
  EED_P44_INJECT_DATA_UPDAT: "Auto Updated From P44"
};

var eventType = {
  CONTAINER_DONE: "MARKED DONE",
  REGISTER_ENTITY: "CONTAINER REGISTERED",
  UNLOAD_FROM_VESSEL: "GROUNDED",
  CUSTOM_RELEASED: "CUSTOM REL",
  CARRIER_RELEASED: "LINE RELEASE",
  CONTAINER_HOLDS: "HOLD",
  CONTAINER_FEES: "FEES",
  READY_FOR_PICKUP: "READY FOR PICKUP",
  GATE_OUT: "GATE OUT",
  TERMINAL_PICKUP_APPOINTMENT: "TERM APPT",
  TERMINAL_EMPTY_DROP_APPOINTMENT: "DEL APPT",
  WAREHOUSE_DROP_APPOINTMENT: "ACTUAL DELIVERY",
  WAREHOUSE_EMPTY_PICKUP_APPOINTMENT: "TERM RETURN APP",
  GATE_IN: "GATE IN",
  DRAYAGE_PARTNER: "DRAYAGE PARTNER"
};

var ContainerHistoryModal = function (_Component) {
  inherits(ContainerHistoryModal, _Component);

  function ContainerHistoryModal(props) {
    classCallCheck(this, ContainerHistoryModal);

    var _this = possibleConstructorReturn(this, (ContainerHistoryModal.__proto__ || Object.getPrototypeOf(ContainerHistoryModal)).call(this, props));

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          entityId = _this$props.entityId,
          commentEntityEventId = _this$props.commentEntityEventId,
          shipmentIds = _this$props.shipmentIds,
          getContainerHistory = _this$props.getContainerHistory;


      var params = {
        entityId: entityId,
        shipmentIds: shipmentIds,
        entityType: "WORKFLOW_ENTITY_TYPE_CONTAINER",
        eventName: "CONTAINER_MODIFICATION_HISTORY",
        commentEntityEventId: commentEntityEventId
      };

      getContainerHistory(params).then(function (res) {
        return _this.setState({ modalHistory: res.data.eventMessage.list });
      });
    };

    _this.sortFun = function (arr, type) {
      if (!arr) return "";
      var _this$state = _this.state,
          changeByEvent = _this$state.changeByEvent,
          changeByRequestType = _this$state.changeByRequestType,
          chabgeByNewSelectedTime = _this$state.chabgeByNewSelectedTime,
          chabgeByNewSelectedTime2 = _this$state.chabgeByNewSelectedTime2,
          changeByOldSelectedTime = _this$state.changeByOldSelectedTime,
          changeByOldSelectedTime2 = _this$state.changeByOldSelectedTime2,
          changeByUserType = _this$state.changeByUserType,
          changeByUserEmail = _this$state.changeByUserEmail,
          changeByCreatedDate = _this$state.changeByCreatedDate;


      var newArr = [].concat(toConsumableArray(arr));

      var status = type == 0 ? changeByEvent : type == 1 ? changeByRequestType : type == 2 ? chabgeByNewSelectedTime : type == 3 ? changeByOldSelectedTime : type == 4 ? chabgeByNewSelectedTime2 : type == 5 ? changeByOldSelectedTime2 : type == 6 ? changeByUserType : type == 7 ? changeByUserEmail : changeByCreatedDate;

      var sortType = type == 0 ? "event" : type == 1 ? "requestType" : type == 2 ? "newSelectedTime" : type == 3 ? "oldSelectedTime" : type == 4 ? "newSelectedTime2" : type == 5 ? "oldSelectedTime2" : type == 6 ? "userType" : type == 7 ? "userEmail" : "createdDate";

      newArr.forEach(function (data) {
        if ((data.event === "CONTAINER_HOLDS" || data.event === "CONTAINER_FEES") && data.oldHoldFeesValue) data.oldSelectedTime = data.oldHoldFeesValue;
        if ((data.event === "CONTAINER_HOLDS" || data.event === "CONTAINER_FEES") && data.newHoldFeesValue) data.newSelectedTime = data.newHoldFeesValue;
        if ((data.event === "CONTAINER_HOLDS" || data.event === "CONTAINER_FEES") && !data.oldHoldFeesValue) data.oldSelectedTime = "0";
        if ((data.event === "CONTAINER_HOLDS" || data.event === "CONTAINER_FEES") && !data.newHoldFeesValue) data.newSelectedTime = "0";
        if (!data.oldSelectedTime) data.oldSelectedTime = "0";
        if (!data.oldSelectedTime2) data.oldSelectedTime2 = "0";
        if (!data.newSelectedTime) data.newSelectedTime = "0";
        if (!data.newSelectedTime2) data.newSelectedTime2 = "0";
      });

      newArr.sort(function (a, b) {
        if (typeof a[sortType] === "undefined") return 1;
        if (typeof b[sortType] === "undefined") return -1;

        if (status == false) {
          return a[sortType] < b[sortType] ? -1 : a[sortType] == b[sortType] ? 0 : 1;
        } else if (status == true) {
          return a[sortType] < b[sortType] ? 1 : a[sortType] == b[sortType] ? 0 : -1;
        }
      });
      _this.setState({ modalHistory: newArr });
    };

    _this.state = {
      modalHistory: [],
      changeByEvent: true,
      changeByRequestType: true,
      chabgeByNewSelectedTime: true,
      chabgeByNewSelectedTime2: true,
      changeByOldSelectedTime: true,
      changeByOldSelectedTime2: true,
      changeByUserType: true,
      changeByUserEmail: true,
      changeByCreatedDate: true
    };
    return _this;
  }

  createClass(ContainerHistoryModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          entityId = _props.entityId,
          onCloseModal = _props.onCloseModal,
          entityTimezone = _props.entityTimezone,
          convertEpochToDate = _props.convertEpochToDate,
          modalHistory = this.state.modalHistory;


      return React__default.createElement(
        Modal,
        {
          onClose: function onClose() {
            return onCloseModal(false);
          },
          open: true,
          className: "historyModal"
        },
        React__default.createElement(
          Modal.Header,
          {
            className: "modal-header"
          },
          React__default.createElement(
            "div",
            null,
            "Container modification history: " + entityId,
            React__default.createElement("br", null),
            React__default.createElement(
              "span",
              null,
              "*All Selected Time in port local timezone"
            )
          ),
          React__default.createElement(
            "button",
            {
              type: "button",
              className: "close",
              style: { border: "none", background: "none", cursor: "pointer" },
              onClick: function onClick() {
                return onCloseModal(false);
              }
            },
            "\xD7"
          )
        ),
        React__default.createElement(
          Modal.Content,
          { image: true, className: "historyModal_container" },
          React__default.createElement(
            "div",
            { className: "history-table" },
            React__default.createElement(
              "table",
              { style: { width: "100%" } },
              React__default.createElement(
                "thead",
                null,
                React__default.createElement(
                  "tr",
                  null,
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this2.setState({ changeByEvent: !_this2.state.changeByEvent });
                        _this2.sortFun(modalHistory, 0);
                      },
                      style: { padding: "5px", cursor: "pointer" }
                    },
                    "Event",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this2.setState({ changeByRequestType: !_this2.state.changeByRequestType });
                        _this2.sortFun(modalHistory, 1);
                      },
                      style: { padding: "5px", cursor: "pointer" }
                    },
                    "Request Type",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this2.setState({ chabgeByNewSelectedTime: !_this2.state.chabgeByNewSelectedTime });
                        _this2.sortFun(modalHistory, 2);
                      },
                      style: { padding: "5px", cursor: "pointer" }
                    },
                    "New Value",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this2.setState({ changeByOldSelectedTime: !_this2.state.changeByOldSelectedTime });
                        _this2.sortFun(modalHistory, 3);
                      },
                      style: { padding: "5px", cursor: "pointer" }
                    },
                    "Old Value",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this2.setState({ chabgeByNewSelectedTime2: !_this2.state.chabgeByNewSelectedTime2 });
                        _this2.sortFun(modalHistory, 4);
                      },
                      style: { padding: "5px", cursor: "pointer" }
                    },
                    "New Selected Time2",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this2.setState({ changeByOldSelectedTime2: !_this2.state.changeByOldSelectedTime2 });
                        _this2.sortFun(modalHistory, 5);
                      },
                      style: { padding: "5px", cursor: "pointer" }
                    },
                    "Old Selected Time2",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this2.setState({ changeByUserType: !_this2.state.changeByUserType });
                        _this2.sortFun(modalHistory, 6);
                      },
                      style: { padding: "5px", cursor: "pointer" }
                    },
                    "User Type",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this2.setState({ changeByUserEmail: !_this2.state.changeByUserEmail });
                        _this2.sortFun(modalHistory, 7);
                      },
                      style: { padding: "5px", cursor: "pointer" }
                    },
                    "User Email",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  ),
                  React__default.createElement(
                    "th",
                    {
                      onClick: function onClick() {
                        _this2.setState({ changeByCreatedDate: !_this2.state.changeByCreatedDate });
                        _this2.sortFun(modalHistory, 8);
                      },
                      style: { padding: "5px", cursor: "pointer" }
                    },
                    "Created Date(UTC)",
                    React__default.createElement(
                      "svg",
                      {
                        style: { position: "absolute" },
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16"
                      },
                      React__default.createElement("path", { fill: "#4448", d: "M11 7H5l3-4zM5 9h6l-3 4z" })
                    )
                  )
                )
              ),
              React__default.createElement(
                "tbody",
                null,
                modalHistory && modalHistory.map(function (histories) {
                  var event = get(histories, "event", "");
                  return React__default.createElement(
                    "tr",
                    null,
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      histories.event ? eventType[histories.event] : "N/A"
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      event === "DRAYAGE_PARTNER" ? get(histories, "requestType", "") : histories.requestType ? requestdType[histories.requestType] : "N/A"
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      histories.newSelectedTime && histories.newSelectedTime !== "0" && histories.event !== "CONTAINER_HOLDS" && histories.event !== "CONTAINER_FEES" ? convertEpochToDate(histories.newSelectedTime, false, true, entityTimezone) : histories.newHoldFeesValue && histories.event === "CONTAINER_HOLDS" ? histories.newHoldFeesValue : histories.newHoldFeesValue && histories.event === "CONTAINER_FEES" && !isNaN(histories.newHoldFeesValue) ? "$" + (histories.newHoldFeesValue / 100).toFixed(2) : histories.newHoldFeesValue && histories.event === "CONTAINER_FEES" && isNaN(histories.newHoldFeesValue) ? histories.newHoldFeesValue : event === "DRAYAGE_PARTNER" ? get(histories, "newValue", "") : "N/A"
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      histories.oldSelectedTime && histories.oldSelectedTime !== "0" && histories.event !== "CONTAINER_HOLDS" && histories.event !== "CONTAINER_FEES" ? convertEpochToDate(histories.oldSelectedTime, false, true, entityTimezone) : histories.oldHoldFeesValue && histories.event === "CONTAINER_HOLDS" ? histories.oldHoldFeesValue : histories.oldHoldFeesValue && histories.event === "CONTAINER_FEES" && !isNaN(histories.oldHoldFeesValue) ? "$" + (histories.oldHoldFeesValue / 100).toFixed(2) : histories.oldHoldFeesValue && histories.event === "CONTAINER_FEES" && isNaN(histories.oldHoldFeesValue) ? histories.oldHoldFeesValue : event === "DRAYAGE_PARTNER" ? get(histories, "previousValue", "") : "N/A"
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      histories.newSelectedTime2 && histories.newSelectedTime2 !== "0" ? convertEpochToDate(histories.newSelectedTime2, false, true, entityTimezone) : "N/A"
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      histories.oldSelectedTime2 && histories.oldSelectedTime2 !== "0" ? convertEpochToDate(histories.oldSelectedTime2, false, true, entityTimezone) : "N/A"
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      histories.userType !== undefined ? histories.userType : "-"
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      histories.userEmail !== undefined ? histories.userEmail : "-"
                    ),
                    React__default.createElement(
                      "td",
                      { style: { padding: "5px" } },
                      histories.createdDate ? moment$1(histories.createdDate).format("MMM Do YYYY, hh:mm:ss a") : "N/A"
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return ContainerHistoryModal;
}(Component);

var css_248z$e = ".sematic-date-field .ui.input .field {\n  width: 100%; }\n";
styleInject(css_248z$e);

var DateInputField = function (_Component) {
  inherits(DateInputField, _Component);

  function DateInputField() {
    classCallCheck(this, DateInputField);

    var _this = possibleConstructorReturn(this, (DateInputField.__proto__ || Object.getPrototypeOf(DateInputField)).call(this));

    _this.errorPopup = function (errors) {
      var error = errors.map(function (info, index) {
        return React__default.createElement(
          'div',
          { className: 'error', key: index },
          '* ',
          info
        );
      });
      return React__default.createElement(Popup, { trigger: React__default.createElement(Icon, { name: 'warning sign', color: 'red' }), content: error || '' });
    };

    _this.emptyField = function (id) {
      !_this.props.isInteger && _this.props.onChange('');
      var element = document.getElementById(id);
      element.focus();
    };

    _this.state = {};
    return _this;
  }

  createClass(DateInputField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.newValue !== this.state.newValue || nextProps.rbCounterId !== this.state.rbCounterId) {
        this.setState({ newValue: nextProps.newValue, rbCounterId: nextProps.rbCounterId }, function () {
          _this2.props.fieldName === _this2.props.id + _this2.props.shipmentId && _this2.props.onChange(_this2.props.isInteger ? parseFloat(_this2.state.newValue.replace(/[^\d.-]/g, '')).toFixed(2) : _this2.state.newValue);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          iconPosition = _props.iconPosition,
          width = _props.width,
          type = _props.type,
          onChange = _props.onChange,
          onBlur = _props.onBlur,
          disabled = _props.disabled,
          value = _props.value,
          setINPUTID = _props.setINPUTID,
          penClicked = _props.penClicked,
          isInteger = _props.isInteger,
          shipmentId = _props.shipmentId,
          handleFocus = _props.handleFocus,
          label = _props.label,
          numberOnly = _props.numberOnly,
          errors = _props.errors,
          minDate = _props.minDate,
          drayageCal = _props.drayageCal;

      return React__default.createElement(
        Form.Input,
        { width: width, className: 'sematic-date-field' },
        React__default.createElement(
          'label',
          null,
          label
        )
      );
    }
  }]);
  return DateInputField;
}(Component);

var CustomLoader = function (_Component) {
    inherits(CustomLoader, _Component);

    function CustomLoader() {
        classCallCheck(this, CustomLoader);
        return possibleConstructorReturn(this, (CustomLoader.__proto__ || Object.getPrototypeOf(CustomLoader)).apply(this, arguments));
    }

    createClass(CustomLoader, [{
        key: 'render',
        value: function render() {

            var showImage = get(this.props, 'showImage', false);
            showImage = isBoolean(showImage) ? showImage : false;

            return React__default.createElement(
                React__default.Fragment,
                null,
                this.props.loading && React__default.createElement(
                    Segment,
                    { className: 'custom-loader' },
                    React__default.createElement(
                        Dimmer,
                        { active: true },
                        React__default.createElement(
                            Loader,
                            null,
                            'Loading'
                        )
                    ),
                    showImage && React__default.createElement(Image, { src: '/images/short-paragraph.png' })
                )
            );
        }
    }]);
    return CustomLoader;
}(Component);

var getCookie$1 = function getCookie() {
  var cname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "kxPartnerToken";

  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

var kxToken$1 = getCookie$1("kxPartnerToken");

var getRequestHeaders$1 = function getRequestHeaders() {
  return {
    "Content-Type": "application/json",
    kxToken: kxToken$1
  };
};

var uploadImageToBucket = function uploadImageToBucket(payload, uploadTo) {
  return HttpClient.custom({
    url: window._env_.REACT_APP_MEDIA_URL + "/" + uploadTo,
    headers: {
      "Content-type": "multipart/form-data"
    },
    data: payload,
    method: "post"
  });
};

var getDrayageChargeList = function getDrayageChargeList(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_FINANCE_CHARGES_LIST",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayagePartnerDetails = function getDrayagePartnerDetails(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "DRAYAGE_GET_PARTNER_DETAILS",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var saveContainerChargeList = function saveContainerChargeList(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "UPSERT_DRAYAGE_CHARGES_LIST",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var saveContainerDisputedData = function saveContainerDisputedData(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "UPDATE_DISPUTED_INVOICE_BY_PARTNER",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var deleteChargeAtLineItem = function deleteChargeAtLineItem(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "ARCHIVE_DRAYAGE_CHARGE_LIST",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var createInvoiceFromChargeList = function createInvoiceFromChargeList(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GENERATE_INVOICE_FROM_CHARGE_LIST",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayageDocument = function getDrayageDocument(_ref) {
  var chargeNames = _ref.chargeNames,
      containerId = _ref.containerId;

  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: { chargeNames: chargeNames, containerId: containerId },
      eventType: "GET_DRAYAGE_DOCUMENTS",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var insertDrayageDocument$1 = function insertDrayageDocument(formData, uploadTo, setProgress, containerId, docType, actualFileName, displayName) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: {
        containerId: containerId,
        chargeNames: docType,
        actualFileName: actualFileName,
        displayName: displayName
      },
      eventType: "INSERT_DRAYAGE_DOCUMENT",
      eventTime: Date.now()
    }),
    onUploadProgress: function onUploadProgress(data) {
      //Set the progress value to show the progress bar
      setProgress(Math.round(100 * data.loaded / data.total));
    },
    method: "post"
  });
};

var getDrayagePendingInvoices = function getDrayagePendingInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayageImageURL = function getDrayageImageURL(fileName) {
  var data = {
    eventMessage: fileName,
    eventType: "GET_SIGNED_URLS",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var getDrayagePaidInvoices = function getDrayagePaidInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var downloadPaidExcelReport = function downloadPaidExcelReport() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$startDate = _ref3.startDate,
      startDate = _ref3$startDate === undefined ? "" : _ref3$startDate,
      _ref3$endDate = _ref3.endDate,
      endDate = _ref3$endDate === undefined ? "" : _ref3$endDate,
      _ref3$partnerId = _ref3.partnerId,
      partnerId = _ref3$partnerId === undefined ? "" : _ref3$partnerId;

  if (!startDate) {
    throw new Error("Start date required");
  }
  if (!endDate) {
    throw new Error("End date required");
  }
  if (!partnerId) {
    throw new Error("Drayage partner required");
  }
  var data = {
    eventMessage: {
      startDate: startDate,
      endDate: endDate,
      partnerId: partnerId
    },
    eventType: "GENERATE_VENDOR_PAID_REPORT",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var getDrayagePartiallyPaidInvoices = function getDrayagePartiallyPaidInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayageRejectedInvoices = function getDrayageRejectedInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var getDrayageDisputedInvoices = function getDrayageDisputedInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var archiveDrayageDocument$1 = function archiveDrayageDocument(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "ARCHIVE_DRAYAGE_DOCUMENT",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var drayagePaidInvoice = function drayagePaidInvoice(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "DRAYAGE_PAID_INVOICE",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var getDrayageTabCount = function getDrayageTabCount(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_TAB_COUNT",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var resolveDisputeForInvoice = function resolveDisputeForInvoice(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "APPROVE_DISPUTE_INVOICE",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var getDrayageChangeLog = function getDrayageChangeLog(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_CHANGE_LOG",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var deleteChargeAtLineItemForDisputedTab = function deleteChargeAtLineItemForDisputedTab(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$1(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "ARCHIVE_CHARGES_FROM_DISPUTED_INVOICE",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var css_248z$f = "\n/* For pdf */\n.react-pdf__Page {\n  margin-top: 10px;\n}\n.react-pdf__Page__textContent {\n  border: 1px solid darkgrey;\n  box-shadow: 5px 5px 5px 1px #ccc;\n  border-radius: 5px;\n}\n\n.react-pdf__Page__annotations.annotationLayer {\n  padding: 20px;\n}\n\n.react-pdf__Page__canvas {\n  margin: 0 auto;\n}\n\n/* For all pages */\n.all-page-container {\n  height: 100%;\n  max-height: 500px;\n  overflow: auto;\n  width:639px\n}\n";
styleInject(css_248z$f);

var PDFViewer = function (_React$Component) {
  inherits(PDFViewer, _React$Component);

  function PDFViewer(props) {
    classCallCheck(this, PDFViewer);

    var _this = possibleConstructorReturn(this, (PDFViewer.__proto__ || Object.getPrototypeOf(PDFViewer)).call(this, props));

    _this.onDocumentLoadSuccess = function (_ref) {
      var numPages = _ref.numPages;

      _this.setState({ numPages: numPages });
    };

    _this.state = { numPages: null };
    return _this;
  }

  createClass(PDFViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      if (lodash_2(lodash_1(this.props, "url", ""))) {
        return "";
      }

      return React__default.createElement(
        "div",
        { className: "all-page-container" },
        React__default.createElement(
          Document,
          {
            file: lodash_1(this.props, "url", ""),
            options: { workerSrc: "/pdf.worker.js" },
            onLoadSuccess: this.onDocumentLoadSuccess
          },
          this.state.numPages && Array.from(new Array(this.state.numPages), function (el, index) {
            return React__default.createElement(Page, { key: "page_" + (index + 1), pageNumber: index + 1 });
          })
        )
      );
    }
  }]);
  return PDFViewer;
}(React__default.Component);

var UploadDocument = function (_Component) {
  inherits(UploadDocument, _Component);

  function UploadDocument(props) {
    var _this2 = this;

    classCallCheck(this, UploadDocument);

    var _this = possibleConstructorReturn(this, (UploadDocument.__proto__ || Object.getPrototypeOf(UploadDocument)).call(this, props));

    _this.get_url_extension = function (url) {
      var ext = url.split(/[#?]/)[0].split(".").pop().trim();
      return ext;
    };

    _this.addTableRows = function () {
      _this.setState({ addNewItem: true, currentSelectedCharge: "" });
    };

    _this.fetchDocument = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$state, useDocument, remaningDocument, chargeDataArray, containerId, getDoc, documents, firstDocumentId, filteredDocumentArray, fileNameArray, imageResults, ImageLinks, remainingDoc, newOption;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state = _this.state, useDocument = _this$state.useDocument, remaningDocument = _this$state.remaningDocument;
              chargeDataArray = _this.props.chargeDesc
              // .filter((x) => !["60001", "60002"].includes(x.glCode))
              .map(function (y) {
                return { glCode: y.glCode, chargeName: y.chargeName };
              });
              containerId = {
                containerId: _this.props.containerId
              };
              _context2.next = 5;
              return getDrayageDocument({
                containerId: _this.props.containerId,
                chargeNames: chargeDataArray
              });

            case 5:
              getDoc = _context2.sent;
              documents = get(getDoc, "data.eventMessage.documents", []);
              firstDocumentId = "";

              if (documents[0]) {
                firstDocumentId = documents[0].key;
              }
              filteredDocumentArray = {};

              documents.forEach(function (val) {
                var chargeNames = get(val, "value.chargeNames", []).map(function (valChargeName) {
                  if (filteredDocumentArray["" + valChargeName.chargeName]) {
                    filteredDocumentArray["" + valChargeName.chargeName] = [].concat(toConsumableArray(filteredDocumentArray["" + valChargeName.chargeName]), [{
                      key: val.key,
                      actualFileName: val.value.actualFileName,
                      displayName: val.value.displayName,
                      docId: val.value.docId,
                      glCode: valChargeName.glCode,
                      chargeName: valChargeName.chargeName
                    }]);
                  } else {
                    filteredDocumentArray["" + valChargeName.chargeName] = [{
                      key: val.key,
                      actualFileName: val.value.actualFileName,
                      displayName: val.value.displayName,
                      docId: val.value.docId,
                      glCode: valChargeName.glCode,
                      chargeName: valChargeName.chargeName
                    }];
                  }
                });
              });
              _this.setState({
                imageId: firstDocumentId,
                useDocument: _extends({}, useDocument, { documents: documents }),
                chargeFiles: filteredDocumentArray
              });
              fileNameArray = documents.map(function () {
                var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(d) {
                  var fileLink;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return getDrayageImageURL(window._env_.DRAYAGE_BILL_BUCKET + ":" + d.value.actualFileName);

                        case 2:
                          fileLink = _context.sent;
                          _context.next = 5;
                          return fileLink;

                        case 5:
                          return _context.abrupt("return", _context.sent);

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context2.next = 15;
              return Promise.all(fileNameArray);

            case 15:
              imageResults = _context2.sent;
              ImageLinks = {};

              imageResults.forEach(function (e, key) {
                var fileKey = get(documents[key].value, "actualFileName", "");
                if (!isEmpty(get(documents[key].value, "chargeNames", []))) {
                  set(ImageLinks, [fileKey], e.data.eventMessage.urls[0]);
                }
              });
              _this.setState({ imageURLs: ImageLinks }, function () {
                var obj = {};
                var i = 0;
                for (i = 0; i < get(_this, "state.useDocument.documents", []).length; i++) {
                  var _useDocument = get(_this, "state.useDocument.documents", {})[i];
                  console.log("testingkkk", _useDocument, i, get(_this, "state.useDocument.documents", []));
                  if (!isEmpty(get(_useDocument, "value.chargeNames", []))) {
                    obj = _useDocument;
                    break;
                  }
                }
                console.log("testingkkk", obj, i);
                _this.setImageToShow(obj, 0);
              });

              remainingDoc = get(getDoc, "data.eventMessage.remainingDocTypes", []);

              console.log("505050", remainingDoc);
              newOption = remainingDoc && remainingDoc.length > 0 && remainingDoc.map(function (item, index) {
                return { key: item.chargeName, text: item.chargeName, value: item };
              });

              _this.setState({ remaningDocument: _extends({}, remaningDocument, { newOption: newOption }) });

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.handleDropDownSelect = function (event, data) {
      _this.setState({ currentSelectedCharge: data.value });
    };

    _this.setProgresStatus = function (val) {
      _this.setState({ progressStatus: val });
    };

    _this.setNewFile = function (event) {
      var selectedFiles = _this.state.selectedFiles;

      var fileData = selectedFiles;
      if (_this.state.currentSelectedCharge !== "") {
        fileData = _extends({}, fileData, { getelectedCharge: event.target.files[0] });
        _this.setState({ selectedFiles: _extends({}, fileData) });
        var containerId = _this.props.containerId;
        var docType = _this.state.currentSelectedCharge;
        var filename = Date.now() + "_" + event.target.files[0].name;

        var bodyFormData = new FormData();
        bodyFormData.append("files", event.target.files[0], filename);
        var url = window._env_.REACT_APP_MEDIA_URL + "/" + window._env_.DRAYAGE_BILL_BUCKET;

        var bucketName = window._env_.DRAYAGE_BILL_BUCKET;
        uploadImageToBucket(bodyFormData, bucketName).then(function (res) {
          var files = get(res, "data.msg", "");
          if (files !== "") {
            files = files.split("[")[1];
            files = files.split("]")[0];
            files = files;
          } else {
            files = "demo";
          }
          insertDrayageDocument$1(bodyFormData, url, _this.setProgresStatus, containerId, docType, files, files).then(function () {
            _this.fetchDocument();
            _this.setState({
              selectedFile: null,
              addNew: false,
              currentSelectedCharge: "",
              progressStatus: "",
              selectedFiles: ""
            });
            _this.fileRef.current.value = null;
          });
        });
      }
    };

    _this.ifChecked = function (value) {
      var selectedFilesKeys = Object.keys(_this.state.selectedFiles);
      if (selectedFilesKeys.includes(value)) {
        return true;
      } else {
        return false;
      }
    };

    _this.setImageToShow = function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, imageIndex) {
        var imageUrls, fileName, fileUrl, extenison, _imageUrls, _fileName, _fileUrl, _extenison;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("setImageToShow", data, imageIndex);
                if (get(data, "actualFileName", false) === false) {
                  imageUrls = _this.state.imageURLs;
                  fileName = get(data, "value.actualFileName", "");
                  fileUrl = get(imageUrls, fileName, "");
                  extenison = _this.get_url_extension(fileUrl);

                  _this.setState({
                    imageShow: fileUrl,
                    fileExtension: extenison,
                    imageId: data.key,
                    fileImageIndex: imageIndex
                  });
                } else {
                  _imageUrls = _this.state.imageURLs;
                  _fileName = get(data, "actualFileName", "");
                  _fileUrl = get(_imageUrls, _fileName, "");
                  _extenison = _this.get_url_extension(_fileUrl);

                  _this.setState({
                    imageShow: _fileUrl,
                    fileExtension: _extenison,
                    imageId: data.key,
                    fileImageIndex: imageIndex
                  });
                }

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.removeDoc = function (id, glCode) {
      var files = _this.state.selectedFiles;
      delete files[id];
      archiveDrayageDocument$1({
        docId: id,
        chargeNames: [{
          glCode: glCode
        }]
      }).then(function (res) {
        _this.setState({ selectedFiles: _extends({}, files) });
        _this.fetchDocument();
      });
    };

    _this.openInNewTab = function (url) {
      var newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    };

    _this.getChargelistData = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.props.getChargelistData();

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    _this.state = {
      open: false,
      addNew: false,
      selectedFiles: {},
      currentSelectedCharge: "",
      selectedFile: null,
      progressStatus: "",
      useDocument: [],
      remaningDocument: [],
      addNewItem: false,
      imageShow: "",
      imageId: "",
      imageURLs: {},
      fileExtension: "",
      fileImageIndex: 0,
      chargeFiles: {}
    };
    _this.fileRef = React__default.createRef();
    return _this;
  }

  createClass(UploadDocument, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var imageUrls = this.state.imageURLs;
      var url = imageUrls[Object.keys(imageUrls)[0]];
      this.setState({ imageShow: url });

      // const imageUrls = this.state.imageURLs;
      // let fileName = get(data, "value.actualFileName", "");
      // let fileUrl = get(imageUrls, fileName, "");
      // this.setState({ imageShow: fileUrl, imageId: data.key })
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          containerId = _props.containerId,
          containerNumber = _props.containerNumber,
          _state = this.state,
          open = _state.open,
          selectedFiles = _state.selectedFiles,
          useDocument = _state.useDocument,
          addNewItem = _state.addNewItem,
          remaningDocument = _state.remaningDocument,
          progressStatus = _state.progressStatus,
          imageShow = _state.imageShow,
          imageId = _state.imageId,
          fileExtension = _state.fileExtension,
          currentSelectedCharge = _state.currentSelectedCharge,
          fileImageIndex = _state.fileImageIndex;

      var isNonEditable = this.props.isNonEditable || false;
      return isNonEditable === false ? React__default.createElement(
        Modal,
        {
          closeIcon: true,
          centered: true,
          open: open,
          trigger: React__default.createElement(
            "span",
            { className: "btn-over" },
            !this.props.showOtherTab ? React__default.createElement(
              "svg",
              {
                width: "45",
                height: "38",
                viewBox: "0 0 45 38",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              },
              React__default.createElement("rect", { x: "1", y: "1", width: "43", height: "36", rx: "2" }),
              React__default.createElement("path", {
                d: "M28.0118 13.9492C27.2688 11.0418 24.6007 9.00174 21.539 9C18.4772 8.99826 15.8067 11.0353 15.0602 13.9418C11.5051 14.2684 8.83993 17.2723 9.00748 20.7637C9.17504 24.255 12.1162 27.0011 15.6869 27H18.1937C18.6552 27 19.0293 26.6338 19.0293 26.1821C19.0293 25.7303 18.6552 25.3641 18.1937 25.3641H15.6869C12.918 25.3721 10.6668 23.1813 10.6588 20.4709C10.6507 17.7605 12.8888 15.557 15.6577 15.549C16.1018 15.5818 16.4991 15.2799 16.5768 14.8505C16.9286 12.4359 19.041 10.6421 21.5327 10.6421C24.0244 10.6421 26.1368 12.4359 26.4886 14.8505C26.5787 15.2631 26.9542 15.5556 27.3851 15.549C30.154 15.549 32.3987 17.7462 32.3987 20.4566C32.3987 23.167 30.154 25.3641 27.3851 25.3641H24.8784C24.4169 25.3641 24.0428 25.7303 24.0428 26.1821C24.0428 26.6338 24.4169 27 24.8784 27H27.3851C30.9277 26.9637 33.8262 24.2283 33.9925 20.7642C34.1589 17.3001 31.5353 14.3106 28.0118 13.9492Z",
                fill: "#008B8F"
              }),
              React__default.createElement("path", {
                d: "M25.5848 21.5233C25.9125 21.8354 26.4333 21.8309 26.7554 21.5133C27.0775 21.1956 27.0821 20.682 26.7656 20.3588L22.5904 16.2411C22.2643 15.9196 21.7357 15.9196 21.4096 16.2411L17.2344 20.3588C16.9179 20.682 16.9225 21.1956 17.2446 21.5133C17.5667 21.8309 18.0875 21.8354 18.4152 21.5233L21.165 18.8114V29.1765C21.165 29.6313 21.5388 30 22 30C22.4612 30 22.835 29.6313 22.835 29.1765V18.8114L25.5848 21.5233Z",
                fill: "#008B8F"
              })
            ) : React__default.createElement(
              "svg",
              {
                width: "41",
                height: "38",
                viewBox: "0 0 41 38",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              },
              React__default.createElement("rect", { x: "1", y: "1", width: "39", height: "36", rx: "2" }),
              React__default.createElement("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M16.5882 10.1351C16.2796 10.1351 16.0294 10.3892 16.0294 10.7027V11.8378H23.2941C23.9113 11.8378 24.4118 12.3461 24.4118 12.973V18.7622C24.0231 18.8423 23.649 18.9635 23.2941 19.1209V12.973H12.1176V28.8649H22.176C22.7064 29.2696 23.3102 29.5808 23.9633 29.7741C23.7768 29.9159 23.5451 30 23.2941 30H12.1176C11.5004 30 11 29.4917 11 28.8649V12.973C11 12.3461 11.5004 11.8378 12.1176 11.8378H14.9118V10.7027C14.9118 9.76233 15.6624 9 16.5882 9H26.0882C27.0142 9 27.7647 9.76233 27.7647 10.7027V19.1209C27.4099 18.9635 27.0357 18.8423 26.6471 18.7622V10.7027C26.6471 10.3892 26.3968 10.1351 26.0882 10.1351H16.5882ZM30 24.3243C30 26.832 27.9985 28.8649 25.5294 28.8649C23.164 28.8649 21.2276 26.999 21.0693 24.6372L21.4584 25.0175L21.4594 25.0184L21.461 25.0199L21.4667 25.0255L21.4869 25.0448C21.5042 25.0613 21.529 25.0848 21.5609 25.1144C21.6245 25.1734 21.7161 25.2566 21.8307 25.3561C22.0591 25.5546 22.3816 25.82 22.7565 26.0864C23.1301 26.352 23.5654 26.6256 24.0192 26.8343C24.4678 27.0407 24.9688 27.2 25.4645 27.2C25.9601 27.2 26.4612 27.0407 26.9097 26.8343C27.3635 26.6256 27.7989 26.352 28.1724 26.0864C28.5474 25.82 28.8698 25.5546 29.0983 25.3561C29.2128 25.2566 29.3045 25.1734 29.3681 25.1144C29.3999 25.0848 29.4248 25.0613 29.4421 25.0448L29.4623 25.0255L29.468 25.0199L29.4697 25.0184L29.4706 25.0175L29.8702 24.627L29.4706 24.2366L29.4697 24.2357L29.468 24.234L29.4623 24.2286L29.4421 24.2093C29.4248 24.1928 29.3999 24.1693 29.3681 24.1397C29.3045 24.0807 29.2128 23.9974 29.0983 23.898C28.8698 23.6995 28.5474 23.4341 28.1724 23.1675C27.7989 22.9021 27.3635 22.6285 26.9097 22.4198C26.4612 22.2134 25.9601 22.0541 25.4645 22.0541C24.9688 22.0541 24.4678 22.2134 24.0192 22.4198C23.5654 22.6285 23.1301 22.9021 22.7565 23.1675C22.3816 23.4341 22.0591 23.6995 21.8307 23.898C21.7161 23.9974 21.6245 24.0807 21.5609 24.1397C21.529 24.1693 21.5042 24.1928 21.4869 24.2093L21.4667 24.2286L21.461 24.234L21.4594 24.2357L21.4584 24.2366L21.068 24.618C21.0619 24.521 21.0588 24.423 21.0588 24.3243C21.0588 21.8166 23.0604 19.7838 25.5294 19.7838C27.9985 19.7838 30 21.8166 30 24.3243ZM21.4584 24.2366C21.4584 24.2368 21.4584 24.2366 21.8281 24.627L21.4584 24.2366ZM21.8281 24.627C21.4584 25.0175 21.4584 25.0173 21.4584 25.0175L21.8281 24.627ZM29.4706 24.2366L29.1009 24.627C29.4706 24.2366 29.4707 24.2368 29.4706 24.2366ZM29.1009 24.627L29.4706 25.0175C29.4707 25.0173 29.4706 25.0175 29.1009 24.627ZM22.6339 24.627C22.8319 24.7946 23.0844 24.9971 23.3682 25.1988C23.709 25.4412 24.0854 25.6755 24.4594 25.8475C24.8386 26.022 25.1815 26.1167 25.4645 26.1167C25.7474 26.1167 26.0903 26.022 26.4695 25.8475C26.8435 25.6755 27.2199 25.4412 27.5608 25.1988C27.8447 24.9971 28.0972 24.7946 28.295 24.627C28.0972 24.4594 27.8447 24.2569 27.5608 24.0551C27.2199 23.8129 26.8435 23.5786 26.4695 23.4065C26.0903 23.232 25.7474 23.1374 25.4645 23.1374C25.1815 23.1374 24.8386 23.232 24.4594 23.4065C24.0854 23.5786 23.709 23.8129 23.3682 24.0551C23.0844 24.2569 22.8319 24.4594 22.6339 24.627ZM25.4281 25.8458C26.0909 25.8458 26.6282 25.3002 26.6282 24.627C26.6282 23.9539 26.0909 23.4083 25.4281 23.4083C24.7655 23.4083 24.2281 23.9539 24.2281 24.627C24.2281 25.3002 24.7655 25.8458 25.4281 25.8458ZM13.2353 16.9459C13.2353 16.6325 13.4855 16.3784 13.7941 16.3784H20.5C20.8086 16.3784 21.0588 16.6325 21.0588 16.9459C21.0588 17.2594 20.8086 17.5135 20.5 17.5135H13.7941C13.4855 17.5135 13.2353 17.2594 13.2353 16.9459ZM13.7941 18.6486C13.4855 18.6486 13.2353 18.9028 13.2353 19.2162C13.2353 19.5296 13.4855 19.7838 13.7941 19.7838H21.6176C21.9262 19.7838 22.1765 19.5296 22.1765 19.2162C22.1765 18.9028 21.9262 18.6486 21.6176 18.6486H13.7941ZM13.2353 21.4865C13.2353 21.1731 13.4855 20.9189 13.7941 20.9189H19.3824C19.691 20.9189 19.9412 21.1731 19.9412 21.4865C19.9412 21.7999 19.691 22.0541 19.3824 22.0541H13.7941C13.4855 22.0541 13.2353 21.7999 13.2353 21.4865ZM13.7941 23.1892C13.4855 23.1892 13.2353 23.4433 13.2353 23.7568C13.2353 24.0702 13.4855 24.3243 13.7941 24.3243H19.3824C19.691 24.3243 19.9412 24.0702 19.9412 23.7568C19.9412 23.4433 19.691 23.1892 19.3824 23.1892H13.7941Z",
                fill: "#008B8F"
              })
            )
          ),
          onClose: asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _this3.getChargelistData();
                    _this3.setState({ open: false, addNewItem: false });

                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, _this3);
          })),
          onOpen: asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this3.fetchDocument();

                  case 2:
                    _this3.setState({ open: true });

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, _this3);
          })),
          className: "upload-document",
          size: "fullscreen"
        },
        React__default.createElement(
          "div",
          { className: "upload-doc-img" },
          React__default.createElement("img", { src: "/images/DOC.svg" })
        ),
        React__default.createElement(
          Modal.Content,
          { scrolling: true },
          React__default.createElement(
            "h3",
            null,
            "Documents for Container ",
            containerNumber
          ),
          React__default.createElement(
            "div",
            { className: "uploadDocument" },
            React__default.createElement(
              "div",
              { className: "documentList" },
              React__default.createElement(
                Table,
                {
                  basic: "very",
                  className: "drayage-line-item-table content-static-card non-edit"
                },
                React__default.createElement(
                  Table.Header,
                  null,
                  React__default.createElement(
                    Table.Row,
                    null,
                    React__default.createElement(
                      Table.HeaderCell,
                      { className: "table-heading-cell" },
                      "Document"
                    ),
                    React__default.createElement(
                      Table.HeaderCell,
                      { className: "table-heading-cell text-align-center" },
                      "Uploaded"
                    )
                  )
                ),
                React__default.createElement(
                  Table.Body,
                  null,
                  React__default.createElement(
                    Form.Field,
                    null,
                    React__default.createElement("input", {
                      ref: this.fileRef,
                      style: { display: "none" },
                      onChange: function onChange(e) {
                        _this3.setNewFile(e);
                      },
                      type: "file",
                      label: "",
                      placeholder: ""
                    })
                  ),
                  Object.keys(get(this, "state.chargeFiles", {})).map(function (val, index) {
                    return React__default.createElement(
                      Table.Row,
                      {
                        key: index,
                        style: {
                          background: fileImageIndex === index ? "rgba(0, 139, 143, 0.2)" : "transparent"
                        }
                      },
                      React__default.createElement(
                        Table.Cell,
                        { className: "table-field-cell", width: "2" },
                        val
                      ),
                      React__default.createElement(
                        Table.Cell,
                        { className: "table-field-cell", width: "2" },
                        get(_this3, "state.chargeFiles[" + val + "]").map(function (mapValue) {
                          return React__default.createElement(
                            "div",
                            { style: { marginBottom: "25px" } },
                            React__default.createElement(
                              "div",
                              {
                                onClick: function onClick() {
                                  return _this3.setImageToShow(mapValue, index);
                                },
                                style: {
                                  display: "inline-block",
                                  cursor: "pointer"
                                }
                              },
                              get(mapValue, "displayName", "")
                            ),
                            !_this3.props.showOtherTab && React__default.createElement(
                              "div",
                              null,
                              React__default.createElement(Icon, {
                                className: "removeIcon",
                                color: "red",
                                name: "close",
                                onClick: function onClick() {
                                  return _this3.removeDoc(get(mapValue, "docId", ""), get(mapValue, "glCode", ""));
                                }
                              })
                            )
                          );
                        })
                      ),
                      React__default.createElement(
                        Table.Cell,
                        { className: "table-field-cell", width: "2" },
                        !_this3.props.showOtherTab && React__default.createElement(
                          "svg",
                          {
                            width: "45",
                            height: "38",
                            viewBox: "0 0 45 38",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            onClick: function onClick(e) {
                              _this3.handleDropDownSelect(e, {
                                value: {
                                  chargeName: get(_this3, "state.chargeFiles[" + val + "][0]", "").chargeName,
                                  glCode: get(_this3, "state.chargeFiles[" + val + "][0]", "").glCode
                                }
                              });
                              _this3.fileRef.current.click();
                            }
                          },
                          React__default.createElement("rect", {
                            x: "1",
                            y: "1",
                            width: "43",
                            height: "36",
                            rx: "2"
                          }),
                          React__default.createElement("path", {
                            d: "M28.0118 13.9492C27.2688 11.0418 24.6007 9.00174 21.539 9C18.4772 8.99826 15.8067 11.0353 15.0602 13.9418C11.5051 14.2684 8.83993 17.2723 9.00748 20.7637C9.17504 24.255 12.1162 27.0011 15.6869 27H18.1937C18.6552 27 19.0293 26.6338 19.0293 26.1821C19.0293 25.7303 18.6552 25.3641 18.1937 25.3641H15.6869C12.918 25.3721 10.6668 23.1813 10.6588 20.4709C10.6507 17.7605 12.8888 15.557 15.6577 15.549C16.1018 15.5818 16.4991 15.2799 16.5768 14.8505C16.9286 12.4359 19.041 10.6421 21.5327 10.6421C24.0244 10.6421 26.1368 12.4359 26.4886 14.8505C26.5787 15.2631 26.9542 15.5556 27.3851 15.549C30.154 15.549 32.3987 17.7462 32.3987 20.4566C32.3987 23.167 30.154 25.3641 27.3851 25.3641H24.8784C24.4169 25.3641 24.0428 25.7303 24.0428 26.1821C24.0428 26.6338 24.4169 27 24.8784 27H27.3851C30.9277 26.9637 33.8262 24.2283 33.9925 20.7642C34.1589 17.3001 31.5353 14.3106 28.0118 13.9492Z",
                            fill: "#008B8F"
                          }),
                          React__default.createElement("path", {
                            d: "M25.5848 21.5233C25.9125 21.8354 26.4333 21.8309 26.7554 21.5133C27.0775 21.1956 27.0821 20.682 26.7656 20.3588L22.5904 16.2411C22.2643 15.9196 21.7357 15.9196 21.4096 16.2411L17.2344 20.3588C16.9179 20.682 16.9225 21.1956 17.2446 21.5133C17.5667 21.8309 18.0875 21.8354 18.4152 21.5233L21.165 18.8114V29.1765C21.165 29.6313 21.5388 30 22 30C22.4612 30 22.835 29.6313 22.835 29.1765V18.8114L25.5848 21.5233Z",
                            fill: "#008B8F"
                          })
                        )
                      )
                    );
                  }),
                  addNewItem && remaningDocument.newOption && React__default.createElement(
                    Table.Row,
                    null,
                    React__default.createElement(
                      Table.Cell,
                      { className: "table-field-cell", width: "1" },
                      React__default.createElement(Dropdown, {
                        value: currentSelectedCharge,
                        multiple: true,
                        clearable: true,
                        options: remaningDocument.newOption,
                        selection: true,
                        onChange: this.handleDropDownSelect
                      })
                    ),
                    React__default.createElement(
                      Table.Cell,
                      { className: "table-field-cell", width: "1" },
                      !progressStatus && get(this.state, "currentSelectedCharge", []).length ? React__default.createElement(
                        "span",
                        {
                          onClick: function onClick(e, data) {
                            // setCurrentSelectedCharge();
                            _this3.fileRef.current.click();
                          }
                        },
                        "UPLOAD"
                      ) : "",
                      get(selectedFiles, "getelectedCharge.name", "") && !progressStatus && React__default.createElement(
                        "div",
                        {
                          style: {
                            display: "inline-block"
                          }
                        },
                        get(selectedFiles, "getelectedCharge.name", "")
                      ),
                      progressStatus && React__default.createElement(
                        React__default.Fragment,
                        null,
                        React__default.createElement(
                          "span",
                          { className: "upload-percentage" },
                          "Uploading (" + progressStatus + "%)"
                        ),
                        React__default.createElement(
                          "div",
                          { className: "progressBar" },
                          React__default.createElement(
                            "div",
                            { id: "myProgress" },
                            React__default.createElement(
                              "div",
                              {
                                id: "myBar",
                                style: { width: progressStatus * 1 + "%" }
                              },
                              " "
                            )
                          ),
                          React__default.createElement("i", {
                            "aria-hidden": "true",
                            className: "green close icon upload-modal-close"
                          })
                        )
                      )
                    )
                  )
                )
              ),
              !addNewItem && remaningDocument.newOption && !this.props.showOtherTab && React__default.createElement(
                "div",
                { className: "addiDocumButton", onClick: this.addTableRows },
                React__default.createElement("i", {
                  "aria-hidden": "true",
                  className: "plus icon add-document"
                }),
                "Add Additional Documents"
              )
            ),
            React__default.createElement(
              "div",
              { className: "showDocument" },
              imageShow && React__default.createElement(
                React__default.Fragment,
                null,
                fileExtension == "pptx" || fileExtension == "xls" || fileExtension == "xlsx" || fileExtension == "csv" ? React__default.createElement(
                  Image,
                  { size: "small" },
                  React__default.createElement(Label, {
                    content: "Extension not supported!",
                    icon: "warning",
                    style: {
                      width: "300px",
                      height: "100px",
                      paddingTop: "35px",
                      paddingLeft: "55px"
                    }
                  })
                ) : fileExtension == "pdf" ? React__default.createElement(PDFViewer, { url: imageShow }) : React__default.createElement(Image, {
                  size: "large",
                  style: {
                    width: "auto",
                    height: "auto"
                  },
                  src: imageShow,
                  alt: "Image not found",
                  wrapped: true
                }),
                React__default.createElement(
                  "div",
                  { style: { height: "20px" } },
                  React__default.createElement(
                    "a",
                    { onClick: function onClick(e) {
                        return _this3.openInNewTab(imageShow);
                      } },
                    React__default.createElement(Icon, { name: "download" })
                  )
                )
              )
            )
          )
        ),
        React__default.createElement(
          Modal.Actions,
          { className: "ModalActionButtons" },
          React__default.createElement(
            Button,
            {
              className: "upload-document-btn",
              onClick: function onClick() {
                _this3.getChargelistData();
                _this3.setState({ open: false });
              }
            },
            "DONE"
          )
        )
      ) : React__default.createElement("div", { style: { width: "63px" } });
    }
  }]);
  return UploadDocument;
}(Component);

function Date$1(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var ChargeListCardHeader = function (_Component) {
  inherits(ChargeListCardHeader, _Component);

  function ChargeListCardHeader(props) {
    classCallCheck(this, ChargeListCardHeader);

    var _this = possibleConstructorReturn(this, (ChargeListCardHeader.__proto__ || Object.getPrototypeOf(ChargeListCardHeader)).call(this, props));

    _this.getFormatedDate = function (date) {
      var dateVal = parseInt(date);
      if (isNaN() || !Number(dateVal) || !dateVal === "") {
        return "";
      }

      var someday = moment$1(dateVal);

      return someday.format("MMMM DD YYYY");
    };

    _this.handleChange = function (e, _ref2) {
      var value = _ref2.value;
      var selectedDropdownData = _this.props.selectedDropdownData;

      var data = _this.props.data.value.billingParties.billToList.filter(function (currentBill) {
        if (currentBill.customerName.toLowerCase() === value.toLowerCase()) {
          return currentBill;
        }
      });
      selectedDropdownData(data || {});
    };

    return _this;
  }

  createClass(ChargeListCardHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          option = _props.option,
          defaultOption = _props.defaultOption,
          cardIndex = _props.cardIndex,
          data = _props.data;

      var countryName = "";
      var countryImage = "";
      if (lodash_1(this.props, "data.value.countryCode", "") === "US") {
        countryName = "USA";
        countryImage = "/images/US.jpg";
      } else if (lodash_1(this.props, "data.value.countryCode", "") === "CANADA" || lodash_1(this.props, "data.value.countryCode", "") === "CA") {
        countryName = "CANADA";
        countryImage = "/images/Canda.jpg";
      } else if (lodash_1(this.props, "data.value.countryCode", "") === "UK") {
        countryName = "UK";
        countryImage = "/images/Uk.jpg";
      } else if (lodash_1(this.props, "data.value.countryCode", "") === "ES") {
        countryName = "SPAIN";
        countryImage = "/images/spain.jpg";
      } else if (lodash_1(this.props, "data.value.countryCode", "") === "NL") {
        countryName = "NL";
        countryImage = "/images/NL.jpg";
      }

      var countryForCurrencyCode = lodash_1(data, "value.chargeDesc[0].countryForCurrency", '');
      var isNonEditable = lodash_1(data, 'value.isNonEditable', false);
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          {
            size: "mini",
            className: "chargeList-table",
            style: { marginBottom: "5px" }
          },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "10px"
              }
            },
            cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
              disabled: isNonEditable,
              onClick: function onClick(e) {
                return _this2.props.expandCard(_this2.props.cardIndex);
              },
              name: "plus circle",
              className: "card-toggle-icon"
            }),
            cardIndex === this.props.activeCard && React__default.createElement(Icon, {
              onClick: function onClick(e) {
                return _this2.props.expandCard(_this2.props.cardIndex);
              },
              name: "minus circle",
              className: "card-toggle-icon"
            }),
            React__default.createElement(
              Statistic,
              { className: "statistic-country" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "COUNTRY"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                React__default.createElement("img", { src: countryImage, className: "countryIcon" }),
                countryName
              )
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "SHIPMENT ID#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this, "props.data.value.shipmentID", "")
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props.data, "value.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props.data, "value.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$1, { date: lodash_1(this.props.data, "value.addedDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props.data, "value.totalAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "10px"
              }
            },
            React__default.createElement(UploadDocument, {
              isNonEditable: isNonEditable,
              containerId: lodash_1(this.props.data, "value.containerId", ""),
              containerNumber: lodash_1(this.props.data, "value.containerNumber", ""),
              chargeDesc: lodash_1(this.props.data, "value.chargeDesc", ""),
              getChargelistData: this.props.getChargelistData,
              showOtherTab: this.props.chargeListType === "isReleased" ? true : false
            })
          )
        )
      );
    }
  }]);
  return ChargeListCardHeader;
}(Component);

var UOM = [{ text: "PER DAY", value: "PER DAY", key: "PER DAY" }, { text: "PER UNIT", value: "PER UNIT", key: "PER UNIT" }, { text: "PER HOUR", value: "PER HOUR", key: "PER HOUR" }, { text: "PER STATE", value: "PER STATE", key: "PER STATE" }, { text: "APMT", value: "APMT", key: "APMT" }];
// const CHARGETYPE = [
//   { text: "BASE", value: "BASE", key: "BASE" },
//   { text: "LANE", value: "LANE", key: "LANE" },
//   { text: "PORT", value: "PORT", key: "PORT" },
// ];


var ChargeListCardEdit = function (_Component) {
  inherits(ChargeListCardEdit, _Component);

  function ChargeListCardEdit(props) {
    classCallCheck(this, ChargeListCardEdit);

    var _this = possibleConstructorReturn(this, (ChargeListCardEdit.__proto__ || Object.getPrototypeOf(ChargeListCardEdit)).call(this, props));

    _this.state = {
      chargeDesc: [],
      saveBtnClicked: false
    };
    return _this;
  }

  createClass(ChargeListCardEdit, [{
    key: "deepEqual",
    value: function deepEqual(object1, object2) {
      var areObjects = this.isObject(object1) && this.isObject(object2);
      if (areObjects) {
        var keys1 = Object.keys(object1);
        var keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
          return false;
        }
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var val1 = object1[key];
            var val2 = object2[key];
            var _areObjects = this.isObject(val1) && this.isObject(val2);
            if (_areObjects && !this.deepEqual(val1, val2) || !_areObjects && val1 !== val2) {
              return false;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return true;
      }
      return false;
    }
  }, {
    key: "isObject",
    value: function isObject(object) {
      return object !== null && object !== undefined && (typeof object === "undefined" ? "undefined" : _typeof(object)) === "object";
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({ chargeDesc: lodash_1(this.props, "data.value.chargeDesc", []) });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.deepEqual(lodash_1(prevProps, "data.value.chargeDesc", [])) !== this.deepEqual(lodash_1(this.props, "data.value.chargeDesc", []))) {
        this.setState({
          chargeDesc: lodash_1(this.props, "data.value.chargeDesc", [])
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table edit-card-list non-edit"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "VENDOR INVOICE NO."
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "COMMENT"
                ),
                React__default.createElement(Table.HeaderCell, { className: "table-heading-cell" })
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.value.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(ChargeListRow, {
                  key: index,
                  index: _this2.props.index,
                  rowIndex: index,
                  chargesOptions: _this2.props.chargesOptions,
                  updateChargeListLineItem: _this2.props.updateChargeListLineItem,
                  deleteChargeLineItem: _this2.props.deleteChargeLineItem,
                  val: val,
                  getFormatedCurrency: _this2.props.getFormatedCurrency,
                  countryCode: _this2.props.data.value.countryCode,
                  addChargeToInvoice: _this2.props.addChargeToInvoice,
                  addAllChargeToInvoice: _this2.props.addAllChargeToInvoice,
                  nonEditableGlCodes: _this2.props.nonEditableGlCodes,
                  unitPriceValue: _this2.props.unitPriceValue,
                  selectedCharge: _this2.props.selectedCharge,
                  unitPriceVal: _this2.props.unitPriceVal,
                  uom: _this2.props.uom,
                  allCharges: lodash_1(_this2.props, "data.value.chargeDesc", []),
                  chassesdata: _this2.props.data
                });
              }),
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.Cell,
                  {
                    colSpan: "12",
                    className: "table-field-cell text-align-center"
                  },
                  React__default.createElement(
                    "div",
                    { className: "table-action-btns" },
                    React__default.createElement(
                      Button,
                      {
                        className: "add-line-item-btn",
                        onClick: function () {
                          var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
                            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    _this2.props.addNewCharge(_this2.props.index);

                                  case 1:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, _this2);
                          }));

                          return function (_x) {
                            return _ref2.apply(this, arguments);
                          };
                        }()
                      },
                      React__default.createElement("img", { src: "./images/ADD_LINE.svg", className: "ui image" }),
                      " ",
                      "ADD LINE ITEM"
                    ),
                    React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(
                        Button,
                        {
                          loading: this.state.saveBtnClicked,
                          className: "save-invoice-btn",
                          onClick: function onClick(e) {
                            if (_this2.state.saveBtnClicked === false) {
                              _this2.setState({ saveBtnClicked: true }, function () {
                                _this2.props.saveChargeListData(_this2.props.index).then(function () {
                                  _this2.setState({ saveBtnClicked: false });
                                });
                              });
                            }
                          }
                        },
                        "SAVE"
                      ),
                      React__default.createElement(
                        Button,
                        {
                          className: "create-invoice-btn",
                          onClick: function onClick(e) {
                            _this2.props.cancelChargeListEdit(_this2.props.index, _this2.state.chargeDesc);
                          }
                        },
                        "CANCEL"
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ChargeListCardEdit;
}(Component);

var ChargeListRow = function (_Component2) {
  inherits(ChargeListRow, _Component2);

  function ChargeListRow(props) {
    var _this4 = this;

    classCallCheck(this, ChargeListRow);

    var _this3 = possibleConstructorReturn(this, (ChargeListRow.__proto__ || Object.getPrototypeOf(ChargeListRow)).call(this, props));

    _this3.showConfirm = function () {
      _this3.setState({ showConfirm: true });
    };

    _this3.handleConfirm = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.props.deleteChargeLineItem(_this3.props.index, _this3.props.rowIndex);

            case 2:
              _this3.setState({ showConfirm: false });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }));

    _this3.handleCancel = function () {
      return _this3.setState({ showConfirm: false });
    };

    _this3.state = {
      quantity: "",
      unitPrice: "",
      showConfirm: false
    };
    return _this3;
  }

  createClass(ChargeListRow, [{
    key: "componentDidUpdate",
    value: function () {
      var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(prevProps) {
        var quantity, unitPrice, total, subtotal, subTotal;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(lodash_1(this.props.val, "quantity", "") !== lodash_1(prevProps.val, "quantity", "") || lodash_1(this.props.val, "unitPrice", "") !== lodash_1(prevProps.val, "unitPrice", ""))) {
                  _context4.next = 9;
                  break;
                }

                quantity = parseInt(lodash_1(this.props.val, "quantity", 0));
                unitPrice = parseFloat(lodash_1(this.props.val, "unitPrice", 0));

                quantity = isNaN(quantity) ? 0 : quantity;
                unitPrice = isNaN(unitPrice) ? 0 : unitPrice;
                total = parseFloat(quantity * unitPrice) * 100;

                total = isNaN(parseFloat(total)) ? 0.0 : total;

                _context4.next = 9;
                return this.props.updateChargeListLineItem(this.props.index, this.props.rowIndex, "subTotal", total);

              case 9:
                subtotal = parseFloat(lodash_1(this.props.val, "subTotal", 0));

                if (!isNaN(subtotal) && (lodash_1(this.props.val, "subTotal", "") !== lodash_1(prevProps.val, "subTotal", "") || lodash_1(this.props.val, "markUPAmount", "") !== lodash_1(prevProps.val, "markUPAmount", ""))) {
                  subTotal = parseFloat(lodash_1(this.props.val, "subTotal", 0));

                  subTotal = isNaN(subTotal) ? 0.0 : subTotal;

                  // let margin = parseFloat(get(this.props.val, "markUPAmount", 0));

                  // if (!isNaN(margin) && margin > 0) {
                  //   let unitPrice = parseFloat(get(this.props.val, "unitPrice", 0));
                  //   let calculatedMargin = parseFloat(1-(parseFloat(margin)/100))
                  //   let value = parseFloat((subTotal/100)/calculatedMargin)
                  //   await this.props.updateChargeListLineItem(
                  //     this.props.index,
                  //     this.props.rowIndex,
                  //     "totalRate",
                  //     value.toFixed(2)
                  //   );
                  // }
                }

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x2) {
        return _ref4.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          index = _props.index,
          rowIndex = _props.rowIndex,
          val = _props.val,
          chargesOptions = _props.chargesOptions,
          updateChargeListLineItem = _props.updateChargeListLineItem,
          deleteChargeLineItem = _props.deleteChargeLineItem,
          chassesdata = _props.chassesdata;


      var deleteMessage = "Are you sure you want to remove the line item?";
      deleteMessage = !lodash_2(lodash_1(val, "chargeName", "")) ? "Are you sure you want to remove the charge - " + lodash_1(val, "chargeName", "") + "?" : deleteMessage;
      return React__default.createElement(
        Table.Row,
        { key: "chargelist-" + rowIndex },
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          lodash_1(val, "new", false) === true && React__default.createElement(Form.Field, {
            disabled: lodash_1(val, "new", false) !== true,
            control: Select,
            label: "",
            value: lodash_1(val, "new", false) === true ? lodash_1(val, "glCode", "") : lodash_1(val, "chargeName", ""),
            options: this.props.chargesOptions.filter(function (filterVal) {
              var glCodes = _this5.props.allCharges.map(function (mapVal) {
                return parseInt(mapVal.glCode);
              });
              if (!glCodes.includes(parseInt(filterVal.value)) || parseInt(filterVal.value) === parseInt(lodash_1(val, "glCode", 0))) {
                return true;
              }
              return false;
            }),
            placeholder: "",
            className: "custom-field",
            icon: "chevron down",
            onChange: function () {
              var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(e, data) {
                var value, options, selectedValue, chassisUnitCount;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        value = data.value;
                        options = data.options;
                        selectedValue = options.find(function (val) {
                          return val.value === value;
                        });
                        chassisUnitCount = chassesdata["value"]["chassisUnitCount"] || '';

                        if (chassisUnitCount < 1) {
                          chassisUnitCount = 1;
                        }
                        _context5.next = 7;
                        return _this5.props.selectedCharge(selectedValue.unitPrice, selectedValue.uom);

                      case 7:
                        _context5.next = 9;
                        return _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "glCode", value);

                      case 9:
                        _context5.next = 11;
                        return _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "chargeName", selectedValue.text);

                      case 11:
                        _context5.next = 13;
                        return _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "unitOfMeasurement", selectedValue.uom);

                      case 13:
                        if (!(selectedValue.text === 'CHASSIS RENTAL')) {
                          _context5.next = 18;
                          break;
                        }

                        _context5.next = 16;
                        return _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "quantity", chassisUnitCount);

                      case 16:
                        _context5.next = 20;
                        break;

                      case 18:
                        _context5.next = 20;
                        return _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "quantity", 1);

                      case 20:
                        _context5.next = 22;
                        return _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "unitPrice", selectedValue.unitPrice);

                      case 22:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, _this5);
              }));

              return function (_x3, _x4) {
                return _ref5.apply(this, arguments);
              };
            }()
          }),
          lodash_1(val, "new", false) === false && React__default.createElement(Form.Field, {
            disabled: lodash_1(val, "new", false) !== true,
            control: Input$1,
            label: "",
            value: lodash_1(val, "chargeName", ""),
            placeholder: "",
            className: "custom-field"
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          React__default.createElement(Form.Input, {
            disabled: lodash_1(val, "isGenerated", false) === true || this.props.nonEditableGlCodes.includes(val.glCode) === true,
            readOnly: lodash_1(val, "isGenerated", false) === true || this.props.nonEditableGlCodes.includes(val.glCode) === true
            // readOnly={get(val, "isGenerated", false) === true}
            // value={get(val, "quantity", "") ? get(val, "quantity", "") : 1}
            , value: lodash_1(val, "quantity", ""),
            onChange: function onChange(e) {
              e.target.value = e.target.value.trim();
              if (!lodash_2(e.target.value.trim()) && !/^([0-9]*)$/.test(e.target.value)) {
                e.preventDefault();
                return;
              }
              if (!lodash_2(e.target.value.trim())) {
                e.target.value = parseInt(e.target.value);
              }
              if (parseInt(e.target.value) === 0) {
                e.target.value = 1;
              }

              _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "quantity", e.target.value);
            }
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          React__default.createElement(Form.Input, {
            disabled: lodash_1(val, "isGenerated", false) === true || this.props.nonEditableGlCodes.includes(val.glCode) === true,
            readOnly: lodash_1(val, "isGenerated", false) === true || this.props.nonEditableGlCodes.includes(val.glCode) === true
            // readOnly={get(val, "isGenerated", false) === true}
            , value: lodash_1(val, "unitPrice", "") ? lodash_1(val, "unitPrice", "") : this.props.unitPriceVal,
            onChange: function onChange(e) {
              e.target.value = e.target.value.trim();
              if (!lodash_2(e.target.value) && !/^[1-9]\d{0,8}(\.{0,1})(\d{1,4})?$/.test(e.target.value)) {
                e.preventDefault();
                return;
              }
              _this5.props.unitPriceValue();
              _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "unitPrice", e.target.value);
            },
            onBlur: function onBlur(e) {
              e.target.value = parseFloat(e.target.value);
              if (isNaN(e.target.value)) {
                e.target.value = 0.0;
              }

              _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "unitPrice", e.target.value);
            }
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          lodash_1(val, "new", false) === true && React__default.createElement(Form.Field, {
            disabled: true,
            control: Select,
            label: "",
            value: lodash_1(val, "unitOfMeasurement", ""),
            options: UOM,
            placeholder: "",
            icon: "chevron down",
            onChange: function () {
              var _ref6 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e, data) {
                var value;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        value = data.value;
                        _context6.next = 3;
                        return _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "unitOfMeasurement", value);

                      case 3:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6, _this5);
              }));

              return function (_x5, _x6) {
                return _ref6.apply(this, arguments);
              };
            }()
          }),
          lodash_1(val, "new", false) === false && React__default.createElement(Form.Field, {
            disabled: true,
            control: Input$1,
            label: "",
            value: lodash_1(val, "unitOfMeasurement", "")
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center total-value" },
          this.props.getFormatedCurrency(lodash_1(val, "subTotal", ""), lodash_1(val, "countryForCurrency", "")),
          React__default.createElement(Icon, { className: "green-tick", name: "check circle" })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center" },
          lodash_1(val, "status", "")
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center" },
          React__default.createElement(Form.Input, {
            readOnly: true,
            disabled: true,
            value: lodash_1(val, "drayageInvoiceNumber", "")
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center" },
          React__default.createElement(Popup, {
            trigger: React__default.createElement(Form.Input, {
              readOnly: lodash_1(val, "isGenerated", false) === true
              // ||
              // this.props.nonEditableGlCodes.includes(val.glCode) === true
              ,
              disabled: lodash_1(val, "isGenerated", false) === true
              // ||
              // this.props.nonEditableGlCodes.includes(val.glCode) === true
              ,
              value: lodash_1(val, "chargeComment", ""),
              onChange: function onChange(e) {
                e.target.value = e.target.value;
                _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "chargeComment", e.target.value);
              },
              onBlur: function onBlur(e) {
                e.target.value = e.target.value;
                _this5.props.updateChargeListLineItem(_this5.props.index, rowIndex, "comment", e.target.value);
              }
            }),
            header: "",
            content: lodash_1(val, "chargeComment", ""),
            position: "top center",
            style: { maxWidth: "150px" },
            on: "focus"
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-right" },
          lodash_1(val, "glCode", "") !== "60001" && lodash_1(val, "glCode", "") !== "60002" && lodash_1(val, "isGenerated", false) !== true && React__default.createElement(
            "span",
            {
              onClick: function onClick() {
                _this5.showConfirm();
              }
            },
            React__default.createElement(
              "svg",
              {
                width: "16",
                height: "17",
                viewBox: "0 0 16 17",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              },
              React__default.createElement("path", {
                d: "M4.7339 5.45847L6.07543 5.4079L6.36627 13.5713L5.02475 13.6217L4.7339 5.45847Z",
                fill: "#286084"
              }),
              React__default.createElement("rect", {
                width: "1.34239",
                height: "8.16348",
                transform: "matrix(-1 0 0 1 8.6712 5.43317)",
                fill: "#286084"
              }),
              React__default.createElement("path", {
                d: "M9.63393 13.5711L9.92477 5.40765L11.2663 5.45826L10.9754 13.6217L9.63393 13.5711Z",
                fill: "#286084"
              }),
              React__default.createElement("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.9873 3.40954V2.02982H0.0126772V3.40954H1.43407L2.54379 16.3704C2.57398 16.7266 2.86439 17 3.21231 17H12.8103C13.1582 17 13.4484 16.7268 13.4788 16.3706L14.5885 3.40954H15.9873ZM12.1957 15.6203H3.8271L2.78158 3.40954H13.241L12.1957 15.6203Z",
                fill: "#286084"
              }),
              React__default.createElement("path", {
                d: "M6.18242 0H10.8176C11.4696 0 12 0.464058 12 1.03447V3H10.5811V1.24137H6.41891V3H5V1.03447C5 0.464058 5.53043 0 6.18242 0Z",
                fill: "#286084"
              })
            )
          ),
          React__default.createElement(Confirm, {
            className: "delete-charge-confirm",
            header: "Delete Charge",
            content: deleteMessage,
            open: this.state.showConfirm,
            onCancel: this.handleCancel,
            onConfirm: this.handleConfirm,
            size: "large",
            confirmButton: "Delete Charge"
          })
        )
      );
    }
  }]);
  return ChargeListRow;
}(Component);

var PreviewDocument = function (_Component) {
  inherits(PreviewDocument, _Component);

  function PreviewDocument(props) {
    classCallCheck(this, PreviewDocument);

    var _this = possibleConstructorReturn(this, (PreviewDocument.__proto__ || Object.getPrototypeOf(PreviewDocument)).call(this, props));

    _this.get_url_extension = function (url) {
      var ext = url.split(/[#?]/)[0].split(".").pop().trim();
      return ext;
    };

    _this.openInNewTab = function (url) {
      var newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    };

    _this.state = { options: [] };
    return _this;
  }

  createClass(PreviewDocument, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      console.log("TESTING", this.props.documentName);
      if (this.props.documentName != prevProps.documentName && this.props.documentName) {
        this.setState({
          options: Array.isArray(lodash_1(this, "props.documentName", [])) ? lodash_1(this, "props.documentName", []).map(function (val) {
            return { value: val, key: val, text: val };
          }) : []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Open = _props.Open,
          Close = _props.Close,
          docUrl = _props.docUrl;

      var extenison = this.get_url_extension(docUrl);
      return React__default.createElement(
        Modal,
        {
          closeIcon: true,
          open: Open,
          onClose: Close,
          onOpen: Open,
          size: "small",
          className: "preDocument"
        },
        React__default.createElement(Header, { content: "Preview Document" }),
        React__default.createElement(
          Modal.Content,
          null,
          Array.isArray(lodash_1(this, "props.documentName", [])) && lodash_1(this, "props.documentName", []).map(function (val) {
            return React__default.createElement(
              "div",
              {
                onClick: function onClick() {
                  return _this2.props.handleModal(val);
                },
                className: "preview-file-links"
              },
              val
            );
          }),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "a",
              { onClick: function onClick(e) {
                  return _this2.openInNewTab(docUrl);
                } },
              React__default.createElement(Icon, { name: "download" })
            )
          ),
          extenison == "pdf" ? React__default.createElement(PDFViewer, { url: docUrl }) : extenison == "pptx" || extenison == "xls" || extenison == "xlsx" || extenison == "csv" ? React__default.createElement(
            Image,
            { size: "small" },
            React__default.createElement(Label, {
              content: "Extension not supported!",
              icon: "warning",
              style: {
                width: "300px",
                height: "100px",
                paddingTop: "35px",
                paddingLeft: "55px"
              }
            })
          ) : React__default.createElement(Image, { size: "large", src: docUrl, alt: "Image not found", wrapped: true })
        ),
        React__default.createElement(Modal.Actions, null)
      );
    }
  }]);
  return PreviewDocument;
}(Component);

var ChargeListCardContentStatic = function (_Component) {
  inherits(ChargeListCardContentStatic, _Component);

  function ChargeListCardContentStatic(props) {
    var _this2 = this;

    classCallCheck(this, ChargeListCardContentStatic);

    var _this = possibleConstructorReturn(this, (ChargeListCardContentStatic.__proto__ || Object.getPrototypeOf(ChargeListCardContentStatic)).call(this, props));

    _this.handleModal = function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(docName) {
        var bucketName, data, url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                bucketName = window._env_.DRAYAGE_BILL_BUCKET;
                _context.next = 3;
                return getDrayageImageURL(
                // `${bucketName}:1658330865595_ScreenShot2022-07-12at8.28.49AM.png`
                bucketName + ":" + docName);

              case 3:
                data = _context.sent;
                url = lodash_1(data, "data.eventMessage.urls[0]", "");

                _this.setState({ modalOpen: true, docUrl: url });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleClose = function () {
      _this.setState({ modalOpen: false });
    };

    _this.handleCloseRefrence = function () {
      _this.setState({ createCall: false, accountRefNumber: "", isOpen: false });
      // if (this.state.createCall === true) return;
      // let refNumber = "";
      // this.setState({ createCall: true, isOpen: false }, async () => {
      //   const res = await this.props.createInvoice(this.props.index, refNumber);

      //   this.setState({ createCall: false, accountRefNumber: "" });
      // });
    };

    _this.refrenceModel = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({ isOpen: true });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.handleChange = function (event) {
      var accountRefNumber = event.target.value;
      var accRefNo = accountRefNumber.trim();
      _this.setState({ accountRefNumber: accRefNo });
    };

    _this.createInvoice = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(_this.state.createCall === true)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              _this.setState({ createCall: true, isOpen: false }, asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var res;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this.props.createInvoice(_this.props.index, _this.state.accountRefNumber);

                      case 2:
                        res = _context3.sent;


                        _this.setState({ createCall: false, accountRefNumber: "" });

                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this2);
              })));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    _this.handleAllChecked = function (event) {
      // let fruites = this.props.data.value.chargeDesc;
      // fruites.forEach(fruite => (fruite.isChecked = event.target.checked));
      // console.log("fruites",fruites)
    };

    _this.openInNewTab = function () {
      var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(docName) {
        var bucketName, data, url, newWindow;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                bucketName = window._env_.DRAYAGE_BILL_BUCKET;
                _context5.next = 3;
                return getDrayageImageURL(
                // `${bucketName}:1658330865595_ScreenShot2022-07-12at8.28.49AM.png`
                bucketName + ":" + docName);

              case 3:
                data = _context5.sent;
                url = lodash_1(data, "data.eventMessage.urls[0]", "");
                newWindow = window.open(url, "_blank", "noopener,noreferrer");

                if (newWindow) newWindow.opener = null;

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this2);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.state = {
      createCall: false,
      modalOpen: false,
      docUrl: "",
      isOpen: false,
      accountRefNumber: "",
      documents: []
    };
    return _this;
  }

  createClass(ChargeListCardContentStatic, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          modalOpen = _state.modalOpen,
          docUrl = _state.docUrl,
          isOpen = _state.isOpen;
      var selectAllInvoice = this.props.selectAllInvoice;


      var addedInvoiceCount = lodash_1(this.props, "data.value.chargeDesc", []).filter(function (value) {
        return lodash_1(value, "includeInInvoice", false) === true;
      }).length;
      var isGeneratedCount = lodash_1(this.props, "data.value.chargeDesc", []).filter(function (value) {
        return lodash_1(value, "isGenerated", false) === true;
      }).length;
      var allChargesCount = lodash_1(this.props, "data.value.chargeDesc", []).length;
      var showCreateInvoiceBtn = addedInvoiceCount > 0 ? true : false;
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table content-static-card non-edit"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  React__default.createElement(
                    "div",
                    {
                      style: {
                        marginLeft: "1rem",
                        display: "flex"
                      }
                    },
                    React__default.createElement(Checkbox, {
                      disabled: isGeneratedCount === allChargesCount,
                      checked: showCreateInvoiceBtn,
                      label: "",
                      className: "charge-list-check all-iii checkbox",
                      name: "status",
                      onClick: function onClick() {
                        _this3.props.addAllChargeToInvoice(_this3.props.index);
                      }
                    })
                  )
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "VENDOR INVOICE NO."
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "COMMENT"
                ),
                React__default.createElement(Table.HeaderCell, { className: "table-heading-cell" })
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.value.chargeDesc", []).map(function (val, index) {
                var documentName = lodash_1(val, "documentName", []);
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    React__default.createElement(
                      "div",
                      {
                        style: {
                          marginLeft: "1rem",
                          display: "flex",
                          gap: "10px"
                        }
                      },
                      documentName.length ? React__default.createElement(
                        "div",
                        {
                          className: "preview",
                          style: {
                            border: "2px solid #08adb6",
                            width: "30px",
                            borderRadius: "5px"
                          }
                        },
                        React__default.createElement(Icon, {
                          style: {
                            fontSize: "15px",
                            color: "#08adb6",
                            paddingTop: "4px",
                            paddingLeft: "5px"
                          },
                          className: "eye icon"
                          // onClick={() => {this.openInNewTab(documentName)}}
                          , onClick: function onClick() {
                            _this3.setState({ documents: documentName });
                            _this3.handleModal(documentName[0]);
                          }
                        })
                      ) : ""
                    )
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    {
                      className: "table-field-cell text-align-center",
                      width: "1"
                    },
                    _this3.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center total-value" },
                    _this3.props.getFormatedCurrency(lodash_1(val, "subTotal", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center" },
                    React__default.createElement(Form.Input, {
                      readOnly: true,
                      disabled: true,
                      value: lodash_1(val, "drayageInvoiceNumber", "")
                    })
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        disabled: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  ),
                  React__default.createElement(Table.Cell, { className: "table-field-cell text-align-right" })
                );
              }),
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.Cell,
                  {
                    colSpan: "12",
                    className: "table-field-cell text-align-center"
                  },
                  this.props.chargeListType === "isOpen" && React__default.createElement(
                    "div",
                    { className: "table-action-btns" },
                    React__default.createElement(
                      "div",
                      { style: { "margin-left": "auto" } },
                      React__default.createElement(
                        Button,
                        {
                          className: "save-invoice-btn",
                          onClick: function onClick(e) {
                            _this3.props.editChargeListCharge(_this3.props.index);
                          }
                        },
                        "EDIT"
                      ),
                      React__default.createElement(
                        Button,
                        {
                          disabled: !showCreateInvoiceBtn,
                          loading: this.state.createCall,
                          className: "create-invoice-btn",
                          onClick: function onClick(e) {
                            _this3.refrenceModel(); //this.createInvoice();
                          }
                        },
                        "CREATE INVOICE"
                      )
                    )
                  )
                )
              )
            )
          ),
          this.props.chargeListType === "isOpen" && React__default.createElement(
            Label,
            { className: "dray-partner-create-invoice-msg" },
            "* Once you click on create invoice,no other charges can be added."
          ),
          isOpen && React__default.createElement(Modal, {
            open: isOpen,
            onClose: function onClose(e) {
              return _this3.handleCloseRefrence(e);
            },
            header: "PLEASE ENTER ACCOUNTING REFERENCE NUMBER",
            className: "chargeList-mdl drayage-accounting-mdl",
            closeOnDimmerClick: false,
            content: React__default.createElement(
              "div",
              { className: "payload_content drayage-accounting-modal" },
              React__default.createElement(
                "label",
                { className: "account-ref-no" },
                React__default.createElement(
                  "p",
                  null,
                  "ACCOUNTING REFERENCE NUMBER:"
                )
              ),
              React__default.createElement(Input$1, {
                type: "text",
                placeholder: "FOR YOUR OWN ACCOUNTING PURPOSE",
                name: "drayageReferenceNumber",
                value: this.state.accountRefNumber,
                onChange: function onChange(e) {
                  return _this3.handleChange(e);
                },
                pattern: "/^\\S*$/"
              }),
              React__default.createElement(
                "div",
                { className: "table-action-btns" },
                React__default.createElement(
                  "button",
                  {
                    className: "ui button save-invoice-btn",
                    disabled: !this.state.accountRefNumber,
                    style: {
                      background: "#1565AE",
                      color: "#fff",
                      fontSize: "14px !important"
                    },
                    onClick: function onClick(e) {
                      _this3.createInvoice();
                    }
                  },
                  "SAVE"
                ),
                React__default.createElement(
                  "button",
                  {
                    negative: true,
                    className: "ui red button create-invoice-btn",
                    style: { fontSize: "14px !important" },
                    onClick: function onClick(e) {
                      return _this3.handleCloseRefrence(e);
                    }
                  },
                  "CLOSE"
                )
              )
            )
          })
        ),
        React__default.createElement(PreviewDocument, {
          Open: this.state.modalOpen,
          Close: this.handleClose,
          docUrl: this.state.docUrl,
          documentName: this.state.documents,
          handleModal: this.handleModal
        })
      );
    }
  }]);
  return ChargeListCardContentStatic;
}(Component);

var Pagination = function (_Component) {
  inherits(Pagination, _Component);

  function Pagination(props) {
    classCallCheck(this, Pagination);
    return possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
  }

  createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        "div",
        {
          className: "pagination drayage-sales-invoices"

        },
        React__default.createElement(
          "button",
          { onClick: function onClick() {
              return _this2.props.prevPage();
            } },
          "Prev"
        ),
        this.props.page + " / " + Math.ceil(this.props.totalCount / 25),
        React__default.createElement(
          "button",
          { onClick: function onClick() {
              return _this2.props.nextPage();
            } },
          "Next"
        )
      );
    }
  }]);
  return Pagination;
}(Component);

var ChargeList = function (_Component) {
  inherits(ChargeList, _Component);

  function ChargeList(props) {
    var _this2 = this;

    classCallCheck(this, ChargeList);

    var _this = possibleConstructorReturn(this, (ChargeList.__proto__ || Object.getPrototypeOf(ChargeList)).call(this, props));

    _this.getDefaultOption = function () {
      var billList = _this.state.billList;

      var dataa = billList;

      var defaultIndex = dataa.findIndex(function (item) {
        return item.isDefault;
      });
      _this.setState({ defaultOption: defaultIndex !== -1 ? defaultIndex : "" });
    };

    _this.getCustomerNameList = function () {
      var billList = _this.state.billList;

      if (billList && billList.length > 0) {
        return billList.map(function (item, index) {
          return {
            text: item.customerName,
            value: item.customerName,
            key: item.customerName
          };
        });
      }
    };

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.0;
      }
      return value;
    };

    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context.next = 6;
              return _this.props.getChargelistData(currPage);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getChargelistData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.state = {
      errorMsg: "",
      successMsg: "",
      options: [],
      defaultOption: "",
      billList: [],
      page: 1
    };
    return _this;
  }

  createClass(ChargeList, [{
    key: "componentDidMount",
    value: function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var chargeList, key, value, getBillingOption, option;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.getChargelistData();

              case 2:
                chargeList = this.props.chargeList;
                key = "";
                value = "";
                getBillingOption = [];

                chargeList.map(function (val) {
                  key = lodash_1(val, "key", "");
                  value = lodash_1(val, "value", "");
                  getBillingOption = lodash_1(value, "billingParties.billToList", []);
                });

                this.setState({ billList: getBillingOption });

                if (getBillingOption && getBillingOption.length > 0) {
                  option = this.getCustomerNameList();

                  this.setState({ options: option });
                  this.getDefaultOption();
                }

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _ref3.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          options = _state.options,
          defaultOption = _state.defaultOption;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("div", { style: { display: "flow-root" } }),
        this.props.successMsg && React__default.createElement(
          Message,
          { positive: true, size: "tiny", className: "info-message" },
          React__default.createElement(
            Message.Header,
            null,
            this.props.successMsg
          )
        ),
        this.props.errorMsg && React__default.createElement(
          Message,
          { negative: true, size: "tiny", className: "info-message" },
          React__default.createElement(
            Message.Header,
            null,
            this.props.errorMsg
          )
        ),
        React__default.createElement(
          "div",
          { className: "dray-partner-charge-list-open-released-btn" },
          React__default.createElement(
            Button.Group,
            null,
            React__default.createElement(
              Button,
              {
                onClick: asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return _this3.props.updateState({ chargeListType: "isOpen" });

                        case 2:
                          _context4.next = 4;
                          return _this3.props.getChargelistData();

                        case 4:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this3);
                })),
                positive: this.props.chargeListType === "isOpen"
              },
              "OPEN"
            ),
            React__default.createElement(Button.Or, { text: "" }),
            React__default.createElement(
              Button,
              {
                onClick: asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return _this3.props.updateState({ chargeListType: "isReleased" });

                        case 2:
                          _context5.next = 4;
                          return _this3.props.getChargelistData();

                        case 4:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this3);
                })),
                positive: this.props.chargeListType === "isReleased"
              },
              "GENERATED"
            )
          )
        ),
        React__default.createElement(CustomLoader, { showImage: true, loading: this.props.fetchChargeList }),
        !this.props.fetchChargeList && this.props.chargeList.map(function (val, index) {
          if (!lodash_1(val, "edit", false)) {
            var isNonEditable = lodash_1(val, "value.isNonEditable", false);
            var ChargeListCardHeaderVar = function ChargeListCardHeaderVar() {
              return React__default.createElement(ChargeListCardHeader, {
                data: val,
                activeCard: _this3.props.activeCard,
                cardIndex: index,
                expandCard: _this3.props.expandChargeListCard,
                getFormatedDate: _this3.getFormatedDate,
                selectedBillToParties: _this3.props.selectedBillToParties,
                option: options,
                defaultOption: defaultOption,
                selectedDropdownData: _this3.props.selectedDropdownData,
                getFormatedCurrency: _this3.props.getFormatedCurrency,
                getChargelistData: _this3.props.getChargelistData,
                chargeListType: _this3.props.chargeListType
              });
            };
            return React__default.createElement(
              Accordion,
              { fluid: true, key: index },
              React__default.createElement(
                "div",
                { style: { marginBottom: "15px", background: "white" } },
                React__default.createElement(
                  Accordion.Title,
                  {
                    style: { marginTop: "15px", padding: "1px 15px" },
                    active: _this3.props.activeCard === index,
                    index: 0,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  isNonEditable ? React__default.createElement(Popup, {
                    trigger: React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(ChargeListCardHeaderVar, null)
                    ),
                    content: "This container is already included with other shipment.",
                    basic: true
                  }) : React__default.createElement(ChargeListCardHeaderVar, null)
                ),
                React__default.createElement(
                  Accordion.Content,
                  {
                    active: _this3.props.activeCard === index,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  React__default.createElement(ChargeListCardContentStatic, {
                    data: val,
                    index: index,
                    editChargeListCharge: _this3.props.editChargeListCharge,
                    formatAmount: _this3.formatAmount,
                    successMsg: _this3.props.successMsg,
                    errorMsg: _this3.props.errorMsg,
                    getFormatedCurrency: _this3.props.getFormatedCurrency,
                    createInvoice: _this3.props.createInvoice,
                    addChargeToInvoice: _this3.props.addChargeToInvoice,
                    addAllChargeToInvoice: _this3.props.addAllChargeToInvoice,
                    nonEditableGlCodes: _this3.props.nonEditableGlCodes,
                    chargeListType: _this3.props.chargeListType
                  })
                )
              )
            );
          } else {
            return React__default.createElement(
              Accordion,
              { fluid: true, key: index },
              React__default.createElement(
                "div",
                { style: { marginBottom: "15px", background: "white" } },
                React__default.createElement(
                  Accordion.Title,
                  {
                    style: { marginTop: "15px", padding: "1px 15px" },
                    active: _this3.props.activeCard === index,
                    index: index,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  "\xA0",
                  React__default.createElement(ChargeListCardHeader, {
                    data: val,
                    activeCard: _this3.props.activeCard,
                    cardIndex: index,
                    expandCard: _this3.props.expandChargeListCard,
                    getFormatedDate: _this3.getFormatedDate,
                    selectedBillToParties: _this3.props.selectedBillToParties,
                    option: options,
                    defaultOption: defaultOption,
                    selectedDropdownData: _this3.props.selectedDropdownData,
                    getFormatedCurrency: _this3.props.getFormatedCurrency
                  })
                ),
                React__default.createElement(
                  Accordion.Content,
                  {
                    active: _this3.props.activeCard === index,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  React__default.createElement(ChargeListCardEdit, {
                    data: val,
                    index: index,
                    updateChargeListLineItem: _this3.props.updateChargeListLineItem,
                    addNewCharge: _this3.props.addNewCharge,
                    deleteChargeLineItem: _this3.props.deleteChargeLineItem,
                    cancelChargeListEdit: _this3.props.cancelChargeListEdit,
                    saveChargeListData: _this3.props.saveChargeListData,
                    chargesOptions: _this3.props.chargesOptions,
                    successMsg: _this3.props.successMsg,
                    errorMsg: _this3.props.errorMsg,
                    getFormatedCurrency: _this3.props.getFormatedCurrency,
                    nonEditableGlCodes: _this3.props.nonEditableGlCodes,
                    unitPriceValue: _this3.props.unitPriceValue,
                    selectedCharge: _this3.props.selectedCharge,
                    unitPriceVal: _this3.props.unitPriceVal,
                    uom: _this3.props.uom
                  })
                )
              )
            );
          }
        }),
        lodash_1(this.props, "chargeList", []).length > 0 && React__default.createElement(Pagination, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return ChargeList;
}(Component);

var DrayageInvoiceChangeLog = function (_React$Component) {
  inherits(DrayageInvoiceChangeLog, _React$Component);

  function DrayageInvoiceChangeLog(props) {
    classCallCheck(this, DrayageInvoiceChangeLog);

    var _this = possibleConstructorReturn(this, (DrayageInvoiceChangeLog.__proto__ || Object.getPrototypeOf(DrayageInvoiceChangeLog)).call(this, props));

    _this.state = {
      containerId: null,
      logData: [],
      loading: false
    };
    return _this;
  }

  createClass(DrayageInvoiceChangeLog, [{
    key: "componentDidMount",
    value: function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var containerId, changeLogData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                containerId = get(this, "props.data.containerId", "");

                this.setState({ containerId: containerId, loading: true });

                if (!containerId) {
                  _context.next = 14;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return getDrayageChangeLog({ containerId: containerId });

              case 6:
                changeLogData = _context.sent;


                changeLogData = get(changeLogData, "data.eventMessage.changeLog", []);
                this.setState({ logData: [].concat(toConsumableArray(changeLogData)), loading: false });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);

                this.setState({ logData: [], loading: false });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 11]]);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(prevProps, prevState) {
        var containerId, prevgContainerId, changeLogData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                containerId = get(prevProps, "data.containerId", "");
                prevgContainerId = get(this, "props.data.containerId", "");

                if (!(containerId !== prevgContainerId)) {
                  _context2.next = 15;
                  break;
                }

                this.setState({ containerId: containerId, loading: false });

                _context2.prev = 4;
                _context2.next = 7;
                return getDrayageChangeLog({ containerId: containerId });

              case 7:
                changeLogData = _context2.sent;


                changeLogData = get(changeLogData, "data.eventMessage.changeLog", []);
                this.setState({ logData: [].concat(toConsumableArray(changeLogData)), loading: false });
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](4);

                this.setState({ logData: [], loading: false });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 12]]);
      }));

      function componentDidUpdate(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement(
        Table,
        { size: "large", color: "teal" },
        React__default.createElement(
          Table.Header,
          null,
          React__default.createElement(
            Table.Row,
            null,
            React__default.createElement(
              Table.HeaderCell,
              null,
              "Action"
            ),
            React__default.createElement(
              Table.HeaderCell,
              null,
              "Comment"
            ),
            React__default.createElement(
              Table.HeaderCell,
              null,
              "Commented By"
            ),
            React__default.createElement(
              Table.HeaderCell,
              null,
              "Date (MMM DD, YYYY)"
            )
          )
        ),
        React__default.createElement(
          Table.Body,
          null,
          this.state.loading && React__default.createElement(
            Table.Row,
            null,
            React__default.createElement(
              Table.Cell,
              { colSpan: "5" },
              React__default.createElement(
                Segment,
                { style: { marginTop: "50px", marginBottom: "50px" } },
                React__default.createElement(
                  Dimmer,
                  { active: true, inverted: true },
                  React__default.createElement(
                    Loader,
                    { size: "large" },
                    "Loading"
                  )
                )
              )
            )
          ),
          get(this.state, "logData", []).map(function (val) {
            var date = !isEmpty(get(val, "createdDate", "").toString().trim()) ? get(val, "createdDate", 0) : 0;
            return React__default.createElement(
              Table.Row,
              null,
              React__default.createElement(
                Table.Cell,
                null,
                get(val, "action", "").split("_").map(function (val) {
                  return upperFirst(lowerCase(val));
                }).join(" ")
              ),
              React__default.createElement(
                Table.Cell,
                null,
                get(val, "comment", "")
              ),
              React__default.createElement(
                Table.Cell,
                null,
                get(val, "commentedBy", "")
              ),
              React__default.createElement(
                Table.Cell,
                null,
                parseInt(date) > 0 ? moment$1(parseInt(date)).format("MMM DD, YYYY").toUpperCase() : "-"
              )
            );
          })
        )
      );
    }
  }]);
  return DrayageInvoiceChangeLog;
}(React__default.Component);

var ModelContext = createContext();
var CustomModal = function (_React$Component) {
  inherits(CustomModal, _React$Component);

  function CustomModal(props) {
    classCallCheck(this, CustomModal);

    var _this = possibleConstructorReturn(this, (CustomModal.__proto__ || Object.getPrototypeOf(CustomModal)).call(this, props));

    _this.resetModal = function () {
      _this.context.setModalHeaderText("");
      _this.context.setDescriptionText("");
      _this.context.setDescriptionHeaderText("");
      _this.context.setCloseButtonText("");
      _this.context.setActionButtonText("");
      _this.context.setCloseButtonCallBack(function () {
        return function () {};
      });
      _this.context.setActionButtonCallBack(function () {
        return function () {};
      });
      _this.context.setModalSize("small");
      _this.context.setScrolling(false);
      _this.context.setCssClass("");
    };

    _this.state = {
      showModal: false
    };
    return _this;
  }

  createClass(CustomModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this.resetModal();
      // this.setState({ showModal: this.context.showModal });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // console.log("PROPSPROPS", prevProps);
      // if (this.context.showModal === false) {
      //     this.resetModal();
      // }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        "div",
        null,
        React__default.createElement(
          "style",
          null,
          "\n          .common-modal.ui.fullscreen.modal{\n            left: unset !important;\n          }\n          .common-modal  .close.icon{\n                    top: auto !important;\n                    position: relative !important;\n                    float: right !important;\n                    right: auto !important;\n                    color: #0A8B8F !important;\n                 }",
          " .ui.dimmer .common-modal .content {\n                width:100% !important;\n           }"
        ),
        React__default.createElement(
          Modal,
          {
            closeIcon: true,
            size: this.context.modalSize,
            onClose: function onClose() {
              return _this2.context.setShowModal(false);
            },
            onOpen: function onOpen() {
              return _this2.context.setShowModal(true);
            },
            open: this.context.showModal,
            className: "common-modal " + this.context.cssClass
          },
          React__default.createElement(
            Modal.Header,
            null,
            this.context.modalHeaderText
          ),
          React__default.createElement(
            Modal.Content,
            { scrolling: this.context.scrolling },
            React__default.createElement(
              Modal.Description,
              null,
              React__default.createElement(
                Header,
                null,
                this.context.descriptionHeaderText
              ),
              this.context.descriptionText
            )
          ),
          React__default.createElement(
            Modal.Actions,
            null,
            !isEmpty(this.context.closeButtonText) && React__default.createElement(
              Button,
              {
                onClick: function onClick() {
                  _this2.context.closeButtonCallBack();
                  _this2.context.setShowModal(false);
                }
              },
              this.context.closeButtonText
            ),
            !isEmpty(this.context.actionButtonText) && React__default.createElement(Button, {
              className: "primary",
              content: this.context.actionButtonText,
              onClick: function onClick() {
                _this2.context.actionButtonCallBack();
                _this2.context.setShowModal(false);
              },
              positive: true
            })
          )
        )
      );
    }
  }]);
  return CustomModal;
}(React__default.Component);

CustomModal.contextType = ModelContext;
var ModalProvider = function (_React$Component2) {
  inherits(ModalProvider, _React$Component2);

  function ModalProvider(props) {
    classCallCheck(this, ModalProvider);

    var _this3 = possibleConstructorReturn(this, (ModalProvider.__proto__ || Object.getPrototypeOf(ModalProvider)).call(this, props));

    _this3.setShowModal = function (value) {
      _this3.setState({ showModal: value });
    };

    _this3.setModalHeaderText = function (value) {
      _this3.setState({ modalHeaderText: value });
    };

    _this3.setDescriptionText = function (value) {
      _this3.setState({ descriptionText: value });
    };

    _this3.setDescriptionHeaderText = function (value) {
      _this3.setState({ descriptionHeaderText: value });
    };

    _this3.setCloseButtonText = function (value) {
      _this3.setState({ closeButtonText: value });
    };

    _this3.setActionButtonText = function (value) {
      _this3.setState({ actionButtonText: value });
    };

    _this3.setCloseButtonCallBack = function (value) {
      _this3.setState({ closeButtonCallBack: value });
    };

    _this3.setActionButtonCallBack = function (value) {
      _this3.setState({ actionButtonCallBack: value });
    };

    _this3.setModalSize = function (value) {
      _this3.setState({ modalSize: value });
    };

    _this3.setScrolling = function (value) {
      _this3.setState({ scrolling: value });
    };

    _this3.setCssClass = function (value) {
      _this3.setState({ cssClass: value });
    };

    _this3.state = {
      showModal: false,
      modalHeaderText: "",
      descriptionHeaderText: "",
      descriptionText: "",
      closeButtonText: "",
      actionButtonText: "",
      modalSize: "small",
      scrolling: false,
      cssClass: "",
      closeButtonCallBack: function closeButtonCallBack() {},
      actionButtonCallBack: function actionButtonCallBack() {}
    };
    return _this3;
  }

  createClass(ModalProvider, [{
    key: "render",
    value: function render() {
      return React__default.createElement(
        ModelContext.Provider,
        {
          value: {
            cssClass: this.state.cssClass,
            scrolling: this.state.scrolling,
            modalSize: this.state.modalSize,
            showModal: this.state.showModal,
            modalHeaderText: this.state.modalHeaderText,
            descriptionText: this.state.descriptionText,
            descriptionHeaderText: this.state.descriptionHeaderText,
            closeButtonText: this.state.closeButtonText,
            actionButtonText: this.state.actionButtonText,
            actionButtonCallBack: this.state.actionButtonCallBack,
            closeButtonCallBack: this.state.closeButtonCallBack,
            setShowModal: this.setShowModal,
            setModalHeaderText: this.setModalHeaderText,
            setDescriptionText: this.setDescriptionText,
            setDescriptionHeaderText: this.setDescriptionHeaderText,
            setCloseButtonText: this.setCloseButtonText,
            setActionButtonText: this.setActionButtonText,
            setCloseButtonCallBack: this.setCloseButtonCallBack,
            setActionButtonCallBack: this.setActionButtonCallBack,
            setModalSize: this.setModalSize,
            setScrolling: this.setScrolling,
            setCssClass: this.setCssClass
          }
        },
        this.props.children
      );
    }
  }]);
  return ModalProvider;
}(React__default.Component);

function Date$2(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var PendingListCardHeader = function (_Component) {
  inherits(PendingListCardHeader, _Component);

  function PendingListCardHeader(props) {
    var _this2 = this;

    classCallCheck(this, PendingListCardHeader);

    var _this = possibleConstructorReturn(this, (PendingListCardHeader.__proto__ || Object.getPrototypeOf(PendingListCardHeader)).call(this, props));

    _this.handlePaidEvent = function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, invo) {
        var setSelectedInvoice;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setSelectedInvoice = _this.props.setSelectedInvoice;

                if (!data.checked) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return setSelectedInvoice(invo, "checked");

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return setSelectedInvoice(invo, "unChecked");

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.state = {
      activeIndex: 1,
      showOtherTab: true
    };
    return _this;
  }

  createClass(PendingListCardHeader, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, "val.countryCode", ""));
      var countryCode = lodash_1(this.props, "val.countryCode", "");
      var invoiceUrl = lodash_1(this.props, "val.invoiceUrl", "") ? lodash_1(this.props, "val.invoiceUrl", "") : "";
      var countryForCurrencyCode = this.props.val && this.props.val.chargeDesc[0] ? lodash_1(this.props, "val.chargeDesc[0].countryForCurrency", "") : countryCode;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          {
            size: "mini",
            className: "pendingList-table flex",
            style: { marginBottom: "5px" }
          },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "10px"
              },
              className: "flex-2"
            },
            React__default.createElement(
              "div",
              { style: { minWidth: "21px" } },
              invoiceUrl === "" && cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this3.props.expandCard(_this3.props.cardIndex);
                },
                name: "plus circle",
                className: "card-toggle-icon"
              }),
              invoiceUrl === "" && cardIndex === this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this3.props.expandCard(_this3.props.cardIndex);
                },
                name: "minus circle",
                className: "card-toggle-icon"
              })
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country invoice-number-container" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, 'val.drayageInvoiceNumber', '')
              ),
              invoiceUrl !== "" && React__default.createElement(
                "div",
                { className: "statistic-value-tooltip" },
                "SYNCED FROM INTACCT"
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country flex-1" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              countryData.countryName
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "SHIPMENT ID#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this, "props.val.shipmentId", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$2, { date: lodash_1(this.props, "val.createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "ACC REF NO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value", style: { "max-width": "100px", "word-wrap": "break-word", "white-space": "normal" } },
              lodash_1(this.props, "val.referenceNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "STATUS"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value reference-no" },
              lodash_1(this.props, "val.status", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.totalAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            "div",
            {
              // className="table-action-btns approve-disapprove-btn"
              style: {
                display: "flex",
                gap: "10px",
                minWidth: "170px"
              },
              className: "flex-2"
            },
            this.props.userTypes === "OPS_PARTNER" && React__default.createElement(
              "div",
              null,
              React__default.createElement(
                Button,
                {
                  className: "save-invoice-btn"
                  // onClick={(e) => {
                  //   this.props.editChargeListCharge(this.props.index);
                  // }}
                },
                "APPROVE"
              ),
              React__default.createElement(
                Button,
                {
                  className: "save-invoice-btn"
                  // onClick={(e) => {
                  //   this.props.editChargeListCharge(this.props.index);
                  // }}
                },
                "REJECT"
              )
            ),
            invoiceUrl === "" && React__default.createElement(UploadDocument, {
              containerId: lodash_1(this.props, "val.containerId", ""),
              containerNumber: lodash_1(this.props, "val.containerNumber", ""),
              chargeDesc: lodash_1(this.props, "val.chargeDesc", ""),
              showOtherTab: this.state.showOtherTab
            }),
            invoiceUrl === "" && React__default.createElement(
              "span",
              {
                className: "btn-over",
                onClick: function onClick() {
                  var context = _this3.context;
                  context.setModalSize("fullscreen");
                  context.setShowModal(true);
                  context.setModalHeaderText("CHANGE LOG FOR " + lodash_1(_this3.props, "val.containerNumber", ""));
                  context.setDescriptionText(React__default.createElement(DrayageInvoiceChangeLog, { data: lodash_1(_this3.props, "val", {}) }));
                  context.setDescriptionHeaderText("");
                  // context.setCloseButtonText("Cancels");
                  // context.setActionButtonText("Raise Dispute");
                }
              },
              React__default.createElement(Icon, {
                style: {
                  padding: "10px 4px",
                  color: "#08adb6",
                  fontSize: "1.4em"
                },
                name: "history"
              })
            )
          )
        )
      );
    }
  }]);
  return PendingListCardHeader;
}(Component);

PendingListCardHeader.contextType = ModelContext;

var PendingListCard = function (_Component) {
  inherits(PendingListCard, _Component);

  function PendingListCard(props) {
    classCallCheck(this, PendingListCard);
    return possibleConstructorReturn(this, (PendingListCard.__proto__ || Object.getPrototypeOf(PendingListCard)).call(this, props));
  }

  createClass(PendingListCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table content-static-card"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    {
                      className: "table-field-cell",
                      width: "1"
                      // style={
                      //   get(val, "calculatedUnitCount", "") &&
                      //   (get(val, "quantity", "") !== get(val, "calculatedUnitCount", ""))
                      //     ? { color: 'red' }
                      //     : {}
                      // }
                    },
                    lodash_1(val, "quantity", ""),
                    lodash_1(val, "calculatedUnitCount", "") && lodash_1(val, "calculatedUnitCount", "") != lodash_1(val, "quantity", "") && React__default.createElement(Popup
                    // trigger={<i class="info circle icon black large"></i>}
                    , { header: "",
                      content: lodash_1(val, "calculatedUnitCount", "") > 0 ? "" + lodash_1(val, "calculatedUnitCount", "") : 'Gate IN event is not available',
                      position: "top center",
                      style: { maxWidth: "250px", height: "50px", color: '#00b5ad' }
                    })
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        disabled: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return PendingListCard;
}(Component);

var PendingList = function (_Component) {
  inherits(PendingList, _Component);

  function PendingList(props) {
    var _this2 = this;

    classCallCheck(this, PendingList);

    var _this = possibleConstructorReturn(this, (PendingList.__proto__ || Object.getPrototypeOf(PendingList)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.00;
      }
      return value;
    };

    _this.markPaidInvoice = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var setPaidInvice;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPaidInvice = _this.props.setPaidInvice;
              _context.next = 3;
              return setPaidInvice();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context3.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.state = { page: 1 };
    return _this;
  }

  createClass(PendingList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("div", { style: { display: "flex", flexDirection: "row-reverse" } }),
        React__default.createElement(CustomLoader, { showImage: true, loading: this.props.fetchPendingTabInvoices }),
        !this.props.fetchPendingTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              { style: { marginBottom: "15px", background: "white" }, key: "pedning-card-" + index },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this3.props.activeCard === index,
                  index: 0,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PendingListCardHeader, {
                  activeCard: _this3.props.activeCard,
                  cardIndex: index,
                  expandCard: _this3.props.expandCard,
                  val: val,
                  getFormatedDate: _this3.props.getFormatedDate,
                  getCountryNameAndImage: _this3.props.getCountryNameAndImage,
                  getFormatedCurrency: _this3.props.getFormatedCurrency,
                  setSelectedInvoice: _this3.props.setSelectedInvoice,
                  userTypes: _this3.props.userTypes
                })
              ),
              React__default.createElement(
                Accordion.Content,
                {
                  active: _this3.props.activeCard === index,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PendingListCard, {
                  data: val,
                  index: index,
                  formatAmount: _this3.formatAmount,
                  getFormatedCurrency: _this3.props.getFormatedCurrency
                })
              )
            );
          })
        ),
        lodash_1(this.props, 'invoices', []).length > 0 && React__default.createElement(Pagination, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return PendingList;
}(Component);

// import PaymentHistory from "../PaymentHistory";
function Date$3(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var PaidListCardHeader = function (_Component) {
  inherits(PaidListCardHeader, _Component);

  function PaidListCardHeader(props) {
    classCallCheck(this, PaidListCardHeader);

    var _this = possibleConstructorReturn(this, (PaidListCardHeader.__proto__ || Object.getPrototypeOf(PaidListCardHeader)).call(this, props));

    _this.state = {
      activeIndex: 1,
      showOtherTab: true
    };
    return _this;
  }

  createClass(PaidListCardHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, "val.countryCode", ""));
      var countryCode = lodash_1(this.props, "val.countryCode", "");
      var invoiceUrl = lodash_1(this.props, "val.invoiceUrl", "") ? lodash_1(this.props, "val.invoiceUrl", "") : "";
      var countryForCurrencyCode = this.props.val && this.props.val.chargeDesc[0] ? lodash_1(this.props, "val.chargeDesc[0].countryForCurrency", "") : countryCode;return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          {
            style: {
              overflowX: "auto", // Enable horizontal scrolling
              paddingBottom: "10px"
            }
          },
          React__default.createElement(
            Statistic.Group,
            {
              size: "mini",
              className: "pendingList-table flex",
              style: { marginBottom: "5px", whiteSpace: "nowrap" }
            },
            React__default.createElement(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px"
                },
                className: "flex-2"
              },
              React__default.createElement(
                "div",
                { style: { minWidth: "21px" } },
                invoiceUrl === "" && cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
                  onClick: function onClick(e) {
                    return _this2.props.expandCard(_this2.props.cardIndex);
                  },
                  name: "plus circle",
                  className: "card-toggle-icon"
                }),
                invoiceUrl === "" && cardIndex === this.props.activeCard && React__default.createElement(Icon, {
                  onClick: function onClick(e) {
                    return _this2.props.expandCard(_this2.props.cardIndex);
                  },
                  name: "minus circle",
                  className: "card-toggle-icon"
                })
              ),
              React__default.createElement(
                Statistic,
                { className: "statistic-country invoice-number-container" },
                React__default.createElement(
                  Statistic.Label,
                  { className: "statistic-label" },
                  "INVOICE#"
                ),
                React__default.createElement(
                  Statistic.Value,
                  { className: "statistic-value" },
                  lodash_1(this.props, 'val.drayageInvoiceNumber', '')
                ),
                invoiceUrl !== "" && React__default.createElement(
                  "div",
                  { className: "statistic-value-tooltip" },
                  "SYNCED FROM INTACCT"
                )
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country flex-1" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "COUNTRY"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                countryData.countryName
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "SHIPMENT ID#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this, "props.val.shipmentId", "")
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "CONTAINER#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "val.containerNumber", "")
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "CUSTOMER"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "val.customerName", "")
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "CREATED DATE"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                React__default.createElement(Date$3, { date: lodash_1(this.props, "val.createdDate", "") })
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "BILL TO"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                "KLEARNOW"
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "ACC REF NO"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "val.referenceNumber", "")
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "PAID AMOUNT"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value reference-no" },
                this.props.getFormatedCurrency(lodash_1(this.props, "val.paidAmount", ""), countryForCurrencyCode)
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "PAID DATE"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                this.props.getFormatedPaidDate(lodash_1(this.props, "val.paidDate", ""))
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "MODE OF PAYMENT"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value currency" },
                lodash_1(this.props, "val.modeOfPayment", "")
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "GRAND TOTAL"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value currency" },
                this.props.getFormatedCurrency(lodash_1(this.props, "val.totalAmount", ""), countryForCurrencyCode)
              )
            ),
            React__default.createElement(
              "div",
              { className: "flex flex-2", style: { gap: "5px", minWidth: "115px" } },
              invoiceUrl === "" && React__default.createElement(UploadDocument, {
                containerId: lodash_1(this.props, "val.containerId", ""),
                containerNumber: lodash_1(this.props, "val.containerNumber", ""),
                chargeDesc: lodash_1(this.props, "val.chargeDesc", ""),
                showOtherTab: this.state.showOtherTab
              }),
              invoiceUrl === "" && React__default.createElement(
                "span",
                {
                  className: "btn-over",
                  style: { width: "46px" },
                  onClick: function onClick() {
                    var context = _this2.context;
                    context.setModalSize("fullscreen");
                    context.setShowModal(true);
                    context.setModalHeaderText("CHANGE LOG FOR " + lodash_1(_this2.props, "val.containerNumber", ""));
                    context.setDescriptionText(React__default.createElement(DrayageInvoiceChangeLog, { data: lodash_1(_this2.props, "val", {}) }));
                    context.setDescriptionHeaderText("");
                    // context.setCloseButtonText("Cancels");
                    // context.setActionButtonText("Raise Dispute");
                  }
                },
                React__default.createElement(Icon, {
                  style: {
                    padding: "11px 6px",
                    color: "#08adb6",
                    fontSize: "1.2em"
                  },
                  name: "history"
                })
              )
            )
          )
        )
      );
    }
  }]);
  return PaidListCardHeader;
}(Component);

PaidListCardHeader.contextType = ModelContext;

var PaidListCardContentStatic = function (_Component) {
  inherits(PaidListCardContentStatic, _Component);

  function PaidListCardContentStatic(props) {
    classCallCheck(this, PaidListCardContentStatic);
    return possibleConstructorReturn(this, (PaidListCardContentStatic.__proto__ || Object.getPrototypeOf(PaidListCardContentStatic)).call(this, props));
  }

  createClass(PaidListCardContentStatic, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table content-static-card"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        disabled: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return PaidListCardContentStatic;
}(Component);

var Paid = function (_Component) {
  inherits(Paid, _Component);

  function Paid(props) {
    var _this2 = this;

    classCallCheck(this, Paid);

    var _this = possibleConstructorReturn(this, (Paid.__proto__ || Object.getPrototypeOf(Paid)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.00;
      }
      return value;
    };

    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.state = { page: 1 };
    return _this;
  }
  // setStateObj(state) {
  //   this.setState({ ...state });
  // }
  // expandCard(id) {
  //   this.state.activeCard === id
  //     ? this.setStateObj({
  //         activeCard: null,
  //       })
  //     : this.setStateObj({
  //         activeCard: id,
  //       });
  // }

  createClass(Paid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(CustomLoader, { showImage: true, loading: this.props.fetchPaidTabInvoices }),
        !this.props.fetchPaidTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              { style: { marginBottom: "15px", background: "white" }, key: "paid-card-" + index },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this3.props.activeCard === index,
                  index: 0,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PaidListCardHeader, {
                  activeCard: _this3.props.activeCard,
                  cardIndex: index,
                  expandCard: _this3.props.expandCard,
                  val: val,
                  getFormatedDate: _this3.props.getFormatedDate,
                  getCountryNameAndImage: _this3.props.getCountryNameAndImage,
                  getFormatedCurrency: _this3.props.getFormatedCurrency,
                  getFormatedPaidDate: _this3.props.getFormatedPaidDate,
                  setSelectedInvoice: _this3.props.setSelectedInvoice
                })
              ),
              React__default.createElement(
                Accordion.Content,
                {
                  active: _this3.props.activeCard === index,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PaidListCardContentStatic, {
                  data: val,
                  index: index,
                  formatAmount: _this3.formatAmount,
                  getFormatedCurrency: _this3.props.getFormatedCurrency
                })
              )
            );
          })
        ),
        lodash_1(this.props, 'invoices', []).length > 0 && React__default.createElement(Pagination, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return Paid;
}(Component);

var Dispute = function (_Component) {
  inherits(Dispute, _Component);

  function Dispute(props) {
    classCallCheck(this, Dispute);

    var _this = possibleConstructorReturn(this, (Dispute.__proto__ || Object.getPrototypeOf(Dispute)).call(this, props));

    _this.state = {
      activeCard: null
    };
    return _this;
  }

  createClass(Dispute, [{
    key: 'setStateObj',
    value: function setStateObj(state) {
      this.setState(_extends({}, state));
    }
  }, {
    key: 'expandCard',
    value: function expandCard(id) {

      this.state.activeCard === id ? this.setStateObj({
        activeCard: null
      }) : this.setStateObj({
        activeCard: id
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React__default.createElement(
        'div',
        null,
        React__default.createElement(
          'p',
          null,
          'Dispute'
        )
      );
    }
  }]);
  return Dispute;
}(Component);

var Cancelled = function (_Component) {
  inherits(Cancelled, _Component);

  function Cancelled(props) {
    classCallCheck(this, Cancelled);

    var _this = possibleConstructorReturn(this, (Cancelled.__proto__ || Object.getPrototypeOf(Cancelled)).call(this, props));

    _this.state = {
      activeCard: null
    };
    return _this;
  }

  createClass(Cancelled, [{
    key: 'setStateObj',
    value: function setStateObj(state) {
      this.setState(_extends({}, state));
    }
  }, {
    key: 'expandCard',
    value: function expandCard(id) {

      this.state.activeCard === id ? this.setStateObj({
        activeCard: null
      }) : this.setStateObj({
        activeCard: id
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React__default.createElement(
        'div',
        null,
        React__default.createElement(
          'p',
          null,
          'Cancelled'
        )
      );
    }
  }]);
  return Cancelled;
}(Component);

function Date$4(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var RejectedListCardHeader = function (_Component) {
  inherits(RejectedListCardHeader, _Component);

  function RejectedListCardHeader(props) {
    classCallCheck(this, RejectedListCardHeader);

    var _this = possibleConstructorReturn(this, (RejectedListCardHeader.__proto__ || Object.getPrototypeOf(RejectedListCardHeader)).call(this, props));

    _this.state = {
      activeIndex: 1,
      showOtherTab: true
    };
    return _this;
  }

  createClass(RejectedListCardHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, 'val.countryCode', ''));
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          { size: "mini", style: { marginBottom: "5px" } },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "20px"

              }
            },
            React__default.createElement(
              Statistic,
              { className: "statistic-country" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, 'val.drayageInvoiceNumber', '')
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              countryData.countryName
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, 'val.containerNumber', '')
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, 'val.customerName', '')
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$4, { date: lodash_1(this.props, "val.createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.totalAmount", ""), lodash_1(this.props, "val.countryCode", ""))
            )
          ),
          React__default.createElement(
            "div",
            {
              className: "table-action-btns approve-disapprove-btn",
              style: {
                display: "flex",
                gap: "10px"
              }
            },
            React__default.createElement(
              "div",
              null,
              React__default.createElement(
                Button,
                {
                  className: "save-invoice-btn",
                  onClick: function onClick(e) {
                    return _this2.props.goToChargelist(lodash_1(_this2.props, 'val.containerNumber', ''));
                  }
                },
                "GO TO CHARGELIST"
              )
            ),
            React__default.createElement(UploadDocument, {
              containerId: lodash_1(this.props, "val.containerId", ""),
              containerNumber: lodash_1(this.props.data, "value.containerNumber", ""),
              chargeDesc: lodash_1(this.props, "val.chargeDesc", ""),
              showOtherTab: this.state.showOtherTab
            })
          )
        )
      );
    }
  }]);
  return RejectedListCardHeader;
}(Component);

var RejectedListCardContentStatic = function (_Component) {
  inherits(RejectedListCardContentStatic, _Component);

  function RejectedListCardContentStatic(props) {
    classCallCheck(this, RejectedListCardContentStatic);
    return possibleConstructorReturn(this, (RejectedListCardContentStatic.__proto__ || Object.getPrototypeOf(RejectedListCardContentStatic)).call(this, props));
  }

  createClass(RejectedListCardContentStatic, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            { basic: "very", className: "drayage-line-item-table content-static-card" },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(_this2.props, "data.countryCode", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(_this2.props, "data.countryCode", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return RejectedListCardContentStatic;
}(Component);

var Rejected = function (_Component) {
  inherits(Rejected, _Component);

  function Rejected(props) {
    classCallCheck(this, Rejected);

    var _this = possibleConstructorReturn(this, (Rejected.__proto__ || Object.getPrototypeOf(Rejected)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.00;
      }
      return value;
    };

    return _this;
  }

  createClass(Rejected, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(CustomLoader, { showImage: true, loading: this.props.fetchRejectedTabInvoices }),
        !this.props.fetchRejectedTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              { style: { marginBottom: "15px", background: "white" }, key: "rejected-card-" + index },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this2.props.activeCard === index,
                  index: 0,
                  className: _this2.props.activeCard === index && "card-opened"
                },
                React__default.createElement(RejectedListCardHeader, {
                  activeCard: _this2.props.activeCard,
                  cardIndex: index,
                  expandCard: _this2.props.expandCard,
                  val: val,
                  getFormatedDate: _this2.props.getFormatedDate,
                  getCountryNameAndImage: _this2.props.getCountryNameAndImage,
                  getFormatedCurrency: _this2.props.getFormatedCurrency,
                  setSelectedInvoice: _this2.props.setSelectedInvoice,
                  goToChargelist: _this2.props.goToChargelist
                })
              )
            );
          })
        )
      );
    }
  }]);
  return Rejected;
}(Component);

function Date$5(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var DisputedCardHeader = function (_Component) {
  inherits(DisputedCardHeader, _Component);

  function DisputedCardHeader(props) {
    classCallCheck(this, DisputedCardHeader);

    var _this = possibleConstructorReturn(this, (DisputedCardHeader.__proto__ || Object.getPrototypeOf(DisputedCardHeader)).call(this, props));

    _this.getFormatedDate = function (date) {
      var dateVal = parseInt(date);
      if (isNaN() || !Number(dateVal) || !dateVal === "") {
        return "";
      }

      var someday = moment$1(dateVal);

      return someday.format("MMMM DD YYYY");
    };

    _this.handleChange = function (e, _ref2) {
      var value = _ref2.value;
      var selectedDropdownData = _this.props.selectedDropdownData;

      var data = _this.props.data.chargeDesc.billingParties.billToList.filter(function (currentBill) {
        if (currentBill.customerName.toLowerCase() === chargeDesc.toLowerCase()) {
          return currentBill;
        }
      });
      selectedDropdownData(data || {});
    };

    return _this;
  }

  createClass(DisputedCardHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          option = _props.option,
          defaultOption = _props.defaultOption,
          cardIndex = _props.cardIndex,
          data = _props.data;

      var countryName = "";
      var countryImage = "";
      if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "US") {
        countryName = "USA";
        countryImage = "/images/US.jpg";
      } else if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "CANADA" || lodash_1(this.props, "data.chargeDesc.countryCode", "") === "CA") {
        countryName = "CANADA";
        countryImage = "/images/Canda.jpg";
      } else if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "UK") {
        countryName = "UK";
        countryImage = "/images/Uk.jpg";
      } else if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "ES") {
        countryName = "SPAIN";
        countryImage = "/images/spain.jpg";
      } else if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "NL") {
        countryName = "NL";
        countryImage = "/images/NL.jpg";
      }
      var countryForCurrencyCode = lodash_1(this.props, 'data.chargeDesc.chargeDesc[0].countryForCurrency', '');
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          {
            size: "mini",
            className: "pendingList-table flex",
            style: { marginBottom: "5px" }
          },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "10px"
              },
              className: "flex-2"
            },
            React__default.createElement(
              "div",
              { style: { minWidth: "21px" } },
              cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this2.props.expandCard(_this2.props.cardIndex);
                },
                name: "plus circle",
                className: "card-toggle-icon"
              }),
              cardIndex === this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this2.props.expandCard(_this2.props.cardIndex);
                },
                name: "minus circle",
                className: "card-toggle-icon"
              })
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "data.drayageInvoiceNumber", "")
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country flex-1" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement("img", { src: countryImage, className: "countryIcon" }),
              countryName
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "SHIPMENT ID#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this, "props.data.shipmentId", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props.data, "chargeDesc.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props.data, "chargeDesc.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$5, { date: lodash_1(this.props.data, "chargeDesc.addedDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "ACC REF NO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value", style: { "max-width": "100px", "word-wrap": "break-word", "white-space": "normal" } },
              lodash_1(this.props.data, "referenceNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "STATUS"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value reference-no" },
              lodash_1(this.props.data, "status", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props.data, "totalAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "10px",
                minWidth: "115px"
              },
              className: "flex-2"
            },
            React__default.createElement(UploadDocument, {
              containerId: lodash_1(this.props.data, "chargeDesc.containerId", ""),
              containerNumber: lodash_1(this.props.data, "chargeDesc.containerNumber", ""),
              chargeDesc: lodash_1(this.props.data, "chargeDesc.chargeDesc", ""),
              showOtherTab: false,
              getChargelistData: this.props.getDisputedData
            }),
            React__default.createElement(
              "span",
              {
                className: "btn-over",
                onClick: function onClick() {
                  var context = _this2.context;
                  context.setModalSize("fullscreen");
                  context.setShowModal(true);
                  context.setModalHeaderText("CHANGE LOG FOR " + lodash_1(_this2.props, "data.containerNumber", ""));
                  context.setDescriptionText(React__default.createElement(DrayageInvoiceChangeLog, { data: lodash_1(_this2.props, "data", {}) }));
                  context.setDescriptionHeaderText("");
                  // context.setCloseButtonText("Cancels");
                  // context.setActionButtonText("Raise Dispute");
                }
              },
              React__default.createElement(Icon, {
                style: {
                  padding: "10px 4px",
                  color: "#08adb6",
                  fontSize: "1.4em"
                },
                name: "history"
              })
            )
          )
        )
      );
    }
  }]);
  return DisputedCardHeader;
}(Component);

DisputedCardHeader.contextType = ModelContext;

var UOM$1 = [{ text: "PER DAY", value: "PERDAY", key: "PERDAY" }, { text: "PER UNIT", value: "PERUNIT", key: "PERUNIT" }, { text: "PER HOUR", value: "PERHOUR", key: "PERHOUR" }, { text: "PER STATE", value: "PERSTATE", key: "PERSTATE" }, { text: "APMT", value: "APMT", key: "APMT" }];

var DisputedCardEdit = function (_Component) {
  inherits(DisputedCardEdit, _Component);

  function DisputedCardEdit(props) {
    classCallCheck(this, DisputedCardEdit);

    var _this = possibleConstructorReturn(this, (DisputedCardEdit.__proto__ || Object.getPrototypeOf(DisputedCardEdit)).call(this, props));

    _this.state = {
      chargeDesc: [],
      saveBtnClicked: false
    };
    return _this;
  }

  createClass(DisputedCardEdit, [{
    key: "deepEqual",
    value: function deepEqual(object1, object2) {
      var areObjects = this.isObject(object1) && this.isObject(object2);
      if (areObjects) {
        var keys1 = Object.keys(object1);
        var keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
          return false;
        }
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var val1 = object1[key];
            var val2 = object2[key];
            var _areObjects = this.isObject(val1) && this.isObject(val2);
            if (_areObjects && !this.deepEqual(val1, val2) || !_areObjects && val1 !== val2) {
              return false;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return true;
      }
      return false;
    }
  }, {
    key: "isObject",
    value: function isObject(object) {
      return object !== null && object !== undefined && (typeof object === "undefined" ? "undefined" : _typeof(object)) === "object";
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  chargeDesc: lodash_1(this.props, "data.chargeDesc.chargeDesc", [])
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.deepEqual(lodash_1(prevProps, "data.chargeDesc.chargeDesc", [])) !== this.deepEqual(lodash_1(this.props, "data.chargeDesc.chargeDesc", []))) {
        this.setState({
          chargeDesc: lodash_1(this.props, "data.chargeDesc.chargeDesc", [])
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table edit-card-list non-edit"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "COMMENT"
                ),
                React__default.createElement(Table.HeaderCell, { className: "table-heading-cell" })
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(DisputedRow, {
                  key: index,
                  index: _this2.props.index,
                  rowIndex: index,
                  chargesOptions: _this2.props.chargesOptions,
                  disputeChargeOptions: _this2.props.disputeChargeOptions,
                  updateDisputedLineItem: _this2.props.updateDisputedLineItem,
                  deleteChargeLineItem: _this2.props.deleteChargeLineItem,
                  val: val,
                  getFormatedCurrency: _this2.props.getFormatedCurrency,
                  countryCode: _this2.props.data.chargeDesc.countryCode,
                  addChargeToInvoice: _this2.props.addChargeToInvoice,
                  addAllChargeToInvoice: _this2.props.addAllChargeToInvoice,
                  nonEditableGlCodes: _this2.props.nonEditableGlCodes,
                  unitPriceValue: _this2.props.unitPriceValue,
                  selectedCharge: _this2.props.selectedCharge,
                  unitPriceVal: _this2.props.unitPriceVal,
                  uom: _this2.props.uom,
                  deleteChargeLineItemForDisputedTab: _this2.props.deleteChargeLineItemForDisputedTab,
                  chassesdata: _this2.props.data
                });
              }),
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.Cell,
                  {
                    colSpan: "12",
                    className: "table-field-cell text-align-center"
                  },
                  React__default.createElement(
                    "div",
                    { className: "table-action-btns" },
                    React__default.createElement(
                      Button,
                      {
                        className: "add-line-item-btn",
                        onClick: function () {
                          var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
                            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    _this2.props.addDisputedNewCharge(_this2.props.index);

                                  case 1:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, _this2);
                          }));

                          return function (_x) {
                            return _ref2.apply(this, arguments);
                          };
                        }()
                      },
                      React__default.createElement("img", { src: "./images/ADD_LINE.svg", className: "ui image" }),
                      " ",
                      "ADD LINE ITEM"
                    ),
                    React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(
                        Button,
                        {
                          loading: this.state.saveBtnClicked,
                          className: "save-invoice-btn",
                          onClick: function onClick(e) {
                            if (_this2.state.saveBtnClicked === false) {
                              _this2.setState({ saveBtnClicked: true }, function () {
                                _this2.props.saveDisputedData(_this2.props.index).then(function () {
                                  _this2.setState({ saveBtnClicked: false });
                                });
                              });
                            }
                          }
                        },
                        "SAVE"
                      ),
                      React__default.createElement(
                        Button,
                        {
                          className: "create-invoice-btn",
                          onClick: function onClick(e) {
                            _this2.props.cancelDisputedEdit(_this2.props.index, _this2.state.chargeDesc);
                          }
                        },
                        "CANCEL"
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return DisputedCardEdit;
}(Component);

var DisputedRow = function (_Component2) {
  inherits(DisputedRow, _Component2);

  function DisputedRow(props) {
    var _this4 = this;

    classCallCheck(this, DisputedRow);

    var _this3 = possibleConstructorReturn(this, (DisputedRow.__proto__ || Object.getPrototypeOf(DisputedRow)).call(this, props));

    _this3.showConfirm = function () {
      _this3.setState({ showConfirm: true });
    };

    _this3.handleConfirm = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.props.deleteChargeLineItemForDisputedTab(_this3.props.index, _this3.props.rowIndex);

            case 2:
              _this3.setState({ showConfirm: false });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }));

    _this3.handleCancel = function () {
      return _this3.setState({ showConfirm: false });
    };

    _this3.state = {
      quantity: "",
      unitPrice: "",
      showConfirm: false
    };
    return _this3;
  }

  createClass(DisputedRow, [{
    key: "componentDidUpdate",
    value: function () {
      var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(prevProps) {
        var quantity, unitPrice, total, subtotal, subTotal;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(lodash_1(this.props.val, "quantity", "") !== lodash_1(prevProps.val, "quantity", "") || lodash_1(this.props.val, "unitPrice", "") !== lodash_1(prevProps.val, "unitPrice", ""))) {
                  _context4.next = 9;
                  break;
                }

                quantity = parseInt(lodash_1(this.props.val, "quantity", 0));
                unitPrice = parseFloat(lodash_1(this.props.val, "unitPrice", 0));

                quantity = isNaN(quantity) ? 0 : quantity;
                unitPrice = isNaN(unitPrice) ? 0 : unitPrice;
                total = parseFloat(quantity * unitPrice).toFixed(2) * 100;

                total = isNaN(parseFloat(total)) ? 0.0 : total;

                _context4.next = 9;
                return this.props.updateDisputedLineItem(this.props.index, this.props.rowIndex, "subTotal", total);

              case 9:
                subtotal = parseFloat(lodash_1(this.props.val, "subTotal", 0));

                if (!isNaN(subtotal) && (lodash_1(this.props.val, "subTotal", "") !== lodash_1(prevProps.val, "subTotal", "") || lodash_1(this.props.val, "markUPAmount", "") !== lodash_1(prevProps.val, "markUPAmount", ""))) {
                  subTotal = parseFloat(lodash_1(this.props.val, "subTotal", 0));

                  subTotal = isNaN(subTotal) ? 0.0 : subTotal;

                  // let margin = parseFloat(get(this.props.val, "markUPAmount", 0));

                  // if (!isNaN(margin) && margin > 0) {
                  //   let unitPrice = parseFloat(get(this.props.val, "unitPrice", 0));
                  //   let calculatedMargin = parseFloat(1-(parseFloat(margin)/100))
                  //   let value = parseFloat((subTotal/100)/calculatedMargin)
                  //   await this.props.updateDisputedLineItem(
                  //     this.props.index,
                  //     this.props.rowIndex,
                  //     "totalRate",
                  //     chargeDesc.toFixed(2)
                  //   );
                  // }
                }

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x2) {
        return _ref4.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          index = _props.index,
          rowIndex = _props.rowIndex,
          val = _props.val,
          chargesOptions = _props.chargesOptions,
          disputeChargeOptions = _props.disputeChargeOptions,
          updateDisputedLineItem = _props.updateDisputedLineItem,
          deleteChargeLineItem = _props.deleteChargeLineItem,
          chassesdata = _props.chassesdata;

      console.log("kkk", val);
      var deleteMessage = "Are you sure you want to remove the line item?";
      deleteMessage = !lodash_2(lodash_1(val, "chargeName", "")) ? "Are you sure you want to remove the charge - " + lodash_1(val, "chargeName", "") + "?" : deleteMessage;
      return React__default.createElement(
        Table.Row,
        { key: "disputed-" + rowIndex },
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          lodash_1(val, "new", false) === true && React__default.createElement(Form.Field, {
            disabled: lodash_1(val, "new", false) !== true,
            control: Select,
            label: "",
            value: lodash_1(val, "new", false) === true ? lodash_1(val, "glCode", "") : lodash_1(val, "chargeName", ""),
            options: this.props.disputeChargeOptions,
            placeholder: "",
            className: "custom-field",
            icon: "chevron down",
            onChange: function () {
              var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(e, data) {
                var value, options, selectedValue, chassisUnitCount;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        value = data.value;
                        options = data.options;
                        selectedValue = options.find(function (val) {
                          return val.value === value;
                        });
                        chassisUnitCount = chassesdata["chargeDesc"]["chassisUnitCount"] || '';

                        if (chassisUnitCount < 1) {
                          chassisUnitCount = 1;
                        }
                        _context5.next = 7;
                        return _this5.props.selectedCharge(selectedValue.unitPrice, selectedValue.uom);

                      case 7:
                        _context5.next = 9;
                        return _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "glCode", value);

                      case 9:
                        _context5.next = 11;
                        return _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "chargeName", selectedValue.text);

                      case 11:
                        _context5.next = 13;
                        return _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "unitOfMeasurement", selectedValue.uom);

                      case 13:
                        if (!(selectedValue.text === 'CHASSIS RENTAL')) {
                          _context5.next = 18;
                          break;
                        }

                        _context5.next = 16;
                        return _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "quantity", chassisUnitCount);

                      case 16:
                        _context5.next = 20;
                        break;

                      case 18:
                        _context5.next = 20;
                        return _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "quantity", 1);

                      case 20:
                        _context5.next = 22;
                        return _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "unitPrice", selectedValue.unitPrice);

                      case 22:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, _this5);
              }));

              return function (_x3, _x4) {
                return _ref5.apply(this, arguments);
              };
            }()
          }),
          lodash_1(val, "new", false) === false && React__default.createElement(Form.Field, {
            disabled: lodash_1(val, "new", false) !== true,
            control: Input$1,
            label: "",
            value: lodash_1(val, "chargeName", ""),
            placeholder: "",
            className: "custom-field"
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          React__default.createElement(Form.Input, {
            // readOnly={get(val, "isGenerated", false) === true}
            // value={get(val, "quantity", "") ? get(val, "quantity", "") : 1}
            value: lodash_1(val, "quantity", ""),
            onChange: function onChange(e) {
              e.target.value = e.target.value.trim();
              if (!lodash_2(e.target.value.trim()) && !/^([0-9]*)$/.test(e.target.value)) {
                e.preventDefault();
                return;
              }
              if (!lodash_2(e.target.value.trim())) {
                e.target.value = parseInt(e.target.value);
              }
              if (parseInt(e.target.value) === 0) {
                e.target.value = 1;
              }

              _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "quantity", e.target.value);
            }
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          React__default.createElement(Form.Input, {
            // readOnly={get(val, "isGenerated", false) === true}
            value: lodash_1(val, "unitPrice", "") ? lodash_1(val, "unitPrice", "") : this.props.unitPriceVal,
            onChange: function onChange(e) {
              e.target.value = e.target.value.trim();
              if (!lodash_2(e.target.value) && !/^[1-9]\d{0,8}(\.{0,1})(\d{1,4})?$/.test(e.target.value)) {
                e.preventDefault();
                return;
              }
              _this5.props.unitPriceValue();
              _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "unitPrice", e.target.value);
            },
            onBlur: function onBlur(e) {
              e.target.value = parseFloat(e.target.value);
              if (isNaN(e.target.value)) {
                e.target.value = 0.0;
              }

              _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "unitPrice", e.target.value);
            }
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          lodash_1(val, "new", false) === true && React__default.createElement(Form.Field, {
            disabled: true,
            control: Select,
            label: "",
            value: lodash_1(val, "unitOfMeasurement", ""),
            options: UOM$1,
            placeholder: "",
            icon: "chevron down",
            onChange: function () {
              var _ref6 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e, data) {
                var value;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        value = data.value;
                        _context6.next = 3;
                        return _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "unitOfMeasurement", value);

                      case 3:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6, _this5);
              }));

              return function (_x5, _x6) {
                return _ref6.apply(this, arguments);
              };
            }()
          }),
          lodash_1(val, "new", false) === false && React__default.createElement(Form.Field, {
            disabled: true,
            control: Input$1,
            label: "",
            value: lodash_1(val, "unitOfMeasurement", "")
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center total-value" },
          this.props.getFormatedCurrency(lodash_1(val, "subTotal", ""), lodash_1(val, "countryForCurrency", "")),
          React__default.createElement(Icon, { className: "green-tick", name: "check circle" })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center" },
          lodash_1(val, "status", "")
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center" },
          React__default.createElement(Popup, {
            trigger: React__default.createElement(Form.Input, {
              value: lodash_1(val, "chargeComment", ""),
              onChange: function onChange(e) {
                e.target.value = e.target.value;
                _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "chargeComment", e.target.value);
              },
              onBlur: function onBlur(e) {
                e.target.value = e.target.value;
                _this5.props.updateDisputedLineItem(_this5.props.index, rowIndex, "comment", e.target.value);
              }
            }),
            header: "",
            content: lodash_1(val, "chargeComment", ""),
            position: "top center",
            style: { maxWidth: "150px" },
            on: "focus"
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-right" },
          lodash_1(val, "glCode", "") !== "60001" && lodash_1(val, "glCode", "") !== "60002" && React__default.createElement(
            "span",
            {
              onClick: function onClick() {
                _this5.showConfirm();
              }
            },
            React__default.createElement(
              "svg",
              {
                width: "16",
                height: "17",
                viewBox: "0 0 16 17",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              },
              React__default.createElement("path", {
                d: "M4.7339 5.45847L6.07543 5.4079L6.36627 13.5713L5.02475 13.6217L4.7339 5.45847Z",
                fill: "#286084"
              }),
              React__default.createElement("rect", {
                width: "1.34239",
                height: "8.16348",
                transform: "matrix(-1 0 0 1 8.6712 5.43317)",
                fill: "#286084"
              }),
              React__default.createElement("path", {
                d: "M9.63393 13.5711L9.92477 5.40765L11.2663 5.45826L10.9754 13.6217L9.63393 13.5711Z",
                fill: "#286084"
              }),
              React__default.createElement("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.9873 3.40954V2.02982H0.0126772V3.40954H1.43407L2.54379 16.3704C2.57398 16.7266 2.86439 17 3.21231 17H12.8103C13.1582 17 13.4484 16.7268 13.4788 16.3706L14.5885 3.40954H15.9873ZM12.1957 15.6203H3.8271L2.78158 3.40954H13.241L12.1957 15.6203Z",
                fill: "#286084"
              }),
              React__default.createElement("path", {
                d: "M6.18242 0H10.8176C11.4696 0 12 0.464058 12 1.03447V3H10.5811V1.24137H6.41891V3H5V1.03447C5 0.464058 5.53043 0 6.18242 0Z",
                fill: "#286084"
              })
            )
          ),
          React__default.createElement(Confirm, {
            className: "delete-charge-confirm",
            header: "Delete Charge",
            content: deleteMessage,
            open: this.state.showConfirm,
            onCancel: this.handleCancel,
            onConfirm: this.handleConfirm,
            size: "large",
            confirmButton: "Delete Charge"
          })
        )
      );
    }
  }]);
  return DisputedRow;
}(Component);

var PreviewDocument$1 = function (_Component) {
  inherits(PreviewDocument, _Component);

  function PreviewDocument(props) {
    classCallCheck(this, PreviewDocument);

    var _this = possibleConstructorReturn(this, (PreviewDocument.__proto__ || Object.getPrototypeOf(PreviewDocument)).call(this, props));

    _this.get_url_extension = function (url) {
      var ext = url.split(/[#?]/)[0].split(".").pop().trim();
      return ext;
    };

    _this.openInNewTab = function (url) {
      var newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    };

    _this.state = { options: [] };
    return _this;
  }

  createClass(PreviewDocument, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      console.log("TESTING", this.props.documentName);
      if (this.props.documentName != prevProps.documentName && this.props.documentName) {
        this.setState({
          options: Array.isArray(lodash_1(this, "props.documentName", [])) ? lodash_1(this, "props.documentName", []).map(function (val) {
            return { value: val, key: val, text: val };
          }) : []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Open = _props.Open,
          Close = _props.Close,
          docUrl = _props.docUrl;

      var extenison = this.get_url_extension(docUrl);
      return React__default.createElement(
        Modal,
        {
          closeIcon: true,
          open: Open,
          onClose: Close,
          onOpen: Open,
          size: "small",
          className: "preDocument"
        },
        React__default.createElement(Header, { content: "Preview Document" }),
        React__default.createElement(
          Modal.Content,
          null,
          Array.isArray(lodash_1(this, "props.documentName", [])) && lodash_1(this, "props.documentName", []).map(function (val) {
            return React__default.createElement(
              "div",
              {
                onClick: function onClick() {
                  return _this2.props.handleModal(val);
                },
                className: "preview-file-links"
              },
              val
            );
          }),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "a",
              { onClick: function onClick(e) {
                  return _this2.openInNewTab(docUrl);
                } },
              React__default.createElement(Icon, { name: "download" })
            )
          ),
          extenison == "pdf" ? React__default.createElement(PDFViewer, { url: docUrl }) : extenison == "pptx" ? React__default.createElement(
            Image,
            { size: "small" },
            React__default.createElement(Label, {
              content: "Extension not supported!",
              icon: "warning",
              style: {
                width: "300px",
                height: "100px",
                paddingTop: "35px",
                paddingLeft: "55px"
              }
            })
          ) : React__default.createElement(Image, { size: "large", src: docUrl, alt: "Image not found", wrapped: true })
        ),
        React__default.createElement(Modal.Actions, null)
      );
    }
  }]);
  return PreviewDocument;
}(Component);

var DisputedCardContentStatic = function (_Component) {
  inherits(DisputedCardContentStatic, _Component);

  function DisputedCardContentStatic(props) {
    var _this2 = this;

    classCallCheck(this, DisputedCardContentStatic);

    var _this = possibleConstructorReturn(this, (DisputedCardContentStatic.__proto__ || Object.getPrototypeOf(DisputedCardContentStatic)).call(this, props));

    _this.componentDidUpdate = function (prevProps, prevState) {
      if (prevProps.disputeResolvedError !== _this.props.disputeResolvedError) {
        if (lodash_2(_this.props.disputeResolvedError)) {
          _this.context.setDescriptionHeaderText("");
        } else {
          _this.context.setDescriptionHeaderText(React__default.createElement(
            Message,
            { negative: true },
            React__default.createElement(
              Message.Header,
              null,
              _this.props.disputeResolvedError
            )
          ));
        }
      }
    };

    _this.handleModal = function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(docName) {
        var bucketName, data, url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                bucketName = window._env_.DRAYAGE_BILL_BUCKET;
                _context.next = 3;
                return getDrayageImageURL(
                // `${bucketName}:1658330865595_ScreenShot2022-07-12at8.28.49AM.png`
                bucketName + ":" + docName);

              case 3:
                data = _context.sent;
                url = lodash_1(data, "data.eventMessage.urls[0]", "");

                _this.setState({ modalOpen: true, docUrl: url });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleClose = function () {
      _this.setState({ modalOpen: false });
    };

    _this.handleAllChecked = function (event) {
      // let fruites = this.props.data.chargeDesc.chargeDesc;
      // fruites.forEach(fruite => (fruite.isChecked = event.target.checked));
      // console.log("fruites",fruites)
    };

    _this.openInNewTab = function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(docName) {
        var bucketName, data, url, newWindow;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                bucketName = window._env_.DRAYAGE_BILL_BUCKET;
                _context2.next = 3;
                return getDrayageImageURL(
                // `${bucketName}:1658330865595_ScreenShot2022-07-12at8.28.49AM.png`
                bucketName + ":" + docName);

              case 3:
                data = _context2.sent;
                url = lodash_1(data, "data.eventMessage.urls[0]", "");
                newWindow = window.open(url, "_blank", "noopener,noreferrer");

                if (newWindow) newWindow.opener = null;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.state = {
      createCall: false,
      modalOpen: false,
      docUrl: "",
      documents: []
    };
    return _this;
  }

  createClass(DisputedCardContentStatic, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          modalOpen = _state.modalOpen,
          docUrl = _state.docUrl;
      var selectAllInvoice = this.props.selectAllInvoice;


      var addedInvoiceCount = lodash_1(this.props, "data.chargeDesc.chargeDesc", []).filter(function (value) {
        return lodash_1(value, "includeInInvoice", false) === true;
      }).length;
      var isGeneratedCount = lodash_1(this.props, "data.chargeDesc.chargeDesc", []).filter(function (value) {
        return lodash_1(value, "isGenerated", false) === true;
      }).length;
      var allChargesCount = lodash_1(this.props, "data.chargeDesc.chargeDesc", []).length;
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table content-static-card non-edit"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  React__default.createElement("div", {
                    style: {
                      marginLeft: "1rem",
                      display: "flex"
                    }
                  })
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "COMMENT"
                ),
                React__default.createElement(Table.HeaderCell, { className: "table-heading-cell" })
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc.chargeDesc", []).map(function (val, index) {
                var documentName = lodash_1(val, "documentName", []);
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    React__default.createElement(
                      "div",
                      {
                        style: {
                          marginLeft: "1rem",
                          display: "flex",
                          gap: "10px"
                        }
                      },
                      documentName.length ? React__default.createElement(
                        "div",
                        {
                          className: "preview",
                          style: {
                            border: "2px solid #08adb6",
                            width: "30px",
                            borderRadius: "5px"
                          }
                        },
                        React__default.createElement(Icon, {
                          style: {
                            fontSize: "15px",
                            color: "#08adb6",
                            paddingTop: "4px",
                            paddingLeft: "5px"
                          },
                          className: "eye icon"
                          // onClick={() => {this.openInNewTab(documentName)}}
                          , onClick: function onClick() {
                            _this3.setState({ documents: documentName });
                            _this3.handleModal(documentName[0]);
                          }
                        })
                      ) : ""
                    )
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    {
                      className: "table-field-cell text-align-center",
                      width: "1"
                    },
                    _this3.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center total-value" },
                    _this3.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        disabled: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  ),
                  React__default.createElement(Table.Cell, { className: "table-field-cell text-align-right" })
                );
              }),
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.Cell,
                  {
                    colSpan: "12",
                    className: "table-field-cell text-align-center"
                  },
                  React__default.createElement(
                    "div",
                    { className: "table-action-btns" },
                    React__default.createElement(
                      "div",
                      { style: { "margin-left": "auto" } },
                      React__default.createElement(
                        Button,
                        {
                          className: "save-invoice-btn",
                          onClick: function onClick(e) {
                            _this3.props.editDisputedCharge(_this3.props.index);
                          }
                        },
                        "EDIT"
                      ),
                      React__default.createElement(
                        Button,
                        {
                          loading: this.state.createCall,
                          className: "create-invoice-btn",
                          onClick: function onClick(e) {
                            var context = _this3.context;
                            context.setModalSize("large");
                            context.setShowModal(true);
                            context.setModalHeaderText("RESOLVE DISPUTE FOR " + lodash_1(_this3.props, "data.containerNumber", ""));
                            context.setDescriptionText(React__default.createElement(ResolveDispute, {
                              disputeResolvedError: _this3.props.disputeResolvedError,
                              setShowModal: context.setShowModal,
                              data: lodash_1(_this3.props, "data", []),
                              callBack: _this3.props.resolveDisputeRequest
                            }));
                            context.setDescriptionHeaderText("");
                            // context.setCloseButtonText("Cancels");
                            // context.setActionButtonText("Raise Dispute");
                          }
                        },
                        "RESOLVE DISPUTE"
                      )
                    )
                  )
                )
              )
            )
          ),
          React__default.createElement(PreviewDocument$1, {
            Open: this.state.modalOpen,
            Close: this.handleClose,
            docUrl: this.state.docUrl,
            documentName: this.state.documents,
            handleModal: this.handleModal
          })
        )
      );
    }
  }]);
  return DisputedCardContentStatic;
}(Component);

DisputedCardContentStatic.contextType = ModelContext;

var ResolveDispute = function (_React$Component) {
  inherits(ResolveDispute, _React$Component);

  function ResolveDispute(props) {
    var _this5 = this;

    classCallCheck(this, ResolveDispute);

    var _this4 = possibleConstructorReturn(this, (ResolveDispute.__proto__ || Object.getPrototypeOf(ResolveDispute)).call(this, props));

    _this4.callBack = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _this4$state, disputeReason, disputeComment, hasError, returnResult;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this4$state = _this4.state, disputeReason = _this4$state.disputeReason, disputeComment = _this4$state.disputeComment;
              _context3.next = 3;
              return new Promise(function (resolve) {
                _this4.setState({ /*disputeReasonError: false,*/disputeCommentError: false }, function () {
                  setTimeout(function () {
                    resolve(true);
                  }, 100);
                });
              });

            case 3:
              hasError = false;
              // if (isEmpty(disputeReason.trim())) {
              //   hasError = true;
              //   this.setState({
              //     disputeReasonError: "Please select valid reason",
              //   });
              // }

              if (lodash_2(disputeComment.trim())) {
                hasError = true;
                _this4.setState({
                  disputeCommentError: "Please enter valid comment"
                });
              }

              if (!(hasError === false)) {
                _context3.next = 10;
                break;
              }

              _context3.next = 8;
              return _this4.props.callBack({
                disputeReason: "NONE",
                disputeComment: disputeComment,
                data: _this4.props.data
              });

            case 8:
              returnResult = _context3.sent;

              if (returnResult) {
                _this4.props.setShowModal(false);
              }

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }));

    _this4.state = {
      disputeReason: "",
      disputeComment: "",
      disputeReasonError: false,
      disputeCommentError: false
    };
    return _this4;
  }

  createClass(ResolveDispute, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      var _state2 = this.state,
          disputeReason = _state2.disputeReason,
          disputeComment = _state2.disputeComment;

      return React__default.createElement(
        "div",
        { className: "raise-dispute-form" },
        React__default.createElement(
          Form,
          null,
          React__default.createElement(
            Form.Field,
            null,
            React__default.createElement(
              "label",
              null,
              "Resolve Comment"
            ),
            React__default.createElement(TextArea, {
              value: disputeComment,
              className: this.state.disputeCommentError ? "raise-dispute-error" : "",
              onChange: function onChange(e, data) {
                _this6.setState({ disputeComment: data.value });
              }
            }),
            !lodash_2(this.state.disputeCommentError) && React__default.createElement(
              Label,
              { className: "pointing-label", pointing: "above" },
              this.state.disputeCommentError
            )
          ),
          React__default.createElement(
            Button,
            {
              type: "submit",
              onClick: this.callBack,
              style: { background: "#04ADB1", color: "#FFF" }
            },
            "Submit"
          )
        )
      );
    }
  }]);
  return ResolveDispute;
}(React__default.Component);

var Disputed = function (_Component) {
  inherits(Disputed, _Component);

  function Disputed(props) {
    var _this2 = this;

    classCallCheck(this, Disputed);

    var _this = possibleConstructorReturn(this, (Disputed.__proto__ || Object.getPrototypeOf(Disputed)).call(this, props));

    _this.getDefaultOption = function () {
      var billList = _this.state.billList;

      var dataa = billList;

      var defaultIndex = dataa.findIndex(function (item) {
        return item.isDefault;
      });
      _this.setState({ defaultOption: defaultIndex !== -1 ? defaultIndex : "" });
    };

    _this.getCustomerNameList = function () {
      var billList = _this.state.billList;

      if (billList && billList.length > 0) {
        return billList.map(function (item, index) {
          return {
            text: item.customerName,
            value: item.customerName,
            key: item.customerName
          };
        });
      }
    };

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.0;
      }
      return value;
    };

    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context.next = 6;
              return _this.props.getDisputedData(currPage);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getDisputedData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.state = {
      errorMsg: "",
      successMsg: "",
      options: [],
      defaultOption: "",
      billList: [],
      page: 1
    };
    return _this;
  }

  createClass(Disputed, [{
    key: "componentDidMount",
    value: function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var disputed, key, value, getBillingOption, option;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.getDisputedData();

              case 2:
                disputed = this.props.disputed;
                key = "";
                value = "";
                getBillingOption = [];

                disputed.map(function (val) {
                  key = lodash_1(val, "key", "");
                  value = lodash_1(val, "value", "");
                  getBillingOption = lodash_1(value, "billingParties.billToList", []);
                });

                this.setState({ billList: getBillingOption });

                if (getBillingOption && getBillingOption.length > 0) {
                  option = this.getCustomerNameList();

                  this.setState({ options: option });
                  this.getDefaultOption();
                }

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _ref3.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          options = _state.options,
          defaultOption = _state.defaultOption;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("div", { style: { display: "flow-root" } }),
        this.props.successMsg && React__default.createElement(
          Message,
          { positive: true, size: "tiny", className: "info-message" },
          React__default.createElement(
            Message.Header,
            null,
            this.props.successMsg
          )
        ),
        this.props.errorMsg && React__default.createElement(
          Message,
          { negative: true, size: "tiny", className: "info-message" },
          React__default.createElement(
            Message.Header,
            null,
            this.props.errorMsg
          )
        ),
        React__default.createElement(CustomLoader, { showImage: true, loading: this.props.fetchDisputed }),
        !this.props.fetchDisputed && this.props.disputed.map(function (val, index) {
          if (!lodash_1(val, "edit", false)) {
            return React__default.createElement(
              Accordion,
              { fluid: true, key: index },
              React__default.createElement(
                "div",
                { style: { marginBottom: "15px", background: "white" } },
                React__default.createElement(
                  Accordion.Title,
                  {
                    style: { marginTop: "15px", padding: "1px 15px" },
                    active: _this3.props.activeCard === index,
                    index: 0,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  React__default.createElement(DisputedCardHeader, {
                    data: val,
                    activeCard: _this3.props.activeCard,
                    cardIndex: index,
                    expandCard: _this3.props.expandDisputedCard,
                    getFormatedDate: _this3.getFormatedDate,
                    selectedBillToParties: _this3.props.selectedBillToParties,
                    option: options,
                    defaultOption: defaultOption,
                    selectedDropdownData: _this3.props.selectedDropdownData,
                    getFormatedCurrency: _this3.props.getFormatedCurrency,
                    getDisputedData: _this3.props.getDisputedData
                  })
                ),
                React__default.createElement(
                  Accordion.Content,
                  {
                    active: _this3.props.activeCard === index,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  React__default.createElement(DisputedCardContentStatic, {
                    data: val,
                    index: index,
                    editDisputedCharge: _this3.props.editDisputedCharge,
                    formatAmount: _this3.formatAmount,
                    successMsg: _this3.props.successMsg,
                    errorMsg: _this3.props.errorMsg,
                    getFormatedCurrency: _this3.props.getFormatedCurrency,
                    nonEditableGlCodes: _this3.props.nonEditableGlCodes,
                    resolveDisputeRequest: _this3.props.resolveDisputeRequest,
                    disputeResolvedError: _this3.props.disputeResolvedError
                  })
                )
              )
            );
          } else {
            return React__default.createElement(
              Accordion,
              { fluid: true, key: index },
              React__default.createElement(
                "div",
                { style: { marginBottom: "15px", background: "white" } },
                React__default.createElement(
                  Accordion.Title,
                  {
                    style: { marginTop: "15px", padding: "1px 15px" },
                    active: _this3.props.activeCard === index,
                    index: index,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  "\xA0",
                  React__default.createElement(DisputedCardHeader, {
                    data: val,
                    activeCard: _this3.props.activeCard,
                    cardIndex: index,
                    expandCard: _this3.props.expandDisputedCard,
                    getFormatedDate: _this3.getFormatedDate,
                    selectedBillToParties: _this3.props.selectedBillToParties,
                    option: options,
                    defaultOption: defaultOption,
                    selectedDropdownData: _this3.props.selectedDropdownData,
                    getFormatedCurrency: _this3.props.getFormatedCurrency
                  })
                ),
                React__default.createElement(
                  Accordion.Content,
                  {
                    active: _this3.props.activeCard === index,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  React__default.createElement(DisputedCardEdit, {
                    data: val,
                    index: index,
                    updateDisputedLineItem: _this3.props.updateDisputedLineItem,
                    addDisputedNewCharge: _this3.props.addDisputedNewCharge,
                    deleteChargeLineItem: _this3.props.deleteChargeLineItem,
                    cancelDisputedEdit: _this3.props.cancelDisputedEdit,
                    saveDisputedData: _this3.props.saveDisputedData,
                    chargesOptions: _this3.props.chargesOptions,
                    disputeChargeOptions: _this3.props.disputeChargeOptions,
                    successMsg: _this3.props.successMsg,
                    errorMsg: _this3.props.errorMsg,
                    getFormatedCurrency: _this3.props.getFormatedCurrency,
                    nonEditableGlCodes: _this3.props.nonEditableGlCodes,
                    unitPriceValue: _this3.props.unitPriceValue,
                    selectedCharge: _this3.props.selectedCharge,
                    unitPriceVal: _this3.props.unitPriceVal,
                    uom: _this3.props.uom,
                    deleteChargeLineItemForDisputedTab: _this3.props.deleteChargeLineItemForDisputedTab
                  })
                )
              )
            );
          }
        }),
        lodash_1(this.props, "disputed", []).length > 0 && React__default.createElement(Pagination, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return Disputed;
}(Component);

// export const debounce(fn, delay) {
//     let timer;
//     return (() => {
//       clearTimeout(timer);
//       timer = setTimeout(() => fn(), delay);
//     })();
//   }

var DrayageInvoiceSearchbar = function (_React$Component) {
  inherits(DrayageInvoiceSearchbar, _React$Component);

  function DrayageInvoiceSearchbar(props) {
    classCallCheck(this, DrayageInvoiceSearchbar);

    var _this = possibleConstructorReturn(this, (DrayageInvoiceSearchbar.__proto__ || Object.getPrototypeOf(DrayageInvoiceSearchbar)).call(this, props));

    _this.componentDidMount = function () {
      if (_this.props.invoiceContainer !== '') {
        _this.setKeyword(_this.props.invoiceContainer);
        setTimeout(function () {
          return _this.props.callbackKeyword(_this.props.invoiceContainer);
        }, 5000);
      }
    };

    _this.setKeyword = function (value) {
      _this.setState({ keyWord: value });
      _this.props.sendKeywordFun(value);
    };

    _this.sendBackKeyword = function () {
      var keyWord = _this.state.keyWord;

      if (keyWord.length > 1 || keyWord === "") {
        _this.props.callbackKeyword(keyWord);
      }
    };

    _this.emptySearch = function () {
      _this.setKeyword("");
      _this.props.callbackKeyword("");
    };

    _this.state = {
      keyWord: ""
    };
    _this.sendBackKeyword = debounce(_this.sendBackKeyword, 500);
    return _this;
  }

  createClass(DrayageInvoiceSearchbar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var keyWord = this.state.keyWord; //this.props.sendKeyword

      return React__default.createElement(
        "div",
        { className: "drayage-invoice-searchbar" },
        React__default.createElement("i", { className: "search icon " }),
        React__default.createElement("input", {
          className: "search icon drayage-invoice-input",
          value: this.props.sendKeyword ? this.props.sendKeyword : keyWord,
          placeholder: "Search Invoices",
          onKeyUp: this.sendBackKeyword,
          onChange: function onChange(e) {
            return _this2.setKeyword(e.target.value, e.preventDefault());
          }
        })
      );
    }
  }]);
  return DrayageInvoiceSearchbar;
}(React__default.Component);

var css_248z$g = ".background-col.invoice-admin-bg {\n  background-color: #f5f5f5 !important; }\n\n.ua-container.invoice-admin-ua-container-bg {\n  padding-bottom: 40px;\n  background-color: none; }\n\n.isgeneraed-in {\n  position: fixed;\n  left: 22vw;\n  text-align: center;\n  top: 50vh;\n  z-index: 1; }\n  .isgeneraed-in .ui.message {\n    width: 50%; }\n\n.isgeneraed-in-msg {\n  left: 40vw !important;\n  width: 500px; }\n\n.billing-ui-repo-payment-history-table {\n  width: 300px !important; }\n  .billing-ui-repo-payment-history-table .customized-loader img {\n    width: 100% !important; }\n  .billing-ui-repo-payment-history-table thead tr {\n    display: table;\n    width: 100%;\n    table-layout: fixed; }\n    .billing-ui-repo-payment-history-table thead tr th {\n      font-family: \"Roboto\";\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px !important;\n      line-height: 16px !important;\n      color: #7a7a7a !important;\n      padding: 5px !important; }\n  .billing-ui-repo-payment-history-table tbody {\n    display: block;\n    height: 200px;\n    overflow: auto; }\n    .billing-ui-repo-payment-history-table tbody tr {\n      display: table;\n      width: 100%;\n      table-layout: fixed; }\n      .billing-ui-repo-payment-history-table tbody tr td {\n        font-family: \"Roboto\";\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px !important;\n        line-height: 16px !important;\n        color: #7a7a7a !important;\n        padding: 5px !important;\n        border: 1px solid rgba(34, 36, 38, 0.1) !important; }\n\n.admin-invoice {\n  width: 80vw;\n  margin: 0 auto;\n  position: relative; }\n  @media screen and (max-width: 1400px) {\n    .admin-invoice {\n      width: 96vw; } }\n  .admin-invoice .icon {\n    cursor: pointer; }\n  .admin-invoice .pending-wrap {\n    overflow: hidden;\n    padding-left: 6px;\n    margin-top: 10px; }\n    .admin-invoice .pending-wrap .pending-left {\n      float: left; }\n    .admin-invoice .pending-wrap .pending-right {\n      float: right; }\n  .admin-invoice div, .admin-invoice .detail-button-s, .admin-invoice label, .admin-invoice button, .admin-invoice h4, .admin-invoice h5, .admin-invoice span, .admin-invoice p, .admin-invoice a {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-weight: 200 !important;\n    color: rgba(0, 0, 0, 0.87) !important; }\n  .admin-invoice .admin-invoice-details {\n    position: relative; }\n  .admin-invoice .paid-select-label {\n    color: rgba(0, 0, 0, 0.87);\n    margin: 0 10px; }\n  .admin-invoice .admin-check-box {\n    position: absolute;\n    z-index: 1;\n    top: 20px;\n    left: 5px; }\n  .admin-invoice .inner-loader {\n    position: fixed;\n    left: 48vw;\n    top: 50vh;\n    font-weight: bold;\n    z-index: 1; }\n  .admin-invoice.invoice-right-sec {\n    width: 60vw;\n    float: left;\n    margin: 0; }\n  .admin-invoice .ui.dimmer .content {\n    background-color: transparent; }\n  .admin-invoice .print-sec {\n    min-width: 44px; }\n  .admin-invoice .headerSectionFour .cbpHeaderText {\n    text-align: center; }\n  .admin-invoice .filterChargeList {\n    display: flex; }\n  .admin-invoice .filterChargeList .ui.checkbox label {\n    font-size: 14px !important; }\n  .admin-invoice .chargeListFilter {\n    display: flex;\n    padding: 10px;\n    background: #fff;\n    margin-top: 10px; }\n  .admin-invoice .chargeListFilter .ui.segment {\n    background-color: #fff !important;\n    padding: 10px; }\n  .admin-invoice .chargeListFilter .ui.input > input {\n    padding: 5px;\n    margin-left: 10px;\n    border: 1px solid rgba(34, 36, 38, 0.15);\n    max-width: 137px; }\n  .admin-invoice .filterChargeList .ui.input {\n    font-size: 14px; }\n  .admin-invoice .ui.segment.import-country-list {\n    width: 40px;\n    border: 1px solid;\n    padding: 0 0 0 5px;\n    border: 1px solid #0A8B8F;\n    right: 0;\n    z-index: 1;\n    line-height: 1;\n    height: 45px;\n    margin-top: 7px;\n    border-radius: 4px; }\n    .admin-invoice .ui.segment.import-country-list .ui.dropdown .menu {\n      width: 100%;\n      top: 100%; }\n    .admin-invoice .ui.segment.import-country-list .item.dropdown.icon {\n      position: absolute;\n      left: 0px;\n      width: 100%;\n      padding-left: 10px;\n      z-index: 2;\n      top: 0px;\n      line-height: 3; }\n    .admin-invoice .ui.segment.import-country-list .angle.down.icon {\n      position: absolute;\n      right: 6px;\n      z-index: 1;\n      bottom: -3px; }\n    .admin-invoice .ui.segment.import-country-list .filter-label {\n      margin-bottom: 0; }\n    .admin-invoice .ui.segment.import-country-list .text {\n      font-size: 14px; }\n  .admin-invoice .display-dir {\n    display: flex;\n    display: flex;\n    align-items: center;\n    vertical-align: middle; }\n    .admin-invoice .display-dir .ui.form .field {\n      margin-bottom: 0; }\n    .admin-invoice .display-dir .invoice-charge-list-drop {\n      margin-right: 100px; }\n  .admin-invoice .country-item-list {\n    padding: 8px;\n    line-height: 1; }\n    .admin-invoice .country-item-list label {\n      margin-left: 15px; }\n  .admin-invoice .content {\n    background-color: #fff; }\n    .admin-invoice .content .invoice-container {\n      width: 100%; }\n  .admin-invoice .title {\n    background-color: #fff; }\n  .admin-invoice .ui.segment {\n    background-color: transparent;\n    box-shadow: none;\n    border: none;\n    border-radius: 0;\n    padding: 10px 0 0 0; }\n  .admin-invoice .admin-invoice-container {\n    display: flex;\n    padding-top: 10px; }\n    .admin-invoice .admin-invoice-container .admin-invoice-title {\n      color: #000000;\n      font-size: 20px;\n      min-width: 100px;\n      cursor: pointer; }\n    .admin-invoice .admin-invoice-container .admin-invoice-tab {\n      display: flex; }\n    .admin-invoice .admin-invoice-container .admin-invoice-tab-title {\n      padding: 10px;\n      background: #fff;\n      margin-right: 5px;\n      position: relative;\n      cursor: pointer; }\n      .admin-invoice .admin-invoice-container .admin-invoice-tab-title.active {\n        background: #0A8B8F;\n        color: #fff; }\n      .admin-invoice .admin-invoice-container .admin-invoice-tab-title .admin-invoice-count {\n        background: #52ABF6;\n        padding: 4px 6px;\n        border-radius: 100%;\n        color: #ffff;\n        font-size: 10px;\n        margin-left: 5px; }\n  .admin-invoice .generate-button {\n    background: #04ADB1;\n    color: #fff;\n    font-size: 18px;\n    font-weight: bold;\n    border: 1px solid #04ADB1;\n    min-width: 120px;\n    padding: 10px;\n    margin-top: 10px; }\n    .admin-invoice .generate-button:hover {\n      background: #04adb1c2;\n      color: #ffffffdb; }\n    .admin-invoice .generate-button .ui.button:active {\n      background: #fff; }\n  .admin-invoice .detail-button {\n    margin: 0; }\n  .admin-invoice .detail-button-s {\n    vertical-align: middle;\n    padding: 10px 1em 10px;\n    font-weight: 500;\n    color: #04ADB1;\n    background: #fff;\n    border: 1px solid #008B8F;\n    margin-top: 10px;\n    display: flex;\n    cursor: pointer; }\n    .admin-invoice .detail-button-s .ui.button:active {\n      background: #fff; }\n    .admin-invoice .detail-button-s:hover {\n      background: transparent;\n      color: #04adb1b5; }\n    .admin-invoice .detail-button-s.delete-button {\n      border: none; }\n    .admin-invoice .detail-button-s.isOpen {\n      background-color: #0A8B8F !important;\n      color: white !important;\n      font-weight: 800 !important; }\n  .admin-invoice .loadingggggg {\n    position: fixed;\n    background: rgba(225, 225, 225, 0.9);\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    opacity: 0.8;\n    text-align: center; }\n  .admin-invoice .invoice-row-container {\n    padding: 0 20px; }\n  .admin-invoice .invoice-hear {\n    overflow: hidden;\n    border-bottom: 3px solid #059090;\n    padding: 15px 0 5px;\n    color: #7f7f7f; }\n  .admin-invoice .invoice-left {\n    float: left;\n    width: 50%; }\n  .admin-invoice .invoice-right {\n    float: left;\n    width: 50%; }\n  .admin-invoice .dispute-reason {\n    background: yellow;\n    padding: 0 10px 5px;\n    max-width: 350px;\n    clear: both; }\n    .admin-invoice .dispute-reason p {\n      margin-bottom: 0; }\n    .admin-invoice .dispute-reason h4 {\n      margin-bottom: 0; }\n  .admin-invoice .head-cell {\n    float: left; }\n  .admin-invoice .head-cell-sl {\n    width: 10%;\n    padding-left: 3px;\n    float: left;\n    font-weight: 700;\n    font-size: 20px;\n    margin-top: 10px; }\n  .admin-invoice .head-cell-sl.head-sr {\n    font-size: 12px;\n    font-weight: 500;\n    margin-top: 0px; }\n  .admin-invoice .head-cell-date {\n    width: 25%;\n    float: left; }\n  .admin-invoice .head-cell-shipment {\n    width: 60%;\n    float: left; }\n  .admin-invoice .head-cell-activity {\n    width: 40%;\n    float: left; }\n    .admin-invoice .head-cell-activity.expand-row {\n      width: 38%; }\n    .admin-invoice .head-cell-activity.charge-list {\n      width: 26%; }\n  .admin-invoice .head-cell-unity {\n    width: 7%;\n    float: left;\n    text-align: right; }\n    .admin-invoice .head-cell-unity.charge-list {\n      min-height: 1px; }\n      .admin-invoice .head-cell-unity.charge-list.charge-list-all {\n        width: 12%;\n        min-height: 1px;\n        text-align: left;\n        word-break: break-all; }\n  .admin-invoice .head-cell-rate {\n    width: 20%;\n    float: left;\n    text-align: right; }\n    .admin-invoice .head-cell-rate.charge-list {\n      width: 7%;\n      margin-left: 10px; }\n  .admin-invoice .head-cell-rate.red {\n    color: red; }\n  .admin-invoice .head-cell-total {\n    width: 17%;\n    float: right;\n    text-align: right;\n    padding-right: 4px; }\n    .admin-invoice .head-cell-total.charge-list {\n      width: 13%;\n      float: left; }\n      .admin-invoice .head-cell-total.charge-list.customerInvoiceNumber {\n        width: 18%; }\n  .admin-invoice .invoice-data-row {\n    overflow: hidden;\n    border-bottom: 2px solid #d4d4d4;\n    padding: 10px 0;\n    font-weight: bold; }\n  .admin-invoice .invoice-data-row.last-row {\n    border-bottom: none; }\n  .admin-invoice .invoice-data {\n    overflow: scroll;\n    padding: 10px 0;\n    border-bottom: 1px solid #d4d4d4;\n    color: #000;\n    align-items: center; }\n    .admin-invoice .invoice-data.new-add {\n      overflow: initial; }\n    .admin-invoice .invoice-data input {\n      display: block;\n      width: 100%;\n      border: 1px solid #d4d4d4;\n      text-align: center;\n      text-align: center;\n      height: 40px;\n      margin-bottom: 10px; }\n    .admin-invoice .invoice-data.delete-selected {\n      background-color: #d1d1d1;\n      pointer-events: none; }\n      .admin-invoice .invoice-data.delete-selected input, .admin-invoice .invoice-data.delete-selected button {\n        background-color: #d1d1d1; }\n    .admin-invoice .invoice-data.add-list {\n      display: flex;\n      overflow: hidden; }\n      .admin-invoice .invoice-data.add-list input {\n        height: 35px;\n        margin-bottom: 0;\n        width: 100%; }\n      .admin-invoice .invoice-data.add-list button {\n        margin-top: 0; }\n  .admin-invoice .invoice-date {\n    color: #000;\n    font-size: 14px;\n    margin: 10px 5px 20px 0; }\n  .admin-invoice .invoice-item {\n    color: #615f5f;\n    font-weight: 300;\n    min-width: 110px; }\n  .admin-invoice .invoice-po {\n    color: #615f5f;\n    min-width: 110px; }\n  .admin-invoice .invoice-bill {\n    color: #615f5f;\n    min-width: 110px; }\n  .admin-invoice .invoice-subtotal {\n    overflow: hidden;\n    padding-top: 10px;\n    color: #059090;\n    font-weight: 700; }\n  .admin-invoice .subtotal-label {\n    float: left;\n    width: 80%; }\n  .admin-invoice .subtotal-amount {\n    float: right;\n    width: 20%;\n    text-align: right; }\n  .admin-invoice .invoice-discount {\n    color: #fa021b; }\n  .admin-invoice .head-cell-date {\n    margin-bottom: 10px; }\n  .admin-invoice .head-cell-shipment {\n    margin-bottom: 10px; }\n    .admin-invoice .head-cell-shipment .invoice-date {\n      cursor: pointer; }\n  .admin-invoice .invoice-item p, .admin-invoice .invoice-po, .admin-invoice .invoice-bill {\n    font-weight: 300;\n    margin-bottom: 10px; }\n  .admin-invoice .invoice-total {\n    padding: 7px 0 7px 0;\n    text-align: right;\n    font-size: 14px;\n    font-weight: bold;\n    overflow: hidden;\n    border-top: 3px solid #059090;\n    border-bottom: 3px solid #059090; }\n  .admin-invoice .entry-wrapper {\n    display: flex; }\n\n.cbpHeaderText {\n  word-wrap: break-word; }\n\n.invoice-right-modal {\n  width: 39vw;\n  padding: 20px 10px 10px;\n  border: 1px solid grey;\n  float: left;\n  position: fixed;\n  right: 0;\n  height: calc(100vh - 133px);\n  overflow: scroll;\n  top: 80px; }\n  .invoice-right-modal .invoice-image-cont {\n    overflow-y: scroll; }\n    .invoice-right-modal .invoice-image-cont img {\n      width: 100%;\n      display: block;\n      height: 100%; }\n  .invoice-right-modal .invoice-shipment-doc {\n    overflow: hidden; }\n    .invoice-right-modal .invoice-shipment-doc .invoice-doc-label {\n      border: 1px solid #008b8f;\n      float: left;\n      background-color: #f1f1f1;\n      cursor: pointer;\n      font-weight: 700;\n      margin: 5px;\n      border-radius: 2px;\n      color: #389cff;\n      min-width: 100px;\n      text-align: center;\n      padding: 8px 28px 8px 8px; }\n    .invoice-right-modal .invoice-shipment-doc .invoice-doc-label.active {\n      background: #ebfeff; }\n\n.admin-popup {\n  position: fixed;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  padding: 1em;\n  background-color: rgba(213, 213, 213, 0.5); }\n\n.admin-popup-containt {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  left: 50%;\n  top: 50%;\n  max-height: 88vh;\n  min-width: 30vh;\n  width: 50vw;\n  color: #000;\n  z-index: 999;\n  padding: 70px 150px 80px;\n  border: 1px solid rgba(146, 146, 146, 0.5);\n  border-radius: 5px;\n  background: #fff;\n  overflow: scroll;\n  box-shadow: 1px 3px 3px 0 rgba(0, 0, 0, 0.2), 1px 3px 15px 2px rgba(0, 0, 0, 0.2); }\n  .admin-popup-containt textarea {\n    width: 100%;\n    min-height: 100px;\n    padding: 10px;\n    border-radius: 0px;\n    margin: 0px;\n    border: 1px solid rgba(146, 146, 146, 0.5); }\n    .admin-popup-containt textarea::-webkit-input-placeholder {\n      font-style: normal; }\n    .admin-popup-containt textarea::-moz-placeholder {\n      font-style: normal; }\n  .admin-popup-containt .close-popup {\n    font-size: 29px;\n    color: #008B8F;\n    text-align: right;\n    position: absolute;\n    right: 0;\n    top: 0px;\n    height: 60px;\n    width: 60px;\n    cursor: pointer;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .admin-popup-containt .admin-popup-wrap {\n    color: #000;\n    border: 1px solid #979797;\n    padding: 14px;\n    margin-bottom: 16px;\n    border-radius: 3px; }\n  .admin-popup-containt .popup-title {\n    font-size: 20px; }\n  .admin-popup-containt .admin-popup-card {\n    display: flex;\n    margin-bottom: 16px; }\n  .admin-popup-containt .popup-button {\n    width: 100%;\n    margin-top: 50px;\n    background-color: #008B8F;\n    border: 1px solid #008B8F;\n    border-radius: 2px;\n    padding: 15px;\n    font-weight: bold;\n    color: #fff;\n    font-size: 16px;\n    cursor: pointer; }\n  .admin-popup-containt .left-sec, .admin-popup-containt .right-sec {\n    display: block;\n    width: 50%;\n    float: left;\n    text-align: left; }\n  .admin-popup-containt .left-sec img {\n    width: 100px; }\n  .admin-popup-containt .add-payment {\n    display: flex;\n    color: #1765AE;\n    margin-bottom: 30px; }\n    .admin-popup-containt .add-payment .change-payment, .admin-popup-containt .add-payment .add-new-payment {\n      width: 50%;\n      cursor: pointer; }\n    .admin-popup-containt .add-payment .change-payment {\n      text-align: left; }\n    .admin-popup-containt .add-payment .add-new-payment {\n      text-align: right; }\n\n.term-and-cond-wrap {\n  font-size: 16px;\n  margin-top: 10px; }\n\n.term-and-cond {\n  color: #1765AE;\n  cursor: pointer; }\n\n.pay-label {\n  color: #606060;\n  font-size: 14px;\n  /* margin-bottom: 10px; */ }\n\n.pay-disc {\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #000; }\n\n.admin-bill {\n  text-align: left; }\n\n.admin-radio {\n  width: 100px;\n  position: relative;\n  top: 25px;\n  left: 15px; }\n  .admin-radio label {\n    font-size: 0px !important;\n    padding-left: 1.85714em;\n    display: inline-block;\n    position: absolute;\n    left: 0;\n    z-index: 1; }\n    .admin-radio label:before {\n      content: '';\n      transform: none;\n      border-radius: 500rem;\n      top: 0px;\n      left: 0;\n      border: 2px solid #008B8F;\n      width: 24px;\n      height: 24px;\n      display: inline-block;\n      cursor: pointer; }\n    .admin-radio label:after {\n      content: '';\n      top: 0px;\n      left: 0;\n      width: 24px;\n      height: 24px;\n      border-radius: 500rem;\n      -webkit-transform: scale(0.46667);\n      transform: scale(0.46667);\n      background-color: #fff;\n      display: inline-block;\n      position: absolute; }\n  .admin-radio input[type=radio] {\n    position: absolute;\n    z-index: 2;\n    opacity: 0;\n    height: 25px;\n    width: 24px;\n    border: 1px solid #008B8F;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    outline: 0; }\n\n.admin-card-pay span {\n  width: calc(100% - 50px);\n  text-align: left;\n  display: inline-block;\n  vertical-align: top; }\n\ninput:checked ~ label:after {\n  background-color: #008B8F; }\n\n.react-datepicker-wrapper .today {\n  width: 150px; }\n\n.react-datepicker-wrapper .react-datepicker__input-container input {\n  width: 100%; }\n\n.popup-date-wrap {\n  display: flex; }\n\n.popup-status {\n  color: #000000;\n  font-size: 17px;\n  background: #FFF8B4;\n  padding: 10px; }\n\n.adress-title {\n  color: #169599;\n  font-size: 13px; }\n\n.pay-adress {\n  font-size: 16px;\n  color: #000;\n  font-weight: bold;\n  font-style: normal; }\n\n.popup-done-state img {\n  width: 100px; }\n\n.popup-done-state {\n  border: 1px solid #979797;\n  padding: 30px 0; }\n\n.auth-label, .popup-confirm {\n  font-size: 18px;\n  margin-top: 20px;\n  color: #606060; }\n\n.headerPrint {\n  border: 1px solid #008B8F;\n  padding-left: 10px;\n  height: 36px;\n  width: 40px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  margin-top: 7px;\n  border-radius: 5px;\n  cursor: pointer; }\n  .headerPrint .paymentPrint {\n    color: #008B8F; }\n\n.sub-total {\n  display: flex;\n  line-height: 3; }\n  .sub-total .sub-total-label, .sub-total .sub-total-price {\n    width: 50%; }\n  .sub-total .sub-total-price {\n    text-align: right; }\n\n.theme-color {\n  color: #169599; }\n\n.total-duties {\n  display: flex;\n  text-align: right;\n  line-height: 2;\n  font-weight: bold; }\n  .total-duties .total-duties-label {\n    width: 63%; }\n  .total-duties .total-duties-amt {\n    width: 37%; }\n  .total-duties .grand-total .total-duties-amt {\n    font-size: 18px; }\n\n.detail-button-s, .paid-button-s {\n  vertical-align: middle !important;\n  padding: 12px 1.5em 11px !important;\n  font-weight: 500 !important;\n  color: #04ADB1 !important;\n  background: #fff !important;\n  border: 1px solid #008B8F !important;\n  margin-top: 10px !important;\n  border-radius: 4px !important; }\n  .detail-button-s .ui.button:active, .paid-button-s .ui.button:active {\n    background: #fff; }\n  .detail-button-s:hover, .paid-button-s:hover {\n    background: transparent;\n    color: #04adb1b5; }\n  .detail-button-s.delete-button, .paid-button-s.delete-button {\n    border: none;\n    font-weight: 700; }\n\n.paid-button-s {\n  margin-top: 0 !important; }\n\n.detail-button-s {\n  display: flex;\n  margin-top: 10px; }\n  .detail-button-s.isOpen {\n    background-color: #0A8B8F; }\n\n.payoad {\n  margin-left: 800px; }\n\n.payload_content {\n  padding: 15px; }\n\n.payload_title_main {\n  padding-top: 2px;\n  margin-right: 20px;\n  margin-bottom: 10px; }\n\n.date_range_start {\n  display: flex; }\n\n.payload_title_startdate {\n  padding-top: 10px;\n  margin-right: 20px;\n  margin-bottom: 10px; }\n\n.date_range_start {\n  display: flex;\n  margin-top: 15px; }\n\n.payload_title_enddate {\n  padding-top: 10px;\n  margin-right: 35px;\n  margin-bottom: 10px; }\n\n.download_payload {\n  margin-left: 70%;\n  margin-right: 5px; }\n\n.chargeListFilter {\n  display: flex; }\n\n.oldinvoice {\n  padding: 10px;\n  font-weight: 500;\n  color: #04ADB1;\n  background: #fff;\n  border: 1px solid #008B8F;\n  margin-top: 22px;\n  cursor: pointer; }\n\n.confirm-modal .primary {\n  background-color: #0A8B8F !important; }\n\n.admin-invoice .total-duties.grand-total {\n  width: revert; }\n\n.pagination.customer-invoices {\n  margin: auto !important; }\n\n.payment-dropdown {\n  font-size: 11px !important;\n  border: 1px solid lightgrey !important;\n  padding: 8px !important;\n  border-radius: 4px !important;\n  color: grey !important;\n  height: 30px !important; }\n\n.invoice-payment .row label {\n  font-size: 11px !important; }\n\n.invoice-payment .row div {\n  font-size: 11px !important; }\n\n.invoice-payment .row .input {\n  display: flex;\n  font-size: 11px !important; }\n\n.invoice-payment .row .payment-teaxtarea-reason label {\n  font-size: 11px !important;\n  display: table-cell; }\n\n.invoice-payment .row .payment-teaxtarea-reason textarea {\n  font-size: 11px !important;\n  width: 100%; }\n\n.admin-invoice-tab-right {\n  flex-grow: 100; }\n  .admin-invoice-tab-right button {\n    float: right !important;\n    margin-top: 0 !important;\n    height: 41px; }\n\n.charge-list-check.all-iii label {\n  margin-bottom: 0px;\n  color: rgba(0, 0, 0, 0.87) !important; }\n\n.payment-history-modal {\n  top: 2% !important; }\n\n.tab-panes .tabular.menu {\n  flex-wrap: wrap; }\n\n.drayage-invoices-container {\n  background-color: #fff !important; }\n  .drayage-invoices-container .flex {\n    display: flex !important; }\n  .drayage-invoices-container .flex-1 {\n    flex: 1 !important; }\n  .drayage-invoices-container .flex-2 {\n    flex: 2 !important; }\n  .drayage-invoices-container .text-align-center {\n    text-align: center !important; }\n    @media only screen and (max-width: 768px) {\n      .drayage-invoices-container .text-align-center {\n        text-align: left !important; } }\n  .drayage-invoices-container .text-align-right {\n    text-align: right !important; }\n  .drayage-invoices-container .drayage-line-item-table {\n    margin: auto 20px !important; }\n    .drayage-invoices-container .drayage-line-item-table tr:last-child td.table-field-cell .table-action-btns {\n      border-top: 2px solid #babcbb !important; }\n  .drayage-invoices-container .ui.basic.table {\n    padding-bottom: 15px; }\n  .drayage-invoices-container .btn-over {\n    border: 1px solid #08adb6;\n    border-radius: .28571429rem;\n    cursor: pointer !important; }\n    .drayage-invoices-container .btn-over:hover {\n      background-color: #cacbcd;\n      background-image: none;\n      box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgba(34, 36, 38, 0.15) inset;\n      color: rgba(0, 0, 0, 0.8); }\n  .drayage-invoices-container .table-heading-cell {\n    color: #909490 !important;\n    font-size: 1em !important;\n    border-bottom: 2px solid #babcbb !important; }\n  .drayage-invoices-container .ui.table thead th {\n    color: rgba(0, 0, 0, 0.87);\n    padding: 5px; }\n  .drayage-invoices-container .ui.table td.table-field-cell {\n    border-top: none;\n    font-size: 12px !important;\n    vertical-align: middle; }\n    .drayage-invoices-container .ui.table td.table-field-cell .field .ui.dropdown, .drayage-invoices-container .ui.table td.table-field-cell .field .ui.input {\n      border: 1px solid #04a4aa;\n      border-radius: 0;\n      background-color: #eef2ff !important;\n      color: black !important; }\n      .drayage-invoices-container .ui.table td.table-field-cell .field .ui.dropdown input, .drayage-invoices-container .ui.table td.table-field-cell .field .ui.input input {\n        border: 0;\n        width: 75px;\n        padding: 9px 8px;\n        background-color: #eef2ff !important;\n        color: black !important; }\n  .drayage-invoices-container .table {\n    border-radius: 0px;\n    width: 98%; }\n    @media only screen and (max-width: 1000px) {\n      .drayage-invoices-container .table {\n        width: 98%; } }\n  .drayage-invoices-container .table-action-btns {\n    padding: 10px 0px 25px !important;\n    margin-bottom: 10px !important;\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important; }\n    .drayage-invoices-container .table-action-btns .save-invoice-btn {\n      background: #1565AE;\n      color: white; }\n      .drayage-invoices-container .table-action-btns .save-invoice-btn :hover {\n        background: #1565AE;\n        color: white; }\n    .drayage-invoices-container .table-action-btns .create-invoice-btn {\n      background: white;\n      border: 1px solid #0067B4;\n      color: #0067B4; }\n      .drayage-invoices-container .table-action-btns .create-invoice-btn :hover {\n        background: #1565AE !important;\n        color: white !important; }\n  .drayage-invoices-container .add-line-item-btn {\n    display: flex !important;\n    background: transparent !important;\n    color: #287374 !important;\n    padding: 0px; }\n    .drayage-invoices-container .add-line-item-btn img {\n      margin-right: 5px; }\n  .drayage-invoices-container .tab-pane {\n    background-color: #f9f9f9 !important;\n    border: 1px solid #d4d4d5 !important; }\n  .drayage-invoices-container .ui.attached.tabular.menu {\n    justify-content: center;\n    height: 41px !important;\n    padding: 12px; }\n  .drayage-invoices-container .ui.menu .item {\n    background: #fefefe !important;\n    border: 1px solid #D5D5D5;\n    border-radius: 0px !important;\n    font-size: 10px !important;\n    width: 150px;\n    height: 30px;\n    border-right: hidden;\n    color: #000 !important;\n    z-index: 1;\n    padding: 0.92857143em 1.14285714em !important;\n    text-transform: uppercase; }\n    .drayage-invoices-container .ui.menu .item .label-green {\n      background-color: #78d038 !important; }\n    .drayage-invoices-container .ui.menu .item .label-red {\n      background-color: #ed6659 !important; }\n  .drayage-invoices-container .ui.menu {\n    min-height: 1.857143em !important; }\n  .drayage-invoices-container .ui.menu .active.item {\n    border-color: transparent !important;\n    color: #FFFFFF !important;\n    background: #008B8F !important;\n    z-index: 1;\n    margin: 0 !important; }\n  .drayage-invoices-container .menu {\n    border: 0px !important;\n    box-shadow: none !important; }\n  .drayage-invoices-container .ui.menu .item:after {\n    position: absolute;\n    content: '';\n    top: -2px;\n    z-index: 1 !important;\n    border-color: #281F11 !important;\n    color: #FFFFFF !important;\n    background: #FFFFFF !important;\n    -webkit-transform: skew(27deg, -1deg);\n    transform: skew(14deg, -1deg);\n    width: 15px !important;\n    right: -11px;\n    height: 29px !important;\n    box-shadow: -1px 0px 0px #d5d5d5; }\n  .drayage-invoices-container .ui.menu .item > .label {\n    font-size: 10px;\n    background-color: #59aef5; }\n  .drayage-invoices-container .ui.tabular.menu .active.item {\n    border-radius: 0px !important; }\n  .drayage-invoices-container .btn {\n    vertical-align: middle;\n    padding: 10px 1em 10px;\n    font-weight: 500;\n    color: #08adb6;\n    background: #fff;\n    border: 1px solid #08adb6;\n    display: flex;\n    cursor: pointer; }\n  .drayage-invoices-container .btn-cal {\n    vertical-align: middle;\n    padding: 6px 1em 6px;\n    font-weight: 500;\n    color: #08adb6;\n    background: #fff;\n    border: 1px solid #08adb6;\n    display: flex;\n    cursor: pointer; }\n  .drayage-invoices-container .ui.mini.statistics {\n    justify-content: space-between;\n    margin: 1em 0; }\n    .drayage-invoices-container .ui.mini.statistics .statistic-country {\n      margin-top: 0; }\n    .drayage-invoices-container .ui.mini.statistics .ui.statistic {\n      align-items: flex-start; }\n      .drayage-invoices-container .ui.mini.statistics .ui.statistic .label.statistic-label {\n        color: #909490 !important;\n        font-size: 0.7em !important; }\n      .drayage-invoices-container .ui.mini.statistics .ui.statistic .value.statistic-value {\n        color: #222223 !important;\n        font-size: 1em !important;\n        z-index: auto;\n        white-space: pre-wrap !important;\n        word-break: break-word !important;\n        text-align: left !important;\n        line-height: 21px !important; }\n      .drayage-invoices-container .ui.mini.statistics .ui.statistic .value.statistic-value.currency {\n        color: #222223 !important;\n        font-size: 1.1em !important;\n        font-weight: 700; }\n      .drayage-invoices-container .ui.mini.statistics .ui.statistic .value.statistic-value.reference-no {\n        color: #3C76BD !important;\n        font-weight: 700; }\n    .drayage-invoices-container .ui.mini.statistics:after {\n      content: none; }\n  .drayage-invoices-container .checkbox {\n    color: #287374 !important; }\n  .drayage-invoices-container .ui.checkbox input:checked ~ label:after {\n    color: #287374 !important;\n    background-color: white !important;\n    outline: 1px solid #356968 !important; }\n  .drayage-invoices-container .card-opened {\n    background-color: #F6FFFA !important; }\n  .drayage-invoices-container .value {\n    background: transparent !important; }\n  .drayage-invoices-container .expand-btn {\n    background-color: #04a4aa !important;\n    color: white; }\n  .drayage-invoices-container .drayage-title {\n    position: absolute;\n    left: 0;\n    top: 12px;\n    font-weight: 600;\n    font-size: 20px;\n    margin-left: 20px; }\n  .drayage-invoices-container .drayage-country-date {\n    position: absolute;\n    right: 20px;\n    top: 0;\n    display: flex;\n    z-index: 9; }\n  .drayage-invoices-container .ui.fluid.container {\n    position: relative; }\n  .drayage-invoices-container .drayage-country-date .import-country-list {\n    float: left;\n    margin-right: 10px;\n    padding: 5px 5px 6px;\n    border: 1px solid #08adb6;\n    right: 0;\n    z-index: 1;\n    line-height: 1;\n    border-radius: 4px;\n    min-width: 130px;\n    position: relative; }\n  .drayage-invoices-container .drayage-country-date .import-country-list i.dropdown.icon {\n    display: none; }\n  .drayage-invoices-container .drayage-country-date .import-country-list i.angle {\n    position: absolute;\n    right: 1px;\n    background-color: #08adb6;\n    border-radius: 2px;\n    width: 15px;\n    height: 15px;\n    color: #fff;\n    line-height: 17px; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .ui.dropdown {\n    width: 100%;\n    position: static; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .ui.dropdown .text {\n    position: relative;\n    z-index: 1; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .menu {\n    background: #fff;\n    font-size: 1em;\n    text-shadow: none;\n    text-align: left;\n    min-width: max-content;\n    margin: 0;\n    width: 100%;\n    position: absolute;\n    top: 26px;\n    border: 1px solid #08adb6 !important; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .menu .country-item-list {\n    display: flex;\n    align-items: center;\n    padding: 5px 8px;\n    line-height: 1;\n    white-space: nowrap; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .menu .country-item-list label {\n    margin-bottom: 0;\n    margin-left: 15px;\n    color: rgba(0, 0, 0, 0.87) !important;\n    font-weight: 400 !important;\n    font-family: 'Lato','Helvetica Neue',Arial,Helvetica,sans-serif; }\n  .drayage-invoices-container .drayage-partner-search-box-and-filter-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 30px; }\n  .drayage-invoices-container .drayage-invoice-searchbar {\n    width: 350px;\n    display: flex;\n    border: 1px solid #08adb6;\n    padding: 6px 6px 6px 12px;\n    border-radius: 4px;\n    justify-content: space-between; }\n  .drayage-invoices-container .drayage-invoice-input {\n    border: none;\n    width: 78%; }\n  .drayage-invoices-container .drayage-invoice-searchbar i.angle.down.icon {\n    color: #08adb6; }\n  .drayage-invoices-container .drayage-invoice-searchbar i.search.icon {\n    color: #c2c2c2; }\n  .drayage-invoices-container .drayage-invoice-searchbar input:focus {\n    box-shadow: none;\n    outline: none; }\n  .drayage-invoices-container .drayage-invoice-searchbar .company-slider-arrow-icon {\n    font-size: 1em !important;\n    position: sticky;\n    top: 10vh;\n    bottom: 30vh;\n    color: #008B8F !important; }\n  .drayage-invoices-container .drayage-country-date .ui.icon.input {\n    height: 29px;\n    width: 130px; }\n  .drayage-invoices-container .ui.input > input {\n    border: 1px solid #008B8F; }\n  .drayage-invoices-container i.calendar.outline.icon {\n    color: #008B8F; }\n  .drayage-invoices-container .clndr-calendars-segment.clndr-floating {\n    right: 0;\n    left: auto; }\n  .drayage-invoices-container .ui.icon input::placeholder {\n    color: #008B8F; }\n  .drayage-invoices-container .total-value {\n    font-size: 15px;\n    font-weight: 900; }\n  .drayage-invoices-container .ui.selection.dropdown > .chevron.down.icon {\n    background: white;\n    color: #04a4aa;\n    top: 12px;\n    cursor: pointer;\n    position: absolute;\n    width: auto;\n    height: auto;\n    line-height: 1.21428571em;\n    right: 1em;\n    z-index: 3;\n    margin: -0.78571429em;\n    padding: 2px 13px;\n    opacity: .8;\n    transition: opacity .1s ease; }\n  .drayage-invoices-container .ui.selection.visible.dropdown > .text:not(.default) {\n    color: black !important; }\n  .drayage-invoices-container .visible.menu.transition {\n    border: 1px solid #96c8da !important; }\n  .drayage-invoices-container .ui.selection.dropdown {\n    cursor: pointer;\n    word-wrap: break-word;\n    line-height: 13px;\n    white-space: normal;\n    outline: 0;\n    -webkit-transform: rotateZ(0);\n    transform: rotateZ(0);\n    min-width: 14em;\n    min-height: 11px;\n    background: #fff;\n    display: inline-block;\n    padding: 6px 10px;\n    color: rgba(0, 0, 0, 0.87);\n    box-shadow: none;\n    border: 1pxsolidrgba 34, 36, 38, 0.15;\n    border-radius: 0.28571429rem;\n    transition: box-shadow .1s ease,width .1s ease; }\n  .drayage-invoices-container .ui.input > input {\n    margin: 0;\n    max-width: 100%;\n    flex: 1 0 auto;\n    outline: 0;\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n    text-align: left;\n    line-height: 0.214286em;\n    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;\n    padding: 0.67857143em 1em;\n    background: #fff;\n    border: 1pxsolidrgba 34, 36, 38, 0.15;\n    color: rgba(0, 0, 0, 0.87);\n    border-radius: 0.28571429rem;\n    transition: box-shadow .1s ease,border-color .1s ease;\n    box-shadow: none;\n    height: 25px; }\n  .drayage-invoices-container .custom-field {\n    margin-bottom: 0px; }\n  .drayage-invoices-container .green-tick {\n    color: #3EC70B; }\n  .drayage-invoices-container .red-tick {\n    color: #FF4848; }\n  .drayage-invoices-container .card-toggle-icon {\n    color: #286084;\n    cursor: pointer; }\n  .drayage-invoices-container .account-ref-no {\n    height: 37px;\n    width: 239px;\n    border: 1px solid #8bb2d6;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-left: 20px;\n    margin-bottom: 7px; }\n    .drayage-invoices-container .account-ref-no label {\n      height: 12px;\n      width: 214px;\n      color: #9D9D9D !important;\n      font-family: \"Helvetica Neue\";\n      font-size: 9px !important;\n      font-weight: 500 !important;\n      letter-spacing: 0;\n      line-height: 12px; }\n    .drayage-invoices-container .account-ref-no input {\n      height: 14px !important;\n      width: 214px;\n      background-color: #F0F4FF !important;\n      border: none !important;\n      font-size: 10px !important;\n      border-radius: initial !important; }\n  .drayage-invoices-container .icon-btns i {\n    margin: auto !important;\n    font-size: 14px !important;\n    line-height: 14x !important; }\n  .drayage-invoices-container .table-field-cell .input {\n    width: 100% !important; }\n  .drayage-invoices-container .drayage-line-item-table tr:last-child td {\n    border-bottom: 2px solid #babcbb; }\n  .drayage-invoices-container .drayage-line-item-table.non-edit tr:last-child td {\n    border-bottom: none; }\n  .drayage-invoices-container .expand-icon {\n    color: #008B8F; }\n  .drayage-invoices-container .info-message {\n    width: 50%;\n    margin: 0px auto; }\n  .drayage-invoices-container .comment-expend:focus {\n    height: 100px; }\n  .drayage-invoices-container .ui.button {\n    font-size: 1rem !important; }\n  .drayage-invoices-container .ui.input {\n    height: unset !important;\n    padding-left: unset !important; }\n  .drayage-invoices-container .table-heading-cell {\n    font-size: 12px !important; }\n  .drayage-invoices-container .table-action-btns.approve-disapprove-btn {\n    padding: unset !important;\n    margin-bottom: unset !important; }\n  .drayage-invoices-container .ui.image {\n    margin-top: unset; }\n  .drayage-invoices-container .pendingList-table .ui.statistic {\n    width: 114px;\n    white-space: nowrap;\n    text-align: left;\n    /*overflow: hidden;*/ }\n  .drayage-invoices-container .pendingList-table .ui.statistic.statistic-country {\n    width: auto; }\n  .drayage-invoices-container .create-invoice-btns {\n    background: white;\n    border: 1px solid #0067B4;\n    color: #0067B4; }\n  .drayage-invoices-container .acc-reference-no input {\n    width: 90px;\n    background-color: #eef2ff !important; }\n  .drayage-invoices-container .ui.mini.statistics.chargeList-table .ui.statistic {\n    width: 150px; }\n  .drayage-invoices-container .ui.accordion .title {\n    cursor: default !important; }\n\n.content-static-card.ui.table td.one.wide, .content-static-card.ui.table th.one.wide {\n  width: auto;\n  vertical-align: middle; }\n\n.drayage-line-item-table.edit-card-list tr td {\n  border-bottom: none;\n  padding: 2px 0px; }\n\n.edit-card-list .custom-field .ui.selection.dropdown {\n  width: 300px; }\n\n.uploadDocument {\n  display: grid;\n  grid-template-columns: 1.2fr 3fr;\n  column-gap: 50px;\n  row-gap: 1em; }\n\n.upload-document .documentList {\n  margin-top: 45px; }\n\n.showDocument {\n  height: 450px;\n  min-width: 340px;\n  width: auto !important; }\n\n.ui.fullscreen.modal.upload-document {\n  top: 10% !important;\n  left: unset !important; }\n\n.ui.fullscreen.modal.upload-document .ModalActionButtons {\n  text-align: left !important; }\n\n.upload-document .upload-doc-img {\n  position: absolute;\n  top: -40px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  background: #fff;\n  border-radius: 50% !important;\n  width: 80px;\n  height: 80px;\n  padding: 7px;\n  object-fit: cover;\n  overflow: hidden;\n  display: flex; }\n\n.upload-document i.close.icon {\n  color: #008B8F;\n  top: 0;\n  padding-right: 58px; }\n\n.upload-document i.red.close.icon.removeIcon {\n  float: right;\n  padding-right: unset; }\n\n.upload-document.ui.modal > .content {\n  margin-top: 0px;\n  padding: 3.5rem; }\n\n.upload-document .uploadDocument .non-edit tr td {\n  border-top: none;\n  padding: 5px !important; }\n\n.upload-document .uploadDocument .non-edit tr th {\n  padding: 5px !important; }\n\n.upload-document .uploadDocument .non-edit tr:hover td {\n  background-color: rgba(0, 139, 143, 0.2);\n  color: #008B8F; }\n\n.upload-document .uploadDocument .non-edit tr td:first-child, .upload-document .uploadDocument .non-edit tr td:last-child {\n  color: #008B8F; }\n\n.upload-document .uploadDocument .non-edit, .upload-document .uploadDocument .non-edit tr th {\n  border-bottom: 1px solid rgba(34, 36, 38, 0.1); }\n\n.text-green {\n  color: #008B8F; }\n\n.ui.dimmer .upload-document .content {\n  width: 100%; }\n\n.ui.dimmer .upload-document .ui.button {\n  background-color: #008B8F;\n  color: #fff;\n  font-size: 1rem !important; }\n\n.addiDocumButton {\n  color: #008B8F;\n  display: flex;\n  align-items: center;\n  gap: 5px; }\n\n.addiDocumButton i {\n  border: 1px solid #008B8F;\n  border-radius: 3px;\n  padding: 3px;\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n  font-size: 10px;\n  align-items: center;\n  justify-content: center; }\n\n.upload-document .uploadDocument .non-edit .ui.checkbox input:checked ~ label:after {\n  color: #008B8F;\n  background-color: white;\n  border: #008B8F 1px solid;\n  border-radius: 3px; }\n\n.upload-document .uploadDocument .non-edit tr td .field {\n  cursor: pointer; }\n\n.drayage-accounting-modal .table-action-btns {\n  padding-top: 20px; }\n\n.drayage-accounting-modal input {\n  background-color: #eef2ff !important;\n  border: 1px solid #008B8F !important;\n  height: 25px;\n  width: 225px; }\n\n.drayage-accounting-modal input::-webkit-input-placeholder {\n  font-size: 10px;\n  line-height: 4; }\n\n.ui.modal.drayage-accounting-mdl > .header:not(.ui) {\n  font-size: 15px; }\n\n.ui.page.modals.active {\n  background-color: rgba(0, 0, 0, 0.5) !important; }\n\n.ui.modal.transition.visible.active.chargeList-mdl.drayage-accounting-mdl {\n  width: 30%; }\n\n.drayage-accounting-modal .table-action-btns .ui .button {\n  font-size: auto; }\n\n#myBar {\n  position: absolute;\n  border-radius: 1.8rem;\n  width: 1%;\n  height: 100%;\n  background-color: #321e8d; }\n\n.isgeneraed-in.showErrorDocument {\n  position: fixed;\n  left: 33vw !important;\n  text-align: center;\n  top: 50vh;\n  z-index: 1; }\n  .isgeneraed-in.showErrorDocument .ui.message {\n    width: unset !important; }\n\n.ui.dimmer .preDocument .content, .preDocument .ui.large.image {\n  width: 100%; }\n\n.preDocument i {\n  font-size: 24px;\n  color: #008B8F;\n  cursor: pointer;\n  float: right; }\n\n#myProgress {\n  position: relative;\n  display: block;\n  line-height: 1;\n  width: 100%;\n  height: 6px;\n  background-color: #DAD6D2;\n  border-radius: 1.8rem; }\n\n.progressBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 5px; }\n\n.upload-document .progressBar i.close.icon {\n  padding-right: 0;\n  height: auto;\n  font-size: 12px;\n  line-height: 12px;\n  color: #008B8F; }\n\n.upload-percentage {\n  font-size: 10px;\n  color: #DAD6D2;\n  line-height: 12px; }\n\n.uploadDocument .showDocument {\n  display: flex;\n  align-items: flex-start;\n  gap: 5px;\n  justify-content: center; }\n\n.uploadDocument .showDocument i {\n  font-size: 24px;\n  color: #008B8F;\n  cursor: pointer; }\n\n.custom-loader {\n  display: flex-root !important;\n  min-height: 100px; }\n  .custom-loader .ui.dimmer {\n    position: absolute !important;\n    padding: 0 !important; }\n  .custom-loader .ui.dimmer.active {\n    background-color: #fff; }\n  .custom-loader .ui.loader {\n    color: black !important; }\n  .custom-loader .ui.loader:after {\n    border-color: #008b8f transparent transparent !important; }\n\n@media screen and (max-width: 1300px) {\n  .ui.attached.tabular.menu {\n    width: 94%; } }\n\n@media screen and (max-width: 1268px) {\n  .drayage-invoices-container .drayage-title {\n    position: static;\n    text-align: center;\n    margin-bottom: 10px; }\n  .drayage-invoices-container .drayage-country-date {\n    position: static;\n    right: 0;\n    top: 0;\n    margin: 0 auto;\n    width: 242px; }\n  .ui.attached.tabular.menu {\n    width: 94%; }\n  .edit-card-list .custom-field .ui.selection.dropdown {\n    width: unset; } }\n\n.delete-charge-confirm .ui.primary.button {\n  background: #1565AE !important;\n  color: white !important; }\n\n.delete-charge-confirm .content {\n  font-size: 1.7em !important;\n  width: 100% !important; }\n\n.dray-partner-charge-list-open-released-btn {\n  text-align: center !important; }\n  .dray-partner-charge-list-open-released-btn .ui.buttons {\n    margin: 15px; }\n    .dray-partner-charge-list-open-released-btn .ui.buttons .ui.positive.button {\n      background-color: #008B8F !important; }\n\n.dray-partner-create-invoice-msg {\n  text-align: end !important;\n  background-color: #f6fffa !important;\n  display: list-item !important; }\n\n.drayage-invoices-container.drayage-partner .ui.statistic + .ui.statistic {\n  margin: 0 0 0 0.5em !important; }\n\n.drayage-invoices-container.drayage-partner .dray-partner-charge-list-open-released-btn .ui.button, .drayage-invoices-container.drayage-partner .dray-partner-charge-list-open-released-btn .ui.buttons .button, .drayage-invoices-container.drayage-partner .dray-partner-charge-list-open-released-btn .ui.buttons .or {\n  font-size: 0.9rem !important; }\n\n.preview-file-links {\n  cursor: pointer;\n  color: navy;\n  margin-top: 10px; }\n\n.invoice-number-container {\n  position: relative;\n  display: inline-block; }\n\n.invoice-number-container:hover .statistic-value-tooltip {\n  visibility: visible;\n  opacity: 1; }\n\n.statistic-value-tooltip {\n  visibility: hidden;\n  background-color: #1565AE;\n  color: #fff;\n  text-align: center;\n  border-radius: 5px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 100%;\n  /* Position above the statistic value */\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s; }\n\n.download-paid-excel-report .error-notification {\n  display: flex;\n  position: absolute;\n  right: 25px;\n  background: #fdcaca;\n  padding: 10px;\n  color: #772323;\n  border-radius: 10px;\n  max-width: 200px;\n  flex-wrap: wrap;\n  word-break: break-word;\n  min-width: 200px;\n  font-weight: 600; }\n\n.download-paid-excel-report .field {\n  font-size: 14px; }\n  .download-paid-excel-report .field label {\n    position: relative !important;\n    font-size: 14px;\n    padding: 0; }\n  .download-paid-excel-report .field .ui.fluid.input input {\n    height: 35px;\n    max-width: 170px; }\n";
styleInject(css_248z$g);

function Date$6(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var PartiallyPaidListCardHeader = function (_Component) {
  inherits(PartiallyPaidListCardHeader, _Component);

  function PartiallyPaidListCardHeader(props) {
    classCallCheck(this, PartiallyPaidListCardHeader);

    var _this = possibleConstructorReturn(this, (PartiallyPaidListCardHeader.__proto__ || Object.getPrototypeOf(PartiallyPaidListCardHeader)).call(this, props));

    _this.state = {
      activeIndex: 1,
      showOtherTab: true
    };
    return _this;
  }

  createClass(PartiallyPaidListCardHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, "val.countryCode", ""));
      var countryCode = lodash_1(this.props, "val.countryCode", "");
      var invoiceUrl = lodash_1(this.props, "val.invoiceUrl", "") ? lodash_1(this.props, "val.invoiceUrl", "") : "";
      var countryForCurrencyCode = this.props.val && this.props.val.chargeDesc[0] ? lodash_1(this.props, "val.chargeDesc[0].countryForCurrency", "") : countryCode;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          {
            size: "mini",
            className: "pendingList-table flex",
            style: { marginBottom: "5px" }
          },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "10px"
              },
              className: "flex-2"
            },
            React__default.createElement(
              "div",
              { style: { minWidth: "21px" } },
              invoiceUrl === "" && cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this2.props.expandCard(_this2.props.cardIndex);
                },
                name: "plus circle",
                className: "card-toggle-icon"
              }),
              invoiceUrl === "" && cardIndex === this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this2.props.expandCard(_this2.props.cardIndex);
                },
                name: "minus circle",
                className: "card-toggle-icon"
              })
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country invoice-number-container flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, 'val.drayageInvoiceNumber', '')
              ),
              invoiceUrl !== "" && React__default.createElement(
                "div",
                { className: "statistic-value-tooltip" },
                "SYNCED FROM INTACCT"
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country flex-1" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              countryData.countryName
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "SHIPMENT ID#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this, "props.val.shipmentId", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$6, { date: lodash_1(this.props, "val.createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "ACC REF NO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.referenceNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "PAID AMOUNT"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value reference-no" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.paidAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.totalAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "10px",
                minWidth: "115px"
              },
              className: "flex-2"
            },
            invoiceUrl === "" && React__default.createElement(UploadDocument, {
              containerId: lodash_1(this.props, "val.containerId", ""),
              containerNumber: lodash_1(this.props, "val.containerNumber", ""),
              chargeDesc: lodash_1(this.props, "val.chargeDesc.chargeDesc", []),
              showOtherTab: this.state.showOtherTab
            }),
            invoiceUrl === "" && React__default.createElement(
              "span",
              {
                className: "btn-over",
                onClick: function onClick() {
                  var context = _this2.context;
                  context.setModalSize("fullscreen");
                  context.setShowModal(true);
                  context.setModalHeaderText("CHANGE LOG FOR " + lodash_1(_this2.props, "val.containerNumber", ""));
                  context.setDescriptionText(React__default.createElement(DrayageInvoiceChangeLog, { data: lodash_1(_this2.props, "val", {}) }));
                  context.setDescriptionHeaderText("");
                  // context.setCloseButtonText("Cancels");
                  // context.setActionButtonText("Raise Dispute");
                }
              },
              React__default.createElement(Icon, {
                style: {
                  padding: "10px 4px",
                  color: "#08adb6",
                  fontSize: "1.4em"
                },
                name: "history"
              })
            )
          )
        )
      );
    }
  }]);
  return PartiallyPaidListCardHeader;
}(Component);

PartiallyPaidListCardHeader.contextType = ModelContext;

var PartiallyPaidListCardContentStatic = function (_Component) {
  inherits(PartiallyPaidListCardContentStatic, _Component);

  function PartiallyPaidListCardContentStatic(props) {
    classCallCheck(this, PartiallyPaidListCardContentStatic);
    return possibleConstructorReturn(this, (PartiallyPaidListCardContentStatic.__proto__ || Object.getPrototypeOf(PartiallyPaidListCardContentStatic)).call(this, props));
  }

  createClass(PartiallyPaidListCardContentStatic, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table content-static-card"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        disabled: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return PartiallyPaidListCardContentStatic;
}(Component);

var PartiallyPaidList = function (_Component) {
  inherits(PartiallyPaidList, _Component);

  function PartiallyPaidList(props) {
    var _this2 = this;

    classCallCheck(this, PartiallyPaidList);

    var _this = possibleConstructorReturn(this, (PartiallyPaidList.__proto__ || Object.getPrototypeOf(PartiallyPaidList)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.00;
      }
      return value;
    };

    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.state = { page: 1 };
    return _this;
  }
  // setStateObj(state) {
  //   this.setState({ ...state });
  // }
  // expandCard(id) {
  //   this.state.activeCard === id
  //     ? this.setStateObj({
  //         activeCard: null,
  //       })
  //     : this.setStateObj({
  //         activeCard: id,
  //       });
  // }

  createClass(PartiallyPaidList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(CustomLoader, { showImage: true, loading: this.props.fetchPartiallyPaidTabInvoices }),
        !this.props.fetchPartiallyPaidTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              { style: { marginBottom: "15px", background: "white" }, key: "partially-paid-card-" + index },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this3.props.activeCard === index,
                  index: 0,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PartiallyPaidListCardHeader, {
                  activeCard: _this3.props.activeCard,
                  cardIndex: index,
                  expandCard: _this3.props.expandCard,
                  val: val,
                  getFormatedDate: _this3.props.getFormatedDate,
                  getCountryNameAndImage: _this3.props.getCountryNameAndImage,
                  getFormatedCurrency: _this3.props.getFormatedCurrency,
                  setSelectedInvoice: _this3.props.setSelectedInvoice
                })
              ),
              React__default.createElement(
                Accordion.Content,
                {
                  active: _this3.props.activeCard === index,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PartiallyPaidListCardContentStatic, {
                  data: val,
                  index: index,
                  formatAmount: _this3.formatAmount,
                  getFormatedCurrency: _this3.props.getFormatedCurrency
                })
              )
            );
          })
        ),
        lodash_1(this.props, 'invoices', []).length > 0 && React__default.createElement(Pagination, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return PartiallyPaidList;
}(Component);

var formatDateToYYYYMMDD = function formatDateToYYYYMMDD(date) {
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  var day = String(date.getDate()).padStart(2, "0");

  return year + "-" + month + "-" + day;
};

var DownloadExcelReport = function (_Component) {
  inherits(DownloadExcelReport, _Component);

  function DownloadExcelReport(props) {
    var _this2 = this;

    classCallCheck(this, DownloadExcelReport);

    var _this = possibleConstructorReturn(this, (DownloadExcelReport.__proto__ || Object.getPrototypeOf(DownloadExcelReport)).call(this, props));

    _this.handleStartDateChange = function (value) {
      var dates = _this.state.dates;

      if (dates.endDate && value > dates.endDate) {
        _this.setState(function (prevState) {
          return {
            errors: _extends({}, prevState.errors, {
              startDate: "End Date cannot be less than Start Date."
            })
          };
        });
        return;
      }
      _this.setState(function (prevState) {
        return {
          errors: _extends({}, prevState.errors, {
            startDate: ""
          }),
          dates: _extends({}, prevState.dates, {
            startDate: value
          })
        };
      });
    };

    _this.handleEndDateChange = function (value) {
      var dates = _this.state.dates;

      if (dates.startDate && value < dates.startDate) {
        _this.setState(function (prevState) {
          return {
            errors: _extends({}, prevState.errors, {
              endDate: "End Date cannot be less than Start Date."
            })
          };
        });
        return;
      }
      _this.setState(function (prevState) {
        return {
          errors: _extends({}, prevState.errors, {
            endDate: ""
          }),
          dates: _extends({}, prevState.dates, {
            endDate: value
          })
        };
      });
    };

    _this.setError = function (msg) {
      _this.setState({ errorMsg: msg || "" });
      setTimeout(function () {
        _this.setState({ errorMsg: "" });
      }, 3000);
    };

    _this.handleSubmit = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var dates, errors, startDate, endDate, res, url, code, message;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dates = _this.state.dates;
              errors = {};

              if (!dates.startDate) {
                errors = _extends({}, errors, {
                  startDate: "Please select start date."
                });
              }
              if (!dates.endDate) {
                errors = _extends({}, errors, {
                  endDate: "Please select end date."
                });
              }
              if (dates.endDate && dates.endDate < dates.startDate) {
                errors = _extends({}, errors, {
                  endDate: "End date cannot be less than start date."
                });
              }

              if (!Object.keys(errors).length) {
                _context.next = 9;
                break;
              }

              _this.setState({ errors: errors });
              _context.next = 28;
              break;

            case 9:
              _this.setState({ errors: {} });
              startDate = formatDateToYYYYMMDD(dates.startDate || "");
              endDate = formatDateToYYYYMMDD(dates.endDate || "");
              _context.prev = 12;

              _this.setState({ isDownloading: true });
              _context.next = 16;
              return downloadPaidExcelReport({
                startDate: startDate,
                endDate: endDate,
                partnerId: _this.props.partnerId
              });

            case 16:
              res = _context.sent;
              url = res.data.eventMessage.value || false;
              code = res.data.eventMessage.code || 0;

              if (url) {
                window.open(url);
              } else if (code === 400) {
                message = res.data.eventMessage.msg || "";

                _this.setState({ message: message });
              } else {
                _this.setError("Something went wrong while downloading report");
              }
              _context.next = 25;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](12);

              _this.setError("Something went wrong while downloading report");

            case 25:
              _context.prev = 25;

              _this.setState({ isDownloading: false });
              //this.props.onClose()
              return _context.finish(25);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[12, 22, 25, 28]]);
    }));


    _this.maxDate = new Date();
    _this.minDate = new Date("2024-06-07");

    _this.state = {
      isDownloading: false,
      errorMsg: "",
      message: "",
      dates: {
        startDate: "",
        endDate: ""
      },
      errors: {
        startDate: "",
        endDate: ""
      }
    };
    return _this;
  }

  createClass(DownloadExcelReport, [{
    key: "render",
    value: function render() {
      var _state = this.state,
          isDownloading = _state.isDownloading,
          errorMsg = _state.errorMsg,
          dates = _state.dates,
          errors = _state.errors;

      return React__default.createElement(
        Card,
        {
          style: { width: "100%" },
          className: "download-paid-excel-report"
        },
        React__default.createElement(
          CardContent,
          null,
          React__default.createElement(CardHeader, { style: { paddingInline: "40px", paddingTop: "20px" } }),
          React__default.createElement(
            CardDescription,
            { style: { background: "white", paddingInline: "35px" } },
            errorMsg ? React__default.createElement(
              "div",
              { className: "error-notification" },
              errorMsg
            ) : null,
            React__default.createElement(
              Form,
              null,
              React__default.createElement(
                FormGroup,
                { style: { maxWidth: "400px", padding: "15px" } },
                React__default.createElement(
                  "div",
                  { className: "field" },
                  React__default.createElement(
                    "label",
                    null,
                    "Start Date"
                  ),
                  React__default.createElement(
                    "div",
                    { className: "ui fluid input" },
                    React__default.createElement(DatePicker, {
                      selected: dates.startDate,
                      title: "Start Date",
                      placeholderText: "Start Date",
                      id: "start-date",
                      name: "etd",
                      minDate: this.minDate,
                      maxDate: this.maxDate,
                      onChange: this.handleStartDateChange,
                      dateCaption: "Start Date",
                      dateFormat: "yyyy-MM-dd",
                      peekNextMonth: true,
                      showMonthDropdown: true,
                      showYearDropdown: true,
                      dropdownMode: "select",
                      disabled: isDownloading
                    })
                  ),
                  React__default.createElement(
                    "div",
                    { style: { color: "#e23410" } },
                    errors.startDate || ""
                  )
                ),
                React__default.createElement(
                  "div",
                  { className: "field" },
                  React__default.createElement(
                    "label",
                    null,
                    "End Date"
                  ),
                  React__default.createElement(
                    "div",
                    { className: "ui fluid input" },
                    React__default.createElement(DatePicker, {
                      selected: dates.endDate,
                      title: "End Date",
                      placeholderText: "End Date",
                      id: "end-date",
                      name: "etd",
                      minDate: this.minDate,
                      maxDate: this.maxDate,
                      onChange: this.handleEndDateChange,
                      dateCaption: "Start Date",
                      dateFormat: "yyyy-MM-dd",
                      peekNextMonth: true,
                      showMonthDropdown: true,
                      showYearDropdown: true,
                      dropdownMode: "select",
                      disabled: isDownloading
                    })
                  ),
                  React__default.createElement(
                    "div",
                    { style: { color: "#e23410" } },
                    errors.endDate || ""
                  )
                )
              ),
              React__default.createElement(
                Button,
                {
                  loading: isDownloading,
                  disabled: isDownloading,
                  onClick: this.handleSubmit,
                  style: { marginLeft: "10px" }
                },
                "Download"
              ),
              React__default.createElement(
                Button,
                {
                  onClick: this.props.onClose,
                  style: { marginLeft: "10px" }
                },
                "Close"
              ),
              this.state.message !== "" && React__default.createElement(
                "div",
                { style: { color: "#e23410" } },
                this.state.message
              )
            )
          )
        )
      );
    }
  }]);
  return DownloadExcelReport;
}(Component);

var FILTER_CHARGE_TYPE = "Charge Type";
var FILTER_CHARGE_TYPE_OPTION_AIR_DRAYAGE = "Air Drayage";

var ChargeTypeFilter = {
  label: FILTER_CHARGE_TYPE,
  Component: Checkbox,
  isCheckBox: true,
  options: [{
    props: {
      label: FILTER_CHARGE_TYPE_OPTION_AIR_DRAYAGE,
      value: FILTER_CHARGE_TYPE_OPTION_AIR_DRAYAGE
    }
  }]
};

var TabFilters = {
  PENDING: [ChargeTypeFilter],
  DISPUTED: [ChargeTypeFilter],
  'CHARGE_LIST': [ChargeTypeFilter],
  PAID: [ChargeTypeFilter],
  "PARTIALLY PAID": [ChargeTypeFilter]
};

var Filters = function (_Component) {
  inherits(Filters, _Component);

  function Filters(props) {
    classCallCheck(this, Filters);
    return possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).call(this, props));
  }

  createClass(Filters, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          activeTab = _props.activeTab,
          selectedFilters = _props.selectedFilters,
          _onChange = _props.onChange;

      var filters = Array.isArray(TabFilters[activeTab]) ? TabFilters[activeTab] : [];
      return React__default.createElement(
        "div",
        { className: "drayage-partner-filters-container" },
        filters.map(function (value, index) {
          var Component$$1 = lodash_1(value, "Component", Fragment);
          var options = lodash_1(value, "options", null);
          var mainLabel = lodash_1(value, "label", null);
          var isCheckbox = lodash_1(value, "isCheckBox", null);
          var props = lodash_1(value, "props", {});

          return React__default.createElement(
            "div",
            {
              className: "filter-input-container",
              key: "filter-input-container-" + index + "-" + mainLabel
            },
            Component$$1 && Array.isArray(options) && isCheckbox ? options.map(function (option, optionIndex) {
              var props = lodash_1(option, "props", {});

              return React__default.createElement(
                "div",
                {
                  className: " ",
                  key: "option-" + lodash_1(props, "label", "") + "-" + optionIndex + "-" + mainLabel
                },
                React__default.createElement(Component$$1, _extends({}, props, {
                  label: lodash_1(props, "label", ""),
                  checked: lodash_1(props, "label", "") === lodash_1(selectedFilters, "" + mainLabel, false),
                  onChange: function onChange(e, data) {
                    if (data.checked) {
                      _onChange(mainLabel, lodash_1(props, "value", ""));
                    } else {
                      _onChange(mainLabel, "");
                    }
                  }
                }))
              );
            }) : null
          );
        })
      );
    }
  }]);
  return Filters;
}(Component);

var payloadMap = new WeakMap();
var selectedFiltersMap = new WeakMap();

var PayloadFilters = function () {
  function PayloadFilters(selectedFilters) {
    classCallCheck(this, PayloadFilters);

    selectedFiltersMap.set(this, selectedFilters);
    payloadMap.set(this, {});
  }

  createClass(PayloadFilters, [{
    key: "getChargeTypeFilterPayload",
    value: function getChargeTypeFilterPayload() {
      var chargeType = lodash_1(selectedFiltersMap.get(this), "[" + FILTER_CHARGE_TYPE + "]", false);

      payloadMap.set(this, _extends({}, payloadMap.get(this), {
        isMotAir: chargeType === FILTER_CHARGE_TYPE_OPTION_AIR_DRAYAGE
      }));

      return this;
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      this.getChargeTypeFilterPayload();
      return payloadMap.get(this);
    }
  }]);
  return PayloadFilters;
}();

/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

var ActiveTabs = {
  "charge-list": {
    label: "CHARGE LIST",
    Component: ChargeList,
    labelClass: [""]
  },
  pending: { label: "PENDING", Component: PendingList, labelClass: [""] },
  paid: { label: "PAID", Component: Paid, labelClass: ["label-green"] },
  "partially-paid": { label: "PARTIALLY PAID", Component: PartiallyPaidList, labelClass: [""] },
  // rejected: {
  //   label: "REJECTED",
  //   Component: Rejected,
  //   labelClass: ["label-red"],
  // },
  disputed: {
    label: "DISPUTED",
    Component: Disputed,
    labelClass: ["label-red"]
  }
  //  disputed: {
  //    label: "DISPUTED",
  //    Component: Dispute,
  //    labelClass: ["label-red"],
  //  },
  //  cancelled: {
  //    label: "CANCELLED",
  //    Component: Cancelled,
  //    labelClass: ["label-red"],
  //  },
};
var getFormatedDate = function getFormatedDate(date) {
  var dateVal = parseInt(date);
  if (isNaN() || !Number(dateVal) || !dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMMM DD YYYY");
};

var getCountryNameAndImage = function getCountryNameAndImage(countryCode) {
  var countryName = "";
  var countryImage = "";
  if (countryCode === "US") {
    countryName = "USA";
    countryImage = "/images/US.jpg";
  } else if (countryCode === "CANADA" || countryCode == 'CA') {
    countryName = "CANADA";
    countryImage = "/images/Canda.jpg";
  } else if (countryCode === "UK") {
    countryName = "UK";
    countryImage = "/images/Uk.jpg";
  } else if (countryCode === "ES") {
    countryName = "SPAIN";
    countryImage = "/images/spain.jpg";
  } else if (countryCode === "NL") {
    countryName = "NL";
    countryImage = "/images/NL.jpg";
  }

  return { countryName: countryName, countryImage: countryImage };
};

var DrayageInvoices = function (_Component) {
  inherits(DrayageInvoices, _Component);

  function DrayageInvoices(props) {
    var _this2 = this;

    classCallCheck(this, DrayageInvoices);

    var _this = possibleConstructorReturn(this, (DrayageInvoices.__proto__ || Object.getPrototypeOf(DrayageInvoices)).call(this, props));

    _this.isDecimal = function (n) {
      var result = n - Math.floor(n) !== 0;
      if (result) {
        return true;
      }
      return false;
    };

    _this.updateState = function (state) {
      return new Promise(function (resolve) {
        _this.setState(_extends({}, state), function () {
          return resolve(true);
        });
      });
    };

    _this.setInfoMessages = function (key, message) {
      var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3500;

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      _this.setState(defineProperty({}, key, message), function () {
        return setTimeout(function () {
          _this.setState(defineProperty({}, key, ""));
        }, time);
      });
    };

    _this.getFormatedCurrency = function (value, country) {
      if (Number.isInteger(value)) {
        value = (parseFloat(value) / 100).toFixed(2);
      }
      value = Number.isNaN(parseFloat(value)) ? 0 : parseFloat(value);

      if (value < 0) {
        value = value * -1;
        var _currencySymbol = lodash_1(CountryCurrencyMap, "" + country, '');
        return "(" + _currencySymbol + " " + value.toFixed(2) + ")";
      }
      var currencySymbol = lodash_1(CountryCurrencyMap, "" + country, '');
      return currencySymbol + " " + value.toFixed(2);
    };

    _this.getFormatedPaidDate = function (date) {
      if (!Number.isInteger(date) && !isNaN(date)) {
        date = date.trim();
      }

      if (date === "") return "-";

      date = new Date(date);
      if (!(date instanceof Date) || String(date) === "Invalid Date") {
        return "-";
      }

      var day = date.getDate();
      var month = date.toLocaleString("en-US", { month: "short" });
      var year = date.getFullYear();

      if (day < 10) {
        day = "0" + day;
      }
      return month + " " + day + ", " + year;
    };

    _this.closePaidExcelReportModal = function () {
      _this.setState({ paidExcelReport: false });
    };

    _this.HandlecallbackKeyword = function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _this$state, isActiveTab, activeIndex;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$state = _this.state, isActiveTab = _this$state.isActiveTab, activeIndex = _this$state.activeIndex;

                _this.setState({ keyword: data, pageNumber: 1 }, function () {
                  if (activeIndex == 1) {
                    _this.getPendingTabData();
                  } else if (activeIndex == 2) {
                    _this.getPaidTabData();
                  } else if (activeIndex == 3) {
                    _this.getPartiallyPaidTabData();
                  } else if (activeIndex == 4) {
                    _this.getDisputedData();
                  } else {
                    _this.getChargelistData();
                  }
                  // { isActiveTab === "CHARGE_LIST" ? this.getChargelistData() : this.getPendingTabData() }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.goToChargelist = function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.setState({ activeIndex: 0 });
                _this.getChargelistData();
                _this.setState({ sendKeyword: data }, function () {
                  _this.HandlecallbackKeyword(data);
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleTabChange = function (e, _ref3) {
      var activeIndex = _ref3.activeIndex;

      _this.setState({ activeIndex: activeIndex });
    };

    _this.sendKeywordFun = function () {
      var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.setState({ sendKeyword: "" });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.selectedCharge = function () {
      var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(unitPrice, uom) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.updateState({ unitPriceVal: unitPrice, uom: uom });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.unitPriceValue = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this.updateState({ unitPriceVal: "" });

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this2);
    }));

    _this.deleteChargeLineItemForDisputedTab = function () {
      var _ref7 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(chargeIndex, index) {
        var charges, chargeId, deleteResponse, msg;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.disputed));
                chargeId = charges[chargeIndex].chargeDesc.chargeDesc[index];

                chargeId.unitPrice = parseFloat(chargeId.unitPrice) * 100;
                chargeId.totalRate = parseFloat(chargeId.totalRate) * 100;
                _context6.next = 6;
                return deleteChargeAtLineItemForDisputedTab(chargeId);

              case 6:
                deleteResponse = _context6.sent;
                msg = lodash_1(deleteResponse, "data.eventMessage.msg", "");

                if (msg === "Drayage charge archived successfully") {
                  charges[chargeIndex].chargeDesc.chargeDesc.splice(index, 1);
                  _this.setInfoMessages("successMsg", msg);
                } else {
                  _this.setInfoMessages("errorMsg", "Unable to archive drayage charge");
                }

                _context6.next = 11;
                return _this.updateState({ disputed: [].concat(toConsumableArray(charges)) });

              case 11:
                _this.callGetDisputedWithDelay(1);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this2);
      }));

      return function (_x7, _x8) {
        return _ref7.apply(this, arguments);
      };
    }();

    _this.resolveDisputeRequest = function () {
      var _ref8 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(data) {
        var disputeReason, disputeComment, chrgDesc, modeOfTransport, docFound, i, payload, returnResult, code, type, msg, duration;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                disputeReason = lodash_1(data, "disputeReason", "");
                disputeComment = lodash_1(data, "disputeComment", "");
                chrgDesc = lodash_1(data, "data.chargeDesc.chargeDesc", []);
                modeOfTransport = lodash_1(data, "data.modeOfTransport", "");
                docFound = true;
                i = 0;

              case 6:
                if (!(i < chrgDesc.length)) {
                  _context8.next = 13;
                  break;
                }

                if (!(parseInt(lodash_1(chrgDesc, "[" + i + "].glCode", 0)) !== 60002 && parseInt(lodash_1(chrgDesc, "[" + i + "].glCode", 0)) !== 60001 && lodash_1(chrgDesc, "[" + i + "].documentName", false) === false && !["MOT_AIR"].includes(modeOfTransport))) {
                  _context8.next = 10;
                  break;
                }

                docFound = false;
                return _context8.abrupt("break", 13);

              case 10:
                i++;
                _context8.next = 6;
                break;

              case 13:
                if (!(docFound === false)) {
                  _context8.next = 16;
                  break;
                }

                _this.setState({ needDocumentForResolve: true }, function () {
                  setTimeout(function () {
                    _this.setState({ needDocumentForResolve: false });
                  }, 5000);
                });
                return _context8.abrupt("return", true);

              case 16:
                payload = {
                  containerId: lodash_1(data, "data.containerId", ""),
                  action: "RESOLVED_DISPUTE_BY_DRAY_VENDOR",
                  comment: disputeComment,
                  invoiceNumber: lodash_1(data, "data.drayageInvoiceNumber", ""),
                  reason: disputeReason,
                  state: lodash_1(data, "data.drayageInvoiceState", "")
                };
                _context8.next = 19;
                return resolveDisputeForInvoice(payload);

              case 19:
                returnResult = _context8.sent;
                code = lodash_1(returnResult, 'data.eventMessage.code', '');
                type = lodash_1(returnResult, 'data.eventMessage.type', '');
                msg = lodash_1(returnResult, 'data.eventMessage.msg', '');
                duration = void 0;

                if (!(code === 400 && type === 'INVOICE_DOCUMENT')) {
                  _context8.next = 29;
                  break;
                }

                duration = 7000;
                _this.setInfoMessages("errorMsg", msg, duration);
                _context8.next = 37;
                break;

              case 29:
                if (!returnResult) {
                  _context8.next = 34;
                  break;
                }

                _this.setInfoMessages("successMsg", "Dispute resolved successfully.");
                _this.callGetDisputedWithDelay(1);
                _context8.next = 37;
                break;

              case 34:
                _context8.next = 36;
                return _this.updateState({ disputeResolvedError: "Some error occurred." });

              case 36:
                setTimeout(asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return _this.updateState({ disputeResolvedError: "" });

                        case 2:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this2);
                })), 3500);

              case 37:
                return _context8.abrupt("return", returnResult);

              case 38:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this2);
      }));

      return function (_x9) {
        return _ref8.apply(this, arguments);
      };
    }();

    _this.getDisputedData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref10 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(resolve) {
          var filterPayload, requestPayload, disputedData, disputedDataFiltered;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.prev = 0;
                  _context9.next = 3;
                  return _this.updateState({
                    fetchDisputed: true
                    // isActiveTab: "DISPUTED",
                  });

                case 3:
                  filterPayload = new PayloadFilters(_this.state.selectedFilters).getPayload();
                  requestPayload = _extends({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_DISPUTE",
                    isDrayInvoice: true
                  }, filterPayload);
                  _context9.next = 7;
                  return getDrayageDisputedInvoices(requestPayload);

                case 7:
                  disputedData = _context9.sent;
                  _context9.next = 10;
                  return _this.getChargelistData(page);

                case 10:
                  // for tab count

                  disputedDataFiltered = lodash_1(disputedData, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(parseInt(value.markUPAmount)) ? 0 : parseInt(value.markUPAmount),
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    });
                    return _extends({}, val, {
                      chargeDesc: _extends({}, val.chargeDesc, {
                        chargeDesc: chargeDesc,
                        totalAmount: parseFloat(val.chargeDesc.totalAmount / 100).toFixed(2)
                      })
                    });
                  });
                  _context9.next = 13;
                  return _this.updateState({
                    disputed: disputedDataFiltered,
                    fetchDisputed: false
                  });

                case 13:
                  resolve(true);
                  _context9.next = 21;
                  break;

                case 16:
                  _context9.prev = 16;
                  _context9.t0 = _context9["catch"](0);
                  _context9.next = 20;
                  return _this.updateState({ disputed: [], fetchDisputed: false });

                case 20:
                  resolve(true);

                case 21:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, _this2, [[0, 16]]);
        }));

        return function (_x11) {
          return _ref10.apply(this, arguments);
        };
      }());
    };

    _this.editDisputedCharge = function (index) {
      var chargelist = _this.state.disputed.map(function (val, i) {
        if (index === i) {
          val.edit = true;
        } else {
          val.edit = false;
        }
        return val;
      });
      _this.updateState({ disputed: [].concat(toConsumableArray(chargelist)) });
    };

    _this.expandDisputedCard = function (id) {
      _this.state.activeDisputedCard === id ? _this.updateState({
        activeDisputedCard: null
      }) : _this.updateState({
        activeDisputedCard: id
      });
    };

    _this.updateDisputedLineItem = function (chargeListIndex, chargeIndex, key, value) {
      var charges = JSON.parse(JSON.stringify(_this.state.disputed));
      charges[chargeListIndex].chargeDesc.chargeDesc[chargeIndex][key] = value;
      return _this.updateState({
        disputed: JSON.parse(JSON.stringify(charges))
      });
    };

    _this.saveDisputedData = function () {
      var _ref11 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(chargeListIndex) {
        var charges, chargesClone, totalValue, totalValueClone, apiDataArray, newChargesIndexSaved, chargeDesc, chargesToSave, afterCall, result, code, type, msg;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.disputed));
                chargesClone = JSON.parse(JSON.stringify(_this.state.disputed));

                charges[chargeListIndex].edit = false;

                totalValue = 0;
                totalValueClone = 0;
                apiDataArray = [];
                newChargesIndexSaved = [];
                chargeDesc = charges[chargeListIndex].chargeDesc.chargeDesc.map(function (val, index) {
                  var valClone = JSON.parse(JSON.stringify(val));
                  if (val.new === true) {
                    newChargesIndexSaved.push(index);
                  }

                  delete val.new;
                  val.markUPAmount = parseInt(val.markUPAmount);
                  val.markUPAmount = isNaN(val.markUPAmount) ? 0 : val.markUPAmount;
                  val.unitPrice = parseFloat(val.unitPrice);
                  val.unitPrice = isNaN(val.unitPrice) ? 0 : val.unitPrice;
                  val.quantity = parseInt(val.quantity);
                  val.quantity = isNaN(val.quantity) ? 1 : val.quantity;
                  var currentArrTotal = val.totalRate;

                  val.totalRate = isNaN(val.totalRate) ? 0 : parseFloat(val.totalRate).toFixed(2);

                  totalValue += parseFloat(currentArrTotal);

                  /**
                   *
                   *  Computation for Api
                   */
                  if (valClone.new) {
                    delete valClone.chargeId;
                  }
                  delete valClone.new;
                  val.markUPAmount = parseInt(val.markUPAmount);
                  val.markUPAmount = isNaN(val.markUPAmount) ? 0 : val.markUPAmount;
                  valClone.unitPrice = parseFloat(valClone.unitPrice);
                  valClone.unitPrice = isNaN(valClone.unitPrice) ? 0 : valClone.unitPrice * 100;
                  valClone.quantity = parseInt(valClone.quantity);
                  valClone.quantity = isNaN(valClone.quantity) ? 1 : valClone.quantity;
                  valClone.totalRate = isNaN(valClone.totalRate) ? 0 : parseFloat(valClone.totalRate) * 100;
                  valClone.subTotal = isNaN(valClone.subTotal) ? 0 : parseFloat(valClone.subTotal);
                  totalValueClone += valClone.totalRate;
                  apiDataArray.push(valClone);

                  return val;
                });


                charges[chargeListIndex].chargeDesc.totalAmount = totalValue * 100;
                charges[chargeListIndex].chargeDesc.chargeDesc = [].concat(toConsumableArray(chargeDesc));

                // FOR API CALL
                chargesClone[chargeListIndex].chargeDesc.totalAmount = totalValueClone;
                chargesClone[chargeListIndex].chargeDesc.chargeDesc = [].concat(apiDataArray);

                chargesToSave = chargesClone[chargeListIndex];

                afterCall = function () {
                  var _ref12 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(status) {
                    var totalForChanges, _chargeDesc;

                    return regeneratorRuntime.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _this.callGetDisputedWithDelay(1);
                            if (status === false) {
                              totalForChanges = 0;
                              _chargeDesc = charges[chargeListIndex].chargeDesc.chargeDesc.filter(function (val, index) {
                                if (!newChargesIndexSaved.includes(index)) {
                                  val.unitPrice = parseFloat(val.unitPrice);
                                  val.unitPrice = isNaN(val.unitPrice) ? 0 : val.unitPrice;
                                  val.quantity = parseInt(val.quantity);
                                  val.quantity = isNaN(val.quantity) ? 1 : val.quantity;
                                  val.totalRate = val.unitPrice * val.quantity;
                                  totalForChanges += val.totalRate;
                                  return true;
                                }
                              });

                              charges[chargeListIndex].chargeDesc.totalAmount = totalForChanges * 100;
                              charges[chargeListIndex].chargeDesc.chargeDesc = [].concat(toConsumableArray(_chargeDesc));
                            }

                            _context10.next = 4;
                            return _this.updateState({ disputed: [].concat(toConsumableArray(charges)) });

                          case 4:
                            return _context10.abrupt("return", new Promise(function (resolve) {
                              return resolve(status);
                            }));

                          case 5:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10, _this2);
                  }));

                  return function afterCall(_x13) {
                    return _ref12.apply(this, arguments);
                  };
                }();

                _context11.prev = 14;
                _context11.next = 17;
                return saveContainerDisputedData(chargesToSave);

              case 17:
                result = _context11.sent;
                code = lodash_1(result, "data.eventMessage.code", "");
                type = lodash_1(result, "data.eventMessage.type", '');
                msg = lodash_1(result, "data.eventMessage.msg", "");

                if (!(code === 200 || msg === "Successfully updated")) {
                  _context11.next = 28;
                  break;
                }

                _this.setInfoMessages("successMsg", "Charges saved successfully.");
                _context11.next = 25;
                return afterCall(true);

              case 25:
                return _context11.abrupt("return", _context11.sent);

              case 28:
                if (code === 400 && type === 'CHASSIS') {
                  _this.setInfoMessages("errorMsg", msg, 12000);
                } else {
                  _this.setInfoMessages("errorMsg", "Some error occurred. Unable to save charges.");
                }
                _context11.next = 31;
                return afterCall(false);

              case 31:
                return _context11.abrupt("return", _context11.sent);

              case 32:
                _context11.next = 40;
                break;

              case 34:
                _context11.prev = 34;
                _context11.t0 = _context11["catch"](14);

                _this.setInfoMessages("errorMsg", "Some error occurred. Unable to save charges.");
                _context11.next = 39;
                return afterCall(false);

              case 39:
                return _context11.abrupt("return", _context11.sent);

              case 40:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this2, [[14, 34]]);
      }));

      return function (_x12) {
        return _ref11.apply(this, arguments);
      };
    }();

    _this.callGetDisputedWithDelay = function () {
      var _ref13 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                setTimeout(function () {
                  _this.getDisputedData(page);
                }, 2000);

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this2);
      }));

      return function () {
        return _ref13.apply(this, arguments);
      };
    }();

    _this.cancelDisputedEdit = function (chargeListIndex, value) {
      var charges = JSON.parse(JSON.stringify(_this.state.disputed));
      charges[chargeListIndex].chargeDesc.chargeDesc = value;
      charges[chargeListIndex].edit = false;
      return _this.updateState({ disputed: [].concat(toConsumableArray(charges)) });
    };

    _this.callDrayageDisputedApi = function () {
      var _ref14 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(index) {
        var chargeList, countryCode, newChargeAdded, glCodes, partnerId, partnerCharges, getPartnerCharges, newCharges;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                chargeList = JSON.parse(JSON.stringify(_this.state.disputed));
                countryCode = lodash_1(chargeList, "[" + index + "]chargeDesc.countryCode", "");
                newChargeAdded = false;
                glCodes = lodash_1(chargeList, "[" + index + "].chargeDesc.chargeDesc", []).map(function (val) {
                  if (newChargeAdded === false && val.new === true) newChargeAdded = true;
                  return val.glCode;
                });
                partnerId = _this.state.partnerId;
                _context13.next = 7;
                return getDrayagePartnerDetails({
                  partnerId: partnerId
                });

              case 7:
                partnerCharges = _context13.sent;
                getPartnerCharges = lodash_1(partnerCharges, "data.eventMessage.pricing.pricingItems", []);
                newCharges = getPartnerCharges.map(function (val) {
                  return {
                    value: val.glCode,
                    key: val.glCode,
                    text: val.chargeName,
                    unitPrice: val.unitPrice,
                    uom: val.unitMeasurement
                  };
                });

                if (!(newChargeAdded === false)) {
                  _context13.next = 13;
                  break;
                }

                _context13.next = 13;
                return _this.updateState({ disputeChargesOptions: [].concat(toConsumableArray(newCharges)) });

              case 13:
                return _context13.abrupt("return", new Promise(function (resolve) {
                  return resolve(newCharges);
                }));

              case 14:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this2);
      }));

      return function (_x15) {
        return _ref14.apply(this, arguments);
      };
    }();

    _this.deleteDisputedItem = function () {
      var _ref15 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(chargeIndex, index) {
        var charges, chargeId, deleteResponse, msg;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.disputed));
                chargeId = charges[chargeIndex].chargeDesc.chargeDesc[index].chargeId;
                _context14.next = 4;
                return deleteChargeAtLineItem({ value: [chargeId] });

              case 4:
                deleteResponse = _context14.sent;
                msg = lodash_1(deleteResponse, "data.eventMessage.msg", "");

                if (msg === "Drayage charge archived successfully") {
                  charges[chargeIndex].chargeDesc.chargeDesc.splice(index, 1);
                  _this.setInfoMessages("successMsg", msg);
                } else {
                  _this.setInfoMessages("errorMsg", "Unable to archive drayage charge");
                }

                _context14.next = 9;
                return _this.updateState({ disputed: [].concat(toConsumableArray(charges)) });

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this2);
      }));

      return function (_x16, _x17) {
        return _ref15.apply(this, arguments);
      };
    }();

    _this.getChargelistData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref16 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(resolve) {
          var filterPayload, addtionalField, requestPayload, chargeListData, totalCount, tabCount, nonEditableGlCodes, chargeListDataFiltered;
          return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.prev = 0;
                  _context15.next = 3;
                  return _this.updateState({
                    fetchChargeList: true
                    // isActiveTab: "CHARGE_LIST",
                  });

                case 3:
                  filterPayload = new PayloadFilters(_this.state.selectedFilters).getPayload();
                  addtionalField = { isOpen: false, isReleased: false };

                  if (_this.state.chargeListType === "isOpen") {
                    addtionalField[_this.state.chargeListType] = true;
                  } else if (_this.state.chargeListType.trim() === "isReleased") {
                    addtionalField[_this.state.chargeListType] = true;
                  }
                  requestPayload = _extends({
                    pageNumber: page,
                    keyword: _this.state.keyword
                  }, filterPayload);
                  _context15.next = 9;
                  return getDrayageChargeList(_extends({}, requestPayload, addtionalField));

                case 9:
                  chargeListData = _context15.sent;

                  // this.props.invoiceData(chargeListData)
                  totalCount = lodash_1(chargeListData, "data.eventMessage.totalCount", 0);
                  _context15.next = 13;
                  return getDrayageTabCount(requestPayload);

                case 13:
                  tabCount = _context15.sent;
                  _context15.next = 16;
                  return _this.updateState({
                    tabCount: _extends({
                      chargeListTabCount: totalCount
                    }, tabCount.data.eventMessage)
                  });

                case 16:
                  nonEditableGlCodes = lodash_1(chargeListData, "data.eventMessage.nonEditableGlCodes", []);
                  _context15.next = 19;
                  return _this.updateState({ nonEditableGlCodes: nonEditableGlCodes });

                case 19:
                  chargeListDataFiltered = lodash_1(chargeListData, "data.eventMessage.charges", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "value.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(parseInt(value.markUPAmount)) ? 0 : parseInt(value.markUPAmount),
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    });
                    return _extends({}, val, {
                      value: _extends({}, val.value, {
                        chargeDesc: chargeDesc,
                        totalAmount: parseFloat(val.value.totalAmount / 100).toFixed(2)
                      })
                    });
                  });
                  _context15.next = 22;
                  return _this.updateState({
                    chargeList: chargeListDataFiltered,
                    fetchChargeList: false
                  });

                case 22:
                  resolve(true);
                  _context15.next = 30;
                  break;

                case 25:
                  _context15.prev = 25;
                  _context15.t0 = _context15["catch"](0);
                  _context15.next = 29;
                  return _this.updateState({ chargeList: [], fetchChargeList: false });

                case 29:
                  resolve(true);

                case 30:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, _this2, [[0, 25]]);
        }));

        return function (_x19) {
          return _ref16.apply(this, arguments);
        };
      }());
    };

    _this.editChargeListCharge = function (index) {
      var chargelist = _this.state.chargeList.map(function (val, i) {
        if (index === i) {
          val.edit = true;
        } else {
          val.edit = false;
        }
        return val;
      });
      _this.updateState({ chargelist: [].concat(toConsumableArray(chargelist)) });
    };

    _this.expandChargeListCard = function (id) {
      _this.state.activeChargeListCard === id ? _this.updateState({
        activeChargeListCard: null
      }) : _this.updateState({
        activeChargeListCard: id
      });
    };

    _this.updateChargeListLineItem = function (chargeListIndex, chargeIndex, key, value) {
      var charges = JSON.parse(JSON.stringify(_this.state.chargeList));
      charges[chargeListIndex].value.chargeDesc[chargeIndex][key] = value;
      return _this.updateState({
        chargeList: JSON.parse(JSON.stringify(charges))
      });
    };

    _this.saveChargeListData = function () {
      var _ref17 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(chargeListIndex) {
        var charges, chargesClone, totalValue, totalValueClone, apiDataArray, newChargesIndexSaved, chargeDesc, chargesToSave, afterCall, result, code, msg;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.chargeList));
                chargesClone = JSON.parse(JSON.stringify(_this.state.chargeList));

                charges[chargeListIndex].edit = false;

                totalValue = 0;
                totalValueClone = 0;
                apiDataArray = [];
                newChargesIndexSaved = [];
                chargeDesc = charges[chargeListIndex].value.chargeDesc.map(function (val, index) {
                  var valClone = JSON.parse(JSON.stringify(val));
                  if (val.new === true) {
                    newChargesIndexSaved.push(index);
                  }

                  delete val.new;
                  val.markUPAmount = parseInt(val.markUPAmount);
                  val.markUPAmount = isNaN(val.markUPAmount) ? 0 : val.markUPAmount;
                  val.unitPrice = parseFloat(val.unitPrice);
                  val.unitPrice = isNaN(val.unitPrice) ? 0 : val.unitPrice;
                  val.quantity = parseInt(val.quantity);
                  val.quantity = isNaN(val.quantity) ? 1 : val.quantity;
                  var currentArrTotal = val.totalRate;

                  val.totalRate = isNaN(val.totalRate) ? 0 : parseFloat(val.totalRate).toFixed(2);

                  totalValue += parseFloat(currentArrTotal);

                  /**
                   *
                   *  Computation for Api
                   */
                  if (valClone.new) {
                    delete valClone.chargeId;
                  }
                  delete valClone.new;
                  val.markUPAmount = parseInt(val.markUPAmount);
                  val.markUPAmount = isNaN(val.markUPAmount) ? 0 : val.markUPAmount;
                  valClone.unitPrice = parseFloat(valClone.unitPrice);
                  valClone.unitPrice = isNaN(valClone.unitPrice) ? 0 : valClone.unitPrice * 100;
                  valClone.quantity = parseInt(valClone.quantity);
                  valClone.quantity = isNaN(valClone.quantity) ? 1 : valClone.quantity;
                  valClone.totalRate = isNaN(valClone.totalRate) ? 0 : parseFloat(valClone.totalRate) * 100;
                  valClone.subTotal = isNaN(valClone.subTotal) ? 0 : parseFloat(valClone.subTotal);
                  totalValueClone += valClone.totalRate;
                  apiDataArray.push(valClone);

                  return val;
                });


                charges[chargeListIndex].value.totalAmount = totalValue * 100;
                charges[chargeListIndex].value.chargeDesc = [].concat(toConsumableArray(chargeDesc));

                // FOR API CALL
                chargesClone[chargeListIndex].value.totalAmount = totalValueClone;
                chargesClone[chargeListIndex].value.chargeDesc = [].concat(apiDataArray);

                chargesToSave = chargesClone[chargeListIndex];

                afterCall = function () {
                  var _ref18 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(status) {
                    var totalForChanges, _chargeDesc2;

                    return regeneratorRuntime.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            _this.callGetChargeListWithDelay(1);
                            if (status === false) {
                              totalForChanges = 0;
                              _chargeDesc2 = charges[chargeListIndex].value.chargeDesc.filter(function (val, index) {
                                if (!newChargesIndexSaved.includes(index)) {
                                  val.unitPrice = parseFloat(val.unitPrice);
                                  val.unitPrice = isNaN(val.unitPrice) ? 0 : val.unitPrice;
                                  val.quantity = parseInt(val.quantity);
                                  val.quantity = isNaN(val.quantity) ? 1 : val.quantity;
                                  val.totalRate = val.unitPrice * val.quantity;
                                  totalForChanges += val.totalRate;
                                  return true;
                                }
                              });

                              charges[chargeListIndex].value.totalAmount = totalForChanges * 100;
                              charges[chargeListIndex].value.chargeDesc = [].concat(toConsumableArray(_chargeDesc2));
                            }

                            _context16.next = 4;
                            return _this.updateState({ chargeList: [].concat(toConsumableArray(charges)) });

                          case 4:
                            return _context16.abrupt("return", new Promise(function (resolve) {
                              return resolve(status);
                            }));

                          case 5:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16, _this2);
                  }));

                  return function afterCall(_x21) {
                    return _ref18.apply(this, arguments);
                  };
                }();

                _context17.prev = 14;
                _context17.next = 17;
                return saveContainerChargeList(chargesToSave.value);

              case 17:
                result = _context17.sent;
                code = lodash_1(result, "data.eventMessage.code", "");
                msg = lodash_1(result, "data.eventMessage.msg", "");

                if (!(code === 200 && msg === "Updated Successfully")) {
                  _context17.next = 27;
                  break;
                }

                _this.setInfoMessages("successMsg", "Charges saved successfully.");
                _context17.next = 24;
                return afterCall(true);

              case 24:
                return _context17.abrupt("return", _context17.sent);

              case 27:
                _this.setInfoMessages("errorMsg", "Some error occurred. Unable to save charges.");
                _context17.next = 30;
                return afterCall(false);

              case 30:
                return _context17.abrupt("return", _context17.sent);

              case 31:
                _context17.next = 39;
                break;

              case 33:
                _context17.prev = 33;
                _context17.t0 = _context17["catch"](14);

                _this.setInfoMessages("errorMsg", "Some error occurred. Unable to save charges.");
                _context17.next = 38;
                return afterCall(false);

              case 38:
                return _context17.abrupt("return", _context17.sent);

              case 39:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this2, [[14, 33]]);
      }));

      return function (_x20) {
        return _ref17.apply(this, arguments);
      };
    }();

    _this.callGetChargeListWithDelay = function () {
      var _ref19 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                setTimeout(function () {
                  _this.getChargelistData(page);
                }, 2300);

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this2);
      }));

      return function () {
        return _ref19.apply(this, arguments);
      };
    }();

    _this.cancelChargeListEdit = function (chargeListIndex, value) {
      var charges = JSON.parse(JSON.stringify(_this.state.chargeList));
      charges[chargeListIndex].value.chargeDesc = value;
      charges[chargeListIndex].edit = false;
      return _this.updateState({ chargeList: [].concat(toConsumableArray(charges)) });
    };

    _this.callDrayageChargeApi = function () {
      var _ref20 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(index) {
        var chargeList, countryCode, newChargeAdded, glCodes, chassisUnitCount, partnerId, partnerCharges, getPartnerCharges, newCharges;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                chargeList = JSON.parse(JSON.stringify(_this.state.chargeList));
                countryCode = lodash_1(chargeList, "[" + index + "]value.countryCode", "");
                newChargeAdded = false;
                glCodes = lodash_1(chargeList, "[" + index + "].value.chargeDesc", []).map(function (val) {
                  if (newChargeAdded === false && val.new === true) newChargeAdded = true;
                  return parseInt(val.glCode);
                });
                chassisUnitCount = lodash_1(chargeList, "[" + index + "].value.chargeDesc", []);
                //  let charges = await getDrayageCharges({
                //    countryCode: countryCode,
                //    glCodes: [...glCodes],
                //  });

                partnerId = _this.state.partnerId;
                _context19.next = 8;
                return getDrayagePartnerDetails({
                  partnerId: partnerId
                });

              case 8:
                partnerCharges = _context19.sent;
                getPartnerCharges = lodash_1(partnerCharges, "data.eventMessage.pricing.pricingItems", []);

                //  let additionalCharge = await getDrayageAdditionalCharge();
                //  let getAdditionalCharge = get(
                //   additionalCharge,
                //   `data.eventMessage.drayageAdditionalCharges`,
                //   []
                //  );

                // let newAdditionalCharges = getAdditionalCharge.map((val) => ({
                //   value: val.glCode,
                //   key: val.glCode,
                //   text: val.chargeName,
                // }));

                //usBuildUp

                newCharges = getPartnerCharges.map(function (val) {
                  return {
                    value: val.glCode,
                    key: val.glCode,
                    text: val.chargeName,
                    unitPrice: val.unitPrice,
                    uom: val.unitMeasurement
                  };
                });

                //  charges = get(
                //    charges,
                //    `data.eventMessage[${countryCode.toLowerCase()}BuildUp]`,
                //    []
                //  );
                //  //usBuildUp
                //  let newCharges = charges.map((val) => ({
                //    value: val.glCode,
                //    key: val.glCode,
                //    text: val.chargeType,
                //  }));

                _context19.next = 13;
                return _this.updateState({ chargesOptions: [].concat(toConsumableArray(newCharges)) });

              case 13:
                return _context19.abrupt("return", new Promise(function (resolve) {
                  return resolve(newCharges);
                }));

              case 14:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this2);
      }));

      return function (_x23) {
        return _ref20.apply(this, arguments);
      };
    }();

    _this.callDrayageDisputeChargeApi = function () {
      var _ref21 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(index) {
        var disputedchargeList, countryCode, newChargeAdded, glCodes, partnerId, partnerCharges, getPartnerCharges, newCharges;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                disputedchargeList = JSON.parse(JSON.stringify(_this.state.disputed));
                countryCode = lodash_1(disputedchargeList, "[" + index + "]value.countryCode", "");
                newChargeAdded = false;
                glCodes = lodash_1(disputedchargeList, "[" + index + "].chargeDesc.chargeDesc", []).map(function (val) {
                  if (newChargeAdded === false && val.new === true) newChargeAdded = true;
                  return parseInt(val.glCode);
                });
                partnerId = _this.state.partnerId;
                _context20.next = 7;
                return getDrayagePartnerDetails({
                  partnerId: partnerId
                });

              case 7:
                partnerCharges = _context20.sent;
                getPartnerCharges = lodash_1(partnerCharges, "data.eventMessage.pricing.pricingItems", []);

                //usBuildUp

                newCharges = getPartnerCharges.filter(function (v) {
                  return !glCodes.includes(parseInt(v.glCode));
                }).map(function (val) {
                  return {
                    value: val.glCode,
                    key: val.glCode,
                    text: val.chargeName,
                    unitPrice: val.unitPrice,
                    uom: val.unitMeasurement
                  };
                });
                _context20.next = 12;
                return _this.updateState({ disputeChargeOptions: [].concat(toConsumableArray(newCharges)) });

              case 12:
                return _context20.abrupt("return", new Promise(function (resolve) {
                  return resolve(newCharges);
                }));

              case 13:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this2);
      }));

      return function (_x24) {
        return _ref21.apply(this, arguments);
      };
    }();

    _this.addNewCharge = function () {
      var _ref22 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(index) {
        var newCharge, countryForCurrency, glCodes, newChargesFiltered, charges, returnVal;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return _this.callDrayageChargeApi(index);

              case 2:
                newCharge = false;
                countryForCurrency = '';
                glCodes = lodash_1(_this.state.chargeList, "[" + index + "].value.chargeDesc", []).map(function (val) {
                  // if (newChargeAdded === false && val.new === true) newChargeAdded = true;
                  if (countryForCurrency === '') {
                    countryForCurrency = lodash_1(val, 'countryForCurrency', '');
                  }
                  return parseInt(val.glCode);
                });

                console.log("TESTING555", glCodes);

                newChargesFiltered = _this.state.chargesOptions.filter(function (val) {
                  console.log("TESTING555----", val.value);
                  return !glCodes.includes(parseInt(val.value));
                });

                console.log("TESTING555", newChargesFiltered);

                if (!(newChargesFiltered.length > 0)) {
                  _context21.next = 15;
                  break;
                }

                charges = JSON.parse(JSON.stringify(_this.state.chargeList));

                charges[index].value.chargeDesc.push({
                  new: true,
                  entityId: lodash_1(charges, "[" + index + "].key", ""),
                  containerNumber: lodash_1(charges, "[" + index + "].value.containerNumber", ""),
                  chargeName: "",
                  glCode: "",
                  quantity: "",
                  unitPrice: "",
                  totalRate: "",
                  createdDate: "",
                  updatedDate: "",
                  chargeId: "",
                  status: "ADMIN GENERATED",
                  paymentTerm: "",
                  unitOfMeasurement: "",
                  markUPAmount: "",
                  countryForCurrency: countryForCurrency
                });
                _context21.next = 13;
                return _this.updateState({ chargeList: [].concat(toConsumableArray(charges)) });

              case 13:
                returnVal = _context21.sent;

                newCharge = true;

              case 15:

                if (newCharge === false) {
                  _this.setInfoMessages("errorMsg", "Unable to fetch more charges.");
                }
                _context21.next = 18;
                return Promise.resolve(newCharge);

              case 18:
                return _context21.abrupt("return", _context21.sent);

              case 19:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this2);
      }));

      return function (_x25) {
        return _ref22.apply(this, arguments);
      };
    }();

    _this.addDisputedNewCharge = function () {
      var _ref23 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(index) {
        var disputenewCharge, countryForCurrency, glCodes, newChargesFiltered, disputedCharges, returnVal;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return _this.callDrayageDisputeChargeApi(index);

              case 2:
                disputenewCharge = false;
                countryForCurrency = '';
                glCodes = lodash_1(_this.state.disputed, "[" + index + "].chargeDesc.chargeDesc", []).map(function (val) {
                  // if (newChargeAdded === false && val.new === true) newChargeAdded = true;
                  if (countryForCurrency === '') {
                    countryForCurrency = lodash_1(val, 'countryForCurrency', '');
                  }
                  return parseInt(val.glCode);
                });
                newChargesFiltered = _this.state.disputeChargeOptions.filter(function (val) {
                  return !glCodes.includes(parseInt(val.value));
                });

                if (!(newChargesFiltered.length > 0)) {
                  _context22.next = 13;
                  break;
                }

                disputedCharges = JSON.parse(JSON.stringify(_this.state.disputed));

                disputedCharges[index].chargeDesc.chargeDesc.push({
                  new: true,
                  drayageInvoiceNumber: lodash_1(disputedCharges, "[" + index + "].drayageInvoiceNumber", ""),
                  containerNumber: lodash_1(disputedCharges, "[" + index + "].chargeDesc.containerNumber", ""),
                  chargeName: "",
                  glCode: "",
                  quantity: "",
                  unitPrice: "",
                  totalRate: "",
                  createdDate: "",
                  updatedDate: "",
                  chargeId: "",
                  status: "ADMIN GENERATED",
                  paymentTerm: "",
                  unitOfMeasurement: "",
                  markUPAmount: "",
                  countryForCurrency: countryForCurrency
                });
                _context22.next = 11;
                return _this.updateState({ disputed: [].concat(toConsumableArray(disputedCharges)) });

              case 11:
                returnVal = _context22.sent;

                disputenewCharge = true;

              case 13:

                if (disputenewCharge === false) {
                  _this.setInfoMessages("errorMsg", "Unable to fetch more charges.");
                }
                _context22.next = 16;
                return Promise.resolve(disputenewCharge);

              case 16:
                return _context22.abrupt("return", _context22.sent);

              case 17:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this2);
      }));

      return function (_x26) {
        return _ref23.apply(this, arguments);
      };
    }();

    _this.deleteChargeLineItem = function () {
      var _ref24 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(chargeIndex, index) {
        var charges, chargeId, deleteResponse, msg;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.chargeList));
                chargeId = charges[chargeIndex].value.chargeDesc[index].chargeId;
                _context23.next = 4;
                return deleteChargeAtLineItem({ value: [chargeId] });

              case 4:
                deleteResponse = _context23.sent;
                msg = lodash_1(deleteResponse, "data.eventMessage.msg", "");

                if (msg === "Drayage charge archived successfully") {
                  charges[chargeIndex].value.chargeDesc.splice(index, 1);
                  _this.setInfoMessages("successMsg", msg);
                } else {
                  _this.setInfoMessages("errorMsg", "Unable to archive drayage charge");
                }

                _context23.next = 9;
                return _this.updateState({ chargeList: [].concat(toConsumableArray(charges)) });

              case 9:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this2);
      }));

      return function (_x27, _x28) {
        return _ref24.apply(this, arguments);
      };
    }();

    _this.selectedDropdownData = function (data) {
      _this.setState({ selectedDropDownData: data });
    };

    _this.createInvoice = function () {
      var _ref25 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(chargeIndex, accountRefNumber) {
        var charges, charge, chargeDesc, documentedSubmitted, response, msg, code, type, duration, typeDurationMap;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.chargeList));
                charge = charges[chargeIndex].value;
                chargeDesc = charge.chargeDesc;

                chargeDesc = chargeDesc.filter(function (val) {
                  return val.isGenerated !== true && val.includeInInvoice === true;
                });

                charge.totalAmount = charge.totalAmount * 100;
                charge.referenceNumber = accountRefNumber ? accountRefNumber : "";

                documentedSubmitted = true;

                charge.chargeDesc = chargeDesc.map(function (val) {
                  if (val.glCode != "60001" && val.glCode != "60002" && !["MOT_AIR"].includes(lodash_1(charge, "modeOfTransport", ""))) {
                    if (!val.documentName) {
                      documentedSubmitted = false;
                      _this.setState({ showErrorDocument: true });
                    }
                  }
                  return _extends({}, val, {
                    unitPrice: parseFloat(val.unitPrice) * 100,
                    totalRate: parseFloat(val.totalRate) * 100
                  });
                });

                if (!(documentedSubmitted === false)) {
                  _context24.next = 11;
                  break;
                }

                setTimeout(function () {
                  _this.setState({ showErrorDocument: false });
                }, 3000);
                return _context24.abrupt("return");

              case 11:
                _context24.next = 13;
                return createInvoiceFromChargeList(charge);

              case 13:
                response = _context24.sent;
                msg = lodash_1(response, "data.eventMessage.msg", "");
                code = lodash_1(response, "data.eventMessage.code", 0);
                type = lodash_1(response, "data.eventMessage.type", '');

                _this.callGetChargeListWithDelay(1);

                if (!(code === 200 || msg === "Invoice generated successfully")) {
                  _context24.next = 26;
                  break;
                }

                _this.setInfoMessages("successMsg", "Invoice created successfully.");
                _this.setState({ selectedDropDownData: [] });
                _context24.next = 23;
                return new Promise(function (resolve) {
                  return resolve(true);
                });

              case 23:
                return _context24.abrupt("return", _context24.sent);

              case 26:
                duration = void 0;
                typeDurationMap = {
                  CHASSIS: 12000,
                  INVOICE_DOCUMENT: 7000
                };

                if (code === 400) {
                  duration = typeDurationMap[type];
                  _this.setInfoMessages("errorMsg", msg, duration);
                }

              case 29:
                _context24.next = 31;
                return new Promise(function (resolve) {
                  return resolve(false);
                });

              case 31:
                return _context24.abrupt("return", _context24.sent);

              case 32:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this2);
      }));

      return function (_x29, _x30) {
        return _ref25.apply(this, arguments);
      };
    }();

    _this.addChargeToInvoice = function () {
      var _ref26 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(chargeListIndex, lineItemIndex) {
        var charges, charge, includeInInvoice;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.chargeList));
                charge = charges[chargeListIndex].value.chargeDesc[lineItemIndex];
                includeInInvoice = lodash_1(charge, "includeInInvoice", false);

                if (includeInInvoice) {
                  delete charges[chargeListIndex].value.chargeDesc[lineItemIndex].includeInInvoice;
                } else {
                  charges[chargeListIndex].value.chargeDesc[lineItemIndex].includeInInvoice = true;
                }
                _context25.next = 6;
                return _this.updateState({ chargeList: [].concat(toConsumableArray(charges)) });

              case 6:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this2);
      }));

      return function (_x31, _x32) {
        return _ref26.apply(this, arguments);
      };
    }();

    _this.addAllChargeToInvoice = function () {
      var _ref27 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(chargeListIndex) {
        var charges;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.chargeList));

                lodash_1(charges[chargeListIndex], "value.chargeDesc", []).map(function (v, k) {
                  var includeInInvoice = lodash_1(v, "includeInInvoice", false);
                  if (includeInInvoice) {
                    delete charges[chargeListIndex].value.chargeDesc[k].includeInInvoice;
                  } else {
                    if (lodash_1(v, "isGenerated", false) === false) {
                      charges[chargeListIndex].value.chargeDesc[k].includeInInvoice = true;
                    }
                  }
                });
                _context26.next = 4;
                return _this.updateState({ chargeList: [].concat(toConsumableArray(charges)) });

              case 4:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this2);
      }));

      return function (_x33) {
        return _ref27.apply(this, arguments);
      };
    }();

    _this.setSelectedInvoice = function (params, identfier) {
      var _this$state2 = _this.state,
          selectedData = _this$state2.selectedData,
          paidInvoice = _this$state2.paidInvoice;

      if (identfier === "checked") {
        _this.setState({ selectedData: [].concat(toConsumableArray(selectedData), [params]) });
      } else {
        var copySelected = selectedData;
        var index = copySelected.indexOf(params);
        copySelected.splice(index, 1);
        _this.setState({ selectedData: copySelected });
      }
    };

    _this.setPaidInvice = function () {

      return new Promise(function () {
        var _ref28 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(resolve) {
          var selectedData, pendingInvoices;
          return regeneratorRuntime.wrap(function _callee27$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  _context27.prev = 0;
                  _context27.next = 3;
                  return _this.updateState({ fetchPendingTabInvoices: true });

                case 3:
                  selectedData = _this.state.selectedData;

                  if (!(selectedData.length > 0)) {
                    _context27.next = 8;
                    break;
                  }

                  _context27.next = 7;
                  return drayagePaidInvoice({
                    containerId: selectedData,
                    isDrayInvoice: false
                  });

                case 7:
                  pendingInvoices = _context27.sent;

                case 8:
                  _context27.next = 10;
                  return _this.updateState({
                    selectedData: [],
                    fetchPendingTabInvoices: false
                  });

                case 10:
                  _this.getPendingTabData(1);
                  resolve(true);
                  _context27.next = 19;
                  break;

                case 14:
                  _context27.prev = 14;
                  _context27.t0 = _context27["catch"](0);
                  _context27.next = 18;
                  return _this.updateState({
                    selectedData: [],
                    fetchPendingTabInvoices: false
                  });

                case 18:
                  resolve(true);

                case 19:
                case "end":
                  return _context27.stop();
              }
            }
          }, _callee27, _this2, [[0, 14]]);
        }));

        return function (_x35) {
          return _ref28.apply(this, arguments);
        };
      }());
    };

    _this.expandPendingCard = function (id) {
      _this.state.activePendingCard === id ? _this.updateState({
        activePendingCard: null
      }) : _this.updateState({
        activePendingCard: id
      });
    };

    _this.getPendingTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref29 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(resolve) {
          var filterPayload, pendingInvoices, pendingInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee28$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  _context28.prev = 0;
                  _context28.next = 3;
                  return _this.updateState({
                    fetchPendingTabInvoices: true
                    // isActiveTab: "PENDING",
                  });

                case 3:
                  filterPayload = new PayloadFilters(_this.state.selectedFilters).getPayload();
                  _context28.next = 6;
                  return getDrayagePendingInvoices(_extends({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_PENDING",
                    isDrayInvoice: true
                  }, filterPayload));

                case 6:
                  pendingInvoices = _context28.sent;
                  _context28.next = 9;
                  return _this.getChargelistData(page);

                case 9:
                  // for tab count
                  pendingInvoicesFiltered = lodash_1(pendingInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []) ? lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(parseInt(value.markUPAmount)) ? 0 : parseInt(value.markUPAmount),
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    }) : [];
                    var chargeDescOriginal = val.chargeDesc ? JSON.parse(JSON.stringify(val.chargeDesc)) : {};
                    delete chargeDescOriginal.chargeDesc;
                    return _extends({}, val, {
                      chargeDescOriginal: chargeDescOriginal,
                      chargeDesc: chargeDesc,
                      totalAmount: parseFloat(val.totalAmount / 100).toFixed(2)
                    });
                  });

                  console.log("PENDING Filtered Invoices", pendingInvoicesFiltered);
                  _context28.next = 13;
                  return _this.updateState({
                    pendingInvoices: pendingInvoicesFiltered,
                    fetchPendingTabInvoices: false
                  });

                case 13:
                  resolve(true);
                  _context28.next = 21;
                  break;

                case 16:
                  _context28.prev = 16;
                  _context28.t0 = _context28["catch"](0);
                  _context28.next = 20;
                  return _this.updateState({
                    pendingInvoices: [],
                    fetchPendingTabInvoices: false
                  });

                case 20:
                  resolve(true);

                case 21:
                case "end":
                  return _context28.stop();
              }
            }
          }, _callee28, _this2, [[0, 16]]);
        }));

        return function (_x37) {
          return _ref29.apply(this, arguments);
        };
      }());
    };

    _this.expandPaidCard = function (id) {
      _this.state.activePaidCard === id ? _this.updateState({
        activePaidCard: null
      }) : _this.updateState({
        activePaidCard: id
      });
    };

    _this.getPaidTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref30 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(resolve) {
          var filterPayload, paidInvoices, paidInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee29$(_context29) {
            while (1) {
              switch (_context29.prev = _context29.next) {
                case 0:
                  _context29.prev = 0;
                  _context29.next = 3;
                  return _this.updateState({
                    fetchPaidTabInvoices: true
                    // isActiveTab: "PAID",
                  });

                case 3:
                  filterPayload = new PayloadFilters(_this.state.selectedFilters).getPayload();
                  _context29.next = 6;
                  return getDrayagePaidInvoices(_extends({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_PAID",
                    isDrayInvoice: true
                  }, filterPayload));

                case 6:
                  paidInvoices = _context29.sent;
                  _context29.next = 9;
                  return _this.getChargelistData(page);

                case 9:
                  // for tab count
                  paidInvoicesFiltered = lodash_1(paidInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []) ? lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(parseInt(value.markUPAmount)) ? 0 : parseInt(value.markUPAmount),
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    }) : [];
                    var chargeDescOriginal = val.chargeDesc ? JSON.parse(JSON.stringify(val.chargeDesc)) : {};
                    delete chargeDescOriginal.chargeDesc;
                    return _extends({}, val, {
                      chargeDescOriginal: chargeDescOriginal,
                      chargeDesc: chargeDesc,
                      totalAmount: parseFloat(val.totalAmount / 100).toFixed(2)
                    });
                  });

                  console.log("PAIDF", paidInvoicesFiltered);
                  _context29.next = 13;
                  return _this.updateState({
                    paidInvoices: paidInvoicesFiltered,
                    fetchPaidTabInvoices: false
                  });

                case 13:
                  resolve(true);
                  _context29.next = 21;
                  break;

                case 16:
                  _context29.prev = 16;
                  _context29.t0 = _context29["catch"](0);
                  _context29.next = 20;
                  return _this.updateState({
                    paidInvoices: [],
                    fetchPaidTabInvoices: false
                  });

                case 20:
                  resolve(true);

                case 21:
                case "end":
                  return _context29.stop();
              }
            }
          }, _callee29, _this2, [[0, 16]]);
        }));

        return function (_x39) {
          return _ref30.apply(this, arguments);
        };
      }());
    };

    _this.expandRejectedCard = function (id) {
      _this.state.activeRejectedCard === id ? _this.updateState({
        activeRejectedCard: null
      }) : _this.updateState({
        activeRejectedCard: id
      });
    };

    _this.getRejectedTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref31 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(resolve) {
          var rejectedInvoices, rejectedInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee30$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  _context30.prev = 0;
                  _context30.next = 3;
                  return _this.updateState({
                    fetchRejectedTabInvoices: true
                    // isActiveTab: "REJECTED",
                  });

                case 3:
                  _context30.next = 5;
                  return getDrayageRejectedInvoices({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_REJECTED",
                    isDrayInvoice: true
                  });

                case 5:
                  rejectedInvoices = _context30.sent;
                  _context30.next = 8;
                  return _this.getChargelistData(page);

                case 8:
                  // for tab count
                  rejectedInvoicesFiltered = lodash_1(rejectedInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(parseInt(value.markUPAmount)) ? 0 : parseInt(value.markUPAmount),
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    });
                    return _extends({}, val, {
                      chargeDesc: chargeDesc,
                      totalAmount: parseFloat(val.totalAmount / 100).toFixed(2)
                    });
                  });
                  _context30.next = 11;
                  return _this.updateState({
                    rejectedInvoices: rejectedInvoicesFiltered,
                    fetchRejectedTabInvoices: false
                  });

                case 11:
                  resolve(true);
                  _context30.next = 19;
                  break;

                case 14:
                  _context30.prev = 14;
                  _context30.t0 = _context30["catch"](0);
                  _context30.next = 18;
                  return _this.updateState({
                    rejectedInvoices: [],
                    fetchRejectedTabInvoices: false
                  });

                case 18:
                  resolve(true);

                case 19:
                case "end":
                  return _context30.stop();
              }
            }
          }, _callee30, _this2, [[0, 14]]);
        }));

        return function (_x41) {
          return _ref31.apply(this, arguments);
        };
      }());
    };

    _this.expandPartiallyPaidCard = function (id) {
      _this.state.activePartiallyPaidCard === id ? _this.updateState({
        activePartiallyPaidCard: null
      }) : _this.updateState({
        activePartiallyPaidCard: id
      });
    };

    _this.getPartiallyPaidTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref32 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31(resolve) {
          var filterPayload, requestPayload, partiallyPaidInvoices, tabCount, partiallyPaidInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee31$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  _context31.prev = 0;

                  // await this.updateState({
                  //   fetchPartiallyPaidTabInvoices: true,
                  //   isActiveTab: "PARTIALLY PAID",
                  // });
                  filterPayload = new PayloadFilters(_this.state.selectedFilters).getPayload();
                  requestPayload = _extends({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_PARTIALLY_PAID",
                    isDrayInvoice: true
                  }, filterPayload);
                  _context31.next = 5;
                  return getDrayagePartiallyPaidInvoices(requestPayload);

                case 5:
                  partiallyPaidInvoices = _context31.sent;
                  _context31.next = 8;
                  return getDrayageTabCount(requestPayload);

                case 8:
                  tabCount = _context31.sent;
                  _context31.next = 11;
                  return _this.updateState({
                    tabCount: _extends({}, tabCount.data.eventMessage)
                  });

                case 11:
                  partiallyPaidInvoicesFiltered = lodash_1(partiallyPaidInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []) ? lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(value.markUPAmount) ? 0 : value.markUPAmount,
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    }) : [];

                    var objReturn = _extends({}, val, {
                      chargeDesc: val.chargeDesc ? _extends({}, val.chargeDesc, {
                        chargeDesc: chargeDesc,
                        totalAmount: parseFloat(lodash_1(val, "chargeDesc.totalAmount", 0) / 100).toFixed(2)
                      }) : {}
                    });

                    return objReturn;
                  });
                  _context31.next = 14;
                  return _this.updateState({
                    partiallyPaidInvoices: partiallyPaidInvoicesFiltered,
                    fetchPartiallyPaidTabInvoices: false
                  });

                case 14:
                  resolve(true);
                  _context31.next = 22;
                  break;

                case 17:
                  _context31.prev = 17;
                  _context31.t0 = _context31["catch"](0);
                  _context31.next = 21;
                  return _this.updateState({
                    partiallyPaidInvoices: [],
                    fetchPartiallyPaidTabInvoices: false
                  });

                case 21:
                  resolve(true);

                case 22:
                case "end":
                  return _context31.stop();
              }
            }
          }, _callee31, _this2, [[0, 17]]);
        }));

        return function (_x43) {
          return _ref32.apply(this, arguments);
        };
      }());
    };

    _this.handleFilterChange = function (key, value) {
      if (value) {
        _this.setState(function (state) {
          return _extends({}, state, {
            selectedFilters: _extends({}, state.selectedFilters, defineProperty({}, key, value))
          });
        }, function () {
          _this.handleFetchInvoicesForActiveTab();
        });
      } else {
        _this.setState(function (state) {
          if (lodash_1(state, "selectedFilters[" + key + "]", false)) {
            delete state.selectedFilters[key];
          }
          return _extends({}, state);
        }, function () {
          _this.handleFetchInvoicesForActiveTab();
        });
      }
    };

    _this.handleFetchInvoicesForActiveTab = function () {
      var isActiveTab = _this.state.isActiveTab;

      var TAB_CALLBACKS = {
        PENDING: _this.getPendingTabData,
        DISPUTED: _this.getDisputedData,
        PAID: _this.getPaidTabData,
        "CHARGE_LIST": _this.getChargelistData,
        "PARTIALLY PAID": _this.getPartiallyPaidTabData
      };

      var callBack = lodash_1(TAB_CALLBACKS, "" + isActiveTab, false);
      if (callBack) {
        callBack();
      }
    };

    _this.handleChargeListMenuCLicked = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return _this.updateState({
                isActiveTab: "CHARGE_LIST"
              });

            case 2:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32, _this2);
    }));
    _this.handlePendingInvoicesMenuCLicked = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33() {
      return regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return _this.updateState({
                isActiveTab: "PENDING"
              });

            case 2:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33, _this2);
    }));
    _this.handlePartiallyPaidMenuCLicked = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34() {
      return regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return _this.updateState({
                isActiveTab: "PARTIALLY PAID"
              });

            case 2:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34, _this2);
    }));
    _this.handlePaidInvoicesMenuCLicked = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee35() {
      return regeneratorRuntime.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return _this.updateState({
                isActiveTab: "PAID"
              });

            case 2:
            case "end":
              return _context35.stop();
          }
        }
      }, _callee35, _this2);
    }));
    _this.handleDisputedMenuCLicked = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee36() {
      return regeneratorRuntime.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return _this.updateState({
                isActiveTab: "DISPUTED"
              });

            case 2:
            case "end":
              return _context36.stop();
          }
        }
      }, _callee36, _this2);
    }));


    _this.state = {
      chargeListType: "isOpen",
      chargeList: [],
      disputed: [],
      fetchDisputed: false,
      activeDisputedCard: null,
      fetchChargeList: false,
      activeChargeListCard: null,
      chargesOptions: [],
      disputeChargeOptions: [],
      errorMsg: "",
      successMsg: "",
      fetchPendingTabInvoices: false,
      fetchPaidTabInvoices: false,
      fetchPartiallyPaidTabInvoices: false,
      fetchRejectedTabInvoices: false,
      pendingInvoices: [],
      paidInvoices: [],
      partiallyPaidInvoices: [],
      rejectedInvoices: [],
      activePendingCard: null,
      activePaidCard: null,
      activePartiallyPaidCard: null,
      activeRejectedCard: null,
      selectedData: [],
      copyData: [],
      selectedBillToParties: {},
      invoiceChargeListData: [],
      selectedDropDownData: [],
      isActiveTab: "CHARGE_LIST",
      pageNumber: 1,
      rejectToChargeList: false,
      sendKeyword: "",
      activeIndex: 0,
      nonEditableGlCodes: [],
      partnerId: "",
      unitPriceVal: 0,
      uom: "",
      tabCount: {},
      disputeResolvedError: "",
      showErrorDocument: false,
      needDocumentForResolve: false,
      paidExcelReport: false,
      openModal: false,
      selectedFilters: {}
    };
    _this.HandlecallbackKeyword = _this.HandlecallbackKeyword.bind(_this);
    return _this;
  }

  createClass(DrayageInvoices, [{
    key: "componentDidMount",
    value: function () {
      var _ref38 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee37() {
        var getkxUser, partnerId;
        return regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return getKxUser();

              case 2:
                getkxUser = _context37.sent;
                partnerId = lodash_1(getkxUser, "data.eventMessage.userInfo.partnerId", "");
                _context37.next = 6;
                return this.updateState({ partnerId: partnerId });

              case 6:

                this.props.invoiceContainer !== "" && this.setState({ chargeListType: "isReleased" });

              case 7:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function componentDidMount() {
        return _ref38.apply(this, arguments);
      }

      return componentDidMount;
    }()
    /***************
     *
     * DISPUTED TAB RELEATED CODE START
     */


    /***************
     * DISPUTED TAB RELEATED CODE ENDS
     *
     ***************/

    /**
     * CHARGELIST RELATED CODE BEGINS
     */

    /**
     * CHARGELIST RELATED CODE ENDS
     */

    /*****************************************
     * PENDING TAB FUNCTION START
     *****************************************/

    /*****************************************
     * PENDING TAB FUNCTION ENDS
     *****************************************/

    /*****************************************
     * PAID TAB FUNCTION
     *****************************************/


    /*****************************************
     * PAID TAB FUNCTION ENDS
     *****************************************/

    /****************************************
     * REJECTED TAB FUNCTION STARS
     ****************************************/

    /****************************************
     * REJECTED TAB FUNCTION ENDS
     ****************************************/

    /****************************************
     * PARTIALLY PAID TAB FUNCTION STARTS
     *************************************/


    /**********************************
     * PARTIALLY PAID TAB FUNCTION ENDS
     ********************************/

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          data = _props.data,
          totalListEl = _props.totalListEl,
          userData = _props.userData;
      var activeIndex = this.state.activeIndex;

      var panes = Object.keys(ActiveTabs).map(function (val, index) {
        var Component$$1 = ActiveTabs[val].Component;
        if (val === "charge-list") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index, onClick: _this3.handleChargeListMenuCLicked },
              ActiveTabs[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.chargeListTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  chargeListType: _this3.state.chargeListType,
                  fetchChargeList: _this3.state.fetchChargeList,
                  chargeList: _this3.state.chargeList,
                  updateState: _this3.updateState,
                  getChargelistData: _this3.getChargelistData,
                  editChargeListCharge: _this3.editChargeListCharge,
                  activeCard: _this3.state.activeChargeListCard,
                  expandChargeListCard: _this3.expandChargeListCard,
                  updateChargeListLineItem: _this3.updateChargeListLineItem,
                  addNewCharge: _this3.addNewCharge,
                  deleteChargeLineItem: _this3.deleteChargeLineItem,
                  cancelChargeListEdit: _this3.cancelChargeListEdit,
                  saveChargeListData: _this3.saveChargeListData,
                  chargesOptions: _this3.state.chargesOptions,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  createInvoice: _this3.createInvoice,
                  addChargeToInvoice: _this3.addChargeToInvoice,
                  addAllChargeToInvoice: _this3.addAllChargeToInvoice,
                  selectedBillToParties: _this3.state.selectedBillToParties,
                  invoiceChargeListData: _this3.state.invoiceChargeListData,
                  selectedDropdownData: _this3.selectedDropdownData,
                  nonEditableGlCodes: _this3.state.nonEditableGlCodes,
                  unitPriceVal: _this3.state.unitPriceVal,
                  uom: _this3.state.uom,
                  selectedCharge: _this3.selectedCharge,
                  unitPriceValue: _this3.unitPriceValue,
                  totalCount: lodash_1(_this3.state, "tabCount.chargeListTabCount", 0)
                })
              );
            }
          };
        } else if (val === "pending") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index, onClick: _this3.handlePendingInvoicesMenuCLicked },
              ActiveTabs[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.pendingTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchPendingTabInvoices: _this3.state.fetchPendingTabInvoices,
                  invoices: _this3.state.pendingInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getPendingTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activePendingCard,
                  expandCard: _this3.expandPendingCard,
                  getFormatedDate: getFormatedDate,
                  getCountryNameAndImage: getCountryNameAndImage,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  setSelectedInvoice: _this3.setSelectedInvoice,
                  setPaidInvice: _this3.setPaidInvice,
                  userTypes: _this3.props.userType,
                  totalCount: lodash_1(_this3.state, "tabCount.pendingTabCount", 0)
                })
              );
            }
          };
        } else if (val === "paid") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index, onClick: _this3.handlePaidInvoicesMenuCLicked },
              ActiveTabs[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.paidTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(
                  Button,
                  { className: "ui primary button", onClick: function onClick() {
                      return _this3.setState({ paidExcelReport: true });
                    } },
                  "Export Excel"
                ),
                _this3.state.paidExcelReport && React__default.createElement(DownloadExcelReport, { partnerId: _this3.state.partnerId, onClose: _this3.closePaidExcelReportModal }),
                React__default.createElement(Component$$1, {
                  fetchPaidTabInvoices: _this3.state.fetchPaidTabInvoices,
                  invoices: _this3.state.paidInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getPaidTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activePaidCard,
                  expandCard: _this3.expandPaidCard,
                  getFormatedDate: getFormatedDate,
                  getCountryNameAndImage: getCountryNameAndImage,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  getFormatedPaidDate: _this3.getFormatedPaidDate,
                  totalCount: lodash_1(_this3.state, "tabCount.paidTabCount", 0),
                  paidExcelReport: _this3.state.paidExcelReport
                })
              );
            }
          };
        } else if (val === "partially-paid") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index, onClick: _this3.handlePartiallyPaidMenuCLicked },
              ActiveTabs[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.partiallyPaidCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchPartiallyPaidTabInvoices: _this3.state.fetchPartiallyPaidTabInvoices,
                  invoices: _this3.state.partiallyPaidInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getPartiallyPaidTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activePartiallyPaidCard,
                  expandCard: _this3.expandPartiallyPaidCard,
                  getFormatedDate: getFormatedDate,
                  getCountryNameAndImage: getCountryNameAndImage,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  totalCount: lodash_1(_this3.state, "tabCount.partiallyPaidCount", 0)
                })
              );
            }
          };
        } else if (val === "disputed") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index, onClick: _this3.handleDisputedMenuCLicked },
              ActiveTabs[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.disputeTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchDisputed: _this3.state.fetchDisputed,
                  disputed: _this3.state.disputed,
                  updateState: _this3.updateState,
                  getDisputedData: _this3.getDisputedData,
                  editDisputedCharge: _this3.editDisputedCharge,
                  activeCard: _this3.state.activeDisputedCard,
                  expandDisputedCard: _this3.expandDisputedCard,
                  updateDisputedLineItem: _this3.updateDisputedLineItem,
                  addDisputedNewCharge: _this3.addDisputedNewCharge,
                  deleteDisputedItem: _this3.deleteDisputedItem,
                  cancelDisputedEdit: _this3.cancelDisputedEdit,
                  saveDisputedData: _this3.saveDisputedData,
                  chargesOptions: _this3.state.chargesOptions,
                  disputeChargeOptions: _this3.state.disputeChargeOptions,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  selectedBillToParties: _this3.state.selectedBillToParties,
                  invoiceChargeListData: _this3.state.invoiceChargeListData,
                  selectedDropdownData: _this3.selectedDropdownData,
                  nonEditableGlCodes: _this3.state.nonEditableGlCodes,
                  unitPriceVal: _this3.state.unitPriceVal,
                  uom: _this3.state.uom,
                  selectedCharge: _this3.selectedCharge,
                  unitPriceValue: _this3.unitPriceValue,
                  resolveDisputeRequest: _this3.resolveDisputeRequest,
                  disputeResolvedError: _this3.state.disputeResolvedError,
                  totalCount: lodash_1(_this3.state, "tabCount.disputeTabCount", 0),
                  deleteChargeLineItemForDisputedTab: _this3.deleteChargeLineItemForDisputedTab
                })
              );
            }
          };
        } else {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index },
              ActiveTabs[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.rejectedTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchRejectedTabInvoices: _this3.state.fetchRejectedTabInvoices,
                  invoices: _this3.state.rejectedInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getRejectedTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activeRejectedCard,
                  expandCard: _this3.expandRejectedCard,
                  getFormatedDate: getFormatedDate,
                  getCountryNameAndImage: getCountryNameAndImage,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  goToChargelist: _this3.goToChargelist
                })
              );
            }
          };
        }
      });

      return React__default.createElement(
        "div",
        null,
        React__default.createElement(
          ModalProvider,
          null,
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "div",
              {
                className: "drayage-invoices-container drayage-partner",
                style: {
                  paddingTop: "90px"
                }
              },
              React__default.createElement(
                "div",
                { className: "drayage-partner-search-box-and-filter-container" },
                React__default.createElement(DrayageInvoiceSearchbar, {
                  sendKeyword: this.state.sendKeyword,
                  sendKeywordFun: this.sendKeywordFun,
                  callbackKeyword: this.HandlecallbackKeyword,
                  invoiceContainer: this.props.invoiceContainer
                }),
                React__default.createElement(Filters, {
                  activeTab: this.state.isActiveTab,
                  onChange: this.handleFilterChange,
                  selectedFilters: this.state.selectedFilters
                })
              ),
              React__default.createElement(
                Container,
                { fluid: true },
                React__default.createElement(
                  "div",
                  { className: "drayage-title" },
                  "Invoices"
                ),
                React__default.createElement("div", { className: "drayage-country-date" }),
                React__default.createElement(Tab, {
                  className: "drayage-tabs",
                  activeIndex: activeIndex,
                  onTabChange: this.handleTabChange,
                  panes: panes
                })
              )
            )
          ),
          React__default.createElement(CustomModal, null),
          this.state.showErrorDocument && React__default.createElement(
            "div",
            { className: "isgeneraed-in showErrorDocument" },
            React__default.createElement(
              Message,
              { color: "red" },
              "Unable to create invoice. Document not uploaded against accessorial fees"
            )
          ),
          this.state.needDocumentForResolve && React__default.createElement(
            "div",
            { className: "isgeneraed-in showErrorDocument" },
            React__default.createElement(
              Message,
              { color: "red" },
              "Upload documents to resolve dispute."
            )
          )
        )
      );
    }
  }]);
  return DrayageInvoices;
}(Component);

var FeesInput = function (_Component) {
    inherits(FeesInput, _Component);

    function FeesInput(props) {
        classCallCheck(this, FeesInput);

        var _this = possibleConstructorReturn(this, (FeesInput.__proto__ || Object.getPrototypeOf(FeesInput)).call(this, props));

        _this.handleInputChange = function (e) {
            var value = e.target.value;

            var feesVal = value.trim();
            _this.setState({ feesPaidValue: feesVal });
        };

        _this.state = {
            feesPaidValue: ''
        };
        return _this;
    }

    createClass(FeesInput, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var eventDescription = this.props.eventDescription;


            if (eventDescription) {
                this.setState({ feesPaidValue: eventDescription / 100 });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                handleFeesUpdate = _props.handleFeesUpdate,
                entityId = _props.entityId,
                eventName = _props.eventName,
                eventCode = _props.eventCode,
                type = _props.type,
                commentEntityEventId = _props.commentEntityEventId,
                selectedTime = _props.selectedTime,
                entityType = _props.entityType;
            var feesPaidValue = this.state.feesPaidValue;


            return React__default.createElement(
                React__default.Fragment,
                null,
                React__default.createElement(Input$1, { type: "number", label: '$', labelPosition: "left", style: { height: "29px", border: "1px solid green", margin: "0", padding: "0", borderRadius: "3px" }, onChange: this.handleInputChange, value: feesPaidValue, defaultValue: feesPaidValue }),
                React__default.createElement(
                    "div",
                    { className: "button-container" },
                    React__default.createElement(
                        "button",
                        {
                            style: { width: "29px", height: "29px" },
                            className: "ui primary button",
                            onClick: function onClick(e) {
                                return handleFeesUpdate(e, entityId, eventName, eventCode, type, feesPaidValue, selectedTime, entityType, commentEntityEventId);
                            }
                        },
                        "Y"
                    )
                )
            );
        }
    }]);
    return FeesInput;
}(Component);

var TextInput = function (_Component) {
    inherits(TextInput, _Component);

    function TextInput(props) {
        classCallCheck(this, TextInput);

        var _this = possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

        _this.handleInputChange = function (e) {
            var value = e.target.value;

            _this.setState({ eventValue: value });
        };

        _this.state = {
            eventValue: ""
        };
        return _this;
    }

    createClass(TextInput, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var eventDescription = this.props.eventDescription;


            if (eventDescription) {
                this.setState({ eventValue: eventDescription });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                handleInputChange = _props.handleInputChange,
                eventCode = _props.eventCode,
                entityId = _props.entityId,
                eventName = _props.eventName,
                type = _props.type,
                selectedTime = _props.selectedTime,
                entityType = _props.entityType,
                commentEntityEventId = _props.commentEntityEventId;
            var eventValue = this.state.eventValue;


            return React__default.createElement(
                React__default.Fragment,
                null,
                React__default.createElement(Input$1, { type: "text", labelPosition: "left", style: { height: "29px", border: "1px solid green", margin: "0", padding: "0", borderRadius: "3px" }, onChange: this.handleInputChange, value: eventValue, defaultValue: eventValue }),
                React__default.createElement(
                    "div",
                    { className: "button-container" },
                    React__default.createElement(
                        "button",
                        {
                            style: { width: "29px", height: "29px" },
                            className: "ui primary button",
                            onClick: function onClick(e) {
                                return handleInputChange(e, entityId, eventName, eventCode, type, eventValue, selectedTime, entityType, commentEntityEventId);
                            }
                        },
                        "Y"
                    )
                )
            );
        }
    }]);
    return TextInput;
}(Component);

var KnConfirmationModal = function (_Component) {
    inherits(KnConfirmationModal, _Component);

    function KnConfirmationModal(props) {
        classCallCheck(this, KnConfirmationModal);

        var _this = possibleConstructorReturn(this, (KnConfirmationModal.__proto__ || Object.getPrototypeOf(KnConfirmationModal)).call(this, props));

        _this.state = {};
        return _this;
    }

    createClass(KnConfirmationModal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                openModal = _props.openModal,
                _onClose = _props.onClose,
                _onOpen = _props.onOpen,
                handleConfirmation = _props.handleConfirmation;


            return React__default.createElement(
                Modal,
                {
                    size: 'tiny',
                    onClose: function onClose() {
                        return _onClose();
                    },
                    onOpen: function onOpen() {
                        return _onOpen();
                    },
                    open: openModal
                },
                React__default.createElement(
                    Modal.Header,
                    null,
                    this.props.header
                ),
                React__default.createElement(
                    Modal.Content,
                    { scrolling: true, style: { width: "100%" } },
                    this.props.content
                ),
                React__default.createElement(
                    Modal.Actions,
                    null,
                    React__default.createElement(
                        'button',
                        {
                            onClick: function onClick() {
                                return handleConfirmation(true);
                            },
                            className: 'simpleButton primaryButton',
                            type: 'submit'
                        },
                        'Yes'
                    ),
                    React__default.createElement(
                        'button',
                        {
                            onClick: function onClick() {
                                return handleConfirmation(false);
                            },
                            className: 'simpleButton secondaryButton',
                            type: 'submit'
                        },
                        'No'
                    )
                )
            );
        }
    }]);
    return KnConfirmationModal;
}(Component);

var ContainerModal = function (_Component) {
  inherits(ContainerModal, _Component);

  function ContainerModal(props) {
    var _this2 = this;

    classCallCheck(this, ContainerModal);

    var _this = possibleConstructorReturn(this, (ContainerModal.__proto__ || Object.getPrototypeOf(ContainerModal)).call(this, props));

    _this.componentDidMount = function () {
      var drayageAssignedPartner = _this.mapShipmentAsPerCustomerCode(get(_this.props, "selectedContainerInfo.entityShipmentList", []));

      _this.fetchCancelDetails();
      {
        window._env_.APP_NAME === "Partner" ? _this.fetchTruckers() : _this.fetchPartners(drayageAssignedPartner);
      }
    };

    _this.componentDidUpdate = function (prevProps, prevState) {
      if (!isEqual(get(prevProps, "selectedContainerInfo.entityId", ""), get(_this.props, "selectedContainerInfo.entityId", ""))) {
        var drayageAssignedPartner = _this.mapShipmentAsPerCustomerCode(get(_this.props, "selectedContainerInfo.entityShipmentList", []));

        {
          window._env_.APP_NAME === "Partner" ? _this.fetchTruckers() : _this.fetchPartners(drayageAssignedPartner);
        }
      }
    };

    _this.mapShipmentAsPerCustomerCode = function (entityShipmentList) {
      var groupedShipments = groupBy(entityShipmentList, function (item) {
        // Extract the shipment code from the shipmentId
        var shipmentCode = get(item, "shipmentId", "").split('-')[1];
        return shipmentCode;
      });

      var mappedArray = [];

      for (var code in groupedShipments) {
        var shipmentIds = groupedShipments[code].map(function (item) {
          return item.shipmentId;
        });
        var newEntry = {
          code: code,
          allShipmentIds: shipmentIds,
          allShipmentInfo: [].concat(toConsumableArray(groupedShipments[code]))
        };

        mappedArray.push(newEntry);
      }

      return mappedArray;
    };

    _this.findUtcOffset = function (timezone) {
      var s = timezone.substr(3); // Get rid of UTC, s= "+05:00"
      var sign = s[0]; // "+""
      var x = s.substr(1, 2) * 60 + parseInt(s.substr(4, 5));
      return sign + x;
    };

    _this.timeZoneConverter = function (value, source) {
      var entityTimezone = _this.props.entityTimezone;

      var time = new Date(value).getTime();

      if (!isEmpty(entityTimezone)) {
        _this.setState({ modelEvent: "OPS" });
        var localTime = moment$1(value);
        var timeZoneTime = moment$1(value).tz(entityTimezone);
        var modifiedDate = moment$1(value);

        modifiedDate.subtract(-localTime.utcOffset() + timeZoneTime.utcOffset(), "minutes");
        if (source === "OPS") {
          _this.setState({ opsTime: modifiedDate.valueOf(), newOpsTime: time });
        } else {
          _this.setState({
            demurrageTime: modifiedDate.valueOf(),
            newDemurrageTime: time
          });
        }
      } else {
        _this.setState({ opsTime: time });
      }
    };

    _this.timeZoneReverse = function (value) {
      if (!isEmpty(value) && !isUndefined(value)) {
        var entityTimezone = _this.props.entityTimezone;

        if (!isEmpty(entityTimezone)) {
          var parsedTime = parseInt(value);
          // string time zone logic
          var localTime = moment$1(parsedTime);
          var timeZoneTime = moment$1(parsedTime).tz(entityTimezone);
          var modifiedDate = moment$1(parsedTime);
          modifiedDate.subtract(localTime.utcOffset() - timeZoneTime.utcOffset(), "minutes");
          return modifiedDate.valueOf();
        }
      }
    };

    _this.getSelectedTime = function () {
      var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var time = "";
      if (!isEmpty(identifier) && identifier.sourceSelected) {
        if (identifier.sourceSelected === "OPS") {
          time = identifier.OPSTime;
        } else if (identifier.sourceSelected === "TMODAL" && identifier.OPSTime) {
          time = identifier.tModalTime;
        } else if (identifier.sourceSelected === "EMODAL" && identifier.OPSTime) {
          time = identifier.eModalTime;
        } else if (identifier.sourceSelected === "P44" && identifier.OPSTime) {
          time = identifier.p44Time;
        }
      }
      return time;
    };

    _this.handleState = function (e, key, value, id) {
      var _this$setState;

      var handleParentState = _this.props.handleParentState;

      e.preventDefault();
      e.stopPropagation();
      _this.setState((_this$setState = {}, defineProperty(_this$setState, key, value), defineProperty(_this$setState, "isContainerLayout", true), defineProperty(_this$setState, "entityId", id), _this$setState));
      handleParentState(id);
    };

    _this.openDateCalendar = function () {
      _this.setState({ showSystemTime: false });
    };

    _this.renderApiCallForHoldFees = function (e, _ref) {
      var commentEntityEventId = _ref.commentEntityEventId,
          entityId = _ref.entityId,
          type = _ref.type,
          time = _ref.time,
          eventName = _ref.eventName,
          entityType = _ref.entityType;

      e.persist();
      setTimeout(function () {
        _this.triggerApiCall(e, {
          entityId: entityId,
          eventName: "CONTAINER_HOLDS",
          eventCode: "NO_HOLD",
          eventDescription: "",
          sourceSelected: "OPS",
          selectedTime: 0,
          entityType: "WORKFLOW_ENTITY_TYPE_CONTAINER",
          commentEntityEventId: commentEntityEventId
        });
      }, 500);

      setTimeout(function () {
        _this.triggerApiCall(e, {
          entityId: entityId,
          eventName: "CONTAINER_FEES",
          eventCode: "NO_DUES",
          eventDescription: "",
          sourceSelected: "OPS",
          selectedTime: 0,
          entityType: "WORKFLOW_ENTITY_TYPE_CONTAINER",
          commentEntityEventId: commentEntityEventId
        });
      }, 500);
    };

    _this.selectModelTime = function (e, _ref2) {
      var entityId = _ref2.entityId,
          type = _ref2.type,
          time = _ref2.time,
          eventName = _ref2.eventName,
          entityType = _ref2.entityType,
          selectedType = _ref2.selectedType,
          holdStatus = _ref2.holdStatus,
          feesStatus = _ref2.feesStatus,
          commentEntityEventId = _ref2.commentEntityEventId;

      console.log("selectedType", selectedType);
      if (selectedType === "grounded") {
        var res = holdStatus === "NO_HOLD" || holdStatus === "ON_HOLD" || feesStatus === "NO_DUES" || feesStatus === "FEES_DUE" || feesStatus === "FEES_PAID" ? "" : _this.renderApiCallForHoldFees(e, {
          commentEntityEventId: commentEntityEventId,
          entityId: entityId,
          type: type,
          time: time,
          eventName: eventName,
          entityType: entityType
        });
        _this.triggerApiCall(e, {
          entityId: entityId,
          eventName: eventName,
          eventCode: "",
          eventDescription: "",
          sourceSelected: type,
          selectedTime: time,
          entityType: entityType,
          commentEntityEventId: commentEntityEventId
        });
      } else {
        _this.triggerApiCall(e, {
          entityId: entityId,
          eventName: eventName,
          eventCode: "",
          eventDescription: "",
          sourceSelected: type,
          selectedTime: time,
          entityType: entityType,
          commentEntityEventId: commentEntityEventId
        });
      }
    };

    _this.selectCustomTime = function (date) {
      _this.setState({ selectedDate: date });
    };

    _this.selectCustomTime2 = function (date) {
      _this.setState({ selectedDate2: date });
    };

    _this.showSystemTimeFunc = function (_ref3) {
      var fieldName = _ref3.fieldName;

      _this.setState({ showSystemTime: true, selectedField: fieldName });
    };

    _this.updateReasonField = function (_ref4) {
      var key = _ref4.key,
          value = _ref4.value;

      _this.setState(defineProperty({}, key, value));
    };

    _this.getSelectedDemurrageTime = function () {
      var identifire = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var time = "";
      if (!isEmpty(identifire) && identifire.sourceSelected) {
        time = identifire.OPSTime2;
      }
      return time;
    };

    _this.getSelectedLdfTime = function () {
      var time = "";
      if (!isEmpty(_this.props.selectedContainerInfo) && _this.props.selectedContainerInfo.demurrageEnd) {
        time = _this.props.selectedContainerInfo.demurrageEnd;
      }
      return time;
    };

    _this.epochToUtc = function (epoch) {
      epoch = Number(epoch);
      var entityTimezone = _this.props.selectedContainerInfo.entityTimezone;

      var newDate = isEmpty(entityTimezone) ? moment(epoch) : moment(epoch).tz(entityTimezone, true); //sets timezone without changing the date/time
      console.log("newDate", epoch, moment(epoch).toString(), newDate.toString(), epoch, entityTimezone, newDate.utc().toString(), newDate.utc().valueOf());
      return newDate.utc().valueOf(); // converts to utc and then to epoch
    };

    _this.triggerApiCall = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments[1];
      var _this$props = _this.props,
          getEntityTime = _this$props.getEntityTime,
          getListOfContainers = _this$props.getListOfContainers,
          selectedFilter = _this$props.selectedFilter,
          getAccordianBody = _this$props.getAccordianBody,
          containerChecked = _this$props.containerChecked,
          triggerLoader = _this$props.triggerLoader,
          isDray = _this$props.isDray;

      var apiParamData = _extends({}, params);

      apiParamData.selectedTime = Number(apiParamData.selectedTime);
      apiParamData.selectedTime2 = Number(apiParamData.selectedTime2);
      apiParamData.isDray = isDray;

      if (!params.skipTzConversion) {
        if (apiParamData.selectedTime && (apiParamData.sourceSelected === "OPS" || apiParamData.sourceSelected === "P44" || apiParamData.sourceSelected === "TMODAL" || apiParamData.sourceSelected === "EMODAL")) apiParamData.selectedTime = apiParamData.selectedTime;
      }

      if (apiParamData.selectedTime2) apiParamData.selectedTime2 = _this.epochToUtc(apiParamData.selectedTime2);

      var entityId = params.entityId;

      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        isMarkDone: false,
        isNewLoading: true,
        showGroundPopuop: false,
        isHoldsStuck: false,
        isFeesStuck: false,
        showLineReleasePopuop: false,
        showReadyPickup: false,
        showGateOut: false,
        showGateIn: false
        // showMsg: true,
      });

      containerChecked && containerChecked.length > 1 && setTimeout(function () {
        triggerLoader();
      }, 6000);

      if (containerChecked.length > 1) delete apiParamData.commentEntityEventId;

      return getEntityTime(apiParamData).then(function (res) {
        _this.setState({ showMessageString: res.data.eventMessage.value, showMsg: true });
        if (selectedFilter === "container") getListOfContainers(true, entityId, false);else if (selectedFilter === "vessel") getAccordianBody(_this.props.indexRowClicked, true, "vessel");else if (selectedFilter === "port") getAccordianBody(_this.props.indexRowClicked, true, "port");

        setTimeout(function () {
          _this.setState({ visible: false, showMsg: false });
        }, 3000);
        _this.setState({
          selectedDate: null,
          loading: false,
          isNewLoading: false
        });
      }).catch(function () {
        _this.setState({
          selectedDate: null,
          loading: false,
          isNewLoading: false
        });
      });
    };

    _this.handleRadioSelectionEvent = function (e, entityId, eventName, eventCode, type, selectedTime) {
      var entityType = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "";
      var commentEntityEventId = arguments[7];

      e.preventDefault();
      e.stopPropagation();
      e.persist();

      _this.triggerApiCall(e, {
        entityId: entityId,
        eventName: eventName,
        eventCode: eventCode,
        eventDescription: "",
        sourceSelected: type,
        selectedTime: selectedTime,
        entityType: entityType,
        commentEntityEventId: commentEntityEventId
      });

      if (eventCode === "NO_HOLD") {
        setTimeout(function () {
          _this.triggerApiCall(e, {
            entityId: entityId,
            eventName: "CONTAINER_FEES",
            eventCode: "NO_DUES",
            eventDescription: "",
            sourceSelected: type,
            selectedTime: selectedTime,
            entityType: "WORKFLOW_ENTITY_TYPE_CONTAINER",
            commentEntityEventId: commentEntityEventId
          });
        }, 500);
      } else {
        setTimeout(function () {
          _this.triggerApiCall(e, {
            entityId: entityId,
            eventName: "CONTAINER_HOLDS",
            eventCode: "NO_HOLD",
            eventDescription: "",
            sourceSelected: type,
            selectedTime: selectedTime,
            entityType: "WORKFLOW_ENTITY_TYPE_CONTAINER",
            commentEntityEventId: commentEntityEventId
          });
        }, 500);
      }
    };

    _this.renderCalendar = function (_ref5) {
      var selectedField = _ref5.selectedField,
          stateInfo = _ref5.stateInfo,
          eventName = _ref5.eventName,
          entityIdData = _ref5.entityIdData,
          OPSTime = _ref5.OPSTime,
          OPSTime2 = _ref5.OPSTime2,
          eModalTime = _ref5.eModalTime,
          tModalTime = _ref5.tModalTime,
          p44Time = _ref5.p44Time,
          entityId = _ref5.entityId,
          entityTimezone = _ref5.entityTimezone,
          fieldName = _ref5.fieldName,
          entityType = _ref5.entityType,
          isEnable = _ref5.isEnable,
          hold = _ref5.hold,
          fees = _ref5.fees,
          proofOfGateIn = _ref5.proofOfGateIn,
          displayName = _ref5.displayName,
          commentEntityEventId = _ref5.commentEntityEventId,
          drayagePartner = _ref5.drayagePartner;
      return isEnable && React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(Calendar, {
          selectCustomTime: _this.selectCustomTime,
          selectedDate2: _this.getSelectedDemurrageTime(stateInfo),
          selectedDate3: _this.getSelectedLdfTime()
          // selectedDate3={this.props.selectedContainerInfo.demurrageEnd}
          , showSystemTimeFunc: function showSystemTimeFunc() {
            return _this.showSystemTimeFunc({ fieldName: fieldName });
          },
          selectedDate: _this.getSelectedTime(stateInfo),
          calendarIdentifire: fieldName,
          eventName: eventName,
          triggerApiCall: _this.triggerApiCall,
          handleState: _this.handleState,
          entityIdData: entityIdData,
          OPSTime: OPSTime,
          OPSTime2: OPSTime2,
          eModalTime: eModalTime,
          tModalTime: tModalTime,
          p44Time: p44Time,
          entityId: entityId,
          entityTimezone: entityTimezone,
          entityType: entityType,
          selectedField: selectedField,
          holdStatus: hold,
          feesStatus: fees,
          renderApiCallForHoldFees: _this.renderApiCallForHoldFees,
          userType: _this.props.userType,
          proofOfGateIn: proofOfGateIn,
          displayName: displayName,
          commentEntityEventId: commentEntityEventId,
          isArchived: _this.props.isArchived,
          epochToUtc: _this.epochToUtc,
          drayagePartner: _this.props.isDray,
          gateOutInfo: _this.props.selectedContainerInfo['gateOut'],
          gateInInfo: _this.props.selectedContainerInfo['gateIn']
        })
      );
    };

    _this.holdsAndFeesApiHandler = function () {
      var _ref6 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, entityId, eventName, eventCode, type, isSourceSelected, selectedTime) {
        var entityType = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var status = arguments[8];
        var commentEntityEventId = arguments[9];

        var _this$state, _this$state$holdsReas, holdsReasonValue, _this$state$feesReaso, feesReasonValue, newFeesVal, eventDescription;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log({eventCode});
                // console.log({status});
                e.preventDefault();
                e.stopPropagation();
                _this.setState({
                  isMarkDone: false,
                  isNewLoading: true,
                  isHoldsStuck: false,
                  isFeesStuck: false,
                  showGroundPopuop: false,
                  showLineReleasePopuop: false,
                  showReadyPickup: false,
                  showGateOut: false,
                  showGateIn: false
                });
                _this$state = _this.state, _this$state$holdsReas = _this$state.holdsReasonValue, holdsReasonValue = _this$state$holdsReas === undefined ? "" : _this$state$holdsReas, _this$state$feesReaso = _this$state.feesReasonValue, feesReasonValue = _this$state$feesReaso === undefined ? "" : _this$state$feesReaso;
                newFeesVal = !isEmpty(feesReasonValue) ? (feesReasonValue * 100).toString() : "";
                eventDescription = !isEmpty(holdsReasonValue) ? holdsReasonValue : newFeesVal;


                _this.setState({ isContainerLayout: true, isFeesYesChecked: false });
                _context.next = 9;
                return _this.triggerApiCall(e, {
                  entityId: entityId,
                  eventName: eventName,
                  eventCode: eventCode,
                  eventDescription: eventDescription,
                  sourceSelected: type,
                  selectedTime: selectedTime,
                  entityType: entityType,
                  commentEntityEventId: commentEntityEventId
                });

              case 9:
                _this.setState({ holdsReasonValue: "", feesReasonValue: "" });

                if (eventCode === "ON_HOLD" && status === "HOLD_NONE") {
                  setTimeout(function () {
                    _this.triggerApiCall(e, {
                      entityId: entityId,
                      eventName: "CONTAINER_FEES",
                      eventCode: "NO_DUES",
                      eventDescription: "",
                      sourceSelected: type,
                      selectedTime: selectedTime,
                      entityType: "WORKFLOW_ENTITY_TYPE_CONTAINER",
                      commentEntityEventId: commentEntityEventId
                    });
                  }, 500);
                } else if (eventCode === "FEES_DUE" && status === "FEES_NONE") {
                  setTimeout(function () {
                    _this.triggerApiCall(e, {
                      entityId: entityId,
                      eventName: "CONTAINER_HOLDS",
                      eventCode: "NO_HOLD",
                      eventDescription: "",
                      sourceSelected: type,
                      selectedTime: selectedTime,
                      entityType: "WORKFLOW_ENTITY_TYPE_CONTAINER",
                      commentEntityEventId: commentEntityEventId
                    });
                  }, 500);
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x5, _x6, _x7, _x8, _x9, _x10, _x11) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.getCurrentTime = function () {
      var time = new Date().getTime();
      var convertedTime = _this.convertEpochToDate(time);
      _this.setState({ doneTime: convertedTime });
    };

    _this.renderReasonTextArea = function (_ref7) {
      var isSourceSelected = _ref7.isSourceSelected,
          holdsReasonValue = _ref7.holdsReasonValue,
          entityId = _ref7.entityId,
          eventName = _ref7.eventName,
          eventCode = _ref7.eventCode,
          entityType = _ref7.entityType,
          type = _ref7.type,
          feesReasonValue = _ref7.feesReasonValue,
          status = _ref7.status,
          commentEntityEventId = _ref7.commentEntityEventId;
      return React__default.createElement(
        "div",
        { className: "holds-reason" },
        React__default.createElement(
          "div",
          { className: "headerLabel" },
          type === "hold" ? "Reason for hold" : "Fees due"
        ),
        React__default.createElement(
          "div",
          { className: "flexDisplay" },
          React__default.createElement(
            "div",
            { className: "rightSpace" },
            React__default.createElement("input", {
              type: "text",
              placeholder: type === "hold" ? "Add description" : "Enter Amount",
              value: type === "hold" ? holdsReasonValue : feesReasonValue,
              onChange: function onChange(_ref8) {
                var value = _ref8.target.value;
                return _this.updateReasonField({
                  key: type === "hold" ? "holdsReasonValue" : "feesReasonValue",
                  value: value
                });
              }
            })
          ),
          React__default.createElement(
            "div",
            { className: "button-container" },
            React__default.createElement(
              "button",
              {
                className: "ui primary button",
                onClick: function onClick(e) {
                  return (type === "hold" ? holdsReasonValue : feesReasonValue) && _this.holdsAndFeesApiHandler(e, entityId, eventName, eventCode, "OPS", isSourceSelected, 0, entityType, status, commentEntityEventId);
                }
              },
              "Y"
            )
          ),
          React__default.createElement(Button, {
            icon: "angle double left",
            className: "iconClass",
            onClick: function onClick() {
              if (type === "hold") {
                _this.setState({ isHoldYesChecked: false });
              } else {
                _this.setState({ isFeesYesChecked: false });
              }
            }
          })
        )
      );
    };

    _this.renderRadioButton = function (_ref9) {
      var isSourceSelected = _ref9.isSourceSelected,
          entityId = _ref9.entityId,
          name = _ref9.name,
          onClickEventName = _ref9.onClickEventName,
          eventName = _ref9.eventName,
          state = _ref9.state,
          entityType = _ref9.entityType,
          commentEntityEventId = _ref9.commentEntityEventId;
      return React__default.createElement(
        "form",
        null,
        React__default.createElement(
          "span",
          { className: "holds-form" },
          React__default.createElement(
            "label",
            null,
            React__default.createElement("input", {
              type: "radio",
              name: name,
              onClick: function onClick(e) {
                return _this.handleState(e, onClickEventName, true, entityId);
              }
            }),
            " ",
            "Yes"
          )
        ),
        React__default.createElement(
          "span",
          { className: "holds-form" },
          React__default.createElement(
            "label",
            null,
            React__default.createElement("input", {
              type: "radio",
              name: name,
              className: "isChecked",
              onClick: function onClick(e) {
                return _this.handleRadioSelectionEvent(e, entityId, eventName, state, "OPS", 0, entityType, commentEntityEventId);
              }
            }),
            " ",
            "No"
          )
        )
      );
    };

    _this.renderRadioButton2 = function (_ref10) {
      var isSourceSelected = _ref10.isSourceSelected,
          entityId = _ref10.entityId,
          name = _ref10.name,
          onClickEventName = _ref10.onClickEventName,
          eventName = _ref10.eventName,
          state = _ref10.state,
          entityType = _ref10.entityType,
          status = _ref10.status;
      return React__default.createElement(
        "form",
        null,
        React__default.createElement(
          "span",
          { className: "holds-form" },
          React__default.createElement(
            "label",
            null,
            React__default.createElement("input", {
              type: "radio",
              name: name,
              onClick: function onClick(e) {
                return _this.handleState(e, onClickEventName, true, entityId);
              }
            }),
            " ",
            "Yes"
          )
        )
      );
    };

    _this.renderTextStatus = function (_ref11) {
      var entityId = _ref11.entityId,
          eventName = _ref11.eventName,
          _ref11$entityType = _ref11.entityType,
          entityType = _ref11$entityType === undefined ? "" : _ref11$entityType,
          eventDescription = _ref11.eventDescription,
          isSourceSelected = _ref11.isSourceSelected,
          text = _ref11.text,
          showButton = _ref11.showButton,
          eventCode = _ref11.eventCode,
          fieldName = _ref11.fieldName,
          status = _ref11.status,
          commentEntityEventId = _ref11.commentEntityEventId;

      var propsToPass = {
        entityId: entityId,
        eventName: eventName,
        type: "OPS",
        commentEntityEventId: commentEntityEventId,
        selectedTime: 0,
        entityType: entityType
      };

      return React__default.createElement(
        Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "flexDisplay" },
          React__default.createElement(
            "div",
            { className: "rightSpace textStyle" },
            text
          ),
          showButton && React__default.createElement(
            "div",
            { className: "button-container" },
            React__default.createElement(
              "button",
              {
                className: "ui primary button",
                onClick: function onClick(e) {
                  return _this.holdsAndFeesApiHandler(e, entityId, eventName, eventCode, "OPS", isSourceSelected, 0, entityType, commentEntityEventId);
                }
              },
              "Y"
            )
          )
        ),
        fieldName === "fees" && (status === "FEES_DUE" || status === "FEES_PAID") ? !isEmpty(eventDescription) && (_this.props.userType === "OPS_USER" ? React__default.createElement(
          "div",
          { className: "rightSpace textStyle", style: { display: "flex", alignItems: "center", gap: "20px" } },
          React__default.createElement(FeesInput, _extends({}, propsToPass, { eventCode: status, handleFeesUpdate: _this.handleFeesUpdate, eventDescription: eventDescription }))
        ) : React__default.createElement(
          "div",
          { className: "rightSpace textStyle" },
          "$",
          eventDescription / 100
        )) : fieldName === "holds" && (status === "ON_HOLD" || status === "HOLD_REMOVED") && !isEmpty(eventDescription) && _this.props.userType !== "DRAY_PARTNER" ? React__default.createElement(
          "div",
          { className: "rightSpace textStyle", style: { display: "flex", alignItems: "center", gap: "20px" } },
          React__default.createElement(TextInput, _extends({}, propsToPass, { eventCode: status, handleInputChange: _this.handleInputChange, eventDescription: eventDescription }))
        ) : !isEmpty(eventDescription) && React__default.createElement(
          "div",
          { className: "rightSpace textStyle" },
          eventDescription
        )
      );
    };

    _this.renderRadioFields = function (_ref12) {
      var status = _ref12.status,
          isSourceSelected = _ref12.isSourceSelected,
          entityId = _ref12.entityId,
          eventName = _ref12.eventName,
          eventDescription = _ref12.eventDescription,
          entityType = _ref12.entityType,
          isHoldYesChecked = _ref12.isHoldYesChecked,
          holdsReasonValue = _ref12.holdsReasonValue,
          isFeesYesChecked = _ref12.isFeesYesChecked,
          feesReasonValue = _ref12.feesReasonValue,
          fieldName = _ref12.fieldName,
          commentEntityEventId = _ref12.commentEntityEventId;

      if (
      // status === "NO_HOLD" ||
      // status === "HOLD_REMOVED" ||
      status === "ON_HOLD" ||
      // status === "NO_DUES" ||
      status === "FEES_DUE"
      // status === "FEES_PAID"
      ) {
          return _this.renderTextStatus({
            entityId: entityId,
            eventName: eventName,
            entityType: entityType,
            eventDescription: eventDescription,
            isSourceSelected: isSourceSelected,
            text: statusTextMapping[status],
            showButton: status === "ON_HOLD" || status === "FEES_DUE",
            eventCode: status === "ON_HOLD" ? "HOLD_REMOVED" : status === "FEES_DUE" ? "FEES_PAID" : "",
            fieldName: fieldName,
            status: status,
            commentEntityEventId: commentEntityEventId
          });
        } else if (status === "HOLD_NONE") {
        if (isHoldYesChecked) {
          return _this.renderReasonTextArea({
            isSourceSelected: isSourceSelected,
            holdsReasonValue: holdsReasonValue,
            entityId: entityId,
            eventName: eventName,
            eventCode: "ON_HOLD",
            entityType: entityType,
            type: "hold",
            status: status,
            commentEntityEventId: commentEntityEventId
          });
        }
        return _this.renderRadioButton({
          isSourceSelected: isSourceSelected,
          entityId: entityId,
          name: "holds",
          onClickEventName: "isHoldYesChecked",
          eventName: eventName,
          state: "NO_HOLD",
          entityType: entityType,
          commentEntityEventId: commentEntityEventId
        });
      } else if (status === "FEES_NONE") {
        if (isFeesYesChecked) {
          return _this.renderReasonTextArea({
            isSourceSelected: isSourceSelected,
            feesReasonValue: feesReasonValue,
            entityId: entityId,
            eventName: eventName,
            eventCode: "FEES_DUE",
            entityType: entityType,
            type: "fees",
            status: status,
            commentEntityEventId: commentEntityEventId
          });
        }
        return _this.renderRadioButton({
          isSourceSelected: isSourceSelected,
          entityId: entityId,
          name: "fees",
          onClickEventName: "isFeesYesChecked",
          eventName: eventName,
          state: "NO_DUES",
          entityType: entityType,
          commentEntityEventId: commentEntityEventId
        });
      } else if (status === "NO_DUES" || status === "FEES_PAID") {
        if (isFeesYesChecked) {
          return _this.renderReasonTextArea({
            isSourceSelected: isSourceSelected,
            feesReasonValue: feesReasonValue,
            entityId: entityId,
            eventName: eventName,
            eventCode: "FEES_DUE",
            entityType: entityType,
            type: "fees",
            status: status,
            commentEntityEventId: commentEntityEventId
          });
        }
        return _this.renderRadioButton2({
          isSourceSelected: isSourceSelected,
          entityId: entityId,
          name: "fees",
          onClickEventName: "isFeesYesChecked",
          eventName: eventName,
          state: "NO_DUES",
          entityType: entityType
        });
      } else if (status === "NO_HOLD" || status === "HOLD_REMOVED") {
        if (isHoldYesChecked) {
          return _this.renderReasonTextArea({
            isSourceSelected: isSourceSelected,
            holdsReasonValue: holdsReasonValue,
            entityId: entityId,
            eventName: eventName,
            eventCode: "ON_HOLD",
            entityType: entityType,
            type: "hold",
            status: status,
            commentEntityEventId: commentEntityEventId
          });
        }
        return _this.renderRadioButton2({
          isSourceSelected: isSourceSelected,
          entityId: entityId,
          name: "holds",
          onClickEventName: "isHoldYesChecked",
          eventName: eventName,
          state: "NO_HOLD",
          entityType: entityType
        });
      }
    };

    _this.renderStateTimeSeriesInfo = function (_ref13) {
      var OPSTime = _ref13.OPSTime,
          OPSTime2 = _ref13.OPSTime2,
          eModalTime = _ref13.eModalTime,
          tModalTime = _ref13.tModalTime,
          p44Time = _ref13.p44Time,
          modalIdentifire = _ref13.modalIdentifire,
          entityId = _ref13.entityId,
          entityIdData = _ref13.entityIdData,
          eventName = _ref13.eventName,
          convertEpochToDate = _ref13.convertEpochToDate,
          sourceSelected = _ref13.sourceSelected,
          entityType = _ref13.entityType,
          selectedField = _ref13.selectedField,
          entityTimezone = _ref13.entityTimezone,
          stateInfo = _ref13.stateInfo,
          hold = _ref13.hold,
          fees = _ref13.fees,
          proofOfGateIn = _ref13.proofOfGateIn,
          commentEntityEventId = _ref13.commentEntityEventId;
      return React__default.createElement(
        Fragment,
        null,
        React__default.createElement(StateTimeSeriesModal, {
          OPSTime: OPSTime,
          OPSTime2: OPSTime2,
          eModalTime: eModalTime,
          tModalTime: tModalTime,
          p44Time: p44Time,
          modalIdentifire: modalIdentifire,
          entityId: entityId,
          entityIdData: entityIdData,
          eventName: eventName,
          selectModelTime: _this.selectModelTime,
          convertEpochToDate: convertEpochToDate,
          sourceSelected: sourceSelected,
          entityType: entityType,
          selectedField: selectedField,
          selectedDate2: _this.getSelectedDemurrageTime(stateInfo),
          triggerApiCall: _this.triggerApiCall,
          openDateCalendar: _this.openDateCalendar,
          entityTimezone: entityTimezone,
          epochToUtc: _this.epochToUtc,
          holdStatus: hold,
          feesStatus: fees,
          commentEntityEventId: commentEntityEventId,
          proofOfGateIn: proofOfGateIn,
          isDray: _this.props.isDray
        })
      );
    };

    _this.computeStaticText = function (_ref14) {
      var sourceSelected = _ref14.sourceSelected,
          eModalTime = _ref14.eModalTime,
          tModalTime = _ref14.tModalTime,
          p44Time = _ref14.p44Time,
          OPSTime = _ref14.OPSTime,
          convertEpochToDate = _ref14.convertEpochToDate,
          entityTimezone = _ref14.entityTimezone;

      var text = void 0;
      switch (sourceSelected) {
        case "OPS":
          if (!isEmpty(OPSTime)) {
            text = convertEpochToDate(OPSTime, false, true, entityTimezone).concat(" (K)");
          }
          break;
        case "TMODAL":
          if (!isEmpty(tModalTime)) {
            text = convertEpochToDate(tModalTime, false, true, entityTimezone).concat(" (T)");
          }
          break;
        case "P44":
          if (!isEmpty(p44Time)) {
            text = convertEpochToDate(p44Time, false, true, entityTimezone).concat(" (P44)");
          }
          break;
        case "EMODAL":
          if (!isEmpty(eModalTime)) {
            text = convertEpochToDate(eModalTime, false, true, entityTimezone).concat(" (E)");
          }
          break;
        default:
          text = "";
      }
      return text;
    };

    _this.handleDismiss = function () {
      _this.setState({ visible: false, showMsg: false });
    };

    _this.shouldShowThisField = function (fieldName) {
      if (window._env_.APP_NAME === "Partner") {
        if (fieldName === "terminalPickupAppointment" || fieldName === "warehousePickupAppointment" || fieldName === "terminalDropAppointment" || fieldName === "warehouseDropAppointment" || fieldName === "gateOut" || fieldName === "gateIn") {
          return true;
        } else {
          return false;
        }
      }
      return true;
    };

    _this.cancelRequest = function (e) {
      _this.state.requestCancelReason === "Other (specify in comment)" && _this.state.requestCancelComment === "None" ? _this.setState({ requiredComment: true }) : requestCancellation(_this.props.selectedContainerInfo.entityId, _this.props.selectedContainerInfo.shipmentIds, _this.state.requestCancelReason, _this.state.requestCancelComment, _this.props.selectedContainerInfo.portName).then(function (response) {
        console.log(response);
        _this.setState({ cancelRequestSubmitted: true, showMsg: true, loading: true });
        _this.fetchCancelDetails();
        setTimeout(function () {
          _this.setState({ visible: false, showMsg: false });
        }, 2000);
      }).catch(function (err) {
        console.log(err);
      });
    };

    _this.selectPartner = function (e) {
      editPartner(_this.props.selectedContainerInfo.entityId, _this.props.selectedContainerInfo.shipmentIds, _this.state.availablePartnerID).then(function (response) {
        console.log(response);
        _this.setState({ cancelRequestSubmitted: true, showMsg: true, loading: true });
        _this.fetchCancelDetails();
        setTimeout(function () {
          _this.setState({ visible: false, showMsg: false });
        }, 2000);
        _this.props.getListOfContainers();
      }).catch(function (err) {
        console.log(err);
      });
    };

    _this.truckerOption = [{
      key: "PICKUP",
      text: "PICKUP",
      value: "PICKUP"
    }, {
      key: "RETURN",
      text: "RETURN",
      value: "RETURN"
    }];

    _this.fetchPartners = function (drayageAssignedPartner) {
      var apiCalls = drayageAssignedPartner.map(function (partner) {
        var shipmentIds = partner.allShipmentIds.join(",");

        return requestPartner(shipmentIds, _this.props.selectedContainerInfo.entityId);
      });

      Promise.all(apiCalls).then(function (response) {
        // Update drayagePartnerAssigned with the API responses
        var updatedDrayagePartnerAssigned = drayageAssignedPartner.map(function (partner, index) {

          var data = [].concat(toConsumableArray(_this.state.drayageAssignedPartner));
          var input = response[index].data.eventMessage.availablePartners;
          input && input.map(function (item, index) {
            var laneList = get(item, 'laneList', []);
            laneList.map(function (v) {
              var partnerName = get(item, 'partnerName', '');
              var lane = get(v, 'lane', '');
              var opportunityPartnerId = get(item, 'opportunityPartnerId', '');
              var destinationId = get(v, 'destinationId', '');
              var sourceId = get(v, 'sourceId', '');
              var laneId = get(v, 'laneId', '');
              data.push({
                text: partnerName + " ( " + lane + " ) (LANE - " + laneId + ")",
                value: opportunityPartnerId,
                destinationId: destinationId,
                laneId: laneId,
                sourceId: sourceId
              });
            });
          });

          if (get(_this.props, "selectedContainerInfo.gateIn.sourceSelected", false) !== "OPS") data.push({
            text: 'None',
            value: 0,
            destinationId: '',
            sourceId: ''
          });

          var partnerInfoMap = data.reduce(function (map, _ref15) {
            var value = _ref15.value,
                destinationId = _ref15.destinationId,
                sourceId = _ref15.sourceId;

            map[value] = { opportunityPartnerId: value, destinationId: destinationId, sourceId: sourceId };
            return map;
          }, {});

          return _extends({}, partner, {
            partnerInfoMap: partnerInfoMap,
            dropdownResult: data
          });
        });

        _this.setState({ drayageAssignedPartner: updatedDrayagePartnerAssigned });
      }).catch(function (error) {
        console.error("Error fetching data:", error);
      });
    };

    _this.requestPartnerAssignment = function (e, item) {
      var shipmentIds = get(item, "allShipmentIds", []).join(",");
      var selectedPartnerId = get(item, "selectedPartnerId", null);

      assignPartner(shipmentIds, _this.props.selectedContainerInfo.entityId, get(item, "partnerInfoMap[" + selectedPartnerId + "]")).then(function (response) {
        console.log("Partner", response);
        _this.setState({ showMsg: true, drayageAssignMessage: response.data.eventMessage.response });
        setTimeout(function () {
          _this.setState({ visible: false, showMsg: false });
          _this.props.closeContainerModal();
        }, 2000);
        _this.props.containerList();
      }).catch(function (err) {
        console.log(err);
      });
    };

    _this.fetchTruckers = function (e) {
      requestTruckers().then(function (response) {
        var data = [];
        var input = response.data.eventMessage.truckers;
        input && input.map(function (item, index) {
          return data.push({
            text: item.user.contactName + '-' + item.phone.phoneNo,
            value: item.user.userGuid
          });
        });
        _this.setState({ truckersInfo: data });
      }).catch(function (err) {
        console.log(err);
      });
    };

    _this.requestTruckersAssignment = function (e) {
      assignTruckers(_this.props.selectedContainerInfo.shipmentIds.split(',')[0], _this.props.selectedContainerInfo.entityId, _this.state.selectedTruckerGuid, _this.state.truckerOptions).then(function (response) {
        console.log("truckers", response);
        _this.setState({ showMsg: true });
        setTimeout(function () {
          _this.setState({ visible: false, showMsg: false });
          _this.props.closeContainerModal();
        }, 2000);
        _this.props.containerList();
      }).catch(function (err) {
        console.log(err);
      });
    };

    _this.fetchCancelDetails = function () {
      window._env_.APP_NAME === "Partner" ? fetchCancellationDetails(_this.props.selectedContainerInfo.entityId, _this.props.selectedContainerInfo.shipmentIds).then(function (response) {
        _this.setState({ getRequestCancelDetails: response }, function () {
          _this.setState({ loading: false });
        });
        var data = [];
        var input = response.data.eventMessage.availablePartners;
        input && input.map(function (item, index) {
          return data.push({
            text: item.partnerName,
            value: item.opportunityPartnerId
          });
        });
        _this.setState({ availablePartner: data });
      }).catch(function (err) {
        console.log(err);
      }) : _this.props.userType === "DRAY_OPS_USER" ? fetchCancellationDetails(_this.props.selectedContainerInfo.entityId, _this.props.selectedContainerInfo.shipmentIds).then(function (response) {
        _this.setState({ getRequestCancelDetails: response }, function () {
          _this.setState({ loading: false });
        });
        var data = [];
        var input = response.data.eventMessage.availablePartners;
        input && input.map(function (item, index) {
          return data.push({
            text: item.partnerName,
            value: item.opportunityPartnerId
          });
        });
        _this.setState({ availablePartner: data });
      }).catch(function (err) {
        console.log(err);
      }) : _this.setState({ loading: false });
    };

    _this.showHistoryPopup = function () {
      _this.setState({ showCommentHistoryPopup: true });
    };

    _this.closeHistoryPopup = function () {
      _this.setState({ showCommentHistoryPopup: false });
    };

    _this.handleFeesUpdate = function () {
      var _ref16 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e, entityId, eventName, eventCode, type, feesPaidValue, selectedTime, entityType, commentEntityEventId) {
        var eventDescription;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                eventDescription = feesPaidValue ? (feesPaidValue * 100).toString() : "";

                if (!(eventCode === "FEES_DUE")) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return _this.triggerApiCall(e, { entityId: entityId, eventName: eventName, eventCode: eventCode, eventDescription: eventDescription, sourceSelected: type, selectedTime: selectedTime, entityType: entityType, commentEntityEventId: commentEntityEventId });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x13, _x14, _x15, _x16, _x17, _x18, _x19, _x20, _x21) {
        return _ref16.apply(this, arguments);
      };
    }();

    _this.handleInputChange = function () {
      var _ref17 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e, entityId, eventName, eventCode, type, eventValue, selectedTime, entityType, commentEntityEventId) {
        var eventDescription;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                eventDescription = eventValue ? eventValue.trim() : "";

                if (!(eventCode === "ON_HOLD")) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return _this.triggerApiCall(e, { entityId: entityId, eventName: eventName, eventCode: eventCode, eventDescription: eventDescription, sourceSelected: type, selectedTime: selectedTime, entityType: entityType, commentEntityEventId: commentEntityEventId });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x22, _x23, _x24, _x25, _x26, _x27, _x28, _x29, _x30) {
        return _ref17.apply(this, arguments);
      };
    }();

    _this.handleUploadDocuments = function () {
      var _this$props2 = _this.props,
          showDragAndDropModal = _this$props2.showDragAndDropModal,
          selectedContainerInfo = _this$props2.selectedContainerInfo;

      var docNames = get(selectedContainerInfo, "proofOfGateIn", "");
      showDragAndDropModal(true, "newUpload", docNames);
    };

    _this.splitProofOfGateIn = function (doc) {
      var stringArray = doc && isString(doc) ? doc.split(",") : [];
      var eirDoc = null,
          podDoc = null;


      if (!isEmpty(stringArray)) {
        var newArr = stringArray.map(function (str) {
          if (str && str.startsWith("EQUIPMENT_INTERCHANGE_RECEIPT:")) {
            eirDoc = str.split(":")[1];
          }
          if (str && str.startsWith("PROOF_OF_GATE_IN:")) {
            podDoc = str.split(":")[1];
          }
        });
      }

      return [eirDoc, podDoc];
    };

    _this.handleDropdownChange = function (index, data) {
      var updatedDrayageAssignedPartner = [].concat(toConsumableArray(_this.state.drayageAssignedPartner));
      var updatedItem = _extends({}, updatedDrayageAssignedPartner[index]);
      updatedItem.selectedPartnerId = data.value;

      updatedDrayageAssignedPartner[index] = updatedItem;
      _this.setState({
        drayageAssignedPartner: updatedDrayageAssignedPartner
      });
    };

    _this.handleConfirmationModalResponse = function (status) {
      if (status) _this.handleDropdownChange(_this.state.openConfirmationModal, { value: 0 });
      // else this.props.closeContainerModal()   //CORE-33092: Commented as user want to stay on the previous containerModal on 'NO' click...
      _this.setState({ openConfirmationModal: false });
    };

    _this.handleInlandEta = function (fieldName) {

      var entityId = get(_this.props, "selectedContainerInfo.entityId", "");
      var currentTimeZone = _this.props.getBrowserTimeZone();
      var _this$props3 = _this.props,
          selectedFilter = _this$props3.selectedFilter,
          getListOfContainers = _this$props3.getListOfContainers;

      var convertedDateTime = _this.convertToUTCWithTimezone(_this.state[fieldName], currentTimeZone);
      var payload = {
        entityId: entityId,
        stopType: "DESTINATION",
        sourceSelected: "OPS",
        selectedTime: Number(convertedDateTime),
        extContainerRef: get(_this.props, "selectedContainerInfo.extContainerRef", ""),
        destinationTimezone: currentTimeZone,
        utcTimeForInlandETA: convertedDateTime
      };
      setInlandTime(payload).then(function (response) {
        var _this$setState3;

        _this.setState({ showMessageString: get(response, "data.eventMessage.value", ""), showMsg: true });
        if (selectedFilter === "container") getListOfContainers(true, entityId, false);
        setTimeout(function () {
          _this.setState({ visible: false, showMsg: false });
        }, 3000);
        _this.setState((_this$setState3 = {}, defineProperty(_this$setState3, fieldName, 0), defineProperty(_this$setState3, "loading", false), defineProperty(_this$setState3, "isNewLoading", false), _this$setState3));
      }).catch(function (error) {
        var _this$setState4;

        console.log("Error", error);
        _this.setState((_this$setState4 = {}, defineProperty(_this$setState4, fieldName, 0), defineProperty(_this$setState4, "loading", false), defineProperty(_this$setState4, "isNewLoading", false), _this$setState4));
      });
    };

    _this.timeZoneConverterRevised = function (value, timezone) {
      var time = new Date(value).getTime();
      var epoch = Number(time);
      var newDate = isEmpty(timezone) ? moment(epoch) : moment(epoch).tz(timezone, true); //sets timezone without changing the date/time
      // console.log(
      //   "newDate",
      //   epoch,
      //   momentTz(epoch).toString(),
      //   newDate.toString(),
      //   epoch,
      //   timezone,
      //   newDate.utc().toString(),
      //   newDate.utc().valueOf()
      // );
      return newDate.utc().valueOf();
      /*
      if (!isEmpty(timezone)) {
        const localTime = moment(value);
        const timeZoneTime = moment(value).tz(timezone);
        const modifiedDate = moment(value);
         modifiedDate.subtract(- localTime.utcOffset() + timeZoneTime.utcOffset(), 'minutes');
        return time;
      } else {
        return time;
      }
        */
    };

    var _props$selectedDate = props.selectedDate2,
        selectedDate2 = _props$selectedDate === undefined ? null : _props$selectedDate;

    _this.state = {
      modelTime: null,
      modelEvent: null,
      sourceName: null,
      demurrageTime: selectedDate2,
      newDemurrageTime: "",

      showSystemTime: false,
      selectedDate: null,

      showGroundPopuop: false,
      showLineReleasePopuop: false,
      showReadyPickup: false,
      showGateOut: false,
      showGateIn: false,

      isHoldYesChecked: false,
      isHoldsStuck: false,
      holdsReasonValue: "",

      isFeesYesChecked: false,
      isFeesStuck: false,
      feesReasonValue: "",

      isContainerLayout: false,
      isNewLoading: false,
      isMarkDone: false,
      isMarkDisable: false,
      doneTime: null,
      selectedField: null,
      showMsg: false,
      visible: true,
      showMessageString: '',
      loading: true,
      getRequestCancelDetails: {},
      availablePartner: "",
      availablePartnerID: "",
      requestCancelComment: "None",
      requestCancelReason: "",
      requiredComment: false,
      showDragAndDropModal: false,
      truckersInfo: "",
      selectedTruckerGuid: "",
      truckerPhoneNumber: "",
      tuckervalidate: true,
      truckerPhoneGuid: "",
      truckerOptions: "",
      drayageAssignMessage: "",
      drayageAssignedPartner: [],
      openConfirmationModal: false,
      p44DestinationEta: 0
      // showCommentHistoryPopup: false,
    };
    return _this;
  }

  createClass(ContainerModal, [{
    key: "convertToUTCWithTimezone",
    value: function convertToUTCWithTimezone(localDate, timeZone) {
      var localTime = moment$1.tz(localDate, timeZone);

      return localTime.utc();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          convertEpochToDate = _props.convertEpochToDate,
          entityIdData = _props.entityIdData,
          selectedContainerInfo = _props.selectedContainerInfo,
          rowHeaders$$1 = _props.rowHeaders,
          closeContainerModal = _props.closeContainerModal,
          containerChecked = _props.containerChecked,
          isBulkUpdateActivate = _props.isBulkUpdateActivate,
          indexRowClicked = _props.indexRowClicked,
          getCommentPerContainer = _props.getCommentPerContainer,
          getCommentHistoryPerContainer = _props.getCommentHistoryPerContainer,
          showContainerHistoryModal = _props.showContainerHistoryModal,
          closeContainerSpecifiedModal = _props.closeContainerSpecifiedModal,
          openSpecifiedContainerModal = _props.openSpecifiedContainerModal,
          isLoadingSpecifiedModal = _props.isLoadingSpecifiedModal,
          userInitialData = _props.userInitialData,
          _state = this.state,
          showSystemTime = _state.showSystemTime,
          selectedDate = _state.selectedDate,
          isHoldYesChecked = _state.isHoldYesChecked,
          holdsReasonValue = _state.holdsReasonValue,
          feesReasonValue = _state.feesReasonValue,
          isFeesYesChecked = _state.isFeesYesChecked,
          selectedField = _state.selectedField,
          showMsg = _state.showMsg,
          showMessageString = _state.showMessageString,
          showCommentHistoryPopup = _state.showCommentHistoryPopup,
          selectedPartnerId = _state.selectedPartnerId;

      if (!selectedContainerInfo) return null;

      var isAirMode = get(selectedContainerInfo, "mot", "") === "MOT_AIR";
      var isSplitChildContainer = get(selectedContainerInfo, "parentContainerId", "");
      var isDrayagePartnerAssigned = get(this.props, "selectedContainerInfo.drayagePartner", null) && get(this.props, "selectedContainerInfo.drayagePartner", null) !== "None";
      var isPodInland = get(selectedContainerInfo, "isPodInland", false);
      var destinationTimezone = get(selectedContainerInfo, "destinationTimezone", "");

      var _splitProofOfGateIn = this.splitProofOfGateIn(get(selectedContainerInfo, "proofOfGateIn", "")),
          _splitProofOfGateIn2 = slicedToArray(_splitProofOfGateIn, 2),
          eirDoc = _splitProofOfGateIn2[0],
          podDoc = _splitProofOfGateIn2[1];
      // let isDrayageEnabled = false;
      // let entityShipmentLists = selectedContainerInfo.entityShipmentList;
      // for(let i=0; i<entityShipmentLists.length; i++) {
      //     if(entityShipmentLists[i].drayageEnabled == 1) {
      //       isDrayageEnabled = true;
      //       break;
      //     }
      // }

      var _selectedContainerInf = selectedContainerInfo.shipmentIds,
          entityType = selectedContainerInfo.entityType,
          archived = selectedContainerInfo.archived,
          _selectedContainerInf2 = selectedContainerInfo.grounded,
          grounded = _selectedContainerInf2 === undefined ? {} : _selectedContainerInf2,
          _selectedContainerInf3 = selectedContainerInfo.customReleased,
          customReleased = _selectedContainerInf3 === undefined ? {} : _selectedContainerInf3,
          _selectedContainerInf4 = selectedContainerInfo.carrierReleased,
          carrierReleased = _selectedContainerInf4 === undefined ? {} : _selectedContainerInf4,
          _selectedContainerInf5 = selectedContainerInfo.holds,
          holds = _selectedContainerInf5 === undefined ? {} : _selectedContainerInf5,
          _selectedContainerInf6 = selectedContainerInfo.fees,
          fees = _selectedContainerInf6 === undefined ? {} : _selectedContainerInf6,
          _selectedContainerInf7 = selectedContainerInfo.readyForPickup,
          readyForPickup = _selectedContainerInf7 === undefined ? {} : _selectedContainerInf7,
          _selectedContainerInf8 = selectedContainerInfo.terminalPickupAppointment,
          terminalPickupAppointment = _selectedContainerInf8 === undefined ? {} : _selectedContainerInf8,
          _selectedContainerInf9 = selectedContainerInfo.terminalDropAppointment,
          terminalDropAppointment = _selectedContainerInf9 === undefined ? {} : _selectedContainerInf9,
          _selectedContainerInf10 = selectedContainerInfo.warehouseDropAppointment,
          warehouseDropAppointment = _selectedContainerInf10 === undefined ? {} : _selectedContainerInf10,
          _selectedContainerInf11 = selectedContainerInfo.warehousePickupAppointment,
          warehousePickupAppointment = _selectedContainerInf11 === undefined ? {} : _selectedContainerInf11,
          _selectedContainerInf12 = selectedContainerInfo.gateOut,
          gateOut = _selectedContainerInf12 === undefined ? {} : _selectedContainerInf12,
          _selectedContainerInf13 = selectedContainerInfo.gateIn,
          gateIn = _selectedContainerInf13 === undefined ? {} : _selectedContainerInf13,
          _selectedContainerInf14 = selectedContainerInfo.done;

      var isSourceSelected = grounded.sourceSelected !== "ENTITY_SOURCE_NONE" && grounded.OPSTime;
      var gateInWarningMsg = "The Gate-In Date must be later than or equal to the Gate-Out Date. Please adjust the Gate-In Date accordingly";
      var gateOutWarningMsg = "The Gate-Out Date must be earlier than or equal to the Gate-In Date. Please adjust the Gate-In Date accordingly";

      var isCustomReleased = customReleased.sourceSelected && customReleased.sourceSelected !== "ENTITY_SOURCE_NONE";
      var isCarrierReleased = carrierReleased.sourceSelected && carrierReleased.sourceSelected !== "ENTITY_SOURCE_NONE";
      var isReadyForPickup = readyForPickup.sourceSelected && readyForPickup.sourceSelected !== "ENTITY_SOURCE_NONE";
      // let isTerminalPickupAppointment  = terminalPickupAppointment.sourceSelected && terminalPickupAppointment.sourceSelected !== 'ENTITY_SOURCE_NONE';

      var isGateOut = gateOut.sourceSelected && gateOut.sourceSelected !== "ENTITY_SOURCE_NONE" && gateOut.OPSTime !== undefined;

      var isTerminalAppointment = terminalPickupAppointment.sourceSelected && terminalPickupAppointment.sourceSelected !== "ENTITY_SOURCE_NONE";

      var isDeliveryAppointment = terminalDropAppointment.sourceSelected && terminalDropAppointment.sourceSelected !== "ENTITY_SOURCE_NONE";

      var isTerminalReturnApp = warehousePickupAppointment.sourceSelected && warehousePickupAppointment.sourceSelected !== "ENTITY_SOURCE_NONE";

      var isActualDelivery = warehouseDropAppointment.sourceSelected && warehouseDropAppointment.sourceSelected !== "ENTITY_SOURCE_NONE";

      // let isWarehousePickupAppointment  = warehousePickupAppointment.sourceSelected && warehousePickupAppointment.sourceSelected !== 'ENTITY_SOURCE_NONE';

      var isGateIn = gateIn.sourceSelected && gateIn.sourceSelected !== "ENTITY_SOURCE_NONE";
      // let isSourceSelected  = grounded.sourceSelected && grounded.sourceSelected !== 'ENTITY_SOURCE_NONE';
      var isReadyForPickupEnable = isSourceSelected;
      //   && isCustomReleased && isCarrierReleased
      //   &&( holds.holdStatus === 'NO_HOLD'  || holds.holdStatus === 'HOLD_REMOVED')
      //  && (fees.feesStatus === 'FEES_PAID' || fees.feesStatus === 'NO_DUES');

      var cuurentHoldStatus = holds.holdStatus;
      var currentFeesStatus = fees.feesStatus;

      var isTerminalAppointmentEnable = void 0;
      var isGateOutEnable = void 0;
      var isDeliveryAppointmentEnable = void 0;
      var isActualDeliveryEnable = void 0;
      var isTerminalReturnAppEnable = void 0;
      var isGateInEnable = void 0;

      isTerminalAppointmentEnable = isAirMode || isReadyForPickupEnable && isReadyForPickup;
      //let isGateOutEnable =isReadyForPickupEnable && isReadyForPickup && isTerminalAppointment && isTerminalAppointmentEnable && isDeliveryAppointment && isDeliveryAppointmentEnable && isActualDeliveryEnable && isActualDelivery && isTerminalReturnAppEnable && isTerminalReturnApp;
      isGateOutEnable = isReadyForPickup && isReadyForPickupEnable;
      isDeliveryAppointmentEnable = this.props.userType === "DRAY_OPS_USER" && get(this.props, "selectedContainerInfo.drayagePartner", null) && get(this.props, "selectedContainerInfo.drayagePartner", null) !== "None" ? isReadyForPickup && isReadyForPickupEnable : isGateOut && isGateOutEnable;
      isActualDeliveryEnable = isGateOut && isGateOutEnable;
      isTerminalReturnAppEnable = isGateOut && isGateOutEnable;
      isGateInEnable = (isCarrierReleased || isAirMode || isSplitChildContainer) && isReadyForPickupEnable && isReadyForPickup && isGateOutEnable && isGateOut;

      var entityId = selectedContainerInfo.entityId,
          entityTimezone = selectedContainerInfo.entityTimezone,
          commentEntityEventId = selectedContainerInfo.commentEntityEventId,
          entityShipmentList = selectedContainerInfo.entityShipmentList,
          containerComment = selectedContainerInfo.containerComment,
          drayagePartner = selectedContainerInfo.drayagePartner;

      var shipmentId = entityShipmentList[0].shipmentId;

      var containerEntityId = isBulkUpdateActivate && Array.isArray(containerChecked) ? containerChecked : entityId;

      var arrayOfMessages = showMessageString.split(',').filter(function (message) {
        return message.includes("Failed: Entity Event Handling");
      });
      var arrayOfEntityId = arrayOfMessages.map(function (msg) {
        return msg.split(':')[0];
      });

      var reasonForCancellation = [{
        key: 'Driver capacity issue',
        text: 'Driver capacity issue',
        value: 'Driver capacity issue'
      }, {
        key: 'Mechanical failure',
        text: 'Mechanical failure',
        value: 'Mechanical failure'
      }, {
        key: 'Chassis shortage',
        text: 'Chassis shortage',
        value: 'Chassis shortage'
      }, {
        key: 'Weather condition',
        text: 'Weather condition',
        value: 'Weather condition'
      }, {
        key: 'Driver personal reason',
        text: 'Driver personal reason',
        value: 'Driver personal reason'
      }, {
        key: 'Other (specify in comment)',
        text: 'Other (specify in comment)',
        value: 'Other (specify in comment)'
      }];

      if (this.props.userType === "CUSTOMER" && openSpecifiedContainerModal) {
        if (isLoadingSpecifiedModal === true) {
          return React__default.createElement(
            "div",
            { className: "newContainerModal" },
            React__default.createElement(Icon, {
              className: "crossIcon",
              name: "close large",
              onClick: function onClick() {
                return closeContainerSpecifiedModal();
              }
            }),
            React__default.createElement(
              "h3",
              null,
              "Loading..."
            )
          );
        }

        return React__default.createElement(
          "div",
          { className: "newContainerModal" },
          React__default.createElement(Icon, {
            className: "crossIcon",
            name: "close large",
            onClick: function onClick() {
              return closeContainerSpecifiedModal();
            }
          }),
          React__default.createElement(
            "h3",
            { className: "modal_header" },
            containerEntityId.toString()
          ),
          showCommentHistoryPopup && React__default.createElement(CommentHistoryModal, {
            getCommentHistoryPerContainer: getCommentHistoryPerContainer,
            closeHistoryPopup: this.closeHistoryPopup,
            entityId: entityId,
            commentEntityEventId: commentEntityEventId,
            userType: this.props.userType,
            userInitialData: this.props.userInitialData,
            onOpen: setTimeout(function () {
              document.querySelector(".ui.dimmer") && document.querySelector(".ui.dimmer").style.setProperty("background-color", "rgba(0,0,0,0.7)", "important");
            }, 300)
          }),
          React__default.createElement(
            "div",
            {
              onClick: this.showHistoryPopup,
              style: { position: "absolute", left: "290px", cursor: "pointer" }
            },
            React__default.createElement(Popup, { content: "Comment history", trigger: React__default.createElement(Icon, { name: "history", style: { fontSize: "1.2rem" } }) })
          ),
          React__default.createElement(CommentBox, {
            getListOfContainers: this.props.getListOfContainers,
            getCommentPerContainer: getCommentPerContainer,
            entityId: entityId,
            commentEntityEventId: commentEntityEventId,
            containerComment: containerComment,
            drayagePartner: drayagePartner
          })
        );
      }

      if (this.state.loading === true || this.props.loadContainerModal) {
        return React__default.createElement(
          "div",
          { className: "newContainerModal" },
          React__default.createElement(Icon, {
            className: "crossIcon",
            name: "close large",
            onClick: function onClick() {
              return closeContainerModal();
            }
          }),
          React__default.createElement(
            "h3",
            null,
            "Loading..."
          )
        );
      }

      var empty = this.state.requestCancelComment === "None" && this.state.requestCancelReason === "" && this.state.availablePartnerID === "";

      return React__default.createElement(
        "div",
        { className: "newContainerModal" },
        React__default.createElement(Icon, {
          className: "crossIcon",
          name: "close large",
          onClick: function onClick() {
            return closeContainerModal();
          }
        }),
        React__default.createElement(
          "h3",
          { className: "modal_header" },
          containerEntityId.toString()
        ),
        this.state.openConfirmationModal !== false && React__default.createElement(KnConfirmationModal, {
          openModal: this.state.openConfirmationModal !== false,
          header: 'Confirm !',
          content: 'Do you want to remove D-carrier for this container ?',
          onClose: function onClose() {
            return _this3.setState({ openConfirmationModal: false });
          },
          onOpen: function onOpen() {},
          handleConfirmation: this.handleConfirmationModalResponse
        }),
        showMsg && arrayOfEntityId.length === 0 && React__default.createElement(Message, {
          onDismiss: this.handleDismiss,
          header: "",
          content: this.state.drayageAssignMessage !== "" ? this.state.drayageAssignMessage : "The Event is Successfully updated",
          color: "green",
          className: "update_popup"
        }),
        showMsg && arrayOfEntityId.length > 0 && React__default.createElement(Message, {
          onDismiss: this.handleDismiss,
          header: "",
          content: arrayOfEntityId.toString().replace(/[{}]/g, "") + " update failed!",
          color: "red",
          className: "update_popup_error"
        }),
        React__default.createElement(
          "div",
          { className: "statesInfo" },
          rowHeaders$$1.map(function (_ref18) {
            var fieldName = _ref18.fieldName,
                displayName = _ref18.displayName;

            var stageInfo = selectedContainerInfo[fieldName];
            // console.log({ selectedContainerInfo });
            if (!isEmpty(stageInfo)) {
              var eventName = stageInfo.eventName,
                  eModalTime = stageInfo.eModalTime,
                  tModalTime = stageInfo.tModalTime,
                  p44Time = stageInfo.p44Time,
                  OPSTime = stageInfo.OPSTime,
                  OPSTime2 = stageInfo.OPSTime2,
                  sourceSelected = stageInfo.sourceSelected,
                  holdStatus = stageInfo.holdStatus,
                  eventDescription = stageInfo.eventDescription,
                  feesStatus = stageInfo.feesStatus;

              return _this3.shouldShowThisField(fieldName) && React__default.createElement(
                "div",
                { className: "state", "data-field": fieldName },
                fieldName === "grounded" ? showSystemTime && selectedField === "grounded" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  _this3.renderStateTimeSeriesInfo({
                    OPSTime: OPSTime,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    modalIdentifire: "grounded",
                    entityId: containerEntityId.toString(),
                    entityIdData: entityIdData,
                    eventName: eventName,
                    convertEpochToDate: convertEpochToDate,
                    sourceSelected: sourceSelected,
                    entityType: entityType,
                    selectedField: selectedField,
                    entityTimezone: entityTimezone,
                    stateInfo: stageInfo,
                    hold: cuurentHoldStatus,
                    fees: currentFeesStatus,
                    commentEntityEventId: commentEntityEventId
                  })
                ) : React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  _this3.renderCalendar({
                    selectedDate: selectedDate,
                    stateInfo: stageInfo,
                    eventName: eventName,
                    entityIdData: entityIdData,
                    OPSTime: OPSTime,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    entityId: containerEntityId.toString(),
                    entityTimezone: entityTimezone,
                    fieldName: fieldName,
                    entityType: entityType,
                    selectedField: selectedField,
                    isEnable: true,
                    hold: cuurentHoldStatus,
                    fees: currentFeesStatus,
                    commentEntityEventId: commentEntityEventId
                  })
                ) : fieldName === "customReleased" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  isCustomReleased ? _this3.renderTextStatus({
                    text: _this3.computeStaticText({
                      sourceSelected: sourceSelected,
                      eModalTime: eModalTime,
                      tModalTime: tModalTime,
                      p44Time: p44Time,
                      OPSTime: OPSTime,
                      convertEpochToDate: convertEpochToDate,
                      entityTimezone: entityTimezone
                    }),
                    showButton: false,
                    commentEntityEventId: commentEntityEventId
                  }) : React__default.createElement(
                    "p",
                    { className: "small_font" },
                    "Disabled"
                  )
                ) : fieldName === "carrierReleased" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  _this3.renderCalendar({
                    selectedDate: selectedDate,
                    selectedField: selectedField,
                    stateInfo: stageInfo,
                    eventName: eventName,
                    entityIdData: entityIdData,
                    OPSTime: OPSTime,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    entityId: containerEntityId.toString(),
                    entityTimezone: entityTimezone,
                    fieldName: fieldName,
                    entityType: entityType,
                    isEnable: true,
                    hold: cuurentHoldStatus,
                    fees: currentFeesStatus,
                    commentEntityEventId: commentEntityEventId
                  })
                ) : fieldName === "holds" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  _this3.renderRadioFields({
                    status: holdStatus,
                    isSourceSelected: isSourceSelected,
                    entityId: containerEntityId.toString(),
                    eventName: eventName,
                    eventDescription: eventDescription,
                    entityType: entityType,
                    isHoldYesChecked: isHoldYesChecked,
                    holdsReasonValue: holdsReasonValue,
                    fieldName: fieldName,
                    commentEntityEventId: commentEntityEventId
                  })
                ) : fieldName === "fees" && !(isNaN(Number(eventDescription)) && feesStatus === "FEES_DUE") ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  _this3.renderRadioFields({
                    status: feesStatus,
                    isSourceSelected: isSourceSelected,
                    entityId: containerEntityId.toString(),
                    eventName: eventName,
                    eventDescription: eventDescription,
                    entityType: entityType,
                    isFeesYesChecked: isFeesYesChecked,
                    feesReasonValue: feesReasonValue,
                    fieldName: fieldName,
                    commentEntityEventId: commentEntityEventId
                  })
                ) : fieldName === "readyForPickup" ? showSystemTime && selectedField === "readyForPickup" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  _this3.renderStateTimeSeriesInfo({
                    OPSTime: OPSTime,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    modalIdentifire: "readyForPickup",
                    entityId: containerEntityId.toString(),
                    entityIdData: entityIdData,
                    eventName: eventName,
                    convertEpochToDate: convertEpochToDate,
                    sourceSelected: sourceSelected,
                    entityType: entityType,
                    selectedField: selectedField,
                    entityTimezone: entityTimezone,
                    stateInfo: stageInfo,
                    commentEntityEventId: commentEntityEventId
                  })
                ) : React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  isReadyForPickupEnable ? _this3.renderCalendar({
                    selectedDate: selectedDate,
                    stateInfo: stageInfo,
                    eventName: eventName,
                    entityIdData: entityIdData,
                    OPSTime: OPSTime,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    entityId: containerEntityId.toString(),
                    entityTimezone: entityTimezone,
                    fieldName: fieldName,
                    entityType: entityType,
                    selectedField: selectedField,
                    isEnable: isReadyForPickupEnable,
                    commentEntityEventId: commentEntityEventId
                  }) : React__default.createElement(
                    "p",
                    { className: "small_font" },
                    "Disabled"
                  )
                ) : fieldName === "terminalPickupAppointment" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  isTerminalAppointmentEnable ? _this3.renderCalendar({
                    selectedDate: selectedDate,
                    selectedField: selectedField,
                    stateInfo: stageInfo,
                    eventName: eventName,
                    entityIdData: entityIdData,
                    OPSTime: OPSTime,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    entityId: containerEntityId.toString(),
                    entityTimezone: entityTimezone,
                    fieldName: fieldName,
                    entityType: entityType,
                    isEnable: isTerminalAppointmentEnable,
                    commentEntityEventId: commentEntityEventId
                  }) : React__default.createElement(
                    "p",
                    { className: "small_font" },
                    "Disabled"
                  )
                ) : fieldName === "gateOut" ? showSystemTime && selectedField === "gateOut" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName,
                    " ",
                    React__default.createElement(Icon, {
                      name: "info circle", size: "large", color: "orange",
                      title: gateOutWarningMsg })
                  ),
                  _this3.renderStateTimeSeriesInfo({
                    OPSTime: OPSTime,
                    OPSTime2: OPSTime2,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    modalIdentifire: "gateOut",
                    entityId: containerEntityId.toString(),
                    entityIdData: entityIdData,
                    eventName: eventName,
                    convertEpochToDate: convertEpochToDate,
                    sourceSelected: sourceSelected,
                    entityType: entityType,
                    selectedField: selectedField,
                    entityTimezone: entityTimezone,
                    stateInfo: stageInfo,
                    commentEntityEventId: commentEntityEventId
                  })
                ) : React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName,
                    " ",
                    React__default.createElement(Icon, {
                      name: "info circle", size: "large", color: "orange",
                      title: gateOutWarningMsg })
                  ),
                  isGateOutEnable ? _this3.renderCalendar({
                    selectedDate: selectedDate,
                    stateInfo: stageInfo,
                    eventName: eventName,
                    entityIdData: entityIdData,
                    OPSTime: OPSTime,
                    OPSTime2: OPSTime2,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    entityId: containerEntityId.toString(),
                    entityTimezone: entityTimezone,
                    fieldName: fieldName,
                    entityType: entityType,
                    selectedField: selectedField,
                    isEnable: isGateOutEnable,
                    commentEntityEventId: commentEntityEventId
                  }) : React__default.createElement(
                    "p",
                    { className: "small_font" },
                    "Disabled"
                  )
                ) : fieldName === "terminalDropAppointment" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  isDeliveryAppointmentEnable ? _this3.renderCalendar({
                    selectedDate: selectedDate,
                    selectedField: selectedField,
                    stateInfo: stageInfo,
                    eventName: eventName,
                    entityIdData: entityIdData,
                    OPSTime: OPSTime,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    entityId: containerEntityId.toString(),
                    entityTimezone: entityTimezone,
                    fieldName: fieldName,
                    entityType: entityType,
                    isEnable: isDeliveryAppointmentEnable,
                    commentEntityEventId: commentEntityEventId
                  }) : React__default.createElement(
                    "p",
                    { className: "small_font" },
                    "Disabled"
                  )
                ) : fieldName === "warehouseDropAppointment" ? showSystemTime && selectedField === "warehouseDropAppointment" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  _this3.renderStateTimeSeriesInfo({
                    OPSTime: OPSTime,
                    OPSTime2: OPSTime2,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    modalIdentifire: "warehouseDropAppointment",
                    entityId: containerEntityId.toString(),
                    entityIdData: entityIdData,
                    eventName: eventName,
                    convertEpochToDate: convertEpochToDate,
                    sourceSelected: sourceSelected,
                    entityType: entityType,
                    selectedField: selectedField,
                    entityTimezone: entityTimezone,
                    stateInfo: stageInfo,
                    commentEntityEventId: commentEntityEventId
                  })
                ) : React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  isActualDeliveryEnable ? _this3.renderCalendar({
                    selectedDate: selectedDate,
                    stateInfo: stageInfo,
                    eventName: eventName,
                    entityIdData: entityIdData,
                    OPSTime: OPSTime,
                    OPSTime2: OPSTime2,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    entityId: containerEntityId.toString(),
                    entityTimezone: entityTimezone,
                    fieldName: fieldName,
                    entityType: entityType,
                    selectedField: selectedField,
                    isEnable: isActualDeliveryEnable,
                    commentEntityEventId: commentEntityEventId
                  }) : React__default.createElement(
                    "p",
                    { className: "small_font" },
                    "Disabled"
                  )
                ) : fieldName === "warehousePickupAppointment" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName
                  ),
                  isTerminalReturnAppEnable ? _this3.renderCalendar({
                    selectedDate: selectedDate,
                    selectedField: selectedField,
                    stateInfo: stageInfo,
                    eventName: eventName,
                    entityIdData: entityIdData,
                    OPSTime: OPSTime,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    entityId: containerEntityId.toString(),
                    entityTimezone: entityTimezone,
                    fieldName: fieldName,
                    entityType: entityType,
                    isEnable: isTerminalReturnAppEnable,
                    commentEntityEventId: commentEntityEventId
                  }) : React__default.createElement(
                    "p",
                    { className: "small_font" },
                    "Disabled"
                  )
                ) : fieldName === "gateIn" ? showSystemTime && selectedField === "gateIn" ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName,
                    " ",
                    React__default.createElement(Icon, {
                      name: "info circle", size: "large", color: "orange",
                      title: gateInWarningMsg })
                  ),
                  _this3.renderStateTimeSeriesInfo({
                    OPSTime: OPSTime,
                    eModalTime: eModalTime,
                    tModalTime: tModalTime,
                    p44Time: p44Time,
                    modalIdentifire: "gateIn",
                    entityId: containerEntityId.toString(),
                    entityIdData: entityIdData,
                    eventName: eventName,
                    convertEpochToDate: convertEpochToDate,
                    sourceSelected: sourceSelected,
                    entityType: entityType,
                    selectedField: selectedField,
                    entityTimezone: entityTimezone,
                    stateInfo: stageInfo,
                    proofOfGateIn: _this3.props.selectedContainerInfo.proofOfGateIn && (isAirMode || eirDoc) && podDoc ? true : false,
                    commentEntityEventId: commentEntityEventId
                  })
                ) : React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "header" },
                    displayName,
                    " ",
                    React__default.createElement(Icon, {
                      name: "info circle", size: "large", color: "orange",
                      title: gateInWarningMsg })
                  ),
                  isGateInEnable ? React__default.createElement(
                    React__default.Fragment,
                    null,
                    console.log("entityIdData", entityIdData),
                    _this3.renderCalendar({
                      selectedDate: selectedDate,
                      stateInfo: stageInfo,
                      eventName: eventName,
                      entityIdData: entityIdData,
                      OPSTime: OPSTime,
                      eModalTime: eModalTime,
                      tModalTime: tModalTime,
                      p44Time: p44Time,
                      entityId: containerEntityId.toString(),
                      entityTimezone: entityTimezone,
                      fieldName: fieldName,
                      entityType: entityType,
                      selectedField: selectedField,
                      isEnable: isGateInEnable,
                      displayName: displayName,
                      proofOfGateIn: _this3.props.selectedContainerInfo.proofOfGateIn && (isAirMode || eirDoc) && podDoc ? true : false,
                      commentEntityEventId: commentEntityEventId,
                      drayagePartner: get(_this3.props, "selectedContainerInfo.drayagePartner", null)
                    }),
                    _this3.props.isDray && React__default.createElement(
                      "div",
                      { style: { marginTop: "15px" } },
                      React__default.createElement(
                        "button",
                        { className: "modalBtn", onClick: _this3.handleUploadDocuments },
                        "Upload Documents"
                      )
                    )
                  ) : React__default.createElement(
                    "p",
                    { className: "small_font" },
                    "Disabled"
                  )
                ) : null
              );
            }
          }),
          isPodInland && this.props.userType === "DRAY_OPS_USER" && containerModalHeaderOnly.map(function (_ref19) {
            var fieldName = _ref19.fieldName,
                displayName = _ref19.displayName;

            var dateString = _this3.props.convertUTCToTimezone(get(selectedContainerInfo, fieldName, ""), destinationTimezone);
            var initialDate = dateString ? new Date(dateString.replace(" ", "T")) : null;
            var selectedTime = _this3.state[fieldName] || initialDate;
            return React__default.createElement(
              React__default.Fragment,
              null,
              React__default.createElement(
                "div",
                { className: "header" },
                displayName
              ),
              React__default.createElement(
                "div",
                { className: "popup-calendor" },
                React__default.createElement(
                  "div",
                  { className: "popup-date-picker" },
                  React__default.createElement(DatePicker, {
                    title: "Select time",
                    placeholderText: "Select time",
                    id: "vessel-departure-date",
                    name: "etd",
                    selected: selectedTime,
                    onChange: function onChange(value) {
                      if (value) {
                        _this3.setState(defineProperty({}, fieldName, value));
                      } else {
                        console.error('Invalid date format selected ops.');
                      }
                    },
                    showTimeSelect: true,
                    timeFormat: "hh:mm a",
                    timeIntervals: 15,
                    timeCaption: "time",
                    dateCaption: "Select time",
                    dateFormat: "MMMM d, yyyy h:mm aa",
                    peekNextMonth: true,
                    showMonthDropdown: true,
                    showYearDropdown: true,
                    dropdownMode: "select",
                    popperPlacement: "bottom-end",
                    onKeyDown: function onKeyDown(e) {
                      if (e.keyCode === 13) {
                        if (get(_this3.state, fieldName, null)) {
                          _this3.handleInlandEta(fieldName);
                        }
                      }
                    },
                    popperProps: {
                      positionFixed: true // prevents the popper from hiding behind overflow parent
                    },
                    popperModifiers: {
                      flip: {
                        behavior: ["bottom"] // don't allow it to flip to be above
                      },
                      preventOverflow: {
                        enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                      },
                      hide: {
                        enabled: false // turn off since needs preventOverflow to be enabled
                      }
                    }
                  })
                ),
                React__default.createElement(
                  "div",
                  { className: "topSpace flexDisplay", style: { padding: 0 } },
                  React__default.createElement(
                    "div",
                    { className: "button-container" },
                    React__default.createElement(
                      "button",
                      { className: "ui primary button",
                        onClick: function onClick(e) {
                          return _this3.handleInlandEta(fieldName);
                        }
                      },
                      "Y"
                    )
                  )
                )
              )
            );
          })
        ),
        this.props.userType !== "DRAY_PARTNER" ? React__default.createElement(
          "div",
          {
            onClick: function onClick() {
              return _this3.props.isContainerHistoryModalActive(true);
            },
            style: { position: "absolute", left: "290px", top: "60px", cursor: "pointer" }
          },
          React__default.createElement(Popup, {
            content: "Modification history",
            size: "large",
            trigger: React__default.createElement(Icon, { name: "history", style: { fontSize: "1.2rem" } })
          })
        ) : null,
        showContainerHistoryModal && React__default.createElement(ContainerHistoryModal, {
          entityId: entityId,
          shipmentId: shipmentId,
          commentEntityEventId: commentEntityEventId,
          entityTimezone: entityTimezone,
          getContainerHistory: this.props.getContainerHistory,
          convertEpochToDate: convertEpochToDate,
          shipmentIds: get(this.props, "selectedContainerInfo.shipmentIds", ""),
          onCloseModal: function onCloseModal() {
            return _this3.props.isContainerHistoryModalActive(false);
          },
          onOpen: setTimeout(function () {
            document.querySelector(".ui.dimmer") && document.querySelector(".ui.dimmer").style.setProperty("background-color", "rgba(0,0,0,0.7)", "important");
          }, 300)
        }),
        React__default.createElement(
          "div",
          {
            onClick: this.showHistoryPopup,
            style: { position: "absolute", left: "290px", cursor: "pointer" }
          },
          React__default.createElement(Popup, { content: "Comment history", trigger: React__default.createElement(Icon, { name: "history", style: { fontSize: "1.2rem" } }) })
        ),
        React__default.createElement(CommentBox, {
          getListOfContainers: this.props.getListOfContainers,
          getCommentPerContainer: getCommentPerContainer,
          entityId: entityId,
          commentEntityEventId: commentEntityEventId,
          containerComment: containerComment,
          drayagePartner: drayagePartner
        }),
        window._env_.APP_NAME !== "Partner" && showCommentHistoryPopup && React__default.createElement(CommentHistoryModal, {
          getCommentHistoryPerContainer: getCommentHistoryPerContainer,
          closeHistoryPopup: this.closeHistoryPopup,
          entityId: entityId,
          commentEntityEventId: commentEntityEventId,
          userInitialData: this.props.userInitialData,
          onOpen: setTimeout(function () {
            document.querySelector(".ui.dimmer") && document.querySelector(".ui.dimmer").style.setProperty("background-color", "rgba(0,0,0,0.7)", "important");
          }, 300)
        }),
        window._env_.APP_NAME === "Partner" ? this.props.selectedContainerInfo.shipmentIds.includes(",") === false ? this.state.getRequestCancelDetails.data.eventMessage.hasOwnProperty("exceptionDetails") === false ? React__default.createElement(
          "div",
          { className: "statesInfo" },
          React__default.createElement(
            "div",
            { className: "reqCancelHeader" },
            "REQUEST CANCELLATION"
          ),
          this.state.getRequestCancelDetails.data.eventMessage.hasOwnProperty("reason") === false ? React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "div",
              { className: "selectDropdown" },
              React__default.createElement(Dropdown, {
                placeholder: "Select Reason",
                fluid: true,
                selection: true,
                options: reasonForCancellation,
                onChange: function onChange(e, data) {
                  _this3.setState({ requestCancelReason: data.value });
                }
              })
            ),
            React__default.createElement(Input$1, { focus: true, placeholder: "Comment here", className: "inputComment", onChange: function onChange(e, data) {
                _this3.setState({ requestCancelComment: data.value });
              } }),
            this.state.requiredComment === true && React__default.createElement(
              "p",
              null,
              "Please leave comment"
            ),
            React__default.createElement(
              "div",
              { className: "topSpace flexDisplay" },
              React__default.createElement(
                "div",
                { className: "button-container" },
                React__default.createElement(
                  "button",
                  { className: "ui primary button", disabled: empty, onClick: this.cancelRequest },
                  " Y "
                )
              )
            )
          ) : React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "div",
              { className: "header" },
              " Request Submitted "
            ),
            React__default.createElement(
              "div",
              { className: "header" },
              "Reason"
            ),
            React__default.createElement(
              "div",
              { className: "rightSpace textStyle" },
              this.state.getRequestCancelDetails.data.eventMessage.reason,
              " "
            ),
            this.state.getRequestCancelDetails.data.eventMessage.comment !== '' && React__default.createElement(
              "div",
              null,
              React__default.createElement(
                "div",
                { className: "header " },
                "Comment"
              ),
              React__default.createElement(
                "div",
                { className: "rightSpace textStyle" },
                this.state.getRequestCancelDetails.data.eventMessage.comment,
                " "
              )
            )
          )
        ) : "" : "" : this.props.userType === "DRAY_OPS_USER" ? React__default.createElement(
          "div",
          null,
          this.state.getRequestCancelDetails.data.eventMessage.hasOwnProperty("exceptionDetails") !== true ? React__default.createElement(
            "div",
            { className: "statesInfo" },
            this.state.getRequestCancelDetails.data.eventMessage.hasOwnProperty("reason") === true ? React__default.createElement(
              "div",
              null,
              React__default.createElement(
                "div",
                { className: "reqCancelHeader" },
                " CANCELLATION REQUESTED"
              ),
              React__default.createElement(
                "div",
                { className: "header" },
                "Reason"
              ),
              React__default.createElement(
                "div",
                { className: "rightSpace textStyle" },
                this.state.getRequestCancelDetails.data.eventMessage.reason,
                " "
              ),
              React__default.createElement(
                "div",
                { className: "header" },
                "Comment"
              ),
              React__default.createElement(
                "div",
                { className: "rightSpace textStyle" },
                this.state.getRequestCancelDetails.data.eventMessage.comment,
                " "
              ),
              React__default.createElement(
                "div",
                { className: "reqCancelHeader" },
                " CHANGE CARRIER"
              )
            ) : React__default.createElement(
              "div",
              { className: "reqCancelHeader" },
              "CHANGE CARRIER",
              React__default.createElement(Popup, {
                content: " Dropdown contains active partners for this lane",
                trigger: React__default.createElement(Icon, {
                  name: "warning circle ",
                  color: "blue",
                  size: "large"
                })
              })
            ),
            React__default.createElement(
              "div",
              { className: "selectcarrier" },
              React__default.createElement(Dropdown, {
                placeholder: "Select Carrier",
                fluid: true,
                selection: true,
                options: this.state.availablePartner,
                onChange: function onChange(e, data) {
                  _this3.setState({ availablePartnerID: data.value });
                }
              })
            ),
            React__default.createElement(
              "div",
              { className: "topSpace flexDisplay" },
              React__default.createElement(
                "div",
                { className: "button-container" },
                React__default.createElement(
                  "button",
                  { className: "ui primary button", disabled: empty, onClick: this.selectPartner },
                  " Y "
                )
              )
            )
          ) : ""
        ) : "",
        window._env_.APP_NAME === "Partner" ? React__default.createElement(
          "div",
          { className: "statesInfo" },
          React__default.createElement(
            "div",
            { className: "reqCancelHeader" },
            "ASSIGN TRUCKERS"
          ),
          this.state.tuckervalidate === false ? React__default.createElement(
            "div",
            null,
            " Please select correct trucker's name and trucker's phone number "
          ) : "",
          this.props.selectedContainerInfo.hasOwnProperty("truckerInfo") === false ? React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "div",
              { className: "selectDropdown" },
              React__default.createElement(Dropdown, {
                placeholder: "Select Trucker",
                fluid: true,
                selection: true,
                options: this.state.truckersInfo,
                onChange: function onChange(e, data) {
                  _this3.setState({ selectedTruckerGuid: data.value });
                }
              })
            ),
            React__default.createElement(
              "div",
              { className: "selectDropdown" },
              React__default.createElement(Dropdown, {
                placeholder: "Select PICKUP/RETURN",
                fluid: true,
                selection: true,
                options: this.truckerOption,
                onChange: function onChange(e, data) {
                  _this3.setState({ truckerOptions: data.value });
                }
              })
            ),
            React__default.createElement(
              "div",
              { className: "topSpace flexDisplay" },
              React__default.createElement(
                "div",
                { className: "button-container" },
                React__default.createElement(
                  "button",
                  { className: "ui primary button", onClick: this.requestTruckersAssignment },
                  " Y "
                )
              )
            )
          ) : React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "div",
              { className: "header" },
              "Trucker's name"
            ),
            React__default.createElement(
              "div",
              { className: "rightSpace textStyle" },
              this.props.selectedContainerInfo.truckerInfo.contactName,
              " "
            ),
            React__default.createElement(
              "div",
              { className: "header" },
              "Trucker's phone number"
            ),
            React__default.createElement(
              "div",
              { className: "rightSpace textStyle" },
              this.props.selectedContainerInfo.truckerInfo.phoneNumber,
              " "
            ),
            React__default.createElement(
              "div",
              { className: "header" },
              "Trucker's trip type"
            ),
            React__default.createElement(
              "div",
              { className: "rightSpace textStyle" },
              this.props.selectedContainerInfo.truckerInfo.tripType,
              " "
            )
          )
        ) : "",
        this.props.userType === "DRAY_OPS_USER" ? isArray(this.state.drayageAssignedPartner) && this.state.drayageAssignedPartner.map(function (item, index) {
          var shipmentIds = get(item, "allShipmentIds", []).join(', ');
          return React__default.createElement(
            "div",
            { className: "statesInfo" },
            React__default.createElement(
              "div",
              { className: "reqCancelHeader" },
              "ASSIGN PARTNER",
              " - " + shipmentIds,
              React__default.createElement(Popup, {
                content: "Dropdown contains all the active partners for customer this container belongs to",
                trigger: React__default.createElement(Icon, {
                  name: "warning circle ",
                  color: "blue",
                  size: "large"
                }),
                size: "large"
              })
            ),
            React__default.createElement(
              "div",
              null,
              React__default.createElement(
                "div",
                { className: "selectDropdown" },
                React__default.createElement(Dropdown
                // placeholder={this.props.selectedContainerInfo.drayagePartner}
                , { placeholder: get(item, 'allShipmentInfo[0].drayPartnerName', 'None'),
                  fluid: true,
                  selection: true,
                  options: get(item, "dropdownResult", []),
                  onChange: function onChange(e, data) {
                    if (data.value === 0) _this3.setState({ openConfirmationModal: index });else _this3.handleDropdownChange(index, data);
                  }
                })
              ),
              React__default.createElement(
                "div",
                { className: "topSpace flexDisplay" },
                React__default.createElement(
                  "div",
                  { className: "button-container" },
                  React__default.createElement(
                    "button",
                    { className: "ui primary button " + (get(item, "selectedPartnerId", "") === "" && 'disable'), onClick: function onClick(e) {
                        return _this3.requestPartnerAssignment(e, item);
                      } },
                    " Y "
                  )
                )
              )
            )
          );
        }) : ""
      );
    }
  }]);
  return ContainerModal;
}(Component);

var css_248z$h = ".container-pagination {\n  position: fixed;\n  bottom: 0;\n  background: #FFFFFF;\n  width: 100%;\n  padding: 9px;\n  text-align: center;\n  z-index: 1; }\n  .container-pagination .prev-button {\n    height: 26px;\n    width: 27px;\n    border-radius: 3px;\n    background-color: #008b8f;\n    padding: 3px 7px;\n    cursor: pointer;\n    color: #fff;\n    margin: 5px; }\n  .container-pagination .next-button {\n    height: 26px;\n    width: 27px;\n    border-radius: 3px;\n    background-color: #008b8f;\n    padding: 3px 7px;\n    cursor: pointer;\n    color: #fff;\n    margin: 5px; }\n  .container-pagination .ui.mini.focus {\n    width: 60px !important;\n    font-size: 12px !important; }\n";
styleInject(css_248z$h);

var Pagination$1 = function (_Component) {
  inherits(Pagination, _Component);

  function Pagination(props) {
    classCallCheck(this, Pagination);

    var _this = possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    _this.state = {};
    return _this;
  }

  createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          pageNumber = _props.pageNumber,
          entitiesCount = _props.entitiesCount,
          pageChangeHandler = _props.pageChangeHandler,
          onPageNumberChange = _props.onPageNumberChange;

      var maxPageNumber = Math.ceil(entitiesCount / 25);

      return React__default.createElement(
        "div",
        { className: "container-pagination" },
        React__default.createElement(Popup, {
          content: "First page",
          size: "large",
          trigger: React__default.createElement(
            "span",
            {
              onClick: function onClick() {
                return pageChangeHandler("first");
              },
              className: "prev-button" + (pageNumber === 1 ? " disable-button" : "")
            },
            "<<"
          )
        }),
        React__default.createElement(Popup, {
          content: "Previous page",
          size: "large",
          trigger: React__default.createElement(
            "span",
            {
              onClick: function onClick() {
                return pageNumber > 1 && pageChangeHandler("prev");
              },
              className: "prev-button" + (pageNumber === 1 ? " disable-button" : "")
            },
            "<"
          )
        }),
        React__default.createElement(
          "span",
          null,
          "Page \xA0",
          React__default.createElement(Input$1, {
            focus: true,
            value: pageNumber,
            onChange: function onChange(e, data) {
              onPageNumberChange(data.value);
            },
            type: "number",
            size: "mini"
          }),
          "\xA0 of ",
          maxPageNumber
        ),
        React__default.createElement(Popup, {
          content: "Next page",
          size: "large",
          trigger: React__default.createElement(
            "span",
            {
              onClick: function onClick() {
                return pageChangeHandler("next");
              },
              className: "next-button" + (pageNumber === maxPageNumber ? " disable-button" : "")
            },
            ">"
          )
        }),
        React__default.createElement(Popup, {
          content: "Last page",
          size: "large",
          trigger: React__default.createElement(
            "span",
            {
              onClick: function onClick() {
                return pageChangeHandler("last");
              },
              className: "next-button" + (pageNumber === maxPageNumber ? " disable-button" : "")
            },
            ">>"
          )
        })
      );
    }
  }]);
  return Pagination;
}(Component);

var css_248z$i = ".outerWrapperContainerModal {\n  padding-top: 120px !important;\n  background-color: #F9F9F9;\n  padding-bottom: 1%; }\n  .outerWrapperContainerModal .search-container-checkbox {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 50px 0 0 15px !important;\n    position: relative;\n    top: -40px; }\n    .outerWrapperContainerModal .search-container-checkbox .search-field {\n      display: flex;\n      width: 1090px; }\n      .outerWrapperContainerModal .search-container-checkbox .search-field input {\n        width: 250px;\n        height: 40px;\n        border: 1px solid #BABABA;\n        padding-right: 30px;\n        padding-left: 50px;\n        font-size: 15px; }\n    .outerWrapperContainerModal .search-container-checkbox .search-select-box {\n      background: #008B8F;\n      border: none;\n      outline: none;\n      color: #fff;\n      height: 28px;\n      cursor: pointer;\n      width: 90%;\n      font-size: 13px; }\n    .outerWrapperContainerModal .search-container-checkbox .search-drop-down {\n      height: 40px;\n      width: 130px;\n      background: #008B8F;\n      position: absolute;\n      z-index: 1;\n      top: 0;\n      border: 1px solid #305E85;\n      color: #fff;\n      margin-left: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      left: -118px;\n      border-radius: 3px; }\n      .outerWrapperContainerModal .search-container-checkbox .search-drop-down .menu.drop-down-open {\n        display: block; }\n    .outerWrapperContainerModal .search-container-checkbox .search-close-icon {\n      width: 33px;\n      position: absolute;\n      height: 34px;\n      top: 3px;\n      z-index: 1;\n      right: 2px;\n      background: #ffff;\n      cursor: pointer; }\n      .outerWrapperContainerModal .search-container-checkbox .search-close-icon i {\n        margin-top: 9px;\n        margin-left: 8px;\n        color: rgba(56, 56, 56, 0.39); }\n    .outerWrapperContainerModal .search-container-checkbox .search-search-icon {\n      width: 40px;\n      position: absolute;\n      height: 34px;\n      top: 3px;\n      z-index: 1;\n      left: 4px;\n      background: rgba(255, 255, 255, 0);\n      cursor: pointer; }\n      .outerWrapperContainerModal .search-container-checkbox .search-search-icon i {\n        margin-top: 9px;\n        margin-left: 18px;\n        color: rgba(56, 56, 56, 0.39); }\n    .outerWrapperContainerModal .search-container-checkbox h3 {\n      color: #000 !important; }\n  .outerWrapperContainerModal .containerFilterDropdown .ui.floating.dropdown > .menu {\n    width: 550px !important; }\n  .outerWrapperContainerModal .containerFilterDropdown .ui.dropdown.drayage_filter_dropdown .menu > .item {\n    width: 550px !important; }\n  .outerWrapperContainerModal .containerFilterDropdown .ui.dropdown .menu > .input:not(.transparent) input {\n    width: 530px;\n    padding-left: 25px; }\n  .outerWrapperContainerModal .search_icon {\n    position: absolute;\n    left: 0;\n    top: 0px; }\n  .outerWrapperContainerModal .close_icon {\n    position: absolute;\n    right: 0px;\n    top: 0px; }\n  .outerWrapperContainerModal .containerFilterDropdown .drayage_filter_dropdown .set_filter_CustomDates .filterDatePicker {\n    width: 140px !important; }\n  .outerWrapperContainerModal .filters_Applied {\n    font-weight: bold;\n    font-size: 12px;\n    margin: -1rem 15px 1rem 15px !important; }\n    .outerWrapperContainerModal .filters_Applied a {\n      cursor: pointer; }\n  .outerWrapperContainerModal .filters_Applied span:nth-child(2), .outerWrapperContainerModal .filters_Applied span:nth-child(3), .outerWrapperContainerModal .filters_Applied span:nth-child(4), .outerWrapperContainerModal .filters_Applied span:nth-child(5),\n  .outerWrapperContainerModal .filters_Applied span:nth-child(6), .outerWrapperContainerModal .filters_Applied span:nth-child(7), .outerWrapperContainerModal .filters_Applied span:nth-child(8), .outerWrapperContainerModal .filters_Applied span:nth-child(9) {\n    border-left: 1px solid #ccc;\n    margin-left: 4px;\n    padding-left: 4px; }\n  .outerWrapperContainerModal .ui.fluid.dropdown {\n    font-size: 15px !important;\n    width: 250px !important;\n    min-width: 0;\n    border: 1px solid #BABABA; }\n  .outerWrapperContainerModal .resetState {\n    margin-left: 10px !important;\n    font-weight: bold !important;\n    font-size: 15px !important; }\n  .outerWrapperContainerModal .ContainerState {\n    width: 697px !important; }\n    .outerWrapperContainerModal .ContainerState .ContainerStateDropdown.ui.fluid.dropdown {\n      width: 655px !important; }\n  .outerWrapperContainerModal .check-container {\n    z-index: 1; }\n    .outerWrapperContainerModal .check-container label {\n      vertical-align: text-bottom !important; }\n    .outerWrapperContainerModal .check-container .checkBoxFilter {\n      display: inline-block;\n      width: auto;\n      padding-left: 10px; }\n      .outerWrapperContainerModal .check-container .checkBoxFilter .labelStyle {\n        margin-left: 8px;\n        text-transform: capitalize !important; }\n  .outerWrapperContainerModal .drayage_filter_dropdown {\n    margin-top: 6px !important;\n    width: 150px !important;\n    padding: 6px 0 !important;\n    height: 35px !important; }\n\n.containerWrapper {\n  opacity: 1;\n  background: #00c4ff12;\n  transform: translate3d(0px, -1px, 0px);\n  width: min-content; }\n\n.leftSideDrayageContainer {\n  color: #020303;\n  font-size: 14px;\n  padding-right: 1%;\n  width: 126px; }\n  .leftSideDrayageContainer .entityIdWithMot {\n    display: flex;\n    align-items: center;\n    gap: 6px; }\n  .leftSideDrayageContainer .labelInfo {\n    width: max-content;\n    border-radius: 4px;\n    color: white;\n    padding: 5px 6px;\n    font-size: 10px; }\n    .leftSideDrayageContainer .labelInfo.failureBackground {\n      background-color: #db2828; }\n    .leftSideDrayageContainer .labelInfo.successBackground {\n      background-color: #23B80A; }\n  .leftSideDrayageContainer .horizantalRuler {\n    margin-top: 6.5%;\n    width: 120%; }\n\n.contDrayStatusWrapper {\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px; }\n  .contDrayStatusWrapper .contAssignTitle {\n    font-size: 10px;\n    line-height: 12px; }\n  .contDrayStatusWrapper .contDrayStatusBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2px 5px;\n    font-size: 10px;\n    cursor: pointer;\n    border-radius: 5px;\n    margin-top: 5px;\n    transition: 0.2s ease-in-out; }\n  .contDrayStatusWrapper .acceptanceBtn {\n    color: #fff;\n    background-color: #008b8f;\n    border: 1px solid #008b8f; }\n  .contDrayStatusWrapper .acceptanceBtn:hover {\n    background-color: transparent;\n    color: #008b8f; }\n  .contDrayStatusWrapper .rejectionBtn {\n    background-color: #db2828;\n    color: #fff;\n    border: 1px solid #db2828; }\n  .contDrayStatusWrapper .rejectionBtn:hover {\n    color: #db2828;\n    background-color: transparent; }\n  .contDrayStatusWrapper .contStatus {\n    font-size: 10px;\n    line-height: 14px;\n    font-weight: 600; }\n  .contDrayStatusWrapper .contDrayStatusDtWrapper {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 10px; }\n  .contDrayStatusWrapper .contStatusUpdateDate {\n    font-size: 10px;\n    line-height: 14px; }\n\n.leftSideIconsCol {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0px 5px; }\n\n.emailDocumentModal .content {\n  max-height: 350px !important; }\n\n.emailDocumentModal .emailDocumentContainer {\n  padding-bottom: 20px; }\n\n.mailCommentsInput {\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  box-sizing: border-box;\n  min-height: 100px;\n  flex-wrap: wrap;\n  border: 2px solid #eee;\n  color: #666;\n  font-size: 16px;\n  font-weight: 400;\n  height: auto;\n  margin: 0 0 10px;\n  padding: 15px;\n  appearance: none;\n  border-radius: 0;\n  cursor: text; }\n\n.mailCommentsInput:hover,\n.mailCommentsInput:focus {\n  outline: 0; }\n\n.commentInputLabel {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 10px;\n  font-weight: 600; }\n\n.contMenuWrapper {\n  display: flex;\n  flex-direction: column;\n  min-width: 250px;\n  margin-top: 15px; }\n  .contMenuWrapper .menuBtn {\n    display: flex;\n    align-items: center;\n    color: #000;\n    font-size: 16px;\n    padding: 6px 10px;\n    transition: 0.2s ease-in-out;\n    cursor: pointer;\n    gap: 10px; }\n  .contMenuWrapper .menuBtn:hover {\n    background-color: #ccc; }\n  .contMenuWrapper .menuIcon {\n    margin-right: 10px;\n    color: #000; }\n  .contMenuWrapper .menuLabel {\n    color: #000; }\n\n.icon-div {\n  margin: 5px; }\n\n.blackLabel {\n  color: black !important; }\n\n.decreaseOpacity {\n  opacity: 0.5; }\n\n.pointerCursor {\n  cursor: pointer; }\n\n.containerRowDisplay {\n  cursor: pointer;\n  margin-bottom: 17px; }\n\n.containerFiltersWrapper {\n  padding-left: 16px;\n  margin-top: 1%;\n  visibility: hidden; }\n\n.filter {\n  margin-right: 30%; }\n  .filter.selectedFilter {\n    background-color: #FFFFFF;\n    padding: 4%;\n    margin-top: -5%;\n    border-bottom: 2px solid #054D4F; }\n  .filter .imgStyle {\n    opacity: 0.59;\n    margin-left: auto;\n    margin-right: auto;\n    display: block; }\n    .filter .imgStyle.vessel {\n      height: 16.41px;\n      width: 28px; }\n    .filter .imgStyle.port {\n      height: 18.02px;\n      width: 18.03px; }\n    .filter .imgStyle.container {\n      height: 18.06px;\n      width: 23px; }\n  .filter .textStyle {\n    color: #054D4F;\n    font-size: 18px;\n    font-weight: 600;\n    letter-spacing: 1px;\n    line-height: 24px; }\n  .filter :hover {\n    cursor: pointer; }\n\n.is-disable .tableWrapper {\n  pointer-events: none;\n  opacity: .4; }\n\n.container-app {\n  width: 100%;\n  margin: 0 auto;\n  font-family: \"Open Sans\", sans-serif !important; }\n  .container-app button.ui.button {\n    padding: 0; }\n  .container-app button.selected-reset-button.ui.button {\n    position: absolute;\n    right: 30px;\n    padding: 10px;\n    top: 15px;\n    z-index: 999; }\n  .container-app .selected-number {\n    position: absolute;\n    right: 13%;\n    top: 20px;\n    z-index: 999; }\n  .container-app .selected-list {\n    background: #fff;\n    display: none; }\n    .container-app .selected-list p:first-child {\n      padding-top: 10px; }\n    .container-app .selected-list p:last-child {\n      padding-bottom: 10px; }\n    .container-app .selected-list p {\n      margin-bottom: 2px;\n      padding-left: 10px; }\n  .container-app .selected-number:hover .selected-list {\n    display: block; }\n\n.container-header {\n  height: 60px;\n  width: 100vw;\n  position: fixed;\n  z-index: 999;\n  background: #EFF3F7;\n  top: 55px;\n  left: 0;\n  right: 0;\n  box-shadow: -1px 0 4px 0 rgba(0, 0, 0, 0.5); }\n  .container-header .check-container {\n    z-index: 1; }\n    .container-header .check-container label {\n      vertical-align: text-bottom !important; }\n    .container-header .check-container .checkBoxFilter {\n      display: inline-block;\n      width: auto;\n      padding-left: 10px; }\n      .container-header .check-container .checkBoxFilter .labelStyle {\n        margin-left: 8px;\n        text-transform: capitalize !important;\n        color: black !important; }\n\n.pulse-animation {\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n  animation: pulse 1.3s infinite;\n  float: left; }\n\n.pulse-animation:hover {\n  animation: none; }\n\n.loading {\n  text-align: center;\n  font-size: 18px;\n  margin-bottom: 1rem; }\n\n@keyframes pulse {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(33, 131, 221, 0.4);\n    box-shadow: 0 0 0 0 rgba(33, 131, 221, 0.4); }\n  70% {\n    -moz-box-shadow: 0 0 0 15px rgba(33, 131, 221, 0);\n    box-shadow: 0 0 0 15px rgba(33, 131, 221, 0); }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(33, 131, 221, 0);\n    box-shadow: 0 0 0 0 rgba(33, 131, 221, 0); } }\n\n.processed-checkbox-search {\n  display: flex; }\n\n.check-container {\n  align-self: center;\n  position: relative;\n  top: 21px;\n  left: 15px;\n  padding-right: 50px;\n  display: flex;\n  width: 100vw !important;\n  justify-content: space-between !important; }\n  .check-container .exportIcon {\n    display: flex; }\n\n.check-container input[type=checkbox] {\n  position: relative;\n  top: 2px; }\n\n.container-modal {\n  height: 100%;\n  overflow-y: scroll;\n  margin-left: 15px;\n  padding: 1%;\n  margin-right: 15px;\n  margin-bottom: 1%;\n  background-color: #FFFFFF;\n  padding-bottom: 0; }\n\n.container-header-sec .flexDisplay.spaceInBetween {\n  justify-content: space-between; }\n\n.topSpace .button-container button {\n  width: 27px;\n  height: 28px; }\n\n.popup-date-picker .react-datepicker-wrapper {\n  width: 96%; }\n\n.popup-date-picker p {\n  margin-bottom: 0;\n  text-align: left;\n  font-size: 10px;\n  opacity: 0.69; }\n\n.visible .divider {\n  width: unset !important;\n  border: 1px solid #979797; }\n\n.ui.green.message {\n  margin-top: 0px;\n  position: fixed;\n  z-index: 10;\n  margin-left: 23px; }\n\n.ui.message > .close.icon {\n  top: 0.28575em;\n  right: 0.2em; }\n\n.statesInfo .ui.primary.button:active {\n  background-color: #add8e6; }\n\n.error {\n  padding-bottom: 10px; }\n\nspan.next-button.disable-button {\n  background-color: #4dc8cb; }\n\nspan.prev-button.disable-button {\n  background-color: #4dc8cb; }\n\n.container-app .ui.input > input, .container-app button, .container-app input, .container-app optgroup, .container-app select, .container-app textarea, .container-app label {\n  font-family: \"Open Sans\", sans-serif !important; }\n\n@media all and (min-width: 1500px) {\n  .headerText {\n    font-size: 11px !important; }\n  .dataDisplay {\n    font-size: 12px !important; } }\n\n.container-app .search-container .search-search-icon i {\n  margin-top: 9px;\n  margin-left: 8px;\n  color: rgba(56, 56, 56, 0.19);\n  font-size: 18px; }\n\n.container-app .search-container .search-search-icon {\n  width: 30px; }\n\n.search-container .search-field {\n  width: 850px !important;\n  margin-left: 15px !important; }\n\n.search-container .search-field input {\n  padding-left: 42px; }\n\n.outerWrapperContainerModal h1 {\n  font-size: 23px;\n  font-weight: bold;\n  letter-spacing: 0.9px;\n  text-align: center;\n  padding-bottom: 10px; }\n\n.portName {\n  color: black !important;\n  font-weight: 900 !important;\n  font-size: 18px !important; }\n\n.terminalName {\n  font-size: 14px !important; }\n\n.outerWrapperContainerModal[data-fieldname=\"container\"] .container-modal > h1 {\n  display: none !important; }\n\n.outerWrapperContainerModal[data-fieldname=\"container\"] .container-modal > h1.container_heading {\n  display: none !important; }\n\n.outerWrapperContainerModal[data-fieldname=\"vessel\"] .container-modal > h1 {\n  display: none !important; }\n\n.outerWrapperContainerModal[data-fieldname=\"vessel\"] .container-modal > h1.vessel_heading {\n  display: block !important; }\n\n.outerWrapperContainerModal[data-fieldname=\"port\"] .container-modal > h1 {\n  display: none !important; }\n\n.outerWrapperContainerModal[data-fieldname=\"port\"] .container-modal > h1.port_heading {\n  display: block !important; }\n\n.container-pagination[data-fieldname=\"port\"], .container-pagination[data-fieldname=\"vessel\"] {\n  display: none !important; }\n\n.lfd_label {\n  margin-top: 6px; }\n\n.no_data_msg {\n  margin: 10px 0 10px 27px !important; }\n\n.done-date {\n  font-size: 11px;\n  margin-left: 3px;\n  margin-top: 4px; }\n\n.tz-offset {\n  position: relative;\n  font-size: 10px;\n  margin-left: 2px;\n  cursor: pointer;\n  color: #008B8F; }\n\n.sortBy_Container {\n  font-weight: bold;\n  font-size: 15px;\n  margin-left: 1430px !important;\n  position: relative;\n  top: -75px; }\n  .sortBy_Container a {\n    cursor: pointer;\n    margin-left: 5px !important; }\n\n.flexDisplay {\n  display: flex; }\n\n.container-app hr {\n  border: 0.3px solid #b7b7b7 !important;\n  margin: 0; }\n\n.container-app .search-container .search-field input {\n  padding-left: 42px; }\n\n.container-app .bulkCopy {\n  background-color: #008b8f !important;\n  padding: 6px 10px !important;\n  color: #fff !important; }\n\n.ui.selection.active.dropdown .menu::-webkit-scrollbar {\n  display: block;\n  width: 10px !important; }\n\n.bulkCopy_Modal {\n  display: grid;\n  place-content: center;\n  background-color: rgba(0, 0, 0, 0.6);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100vh; }\n  .bulkCopy_Modal .bulkCopy_Container {\n    width: 100%;\n    height: auto;\n    border-radius: 5px;\n    padding: 1rem 3rem;\n    background-color: #fff;\n    overflow: auto !important;\n    overflow-x: hidden !important;\n    margin: 5rem 0 1rem 0; }\n    .bulkCopy_Modal .bulkCopy_Container::-webkit-scrollbar {\n      display: block;\n      width: 10px !important;\n      background: aliceblue; }\n    .bulkCopy_Modal .bulkCopy_Container::-webkit-scrollbar-track {\n      box-shadow: inset 0 0 5px grey;\n      border-radius: 6px; }\n  .bulkCopy_Modal .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; }\n  .bulkCopy_Modal .filter {\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    position: relative;\n    top: -5px;\n    margin: 20px  0; }\n  .bulkCopy_Modal .bulkCopy_dropdown {\n    width: 22% !important; }\n  .bulkCopy_Modal .delimeter {\n    margin-left: 15px; }\n  .bulkCopy_Modal .delimeterHeadingText {\n    padding: 0px;\n    font-weight: 800;\n    font-size: 16px; }\n  .bulkCopy_Modal .radio-btn {\n    display: flex; }\n  .bulkCopy_Modal .radio-btn .radio2 {\n    margin-left: 10px; }\n  .bulkCopy_Modal .radio1, .bulkCopy_Modal .radio2 {\n    font-weight: 600;\n    text-transform: uppercase; }\n  .bulkCopy_Modal .table {\n    margin: 1rem 0 2rem 0; }\n  .bulkCopy_Modal .bulkCopyModal_table {\n    overflow: auto;\n    max-height: 500px;\n    width: max-content; }\n    .bulkCopy_Modal .bulkCopyModal_table::-webkit-scrollbar {\n      display: block;\n      width: 10px !important;\n      background: aliceblue; }\n    .bulkCopy_Modal .bulkCopyModal_table::-webkit-scrollbar-track {\n      box-shadow: inset 0 0 5px grey;\n      border-radius: 6px; }\n    .bulkCopy_Modal .bulkCopyModal_table thead {\n      position: sticky;\n      top: -1px;\n      z-index: 1; }\n  .bulkCopy_Modal .ui.table thead th {\n    font-family: 'Open Sans' !important;\n    font-size: 16px !important; }\n  .bulkCopy_Modal .bulkCopyModal_table-header {\n    align-items: center; }\n  .bulkCopy_Modal .table > :not(:last-child) > :last-child > * {\n    border-bottom-color: rgba(0, 0, 0, 0.25); }\n  .bulkCopy_Modal .bottom {\n    display: flex;\n    justify-content: end;\n    margin-top: 1rem; }\n  .bulkCopy_Modal .button {\n    padding: 13px !important; }\n  .bulkCopy_Modal .bottom .cancel {\n    background-color: #dc3545 !important;\n    color: #fff !important;\n    width: 85px !important; }\n  .bulkCopy_Modal .bottom .copy {\n    background-color: #008b8f !important;\n    color: #fff !important;\n    width: 85px !important;\n    margin-left: 5px !important; }\n\n.new-req {\n  height: 41px;\n  width: 77px;\n  border-radius: 2px;\n  background-color: #7C02C4;\n  color: #FFFFFF;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin-top: -40px;\n  border: none; }\n\n.dragAndDrop_Modal {\n  display: grid;\n  place-content: center;\n  background-color: rgba(0, 0, 0, 0.6);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100vh; }\n  .dragAndDrop_Modal .dragAndDrop_Container {\n    width: 100%;\n    height: auto;\n    border-radius: 5px;\n    padding: 1rem 3rem;\n    background-color: #fff;\n    margin: 5rem 0 1rem 0;\n    /* &::-webkit-scrollbar {\n            display: block;\n            width: 10px !important;\n          } */ }\n  .dragAndDrop_Modal .uploadedImage {\n    width: 70%;\n    height: 70%; }\n  .dragAndDrop_Modal .bottom {\n    display: flex;\n    justify-content: end;\n    margin-top: 1rem; }\n  .dragAndDrop_Modal .button {\n    padding: 13px !important; }\n  .dragAndDrop_Modal .bottom .cancel {\n    background-color: #dc3545 !important;\n    color: #fff !important;\n    width: 85px !important; }\n  .dragAndDrop_Modal .bottom .copy {\n    background-color: #008b8f !important;\n    color: #fff !important;\n    width: 85px !important;\n    margin-left: 5px !important; }\n\n.text-green {\n  color: #008C8E; }\n\n.modalHolder {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(34, 31, 28, 0.5);\n  font-family: 'Poppins', sans-serif;\n  z-index: 9999;\n  top: 0;\n  left: 0;\n  right: 0; }\n\n.modal-contentHolder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  min-height: calc(100% - 15px * 2); }\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: #000;\n  pointer-events: auto;\n  background-clip: padding-box;\n  border-radius: 4px;\n  outline: 0;\n  box-shadow: 0px 12px 48px -6px rgba(101, 91, 83, 0.38), 0px 3px 18px -2px rgba(101, 91, 83, 0.16); }\n\n.pdf-view {\n  padding: 5px;\n  border-bottom-width: 2px;\n  border-style: solid;\n  border-color: #e7e7e7;\n  min-height: 80%;\n  height: 600px; }\n\n.fileViewerModal {\n  width: fit-content;\n  margin: 20px auto;\n  overflow-y: auto;\n  max-height: 400px; }\n\n.modalFileImage {\n  width: 100%;\n  position: relative;\n  max-height: 400px; }\n\n.successScreen {\n  text-align: center;\n  color: #2B8C3B;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding-top: 100px;\n  padding-bottom: 100px; }\n\n.successText {\n  font-size: 64px;\n  line-height: 70px;\n  font-weight: 500;\n  margin-bottom: 0; }\n\n.successMessage {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20px; }\n\n.custom-modal-header, .custom-modal-body, .custom-modal-footer {\n  display: flex;\n  padding: 20px;\n  gap: 15px; }\n\n.custom-modal-body {\n  padding-bottom: 0; }\n\n.uploadContentholder {\n  width: 100%;\n  border: 1px dashed #006466;\n  background: linear-gradient(0deg, #F6F5F4, #F6F5F4), linear-gradient(0deg, #EDEBE9, #EDEBE9), #FFFCFA;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.uploadContentholder.success {\n  background: #F0FAF1; }\n\n.uploadContentholder.fail {\n  background: #FCEDF1; }\n\n.custom-modal-footer.justify-end {\n  justify-content: flex-end; }\n\n.custom-modal-footer .button {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px !important;\n  border: 2px solid #006466;\n  color: #006466;\n  font-size: 16px;\n  background-color: transparent;\n  cursor: pointer !important;\n  border-radius: 0 !important;\n  font-weight: 400 !important; }\n\n.custom-modal-footer .button:hover {\n  background-color: inherit;\n  color: #006466; }\n\n.button.btn-confirm {\n  background-color: #006466;\n  color: #fff; }\n\n.button.btn-confirm:hover {\n  background-color: #006466;\n  color: #fff; }\n\n.uploadCloudIcon {\n  width: 40px; }\n\n.uploadFileHolder {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  align-items: center;\n  text-decoration: none;\n  width: 100%;\n  height: 100%;\n  position: relative; }\n\n.uploadFileMsg {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 40px;\n  color: #70665C;\n  margin: 0;\n  text-align: center; }\n\n.progressBar {\n  padding: 30px 40px; }\n\n.fileDetails {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%; }\n\n.fileName {\n  font-size: 17px;\n  font-weight: bold; }\n\n.fileData {\n  font-size: 16px;\n  color: #70665C;\n  font-weight: 700; }\n\n.fileData.fileSize {\n  color: #4F4740; }\n\n.file-upload-input {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  outline: none;\n  opacity: 0; }\n\n.file-upload-content {\n  display: none;\n  text-align: center;\n  width: 100%;\n  z-index: 9;\n  position: relative; }\n\n.file-upload-content img {\n  width: 100%; }\n\n.ui.progress {\n  border-radius: 1.8rem !important;\n  margin: 0.2em 0 0.2em !important; }\n\n.ui.progress .bar {\n  border-radius: 1.8rem !important;\n  background: #008C8E; }\n\n.progressBar {\n  width: 100%; }\n\n.progress.is-large {\n  height: 40px;\n  width: 100%; }\n\n.deleteScreenText {\n  font-size: 22px;\n  margin: 0.5rem 0;\n  font-weight: 700; }\n\n.deleteScreenText.alert {\n  color: #CD214A; }\n\n.uploadFileHolder #myProgress {\n  position: relative;\n  display: block;\n  line-height: 1;\n  width: 100%;\n  height: 1em;\n  background-color: #DAD6D2;\n  border-radius: 1.8rem; }\n\n.uploadFileHolder #myBar {\n  position: absolute;\n  border-radius: 1.8rem;\n  width: 1%;\n  height: 100%;\n  background-color: #008C8E; }\n\n.disable {\n  opacity: 0.5;\n  pointer-events: none; }\n\n@media (min-width: 576px) {\n  .modal-contentHolder {\n    max-width: 500px;\n    margin-right: auto;\n    margin-left: auto; } }\n\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    width: 800px;\n    max-width: inherit; } }\n\n.uploadScreenModal {\n  position: fixed;\n  z-index: 999 !important; }\n\n.showDocErrorModal .content {\n  width: 100% !important; }\n";
styleInject(css_248z$i);

var UploadDocScreen = function (_Component) {
  inherits(UploadDocScreen, _Component);

  function UploadDocScreen(props) {
    var _this2 = this;

    classCallCheck(this, UploadDocScreen);

    var _this = possibleConstructorReturn(this, (UploadDocScreen.__proto__ || Object.getPrototypeOf(UploadDocScreen)).call(this, props));

    _this.getArchieveList = function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var containerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var getDocId, documentList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getArchieveDocument(containerId);

              case 2:
                getDocId = _context.sent;
                documentList = get(getDocId, "data.eventMessage.documents", []);

                _this.setState({ archiveDocList: documentList });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }();

    _this.updateSelectedFiles = function (type, file) {
      if (file) {
        _this.setState(function (prevState) {
          return {
            selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, type, _extends({}, prevState.selectedFiles[type], {
              existingFile: file
            })))
          };
        });
      }
    };

    _this.handleIconClick = function (key, itemId, iconType) {
      _this.setState(function (prevState) {
        return {
          clickedIndex: itemId,
          clickedIconType: iconType,
          selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, key, _extends({}, prevState.selectedFiles[key], {
            isReuploadClicked: true
          })))
        };
      });
    };

    _this.onFileChange = function (event, screen, fileName) {
      var _event$target = event.target,
          name = _event$target.name,
          files = _event$target.files;

      var updatedSelectedFiles = _extends({}, _this.state.selectedFiles);

      updatedSelectedFiles[name] = {
        file: files[0],
        progress: 0,
        error: false,
        uploaded: false,
        existingFile: fileName,
        isReuploadClicked: screen === "Reupload" ? true : false
      };

      _this.setState({
        selectedFiles: updatedSelectedFiles
      }, function () {
        _this.uploadFile(files[0], name, screen);
      });
    };

    _this.splitProofOfGateIn = function (doc) {
      var stringArray = doc && isString(doc) ? doc.split(",") : [];
      var eirDoc = null,
          podDoc = null;


      if (!isEmpty(stringArray)) {
        var newArr = stringArray.map(function (str) {
          if (str && str.startsWith("EQUIPMENT_INTERCHANGE_RECEIPT:")) {
            eirDoc = str.split(":")[1];
          }
          if (str && str.startsWith("PROOF_OF_GATE_IN:")) {
            podDoc = str.split(":")[1];
          }
        });
      }

      return [eirDoc, podDoc];
    };

    _this.uploadFile = function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(image, name, screen) {
        var filename, bodyFormData, response, bucketName, str, firstIndex, lastIndex, finalString;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!image) {
                  _context2.next = 21;
                  break;
                }

                _context2.prev = 1;
                filename = Date.now() + "_" + image.name;
                bodyFormData = new FormData();

                bodyFormData.append("files", image, filename);
                _context2.next = 7;
                return uploadImageFileData(bodyFormData, window._env_.DRAYAGE_PARTNER_DOC_BUCKET, function (progress) {
                  // Update the progress state for the specific file
                  _this.setState(function (prevState) {
                    return {
                      selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, name, _extends({}, prevState.selectedFiles[name], {
                        progress: progress
                      })))
                    };
                  });
                });

              case 7:
                response = _context2.sent;
                bucketName = window._env_.DRAYAGE_BILL_BUCKET;
                _context2.next = 11;
                return uploadImageFileDataDrayage(bodyFormData, bucketName).then(function (res) {
                  var files = get(res, "data.msg", "");
                  if (files !== "") {
                    files = files.split("[")[1];
                    files = files.split("]")[0];
                    files = files;
                  } else {
                    files = "demo";
                  }

                  _this.setState(function (prevState) {
                    return {
                      selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, name, _extends({}, prevState.selectedFiles[name], {
                        drayageBillUploadUrl: files,
                        isReplacementDocument: screen === "Reupload" ? true : false
                      })))
                    };
                  });
                });

              case 11:
                str = response.data.msg;
                firstIndex = str.indexOf("[");
                lastIndex = str.indexOf("]");
                finalString = str.substring(firstIndex + 1, lastIndex);
                // console.log("checking finalString", finalString);

                // Set the uploaded flag to true after successful upload

                _this.setState(function (prevState) {
                  return {
                    selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, name, _extends({}, prevState.selectedFiles[name], {
                      uploaded: true,
                      uploadUrl: finalString
                    })))
                  };
                });
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](1);

                // Set the error flag to true if an error occurred during upload
                _this.setState(function (prevState) {
                  return {
                    selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, name, _extends({}, prevState.selectedFiles[name], {
                      error: true
                    })))
                  };
                });

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 18]]);
      }));

      return function (_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleDeleteScreen = function (key, index, type) {
      _this.setState(function (prevState) {
        return {
          deleteModalOpen: true,
          clickedIndex: index,
          clickedIconType: type,
          selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, key, _extends({}, prevState.selectedFiles[key], {
            isDeleteClicked: true
          })))
        };
      });
    };

    _this.handleConfirmProgressDelete = function (key) {
      _this.setState(function (prevState) {
        return {
          deleteProgressModalOpen: false,
          selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, key, _extends({}, prevState.selectedFiles[key], {
            uploaded: false
          })))
        };
      });
    };

    _this.renderConfirmDeleteScreen = function (name, from) {
      return React__default.createElement(
        Modal,
        {
          open: _this.state.deleteModalOpen,
          onClose: function onClose() {
            return _this.setState({ deleteModalOpen: false });
          },
          size: "mini",
          className: "confirm-delete-screen"
        },
        React__default.createElement(
          Modal.Header,
          null,
          React__default.createElement(Icon, { name: "trash", color: "red" }),
          "Confirm Deletion"
        ),
        React__default.createElement(
          Modal.Content,
          null,
          React__default.createElement(
            "p",
            null,
            "Are you sure you want to delete this item?"
          )
        ),
        React__default.createElement(
          Modal.Actions,
          null,
          React__default.createElement(
            Button,
            {
              color: "red",
              onClick: function onClick() {
                return _this.setState({ deleteModalOpen: false });
              }
            },
            React__default.createElement(Icon, { name: "remove" }),
            " No"
          ),
          React__default.createElement(
            Button,
            {
              color: "green",
              onClick: function onClick() {
                return _this.handleConfirmDelete(name, from);
              }
            },
            React__default.createElement(Icon, { name: "checkmark" }),
            " Yes"
          )
        )
      );
    };

    _this.renderProgressConfirmDelete = function (name, screen) {
      return React__default.createElement(
        Modal,
        {
          open: _this.state.deleteProgressModalOpen,
          onClose: function onClose() {
            return _this.setState({ deleteProgressModalOpen: false });
          },
          size: "mini",
          className: "confirm-progress-delete-screen"
        },
        React__default.createElement(
          Modal.Header,
          null,
          React__default.createElement(Icon, { name: "trash", color: "red" }),
          "Confirm Deletion"
        ),
        React__default.createElement(
          Modal.Content,
          null,
          React__default.createElement(
            "p",
            null,
            "Are you sure you want to delete this item?"
          )
        ),
        React__default.createElement(
          Modal.Actions,
          null,
          React__default.createElement(
            Button,
            {
              color: "red",
              onClick: function onClick() {
                return _this.setState({ deleteProgressModalOpen: false });
              }
            },
            React__default.createElement(Icon, { name: "remove" }),
            " No"
          ),
          React__default.createElement(
            Button,
            {
              color: "green",
              onClick: function onClick() {
                return _this.handleConfirmProgressDelete(name);
              }
            },
            React__default.createElement(Icon, { name: "checkmark" }),
            " Yes"
          )
        )
      );
    };

    _this.handleConfirmDelete = function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(name, from) {
        var _this$state, clickedIndex, clickedIconType, selectedFiles, archiveDocList, _this$props, containerInfo, resetFilters, attachmentAction, attachmentType, entityId, shipmentIds, entityEventID, response, existingDocName, docId, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, document, docName, chargeNames, payload, selectedFilesCopy;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$state = _this.state, clickedIndex = _this$state.clickedIndex, clickedIconType = _this$state.clickedIconType, selectedFiles = _this$state.selectedFiles, archiveDocList = _this$state.archiveDocList;
                _this$props = _this.props, containerInfo = _this$props.containerInfo, resetFilters = _this$props.resetFilters;
                attachmentAction = 1;
                attachmentType = 0;

                if (clickedIconType === "delete" && clickedIndex === 1) attachmentType = 1;

                entityId = containerInfo.entityId, shipmentIds = containerInfo.shipmentIds, entityEventID = containerInfo.gateIn.entityEventID;
                _context3.next = 8;
                return handleFileUrl(entityEventID, entityId, shipmentIds, attachmentAction, attachmentType);

              case 8:
                response = _context3.sent;

                if (isEmpty(archiveDocList)) {
                  _context3.next = 43;
                  break;
                }

                existingDocName = get(selectedFiles, name + ".existingFile", "");
                docId = "";
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 15;
                _iterator = archiveDocList[Symbol.iterator]();

              case 17:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 27;
                  break;
                }

                document = _step.value;
                docName = get(document, "value.actualFileName", "");
                chargeNames = get(document, "value.chargeNames", []);

                if (!(!isEmpty(chargeNames) && chargeNames.some(function (charge) {
                  return charge.glCode === "60001" && charge.chargeName === "BASE CHARGE";
                }) && docName === existingDocName)) {
                  _context3.next = 24;
                  break;
                }

                docId = document.key;
                return _context3.abrupt("break", 27);

              case 24:
                _iteratorNormalCompletion = true;
                _context3.next = 17;
                break;

              case 27:
                _context3.next = 33;
                break;

              case 29:
                _context3.prev = 29;
                _context3.t0 = _context3["catch"](15);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 33:
                _context3.prev = 33;
                _context3.prev = 34;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 36:
                _context3.prev = 36;

                if (!_didIteratorError) {
                  _context3.next = 39;
                  break;
                }

                throw _iteratorError;

              case 39:
                return _context3.finish(36);

              case 40:
                return _context3.finish(33);

              case 41:
                payload = {
                  docId: docId
                };


                archiveDrayageDocument(payload);

              case 43:

                console.log({ response: response });
                if (response && response.status === 200) {
                  selectedFilesCopy = _extends({}, _this.state.selectedFiles);

                  if (clickedIndex == 1) {
                    delete selectedFilesCopy["EIR"];
                  } else {
                    delete selectedFilesCopy["POD"];
                  }

                  _this.setState({
                    deleteModalOpen: false,
                    selectedFiles: selectedFilesCopy
                  }, function () {
                    resetFilters();
                  });
                }

              case 45:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[15, 29, 33, 41], [34,, 36, 40]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.handleProgressDelete = function (key, index, type) {
      _this.setState(function (prevState) {
        return {
          deleteProgressModalOpen: true,
          clickedIndex: index,
          clickedIconType: type,
          selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, key, _extends({}, prevState.selectedFiles[key], {
            isProgressDeleteClicked: true
          })))
        };
      });
    };

    _this.renderUploadProgressScreen = function (name, _ref4, index) {
      var _ref4$file = _ref4.file,
          file = _ref4$file === undefined ? "" : _ref4$file,
          _ref4$progress = _ref4.progress,
          progress = _ref4$progress === undefined ? 0 : _ref4$progress,
          _ref4$error = _ref4.error,
          error = _ref4$error === undefined ? false : _ref4$error;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          {
            style: { fontSize: "16px", fontWeight: "400" }
          },
          name + " Document"
        ),
        React__default.createElement(
          "div",
          { className: "fileDetails", style: { gap: "5px" } },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "5px"
              }
            },
            React__default.createElement(
              "div",
              null,
              progress == 100 && !error && React__default.createElement(
                "svg",
                {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 26 26",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                },
                React__default.createElement("path", {
                  d: "M13 0C10.4288 0 7.91543 0.762437 5.77759 2.1909C3.63975 3.61935 1.97351 5.64968 0.989572 8.02512C0.0056327 10.4006 -0.251811 13.0144 0.249797 15.5362C0.751405 18.0579 1.98953 20.3743 3.80762 22.1924C5.6257 24.0105 7.94208 25.2486 10.4638 25.7502C12.9856 26.2518 15.5995 25.9944 17.9749 25.0104C20.3503 24.0265 22.3807 22.3603 23.8091 20.2224C25.2376 18.0846 26 15.5712 26 13C25.996 9.55341 24.6251 6.24912 22.188 3.81201C19.7509 1.3749 16.4466 0.00398351 13 0V0ZM19.1914 10.7236L11.8574 17.7236C11.671 17.9011 11.4234 18 11.166 18C10.9086 18 10.6611 17.9011 10.4746 17.7236L6.8086 14.2236C6.61707 14.0402 6.5062 13.7882 6.50033 13.523C6.49446 13.2579 6.59407 13.0012 6.77729 12.8095C6.96051 12.6177 7.21235 12.5065 7.4775 12.5003C7.74265 12.4941 7.99942 12.5934 8.19141 12.7764L11.166 15.6172L17.8086 9.27637C18.0006 9.09339 18.2574 8.9941 18.5225 9.00031C18.7877 9.00651 19.0395 9.11771 19.2227 9.30947C19.4059 9.50123 19.5056 9.75788 19.4997 10.023C19.4938 10.2882 19.3829 10.5402 19.1914 10.7236V10.7236Z",
                  fill: "#3BBA50"
                })
              ),
              React__default.createElement(
                "span",
                { className: "fileName" },
                file.name.length > 35 ? file.name.substring(0, 35) + "..." : file.name
              )
            ),
            React__default.createElement(
              "div",
              {
                style: { cursor: "pointer" },
                onClick: function onClick() {
                  return _this.handleProgressDelete(name, index, "delete");
                }
              },
              React__default.createElement(Icon, { name: "trash", color: "red" })
            )
          ),
          progress < 100 ? React__default.createElement("svg", {
            style: { cursor: "pointer" },
            onClick: function onClick() {},
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }) : null
        ),
        React__default.createElement(
          "div",
          { id: "myProgress" },
          React__default.createElement("div", { id: "myBar", style: { width: progress + "%" } })
        ),
        React__default.createElement(
          "div",
          { className: "fileDetails" },
          React__default.createElement(
            "span",
            { className: "fileData" },
            progress,
            "% done"
          ),
          React__default.createElement(
            "span",
            { className: "fileData fileSize" },
            Number(file.size) / 1000,
            " kb"
          )
        ),
        _this.state.deleteProgressModalOpen && _this.state.clickedIndex === index && _this.renderProgressConfirmDelete(name, "progressScreen")
      );
    };

    _this.renderDragAndDropAreas = function () {
      var dragAndDropAreas = multipleDocUploadList;
      var selectedFiles = _this.state.selectedFiles;


      return dragAndDropAreas.map(function (docName, index) {
        var text = docName.text;

        return React__default.createElement(
          "div",
          {
            key: index,
            style: {
              borderRadius: "8px",
              background: "#FFF",
              border: "1px dashed #B9ADA2",
              display: "flex",
              padding: "20px",
              flexDirection: "column",
              alignItems: "flex-start",
              margin: "10px 0"
            }
          },
          selectedFiles[text] && selectedFiles[text].existingFile ? _this.renderFileViewScreen(text, index, selectedFiles[text].existingFile) : _this.renderFileUploadScreen("Upload", text, index)
        );
      });
    };

    _this.renderFileViewScreen = function (text, index) {
      var fileName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var _this$state2 = _this.state,
          selectedFiles = _this$state2.selectedFiles,
          isGateInMarked = _this$state2.isGateInMarked;
      var _this$props2 = _this.props,
          historyMode = _this$props2.historyMode,
          containerInfo = _this$props2.containerInfo;
      // let gateInTime = get(containerInfo, "gateIn.OPSTime", null);

      var isUploadClicked = selectedFiles[text] && selectedFiles[text].isReuploadClicked;
      var isDeleteButtonClicked = selectedFiles[text] && selectedFiles[text].isDeleteClicked;

      var documentName = fileName ? fileName.substring(0, 35) + "..." : null;
      // if (documentName) documentName = `${documentName.substring(0, 35)}...`;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%"
            }
          },
          documentName ? React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "20px",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
              }
            },
            React__default.createElement(
              "div",
              null,
              React__default.createElement(
                "div",
                {
                  style: { fontSize: "16px", fontWeight: "400" }
                },
                text + " Document"
              ),
              React__default.createElement(
                "p",
                { className: "uploadFileMsg" },
                documentName
              )
            ),
            React__default.createElement(
              "div",
              null,
              React__default.createElement(
                "div",
                { className: "gate_in_icons" },
                React__default.createElement(
                  "span",
                  {
                    className: "viewFile",
                    style: { cursor: "pointer" },
                    "data-tooltip": "View file",
                    "data-position": "bottom right",
                    onClick: function onClick() {
                      return _this.getFileUrl(text, index);
                    }
                  },
                  React__default.createElement(Icon, { name: "eye", size: "large" })
                ),
                get(_this.props, "accessType", "") !== "readOnly" && React__default.createElement(
                  "span",
                  {
                    className: "viewFile",
                    style: { cursor: "pointer" },
                    "data-tooltip": "Reupload file",
                    "data-position": "bottom right",
                    onClick: function onClick() {
                      return _this.handleIconClick(text, index, "reupload");
                    }
                  },
                  React__default.createElement(Icon, { name: "upload", color: "black", size: "large" })
                ),
                !historyMode && !isGateInMarked && get(_this.props, "accessType", "") !== "readOnly" && React__default.createElement(
                  "span",
                  {
                    "data-position": "bottom right",
                    "data-tooltip": "Delete file",
                    onClick: function onClick() {
                      return _this.handleDeleteScreen(text, index, "delete");
                    },
                    style: { cursor: "pointer" }
                  },
                  React__default.createElement(Icon, { name: "trash", color: "red" })
                )
              )
            )
          ) : _this.renderFileUploadScreen("Upload", text, index),
          isDeleteButtonClicked && get(_this.props, "accessType", "") !== "readOnly" && _this.renderConfirmDeleteScreen(text),
          isUploadClicked && get(_this.props, "accessType", "") !== "readOnly" && _this.renderFileUploadScreen("Reupload", text, index, fileName)
        )
      );
    };

    _this.renderFileReUploadScreen = function () {};

    _this.handleCloseReuploadScreen = function (text) {
      _this.setState(function (prevState) {
        return {
          selectedFiles: _extends({}, prevState.selectedFiles, defineProperty({}, text, _extends({}, prevState.selectedFiles[text], {
            isReuploadClicked: false,
            uploadUrl: ""
          })))
        };
      });
    };

    _this.renderFileUploadScreen = function (screen, text, index, fileName) {
      var screenName = screen ? screen : "Upload";
      var fileInfo = _this.state.selectedFiles[text] || {};
      var fileUploaded = get(fileInfo, "uploaded", false);
      var fileUploadError = get(fileInfo, "error", false);
      var showUploadProgress = fileInfo && fileUploaded && !fileUploadError;

      if (get(_this.props, "accessType", "") === "readOnly") return;

      return React__default.createElement(
        "div",
        {
          style: screen === "Reupload" ? {
            borderRadius: "8px",
            background: "#FFF",
            border: "1px dashed #B9ADA2",
            display: "flex",
            padding: "20px",
            flexDirection: "column",
            alignItems: "flex-start",
            margin: "10px 0",
            width: "100%",
            position: "relative"
          } : {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: "100%",
            position: "relative"
          }
        },
        showUploadProgress ? _this.renderUploadProgressScreen(text, fileInfo, index) : React__default.createElement(
          React__default.Fragment,
          null,
          screen === "Reupload" && React__default.createElement(
            "span",
            {
              onClick: function onClick() {
                return _this.handleCloseReuploadScreen(text);
              },
              style: {
                cursor: "pointer",
                position: "absolute",
                right: "10px",
                zIndex: "1"
              }
            },
            React__default.createElement(Icon, { name: "close", color: "red" })
          ),
          React__default.createElement(
            "div",
            {
              style: {
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start"
              }
            },
            React__default.createElement("input", {
              type: "file",
              name: text,
              className: "file-upload-input",
              onChange: function onChange(event) {
                return _this.onFileChange(event, screen, fileName);
              },
              accept: "image/*, application/pdf",
              style: { height: "80px", width: "100%" }
            }),
            React__default.createElement(
              "div",
              {
                style: {
                  fontSize: "16px",
                  fontWeight: "400",
                  display: "flex",
                  justifyContent: "space-between"
                }
              },
              React__default.createElement(
                "span",
                null,
                screenName + " " + text + " Document"
              )
            ),
            React__default.createElement(
              "p",
              { className: "uploadFileMsg" },
              "Drop your files here or",
              " ",
              React__default.createElement(
                "span",
                { className: "text-green" },
                "Browse"
              )
            )
          )
        )
      );
    };

    _this.areAllDocsUploaded = function () {
      var selectedFiles = _this.state.selectedFiles;


      var docKeys = Object.keys(selectedFiles);
      return docKeys.length > 0 && docKeys.some(function (key) {
        return selectedFiles[key].uploaded;
      });
    };

    _this.handleConfirmClick = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _this$props3, containerInfo, showDragAndDropModal, resetFilters, historyMode, entityId, shipmentIds, entityEventID, containerID, entityShipmentList, selectedFiles, docKeys, filteredDocList, attachmentAction, isArchived, listOfFirstApiPromises, listOfSecondApiPromises, listOfFinalResultError, listOfFinalResultSuccess;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props3 = _this.props, containerInfo = _this$props3.containerInfo, showDragAndDropModal = _this$props3.showDragAndDropModal, resetFilters = _this$props3.resetFilters, historyMode = _this$props3.historyMode;

              if (isEmpty(containerInfo)) {
                _context4.next = 26;
                break;
              }

              _context4.prev = 2;
              entityId = containerInfo.entityId, shipmentIds = containerInfo.shipmentIds, entityEventID = containerInfo.gateIn.entityEventID, containerID = containerInfo.containerID, entityShipmentList = containerInfo.entityShipmentList;
              selectedFiles = _this.state.selectedFiles;
              docKeys = Object.entries(selectedFiles);
              filteredDocList = [];


              if (!isEmpty(docKeys)) {
                filteredDocList = docKeys.filter(function (doc) {
                  return doc[1] && get(doc[1], "uploaded", false);
                });
              }

              attachmentAction = 0;
              isArchived = historyMode ? true : false;
              listOfFirstApiPromises = [];
              listOfSecondApiPromises = [];


              filteredDocList.forEach(function (docs) {
                var key = get(docs, "[0]", null) && docs[0];
                var docValues = get(docs, "[1]", null);
                var attachmentType = 0;
                var uploadUrl = get(docValues, "uploadUrl", "");

                if (key === "EIR") attachmentType = 1;

                if (key && docValues && uploadUrl) {
                  // Returning an object with key and the API call result
                  listOfFirstApiPromises.push({
                    key: key,
                    promise: updateDrayagePartnerGateInFileData(attachmentAction, attachmentType, entityEventID, entityId, shipmentIds, isArchived, uploadUrl)
                  });
                }

                var drayageBillUploadUrl = get(docValues, "drayageBillUploadUrl", "");
                var isReplaceCheck = get(docValues, "isReplacementDocument", false);
                var documentType = key;
                if (key && docValues && drayageBillUploadUrl) {
                  if (_.isArray(entityShipmentList) && !_.isEmpty(entityShipmentList)) {
                    entityShipmentList.forEach(function (shipment) {
                      listOfSecondApiPromises.push({
                        key: key,
                        promise: insertDrayageDocument(shipment.containerId, drayageBillUploadUrl, drayageBillUploadUrl, isReplaceCheck, documentType)
                      });
                    });
                  } else {
                    listOfSecondApiPromises.push({
                      key: key,
                      promise: insertDrayageDocument(containerID, drayageBillUploadUrl, drayageBillUploadUrl, isReplaceCheck, documentType)
                    });
                  }
                }
              });

              listOfFinalResultError = [];
              listOfFinalResultSuccess = [];
              _context4.next = 17;
              return Promise.allSettled(listOfFirstApiPromises.map(function (item) {
                return item.promise;
              })).then(function (results) {
                results.forEach(function (result, index) {
                  var key = get(listOfFirstApiPromises, "[" + index + "].key", "");

                  if (result.status === "fulfilled") {
                    var isSuccess = get(result, "value.data.eventMessage.value", "");
                    if (isSuccess && isSuccess.includes("SUCCESS")) {
                      listOfFinalResultSuccess.push("" + key);
                    } else {
                      listOfFinalResultError.push("" + key);
                    }
                  } else {
                    listOfFinalResultError.push("" + key);
                  }
                });
              });

            case 17:

              if (listOfFinalResultSuccess.length === listOfFirstApiPromises.length) {
                _this.setState({
                  successConfirmationScreen: true,
                  successMessage: "You have successfully submitted your document."
                }, function () {
                  setTimeout(function () {
                    resetFilters();
                    showDragAndDropModal && showDragAndDropModal(false, "reset");
                  }, 2000);
                });
              } else {
                _this.setState({
                  onConfirmationError: !isEmpty(listOfFinalResultError) ? "Error uploading " + listOfFinalResultError.join(", ") + " documents." : ""
                }, function () {
                  setTimeout(function () {
                    _this.setState({ onConfirmationError: "" });
                  }, 2000);
                });
              }
              _context4.next = 24;
              break;

            case 20:
              _context4.prev = 20;
              _context4.t0 = _context4["catch"](2);

              console.log(_context4.t0);
              _this.setState({
                onConfirmationError: "Something went wrong."
              }, function () {
                setTimeout(function () {
                  _this.setState({ onConfirmationError: "" });
                }, 2000);
              });

            case 24:
              _context4.next = 27;
              break;

            case 26:
              // Display a message or handle the scenario when both documents are not uploaded
              console.log("Please upload both documents before confirming.");

            case 27:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this2, [[2, 20]]);
    }));

    _this.successScreen = function () {
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "modalHolder uploadScreenModal" },
          React__default.createElement(
            "div",
            { className: "modal-contentHolder modal-lg" },
            React__default.createElement(
              "div",
              {
                className: "modal-content",
                style: {
                  backgroundColor: "#F0FAF1",
                  padding: "20px"
                }
              },
              React__default.createElement(
                "div",
                { className: "successScreen" },
                React__default.createElement(
                  "svg",
                  {
                    width: "80",
                    height: "80",
                    viewBox: "0 0 130 130",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  },
                  React__default.createElement("path", {
                    d: "M64.9989 2C81.7018 2.0196 97.715 8.66349 109.526 20.4743C121.337 32.2853 127.981 48.299 128 65.0023C128 77.4617 124.305 89.6413 117.383 100.001C110.46 110.361 100.621 118.436 89.1091 123.204C77.5973 127.973 64.9301 129.22 52.7093 126.789C40.4885 124.359 29.263 118.358 20.4523 109.548C11.6416 100.737 5.64143 89.5115 3.21056 77.2907C0.779688 65.0699 2.0273 52.4027 6.79562 40.8909C11.5639 29.3792 19.6388 19.5399 29.9991 12.6174C40.3591 5.6951 52.539 2.00023 64.9989 2ZM60.6657 90.0671L60.668 90.0649L97.3379 55.0649L95.9571 53.6182L97.3405 55.0625C98.6809 53.7785 99.4569 52.0151 99.4979 50.1594C99.539 48.3038 98.8419 46.5077 97.5597 45.1657C96.2774 43.8237 94.5149 43.0455 92.6594 43.0021C90.8038 42.9586 89.0068 43.6535 87.6632 44.934L87.662 44.9351L55.8304 75.3207L42.3384 62.4355L42.3369 62.434C40.9932 61.1535 39.1963 60.4586 37.3407 60.5021C35.4851 60.5455 33.7226 61.3237 32.4404 62.6657C31.1582 64.0077 30.461 65.8038 30.5021 67.6594C30.5432 69.515 31.3191 71.2785 32.6595 72.5625L32.6619 72.5648L50.992 90.0648L50.9945 90.0671C52.2987 91.308 54.0299 92 55.8301 92C57.6303 92 59.3616 91.308 60.6657 90.0671Z",
                    fill: "#2B8C3B",
                    stroke: "#2B8C3B",
                    "stroke-width": "4"
                  })
                ),
                React__default.createElement(
                  "p",
                  { className: "successText" },
                  "Success!"
                ),
                React__default.createElement(
                  "p",
                  { className: "successMessage" },
                  _this.state.successMessage
                )
              )
            )
          )
        )
      );
    };

    _this.displayMessage = function (title, color) {
      return React__default.createElement(
        "div",
        {
          style: {
            marginTop: "10px",
            marginLeft: "10px",
            color: color
          }
        },
        title
      );
    };

    _this.handleDocDownload = function () {
      if (_this.state.viewDocUrl) {
        window.open(_this.state.viewDocUrl, "_blank");
      }
    };

    _this.renderViewFilesModal = function () {
      return _this.state.viewDocUrl ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "modalHolder uploadScreenModal" },
          React__default.createElement(
            "div",
            { className: "modal-contentHolder modal-lg" },
            React__default.createElement(
              "div",
              {
                className: "modal-content",
                style: {
                  backgroundColor: "#F0FAF1",
                  padding: "20px"
                }
              },
              React__default.createElement(
                "div",
                { className: "fileViewerModal" },
                isString(_this.state.viewDocUrl) && (_this.state.viewDocUrl.includes("pdf") || _this.state.viewDocUrl.includes("PDF")) ? React__default.createElement(
                  Document,
                  {
                    file: _this.state.viewDocUrl,
                    loading: _this.displayMessage("Loading PDF ...", "black"),
                    error: _this.displayMessage("Error Loading Document", "red"),
                    onLoadSuccess: function onLoadSuccess(pdf) {
                      _this.onDocumentLoadSuccess(pdf);
                    }
                  },
                  _this.state.numPages.length > 0 && _this.state.numPages.map(function (item, index) {
                    return React__default.createElement(Page, {
                      pageNumber: item,
                      loading: "",
                      className: "pdf-view"
                    });
                  })
                ) : React__default.createElement("img", { className: "modalFileImage", src: _this.state.viewDocUrl })
              ),
              React__default.createElement(
                "div",
                { className: "custom-modal-footer justify-end" },
                React__default.createElement(
                  Button,
                  {
                    className: "button btn-confirm",
                    onClick: _this.handleDocDownload
                  },
                  "Download"
                ),
                React__default.createElement(
                  Button,
                  {
                    className: "button",
                    onClick: function onClick() {
                      return _this.setState({ viewDocUrl: "" });
                    }
                  },
                  "Cancel"
                )
              )
            )
          )
        )
      ) : null;
    };

    _this.getFileUrl = function () {
      var _ref6 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(key, index) {
        var containerInfo, entityId, shipmentIds, entityEventID, containerID, attachmentAction, attachmentType, resp, pdfUrl;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                containerInfo = _this.props.containerInfo;

                if (!(key && !isEmpty(containerInfo))) {
                  _context5.next = 12;
                  break;
                }

                entityId = containerInfo.entityId, shipmentIds = containerInfo.shipmentIds, entityEventID = containerInfo.gateIn.entityEventID, containerID = containerInfo.containerID;
                attachmentAction = 2;
                attachmentType = 0;

                if (!(entityEventID || shipmentIds && entityId)) {
                  _context5.next = 12;
                  break;
                }

                attachmentType = index;
                _context5.next = 10;
                return handleFileUrl(entityEventID, entityId, shipmentIds, attachmentAction, attachmentType);

              case 10:
                resp = _context5.sent;

                if (resp.status == 200) {
                  pdfUrl = get(resp, "data.eventMessage.url", "");

                  _this.setState({ viewDocUrl: pdfUrl });
                }

              case 12:
                _context5.next = 17;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this2, [[0, 14]]);
      }));

      return function (_x8, _x9) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.state = {
      selectedFiles: {},
      successConfirmationScreen: false,
      successMessage: "",
      numPages: [],
      viewDocUrl: "",
      clickedIndex: null,
      clickedIconType: null,
      deleteModalOpen: false,
      eirDocument: null,
      deleteProgressModalOpen: false,
      onConfirmationError: "",
      archiveDocList: [],
      isGateInMarked: false
    };
    return _this;
  }

  createClass(UploadDocScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          proofOfGateIn = _props.proofOfGateIn,
          containerInfo = _props.containerInfo,
          checkGateInMarked = _props.checkGateInMarked;

      var _splitProofOfGateIn = this.splitProofOfGateIn(proofOfGateIn),
          _splitProofOfGateIn2 = slicedToArray(_splitProofOfGateIn, 2),
          eirDoc = _splitProofOfGateIn2[0],
          podDoc = _splitProofOfGateIn2[1];

      this.updateSelectedFiles("EIR", eirDoc);
      this.updateSelectedFiles("POD", podDoc);

      var containerId = get(containerInfo, "containerID", null);

      if (containerId) {
        this.getArchieveList(containerId);
      }

      // To check if gateIn is marked
      var entityTimezone = get(containerInfo, "entityTimezone", "");
      var fieldName = "gateIn";
      var stageInfo = get(containerInfo, "gateIn", {});

      var _checkGateInMarked = checkGateInMarked({
        fieldName: fieldName,
        entityTimezone: entityTimezone,
        stageInfo: stageInfo
      }),
          dataList = _checkGateInMarked.dataList,
          sourceSelected = _checkGateInMarked.sourceSelected;

      if (dataList && isArray(dataList) && !isEmpty(dataList)) {
        var dataListArr = dataList.map(function (str) {
          return isString(str) ? str.trim() : "";
        });
        var joinedString = dataListArr.join("");

        if (joinedString) {
          this.setState({ isGateInMarked: true });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var proofOfGateIn = this.props.proofOfGateIn;


      if (!isEqual(prevProps.proofOfGateIn, proofOfGateIn)) {
        var _splitProofOfGateIn3 = this.splitProofOfGateIn(proofOfGateIn),
            _splitProofOfGateIn4 = slicedToArray(_splitProofOfGateIn3, 2),
            eirDoc = _splitProofOfGateIn4[0],
            podDoc = _splitProofOfGateIn4[1];

        this.updateSelectedFiles("EIR", eirDoc);
        this.updateSelectedFiles("POD", podDoc);
      }
    }
  }, {
    key: "onDocumentLoadSuccess",
    value: function onDocumentLoadSuccess(pdf) {
      var myArr = [];
      for (var i = 1; i <= pdf._pdfInfo.numPages; i++) {
        myArr.push(i);
      }
      this.setState({ numPages: myArr });
    }
  }, {
    key: "render",
    value: function render() {
      var isConfirmEnabled = this.areAllDocsUploaded();
      var showDragAndDropModal = this.props.showDragAndDropModal;


      if (this.state.successConfirmationScreen) {
        return React__default.createElement(
          React__default.Fragment,
          null,
          this.successScreen()
        );
      }

      if (this.state.viewDocUrl) {
        return React__default.createElement(
          React__default.Fragment,
          null,
          this.renderViewFilesModal()
        );
      }

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "modalHolder uploadScreenModal" },
          React__default.createElement(
            "div",
            { className: "modal-contentHolder modal-lg" },
            React__default.createElement(
              "div",
              {
                className: "modal-content",
                style: {
                  backgroundColor: "#F0FAF1",
                  padding: "20px"
                }
              },
              React__default.createElement(
                "div",
                {
                  style: {
                    fontSize: "18px",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "24px"
                  }
                },
                (this.props.viewAttachment ? "Manage" : "Upload") + " Documents"
              ),
              this.renderDragAndDropAreas(),
              this.state.onConfirmationError && React__default.createElement(Message, {
                negative: true,
                content: this.state.onConfirmationError,
                info: true,
                style: { width: "100%" }
              }),
              React__default.createElement(
                "div",
                { className: "custom-modal-footer justify-end" },
                React__default.createElement(
                  Button,
                  {
                    className: "button btn-confirm",
                    onClick: this.handleConfirmClick,
                    disabled: !isConfirmEnabled
                  },
                  "Confirm"
                ),
                React__default.createElement(
                  Button,
                  {
                    className: "button",
                    onClick: function onClick() {
                      return showDragAndDropModal(false, "reset");
                    }
                  },
                  "Cancel"
                )
              )
            )
          )
        )
      );
    }
  }]);
  return UploadDocScreen;
}(Component);

var ModalDatePicker = function (_Component) {
    inherits(ModalDatePicker, _Component);

    function ModalDatePicker(props) {
        classCallCheck(this, ModalDatePicker);

        var _this = possibleConstructorReturn(this, (ModalDatePicker.__proto__ || Object.getPrototypeOf(ModalDatePicker)).call(this, props));

        _this.state = {};
        return _this;
    }

    createClass(ModalDatePicker, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                modalOpen = _props.modalOpen,
                errorMessage = _props.errorMessage,
                handleModalClose = _props.handleModalClose,
                handleModalOpen = _props.handleModalOpen,
                handleDateChange = _props.handleDateChange,
                handleExportSubmitClick = _props.handleExportSubmitClick,
                startDate = _props.startDate,
                endDate = _props.endDate;

            return React__default.createElement(
                Fragment,
                null,
                React__default.createElement(
                    Modal,
                    {
                        onClose: handleModalClose,
                        onOpen: handleModalOpen,
                        open: modalOpen
                    },
                    React__default.createElement(
                        Modal.Header,
                        null,
                        "Select ETA Range"
                    ),
                    React__default.createElement(
                        Modal.Content,
                        null,
                        React__default.createElement(
                            "div",
                            { style: { display: "flex", gap: "10px", flexDirection: "column" } },
                            React__default.createElement(
                                "div",
                                { style: { display: "flex", gap: "10px", alignItems: "center" } },
                                React__default.createElement(
                                    "div",
                                    { style: { width: "100px" } },
                                    "ETA After"
                                ),
                                React__default.createElement(
                                    "div",
                                    { style: { width: "200px" } },
                                    React__default.createElement(DatePicker, { selected: endDate, dateFormat: "MMM d, yyyy", placeholderText: "Select Date", onChange: function onChange(date) {
                                            return handleDateChange('endDate', date);
                                        } })
                                )
                            ),
                            React__default.createElement(
                                "div",
                                { style: { display: "flex", gap: "10px", alignItems: "center" } },
                                React__default.createElement(
                                    "div",
                                    { style: { width: "100px" } },
                                    "ETA Before"
                                ),
                                React__default.createElement(
                                    "div",
                                    { style: { width: "200px" } },
                                    React__default.createElement(DatePicker, { selected: startDate, dateFormat: "MMM d, yyyy", placeholderText: "Select Date", onChange: function onChange(date) {
                                            return handleDateChange('startDate', date);
                                        } })
                                )
                            ),
                            errorMessage && React__default.createElement(
                                Message,
                                { style: { width: "100%" }, negative: true, size: "small" },
                                errorMessage
                            )
                        )
                    ),
                    React__default.createElement(
                        Modal.Actions,
                        null,
                        React__default.createElement(
                            Button,
                            { onClick: handleModalClose },
                            "Cancel"
                        ),
                        React__default.createElement(
                            Button,
                            { onClick: handleExportSubmitClick, positive: true },
                            "Submit"
                        )
                    )
                )
            );
        }
    }]);
    return ModalDatePicker;
}(Component);

var KnModal = function (_Component) {
  inherits(KnModal, _Component);

  function KnModal(props) {
    classCallCheck(this, KnModal);

    var _this = possibleConstructorReturn(this, (KnModal.__proto__ || Object.getPrototypeOf(KnModal)).call(this, props));

    _this.state = {};
    return _this;
  }

  createClass(KnModal, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          openModal = _props.openModal,
          _onClose = _props.onClose,
          _onOpen = _props.onOpen,
          handleConfirmation = _props.handleConfirmation,
          header = _props.header,
          content = _props.content,
          footer = _props.footer,
          size = _props.size,
          style = _props.style,
          className = _props.className;


      return React__default.createElement(
        Modal,
        {
          size: size //'tiny'
          , onClose: function onClose() {
            return _onClose();
          },
          onOpen: function onOpen() {
            return _onOpen();
          },
          open: openModal,
          style: style,
          className: className
        },
        React__default.createElement(
          Modal.Header,
          null,
          header
        ),
        React__default.createElement(
          Modal.Content,
          { scrolling: true, style: { width: "100%" } },
          content
        ),
        React__default.createElement(
          Modal.Actions,
          null,
          footer ? footer : React__default.createElement(
            "button",
            {
              onClick: function onClick() {
                return _onClose();
              },
              className: "simpleButton primaryButton" //secondaryButton
              , type: "submit"
            },
            "OK"
          )
        )
      );
    }
  }]);
  return KnModal;
}(Component);

var ContainerMenu = function (_Component) {
  inherits(ContainerMenu, _Component);

  function ContainerMenu(props) {
    classCallCheck(this, ContainerMenu);

    var _this = possibleConstructorReturn(this, (ContainerMenu.__proto__ || Object.getPrototypeOf(ContainerMenu)).call(this, props));

    _this.updateLoadingState = function () {
      _this.setState({ isLoading: !_this.state.isLoading });
    };

    _this.handleSplitContainer = function () {
      _this.props.onSplitContainerClick(_this.props.containerNumber);
    };

    _this.handleEmailDo = function () {
      _this.props.handleOpenEmailModal(_this.props.containerNumber);
    };

    _this.handleDownloadDo = function () {
      var _this$props = _this.props,
          containerNumber = _this$props.containerNumber,
          shipmentIds = _this$props.shipmentIds;

      var payload = {
        containerNumber: containerNumber,
        shipmentIds: shipmentIds //[]
      };
      downloadDrayageDo(payload).then(function (res) {
        _this.updateLoadingState();
        var urls = get(res.data, "eventMessage.urls", []);
        if (!_$1.isEmpty(urls)) {
          var fileList = [];
          urls.forEach(function (url, index) {
            var fileObj = {
              fileName: "file" + index,
              url: url
            };
            fileList.push(fileObj);
          });
          downloadMultipleFiles(fileList);
        } else {
          _this.setState({
            showResponse: {
              code: 400,
              msg: get(res.data, "eventMessage.msg", "Error while downloading the DO")
            }
          });
        }
      }).catch(function (error) {
        _this.updateLoadingState();
        _this.setState({
          showResponse: {
            code: 400,
            msg: "Network issue."
          }
        });
      });
    };

    _this.CONTAINER_MENU_OPTIONS = getContMenuOptions({
      onSplitContainerClick: _this.handleSplitContainer,
      onEmailDoClick: _this.handleEmailDo,
      onDowloadDoClick: _this.handleDownloadDo,
      userType: _this.props.userType,
      containerInfo: _this.props.containerInfo
    });

    _this.state = {
      isLoading: false,
      showResponseModal: ""
    };
    return _this;
  }

  createClass(ContainerMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var stopPropagation = this.props.stopPropagation;

      return React__default.createElement(
        "div",
        { className: "contMenuWrapper" },
        get(this.state.showResponse, "code", "") && React__default.createElement(
          "p",
          {
            style: {
              color: get(this.state.showResponse, "code", "") === 400 ? "red" : "green"
            }
          },
          get(this.state.showResponse, "msg", "")
        ),
        this.CONTAINER_MENU_OPTIONS.map(function (menu, index) {
          return menu.display && React__default.createElement(
            "div",
            {
              className: "menuBtn",
              style: {
                cursor: _this2.state.isLoading === menu.id ? "not-allowed" : "pointer"
              },
              key: menu.id,
              onClick: function onClick(e) {
                stopPropagation(e);
                if (menu.action === CONTAINER_MENU_ACTIONS.DOWNLOAD_DO) {
                  _this2.setState({ isLoading: menu.id });
                }
                menu.onClick();
              }
            },
            React__default.createElement(
              "div",
              { className: "menuIcon" },
              menu.icon
            ),
            React__default.createElement(
              "div",
              { className: "menuLabel" },
              menu.label,
              _this2.state.isLoading === menu.id ? React__default.createElement(Icon, {
                loading: true,
                name: "spinner",
                style: {
                  marginRight: 5,
                  fontSize: 18,
                  color: "#04adb1"
                }
              }) : null
            ),
            menu.extraInfo && React__default.createElement(
              "div",
              null,
              menu.extraInfo
            )
          );
        })
      );
    }
  }]);
  return ContainerMenu;
}(Component);

var css_248z$j = ".inputLabel {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 10px;\n  font-weight: 600; }\n\n.tagsInput {\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  box-sizing: border-box;\n  min-height: 100px;\n  flex-wrap: wrap;\n  border: 2px solid #eee;\n  color: #666;\n  font-size: 16px;\n  font-weight: 400;\n  height: auto;\n  margin: 0 0 10px;\n  padding: 15px;\n  appearance: none;\n  border-radius: 0;\n  cursor: text; }\n\n#tags {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0;\n  margin: 8px 0 0 0; }\n\n.tag {\n  width: auto;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  padding: 0 8px;\n  font-size: 14px;\n  list-style: none;\n  border-radius: 6px;\n  margin: 0 8px 8px 0;\n  background: #0052cc; }\n\n@media screen and (max-width: 567px) {\n  .tags-input {\n    width: calc(100vw - 32px); } }\n\n.email-input {\n  border: 0;\n  color: #222;\n  font-size: 16px;\n  height: 30px; }\n\n.width-max {\n  width: 100% !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.width-max::placeholder {\n  overflow: visible;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%; }\n\n.width-max::-webkit-input-placeholder {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%; }\n\n.width-min {\n  width: auto;\n  background-color: transparent; }\n\n.email-input::placeholder {\n  color: #222; }\n\n.email-input:hover,\n.email-input:focus {\n  outline: 0; }\n\n.chip-margin {\n  margin: 0 5px 5px 0; }\n\n@media screen and (max-width: 767px) {\n  .email-input {\n    font-size: 12px; } }\n\n.limitReached {\n  color: #d62d1e;\n  font-size: 12px;\n  line-height: 15px;\n  display: flex;\n  align-items: center;\n  padding-bottom: 2px; }\n";
styleInject(css_248z$j);

var Chip = function (_Component) {
  inherits(Chip, _Component);

  function Chip() {
    classCallCheck(this, Chip);
    return possibleConstructorReturn(this, (Chip.__proto__ || Object.getPrototypeOf(Chip)).apply(this, arguments));
  }

  createClass(Chip, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          label = _props.label,
          onDelete = _props.onDelete;

      return React__default.createElement(
        "a",
        { className: className, "class": "ui label" },
        label,
        React__default.createElement("i", { "class": "delete icon", onClick: onDelete })
      );
    }
  }]);
  return Chip;
}(Component);

var KnMultiEmailInput = function (_Component2) {
  inherits(KnMultiEmailInput, _Component2);

  function KnMultiEmailInput(props) {
    classCallCheck(this, KnMultiEmailInput);

    var _this2 = possibleConstructorReturn(this, (KnMultiEmailInput.__proto__ || Object.getPrototypeOf(KnMultiEmailInput)).call(this, props));

    _this2.removeTags = function (indexToRemove) {
      var tags = _this2.state.tags;

      var updatedTags = tags.filter(function (_, index) {
        return index !== indexToRemove;
      });
      _this2.setState({ tags: updatedTags });
      _this2.props.onTagsChange(updatedTags);
    };

    _this2.addTags = function (event) {
      var tags = _this2.state.tags;
      var max = _this2.props.max;

      if (max) {
        if (tags.length < max) {
          if (event.target.value !== "") {
            if (tags.find(function (tag) {
              return tag === event.target.value;
            })) {
              event.target.value = "";
            } else {
              var updatedTags = [].concat(toConsumableArray(tags), [event.target.value]);
              _this2.setState({ tags: updatedTags });
              _this2.props.onTagsChange(updatedTags);
              event.target.value = "";
            }
          }
        } else {
          event.target.value = "";
          _this2.setState({ limitReached: true });
        }
      } else {
        if (event.target.value !== "") {
          if (tags.find(function (tag) {
            return tag === event.target.value;
          })) {
            event.target.value = "";
          } else {
            var _updatedTags = [].concat(toConsumableArray(tags), [event.target.value]);
            _this2.setState({ tags: _updatedTags });
            _this2.props.onTagsChange(_updatedTags);
            event.target.value = "";
          }
        }
      }
    };

    _this2.validateEmail = function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    _this2.onBlurHandler = function () {
      _this2.setState({ limitReached: false });
    };

    _this2.onKeyDown = function (event) {
      var type = _this2.props.type;

      if (event.key === "Enter" || event.key === ",") {
        if (type === "email" && !_this2.validateEmail(event.target.value)) {
          _this2.setState({ error: "Email is not valid" });
          return;
        } else if (type === "text" || type === "email") {
          _this2.addTags(event);
          _this2.setState({ error: "" });
        }
      } else if (event.key === "Backspace" && event.target.value === "") {
        _this2.removeTags(_this2.state.tags.length - 1);
      }
    };

    _this2.onKeyUp = function (event) {
      var type = _this2.props.type;

      if (event.key === "," && (type === "text" || type === "email" && !_this2.validateEmail(event.target.value)) && event.target.value === ",") {
        event.target.value = "";
      }
    };

    _this2.state = {
      tags: props.tags,
      limitReached: false,
      error: ""
    };
    _this2.myInp = React__default.createRef();
    return _this2;
  }

  createClass(KnMultiEmailInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var tags = this.state.tags;
      var _props2 = this.props,
          invite = _props2.invite,
          propsTags = _props2.tags;

      if (prevProps.tags !== propsTags && !invite) {
        this.setState({ tags: propsTags });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          style = _props3.style,
          type = _props3.type,
          max = _props3.max,
          placeholder = _props3.placeholder,
          label = _props3.label,
          required = _props3.required,
          stopPropagation = _props3.stopPropagation;
      var _state = this.state,
          tags = _state.tags,
          limitReached = _state.limitReached,
          error = _state.error;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "inputLabel" },
          label,
          " ",
          required && React__default.createElement(
            "sup",
            { style: { color: "red" } },
            "*"
          )
        ),
        React__default.createElement(
          "div",
          {
            className: "tagsInput",
            onClick: function onClick(e) {
              stopPropagation(e);
              _this3.myInp.current.focus();
            },
            style: style
          },
          tags.map(function (tag, index) {
            return React__default.createElement(Chip, {
              className: "chip-margin",
              key: index,
              label: tag,
              onDelete: function onDelete() {
                return _this3.removeTags(index);
              }
            });
          }),
          React__default.createElement("input", {
            ref: this.myInp,
            className: tags.length === 0 ? "email-input width-max" : "email-input width-min",
            type: "text",
            onKeyDown: this.onKeyDown,
            onKeyUp: this.onKeyUp,
            onBlur: this.onBlurHandler,
            onChange: function onChange(e) {
              if (e.target.value === "") {
                _this3.setState({ error: "" });
              }
            },
            placeholder: tags.length === 0 && placeholder
          })
        ),
        limitReached && max && React__default.createElement(
          "div",
          { className: "limitReached" },
          "You can only add ",
          max,
          " tags."
        ),
        error && React__default.createElement(
          "div",
          { className: "limitReached", style: { color: "red" } },
          error
        )
      );
    }
  }]);
  return KnMultiEmailInput;
}(Component);

var EmailDocuments = function (_Component) {
  inherits(EmailDocuments, _Component);

  function EmailDocuments(props) {
    classCallCheck(this, EmailDocuments);

    var _this = possibleConstructorReturn(this, (EmailDocuments.__proto__ || Object.getPrototypeOf(EmailDocuments)).call(this, props));

    _this.onTagsChange = function (toEmails) {
      _this.setState({ toEmails: toEmails, emailError: "" });
    };

    _this.onCcEmailsChange = function (ccEmails) {
      _this.setState({ ccEmails: ccEmails });
    };

    _this.handleSendingEmail = function () {
      if (lodash.isEmpty(_this.state.toEmails)) {
        _this.setState({ emailError: "At least one recipient is required." });
        return;
      } else {
        _this.setState({ emailError: "", isLoading: true });
        var payload = {
          communicationParams: {
            toEmail: _this.state.toEmails,
            cc: _this.state.ccEmails,
            bcc: []
          },
          comment: _this.state.comment,
          containerNumber: _this.props.containerNumber, //ASDU7877777,
          shipmentIds: _this.props.shipmentIds //["KX-I5H7-19739","KX-I5H7-19732"],
        };

        sendDrayageDoEmail(payload).then(function (res) {
          _this.setState({ isLoading: false });
          var code = lodash_1(res.data, "eventMessage.code", "");
          var msg = lodash_1(res.data, "eventMessage.msg", "Network issue.");
          if (code) {
            _this.setState({ showResponse: { type: code, msg: msg } });
            setTimeout(function () {
              _this.props.onClose();
            }, 3000);
          }
        }).catch(function (error) {
          _this.setState({
            showResponse: {
              type: 400,
              msg: "Network issue."
            },
            isLoading: false
          });
        });
      }
    };

    _this.state = {
      toEmails: [],
      ccEmails: [],
      emailError: "",
      isLoading: false,
      showResponse: {
        type: "",
        msg: ""
      },
      comment: ""
    };
    return _this;
  }

  createClass(EmailDocuments, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          openEmailModal = _props.openEmailModal,
          containerNumber = _props.containerNumber,
          _onClose = _props.onClose,
          _stopPropagation = _props.stopPropagation,
          userType = _props.userType;
      var _state = this.state,
          toEmails = _state.toEmails,
          ccEmails = _state.ccEmails,
          emailError = _state.emailError,
          showResponse = _state.showResponse;

      return React__default.createElement(KnModal, {
        openModal: openEmailModal,
        style: userType === DMODAL_USERS.CUSTOMER ? { position: "absolute", top: "5%" // added position because of conflicts in the css of customer-panel
        } : {},
        className: "emailDocumentModal",
        header: "Email Document(s) for " + containerNumber,
        content: React__default.createElement(
          "div",
          { className: "emailDocumentContainer" },
          this.state.isLoading && React__default.createElement(Icon, {
            loading: true,
            name: "spinner",
            style: {
              marginRight: 5,
              fontSize: 18,
              color: "#04adb1",
              position: "absolute",
              top: 10,
              right: 15
            }
          }),
          lodash_1(showResponse, "type", "") && React__default.createElement(
            "div",
            {
              className: "responseLabel",
              style: {
                color: lodash_1(showResponse, "type", 400) === 200 ? "green" : "red",
                margin: "10px 0px",
                fontSize: 16,
                fontWeight: "600"
              }
            },
            lodash_1(showResponse, "msg", "")
          ),
          React__default.createElement(KnMultiEmailInput, {
            label: "Send To",
            required: true,
            invite: true,
            onTagsChange: this.onTagsChange,
            tags: toEmails,
            type: "email",
            placeholder: "Enter emails here and press Enter...",
            stopPropagation: function stopPropagation(e) {
              return _stopPropagation(e);
            }
          }),
          React__default.createElement(KnMultiEmailInput, {
            label: "CC",
            invite: true,
            onTagsChange: this.onCcEmailsChange,
            tags: ccEmails,
            type: "email",
            placeholder: "Enter emails here and press Enter...",
            stopPropagation: function stopPropagation(e) {
              return _stopPropagation(e);
            }
          }),
          React__default.createElement(
            "p",
            { className: "commentInputLabel" },
            "Comment"
          ),
          React__default.createElement("textarea", {
            className: "mailCommentsInput",
            placeholder: "Comments to be attached in the mail...",
            value: this.state.comment,
            onClick: function onClick(e) {
              return _stopPropagation(e);
            },
            onChange: function onChange(e) {
              return _this2.setState({ comment: e.target.value });
            }
          }),
          emailError && React__default.createElement(
            "div",
            {
              style: {
                color: "red",
                margin: "10px 0px"
              }
            },
            emailError
          )
        ),
        onClose: function onClose() {
          _onClose();
        },
        onOpen: function onOpen() {},
        footer: React__default.createElement(
          React__default.Fragment,
          null,
          React__default.createElement(
            "button",
            {
              onClick: function onClick(e) {
                _stopPropagation(e);
                _onClose();
              },
              className: "simpleButton secondaryButton",
              type: "submit"
            },
            "Cancel"
          ),
          React__default.createElement(
            "button",
            {
              onClick: function onClick(e) {
                _stopPropagation(e);
                _this2.handleSendingEmail(e);
              },
              className: "simpleButton primaryButton",
              type: "submit"
            },
            "Send Document"
          )
        )
      });
    }
  }]);
  return EmailDocuments;
}(Component);

var LoaderModal = function LoaderModal(_ref) {
  var open = _ref.open,
      loading = _ref.loading,
      message = _ref.message,
      _onClose = _ref.onClose;

  return React__default.createElement(
    Modal,
    {
      open: open,
      size: "tiny",
      onClose: function onClose() {
        return _onClose();
      },
      closeOnDimmerClick: false
    },
    React__default.createElement(
      Modal.Content,
      { style: { width: "100%" } },
      React__default.createElement(
        React__default.Fragment,
        null,
        loading ? React__default.createElement(
          "div",
          null,
          "Loading..."
        ) : React__default.createElement(
          "div",
          null,
          message
        )
      )
    )
  );
};

var css_248z$k = ".splitContainerModal {\n  width: fit-content !important;\n  max-width: 80vw !important;\n  height: 65vh !important;\n  font-family: Inter;\n  position: relative;\n  z-index: 1000;\n  display: flex;\n  /* Make the modal a flex container */\n  flex-direction: column;\n  /* Stack children vertically */ }\n  .splitContainerModal .ui.dropdown .menu {\n    z-index: 1050 !important; }\n  .splitContainerModal .modalHeader {\n    position: relative;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px; }\n    .splitContainerModal .modalHeader .close.icon {\n      position: absolute;\n      right: 1rem;\n      top: 0.75rem;\n      font-size: 1.2rem;\n      font-weight: 200; }\n  .splitContainerModal .scrollableContent {\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    /* This handles the overall modal content scrolling */\n    width: 100% !important;\n    flex: 1;\n    /* Allow this content to grow and take available space */\n    padding-bottom: 1rem; }\n    .splitContainerModal .scrollableContent .kn-splitloader {\n      width: 70vw;\n      height: 40vh;\n      display: flex;\n      align-items: center;\n      justify-content: center; }\n    .splitContainerModal .scrollableContent .summary {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n      margin-bottom: 1rem;\n      background-color: #f5f5f5;\n      border-radius: 8px;\n      padding: 20px 32px;\n      color: #212121;\n      font-size: 14px;\n      align-items: center;\n      justify-content: space-between; }\n    .splitContainerModal .scrollableContent .table-header {\n      margin: 1rem 0 0.5rem;\n      font-weight: bold;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 10px; }\n      .splitContainerModal .scrollableContent .table-header .addRowButton {\n        color: #33657c;\n        border: 1px solid #33657c;\n        border-radius: 6px;\n        padding: 4px 12px;\n        background-color: white; }\n    .splitContainerModal .scrollableContent .table-scroll-container {\n      overflow-x: auto;\n      gap: 1rem;\n      max-height: 150px;\n      overflow-y: auto; }\n      .splitContainerModal .scrollableContent .table-scroll-container .splitContainerTableHeader {\n        font-family: Roboto;\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 12px; }\n      .splitContainerModal .scrollableContent .table-scroll-container .ui.table {\n        min-width: 1000px;\n        width: max-content; }\n      .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow {\n        background-color: #fff; }\n        .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow .custom-multiselect-prime-style .trigger-container {\n          width: 100%;\n          display: flex;\n          justify-content: space-between;\n          align-items: center; }\n          .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow .custom-multiselect-prime-style .trigger-container .dropdown-trigger-label {\n            display: inline-block;\n            padding: 0.67857143em 1em;\n            width: 100%;\n            color: rgba(0, 0, 0, 0.87);\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            max-width: 100%;\n            padding-right: \"0\"; }\n        .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow .kn-splitSearchInput {\n          width: 100%; }\n          .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow .kn-splitSearchInput .ellipsis-input input {\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            border-radius: 0px; }\n          .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow .kn-splitSearchInput .customSearchByText .right {\n            margin-left: 0px !important; }\n          .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow .kn-splitSearchInput .customSearchByText .content {\n            padding: 0; }\n        .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow .custom-input-without-border > input {\n          border: none !important;\n          box-shadow: none !important;\n          border: none !important; }\n        .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow .custom-input-without-border {\n          border-radius: 6px;\n          padding: 0;\n          border: 1px solid #ced4da !important; }\n        .splitContainerModal .scrollableContent .table-scroll-container .splitTableRow .custom-action-dropdown {\n          border: 1px solid #ced4da !important;\n          height: fit-content !important;\n          background-color: #f5f5f5 !important;\n          margin: auto 5px;\n          padding: 2px 4px;\n          border-radius: 6px !important;\n          color: #495057;\n          font-family: Inter;\n          font-size: 11px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 12px; }\n  .splitContainerModal .splitModalSubmit {\n    color: #fff;\n    font-family: Inter;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 16px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding: 1rem;\n    background-color: white;\n    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); }\n    .splitContainerModal .splitModalSubmit .cancel {\n      background-color: #64748b;\n      border: 1px solid #64748b;\n      color: white !important; }\n    .splitContainerModal .splitModalSubmit .confirm {\n      color: white !important;\n      background-color: #33657c;\n      border: 1px solid #33657c; }\n\n.ui.search.customSearchByText > .results {\n  display: none !important; }\n\n.kn-splitSearchInput.search-dropdown-wrapper {\n  position: relative; }\n\n.custom-dropdown-box {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ccc;\n  z-index: 9999;\n  max-height: 250px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); }\n\n.custom-dropdown-scroll {\n  flex: 1 1 auto;\n  overflow-y: auto; }\n\n.custom-dropdown-item {\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.custom-dropdown-item:hover {\n  background-color: #f0f8ff; }\n\n.custom-dropdown-add:hover {\n  background: #e6f7ff; }\n\n.custom-dropdown-noresult,\n.custom-dropdown-loading {\n  padding: 12px;\n  color: #999;\n  text-align: center; }\n\n.custom-dropdown-box {\n  border-radius: 0 0 4px 4px;\n  /* Adjust as needed for bottom corners */ }\n\n.custom-dropdown-add {\n  flex-shrink: 0;\n  padding: 10px;\n  text-align: center;\n  cursor: pointer;\n  background: #f9f9f9;\n  font-weight: bold;\n  color: #2185d0;\n  border-top: 1px solid #eee; }\n\n.addAddressModalContainer {\n  color: #212121;\n  font-feature-settings: \"liga\" off, \"clig\" off;\n  font-family: Inter;\n  font-style: normal;\n  border-radius: 8px;\n  background: var(--Lara-Surface-surface-0, #fff);\n  box-shadow: 2px 8px 25px 0px rgba(0, 0, 0, 0.15); }\n  .addAddressModalContainer .addAddressHeader {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 24px;\n    border-bottom: none !important; }\n  .addAddressModalContainer .addAddressFormContainer {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px; }\n    .addAddressModalContainer .addAddressFormContainer .custom-label {\n      color: var(--Lara-Surface-surface-900, #212121);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 16px;\n      /* 133.333% */ }\n  .addAddressModalContainer .addAddressModalFooter {\n    border-top: none !important;\n    border-radius: 6px;\n    display: flex;\n    padding: var(--Spacing-3, 8px) var(--Spacing-5, 16px);\n    align-items: center;\n    justify-content: right;\n    gap: var(--Spacing-3, 8px);\n    font-family: Inter;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 16px;\n    /* 123.077% */ }\n    .addAddressModalContainer .addAddressModalFooter .action-cancel {\n      color: #fff !important;\n      background: var(--Lara-Button-secondaryButtonBg, #64748b);\n      border: 1px solid var(--Lara-Button-secondaryButtonBorder, #64748b); }\n    .addAddressModalContainer .addAddressModalFooter .action-confirm {\n      color: #fff !important;\n      border: 1px solid var(--KN-Theme-Primary-Indigo-indigo-400, #33657c);\n      background: var(--KN-Theme-Primary-Indigo-indigo-400, #33657c); }\n\n.dray-partner-dropdown .text:not(.menu .text) {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  max-width: 100%; }\n";
styleInject(css_248z$k);

var LocationInput = function (_Component) {
  inherits(LocationInput, _Component);

  function LocationInput(props) {
    var _this2 = this;

    classCallCheck(this, LocationInput);

    var _this = possibleConstructorReturn(this, (LocationInput.__proto__ || Object.getPrototypeOf(LocationInput)).call(this, props));

    _this.handleClickOutside = function (event) {
      if (_this.wrapperRef.current && !_this.wrapperRef.current.contains(event.target)) {
        if (_this.state.isDropdownOpen) {
          _this.setState({ isDropdownOpen: false });
        }
      }
    };

    _this.handleToggle = function () {
      var inputKey = _this.state.inputKey;

      var currentType = _this.state.types[inputKey];
      var nextType = currentType === "CUSTOMER_WAREHOUSE" ? "PORT" : "CUSTOMER_WAREHOUSE";

      _this.setState(function (prevState) {
        return {
          types: _extends({}, prevState.types, defineProperty({}, inputKey, nextType)),
          values: _extends({}, prevState.values, defineProperty({}, inputKey, "")),
          results: [],
          isLoading: false,
          isDropdownOpen: false
        };
      }, function () {
        _this.props.onTypeChange(nextType);
        _this.props.onValueChange("", "");
      });
    };

    _this.handleResultSelect = function (_, _ref) {
      var result = _ref.result;
      var inputKey = _this.state.inputKey;

      var displayValue = result.title;

      _this.setState(function (prevState) {
        return {
          values: _extends({}, prevState.values, defineProperty({}, inputKey, displayValue)),
          isLoading: false,
          isDropdownOpen: false
        };
      }, function () {
        _this.props.onValueChange(result.title, result.key);
      });
    };

    _this.handleSearchChange = function (_, _ref2) {
      var value = _ref2.value;
      var inputKey = _this.state.inputKey;

      var trimmed = value.trim();

      if (_this.typingTimeout) clearTimeout(_this.typingTimeout);

      _this.setState(function (prevState) {
        return {
          values: _extends({}, prevState.values, defineProperty({}, inputKey, value)),
          isTyping: true,
          isLoading: Boolean(trimmed),
          isDropdownOpen: Boolean(trimmed),
          results: trimmed ? prevState.results : []
        };
      });

      _this.typingTimeout = setTimeout(function () {
        _this.setState({ isTyping: false });
      }, 800);

      if (!trimmed) {
        _this.debouncedSearch.cancel();
        _this.setState({ isLoading: false, results: [], isDropdownOpen: false });
        return;
      }

      _this.debouncedSearch(trimmed);
    };

    _this.fetchResults = function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(query) {
        var _this$state, inputKey, types, localType, customerDetails, countryOfBusiness, customerEmail, fetchedResults, response, ports, identifier, _response, addresses;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$state = _this.state, inputKey = _this$state.inputKey, types = _this$state.types;
                localType = types[inputKey];
                customerDetails = _this.props.customerDetails;
                countryOfBusiness = get(customerDetails, "countryOfBusiness", "US");
                customerEmail = get(customerDetails, "customerEmail", "");


                _this.setState({ isLoading: true });

                _context.prev = 6;
                fetchedResults = [];

                if (!(localType === "PORT")) {
                  _context.next = 16;
                  break;
                }

                _context.next = 11;
                return getPortsList(query, countryOfBusiness);

              case 11:
                response = _context.sent;
                ports = get(response, "data.eventMessage.ports.list", []);

                fetchedResults = ports.map(function (item) {
                  return {
                    key: item.portKxId,
                    title: item.payload
                  };
                });
                _context.next = 22;
                break;

              case 16:
                identifier = customerEmail + "," + query;
                _context.next = 19;
                return getAddressList(identifier);

              case 19:
                _response = _context.sent;
                addresses = get(_response, "data.eventMessage.customerAddressInfo", []);

                fetchedResults = addresses.map(function (item) {
                  return {
                    key: get(item, "addressId.value", ""),
                    title: get(item, "addressName.value", "")
                  };
                });

              case 22:

                _this.setState({ results: fetchedResults, isLoading: false });
                _context.next = 29;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](6);

                console.error("Error fetching search results:", _context.t0);
                _this.setState({ results: [], isLoading: false });

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 25]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.handleClear = function () {
      var inputKey = _this.state.inputKey;


      _this.setState(function (prevState) {
        return {
          values: _extends({}, prevState.values, defineProperty({}, inputKey, "")),
          results: [],
          isLoading: false,
          isDropdownOpen: false
        };
      });

      _this.props.onValueChange("", "");
    };

    _this.state = {
      types: defineProperty({}, props.inputKey, props.type || "PORT"),
      values: defineProperty({}, props.inputKey, props.value || ""),
      results: [],
      isLoading: false,
      inputKey: props.inputKey,
      isDropdownOpen: false,
      isTyping: false
    };

    _this.typingTimeout = null;
    _this.debouncedSearch = debounce(_this.fetchResults, 400);
    _this.wrapperRef = React__default.createRef();
    return _this;
  }

  createClass(LocationInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
      this.debouncedSearch.cancel();
      if (this.typingTimeout) clearTimeout(this.typingTimeout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (prevProps.type !== this.props.type || prevProps.inputKey !== this.props.inputKey || prevProps.value !== this.props.value) {
        this.setState(function (prevState) {
          return {
            types: _extends({}, prevState.types, defineProperty({}, _this3.props.inputKey, _this3.props.type)),
            values: _extends({}, prevState.values, defineProperty({}, _this3.props.inputKey, _this3.props.value || "")),
            results: prevProps.value !== _this3.props.value ? [] : prevState.results,
            isLoading: false,
            isDropdownOpen: false
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          disabled = _props.disabled,
          inputKey = _props.inputKey;
      var _state = this.state,
          types = _state.types,
          values = _state.values,
          isLoading = _state.isLoading,
          results = _state.results,
          isDropdownOpen = _state.isDropdownOpen;

      var localType = types[inputKey];
      var value = values[inputKey];
      var isAddress = localType === "CUSTOMER_WAREHOUSE";

      var showCustomDropdownContainer = isDropdownOpen && (isLoading || results.length > 0 || value && value.length > 0);

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 8
            }
          },
          React__default.createElement(
            "span",
            null,
            "Port"
          ),
          React__default.createElement(Checkbox, {
            toggle: true,
            checked: isAddress,
            onChange: this.handleToggle,
            disabled: disabled
          }),
          React__default.createElement(
            "span",
            null,
            "Address"
          )
        ),
        React__default.createElement(
          "div",
          {
            className: "kn-splitSearchInput search-dropdown-wrapper",
            ref: this.wrapperRef
          },
          React__default.createElement(Popup, {
            content: value || "Type to search...",
            position: "top left",
            trigger: React__default.createElement(Search, {
              input: {
                icon: value && !disabled ? React__default.createElement(Icon, {
                  name: "close",
                  link: true,
                  onClick: this.handleClear,
                  style: { marginLeft: "8px" }
                }) : "search",
                iconPosition: "right",
                className: "ellipsis-input",
                style: {
                  maxWidth: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }
              },
              loading: isLoading,
              onSearchChange: this.handleSearchChange,
              results: [],
              value: value,
              disabled: disabled,
              className: "customSearchByText"
            })
          }),
          showCustomDropdownContainer && React__default.createElement(
            "div",
            { className: "custom-dropdown-box" },
            React__default.createElement(
              "div",
              { className: "custom-dropdown-scroll" },
              isLoading && value.length > 0 ? React__default.createElement(
                "div",
                { className: "custom-dropdown-loading" },
                "Loading..."
              ) : results.length > 0 ? results.map(function (res) {
                return React__default.createElement(
                  "div",
                  {
                    key: res.key,
                    className: "custom-dropdown-item",
                    onClick: function onClick() {
                      return _this4.handleResultSelect(null, { result: res });
                    }
                  },
                  res.title
                );
              }) : !isLoading && value.length > 0 && React__default.createElement(
                "div",
                { className: "custom-dropdown-noresult" },
                "No results found"
              )
            ),
            isAddress && React__default.createElement(
              "div",
              {
                className: "custom-dropdown-add",
                onClick: this.props.onAddAddress
              },
              "Add " + (inputKey === "destinationType" ? "Delivery" : "Pick Up") + " Address"
            )
          )
        )
      );
    }
  }]);
  return LocationInput;
}(Component);

var DrayPartnerDropdown = function (_Component) {
  inherits(DrayPartnerDropdown, _Component);

  function DrayPartnerDropdown() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, DrayPartnerDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DrayPartnerDropdown.__proto__ || Object.getPrototypeOf(DrayPartnerDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e, _ref2) {
      var value = _ref2.value,
          options = _ref2.options;

      if (!value) {
        // Clear was clicked
        _this.props.onChange({
          id: "",
          title: "",
          sourceType: "PORT",
          source: "",
          destinationType: "PORT",
          destination: "",
          sourceId: "",
          destinationId: ""
        });
        return;
      }

      var selected = options.find(function (opt) {
        return opt.value === value;
      });
      if (!selected) return;

      var payload = {
        id: value,
        title: selected.text || "",
        sourceType: selected.sourceType || "PORT",
        source: selected.source || "",
        destinationType: selected.destinationType || "PORT",
        destination: selected.destination || "",
        destinationId: selected.destinationId || "",
        sourceId: selected.sourceId || ""
      };

      _this.props.onChange(payload);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(DrayPartnerDropdown, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          disabled = _props.disabled;

      var selectedOption = options.find(function (opt) {
        return opt.value === value;
      });

      var dropdownElement = React__default.createElement(
        "div",
        { style: { display: "inline-block", width: "200px" } },
        React__default.createElement(Dropdown, {
          clearable: true,
          fluid: true,
          selection: true,
          placeholder: "Select Dray Partner",
          options: options,
          style: { width: "200px" },
          value: value,
          onChange: this.handleChange,
          disabled: disabled,
          className: "dray-partner-dropdown"
        })
      );

      return selectedOption ? React__default.createElement(Popup, { content: selectedOption.text, trigger: dropdownElement }) : dropdownElement;
    }
  }]);
  return DrayPartnerDropdown;
}(Component);

var AddAddressModal = function (_Component) {
  inherits(AddAddressModal, _Component);

  function AddAddressModal() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    classCallCheck(this, AddAddressModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AddAddressModal.__proto__ || Object.getPrototypeOf(AddAddressModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      errors: {},
      countryList: []
    }, _this.loadCountryList = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response, res1, countryList;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return apis.getCountryList();

            case 3:
              response = _context.sent;
              res1 = get(response, "data.eventMessage.itemList", []);
              countryList = res1.map(function (item) {
                return {
                  key: item.id,
                  value: item.id,
                  text: item.id + " - " + item.description
                };
              });


              _this.setState({ countryList: countryList });
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              console.error("Error loading country list", _context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 9]]);
    })), _this.handleChange = function (e, _ref3) {
      var name = _ref3.name,
          value = _ref3.value;
      var onChange = _this.props.onChange;

      if (onChange) onChange(name, value);
      _this.setState(function (prev) {
        return {
          errors: _extends({}, prev.errors, defineProperty({}, name, false)) // clear error on change
        };
      });
    }, _this.validate = function () {
      var _this$props = _this.props,
          formData = _this$props.formData,
          row = _this$props.row;

      var errors = {};
      var addressLine1Parts = (formData.line1 || "").trim().split(" ");
      var streetNumber = addressLine1Parts[0];
      var streetName = addressLine1Parts.slice(1).join(" ");

      if (!streetNumber || !streetName) errors.line1 = "Enter both Street Number and Name";
      if (!formData.city) errors.city = "City is required";
      if (!formData.zip) errors.zip = "Postal Code is required";
      if (!formData.country) errors.country = "Country is required";
      if (!formData.refCode) errors.refCode = "Reference Code is required";
      if (!formData.name) errors.name = "Address Name is required";
      if (!row.customerEmail) errors.customerEmail = "Customer Email is required";

      _this.setState({ errors: errors });
      return Object.keys(errors).length === 0;
    }, _this.handleSave = function () {
      if (!_this.validate()) return;
      _this.props.onSave(); // call parent save only if valid
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(AddAddressModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadCountryList();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          open = _props.open,
          onClose = _props.onClose,
          formData = _props.formData,
          currentInputKey = _props.currentInputKey;
      var errors = this.state.errors;


      return React__default.createElement(
        Modal,
        {
          open: open,
          onClose: onClose,
          size: "small",
          className: "addAddressModalContainer"
        },
        React__default.createElement(
          Modal.Header,
          { className: "addAddressHeader" },
          "Add ",
          currentInputKey === "destinationType" ? "Delivery" : "Pick Up",
          " ",
          "Address"
        ),
        React__default.createElement(
          Modal.Content,
          { style: { width: "100%" } },
          React__default.createElement(
            Form,
            { error: true },
            React__default.createElement(
              Grid,
              { className: "addAddressFormContainer" },
              React__default.createElement(
                Grid.Row,
                { columns: 2 },
                React__default.createElement(
                  Grid.Column,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "custom-label" },
                    "Address Name"
                  ),
                  React__default.createElement(Form.Input, {
                    fluid: true,
                    name: "name",
                    value: formData.name,
                    placeholder: "Enter address name",
                    onChange: this.handleChange,
                    error: errors.name ? { content: errors.name } : null,
                    required: true
                  })
                ),
                React__default.createElement(
                  Grid.Column,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "custom-label" },
                    "Reference Code"
                  ),
                  React__default.createElement(Form.Input, {
                    fluid: true,
                    name: "refCode",
                    value: formData.refCode,
                    placeholder: "Enter Reference code",
                    onChange: this.handleChange,
                    error: errors.refCode ? { content: errors.refCode } : null,
                    required: true
                  })
                )
              ),
              React__default.createElement(
                Grid.Row,
                { columns: 2 },
                React__default.createElement(
                  Grid.Column,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "custom-label" },
                    "Address Line 1"
                  ),
                  React__default.createElement(Form.Input, {
                    fluid: true,
                    name: "line1",
                    value: formData.line1,
                    placeholder: "Street Number and Name (e.g., 123 Main St)",
                    onChange: this.handleChange,
                    error: errors.line1 ? { content: errors.line1 } : null,
                    required: true
                  })
                ),
                React__default.createElement(
                  Grid.Column,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "custom-label" },
                    "Address Line 2"
                  ),
                  React__default.createElement(Form.Input, {
                    fluid: true,
                    name: "line2",
                    value: formData.line2,
                    placeholder: "Apartment, Floor, etc.",
                    onChange: this.handleChange
                  })
                )
              ),
              React__default.createElement(
                Grid.Row,
                { columns: 2 },
                React__default.createElement(
                  Grid.Column,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "custom-label" },
                    "City"
                  ),
                  React__default.createElement(Form.Input, {
                    fluid: true,
                    name: "city",
                    value: formData.city,
                    placeholder: "Enter city",
                    onChange: this.handleChange,
                    error: errors.city ? { content: errors.city } : null,
                    required: true
                  })
                ),
                React__default.createElement(
                  Grid.Column,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "custom-label" },
                    "State / Province"
                  ),
                  React__default.createElement(Form.Input, {
                    fluid: true,
                    name: "state",
                    value: formData.state,
                    placeholder: "Enter state or province",
                    onChange: this.handleChange
                  })
                )
              ),
              React__default.createElement(
                Grid.Row,
                { columns: 2 },
                React__default.createElement(
                  Grid.Column,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "custom-label" },
                    "ZIP / Postal Code"
                  ),
                  React__default.createElement(Form.Input, {
                    fluid: true,
                    name: "zip",
                    value: formData.zip,
                    placeholder: "Enter ZIP code",
                    onChange: this.handleChange,
                    error: errors.zip ? { content: errors.zip } : null,
                    required: true
                  })
                ),
                React__default.createElement(
                  Grid.Column,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "custom-label" },
                    "Country"
                  ),
                  React__default.createElement(Form.Dropdown, {
                    fluid: true,
                    search: true,
                    selection: true,
                    name: "country",
                    value: formData.country,
                    options: this.state.countryList,
                    placeholder: "Select country",
                    onChange: this.handleChange,
                    error: errors.country ? { content: errors.country } : null,
                    required: true
                  })
                )
              )
            ),
            errors.customerEmail && React__default.createElement(Message, {
              error: true,
              header: "Missing Customer Email",
              content: errors.customerEmail
            })
          )
        ),
        React__default.createElement(
          Modal.Actions,
          { className: "addAddressModalFooter" },
          React__default.createElement(
            Button,
            { onClick: onClose, className: "action-cancel" },
            "Cancel"
          ),
          React__default.createElement(
            Button,
            { onClick: this.handleSave, className: "action-confirm" },
            React__default.createElement(
              "strong",
              null,
              "Add Address"
            )
          )
        )
      );
    }
  }]);
  return AddAddressModal;
}(Component);

var SplitContainerRow = function (_Component) {
  inherits(SplitContainerRow, _Component);

  function SplitContainerRow(props) {
    var _this2 = this;

    classCallCheck(this, SplitContainerRow);

    var _this = possibleConstructorReturn(this, (SplitContainerRow.__proto__ || Object.getPrototypeOf(SplitContainerRow)).call(this, props));

    _this.handleChange = function (field, value) {
      var _this$props = _this.props,
          row = _this$props.row,
          onChange = _this$props.onChange;

      onChange(row.containerNumber, field, value);
    };

    _this.handleOpenModal = function (key) {
      var handleHideParentModal = _this.props.handleHideParentModal;

      handleHideParentModal(true);
      _this.setState({ currentInputKey: key, showAddModal: true });
    };

    _this.handleCloseModal = function () {
      var handleHideParentModal = _this.props.handleHideParentModal;

      handleHideParentModal(false);
      _this.setState({ showAddModal: false, currentInputKey: "" });
    };

    _this.handleFormChange = function (name, value) {
      _this.setState(function (prevState) {
        return {
          formData: _extends({}, prevState.formData, defineProperty({}, name, value))
        };
      });
    };

    _this.handleFormSave = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var formData, _this$props2, row, handleResponseMessage, addressLine1Parts, streetNumber, streetName, payload, response, eventMessage, errorMsg, _errorMsg;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formData = _this.state.formData;
              _this$props2 = _this.props, row = _this$props2.row, handleResponseMessage = _this$props2.handleResponseMessage;
              addressLine1Parts = (formData.line1 || "").trim().split(" ");
              streetNumber = addressLine1Parts[0] || "";
              streetName = addressLine1Parts.slice(1).join(" ") || "";
              payload = {
                customer: {
                  value: row.customerEmail || ""
                },
                address: {
                  values: [{ type: "STREET_NUMBER", information: streetNumber }, { type: "STREET_NAME", information: streetName }, {
                    type: "UNSTRUCTURED_STREET_ADDRESS",
                    information: formData.line2 || ""
                  }, { type: "CITY", information: formData.city || "" }, { type: "COUNTRY", information: formData.country || "" }, { type: "COUNTRY_CODE", information: formData.country || "" }, { type: "COUNTRY_SUB_ENTITY", information: formData.state || "" }, { type: "POSTAL_CODE", information: formData.zip || "" }]
                },
                addressName: {
                  value: formData.name || ""
                },
                refCode: formData.refCode || ""
              };
              _context.prev = 6;
              _context.next = 9;
              return addCustomerDestination(payload);

            case 9:
              response = _context.sent;
              eventMessage = get(response, "data.eventMessage", "");


              if (typeof eventMessage === "number") {
                _this.handleCloseModal();
                handleResponseMessage("Address added successfully", "positive");
                _this.resetFormData();
              } else {
                errorMsg = get(response, "data.eventMessage.msg", "Something went wrong while saving.");

                _this.handleCloseModal();
                handleResponseMessage(errorMsg, "negative");
              }
              _context.next = 19;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](6);
              _errorMsg = get(_context.t0, "response.data.eventMessage.msg", _context.t0.message || "Failed to save address");

              _this.handleCloseModal();
              handleResponseMessage(_errorMsg, "negative");

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[6, 14]]);
    }));

    _this.resetFormData = function () {
      _this.setState({
        formData: {
          name: "",
          refCode: "",
          line1: "",
          line2: "",
          city: "",
          state: "",
          zip: "",
          country: "US"
        }
      });
    };

    _this.handleCustomerChange = function (_, _ref2) {
      var value = _ref2.value,
          options = _ref2.options;
      var _this$props3 = _this.props,
          row = _this$props3.row,
          onChange = _this$props3.onChange;

      var selectedOption = options.find(function (opt) {
        return opt.value === value;
      });
      var email = selectedOption.email || "";
      var countryOfBusiness = selectedOption.countryOfBusiness || "";

      if (row.customerCode !== value) {
        onChange(row.containerNumber, "customerCode", value);
        onChange(row.containerNumber, "customerEmail", email);
        onChange(row.containerNumber, "countryOfBusiness", countryOfBusiness);
        onChange(row.containerNumber, "sourceLocation", "");
        onChange(row.containerNumber, "sourceType", "PORT");
        onChange(row.containerNumber, "sourceId", "");
        onChange(row.containerNumber, "destinationLocation", "");
        onChange(row.containerNumber, "destinationType", "PORT");
        onChange(row.containerNumber, "destinationId", "");
        onChange(row.containerNumber, "drayPartner", "");
        onChange(row.containerNumber, "drayageOpportunityPartnerId", "");
        onChange(row.containerNumber, "quantity", "");
        onChange(row.containerNumber, "weight", "");
        onChange(row.containerNumber, "entityShipmentInfo", []);
      }
    };

    _this.handleShipmentChange = function (_, _ref3) {
      var selectedShipmentIds = _ref3.value;
      var row = _this.props.row;

      var currentInfo = row.entityShipmentInfo || [];
      var selectedSet = new Set(selectedShipmentIds);

      var updatedEntityInfo = [];

      // Add selected shipments (new or existing)
      selectedShipmentIds.forEach(function (id) {
        var existing = currentInfo.find(function (s) {
          return s.shipmentId === id && s.archived !== 1;
        });
        updatedEntityInfo.push(existing ? _extends({}, existing) : { shipmentId: id });
      });

      // Mark previously included shipments that are now unselected as archived
      currentInfo.forEach(function (s) {
        if (!selectedSet.has(s.shipmentId)) {
          updatedEntityInfo.push(_extends({}, s, { archived: 1 }));
        }
      });

      _this.handleChange("entityShipmentInfo", updatedEntityInfo);
    };

    _this.state = {
      showAddModal: false,
      currentInputKey: null,
      formData: {
        name: "",
        refCode: "",
        line1: "",
        line2: "",
        city: "",
        state: "",
        zip: "",
        country: "US"
      }
    };
    return _this;
  }

  createClass(SplitContainerRow, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          row = _props.row,
          onRemove = _props.onRemove,
          customerDropdownOptions = _props.customerDropdownOptions,
          shipmentDropdownOptions = _props.shipmentDropdownOptions,
          fetchError = _props.fetchError;

      var selectedCustomerCode = row.customerCode;
      var isDisabled = !row.customerCode;
      var isLocationInputDisabled = row.drayageOpportunityPartnerId || row.drayPartner;

      var shipmentOptionsFiltered = shipmentDropdownOptions.filter(function (info) {
        return info && typeof info.value === "string" && info.value.includes(selectedCustomerCode);
      });

      var activeShipmentIds = (row.entityShipmentInfo || []).filter(function (s) {
        return s.archived !== 1;
      }).map(function (s) {
        return s.shipmentId;
      });

      return React__default.createElement(
        Table.Row,
        { className: "splitTableRow" },
        React__default.createElement(
          Table.Cell,
          { verticalAlign: "bottom" },
          row.containerNumber
        ),
        React__default.createElement(
          Table.Cell,
          { verticalAlign: "bottom" },
          React__default.createElement(Dropdown, {
            placeholder: "Select Customer",
            fluid: true,
            search: true,
            selection: true,
            className: "customer-dropdown",
            options: customerDropdownOptions,
            value: selectedCustomerCode,
            onChange: this.handleCustomerChange
          })
        ),
        React__default.createElement(
          Table.Cell,
          { verticalAlign: "bottom" },
          React__default.createElement(DrayPartnerDropdown, {
            text: row.drayPartner,
            value: row.drayageOpportunityPartnerId,
            options: this.props.partnerDropdownOptions,
            onChange: function onChange(_ref4) {
              var id = _ref4.id,
                  title = _ref4.title,
                  source = _ref4.source,
                  sourceType = _ref4.sourceType,
                  destination = _ref4.destination,
                  destinationType = _ref4.destinationType,
                  destinationId = _ref4.destinationId,
                  sourceId = _ref4.sourceId;

              _this3.handleChange("drayPartner", title);
              _this3.handleChange("drayageOpportunityPartnerId", id);
              _this3.handleChange("sourceLocation", source);
              _this3.handleChange("sourceType", sourceType);
              _this3.handleChange("destinationLocation", destination);
              _this3.handleChange("destinationType", destinationType);
              _this3.handleChange("destinationId", destinationId);
              _this3.handleChange("sourceId", sourceId);
            },
            disabled: !row.customerCode
          })
        ),
        React__default.createElement(
          Table.Cell,
          { verticalAlign: "bottom" },
          React__default.createElement(LocationInput, {
            inputKey: "sourceType",
            type: row.sourceType,
            value: row.sourceLocation,
            onAddAddress: function onAddAddress() {
              return _this3.handleOpenModal("sourceType");
            },
            onTypeChange: function onTypeChange(type) {
              _this3.handleChange("sourceType", type);
            },
            onValueChange: function onValueChange(value, id) {
              _this3.handleChange("sourceId", id);
              _this3.handleChange("sourceLocation", value);
            },
            customerDetails: {
              countryOfBusiness: get(row, "countryOfBusiness", ""),
              customerEmail: get(row, "customerEmail", "")
            },
            label: "Pick-up",
            disabled: isDisabled || isLocationInputDisabled
          }),
          React__default.createElement(AddAddressModal, {
            open: this.state.showAddModal,
            onClose: this.handleCloseModal,
            onSave: this.handleFormSave,
            formData: this.state.formData,
            onChange: this.handleFormChange,
            currentInputKey: this.state.currentInputKey,
            row: row
          })
        ),
        React__default.createElement(
          Table.Cell,
          { verticalAlign: "bottom" },
          React__default.createElement(LocationInput, {
            inputKey: "destinationType",
            type: row.destinationType,
            value: row.destinationLocation,
            onAddAddress: function onAddAddress() {
              return _this3.handleOpenModal("destinationType");
            },
            onTypeChange: function onTypeChange(type, id) {
              _this3.handleChange("destinationType", type);
            },
            onValueChange: function onValueChange(value, id) {
              _this3.handleChange("destinationLocation", value);
              _this3.handleChange("destinationId", id);
            },
            label: "Delivery",
            disabled: isDisabled || isLocationInputDisabled,
            customerDetails: {
              countryOfBusiness: get(row, "countryOfBusiness", ""),
              customerEmail: get(row, "customerEmail", "")
            }
          })
        ),
        React__default.createElement(
          Table.Cell,
          { verticalAlign: "bottom" },
          React__default.createElement(Dropdown, {
            fluid: true,
            multiple: true,
            search: true,
            selection: true,
            error: fetchError && get(row, "entityShipmentInfo", []).filter(function (s) {
              return s.archived !== 1;
            }).length === 0,
            options: shipmentOptionsFiltered,
            value: activeShipmentIds,
            onChange: this.handleShipmentChange,
            disabled: !row.customerCode,
            className: "custom-multiselect-prime-style",
            style: { width: "200px" },
            renderLabel: function renderLabel() {
              return null;
            },
            trigger: React__default.createElement(
              "div",
              { className: "trigger-container" },
              React__default.createElement(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    overflow: "hidden"
                  }
                },
                row.customerCode && activeShipmentIds.length > 0 ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(Popup, {
                    content: shipmentOptionsFiltered.filter(function (option) {
                      return activeShipmentIds.includes(option.value);
                    }).map(function (option) {
                      return option.text;
                    }).join(", "),
                    trigger: React__default.createElement(
                      "span",
                      { className: "dropdown-trigger-label" },
                      shipmentOptionsFiltered.filter(function (option) {
                        return activeShipmentIds.includes(option.value);
                      }).map(function (option) {
                        return option.text;
                      }).join(", ")
                    )
                  })
                ) : React__default.createElement(
                  "span",
                  {
                    style: {
                      color: "#888",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "8px"
                    }
                  },
                  "Select Shipment"
                )
              ),
              row.customerCode && activeShipmentIds.length > 0 && React__default.createElement(Icon, {
                name: "close",
                onClick: function onClick(e) {
                  e.stopPropagation();
                  _this3.handleShipmentChange(null, { value: [] });
                },
                style: { cursor: "pointer", marginLeft: 10 }
              })
            )
          })
        ),
        React__default.createElement(
          Table.Cell,
          { verticalAlign: "bottom" },
          React__default.createElement(Input$1, {
            type: "number",
            className: "custom-input-without-border",
            value: row.quantity,
            onChange: function onChange(e) {
              return _this3.handleChange("quantity", e.target.value);
            },
            fluid: true,
            disabled: isDisabled
          })
        ),
        React__default.createElement(
          Table.Cell,
          { verticalAlign: "bottom" },
          React__default.createElement(Input$1, {
            type: "number",
            className: "custom-input-without-border",
            value: row.weight,
            onChange: function onChange(e) {
              return _this3.handleChange("weight", e.target.value);
            },
            fluid: true,
            disabled: isDisabled
          })
        ),
        React__default.createElement(
          Table.Cell,
          { verticalAlign: "bottom", textAlign: "center" },
          React__default.createElement(Icon, {
            name: "trash alternate outline",
            link: true,
            onClick: function onClick() {
              return onRemove(row.containerNumber);
            },
            style: { marginBottom: "10px" },
            size: "large"
          })
        )
      );
    }
  }]);
  return SplitContainerRow;
}(Component);

var SplitContainerForm = function (_Component) {
  inherits(SplitContainerForm, _Component);

  function SplitContainerForm() {
    classCallCheck(this, SplitContainerForm);
    return possibleConstructorReturn(this, (SplitContainerForm.__proto__ || Object.getPrototypeOf(SplitContainerForm)).apply(this, arguments));
  }

  createClass(SplitContainerForm, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          structuredChildContainersDetails = _props.structuredChildContainersDetails,
          onAddRow = _props.onAddRow,
          onRemoveRow = _props.onRemoveRow,
          onChange = _props.onChange,
          onCopyToAll = _props.onCopyToAll,
          containerInfo = _props.containerInfo,
          handleHideParentModal = _props.handleHideParentModal,
          handleResponseMessage = _props.handleResponseMessage;


      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "summary" },
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "strong",
              null,
              "Parent Container"
            ),
            React__default.createElement(
              "div",
              null,
              get(containerInfo, "parentContainerNumber", "N/A")
            )
          ),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "strong",
              null,
              "Pick up Location"
            ),
            React__default.createElement(
              "div",
              null,
              get(containerInfo, "sourceLocation", "N/A")
            )
          ),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "strong",
              null,
              "Delivery Location"
            ),
            React__default.createElement(
              "div",
              null,
              get(containerInfo, "destinationLocation", "N/A")
            )
          ),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "strong",
              null,
              "Quantity"
            ),
            React__default.createElement(
              "div",
              null,
              get(containerInfo, "quantity", "") ? get(containerInfo, "quantity") : "N/A"
            )
          ),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "strong",
              null,
              "Weight"
            ),
            React__default.createElement(
              "div",
              null,
              get(containerInfo, "weight", "") ? get(containerInfo, "weight") : "N/A"
            )
          )
        ),
        React__default.createElement(
          "div",
          { className: "table-header" },
          "Split Containers",
          " ",
          React__default.createElement(
            Button,
            { onClick: onAddRow, size: "small", className: "addRowButton" },
            "Add Row"
          )
        ),
        React__default.createElement(
          "div",
          { className: "table-scroll-container" },
          React__default.createElement(
            Table,
            null,
            React__default.createElement(
              Table.Header,
              { className: "splitContainerTableHeader" },
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  null,
                  "Container "
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  null,
                  "Customer",
                  " ",
                  React__default.createElement(Icon, {
                    name: "copy outline",
                    size: "small",
                    onClick: function onClick() {
                      return onCopyToAll("customerCode");
                    }
                  })
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { style: { width: "150px" } },
                  "Dray Partner",
                  React__default.createElement(Icon, {
                    name: "copy outline",
                    size: "small",
                    onClick: function onClick() {
                      onCopyToAll("drayPartner");
                      onCopyToAll("drayageOpportunityPartnerId");
                    }
                  })
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  null,
                  "Pick up Location",
                  " ",
                  React__default.createElement(Icon, {
                    name: "copy outline",
                    size: "small",
                    onClick: function onClick() {
                      onCopyToAll("sourceLocation");
                      onCopyToAll("sourceId");
                    }
                  })
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  null,
                  "Delivery Location",
                  " ",
                  React__default.createElement(Icon, {
                    name: "copy outline",
                    size: "small",
                    onClick: function onClick() {
                      onCopyToAll("destinationLocation");
                      onCopyToAll("destinationId");
                    }
                  })
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  null,
                  "Shipment",
                  " ",
                  React__default.createElement(Icon, {
                    name: "copy outline",
                    size: "small",
                    onClick: function onClick() {
                      return onCopyToAll("entityShipmentInfo");
                    }
                  })
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  null,
                  "Quantity",
                  " ",
                  React__default.createElement(Icon, {
                    name: "copy outline",
                    size: "small",
                    onClick: function onClick() {
                      return onCopyToAll("quantity");
                    }
                  })
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  null,
                  "Weight",
                  " ",
                  React__default.createElement(Icon, {
                    name: "copy outline",
                    size: "small",
                    onClick: function onClick() {
                      return onCopyToAll("weight");
                    }
                  })
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  null,
                  "Actions "
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              get(structuredChildContainersDetails, "splitContainers", []).filter(function (row) {
                return row.archived !== 1;
              }).map(function (row, index) {
                return React__default.createElement(SplitContainerRow, {
                  key: row ? row.containerNumber : "" + (Date.now() + index),
                  row: row,
                  onChange: onChange,
                  handleHideParentModal: handleHideParentModal,
                  onRemove: onRemoveRow,
                  containerInfo: containerInfo,
                  handleResponseMessage: handleResponseMessage,
                  customerDropdownOptions: get(structuredChildContainersDetails, "customerDropdownOptions", []),
                  shipmentDropdownOptions: get(structuredChildContainersDetails, "shipmentDropdownOptions", []),
                  partnerDropdownOptions: get(structuredChildContainersDetails, "partnerDropdownOptions", [])
                });
              })
            )
          )
        )
      );
    }
  }]);
  return SplitContainerForm;
}(Component);

var KnLoader = function (_Component) {
  inherits(KnLoader, _Component);

  function KnLoader() {
    classCallCheck(this, KnLoader);
    return possibleConstructorReturn(this, (KnLoader.__proto__ || Object.getPrototypeOf(KnLoader)).apply(this, arguments));
  }

  createClass(KnLoader, [{
    key: "render",
    value: function render() {
      return React__default.createElement(
        Dimmer,
        { active: true, inverted: true },
        React__default.createElement(
          Loader,
          { inverted: true },
          "Loading"
        )
      );
    }
  }]);
  return KnLoader;
}(Component);

var SplitContainerModal = function (_Component) {
  inherits(SplitContainerModal, _Component);

  function SplitContainerModal(props) {
    classCallCheck(this, SplitContainerModal);

    var _this = possibleConstructorReturn(this, (SplitContainerModal.__proto__ || Object.getPrototypeOf(SplitContainerModal)).call(this, props));

    _this.buildPartnerDropdownOptions = function (drayPartners) {
      var options = [];

      drayPartners.forEach(function (partner) {
        var partnerName = get(partner, "partnerName", "");
        var opportunityPartnerId = get(partner, "opportunityPartnerId", "");
        var laneList = get(partner, "laneList", []);

        laneList.forEach(function (lane) {
          options.push({
            key: opportunityPartnerId + "_" + lane.laneId,
            text: partnerName + " ( " + lane.lane + " ) (LANE - " + lane.laneId + ")",
            value: "" + opportunityPartnerId,
            destinationId: lane.destinationId,
            sourceId: lane.sourceId,
            laneId: lane.laneId,
            sourceType: lane.sourceType,
            destinationType: lane.destinationType,
            source: lane.source,
            destination: lane.destination
          });
        });
      });

      return options;
    };

    _this.handleAddRow = function () {
      var _this$state = _this.state,
          containerDetails = _this$state.containerDetails,
          structuredChildContainersDetails = _this$state.structuredChildContainersDetails,
          newSplitCount = _this$state.newSplitCount,
          orgSplitCount = _this$state.orgSplitCount;


      var baseContainerNumber = get(containerDetails, "parentContainerNumber", "");

      if (!baseContainerNumber) {
        console.warn("Base container number is missing. Cannot add new container.");
        return;
      }

      var newSuffix = newSplitCount + orgSplitCount + 1;

      var newContainerNumber = baseContainerNumber + "-" + newSuffix;

      var newContainer = {
        containerNumber: newContainerNumber,
        entityShipmentInfo: [],
        sourceType: get(containerDetails, "sourceType", "PORT"),
        sourceLocation: get(containerDetails, "sourceLocation", ""),
        destinationLocation: "",
        destinationType: "PORT",
        quantity: "",
        weight: "",
        drayPartner: "",
        drayageOpportunityPartnerId: "",
        customerCode: get(structuredChildContainersDetails, "customerDropdownOptions[0].value", ""),
        customerEmail: get(structuredChildContainersDetails, "customerDropdownOptions[0].email", ""),
        countryOfBusiness: get(structuredChildContainersDetails, "customerDropdownOptions[0].countryOfBusiness", ""),
        sourceId: get(containerDetails, "sourceId", ""),
        destinationId: ""
      };

      _this.setState(function (prevState) {
        return {
          structuredChildContainersDetails: _extends({}, prevState.structuredChildContainersDetails, {
            splitContainers: [].concat(toConsumableArray(get(prevState, "structuredChildContainersDetails.splitContainers", [])), [_extends({}, newContainer)])
          }),
          newSplitCount: newSplitCount + 1
        };
      });
    };

    _this.handleRowChange = function (containerNumber, field, value) {
      _this.setState(function (prevState) {
        var splitContainers = get(prevState, "structuredChildContainersDetails.splitContainers", []);
        var updated = splitContainers.map(function (row) {
          return row.containerNumber === containerNumber ? _extends({}, row, defineProperty({}, field, value)) : row;
        });
        return {
          structuredChildContainersDetails: _extends({}, prevState.structuredChildContainersDetails, {
            splitContainers: [].concat(toConsumableArray(updated))
          })
        };
      });
    };

    _this.handleConfirm = function () {
      var _this$state2 = _this.state,
          structuredChildContainersDetails = _this$state2.structuredChildContainersDetails,
          containerDetails = _this$state2.containerDetails,
          orgSplitCount = _this$state2.orgSplitCount,
          newSplitCount = _this$state2.newSplitCount;
      var saveFormData = _this.props.saveFormData;

      var originalContainers = get(containerDetails, "splitContainers", []);
      var currentContainers = get(structuredChildContainersDetails, "splitContainers", []);

      var invalidContainers = currentContainers.filter(function (container) {
        var info = container.entityShipmentInfo;
        if (!Array.isArray(info)) return true;

        var validShipments = info.filter(function (s) {
          return s.archived !== 1 && s.shipmentId;
        });

        return validShipments.length === 0;
      });

      if (invalidContainers.length > 0) {
        _this.setState({ fetchError: "Shipments are mandatory", messageType: "negative" }, function () {
          setTimeout(function () {
            _this.setState({ fetchError: "", messageType: "" });
          }, 2000);
        });
        return;
      }

      // Identify which original containers were removed (not present in currentContainers)
      var removedContainers = originalContainers.filter(function (orig) {
        return !currentContainers.some(function (curr) {
          return curr.containerNumber === orig.containerNumber;
        });
      });

      // Add archived: 1 to removed ones
      var archivedContainers = removedContainers.map(function (container) {
        return _extends({}, container, {
          archived: 1
        });
      });

      var cleanedCurrentContainers = currentContainers.map(function (_ref) {
        var customerCode = _ref.customerCode,
            customerEmail = _ref.customerEmail,
            countryOfBusiness = _ref.countryOfBusiness,
            rest = objectWithoutProperties(_ref, ["customerCode", "customerEmail", "countryOfBusiness"]);
        return _extends({}, rest);
      });

      // Merge current containers with archived ones (without duplicates)
      var finalSplitContainers = [].concat(toConsumableArray(cleanedCurrentContainers), toConsumableArray(archivedContainers));

      var payload = {
        parentContainerNumber: get(containerDetails, "parentContainerNumber", ""),
        splitContainers: finalSplitContainers,
        shipmentIds: [].concat(toConsumableArray(get(containerDetails, "shipmentIds", []))),
        splitCount: newSplitCount + orgSplitCount,
        weight: get(containerDetails, "weight", ""),
        quantity: get(containerDetails, "quantity", "")
      };

      // console.log("Final Payload on Confirm", payload);

      saveFormData(payload);
    };

    _this.handleCopyToAll = function (field) {
      _this.setState(function (prevState) {
        var splitContainers = get(prevState, "structuredChildContainersDetails.splitContainers", []);

        var firstRow = splitContainers[0];
        if (!firstRow || !(field in firstRow)) return null;

        // Define field groupings
        var groupedFieldsMap = {
          destinationLocation: ["destinationLocation", "destinationType"],
          sourceLocation: ["sourceLocation", "sourceType"]
        };

        // Determine which fields to copy
        var fieldsToCopy = groupedFieldsMap[field] || [field];

        var updatedSplitContainers = splitContainers.map(function (row, index) {
          if (index === 0) return row; // skip the first row

          var updatedRow = _extends({}, row);
          fieldsToCopy.forEach(function (key) {
            updatedRow[key] = firstRow[key];
          });

          return updatedRow;
        });

        return {
          structuredChildContainersDetails: _extends({}, prevState.structuredChildContainersDetails, {
            splitContainers: updatedSplitContainers
          })
        };
      });
    };

    _this.handleRemoveRow = function (containerNumberToRemove) {
      _this.setState(function (prevState) {
        var containerDetails = prevState.containerDetails,
            orgSplitCount = prevState.orgSplitCount,
            newSplitCount = prevState.newSplitCount;

        var currentContainers = get(prevState, "structuredChildContainersDetails.splitContainers", []);
        var baseContainerNumber = get(containerDetails, "parentContainerNumber", "");

        var parts = split(containerNumberToRemove || "", "-");
        var suffix = parts.length > 1 ? parseInt(parts[parts.length - 1], 10) : 0;
        // Filter out the container to be removed
        var updatedContainers = currentContainers.filter(function (container) {
          return container.containerNumber !== containerNumberToRemove;
        });

        var reSequencedContainers = [].concat(toConsumableArray(updatedContainers));

        var newContRemoved = false;
        if (suffix > orgSplitCount) {
          newContRemoved = true;
          var counter = orgSplitCount + 1;

          reSequencedContainers = updatedContainers.map(function (container) {
            var tempParts = split(get(container, "containerNumber", ""), "-");
            var tempSuffix = parts.length > 1 ? parseInt(tempParts[tempParts.length - 1], 10) : 0;

            if (tempSuffix > orgSplitCount) {
              return _extends({}, container, {
                containerNumber: baseContainerNumber + "-" + counter++
              });
            }
            return container;
          });
        }

        return {
          structuredChildContainersDetails: _extends({}, prevState.structuredChildContainersDetails, {
            splitContainers: reSequencedContainers
          }),
          newSplitCount: newContRemoved ? newSplitCount - 1 : newSplitCount
        };
      });
    };

    _this.handleHideParentModal = function (hide) {
      _this.setState({ hideParentModal: hide });
    };

    _this.handleResponseMessage = function (message, type) {
      _this.setState({ fetchError: message, messageType: type || "negative" }, function () {
        setTimeout(function () {
          _this.setState({ fetchError: "", messageType: "" });
        }, 2000);
      });
    };

    _this.state = {
      structuredChildContainersDetails: {},
      containerDetails: {},
      loading: true,
      fetchError: "",
      messageType: "negative",
      newSplitCount: 0,
      orgSplitCount: 0,
      hideParentModal: false
    };
    return _this;
  }

  createClass(SplitContainerModal, [{
    key: "componentDidMount",
    value: function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var containerInfo, containerNumber, shipmentIdsString, shipmentIds, _ref3, _ref4, partnerResult, childContainerResult, drayPartners, childData, allShipmentInfo, groupedByCustomerCode, customerDropdownOptions, shipmentDropdownOptions, rawSplitContainers, laneMap, enhancedSplitContainers;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                containerInfo = this.props.containerInfo;
                containerNumber = get(containerInfo, "entityId", "");
                shipmentIdsString = get(containerInfo, "shipmentIds", "");
                shipmentIds = shipmentIdsString ? shipmentIdsString.split(",") : [];
                _context.prev = 4;
                _context.next = 7;
                return Promise.allSettled([requestPartner(shipmentIds.join(","), containerNumber), getDrayageChildContainers({ shipmentIds: shipmentIds, containerNumber: containerNumber })]);

              case 7:
                _ref3 = _context.sent;
                _ref4 = slicedToArray(_ref3, 2);
                partnerResult = _ref4[0];
                childContainerResult = _ref4[1];
                drayPartners = partnerResult.status === "fulfilled" ? get(partnerResult.value, "data.eventMessage.availablePartners", []) : [];
                childData = childContainerResult.status === "fulfilled" ? get(childContainerResult.value, "data.eventMessage", {}) : {};
                allShipmentInfo = get(childData, "entityShipmentInfo", []);
                groupedByCustomerCode = allShipmentInfo.reduce(function (acc, shipment) {
                  var customerCode = shipment.customerCode;

                  if (!acc[customerCode]) {
                    acc[customerCode] = [];
                  }
                  acc[customerCode].push(shipment);
                  return acc;
                }, {});
                customerDropdownOptions = Object.entries(groupedByCustomerCode).map(function (_ref5) {
                  var _ref6 = slicedToArray(_ref5, 2),
                      customerCode = _ref6[0],
                      shipments = _ref6[1];

                  return {
                    key: customerCode,
                    value: customerCode,
                    text: customerCode,
                    email: get(shipments, "[0].customerEmail", ""),
                    countryOfBusiness: get(shipments, "[0].countryOfBusiness", "")
                  };
                });
                shipmentDropdownOptions = Object.values(groupedByCustomerCode).flat().map(function (shipment) {
                  return {
                    key: shipment.shipmentId,
                    value: shipment.shipmentId,
                    text: shipment.shipmentId
                  };
                });
                rawSplitContainers = get(childData, "splitContainers", []);

                //Flatten drayPartner lanes for quick lookup

                laneMap = {};

                drayPartners.forEach(function (partner) {
                  var opportunityPartnerId = get(partner, "opportunityPartnerId");
                  var partnerName = get(partner, "partnerName");
                  var laneList = get(partner, "laneList", []);

                  var firstLane = laneList[0] || {};
                  if (!isEmpty(firstLane)) {
                    laneMap["" + opportunityPartnerId] = {
                      source: get(firstLane, "source", ""),
                      destination: get(firstLane, "destination", ""),
                      sourceType: get(firstLane, "sourceType", ""),
                      destinationType: get(firstLane, "destinationType", ""),
                      destinationId: get(firstLane, "destinationId", ""),
                      sourceId: get(firstLane, "sourceId", ""),
                      laneId: get(firstLane, "laneId", ""),
                      drayPartner: partnerName + " ( " + get(firstLane, "lane", "") + " ) (LANE - " + get(firstLane, "laneId", "") + ")"
                    };
                  }
                });

                //Enhance split containers with drayage info
                enhancedSplitContainers = rawSplitContainers.map(function (container) {
                  var drayId = get(container, "drayageOpportunityPartnerId");
                  var laneInfo = laneMap[drayId] || {};
                  return _extends({}, container, {
                    customerCode: get(container, "entityShipmentInfo[0].customerCode", ""),
                    customerEmail: get(container, "entityShipmentInfo[0].customerEmail", ""),
                    countryOfBusiness: get(container, "entityShipmentInfo[0].countryOfBusiness", "")
                  }, !isEmpty(laneInfo) ? {
                    sourceLocation: laneInfo.source,
                    destinationLocation: laneInfo.destination,
                    sourceType: laneInfo.sourceType || "PORT",
                    destinationType: laneInfo.destinationType || "PORT",
                    drayPartner: laneInfo.drayPartner,
                    sourceId: laneInfo.sourceId,
                    destinationId: laneInfo.destinationId
                  } : {});
                });


                this.setState(function (prevState) {
                  return {
                    containerDetails: childData,
                    loading: false,
                    structuredChildContainersDetails: _extends({}, prevState.structuredChildContainersDetails, {
                      partnerDropdownOptions: _this2.buildPartnerDropdownOptions(drayPartners),
                      splitContainers: enhancedSplitContainers,
                      shipmentDropdownOptions: shipmentDropdownOptions,
                      customerDropdownOptions: customerDropdownOptions
                    }),
                    orgSplitCount: get(childData, "splitCount", 0)
                  };
                }, function () {
                  if (!enhancedSplitContainers.length) {
                    _this2.handleAddRow();
                  }
                });
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](4);

                console.error("Unexpected error while initializing:", _context.t0);
                this.setState({
                  loading: false,
                  fetchError: "Unable to load container/partner details. Please try again.",
                  messageType: "negative"
                });

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 24]]);
      }));

      function componentDidMount() {
        return _ref2.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          open = _props.open,
          onClose = _props.onClose,
          splitFormLoading = _props.splitFormLoading;
      var _state = this.state,
          containerDetails = _state.containerDetails,
          structuredChildContainersDetails = _state.structuredChildContainersDetails,
          hideParentModal = _state.hideParentModal;


      var modalInlineStyle = hideParentModal ? {
        visibility: "hidden !important",
        pointerEvents: "none !important",
        opacity: "0",
        transition: "visibility 0s 0.2s, opacity 0.2s linear"
      } : {};

      return React__default.createElement(
        Modal,
        {
          open: open,
          onClose: onClose,
          size: "large",
          className: "splitContainerModal",
          style: _extends({}, modalInlineStyle),
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        },
        React__default.createElement(
          Modal.Header,
          { className: "modalHeader" },
          "Split Container",
          React__default.createElement("i", {
            className: "close icon",
            style: { float: "right", cursor: "pointer" },
            onClick: onClose
          })
        ),
        this.state.fetchError && React__default.createElement(
          "div",
          { style: { position: "relative", left: "20px", top: "10px" } },
          React__default.createElement(
            Message,
            _extends({}, this.state.messageType === "positive" && { positive: true }, this.state.messageType === "negative" && { negative: true }, this.state.messageType === "warning" && { warning: true }, this.state.messageType === "info" && { info: true }, {
              compact: true
            }),
            this.state.fetchError
          )
        ),
        React__default.createElement(
          Modal.Content,
          { className: "scrollableContent" },
          this.state.loading ? React__default.createElement(
            "div",
            { className: "kn-splitloader" },
            React__default.createElement(KnLoader, null)
          ) : React__default.createElement(SplitContainerForm, {
            structuredChildContainersDetails: structuredChildContainersDetails,
            onAddRow: this.handleAddRow,
            onRemoveRow: this.handleRemoveRow,
            onChange: this.handleRowChange,
            onCopyToAll: this.handleCopyToAll,
            containerInfo: containerDetails,
            handleResponseMessage: this.handleResponseMessage,
            handleHideParentModal: this.handleHideParentModal
          })
        ),
        React__default.createElement(
          Modal.Actions,
          { className: "splitModalSubmit" },
          React__default.createElement(
            Button,
            { className: "cancel", onClick: onClose },
            "Cancel"
          ),
          React__default.createElement(
            Button,
            {
              className: "confirm",
              disabled: this.state.loading,
              loading: splitFormLoading,
              onClick: this.handleConfirm
            },
            "Confirm Split"
          )
        )
      );
    }
  }]);
  return SplitContainerModal;
}(Component);

var css_248z$l = ".k-toast-container {\n  position: fixed;\n  top: 65px;\n  right: 1rem;\n  z-index: 9999;\n  width: 300px; }\n\n.k-toast-message {\n  margin: 0;\n  display: flex;\n  align-items: center; }\n";
styleInject(css_248z$l);

var KToast = function (_Component) {
  inherits(KToast, _Component);

  function KToast() {
    classCallCheck(this, KToast);
    return possibleConstructorReturn(this, (KToast.__proto__ || Object.getPrototypeOf(KToast)).apply(this, arguments));
  }

  createClass(KToast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          _props$duration = _props.duration,
          duration = _props$duration === undefined ? 3000 : _props$duration,
          onClose = _props.onClose;

      this.timer = setTimeout(function () {
        if (onClose) onClose();
      }, duration);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          message = _props2.message,
          _props2$type = _props2.type,
          type = _props2$type === undefined ? "info" : _props2$type,
          onClose = _props2.onClose;


      return React__default.createElement(
        "div",
        { className: "k-toast-container" },
        React__default.createElement(
          Message,
          {
            className: "k-toast-message",
            positive: type === "success",
            negative: type === "error",
            warning: type === "warning",
            info: type === "info",
            onDismiss: onClose
          },
          message
        )
      );
    }
  }]);
  return KToast;
}(Component);

var DocErrorModal = function DocErrorModal(_ref) {
  var errorMessage = _ref.errorMessage,
      onClose = _ref.onClose;

  return React__default.createElement(
    Modal,
    {
      open: !!errorMessage,
      onClose: onClose,
      size: "small",
      centered: true,
      className: "showDocErrorModal"
    },
    React__default.createElement(
      Modal.Header,
      null,
      "Error"
    ),
    React__default.createElement(
      Modal.Content,
      null,
      React__default.createElement(Message, { negative: true, content: errorMessage })
    ),
    React__default.createElement(
      Modal.Actions,
      null,
      React__default.createElement(
        Button,
        { negative: true, onClick: onClose },
        "Close"
      )
    )
  );
};

pdfjs.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/" + pdfjs.version + "/pdf.worker.js";

var eventType$1 = {
  CONTAINER_DONE: "MARKED DONE",
  REGISTER_ENTITY: "CONTAINER REGISTERED",
  UNLOAD_FROM_VESSEL: "GROUNDED",
  CUSTOM_RELEASED: "CUSTOM REL",
  CARRIER_RELEASED: "LINE RELEASE",
  CONTAINER_HOLDS: "HOLD",
  CONTAINER_FEES: "FEES",
  READY_FOR_PICKUP: "READY FOR PICKUP",
  GATE_OUT: "GATE OUT",
  TERMINAL_PICKUP_APPOINTMENT: "TERM APPT",
  TERMINAL_EMPTY_DROP_APPOINTMENT: "DEL APPT",
  WAREHOUSE_DROP_APPOINTMENT: "ACTUAL DELIVERY",
  WAREHOUSE_EMPTY_PICKUP_APPOINTMENT: "TERM RETURN APP",
  GATE_IN: "GATE IN"
};

var prevTerminal = "",
    prevName = "";

var optionsForUpdateDrayage = [{ key: 'none', text: 'None', value: 'None' }, { key: 'gateOut', text: 'Gate Out', value: 'GATE_OUT' }, { key: 'gateIn', text: 'Gate In', value: 'GATE_IN' }];

var optionsForUpdateOPS = [{ key: 'all', text: 'All', value: 'All' }, { key: 'not grounded', text: 'Not Grounded', value: 'NONE' }, { key: 'grounded', text: 'Grounded', value: 'UNLOAD_FROM_VESSEL' }, { key: 'readyForPickup', text: 'Ready for pickup', value: 'READY_FOR_PICKUP' }, { key: 'gateOut', text: 'Gate Out', value: 'GATE_OUT' }, { key: 'gateIn', text: 'Gate In', value: 'GATE_IN' }];

var optionsForBulkCopy = [{ key: "container number", text: "Container Number", value: "Container Number" }, { key: "shipment id", text: "Shipment Id", value: "Shipment Id" }, { key: "mbol", text: "MBOL", value: "MBOL" }];

// const { data, containerDataSample } = sampleResponses;

var ContainerTrackingApp = function (_Component) {
  inherits(ContainerTrackingApp, _Component);

  function ContainerTrackingApp(props) {
    var _this2 = this;

    classCallCheck(this, ContainerTrackingApp);

    var _this = possibleConstructorReturn(this, (ContainerTrackingApp.__proto__ || Object.getPrototypeOf(ContainerTrackingApp)).call(this, props));

    _this.filtersSubmitted = function (filterValues) {
      var selectedTab = document.querySelector(".outerWrapperContainerModal").getAttribute('data-fieldname');
      if (selectedTab === "container") {
        _this.setState({ filterValues: filterValues, loading: true, appliedFilters: true, indexRowClicked: -1 }, function () {
          _this.getListOfContainers();
        });
      } else {
        _this.setState({ filterValues: filterValues, accordianStateVessels: [false], accordianStatePorts: [false] });
      }
    };

    _this.resetFilters = function () {
      _this.setState({ filterValues: { sortBy: "ETA_DESCENDING" }, resetClicked: true, appliedFilters: false }, function () {
        return _this.getListOfContainers();
      });
    };

    _this.convertIsoToDate = function (isoDate) {
      if (isoDate) return moment$1(isoDate).format("MMM DD, YYYY; HH:MMa").toString();else return "";
    };

    _this.setupFiltersForDrayage = function (filters) {
      var newFilters = filters.filter(function (filter) {
        return filter.value !== null;
      });
      if (window._env_.APP_NAME !== "Partner") {
        return newFilters;
      } else {
        return newFilters;
      }

      // let i = 0;

      // while (i < filters.length) {
      //   if (filters[i].key === "SEARCH_FILTER_ENTITY_ARCHIVED") {
      //     filters.splice(i, 1) //indices changed so not doing i++
      //   } else if (filters[i].key === "SEARCH_FILTER_ENTITY_UNPROCESSED") {
      //     filters[i].value = ["0"]
      //     i++;
      //   }
      //   else {
      //     i++;
      //   }
      // }
      // return filters;
    };

    _this.handelDoUrl = function (document) {
      var data = document.remoteurl.split('/', -1)[3];
      getUrl(data).then(function (response) {
        _this.setState({ doUrl: response.data.eventMessage.urls[0], viewDoFile: true, doDocumentData: document });
        _this.setState({ doDocuments: [].concat(toConsumableArray(_this.state.doDocuments), [_this.state.doUrl]) });
      });
    };

    _this.getDocument = function () {
      getDocUrl(_this.state.doDocumentData.docid).then(function (data) {
        var signedUrl = get(data, 'data.eventMessage.signedUrl', "");
        if (!isEmpty(signedUrl)) {
          var _JSON$parse = JSON.parse(signedUrl),
              urls = _JSON$parse.urls;

          if (!isEmpty(urls) && urls) {
            var urlOriginalDoc = urls[0];
            var newWindow = window.open(urlOriginalDoc, "_blank", "noopener,noreferrer");
            if (newWindow) newWindow.opener = null;
          }
        } else {
          _this.setState({ isDocumentDownloadable: true });
          setTimeout(function () {
            _this.setState({ isDocumentDownloadable: false });
          }, 2000);
        }
        _this.setState({ viewDoFile: false });
      });
    };

    _this.doCancellationButton = function () {
      _this.setState({ viewDoFile: false, doDocuments: [] });
    };

    _this.renderMissingInvoice = function (containerInfo) {

      if (containerInfo.hasOwnProperty("isInvoiceGenerated") === false && containerInfo.gateIn.hasOwnProperty("OPSTime") && containerInfo.hasOwnProperty("proofOfGateIn")) return React__default.createElement(
        "p",
        { onClick: function onClick() {
            return _this.setState({ createInvoice: true, noInvoiceContainer: containerInfo.entityId });
          } },
        "Invoice not submitted"
      );
    };

    _this.onFileChange = function (e) {
      if (e.target.files[0]) {
        _this.setState({ fileData: e.target.files[0], showUploadPercentage: true });
        setTimeout(function () {
          _this.uploadFile();
        }, 300);
      }
    };

    _this.uploadFileFunc = function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(image) {
        var filename, bodyFormData, response, str, firstIndex, lastIndex, finalString;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!image) {
                  _context.next = 19;
                  break;
                }

                _context.prev = 1;
                filename = Date.now() + "_" + image.name;
                bodyFormData = new FormData();

                bodyFormData.append("files", image, filename);
                _context.next = 7;
                return uploadImageFileData(bodyFormData, window._env_.DRAYAGE_PARTNER_DOC_BUCKET, _this.setProgressStatus);

              case 7:
                response = _context.sent;
                str = response.data.msg;
                firstIndex = str.indexOf("[");
                lastIndex = str.indexOf("]");
                finalString = str.substring(firstIndex + 1, lastIndex);

                console.log("checking finalString", finalString);
                return _context.abrupt("return", finalString);

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](1);

                _this.setState({ errorInFileUpload: true });

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 16]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.uploadFile = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var containerID, url;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              containerID = _this.state.selectedContainerInfo.containerID;
              url = "";

              if (!(_this.props.userType === "DRAY_OPS_USER")) {
                _context2.next = 8;
                break;
              }

              _context2.next = 5;
              return _this.uploadFileFunc(_this.state.fileData, containerID, _this.setProgressStatus);

            case 5:
              url = _context2.sent;
              _context2.next = 11;
              break;

            case 8:
              _context2.next = 10;
              return _this.props.uploadFile(_this.state.fileData, containerID);

            case 10:
              url = _context2.sent;

            case 11:
              _this.setState({ uploadUrl: url });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.deleteFileUrl = function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(entityEventID, shipmentIds, entityId) {
        var attachmentAction, attachmentType, resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                attachmentAction = 1;
                attachmentType = 0;

                // here entityId is the containerNumber

                if (!(entityEventID || shipmentIds && entityId)) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 5;
                return handleFileUrl(entityEventID, entityId, shipmentIds, attachmentAction, attachmentType);

              case 5:
                resp = _context3.sent;

                if (!(resp.status == 200)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", true);

              case 10:
                return _context3.abrupt("return", true);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x3, _x4, _x5) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.onConfirmUpload = function () {
      var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(entityEventID, containerNumber, shipmentIds, isArchived) {
        var attachmentAction, attachmentType, resp;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                attachmentAction = 0;
                attachmentType = 0;
                resp = {
                  status: null
                };

                if (!(_this.props.userType === "DRAY_OPS_USER")) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 6;
                return updateDrayagePartnerGateInFileData(attachmentAction, attachmentType, entityEventID, containerNumber, shipmentIds, isArchived, _this.state.uploadUrl);

              case 6:
                resp = _context4.sent;
                _context4.next = 12;
                break;

              case 9:
                _context4.next = 11;
                return _this.props.updateDrayagePartnerGateInFileData(attachmentAction, attachmentType, entityEventID, containerNumber, shipmentIds, isArchived, _this.state.uploadUrl);

              case 11:
                resp = _context4.sent;

              case 12:
                if (!(resp.status === 200)) {
                  _context4.next = 15;
                  break;
                }

                _this.setState({ proofOfGateIn: true });
                return _context4.abrupt("return", true);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x6, _x7, _x8, _x9) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.setProgressStatus = function (value) {
      _this.setState({ progressStatus: value });
    };

    _this.renderUploadScreen = function () {
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("input", { type: "file", className: "file-upload-input", onChange: _this.onFileChange, accept: "image/*, application/pdf" }),
        React__default.createElement(
          "svg",
          { className: "uploadCloudIcon", viewBox: "0 0 201 164", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
          React__default.createElement("path", { d: "M162 64.7692V63.5385C162 29.0769 134.923 2 100.462 2C69.6923 2 43.8462 24.1538 40.1538 54.9231C18 62.3077 2 82 2 106.615C2 137.385 26.6154 162 57.3846 162C78.3077 162 130 162 149.692 162C176.769 162 198.923 139.846 198.923 112.769C198.923 89.3846 182.923 70.9231 162 64.7692Z", fill: "white", stroke: "#008C8E", "stroke-width": "4" }),
          React__default.createElement("path", { d: "M112.767 100.462V137.385H88.1516V100.462H51.2285L100.459 51.2308L149.69 100.462H112.767Z", fill: "#008C8E" })
        ),
        React__default.createElement(
          "p",
          { className: "uploadFileMsg" },
          "Drop your files here or ",
          React__default.createElement(
            "span",
            { className: "text-green" },
            "Browse"
          )
        )
      );
    };

    _this.renderUploadProgressScreen = function () {
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "fileDetails" },
          React__default.createElement(
            "div",
            null,
            (_this.props.userType === "DRAY_OPS_USER" ? _this.state.progressStatus == 100 && !_this.state.errorInFileUpload : _this.props.progressStatus == 100 && !_this.props.errorInFileUpload) && React__default.createElement(
              "svg",
              { width: "14", height: "14", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
              React__default.createElement("path", { d: "M13 0C10.4288 0 7.91543 0.762437 5.77759 2.1909C3.63975 3.61935 1.97351 5.64968 0.989572 8.02512C0.0056327 10.4006 -0.251811 13.0144 0.249797 15.5362C0.751405 18.0579 1.98953 20.3743 3.80762 22.1924C5.6257 24.0105 7.94208 25.2486 10.4638 25.7502C12.9856 26.2518 15.5995 25.9944 17.9749 25.0104C20.3503 24.0265 22.3807 22.3603 23.8091 20.2224C25.2376 18.0846 26 15.5712 26 13C25.996 9.55341 24.6251 6.24912 22.188 3.81201C19.7509 1.3749 16.4466 0.00398351 13 0V0ZM19.1914 10.7236L11.8574 17.7236C11.671 17.9011 11.4234 18 11.166 18C10.9086 18 10.6611 17.9011 10.4746 17.7236L6.8086 14.2236C6.61707 14.0402 6.5062 13.7882 6.50033 13.523C6.49446 13.2579 6.59407 13.0012 6.77729 12.8095C6.96051 12.6177 7.21235 12.5065 7.4775 12.5003C7.74265 12.4941 7.99942 12.5934 8.19141 12.7764L11.166 15.6172L17.8086 9.27637C18.0006 9.09339 18.2574 8.9941 18.5225 9.00031C18.7877 9.00651 19.0395 9.11771 19.2227 9.30947C19.4059 9.50123 19.5056 9.75788 19.4997 10.023C19.4938 10.2882 19.3829 10.5402 19.1914 10.7236V10.7236Z", fill: "#3BBA50" })
            ),
            React__default.createElement(
              "span",
              { className: "fileName" },
              _this.state.fileData.name.length > 35 ? _this.state.fileData.name.substring(0, 35) + "..." : _this.state.fileData.name
            )
          ),
          (_this.props.userType === "DRAY_OPS_USER" ? _this.state.progressStatus != 100 : _this.props.progressStatus != 100) ? React__default.createElement(
            "svg",
            { style: { "cursor": "pointer" }, onClick: function onClick() {
                _this.setState({ showDragAndDropModal: true, fileData: null, showUploadPercentage: false });
              }, width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M7.00072 5.586L11.9507 0.636002L13.3647 2.05L8.41472 7L13.3647 11.95L11.9507 13.364L7.00072 8.414L2.05072 13.364L0.636719 11.95L5.58672 7L0.636719 2.05L2.05072 0.636002L7.00072 5.586Z", fill: "#877A6E" }),
            React__default.createElement("path", { d: "M7.00072 5.586L11.9507 0.636002L13.3647 2.05L8.41472 7L13.3647 11.95L11.9507 13.364L7.00072 8.414L2.05072 13.364L0.636719 11.95L5.58672 7L0.636719 2.05L2.05072 0.636002L7.00072 5.586Z", fill: "#70665C" })
          ) :
          /* -------- delete button ---------- */
          React__default.createElement(
            "svg",
            { style: { "cursor": "pointer" }, onClick: function onClick() {
                _this.setState({ confirmDeleteScreen: true });
              }, width: "14", height: "14", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM7 9V15H9V9H7ZM11 9V15H13V9H11ZM7 2V4H13V2H7Z", fill: "#CD214A" })
          )
        ),
        React__default.createElement(
          "div",
          { id: "myProgress" },
          React__default.createElement("div", { id: "myBar", style: { "width": (_this.props.userType === "DRAY_OPS_USER" ? _this.state.progressStatus * 1 : _this.props.progressStatus * 1) + "%" } })
        ),
        React__default.createElement(
          "div",
          { className: "fileDetails" },
          React__default.createElement(
            "span",
            { className: "fileData" },
            (_this.props.userType === "DRAY_OPS_USER" ? _this.state.progressStatus !== 100 : _this.props.progressStatus !== 100) ? (_this.props.userType === "DRAY_OPS_USER" ? _this.state.progressStatus : _this.props.progressStatus) + "% done" : (_this.props.userType === "DRAY_OPS_USER" ? _this.state.errorInFileUpload : _this.props.errorInFileUpload) ? "An error occured" : "Upload Complete"
          ),
          React__default.createElement(
            "span",
            { className: "fileData fileSize" },
            Number(_this.state.fileData.size) / 1000,
            " kb"
          )
        )
      );
    };

    _this.renderConfirmDeleteScreen = function () {
      var getFileName = function getFileName() {
        if (_this.state && _this.state.uploadUrl) {
          return _this.state.uploadUrl.length > 35 ? _this.state.uploadUrl.substring(14, 35) + "..." : _this.state.uploadUrl;
        } else if (_this.state && _this.state.fileData && _this.state.fileData.name) {
          return _this.state.fileData.name.length > 35 ? _this.state.fileData.name.substring(0, 35) + "..." : _this.state.fileData.name;
        } else {
          // if file name doesn't exist opening upload screen
          _this.setState({ confirmDeleteScreen: false, showUploadPercentage: false });
        }
      };
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "svg",
          { width: "64", height: "64", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
          React__default.createElement("path", { d: "M45.1207 0.333336L63.6673 18.89V45.1233L45.1207 63.6667H18.8873L0.333984 45.12V18.8867L18.8873 0.333336H45.1207ZM42.3573 7H21.6473L7.00398 21.65V42.36L21.6473 57.0067H42.3573L57.004 42.36V21.6467L42.3573 7.00334V7ZM28.6673 42H35.334V48.6667H28.6673V42ZM28.6673 15.3333H35.334V35.3333H28.6673V15.3333Z", fill: "#CD214A" })
        ),
        React__default.createElement(
          "span",
          { className: "deleteScreenText" },
          "Could ",
          getFileName(),
          " be deleted?"
        ),
        React__default.createElement(
          "span",
          { className: "deleteScreenText alert" },
          "Please Confirm!"
        )
      );
    };

    _this.displayMessage = function (title, color) {
      return React__default.createElement(
        "div",
        {
          style: {
            marginTop: "10px",
            marginLeft: "10px",
            color: color
          }
        },
        title
      );
    };

    _this.renderFileUploadScreen = function () {
      return React__default.createElement(
        "div",
        { className: "custom-modal-body" },
        React__default.createElement(
          "div",
          { className: "uploadContentholder " + (_this.state.showUploadPercentage && _this.props.progressStatus == 100 && "success") + " " + (_this.props.progressStatus == 100 && _this.props.errorInFileUpload || _this.state.confirmDeleteScreen && "fail") },
          React__default.createElement(
            "div",
            { className: "uploadFileHolder progressBar" },
            !_this.state.confirmDeleteScreen && !_this.state.showUploadPercentage && _this.renderUploadScreen(),
            !_this.state.confirmDeleteScreen && _this.state.fileData && _this.state.showUploadPercentage && _this.renderUploadProgressScreen(),
            _this.state.confirmDeleteScreen && _this.renderConfirmDeleteScreen()
          )
        )
      );
    };

    _this.renderDOFilesModal = function () {
      return React__default.createElement(
        "div",
        { className: "fileViewerModal" },
        _this.state.doDocuments.map(function (docs, index) {
          return React__default.createElement(
            "div",
            null,
            React__default.createElement("img", { className: "modalFileImage", src: docs })
          );
        })
      );
    };

    _this.renderViewFilesModal = function () {
      return React__default.createElement(
        "div",
        { className: "fileViewerModal" },
        _this.state.uploadUrl.includes("pdf") || _this.state.uploadUrl.includes("PDF") ? React__default.createElement(
          Document,
          {
            file: _this.state.uploadUrl,
            loading: _this.displayMessage("Loading PDF ...", "black"),
            error: _this.displayMessage("Error Loading Document", "red"),
            onLoadSuccess: function onLoadSuccess(pdf) {
              _this.onDocumentLoadSuccess(pdf);
            }
          },
          _this.state.numPages.length > 0 && _this.state.numPages.map(function (item, index) {
            return React__default.createElement(Page, { pageNumber: item, loading: "", className: "pdf-view" });
          })
        ) : React__default.createElement("img", { className: "modalFileImage", src: _this.state.uploadUrl })
      );
    };

    _this.successScreen = function () {
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "successScreen" },
          React__default.createElement(
            "svg",
            { width: "80", height: "80", viewBox: "0 0 130 130", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M64.9989 2C81.7018 2.0196 97.715 8.66349 109.526 20.4743C121.337 32.2853 127.981 48.299 128 65.0023C128 77.4617 124.305 89.6413 117.383 100.001C110.46 110.361 100.621 118.436 89.1091 123.204C77.5973 127.973 64.9301 129.22 52.7093 126.789C40.4885 124.359 29.263 118.358 20.4523 109.548C11.6416 100.737 5.64143 89.5115 3.21056 77.2907C0.779688 65.0699 2.0273 52.4027 6.79562 40.8909C11.5639 29.3792 19.6388 19.5399 29.9991 12.6174C40.3591 5.6951 52.539 2.00023 64.9989 2ZM60.6657 90.0671L60.668 90.0649L97.3379 55.0649L95.9571 53.6182L97.3405 55.0625C98.6809 53.7785 99.4569 52.0151 99.4979 50.1594C99.539 48.3038 98.8419 46.5077 97.5597 45.1657C96.2774 43.8237 94.5149 43.0455 92.6594 43.0021C90.8038 42.9586 89.0068 43.6535 87.6632 44.934L87.662 44.9351L55.8304 75.3207L42.3384 62.4355L42.3369 62.434C40.9932 61.1535 39.1963 60.4586 37.3407 60.5021C35.4851 60.5455 33.7226 61.3237 32.4404 62.6657C31.1582 64.0077 30.461 65.8038 30.5021 67.6594C30.5432 69.515 31.3191 71.2785 32.6595 72.5625L32.6619 72.5648L50.992 90.0648L50.9945 90.0671C52.2987 91.308 54.0299 92 55.8301 92C57.6303 92 59.3616 91.308 60.6657 90.0671Z", fill: "#2B8C3B", stroke: "#2B8C3B", "stroke-width": "4" })
          ),
          React__default.createElement(
            "p",
            { className: "successText" },
            "Success!"
          ),
          React__default.createElement(
            "p",
            { className: "successMessage" },
            _this.state.successMessage
          )
        )
      );
    };

    _this.triggerDragAndDrop = function (containerInfo) {
      // console.log("checking containerinfo", containerInfo);
      var entityId = containerInfo.entityId,
          shipmentIds = containerInfo.shipmentIds,
          entityEventID = containerInfo.gateIn.entityEventID;

      var containerNumber = entityId;
      var isArchived = false;

      var checkButtonStatus = function checkButtonStatus() {
        if (!_this.state.uploadUrl) {
          return true;
        }

        if (_this.props.userType === "DRAY_OPS_USER") {
          if (!(_this.state.progressStatus == 100 && !_this.state.errorInFileUpload || _this.state.enableDeleteButton || _this.state.viewFileScreen)) {
            return true;
          }
        } else {
          if (!(_this.props.progressStatus == 100 && !_this.props.errorInFileUpload || _this.state.enableDeleteButton || _this.state.viewFileScreen)) {
            return true;
          }
        }

        return false;
      };

      var handleStateOnCancel = function handleStateOnCancel() {
        if (_this.state.directDelete) {
          _this.setState({ showDragAndDropModal: false, fileData: null, showUploadPercentage: false, confirmDeleteScreen: false, enableDeleteButton: false, viewFileScreen: false, directDelete: false, uploadUrl: "" });
        } else if (_this.state.confirmDeleteScreen) {
          _this.setState({ confirmDeleteScreen: false, showUploadPercentage: true });
        } else {
          _this.setState({ showDragAndDropModal: _this.state.showUploadPercentage ? true : false, fileData: null, showUploadPercentage: false, confirmDeleteScreen: false, enableDeleteButton: false, viewFileScreen: false, uploadUrl: "" });
        }
      };

      var handleConfirmButton = function () {
        var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
          var response, _response;

          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!_this.state.confirmDeleteScreen) {
                    _context5.next = 7;
                    break;
                  }

                  _context5.next = 3;
                  return _this.deleteFileUrl(entityEventID, shipmentIds, entityId);

                case 3:
                  response = _context5.sent;

                  if (response === true) {
                    _this.setState({ successConfirmationScreen: true, confirmDeleteScreen: false, fileUploadScreen: false, showUploadPercentage: false, successMessage: "You have successfully deleted your document." });
                  }
                  _context5.next = 15;
                  break;

                case 7:
                  if (!_this.state.viewFileScreen) {
                    _context5.next = 11;
                    break;
                  }

                  window.open(_this.state.uploadUrl, "_blank");
                  _context5.next = 15;
                  break;

                case 11:
                  _context5.next = 13;
                  return _this.onConfirmUpload(entityEventID, containerNumber, shipmentIds, isArchived);

                case 13:
                  _response = _context5.sent;

                  if (_response === true) {
                    _this.setState({ successConfirmationScreen: true, confirmDeleteScreen: false, fileUploadScreen: false, showUploadPercentage: false, successMessage: "You have successfully submitted your document." });
                  }

                case 15:

                  setTimeout(function () {
                    _this.resetFilters();handleStateOnCancel();
                  }, 1300);

                case 16:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, _this2);
        }));

        return function handleConfirmButton() {
          return _ref5.apply(this, arguments);
        };
      }();

      return React__default.createElement(
        "div",
        { className: "modalHolder" },
        React__default.createElement(
          "div",
          { className: "modal-contentHolder modal-lg" },
          React__default.createElement(
            "div",
            { className: "modal-content", style: { "backgroundColor": "" + (_this.state.successConfirmationScreen ? "#F0FAF1" : "#fff") } },
            _this.state.successConfirmationScreen && _this.successScreen(),
            _this.state.viewFileScreen && _this.renderViewFilesModal(),
            _this.state.fileUploadScreen && _this.renderFileUploadScreen(),
            !_this.state.successConfirmationScreen && React__default.createElement(
              "div",
              { className: "custom-modal-footer justify-end" },
              React__default.createElement(
                Button,
                { disabled: checkButtonStatus(), className: "button btn-confirm", onClick: handleConfirmButton },
                _this.state.viewFileScreen ? "Download" : "Confirm"
              ),
              React__default.createElement(
                Button,
                { className: "button", onClick: handleStateOnCancel },
                "Cancel"
              )
            )
          )
        )
      );
    };

    _this.toggleDragAndDropState = function (data, type, fileUrl) {
      if (type === "attach") {
        _this.setState({ indexRowClicked: -1, viewAttachment: true, proofOfGateInDocument: fileUrl }, function () {
          _this.setState({ showDragAndDropModal: data });
        });
      } else if (type === "newUpload") {
        _this.setState({ indexRowClicked: -1, viewAttachment: false, proofOfGateInDocument: fileUrl }, function () {
          _this.setState({ showDragAndDropModal: data });
        });
      } else {
        _this.setState({ showDragAndDropModal: data });
        if (type === "upload") {
          _this.setState({ indexRowClicked: -1, fileUploadScreen: true, showUploadPercentage: false, successConfirmationScreen: false, viewFileScreen: false, confirmDeleteScreen: false, enableDeleteButton: false, viewAttachment: false, proofOfGateInDocument: fileUrl });
        } else if (type === "delete") {
          _this.setState({ indexRowClicked: -1, fileUploadScreen: true, successConfirmationScreen: false, viewFileScreen: false, confirmDeleteScreen: true, uploadUrl: fileUrl, enableDeleteButton: true, directDelete: true });
        } else if (type === "view") {
          _this.setState({ indexRowClicked: -1, viewFileScreen: true, uploadUrl: fileUrl, fileUploadScreen: false, successConfirmationScreen: false });
        } else if (type === "reset") {
          _this.setState({ indexRowClicked: -1, viewAttachment: false, proofOfGateInDocument: "" });
        }
      }
    };

    _this.getFilterParams = function (entityId, number, type) {
      var _this$state = _this.state,
          pageNumber = _this$state.pageNumber,
          searchText = _this$state.searchText,
          showDrayageOnly = _this$state.showDrayageOnly,
          activeDrayageContainers = _this$state.activeDrayageContainers,
          invoiceNotSubmitted = _this$state.invoiceNotSubmitted,
          containersPendingAssignment = _this$state.containersPendingAssignment,
          historyMode = _this$state.historyMode,
          excludeprocessed = _this$state.excludeprocessed,
          containerData = _this$state.containerData,
          searchOrder = _this$state.searchOrder,
          filterValues = _this$state.filterValues,
          containerChecked = _this$state.containerChecked,
          isBulkUpdateActivate = _this$state.isBulkUpdateActivate,
          selectParameters = _this$state.selectParameters,
          multiFilterValues = _this$state.multiFilterValues,
          p44NonTracking = _this$state.p44NonTracking,
          TModalVSP44differences = _this$state.TModalVSP44differences,
          filterContainerComment = _this$state.filterContainerComment,
          hotContainers = _this$state.hotContainers,
          hyperCareContainers = _this$state.hyperCareContainers,
          _this$props = _this.props,
          getContainerList = _this$props.getContainerList,
          baseUrl = _this$props.baseUrl,
          userType = _this$props.userType,
          customersAccess = _this$props.customersAccess;


      var sortByValue = historyMode ? "RECENT_DONE" : filterValues.sortBy;

      return [].concat(toConsumableArray(type === "vessel" && !isEmpty(number) ? [{
        key: "SEARCH_FILTER_ENTITY_VESSEL_IMO",
        value: [number]
      }] : []), toConsumableArray(type === "port" && !isEmpty(number) ? [{
        key: "SEARCH_FILTER_ENTITY_PORT_UNLOC",
        value: [number]
      }] : []), toConsumableArray(selectParameters !== 'All' && !isEmpty(selectParameters) ? [{
        key: "SEARCH_FILTER_ENTITY_BULK_UPDATE",
        value: selectParameters
      }] : []), toConsumableArray(multiFilterValues.length > 0 ? [].concat(toConsumableArray(multiFilterValues)) : []), toConsumableArray(isEmpty(entityId) && !excludeprocessed && !historyMode && userType !== "CUSTOMER" ? [{
        key: "SEARCH_FILTER_ENTITY_UNPROCESSED",
        value: ["0"]
      }] : []), toConsumableArray(excludeprocessed && !historyMode && userType !== "CUSTOMER" ? [{
        key: "SEARCH_FILTER_ENTITY_UNPROCESSED",
        value: ["1"]
      },
      // {
      //   key: "SEARCH_FILTER_ENTITY_IS_DIRTY",
      //   value: ["1"],
      // },
      {
        key: "SEARCH_FILTER_ENTITY_ARCHIVED",
        value: ["0"]
      }] : []), toConsumableArray(historyMode ? [{
        key: "SEARCH_FILTER_ENTITY_ARCHIVED",
        value: ["1"]
      }] : []), toConsumableArray(showDrayageOnly ? [{
        key: "SEARCH_FILTER_ENTITY_DRAYAGE_ENABLED",
        value: ["1"]
      }] : []), toConsumableArray(activeDrayageContainers ? [{
        key: "SEARCH_FILTER_ENTITY_ACTIVE_DRAYAGE",
        value: ["1"]
      }] : []), toConsumableArray(invoiceNotSubmitted ? [{
        key: "SEARCH_FILTER_INVOICE_NOT_SUBMITTED",
        value: ["1"]
      }] : []), toConsumableArray(containersPendingAssignment && !historyMode ? [{
        key: "SEARCH_FILTER_DRAYAGE_NOT_ASSIGNED_TO_TRUCKER",
        value: ["1"]
      }] : []), toConsumableArray(p44NonTracking && !historyMode ? [{
        key: "SEARCH_FILTER_P44_TRACKING",
        value: ["0"]
      }] : []), toConsumableArray(TModalVSP44differences && !historyMode ? [{
        key: "SEARCH_FILTER_P44_TMODAL_DIFF",
        value: ["1"]
      }] : []), toConsumableArray(hotContainers && !historyMode ? [{
        key: "SEARCH_FILTER_HOT_CONTAINERS",
        value: ["1"]
      }] : []), toConsumableArray(hyperCareContainers && !historyMode ? [{
        key: "SEARCH_FILTER_HYPERCARE_CONTAINERS",
        value: ["1"]
      }] : []), toConsumableArray(filterContainerComment ? [{
        key: "SEARCH_FILTER_COMMENTS_ONLY",
        value: ["1"]
      }] : []), toConsumableArray(filterValues ? [{
        key: "SEARCH_FILTER_ENTITY_SORT_BY",
        value: [sortByValue]
      }] : []), toConsumableArray(userType === "CUSTOMER" && Array.isArray(customersAccess) && customersAccess.length ? [{
        key: "SEARCH_FILTER_ENTITY_CUSTOMER_CODE",
        value: [].concat(toConsumableArray(customersAccess))
      }] : []));
    };

    _this.getListOfContainers = function () {
      var mergeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var entityId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var updatePagination = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var _this$state2 = _this.state,
          pageNumber = _this$state2.pageNumber,
          containerData = _this$state2.containerData,
          searchOrder = _this$state2.searchOrder,
          searchByParameter = _this$state2.searchByParameter,
          selectParameters = _this$state2.selectParameters,
          containerChecked = _this$state2.containerChecked,
          searchText = _this$state2.searchText,
          multiFilterValues = _this$state2.multiFilterValues,
          getContainerList = _this.props.getContainerList;


      _this.setState({ isError: false, isApiCallDone: false, containerListLoading: true });

      var params = {
        filters: _this.setupFiltersForDrayage(_this.getFilterParams(entityId)),
        pageNumber: pageNumber,
        searchOrder: {
          direction: searchOrder
        }
      };

      if (pageNumber > 1) params["totalRowsCount"] = _this.state.totalListEl;
      return getContainerList(params).then(function (response) {
        var containerDoneState = _this.state.containerDoneState;

        var containerDataItem = get(response, 'data.eventMessage.list', []);
        // console.log("checking containerDataItem >>", containerDataItem);

        containerDataItem.length > 0 && containerDataItem.map(function (container, index) {
          // console.log("checking container", container);
          if (container.archived) {
            containerDoneState[container.entityId] = true;
          } else {
            containerDoneState[container.entityId] = false;
          }
          _this.setState({ containerDoneState: containerDoneState });
        });

        var totalDirtyRowsCount = get(response, 'data.eventMessage.totalDirtyRowsCount', 0);
        var mergedItems = containerDataItem;
        _this.setState({ isCount: true });

        if (mergeData) {
          _this.setState({ isCount: false });

          var removeDuplicateContainer = containerData.filter(function (item) {
            return !containerChecked.includes(item.entityId);
          });

          mergedItems = !isEmpty(containerData) && selectParameters !== "All" && containerChecked.length > 1 ? [].concat(toConsumableArray(containerDataItem), toConsumableArray(removeDuplicateContainer)) : containerDataItem;
        }

        //  mergedItems = containerDataSample;

        var filteredMergedItems = mergedItems.filter(function (el) {
          return el !== undefined;
        });

        if (pageNumber > 1) {
          // this.setState({containerData: [...containerData, ...mergedItems]})
          _this.setState({ containerData: filteredMergedItems });
        } else {
          _this.setState({ containerData: filteredMergedItems });
        }
        _this.setState({
          loading: false,
          isError: false,
          isApiCallDone: true,
          isLoading: false,
          isEnableSpacer: true,
          isApiTimeout: false,
          containerListLoading: false
        });

        if (updatePagination) _this.setState({
          totalListEl: totalDirtyRowsCount
        });
      }).catch(function (error) {
        console.error('getListOfContainers ERROR', error);
        _this.setState({
          loading: false,
          isError: true,
          isLoading: false,
          isEnableSpacer: false,
          isApiTimeout: true,
          containerData: [],
          containerListLoading: false
        });
      });
    };

    _this.handleState = function (key, val) {
      _this.setState(defineProperty({}, key, val));
    };

    _this.constructAccordianBody = function (_ref6, type) {
      var list = _ref6.list;
      return list && list.map(function (_ref7, index) {
        var unloc = _ref7.unloc,
            name = _ref7.name,
            containers = _ref7.containers,
            terminal = _ref7.terminal;


        var jsx$$1 = React__default.createElement(
          "div",
          { className: "port_wrapper", "data-imo": unloc, "data-portindex": index },
          type === "vessel" && name !== prevName && React__default.createElement(
            "div",
            { className: "accordian_internal_heading portName" },
            name
          ),
          (terminal !== prevTerminal || name !== prevName) && React__default.createElement(
            "div",
            { className: "accordian_internal_heading terminalName" },
            terminal === "TERMINAL_TEMP" ? "TBD" : terminal
          ),
          containers.map(function (containerInfo, index) {
            return _this.renderContainerTable({ containerInfo: containerInfo, index: index, unloc: unloc });
          })
        );

        prevTerminal = terminal;
        prevName = name;
        if (list.length - 1 === index) {
          prevName = "";
          prevTerminal = "";
        }
        return jsx$$1;
      });
    };

    _this.getAccordianBody = function (index, forceUpdate, type) {
      var _this$state3 = _this.state,
          vesselsList = _this$state3.vesselsList,
          portsList = _this$state3.portsList,
          filterValues = _this$state3.filterValues;

      var accordianBodies = type === "vessel" ? _this.state.accordianBodiesVessels : _this.state.accordianBodiesPorts;

      if (forceUpdate || typeof accordianBodies === "undefined" || typeof accordianBodies[index] === "undefined") {
        accordianBodies[index] = React__default.createElement(Fragment, null);

        var _this$props2 = _this.props,
            getVesselsLvl2 = _this$props2.getVesselsLvl2,
            getPortsLvl2 = _this$props2.getPortsLvl2;


        var fetchLevel2 = type === "vessel" ? getVesselsLvl2 : getPortsLvl2;

        fetchLevel2(_this.getFilterParams("", type === "vessel" ? vesselsList[index].imo : portsList[index].unloc, type)).then(function (response) {
          var _this$setState2;

          var list = response.data.eventMessage.list;


          list && list.sort(function (a, b) {
            if (a.name < b.name) return -1;else if (a.name >= b.name) return 1;else {
              if (a.terminal < b.terminal) return -1;else if (a.terminal >= b.terminal) return 1;
              // else {
              //     if (a.shipmentId < b.shipmentId) return -1;
              //     else if (a.shipmentId > b.shipmentId) return 1;
              // }
            }
          });

          accordianBodies[index] = _this.constructAccordianBody({ list: list }, type);
          if (list.length === 0) accordianBodies[index] = React__default.createElement(
            "p",
            { className: "no_data_msg" },
            "There is no data to display"
          );
          _this.setState((_this$setState2 = {}, defineProperty(_this$setState2, type === "vessel" ? "accordianBodiesVessels" : "accordianBodiesPorts", accordianBodies), defineProperty(_this$setState2, "list", list), _this$setState2));
        });
      }
    };

    _this.toggleVesselAccordian = function (index) {
      var accordianStateVessels = _this.state.accordianStateVessels;

      accordianStateVessels[index] = !accordianStateVessels[index];
      _this.setState({ accordianStateVessels: accordianStateVessels });
      // this.forceUpdate();
      if (accordianStateVessels[index]) {
        _this.getAccordianBody(index, true, 'vessel');
      }
    };

    _this.togglePortAccordian = function (index) {
      var accordianStatePorts = _this.state.accordianStatePorts;

      accordianStatePorts[index] = !accordianStatePorts[index];
      _this.setState({ accordianStatePorts: accordianStatePorts });
      // this.forceUpdate();
      if (accordianStatePorts[index]) {
        _this.getAccordianBody(index, true, 'port');
      }
    };

    _this.closeContainerModal = function () {
      return _this.setState({ indexRowClicked: -1 });
    };

    _this.closeContainerSpecifiedModal = function () {
      return _this.setState({ indexRowClicked: -1, openSpecifiedContainerModal: false });
    };

    _this.longDateFormatter = function (seconds, entityTimezone) {
      var time = void 0;
      if (!isEmpty(entityTimezone)) {
        time = moment$1.unix(seconds).tz(entityTimezone).format("MMM DD, YYYY; h:mm a");
      } else {
        time = moment$1.unix(seconds).format("MMM DD, YYYY; h:mm a");
      }
      if (time === "Invalid date") return null;
      return time;
    };

    _this.shortDateFormatter = function (seconds) {
      var time = moment$1.unix(seconds).format("MM/DD/YYYY");
      if (time === "Invalid date") return null;
      return time;
    };

    _this.convertEpochToDate = function (epoch) {
      var shortFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var longDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var entityTimezone = arguments[3];

      if (!epoch || epoch === "TBD") return null;
      if (shortFormat) return _this.shortDateFormatter(epoch / 1000);
      if (longDate) return _this.longDateFormatter(epoch / 1000, entityTimezone);
      return _this.dateFormatter(epoch / 1000);
    };

    _this.changeIsoToKnFormat = function (isoDate) {
      if (!isoDate) return "";
      var firstPart = isoDate.split(" ")[0];
      var secondpartPart = moment$1(isoDate).format("hh:mm a");

      var _firstPart$split = firstPart.split("-"),
          _firstPart$split2 = slicedToArray(_firstPart$split, 3),
          year = _firstPart$split2[0],
          month = _firstPart$split2[1],
          day = _firstPart$split2[2];

      var monthMapping = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec"
      };
      return monthMapping[month] + " " + day + ", " + year + ", " + secondpartPart + " (P44)";
    };

    _this.computeData = function (_ref8) {
      var fieldName = _ref8.fieldName,
          dataType = _ref8.dataType,
          stageInfo = _ref8.stageInfo,
          entityTimezone = _ref8.entityTimezone,
          isMarkDisable = _ref8.isMarkDisable,
          index = _ref8.index,
          demurrageEnd = _ref8.demurrageEnd;

      //  Todo: adding onclick functionality and other things from containerlist.js file
      var dataList = [];
      var sourceSelected = stageInfo.sourceSelected;
      var tModalTime = stageInfo.tModalTime,
          eModalTime = stageInfo.eModalTime,
          p44Time = stageInfo.p44Time,
          OPSTime = stageInfo.OPSTime,
          OPSTime2 = stageInfo.OPSTime2,
          archived = stageInfo.archived,
          holdStatus = stageInfo.holdStatus,
          eventDescription = stageInfo.eventDescription,
          feesStatus = stageInfo.feesStatus;
      var _ref9 = [_this.convertEpochToDate(tModalTime, false, true, entityTimezone), _this.convertEpochToDate(eModalTime, false, true, entityTimezone), _this.convertEpochToDate(p44Time, false, true, entityTimezone), _this.convertEpochToDate(OPSTime, false, true, entityTimezone), _this.convertEpochToDate(OPSTime2, false, true, entityTimezone), _this.convertEpochToDate(demurrageEnd, false, true, entityTimezone)],
          humanReadableTModalTime = _ref9[0],
          humanReadableEModalTime = _ref9[1],
          humanReadableP44Time = _ref9[2],
          humanReadableOPSTime = _ref9[3],
          humanReadableOPSTime2 = _ref9[4],
          humanReadableLfdTime = _ref9[5];


      switch (fieldName) {

        case 'grounded':
          if (sourceSelected === 'P44' && !isEmpty(p44Time) && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableP44Time.concat(' (P44)'));
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'P44') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
            if (!isEmpty(p44Time)) {
              dataList.push(humanReadableP44Time.concat(' (P44)'));
            }
          } else if (sourceSelected === 'P44' && !isEmpty(humanReadableP44Time)) {
            dataList.push(humanReadableP44Time.concat(' (P44)'));
          }
          if (sourceSelected === 'ENTITY_SOURCE_NONE') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
            if (!isEmpty(p44Time)) {
              dataList.push(humanReadableP44Time.concat(' (P44)'));
            }
          } else if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }
          return { dataList: dataList, sourceSelected: sourceSelected };

        case 'customReleased':
          if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }
          return { dataList: dataList, sourceSelected: sourceSelected };
        case 'carrierReleased':
          if (sourceSelected === 'ENTITY_SOURCE_NONE' && !archived && !isMarkDisable) {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
          } else if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }
          return { dataList: dataList, sourceSelected: sourceSelected };
        case 'holds':
          if (holdStatus === 'NO_HOLD') {
            dataList.push('No hold');
          } else if (holdStatus === 'HOLD_REMOVED') {
            dataList.push('Hold removed');
          } else {
            dataList.push('');
          }
          if (!isEmpty(eventDescription)) {
            dataList.push(eventDescription);
          }
          return { dataList: dataList, sourceSelected: holdStatus };
        case 'fees':
          if (feesStatus === 'NO_DUES') {
            dataList.push('No dues');
          } else if (feesStatus === 'FEES_PAID') {
            dataList.push('Fees paid');
          } else {
            dataList.push('');
          }
          if (!isEmpty(eventDescription)) {
            dataList.push(eventDescription);
          }
          return { dataList: dataList, sourceSelected: feesStatus };
        case 'readyForPickup':
          if (sourceSelected === 'ENTITY_SOURCE_NONE') {
            if (!isEmpty(humanReadableOPSTime)) {
              dataList.push(humanReadableOPSTime);
            }
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
          } else if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push('Ops: '.concat(humanReadableOPSTime));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }
          if (!isEmpty(OPSTime2)) {
            dataList.push('Dem: '.concat(humanReadableOPSTime2));
          }
          if (!isEmpty(demurrageEnd)) {
            dataList.push('Lfd: '.concat(humanReadableLfdTime));
          }
          return { dataList: dataList, sourceSelected: sourceSelected };

        case 'terminalPickupAppointment':
          if (sourceSelected === 'ENTITY_SOURCE_NONE') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
          } else if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }

          return { dataList: dataList, sourceSelected: sourceSelected };

        case 'gateOut':
          // sGateOutEnable && (!archived && !isMarkDisable) => this check missing
          if (sourceSelected === 'P44' && !isEmpty(p44Time) && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableP44Time.concat(' (P44)'));
          } else if (sourceSelected === 'P44') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
            if (!isEmpty(p44Time)) {
              dataList.push(humanReadableP44Time.concat(' (P44)'));
            }
          } else if (sourceSelected === 'P44' && !isEmpty(humanReadableP44Time)) {
            dataList.push(humanReadableP44Time.concat(' (P44)'));
          }

          if (sourceSelected === 'ENTITY_SOURCE_NONE') {
            if (!isEmpty(humanReadableOPSTime)) {
              dataList.push(humanReadableOPSTime);
            }
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
            if (!isEmpty(p44Time)) {
              dataList.push(humanReadableP44Time.concat(' (P44)'));
            }
          } else if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push('Ops: '.concat(humanReadableOPSTime));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }

          if (!isEmpty(OPSTime2)) {
            dataList.push('PD: '.concat(humanReadableOPSTime2));
          }
          return { dataList: dataList, sourceSelected: sourceSelected };

        case 'terminalDropAppointment':
          if (sourceSelected === 'ENTITY_SOURCE_NONE') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
          } else if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }
          return { dataList: dataList, sourceSelected: sourceSelected };

        case 'warehouseDropAppointment':
          if (sourceSelected === 'P44' && !isEmpty(p44Time) && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableP44Time.concat(' (P44)'));
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'P44') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
            if (!isEmpty(p44Time)) {
              dataList.push(humanReadableP44Time.concat(' (P44)'));
            }
          } else if (sourceSelected === 'P44' && !isEmpty(humanReadableP44Time)) {
            dataList.push(humanReadableP44Time.concat(' (P44)'));
          }
          if (sourceSelected === 'ENTITY_SOURCE_NONE') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
            if (!isEmpty(p44Time)) {
              dataList.push(humanReadableP44Time.concat(' (P44)'));
            }
          } else if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }
          return { dataList: dataList, sourceSelected: sourceSelected };

        case 'warehousePickupAppointment':
          if (sourceSelected === 'ENTITY_SOURCE_NONE') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
          } else if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }
          return { dataList: dataList, sourceSelected: sourceSelected };

        case 'gateIn':
          // line775 => this check missing
          if (sourceSelected === 'P44' && !isEmpty(p44Time) && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableP44Time.concat(' (P44)'));
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'P44') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
            if (!isEmpty(p44Time)) {
              dataList.push(humanReadableP44Time.concat(' (P44)'));
            }
          } else if (sourceSelected === 'P44' && !isEmpty(humanReadableP44Time)) {
            dataList.push(humanReadableP44Time.concat(' (P44)'));
          }
          if (sourceSelected === 'ENTITY_SOURCE_NONE') {
            if (!isEmpty(tModalTime)) {
              dataList.push(humanReadableTModalTime.concat(' (T)'));
            }
            if (!isEmpty(eModalTime)) {
              dataList.push(humanReadableEModalTime.concat(' (E)'));
            }
            if (!isEmpty(p44Time)) {
              dataList.push(humanReadableP44Time.concat(' (P44)'));
            }
          } else if (sourceSelected === 'OPS' && !isEmpty(humanReadableOPSTime)) {
            dataList.push(humanReadableOPSTime.concat(' (K)'));
          } else if (sourceSelected === 'TMODAL' && !isEmpty(humanReadableTModalTime)) {
            dataList.push(humanReadableTModalTime.concat(' (T)'));
          } else if (sourceSelected === 'EMODAL' && !isEmpty(humanReadableEModalTime)) {
            dataList.push(humanReadableEModalTime.concat(' (E)'));
          }
          return { dataList: dataList, sourceSelected: sourceSelected };

        case 'purchaseOrder':
          dataList.push(stageInfo[fieldName] && stageInfo[fieldName].replace(/,/g, ", "));
          return { dataList: dataList };
        case 'shipmentId':

        case 'carrierName':
          dataList.push(stageInfo[fieldName]);
          dataList.push(stageInfo.p44ShipmentState !== undefined && stageInfo.p44ShipmentState.vesselName !== undefined && stageInfo.p44ShipmentState.vesselName.concat(' (P44) '));
          return { dataList: dataList };
        case 'finalDelivery':
        case 'masterBolNumber':
        case 'bolDocNumber':
        case 'seal':
          dataList.push(stageInfo[fieldName]);
          return { dataList: dataList };
        case 'eta':
          dataList.push(_this.convertEpochToDate(stageInfo[fieldName], false, true, entityTimezone));
          stageInfo.p44ShipmentState !== undefined && dataList.push(_this.changeIsoToKnFormat(stageInfo.p44ShipmentState !== undefined && stageInfo.p44ShipmentState.eta));
          return { dataList: dataList };
        case 'berthed':
          dataList.push(_this.convertEpochToDate(stageInfo[fieldName], false, true, entityTimezone));
          return { dataList: dataList };
        case 'arrivalNoticeReceived':
        case 'doCreated':
        case 'doPublished':
          dataList.push(_this.convertIsoToDate(stageInfo[fieldName]));
          return { dataList: dataList };
        default:
          return { dataList: dataList, sourceSelected: sourceSelected };
      }
    };

    _this.getCurrentTime = function (containerId) {
      var time = new Date().getTime();
      var convertedTime = _this.convertEpochToDate(time);

      var doneTime = _this.state.doneTime;

      doneTime[containerId] = convertedTime;
      _this.setState({ doneTime: doneTime });
    };

    _this.renderLoader = function () {
      return React__default.createElement(
        "div",
        { className: "loading" },
        "  Loading... "
      );
    };

    _this.updatePartnerContAssignStatus = function (containerId, partnersShipmentData, status) {
      _this.setState({ contStatusLoading: true });
      var currentPartnerData = partnersShipmentData.get(_this.state.partnerId);
      var shipmentIds = [];
      currentPartnerData.forEach(function (item) {
        shipmentIds.push(item.shipmentId);
      });
      var payload = {
        containerNumber: containerId, //ASDU7877777,
        shipmentIds: shipmentIds, //["KX-I5H7-19739","KX-I5H7-19732"],
        partnerContainerStatus: status //"CONTAINER_ACCEPTED"/"CONTAINER_REJECTED",
      };
      updatePartnerContDrayageStatus(payload).then(function (res) {
        _this.setState({ contStatusLoading: false });
        var code = get(res.data, 'eventMessage.code', '');
        var msg = get(res.data, "eventMessage.msg", 'Network issue.');
        if (code) {
          _this.setState({ showResponseModal: { containerId: containerId, msg: msg } });
        }
      }).catch(function (error) {
        return _this.setState({ showResponseModal: { containerId: containerId, msg: "Network issue." } });
      });
    };

    _this.renderContStatusConfirmation = function (status, partnersShipmentData) {
      return React__default.createElement(KnConfirmationModal, {
        openModal: _this.state.openConfirmationModal,
        header: CONTAINER_DRAY_ASSIGN_STATUS[status].modalheader,
        content: CONTAINER_DRAY_ASSIGN_STATUS[status].modalContent,
        onClose: function onClose() {
          return _this.setState({ openConfirmationModal: false });
        },
        onOpen: function onOpen() {
          return _this.setState({ openConfirmationModal: true });
        },
        handleConfirmation: function handleConfirmation(response) {
          if (response) {
            _this.updatePartnerContAssignStatus(_this.state.openConfirmationModal, partnersShipmentData, _this.state.partnerContAssignStatus);
          }
          _this.setState({ openConfirmationModal: false });
        }
      });
    };

    _this.renderContainerStatus = function (status, partner) {
      var statusColor = get(CONTAINER_DRAY_ASSIGN_STATUS[status], 'color', 'black');
      var label = get(CONTAINER_DRAY_ASSIGN_STATUS[status], 'label', 'N/A');
      return React__default.createElement(
        "div",
        { className: "contStatus", style: { color: statusColor } },
        " ",
        partner ? partner + ' : ' : '',
        " ",
        label
      );
    };

    _this.handleOpenEmailModal = function (contId) {
      _this.setState({ openContainerMenu: false, openEmailModal: contId });
    };

    _this.handleOpenSplitContainerModal = function (contId) {
      _this.setState({ openSplitModal: contId, openContainerMenu: false });
    };

    _this.renderContainerTable = function (_ref10) {
      var containerInfo = _ref10.containerInfo,
          index = _ref10.index,
          unloc = _ref10.unloc;
      var _this$props3 = _this.props,
          isMarkDisable = _this$props3.isMarkDisable,
          userType = _this$props3.userType,
          _this$state4 = _this.state,
          indexRowClicked = _this$state4.indexRowClicked,
          selectedFilter = _this$state4.selectedFilter,
          selectedPort = _this$state4.selectedPort,
          containerDoneState = _this$state4.containerDoneState,
          doneTime = _this$state4.doneTime,
          selectParameters = _this$state4.selectParameters,
          containerData = _this$state4.containerData,
          modalIsLoading = _this$state4.modalIsLoading,
          showModal = _this$state4.showModal,
          showLastActionMessage = _this$state4.showLastActionMessage,
          _containerInfo$entity = containerInfo.entityTimezone,
          entityTimezone = _containerInfo$entity === undefined ? '' : _containerInfo$entity,
          entityId = containerInfo.entityId,
          splitCount = containerInfo.splitCount,
          quantity = containerInfo.quantity,
          weight = containerInfo.weight,
          finalDestinationInfo = containerInfo.finalDestinationInfo,
          commentEntityEventId = containerInfo.commentEntityEventId,
          sealNumber = containerInfo.sealNumber,
          gateOut = containerInfo.gateOut,
          lfd = containerInfo.lfd,
          lrd = containerInfo.lrd,
          holds = containerInfo.holds,
          fees = containerInfo.fees,
          _containerInfo$archiv = containerInfo.archived,
          archived = _containerInfo$archiv === undefined ? false : _containerInfo$archiv,
          entityType = containerInfo.entityType,
          entityShipmentList = containerInfo.entityShipmentList,
          done = containerInfo.done,
          shipmentIds = containerInfo.shipmentIds,
          cancellationRequested = containerInfo.cancellationRequested,
          demurrageEnd = containerInfo.demurrageEnd,
          containerComment = containerInfo.containerComment,
          isPodInland = containerInfo.isPodInland,
          isHypercare = containerInfo.isHypercare,
          drayagePartner = containerInfo.drayagePartner,
          proofOfGateIn = containerInfo.proofOfGateIn,
          gateIn = containerInfo.gateIn,
          description = containerInfo.description,
          mot = containerInfo.mot;
      var _ref11 = [cloneDeep(rowHeaders), cloneDeep(metaData), cloneDeep(containerHeaderDataOPS), cloneDeep(containerHeaderDataDrayage)],
          rowHeadersCopy = _ref11[0],
          metaHeadersCopy = _ref11[1],
          containerHeaderCopyOPS = _ref11[2],
          containerHeaderCopyDrayage = _ref11[3];


      var atLeastOneHot = _this.checkIsHotContainer(entityShipmentList);

      rowHeadersCopy.forEach(function (_ref12, index2, arr) {
        var fieldName = _ref12.fieldName,
            dataType = _ref12.dataType;

        var stageInfo = containerInfo[fieldName];
        if (!isEmpty(stageInfo)) {
          var _this$computeData = _this.computeData({ fieldName: fieldName, dataType: dataType, stageInfo: stageInfo, entityTimezone: entityTimezone, isMarkDisable: isMarkDisable, index: index, demurrageEnd: demurrageEnd }),
              dataList = _this$computeData.dataList,
              sourceSelected = _this$computeData.sourceSelected;

          arr[index2].dataList = dataList;
          arr[index2].eModalTime = stageInfo.eModalTime;
          arr[index2].tModalTime = stageInfo.tModalTime;
          arr[index2].p44Time = stageInfo.p44Time;
          arr[index2].status = sourceSelected;
        }
      });
      metaHeadersCopy.forEach(function (_ref13, index, arr) {
        var fieldName = _ref13.fieldName,
            dataType = _ref13.dataType;

        var stageInfo = entityShipmentList[0];
        var isPodInland = get(containerInfo, "isPodInland", false);
        if (fieldName === "berthed" && isPodInland) {
          var dataList = [];
          var formatedDate = _this.convertUTCToTimezone(get(containerInfo, "p44DestinationEta", ""), get(containerInfo, "destinationTimezone") || get(containerInfo, "entityTimezone", ""));
          dataList.push(formatedDate || "");
          arr[index].displayName = "INLAND ETA";
          arr[index].dataType = "string";
          arr[index].fieldName = "p44DestinationEta";
          arr[index].compactName = "IN ETA";
          arr[index].dataList = dataList;
        } else if (!isEmpty(stageInfo)) {
          var _this$computeData2 = _this.computeData({ fieldName: fieldName, dataType: dataType, stageInfo: stageInfo, entityTimezone: entityTimezone, isMarkDisable: isMarkDisable, demurrageEnd: demurrageEnd }),
              _dataList = _this$computeData2.dataList;

          arr[index].dataList = _dataList;
        }
      });

      {
        window._env_.APP_NAME !== "Partner" ? containerHeaderCopyOPS.forEach(function (_ref14, index, arr) {
          var label = _ref14.label,
              fieldName = _ref14.fieldName;


          var fieldValue = containerInfo[fieldName];

          if (fieldName === 'drayagePartner') {
            var drayagePartnersData = getCustomersContDataFromShipmentList(entityShipmentList); // customer code-wise data
            var drayagePartnersValueArr = drayagePartnersData && [].concat(toConsumableArray(drayagePartnersData)).map(function (_ref15) {
              var _ref16 = slicedToArray(_ref15, 2),
                  partnerIdKey = _ref16[0],
                  partnerShipmentsDataValue = _ref16[1];

              var str = partnerShipmentsDataValue.map(function (item) {
                var partnerName = item.drayPartnerName || "None";
                var shipmentSuffix = item.shipmentId || "";
                return partnerName + "(" + shipmentSuffix + ")";
              }).join(", "); // Join the partner data of same customer code
              return str;
            });
            var drayagePartnersValue = drayagePartnersValueArr.join(', '); // join the partner data of all customer codes
            fieldValue = drayagePartnersValue.length > 20 ? React__default.createElement(
              React__default.Fragment,
              null,
              drayagePartnersValue.slice(0, 20),
              React__default.createElement(ViewMorePopup, { content: drayagePartnersValue, triggerColor: "#0A8B8F", triggerContent: "..." })
            ) : drayagePartnersValue;
          }

          if (fieldName === "customer" && fieldValue) fieldValue = fieldValue.split('@')[0];

          if (label === "DELIVERY ADDRESS") {
            fieldValue = get(containerInfo, fieldName, {});
            arr[index].valueLong = addressObjectToString({ value: fieldValue, format: ['streetNumber', 'streetName', 'city', 'state', 'postalCode'] });
            fieldValue = addressObjectToString({ value: fieldValue, format: ['city', 'state', 'postalCode'] });
          }
          arr[index].value = fieldValue;
        }) : containerHeaderCopyDrayage.forEach(function (_ref17, index, arr) {
          var label = _ref17.label,
              fieldName = _ref17.fieldName;

          var fieldValue = containerInfo[fieldName];
          if (fieldName === "drayagePartner" && fieldValue) fieldValue = fieldValue.split('@')[0];

          if (label === "DELIVERY ADDRESS") {
            fieldValue = get(containerInfo, fieldName, {});
            arr[index].valueLong = addressObjectToString({ value: fieldValue, format: ['streetNumber', 'streetName', 'city', 'state', 'postalCode'] });
            fieldValue = addressObjectToString({ value: fieldValue, format: ['city', 'state', 'postalCode'] });
          }
          arr[index].value = fieldValue;
        });
      }

      var groundedSource = find(rowHeadersCopy, { fieldName: 'grounded' });
      var isSourceSelected = !isEmpty(groundedSource) && groundedSource.status !== 'ENTITY_SOURCE_NONE';
      // console.log({ selectedPort, unloc, index });
      var allShipmentInfo = entityShipmentList;
      var gateOutSource = find(rowHeadersCopy, { fieldName: 'gateOut' });
      //  console.log("entityTimezone:",entityTimezone);
      // console.log("gateOut", gateOutSource.dataList)
      // console.log("container Done:",containerDoneState[entityId]);
      // let currentdate = moment();
      var partnersShipmentData = getPartnersContDataFromShipmentList(entityShipmentList);
      var currentPartnerContStatus = partnersShipmentData.has(_this.state.partnerId) && get(partnersShipmentData.get(_this.state.partnerId)[0], 'drayStatus', false);
      var currentPartnerData = partnersShipmentData.get(_this.state.partnerId);
      var contPartnerShipmentIds = [];
      currentPartnerData && currentPartnerData.forEach(function (item) {
        contPartnerShipmentIds.push(item.shipmentId);
      });
      var contAllShipmentIds = [];
      entityShipmentList && entityShipmentList.forEach(function (item) {
        contAllShipmentIds.push(item.shipmentId);
      });
      var isAirMode = get(containerInfo, "mot", "") === "MOT_AIR";

      return React__default.createElement(
        "div",
        { style: { position: "relative" } },
        selectParameters !== 'All' && containerData.length > 1 && userType !== "CUSTOMER" && React__default.createElement(
          "div",
          { style: { position: "absolute", left: "-1.2rem", top: "3rem" } },
          React__default.createElement(Checkbox, {
            onChange: function onChange(e, data) {
              return _this.updateBulkContainer(e, data, containerInfo);
            }
          })
        ),
        _this.state.openConfirmationModal === entityId && _this.renderContStatusConfirmation(_this.state.partnerContAssignStatus, partnersShipmentData),
        get(_this.state.showResponseModal, 'containerId', '') === entityId && React__default.createElement(KnModal, {
          openModal: get(_this.state.showResponseModal, 'containerId', ''),
          header: "Container Status (" + get(_this.state.showResponseModal, 'containerId', '') + ")",
          content: get(_this.state.showResponseModal, 'msg', ''),
          onClose: function onClose() {
            _this.setState({ showResponseModal: false });
            _this.getListOfContainers();
          },
          onOpen: function onOpen() {}
        }),
        React__default.createElement(
          "div",
          {
            className: (indexRowClicked === index && (selectedFilter === 'vessel' && selectedPort === unloc ? 'containerWrapper ' : false) ? 'containerWrapper ' : '') + "containerRowDisplay flexDisplay" + (archived || containerDoneState[entityId] ? ' is-disable' : '')
            // className="flexDisplay"
            , onClick: function onClick() {
              return _this.setState({ rowClicked: true, indexRowClicked: index, loadContainerModal: true, isBulkUpdateActivate: false, selectedPort: selectedFilter !== 'container' && unloc, selectedContainerInfo: containerData[index] }, function () {
                return _this.resetloadContainerModal();
              });
            }
            // onMouseOver={() => this.setState({ childHovered: true })}
            // onMouseOut={()=> this.setState({ childHovered: false })}
          },
          React__default.createElement(
            "div",
            { className: "leftSideDrayageContainer" },
            React__default.createElement(
              "span",
              { style: atLeastOneHot ? { color: "red", fontWeight: "700" } : null, className: "entityIdWithMot" },
              entityId,
              mot ? React__default.createElement(
                "span",
                { style: { padding: "0" } },
                getMOTImage(mot)
              ) : React__default.createElement(Icon, { name: "question circle outline", color: "grey", size: "large" })
            ),
            isHypercare && React__default.createElement(Popup, {
              content: "HyperCare Container",
              position: "top left",
              trigger: React__default.createElement(
                "div",
                null,
                React__default.createElement(Icon, { name: "heartbeat", color: "red" })
              )
            }),
            React__default.createElement("hr", { className: "horizantalRuler" }),
            sealNumber && React__default.createElement(
              "div",
              { className: "labelInfo blackLabel" },
              "SEAL: ",
              sealNumber
            ),
            !containerDoneState[entityId] && React__default.createElement(
              React__default.Fragment,
              null,
              gateOutSource.dataList.length > 0 && gateOut.sourceSelected != "ENTITY_SOURCE_NONE" && lrd && React__default.createElement(
                "div",
                { className: "labelInfo " + (lrd < 0 ? 'failureBackground' : 'successBackground') + " lfd_label" },
                Math.floor(lrd),
                " LRD"
              ),
              (gateOut.sourceSelected === "ENTITY_SOURCE_NONE" || gateOut.sourceSelected !== "ENTITY_SOURCE_NONE" && !gateOut.OPSTime) && lfd && React__default.createElement(
                "div",
                { className: "labelInfo " + (lfd < 0 ? 'failureBackground' : 'successBackground') + " lfd_label" },
                Math.floor(lfd),
                " LFD"
              ),
              " "
            ),
            React__default.createElement(
              React__default.Fragment,
              null,
              _this.props.accessType !== "readOnly" && React__default.createElement(
                "p",
                {
                  className: "undo-action " + (modalIsLoading ? 'disabled' : ''),
                  onClick: function onClick(e) {
                    !modalIsLoading && _this.undoLastAction(e, { entityId: entityId, commentEntityEventId: commentEntityEventId, shipmentIds: shipmentIds, eventName: "", entityType: entityType, eventDescription: "", sourceSelected: "OPS", selectedTime: new Date().getTime() });
                  }
                },
                "UNDO LAST ACTION"
              ),
              _this.state.activeEntityId === entityId && React__default.createElement(LoaderModal, { open: showModal, loading: modalIsLoading, message: showLastActionMessage, onClose: function onClose() {
                  return _this.setState({ showModal: false });
                } })
            ),
            _this.state.historyMode === true && _this.props.accessType !== "readOnly" && _this.renderMissingInvoice(containerInfo),
            _this.state.createInvoice === true && _this.props.handlePortal("DrayageInvoices", _this.state.noInvoiceContainer),
            window._env_.APP_NAME !== "Partner" && _this.props.accessType !== "readOnly" && entityTimezone && React__default.createElement(
              "p",
              { className: "tz-offset" },
              moment$1.tz(entityTimezone).format('Z')
            ),
            _this.state.errorContainerId === entityId && _this.state.showMarkAsDoneDocError && React__default.createElement(DocErrorModal, {
              errorMessage: _this.state.showMarkAsDoneDocError,
              onClose: function onClose() {
                return _this.setState({ showMarkAsDoneDocError: "", errorContainerId: null });
              }
            }),
            _this.props.accessType !== "readOnly" && (window._env_.APP_NAME !== "Partner" ? done.sourceSelected === 'ENTITY_SOURCE_NONE' && containerInfo.archived === undefined && containerDoneState[entityId] === false ? React__default.createElement(
              Button,
              { id: "markAsDone", className: "modalBtn", onClick: function onClick(e) {
                  var containerDoneState = _this.state.containerDoneState;

                  containerDoneState[entityId] = true;
                  _this.setState({ containerDoneState: containerDoneState });

                  var isDray = drayagePartner && drayagePartner !== "None" ? true : false;

                  _this.markDonetriggerApiCall(e, { entityId: entityId, commentEntityEventId: commentEntityEventId, entityType: entityType, eventName: done.eventName, eventCode: "", eventDescription: "", sourceSelected: "OPS", manuallyDone: true, selectedTime: new Date().getTime(), isDray: isDray });
                },
                style: { fontWeight: "normal", fontSize: "8px", width: "100%", margin: "2px 0", marginTop: "8px" }
              },
              "MARK AS DONE"
            ) : React__default.createElement(
              "div",
              { className: "done-date" },
              "Marked done on:",
              React__default.createElement("br", null),
              React__default.createElement(
                "div",
                { className: "date" },
                doneTime[entityId] || _this.convertEpochToDate(done.OPSTime)
              )
            ) : get(gateIn, "OPSTime", null) ? done.sourceSelected === 'ENTITY_SOURCE_NONE' && containerInfo.archived === undefined && containerDoneState[entityId] === false ? React__default.createElement(
              Button,
              { id: "markAsDone", className: "modalBtn", onClick: function onClick(e) {
                  var requiredDocs = isAirMode ? ["PROOF_OF_GATE_IN"] : ["PROOF_OF_GATE_IN", "EQUIPMENT_INTERCHANGE_RECEIPT"];
                  var isDocMissing = !_this.checkDocuments(proofOfGateIn, requiredDocs);
                  if (isDocMissing) {
                    _this.setState({ showMarkAsDoneDocError: 'Kindly upload POD to mark this container as completed.', errorContainerId: entityId });
                    setTimeout(function () {
                      _this.setState({ showMarkAsDoneDocError: '', errorContainerId: null });
                    }, 2000);
                    return;
                  }
                  var containerDoneState = _this.state.containerDoneState;

                  containerDoneState[entityId] = true;
                  _this.setState({ containerDoneState: containerDoneState });
                  var isDray = drayagePartner && drayagePartner !== "None" ? true : false;
                  _this.markDonetriggerApiCall(e, { entityId: entityId, commentEntityEventId: commentEntityEventId, entityType: entityType, eventName: done.eventName, eventCode: "", eventDescription: "", sourceSelected: "OPS", manuallyDone: true, selectedTime: new Date().getTime(), isDray: isDray });
                },
                style: { fontWeight: "normal", fontSize: "8px", width: "100%", margin: "2px 0", marginTop: "8px" }
              },
              "MARK AS DONE"
            ) : React__default.createElement(
              "div",
              { className: "done-date" },
              "Marked done on:",
              React__default.createElement("br", null),
              React__default.createElement(
                "div",
                { className: "date" },
                doneTime[entityId] || _this.convertEpochToDate(done.OPSTime)
              )
            ) : null),
            cancellationRequested === true && React__default.createElement(
              "p",
              { className: "undo-action", style: { color: "red" } },
              "CANCELLATION REQUESTED"
            ),
            React__default.createElement(
              "div",
              { className: "contDrayStatusWrapper" },
              userType === DMODAL_USERS.DRAYAGE_PARTNER && currentPartnerContStatus === CONTAINER_DRAY_ASSIGN_STATUS.CONTAINER_PENDING.value && React__default.createElement(
                "div",
                null,
                React__default.createElement(
                  "div",
                  { className: "contAssignTitle" },
                  "Container assignment ",
                  _this.state.contStatusLoading && React__default.createElement(Icon, { loading: true, name: "spinner", style: { marginRight: 5, fontSize: 18, color: '#04adb1' } })
                ),
                React__default.createElement(
                  "div",
                  { className: "contDrayStatusBtn acceptanceBtn", onClick: function onClick(e) {
                      e.stopPropagation();
                      _this.setState({
                        openConfirmationModal: entityId,
                        partnerContAssignStatus: CONTAINER_DRAY_ASSIGN_STATUS.CONTAINER_ACCEPTED.value
                      });
                    } },
                  "Accept"
                ),
                React__default.createElement(
                  "div",
                  { className: "contDrayStatusBtn rejectionBtn", onClick: function onClick(e) {
                      e.stopPropagation();
                      _this.setState({
                        openConfirmationModal: entityId,
                        partnerContAssignStatus: CONTAINER_DRAY_ASSIGN_STATUS.CONTAINER_REJECTED.value
                      });
                    } },
                  "Reject"
                )
              ),
              showContainerStatus(userType) && [].concat(toConsumableArray(partnersShipmentData)).map(function (_ref18) {
                var _ref19 = slicedToArray(_ref18, 2),
                    partnerIdKey = _ref19[0],
                    partnerShipmentsDataValue = _ref19[1];

                return get(partnerShipmentsDataValue[0], 'drayStatus', '') && React__default.createElement(
                  "div",
                  { className: "contDrayStatusDtWrapper" },
                  _this.renderContainerStatus(get(partnerShipmentsDataValue[0], 'drayStatus', ''), get(partnerShipmentsDataValue[0], 'drayPartnerName', '')),
                  React__default.createElement(
                    "div",
                    { className: "contStatusUpdateDate" },
                    " ",
                    formatDateTimeToMonDateTime(get(partnerShipmentsDataValue[0], 'drayAssignmentTime', '')),
                    " "
                  )
                );
              }),
              userType === DMODAL_USERS.DRAYAGE_PARTNER && currentPartnerContStatus && currentPartnerContStatus !== CONTAINER_DRAY_ASSIGN_STATUS.CONTAINER_PENDING.value && React__default.createElement(
                "div",
                { className: "contDrayStatusDtWrapper" },
                _this.renderContainerStatus(currentPartnerContStatus ? currentPartnerContStatus : ''),
                React__default.createElement(
                  "div",
                  { className: "contStatusUpdateDate" },
                  " ",
                  formatDateTimeToMonDateTime(get(partnersShipmentData.get(_this.state.partnerId)[0], 'drayAssignmentTime', '')),
                  " "
                )
              )
            )
          ),
          _this.state.showToast && React__default.createElement(KToast, _this.state.toastProps),
          _this.state.openSplitModal === entityId && _this.props.userType === "DRAY_OPS_USER" && React__default.createElement(SplitContainerModal, {
            splitFormLoading: _this.state.splitFormLoading,
            open: _this.state.openSplitModal,
            onClose: function onClose() {
              return _this.setState({ openSplitModal: false });
            },
            containerInfo: containerInfo,
            saveFormData: _this.handleConfirmSplit
          }),
          _this.state.openEmailModal === entityId && React__default.createElement(EmailDocuments, {
            openEmailModal: _this.state.openEmailModal,
            onClose: function onClose() {
              _this.setState({ openEmailModal: false });
            },
            containerNumber: entityId,
            stopPropagation: function stopPropagation(e) {
              return e.stopPropagation();
            },
            shipmentIds: userType === DMODAL_USERS.DRAYAGE_PARTNER ? contPartnerShipmentIds : contAllShipmentIds,
            userType: userType
          }),
          React__default.createElement(
            "div",
            { className: "leftSideIconsCol" },
            React__default.createElement(
              "div",
              { className: "menuIcon"
              },
              React__default.createElement(Popup, {
                header: entityId,
                content: React__default.createElement(ContainerMenu, {
                  containerNumber: entityId,
                  shipmentIds: userType === DMODAL_USERS.DRAYAGE_PARTNER ? contPartnerShipmentIds : contAllShipmentIds,
                  handleOpenEmailModal: _this.handleOpenEmailModal,
                  onSplitContainerClick: _this.handleOpenSplitContainerModal,
                  stopPropagation: function stopPropagation(e) {
                    return e.stopPropagation();
                  },
                  userType: userType,
                  containerInfo: containerInfo
                }),
                trigger: React__default.createElement(Icon, { name: "ellipsis horizontal", style: { fontSize: "1.2rem", color: "#000" },
                  onClick: function onClick(e) {
                    return e.stopPropagation();
                  } })
                // pinned
                , on: "click",
                onClose: function onClose() {
                  _this.setState({ openContainerMenu: false });
                },
                onOpen: function onOpen() {
                  _this.setState({ openContainerMenu: entityId });
                },
                open: _this.state.openContainerMenu === entityId
              })
            ),
            userType !== "CUSTOMER" && React__default.createElement(
              "div",
              null,
              userType !== "DRAY_PARTNER" && React__default.createElement(
                "div",
                {
                  className: "icon-div",
                  onClick: function onClick() {
                    return _this.setState({ showContainerHistoryModal: true });
                  }
                },
                React__default.createElement(Popup, {
                  content: "Modification history",
                  size: "small",
                  trigger: React__default.createElement(Icon, { name: "history", style: { fontSize: "1.2rem" } })
                })
              ),
              containerComment && React__default.createElement(
                "div",
                { className: "icon-div" },
                React__default.createElement(Popup, {
                  content: containerComment && containerComment.comment,
                  trigger: React__default.createElement(
                    "svg",
                    {
                      width: "17px",
                      height: "17px",
                      viewBox: "0 0 17 17",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg"
                    },
                    React__default.createElement("g", null),
                    React__default.createElement("path", {
                      d: "M15.5 0h-14c-0.827 0-1.5 0.673-1.5 1.5v10c0 0.827 0.673 1.5 1.5 1.5h0.5v4.102l4.688-4.102h8.812c0.827 0 1.5-0.673 1.5-1.5v-10c0-0.827-0.673-1.5-1.5-1.5zM16 11.5c0 0.275-0.224 0.5-0.5 0.5h-9.188l-3.312 2.898v-2.898h-1.5c-0.276 0-0.5-0.225-0.5-0.5v-10c0-0.275 0.224-0.5 0.5-0.5h14c0.276 0 0.5 0.225 0.5 0.5v10zM3 3h11v1h-11v-1zM3 5h11v1h-11v-1zM3 7h6v1h-6v-1z",
                      fill: "#000000"
                    })
                  )
                })
              )
            ),
            description && React__default.createElement(
              "div",
              { className: "icon-div" },
              React__default.createElement(Popup, {
                content: description,
                trigger: React__default.createElement(
                  "svg",
                  { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                  React__default.createElement(
                    "mask",
                    { id: "path-1-inside-1_782_13108", fill: "white" },
                    React__default.createElement("rect", { x: "3", y: "9.89844", width: "12", height: "6", rx: "0.5" })
                  ),
                  React__default.createElement("rect", { x: "3", y: "9.89844", width: "12", height: "6", rx: "0.5", stroke: "#002332", "stroke-width": "2", mask: "url(#path-1-inside-1_782_13108)" }),
                  React__default.createElement(
                    "mask",
                    { id: "path-2-inside-2_782_13108", fill: "white" },
                    React__default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.5 1.5C6.22386 1.5 6 1.72386 6 2V3L7.35157 5.02735C7.4443 5.16645 7.60042 5.25 7.76759 5.25H10.2324C10.3996 5.25 10.5557 5.16645 10.6484 5.02735L12 3V2C12 1.72386 11.7761 1.5 11.5 1.5H6.5Z" })
                  ),
                  React__default.createElement("path", { d: "M6 3H5V3.30278L5.16795 3.5547L6 3ZM7.35157 5.02735L8.18362 4.47265L8.18362 4.47265L7.35157 5.02735ZM10.6484 5.02735L9.81638 4.47265L9.81638 4.47265L10.6484 5.02735ZM12 3L12.8321 3.5547L13 3.30278V3H12ZM7 2C7 2.27614 6.77614 2.5 6.5 2.5V0.5C5.67157 0.5 5 1.17157 5 2H7ZM7 3V2H5V3H7ZM5.16795 3.5547L6.51952 5.58205L8.18362 4.47265L6.83205 2.4453L5.16795 3.5547ZM6.51952 5.58205C6.79772 5.99935 7.26606 6.25 7.76759 6.25V4.25C7.93477 4.25 8.09088 4.33355 8.18362 4.47265L6.51952 5.58205ZM7.76759 6.25H10.2324V4.25H7.76759V6.25ZM10.2324 6.25C10.7339 6.25 11.2023 5.99935 11.4805 5.58205L9.81638 4.47265C9.90912 4.33355 10.0652 4.25 10.2324 4.25V6.25ZM11.4805 5.58205L12.8321 3.5547L11.1679 2.4453L9.81638 4.47265L11.4805 5.58205ZM11 2V3H13V2H11ZM11.5 2.5C11.2239 2.5 11 2.27614 11 2H13C13 1.17157 12.3284 0.5 11.5 0.5V2.5ZM6.5 2.5H11.5V0.5H6.5V2.5Z", fill: "#002332", mask: "url(#path-2-inside-2_782_13108)" }),
                  React__default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.05492 6.05492C9.01975 6.01975 9 5.97206 9 5.92233V5.25H9.375V5.92234C9.375 6.08938 9.17304 6.17304 9.05492 6.05492V6.05492Z", fill: "#002332", stroke: "#002332", "stroke-width": "0.5" }),
                  React__default.createElement("rect", { x: "5.4375", y: "11.5859", width: "0.375", height: "2.625", rx: "0.1875", fill: "white", stroke: "#002332", "stroke-width": "0.375" }),
                  React__default.createElement("rect", { x: "7.6875", y: "11.5859", width: "0.375", height: "2.625", rx: "0.1875", fill: "white", stroke: "#002332", "stroke-width": "0.375" }),
                  React__default.createElement("rect", { x: "9.9375", y: "11.5859", width: "0.375", height: "2.625", rx: "0.1875", fill: "white", stroke: "#002332", "stroke-width": "0.375" }),
                  React__default.createElement("rect", { x: "12.1875", y: "11.5859", width: "0.375", height: "2.625", rx: "0.1875", fill: "white", stroke: "#002332", "stroke-width": "0.375" }),
                  React__default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.38708 6.12821C9.32838 6.21351 9.21137 6.23105 9.11114 6.205C8.89827 6.14967 8.66428 6.22921 8.53237 6.42089C8.36386 6.66572 8.42575 7.0008 8.67059 7.1693C8.86226 7.30121 9.10923 7.29193 9.2883 7.16422C9.3726 7.10409 9.48816 7.07867 9.57346 7.13738V7.13738C9.65876 7.19609 9.68147 7.3147 9.60668 7.38632C9.30056 7.67944 8.82086 7.72795 8.45799 7.47822C8.04254 7.1923 7.93754 6.62373 8.22345 6.20829C8.47319 5.84541 8.93857 5.71938 9.32919 5.88383C9.42464 5.924 9.44579 6.0429 9.38708 6.12821V6.12821Z", fill: "#008C8E", stroke: "#002332", "stroke-width": "0.5" }),
                  React__default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.49935 7.64717C7.56316 7.72922 7.54799 7.84753 7.46554 7.91082L4.51657 10.1744C4.44307 10.2308 4.33913 10.224 4.27361 10.1585V10.1585C4.19483 10.0797 4.20325 9.94964 4.29153 9.88167L7.23716 7.61374C7.31886 7.55083 7.43604 7.56577 7.49935 7.64717V7.64717ZM13.7264 10.1585C13.6609 10.224 13.5569 10.2308 13.4834 10.1744L10.5345 7.91082C10.452 7.84753 10.4368 7.72922 10.5006 7.64717V7.64717C10.564 7.56577 10.6811 7.55083 10.7628 7.61374L13.7085 9.88167C13.7967 9.94964 13.8052 10.0797 13.7264 10.1585V10.1585Z", fill: "#008C8E", stroke: "#002332", "stroke-width": "0.5" })
                )
              })
            ),
            userType === "CUSTOMER" && React__default.createElement(
              "div",
              { className: "icon-div" },
              React__default.createElement(Popup, {
                content: containerComment ? containerComment.comment : React__default.createElement(
                  "span",
                  { style: { fontStyle: "italic" } },
                  "Add Comment..."
                ),
                trigger: React__default.createElement(
                  "div",
                  { style: { cursor: "pointer" }, onClick: function onClick() {
                      return _this.setState({ openSpecifiedContainerModal: true, isLoadingSpecifiedModal: true, selectedContainerInfo: containerData[index] }, function () {
                        return _this.resetloadSpecifiedContainerModal();
                      });
                    } },
                  React__default.createElement(
                    "svg",
                    {
                      width: "17px",
                      height: "17px",
                      viewBox: "0 0 17 17",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg"
                    },
                    React__default.createElement("g", null),
                    React__default.createElement("path", {
                      d: "M15.5 0h-14c-0.827 0-1.5 0.673-1.5 1.5v10c0 0.827 0.673 1.5 1.5 1.5h0.5v4.102l4.688-4.102h8.812c0.827 0 1.5-0.673 1.5-1.5v-10c0-0.827-0.673-1.5-1.5-1.5zM16 11.5c0 0.275-0.224 0.5-0.5 0.5h-9.188l-3.312 2.898v-2.898h-1.5c-0.276 0-0.5-0.225-0.5-0.5v-10c0-0.275 0.224-0.5 0.5-0.5h14c0.276 0 0.5 0.225 0.5 0.5v10zM3 3h11v1h-11v-1zM3 5h11v1h-11v-1zM3 7h6v1h-6v-1z",
                      fill: "#000000"
                    })
                  )
                )
              })
            )
          ),
          React__default.createElement(ContainerTable, {
            tableData: rowHeadersCopy,
            data: window._env_.APP_NAME !== "Partner" ? containerHeaderCopyOPS : containerHeaderCopyDrayage,
            isSourceSelected: isSourceSelected,
            entityId: entityId,
            holds: holds,
            handleParentState: _this.handleState,
            archived: archived,
            fees: fees,
            containerInfo: containerInfo,
            entityTimezone: entityTimezone,
            entityType: entityType,
            showContainerModal: indexRowClicked !== -1,
            metaData: metaHeadersCopy,
            allShipmentInfo: allShipmentInfo,
            terminalLink: containerInfo.terminalLink,
            showDragAndDropModal: _this.toggleDragAndDropState
            // showDoDocumentModal={this.toggleDoDocumentModal}
            , userType: _this.props.userType,
            handelDoUrl: _this.handelDoUrl
            // uploadFile={this.props.uploadFile}
            , historyMode: _this.state.historyMode,
            isPodInland: isPodInland
          })
        )
      );
    };

    _this.renderVessels = function () {
      var _this$state5 = _this.state,
          accordianStateVessels = _this$state5.accordianStateVessels,
          loadingAccordian = _this$state5.loadingAccordian,
          accordianBodiesVessels = _this$state5.accordianBodiesVessels;
      var vesselsList = _this.state.vesselsList;


      return vesselsList && vesselsList.map(function (_ref20, index) {
        var imo = _ref20.imo,
            name = _ref20.name;


        return React__default.createElement(Accordian, {
          accordianTitle: name + " (" + imo + ")",
          accordianBody: accordianStateVessels[index] && accordianBodiesVessels[index],
          accordianState: accordianStateVessels[index],
          index: index,
          toggleAccordian: _this.toggleVesselAccordian,
          loading: loadingAccordian[index],
          shipmentCount: 2,
          additionalBodyClass: "blockDisplay"
        });
      });
    };

    _this.renderPorts = function () {
      var _this$state6 = _this.state,
          accordianStatePorts = _this$state6.accordianStatePorts,
          loadingAccordian = _this$state6.loadingAccordian,
          accordianBodiesPorts = _this$state6.accordianBodiesPorts;
      var portsList = _this.state.portsList;


      return portsList && portsList.map(function (_ref21, index) {
        var name = _ref21.name,
            unloc = _ref21.unloc;


        return React__default.createElement(Accordian, {
          accordianTitle: name + " (" + unloc + ")",
          accordianBody: accordianStatePorts[index] && accordianBodiesPorts[index],
          accordianState: accordianStatePorts[index],
          index: index,
          toggleAccordian: _this.togglePortAccordian,
          loading: loadingAccordian[index],
          shipmentCount: 2,
          additionalBodyClass: "blockDisplay"
        });
      });
    };

    _this.nextContainer = function (params) {
      var _this$state7 = _this.state,
          pageNumber = _this$state7.pageNumber,
          totalListEl = _this$state7.totalListEl;

      var totalPage = Math.ceil(totalListEl / 25);

      if (pageNumber > 1 && params === "first") {
        _this.setState({ pageNumber: 1, loading: true, containerChecked: [], indexRowClicked: -1 }, function () {
          _this.getListOfContainers(false, '');
        });
      }
      if (pageNumber < totalPage && params === "next") {
        _this.setState({ pageNumber: pageNumber + 1, loading: true, containerChecked: [], indexRowClicked: -1 }, function () {
          _this.getListOfContainers(false, '');
        });
      }
      if (pageNumber > 1 && params === "prev") {
        _this.setState({ pageNumber: pageNumber - 1, loading: true, containerChecked: [], indexRowClicked: -1 }, function () {
          _this.getListOfContainers(false, '');
        });
      }
      if (pageNumber < totalPage && params === "last") {
        _this.setState({ pageNumber: totalPage, loading: true, containerChecked: [], indexRowClicked: -1 }, function () {
          _this.getListOfContainers(false, '');
        });
      }
    };

    _this.filterChangeHandler = function (_ref22) {
      var fieldName = _ref22.fieldName;


      _this.setState({ selectedFilter: fieldName });

      document.querySelector(".outerWrapperContainerModal").setAttribute('data-fieldname', fieldName);
      document.querySelector(".container-pagination") && document.querySelector(".container-pagination").setAttribute('data-fieldname', fieldName);

      if (fieldName == "vessel" || fieldName == "port") {
        _this.fetchVesselsPortsLvl1(fieldName);
      }
    };

    _this.fetchVesselsPortsLvl1 = function (tabType$$1) {
      var getVesselsPortsLvl1 = _this.props.getVesselsPortsLvl1;


      var filters = [];
      _this.getFilterParams("").map(function (filter) {
        if (filter.key === "SEARCH_FILTER_ENTITY_SORT_BY") return;
        filters.push(filter);
      });

      getVesselsPortsLvl1(filters, tabType$$1).then(function (response) {
        var _response$data$eventM = response.data.eventMessage,
            vessels = _response$data$eventM.vessels,
            ports = _response$data$eventM.ports;

        _this.setState({ vesselsList: vessels, portsList: ports });

        Array.from(document.querySelectorAll(".accordian_item_header .minus.square.outline.icon")).forEach(function (element, index) //Change all minus to plus
        {
          element.classList.remove("minus");
          element.classList.add("plus");
        });
      });
    };

    _this.renderFilter = function (_ref23) {
      var displayName = _ref23.displayName,
          alt = _ref23.alt,
          fieldName = _ref23.fieldName,
          selectedFilter = _ref23.selectedFilter;
      return React__default.createElement(
        "div",
        {
          className: "filter" + (selectedFilter === fieldName ? ' selectedFilter' : ''),
          onClick: function onClick() {
            return _this.filterChangeHandler({ fieldName: fieldName });
          }
        },
        React__default.createElement("img", {
          src: fieldName === 'vessel' ? vesselIcon : fieldName === 'container' ? containerIcon : fieldName === 'port' ? portIcon : '',
          alt: alt,
          className: "imgStyle " + fieldName
        }),
        React__default.createElement(
          "div",
          { className: "textStyle" },
          displayName
        )
      );
    };

    _this.renderContainerFilters = function (_ref24) {
      var selectedFilter = _ref24.selectedFilter;
      return containerFilters.map(function (_ref25) {
        var displayName = _ref25.displayName,
            fieldName = _ref25.fieldName,
            alt = _ref25.alt;
        return _this.renderFilter({ displayName: displayName, alt: alt, fieldName: fieldName, selectedFilter: selectedFilter });
      });
    };

    _this.resetSearchFilter = function () {
      // document.getElementById('search-select-box').selectedIndex = "0";
      _this.setState({ isDropDownFilter: '', searchText: '', pageNumber: 1 });
    };

    _this.updateSearch = function (_ref26) {
      var _ref26$searchText = _ref26.searchText,
          searchText = _ref26$searchText === undefined ? '' : _ref26$searchText;
      var selectedFilter = _this.state.selectedFilter;

      var search = new String(searchText);
      if (search.length > 3) {
        if (selectedFilter === "container") _this.getListOfContainers();else _this.fetchVesselsPortsLvl1(selectedFilter);
      }
      if (search.length === 0) {
        _this.resetSearchFilter();

        if (selectedFilter === "container") _this.getListOfContainers(false, "");else _this.fetchVesselsPortsLvl1(selectedFilter);
      }
      _this.setState({ pageNumber: 1 });
    };

    _this.handleExportClick = function (type, filters) {
      _this.setState({ isExportExcelLoading: true });
      var exportContainers = _this.props.exportContainers;


      var params = {
        filters: _this.setupFiltersForDrayage(_this.getFilterParams()),
        exportType: type === "excel" ? 0 : 1
        // searchType: 1
      };

      if (filters && _.isArray(filters) && !isEmpty(filters)) {
        params['filters'] = [].concat(toConsumableArray(filters), toConsumableArray(params['filters']));
      }

      return exportContainers(params).then(function (res) {
        window.open("" + res.data.eventMessage.url, '_blank');
      }).finally(function () {
        _this.setState({ isExportExcelLoading: false });
      });
    };

    _this.renderCheckBoxes = function (_ref27) {
      var searchText = _ref27.searchText;
      var _this$state8 = _this.state,
          modalOpen = _this$state8.modalOpen,
          endDate = _this$state8.endDate,
          startDate = _this$state8.startDate,
          errorMessage = _this$state8.errorMessage;


      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          { className: "check-container" },
          React__default.createElement(
            "div",
            null,
            checkBoxFilters.map(function (_ref28) {
              var labelName = _ref28.labelName,
                  fieldName = _ref28.fieldName,
                  showFor = _ref28.showFor;

              if (_this.props.accessType === "readOnly" && !["historyMode", "hotContainers"].includes(fieldName)) {
                return null;
              }

              return React__default.createElement(
                "div",
                { className: "checkBoxFilter" },
                window._env_.APP_NAME !== "Partner" ? React__default.createElement(
                  "div",
                  { className: "checkBoxFilter" },
                  React__default.createElement("input", {
                    type: "checkbox",
                    checked: _this.state[fieldName],
                    onChange: function onChange(_ref29) {
                      var _this$setState3;

                      var checked = _ref29.target.checked;

                      _this.setState((_this$setState3 = {}, defineProperty(_this$setState3, fieldName, checked), defineProperty(_this$setState3, "loading", true), defineProperty(_this$setState3, "indexRowClicked", -1), _this$setState3), function () {
                        return _this.updateSearch({ searchText: searchText });
                      });
                    },
                    disabled: fieldName === "excludeprocessed" && _this.state.historyMode || fieldName === "p44NonTracking" && _this.state.historyMode || fieldName === "TModalVSP44differences" && _this.state.historyMode || fieldName === "hotContainers" && _this.state.historyMode || fieldName === "hyperCareContainers" && _this.state.historyMode,
                    defaultChecked: fieldName === "excludeprocessed" && _this.props.userType !== "DRAY_OPS_USER"
                  }),
                  React__default.createElement(
                    "label",
                    { className: "labelStyle" },
                    labelName
                  )
                ) : labelName === "History Mode" && React__default.createElement(
                  "div",
                  { className: "checkBoxFilter" },
                  React__default.createElement("input", {
                    type: "checkbox",
                    onChange: function onChange(_ref30) {
                      var _this$setState4;

                      var checked = _ref30.target.checked;

                      _this.setState((_this$setState4 = {}, defineProperty(_this$setState4, fieldName, checked), defineProperty(_this$setState4, "loading", true), defineProperty(_this$setState4, "indexRowClicked", -1), _this$setState4), function () {
                        return _this.updateSearch({ searchText: searchText });
                      });
                    }
                  }),
                  React__default.createElement(
                    "label",
                    { className: "labelStyle" },
                    labelName
                  )
                ),
                window._env_.APP_NAME === "Partner" && labelName === "Containers Pending Assignment" ? React__default.createElement(
                  "div",
                  { className: "checkBoxFilter" },
                  React__default.createElement("input", {
                    type: "checkbox",
                    onChange: function onChange(_ref31) {
                      var _this$setState5;

                      var checked = _ref31.target.checked;

                      _this.setState((_this$setState5 = {}, defineProperty(_this$setState5, fieldName, checked), defineProperty(_this$setState5, "loading", true), defineProperty(_this$setState5, "indexRowClicked", -1), _this$setState5), function () {
                        return _this.updateSearch({ searchText: searchText });
                      });
                    }
                  }),
                  React__default.createElement(
                    "label",
                    { className: "labelStyle" },
                    labelName
                  )
                ) : "",
                window._env_.APP_NAME === "Partner" && (fieldName === "hotContainers" || fieldName === "hyperCareContainers") ? React__default.createElement(
                  "div",
                  { className: "checkBoxFilter" },
                  React__default.createElement("input", {
                    type: "checkbox",
                    onChange: function onChange(_ref32) {
                      var _this$setState6;

                      var checked = _ref32.target.checked;

                      _this.setState((_this$setState6 = {}, defineProperty(_this$setState6, fieldName, checked), defineProperty(_this$setState6, "loading", true), defineProperty(_this$setState6, "indexRowClicked", -1), _this$setState6), function () {
                        return _this.updateSearch({ searchText: searchText });
                      });
                    }
                  }),
                  React__default.createElement(
                    "label",
                    { className: "labelStyle" },
                    labelName
                  )
                ) : ""
              );
            })
          ),
          React__default.createElement(
            "div",
            { className: "exportIcon" },
            React__default.createElement(
              "span",
              { onClick: _this.state.historyMode ? function () {
                  return _this.handleModalOpen('excel');
                } : function () {
                  return _this.handleExportClick('excel');
                } },
              React__default.createElement(Popup, {
                content: "Export To Excel",
                trigger: React__default.createElement(Button, { icon: "file excel", size: "large", style: { fontSize: "1.5rem", padding: "0px" } }),
                position: "top right"
              })
            ),
            React__default.createElement(
              "span",
              { onClick: _this.state.historyMode ? function () {
                  return _this.handleModalOpen('csv');
                } : function () {
                  return _this.handleExportClick("csv");
                } },
              React__default.createElement(Popup, {
                content: "Export To CSV",
                trigger: React__default.createElement(Button, { icon: "file excel outline", size: "large", style: { fontSize: "1.5rem", padding: "0px", marginLeft: "15px" } })
              })
            ),
            _this.state.isExportExcelLoading && React__default.createElement(Icon, { loading: true, name: "spinner", style: { marginRight: 5, fontSize: 18, color: '#04adb1' } })
          ),
          React__default.createElement(ModalDatePicker, { handleModalClose: _this.handleModalClose, handleModalOpen: _this.handleModalOpen, modalOpen: modalOpen, handleDateChange: _this.handleDateChange, startDate: startDate, endDate: endDate, handleExportSubmitClick: _this.handleExportSubmitClick, errorMessage: errorMessage })
        )
      );
    };

    _this.undoLastAction = function () {
      var _ref33 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e, params) {
        var undoEntityEvent, entityId, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                undoEntityEvent = _this.props.undoEntityEvent;
                entityId = params.entityId;

                e.preventDefault();
                e.stopPropagation();

                if (!_this.state.modalIsLoading) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt("return");

              case 6:

                _this.setState({ entityId: entityId, modalIsLoading: true, showModal: true, activeEntityId: entityId });

                _context6.prev = 7;
                _context6.next = 10;
                return undoEntityEvent(params);

              case 10:
                response = _context6.sent;

                _this.setState({ isMarkDisable: false, modalIsLoading: false, showLastActionMessage: get(response, "data.eventMessage.value", "Action undone successfully!") });
                _context6.next = 17;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](7);

                _this.setState({ modalIsLoading: false, showLastActionMessage: "Failed to undo action. Please try again." });

              case 17:
                _context6.next = 19;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1500);
                });

              case 19:
                _this.setState({ showLastActionMessage: "Fetching latest container data..." });
                _context6.next = 22;
                return _this.getListOfContainers(true, entityId, false);

              case 22:

                if (!_this.state.containerListLoading) {
                  _this.setState({
                    showLastActionMessage: _this.state.isError ? "Failed to fetch container data." : "Container data fetched successfully!"
                  });
                }

                setTimeout(function () {
                  _this.setState({
                    showModal: false,
                    modalIsLoading: false,
                    activeEntityId: null,
                    showLastActionMessage: ""
                  });
                }, 1500);

              case 24:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this2, [[7, 14]]);
      }));

      return function (_x15, _x16) {
        return _ref33.apply(this, arguments);
      };
    }();

    _this.markDonetriggerApiCall = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments[1];

      e.preventDefault();
      e.stopPropagation();
      _this.setState({ isMarkDone: false, isNewLoading: true, showGroundPopuop: false, isHoldsStuck: false, isFeesStuck: false, showLineReleasePopuop: false, showReadyPickup: false, showGateOut: false, showGateIn: false });

      var apiParamData = _extends({}, params);
      return _this.props.getEntityTime(apiParamData).then(function (response) {
        // markAsDone(apiParamData.entityId);
        _this.setState({
          isMarkDisable: true, selectedDate: null, loading: false, isNewLoading: false
        });
        _this.getCurrentTime(apiParamData.entityId);
      }).catch(function (error) {

        _this.setState({
          isMarkDisable: false, selectedDate: null, loading: false, isNewLoading: false
        });
      });
    };

    _this.renderSearchHeader = function (_ref34) {
      var searchText = _ref34.searchText,
          selectedFilter = _ref34.selectedFilter;
      return React__default.createElement(
        "div",
        { className: "container-app" },
        React__default.createElement(
          "div",
          { className: "container-header", onClick: function onClick() {
              return _this.setState({ indexRowClicked: -1 });
            } },
          React__default.createElement(
            "div",
            { className: "container-header-sec" },
            React__default.createElement(
              "div",
              { className: "flexDisplay spaceInBetween" },
              React__default.createElement(
                "div",
                { className: "processed-checkbox-search" },
                _this.renderCheckBoxes({ searchText: searchText })
              )
            )
          )
        )
      );
    };

    _this.triggerLoader = function () {
      _this.setState({ loading: true, containerChecked: [], indexRowClicked: -1 }, function () {
        return _this.getListOfContainers();
      });
    };

    _this.updateBulkContainer = function (e, data, containerInfo) {
      var _this$state9 = _this.state,
          containerChecked = _this$state9.containerChecked,
          containerData = _this$state9.containerData;


      var updatedList = [].concat(toConsumableArray(containerChecked));
      if (data.checked) {
        updatedList = [].concat(toConsumableArray(containerChecked), [containerInfo.entityId]);
      } else {
        updatedList.splice(containerChecked.indexOf(containerInfo.entityId), 1);
      }

      _this.setState({ containerChecked: updatedList, isBulkUpdateActivate: true });

      containerData.map(function (container, index) {
        updatedList.includes(container.entityId) && _this.setState({ indexRowClicked: index });
      });
    };

    _this.triggerBulkCopyModal = function () {
      var _this$state10 = _this.state,
          radioValue = _this$state10.radioValue,
          copyField = _this$state10.copyField,
          valueCopid = _this$state10.valueCopid,
          containerData = _this$state10.containerData,
          selectAll = _this$state10.selectAll,
          checkedCopyValue = _this$state10.checkedCopyValue,
          checkedContainerValues = _this$state10.checkedContainerValues;


      var selectBox = function selectBox(e, data) {
        var newContainerData = void 0;
        if (data.name == "selectAll") {
          _this.setState({ selectAll: data.checked, copyButton: !_this.state.copyButton });
          newContainerData = containerData.map(function (container) {
            return _extends({}, container, { isChecked: data.checked });
          });
        } else {
          // this.setState({copyButton: true });
          newContainerData = containerData.map(function (container) {
            return container.entityId === data.name ? _extends({}, container, { isChecked: data.checked }) : container;
          });
        }

        var checkedList = [].concat(toConsumableArray(checkedContainerValues));
        if (data.name === "selectAll") {
          if (data.checked) {
            checkedList = [].concat(toConsumableArray(checkedContainerValues), toConsumableArray(containerData));
          } else {
            _this.setState({ valueCopid: false });
            checkedList = [];
          }
        } else {
          var newContainer = void 0;

          if (data.checked) {
            newContainer = containerData.filter(function (container) {
              return container.entityId === data.name;
            });
            checkedList = [].concat(toConsumableArray(checkedContainerValues), toConsumableArray(newContainer));
            _this.setState({ valueCopid: false, copyButton: true });
          } else {
            newContainer = containerData.find(function (container) {
              return container.entityId === data.name;
            });
            checkedList = checkedList.filter(function (container) {
              return container.entityId !== newContainer.entityId;
            });
            _this.setState({ valueCopid: false, copyButton: true });
          }
        }

        var parmeters = copyField === "Container Number" ? checkedList.map(function (container) {
          return container.entityId;
        }).filter(function (id) {
          return id !== undefined;
        }) : copyField === "Shipment Id" ? checkedList.map(function (container) {
          return container.shipmentIds.split(',')[0];
        }).filter(function (shipId) {
          return shipId !== undefined;
        }) : checkedList.map(function (container) {
          return container.entityShipmentList[0].masterBolNumber;
        }).filter(function (mbol) {
          return mbol !== undefined;
        });

        _this.setState({
          containerData: newContainerData,
          checkedCopyValue: [].concat(toConsumableArray(new Set(parmeters))),
          checkedContainerValues: checkedList,
          copyButton: checkedList.length > 0 ? true : false
        });
      };

      var handleFieldChange = function handleFieldChange(e, data) {
        var parmeters = data.value === "Container Number" ? checkedContainerValues.map(function (container) {
          return container.entityId;
        }).filter(function (id) {
          return id !== undefined;
        }) : data.value === "Shipment Id" ? checkedContainerValues.map(function (container) {
          return container.shipmentIds.split(',')[0];
        }).filter(function (shipId) {
          return shipId !== undefined;
        }) : checkedContainerValues.map(function (container) {
          return container.entityShipmentList[0].masterBolNumber;
        }).filter(function (mbol) {
          return mbol !== undefined;
        });

        _this.setState({ checkedCopyValue: [].concat(toConsumableArray(new Set(parmeters))), copyButton: true });
      };

      var handleCopy = function handleCopy() {

        var string = "";
        for (var i = 0; i < checkedCopyValue.length; i++) {
          string = string + " " + checkedCopyValue[i];
        }

        var copiedValues = radioValue === "comma" ? checkedCopyValue.toString() : string;
        // console.log(copiedValues.trim());
        navigator.clipboard.writeText(copiedValues.trim());
      };

      var uncheckAll = function uncheckAll() {
        var newContainerData = containerData.map(function (container) {
          return _extends({}, container, { isChecked: false });
        });

        navigator.clipboard.writeText('');
        _this.setState({
          containerData: newContainerData,
          checkedCopyValue: [],
          selectAll: false,
          checkedContainerValues: [],
          copyField: "Container Number",
          radioValue: "space"
        });
      };

      return React__default.createElement(
        "div",
        { className: "bulkCopy_Modal" },
        React__default.createElement(
          "div",
          { className: "bulkCopy_Container" },
          React__default.createElement(
            "div",
            { className: "header" },
            React__default.createElement(
              "h2",
              null,
              "Bulk Copy"
            ),
            React__default.createElement(Icon, {
              name: "close",
              size: "small",
              onClick: function onClick() {
                return _this.setState({
                  showModalForBulkCopy: false,
                  selectAll: false,
                  checkedCopyValue: [],
                  valueCopid: false,
                  radioValue: "space",
                  copyField: "Container Number",
                  checkedContainerValues: [],
                  copyButton: false,
                  containerData: containerData.map(function (container) {
                    return _extends({}, container, { isChecked: false });
                  })
                });
              },
              style: { cursor: "pointer" }
            })
          ),
          React__default.createElement("hr", null),
          React__default.createElement(
            "div",
            { className: "filter" },
            React__default.createElement(Dropdown, {
              value: copyField,
              onChange: function onChange(e, data) {
                return _this.setState({
                  copyField: data.value,
                  valueCopid: false
                }, function () {
                  return handleFieldChange(e, data);
                });
              },
              fluid: true,
              search: true,
              selection: true,
              className: "bulkCopy_dropdown",
              options: optionsForBulkCopy
            }),
            React__default.createElement(
              "div",
              { className: "delimeter" },
              React__default.createElement(
                "span",
                { className: "delimeterHeadingText" },
                "Delimiter"
              ),
              React__default.createElement(
                "div",
                { className: "radio-btn" },
                React__default.createElement(Radio, {
                  label: "space",
                  name: "radioGroup",
                  value: "space",
                  className: "radio1",
                  checked: radioValue === "space",
                  onChange: function onChange(e, data) {
                    return _this.setState({ radioValue: data.value, valueCopid: false, copyButton: true });
                  }
                }),
                React__default.createElement(Radio, {
                  label: "comma",
                  name: "radioGroup",
                  value: "comma",
                  className: "radio2",
                  checked: radioValue === "comma",
                  onChange: function onChange(e, data) {
                    return _this.setState({ radioValue: data.value, valueCopid: false, copyButton: true });
                  }
                })
              )
            )
          ),
          React__default.createElement(
            "div",
            { className: "table bulkCopyModal_table" },
            React__default.createElement(
              Table,
              { size: "large" },
              React__default.createElement(
                Table.Header,
                null,
                React__default.createElement(
                  Table.Row,
                  { className: "bulkCopyModal_table-header" },
                  React__default.createElement(
                    Table.HeaderCell,
                    null,
                    React__default.createElement(Checkbox, {
                      label: "Select All",
                      name: "selectAll",
                      checked: selectAll,
                      onChange: function onChange(e, data) {
                        return selectBox(e, data);
                      }
                    })
                  ),
                  React__default.createElement(
                    Table.HeaderCell,
                    null,
                    "Container Number"
                  ),
                  React__default.createElement(
                    Table.HeaderCell,
                    null,
                    "Shipment Id"
                  ),
                  React__default.createElement(
                    Table.HeaderCell,
                    null,
                    "MBOL"
                  ),
                  React__default.createElement(
                    Table.HeaderCell,
                    null,
                    "Customer"
                  ),
                  React__default.createElement(
                    Table.HeaderCell,
                    null,
                    "Terminal"
                  ),
                  React__default.createElement(
                    Table.HeaderCell,
                    null,
                    "ETA"
                  ),
                  React__default.createElement(
                    Table.HeaderCell,
                    null,
                    "Current Event"
                  )
                )
              ),
              React__default.createElement(
                Table.Body,
                { style: { fontSize: "14px" } },
                containerData.map(function (_ref35) {
                  var entityId = _ref35.entityId,
                      shipmentIds = _ref35.shipmentIds,
                      entityShipmentList = _ref35.entityShipmentList,
                      isChecked = _ref35.isChecked,
                      customer = _ref35.customer,
                      terminal = _ref35.terminal,
                      entityTimezone = _ref35.entityTimezone,
                      grounded = _ref35.grounded,
                      customReleased = _ref35.customReleased,
                      carrierReleased = _ref35.carrierReleased,
                      holds = _ref35.holds,
                      fees = _ref35.fees,
                      readyForPickup = _ref35.readyForPickup,
                      terminalPickupAppointment = _ref35.terminalPickupAppointment,
                      terminalDropAppointment = _ref35.terminalDropAppointment,
                      warehouseDropAppointment = _ref35.warehouseDropAppointment,
                      warehousePickupAppointment = _ref35.warehousePickupAppointment,
                      gateOut = _ref35.gateOut,
                      gateIn = _ref35.gateIn,
                      done = _ref35.done;


                  var containerFieldArray = [grounded, customReleased, carrierReleased, holds, fees, readyForPickup, terminalPickupAppointment, gateOut, terminalDropAppointment, warehouseDropAppointment, warehousePickupAppointment, gateIn, done];
                  var currentEvent = {};
                  if (containerFieldArray.every(function (containerData) {
                    return containerData.sourceSelected === "ENTITY_SOURCE_NONE";
                  })) {
                    currentEvent = {};
                  } else {
                    for (var i = containerFieldArray.length - 1; i >= 0; i--) {
                      currentEvent = containerFieldArray[i];
                      if (containerFieldArray[i].sourceSelected !== "ENTITY_SOURCE_NONE") break;
                    }
                  }
                  //let sortedData = []
                  // containerFieldArray.map(data => sortedData.push({updatedDate: Date.parse(data.updatedDate), eventName: data.eventName}));
                  // sortedData.sort((a, b) => b.updatedDate - a.updatedDate);

                  return React__default.createElement(
                    Table.Row,
                    null,
                    React__default.createElement(
                      Table.Cell,
                      null,
                      React__default.createElement(Checkbox, {
                        name: entityId,
                        checked: isChecked || false,
                        onChange: function onChange(e, data) {
                          return selectBox(e, data);
                        }
                      })
                    ),
                    React__default.createElement(
                      Table.Cell,
                      null,
                      entityId
                    ),
                    React__default.createElement(
                      Table.Cell,
                      null,
                      shipmentIds.split(',')[0]
                    ),
                    React__default.createElement(
                      Table.Cell,
                      null,
                      entityShipmentList[0].masterBolNumber ? entityShipmentList[0].masterBolNumber : "-"
                    ),
                    React__default.createElement(
                      Table.Cell,
                      null,
                      customer
                    ),
                    React__default.createElement(
                      Table.Cell,
                      null,
                      terminal && terminal.length > 20 ? terminal.substring(0, 20) + "..." : terminal || "-"
                    ),
                    React__default.createElement(
                      Table.Cell,
                      null,
                      entityShipmentList[0] && entityShipmentList[0].eta ? _this.convertEpochToDate(entityShipmentList[0].eta, false, true, entityTimezone) : "-"
                    ),
                    React__default.createElement(
                      Table.Cell,
                      null,
                      eventType$1[currentEvent["eventName"]] || "-"
                    )
                  );
                })
              )
            )
          ),
          React__default.createElement("hr", null),
          React__default.createElement(
            "div",
            { className: "bottom" },
            React__default.createElement(
              Button,
              { className: "cancel button", onClick: function onClick() {
                  return _this.setState({ valueCopid: false, copyButton: false }, function () {
                    return uncheckAll();
                  });
                } },
              "Reset"
            ),
            React__default.createElement(
              Button,
              { disabled: !_this.state.copyButton || checkedCopyValue.length < 1, className: "copy button", onClick: function onClick() {
                  return _this.setState({ valueCopid: true, copyButton: false }, function () {
                    return handleCopy();
                  });
                } },
              valueCopid ? "Copied!" : "Copy"
            )
          )
        )
      );
    };

    _this.multiFiltersSubmitted = function (filterValues) {
      _this.setState({
        multiFilterValues: filterValues,
        loading: true,
        appliedFilters: true,
        accordianStateVessels: [false],
        accordianStatePorts: [false],
        pageNumber: 1,
        indexRowClicked: -1
      }, function () {
        return _this.getListOfContainers();
      });
    };

    _this.resetMultiFilters = function () {
      _this.setState({
        multiFilterValues: {},
        loading: true,
        resetClicked: true,
        appliedFilters: false,
        resetMultiFilters2: true,
        pageNumber: 1,
        indexRowClicked: -1
      }, function () {
        return _this.getListOfContainers();
      });
    };

    _this.resetContainerChecked = function () {
      _this.setState({ containerChecked: [] });
    };

    _this.makeFilterdisplay = function () {
      var multiFilterValues = _this.state.multiFilterValues;

      var i = 0;
      var jsx$$1 = [];

      var container = void 0,
          shipment = void 0,
          country = void 0,
          mbol = void 0,
          terminal = void 0,
          customer = void 0,
          cityOFDeliveryAddress = void 0,
          vessel = void 0,
          Dcarrier = void 0,
          ETAbefore = void 0,
          ETAafter = void 0,
          PerDiemBefore = void 0,
          PerDiemAfter = void 0,
          poNumber = void 0,
          MOT = void 0;

      multiFilterValues.map(function (param) {
        if (param.key.includes("COUNTRY")) return country = { key: "Country", value: param.value };
        if (param.key.includes("SHIPMENT_IDS")) return shipment = { key: "Shipments", value: param.value };
        if (param.key.includes("ENTITY_IDS")) return container = { key: "Container", value: param.value };
        if (param.key.includes("CITY_OF_DELIVERY")) return cityOFDeliveryAddress = { key: "City of Delivery Address", value: param.value };
        if (param.key.includes("BOL")) return mbol = { key: "MBOL", value: param.value };
        if (param.key.includes("ARRIVAL_NOTICE")) return terminal = { key: "Terminal", value: param.value };
        if (param.key.includes("CUSTOMER_NAME")) return customer = { key: "Customer", value: param.value };
        if (param.key.includes("CARRIER_NAME")) return vessel = { key: "Vessel", value: param.value };
        if (param.key.includes("DRAYAGE_CARRIER")) return Dcarrier = { key: "D-Carrier", value: param.value };
        if (param.key.includes("ETA_BEFORE")) return ETAbefore = { key: "ETA Before", value: param.value };
        if (param.key.includes("ETA_AFTER")) return ETAafter = { key: "ETA After", value: param.value };
        if (param.key.includes("PDT_BEFORE")) return PerDiemBefore = { key: "Per Diem Time Before", value: param.value };
        if (param.key.includes("PDT_AFTER")) return PerDiemAfter = { key: "Per Diem Time After", value: param.value };
        if (param.key.includes("MODE_OF_TRANSPORT")) return MOT = { key: "Mot", value: param.value };
        if (param.key.includes("PO")) return poNumber = { key: "PO", value: param.value };
      });

      if (container !== undefined && container.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          container.key,
          " - ",
          container.value.toString()
        );
      }

      if (shipment !== undefined && shipment.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          shipment.key,
          " - ",
          shipment.value.toString()
        );
      }

      if (country !== undefined && country.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          country.key,
          " - ",
          country.value.toString()
        );
      }

      if (cityOFDeliveryAddress !== undefined && cityOFDeliveryAddress.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          cityOFDeliveryAddress.key,
          " - ",
          cityOFDeliveryAddress.value.toString()
        );
      }

      if (mbol !== undefined && mbol.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          mbol.key,
          " - ",
          mbol.value.toString()
        );
      }

      if (poNumber !== undefined && poNumber.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          poNumber.key,
          " - ",
          poNumber.value.toString()
        );
      }

      if (terminal !== undefined && terminal.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          terminal.key,
          " - ",
          terminal.value.toString()
        );
      }

      if (customer !== undefined && customer.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          customer.key,
          " - ",
          customer.value.toString()
        );
      }

      if (vessel !== undefined && vessel.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          vessel.key,
          " - ",
          vessel.value.toString()
        );
      }

      if (Dcarrier !== undefined && Dcarrier.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          Dcarrier.key,
          " - ",
          Dcarrier.value.toString()
        );
      }

      if (ETAbefore !== undefined && ETAbefore && ETAbefore.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          ETAbefore.key,
          " - ",
          moment$1.utc(+ETAbefore.value.toString()).format("MMM DD, YYYY")
        );
      }

      if (ETAafter !== undefined && ETAafter && ETAafter.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          ETAafter.key,
          " - ",
          moment$1.utc(+ETAafter.value.toString()).format("MMM DD, YYYY")
        );
      }

      if (PerDiemBefore !== undefined && PerDiemBefore && PerDiemBefore.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          PerDiemBefore.key,
          " - ",
          moment$1.utc(+PerDiemBefore.value.toString()).format("MMM DD, YYYY")
        );
      }

      if (MOT && MOT.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          MOT.key,
          " - ",
          (Array.isArray(MOT.value) ? MOT.value : []).map(function (item) {
            return item.replace('MOT_', '');
          }).join(', ')
        );
      }

      if (PerDiemAfter !== undefined && PerDiemAfter && PerDiemAfter.value) {
        jsx$$1[i++] = React__default.createElement(
          "span",
          null,
          PerDiemAfter.key,
          " - ",
          moment$1.utc(+PerDiemAfter.value.toString()).format("MMM DD, YYYY")
        );
      }

      return React__default.createElement(
        "div",
        { className: "filters_Applied" },
        "Applied Filters -",
        React__default.createElement(
          "p",
          null,
          jsx$$1,
          " ",
          " ",
          React__default.createElement(
            "a",
            { onClick: _this.resetMultiFilters },
            "Reset"
          )
        )
      );
    };

    _this.onPageNumberChange = function (value) {
      var totalListEl = _this.state.totalListEl;

      var maxPageNumber = Math.ceil(totalListEl / 25);
      _this.setState({ pageNumber: value });
      if (value) {
        var newValue = value <= 0 ? 1 : value > maxPageNumber ? maxPageNumber : value;
        _this.setState({ pageNumber: parseInt(newValue), loading: true, containerChecked: [], indexRowClicked: -1 }, function () {
          _this.getListOfContainers(false, '');
        });
      }
    };

    _this.resetloadContainerModal = function () {
      setTimeout(function () {
        _this.setState({ loadContainerModal: false });
      }, 800);
    };

    _this.resetloadSpecifiedContainerModal = function () {
      setTimeout(function () {
        _this.setState({ isLoadingSpecifiedModal: false });
      }, 800);
    };

    _this.defaultFilterValues = function (filterValues) {
      _this.setState({ multiFilterValues: filterValues }, function () {
        _this.getListOfContainers();
      });
    };

    _this.checkIsHotContainer = function (entityShipmentList) {
      if (Array.isArray(entityShipmentList) && entityShipmentList.length) {
        var isAtLeastOneHot = entityShipmentList.some(function (obj) {
          return obj.isHot === true;
        });
        return isAtLeastOneHot;
      }

      return false;
    };

    _this.handleModalOpen = function (format) {
      _this.setState({ modalOpen: true, errorMessage: '', exportFormat: format });
    };

    _this.handleModalClose = function () {
      _this.setState({ modalOpen: false });
    };

    _this.handleDateChange = function (name, value) {
      _this.setState(defineProperty({}, name, value), function () {
        // Check date range and update the error message
        if (_this.state.startDate && _this.state.endDate) {
          var startDateObj = new Date(_this.state.startDate);
          var endDateObj = new Date(_this.state.endDate);
          var todaysObj = new Date();
          var timeDifference = Math.abs(endDateObj - startDateObj);
          var dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

          if (startDateObj > todaysObj || endDateObj > todaysObj) {
            _this.setState({ errorMessage: 'ETA After/ETA Before should not be in future.' }, function () {
              setTimeout(function () {
                _this.setState({ errorMessage: '' });
              }, 3000);
            });
          } else if (startDateObj < endDateObj) {
            _this.setState({ errorMessage: 'ETA After should be less than equal to ETA Before.' }, function () {
              setTimeout(function () {
                _this.setState({ errorMessage: '' });
              }, 3000);
            });
          } else if (dayDifference > 60) {
            _this.setState({ errorMessage: 'Date range should be within 60 days.' }, function () {
              setTimeout(function () {
                _this.setState({ errorMessage: '' });
              }, 3000);
            });
          } else {
            _this.setState({ errorMessage: '' }); // Clear the error message if the range is within 60 days
          }
        }
      });
    };

    _this.convertToEpoch = function (date) {
      var inToEpoch = void 0;
      if (date) {
        var isoDate = moment$1(date).format("YYYY-MM-DD");
        inToEpoch = moment$1(isoDate).utc(true).valueOf().toString();
      } else {
        inToEpoch = '';
      }
      return inToEpoch;
    };

    _this.handleExportSubmitClick = function () {
      var _this$state11 = _this.state,
          startDate = _this$state11.startDate,
          endDate = _this$state11.endDate,
          exportFormat = _this$state11.exportFormat;


      if (startDate && endDate) {
        var startDateObj = new Date(startDate);
        var endDateObj = new Date(endDate);
        var todaysObj = new Date();
        var timeDifference = Math.abs(endDateObj - startDateObj);
        var dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

        if (startDateObj > todaysObj || endDateObj > todaysObj) {
          _this.setState({ errorMessage: 'ETA After/ETA Before should not be in future.' }, function () {
            setTimeout(function () {
              _this.setState({ errorMessage: '' });
            }, 3000);
          });
        } else if (startDateObj < endDateObj) {
          _this.setState({ errorMessage: 'ETA After should be less than equal to ETA Before.' }, function () {
            setTimeout(function () {
              _this.setState({ errorMessage: '' });
            }, 3000);
          });
        } else if (dayDifference > 60) {
          _this.setState({ errorMessage: 'Date range should be within 60 days.' }, function () {
            setTimeout(function () {
              _this.setState({ errorMessage: '' });
            }, 3000);
          });
        } else {
          if (exportFormat) {
            var filters = [{
              key: "SEARCH_FILTER_ENTITY_ETA_BEFORE",
              value: [_this.convertToEpoch(startDate)]
            }, {
              key: "SEARCH_FILTER_ENTITY_ETA_AFTER",
              value: [_this.convertToEpoch(endDate)]
            }];

            _this.handleExportClick(exportFormat, filters);
          }

          _this.handleModalClose();
        }
      } else {
        _this.setState({ errorMessage: 'Please select both start and end dates.' }, function () {
          setTimeout(function () {
            _this.setState({ errorMessage: '' });
          }, 3000);
        });
      }
    };

    _this.checkDocuments = function (str, requiredDocuments$$1) {
      var documents = isString(str) ? str.split(',') : [];

      var allDocumentsPresent = requiredDocuments$$1.every(function (docType) {
        return documents.some(function (doc) {
          return doc.startsWith(docType);
        });
      });

      return allDocumentsPresent;
    };

    _this.getBrowserTimeZone = function () {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    };

    _this.convertUTCToTimezone = function (utcDate) {
      var timeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UTC';
      var timeFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY-MM-DD HH:mm:ss';

      if (!utcDate) return utcDate;

      if (!timeZone) {
        timeZone = 'UTC';
      }

      return moment$1.utc(utcDate).tz(timeZone).format(timeFormat);
    };

    _this.handleConfirmSplit = function () {
      var _ref36 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(payload) {
        var response, _get, _get$code, code, _get$msg, msg, _get$warnings, warnings, isSuccess, fullMessage;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this.setState({ splitFormLoading: true });

                _context7.prev = 1;
                _context7.next = 4;
                return setDrayageSplitContainers(payload);

              case 4:
                response = _context7.sent;
                _get = get(response, "data.eventMessage", {}), _get$code = _get.code, code = _get$code === undefined ? 500 : _get$code, _get$msg = _get.msg, msg = _get$msg === undefined ? "Something went wrong!" : _get$msg, _get$warnings = _get.warnings, warnings = _get$warnings === undefined ? [] : _get$warnings;
                isSuccess = code === 200;
                fullMessage = [msg].concat(toConsumableArray(warnings.length ? [""].concat(toConsumableArray(warnings)) : [])).join("\n");


                _this.setState({
                  openSplitModal: false,
                  showToast: true,
                  toastProps: {
                    message: fullMessage,
                    type: isSuccess ? "success" : "error",
                    duration: 3000,
                    onClose: _this.handleToastClose
                  }
                }, function () {
                  if (isSuccess) _this.getListOfContainers();
                  _this.setState({ splitFormLoading: false });
                });

                _context7.next = 14;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](1);

                _this.setState({
                  openSplitModal: false,
                  showToast: true,
                  toastProps: {
                    message: _context7.t0.message || "Something went wrong!",
                    type: "error",
                    duration: 3000,
                    onClose: _this.handleToastClose
                  },
                  splitFormLoading: false
                });

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this2, [[1, 11]]);
      }));

      return function (_x20) {
        return _ref36.apply(this, arguments);
      };
    }();

    _this.handleToastClose = function () {
      _this.setState({ showToast: false });
    };

    window.BASE_URL = _this.props.base_url;
    _this.state = {
      loading: true,
      isError: false,
      isApiTimeout: false,
      searchText: '',
      searchByParameter: 'Container',
      searchOrder: 'ASC',
      isEnableSpacer: false,
      isDropDownFilter: "",
      // searchDropDownFilter: "NONE",
      scrollTop: 0,
      pageNumber: 1,
      totalCount: null,
      totalListEl: 0,
      isApiCallDone: true,
      isLoading: false,
      isCount: false,
      isexcludeprocessedChecked: true,
      historyMode: false,
      showDrayageOnly: false,
      activeDrayageContainers: _this.props.userType === DMODAL_USERS.DRAY_OPS || _this.props.userType === DMODAL_USERS.SALES,
      invoiceNotSubmitted: false,
      containersPendingAssignment: false,
      excludeprocessed: window._env_.APP_NAME === "Partner" ? false : _this.props.userType === "DRAY_OPS_USER" ? false : true,
      prevCounter: 0,
      resetClicked: false,
      indexRowClicked: -1,
      rowClicked: false,
      isMarkDisable: false,
      selectedFilter: 'container',
      accordianStateVessels: [false],
      accordianBodiesVessels: [],
      accordianStatePorts: [false],
      accordianBodiesPorts: [],
      loadingAccordian: [false],
      containerDoneState: [false],
      list: [],
      vesselsList: [],
      portsList: [],
      filterValues: { sortBy: "ETA_DESCENDING", dModalDate: props.etaAfterDate },
      doneTime: [],
      appliedFilters: false,
      containerChecked: [],
      isBulkUpdateActivate: false,
      selectParameters: 'All',
      showModalForBulkCopy: false,
      etaBefore: "",
      radioValue: 'space',
      copyField: "Container Number",
      valueCopid: false,
      selectAll: false,
      checkedCopyValue: [],
      checkedContainerValues: [],
      multiFilterValues: {},
      resetMultiFilters2: false,
      copyButton: false,
      showDragAndDropModal: false,
      fileData: null,
      showUploadPercentage: false,
      confirmDeleteScreen: false,
      uploadUrl: "",
      doUrl: "",
      doDocumentData: {},
      viewDoFile: false,
      doDownload: "",
      enableDeleteButton: false,
      proofOfGateIn: false,
      viewFileScreen: false,
      viewAttachment: false,
      numPages: [],
      successConfirmationScreen: false,
      successMessage: "",
      selectedContainerInfo: {},
      directDelete: false,
      showContainerHistoryModal: false,
      p44NonTracking: false,
      TModalVSP44differences: false,
      filterContainerComment: false,
      hotContainers: false,
      hyperCareContainers: false,
      // viewDoScreen: false,
      // uploadDoUrl: "",
      createInvoice: false,
      containersinfo: {},
      noInvoiceContainer: "",
      doDocuments: [],
      loadContainerModal: false,
      progressStatus: 0,
      errorInFileUpload: false,
      proofOfGateInDocument: "",
      modalOpen: false,
      startDate: new Date(),
      endDate: new Date(Date.now() - 59 * 24 * 60 * 60 * 1000),
      errorMessage: '',
      exportFormat: '',
      openConfirmationModal: false,
      partnerContAssignStatus: '', // REJECTED; ACCEPTED; partner can accept or reject the container assigned.
      showResponseModal: false,
      contStatusLoading: false,
      partnerId: '',
      openEmailModal: false,
      additionalEmails: [],
      openContainerMenu: false,
      openSpecifiedContainerModal: false,
      isLoadingSpecifiedModal: false,
      isExportExcelLoading: false,
      showModal: false,
      modalIsLoading: false,
      showLastActionMessage: '',
      activeEntityId: null,
      containerListLoading: false,
      openSplitModal: false,
      showToast: false,
      toastProps: {},
      splitFormLoading: false,
      showMarkAsDoneDocError: "",
      errorContainerId: null
    };
    _this.updateSearch = debounce(_this.updateSearch, 1000);
    // this.readURL = this.readURL.bind(this);
    return _this;
  }

  createClass(ContainerTrackingApp, [{
    key: "onDocumentLoadSuccess",
    value: function onDocumentLoadSuccess(pdf) {
      var myArr = [];
      for (var i = 1; i <= pdf._pdfInfo.numPages; i++) {
        myArr.push(i);
      }
      this.setState({ numPages: myArr });
    }

    // triggerDoDomument = () => {

    //   const handleOnCancel = () => {
    //     this.setState({viewDoScreen: false})
    //   }

    //   const handleDownloadButton = () => {
    //       window.open(this.state.uploadDoUrl, "_blank");

    //     setTimeout(() => {this.resetFilters(); handleStateOnCancel(); }, 1300);
    //   }
    //   return (
    //     <div className="modalHolder">
    //       <div className="modal-contentHolder modal-lg">
    //           <div className="modal-content" style={{"backgroundColor": `${this.state.successConfirmationScreen ? "#F0FAF1" : "#fff"}`}}>
    //               {this.renderDoDocument()}
    //               <div className="custom-modal-footer justify-end">
    //                 <Button className="button btn-confirm" onClick={handleDownloadButton}>Download</Button>
    //                 <Button className="button" onClick={handleOnCancel}>Cancel</Button>
    //               </div>
    //           </div>
    //       </div>
    //   </div>
    //   )
    // }


    // FGOU6330546

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      Array.isArray(this.state.multiFilterValues) && this.defaultFilterValues();
      // this.getListOfContainers();
      // $('.image-upload-wrap').bind('dragover', function () {
      //   $('.image-upload-wrap').addClass('image-dropping');
      // });
      // $('.image-upload-wrap').bind('dragleave', function () {
      //   $('.image-upload-wrap').removeClass('image-dropping');
      // });
      if (this.props.userType === DMODAL_USERS.DRAYAGE_PARTNER) {
        getKxUser().then(function (res) {
          var partnerId = get(res, "data.eventMessage.userInfo.partnerId", null);
          _this3.setState({
            partnerId: partnerId
          });
        }).catch(function (err) {
          console.log(" getKxUser", err);
        });
      }
    }

    // Multisearch filter dropdown

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          getEntityTime = _props.getEntityTime,
          undoEntityEvent = _props.undoEntityEvent,
          accessType = _props.accessType,
          _state = this.state,
          pageNumber = _state.pageNumber,
          totalListEl = _state.totalListEl,
          indexRowClicked = _state.indexRowClicked,
          loading = _state.loading,
          isEnableSpacer = _state.isEnableSpacer,
          isApiTimeout = _state.isApiTimeout,
          searchText = _state.searchText,
          selectedFilter = _state.selectedFilter,
          containerData = _state.containerData,
          list = _state.list,
          selectedPort = _state.selectedPort,
          selectParameters = _state.selectParameters,
          containerChecked = _state.containerChecked,
          showModalForBulkCopy = _state.showModalForBulkCopy,
          isBulkUpdateActivate = _state.isBulkUpdateActivate,
          historyMode = _state.historyMode,
          multiFilterValues = _state.multiFilterValues,
          showContainerHistoryModal = _state.showContainerHistoryModal,
          modalOpen = _state.modalOpen;

      // console.log("hhhh", containerData.length)

      return React__default.createElement(
        Fragment,
        null,
        this.renderSearchHeader({ searchText: searchText, selectedFilter: selectedFilter }),
        totalListEl > 0 && containerData.length > 0 && React__default.createElement(Pagination$1, {
          pageNumber: pageNumber,
          entitiesCount: totalListEl,
          pageChangeHandler: this.nextContainer,
          onPageNumberChange: this.onPageNumberChange
        }),
        React__default.createElement(
          "div",
          { className: "outerWrapperContainerModal", "data-fieldname": "container" },
          React__default.createElement(
            "div",
            { className: "search-container-checkbox right labeled" },
            React__default.createElement(
              "div",
              { className: "containerFilterDropdown" },
              React__default.createElement(
                "h4",
                null,
                "Filter By"
              ),
              React__default.createElement(FilterDropdown, {
                filtersSubmitted: this.multiFiltersSubmitted,
                resetMultiFilters: this.resetMultiFilters,
                resetContainerChecked: this.resetContainerChecked,
                defaultCountryFilterValues: this.defaultFilterValues,
                resetMultiFilters2: this.state.resetMultiFilters2,
                setResetClicked2: function setResetClicked2(val) {
                  _this4.setState({ "resetMultiFilters2": val, pageNumber: 1 });
                },
                type: "drayage_multisearch_filter",
                userType: get(this.props, "userType", ""),
                etaAfterDate: this.props.etaAfterDate
              })
            ),
            React__default.createElement(
              "div",
              { className: "ContainerState" },
              React__default.createElement(
                "h4",
                null,
                "Container State"
              ),
              React__default.createElement(
                "div",
                { style: { display: "flex", alignItems: "center", marginTop: "5px" } },
                React__default.createElement(Dropdown, {
                  value: selectParameters,
                  onChange: function onChange(e, data) {
                    return _this4.setState({ selectParameters: data.value, loading: true, containerChecked: [], pageNumber: 1, indexRowClicked: -1 }, function () {
                      return _this4.getListOfContainers();
                    });
                  },
                  fluid: true,
                  search: true,
                  multiple: true,
                  selection: true,
                  options: window._env_.APP_NAME === "Partner" ? optionsForUpdateDrayage : optionsForUpdateOPS,
                  className: "ContainerStateDropdown"
                }),
                selectParameters !== "All" && React__default.createElement(
                  "a",
                  {
                    className: "resetState",
                    onClick: function onClick(e) {
                      return _this4.setState({ selectParameters: 'All', loading: true, containerChecked: [], pageNumber: 1, indexRowClicked: -1 }, function () {
                        return _this4.getListOfContainers();
                      });
                    }
                  },
                  "RESET"
                )
              )
            ),
            React__default.createElement(
              "div",
              { className: "ContainerSortby" },
              React__default.createElement(
                "h4",
                null,
                "Sort By"
              ),
              React__default.createElement(FilterDropdown, {
                filtersSubmitted: this.filtersSubmitted,
                resetFilters: this.resetFilters,
                filterValues: this.state.filterValues,
                resetClicked: this.state.resetClicked,
                setResetClicked: function setResetClicked(val) {
                  _this4.setState({ "resetClicked": val });
                },
                historyMode: historyMode,
                type: "container_app",
                userType: get(this.props, "userType", "")
              })
            ),
            React__default.createElement(
              "div",
              { style: { position: "relative", top: "10px", right: "100px" }, className: "ContainerBulkCopy" },
              React__default.createElement(
                Button,
                {
                  className: "bulkCopy",
                  onClick: function onClick() {
                    return _this4.setState({ showModalForBulkCopy: true });
                  }
                },
                "Bulk Copy"
              )
            )
          ),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "h4",
              {
                style: { textAlign: "end", marginRight: "20px" } },
              "Total Containers : ",
              containerData && containerData.length
            )
          ),
          showModalForBulkCopy && this.triggerBulkCopyModal(),
          this.state.viewDoFile && React__default.createElement(
            "div",
            { className: "modalHolder" },
            React__default.createElement(
              "div",
              { className: "modal-contentHolder modal-xl" },
              React__default.createElement(
                "div",
                { className: "modal-content", style: { "backgroundColor": "" + (this.state.successConfirmationScreen ? "#F0FAF1" : "#fff") } },
                this.renderDOFilesModal(),
                React__default.createElement(
                  "div",
                  { className: "custom-modal-footer justify-end" },
                  React__default.createElement(
                    Button,
                    { className: "button btn-confirm", onClick: this.getDocument },
                    "Download"
                  ),
                  React__default.createElement(
                    Button,
                    { className: "button", onClick: this.doCancellationButton },
                    "Cancel"
                  )
                )
              )
            )
          ),
          multiFilterValues.length > 0 && this.makeFilterdisplay(),
          this.state.showDragAndDropModal && (isDrayageContainer(get(this.state, "selectedContainerInfo.entityShipmentList", [])) ? React__default.createElement(UploadDocScreen, { accessType: accessType, containerInfo: this.state.selectedContainerInfo, showDragAndDropModal: this.toggleDragAndDropState, viewAttachment: this.state.viewAttachment, resetFilters: this.resetFilters, proofOfGateIn: this.state.proofOfGateInDocument, historyMode: historyMode, checkGateInMarked: this.computeData }) : this.triggerDragAndDrop(this.state.selectedContainerInfo)),
          React__default.createElement(
            "div",
            { className: "container-modal", id: "container-modal" },
            React__default.createElement(
              "h1",
              { className: "container_heading" },
              "Container Details"
            ),
            React__default.createElement(
              "h1",
              { className: "vessel_heading" },
              "VESSELS"
            ),
            React__default.createElement(
              "h1",
              { className: "port_heading" },
              "PORTS"
            ),
            (this.props.userType !== "CUSTOMER" && indexRowClicked !== -1 || this.props.userType === "CUSTOMER" && this.state.openSpecifiedContainerModal) && React__default.createElement(ContainerModal
            // undoEntityEvent={undoEntityEvent}
            , { selectedFilter: selectedFilter,
              selectedContainerInfo: selectedFilter === 'container' ? containerData[indexRowClicked] : selectedFilter === 'vessel' ? find(list, { unloc: selectedPort }) && find(list, { unloc: selectedPort }).containers[indexRowClicked] : find(list, { unloc: selectedPort }) && find(list, { unloc: selectedPort }).containers[indexRowClicked]
              // ^^ TODO: Might need change for port
              // isDrayageEnabled={getDrayAgeEnabled(containerData[indexRowClicked])}
              , rowHeaders: rowHeaders,
              convertEpochToDate: this.convertEpochToDate,
              getBrowserTimeZone: this.getBrowserTimeZone,
              convertUTCToTimezone: this.convertUTCToTimezone,
              getEntityTime: getEntityTime,
              getListOfContainers: this.getListOfContainers,
              handleParentState: this.handleState,
              closeContainerModal: this.closeContainerModal,
              indexRowClicked: indexRowClicked,
              getAccordianBody: this.getAccordianBody,
              containerChecked: containerChecked.length > 1 && containerChecked,
              isBulkUpdateActivate: isBulkUpdateActivate,
              triggerLoader: this.triggerLoader,
              userType: this.props.userType,
              containerList: this.getListOfContainers,
              getCommentPerContainer: this.props.getCommentPerContainer,
              getCommentHistoryPerContainer: this.props.getCommentHistoryPerContainer,
              showDragAndDropModal: this.toggleDragAndDropState,
              isArchived: containerData[indexRowClicked] && containerData[indexRowClicked].archived ? true : false,
              showContainerHistoryModal: showContainerHistoryModal,
              getContainerHistory: this.props.getContainerHistory,
              isContainerHistoryModalActive: function isContainerHistoryModalActive(value) {
                return _this4.setState({ showContainerHistoryModal: value });
              },
              loadContainerModal: this.state.loadContainerModal,
              accessType: accessType,
              openSpecifiedContainerModal: this.state.openSpecifiedContainerModal,
              closeContainerSpecifiedModal: this.closeContainerSpecifiedModal,
              isLoadingSpecifiedModal: this.state.isLoadingSpecifiedModal
              // isDray={(get(this.state, "selectedContainerInfo.drayagePartner",false) && this.state.selectedContainerInfo.drayagePartner !== "None") ? true : false }
              , isDray: isDrayageContainer(get(this.state, "selectedContainerInfo.entityShipmentList", [])),
              userInitialData: this.props.userInitialData
              // uploadFile={this.props.uploadFile}
              // markAsDone={(containerId)=> {
              //   let { state: { containerDoneState } } = this;
              //   containerDoneState[containerId] = true;
              //   this.setState({ containerDoneState });
              //   console.log("containerDoneState", containerDoneState, containerId)
              // }}
            }),
            loading ? this.renderLoader() : React__default.createElement(
              "div",
              null,
              selectedFilter === 'container' ? containerData.map(function (containerInfo, index) {
                return _this4.renderContainerTable({ containerInfo: containerInfo, index: index });
              }) : selectedFilter === 'vessel' ? this.renderVessels() : this.renderPorts()
            ),
            !loading && !isApiTimeout && selectedFilter === 'container' && containerData && containerData.length === 0 ? React__default.createElement(
              "div",
              { className: "error", style: { textAlign: "center", fontSize: "18px" } },
              "  No more container events to process, search to see existing containers "
            ) : null,
            !isEnableSpacer && React__default.createElement(
              "div",
              { style: { height: "50px" } },
              ' '
            ),
            !loading && isApiTimeout && containerData.length === 0 && React__default.createElement(
              "div",
              { style: { textAlign: "center", fontSize: "18px" } },
              "Search result has too many containers. Please, narrow the search criteria's."
            )
          )
        )
      );
    }
  }]);
  return ContainerTrackingApp;
}(Component);

var css_248z$m = ".main-header-holder {\n  height: 60px;\n  width: 1942px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  z-index: 1;\n  margin-left: -8px; }\n\n.left-items-header {\n  width: 25%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start; }\n\n.kleardray-btn {\n  color: #ffffff;\n  font-family: \"Open Sans\" !important;\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 19px;\n  box-sizing: border-box;\n  height: 38px;\n  width: 130px;\n  border: 1px solid #008b8f;\n  border-radius: 2px;\n  background-color: #267678;\n  margin-right: 80px;\n  padding-left: 15px;\n  padding-top: 10px;\n  margin-top: 10px; }\n\n.img-burger {\n  margin-top: 12px;\n  margin-left: 18px; }\n\n.img-logo {\n  margin-top: 10px;\n  margin-left: 20px;\n  margin-right: 20px;\n  width: 60px;\n  height: 40px;\n  padding-top: 10px;\n  padding-left: 10px; }\n\n.main-header-text {\n  height: 22px;\n  width: 219px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 22px;\n  margin-bottom: 18px;\n  margin-top: 20px;\n  margin-left: 100px; }\n\n.page-wrapper {\n  display: flex;\n  flex-direction: row;\n  width: 100%; }\n\n.leftSidePartnerCustomer {\n  display: flex;\n  flex-direction: column;\n  background-color: #f9f9f9;\n  margin-top: 58px; }\n\n.marketPlaceSalesAndPartner {\n  display: flex;\n  flex-direction: column;\n  background-color: #f9f9f9;\n  width: 100% !important; }\n\n.rightSide {\n  flex-grow: 1;\n  width: unset !important; }\n\n.partner-top-header {\n  height: 60px;\n  width: 870px;\n  background-color: #e5e5e5;\n  box-shadow: 0 1px 1px 0 rgba(187, 187, 187, 0.5);\n  margin-top: 2px; }\n\n.tab-btn {\n  height: 24px;\n  border: 1px solid #e7e7e7;\n  border-radius: 2px;\n  background-color: #ffffff;\n  color: #606060;\n  font-family: \"Open Sans\" !important;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 17px;\n  margin-right: -32px;\n  margin-top: 38px;\n  width: 90px !important;\n  text-align: center;\n  border: 1px solid #cccccc63;\n  border-left: 4px solid #ffffff;\n  border-right: 5px solid transparent;\n  padding-top: 3px;\n  clip-path: polygon(0 0, 92% 1%, 100% 100%, 0% 100%); }\n  .tab-btn.selected {\n    border-left: 4px solid #04adb1;\n    clip-path: polygon(0 0, 92% 1%, 100% 100%, 0% 100%);\n    background-color: #04adb1 !important;\n    height: 24px;\n    background-color: #04adb1 !important;\n    color: white; }\n\n.marketplace-wrapper {\n  flex-direction: row;\n  box-sizing: border-box;\n  background-color: #f9f9f9;\n  margin-left: 30px;\n  padding-right: 30px; }\n  .marketplace-wrapper .OpoortunityGroup {\n    border: 1px solid #DAD6D2;\n    margin: 2rem 0; }\n    .marketplace-wrapper .OpoortunityGroup .OpoortunityGroupTitle {\n      margin: 0rem 0;\n      display: flex;\n      width: 100%;\n      background: linear-gradient(0deg, #F6F5F4, #F6F5F4), linear-gradient(0deg, #EDEBE9, #EDEBE9), #FFFCFA;\n      height: 60px;\n      align-items: center;\n      justify-content: start;\n      padding: 1rem 2rem;\n      text-align: start;\n      text-transform: uppercase;\n      border-bottom: 1px solid #DAD6D2; }\n      .marketplace-wrapper .OpoortunityGroup .OpoortunityGroupTitle i {\n        cursor: pointer;\n        margin-right: 0.5rem;\n        color: #04adb1 !important; }\n    .marketplace-wrapper .OpoortunityGroup .customerOpportunitiesGroup {\n      padding: 0rem 2rem;\n      margin: 0;\n      background-color: white;\n      width: 100%;\n      min-width: 730px; }\n      .marketplace-wrapper .OpoortunityGroup .customerOpportunitiesGroup:first-of-type {\n        padding: 1rem 2rem; }\n      .marketplace-wrapper .OpoortunityGroup .customerOpportunitiesGroup:last-of-type {\n        padding: 0 2rem 1rem 2rem; }\n  .marketplace-wrapper .OpoortunityGroupClose .OpoortunityGroupTitle {\n    border: none; }\n  .marketplace-wrapper .customer-opportunity {\n    -webkit-animation: scale-in-ver-top 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n    animation: scale-in-ver-top 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both; }\n\n@-webkit-keyframes scale-in-ver-top {\n  0% {\n    -webkit-transform: scaleY(0);\n    transform: scaleY(0);\n    -webkit-transform-origin: 100% 0%;\n    transform-origin: 100% 0%;\n    opacity: 1; }\n  100% {\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n    -webkit-transform-origin: 100% 0%;\n    transform-origin: 100% 0%;\n    opacity: 1; } }\n\n@keyframes scale-in-ver-top {\n  0% {\n    -webkit-transform: scaleY(0);\n    transform: scaleY(0);\n    -webkit-transform-origin: 100% 0%;\n    transform-origin: 100% 0%;\n    opacity: 1; }\n  100% {\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n    -webkit-transform-origin: 100% 0%;\n    transform-origin: 100% 0%;\n    opacity: 1; } }\n  .marketplace-wrapper .marketplace-wrapper-opportunity-type {\n    margin: 2rem auto;\n    width: 100%;\n    text-align: start; }\n\n.sales_app .marketplace-wrapper-opportunity-type {\n  display: none; }\n\n.sales_app .OpoortunityGroup .customerOpportunitiesGroup {\n  margin: 0;\n  width: max-content;\n  min-width: unset;\n  padding: 1rem 2rem; }\n\n.marketplace-map-wrapper {\n  width: 100%; }\n\n.job-wrapper {\n  box-sizing: border-box;\n  height: 450px;\n  width: 741px;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  background-color: #f2f6fb;\n  box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5);\n  margin-left: 30px; }\n\n.party-name-wrapper {\n  height: 70px;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5);\n  margin-top: 10px;\n  min-width: max-content;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  background-color: white; }\n\n.opportunity-closed {\n  height: 60px;\n  width: 777px;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5);\n  margin-top: 10px;\n  min-width: max-content;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-evenly;\n  background-color: white; }\n\n.opportunity-opened {\n  height: 60px;\n  width: max-content;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5);\n  margin-top: 10px;\n  background-color: #e9edf3;\n  position: relative; }\n\n.sales_app [data-tab-container=\"SALES_PUBLISHED\"] .opportunity-opened {\n  width: auto; }\n\n.opportunity-opened {\n  width: 100%; }\n\n.cust-sec {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  background-color: #f9f9f9;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-left: 29px;\n  margin-bottom: -10px;\n  margin-left: -4px;\n  margin-top: 5px; }\n\n.cust-sec-active-lanes {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n\n.cust-sec-show-active-only {\n  padding-top: 25px; }\n\n.cust-text {\n  color: #969696 !important; }\n\n.oppor-name-text {\n  height: 28px;\n  width: 515px !important;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 20px !important;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 28px;\n  margin-top: -30px; }\n\n.cust-text-name {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 24px;\n  padding-left: 5px; }\n\n.partyName-date {\n  display: flex;\n  flex-direction: column;\n  font-family: \"Open Sans\";\n  margin-left: -225px;\n  float: left;\n  margin-left: 56px; }\n\n.sales_app .partyName-date {\n  flex-grow: 1; }\n\n.sales_app .expandHorizontally {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .sales_app .expandHorizontally img {\n    margin: 0; }\n\n.sales_app .opportunity_wrapper {\n  min-width: fit-content; }\n\n.sales_app [data-tab=\"OPPORTUNITIES_LIST_OPENED\"] {\n  min-width: 100% !important; }\n\n.sales_app .publishBtn, .sales_app .renewBtn {\n  height: 100%;\n  width: fit-content;\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  line-height: 19px; }\n  .sales_app .publishBtn button, .sales_app .renewBtn button {\n    color: #0a8b8f;\n    background-color: #FFFFFF;\n    border: 3px solid #0a8b8f;\n    border-radius: 3px; }\n    .sales_app .publishBtn button:disabled, .sales_app .renewBtn button:disabled {\n      cursor: not-allowed; }\n\n.sales_app .renewBtn {\n  margin: 0 0 -1rem 0.2rem; }\n\n.date-pair {\n  display: flex;\n  color: #267678;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 13px;\n  font-weight: bold;\n  padding: 2px;\n  margin-right: 10px; }\n  .date-pair .renewal-date {\n    color: #de0f0f; }\n  .date-pair .new-color {\n    color: #474747; }\n\n.data-header {\n  display: flex;\n  height: 52px;\n  background-color: #f2f6fb;\n  margin-left: 38px;\n  margin-bottom: 2px;\n  padding-right: 10px; }\n  .data-header > div {\n    width: 100px;\n    float: left; }\n\n.data-row > div {\n  float: left; }\n\n.data-row {\n  display: flex;\n  flex-direction: row;\n  height: 52px;\n  box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5);\n  margin-left: 38px;\n  margin-bottom: 2px;\n  margin-top: 5px;\n  padding-right: 10px; }\n\n.data-header-first {\n  flex-grow: 1; }\n\n.data-header-first-total {\n  flex-grow: 1;\n  font-size: 16px; }\n\n.data-header-others {\n  width: 120px;\n  text-align: right;\n  padding-right: 10px; }\n\n.data-header-lower {\n  color: #6c6d6e;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0;\n  line-height: 14px;\n  padding-bottom: 10px;\n  text-align: center; }\n\n.small-text {\n  color: #6c6d6e;\n  font-family: \"Open Sans\";\n  font-size: 10px;\n  letter-spacing: 0; }\n\n.sec-col-header-text {\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 17px;\n  margin-top: 10px;\n  color: black;\n  margin-left: 2px;\n  text-align: center;\n  color: #000000; }\n\n.sec-col-header-text-bid {\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0;\n  margin-top: 10px;\n  color: black;\n  margin-left: 2px;\n  text-align: right; }\n\n.third-col-header-text {\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0;\n  margin-right: 10px;\n  margin-top: 10px;\n  color: black;\n  background-color: #222; }\n\n.fourth-col-header-text {\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0;\n  margin-left: 90px;\n  margin-right: 10px;\n  margin-top: 10px;\n  color: black; }\n\n.fifth-col-header-text {\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0;\n  margin-left: 100px;\n  margin-right: 10px;\n  margin-top: 10px;\n  color: black; }\n\n.lower {\n  color: #6c6d6e;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0;\n  line-height: 17px;\n  padding-bottom: 10px;\n  text-align: center; }\n\n.data-wrapper {\n  opacity: 0.8px;\n  border-radius: 2px;\n  background-color: #ffffff;\n  margin-left: 38px;\n  margin-bottom: 2px;\n  height: 50px;\n  width: 900px !important;\n  opacity: 0.8;\n  border-radius: 2px;\n  background-color: #ffffff;\n  clear: left; }\n  .data-wrapper > div {\n    float: left; }\n\n.data-wrapper-bid {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  opacity: 0.8px;\n  border-radius: 2px;\n  background-color: #ffffff;\n  margin-left: 35px;\n  margin-bottom: 2px;\n  padding-top: 10px;\n  height: 50px;\n  width: 939px;\n  opacity: 0.8;\n  border-radius: 2px;\n  background-color: #eaeaea;\n  margin-bottom: 6px;\n  background-color: #d8dfe8;\n  text-align: right; }\n\n.party-name {\n  height: 28px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0;\n  padding-left: 15px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.party-name-bid {\n  height: 28px;\n  width: 256px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 28px; }\n\n.customer-party-name-bid {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 22px;\n  font-weight: bold;\n  letter-spacing: 0;\n  width: 400px; }\n\n.down {\n  margin-top: 16px;\n  color: black; }\n\n.left {\n  margin-left: 20px; }\n\n.portName-text {\n  color: #1158ba;\n  font-family: \"Roboto\", \"Open Sans\";\n  font-size: 18px;\n  line-height: 21px;\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.portName-text-bid {\n  font-size: 16px;\n  font-weight: bold;\n  font-family: \"Open Sans\";\n  padding-left: 10px;\n  text-align: left; }\n\n.simple-text {\n  height: 13px;\n  width: 156px;\n  color: #0a53b8;\n  font-family: Roboto;\n  font-size: 11px;\n  letter-spacing: 0;\n  line-height: 13px;\n  margin-left: 38px;\n  margin-top: 20px; }\n\n.action-btn {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  clear: left; }\n\n.bid-btn {\n  height: 40px;\n  width: 160px;\n  border: 1px solid #0a53b8;\n  border-radius: 2px;\n  background-color: #0a53b8;\n  color: white;\n  color: #ffffff;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 19px;\n  text-align: center;\n  margin-left: 33px;\n  margin-top: 10px; }\n\n.decline-btn {\n  height: 40px;\n  width: 160px;\n  border: 1px solid #0a53b8;\n  border-radius: 2px;\n  background-color: #ffffff;\n  text-align: center;\n  color: #0a53b8;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 19px;\n  margin-left: 10px;\n  margin-top: 10px; }\n\n.arrow-img {\n  width: 16px;\n  height: 16px;\n  background-color: #04adb1;\n  border-radius: 50%;\n  margin-top: 10px;\n  padding: 2px;\n  margin-left: -35px; }\n\n.collapsible {\n  cursor: pointer;\n  padding: 2px;\n  border: none;\n  text-align: left;\n  outline: none; }\n\n.data-other-col {\n  width: 110px;\n  text-align: right !important;\n  font-size: 18px; }\n\n.data-light-green {\n  background-color: #f1fff3; }\n\n.data-solid-green {\n  background-color: #c7edbe; }\n\n.data-light-red {\n  background-color: #faeded;\n  margin-right: -10px; }\n\n.data-solid-red {\n  background-color: #edc7be; }\n\n.data-solid-gray {\n  background-color: #eeeeee; }\n\n.data-other-col-blue {\n  background-color: #1158ba; }\n\n.data-other-col-lightblue {\n  background-color: #04ADB1; }\n\n.sec-col {\n  width: 100px;\n  text-align: right !important; }\n\n.third-col {\n  width: 100px;\n  text-align: right; }\n\n.fourth-col {\n  width: 100px;\n  text-align: left;\n  margin-right: 15px; }\n  .fourth-col .sales_app .fourth-col {\n    margin-right: 15px; }\n\n.bid-col-one {\n  width: 32%; }\n\n.bid-col-two {\n  width: 13%; }\n\n.bid-col-third {\n  width: 13%; }\n\n.bid-col-fourth {\n  width: 13%; }\n\n.port-content-open {\n  padding: 0 18px;\n  display: block;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  background-color: #f2f6fb;\n  box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5); }\n\n.hideExtraBids:not(.sales_app) .data-row .partner-total-footer:nth-child(5) {\n  margin-right: 0 !important; }\n\n.sales_app [data-tab-container]:not([data-tab-container=\"SALES_PUBLISHED\"]) .data-other-col:nth-child(4) {\n  margin-right: 15px; }\n\n.sales_app .grand-action {\n  height: 62px !important; }\n\n.sales_app .data-row .partner-total-footer {\n  margin-right: 23px; }\n\n.showExtraBids .data-row {\n  padding-right: 0; }\n\n.showExtraBids .bid-col:last-child {\n  margin-right: 0; }\n\n.showExtraBids .data-header .partner-total-footer:last-child {\n  margin-right: 0; }\n\n.showExtraBids .data-row .partner-total-footer:last-child {\n  margin-right: 0; }\n\n.showExtraBids .grand-total-wrapper .partner-total-footer:last-child {\n  margin-right: 23px; }\n\n.showExtraBids .data-header {\n  padding-right: 0;\n  width: fit-content;\n  margin-left: auto; }\n\n.showExtraBids .port-content-open {\n  padding-right: 23px; }\n\n.showExtraBids .bid-per-container {\n  margin-left: 23px; }\n\n.bid-per-container:nth-child(5) {\n  margin-left: 15px; }\n\n.content-closed {\n  padding: 0 18px;\n  display: none;\n  overflow: hidden; }\n\n.mid-sec {\n  display: flex;\n  flex-direction: column;\n  margin-left: 50px;\n  position: relative;\n  margin-top: 10px; }\n\n.very-small-text {\n  height: 10px;\n  width: 163px;\n  color: #818181;\n  font-family: \"Open Sans\";\n  font-size: 11px;\n  letter-spacing: 0;\n  line-height: 13px;\n  margin-top: 2px;\n  margin-bottom: 3px; }\n\n.anchor-img {\n  float: left;\n  border-radius: 55%;\n  margin-left: -37px;\n  padding: 2px;\n  margin-top: 3px;\n  width: 20px; }\n\n.warehouse-img {\n  float: left;\n  border-radius: 55%;\n  margin-left: -37px;\n  padding: 2px;\n  margin-top: 1px;\n  width: 20px; }\n\n.Modal {\n  height: 1028px;\n  width: 815px;\n  border-radius: 13px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5);\n  margin-left: 513px;\n  margin-top: 156px;\n  overflow: auto; }\n\n.partner-Modal {\n  width: 815px;\n  border-radius: 13px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5);\n  margin-top: 156px;\n  overflow: auto; }\n\n.modal-first {\n  height: 933px;\n  width: 1043px;\n  border-radius: 12px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5);\n  margin-left: 490px;\n  margin-top: 75px;\n  overflow: auto; }\n\n.cont-num {\n  color: #696969;\n  margin-top: 17px;\n  font-size: 18px;\n  text-align: center;\n  padding-top: 1px;\n  padding-right: 10px; }\n\n.cont-num-2 {\n  color: #696969;\n  margin-top: 17px;\n  font-size: 18px;\n  text-align: center;\n  padding-top: 1px;\n  padding-right: 10px;\n  margin-left: 150px; }\n\n.cont-num-renewal-date {\n  color: #696969;\n  padding-top: 20px;\n  font-size: 14px;\n  text-align: right;\n  font-weight: bold;\n  font-family: \"Open Sans\"; }\n\n.price-2 {\n  margin-top: 10px;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  padding-right: 10px;\n  margin-left: 120px;\n  color: #696969;\n  padding-top: 7px; }\n\n.price {\n  margin-top: 10px;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  padding-right: 10px;\n  margin-left: 20px;\n  color: #696969;\n  padding-top: 7px; }\n\n.price-total {\n  margin-top: 11px;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  color: black;\n  font-weight: bold;\n  padding-left: 6px;\n  padding-top: 6px;\n  padding-right: 10px; }\n\n.price-total-white {\n  margin-top: 11px;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  color: white;\n  font-weight: bold;\n  padding-left: 6px;\n  padding-top: 6px; }\n\n.indiv-total-wrapper {\n  margin-top: 10px;\n  margin-bottom: 20px;\n  width: max-content; }\n  .indiv-total-wrapper div:nth-child(4) {\n    margin-right: 20px; }\n  .indiv-total-wrapper > div {\n    float: left;\n    height: 43px; }\n\n.indiv-total {\n  margin-left: 320px;\n  color: #bababa;\n  font-family: \"Open Sans\";\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n  font-weight: 500;\n  text-align: right; }\n\n.indiv-total-wrapper-bid {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n  width: 930px;\n  margin-left: -30px; }\n\n.total-cont {\n  margin-top: -1px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: right;\n  width: 12%;\n  margin-top: -1px;\n  font-size: 18px;\n  font-weight: bold;\n  width: 100px;\n  text-align: right; }\n\n.total-price {\n  margin-left: 160px;\n  font-size: 18px;\n  font-weight: 500; }\n\n.total-indiv-sum {\n  padding-left: 155px;\n  font-weight: bold;\n  font-size: 18px;\n  padding-right: 10px;\n  width: 100px;\n  text-align: right; }\n\n.grand-total-wrapper {\n  margin-top: 6px;\n  margin-bottom: 7px;\n  display: flex; }\n  .grand-total-wrapper > div {\n    float: left;\n    height: 38px; }\n\n.grand-action {\n  box-sizing: border-box;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  background-color: #e9edf3;\n  box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5);\n  height: 117px;\n  min-width: max-content;\n  width: 100%;\n  padding-right: 18px; }\n  .grand-action .data-other-col .price-total {\n    font-size: 24px; }\n  .grand-action .data-other-col .cont-num {\n    font-size: 24px !important; }\n  .grand-action .partner-total-footer {\n    font-size: 24px !important; }\n\n.grand-total {\n  color: black;\n  font-family: \"Open Sans\";\n  font-size: 18px;\n  font-weight: 900;\n  letter-spacing: 0;\n  line-height: 21px;\n  margin-top: 2px;\n  width: 293px;\n  text-align: right;\n  margin-left: 23px;\n  flex-grow: 1; }\n\n.sales_app .grand-total {\n  width: auto;\n  flex-grow: 1; }\n\n.grand-cont {\n  font-size: 22px;\n  margin-top: -2px;\n  font-weight: 900;\n  width: 100px;\n  text-align: right;\n  margin-right: 290px; }\n\n.grand-price {\n  font-size: 22px;\n  margin-top: -2px;\n  font-weight: 900;\n  width: 100px;\n  text-align: right; }\n\n.Overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.Overlay-bid {\n  position: relative;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.m-layout {\n  box-sizing: border-box;\n  width: 741px;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  background-color: #ffffff;\n  margin-top: 40px;\n  margin-left: 40px;\n  width: 983px;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  background-color: #ffffff;\n  overflow: auto; }\n\n.bid-header {\n  height: 157px;\n  display: flex;\n  flex-direction: row; }\n\n.customer-bid-modal-header {\n  display: flex;\n  flex-direction: row;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.bid-data-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 942px;\n  height: 60px;\n  padding-left: 38px;\n  margin-bottom: 2px;\n  padding-bottom: 10px; }\n\n.bid-left-header {\n  display: flex;\n  flex-direction: column; }\n\n.bid-left-header -indiv {\n  width: 40%; }\n\n.img-close {\n  width: 25px;\n  margin-left: 230px;\n  margin-bottom: 70px; }\n\n.icon-text {\n  display: flex;\n  flex-direction: column; }\n\n.img-bidIcon {\n  margin-left: 375px;\n  margin-bottom: 10px;\n  margin-top: -43px;\n  border-top: 2px solid white; }\n\n.bid-text {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 27px;\n  margin-left: 309px; }\n\n.bid-text-modal {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 27px;\n  margin-left: 320px;\n  padding-top: 10px;\n  width: 300px; }\n\n.bid-submit {\n  height: 50px;\n  width: 163px;\n  opacity: 0.53;\n  border-radius: 3px;\n  background-color: #008b8f;\n  margin-top: 20px;\n  color: white;\n  text-align: center;\n  margin-left: 400px;\n  border: 1px solid #008b8f;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  line-height: 17px; }\n\n.bid-cancel {\n  height: 50px;\n  width: 133px;\n  margin-left: 10px;\n  border: 1px solid #008b8f;\n  color: #008b8f;\n  background-color: white;\n  font-size: 16px;\n  line-height: 17px;\n  border-radius: 3px; }\n\n.bid-body-header {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 1px;\n  width: 982px;\n  font-size: 12px;\n  font-family: \"Open Sans\";\n  border-top: 1px solid black;\n  margin-left: 5px; }\n\n.bid-port-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n\n.bid-dest {\n  width: 36%;\n  margin-top: 10px;\n  padding-left: 44px; }\n\n.approx-bid {\n  width: 13%;\n  text-align: right; }\n\n.approx-bid-two {\n  width: 13%; }\n\n.approx-bid-three {\n  padding-top: 10px;\n  width: 12%;\n  text-align: right; }\n\n.approx-bid-five {\n  width: 13%;\n  padding-top: 10px;\n  text-align: right; }\n\n.bid-suggest {\n  width: 13%;\n  margin-bottom: 20px;\n  margin-left: 20px;\n  font-family: \"Open Sans\";\n  text-align: left; }\n\n.bid-best {\n  font-family: \"Open Sans\";\n  padding-right: 30px; }\n\n.bid-best-your {\n  padding-top: 9px;\n  width: 12%;\n  padding-right: 7px;\n  text-align: right; }\n\n.more-left {\n  margin-left: -5px; }\n\n.bid-price-holder {\n  border-radius: 2px;\n  background-color: #dadada;\n  height: 50px;\n  width: 12.5%;\n  margin-top: -10px;\n  padding-right: 20px; }\n\n.bid-price {\n  box-sizing: border-box;\n  height: 26px;\n  width: 94px;\n  border: 1px solid #0a53b8;\n  border-radius: 2px;\n  background-color: white !important;\n  padding-right: 10px;\n  margin-top: 13px;\n  padding-left: 10px;\n  z-index: 100;\n  color: #0a53b8;\n  font-weight: bold;\n  font-size: 16px;\n  margin-left: 15px; }\n\n.bid-cont-num {\n  text-align: right;\n  margin-top: 6px;\n  font-size: 18px;\n  font-weight: bold; }\n\n.bidIcon {\n  margin-left: 150px; }\n\n.bid-sec-col {\n  width: 13%;\n  font-size: 18px;\n  margin-top: 20px; }\n\n.bid-item-price {\n  width: 13%;\n  text-align: right;\n  font-size: 18px;\n  margin-top: 6px;\n  padding-left: 68px;\n  font-weight: bold; }\n\n.sec-col-header-bid-text {\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0;\n  line-height: 17px;\n  margin-top: 10px;\n  color: black; }\n\n.modal-bid {\n  height: 823px;\n  width: 815px;\n  border-radius: 13px;\n  margin-left: 500px !important; }\n\n.right {\n  margin-left: -80px; }\n\n.line-drayage {\n  height: 2px;\n  width: 62px;\n  border: 1px solid #4ba3e3;\n  background-color: #4ba3e3;\n  margin-top: 48px;\n  margin-right: 31px;\n  margin-left: 33px; }\n\n.laneBidChargesContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  justify-content: center; }\n\n.bidcard-wrapper {\n  box-sizing: border-box;\n  height: 578px;\n  width: 741px;\n  border: 1px solid #dcdcdc;\n  border-radius: 0 0 3px 3px;\n  background-color: #ffffff; }\n\n.bidcard-header {\n  box-sizing: border-box;\n  height: 87px;\n  width: 741px;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px 3px 0 0;\n  background-color: #eeeeee;\n  display: flex;\n  flex-direction: row; }\n\n.internal {\n  width: 741px;\n  height: 380px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n\n.internal-box {\n  height: 141px;\n  width: 501px;\n  margin-left: 123.5px;\n  margin-right: 127.5px;\n  margin-top: 40px;\n  margin-bottom: 110px; }\n\n.fees-fuel {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start; }\n\n.general-col {\n  display: flex;\n  flex-direction: column; }\n\n.general-row {\n  display: flex;\n  flex-direction: row;\n  justify-self: flex-start; }\n\n#general-row {\n  justify-content: space-evenly; }\n\n#general-row-button {\n  justify-content: center; }\n\n.general-centered {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  flex-direction: row;\n  justify-self: center;\n  align-items: center;\n  margin: 10px 250px; }\n  .general-centered .secondaryButton {\n    margin: 3px !important; }\n\n.base-fees {\n  height: 49px;\n  width: 201px;\n  border: 1px solid #1765ae;\n  border-radius: 2px 0 0 0;\n  background-color: #ffffff;\n  border-right: none;\n  color: #606060; }\n\n.faded-text {\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 17px;\n  margin-top: 5px;\n  margin-left: 20px; }\n\n.chasis {\n  display: flex;\n  flex-direction: row; }\n\n.chasis-rental {\n  margin-left: 20px;\n  width: 50%; }\n\n.total-num {\n  margin-left: 60px; }\n\n.radio {\n  margin-top: -1rem; }\n\n.input-box {\n  width: 70px;\n  margin-bottom: 10px;\n  margin-left: 20px;\n  border: none; }\n\ninput.input-box:focus {\n  background: lightcyan;\n  border: none; }\n\n.note-text {\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 1.14px;\n  line-height: 19px;\n  margin-left: 20px;\n  font-family: \"Open Sans\";\n  background-color: lightcyan; }\n\n.percent-fuel {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 21px;\n  font-weight: 500;\n  letter-spacing: 1.71px;\n  line-height: 28px;\n  margin-left: 20px;\n  padding-bottom: 10px;\n  display: flex;\n  flex-direction: row; }\n\n.yes-no {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 21px;\n  font-weight: 500;\n  letter-spacing: 1.71px;\n  line-height: 28px;\n  padding-left: 7px;\n  padding-right: 15px;\n  margin-bottom: 10px; }\n\n.yes-no-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap; }\n\n.fuel-inclusion {\n  height: 49px;\n  width: 304px;\n  border: 1px solid #1765ae;\n  border-radius: 0 2px 0 0;\n  background-color: #ffffff; }\n\n.fuel-charges {\n  height: 49px;\n  width: 501px;\n  border: 1px solid #1765ae;\n  background-color: #ffffff; }\n\n.best-cont {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-top: 150px; }\n\n.best-box {\n  height: 53px;\n  width: 377px;\n  opacity: 0.8;\n  border-radius: 2px 0 0 2px;\n  background-color: #090707;\n  color: white;\n  margin-left: 30px;\n  clip-path: polygon(0 0, 99% 0, 85% 100%, 0% 100%);\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-align: left;\n  padding-left: 20px;\n  padding-top: 10px; }\n\n.best-box-grand {\n  height: 53px;\n  width: 377px;\n  opacity: 0.8;\n  border-radius: 2px 0 0 2px;\n  background-color: #090707;\n  color: white;\n  margin-left: 30px;\n  clip-path: polygon(0 0, 99% 0, 85% 100%, 0% 100%);\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-align: left;\n  padding-left: 20px;\n  padding-top: 10px; }\n\n.additional {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 27px;\n  margin-left: 120px;\n  padding-top: 20px; }\n\n.btn-add-bid {\n  height: 26px;\n  width: 68px;\n  border: 1px solid #0a53b8;\n  border-radius: 2px;\n  background-color: #ffffff;\n  color: #0a53b8;\n  margin-left: 120px;\n  margin-bottom: 70px;\n  margin-top: 30px; }\n\n.cont-bid-box {\n  height: 53px;\n  border-radius: 2px;\n  background-color: #d9efff;\n  margin-right: 20px;\n  margin-left: -50px;\n  padding-left: 200px;\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row;\n  height: 53px;\n  width: 710px;\n  border-radius: 2px;\n  background-color: #d9efff; }\n\n.total-per-bid {\n  font-size: 30px;\n  font-weight: bold;\n  line-height: 35px; }\n\n.total-holder {\n  width: 123px;\n  margin-top: -8px;\n  border-radius: 2px;\n  background-color: #1158ba; }\n\n.total-price-bid {\n  font-weight: bold;\n  padding-right: 50px;\n  font-size: 18px;\n  padding-top: 15px;\n  padding-left: 20px; }\n\n.per-cont {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 14px;\n  padding-top: 25px; }\n\n.btn-done {\n  height: 50px;\n  width: 163px;\n  border-radius: 3px;\n  background-color: #008b8f;\n  color: white;\n  margin-left: 30px;\n  border: none;\n  margin-top: 30px;\n  margin-right: 20px;\n  font-size: 14px; }\n\n.cancel-btn {\n  margin-top: 30px;\n  height: 50px;\n  width: 163px;\n  border: 1px solid #008b8f;\n  color: #008b8f;\n  background-color: white;\n  font-size: 14px;\n  margin-bottom: 10px; }\n\n.add-head-text {\n  margin-top: 10px;\n  margin-left: 20px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 27px;\n  margin-bottom: 10px; }\n\n.line-add {\n  width: 691px;\n  border: 0.5px solid #d4d4d4;\n  margin-left: 12px;\n  margin-top: 1px; }\n\n.table-box {\n  height: 322px;\n  border: 1px solid #d4d4d4; }\n\n.add-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-left: 22px;\n  height: 30px;\n  width: 691px;\n  margin-top: 8px;\n  margin-bottom: 5px; }\n\n.title-one {\n  width: 30% !important;\n  display: flex; }\n\n.select {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 19px;\n  margin-left: 4px;\n  margin-right: 10px;\n  color: #000000; }\n\n.title-two {\n  width: 35%;\n  margin-left: 25px;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0; }\n\n.title-three {\n  margin-right: 70px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 19px;\n  width: 18%; }\n\n.title-four {\n  width: 20%;\n  font-family: \"Open Sans\";\n  font-size: 14px !important;\n  font-weight: bold;\n  letter-spacing: 0;\n  padding-left: 35px; }\n\n.per-day-box {\n  height: 21px;\n  width: 99px;\n  background-color: #ffffff;\n  margin-top: 5px;\n  padding-left: 3px;\n  font-size: 12px;\n  font-weight: normal;\n  display: flex;\n  align-items: center; }\n\n.input-box-small {\n  height: 19px;\n  width: 38px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 1.14px;\n  line-height: 19px;\n  text-align: center;\n  margin-left: 20px;\n  margin-top: 5px;\n  border: 1px solid #008b8f;\n  border-radius: 2px;\n  cursor: pointer; }\n\ninput.input-box-small:focus {\n  background: lightcyan;\n  border: none; }\n\n.add-header-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-left: 22px;\n  height: 30px;\n  width: 691px; }\n\n.first {\n  margin-left: 10px; }\n\n.first-box {\n  width: 30% !important;\n  margin-top: 5px;\n  display: flex; }\n\n.second {\n  width: 35%; }\n\n.third {\n  width: 15%;\n  margin-right: 40px; }\n\n.fourth {\n  width: 12%;\n  border: 1px solid #008b8f;\n  margin-right: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.best-box-add {\n  height: 53px;\n  width: 750px !important;\n  opacity: 0.8;\n  border-radius: 2px 0 0 2px;\n  background-color: #090707;\n  color: white;\n  margin-left: 25px;\n  clip-path: polygon(0 0, 99% 0, 85% 100%, 0% 100%);\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-align: left;\n  padding-left: 20px;\n  padding-top: 10px; }\n\n.line-two {\n  width: 695px;\n  border: 1px solid #2f2f2f;\n  margin-left: 12px; }\n\n.add-additional {\n  color: #0a53b8;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 19px;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  margin-left: 25px; }\n\n.pot-add {\n  height: 50px;\n  width: 930px;\n  opacity: 0.8;\n  border-radius: 2px;\n  background-color: #eaeaea;\n  background-color: #e0e5ec;\n  margin-left: 36px;\n  margin-top: 20px;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px; }\n\n.add {\n  margin-left: 410px;\n  margin-top: 12px;\n  text-align: center; }\n\n.pot-text {\n  color: #000000;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n  font-family: \"Open Sans\";\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 21px;\n  margin-left: 10px;\n  margin-top: 15px;\n  letter-spacing: 0; }\n\n.grand-total-bid-holder {\n  height: 53px;\n  width: 983px;\n  border-radius: 2px;\n  background-color: #d9efff;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-left: 37px;\n  margin-top: 20px; }\n\n.grand-total-bid {\n  height: 47px;\n  width: 219px;\n  opacity: 0.8;\n  border-radius: 2px 0 0 2px;\n  background-color: #717171;\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  padding-left: 50px;\n  padding-top: 8px;\n  clip-path: polygon(0 0, 99% 0, 85% 100%, 0% 100%); }\n\n.number-one {\n  color: #000000;\n  font-size: 30px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 35px;\n  margin-right: 100px;\n  margin-top: 10px; }\n\n.number-two {\n  color: #000000;\n  font-size: 30px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 35px;\n  margin-right: 70px;\n  margin-top: 10px; }\n\n.number-three {\n  color: #000000;\n  font-size: 30px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 35px;\n  margin-right: 40px;\n  margin-top: 10px; }\n\n.charges-text {\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 17px;\n  width: 72%; }\n\n.warehouse {\n  background-color: lightskyblue;\n  margin-left: -20px; }\n\n.lfc {\n  height: 27px;\n  width: 519px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: row;\n  margin-top: -30px;\n  flex-wrap: wrap; }\n\n.name-text {\n  height: 17px;\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 17px;\n  margin-left: 5px;\n  margin-top: 6px; }\n\n.small-input {\n  width: 25px;\n  height: 15px;\n  border: teal;\n  margin-top: 5px;\n  margin-left: 6px;\n  cursor: pointer;\n  background-color: lightcyan; }\n\n.lfc-holder {\n  width: 20%;\n  display: flex;\n  flex-direction: row; }\n\n.drop-holder {\n  width: 30%;\n  display: flex;\n  flex-direction: row; }\n\n.warehouse-holder {\n  width: 50%;\n  display: flex;\n  flex-direction: row; }\n\n.pot-add-box {\n  box-sizing: border-box;\n  height: 49px;\n  width: 504px;\n  border: 1px solid #1765ae;\n  border-radius: 2px;\n  background-color: #ffffff;\n  margin-left: 120px;\n  overflow: auto;\n  margin-top: 17px; }\n\n.light-text {\n  height: 17px;\n  width: 167px;\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 17px; }\n\n.pot-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around; }\n\n.first-head {\n  width: 10%;\n  height: 17px;\n  width: 140px;\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 17px;\n  margin-top: 8px; }\n\n.sec-head {\n  width: 25%;\n  height: 17px;\n  width: 120px;\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 17px;\n  margin-top: 8px; }\n\n.third-head {\n  width: 25%;\n  height: 17px;\n  width: 140px;\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 17px;\n  margin-top: 8px; }\n\n.btn-submit {\n  height: 50px;\n  width: 163px;\n  opacity: 0.73;\n  border-radius: 3px;\n  background-color: #008b8f;\n  color: white;\n  margin-left: 400px;\n  border: 1px solid #008b8f;\n  color: white;\n  margin-right: 15px;\n  font-family: \"Open Sans\";\n  margin-bottom: 10px; }\n\n.checker {\n  border: 1px solid #008b8f;\n  width: 10px; }\n\n.text-charge {\n  font-weight: bold; }\n\n.text-confirm {\n  height: 12px;\n  width: 385px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 40px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 12px;\n  margin-top: 20px;\n  margin-left: 120px; }\n\n.email-text {\n  height: 22px;\n  width: 355px;\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 22px;\n  margin-bottom: 15px;\n  margin-top: 30px;\n  margin-left: 32px; }\n\n.contents {\n  text-align: center; }\n\n.checkbox-container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0; }\n\n/* Create a custom checkbox */\n.checkmark {\n  position: absolute;\n  top: 5px;\n  left: 0px;\n  height: 13px;\n  width: 14px;\n  background-color: white;\n  border: 1px solid #04adb1; }\n\n.text-success-bid {\n  height: 12px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 30px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 12px;\n  margin-bottom: 30px;\n  margin-top: 20px; }\n\n.email-success {\n  height: 22px;\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 22px; }\n\n/* Fixes for making market place work for all apps */\n.marketplace-wrapper {\n  height: calc(100vh - 119px) !important;\n  overflow-y: auto !important; }\n  .marketplace-wrapper > div {\n    width: 100%; }\n\n.partner-top-header {\n  width: calc(100% + 50px); }\n  .partner-top-header .marketplaceTabHeaderContainer {\n    margin-left: 28px;\n    padding: 20px 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between; }\n    .partner-top-header .marketplaceTabHeaderContainer .title-header {\n      color: \"#000\";\n      font-size: 22px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 34px; }\n    .partner-top-header .marketplaceTabHeaderContainer .marketplace-country-dropdown {\n      width: 150px;\n      height: 48px;\n      border-radius: 4px;\n      border: \"1px solid #7A7A7A\";\n      background-color: #FFF;\n      padding: 4px 12px; }\n\n[data-tab-container=\"OPPORTUNITIES_LIST_CLOSED\"],\n[data-tab-container=\"OPPORTUNITIES_LIST_OPENED\"] {\n  margin-left: 26px;\n  width: calc(100% - 49px); }\n\n.sales_app [data-tab-container=\"OPPORTUNITIES_LIST_CLOSED\"],\n.sales_app [data-tab-container=\"OPPORTUNITIES_LIST_OPENED\"] {\n  width: auto; }\n\n.content-open {\n  min-width: max-content;\n  width: 100%; }\n\nbutton.tab-btn {\n  width: auto !important; }\n\n.bid-col {\n  height: 48px;\n  color: #0a53b8;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 21px;\n  margin-right: 23px;\n  text-align: center;\n  font-weight: bold;\n  width: auto !important;\n  position: relative; }\n\n.partner-bid {\n  width: 113px;\n  border: 1px solid #eeeeee;\n  border-radius: 2px 0 0 2px;\n  background-color: #ffffff;\n  box-shadow: 1px 1px 1px 0 rgba(165, 163, 163, 0.5);\n  padding-top: 2px;\n  display: inline-block;\n  height: 48px;\n  line-height: 46px;\n  position: relative; }\n\n.partner-bid-total {\n  overflow-x: scroll;\n  position: relative;\n  width: 113px;\n  border-left: 1px solid #eeeeee;\n  display: inline-flex;\n  box-sizing: border-box;\n  border: 1px solid #eeeeee;\n  border-radius: 0 2px 2px 0;\n  background-color: #ffffff;\n  box-shadow: 1px 1px 1px 0 rgba(165, 163, 163, 0.5);\n  padding-top: 3px;\n  height: 48px;\n  line-height: 39px; }\n  .partner-bid-total .icon {\n    position: absolute;\n    top: 4px;\n    right: 0px; }\n\n.partner-bid-total::-webkit-scrollbar {\n  display: none; }\n\n.source-port {\n  width: 300px !important; }\n\n.sales_app [data-tab-container=\"SALES_PENDING_APPROVAL\"] .marketplace-wrapper,\n.sales_app [data-tab-container=\"SALES_ACCEPTED\"] .marketplace-wrapper,\n.sales_app [data-tab-container=\"SALES_REJECTED\"] .marketplace-wrapper,\n.sales_app [data-tab-container=\"SALES_ARCHIVED\"] .marketplace-wrapper {\n  max-width: unset !important; }\n\n.sales_app .data-wrapper {\n  width: max-content !important; }\n\n.sales_app [data-tab-container=\"SALES_ACCEPTED\"] .opportunity-opened .expiry-date {\n  font-size: 12px; }\n\n.content-open {\n  box-sizing: border-box; }\n\n.bid-per-container {\n  width: 115px !important;\n  margin-left: 15px; }\n\n.total-bid {\n  width: 112px !important; }\n\n.opportunityCountryImgContainer {\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  /* top: 5px; */\n  padding: 5px 6px 0px 0px;\n  right: 0px; }\n  .opportunityCountryImgContainer .opportunityCountryImage {\n    width: auto;\n    height: 22px; }\n\n.partner_header {\n  background-color: #c1cedf;\n  text-align: center;\n  width: 228px;\n  padding-top: 13px;\n  display: block !important;\n  height: 100%; }\n\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .partner_header {\n  height: 50px;\n  padding-top: 5px; }\n\n.partner-name {\n  color: #1158ba;\n  font-size: 18px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  padding: 0px 2px; }\n\n.partner-bid-date {\n  color: #030303;\n  font-size: 12px; }\n\n.sales_app .grand-total-wrapper .partner-total-footer {\n  margin-right: 23px; }\n\n.partner-total-footer {\n  background-color: #c1cedf;\n  text-align: right;\n  width: 226px !important;\n  margin-right: 23px;\n  padding-top: 13px;\n  font-weight: bold;\n  font-size: 18px;\n  margin-top: -10px;\n  margin-bottom: -20px;\n  padding-right: 10px;\n  margin-top: -1px;\n  height: 53px; }\n\n.sales_app .partner-total-footer {\n  margin-right: 0; }\n\n.grand-price {\n  margin-right: 26px; }\n  .sales_app .grand-price {\n    margin-right: 15px; }\n\n.grand-total-wrapper .partner-total-footer {\n  width: 228px;\n  margin-top: -6px; }\n\n.expandHorizontally {\n  background: #2e6cc2;\n  color: white;\n  width: 18px;\n  height: 100%;\n  display: block;\n  float: left;\n  height: 50px; }\n  .expandHorizontally img {\n    width: 11px;\n    margin: 15px 4px; }\n\n.hideExtraBids .arrow_right {\n  display: block; }\n\n.hideExtraBids .arrow_left {\n  display: none; }\n\n.showExtraBids .arrow_right {\n  display: none; }\n\n.showExtraBids .arrow_left {\n  display: block; }\n\n.data-header .bid-per-container:nth-child(5),\n.data-header .total-bid:nth-child(6) {\n  display: block; }\n\n.sales_app:not(.hideExtraBids) .leftSide {\n  max-width: 1138px; }\n\n.sales_app:not(.hideExtraBids) .opportunity-opened {\n  display: block;\n  width: max-content; }\n\n.sales_app:not(.hideExtraBids) [data-tab-container=\"SALES_PUBLISHED\"] .opportunity-opened, .sales_app:not(.hideExtraBids) [data-tab-container=\"SALES_CUSTOMER_REQUESTED\"] .opportunity-opened {\n  width: auto; }\n\n.rightSide {\n  width: 100%; }\n\n.opportunity_wrapper {\n  overflow-x: auto;\n  clear: right; }\n\n.sales_app .opportunity-opened {\n  display: flex; }\n\n.SALES_PENDING_APPROVAL_SinglePartner {\n  width: unset !important; }\n  .SALES_PENDING_APPROVAL_SinglePartner .oppor-name-text {\n    width: 580px !important; }\n  .SALES_PENDING_APPROVAL_SinglePartner .partner_header {\n    margin-right: 0 !important; }\n\n.accepted_tick {\n  position: absolute;\n  top: 3px;\n  left: 2px;\n  color: #008b8f !important; }\n  .accepted_tick.selected {\n    top: 50%;\n    height: auto;\n    font-size: 1em;\n    transform: translateY(-50%); }\n\n.top-right {\n  position: absolute;\n  top: 0.25rem; }\n\n.sales_app.hideExtraBids .grand-total-wrapper .partner-total-footer:nth-child(4) {\n  margin-right: 18px; }\n\n.sales_app.hideExtraBids .bid-col {\n  margin-right: 0; }\n\n.sales_app.hideExtraBids .data-row {\n  padding-right: 0; }\n\n.sales_app.hideExtraBids .data-header .partner-total-footer:nth-child(5) {\n  margin-right: 0px; }\n\n.sales_app.hideExtraBids .data-header {\n  padding-right: 0; }\n\n.sales_app .opportunity-closed .partner_header,\n.sales_app .opportunity-closed .expandHorizontally {\n  display: none; }\n\n.select_box {\n  height: 26px;\n  width: 100%;\n  clear: left;\n  border: 1px solid #0a53b8;\n  border-radius: 0 0 2px 2px;\n  background-color: #0a53b8;\n  display: none; }\n\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .lane-row .handle-select-box:hover .handle-select-box-child1,\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .handle-select-box.is-selected .handle-select-box-child1 {\n  padding-top: 6px;\n  height: 28px;\n  line-height: 19px;\n  font-size: 13px; }\n\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .lane-row .handle-select-box:hover .handle-select-box-child2,\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .handle-select-box.is-selected .handle-select-box-child2 {\n  height: 28px;\n  line-height: 19px;\n  padding-top: 6px;\n  font-size: 13px; }\n\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .lane-row .handle-select-box:hover .select_box,\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .handle-select-box.is-selected .select_box {\n  display: block;\n  color: white;\n  font-size: 13px; }\n\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .destinationDataRow .handle-select-box:hover .handle-select-box-child1,\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .handle-select-box.is-selected .handle-select-box-child1 {\n  padding-top: 6px;\n  height: 28px;\n  line-height: 19px;\n  font-size: 13px; }\n\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .destinationDataRow .handle-select-box:hover .handle-select-box-child2,\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .handle-select-box.is-selected .handle-select-box-child2 {\n  height: 28px;\n  line-height: 19px;\n  padding-top: 6px;\n  font-size: 13px; }\n\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .destinationDataRow .handle-select-box:hover .select_box,\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .handle-select-box.is-selected .select_box {\n  display: block;\n  color: white;\n  font-size: 13px; }\n\n.select_box {\n  position: relative; }\n  .select_box .show_as_unselected {\n    display: inline-block; }\n  .select_box .show_as_selected {\n    display: none; }\n  .is-selected .select_box .show_as_unselected {\n    display: none; }\n  .is-selected .select_box .show_as_selected {\n    display: inline-block; }\n\n.data-first-col {\n  flex-grow: 1; }\n\n.drayage-approve-btn {\n  box-sizing: border-box;\n  height: 38px;\n  width: 119px;\n  border: 1px solid #008b8f;\n  border-radius: 2px;\n  background-color: #267678;\n  color: #ffffff;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin-left: 670px;\n  margin-bottom: 10px;\n  margin-top: -40px;\n  margin-left: 470px;\n  cursor: pointer; }\n\n.drayage-select-btn {\n  box-sizing: border-box;\n  height: 38px;\n  width: 118px;\n  border: 1px solid #0a53b8;\n  border-radius: 2px;\n  background-color: #0a53b8;\n  color: #ffffff;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin-left: 725px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 530px;\n  cursor: pointer; }\n\n.drayage-text-customer {\n  color: #131212;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 19px;\n  margin-bottom: 10px;\n  margin-right: 20px;\n  margin-top: 10px;\n  padding-left: 30px; }\n\n.unitPrice-btn {\n  box-sizing: border-box;\n  height: 52px;\n  border: 1px solid #eeeeee;\n  border-radius: 2px 0 0 2px;\n  background-color: #ffffff;\n  box-shadow: 1px 1px 1px 0 rgba(165, 163, 163, 0.5);\n  color: #0a53b8;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n  margin-top: -16.5px;\n  padding-top: 17px;\n  text-align: center;\n  cursor: pointer; }\n\n.detailPrice-btn {\n  box-sizing: border-box;\n  height: 52px;\n  width: 90px;\n  border: 1px solid white;\n  border-radius: 2px 0 0 2px;\n  background-color: #ffffff;\n  color: #0a53b8;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n  padding-top: 8px;\n  text-align: center;\n  position: relative;\n  /* margin-top: -150px; */\n  margin-left: -8px;\n  /* background-color: red; */\n  top: -52px; }\n\n.detailPrice-btn-suggested-bid {\n  box-sizing: border-box;\n  height: 65px;\n  width: 90px;\n  border: 1px solid #eeeeee;\n  border-radius: 2px 0 0 2px;\n  background-color: #ffffff;\n  box-shadow: 1px 1px 1px 0 rgba(165, 163, 163, 0.5);\n  color: #0a53b8;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n  padding-top: 8px;\n  text-align: center;\n  opacity: 0%;\n  margin-top: -120px; }\n\ndetailPrice-btn-without {\n  box-sizing: border-box;\n  border: 1px solid #eeeeee;\n  border-radius: 2px 0 0 2px;\n  box-shadow: 1px 1px 1px 0 rgba(165, 163, 163, 0.5);\n  color: #0a53b8;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n  padding-top: 8px;\n  text-align: center;\n  position: fixed;\n  margin-top: -52px;\n  margin-left: -70px;\n  opacity: 0%; }\n\n.unitPrice-select_box {\n  height: 26px;\n  width: 100%;\n  clear: left;\n  border: 1px solid #0a53b8;\n  border-radius: 0 0 2px 2px;\n  background-color: #0a53b8;\n  display: none; }\n\n.customer-select_box {\n  height: 22px;\n  width: 100%;\n  border: 1px solid #0a53b8;\n  border-radius: 0 0 2px 2px;\n  background-color: #0a53b8;\n  display: none;\n  padding-right: 10px;\n  font-size: 14px; }\n\n.customerpricecard-modal {\n  height: 247px;\n  width: 370px;\n  z-index: 100;\n  margin-top: 285px;\n  margin-left: 675px;\n  height: 232px;\n  width: 350.5px;\n  border-radius: 6px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5);\n  overflow: auto;\n  position: relative;\n  float: left; }\n\n.customerpricecard-modal.arrow-top {\n  margin-top: 40px; }\n\n.customerpricecard-modal.arrow-left:after {\n  content: \" \";\n  position: absolute;\n  left: -15px;\n  top: 15px;\n  border-top: 15px solid blue;\n  border-right: 15px solid black;\n  border-left: none;\n  border-bottom: 15px solid blue; }\n\n.priceCardContainer {\n  width: 500px;\n  max-height: 220px;\n  overflow: scroll; }\n\n.pricecard-holder {\n  margin: -10px;\n  max-height: fit-content; }\n\n.drayage-pricecard-header {\n  height: 26px;\n  width: 100%;\n  background-color: #3c3c3c;\n  color: #ffffff;\n  font-family: \"OPEN SANS\";\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 11px;\n  padding-left: 18px;\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center; }\n\n.base-row {\n  display: flex;\n  flex-direction: column;\n  height: 21px;\n  width: 400px;\n  background-color: #f9f9f9; }\n\n.pricecard-basefees {\n  border-radius: 3px;\n  display: flex;\n  flex-direction: row;\n  padding-left: 10px;\n  margin-left: 10px;\n  padding-right: 6px; }\n\n.pricecard-basefees-text {\n  height: 17px;\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0;\n  padding-top: 5px;\n  color: #606060;\n  letter-spacing: 0;\n  line-height: 15px;\n  width: 140px; }\n\n.pricecard-basefees-amount {\n  height: 17px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0px;\n  padding-top: 2px;\n  padding-left: 20px; }\n\n.pricecard-fuel-info {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n\n.fuel-title {\n  color: #606060;\n  font-family: \"Open Sans\";\n  font-size: 10px;\n  letter-spacing: 0;\n  padding: 10px; }\n\n.fuel-amount {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 10px;\n  letter-spacing: 0px; }\n\n.card-totals-row {\n  width: unset !important;\n  font-weight: bold;\n  background: #cccccc42;\n  font-size: 12px; }\n  .card-totals-row .pricecard-charges-name {\n    padding-right: 0 !important; }\n\n.data-header-first-total + .data-other-col {\n  margin-right: 100px; }\n\n.done_button {\n  height: 38px;\n  width: 76px;\n  border: 1px solid #008b8f;\n  border-radius: 2px;\n  background-color: #267678;\n  float: right;\n  color: white;\n  margin: 10px;\n  font-weight: bold; }\n  .done_button.isDisabled {\n    opacity: 0.5; }\n\n.opportunity-closed .done_button {\n  display: none; }\n\n.container-drayage {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n/* Hide the browser's default checkbox */\n.container-drayage input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0; }\n\n/* Create a custom checkbox */\n.checkmark-drayage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 17px;\n  width: 17px;\n  background-color: white;\n  border: 1px solid #0a8b8f; }\n\n/* On mouse-over, add a grey background color */\n.container-drayage:hover input ~ .checkmark-drayage {\n  background-color: #ccc; }\n\n/* When the checkbox is checked, add a blue background */\n.container-drayage input:checked ~ .checkmark-drayage {\n  background-color: white; }\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark-drayage:after {\n  content: \"\";\n  position: absolute;\n  display: none; }\n\n/* Show the checkmark when checked */\n.container-drayage input:checked ~ .checkmark-drayage:after {\n  display: block; }\n\n/* Style the checkmark/indicator */\n.container-drayage .checkmark-drayage:after {\n  left: 5px;\n  top: 2px;\n  width: 6px;\n  height: 10px;\n  border: solid #04adb1;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg); }\n\n.pricecard-charges-name {\n  font-weight: bold;\n  font-size: 12px;\n  padding-left: 16px; }\n\n.total-row .data-header-first-total,\n.total-row .data-other-col {\n  padding-top: 13px; }\n\n.customer_drayage_app .data-header-first-total + .data-other-col {\n  margin-right: 0 !important; }\n\n.customer_drayage_app .grand-cont {\n  margin-right: 0 !important; }\n\n.customer_drayage_app .marketplace-wrapper {\n  padding-left: 10px; }\n\n.customer_drayage_app .leftSide {\n  width: 45.5% !important; }\n\n.bid-total-cell {\n  background-color: #c1cedf; }\n\n.grand-action,\n.grand-action .data-other-col,\n.grand-action .cont-num {\n  font-weight: bold;\n  font-size: 20px !important; }\n\n.total-after-margin {\n  font-weight: bold;\n  background: #cccccc42;\n  font-size: 12px; }\n\n.partner-container {\n  color: black;\n  font-size: 10px;\n  background-color: #c1cedf;\n  line-height: 1.6;\n  border-radius: 2px;\n  padding: 0px 2px; }\n\n.partner-container:last-child {\n  margin: 0px 4px; }\n\n.new-req {\n  height: 41px;\n  width: 127px;\n  border-radius: 2px;\n  color: #FFFFFF;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin-top: -40px;\n  border: none;\n  margin-right: 26px;\n  background-color: #04adb1;\n  align-self: flex-end; }\n\n.drayagelane--req-modal {\n  width: 60%;\n  border-radius: 13px;\n  box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5);\n  z-index: 100;\n  background-color: #FFFFFF;\n  overflow: auto;\n  margin: 7vh 20vw; }\n\n.req-drayage-text {\n  color: #000000;\n  font-family: \"Open Sans\";\n  margin-left: 60px;\n  font-size: 24px;\n  font-weight: bold;\n  letter-spacing: 1.2px;\n  font-weight: bold; }\n\n.requestDrayageContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 80vh;\n  overflow: auto; }\n  .requestDrayageContainer .flitersSection {\n    display: flex;\n    width: 100%;\n    padding: 0px 10px 10px 10px;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 5px; }\n    .requestDrayageContainer .flitersSection .marketplace-country-dropdown {\n      width: 130px;\n      height: 48px;\n      border-radius: 4px;\n      border: \"1px solid #7A7A7A\";\n      background-color: #eee;\n      padding: 4px 12px; }\n\n.sendReq-btn {\n  height: 38px;\n  width: 162px;\n  border: 1px solid #008B8F;\n  border-radius: 2px;\n  background-color: #267678;\n  color: #FFFFFF;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 19px;\n  margin-left: 120px;\n  margin-right: 20px;\n  margin-top: 20px; }\n\n.cancel-req {\n  height: 38px;\n  width: 134px;\n  border: 1px solid #01A1A5;\n  border-radius: 2px;\n  background-color: #FFFFFF;\n  color: #01A1A5;\n  margin-top: 20px; }\n\n.container-text-drayage {\n  height: 18px;\n  width: 270px;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 15px;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin-left: 120px;\n  margin-top: 50px;\n  margin-bottom: 10px; }\n\n.container-num-box {\n  height: 41px;\n  width: 570px;\n  border: 1px solid #1765AE;\n  background-color: #FFFFFF;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 1.14px;\n  line-height: 19px;\n  margin-left: 120px; }\n\n.customer_drayage_app div .clndr-calendars-segment {\n  position: absolute !important; }\n\n.ui .segment clndr-calendars-segment clndr-left {\n  left: 0;\n  top: unset;\n  right: unset;\n  left: unset;\n  top: 238px; }\n\n.apply-all-btn {\n  width: 150px;\n  height: 50px;\n  border: 1px solid #008b8f;\n  font-size: 16px;\n  letter-spacing: 0.53px;\n  box-sizing: border-box;\n  border-radius: 3px;\n  text-transform: uppercase;\n  color: #008b8f;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Open Sans\" !important;\n  background-color: #0a8b8f;\n  background-color: white;\n  margin-top: 20px;\n  margin-left: 150px; }\n\n.btn-edit-dray {\n  background-color: #0a8b8f;\n  color: white;\n  font-family: \"Open Sans\" !important;\n  width: 80px;\n  height: 30px;\n  border: none;\n  /* margin-bottom: 30px; */\n  margin-right: 8px; }\n\n.apply-selected-btn {\n  width: 150px;\n  height: 50px;\n  border: 1px solid #008b8f;\n  font-size: 16px;\n  letter-spacing: 0.53px;\n  box-sizing: border-box;\n  border-radius: 3px;\n  text-transform: uppercase;\n  color: #008b8f;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Open Sans\" !important;\n  background-color: #0a8b8f;\n  background-color: white;\n  margin-top: 10px;\n  margin-left: 20px; }\n\n@media not all and (min-resolution: 0.001dpcm) {\n  @supports (-webkit-appearance: none) and (display: flow-root) {\n    .partnerBids.open {\n      right: -8% !important; }\n    .faded-text {\n      font-size: 10px; } } }\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.7; }\n\n[data-tab-container=\"SALES_REJECTED\"] .unitPrice-btn {\n  border: 1px solid #ff9494;\n  background-color: #edc7be; }\n\n.opportunityHeaderContainer {\n  width: 100% !important; }\n\n.dateEditBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  background-color: #04adb1;\n  padding: 5px 10px;\n  border-radius: 3px;\n  cursor: pointer;\n  text-transform: uppercase; }\n\n.oppHistoryBtn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: grey;\n  font-size: 20px;\n  padding: 5px;\n  cursor: pointer;\n  text-transform: uppercase; }\n\n.disabledEditBtn {\n  opacity: 0.7;\n  cursor: not-allowed; }\n\n.rowAlignFlex {\n  display: flex; }\n\n.centerAligned {\n  justify-content: center;\n  align-items: center; }\n\n.bidDateUpdationContainer {\n  min-height: 250px; }\n  .bidDateUpdationContainer .bidDateHistoryContent {\n    margin-top: 10px; }\n  .bidDateUpdationContainer .dateWrapper {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 15px; }\n  .bidDateUpdationContainer .dateLabel {\n    text-transform: uppercase;\n    font-size: 14px;\n    color: #606060;\n    font-weight: 600;\n    width: 200px; }\n  .bidDateUpdationContainer .dateIconInputWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #286084;\n    border-radius: 2px;\n    transition: 0.2s ease-in-out; }\n  .bidDateUpdationContainer .datePickerFocused {\n    border: 1px solid #0a8b8f;\n    box-shadow: 0px 1px 5px #0a8b8f; }\n  .bidDateUpdationContainer .calendarIconContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 25px;\n    cursor: pointer; }\n  .bidDateUpdationContainer .calendarIcon {\n    margin-left: 10px; }\n  .bidDateUpdationContainer .datePickerInput {\n    padding: 5px 10px;\n    border: 0px solid transparent; }\n  .bidDateUpdationContainer .datePickerInput:focus {\n    outline: none;\n    border: none; }\n  .bidDateUpdationContainer .oppUpdationPartnerSection {\n    display: flex;\n    flex-direction: column;\n    width: 100%; }\n  .bidDateUpdationContainer .laneTitle {\n    font-size: 14px;\n    font-weight: 700;\n    margin: 10px 0px; }\n  .bidDateUpdationContainer .bidButton {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    background-color: #0a53b8;\n    padding: 5px 10px;\n    border-radius: 3px;\n    cursor: pointer;\n    text-transform: uppercase; }\n\n.oppUpdationAccordion {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border: 1px solid #eee;\n  border-radius: 3px;\n  margin-bottom: 10px; }\n  .oppUpdationAccordion .oppUpdationAccordionHeader {\n    display: flex;\n    padding: 10px;\n    align-items: center;\n    background: linear-gradient(0deg, #F6F5F4, #F6F5F4), linear-gradient(0deg, #EDEBE9, #EDEBE9), #FFFCFA; }\n  .oppUpdationAccordion .headerTitle {\n    font-size: 18px;\n    font-weight: 700; }\n  .oppUpdationAccordion .headerIcon {\n    color: #04adb1;\n    margin-top: -5px;\n    margin-right: 5px;\n    cursor: pointer; }\n  .oppUpdationAccordion .oppUpdationAccordionContent {\n    display: flex;\n    padding: 10px; }\n  .oppUpdationAccordion .oppDatesSection {\n    display: flex;\n    flex-direction: column;\n    width: 100%; }\n\n.portOpportunityContent {\n  padding: 0px 18px 5px 18px;\n  width: 100%;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  background-color: #f2f6fb;\n  box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5);\n  overflow-x: auto;\n  overflow-y: hidden; }\n\n.portOpportunityTable {\n  width: 100%;\n  background-color: #f2f6fb;\n  border-collapse: collapse; }\n  .portOpportunityTable th {\n    text-align: start; }\n  .portOpportunityTable td {\n    border: 1.5px solid transparent; }\n  .portOpportunityTable td.opportunityHeader {\n    width: 140px; }\n  .portOpportunityTable .portOpportunityHeader {\n    width: 228px; }\n  .portOpportunityTable td:first-child {\n    width: 340px; }\n  .portOpportunityTable .anchor-img {\n    float: left;\n    border-radius: 55%;\n    margin-right: 18px;\n    padding: 2px;\n    margin-top: 3px;\n    width: 20px;\n    margin-left: 0 !important; }\n  .portOpportunityTable .warehouse-img {\n    float: left;\n    border-radius: 55%;\n    margin-right: 18px;\n    padding: 2px;\n    margin-top: 3px;\n    width: 20px;\n    margin-left: 0 !important; }\n  .portOpportunityTable .rowAlignCentered {\n    display: flex;\n    flex-direction: row;\n    align-items: center; }\n  .portOpportunityTable .colAlignCentered {\n    display: flex;\n    flex-direction: column;\n    align-items: center; }\n  .portOpportunityTable .extraBottomPadding {\n    padding-bottom: 5px; }\n  .portOpportunityTable .portOpportunityTablePartnerHeaderWrapper {\n    display: flex;\n    justify-content: flex-end; }\n  .portOpportunityTable .portOpportunityTablePartnerDataWrapper {\n    display: flex;\n    justify-content: flex-end; }\n  .portOpportunityTable .destinationDataRow {\n    padding-bottom: 10px; }\n  .portOpportunityTable .portOpportunityTablePartnerHeader {\n    position: relative;\n    display: flex;\n    align-self: center; }\n  .portOpportunityTable .expandHorizontally i {\n    color: white;\n    margin: 0;\n    font-size: 1.3em !important; }\n\n#market-place-dropdown.ui.dropdown > .dropdown.icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%); }\n  #market-place-dropdown.ui.dropdown > .dropdown.icon .dropdown-checkbox label {\n    color: #333333;\n    font-size: 14px !important; }\n\n#market-place-dropdown .dropdown-checkbox label::after {\n  color: white !important;\n  background-color: #005C7B !important; }\n\n.portOpportunityContentCommon {\n  padding: 0px 18px 5px 18px;\n  display: table;\n  width: 100%;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  background-color: #f2f6fb;\n  box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5); }\n\n.portOpportunityTableCommon {\n  width: 100%;\n  background-color: #f2f6fb;\n  border-collapse: collapse; }\n  .portOpportunityTableCommon th {\n    text-align: start; }\n  .portOpportunityTableCommon td {\n    border: 1.5px solid transparent;\n    padding: 5px; }\n  .portOpportunityTableCommon .opportunityRowIcon {\n    border-radius: 55%;\n    padding: 2px;\n    width: 25px;\n    height: 25px; }\n  .portOpportunityTableCommon .laneSelectionCheckBox {\n    margin: 0 15px 0 0 !important; }\n    .portOpportunityTableCommon .laneSelectionCheckBox label {\n      color: #333333;\n      font-size: 14px !important; }\n  .portOpportunityTableCommon .laneSelectionCheckBox label::after {\n    color: white !important;\n    background-color: #005C7B !important; }\n  .portOpportunityTableCommon .ui.checkbox input.hidden + label {\n    color: transparent !important;\n    position: absolute !important; }\n  .portOpportunityTableCommon .rowAlignCentered {\n    display: flex;\n    flex-direction: row;\n    align-items: center; }\n  .portOpportunityTableCommon .colAlignCentered {\n    display: flex;\n    flex-direction: column;\n    align-items: center; }\n  .portOpportunityTableCommon .colAlign {\n    display: flex;\n    flex-direction: column; }\n  .portOpportunityTableCommon .spaceBetween {\n    justify-content: space-between; }\n  .portOpportunityTableCommon .extraBottomPadding {\n    padding-bottom: 5px; }\n  .portOpportunityTableCommon .portOpportunityTablePartnerHeaderWrapper {\n    display: flex;\n    justify-content: flex-end; }\n  .portOpportunityTableCommon .portOpportunityTablePartnerDataWrapper {\n    display: flex;\n    justify-content: flex-end; }\n  .portOpportunityTableCommon .data-header-others {\n    width: auto;\n    text-align: center;\n    padding-right: 0; }\n  .portOpportunityTableCommon .data-header-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center; }\n  .portOpportunityTableCommon .containerDataTxt {\n    text-align: center;\n    color: #696969;\n    font-size: 18px; }\n  .portOpportunityTableCommon .data-other-col {\n    width: auto;\n    text-align: center; }\n  .portOpportunityTableCommon .destinationDataRow td:first-child {\n    background-color: #f2f6fb; }\n  .portOpportunityTableCommon .destinationDataRow .cont-num-renewal-date {\n    color: #000;\n    font-size: 16px;\n    text-align: center;\n    font-weight: normal;\n    font-family: \"Open Sans\";\n    padding: 0; }\n  .portOpportunityTableCommon .destinationDataRow .laneValueText {\n    color: #000;\n    font-size: 16px;\n    text-align: center;\n    font-family: \"Open Sans\"; }\n  .portOpportunityTableCommon .destinationDataRow .cont-num {\n    color: #000;\n    text-align: center;\n    font-size: 16px;\n    padding: 0;\n    margin: 0; }\n  .portOpportunityTableCommon .destinationDataRow .price {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    justify-content: center;\n    position: relative; }\n  .portOpportunityTableCommon .destinationDataRow .priceInfoIcon {\n    position: relative;\n    margin-left: 3px;\n    padding-bottom: 1px;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center; }\n  .portOpportunityTableCommon .destinationDataRow .detailPrice-btn-suggested-bid {\n    position: absolute;\n    width: 90px;\n    height: 30px;\n    background-color: transparent;\n    opacity: 0;\n    margin: 0;\n    top: 0;\n    left: 5px; }\n  .portOpportunityTableCommon .destinationDataRow .price-total-white {\n    font-size: 18px;\n    font-weight: 500;\n    text-align: center;\n    color: white;\n    font-weight: bold;\n    padding: 5px 8px;\n    margin: 0;\n    position: relative; }\n  .portOpportunityTableCommon .destinationDataRow .price-total {\n    font-size: 18px;\n    font-weight: 500;\n    text-align: center;\n    color: black;\n    font-weight: bold;\n    padding: 5px 8px;\n    margin: 0;\n    position: relative; }\n  .portOpportunityTableCommon .portOpportunityTablePartnerHeader {\n    position: relative;\n    display: flex;\n    align-self: center; }\n  .portOpportunityTableCommon .expandHorizontally i {\n    color: white;\n    margin: 0;\n    font-size: 1.3em !important; }\n  .portOpportunityTableCommon .sourceName {\n    height: 28px;\n    color: #000000;\n    font-family: \"Open Sans\";\n    font-size: 18px;\n    font-weight: bold; }\n\n.opportunityFooter {\n  display: flex;\n  width: 100%;\n  height: 70px;\n  align-items: center;\n  justify-content: space-between; }\n  .opportunityFooter .footerBtnRow {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    padding: 5px 0px;\n    padding-bottom: 0px; }\n  .opportunityFooter .opportunityApprovalBtn {\n    height: 38px;\n    padding: 4px 10px;\n    border: 1px solid #008b8f;\n    border-radius: 2px;\n    background-color: #267678;\n    color: #ffffff;\n    font-family: \"Open Sans\";\n    font-size: 14px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n    cursor: pointer; }\n  .opportunityFooter .disabledApprovalBtn {\n    background-color: #3E7477;\n    color: #aaa;\n    cursor: not-allowed; }\n  .opportunityFooter .opportunityRejectionBtn {\n    height: 38px;\n    padding: 4px 10px;\n    border-radius: 2px;\n    background-color: #FCEDF1;\n    color: #CD214A;\n    font-family: \"Open Sans\";\n    font-size: 14px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n    cursor: pointer;\n    border: 1px solid #FCEDF1;\n    margin-right: 15px; }\n  .opportunityFooter .disabledRejectionBtn {\n    background-color: #FCEDF1;\n    color: #CD214A50;\n    cursor: not-allowed; }\n  .opportunityFooter .footerLaneTextContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: flex-start;\n    height: 60px;\n    padding: 5px;\n    padding-bottom: 0px; }\n  .opportunityFooter .laneSelectionWarningText {\n    font-family: \"Open Sans\";\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 16px;\n    letter-spacing: 0em;\n    color: #CD214A;\n    background-color: #FCEDF1;\n    padding: 2px 5px; }\n  .opportunityFooter .laneCountText {\n    font-family: \"Open Sans\";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 16px;\n    letter-spacing: 0em;\n    color: #0062B8; }\n\n.filtersContainer {\n  display: flex;\n  width: 70%;\n  gap: 10px;\n  justify-content: flex-end;\n  padding-right: 10px; }\n\n.oppSearchContainer {\n  display: flex;\n  flex-direction: column;\n  width: 70%;\n  min-width: 200px;\n  margin-right: 20px; }\n\n.oppFilterOptionWrapper {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #7A7A7A;\n  border-radius: 4px;\n  padding: 5px 10px;\n  background-color: #fff; }\n  .oppFilterOptionWrapper .oppFilterInput {\n    width: 65%;\n    min-width: 198px;\n    display: flex;\n    align-items: center;\n    height: 36px; }\n    .oppFilterOptionWrapper .oppFilterInput input {\n      border: none;\n      outline: none;\n      height: 100%;\n      width: 90%;\n      font-size: 16px;\n      padding-left: 5px; }\n  .oppFilterOptionWrapper .oppFilterDropDown {\n    width: 30%;\n    min-width: 180px;\n    border-radius: 4px;\n    background-color: #F5F5F5;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 8px; }\n  .oppFilterOptionWrapper .dropDownItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; }\n  .oppFilterOptionWrapper .dropDownItemTitle {\n    font-size: 14px; }\n\n.opportunityClosedMot {\n  display: flex;\n  gap: 4px;\n  align-items: center; }\n";
styleInject(css_248z$m);

var usFlagIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2055.2%2038.4%22%20style%3D%22enable-background%3Anew%200%200%2055.2%2038.4%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.st0%7Bfill%3A%23B22234%3B%7D%20.st1%7Bfill%3A%23FFFFFF%3B%7D%20.st2%7Bfill%3A%233C3B6E%3B%7D%3C%2Fstyle%3E%3Cg%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M3.03%2C0h49.13c1.67%2C0%2C3.03%2C1.36%2C3.03%2C3.03v32.33c0%2C1.67-1.36%2C3.03-3.03%2C3.03H3.03C1.36%2C38.4%2C0%2C37.04%2C0%2C35.37%20V3.03C0%2C1.36%2C1.36%2C0%2C3.03%2C0L3.03%2C0z%22%2F%3E%3Cpath%20class%3D%22st1%22%20d%3D%22M0.02%2C2.73h55.17c0.01%2C0.1%2C0.02%2C0.2%2C0.02%2C0.31v2.94H0V3.03C0%2C2.93%2C0.01%2C2.83%2C0.02%2C2.73L0.02%2C2.73z%20M55.2%2C8.67%20v3.24H0V8.67H55.2L55.2%2C8.67z%20M55.2%2C14.61v3.24H0v-3.24H55.2L55.2%2C14.61z%20M55.2%2C20.55v3.24H0v-3.24H55.2L55.2%2C20.55z%20M55.2%2C26.49%20v3.24H0v-3.24H55.2L55.2%2C26.49z%20M55.2%2C32.43v2.93c0%2C0.1-0.01%2C0.21-0.02%2C0.31H0.02C0.01%2C35.58%2C0%2C35.47%2C0%2C35.37v-2.93H55.2%20L55.2%2C32.43z%22%2F%3E%3Cpath%20class%3D%22st2%22%20d%3D%22M20.8%2C0v20.68H0V3.03C0%2C1.36%2C1.36%2C0%2C3.03%2C0H20.8L20.8%2C0L20.8%2C0z%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%221.23%2C2.86%201.92%2C5.01%200.1%2C3.68%202.36%2C3.68%200.53%2C5.01%201.23%2C2.86%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%221.23%2C7.02%201.92%2C9.17%200.1%2C7.84%202.36%2C7.84%200.53%2C9.17%201.23%2C7.02%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%221.23%2C11.18%201.92%2C13.33%200.1%2C12%202.36%2C12%200.53%2C13.33%201.23%2C11.18%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%221.23%2C15.34%201.92%2C17.49%200.1%2C16.16%202.36%2C16.16%200.53%2C17.49%201.23%2C15.34%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%223.67%2C0.78%204.37%2C2.93%202.54%2C1.6%204.81%2C1.6%202.97%2C2.93%203.67%2C0.78%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%223.67%2C4.94%204.37%2C7.09%202.54%2C5.76%204.81%2C5.76%202.97%2C7.09%203.67%2C4.94%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%223.67%2C9.1%204.37%2C11.25%202.54%2C9.92%204.81%2C9.92%202.97%2C11.25%203.67%2C9.1%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%223.67%2C13.26%204.37%2C15.41%202.54%2C14.08%204.81%2C14.08%202.97%2C15.41%203.67%2C13.26%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%223.67%2C17.42%204.37%2C19.57%202.54%2C18.24%204.81%2C18.24%202.97%2C19.57%203.67%2C17.42%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%226.12%2C2.86%206.82%2C5.01%204.99%2C3.68%207.25%2C3.68%205.42%2C5.01%206.12%2C2.86%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%226.12%2C7.02%206.82%2C9.17%204.99%2C7.84%207.25%2C7.84%205.42%2C9.17%206.12%2C7.02%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%226.12%2C11.18%206.82%2C13.33%204.99%2C12%207.25%2C12%205.42%2C13.33%206.12%2C11.18%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%226.12%2C15.34%206.82%2C17.49%204.99%2C16.16%207.25%2C16.16%205.42%2C17.49%206.12%2C15.34%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%228.57%2C0.78%209.26%2C2.93%207.44%2C1.6%209.7%2C1.6%207.87%2C2.93%208.57%2C0.78%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%228.57%2C4.94%209.26%2C7.09%207.44%2C5.76%209.7%2C5.76%207.87%2C7.09%208.57%2C4.94%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%228.57%2C9.1%209.26%2C11.25%207.44%2C9.92%209.7%2C9.92%207.87%2C11.25%208.57%2C9.1%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%228.57%2C13.26%209.26%2C15.41%207.44%2C14.08%209.7%2C14.08%207.87%2C15.41%208.57%2C13.26%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%228.57%2C17.42%209.26%2C19.57%207.44%2C18.24%209.7%2C18.24%207.87%2C19.57%208.57%2C17.42%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2211.01%2C2.86%2011.71%2C5.01%209.88%2C3.68%2012.14%2C3.68%2010.31%2C5.01%2011.01%2C2.86%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2211.01%2C7.02%2011.71%2C9.17%209.88%2C7.84%2012.14%2C7.84%2010.31%2C9.17%2011.01%2C7.02%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2211.01%2C11.18%2011.71%2C13.33%209.88%2C12%2012.14%2C12%2010.31%2C13.33%2011.01%2C11.18%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2211.01%2C15.34%2011.71%2C17.49%209.88%2C16.16%2012.14%2C16.16%2010.31%2C17.49%2011.01%2C15.34%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2213.46%2C0.78%2014.16%2C2.93%2012.33%2C1.6%2014.59%2C1.6%2012.76%2C2.93%2013.46%2C0.78%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2213.46%2C4.94%2014.16%2C7.09%2012.33%2C5.76%2014.59%2C5.76%2012.76%2C7.09%2013.46%2C4.94%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2213.46%2C9.1%2014.16%2C11.25%2012.33%2C9.92%2014.59%2C9.92%2012.76%2C11.25%2013.46%2C9.1%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2213.46%2C13.26%2014.16%2C15.41%2012.33%2C14.08%2014.59%2C14.08%2012.76%2C15.41%2013.46%2C13.26%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2213.46%2C17.42%2014.16%2C19.57%2012.33%2C18.24%2014.59%2C18.24%2012.76%2C19.57%2013.46%2C17.42%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2215.9%2C2.86%2016.6%2C5.01%2014.77%2C3.68%2017.03%2C3.68%2015.21%2C5.01%2015.9%2C2.86%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2215.9%2C7.02%2016.6%2C9.17%2014.77%2C7.84%2017.03%2C7.84%2015.21%2C9.17%2015.9%2C7.02%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2215.9%2C11.18%2016.6%2C13.33%2014.77%2C12%2017.03%2C12%2015.21%2C13.33%2015.9%2C11.18%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2215.9%2C15.34%2016.6%2C17.49%2014.77%2C16.16%2017.03%2C16.16%2015.21%2C17.49%2015.9%2C15.34%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2218.35%2C0.78%2019.05%2C2.93%2017.22%2C1.6%2019.48%2C1.6%2017.65%2C2.93%2018.35%2C0.78%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2218.35%2C4.94%2019.05%2C7.09%2017.22%2C5.76%2019.48%2C5.76%2017.65%2C7.09%2018.35%2C4.94%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2218.35%2C9.1%2019.05%2C11.25%2017.22%2C9.92%2019.48%2C9.92%2017.65%2C11.25%2018.35%2C9.1%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2218.35%2C13.26%2019.05%2C15.41%2017.22%2C14.08%2019.48%2C14.08%2017.65%2C15.41%2018.35%2C13.26%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%2218.35%2C17.42%2019.05%2C19.57%2017.22%2C18.24%2019.48%2C18.24%2017.65%2C19.57%2018.35%2C17.42%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var canadaFlagIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2055.2%2038.4%22%20style%3D%22enable-background%3Anew%200%200%2055.2%2038.4%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.st0%7Bfill%3A%23FF0000%3B%7D%20.st1%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cg%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M3.03%2C0h49.13c1.67%2C0%2C3.03%2C1.36%2C3.03%2C3.03v32.33c0%2C1.67-1.36%2C3.03-3.03%2C3.03H3.03C1.36%2C38.4%2C0%2C37.04%2C0%2C35.37%20V3.03C0%2C1.36%2C1.36%2C0%2C3.03%2C0L3.03%2C0z%22%2F%3E%3Cpolygon%20class%3D%22st1%22%20points%3D%228.4%2C0%2046.8%2C0%2046.8%2C38.4%208.4%2C38.4%208.4%2C0%22%2F%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M27.6%2C3.6l-2.62%2C4.89c-0.3%2C0.53-0.83%2C0.48-1.37%2C0.18l-1.9-0.98l1.41%2C7.5c0.3%2C1.37-0.66%2C1.37-1.13%2C0.78%20l-3.31-3.7l-0.53%2C1.88c-0.06%2C0.25-0.33%2C0.51-0.74%2C0.45l-4.18-0.88l1.1%2C4c0.24%2C0.89%2C0.42%2C1.26-0.24%2C1.49l-1.49%2C0.7l7.21%2C5.85%20c0.29%2C0.22%2C0.43%2C0.62%2C0.32%2C0.98l-0.63%2C2.07c2.48-0.29%2C4.71-0.72%2C7.19-0.98c0.22-0.02%2C0.58%2C0.33%2C0.58%2C0.59L26.95%2C36h1.2l-0.19-7.56%20c0-0.26%2C0.33-0.63%2C0.55-0.61c2.48%2C0.27%2C4.71%2C0.7%2C7.19%2C0.98l-0.64-2.08c-0.11-0.36%2C0.04-0.75%2C0.32-0.98l7.21-5.85l-1.49-0.7%20c-0.66-0.24-0.48-0.6-0.24-1.49l1.1-4l-4.18%2C0.88c-0.41%2C0.06-0.68-0.2-0.74-0.45l-0.53-1.88l-3.31%2C3.7%20c-0.47%2C0.59-1.42%2C0.59-1.13-0.78l1.41-7.5l-1.9%2C0.98c-0.53%2C0.3-1.07%2C0.34-1.37-0.18L27.6%2C3.6L27.6%2C3.6L27.6%2C3.6z%20M27.6%2C3.6%20L27.6%2C3.6L27.6%2C3.6L27.6%2C3.6L27.6%2C3.6z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

//import{getOpportunityPartnerBids} from "../Opportunity/OpportunityAccordian/"

var OpportunityClosedCommon = function (_Component) {
  inherits(OpportunityClosedCommon, _Component);

  function OpportunityClosedCommon(props) {
    classCallCheck(this, OpportunityClosedCommon);

    var _this = possibleConstructorReturn(this, (OpportunityClosedCommon.__proto__ || Object.getPrototypeOf(OpportunityClosedCommon)).call(this, props));

    _this.isExpandableTab = function () {
      var tab = _this.props.tab;

      return tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED";
    };

    _this.OpportunityCountryImage = {
      US: usFlagIcon,
      CA: canadaFlagIcon
    };

    _this.state = { expandedTab: false };

    return _this;
  }

  createClass(OpportunityClosedCommon, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var opportunityName = this.props.opportunity.opportunityName;
      var _props = this.props,
          drayageApp = _props.drayageApp,
          tab = _props.tab;
      var opportunityId = this.props.opportunity.opportunityId;


      console.log("OpportunityClosedCommon :: ", this.props);

      var opportunity = this.props.opportunityData && this.props.opportunityData.get(this.props.opportunity.opportunityId);
      var opportunityExpiryDate = opportunity && opportunity['opportunityExpiryDate'] ? parseInt(opportunity.opportunityExpiryDate) : null;

      console.log("OPPORTUNITY CLOSED COMMON  opportunityExpiryDate ", opportunityExpiryDate);

      var partnerBids = [];
      if (opportunity && opportunity.portData && opportunity.portData.values().next().value.destinations) {
        var portData = opportunity.portData;
        partnerBids = portData.values().next().value.destinations[0].partnerBids;
      }
      var widthpartyNamewrapper = getWidthPartyNameWrapper(this.props.drayageApp, this.props.tab);

      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "UTC"
      };

      var opp_key = this.props.opp_key;
      var lastSubmittedDate = parseInt(lodash_1(this.props, "opportunity.lastSubmittedDate", null));
      console.log("lastSubmittedDate", lastSubmittedDate);
      lastSubmittedDate = formatDate(lastSubmittedDate);

      var opportunityCountry = this.props.opportunity && this.props.opportunity.opportunityCountry;
      console.log('oppCountryInheader', opportunityCountry);
      var opportunityMot = this.props.opportunity ? this.props.opportunity.modeOfTransport : "";
      var endDate = this.props.opportunity && parseInt(this.props.opportunity.endDate);
      var customerAcceptanceDeadline = this.props.opportunity && parseInt(this.props.opportunity.customerAcceptanceDeadline);
      console.log("Oppor closed endDate", endDate);
      var editValidButton = false;
      var currentDate = new Date().getTime();
      console.log("Oppor closed CurrentDate", currentDate);

      if (currentDate <= endDate) {
        editValidButton = true;
      }

      var renewalDate = this.props.opportunity && this.props.opportunity.opportunityExpiryDate && parseInt(this.props.opportunity.opportunityExpiryDate);
      // renewalDate = 1651363199999
      var expPickUpDate = this.props.opportunity && opp_key === "containerOpportunities" && this.props.opportunity.eta && parseInt(this.props.opportunity.eta);
      expPickUpDate = expPickUpDate && moment$1.utc(moment$1(expPickUpDate).utc()).toDate();
      expPickUpDate = expPickUpDate && formatDate(expPickUpDate);
      var diffDays = moment$1(new Date()).diff(moment$1(endDate), "days");
      var alreadyExpired = moment$1(new Date()).isSameOrAfter(moment$1(renewalDate), "days");
      var diffRenewalDays = moment$1(new Date(renewalDate)).diff(moment$1(new Date()), "days");
      //console.log({alreadyExpired,diffRenewalDays},"KETAN")
      var date = moment$1.utc(moment$1(endDate).utc()).toDate(); //converting epoch to date object in UTC
      //console.log("date >>  expired and renewal ", expiredDate, renewalDate)
      var oppEndDateFormatted = formatDate(endDate); //converting epoch to date object in UTC
      var oppCustAcceptanceDateFormatted = formatDate(customerAcceptanceDeadline); //converting epoch to date object in UTC
      var renewalDateFormatted = formatDate(renewalDate); //converting epoch to date object in UTC
      console.log("renewalDateFormatted ", renewalDateFormatted);
      console.log("renewalDateFormatted ", renewalDate);
      var expiredDate = renewalDate && new Date(renewalDate);
      expiredDate = expiredDate && expiredDate.toLocaleDateString("en-US", options).toUpperCase();
      //console.log("expiredDate :: ", expiredDate, renewalDate)
      var custEndDate = opportunity && parseInt(opportunity.endDate);
      var closeDateCust = new Date(custEndDate);
      closeDateCust = closeDateCust && closeDateCust.toLocaleDateString("en-Us", options).toUpperCase();

      var customerEndDate = new Date(endDate + 7 * 24 * 60 * 60 * 1000);
      customerEndDate = date.toLocaleDateString("en-US", options).toUpperCase();

      date = date.toLocaleDateString("en-US", options).toUpperCase();
      // let expireDate = expiredDate.toLocaleDateString("en-US",options).toUpperCase()


      /*
                           CUSTOMER               BID START      BID CLOSE     RENWAL     EXIPRED
                              NEW                                               Yes
                              REQUSTED                              Yes         Yes
                              ACTIVE                                            Yes 
                              REJECTED                             
                            PARTNER
                              NEW                                   Yes        
                              SUBMITTED                             Yes
                              ACTIVE                                Yes
                              REJECTED                              Yes
                             SALES
                               NEW  
                               PUBLISHED                            Yes
                               PENDING APPROVAL                     Yes
                               ACCEPTED                             Yes         Yes
                               REJECTED                             Yes
                               ARCHIVED                                                      Yes
        */
      var showBidClose = function showBidClose(app, tab) {

        if (app === DRAYAGE_APP.KLEARDRAY_CUSTOMER || tab === SELECTED_TABS.SALES_ARCHIVED) {
          //console.log("showBidClose :: hide", tab)
          return false;
        } else {
          //console.log("showBidClose :: show", tab)
          return true;
        }
      };

      var showCustomerAcceptanceDate = function showCustomerAcceptanceDate(app, tab) {

        if (app === DRAYAGE_APP.KLEARDRAY_CUSTOMER) {
          if (tab === SELECTED_TABS.CUSTOMER_ACTIVE || tab === SELECTED_TABS.CUSTOMER_REJECTED) return false;else return true;
        }
        return false;
      };

      var showRenewalDate = function showRenewalDate(app, tab) {
        if (app === DRAYAGE_APP.KLEARDRAY_CUSTOMER) {
          return tab === SELECTED_TABS.CUSTOMER_NEW || tab === SELECTED_TABS.CUSTOMER_REQUESTED || tab === SELECTED_TABS.CUSTOMER_ACTIVE;
        } else if (app == DRAYAGE_APP.KLEARDRAY_PARTNER) {
          return tab === SELECTED_TABS.PARTNER_NEW || tab === SELECTED_TABS.PARTNER_ACTIVE || tab === SELECTED_TABS.PARTNER_SUBMITTED;
        } else if (app === DRAYAGE_APP.KLEARDRAY_SALES) {
          return tab === SELECTED_TABS.SALES_PUBLISHED || tab === SELECTED_TABS.SALES_PENDING_APPROVAL;
        }
        return false;
      };

      var isSingleBidOpenedSalesTabPending = function isSingleBidOpenedSalesTabPending() {
        var _props2 = _this2.props,
            tab = _props2.tab,
            drayageApp = _props2.drayageApp;

        var classname = '';
        if (drayageApp === DRAYAGE_APP.KLEARDRAY_SALES) {

          if (partnerBids && partnerBids.length <= 1) {
            classname = "SALES_PENDING_APPROVAL_SinglePartner";
          }
          // if(tab === "SALES_PENDING_APPROVAL"){
          // }
        }
        return classname;
      };

      var splitForTooltip = function splitForTooltip(name) {
        if (!name) return "TBD";

        var firstPart = name.substring(0, 15);

        console.log("splitForTooltip :: ", name, ", firstPart", firstPart);
        return React__default.createElement(
          "div",
          null,
          firstPart,
          name.length > 15 ? React__default.createElement(Popup, { content: name, trigger: React__default.createElement(
              "b",
              null,
              React__default.createElement(
                "a",
                { style: { color: "#0A8B8F", marginTop: "-20px" } },
                "..."
              )
            ) }) : ""
        );
      };

      return React__default.createElement(
        "div",
        { "data-tab": "OPPORTUNITIES_LIST_CLOSED", className: "opportunities-list-closed" },
        React__default.createElement(
          "section",
          null,
          React__default.createElement(
            "div",
            {
              className: this.props.isOpen ? "opportunity-opened " + isSingleBidOpenedSalesTabPending() : "opportunity-closed",
              style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER && this.props.opportunity.editPartnerBidAllowed && this.props.opportunity.editPartnerBidAllowed === 1 && tab === "DRAYAGE_SUBMITTED" && editValidButton ? { position: 'relative' } : null
            },
            this.props.tab === "SALES_PENDING_APPROVAL" && React__default.createElement(
              "button",
              {
                className: "done_button" + (this.props.isDoneDisabled(opportunityId) ? " isDisabled" : ""),
                onClick: function onClick() {
                  return !_this2.props.isDoneDisabled(opportunityId) && _this2.props.onOpportunitySelect(opportunityId);
                }
              },
              "DONE"
            ),
            React__default.createElement(
              "div",
              { className: "partyName-date" },
              React__default.createElement(
                "div",
                { className: "collapsible", onClick: function onClick(e) {
                    return _this2.props.onButtonClick(false);
                  } },
                this.props.isOpen ? React__default.createElement("img", {
                  className: "arrow-img",
                  src: "/images/files/downArrow.svg",
                  alt: "",
                  onClick: this.props.cancelBid
                }) : React__default.createElement("img", {
                  className: "arrow-img",
                  src: "/images/files/sideArrow.svg",
                  alt: ""
                })
              ),
              React__default.createElement(
                "div",
                { className: "oppor-name-text" },
                opportunityName && splitForTooltip(opportunityName.toUpperCase()),
                " ",
                React__default.createElement("div", null)
              ),
              React__default.createElement(
                "div",
                { className: "date-pair" },
                showBidClose(this.props.drayageApp, tab) && React__default.createElement(
                  "div",
                  { className: "expiry-date", style: { paddingRight: "15px" } },
                  "BID CLOSE DATE: ",
                  oppEndDateFormatted
                ),
                showCustomerAcceptanceDate(this.props.drayageApp, tab) && React__default.createElement(
                  "div",
                  { className: "expiry-date", style: { paddingRight: "15px" } },
                  "CUSTOMER ACCEPTANCE DEADLINE: ",
                  oppCustAcceptanceDateFormatted
                ),
                tab === SELECTED_TABS.SALES_ARCHIVED && React__default.createElement(
                  "div",
                  { style: { paddingRight: "10px" } },
                  "EXPIRED ON:  ",
                  oppEndDateFormatted
                ),
                showRenewalDate(this.props.drayageApp, tab) && opp_key !== "containerOpportunities" && React__default.createElement(
                  "div",
                  { className: diffRenewalDays < 10 && diffRenewalDays > 0 || alreadyExpired ? "renewal-date" : "" },
                  opportunityExpiryDate && opportunityExpiryDate != 0 ? "RENEWAL DATE: " + renewalDateFormatted : ""
                ),
                showRenewalDate(this.props.drayageApp, tab) && opp_key === "containerOpportunities" && React__default.createElement(
                  "div",
                  { className: "etaDate" },
                  this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? "ETA: " : "ESTIMATED TIME OF ARRIVAL:",
                  " ",
                  expPickUpDate
                ),
                this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && tab === "SALES_ACCEPTED" && renewalDate ? React__default.createElement(
                  "div",
                  { style: { minWidth: '43%', fontSize: this.props.isOpen ? '12px' : '14px' }, className: diffRenewalDays < 10 && diffRenewalDays > 0 || alreadyExpired ? "renewal-date" : "" },
                  " RENEWAL DATE: ",
                  " ",
                  renewalDateFormatted
                ) : null,
                tab === "SALES_ACCEPTED" && (diffRenewalDays < 10 && diffRenewalDays > 0 || alreadyExpired) && this.props.isOpen && React__default.createElement(
                  "div",
                  { className: "renewBtn" },
                  React__default.createElement(
                    "button",
                    {
                      className: "",
                      onClick: function onClick() {
                        return _this2.props.renewOpportunityFunc(_this2.props.opportunity.opportunityId, true);
                      }
                    },
                    "RENEW"
                  )
                ),
                lastSubmittedDate && React__default.createElement(
                  "div",
                  { style: { marginLeft: "10px", color: "#04adb1", fontStyle: "italic" } },
                  " Last Submission: ",
                  lastSubmittedDate
                )
              )
            ),
            this.props.tab === "SALES_CUSTOMER_REQUESTED" && React__default.createElement(
              "div",
              { className: "publishBtn" },
              React__default.createElement(
                "button",
                {
                  onClick: function onClick() {
                    return _this2.props.renewOpportunityFunc(_this2.props.opportunity.opportunityId);
                  },
                  disabled: this.props.isOpen ? false : true
                },
                "PUBLISH"
              )
            ),
            partnerBids && this.props.isOpen && this.isExpandableTab() && partnerBids.map(function (partner, partnerIndex) {
              if (!_this2.state.expandedTab && partnerIndex > 0 && _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES) {
                return;
              }
              return React__default.createElement(
                "div",
                { className: "partner_header" },
                React__default.createElement(
                  "div",
                  { className: "partner-name" },
                  partner.partnerName
                ),
                React__default.createElement(
                  "div",
                  { className: "partner-bid-date" },
                  convertEpochToDate(partner.submittedDate, false, false, true)
                )
              );
            }),
            partnerBids && partnerBids.length > 1 && this.isExpandableTab() && React__default.createElement(
              "a",
              {
                href: "/#",
                className: "expandHorizontally",
                onClick: function onClick(e) {
                  _this2.setState({ expandedTab: !_this2.state.expandedTab });
                  var openedEls = document.querySelectorAll("\n\t\t\t\t\t\t\t\t\t\t\t[data-tab-container='SALES_PENDING_APPROVAL'] [data-tab='OPPORTUNITIES_LIST_OPENED'], \n\t\t\t\t\t\t\t\t\t\t\t[data-tab-container='SALES_ACCEPTED'] [data-tab='OPPORTUNITIES_LIST_OPENED'],\n\t\t\t\t\t\t\t\t\t\t\t[data-tab-container='SALES_REJECTED'] [data-tab='OPPORTUNITIES_LIST_OPENED'],\n\t\t\t\t\t\t\t\t\t\t\t[data-tab-container='SALES_ARCHIVED'] [data-tab='OPPORTUNITIES_LIST_OPENED']\n\t\t\t\t\t\t\t\t\t\t");

                  if (document.querySelector("body.hideExtraBids")) {
                    document.querySelector("body").classList.remove("hideExtraBids");
                    document.querySelector("body").classList.add("showExtraBids");

                    Array.from(openedEls).forEach(function (el) {
                      var width = el.closest(".opportunity_wrapper").querySelector(".opportunity-opened").offsetWidth;
                      el.style.width = width + "px";
                    });
                  } else {
                    document.querySelector("body").classList.add("hideExtraBids");
                    document.querySelector("body").classList.remove("showExtraBids");

                    Array.from(openedEls).forEach(function (el) {
                      el.style.width = null;
                    });
                  }
                }
              },
              React__default.createElement("img", {
                className: "arrow_left",
                src: "/images/files/arrow_left.png",
                alt: ""
              }),
              React__default.createElement("img", {
                className: "arrow_right",
                src: "/images/files/arrow_right.png",
                alt: ""
              })
            ),
            React__default.createElement(
              "div",
              { className: "opportunityCountryImgContainer" },
              this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER && this.props.opportunity.editPartnerBidAllowed && this.props.opportunity.editPartnerBidAllowed === 1 && tab === "DRAYAGE_SUBMITTED" && editValidButton ? React__default.createElement(
                "button",
                { onClick: function () {
                    var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              // getDrayageOpportunityDetails(this.props.opportunity.opportunityId,"DRAYAGE_SUBMITTED")
                              _this2.props.onButtonClick(true);
                              _this2.props.handleOpportunityBidClicked(true);
                              _this2.props.handleOpenBidModal(_this2.props.opportunity.opportunityId, _this2.props.opp_key, _this2.props.changeEditStatus());
                              // let data = await fetchCustomerOpporunityPriceDetails(this.props.opportunity.opportunityId)
                              // this.props.handleSetChargeForEdit(this.props.opportunity.opportunityId, {})

                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, _this2);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }(), className: "btn-edit-dray" },
                "EDIT"
              ) : "",
              React__default.createElement(
                "div",
                { className: "opportunityClosedMot" },
                React__default.createElement("img", { src: this.OpportunityCountryImage[opportunityCountry], alt: opportunityCountry, className: "opportunityCountryImage", height: "50", width: "40" }),
                React__default.createElement(
                  "span",
                  null,
                  getMOTImage(opportunityMot)
                )
              )
            )
          )
        )
      );
    }
  }]);
  return OpportunityClosedCommon;
}(Component);

//import { Popup } from "reactjs-popup";


var CustomerPriceCard = function (_Component) {
  inherits(CustomerPriceCard, _Component);

  function CustomerPriceCard(props) {
    var _this2 = this;

    classCallCheck(this, CustomerPriceCard);

    var _this = possibleConstructorReturn(this, (CustomerPriceCard.__proto__ || Object.getPrototypeOf(CustomerPriceCard)).call(this, props));

    _this.getCustomerLanePriceDetails = function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(opporunityId, laneId, sourceId, partnerId) {
        var priceList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("getCustomerLanePriceDetails >> 1");
                _context.next = 3;
                return fetchCustomerLanePriceDetails(opporunityId, laneId, sourceId, partnerId, _this.props.isSelectedBid);

              case 3:
                priceList = _context.sent;

                console.log("getCustomerLanePriceDetails >> 3");
                _this.setState({ priceList: priceList });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      priceList: null
    };
    return _this;
  }

  createClass(CustomerPriceCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {

      // {
      //   "baseChargeList" : [{"chargeName" : "", unitPrice : "", "amount" : "", "quantity" : 2}, {"chargeName" : "", unitPrice : "", "amount" : "", "quantity" : 2}] 
      //   "portAdditionalCharge" : [{"chargeName" : "", unitPrice : "", "amount" : "", "quantity" : 2}, {"chargeName" : "", unitPrice : "", "amount" : "", "quantity" : 2}]   
      //   "laneAdditionalCharge" : [{"chargeName" : "", unitPrice : "", "amount" : "", "quantity" : 2}, {"chargeName" : "", unitPrice : "", "amount" : "", "quantity" : 2}]   
      //  }
      //
      console.log("getCustomerLanePriceDetails :: componentDidMount ");
      var priceDetails = this.getCustomerLanePriceDetails(this.props.opportunityId, this.props.laneId, this.props.sourceId, this.props.partnerId);
      this.setState({ priceList: priceDetails });
    }
  }, {
    key: "prepareTotal",
    value: function prepareTotal(totalBaseCharge, totalLaneAdditionalCharge, totalPortCharge, knMargin) {
      var totalAmt = totalBaseCharge;
      var knMarginAmt = Math.round(totalAmt / (1 - knMargin / 100) + totalLaneAdditionalCharge + totalPortCharge);
      console.log("totalBaseCharge totalAmt knMarginAmt", totalBaseCharge, totalAmt, knMarginAmt, totalLaneAdditionalCharge, totalPortCharge);
      return knMarginAmt;
    }
  }, {
    key: "baseChargeListShowAmount",
    value: function baseChargeListShowAmount(charge, chargePercent, isKnCharge) {

      var currencyType = isKnCharge ? DRAYAGE_CURRENCY_COLUMNS.KN_CHARGES : DRAYAGE_CURRENCY_COLUMNS[this.props.tab];
      console.log('props tab, destinationData price-', this.props.tab, this.state.priceList);
      var currency = this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER ? lodash_1(this.state.priceList, 'apCurrencyCode', 'N/A') : this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? lodash_1(this.state.priceList, 'arCurrencyCode', 'N/A') : lodash_1(this.state.priceList, [currencyType], '');
      var amount = lodash_1(charge, 'amount', 0).toFixed(2);

      var glCode = lodash_1(charge, 'glCode', 0);
      var returnValue = '$0';
      console.log("baseChargeListShowAmount >>> ", charge, chargePercent, amount);
      // chargePercent = charge.chargePercent
      if (glCode === 60002) {
        if (amount > 0) {
          this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? returnValue = "(" + chargePercent + " %, " + currency + " " + amount + ")" : returnValue = currency + " " + amount + " ";
          // returnValue = `$${amount} `

        }
        if (!amount || !chargePercent) {
          returnValue = "TBD at Gate Out";
        }
      } else {
        if (amount > 0) {
          returnValue = currency + " " + amount;
        }
      }
      return returnValue;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          drayageApp = _props.drayageApp,
          tab = _props.tab;

      if (!this.state.priceList) {
        return React__default.createElement(
          "div",
          { className: "pricecard-holder " },
          React__default.createElement(
            "div",
            { className: "drayage-pricecard-header" },
            "PRICING DETAIL"
          ),
          "Fetching pricing details ...",
          React__default.createElement("br", null)
        );
      }
      console.log("priceDetails", this.state.priceList);
      var baseChargeList = lodash_1(this.state.priceList, "baseChargeList", []);
      var chargePercent = void 0;

      // let fuelPercent=0;
      //  for (let i = 0; i < baseChargeList.length; i++) {
      //    if (baseChargeList[i].glCode === 60005) {
      //      baseChargeAmount = baseChargeList[i].amount;
      //    }
      //    console.log("baseChargeAmount ", baseChargeList);
      //    if (baseChargeList[i].chargeName === "Fuel Charge") {
      //      fuelChargeAmount = baseChargeList[i].amount;

      //      fuelPercent = (fuelChargeAmount * 100) / baseChargeAmount;
      //      fuelPercent = fuelPercent.toFixed(2)
      //      console.log("fuelPercent", fuelPercent);
      //    }
      //}
      for (var i = 0; i < baseChargeList.length; i++) {
        if (baseChargeList[i].glCode === 60002) chargePercent = baseChargeList[i].chargePercent;
      }

      var isFuelChargePresent = baseChargeList.findIndex(function (o) {
        return o.glCode === 60002;
      });

      var knMargin = lodash_1(this.state.priceList, "knMargin", null);
      var totalBaseCharge = lodash_1(this.state.priceList, "totalBaseCharge", "");
      var portChargeList = lodash_1(this.state.priceList, "portChargeList", []);
      var laneAdditionalChargeList = lodash_1(this.state.priceList, "laneAdditionalChargeList", []);
      var totalPortCharge = lodash_1(this.state.priceList, "totalPortCharge", []);
      var totalLaneAdditionalCharge = lodash_1(this.state.priceList, "totalLaneAdditionalCharge", []);

      var splitForTooltip = function splitForTooltip(name) {
        if (!name) return "";

        var firstPart = name.substring(0, 14);

        return React__default.createElement(
          React__default.Fragment,
          null,
          firstPart,
          name.length > 14 ? React__default.createElement(Popup, {
            content: name,
            trigger: React__default.createElement(
              "b",
              null,
              React__default.createElement(
                "a",
                { style: { color: "#0A8B8F", marginTop: "-80px" } },
                "  ",
                " ..."
              )
            )
          }) : ""
        );
      };

      console.log("priceDetails baseChargeList ", baseChargeList);
      // console.log("isFuelChargePresent :: ", isFuelChargePresent)

      var knBaseChargeList = lodash_1(this.state.priceList, "knBaseChargeList", []);
      var knchargePercent = void 0;

      for (var _i = 0; _i < knBaseChargeList.length; _i++) {
        if (knBaseChargeList[_i].glCode === 60002) knchargePercent = knBaseChargeList[_i].chargePercent;

        console.log("knchargePercent", knchargePercent);
      }
      var knTotalBaseCharge = lodash_1(this.state.priceList, "knTotalBaseCharge", "");
      var knTotalLaneAdditionalCharge = lodash_1(this.state.priceList, "knTotalLaneAdditionalCharge", []);
      var knPortChargeList = lodash_1(this.state.priceList, "knPortChargeList", []);
      var knLaneAdditionalChargeList = lodash_1(this.state.priceList, "knLaneAdditionalChargeList", []);
      var knTotalPortCharge = lodash_1(this.state.priceList, "knTotalPortCharge", []);

      var amountColorMap = {};

      console.log("priceDetails laneAdditionalChargeList knLaneAdditionalChargeList ", laneAdditionalChargeList, knLaneAdditionalChargeList, knLaneAdditionalChargeList.length);

      var tmp = {}; //map of glcode to kn amount code 
      for (var j = 0; j < knLaneAdditionalChargeList.length; j++) {
        var glCode = knLaneAdditionalChargeList[j].glCode;
        tmp[glCode] = knLaneAdditionalChargeList[j].amount;
      }

      for (var _i2 = 0; _i2 < laneAdditionalChargeList.length; _i2++) {

        var _glCode = laneAdditionalChargeList[_i2].glCode;
        var knAmout = tmp[_glCode] ? tmp[_glCode] : 0.0;
        if (laneAdditionalChargeList[_i2].amount > knAmout) {
          amountColorMap[_glCode] = "red";
        } else {
          amountColorMap[_glCode] = "black";
        }
      }
      var baseColorMap = {};
      var baseTmp = {};
      for (var _i3 = 0; _i3 < knBaseChargeList.length; _i3++) {
        var _glCode2 = knBaseChargeList[_i3].glCode;
        baseTmp[_glCode2] = knBaseChargeList[_i3].amount;
      }
      for (var _j = 0; _j < baseChargeList.length; _j++) {
        var _glCode3 = baseChargeList[_j].glCode;
        var knbaseamount = baseTmp[_glCode3] ? baseTmp[_glCode3] : 0.0;
        if (baseChargeList[_j].amount >= knbaseamount) {
          baseColorMap[_glCode3] = "red";
        } else {
          baseColorMap[_glCode3] = "black";
        }
      }
      var portColorMap = {};
      var portTmp = {};
      for (var _i4 = 0; _i4 < knPortChargeList.length; _i4++) {
        var _glCode4 = knPortChargeList[_i4].glCode;
        portTmp[_glCode4] = knPortChargeList[_i4].amount;
      }
      for (var _j2 = 0; _j2 < portChargeList.length; _j2++) {
        var _glCode5 = portChargeList[_j2].glCode;
        var knportamount = portTmp[_glCode5] ? portTmp[_glCode5] : 0.0;
        if (portChargeList[_j2].amount >= knportamount) {
          portColorMap[_glCode5] = "red";
        } else {
          portColorMap[_glCode5] = "black";
        }
      }

      var currencyTypeForNotSales = this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER ? lodash_1(this.state.priceList, 'apCurrencyCode', 'N/A') : this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? lodash_1(this.state.priceList, 'arCurrencyCode', '') : "";

      return React__default.createElement(
        "div",
        { className: "priceCardContainer" },
        drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && (tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED") ? React__default.createElement(
          "div",
          { style: { height: "min-content" }, className: "pricecard-holder " },
          React__default.createElement(
            "div",
            { className: "drayage-pricecard-header" },
            "PRICING DETAIL"
          ),
          React__default.createElement(
            "div",
            { className: "general-row" },
            React__default.createElement(
              "div",
              null,
              baseChargeList && React__default.createElement(
                "div",
                { style: { paddingLeft: "16px" }, className: "pricecard-charges-name" },
                "PARTNER CHARGES:"
              ),
              baseChargeList && baseChargeList.map(function (charge) {
                //console.log("baseChargeList",baseChargeList)
                //console.log("Charge amount ::", charge.amount, parseFloat(charge.amount).toFixed(2))
                // let amount = parseFloat((charge.amount)).toFixed(2)
                //let  amount= amountToCommaSeparated(charge.amount)
                var amount = amountToTwoDecimalWithoutSplit(charge.amount, true, _this3.state.priceList[DRAYAGE_CURRENCY_COLUMNS[tab]]);
                return React__default.createElement(
                  "div",
                  null,
                  React__default.createElement(
                    "div",
                    { className: "base-row pricecard-basefees" },
                    React__default.createElement(
                      "div",
                      { className: "pricecard-basefees-text" },
                      splitForTooltip(charge.chargeName),
                      ":"
                    ),
                    React__default.createElement(
                      "div",
                      { className: "pricecard-basefees-amount with-percentage" },
                      charge.chargeName === "BASE CHARGE" ? _this3.baseChargeListShowAmount(charge, chargePercent) : React__default.createElement(
                        "div",
                        { className: "general-row" },
                        React__default.createElement(
                          "div",
                          null,
                          "Estd: ",
                          _this3.baseChargeListShowAmount(charge, chargePercent)
                        ),
                        React__default.createElement(
                          "div",
                          { style: { fontSize: "10px", color: "#2e6cc2", paddingRight: "1px", paddingLeft: "1px", letterSpacing: "0.5px" } },
                          " ( TBD at Gate Out)"
                        )
                      )
                    )
                  )
                );
              })
            ),
            React__default.createElement(
              "div",
              null,
              knBaseChargeList && React__default.createElement(
                "div",
                { style: { paddingLeft: "16px" }, className: "pricecard-charges-name" },
                "KN CHARGES:"
              ),
              knBaseChargeList && knBaseChargeList.map(function (charge) {

                console.log("Charge amount ::", charge, parseFloat(charge.amount).toFixed(2));
                console.log("Charge Percent ", charge, chargePercent, knchargePercent);
                // let amount = parseFloat((charge.amount)).toFixed(2)
                //let  amount= amountToCommaSeparated(charge.amount)
                var amount = amountToTwoDecimalWithoutSplit(charge.amount, true, _this3.state.priceList[DRAYAGE_CURRENCY_COLUMNS[tab]]);
                return React__default.createElement(
                  "div",
                  null,
                  React__default.createElement(
                    "div",
                    { className: "base-row pricecard-basefees" },
                    React__default.createElement(
                      "div",
                      { className: "pricecard-basefees-text" },
                      " ",
                      charge.chargeName,
                      ":"
                    ),
                    React__default.createElement(
                      "div",
                      { className: "pricecard-basefees-amount with-percentage", style: { fontWeight: "bold", color: baseColorMap[charge.glCode] } },
                      _this3.baseChargeListShowAmount(charge, knchargePercent, true)
                    )
                  )
                );
              })
            )
          ),
          React__default.createElement("br", null),
          React__default.createElement(
            "div",
            { className: "general-row" },
            React__default.createElement(
              "div",
              null,
              portChargeList && portChargeList.length > 0 && React__default.createElement(
                "div",
                { className: "pricecard-charges-name" },
                " PORT ADDL. CHARGES"
              ),
              portChargeList && portChargeList.length > 0 ? portChargeList.map(function (charge) {
                //let  amount= amountToCommaSeparated(charge.amount)
                var amount = amountToTwoDecimalWithoutSplit(charge.amount, true, _this3.state.priceList[DRAYAGE_CURRENCY_COLUMNS[tab]]);

                if (charge && charge.chargeName) {
                  return React__default.createElement(
                    "div",
                    null,
                    React__default.createElement(
                      "div",
                      { className: "base-row pricecard-basefees" },
                      React__default.createElement(
                        "div",
                        { className: "pricecard-basefees-text" },
                        splitForTooltip(charge.chargeName),
                        ":"
                      ),
                      React__default.createElement(
                        "div",
                        { className: "pricecard-basefees-amount", style: { fontWeight: "bold" } },
                        amount
                      )
                    )
                  );
                }
              }) : React__default.createElement("div", { className: "base-row pricecard-basefees", style: { backgroundColor: '#fff' } })
            ),
            React__default.createElement(
              "div",
              null,
              knPortChargeList && knPortChargeList.length > 0 && React__default.createElement(
                "div",
                { className: "pricecard-charges-name" },
                " PORT ADDL. CHARGES"
              ),
              knPortChargeList && knPortChargeList.length > 0 ? knPortChargeList.map(function (charge) {
                //let  amount= amountToCommaSeparated(charge.amount)
                var amount = amountToTwoDecimalWithoutSplit(charge.amount, true, _this3.state.priceList[DRAYAGE_CURRENCY_COLUMNS[tab]]);
                if (charge && charge.chargeName) {
                  return React__default.createElement(
                    "div",
                    null,
                    React__default.createElement(
                      "div",
                      { className: "base-row pricecard-basefees" },
                      React__default.createElement(
                        "div",
                        { className: "pricecard-basefees-text" },
                        splitForTooltip(charge.chargeName),
                        ":"
                      ),
                      React__default.createElement(
                        "div",
                        { className: "pricecard-basefees-amount", style: { fontWeight: "bold", color: portColorMap[charge.glCode] } },
                        amount
                      )
                    )
                  );
                }
              }) : React__default.createElement("div", { className: "base-row pricecard-basefees", style: { backgroundColor: '#fff' } })
            )
          ),
          React__default.createElement("br", null),
          React__default.createElement(
            "div",
            { className: "general-row" },
            React__default.createElement(
              "div",
              null,
              laneAdditionalChargeList && laneAdditionalChargeList.length > 0 && React__default.createElement(
                "div",
                { className: "pricecard-charges-name" },
                " LANE ADDL. CHARGES"
              ),
              laneAdditionalChargeList && laneAdditionalChargeList.length > 0 ? laneAdditionalChargeList.map(function (charge) {
                //let  amount= amountToCommaSeparated(charge.amount)
                var amount = amountToTwoDecimalWithoutSplit(charge.amount, true, _this3.state.priceList[DRAYAGE_CURRENCY_COLUMNS[tab]]);
                if (charge && charge.chargeName) {
                  return React__default.createElement(
                    "div",
                    null,
                    React__default.createElement(
                      "div",
                      { className: "base-row pricecard-basefees" },
                      React__default.createElement(
                        "div",
                        { className: "pricecard-basefees-text" },
                        splitForTooltip(charge.chargeName),
                        ":"
                      ),
                      React__default.createElement(
                        "div",
                        { className: "pricecard-basefees-amount" },
                        amount
                      )
                    )
                  );
                }
              }) : React__default.createElement("div", { className: "base-row pricecard-basefees", style: { backgroundColor: '#fff' } })
            ),
            React__default.createElement(
              "div",
              null,
              knLaneAdditionalChargeList && knLaneAdditionalChargeList.length > 0 && React__default.createElement(
                "div",
                { className: "pricecard-charges-name" },
                "LANE ADDL. CHARGES"
              ),
              knLaneAdditionalChargeList && knLaneAdditionalChargeList.length > 0 ? knLaneAdditionalChargeList.map(function (charge) {
                //let  amount= amountToCommaSeparated(charge.amount)
                var amount = amountToTwoDecimalWithoutSplit(charge.amount, true, _this3.state.priceList[DRAYAGE_CURRENCY_COLUMNS.KN_CHARGES]);
                if (charge && charge.chargeName) {
                  return React__default.createElement(
                    "div",
                    null,
                    React__default.createElement(
                      "div",
                      { className: "base-row pricecard-basefees" },
                      React__default.createElement(
                        "div",
                        { className: "pricecard-basefees-text" },
                        charge.chargeName,
                        ":"
                      ),
                      React__default.createElement(
                        "div",
                        { className: "pricecard-basefees-amount", style: { color: amountColorMap[charge.glCode] } },
                        amount
                      )
                    )
                  );
                }
              }) : React__default.createElement("div", { className: "base-row pricecard-basefees", style: { backgroundColor: '#fff' } }),
              knMargin && React__default.createElement(
                "div",
                { className: "base-row pricecard-basefees" },
                React__default.createElement(
                  "div",
                  { className: "pricecard-basefees-text" },
                  "  KN Margin "
                ),
                React__default.createElement(
                  "div",
                  { className: "pricecard-basefees-amount" },
                  knMargin,
                  "%"
                )
              )
            )
          )
        ) : React__default.createElement(
          "div",
          { className: "pricecard-holder " },
          React__default.createElement(
            "div",
            { className: "drayage-pricecard-header" },
            "PRICING DETAIL"
          ),
          React__default.createElement(
            "div",
            null,
            baseChargeList && React__default.createElement(
              "div",
              { style: { paddingLeft: "16px" }, className: "pricecard-charges-name" },
              lodash_1(this.props, "drayageApp", "") === DRAYAGE_APP.KLEARDRAY_PARTNER ? "PARTNER" : "KN",
              " CHARGES:"
            ),
            baseChargeList && baseChargeList.map(function (charge) {
              console.log("Charge amount ::", charge.amount, parseFloat(charge.amount).toFixed(2));
              // let amount = parseFloat((charge.amount)).toFixed(2)
              //let  amount= amountToCommaSeparated(charge.amount)
              var amount = amountToTwoDecimalWithoutSplit(charge.amount, true);
              return React__default.createElement(
                "div",
                null,
                React__default.createElement(
                  "div",
                  { className: "base-row pricecard-basefees" },
                  React__default.createElement(
                    "div",
                    { className: "pricecard-basefees-text" },
                    charge.chargeName,
                    ":"
                  ),
                  React__default.createElement(
                    "div",
                    { className: "pricecard-basefees-amount with-percentage" },
                    charge.chargeName === "BASE CHARGE" ? _this3.baseChargeListShowAmount(charge, chargePercent) : React__default.createElement(
                      "div",
                      { className: "general-row" },
                      React__default.createElement(
                        "div",
                        null,
                        "Estd:",
                        _this3.baseChargeListShowAmount(charge, chargePercent)
                      ),
                      React__default.createElement(
                        "div",
                        { style: { fontSize: "10px", color: "#2e6cc2", paddingRight: "1px", paddingLeft: "1px", letterSpacing: "0.5px" } },
                        "(TBD at Gate Out)"
                      )
                    )
                  )
                )
              );
            }),
            baseChargeList && React__default.createElement(
              "div",
              { className: "base-row pricecard-basefees card-totals-row" },
              React__default.createElement(
                "div",
                { style: { width: "140px" } },
                "TOTAL:"
              ),
              React__default.createElement(
                "div",
                { className: "pricecard-charges-name", style: { fontWeight: "bold", paddingLeft: "20px" } },
                totalBaseCharge && totalBaseCharge ? amountToTwoDecimalWithoutSplit(totalBaseCharge, true, currencyTypeForNotSales) : 0
              )
            )
          ),
          React__default.createElement("br", null),
          React__default.createElement(
            "div",
            null,
            portChargeList && portChargeList.length > 0 && React__default.createElement(
              "div",
              { className: "pricecard-charges-name" },
              " PORT ADDL. CHARGES"
            ),
            portChargeList && portChargeList.length > 0 ? portChargeList.map(function (charge) {
              //let  amount= amountToCommaSeparated(charge.amount)
              var amount = amountToTwoDecimalWithoutSplit(charge.amount, true, currencyTypeForNotSales);
              if (charge && charge.chargeName) {
                return React__default.createElement(
                  "div",
                  null,
                  React__default.createElement(
                    "div",
                    { className: "base-row pricecard-basefees" },
                    React__default.createElement(
                      "div",
                      { className: "pricecard-basefees-text" },
                      splitForTooltip(charge.chargeName),
                      ":"
                    ),
                    React__default.createElement(
                      "div",
                      { className: "pricecard-basefees-amount", style: { fontWeight: "bold" } },
                      amount
                    )
                  )
                );
              }
            }) : React__default.createElement("div", { className: "base-row pricecard-basefees", style: { backgroundColor: '#fff' } }),
            totalPortCharge > 0 && React__default.createElement(
              "div",
              { className: "base-row pricecard-basefees card-totals-row" },
              React__default.createElement(
                "div",
                { style: { width: "140px" } },
                "TOTAL:"
              ),
              React__default.createElement(
                "div",
                { style: { fontWeight: "bold", paddingLeft: "20px" } },
                amountToTwoDecimalWithoutSplit(totalPortCharge, true, currencyTypeForNotSales)
              )
            )
          ),
          React__default.createElement("br", null),
          React__default.createElement(
            "div",
            null,
            laneAdditionalChargeList && laneAdditionalChargeList.length > 0 && React__default.createElement(
              "div",
              { className: "pricecard-charges-name" },
              " LANE ADDL. CHARGES"
            ),
            laneAdditionalChargeList && laneAdditionalChargeList.length > 0 ? laneAdditionalChargeList.map(function (charge) {
              //let  amount= amountToCommaSeparated(charge.amount)
              var amount = amountToTwoDecimalWithoutSplit(charge.amount, true, currencyTypeForNotSales);
              //console.log("LANE ADDITIONAL CHARGE >>> ", charge,  amount)
              if (charge && charge.chargeName) {
                return React__default.createElement(
                  "div",
                  null,
                  React__default.createElement(
                    "div",
                    { className: "base-row pricecard-basefees" },
                    React__default.createElement(
                      "div",
                      { className: "pricecard-basefees-text" },
                      splitForTooltip(charge.chargeName),
                      ":"
                    ),
                    React__default.createElement(
                      "div",
                      { className: "pricecard-basefees-amount", style: { fontWeight: "bold" } },
                      amount
                    )
                  )
                );
              }
            }) : React__default.createElement("div", { className: "base-row pricecard-basefees", style: { backgroundColor: '#fff' } }),
            totalLaneAdditionalCharge > 0 && React__default.createElement(
              "div",
              { className: "base-row pricecard-basefees card-totals-row" },
              React__default.createElement(
                "div",
                { style: { width: "140px"
                  } },
                "TOTAL:"
              ),
              React__default.createElement(
                "div",
                { className: "pricecard-charges-name", style: { fontWeight: "bold", paddingLeft: "20px" } },
                amountToTwoDecimalWithoutSplit(totalLaneAdditionalCharge, true, currencyTypeForNotSales)
              )
            )
          ),
          knMargin && React__default.createElement(
            "div",
            { className: "base-row pricecard-basefees" },
            React__default.createElement(
              "div",
              { className: "pricecard-basefees-text" },
              "  KN Margin: "
            ),
            React__default.createElement(
              "div",
              { className: "pricecard-basefees-amount" },
              knMargin,
              "%"
            )
          )
        )
      );
    }
  }]);
  return CustomerPriceCard;
}(Component);

var KnHoverablePopup = function (_Component) {
  inherits(KnHoverablePopup, _Component);

  function KnHoverablePopup(props) {
    classCallCheck(this, KnHoverablePopup);

    var _this = possibleConstructorReturn(this, (KnHoverablePopup.__proto__ || Object.getPrototypeOf(KnHoverablePopup)).call(this, props));

    _this.handleMouseEnter = function () {
      clearTimeout(_this.timerId);
      _this.timerId = setTimeout(function () {
        _this.setState({ open: true });
      }, 200);
    };

    _this.handleMouseLeave = function () {
      clearTimeout(_this.timerId);
      _this.timerId = setTimeout(function () {
        _this.setState({ open: false });
      }, 200);
    };

    _this.state = {
      open: false
    };
    _this.timerId = null;
    return _this;
  }

  createClass(KnHoverablePopup, [{
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _props = this.props,
          content = _props.content,
          trigger = _props.trigger,
          position = _props.position;

      return React__default.createElement(Popup, {
        open: open,
        content: React__default.createElement(
          "div",
          {
            onMouseLeave: this.handleMouseLeave,
            onMouseEnter: this.handleMouseEnter
          },
          content
        ),
        trigger: cloneElement(trigger, {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }),
        position: position ? position : 'top center'
      });
    }
  }]);
  return KnHoverablePopup;
}(Component);

var DestinationLane = function (_Component) {
  inherits(DestinationLane, _Component);

  function DestinationLane(props) {
    classCallCheck(this, DestinationLane);

    // let isSelected = get(this.props.destinationData,"isSelected",false)
    // let lanePriceSelected = false
    // if (isSelected && isSelected === "YES") {
    //   lanePriceSelected = true
    // }
    var _this = possibleConstructorReturn(this, (DestinationLane.__proto__ || Object.getPrototypeOf(DestinationLane)).call(this, props));

    _this.customerPricecardHandler = function (laneId, price) {
      _this.setState({
        priceClicked: !_this.state.priceClicked,
        priceClickedLaneId: laneId,
        priceOfClickedLane: price
      });
    };

    _this.priceCardCaneled = function () {
      _this.setState({ priceClickedLaneId: "" });
    };

    _this.getTotals = function (wantsPortLevel) {
      var destinationData = _this.props.destinationData;


      var totals = [],
          portDataIsMap = false;

      if (_this.props.portData) {
        if (_this.props.portData instanceof Map) portDataIsMap = true;

        var portCodeClone = _this.props.portData;
        if (!portDataIsMap) {
          portCodeClone = new Map();
          portCodeClone.set(_this.props.portData.sourceId, _this.props.portData);
        }

        var ports = Array.from(portCodeClone.keys());
        if (wantsPortLevel) ports = [destinationData.sourceId];

        for (var j = 0; j < ports.length; j++) {
          var portCode = portCodeClone.get(ports[j]).sourceId;
          var thisPortData = portCodeClone.get(portCode);

          var _loop = function _loop(i) {
            var _thisPortData$destina = thisPortData.destinations[i],
                partnerBids = _thisPortData$destina.partnerBids,
                approxVolume = _thisPortData$destina.approxVolume;


            partnerBids.forEach(function (bid, j) {
              if (!totals[j]) totals[j] = 0;
              totals[j] += partnerBids[j].bidAmount * Number(approxVolume);
            });
          };

          for (var i = 0; i < thisPortData.destinations.length; i++) {
            _loop(i);
          }
        }
      }

      return totals;
    };

    _this.selectBox = function (e, partnerId, laneId) {
      var _this$props = _this.props,
          portId = _this$props.portId,
          opportunityId = _this$props.opportunityId,
          customerId = _this$props.customerId;

      var parentEl = e.target.closest(".handle-select-box");
      var laneEl = e.target.closest(".lane-row");

      if (parentEl.classList.contains("is-selected")) {
        laneEl.classList.remove("laneSelected");
        parentEl.classList.remove("is-selected");
        _this.props.unSelectBid(partnerId, laneId, portId, opportunityId, customerId);
      } else {
        laneEl.classList.add("laneSelected");
        parentEl.classList.add("is-selected");
        _this.props.selectBid(partnerId, laneId, portId, opportunityId, customerId);
      }
    };

    _this.loadOpportunityDetails = function () {
      _this.props.getOpportunityDetailsApi(_this.props.opportunityId, _this.props.tab, false);
      _this.setState({ isLanePriceUpdating: false });
    };

    _this.customerSelectBox = function (e, destinationData) {
      _this.props.setCustomerLanePriceSelected(_this.props.opportunityId, destinationData.laneId, !(destinationData.isSelected === "YES"), _this.props.tab);
      // this.props.getOpportunityDetailsApi(this.props.opportunityId, this.props.tab, false)
      setTimeout(_this.loadOpportunityDetails, 1000);
      _this.setState({ isLanePriceUpdating: true });
      // this.setState({ islanePriceSelected: !this.state.islanePriceSelected })
      // this.props.setLanePriceSelected(
      //   this.props.opportunityId,
      //   destinationData.sourceId,
      //   destinationData.laneId,
      //   selected
      // destinationData.unitPrice,
      // );
      //this.props.selectBid(partnerId, laneId, portId, opportunityId, customerId)
    };

    _this.state = {
      bidData: {},
      priceClickedLaneId: "",
      priceOfClickedLane: ""
      // islanePriceSelected:lanePriceSelected,
      // isLanePriceUpdating: false,
    };
    return _this;
  }

  createClass(DestinationLane, [{
    key: "render",


    //this.props.drayageApp , "this.props.drayageApp"
    value: function render() {
      var _this2 = this;

      var laneColumns = lodash_1(this.props, "opp_key") === "containerOpportunities" ? OpportunityOpenedColumnValuesContainers[this.props.drayageApp][this.props.tab] : OpportunityOpenedColumnValues[this.props.drayageApp][this.props.tab];

      // let laneColumns = OpportunityOpenedColumnValues[this.props.drayageApp][this.props.tab.split(" ").join("_") + "_SALES"]

      //this.props.destinationData
      // baseFees: "600"
      // chasisRentalperday: "12"
      // fuelCharges: "2"
      // minReqDays: "12"
      //bidBaseTotal
      var bidBaseTotal = lodash_1(this.props, "destinationData.destinationBidData.bidBaseTotal", null);

      var _props = this.props,
          destinationData = _props.destinationData,
          tab = _props.tab,
          drayageApp = _props.drayageApp;
      // console.log("destinationData, DestinationLane>>>>",destinationData,)

      var destinationName = destinationData.destinationId;
      var destinationApproxVolume = destinationData["approxVolume"];
      var proposedBid = destinationData["proposedBid"];
      var totalPrice = destinationData["totalPrice"];
      var totalProposedAmount = destinationData["totalProposedAmount"];

      // let totalPrice = parseInt(destinationData["approxVolume"]) * destinationData["proposedBid"];
      var portId = destinationData.sourceId;
      var sourceId = destinationData.sourceId;
      var sourceName = destinationData.source;
      var laneId = destinationData.laneId;
      var inEditStatus = destinationData.partnerBids && destinationData.partnerBids[0].inEdit ? destinationData.partnerBids[0].inEdit : 0;
      var containers = destinationData.containers;
      var containersToDisplay = "";
      if (containers) {
        containersToDisplay = containers.join(' , ');
      }

      //let sorcePortName=destinationData.sourceName
      var destinationAddressNamelower = lodash_1(destinationData["destinationAddress"], "addressName.value", "NONE");
      var destinationAddressName = destinationAddressNamelower && destinationAddressNamelower.toUpperCase();

      destinationAddressName = !destinationAddressName ? "TBD" : destinationAddressName;

      var addressInfo = lodash_1(destinationData, "destination", '');

      // let addressName = extractAddressToDisplay(addressInfo);
      var addressName = addressInfo;

      totalPrice = amountToShortString(totalPrice);

      var lowestBid = Number.MAX_SAFE_INTEGER;
      var numOfBids = destinationData.partnerBids ? destinationData.partnerBids.length : 0;
      for (var i = 0; i < numOfBids; i++) {
        if (destinationData.partnerBids[i].bidAmount < lowestBid) lowestBid = destinationData.partnerBids[i].bidAmount;
      }

      var splitForTooltip = function splitForTooltip(name) {
        // // if(!name)
        // return"TBD"

        var firstPart = name ? name.substring(0, 20) : "";

        return React__default.createElement(
          React__default.Fragment,
          null,
          firstPart,
          name && name.length > 20 ? React__default.createElement(Popup, {
            content: name,
            trigger: React__default.createElement(
              "b",
              null,
              React__default.createElement(
                "a",
                { href: "/#", style: { color: "#0A8B8F" } },
                "..."
              )
            )
          }) : ""
        );
      };

      var priceBackgroundColor = function priceBackgroundColor(props, destinationData) {
        if (isCustomerActiveTab(props)) {
          if (destinationData.customerStatus === "CUSTOMER_ACTIVE") {
            return {
              backgroundColor: "#EAFCFD",
              border: "1px solid #1EA507",
              padding: "5px 8px"
            };
          }
        }

        if (isCustomerRejectedTab(props)) {
          if (destinationData.customerStatus === "CUSTOMER_REJECTED") {
            return {
              backgroundColor: "#EDC7BE",
              border: "1px solid #F18A72",
              padding: "5px 8px"
            };
          } else if (destinationData.customerStatus === "CUSTOMER_ACTIVE") {
            return { padding: "5px 8px" };
          }
        }

        return "white";
      };
      var submitBidColorClass = null;
      var totalBidColorClass = null;

      var partnerStatus = "PARTNER_STATUS_NONE";
      if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.props.columnDataLane[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = slicedToArray(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            if (key === "PartnerStatus") {
              partnerStatus = value && value.length > 0 ? value[0] : partnerStatus;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var laneDisabled = false;
      switch (partnerStatus) {
        case "PARTNER_NEW":
          break;

        case "PARTNER_REJECTED":
          if (this.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
            totalBidColorClass = " data-light-red";
            submitBidColorClass = " data-solid-red";
          } else if (this.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
            laneDisabled = true;
            submitBidColorClass = " data-solid-gray";
          }
          break;

        case "PARTNER_SUBMITTED":
          break;

        case "PARTNER_ACTIVE":
          if (this.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
            submitBidColorClass = " data-solid-green";
          } else if (this.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
            laneDisabled = true;
          }
          break;

        default:
          break;
      }
      if (laneDisabled && (this.props.activeLanesOnly || this.props.tab === SELECTED_TABS.PARTNER_REJECTED)) {
        return null;
      }

      var getCoumnClassName = function getCoumnClassName(column, submitBidColorClass, totalBidColorClass, isTotalRow) {
        if (isTotalRow) {
          return "data-other-col";
        }
        switch (column.name) {
          case "SubmittedBid":
            if (submitBidColorClass) {
              return column.classname1 + submitBidColorClass;
            } else if (inEditStatus === 1) {
              return column.classname3;
            } else {
              return column.classname1;
            }
          case "Total":
            if (totalBidColorClass) {
              return column.classname1 + totalBidColorClass;
            } else {
              return column.classname1;
            }
          default:
            return column.classname1;
        }
      };

      var isSelected = this.props.destinationData.isSelected;
      // let lanePriceSelected = false
      // if (isSelected  && isSelected === "YES") {
      //   lanePriceSelected = true
      // }

      var computeAmountDisplay = function computeAmountDisplay(amount, column) {
        // let result = amount
        // if (column.amountDisplayFunc) {
        console.log("computeAmountDisplay >>> ", amount, column);
        return column.amountDisplayFunc(amount, column.isPrice, column);
        // }
        // return amount
      };

      console.log("DestinationLane >>> ", this.props, laneColumns);

      return React__default.createElement(
        "tr",
        {
          className: "destinationDataRow"
          // className={
          //   !rowColorClass
          //     ? "lane-row data-row"
          //     : "lane-row data-row " + rowColorClass
          // }
          , style: laneDisabled ? this.props.isTotalRow || this.props.isGrandTotalRow ? { color: "gray" } : { color: "gray", backgroundColor: "white" } : this.props.isTotalRow || this.props.isGrandTotalRow ? null : { backgroundColor: "white" }
        },
        React__default.createElement(
          "td",
          {
            style: { width: isCustomerNewTab(this.props) ? 'auto' : 50 } },
          React__default.createElement(
            "div",
            { className: "rowAlignCentered" },
            isCustomerNewTab(this.props) && this.props.totalNumberOfLanes > 1 && this.props.totalNumberOfPortLanes === 1 ? React__default.createElement(Checkbox, {
              className: "laneSelectionCheckBox",
              value: isSelected === "YES" ? true : false,
              label: ".",
              onChange: function onChange(e) {
                _this2.props.handleLaneSelection(destinationData.laneId, isSelected === "YES" ? "NO" : "YES");
              },
              checked: isSelected === "YES" ? true : false
            }) : null,
            isCustomerNewTab(this.props) && this.props.totalNumberOfLanes > 0 && this.props.totalNumberOfPortLanes > 1 ? React__default.createElement(Checkbox, {
              className: "laneSelectionCheckBox",
              value: isSelected === "YES" ? true : false,
              label: ".",
              onChange: function onChange(e) {
                _this2.props.handleLaneSelection(destinationData.laneId, isSelected === "YES" ? "NO" : "YES");
              },
              checked: isSelected === "YES" ? true : false
            }) : null,
            !(this.props.isTotalRow || this.props.isGrandTotalRow) && React__default.createElement("img", {
              className: "opportunityRowIcon",
              src: "images/files/warehouse.svg",
              alt: ""
            })
          )
        ),
        React__default.createElement(
          "td",
          null,
          React__default.createElement(
            "div",
            { className: "colAlign extraBottomPadding" },
            !(this.props.isTotalRow || this.props.isGrandTotalRow) && React__default.createElement(
              "div",
              { className: "small-text" },
              "TO"
            ),
            !(this.props.isTotalRow || this.props.isGrandTotalRow) && React__default.createElement(
              "div",
              { className: "portName-text" },
              React__default.createElement(
                "div",
                null,
                splitForTooltip(addressName)
              )
            ),
            (this.props.isTotalRow || this.props.isGrandTotalRow) && React__default.createElement("div", {
              style: {
                fontSize: "18px",
                textAlign: "right",
                paddingTop: "18px"
              }
            })
          )
        ),
        laneColumns && laneColumns.map(function (column) {
          console.log("column >>> ", column);
          if ((_this2.props.isTotalRow || _this2.props.isGrandTotalRow) && !["ApproxVolume", "ApproxTotalBusiness", "Total"].includes(column.name)) {
            return React__default.createElement(
              "td",
              null,
              React__default.createElement(
                "div",
                { className: "colAlignCentered" },
                React__default.createElement(
                  "div",
                  {
                    className: getCoumnClassName(column, submitBidColorClass, totalBidColorClass, _this2.props.isTotalRow || _this2.props.isGrandTotalRow)
                  },
                  React__default.createElement("div", { className: column.classname2 })
                )
              )
            );
          }
          return (
            // <div className={column.name === "SubmittedBid" ? (submitBidColorClass ? column.classname1 + submitBidColorClass  :   column.classname1) :
            //               ( column.name === "Total" ? totalBidColorClass ? column.classname1 + totalBidColorClass  :  column.classname1 : column.classname1)}>
            React__default.createElement(
              "td",
              null,
              React__default.createElement(
                "div",
                { className: "colAlignCentered" },
                React__default.createElement(
                  "div",
                  {
                    className: getCoumnClassName(column, submitBidColorClass, totalBidColorClass, _this2.props.isTotalRow || _this2.props.isGrandTotalRow)
                  },
                  React__default.createElement(
                    "div",
                    { className: column.classname2 },
                    column.name === "UnitPrice" || column.name === "TotalBaseCharge" ? React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(
                        "div",
                        { id: "unitPriceCust"
                          // className="unitPrice-btn customer-handle-select-box"
                          , className: "laneValueText rowAlignCentered",
                          style: {
                            backgroundColor: priceBackgroundColor(_this2.props, destinationData).backgroundColor,
                            border: priceBackgroundColor(_this2.props, destinationData).border,
                            padding: priceBackgroundColor(_this2.props, destinationData).padding
                            // paddingTop: "15px"

                          },
                          onMouseOver: !isCustomerNewTab(_this2.props) && column.name === "UnitPrice" ? function (e) {
                            _this2.customerPricecardHandler(destinationData.laneId);
                          } : null
                          // onMouseLeave={(e) => {
                          //   this.priceCardCaneled(
                          //     destinationData.laneId
                          //   );
                          // }}
                        },
                        React__default.createElement(
                          "div",
                          { className: "laneValueText" },
                          React__default.createElement(
                            "span",
                            { className: "currencyType", style: { fontSize: 12 } },
                            column.currencyType ? _this2.props.columnDataLane.get(column.currencyType) : ''
                          ),
                          ' ',
                          " here",
                          computeAmountDisplay(_this2.props.columnDataLane.get(column.name), column)
                        ),
                        column.name === "UnitPrice" && React__default.createElement(KnHoverablePopup, {
                          position: "top right",
                          content: _this2.props.destinationData.laneId === _this2.state.priceClickedLaneId ? React__default.createElement(CustomerPriceCard, {
                            priceCardCaneled: _this2.priceCardCaneled,
                            opportunityId: _this2.props.opportunityId,
                            laneId: destinationData.laneId,
                            sourceId: destinationData.sourceId,
                            style: { backgroundColor: "white" },
                            drayageApp: drayageApp,
                            destinationData: _this2.props.destinationData,
                            tab: tab
                          }) : null,
                          trigger: React__default.createElement(
                            "div",
                            {
                              onMouseOver: function onMouseOver(e) {
                                _this2.customerPricecardHandler(destinationData.laneId);
                              },
                              className: "priceInfoIcon"
                            },
                            React__default.createElement(Icon, {
                              name: "info circle",
                              color: "blue",
                              size: "small",
                              style: { margin: 0 }
                            })
                          )
                        })
                      )
                    ) : React__default.createElement(
                      "div",
                      {
                        onMouseOver: function onMouseOver(e) {
                          if (column.name === "SubmittedBid") {
                            _this2.customerPricecardHandler(destinationData.laneId);
                          }
                        },
                        title: _this2.props.opp_key === "containerOpportunities" && _this2.props.drayageApp === "KLEARDRAY_CUSTOMER" && column.classname2 === "cont-num" ? destinationData.containers && destinationData.containers.join(' , ') : null
                      },
                      " ",
                      React__default.createElement(
                        "span",
                        { className: "currencyType", style: { fontSize: 12 } },
                        column.currencyType ? lodash_1(destinationData.partnerBids[0], column.currencyType, 'N/A') : ''
                      ),
                      computeAmountDisplay(_this2.props.columnDataLane.get(column.name), column),
                      " ",
                      column.name === "SubmittedBid" && React__default.createElement(KnHoverablePopup, {
                        position: "top right",
                        content: _this2.props.destinationData.laneId === _this2.state.priceClickedLaneId ? React__default.createElement(CustomerPriceCard, {
                          priceCardCaneled: _this2.priceCardCaneled,
                          opportunityId: _this2.props.opportunityId,
                          laneId: destinationData.laneId,
                          sourceId: destinationData.sourceId,
                          style: { backgroundColor: "white" },
                          drayageApp: drayageApp,
                          destinationData: _this2.props.destinationData,
                          tab: tab
                        }) : null,
                        trigger: React__default.createElement(Icon, {
                          name: "info circle"
                          // color="blue"
                          , size: "small",
                          style: { color: "revert", margin: 0 },
                          onMouseOver: function onMouseOver(e) {
                            _this2.customerPricecardHandler(destinationData.laneId);
                          }
                        })
                      }),
                      _this2.props.opp_key === "containerOpportunities" && _this2.props.drayageApp === "KLEARDRAY_CUSTOMER" && column.name === "ApproxVolume" &&
                      //isCustomerNewTab(this.props) &&

                      React__default.createElement(
                        Popup,
                        {
                          trigger: React__default.createElement(Icon, {
                            name: "warning circle",
                            color: "blue",
                            size: "small",
                            style: { position: "absolute", backgroundColor: "white" }

                          }),
                          size: "mini"
                          //position="top center"
                        },
                        React__default.createElement(
                          List,
                          null,
                          React__default.createElement(
                            List.Item,
                            null,
                            React__default.createElement(
                              List.Content,
                              null,
                              React__default.createElement(
                                List.Header,
                                null,
                                "CONTAINERS:"
                              ),
                              React__default.createElement(
                                List.Description,
                                null,
                                containersToDisplay
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          );
        }),
        (this.props.isTotalRow || this.props.isGrandTotalRow) && (tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED") && this.getTotals().map(function (val) {
          return React__default.createElement(
            "div",
            { className: "partner-total-footer" },
            "$",
            amountToShortString(val)
          );
        }),
        (tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED") && React__default.createElement(
          React__default.Fragment,
          null,
          destinationData.partnerBids && destinationData.partnerBids.map(function (bid) {
            return React__default.createElement(
              "div",
              {
                className: "bid-col handle-select-box",
                "bid-status-sales": bid.salesStatus,
                "bid-status-customer": bid.customerStatus
              },
              (bid.salesStatus === "SALES_ACCEPTED" || bid.customerStatus === "CUSTOMER_ACCEPTED") && tab === "SALES_ACCEPTED" && React__default.createElement(Icon, {
                name: "check circle outline",
                className: "accepted_tick",
                size: "small"
              }),
              bid.bidAmount < proposedBid && React__default.createElement(Icon, {
                name: "long arrow alternate down",
                className: "low_bid_arrow",
                size: "small"
              }),
              React__default.createElement(KnHoverablePopup, {
                position: "top right",
                content: React__default.createElement(CustomerPriceCard, {
                  priceCardCaneled: _this2.priceCardCaneled,
                  opportunityId: _this2.props.opportunityId,
                  laneId: destinationData.laneId,
                  sourceId: destinationData.sourceId,
                  partnerId: bid.partnerId,
                  isSelectedBid: (bid.salesStatus === "SALES_ACCEPTED" || bid.customerStatus === "CUSTOMER_ACCEPTED") && tab === "SALES_ACCEPTED",
                  drayageApp: drayageApp,
                  destinationData: _this2.props.destinationData,
                  tab: tab
                }),
                trigger: React__default.createElement(
                  "div",
                  {
                    className: "partner-bid handle-select-box-child1" + (tab !== "SALES_REJECTED" && bid.bidAmount < proposedBid ? " low-bid" : "") + (tab !== "SALES_REJECTED" && bid.bidAmount === lowestBid ? " lowest-bid" : "")
                  },
                  "$",
                  bid.bidAmount
                )
              }),
              React__default.createElement(
                "div",
                {
                  className: "partner-bid-total handle-select-box-child2" + (tab !== "SALES_REJECTED" && bid.bidAmount < proposedBid ? " low-bid" : "") + (tab !== "SALES_REJECTED" && bid.bidAmount === lowestBid ? " lowest-bid" : "")
                },
                amountToTwoDecimal(bid.bidAmount * destinationData["approxVolume"], true),
                React__default.createElement(
                  Popup,
                  {
                    trigger: React__default.createElement(Icon, {
                      name: "warning circle top-right",
                      color: "blue",
                      size: "small"
                    }),
                    size: "mini",
                    position: "top center"
                  },
                  React__default.createElement(
                    List,
                    null,
                    React__default.createElement(
                      List.Item,
                      null,
                      React__default.createElement(
                        List.Content,
                        null,
                        React__default.createElement(
                          List.Header,
                          { className: "float-left" },
                          "Capacity:"
                        ),
                        React__default.createElement(
                          List.Description,
                          { className: "float-left" },
                          tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" ? !bid.capacityAccepted ? 'Not Available' : bid.capacityAccepted + " containers" : bid.capacityPerMonth + " containers"
                        )
                      )
                    ),
                    React__default.createElement(
                      List.Item,
                      null,
                      React__default.createElement(
                        List.Content,
                        null,
                        React__default.createElement(
                          List.Header,
                          { className: "float-left" },
                          "Renew due on:",
                          " "
                        ),
                        React__default.createElement(
                          List.Description,
                          { className: "float-left" },
                          _this2.props.opp_key === "containerOpportunities" ? destinationData.containers && destinationData.containers.join(' , ') : enhanceFormatter(bid.rateValidUntilDate).toLocaleUpperCase()
                        )
                      )
                    )
                  )
                )
              ),
              React__default.createElement("br", null),
              React__default.createElement(
                "div",
                {
                  className: "select_box",
                  onClick: function onClick(e) {
                    return _this2.selectBox(e, bid.partnerId, destinationData.laneId);
                  }
                },
                React__default.createElement(
                  "p",
                  { className: "show_as_unselected" },
                  "SELECT"
                ),
                React__default.createElement(
                  "p",
                  { className: "show_as_selected" },
                  React__default.createElement(Icon, {
                    name: "check circle outline",
                    className: "accepted_tick selected"
                  }),
                  "SELECTED"
                )
              ),
              bid.customerStatus === "CUSTOMER_ACCEPTED" && tab === "SALES_ACCEPTED" && React__default.createElement(
                "div",
                { className: "customerAccepted" },
                "Customer Accepted"
              ),
              bid.customerStatus === "CUSTOMER_REJECTED" && tab === "SALES_REJECTED" && React__default.createElement(
                "div",
                { className: "customerRejected" },
                "Customer Rejected"
              )
            );
          })
        )
      );
    }
  }]);
  return DestinationLane;
}(Component);

var PortOpportunity = function (_Component) {
  inherits(PortOpportunity, _Component);

  function PortOpportunity(props) {
    classCallCheck(this, PortOpportunity);

    var _this = possibleConstructorReturn(this, (PortOpportunity.__proto__ || Object.getPrototypeOf(PortOpportunity)).call(this, props));

    _this.isExpandableTab = function () {
      var tab = _this.props.tab;

      return tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED";
    };

    _this.splitForTooltip = function (name) {

      var firstPart = name ? name.substring(0, 20) : "";

      return React__default.createElement(
        React__default.Fragment,
        null,
        firstPart,
        name && name.length > 20 ? React__default.createElement(Popup, {
          content: name,
          trigger: React__default.createElement(
            "b",
            { style: { color: "#000" } },
            "..."
          )
        }) : ""
      );
    };

    _this.handleLaneSelection = function (laneId, status) {
      var allLanes = _this.state.destinations;
      var isAllSelected = false;
      var numberOfLanesSelected = 0;
      if (Array.isArray(allLanes) && allLanes.length > 0) {
        var laneIndex = 0;
        for (laneIndex = 0; laneIndex < allLanes.length; laneIndex++) {
          if (laneId === allLanes[laneIndex].laneId) {
            _this.props.setLanePriceSelected(_this.props.opportunityId, allLanes[laneIndex].sourceId, allLanes[laneIndex].laneId, status);
            allLanes[laneIndex].isSelected = status;
            if (status === "YES") numberOfLanesSelected += 1;
          } else {
            if (lodash_1(allLanes[laneIndex], 'isSelected', false) === 'YES') {
              numberOfLanesSelected += 1;
            }
          }
        }
        isAllSelected = numberOfLanesSelected === allLanes.length ? true : false;
        _this.setState({ destinations: allLanes, isAllLaneSelected: isAllSelected, numberOfLanesSelected: numberOfLanesSelected });
        _this.props.updateTotalNumberOfLanesSelected(_this.props.portId, numberOfLanesSelected);
      }
    };

    _this.handleAllLanesSelection = function (status) {
      var allLanes = _this.state.destinations;
      if (Array.isArray(allLanes) && allLanes.length > 0) {
        var laneIndex = 0;
        for (laneIndex = 0; laneIndex < allLanes.length; laneIndex++) {
          _this.props.setLanePriceSelected(_this.props.opportunityId, allLanes[laneIndex].sourceId, allLanes[laneIndex].laneId, status);
          allLanes[laneIndex].isSelected = status;
        }
        _this.setState({
          isAllLaneSelected: status === "YES" ? true : false,
          destinations: allLanes,
          numberOfLanesSelected: status === "YES" ? allLanes.length : 0
        });
        _this.props.updateTotalNumberOfLanesSelected(_this.props.portId, status === "YES" ? allLanes.length : 0);
      }
    };

    _this.checkForAllLanesSelected = function () {
      var allLanes = lodash_1(_this.props.portData, 'destinations', []);
      var isAllSelected = false;
      var numberOfLanesSelected = 0;
      if (Array.isArray(allLanes) && allLanes.length > 0) {
        var laneIndex = 0;
        for (laneIndex = 0; laneIndex < allLanes.length; laneIndex++) {
          if (lodash_1(allLanes[laneIndex], 'isSelected', false) === 'YES') numberOfLanesSelected += 1;
        }
        isAllSelected = numberOfLanesSelected === allLanes.length ? true : false;
        _this.setState({ isAllLaneSelected: isAllSelected, numberOfLanesSelected: numberOfLanesSelected });
        _this.props.updateTotalNumberOfLanesSelected(_this.props.portId, numberOfLanesSelected);
      }
    };

    var destinations = lodash_1(_this.props.portData, 'destinations', []);

    _this.state = {
      priceClicked: false,
      isAllLaneSelected: false,
      destinations: destinations,
      numberOfLanesSelected: 0,
      totalNumberOfLanes: Array.isArray(destinations) ? destinations.length : 0
    };
    return _this;
  }

  createClass(PortOpportunity, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkForAllLanesSelected();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var drayageApp = this.props.drayageApp;
      /* Compute total Volume across all lanes */

      var getInEditStatus = function getInEditStatus() {
        var inEditStatus = 0;

        for (var i = 0; i < _this2.props.portData.destinations.length; i++) {
          var destinations = _this2.props.portData.destinations[i];

          if (_this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
            var inEdit = destinations && destinations.partnerBids && destinations.partnerBids.length > 0 && destinations.partnerBids[0].inEdit ? destinations.partnerBids[0].inEdit : 0;
            inEditStatus = inEdit;
          }
        }
        return inEditStatus;
      };
      var inEditStatus = getInEditStatus();

      var getTotalVolume = function getTotalVolume() {
        var totalVolume = 0;

        for (var i = 0; i < _this2.props.portData.destinations.length; i++) {
          var destinations = _this2.props.portData.destinations[i];

          if (_this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
            var status = destinations && destinations.partnerBids && destinations.partnerBids.length > 0 ? destinations.partnerBids[0].partnerStatus : "NONE";
            if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
              if (_this2.props.activeLanesOnly) {
                if (status === "PARTNER_REJECTED") {
                  continue;
                }
              }
            } else if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
              if (status !== "PARTNER_REJECTED") {
                continue;
              }
            }
          }

          var cont = _this2.props.portData.destinations[i].approxVolume;
          totalVolume += cont;
        }
        return totalVolume;
      };

      /* Compute total submitted business across all lanes */
      var getTotals = function getTotals() {
        var totals = [];

        var _loop = function _loop(i) {
          var _props$portData$desti = _this2.props.portData.destinations[i],
              partnerBids = _props$portData$desti.partnerBids,
              approxVolume = _props$portData$desti.approxVolume;

          // totals[0] += bids[0].bidAmount;

          if (partnerBids) {
            partnerBids.forEach(function (bid, j) {
              if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE && _this2.props.activeLanesOnly && partnerBids[j].partnerStatus === "PARTNER_REJECTED") {
                return;
              }

              if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED && _this2.props.activeLanesOnly && partnerBids[j].partnerStatus !== "PARTNER_REJECTED") {
                return;
              }

              if (!totals[j]) totals[j] = 0;
              totals[j] += (partnerBids[j].bidAmount || 0) * Number(approxVolume);
            });
          }
        };

        for (var i = 0; i < _this2.props.portData.destinations.length; i++) {
          _loop(i);
        }
        return totals;
      };
      var totalVol = getTotalVolume();

      /* Compute total suggested business across all lanes */
      var totalBussiness = function totalBussiness() {
        var total = 0;

        for (var i = 0; i < _this2.props.portData.destinations.length; i++) {
          var destinations = _this2.props.portData.destinations[i];

          if (_this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
            var status = destinations && destinations.partnerBids && destinations.partnerBids.length > 0 ? destinations.partnerBids[0].partnerStatus : "NONE";
            if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
              if (_this2.props.activeLanesOnly) {
                if (status === "PARTNER_REJECTED") {
                  continue;
                }
              }
            } else if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
              if (status !== "PARTNER_REJECTED") {
                continue;
              }
            }
          }

          var cont = _this2.props.portData.destinations[i].approxVolume;
          var price = _this2.props.portData.destinations[i].proposedBid || 0;
          total = total + cont * price;
        }
        return total;
      };
      var totalBuss = totalBussiness();
      // totalBuss = totalBuss > 1000000 ? totalBuss / 1000000 + "M" : totalBuss;
      //console.log("source this.props original", this.props)
      var source = this.props.portData.source && this.props.portData.source.toUpperCase();
      console.log("source this.props original", source);
      var tab = this.props.tab;
      // if (tab === "Submitted")  {
      //   className = "content-open submitted"
      // }

      var headers = this.props.isLane ? OpportunityOpenedHeaader[this.props.drayageApp][tab] : OpportunityOpenedHeaaderContainer[this.props.drayageApp][tab];
      // let widthContentOPen = getWidthContentOPen(this.props.drayageApp,tab)

      var grandTotalsForPort = getTotals();
      var totalColumnDataLane = new Map();
      totalColumnDataLane.set("ApproxVolume", totalVol);
      totalColumnDataLane.set("ApproxTotalBusiness", totalBuss);
      totalColumnDataLane.set("Total", grandTotalsForPort);

      var isAnyLaneEnabled = function isAnyLaneEnabled() {

        var allLaneData = _this2.props.columnDataPort;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = allLaneData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = slicedToArray(_ref, 2);

            var key = _ref2[0];
            var columnDataLane = _ref2[1];

            var partnerStatus = "PARTNER_STATUS_NONE";
            if (_this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = columnDataLane[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = slicedToArray(_ref3, 2);

                  var _key = _ref4[0];
                  var value = _ref4[1];

                  if (_key === "PartnerStatus") {
                    partnerStatus = value && value.length > 0 ? value[0] : partnerStatus;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }

            var laneDisabled = false;
            switch (partnerStatus) {
              case "PARTNER_REJECTED":
                if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
                  laneDisabled = true;
                }
                break;

              case "PARTNER_ACTIVE":
                if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
                  laneDisabled = true;
                }
                break;

              default:
                break;
            }

            if (!laneDisabled) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return false;
      };

      if ((this.props.tab === SELECTED_TABS.PARTNER_REJECTED || this.props.activeLanesOnly) && !isAnyLaneEnabled()) {
        return null;
      }
      return React__default.createElement(
        "div",
        { className: "portOpportunityContentCommon" },
        React__default.createElement(
          "table",
          {
            //style={{ width: widthContentOPen["width"] }}
            // className="port-content-open"
            className: "portOpportunityTableCommon"
          },
          React__default.createElement(
            "tbody",
            null,
            React__default.createElement(
              "tr",
              null,
              React__default.createElement(
                "td",
                {
                  style: { width: isCustomerNewTab(this.props) ? 'auto' : 50 } },
                React__default.createElement(
                  "div",
                  { className: "rowAlignCentered extraBottomPadding" },
                  this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && this.state.totalNumberOfLanes > 1 && isCustomerNewTab(this.props) ? React__default.createElement(Checkbox, {
                    className: "laneSelectionCheckBox",
                    value: this.state.isAllLaneSelected,
                    label: ".",
                    onChange: function onChange(e) {
                      return _this2.handleAllLanesSelection(_this2.state.isAllLaneSelected ? "NO" : "YES");
                    },
                    checked: this.state.isAllLaneSelected
                  }) : isCustomerNewTab(this.props) && this.props.totalNumberOfPortLanes > 1 ? React__default.createElement("div", { style: { width: 32 } }) : null,
                  React__default.createElement("img", {
                    className: "opportunityRowIcon",
                    src: "images/files/anchor.svg",
                    alt: ""
                  })
                )
              ),
              React__default.createElement(
                "td",
                null,
                React__default.createElement(
                  "div",
                  { className: "colAlign" },
                  React__default.createElement(
                    "div",
                    null,
                    React__default.createElement(
                      "div",
                      { className: "small-text" },
                      "FROM"
                    ),
                    React__default.createElement(
                      "div",
                      { className: "sourceName" },
                      this.splitForTooltip(source)
                    )
                  )
                )
              ),
              headers && headers.map(function (header, idx) {
                return React__default.createElement(
                  "td",
                  { key: idx },
                  React__default.createElement(
                    "div",
                    { className: header.classLevel1 },
                    React__default.createElement(
                      "div",
                      { className: header.classLevel2 },
                      _this2.props.opp_key === "containerOpportunities" && header.containerUpper ? header.containerUpper : header.upper === "Submitted Bid" && inEditStatus === 1 ? "Saved Bid" : header.upper
                    ),
                    React__default.createElement(
                      "div",
                      { className: header.classLevel3 },
                      _this2.props.opp_key === "containerOpportunities" && header.containerLower ? header.containerLower : header.upper === "Submitted Bid" && inEditStatus === 1 ? "(Please Re-submit)" : header.lower
                    )
                  )
                );
              }),
              this.isExpandableTab() && getTotals().map(function () {
                return React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(
                    "div",
                    { className: "bid-per-container" },
                    React__default.createElement(
                      "div",
                      { className: "sec-col-header-text" },
                      "Bid"
                    ),
                    React__default.createElement(
                      "div",
                      { className: "lower" },
                      "Per Container"
                    )
                  ),
                  React__default.createElement(
                    "div",
                    { className: "total-bid" },
                    React__default.createElement(
                      "div",
                      { className: "sec-col-header-text" },
                      "Total"
                    ),
                    React__default.createElement("div", { className: "" })
                  )
                );
              })
            ),
            this.state.destinations && this.state.destinations.map(function (destinationData) {
              return React__default.createElement(DestinationLane, {
                activeLanesOnly: _this2.props.activeLanesOnly,
                opportunityId: _this2.props.opportunityId,
                destinationData: destinationData,
                columnDataLane: _this2.props.columnDataPort.get(destinationData.laneId),
                tableData: getTableDataForTab(_this2.props.tab, _this2.props.drayageApp, destinationData),
                totalVol: totalVol,
                opp_key: _this2.props.opp_key,
                totalBuss: totalBuss,
                tab: _this2.props.tab,
                drayageApp: _this2.props.drayageApp,
                selectBid: _this2.props.selectBid,
                unSelectBid: _this2.props.unSelectBid,
                setLanePriceSelected: _this2.props.setLanePriceSelected,
                customerId: _this2.props.customerId,
                portId: _this2.props.portId,
                setCustomerLanePriceSelected: _this2.props.setCustomerLanePriceSelected,
                getOpportunityDetailsApi: _this2.props.getOpportunityDetailsApi,
                isTotalRow: false,
                portData: _this2.props.portData,
                isLane: _this2.props.isLane,
                handleLaneSelection: _this2.handleLaneSelection,
                totalNumberOfLanes: _this2.state.totalNumberOfLanes,
                totalNumberOfPortLanes: _this2.props.totalNumberOfPortLanes
              });
            })
          )
        ),
        this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && this.props.isLastPort && this.props.tab === SELECTED_TABS.CUSTOMER_NEW && React__default.createElement(
          "div",
          { className: "opportunityFooter" },
          this.state.totalNumberOfLanes > 1 || this.props.totalNumberOfPortLanes > 1 ?
          // && this.props.totalNumberOfLanesSelected > 0 ?
          React__default.createElement(
            "div",
            { className: "footerLaneTextContainer" },
            React__default.createElement(
              "span",
              { className: "laneCountText" },
              this.props.totalNumberOfLanesSelected,
              " lane selected "
            ),
            React__default.createElement(
              "span",
              { className: "laneSelectionWarningText" },
              React__default.createElement(Icon, {
                name: "warning circle",
                color: "#CD214A"
              }),
              "Unselected opportunities will be automatically rejected."
            )
          ) : React__default.createElement("div", null),
          React__default.createElement(
            "div",
            { className: "footerBtnRow" },
            React__default.createElement(
              "button",
              {
                onClick: function onClick(e) {
                  if (_this2.props.totalNumberOfLanesSelected > 0 && (_this2.state.totalNumberOfLanes > 1 || _this2.props.totalNumberOfPortLanes > 1)) return;
                  if (_this2.state.totalNumberOfLanes === 1 && _this2.props.totalNumberOfPortLanes === 1) _this2.handleLaneSelection(_this2.state.destinations[0].laneId, "NO");
                  _this2.props.customerBidmodalHandler(_this2.props.opportunityId);
                },
                className: "opportunityRejectionBtn " + (this.props.totalNumberOfLanesSelected > 0 && (this.state.totalNumberOfLanes > 1 || this.props.totalNumberOfPortLanes > 1) ? 'disabledRejectionBtn' : '')
              },
              "PROCEED TO REJECT"
            ),
            React__default.createElement(
              "button",
              {
                onClick: function onClick(e) {
                  if (_this2.props.totalNumberOfLanesSelected === 0 && (_this2.state.totalNumberOfLanes > 1 || _this2.props.totalNumberOfPortLanes > 1)) return;
                  if (_this2.state.totalNumberOfLanes === 1 && _this2.props.totalNumberOfPortLanes === 1) _this2.handleLaneSelection(_this2.state.destinations[0].laneId, "YES");
                  _this2.props.customerBidmodalHandler(_this2.props.opportunityId);
                },
                className: "opportunityApprovalBtn " + (this.props.totalNumberOfLanesSelected === 0 && (this.state.totalNumberOfLanes > 1 || this.props.totalNumberOfPortLanes > 1) ? 'disabledApprovalBtn' : '')
              },
              "PROCEED TO APPROVE"
            )
          )
        )
      );
    }
  }]);
  return PortOpportunity;
}(Component);

var OpportunityOpenedCommon = function (_Component) {
  inherits(OpportunityOpenedCommon, _Component);

  function OpportunityOpenedCommon(props) {
    classCallCheck(this, OpportunityOpenedCommon);

    var _this = possibleConstructorReturn(this, (OpportunityOpenedCommon.__proto__ || Object.getPrototypeOf(OpportunityOpenedCommon)).call(this, props));

    _initialiseProps$1.call(_this);

    var opportunityData = _this.props.opportunityData.get(_this.props.opportunity.opportunityId);
    var portData = lodash_1(opportunityData, "portData", new Map());

    _this.state = {
      // showModal: false,
      // showLaneBidCard: false,
      // showAddCard: false,
      // selectedPortCode : "",
      // selectedsource : "",
      // selectedsourceName:"",
      // selectedDestinationName : "",
      // selectedLaneId : "",
      // selectedDestinationLaneData :"",
      // selectedPortId: "",
      // selectedLaneDestination: "",
      // selectedPortName: "",
      // selectedDestination: "",
      // total: "800",

      // isPort: false,
      opportunityDetails: {},

      // opportunityPortsData: [],
      // destinationData: "",
      // showPortWiseBidModal: false,

      /*
       * Opened landBidCard
       */
      // openedLanePortId : "",
      // openedLaneDestination : "",
      // openedLaneData : "",
      totalNumberOfPortLanes: portData.size,
      portSelectionData: new Map(),
      totalNumberOfLanesSelected: 0
    };

    _this.openOpportunity = React__default.createRef();
    return _this;
  }

  createClass(OpportunityOpenedCommon, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      //const { data, header } = this.props;

      console.log("MarketplacePortalCommon >>> OpportunityBody >>> ", this.props);

      var thisOpportunityData = this.props.opportunityData.get(this.props.opportunity.opportunityId);

      if (!thisOpportunityData) {
        return React__default.createElement(
          "div",
          null,
          "Opportunity not found"
        );
      }

      var grandTotalVol = thisOpportunityData.grandTotalVolume;
      var grandTotalAmount = thisOpportunityData.grandTotalAmount;
      var opportunityExpiryDate = thisOpportunityData.opportunityExpiryDate;
      var endDate = parseInt(opportunityExpiryDate);

      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "UTC"
      };
      var expirationDate = moment$1.utc(moment$1(endDate).utc()).toDate(); //converting epoch to date object in UTC
      expirationDate = expirationDate.toLocaleDateString("en-US", options).toUpperCase();

      // grandTotalAmount = grandTotalAmount > 1000000  ? parseFloat(grandTotalAmount / 1000000).toFixed(2) + "M" : grandTotalAmount;
      //  let grandTotalAm
      // if(grandTotalAmount && grandTotalAmount > 1000000){
      //   grandTotalAm = (grandTotalAmount / 1000000)
      //   grandTotalAm = parseFloat(grandTotalAm)
      //   grandTotalAm = grandTotalAm.toFixed(2)+"M"
      //   grandTotalAmount= grandTotalAm
      // }
      // else{
      //   grandTotalAmount=grandTotalAmount
      // }

      // let opportunity = this.props.opportunityData.get(this.props.opportunity.opportunityId)

      var partnerBids = [];

      if (thisOpportunityData.portData && thisOpportunityData.portData.destinations) {
        var portData = thisOpportunityData.portData;
        partnerBids = portData.destinations.values().next().value.partnerBids;
      }

      var widthGrandAction = getWidthGrandAction(this.props.drayageApp, this.props.tab);

      /* Compute total submitted business across all lanes */
      var getTotals = function getTotals(portData) {
        if (!portData) {
          return 0;
        }

        var totals = [];
        var totalVolume = 0;
        var totalProposedBusiness = 0;

        var _loop = function _loop(i) {
          var _portData$destination = portData.destinations[i],
              partnerBids = _portData$destination.partnerBids,
              approxVolume = _portData$destination.approxVolume,
              proposedBid = _portData$destination.proposedBid;

          var rejected = false;

          if (partnerBids) {
            partnerBids.forEach(function (bid, j) {
              if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE && _this2.props.activeLanesOnly && partnerBids[j].partnerStatus === "PARTNER_REJECTED") {
                rejected = true;
              }

              if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED && partnerBids[j].partnerStatus !== "PARTNER_REJECTED") {
                rejected = true;
              }

              if (!totals[j]) totals[j] = 0;
              totals[j] += partnerBids[j].bidAmount * Number(approxVolume);
            });
          }

          // totals[0] += bids[0].bidAmount;
          if (!rejected) {
            totalVolume += approxVolume;
            totalProposedBusiness += (proposedBid || 0) * Number(approxVolume);
          }
        };

        for (var i = 0; i < portData.destinations.length; i++) {
          _loop(i);
        }
        return { totals: totals, totalVolume: totalVolume, totalProposedBusiness: totalProposedBusiness };
      };

      var grandTotal = 0;
      var grandTotalVolume = 0;
      var grandTotalProposedBusiness = 0;
      if (thisOpportunityData && thisOpportunityData.portData) {
        Array.from(thisOpportunityData.portData.keys()).forEach(function (portId) {
          var x = getTotals(thisOpportunityData.portData.get(portId));
          grandTotal += x["totals"][0];
          grandTotalVolume += x["totalVolume"];
          grandTotalProposedBusiness += x["totalProposedBusiness"];
        });
      }

      var grandTotalColumnDataLane = new Map();
      grandTotalColumnDataLane.set("ApproxVolume", grandTotalVolume);
      grandTotalColumnDataLane.set("ApproxTotalBusiness", grandTotalProposedBusiness);
      grandTotalColumnDataLane.set("Total", grandTotal);

      if (this.isExpandableTab()) grandTotalColumnDataLane.set("GrandTotalBids", this.getGrandTotals());

      return React__default.createElement(
        "div",
        { "data-tab": "OPPORTUNITIES_LIST_OPENED", ref: this.openOpportunity, className: "opportunities-list-opened" },
        React__default.createElement(
          "div",
          null,
          thisOpportunityData && thisOpportunityData.portData && Array.from(thisOpportunityData.portData.keys()).map(function (portId, portIndex) {
            return React__default.createElement(PortOpportunity, {
              activeLanesOnly: _this2.props.activeLanesOnly,
              opportunityId: _this2.props.opportunity.opportunityId,
              portData: thisOpportunityData.portData.get(portId),
              columnDataPort: _this2.props.columnDataOpportunity.get(portId),
              additionalCharges: _this2.props.additionalCharges,
              partnerId: _this2.props.partnerId,
              tab: _this2.props.tab,
              drayageApp: _this2.props.drayageApp,
              selectBid: _this2.props.selectBid,
              unSelectBid: _this2.props.unSelectBid,
              setLanePriceSelected: _this2.props.setLanePriceSelected,
              customerId: _this2.props.customerId,
              portId: portId,
              opp_key: _this2.props.opp_key,
              setCustomerLanePriceSelected: _this2.props.setCustomerLanePriceSelected,
              grandTotalVol: grandTotalVol,
              grandTotalAmount: grandTotalAmount,
              getOpportunityDetailsApi: _this2.props.getOpportunityDetailsApi,
              expirationDate: expirationDate,
              isLane: _this2.props.isLane,
              customerBidmodalHandler: _this2.props.customerBidmodalHandler,
              totalNumberOfPortLanes: _this2.state.totalNumberOfPortLanes,
              isLastPort: portIndex === _this2.state.totalNumberOfPortLanes - 1,
              updateTotalNumberOfLanesSelected: _this2.updateTotalNumberOfLanesSelected,
              totalNumberOfLanesSelected: _this2.state.totalNumberOfLanesSelected
            });
          })
        ),
        this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER && this.props.tab === SELECTED_TABS.PARTNER_NEW && React__default.createElement(
          "div",
          {
            style: { height: "60px" },
            className: "grand-action"
          },
          React__default.createElement(
            "div",
            { className: "action-btn" },
            React__default.createElement(
              "div",
              null,
              React__default.createElement(
                "button",
                {
                  className: "bid-btn",
                  onClick: function onClick(e) {
                    _this2.props.handleOpportunityBidClicked(false);
                    _this2.props.handleOpenBidModal(_this2.props.opportunity.opportunityId, _this2.props.opp_key);
                  }
                },
                "BID"
              )
            )
          )
        )
      );
    }
  }]);
  return OpportunityOpenedCommon;
}(Component);

var _initialiseProps$1 = function _initialiseProps() {
  var _this3 = this;

  this.updateTotalNumberOfLanesSelected = function (portId, count) {
    var portSelectionData = _this3.state.portSelectionData;
    var totalNumberOfLanesSelected = 0;
    portSelectionData.set(portId, count);
    portSelectionData.forEach(function (value, key) {
      totalNumberOfLanesSelected += value;
    });
    _this3.setState({ portSelectionData: portSelectionData, totalNumberOfLanesSelected: totalNumberOfLanesSelected });
  };

  this.componentDidMount = function () {
    // this.getOpportunityDetailsData(this.props.opportunity.opportunityId);

    var tab = _this3.props.tab;

    if (tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED") {
      var el = _this3.openOpportunity.current;
      var width = el.closest(".opportunity_wrapper").querySelector(".opportunity-opened").offsetWidth;

      _this3.openOpportunity.current.style.width = width + "px";
      // this.openOpportunity.current.style.minWidth = '100%';
    }
  };

  this.getGrandTotals = function () {
    var totals = [];
    // let thisOpportunityData =   this.props.opportunityData.get(this.props.opportunity.opportunityId)
    var portData = _this3.props.opportunityData.get(_this3.props.opportunity.opportunityId).portData;
    if (portData) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = portData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = slicedToArray(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];
          var destinations = value.destinations;

          var _loop2 = function _loop2(i) {
            var _destinations$i = destinations[i],
                partnerBids = _destinations$i.partnerBids,
                approxVolume = _destinations$i.approxVolume;
            // totals[0] += bids[0].bidAmount;

            partnerBids.forEach(function (bid, j) {
              if (!totals[j]) totals[j] = 0;
              totals[j] += (partnerBids[j].bidAmount || 0) * Number(approxVolume);
            });
          };

          for (var i = 0; i < destinations.length; i++) {
            _loop2(i);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    return totals;
  };

  this.isExpandableTab = function () {
    var tab = _this3.props.tab;

    return tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED";
  };
};

var note = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2218%22%20height%3D%2222%22%20viewBox%3D%220%200%2018%2022%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M14%202H17C17.2652%202%2017.5196%202.10536%2017.7071%202.29289C17.8946%202.48043%2018%202.73478%2018%203V21C18%2021.2652%2017.8946%2021.5196%2017.7071%2021.7071C17.5196%2021.8946%2017.2652%2022%2017%2022H1C0.734784%2022%200.48043%2021.8946%200.292893%2021.7071C0.105357%2021.5196%200%2021.2652%200%2021V3C0%202.73478%200.105357%202.48043%200.292893%202.29289C0.48043%202.10536%200.734784%202%201%202H4V0H6V2H12V0H14V2ZM4%208V10H14V8H4ZM4%2012V14H14V12H4Z%22%20fill%3D%22%23877A6E%22%2F%3E%3Cpath%20d%3D%22M14%202H17C17.2652%202%2017.5196%202.10536%2017.7071%202.29289C17.8946%202.48043%2018%202.73478%2018%203V21C18%2021.2652%2017.8946%2021.5196%2017.7071%2021.7071C17.5196%2021.8946%2017.2652%2022%2017%2022H1C0.734784%2022%200.48043%2021.8946%200.292893%2021.7071C0.105357%2021.5196%200%2021.2652%200%2021V3C0%202.73478%200.105357%202.48043%200.292893%202.29289C0.48043%202.10536%200.734784%202%201%202H4V0H6V2H12V0H14V2ZM4%208V10H14V8H4ZM4%2012V14H14V12H4Z%22%20fill%3D%22%2370665C%22%2F%3E%3C%2Fsvg%3E";

function KnModal$1(props) {
  var dimmer = props.dimmer,
      open = props.open,
      onClose = props.onClose,
      header = props.header,
      content = props.content,
      size = props.size,
      actionButtons = props.actionButtons,
      className = props.className;

  return React__default.createElement(
    Modal,
    { dimmer: dimmer, open: open, onClose: onClose, size: size, className: className },
    header && React__default.createElement(
      Modal.Header,
      null,
      header
    ),
    content && React__default.createElement(
      Modal.Content,
      null,
      content
    ),
    actionButtons && React__default.createElement(
      Modal.Actions,
      null,
      actionButtons.map(function (button) {
        return React__default.createElement(
          Button,
          { className: "primaryButton", onClick: button.onClick },
          button.name
        );
      })
    )
  );
}

var css_248z$n = ".style-module_knModalContainer__2sYh1 .content {\n  width: 100% !important; }\n\n.style-module_knModalContainer__2sYh1 .primaryButton {\n  border-radius: 3px !important;\n  background-color: #008b8f !important;\n  color: white !important; }\n";
var KnModalsStyle = { "knModalContainer": "style-module_knModalContainer__2sYh1" };
styleInject(css_248z$n);

var PartnerSelectionModal = function (_Component) {
    inherits(PartnerSelectionModal, _Component);

    function PartnerSelectionModal(props) {
        classCallCheck(this, PartnerSelectionModal);

        var _this = possibleConstructorReturn(this, (PartnerSelectionModal.__proto__ || Object.getPrototypeOf(PartnerSelectionModal)).call(this, props));

        _this.state = {
            partnerData: {
                partnerId: "",
                partnerName: "",
                selected: true,
                salesStatus: "SALES_ACCEPTED"
            }
        };
        return _this;
    }

    createClass(PartnerSelectionModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                allPartners = _props.allPartners,
                currentBidPartnersIds = _props.currentBidPartnersIds,
                openModal = _props.openModal,
                _onOpen = _props.onOpen,
                _onClose = _props.onClose,
                handlePartnerSelection = _props.handlePartnerSelection;


            return React__default.createElement(
                Modal,
                {
                    size: 'small',
                    onClose: function onClose() {
                        return _onClose();
                    },
                    onOpen: function onOpen() {
                        return _onOpen();
                    },
                    open: openModal
                },
                React__default.createElement(
                    Modal.Header,
                    null,
                    'Add Partner'
                ),
                React__default.createElement(
                    Modal.Content,
                    { scrolling: true, style: { width: "100%" } },
                    React__default.createElement(
                        Table,
                        { celled: true },
                        React__default.createElement(
                            Table.Header,
                            null,
                            React__default.createElement(
                                Table.Row,
                                null,
                                React__default.createElement(
                                    Table.HeaderCell,
                                    null,
                                    'Select'
                                ),
                                React__default.createElement(
                                    Table.HeaderCell,
                                    null,
                                    'PARTNER NAME'
                                )
                            )
                        ),
                        React__default.createElement(
                            Table.Body,
                            null,
                            allPartners.map(function (dp) {
                                return !currentBidPartnersIds.includes(dp.partnerId) && React__default.createElement(
                                    Table.Row,
                                    { key: dp.partnerId },
                                    React__default.createElement(
                                        Table.Cell,
                                        null,
                                        React__default.createElement('input', {
                                            type: 'checkbox',
                                            checked: _this2.state.partnerData.partnerId === dp.partnerId ? true : false,
                                            onChange: function onChange() {
                                                return _this2.setState({
                                                    partnerData: _extends({}, _this2.state.partnerData, {
                                                        partnerId: dp.partnerId,
                                                        partnerName: dp.name
                                                    })
                                                });
                                            },
                                            className: 'partner_cb'
                                        })
                                    ),
                                    React__default.createElement(
                                        Table.Cell,
                                        null,
                                        dp.name
                                    )
                                );
                            })
                        )
                    )
                ),
                React__default.createElement(
                    Modal.Actions,
                    null,
                    React__default.createElement(
                        'button',
                        {
                            onClick: function onClick() {
                                if (_this2.state.partnerData.partnerId) {
                                    currentBidPartnersIds.push(_this2.state.partnerData.partnerId);
                                    handlePartnerSelection(_this2.state.partnerData);
                                }
                            },
                            className: 'simpleButton primaryButton ' + (!this.state.partnerData.partnerId && 'disabled'),
                            type: 'submit'
                        },
                        'Submit'
                    ),
                    React__default.createElement(
                        'button',
                        {
                            onClick: function onClick() {
                                return _onClose();
                            },
                            className: 'simpleButton secondaryButton',
                            type: 'submit'
                        },
                        'Cancel'
                    )
                )
            );
        }
    }]);
    return PartnerSelectionModal;
}(Component);

var OppUpdationDatePicker = function (_Component) {
    inherits(OppUpdationDatePicker, _Component);

    function OppUpdationDatePicker(props) {
        classCallCheck(this, OppUpdationDatePicker);

        var _this = possibleConstructorReturn(this, (OppUpdationDatePicker.__proto__ || Object.getPrototypeOf(OppUpdationDatePicker)).call(this, props));

        _this.state = {
            isInputFocused: false
        };
        _this.dateRef = React__default.createRef();
        return _this;
    }

    createClass(OppUpdationDatePicker, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                name = _props.name,
                label = _props.label,
                id = _props.id,
                value = _props.value,
                dateKey = _props.dateKey,
                handleDateChanges = _props.handleDateChanges;


            return React__default.createElement(
                'div',
                { className: 'dateWrapper', key: id },
                React__default.createElement(
                    'label',
                    { className: 'dateLabel' },
                    label
                ),
                React__default.createElement(
                    'div',
                    { className: 'dateIconInputWrapper ' + (this.state.isInputFocused ? 'datePickerFocused' : '') },
                    React__default.createElement(
                        'div',
                        { className: 'calendarIconContainer'
                            // onClick={() => this.dateRef.current.seFocus()}
                        },
                        React__default.createElement(Icon, { name: 'calendar alternate outline', color: 'black', size: 'small', className: 'calendarIcon' })
                    ),
                    React__default.createElement(DatePicker, {
                        placeholderText: name,
                        id: id,
                        name: name,
                        minDate: new Date(),
                        selected: value,
                        onChange: function onChange(value) {
                            return handleDateChanges(dateKey, value);
                        },
                        dateFormat: 'MMM dd, yyyy',
                        value: value,
                        className: 'datePickerInput'
                        // ref={this.dateRef}
                        , onFocus: function onFocus() {
                            return _this2.setState({ isInputFocused: true });
                        },
                        onBlur: function onBlur() {
                            return _this2.setState({ isInputFocused: false });
                        },
                        onSelect: function onSelect() {
                            return _this2.setState({ isInputFocused: false });
                        }
                    })
                )
            );
        }
    }]);
    return OppUpdationDatePicker;
}(Component);

var OpportunityUpdationModal = function (_Component) {
    inherits(OpportunityUpdationModal, _Component);

    function OpportunityUpdationModal(props) {
        classCallCheck(this, OpportunityUpdationModal);

        var _this = possibleConstructorReturn(this, (OpportunityUpdationModal.__proto__ || Object.getPrototypeOf(OpportunityUpdationModal)).call(this, props));

        _this.handleSorting = function (state, action) {
            switch (action.type) {
                case 'CHANGE_SORT':
                    if (state.column === action.column) {
                        return _extends({}, state, {
                            data: state.data.slice().reverse(),
                            direction: state.direction === 'ascending' ? 'descending' : 'ascending'
                        });
                    }

                    return _extends({}, state, {
                        column: action.column,
                        data: lodash.sortBy(state.data, [action.column]),
                        direction: 'ascending'
                    });
                default:
                    throw new Error();
            }
        };

        _this.updateTableData = function (action) {
            _this.setState(function (prevState) {
                return _this.handleSorting(prevState, action);
            });
        };

        _this.handleSubmissionApiResponse = function (status, msg, msgType) {
            return _this.setState({
                updationResponse: {
                    showMessage: true,
                    isSuccess: status,
                    msg: msg,
                    modalLocalMsg: msgType ? msgType : false
                }
            });
        };

        _this.handleSubmit = function () {
            _this.setState({ isLoading: true });
            updateOpportunityData(_this.getApiPayload(_this.props.tab === salesPortalTabs.SALES_ACCEPTED ? true : false)).then(function (res) {
                _this.setState({ isLoading: false });
                if (res.data.eventMessage.code === 200) {
                    _this.handleSubmissionApiResponse(true, res.data.eventMessage.msg);
                    _this.props.setSalesOpportunityUpdatedData({
                        opportunityId: _this.props.opportunityId,
                        bidCloseDate: _this.state.oppDates.bidCloseDate,
                        opportunityExpiryDate: _this.state.oppDates.bidRenewalDate, //renewal date
                        customerAcceptanceDeadline: _this.state.oppDates.customerAcceptanceDate
                    });
                    _this.props.openCloseOpp(_this.props.opportunityId);
                    if (_this.props.tab === salesPortalTabs.SALES_ARCHIVED) _this.props.fetchTabDetails(salesPortalTabs.SALES_ARCHIVED);
                } else _this.handleSubmissionApiResponse(false, lodash_1(res.data, "eventMessage.msg", 'Something went wrong.'));
            }).catch(function (err) {
                _this.setState({ isLoading: false });
                _this.handleSubmissionApiResponse(false, "Something went wrong.");
            });
        };

        _this.getApiPayload = function (partnerUpdationStatus) {
            var oppDates = _this.state.oppDates;

            var opportunityDetails = {
                opportunityId: _this.props.opportunityId,
                endDate: oppDates.bidCloseDate,
                opportunityExpiryDate: oppDates.bidRenewalDate, //renewal date
                customerAcceptanceDeadline: oppDates.customerAcceptanceDate
            };
            if (!partnerUpdationStatus) return { opportunityDetails: opportunityDetails };else {
                var sourceList = Array.from(_this.props.oppUpdationData.sourceList.values()).map(function (port) {
                    return _extends({}, port, {
                        destinations: port.destinations.map(function (destination) {
                            var partnersNotSubmittedBids = destination.partnersNotSubmittedBids,
                                restDestination = objectWithoutProperties(destination, ['partnersNotSubmittedBids']); // Remove 'partnersNotSubmittedBids'

                            var updatedPartnerBids = (destination.partnerBids || []).map(function (partnerBid) {
                                var chargeDetails = partnerBid.chargeDetails || {};
                                var portChargeList = chargeDetails.portChargeList,
                                    restChargeDetails = objectWithoutProperties(chargeDetails, ['portChargeList']); // Remove 'portChargeList'

                                return _extends({}, partnerBid, {
                                    chargeDetails: restChargeDetails
                                });
                            });

                            return _extends({}, restDestination, {
                                partnerBids: updatedPartnerBids
                            });
                        })
                    });
                });
                return { opportunityDetails: opportunityDetails, sourceList: sourceList };
            }
        };

        _this.getOpportunityUpdationHistory = function () {
            _this.setState({ isLoading: true });
            getOpportunityUpdationLogs({
                opportunityId: _this.props.opportunityId
            }).then(function (res) {
                _this.setState({ isLoading: false });
                if (res.data.eventMessage && res.data.eventMessage.opportunityChangeLog) {
                    _this.setState({ data: res.data.eventMessage.opportunityChangeLog });
                }
                // else this.handleApiResponse(false, res.data.eventMessage.msg)
            }).catch(function (err) {
                _this.setState({ isLoading: false });
                _this.handleSubmissionApiResponse(false, "Something went wrong while fetching history data.");
            });
        };

        _this.isSelectedAndCurrentDateEqual = function () {
            var oldDate = new Date(_this.props.currentBidCloseDate);
            var newDate = new Date(_this.props.bidCloseDate);
            if (oldDate.toDateString() === newDate.toDateString()) return true;else return false;
        };

        _this.splitForTooltip = function (name) {

            var firstPart = name ? name.substring(0, 12) : "";

            return React__default.createElement(
                React__default.Fragment,
                null,
                firstPart,
                name && name.length > 12 ? React__default.createElement(Popup, {
                    content: name,
                    trigger: React__default.createElement(
                        'span',
                        { style: { padding: 0 } },
                        '...'
                    )
                }) : ""
            );
        };

        _this.updatePortsData = function () {
            var sourceList = lodash.cloneDeep(_this.props.currentsourceList);
            sourceList.forEach(function (port, portKey) {
                var newPortData = lodash.omit(port, 'portAdditionalCharges');
                sourceList.set(portKey, newPortData);
                var destinations = newPortData.destinations;
                for (var i = 0; i < destinations.length; i++) {
                    var destination = lodash.omit(destinations[i], ['destinationAdditionalCharges', 'destinationBidData']);
                    var partnerBids = destination.partnerBids;
                    var partnersNotSubmittedBids = destination.partnersNotSubmittedBids;
                    for (var j = 0; j < partnerBids.length; j++) {
                        partnerBids[j].selected = partnerBids[j].salesStatus === "SALES_ACCEPTED" ? true : false;
                    }
                    for (var z = 0; z < partnersNotSubmittedBids.length; z++) {
                        partnersNotSubmittedBids[z].selected = partnersNotSubmittedBids[z].salesStatus === "SALES_ACCEPTED" ? true : false;
                        partnerBids.push(partnersNotSubmittedBids[z]);
                    }
                    destinations[i] = destination;
                }
            });

            console.log("updatedPortDataHere", sourceList);
            _this.props.handleBidUpdationOpenClose(false, {
                partnerData: {},
                sourceList: sourceList
            });
        };

        _this.handleAccordionOpenClose = function (accordionId) {
            _this.setState({ activeAccordion: _this.state.activeAccordion !== accordionId ? accordionId : -1 });
        };

        _this.componentDidMount = function () {
            // console.log("propsToUpdationModal--->", this.props)
            // this.getOpportunityUpdationHistory()
            if (_this.props.tab === salesPortalTabs.SALES_ACCEPTED) _this.updatePortsData();
        };

        _this.componentDidUpdate = function (prevProps, prevState) {
            if (prevState.updationResponse.showMessage !== _this.state.updationResponse.showMessage) {
                setTimeout(function () {
                    // this.setState({ updationResponse: {} })
                    if (!_this.state.updationResponse.modalLocalMsg) _this.props.onClose();else _this.setState({ updationResponse: _extends({}, _this.state.updationResponse, { showMessage: false }) });
                }, 3000);
            }
        };

        _this.handlePartnerSelection = function (partnerData) {
            var _this$state$partnerSe = _this.state.partnerSelectionData,
                sourceId = _this$state$partnerSe.sourceId,
                laneId = _this$state$partnerSe.laneId;

            var sourceList = _this.props.oppUpdationData.sourceList;
            var port = sourceList.get(sourceId);
            console.log('portHere', port, '\n ');
            var destinations = port.destinations;
            for (var i = 0; i < destinations.length; i++) {
                var destination = destinations[i];
                var partnerBids = destination.partnerBids;
                if (destination.laneId === laneId) {
                    partnerBids.push(partnerData);
                    break;
                }
            }
            console.log("newsourceListHere", sourceList);
            _this.setState({ sourceList: sourceList, openPartnerSelectionModal: false });
            _this.props.handleBidUpdationOpenClose(false, {
                partnerData: {},
                sourceList: sourceList
            });
        };

        _this.checkSelectedPartnersCount = function (partnerBids) {
            var count = 0;
            for (var i = 0; i < partnerBids.length; i++) {
                if (partnerBids[i].selected === true) count += 1;
            }
            return count;
        };

        _this.handlePartnerBidsSelection = function (sourceId, laneId, partnerId) {
            var sourceList = _this.props.oppUpdationData.sourceList;
            var port = sourceList.get(sourceId);
            var destinations = port.destinations;
            for (var i = 0; i < destinations.length; i++) {
                var destination = destinations[i];
                var partnerBids = destination.partnerBids;
                if (destination.laneId === laneId) {
                    for (var j = 0; j < partnerBids.length; j++) {
                        var partner = partnerBids[j];
                        var isPartnerBeingUnselected = partner.selected;
                        if (partner.partnerId === partnerId) {
                            if (isPartnerBeingUnselected) {
                                if (_this.checkSelectedPartnersCount(partnerBids) > 1) {
                                    partner.salesStatus = partner.selected ? "SALES_REJECTED" : "SALES_ACCEPTED";
                                    partner.selected = !partner.selected;
                                } else _this.handleSubmissionApiResponse(false, "One partner must be selected.", true);
                            } else {
                                partner.salesStatus = partner.selected ? "SALES_REJECTED" : "SALES_ACCEPTED";
                                partner.selected = !partner.selected;
                            }
                            break;
                        }
                    }
                    break;
                }
            }
            _this.props.handleBidUpdationOpenClose(false, {
                partnerData: {},
                sourceList: sourceList
            });
        };

        _this.handleConfirmationModalResponse = function (status) {
            var partnerDetails = _this.state.partnerDetails;

            if (status) {
                _this.handlePartnerBidsSelection(partnerDetails.portKey, partnerDetails.laneId, partnerDetails.partnerId);
            }
            _this.setState({ openConfirmationModal: false, partnerDetails: { portKey: '', laneId: '', partnerId: '' } });
        };

        _this.HistoryDataTable = function () {
            var _this$state = _this.state,
                column = _this$state.column,
                data = _this$state.data,
                direction = _this$state.direction;

            return React__default.createElement(
                'div',
                { className: 'bidDateHistoryContent' },
                React__default.createElement(
                    Table,
                    { sortable: true, celled: true, fixed: true },
                    React__default.createElement(
                        Table.Header,
                        null,
                        React__default.createElement(
                            Table.Row,
                            null,
                            React__default.createElement(
                                Table.HeaderCell,
                                {
                                    sorted: column === 'changedBy' ? direction : null,
                                    onClick: function onClick() {
                                        return _this.updateTableData({ type: 'CHANGE_SORT', column: 'changedBy' });
                                    },
                                    className: 'historyTbHeader'
                                },
                                'Changed By'
                            ),
                            React__default.createElement(
                                Table.HeaderCell,
                                {
                                    sorted: column === 'field' ? direction : null,
                                    onClick: function onClick() {
                                        return _this.updateTableData({ type: 'CHANGE_SORT', column: 'field' });
                                    },
                                    className: 'historyTbHeader'
                                },
                                'Field Name'
                            ),
                            React__default.createElement(
                                Table.HeaderCell,
                                {
                                    sorted: column === 'newValue' ? direction : null,
                                    onClick: function onClick() {
                                        return _this.updateTableData({ type: 'CHANGE_SORT', column: 'newValue' });
                                    },
                                    className: 'historyTbHeader'
                                },
                                'New Value'
                            ),
                            React__default.createElement(
                                Table.HeaderCell,
                                {
                                    sorted: column === 'oldValue' ? direction : null,
                                    onClick: function onClick() {
                                        return _this.updateTableData({ type: 'CHANGE_SORT', column: 'oldValue' });
                                    },
                                    className: 'historyTbHeader'
                                },
                                'Old Value'
                            ),
                            React__default.createElement(
                                Table.HeaderCell,
                                {
                                    sorted: column === 'changedOn' ? direction : null,
                                    onClick: function onClick() {
                                        return _this.updateTableData({ type: 'CHANGE_SORT', column: 'changedOn' });
                                    },
                                    className: 'historyTbHeader'
                                },
                                'Changed On'
                            )
                        )
                    ),
                    React__default.createElement(
                        Table.Body,
                        null,
                        data.map(function (item, index) {
                            return React__default.createElement(
                                Table.Row,
                                { key: index },
                                React__default.createElement(
                                    Table.Cell,
                                    { className: 'historyTbData' },
                                    _this.splitForTooltip(item.changedBy)
                                ),
                                React__default.createElement(
                                    Table.Cell,
                                    { className: 'historyTbData' },
                                    _this.splitForTooltip(item.field)
                                ),
                                React__default.createElement(
                                    Table.Cell,
                                    { className: 'historyTbData' },
                                    _this.splitForTooltip(item.newValue)
                                ),
                                React__default.createElement(
                                    Table.Cell,
                                    { className: 'historyTbData' },
                                    _this.splitForTooltip(item.oldValue)
                                ),
                                React__default.createElement(
                                    Table.Cell,
                                    { className: 'historyTbData' },
                                    item.changedOn
                                )
                            );
                        })
                    )
                )
            );
        };

        _this.handleDateChanges = function (key, value) {
            console.log(_this.state.oppDates, key, value);
            _this.setState({ oppDates: _extends({}, _this.state.oppDates, defineProperty({}, key, value)) });
        };

        _this.oppDatesData = [{ id: 1, name: 'Bid close date', value: _this.props.bidCloseDate, dateKey: 'bidCloseDate', showDateSection: true }, { id: 2, name: 'Bid renewal date', value: _this.props.bidRenewalDate, dateKey: 'bidRenewalDate', showDateSection: _this.props.opportunityType === 'DRAYAGE_CONTAINER' ? false : true }, { id: 3, name: 'Customer acceptance deadline', value: _this.props.customerAcceptanceDate, dateKey: 'customerAcceptanceDate', showDateSection: true }];

        _this.OpportunityDates = function () {
            var oppDates = _this.state.oppDates;


            return React__default.createElement(
                'div',
                { className: 'oppDatesSection' },
                _this.oppDatesData.map(function (item, index) {
                    return item.showDateSection && React__default.createElement(OppUpdationDatePicker, {
                        label: item.name,
                        id: item.id,
                        value: oppDates[item.dateKey],
                        dateKey: item.dateKey,
                        handleDateChanges: _this.handleDateChanges,
                        key: item.id
                    });
                })
            );
        };

        _this.PartnersSection = function () {
            var _this$props = _this.props,
                allPartners = _this$props.allPartners,
                oppUpdationData = _this$props.oppUpdationData,
                handleBidUpdationOpenClose = _this$props.handleBidUpdationOpenClose;
            var currentBidPartnersIds = _this.state.currentBidPartnersIds;


            return React__default.createElement(
                'div',
                { className: 'oppUpdationPartnerSection' },
                _this.state.openPartnerSelectionModal && React__default.createElement(PartnerSelectionModal, {
                    openModal: _this.state.openPartnerSelectionModal,
                    allPartners: allPartners,
                    currentBidPartnersIds: currentBidPartnersIds,
                    onClose: function onClose() {
                        return _this.setState({ openPartnerSelectionModal: false });
                    },
                    onOpen: function onOpen() {
                        return _this.setState({ openPartnerSelectionModal: true });
                    },
                    handlePartnerSelection: _this.handlePartnerSelection
                }),
                _this.state.openConfirmationModal && React__default.createElement(KnConfirmationModal, {
                    openModal: _this.state.openConfirmationModal,
                    header: 'Confirm !',
                    content: 'Container/Containers have been force/auto-assigned with the partner, Do you want to proceed forward ?',
                    onClose: function onClose() {
                        return _this.setState({ openConfirmationModal: false });
                    },
                    onOpen: function onOpen() {
                        return _this.setState({ openConfirmationModal: true });
                    },
                    handleConfirmation: _this.handleConfirmationModalResponse
                }),
                Array.from(oppUpdationData.sourceList).map(function (_ref) {
                    var _ref2 = slicedToArray(_ref, 2),
                        portKey = _ref2[0],
                        port = _ref2[1];

                    return port.destinations.map(function (destination, index) {
                        return React__default.createElement(
                            'div',
                            null,
                            React__default.createElement(
                                'div',
                                { className: 'laneTitle' },
                                destination.source + " ---> " + lodash_1(destination.destinationAddress, 'addressName.value', '')
                            ),
                            React__default.createElement(
                                Table,
                                { celled: true },
                                React__default.createElement(
                                    Table.Header,
                                    null,
                                    React__default.createElement(
                                        Table.Row,
                                        null,
                                        React__default.createElement(
                                            Table.HeaderCell,
                                            null,
                                            'Partner Name'
                                        ),
                                        React__default.createElement(
                                            Table.HeaderCell,
                                            null,
                                            'Selection'
                                        ),
                                        React__default.createElement(
                                            Table.HeaderCell,
                                            null,
                                            'Bid'
                                        )
                                    )
                                ),
                                React__default.createElement(
                                    Table.Body,
                                    null,
                                    destination.partnerBids.map(function (partner) {
                                        return React__default.createElement(
                                            Table.Row,
                                            { key: partner.partnerId },
                                            React__default.createElement(
                                                Table.Cell,
                                                null,
                                                partner.partnerName
                                            ),
                                            React__default.createElement(
                                                Table.Cell,
                                                null,
                                                React__default.createElement('input', {
                                                    type: 'checkbox',
                                                    checked: partner.selected === true ? true : false,
                                                    value: partner.partnerId,
                                                    onChange: function onChange() {
                                                        if (partner.isContainerAssigned && partner.selected) _this.setState({
                                                            openConfirmationModal: true, partnerDetails: {
                                                                portKey: portKey, laneId: destination.laneId, partnerId: partner.partnerId
                                                            }
                                                        });else _this.handlePartnerBidsSelection(portKey, destination.laneId, partner.partnerId);
                                                    },
                                                    className: 'partner_cb'
                                                })
                                            ),
                                            React__default.createElement(
                                                Table.Cell,
                                                null,
                                                React__default.createElement(
                                                    'div',
                                                    { className: 'bidButton',
                                                        onClick: function onClick() {
                                                            if (!lodash_1(partner, 'bidAmount', false)) {
                                                                handleBidUpdationOpenClose(true, {
                                                                    partnerData: partner,
                                                                    sourceList: _this.props.oppUpdationData.sourceList,
                                                                    sourceId: portKey,
                                                                    laneId: destination.laneId
                                                                });
                                                                _this.props.handleOpportunityBidClicked(true);
                                                                _this.props.handleOpenBidModal(_this.props.opportunityId);
                                                            }
                                                        }
                                                    },
                                                    partner.bidAmount ? partner.apCurrencyCode + ' ' + partner.bidAmount : 'Bid'
                                                )
                                            )
                                        );
                                    })
                                )
                            ),
                            React__default.createElement(
                                'div',
                                { className: 'dateEditBtn', style: { width: 80 }, onClick: function onClick() {
                                        return _this.setState({
                                            openPartnerSelectionModal: true,
                                            partnerSelectionData: { sourceId: portKey, laneId: destination.laneId }
                                        });
                                    } },
                                ' ADD'
                            )
                        );
                    });
                })
            );
        };

        _this.accordionsSections = [{ id: 1, name: 'Edit Opportunity Dates', content: function content() {
                return _this.OpportunityDates();
            }, showSection: true }, { id: 2, name: 'Edit Partners', content: function content() {
                return _this.PartnersSection();
            }, showSection: _this.props.tab === salesPortalTabs.SALES_ACCEPTED ? true : false }];


        _this.state = {
            column: null,
            data: [{}],
            direction: null,
            isDateInputFocused: false,
            isLoading: false,
            updationResponse: {
                showMessage: false,
                isSuccess: '',
                msg: '',
                modalLocalMsg: false
            },
            openPartnerSelectionModal: false,
            sourceList: new Map(),
            partnerSelectionData: { sourceId: '', laneId: '' },
            currentBidPartnersIds: [].concat(toConsumableArray(_this.props.currentBidPartnersIds)),
            openBidModal: false,
            activeAccordion: 0,
            oppDates: {
                bidCloseDate: new Date(_this.props.bidCloseDate),
                bidRenewalDate: new Date(_this.props.bidRenewalDate), //opportunityExpiryDate
                customerAcceptanceDate: new Date(_this.props.customerAcceptanceDate) //customerAcceptanceDeadline
            },
            openConfirmationModal: false,
            partnerDetails: {
                portKey: '', laneId: '', partnerId: ''
            }
        };
        return _this;
    }

    createClass(OpportunityUpdationModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                openModal = _props.openModal,
                _onClose = _props.onClose,
                _onOpen = _props.onOpen;


            return React__default.createElement(
                Modal,
                {
                    size: 'small',
                    onClose: function onClose() {
                        return _onClose();
                    },
                    onOpen: function onOpen() {
                        return _onOpen();
                    },
                    open: openModal
                },
                React__default.createElement(
                    Modal.Header,
                    null,
                    'Update Opportunity'
                ),
                this.state.isLoading ? React__default.createElement(KnLoader, null) : null,
                React__default.createElement(
                    Modal.Content,
                    { scrolling: true, style: { width: "100%" } },
                    this.state.updationResponse.showMessage ? React__default.createElement(
                        'div',
                        { style: { marginBottom: 30 } },
                        React__default.createElement(
                            Message,
                            { positive: this.state.updationResponse.isSuccess ? true : false,
                                negative: !this.state.updationResponse.isSuccess ? true : false },
                            React__default.createElement(
                                'p',
                                null,
                                this.state.updationResponse.msg
                            )
                        )
                    ) : null,
                    React__default.createElement(
                        'div',
                        { className: 'bidDateUpdationContainer' },
                        this.accordionsSections.map(function (item, index) {
                            return item.showSection && React__default.createElement(
                                'div',
                                { className: 'oppUpdationAccordion', key: item.id },
                                React__default.createElement(
                                    'div',
                                    { className: 'oppUpdationAccordionHeader' },
                                    React__default.createElement(Icon, { onClick: function onClick() {
                                            _this2.handleAccordionOpenClose(item.id);
                                        }, className: 'headerIcon', name: item.id !== _this2.state.activeAccordion ? 'chevron circle right' : "chevron circle down" }),
                                    React__default.createElement(
                                        'div',
                                        { className: 'headerTitle' },
                                        item.name
                                    )
                                ),
                                item.id === _this2.state.activeAccordion && React__default.createElement(
                                    'div',
                                    { className: 'oppUpdationAccordionContent' },
                                    item.content()
                                )
                            );
                        })
                    )
                ),
                React__default.createElement(
                    Modal.Actions,
                    null,
                    React__default.createElement(
                        'button',
                        {
                            onClick: function onClick() {
                                return _this2.handleSubmit();
                            },
                            className: 'simpleButton primaryButton',
                            type: 'submit'
                        },
                        'Submit'
                    ),
                    React__default.createElement(
                        'button',
                        {
                            onClick: function onClick() {
                                return _onClose();
                            },
                            className: 'simpleButton secondaryButton',
                            type: 'submit'
                        },
                        'Cancel'
                    )
                )
            );
        }
    }]);
    return OpportunityUpdationModal;
}(Component);

var OppUpdateHistoryModal = function (_Component) {
    inherits(OppUpdateHistoryModal, _Component);

    function OppUpdateHistoryModal(props) {
        classCallCheck(this, OppUpdateHistoryModal);

        var _this = possibleConstructorReturn(this, (OppUpdateHistoryModal.__proto__ || Object.getPrototypeOf(OppUpdateHistoryModal)).call(this, props));

        _this.handleSorting = function (state, action) {
            switch (action.type) {
                case 'CHANGE_SORT':
                    if (state.column === action.column) {
                        return _extends({}, state, {
                            data: state.data.slice().reverse(),
                            direction: state.direction === 'ascending' ? 'descending' : 'ascending'
                        });
                    }

                    return _extends({}, state, {
                        column: action.column,
                        data: lodash.sortBy(state.data, [action.column]),
                        direction: 'ascending'
                    });
                default:
                    throw new Error();
            }
        };

        _this.splitForTooltip = function (name) {

            var firstPart = name ? name.substring(0, 12) : "";

            return React__default.createElement(
                React__default.Fragment,
                null,
                firstPart,
                name && name.length > 12 ? React__default.createElement(Popup, {
                    content: name,
                    trigger: React__default.createElement(
                        'span',
                        { style: { padding: 0 } },
                        '...'
                    )
                }) : ""
            );
        };

        _this.updateTableData = function (action) {
            _this.setState(function (prevState) {
                return _this.handleSorting(prevState, action);
            });
        };

        _this.handleApiResponse = function (status, msg, msgType) {
            return _this.setState({
                updationResponse: {
                    showMessage: true,
                    isSuccess: status,
                    msg: msg,
                    modalLocalMsg: msgType ? msgType : false
                }
            });
        };

        _this.getOpportunityUpdationHistory = function () {
            _this.setState({ isLoading: true });
            getOpportunityUpdationLogs({
                opportunityId: _this.props.opportunityId
            }).then(function (res) {
                _this.setState({ isLoading: false });
                if (res.data.eventMessage && res.data.eventMessage.opportunityChangeLog) {
                    _this.setState({ data: res.data.eventMessage.opportunityChangeLog });
                }
                // else this.handleApiResponse(false, res.data.eventMessage.msg)
            }).catch(function (err) {
                _this.setState({ isLoading: false });
                _this.handleApiResponse(false, "Something went wrong while fetching history data.");
            });
        };

        _this.componentDidMount = function () {
            _this.getOpportunityUpdationHistory();
        };

        _this.state = {
            column: null,
            data: [{}],
            direction: null,
            isLoading: false,
            updationResponse: {
                showMessage: false,
                isSuccess: '',
                msg: '',
                modalLocalMsg: false
            }
        };
        return _this;
    }

    createClass(OppUpdateHistoryModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                openModal = _props.openModal,
                _onClose = _props.onClose,
                _onOpen = _props.onOpen;
            var _state = this.state,
                column = _state.column,
                data = _state.data,
                direction = _state.direction;


            return React__default.createElement(
                Modal,
                {
                    size: 'small',
                    closeIcon: true,
                    onClose: function onClose() {
                        return _onClose();
                    },
                    onOpen: function onOpen() {
                        return _onOpen();
                    },
                    open: openModal
                },
                React__default.createElement(
                    Modal.Header,
                    null,
                    'Opportunity Update History'
                ),
                this.state.isLoading ? React__default.createElement(KnLoader, null) : null,
                React__default.createElement(
                    Modal.Content,
                    { scrolling: true, style: { width: "100%" } },
                    React__default.createElement(
                        'div',
                        { className: 'bidDateHistoryContent' },
                        React__default.createElement(
                            Table,
                            { sortable: true, celled: true, fixed: true },
                            React__default.createElement(
                                Table.Header,
                                null,
                                React__default.createElement(
                                    Table.Row,
                                    null,
                                    React__default.createElement(
                                        Table.HeaderCell,
                                        {
                                            sorted: column === 'changedBy' ? direction : null,
                                            onClick: function onClick() {
                                                return _this2.updateTableData({ type: 'CHANGE_SORT', column: 'changedBy' });
                                            },
                                            className: 'historyTbHeader'
                                        },
                                        'Changed By'
                                    ),
                                    React__default.createElement(
                                        Table.HeaderCell,
                                        {
                                            sorted: column === 'field' ? direction : null,
                                            onClick: function onClick() {
                                                return _this2.updateTableData({ type: 'CHANGE_SORT', column: 'field' });
                                            },
                                            className: 'historyTbHeader'
                                        },
                                        'Field Name'
                                    ),
                                    React__default.createElement(
                                        Table.HeaderCell,
                                        {
                                            sorted: column === 'newValue' ? direction : null,
                                            onClick: function onClick() {
                                                return _this2.updateTableData({ type: 'CHANGE_SORT', column: 'newValue' });
                                            },
                                            className: 'historyTbHeader'
                                        },
                                        'New Value'
                                    ),
                                    React__default.createElement(
                                        Table.HeaderCell,
                                        {
                                            sorted: column === 'oldValue' ? direction : null,
                                            onClick: function onClick() {
                                                return _this2.updateTableData({ type: 'CHANGE_SORT', column: 'oldValue' });
                                            },
                                            className: 'historyTbHeader'
                                        },
                                        'Old Value'
                                    ),
                                    React__default.createElement(
                                        Table.HeaderCell,
                                        {
                                            sorted: column === 'changedOn' ? direction : null,
                                            onClick: function onClick() {
                                                return _this2.updateTableData({ type: 'CHANGE_SORT', column: 'changedOn' });
                                            },
                                            className: 'historyTbHeader'
                                        },
                                        'Changed On'
                                    )
                                )
                            ),
                            React__default.createElement(
                                Table.Body,
                                null,
                                data.map(function (item, index) {
                                    return React__default.createElement(
                                        Table.Row,
                                        { key: index },
                                        React__default.createElement(
                                            Table.Cell,
                                            { className: 'historyTbData' },
                                            _this2.splitForTooltip(item.changedBy)
                                        ),
                                        React__default.createElement(
                                            Table.Cell,
                                            { className: 'historyTbData' },
                                            _this2.splitForTooltip(item.field)
                                        ),
                                        React__default.createElement(
                                            Table.Cell,
                                            { className: 'historyTbData' },
                                            _this2.splitForTooltip(item.newValue)
                                        ),
                                        React__default.createElement(
                                            Table.Cell,
                                            { className: 'historyTbData' },
                                            _this2.splitForTooltip(item.oldValue)
                                        ),
                                        React__default.createElement(
                                            Table.Cell,
                                            { className: 'historyTbData' },
                                            item.changedOn
                                        )
                                    );
                                })
                            )
                        )
                    )
                ),
                React__default.createElement(Modal.Actions, null)
            );
        }
    }]);
    return OppUpdateHistoryModal;
}(Component);

var OpportunityHeader = function (_PureComponent) {
  inherits(OpportunityHeader, _PureComponent);

  function OpportunityHeader(props) {
    classCallCheck(this, OpportunityHeader);

    var _this = possibleConstructorReturn(this, (OpportunityHeader.__proto__ || Object.getPrototypeOf(OpportunityHeader)).call(this, props));

    _this.isExpandableTab = function () {
      var tab = _this.props.tab;

      return tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED";
    };

    _this.openCloseOpp = function (opportunityId) {
      if (_this.props.isOpportunityOpened) {
        _this.props.cancelBid();
      }
      _this.props.onButtonClick(opportunityId, _this.props.isOpportunityOpened);
      _this.fetchDPList();
    };

    _this.fetchDPList = function () {
      getDPList().then(function (res) {
        var dpList = [];

        res.data.eventMessage.drayagePartners && res.data.eventMessage.drayagePartners.forEach(function (dp, index) {
          var _dp$companyProfile$en = dp.companyProfile.entityAddress,
              addressLine1 = _dp$companyProfile$en.addressLine1,
              addressLine2 = _dp$companyProfile$en.addressLine2,
              city = _dp$companyProfile$en.city,
              state = _dp$companyProfile$en.state,
              zip = _dp$companyProfile$en.zip,
              country = _dp$companyProfile$en.country;

          dpList[index] = {
            name: dp.companyProfile.name,
            territory: dp.serviceAreas && dp.serviceAreas[0].regions.join(", "), //dp.serviceAreas[0].country
            serviceAreas: _.get(dp, 'serviceAreas[0].regions', []),
            address: addressLine1 + ', ' + addressLine2 + ', ' + city + ', ' + state + ' ' + zip + (country ? "," + country : ""),
            partnerId: dp.companyProfile.partnerId,
            checked: false
          };
        });

        _this.setState({ dpList: dpList });
        _this.getOpportunityPartnerBids();
      });
    };

    _this.addPartnerId = function (e) {
      var dpList = [].concat(toConsumableArray(_this.state.dpList));
      var _e$target = e.target,
          value = _e$target.value,
          checked = _e$target.checked;


      if (value === "all") {
        if (checked) dpList.forEach(function (dp) {
          return dp.checked = true;
        });else dpList.forEach(function (dp) {
          return dp.checked = false;
        });
      } else {
        var index = dpList.findIndex(function (dp) {
          return dp.partnerId === value;
        });
        dpList[index].checked = checked;
      }

      _this.setState({ dpList: dpList });
      var data = [];
      _this.state.dpList && _this.state.dpList.map(function (item) {
        if (item.checked === true) {
          data.push(item.partnerId);
        }
      });
      _this.setState({ republishPartner: data });
    };

    _this.onSubmitDP = function () {
      var republishPartner = _this.state.republishPartner;

      if (!!(republishPartner.length < 1)) {
        return;
      }
      var exDate = parseInt(_this.props.opportunity.opportunityExpiryDate);
      var oppExDate = formatDateTypeSecond(exDate);
      var endDate = parseInt(_this.props.opportunity.endDate);
      var oppEndDate = formatDateTypeSecond(endDate);
      console.log("hhhh", oppExDate, oppEndDate);
      var obj = {
        opportunityDetails: {
          opportunityId: _this.props.opportunity.opportunityId,
          opportunityExpiryDate: oppExDate,
          endDate: oppEndDate,
          opportunityType: _this.props.opportunity.opportunityType
        },
        operationType: "PUBLISH",
        drayagePartners: _this.state.republishPartner
      };

      republishOppurtunity(obj).then(function (res) {
        _this.openCloseOpp(_this.props.opportunity.opportunityId);
        _this.setState({ republished: false });
        var resCode = lodash_1(res, 'data.eventMessage.code', false);
        if (resCode) _this.setState({ errorModal: true, errorContent: lodash_1(res, 'data.eventMessage.msg', 'Exception Occured') });else _this.setState({ sucessModal: true });
      }).catch(function (err) {
        _this.setState({ errorModal: true, errorContent: lodash_1(err, 'message', 'Exception Occured') });
      }).finally(function () {
        _this.setState({ republishPartner: [] });
      });
    };

    _this.getOpportunityPartnerBids = function () {
      var tab = _this.props.tab;

      getDrayageOpportunityDetails(_this.props.opportunity.opportunityId, tabType[tab]).then(function (res) {
        var opportunityDetailData = lodash_1(res.data, "eventMessage", {});
        _this.setState({ salesAllowed: lodash_1(opportunityDetailData.opportunityDetails, "salesApprovalAllowed", true) === 1 });
        console.log("dddd", _this.state.salesAllowed);
        var data = [];
        //filter out not needed partnerBids
        opportunityDetailData.sourceList.forEach(function (port) {
          port.destinations.forEach(function (dest) {
            dest.partnerBids.map(function (item) {
              data.push(item.partnerId);
            });
          });
        });
        _this.setState({ bidPartnerId: data });
      }).catch(function (err) {
        console.log("err", err);
      });
    };

    _this.onSucessOk = function (value) {
      _this.setState({ sucessModal: value });
    };

    _this.showOppUpdationModal = function () {
      var tab = _this.props.tab;

      return tab === salesPortalTabs.SALES_PENDING_APPROVAL || tab === salesPortalTabs.SALES_PUBLISHED || tab === salesPortalTabs.SALES_ACCEPTED || tab === salesPortalTabs.SALES_ARCHIVED ? true : false;
    };

    _this.showOppUpdateHistoryModal = function () {
      var tab = _this.props.tab;

      return tab === salesPortalTabs.SALES_PENDING_APPROVAL || tab === salesPortalTabs.SALES_PUBLISHED || tab === salesPortalTabs.SALES_ACCEPTED || tab === salesPortalTabs.SALES_REJECTED || tab === salesPortalTabs.SALES_ARCHIVED ? true : false;
    };

    _this.state = {
      partBids: [],
      republished: false,
      dpList: [],
      checkOpportunityId: "",
      republishPartner: [],
      bidPartnerId: [],
      salesAllowed: false,
      sucessModal: false,
      errorContent: '',
      errorModal: false,
      openOpportunityUpdationModal: false,
      bidCloseDate: _this.props.opportunity && parseInt(_this.props.opportunity.endDate),
      currentsourceList: new Map(),
      openOpportunityUpdateHistoryModal: false
    };
    return _this;
  }

  createClass(OpportunityHeader, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isOpportunityOpened = _props.isOpportunityOpened,
          tab = _props.tab,
          drayageApp = _props.drayageApp,
          onButtonClick = _props.onButtonClick,
          opportunityData = _props.opportunityData,
          onOpportunitySelect = _props.onOpportunitySelect,
          expanded = _props.expanded,
          setExpanded = _props.setExpanded;
      var _state = this.state,
          dpList = _state.dpList,
          bidPartnerId = _state.bidPartnerId,
          salesAllowed = _state.salesAllowed,
          republishPartner = _state.republishPartner,
          errorContent = _state.errorContent,
          errorModal = _state.errorModal,
          openOpportunityUpdationModal = _state.openOpportunityUpdationModal,
          openOpportunityUpdateHistoryModal = _state.openOpportunityUpdateHistoryModal,
          bidCloseDate = _state.bidCloseDate;


      var opportunityName = this.props.opportunity.opportunityName;
      var opportunityId = this.props.opportunity.opportunityId;


      console.log("OpportunityClosedCommon :: ", this.props);

      var opportunity = this.props.opportunityData && this.props.opportunityData.get(this.props.opportunity.opportunityId);
      var opportunityExpiryDate = opportunity && opportunity['opportunityExpiryDate'] ? parseInt(opportunity.opportunityExpiryDate) : null;

      console.log("OPPORTUNITY CLOSED COMMON  opportunityExpiryDate ", opportunityExpiryDate);

      var partnerBids = [];
      // console.log(partnerBids,'partnerBids :: BEFORE')
      // debugger
      if (opportunity && opportunity.portData && opportunity.portData.values().next().value.destinations) {
        var portData = opportunity.portData;
        partnerBids = portData.values().next().value.destinations[0].partnerBids;
        this.setState({ partBids: partnerBids, currentsourceList: portData });
      }
      var widthpartyNamewrapper = getWidthPartyNameWrapper(this.props.drayageApp, this.props.tab);

      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "UTC"
      };
      var opp_key = this.props.opp_key;
      var arWithoutAP = !!lodash_1(this.props, 'opportunity.arWithoutAP', false);
      var opportunityState = lodash_1(this.props, 'opportunity.opportunityState', '');
      var endDate = this.props.opportunity && parseInt(this.props.opportunity.endDate);
      var renewalDate = this.props.opportunity && this.props.opportunity.opportunityExpiryDate && parseInt(this.props.opportunity.opportunityExpiryDate);
      var expPickUpDate = this.props.opportunity && opp_key === "containerOpportunities" && this.props.opportunity.eta && parseInt(this.props.opportunity.eta);
      var customerAcceptanceDate = this.props.opportunity && formatDate(lodash_1(this.props.opportunity, 'customerAcceptanceDeadline', new Date()));
      // renewalDate = 1651363199999
      expPickUpDate = expPickUpDate && moment$1.utc(moment$1(expPickUpDate).utc()).toDate();
      expPickUpDate = expPickUpDate && formatDate(expPickUpDate);
      var diffDays = moment$1(new Date()).diff(moment$1(endDate), "days");
      var alreadyExpired = moment$1(new Date()).isSameOrAfter(moment$1(renewalDate), "days");
      var diffRenewalDays = moment$1(new Date(renewalDate)).diff(moment$1(new Date()), "days");
      console.log({ alreadyExpired: alreadyExpired, diffRenewalDays: diffRenewalDays });
      var date = moment$1.utc(moment$1(endDate).utc()).toDate(); //converting epoch to date object in UTC
      var oppEndDateFormatted = formatDate(endDate); //converting epoch to date object in UTC
      var expiredDate = renewalDate && new Date(renewalDate);
      expiredDate = expiredDate && formatDate(expiredDate);
      console.log("expiredDate :: ", expiredDate, renewalDate);
      var custEndDate = opportunity && parseInt(opportunity.endDate);
      var closeDateCust = new Date(custEndDate);
      closeDateCust = closeDateCust && closeDateCust.toLocaleDateString("en-Us", options).toUpperCase();
      //today’s date >= renewal date - 10

      var colorOfRenewal = "teal";
      if (parseInt(opportunityExpiryDate) - 86400000 <= Date.now()) {
        colorOfRenewal = "red";
      }

      var customerEndDate = new Date(endDate + 7 * 24 * 60 * 60 * 1000);
      customerEndDate = date.toLocaleDateString("en-US", options).toUpperCase();

      date = date.toLocaleDateString("en-US", options).toUpperCase();
      var showBidClose = function showBidClose(app, tab) {

        if (app === DRAYAGE_APP.KLEARDRAY_CUSTOMER && (tab === SELECTED_TABS.CUSTOMER_NEW || tab === SELECTED_TABS.CUSTOMER_ACTIVE || tab === SELECTED_TABS.CUSTOMER_REJECTED || tab === SELECTED_TABS.SALES_ARCHIVED)) {
          //console.log("showBidClose :: hide", tab)
          return false;
        } else {
          //console.log("showBidClose :: show", tab)
          return true;
        }
      };

      var showRenewalDate = function showRenewalDate(app, tab) {
        if (app === DRAYAGE_APP.KLEARDRAY_CUSTOMER) {
          return tab === SELECTED_TABS.CUSTOMER_NEW || tab === SELECTED_TABS.CUSTOMER_REQUESTED || tab === SELECTED_TABS.CUSTOMER_ACTIVE;
        } else if (app == DRAYAGE_APP.KLEARDRAY_PARTNER) {
          return tab === SELECTED_TABS.PARTNER_NEW || tab === SELECTED_TABS.PARTNER_ACTIVE || tab === SELECTED_TABS.PARTNER_SUBMITTED;
        } else if (app === DRAYAGE_APP.KLEARDRAY_SALES) {
          return tab === SELECTED_TABS.SALES_PUBLISHED || tab === SELECTED_TABS.SALES_PENDING_APPROVAL;
        }
        return false;
      };

      var splitForTooltip = function splitForTooltip(name) {
        if (!name) return "TBD";

        var firstPart = name.substring(0, 20);

        console.log("splitForTooltip :: ", name, ", firstPart", firstPart);
        return React__default.createElement(
          'div',
          { className: 'opportunityTitle' },
          firstPart,
          name.length > 20 ? React__default.createElement(Popup, { content: name, trigger: React__default.createElement(
              'b',
              null,
              React__default.createElement(
                'a',
                { style: { color: "#0A8B8F", marginTop: "-20px" } },
                '...'
              )
            ) }) : ""
        );
      };
      console.log(expPickUpDate, 'expPickUpDate');
      var opportunityDescription = lodash_1(this.props, 'opportunity.description', 'N/A');
      console.log("isOpportunityOpened >>>", this.props, this.props.tab === "SALES_PENDING_APPROVAL" && this.props.isOpportunityOpened && this.state.salesAllowed, salesAllowed);
      return this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? React__default.createElement(
        'div',
        null,
        errorModal && React__default.createElement(KnModal$1, {
          size: 'mini',
          className: KnModalsStyle.knModalContainer,
          open: errorModal,
          onClose: function onClose() {
            _this2.setState({ errorModal: false });
          },
          header: 'Error',
          content: errorContent,
          actionButtons: [{
            name: 'OK',
            onClick: function onClick() {
              _this2.setState({ errorModal: false });
            }
          }]
        }),
        openOpportunityUpdateHistoryModal && React__default.createElement(OppUpdateHistoryModal, {
          openModal: openOpportunityUpdateHistoryModal,
          opportunityId: opportunityId,
          onClose: function onClose() {
            return _this2.setState({ openOpportunityUpdateHistoryModal: false });
          },
          onOpen: function onOpen() {
            return _this2.setState({ openOpportunityUpdateHistoryModal: true });
          }
        }),
        openOpportunityUpdationModal && React__default.createElement(OpportunityUpdationModal, {
          minDate: new Date(),
          openModal: openOpportunityUpdationModal
          // bidCloseDate={bidCloseDate}
          , bidCloseDate: formatDateTime(endDate),
          currentBidCloseDate: this.props.opportunity && parseInt(this.props.opportunity.endDate),
          opportunityId: opportunityId
          // onChange={(value) => {
          //   this.setState({ bidCloseDate: value });
          // }}
          , onClose: function onClose() {
            return _this2.setState({ openOpportunityUpdationModal: false });
          },
          onOpen: function onOpen() {
            return _this2.setState({ openOpportunityUpdationModal: true });
          },
          setSalesOpportunityUpdatedData: this.props.setSalesOpportunityUpdatedData,
          tab: this.props.tab,
          allPartners: dpList,
          currentBidPartnersIds: bidPartnerId,
          partnerBidsData: this.state.partBids,
          currentsourceList: this.state.currentsourceList,
          handleOpenBidModal: this.props.handleOpenBidModal,
          handleOpportunityBidClicked: this.props.handleOpportunityBidClicked,
          isBiddingFromOppUpdation: this.props.isBiddingFromOppUpdation,
          oppUpdationData: this.props.oppUpdationData,
          handleBidUpdationOpenClose: this.props.handleBidUpdationOpenClose,
          openCloseOpp: this.openCloseOpp,
          bidRenewalDate: formatDateTime(renewalDate),
          customerAcceptanceDate: this.props.opportunity && formatDateTime(lodash_1(this.props.opportunity, 'customerAcceptanceDeadline', new Date())),
          opportunityType: this.props.opportunity && lodash_1(this.props.opportunity, 'opportunityType', ''),
          fetchTabDetails: this.props.fetchTabDetails
        }),
        this.state.sucessModal === true && React__default.createElement(
          Modal,
          {
            size: 'mini',
            open: this.state.sucessModal === true
          },
          React__default.createElement(
            Modal.Header,
            null,
            'REPUBLISHED OPPORTUNITY'
          ),
          React__default.createElement(
            Modal.Content,
            { style: { width: "100%" } },
            React__default.createElement(
              'p',
              null,
              'Opportunity is successfully republished'
            )
          ),
          React__default.createElement(
            Modal.Actions,
            null,
            React__default.createElement(
              Button,
              { positive: true, onClick: function onClick() {
                  return _this2.onSucessOk(false);
                } },
              'OK'
            )
          )
        ),
        React__default.createElement(
          Grid,
          { columns: 4, style: { width: "100%", margin: "0", padding: "0" } },
          React__default.createElement(
            Grid.Row,
            {
              className: 'OpportunityHeader opportunityHeaderContainer',
              style: { margin: "0", padding: "0", width: "100%", color: "#474747" }
            },
            React__default.createElement(
              Grid.Column,
              {
                width: 4,
                className: 'accordianControllerIcon',
                style: { display: "flex", gap: "10px", alignItems: "center", justifyContent: "left" }
              },
              React__default.createElement(Icon, {
                style: { margin: "0" },
                onClick: function onClick() {
                  return _this2.openCloseOpp(opportunityId);
                },
                className: isOpportunityOpened ? "opportunityHeaderIcon openOpportunity" : "opportunityHeaderIcon",
                name: !isOpportunityOpened ? "chevron circle right" : "chevron circle down"
              }),
              opportunityName && splitForTooltip(opportunityName.toUpperCase())
            ),
            React__default.createElement(
              Grid.Column,
              {
                className: 'date-pair',
                width: 8,
                style: {
                  marginRight: "0",
                  display: "flex",
                  gap: "10px",
                  alignItems: "center"
                }
              },
              React__default.createElement(
                'div',
                {
                  className: 'expiry-date date-pair ' + (this.props.tab !== "SALES_ARCHIVED" ? 'new-color' : ''),
                  style: {
                    display: "flex",
                    justifyContent: "left",
                    flexDirection: "column",
                    gap: "4px",
                    width: "125px",
                    margin: "0"
                  }
                },
                React__default.createElement(
                  'div',
                  { style: { fontWeight: "400" } },
                  'Bid Close Date'
                ),
                React__default.createElement(
                  'div',
                  null,
                  oppEndDateFormatted
                )
              ),
              tab === SELECTED_TABS.SALES_ARCHIVED && React__default.createElement(
                'div',
                {
                  style: {
                    display: "flex",
                    justifyContent: "left",
                    flexDirection: "column",
                    gap: "4px",
                    width: "125px",
                    margin: "0"
                  }
                },
                React__default.createElement(
                  'div',
                  { style: { fontWeight: "400" } },
                  'Expired On'
                ),
                React__default.createElement(
                  'div',
                  null,
                  oppEndDateFormatted
                )
              ),
              this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && opp_key !== "containerOpportunities" && renewalDate ? React__default.createElement(
                'div',
                {
                  className: diffRenewalDays < 10 && diffRenewalDays > 0 || alreadyExpired ? "date-pair renewal-date" : "date-pair new-color",
                  style: {
                    display: "flex",
                    justifyContent: "left",
                    flexDirection: "column",
                    gap: "4px",
                    width: "125px",
                    margin: "0"
                  }
                },
                React__default.createElement(
                  'div',
                  { style: { fontWeight: "400" } },
                  'Renewal Date'
                ),
                React__default.createElement(
                  'div',
                  null,
                  expiredDate
                )
              ) : null,
              this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && customerAcceptanceDate && React__default.createElement(
                'div',
                {
                  className: 'date-pair new-color',
                  style: {
                    display: "flex",
                    justifyContent: "left",
                    flexDirection: "column",
                    gap: "4px",
                    margin: "0"
                  }
                },
                React__default.createElement(
                  'div',
                  { style: { fontWeight: "400" } },
                  'Customer Acceptance Deadline'
                ),
                React__default.createElement(
                  'div',
                  null,
                  customerAcceptanceDate
                )
              ),
              this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && opp_key === "containerOpportunities" && tab === "SALES_ACCEPTED" && React__default.createElement(
                'div',
                {
                  className: 'date-pair',
                  style: {
                    display: "flex",
                    justifyContent: "left",
                    flexDirection: "column",
                    gap: "4px"
                  }
                },
                React__default.createElement(
                  'div',
                  null,
                  'Estimated Time Of Arrival'
                ),
                React__default.createElement(
                  'div',
                  null,
                  expPickUpDate
                )
              ),
              arWithoutAP && lodash_1(opportunityStateMapColor, opportunityState + '.label', "") && showOpprotunityStateStatus({ tab: tab }) && React__default.createElement(
                'div',
                {
                  className: 'date-pair new-color',
                  style: {
                    display: "flex",
                    justifyContent: "left",
                    flexDirection: "column",
                    gap: "4px"
                  }
                },
                React__default.createElement(
                  'div',
                  { style: { fontWeight: "400" } },
                  'Opportunity State'
                ),
                React__default.createElement(
                  'div',
                  { style: { color: lodash_1(opportunityStateMapColor, opportunityState + '.color', "#3BBA50") } },
                  lodash_1(opportunityStateMapColor, opportunityState + '.label', "")
                )
              )
            ),
            React__default.createElement(
              Grid.Column,
              {
                className: 'actionBtns',
                width: 3,
                style: { display: "flex", gap: "5px", alignItems: "center" }
              },
              isOpportunityOpened && this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && this.props.tab === SELECTED_TABS.CUSTOMER_NEW && React__default.createElement(
                'button',
                {
                  onClick: function onClick(e) {
                    _this2.props.customerBidmodalHandler(_this2.props.opportunity.opportunityId);
                  },
                  className: 'drayage-approve-btn'
                },
                'APPROVE'
              ),
              tab === "SALES_ACCEPTED" && opp_key !== "containerOpportunities" && (diffRenewalDays < 10 && diffRenewalDays > 0 || alreadyExpired) && isOpportunityOpened && React__default.createElement(
                'div',
                { className: 'renewBtn', style: { margin: "0" } },
                React__default.createElement(
                  'button',
                  {
                    className: '',
                    onClick: function onClick() {
                      return _this2.props.renewOpportunityFunc(opportunityId, true);
                    }
                  },
                  'RENEW'
                )
              ),
              this.props.tab === "SALES_PUBLISHED" && React__default.createElement(
                Modal,
                {
                  size: 'tiny',
                  onClose: function onClose() {
                    return _this2.setState({ republished: false });
                  },
                  onOpen: function onOpen() {
                    return _this2.setState({ republished: true });
                  },
                  open: this.state.republished,
                  trigger: React__default.createElement(
                    'div',
                    { className: 'publishBtn' },
                    React__default.createElement(
                      'button',
                      { disabled: isOpportunityOpened ? false : true },
                      'REPUBLISH'
                    )
                  )
                },
                React__default.createElement(
                  Modal.Header,
                  null,
                  'Update Opportunity'
                ),
                React__default.createElement(
                  Modal.Content,
                  { scrolling: true, style: { width: "100%" } },
                  React__default.createElement(
                    Table,
                    { celled: true },
                    React__default.createElement(
                      Table.Header,
                      null,
                      React__default.createElement(
                        Table.Row,
                        null,
                        React__default.createElement(
                          Table.HeaderCell,
                          null,
                          React__default.createElement('input', {
                            type: 'checkbox',
                            value: 'all',
                            checked: dpList.length && dpList.every(function (dp) {
                              return dp.checked;
                            }),
                            onChange: this.addPartnerId,
                            className: 'partner_cb'
                          })
                        ),
                        React__default.createElement(
                          Table.HeaderCell,
                          null,
                          'PARTNER NAME'
                        )
                      )
                    ),
                    React__default.createElement(
                      Table.Body,
                      null,
                      dpList.map(function (dp) {
                        return !bidPartnerId.includes(dp.partnerId) && React__default.createElement(
                          Table.Row,
                          { key: dp.partnerId },
                          React__default.createElement(
                            Table.Cell,
                            null,
                            React__default.createElement('input', {
                              type: 'checkbox',
                              checked: dp.checked,
                              value: dp.partnerId,
                              onChange: _this2.addPartnerId,
                              className: 'partner_cb'
                            })
                          ),
                          React__default.createElement(
                            Table.Cell,
                            null,
                            dp.name
                          )
                        );
                      })
                    )
                  )
                ),
                React__default.createElement(
                  Modal.Actions,
                  null,
                  React__default.createElement(
                    'button',
                    {
                      onClick: function onClick() {
                        return _this2.onSubmitDP();
                      },
                      className: 'simpleButton primaryButton ' + (!!(republishPartner.length < 1) && "disabled"),
                      type: 'submit'
                    },
                    'Submit'
                  ),
                  React__default.createElement(
                    'button',
                    {
                      onClick: function onClick() {
                        return _this2.setState({ republished: false });
                      },
                      className: 'simpleButton secondaryButton',
                      type: 'submit'
                    },
                    'Cancel'
                  )
                )
              ),
              this.props.tab === "SALES_PENDING_APPROVAL" && React__default.createElement(
                'div',
                { style: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "5px" } },
                React__default.createElement(
                  Modal,
                  {
                    size: 'tiny',
                    onClose: function onClose() {
                      return _this2.setState({ republished: false });
                    },
                    onOpen: function onOpen() {
                      return _this2.setState({ republished: true });
                    },
                    open: this.state.republished,
                    trigger: React__default.createElement(
                      'div',
                      { className: 'publishBtn', style: { height: "auto" } },
                      React__default.createElement(
                        'button',
                        { disabled: isOpportunityOpened ? false : true },
                        'REPUBLISH'
                      )
                    )
                  },
                  React__default.createElement(
                    Modal.Header,
                    null,
                    'Select Drayage Partners'
                  ),
                  React__default.createElement(
                    Modal.Content,
                    { scrolling: true, style: { width: "100%" } },
                    React__default.createElement(
                      Table,
                      { celled: true },
                      React__default.createElement(
                        Table.Header,
                        null,
                        React__default.createElement(
                          Table.Row,
                          null,
                          React__default.createElement(
                            Table.HeaderCell,
                            null,
                            React__default.createElement('input', {
                              type: 'checkbox',
                              value: 'all',
                              checked: dpList.length && dpList.every(function (dp) {
                                return dp.checked;
                              }),
                              onChange: this.addPartnerId,
                              className: 'partner_cb'
                            })
                          ),
                          React__default.createElement(
                            Table.HeaderCell,
                            null,
                            'PARTNER NAME'
                          )
                        )
                      ),
                      React__default.createElement(
                        Table.Body,
                        null,
                        dpList.map(function (dp) {
                          return !bidPartnerId.includes(dp.partnerId) && React__default.createElement(
                            Table.Row,
                            { key: dp.partnerId },
                            React__default.createElement(
                              Table.Cell,
                              null,
                              React__default.createElement('input', {
                                type: 'checkbox',
                                checked: dp.checked,
                                value: dp.partnerId,
                                onChange: _this2.addPartnerId,
                                className: 'partner_cb'
                              })
                            ),
                            React__default.createElement(
                              Table.Cell,
                              null,
                              dp.name
                            )
                          );
                        })
                      )
                    )
                  ),
                  React__default.createElement(
                    Modal.Actions,
                    null,
                    React__default.createElement(
                      'button',
                      {
                        onClick: function onClick() {
                          return _this2.onSubmitDP();
                        },
                        className: 'simpleButton primaryButton ' + (!!(republishPartner.length < 1) && "disabled"),
                        type: 'submit'
                      },
                      'Submit'
                    ),
                    React__default.createElement(
                      'button',
                      {
                        onClick: function onClick() {
                          return _this2.setState({ republished: false });
                        },
                        className: 'simpleButton secondaryButton',
                        type: 'submit'
                      },
                      'Cancel'
                    )
                  )
                ),
                isOpportunityOpened && salesAllowed && React__default.createElement(
                  'button',
                  {
                    style: { margin: "0", height: "auto" },
                    className: "done_button" + (this.props.isDoneDisabled(opportunityId) ? " isDisabled" : ""),
                    onClick: function onClick() {
                      return !_this2.props.isDoneDisabled(opportunityId) && onOpportunitySelect(opportunityId);
                    }
                  },
                  'DONE'
                )
              ),
              this.props.tab === "SALES_CUSTOMER_REQUESTED" && React__default.createElement(
                'div',
                { className: 'publishBtn' },
                React__default.createElement(
                  'button',
                  {
                    onClick: function onClick() {
                      return _this2.props.renewOpportunityFunc(opportunityId);
                    },
                    disabled: isOpportunityOpened ? false : true
                  },
                  'PUBLISH'
                )
              ),
              this.showOppUpdationModal() ? React__default.createElement(
                'div',
                {
                  className: 'dateEditBtn ' + (tab === salesPortalTabs.SALES_ACCEPTED && !isOpportunityOpened ? "disabledEditBtn" : ""),
                  style: { width: "fit-content" },
                  onClick: function onClick() {
                    return tab === salesPortalTabs.SALES_ACCEPTED && !isOpportunityOpened ? {} : _this2.setState({ openOpportunityUpdationModal: true });
                  }
                },
                'Edit'
              ) : null,
              this.showOppUpdateHistoryModal() ? React__default.createElement(Popup, { content: 'History',
                trigger: React__default.createElement(
                  'div',
                  { className: 'oppHistoryBtn',
                    onClick: function onClick() {
                      return _this2.setState({ openOpportunityUpdateHistoryModal: true });
                    }
                  },
                  React__default.createElement(Icon, { name: 'history' })
                ),
                size: 'mini',
                position: 'top center' }) : null
            ),
            React__default.createElement(
              Grid.Column,
              { width: 1 },
              React__default.createElement(
                'div',
                { className: 'infoSEC' },
                this.props.opportunity.description && this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && React__default.createElement(
                  Popup,
                  {
                    trigger: React__default.createElement('img', { className: 'noteIcon', style: arWithoutAP ? { top: "20px", right: "15px" } : { top: "10px", right: "15px" }, src: note, alt: 'notes' }),
                    size: 'mini',
                    position: 'top center'
                  },
                  lodash_1(this.props, "opportunity.description", "N/A")
                )
              ),
              arWithoutAP && React__default.createElement(
                'div',
                { 'class': 'ribbon-wrapper-green' },
                React__default.createElement(
                  'div',
                  { 'class': 'ribbon-green' },
                  'AR WITHOUT AP'
                )
              )
            )
          )
        )
      ) : React__default.createElement(
        'div',
        { className: 'OpportunityHeader opportunityHeaderContainer' },
        errorModal && React__default.createElement(KnModal$1, {
          size: 'mini',
          className: KnModalsStyle.knModalContainer,
          open: errorModal,
          onClose: function onClose() {
            _this2.setState({ errorModal: false });
          },
          header: 'Error',
          content: errorContent,
          actionButtons: [{
            name: 'OK',
            onClick: function onClick() {
              _this2.setState({ errorModal: false });
            }
          }]
        }),
        openOpportunityUpdationModal && React__default.createElement(OpportunityUpdationModal, {
          minDate: new Date(),
          openModal: openOpportunityUpdationModal
          // bidCloseDate={bidCloseDate}
          , bidCloseDate: formatDateTime(endDate),
          currentBidCloseDate: this.props.opportunity && parseInt(this.props.opportunity.endDate),
          opportunityId: opportunityId
          // onChange={(value) => {
          //   this.setState({ bidCloseDate: value });
          // }}
          , onClose: function onClose() {
            return _this2.setState({ openOpportunityUpdationModal: false });
          },
          onOpen: function onOpen() {
            return _this2.setState({ openOpportunityUpdationModal: true });
          },
          setSalesOpportunityUpdatedData: this.props.setSalesOpportunityUpdatedData,
          tab: this.props.tab,
          allPartners: dpList,
          currentBidPartnersIds: bidPartnerId,
          partnerBidsData: this.state.partBids,
          currentsourceList: this.state.currentsourceList,
          handleOpenBidModal: this.props.handleOpenBidModal,
          handleOpportunityBidClicked: this.props.handleOpportunityBidClicked,
          isBiddingFromOppUpdation: this.props.isBiddingFromOppUpdation,
          oppUpdationData: this.props.oppUpdationData,
          handleBidUpdationOpenClose: this.props.handleBidUpdationOpenClose,
          openCloseOpp: this.openCloseOpp,
          bidRenewalDate: formatDateTime(renewalDate),
          customerAcceptanceDate: this.props.opportunity && formatDateTime(lodash_1(this.props.opportunity, 'customerAcceptanceDeadline', new Date()))
        }),
        React__default.createElement(
          'div',
          { className: 'accordianControllerIcon' },
          React__default.createElement(Icon, { onClick: function onClick() {
              return _this2.openCloseOpp(opportunityId);
            }, className: isOpportunityOpened ? "opportunityHeaderIcon openOpportunity" : 'opportunityHeaderIcon', name: !isOpportunityOpened ? 'chevron circle right' : "chevron circle down" })
        ),
        this.state.sucessModal === true && React__default.createElement(
          Modal,
          {
            size: 'mini',
            open: this.state.sucessModal === true
          },
          React__default.createElement(
            Modal.Header,
            null,
            'REPUBLISHED OPPORTUNITY'
          ),
          React__default.createElement(
            Modal.Content,
            { style: { width: "100%" } },
            React__default.createElement(
              'p',
              null,
              'Opportunity is successfully republished'
            )
          ),
          React__default.createElement(
            Modal.Actions,
            null,
            React__default.createElement(
              Button,
              { positive: true, onClick: function onClick() {
                  return _this2.onSucessOk(false);
                } },
              'OK'
            )
          )
        ),
        React__default.createElement(
          'div',
          { className: 'titleSec' },
          opportunityName && splitForTooltip(opportunityName.toUpperCase()),
          React__default.createElement(
            'div',
            { className: 'date-pair', style: { marginRight: '0' } },
            React__default.createElement(
              'div',
              { className: 'rowAlignFlex centerAligned' },
              showBidClose(this.props.drayageApp, tab) && React__default.createElement(
                'div',
                { className: 'expiry-date date-pair' },
                'BID CLOSE DATE: ',
                oppEndDateFormatted
              ),
              this.showOppUpdationModal() ? React__default.createElement(
                'div',
                { className: 'dateEditBtn ' + (tab === salesPortalTabs.SALES_ACCEPTED && !isOpportunityOpened ? 'disabledEditBtn' : ''),
                  onClick: function onClick() {
                    return tab === salesPortalTabs.SALES_ACCEPTED && !isOpportunityOpened ? {} : _this2.setState({ openOpportunityUpdationModal: true });
                  }
                },
                'Edited'
              ) : null
            ),
            tab === SELECTED_TABS.SALES_ARCHIVED && React__default.createElement(
              'div',
              null,
              'EXPIRED ON:  ',
              oppEndDateFormatted
            ),
            arWithoutAP && opportunityStateMap[opportunityState] && showOpprotunityStateStatus({ tab: tab }) && React__default.createElement(
              'div',
              { className: 'date-pair' },
              'OPPORTUNITY STATE:  ',
              opportunityStateMap[opportunityState]
            )
          )
        ),
        React__default.createElement(
          'div',
          { className: 'renewalSec' },
          React__default.createElement(
            'div',
            { className: 'actionSec' },
            tab === "SALES_ACCEPTED" && opp_key !== "containerOpportunities" && (diffRenewalDays < 10 && diffRenewalDays > 0 || alreadyExpired) && isOpportunityOpened && React__default.createElement(
              'div',
              { className: 'renewBtn' },
              React__default.createElement(
                'button',
                {
                  className: '',
                  onClick: function onClick() {
                    return _this2.props.renewOpportunityFunc(opportunityId, true);
                  }
                },
                'RENEW'
              )
            )
          ),
          React__default.createElement(
            'div',
            { className: 'renewalDateSec' },
            showRenewalDate(this.props.drayageApp, tab) && opp_key !== "containerOpportunities" && React__default.createElement(
              'div',
              { className: diffRenewalDays < 10 && diffRenewalDays > 0 || alreadyExpired ? "renewal-date" : "", style: { color: colorOfRenewal } },
              opportunityExpiryDate && opportunityExpiryDate != 0 ? "RENEWAL DATE: " + expiredDate : ""
            ),
            this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && opp_key !== "containerOpportunities" && tab === "SALES_ACCEPTED" && renewalDate ? React__default.createElement(
              'div',
              { className: diffRenewalDays < 10 && diffRenewalDays > 0 || alreadyExpired ? "date-pair renewal-date" : "date-pair" },
              "RENEWAL DATE: ",
              ' ',
              expiredDate
            ) : null,
            this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && opp_key === "containerOpportunities" && tab === "SALES_ACCEPTED" && React__default.createElement(
              'div',
              { className: 'date-pair' },
              "ESTIMATED TIME OF ARRIVAL: ",
              ' ',
              expPickUpDate
            )
          )
        ),
        React__default.createElement(
          'div',
          { className: 'actionBtns', style: { display: "flex", marginRight: arWithoutAP ? 57 : 0, gap: '5px' } },
          isOpportunityOpened && this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && this.props.tab === SELECTED_TABS.CUSTOMER_NEW && React__default.createElement(
            'button',
            {
              onClick: function onClick(e) {
                _this2.props.customerBidmodalHandler(_this2.props.opportunity.opportunityId);
              },
              className: 'drayage-approve-btn'
            },
            'APPROVE'
          ),
          this.props.tab === "SALES_PUBLISHED" && React__default.createElement(
            Modal,
            {
              size: 'tiny',
              onClose: function onClose() {
                return _this2.setState({ republished: false });
              },
              onOpen: function onOpen() {
                return _this2.setState({ republished: true });
              },
              open: this.state.republished,
              trigger: React__default.createElement(
                'div',
                { className: 'publishBtn' },
                React__default.createElement(
                  'button',
                  {
                    disabled: isOpportunityOpened ? false : true
                  },
                  'REPUBLISH'
                )
              )
            },
            React__default.createElement(
              Modal.Header,
              null,
              'Update Opportunity'
            ),
            React__default.createElement(
              Modal.Content,
              { scrolling: true, style: { width: "100%" } },
              React__default.createElement(
                Table,
                { celled: true },
                React__default.createElement(
                  Table.Header,
                  null,
                  React__default.createElement(
                    Table.Row,
                    null,
                    React__default.createElement(
                      Table.HeaderCell,
                      null,
                      React__default.createElement('input', {
                        type: 'checkbox',
                        value: 'all',
                        checked: dpList.length && dpList.every(function (dp) {
                          return dp.checked;
                        }),
                        onChange: this.addPartnerId,
                        className: 'partner_cb'
                      })
                    ),
                    React__default.createElement(
                      Table.HeaderCell,
                      null,
                      'PARTNER NAME'
                    )
                  )
                ),
                React__default.createElement(
                  Table.Body,
                  null,
                  dpList.map(function (dp) {
                    return !bidPartnerId.includes(dp.partnerId) && React__default.createElement(
                      Table.Row,
                      { key: dp.partnerId },
                      React__default.createElement(
                        Table.Cell,
                        null,
                        React__default.createElement('input', {
                          type: 'checkbox',
                          checked: dp.checked,
                          value: dp.partnerId,
                          onChange: _this2.addPartnerId,
                          className: 'partner_cb'
                        })
                      ),
                      React__default.createElement(
                        Table.Cell,
                        null,
                        dp.name
                      )
                    );
                  })
                )
              )
            ),
            React__default.createElement(
              Modal.Actions,
              null,
              React__default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    return _this2.onSubmitDP();
                  },
                  className: 'simpleButton primaryButton ' + (!!(republishPartner.length < 1) && 'disabled'),
                  type: 'submit'
                },
                'Submit'
              ),
              React__default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    return _this2.setState({ republished: false });
                  },
                  className: 'simpleButton secondaryButton',
                  type: 'submit'
                },
                'Cancel'
              )
            )
          ),
          this.props.tab === "SALES_PENDING_APPROVAL" && React__default.createElement(
            Modal,
            {
              size: 'tiny',
              onClose: function onClose() {
                return _this2.setState({ republished: false });
              },
              onOpen: function onOpen() {
                return _this2.setState({ republished: true });
              },
              open: this.state.republished,
              trigger: React__default.createElement(
                'div',
                { className: 'publishBtn' },
                React__default.createElement(
                  'button',
                  {
                    disabled: isOpportunityOpened ? false : true
                  },
                  'REPUBLISH'
                )
              )
            },
            React__default.createElement(
              Modal.Header,
              null,
              'Select Drayage Partners'
            ),
            React__default.createElement(
              Modal.Content,
              { scrolling: true, style: { width: "100%" } },
              React__default.createElement(
                Table,
                { celled: true },
                React__default.createElement(
                  Table.Header,
                  null,
                  React__default.createElement(
                    Table.Row,
                    null,
                    React__default.createElement(
                      Table.HeaderCell,
                      null,
                      React__default.createElement('input', {
                        type: 'checkbox',
                        value: 'all',
                        checked: dpList.length && dpList.every(function (dp) {
                          return dp.checked;
                        }),
                        onChange: this.addPartnerId,
                        className: 'partner_cb'
                      })
                    ),
                    React__default.createElement(
                      Table.HeaderCell,
                      null,
                      'PARTNER NAME'
                    )
                  )
                ),
                React__default.createElement(
                  Table.Body,
                  null,
                  dpList.map(function (dp) {
                    return !bidPartnerId.includes(dp.partnerId) && React__default.createElement(
                      Table.Row,
                      { key: dp.partnerId },
                      React__default.createElement(
                        Table.Cell,
                        null,
                        React__default.createElement('input', {
                          type: 'checkbox',
                          checked: dp.checked,
                          value: dp.partnerId,
                          onChange: _this2.addPartnerId,
                          className: 'partner_cb'
                        })
                      ),
                      React__default.createElement(
                        Table.Cell,
                        null,
                        dp.name
                      )
                    );
                  })
                )
              )
            ),
            React__default.createElement(
              Modal.Actions,
              null,
              React__default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    return _this2.onSubmitDP();
                  },
                  className: 'simpleButton primaryButton ' + (!!(republishPartner.length < 1) && 'disabled'),
                  type: 'submit'
                },
                'Submit'
              ),
              React__default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    return _this2.setState({ republished: false });
                  },
                  className: 'simpleButton secondaryButton',
                  type: 'submit'
                },
                'Cancel'
              )
            )
          ),
          this.props.tab === "SALES_CUSTOMER_REQUESTED" && React__default.createElement(
            'div',
            { className: 'publishBtn' },
            React__default.createElement(
              'button',
              {
                onClick: function onClick() {
                  return _this2.props.renewOpportunityFunc(opportunityId);
                },
                disabled: isOpportunityOpened ? false : true
              },
              'PUBLISH'
            )
          ),
          this.props.tab === "SALES_PENDING_APPROVAL" && isOpportunityOpened && salesAllowed && React__default.createElement(
            'button',
            {
              className: "done_button" + (this.props.isDoneDisabled(opportunityId) ? " isDisabled" : ""),
              onClick: function onClick() {
                return !_this2.props.isDoneDisabled(opportunityId) && onOpportunitySelect(opportunityId);
              }
            },
            'DONE'
          ),
          React__default.createElement(
            'div',
            { className: 'infoSEC' },
            this.props.opportunity.description && this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && React__default.createElement(
              Popup,
              {
                trigger: React__default.createElement('img', { className: 'noteIcon', src: note, alt: 'notes' }),
                size: 'mini',
                position: 'top center'
              },
              lodash_1(this.props, 'opportunity.description', 'N/A')
            )
          )
        ),
        arWithoutAP && React__default.createElement(
          'div',
          { 'class': 'ribbon-wrapper-green' },
          React__default.createElement(
            'div',
            { 'class': 'ribbon-green' },
            'AR WITHOUT AP'
          )
        )
      );
    }
  }]);
  return OpportunityHeader;
}(PureComponent);

var css_248z$o = ".opportunityAccordian {\n  width: 100%;\n  margin: 2rem auto 0; }\n  .opportunityAccordian .OpportunityHeader {\n    position: relative;\n    width: 100%;\n    border: 1px solid #dcdcdc;\n    background-color: #e9edf3;\n    border-radius: 3px;\n    box-shadow: 0 2px 4px 0 rgba(219, 219, 219, 0.5);\n    height: 60px;\n    display: grid;\n    padding-left: 17px;\n    grid-template-columns: 30px minmax(max-content, 4fr) minmax(max-content, 4fr) minmax(max-content, 1fr) minmax(max-content, 1fr); }\n    .opportunityAccordian .OpportunityHeader .ribbon-wrapper-green {\n      width: 77px;\n      height: 60px;\n      overflow: hidden;\n      position: absolute;\n      top: -3px;\n      right: 0; }\n      .opportunityAccordian .OpportunityHeader .ribbon-wrapper-green .ribbon-green {\n        font-size: xx-small;\n        color: #fff;\n        text-align: center;\n        text-shadow: rgba(255, 255, 255, 0.5) 0px 1px 0px;\n        -webkit-transform: rotate(45deg);\n        position: relative;\n        padding: 7px 0;\n        left: -10px;\n        top: 12px;\n        width: 120px;\n        float: left;\n        background-color: #04adb1; }\n      .opportunityAccordian .OpportunityHeader .ribbon-wrapper-green .ribbon-green:before,\n      .opportunityAccordian .OpportunityHeader .ribbon-wrapper-green .ribbon-green:after {\n        content: \"\";\n        border-top: 3px solid #6e8900;\n        border-left: 3px solid transparent;\n        border-right: 3px solid transparent;\n        position: absolute;\n        bottom: -3px; }\n      .opportunityAccordian .OpportunityHeader .ribbon-wrapper-green .ribbon-green:before {\n        left: 0; }\n      .opportunityAccordian .OpportunityHeader .ribbon-wrapper-green .ribbon-green:after {\n        right: 0; }\n    .opportunityAccordian .OpportunityHeader .titleSec, .opportunityAccordian .OpportunityHeader .renewalSec, .opportunityAccordian .OpportunityHeader .accordianControllerIcon {\n      display: grid;\n      grid-auto-rows: 1fr;\n      align-items: center;\n      justify-content: start; }\n    .opportunityAccordian .OpportunityHeader .titleSec {\n      padding-left: 6px; }\n    .opportunityAccordian .OpportunityHeader .infoSEC {\n      line-height: 4rem; }\n      .opportunityAccordian .OpportunityHeader .infoSEC .noteIcon {\n        top: 5px;\n        position: relative; }\n    .opportunityAccordian .OpportunityHeader .renewal-date {\n      color: #de0f0f; }\n    .opportunityAccordian .OpportunityHeader .expandHorizontally {\n      margin-left: -18px; }\n      .opportunityAccordian .OpportunityHeader .expandHorizontally i {\n        color: white;\n        margin: 0;\n        font-size: 1.3em; }\n    .opportunityAccordian .OpportunityHeader .accordianControllerIcon {\n      justify-content: center;\n      align-items: flex-start; }\n      .opportunityAccordian .OpportunityHeader .accordianControllerIcon .opportunityHeaderIcon {\n        cursor: pointer;\n        margin: 6px auto 0 auto;\n        color: #04adb1;\n        font-size: 18px; }\n    .opportunityAccordian .OpportunityHeader .opportunityTitle {\n      color: #000000;\n      font-family: \"Open Sans\";\n      font-size: 20px !important;\n      font-weight: bold;\n      letter-spacing: 0;\n      line-height: 28px; }\n  .opportunityAccordian .party-name {\n    padding-left: 0 !important; }\n\n.bid-amount-customer-status {\n  display: flex;\n  flex-direction: row; }\n\n.opportunityAccordian.opportunityAccordianExpanded .bid-per-container, .opportunityAccordian.opportunityAccordianExpanded .total-bid {\n  display: block !important; }\n\n[data-tab-container=\"SALES_ACCEPTED\"] .opportunityAccordian .OpportunityHeader {\n  grid-template-columns: 30px minmax(max-content, 4fr) minmax(max-content, 4fr) auto minmax(246px, auto); }\n\n[data-tab-container=\"SALES_PENDING_APPROVAL\"] .opportunityAccordian .OpportunityHeader, [data-tab-container=\"SALES_REJECTED\"] .opportunityAccordian .OpportunityHeader, [data-tab-container=\"SALES_ACCEPTED\"] .opportunityAccordian .OpportunityHeader, [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian .OpportunityHeader {\n  position: relative; }\n  [data-tab-container=\"SALES_PENDING_APPROVAL\"] .opportunityAccordian .OpportunityHeader .partnerBids, [data-tab-container=\"SALES_REJECTED\"] .opportunityAccordian .OpportunityHeader .partnerBids, [data-tab-container=\"SALES_ACCEPTED\"] .opportunityAccordian .OpportunityHeader .partnerBids, [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian .OpportunityHeader .partnerBids {\n    position: absolute;\n    right: -4px;\n    top: 60px; }\n    [data-tab-container=\"SALES_PENDING_APPROVAL\"] .opportunityAccordian .OpportunityHeader .partnerBids .partner_header, [data-tab-container=\"SALES_REJECTED\"] .opportunityAccordian .OpportunityHeader .partnerBids .partner_header, [data-tab-container=\"SALES_ACCEPTED\"] .opportunityAccordian .OpportunityHeader .partnerBids .partner_header, [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian .OpportunityHeader .partnerBids .partner_header {\n      margin-top: 0; }\n    [data-tab-container=\"SALES_PENDING_APPROVAL\"] .opportunityAccordian .OpportunityHeader .partnerBids .expandHorizontally, [data-tab-container=\"SALES_REJECTED\"] .opportunityAccordian .OpportunityHeader .partnerBids .expandHorizontally, [data-tab-container=\"SALES_ACCEPTED\"] .opportunityAccordian .OpportunityHeader .partnerBids .expandHorizontally, [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian .OpportunityHeader .partnerBids .expandHorizontally {\n      margin-left: -22px;\n      height: 50px; }\n  [data-tab-container=\"SALES_PENDING_APPROVAL\"] .opportunityAccordian .OpportunityHeader .actionBtns, [data-tab-container=\"SALES_REJECTED\"] .opportunityAccordian .OpportunityHeader .actionBtns, [data-tab-container=\"SALES_ACCEPTED\"] .opportunityAccordian .OpportunityHeader .actionBtns, [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian .OpportunityHeader .actionBtns {\n    display: flex; }\n    [data-tab-container=\"SALES_PENDING_APPROVAL\"] .opportunityAccordian .OpportunityHeader .actionBtns .done_button, [data-tab-container=\"SALES_REJECTED\"] .opportunityAccordian .OpportunityHeader .actionBtns .done_button, [data-tab-container=\"SALES_ACCEPTED\"] .opportunityAccordian .OpportunityHeader .actionBtns .done_button, [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian .OpportunityHeader .actionBtns .done_button {\n      margin-right: 65px; }\n\n.sales_app .opportunityAccordian .bid-col, .sales_app .opportunityAccordian .partner-total-footer {\n  margin-right: 18px; }\n  .sales_app .opportunityAccordian .bid-col:last-of-type, .sales_app .opportunityAccordian .partner-total-footer:last-of-type {\n    margin-right: 0; }\n\n.sales_app [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian.opportunityAccordianExpanded {\n  display: grid; }\n  .sales_app [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian.opportunityAccordianExpanded .OpportunityHeader {\n    width: 100% !important; }\n    .sales_app [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian.opportunityAccordianExpanded .OpportunityHeader .partnerBids .partner_header:first-of-type {\n      margin-right: 13px; }\n  .sales_app [data-tab-container=\"SALES_ARCHIVED\"] .opportunityAccordian.opportunityAccordianExpanded [data-tab=\"OPPORTUNITIES_LIST_OPENED\"] {\n    min-width: fit-content !important; }\n\n.cust-acc-text {\n  font-size: 5px;\n  color: green; }\n";
styleInject(css_248z$o);

var DestinationLane$1 = function (_Component) {
  inherits(DestinationLane, _Component);

  function DestinationLane(props) {
    classCallCheck(this, DestinationLane);

    // let isSelected = this.props.destinationData.isSelected
    // let lanePriceSelected = false
    // if (isSelected  && isSelected === "YES") {
    //   lanePriceSelected = true
    // }
    var _this = possibleConstructorReturn(this, (DestinationLane.__proto__ || Object.getPrototypeOf(DestinationLane)).call(this, props));

    _this.customerPricecardHandler = function (laneId, price) {
      _this.setState({
        priceClicked: !_this.state.priceClicked,
        priceClickedLaneId: laneId,
        priceOfClickedLane: price
      });
    };

    _this.priceCardCaneled = function () {
      _this.setState({ priceClickedLaneId: "" });
    };

    _this.getTotals = function (wantsPortLevel) {
      var destinationData = _this.props.destinationData;


      var totals = [],
          portDataIsMap = false;

      if (_this.props.portData) {
        if (_this.props.portData instanceof Map) portDataIsMap = true;

        var portCodeClone = _this.props.portData;
        if (!portDataIsMap) {
          portCodeClone = new Map();
          portCodeClone.set(_this.props.portData.sourceId, _this.props.portData);
        }

        var ports = Array.from(portCodeClone.keys());
        if (wantsPortLevel) ports = [destinationData.sourceId];

        for (var j = 0; j < ports.length; j++) {
          var portCode = portCodeClone.get(ports[j]).sourceId;
          var thisPortData = portCodeClone.get(portCode);

          var _loop = function _loop(i) {
            var approxVolume = thisPortData.destinations[i].approxVolume;

            var partnerBids = lodash_1(thisPortData.destinations[i], partnerBids, []);
            partnerBids.forEach(function (bid, j) {
              if (!totals[j]) totals[j] = 0;
              totals[j] += partnerBids[j].bidAmount * Number(approxVolume);
            });
          };

          for (var i = 0; i < thisPortData.destinations.length; i++) {
            _loop(i);
          }
        }
      }

      return totals;
    };

    _this.selectBox = function (e, partnerId, laneId, bid) {
      var _this$props = _this.props,
          portId = _this$props.portId,
          opportunityId = _this$props.opportunityId,
          customerId = _this$props.customerId;

      var parentEl = e.target.closest(".handle-select-box");
      var laneEl = e.target.closest(".lane-row") || e.target.closest(".destinationDataRow");

      if (parentEl.classList.contains("is-selected")) {
        laneEl.classList.remove("laneSelected");
        parentEl.classList.remove("is-selected");
        _this.props.unSelectBid(partnerId, laneId, portId, opportunityId, customerId);
      } else {
        laneEl.classList.add("laneSelected");
        parentEl.classList.add("is-selected");
        _this.props.selectBid(partnerId, laneId, portId, opportunityId, customerId, _this.props.opp_key, bid);
      }
    };

    _this.loadOpportunityDetails = function () {
      _this.props.getOpportunityDetailsApi(_this.props.opportunityId, _this.props.tab, false);
      _this.setState({ isLanePriceUpdating: false });
    };

    _this.customerSelectBox = function (e, destinationData) {
      _this.props.setCustomerLanePriceSelected(_this.props.opportunityId, destinationData.laneId, !(destinationData.isSelected === "YES"), _this.props.tab);
      // this.props.getOpportunityDetailsApi(this.props.opportunityId, this.props.tab, false)
      setTimeout(_this.loadOpportunityDetails, 1000);
      _this.setState({ isLanePriceUpdating: true });

      // this.props.setLanePriceSelected(
      //   this.props.opportunityId,
      //   destinationData.sourceId,
      //   destinationData.laneId,
      //   selected,
      //   // destinationData.unitPrice,

      // );
      //this.props.selectBid(partnerId, laneId, portId, opportunityId, customerId)
    };

    _this.state = {
      bidData: {},
      priceClickedLaneId: "",
      priceOfClickedLane: "",
      // lanePriceSelected:lanePriceSelected,
      isLanePriceUpdating: false
    };
    return _this;
  }

  createClass(DestinationLane, [{
    key: "render",


    //this.props.drayageApp , "this.props.drayageApp"
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          destinationData = _props.destinationData,
          tab = _props.tab,
          drayageApp = _props.drayageApp,
          opportunityState = _props.opportunityState,
          arWithoutAP = _props.arWithoutAP;

      var laneColumns = OpportunityOpenedColumnValues[this.props.drayageApp][this.props.tab];

      var extraLaneColumns = getExtraLaneColumn({ drayageApp: drayageApp, tab: tab, opportunityState: opportunityState, arWithoutAP: arWithoutAP }); // for adding extra on some condition add here in this function 
      laneColumns = [].concat(toConsumableArray(laneColumns), toConsumableArray(extraLaneColumns));
      // let laneColumns = OpportunityOpenedColumnValues[this.props.drayageApp][this.props.tab.split(" ").join("_") + "_SALES"]

      //this.props.destinationData
      // baseFees: "600"
      // chasisRentalperday: "12"
      // fuelCharges: "2"
      // minReqDays: "12"
      //bidBaseTotal
      var bidBaseTotal = lodash_1(this.props, "destinationData.destinationBidData.bidBaseTotal", null);

      var destinationName = destinationData.destinationId;
      var destinationApproxVolume = destinationData["approxVolume"];
      var proposedBid = destinationData["proposedBid"];
      var totalPrice = destinationData["totalPrice"];
      var totalProposedAmount = destinationData["totalProposedAmount"];

      // let totalPrice = parseInt(destinationData["approxVolume"]) * destinationData["proposedBid"];
      var portId = destinationData.sourceId;
      var sourceId = destinationData.sourceId;
      var sourceName = destinationData.source;
      var laneId = destinationData.laneId;
      //let sorcePortName=destinationData.sourceName
      var destinationAddressNamelower = lodash_1(destinationData["destinationAddress"], "addressName.value", "NONE");
      var destinationAddressName = destinationAddressNamelower && destinationAddressNamelower.toUpperCase();

      destinationAddressName = !destinationAddressName ? "TBD" : destinationAddressName;

      var addressInfo = lodash_1(destinationData, "destination", '');

      // let addressName = extractAddressToDisplay(addressInfo);
      var addressName = addressInfo;

      totalPrice = amountToShortString(totalPrice);

      var lowestBid = Number.MAX_SAFE_INTEGER;
      var numOfBids = destinationData.partnerBids ? destinationData.partnerBids.length : 0;

      for (var i = 0; i < numOfBids; i++) {
        if (destinationData.partnerBids[i].bidAmount < lowestBid) lowestBid = destinationData.partnerBids[i].bidAmount;
      }

      var splitForTooltip = function splitForTooltip(name) {
        // // if(!name)
        // return"TBD"

        var firstPart = name ? name.substring(0, 20) : "";

        return React__default.createElement(
          React__default.Fragment,
          null,
          firstPart,
          name && name.length > 20 ? React__default.createElement(Popup, {
            content: name,
            trigger: React__default.createElement(
              "b",
              null,
              React__default.createElement(
                "a",
                { href: "/#", style: { color: "#0A8B8F" } },
                "..."
              )
            )
          }) : ""
        );
      };

      var priceBackgroundColor = function priceBackgroundColor(props, destinationData) {
        if (isCustomerActiveTab(props)) {
          if (destinationData.customerStatus === "CUSTOMER_ACTIVE") {
            return {
              backgroundColor: "#EAFCFD",
              border: "1px solid #1EA507",
              padding: "12px"
            };
          }
        }

        if (isCustomerRejectedTab(props)) {
          if (destinationData.customerStatus === "CUSTOMER_REJECTED") {
            return {
              backgroundColor: "#EDC7BE",
              border: "1px solid #F18A72",
              padding: "12px"
            };
          } else if (destinationData.customerStatus === "CUSTOMER_ACTIVE") {
            return { padding: "12px" };
          }
        }

        return "white";
      };
      var submitBidColorClass = null;
      var totalBidColorClass = null;

      var partnerStatus = "PARTNER_STATUS_NONE";
      if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.props.columnDataLane[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = slicedToArray(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            if (key === "PartnerStatus") {
              partnerStatus = value && value.length > 0 ? value[0] : partnerStatus;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var laneDisabled = false;
      switch (partnerStatus) {
        case "PARTNER_NEW":
          break;

        case "PARTNER_REJECTED":
          if (this.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
            totalBidColorClass = " data-light-red";
            submitBidColorClass = " data-solid-red";
          } else if (this.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
            laneDisabled = true;
            submitBidColorClass = " data-solid-gray";
          }
          break;

        case "PARTNER_SUBMITTED":
          break;

        case "PARTNER_ACTIVE":
          if (this.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
            submitBidColorClass = " data-solid-green";
          } else if (this.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
            laneDisabled = true;
          }
          break;

        default:
          break;
      }
      if (laneDisabled && (this.props.activeLanesOnly || this.props.tab === SELECTED_TABS.PARTNER_REJECTED)) {
        return null;
      }

      var getCoumnClassName = function getCoumnClassName(column, submitBidColorClass, totalBidColorClass, isTotalRow) {
        if (isTotalRow) {
          return "data-other-col";
        }
        switch (column.name) {
          case "SubmittedBid":
            if (submitBidColorClass) {
              return column.classname1 + submitBidColorClass;
            } else {
              return column.classname1;
            }
          case "Total":
            if (totalBidColorClass) {
              return column.classname1 + totalBidColorClass;
            } else {
              return column.classname1;
            }
          default:
            return column.classname1;
        }
      };

      var isSelected = this.props.destinationData.isSelected;
      // let lanePriceSelected = false
      // if (isSelected  && isSelected === "YES") {
      //   lanePriceSelected = true
      // }

      var computeAmountDisplay = function computeAmountDisplay(amount, column) {
        // let result = amount
        // if (column.amountDisplayFunc) {
        console.log("computeAmountDisplay >>> ", amount, column);
        if (column.amountDisplayFunc) {
          return column.amountDisplayFunc(amount, column.isPrice);
        }
        return amount;
        // }
        // return amount
      };

      return React__default.createElement(
        "tr",
        {
          className: "destinationDataRow"
          // className={
          //   !rowColorClass
          //     ? "lane-row data-row"
          //     : "lane-row data-row " + rowColorClass
          // }
          , style: laneDisabled ? this.props.isTotalRow || this.props.isGrandTotalRow ? { color: "gray" } : { color: "gray", backgroundColor: "white" } : this.props.isTotalRow || this.props.isGrandTotalRow ? null : { backgroundColor: "white" }
        },
        React__default.createElement(
          "td",
          null,
          React__default.createElement(
            "div",
            { className: "rowAlignCentered extraBottomPadding" },
            React__default.createElement(
              "div",
              null,
              !(this.props.isTotalRow || this.props.isGrandTotalRow) && React__default.createElement("img", {
                className: "warehouse-img",
                src: "images/files/warehouse.svg",
                alt: ""
              })
            ),
            React__default.createElement(
              "div",
              null,
              !(this.props.isTotalRow || this.props.isGrandTotalRow) && React__default.createElement(
                "div",
                { className: "small-text" },
                "TO:"
              ),
              !(this.props.isTotalRow || this.props.isGrandTotalRow) && React__default.createElement(
                "div",
                { className: "portName-text" },
                React__default.createElement(
                  "div",
                  null,
                  splitForTooltip(addressName)
                )
              ),
              (this.props.isTotalRow || this.props.isGrandTotalRow) && React__default.createElement(
                "div",
                {
                  style: {
                    fontSize: "18px",
                    textAlign: "right",
                    paddingTop: "18px"
                  }
                },
                this.props.isTotalRow ? "Total" : "Grand Total"
              )
            )
          )
        ),
        laneColumns && laneColumns.map(function (column) {
          if ((_this2.props.isTotalRow || _this2.props.isGrandTotalRow) && !["ApproxVolume", "ApproxTotalBusiness", "Total"].includes(column.name)) {
            return React__default.createElement(
              "td",
              null,
              React__default.createElement(
                "div",
                { className: "colAlignCentered extraBottomPadding", style: _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { alignItems: "flex-start" } : null },
                React__default.createElement(
                  "div",
                  {
                    style: _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { textAlign: "left" } : null,
                    className: getCoumnClassName(column, submitBidColorClass, totalBidColorClass, _this2.props.isTotalRow || _this2.props.isGrandTotalRow)
                  },
                  React__default.createElement("div", { className: column.classname2 })
                )
              )
            );
          }
          return (
            // <div className={column.name === "SubmittedBid" ? (submitBidColorClass ? column.classname1 + submitBidColorClass  :   column.classname1) :
            //               ( column.name === "Total" ? totalBidColorClass ? column.classname1 + totalBidColorClass  :  column.classname1 : column.classname1)}>
            React__default.createElement(
              "td",
              null,
              React__default.createElement(
                "div",
                { className: "colAlignCentered extraBottomPadding",
                  style: _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { alignItems: "flex-start" } : null
                },
                React__default.createElement(
                  "div",
                  {
                    className: getCoumnClassName(column, submitBidColorClass, totalBidColorClass, _this2.props.isTotalRow || _this2.props.isGrandTotalRow),
                    style: _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { textAlign: "left" } : null
                  },
                  React__default.createElement(
                    "div",
                    { className: column.classname2, style: _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { textAlign: "left", margin: "0" } : null },
                    column.name === "UnitPrice" || column.name === "TotalBaseCharge" ? React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(
                        "div",
                        { id: "opp-accord",
                          className: "unitPrice-btn customer-handle-select-box",
                          style: {
                            backgroundColor: priceBackgroundColor(_this2.props, destinationData).backgroundColor,
                            border: priceBackgroundColor(_this2.props, destinationData).border,
                            padding: priceBackgroundColor(_this2.props, destinationData).padding,
                            margin: _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? "0" : "-16.5px"
                          },
                          onMouseOver: !isCustomerNewTab(_this2.props) && column.name === "UnitPrice" ? function (e) {
                            _this2.customerPricecardHandler(destinationData.laneId);
                          } : null
                          // onMouseLeave={(e) => {
                          //   this.priceCardCaneled(
                          //     destinationData.laneId
                          //   );
                          // }}
                        },
                        React__default.createElement(
                          "div",
                          { className: "customer-handle-select-box-child1" },
                          React__default.createElement(
                            "span",
                            { style: { fontSize: 10 } },
                            destinationData[DRAYAGE_CURRENCY_COLUMNS.AR_WITHOUT_AP]
                          ),
                          computeAmountDisplay(_this2.props.columnDataLane.get(column.name), column)
                        ),
                        isCustomerNewTab(_this2.props) && column.name === "TotalBaseCharge" && React__default.createElement(
                          "div",
                          {
                            // className="customer-select_box"
                            onClick: !_this2.state.isLanePriceUpdating ? function (e) {
                              _this2.customerSelectBox(e, destinationData);
                              // this.props.setCustomerLanePriceSelected(this.props.opportunityId, destinationData.laneId, true);
                            } : null,
                            style: isSelected === "YES" ? {
                              backgroundColor: "#0A53B8",
                              color: "white"
                            } : {}
                          },
                          _this2.state.isLanePriceUpdating ? isSelected === "YES" ? "Unselecting ..." : "selecting ..." : isSelected === "YES" ? "SELECTED" : "SELECT"
                        )
                      )
                    ) : React__default.createElement(
                      "div",
                      {
                        onMouseOver: function onMouseOver(e) {
                          if (column.name === "SubmittedBid") {
                            _this2.customerPricecardHandler(destinationData.laneId);
                          }
                        }
                      },
                      " ",
                      " ",
                      React__default.createElement(
                        "span",
                        { className: "currencyType", style: { fontSize: 12 } },
                        column.currencyType ? _this2.props.columnDataLane.get(column.currencyType) : ''
                      ),
                      computeAmountDisplay(_this2.props.columnDataLane.get(column.name), column),
                      " "
                    ),
                    column.name === "UnitPrice" && isCustomerNewTab(_this2.props) && React__default.createElement(KnHoverablePopup, {
                      position: "top right",
                      content: _this2.props.destinationData.laneId === _this2.state.priceClickedLaneId ? React__default.createElement(CustomerPriceCard, {
                        priceCardCaneled: _this2.priceCardCaneled,
                        opportunityId: _this2.props.opportunityId,
                        laneId: destinationData.laneId,
                        sourceId: destinationData.sourceId,
                        destinationData: _this2.props.destinationData,
                        drayageApp: drayageApp,
                        tab: tab
                      }) : null,
                      trigger: React__default.createElement(
                        "button",
                        {
                          onMouseOver: function onMouseOver(e) {
                            _this2.customerPricecardHandler(destinationData.laneId);
                          },
                          className: "detailPrice-btn"
                          // style={column.name != "Details" ? {opacity:0} : null}
                        },
                        computeAmountDisplay(_this2.props.columnDataLane.get(column.name), column)
                      )
                    }),
                    (column.name === "UnitPrice" && !isCustomerNewTab(_this2.props) && tab !== 'SALES_PUBLISHED' && tab !== 'SALES_REJECTED' || column.name === "SubmittedBid") && React__default.createElement(KnHoverablePopup, {
                      position: "top right",
                      content: _this2.props.destinationData.laneId === _this2.state.priceClickedLaneId ? React__default.createElement(CustomerPriceCard, {
                        priceCardCaneled: _this2.priceCardCaneled,
                        opportunityId: _this2.props.opportunityId,
                        laneId: destinationData.laneId,
                        sourceId: destinationData.sourceId,
                        drayageApp: drayageApp,
                        tab: tab
                      }) : null,
                      trigger: React__default.createElement("button", {
                        onMouseOver: function onMouseOver(e) {
                          _this2.customerPricecardHandler(destinationData.laneId);
                        },
                        className: "detailPrice-btn-suggested-bid"
                        // style={column.name != "Details" ? {opacity:0} : null}
                      })
                    })
                  )
                )
              )
            )
          );
        }),
        React__default.createElement("td", null),
        (this.props.isTotalRow || this.props.isGrandTotalRow) && (tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED") && this.getTotals().map(function (val, index) {
          return !_this2.props.expanded && index > 0 ? null : React__default.createElement(
            "div",
            { className: "partner-total-footer" },
            "$",
            amountToTwoDecimal(val)
          );
        }),
        (tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED") && React__default.createElement(
          React__default.Fragment,
          null,
          destinationData.partnerBids && destinationData.partnerBids.map(function (bid, index) {
            return !_this2.props.expanded && index > 0 ? null : React__default.createElement(
              "td",
              null,
              React__default.createElement(
                "div",
                { className: "portOpportunityTablePartnerDataWrapper" },
                React__default.createElement(
                  "div",
                  {
                    className: "bid-col handle-select-box",
                    "bid-status-sales": bid.salesStatus,
                    "bid-status-customer": bid.customerStatus
                  },
                  React__default.createElement(KnHoverablePopup, {
                    position: "top right",
                    content: React__default.createElement(CustomerPriceCard, {
                      priceCardCaneled: _this2.priceCardCaneled,
                      opportunityId: _this2.props.opportunityId,
                      laneId: destinationData.laneId,
                      sourceId: destinationData.sourceId,
                      partnerId: bid.partnerId,
                      drayageApp: drayageApp,
                      tab: tab,
                      isSelectedBid: (bid.salesStatus === "SALES_ACCEPTED" || bid.customerStatus === "CUSTOMER_ACCEPTED") && tab === "SALES_ACCEPTED",
                      destinationData: destinationData
                    }),
                    trigger: React__default.createElement(
                      "div",
                      {
                        className: "partner-bid handle-select-box-child1" + (tab !== "SALES_REJECTED" && bid.bidAmount < proposedBid ? " low-bid" : "") + (tab !== "SALES_REJECTED" && bid.bidAmount === lowestBid ? " lowest-bid" : "")
                      },
                      (bid.salesStatus === "SALES_ACCEPTED" || bid.customerStatus === "CUSTOMER_ACCEPTED") && tab === "SALES_ACCEPTED" && React__default.createElement(Icon, {
                        name: "check circle outline",
                        className: "accepted_tick",
                        size: "small"
                      }),
                      bid.bidAmount < proposedBid && React__default.createElement(Icon, {
                        name: "long arrow alternate down",
                        className: "low_bid_arrow",
                        size: "small"
                      }),
                      React__default.createElement(
                        "div",
                        { style: { display: "flex", flexDirection: "column" } },
                        React__default.createElement(
                          "div",
                          null,
                          React__default.createElement(
                            "span",
                            { style: { fontSize: 10 } },
                            lodash_1(bid, [DRAYAGE_CURRENCY_COLUMNS[tab]], 'N/A')
                          ),
                          bid.bidAmount.toFixed(2)
                        ),
                        bid.customerStatus === "CUSTOMER_ACTIVE" ? React__default.createElement(
                          "div",
                          { style: { fontSize: "10px", color: "green", marginTop: "-26px" } },
                          "Customer Accepted"
                        ) : ""
                      )
                    )
                  }),
                  React__default.createElement(
                    "div",
                    { style: { marginTop: "-37px" },
                      className: "partner-bid-total handle-select-box-child2" + (tab !== "SALES_REJECTED" && bid.bidAmount < proposedBid ? " low-bid" : "") + (tab !== "SALES_REJECTED" && bid.bidAmount === lowestBid ? " lowest-bid" : "")
                    },
                    React__default.createElement(
                      "span",
                      { style: { fontSize: 10 } },
                      lodash_1(bid, [DRAYAGE_CURRENCY_COLUMNS[tab]], 'N/A')
                    ),
                    amountToTwoDecimal(bid.bidAmount * destinationData["approxVolume"], true),
                    React__default.createElement(
                      Popup,
                      {
                        trigger: React__default.createElement(Icon, {
                          name: "warning circle top-right",
                          color: "blue",
                          size: "small"
                        }),
                        size: "mini",
                        position: "top center"
                      },
                      React__default.createElement(
                        List,
                        null,
                        React__default.createElement(
                          List.Item,
                          null,
                          React__default.createElement(
                            List.Content,
                            null,
                            React__default.createElement(
                              List.Header,
                              { className: "float-left" },
                              "Capacity:"
                            ),
                            React__default.createElement(
                              List.Description,
                              { className: "float-left" },
                              bid.capacityAccepted ? bid.capacityAccepted + " containers" : bid.capacityPerMonth + " containers"
                            )
                          )
                        ),
                        React__default.createElement(
                          List.Item,
                          null,
                          React__default.createElement(
                            List.Content,
                            null,
                            React__default.createElement(
                              List.Header,
                              { className: "float-left" },
                              _this2.props.opp_key === "containerOpportunities" ? 'Container Number: ' : 'Renew due on: '
                            ),
                            React__default.createElement(
                              List.Description,
                              { className: "float-left" },
                              _this2.props.opp_key === "containerOpportunities" ? destinationData.containers && destinationData.containers.join(' , ') : enhanceFormatter(bid.rateValidUntilDate).toLocaleUpperCase()
                            )
                          )
                        ),
                        bid.questionsAboutBid && React__default.createElement(
                          List.Item,
                          null,
                          React__default.createElement(
                            List.Content,
                            null,
                            React__default.createElement(
                              List.Header,
                              { className: "float-left" },
                              "Questions:"
                            ),
                            React__default.createElement(
                              List.Description,
                              { className: "float-left" },
                              lodash_1(bid, 'questionsAboutBid', 'N/A')
                            )
                          )
                        )
                      )
                    )
                  ),
                  React__default.createElement("br", null),
                  React__default.createElement(
                    "div",
                    {
                      className: "select_box",
                      onClick: function onClick(e) {
                        return _this2.selectBox(e, bid.partnerId, destinationData.laneId, bid);
                      }
                    },
                    React__default.createElement(
                      "p",
                      { className: "show_as_unselected" },
                      "SELECT"
                    ),
                    React__default.createElement(
                      "p",
                      { className: "show_as_selected" },
                      React__default.createElement(Icon, {
                        name: "check circle outline",
                        className: "accepted_tick selected"
                      }),
                      "SELECTED"
                    )
                  ),
                  bid.customerStatus === "CUSTOMER_ACCEPTED" && tab === "SALES_ACCEPTED" && React__default.createElement(
                    "div",
                    { className: "customerAccepted" },
                    "Customer Accepted"
                  ),
                  bid.customerStatus === "CUSTOMER_REJECTED" && tab === "SALES_REJECTED" && React__default.createElement(
                    "div",
                    { className: "customerRejected" },
                    "Customer Rejected"
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);
  return DestinationLane;
}(Component);

var PortOpportunity$1 = function (_Component) {
  inherits(PortOpportunity, _Component);

  function PortOpportunity(props) {
    classCallCheck(this, PortOpportunity);

    var _this = possibleConstructorReturn(this, (PortOpportunity.__proto__ || Object.getPrototypeOf(PortOpportunity)).call(this, props));

    _this.isExpandableTab = function () {
      var tab = _this.props.tab;

      return tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED";
    };

    _this.splitForTooltip = function (name) {

      var firstPart = name ? name.substring(0, 20) : "";

      return React__default.createElement(
        React__default.Fragment,
        null,
        firstPart,
        name && name.length > 20 ? React__default.createElement(Popup, {
          content: name,
          trigger: React__default.createElement(
            "b",
            { style: { color: "#000" } },
            "..."
          )
        }) : ""
      );
    };

    _this.state = {
      priceClicked: false,
      partnerBids: []
    };
    return _this;
  }

  createClass(PortOpportunity, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var portData = this.props.portData;

      var partnerData = [];
      var destinations = lodash_1(portData, 'destinations', []);
      partnerData = lodash_1(destinations[0], 'partnerBids', []);
      if (!_.isEmpty(partnerData)) this.setState({ partnerBids: partnerData });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          drayageApp = _props.drayageApp,
          arWithoutAP = _props.arWithoutAP,
          opportunityState = _props.opportunityState;

      /* Compute total Volume across all lanes */

      var getTotalVolume = function getTotalVolume() {
        var totalVolume = 0;

        for (var i = 0; i < _this2.props.portData.destinations.length; i++) {
          var destinations = _this2.props.portData.destinations[i];

          if (_this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
            var status = destinations && destinations.partnerBids && destinations.partnerBids.length > 0 ? destinations.partnerBids[0].partnerStatus : "NONE";
            if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
              if (_this2.props.activeLanesOnly) {
                if (status === "PARTNER_REJECTED") {
                  continue;
                }
              }
            } else if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
              if (status !== "PARTNER_REJECTED") {
                continue;
              }
            }
          }

          var cont = _this2.props.portData.destinations[i].approxVolume;
          totalVolume += cont;
        }
        return totalVolume;
      };

      /* Compute total submitted business across all lanes */
      var getTotals = function getTotals() {
        var totals = [];

        var _loop = function _loop(i) {
          var _props$portData$desti = _this2.props.portData.destinations[i],
              partnerBids = _props$portData$desti.partnerBids,
              approxVolume = _props$portData$desti.approxVolume;

          // totals[0] += bids[0].bidAmount;

          if (partnerBids) {
            partnerBids.forEach(function (bid, j) {
              if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE && _this2.props.activeLanesOnly && partnerBids[j].partnerStatus === "PARTNER_REJECTED") {
                return;
              }

              if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED && _this2.props.activeLanesOnly && partnerBids[j].partnerStatus !== "PARTNER_REJECTED") {
                return;
              }

              if (!totals[j]) totals[j] = 0;
              totals[j] += (partnerBids[j].bidAmount || 0) * Number(approxVolume);
            });
          }
        };

        for (var i = 0; i < _this2.props.portData.destinations.length; i++) {
          _loop(i);
        }
        return totals;
      };
      var totalVol = getTotalVolume();

      /* Compute total suggested business across all lanes */
      var totalBussiness = function totalBussiness() {
        var total = 0;

        for (var i = 0; i < _this2.props.portData.destinations.length; i++) {
          var destinations = _this2.props.portData.destinations[i];

          if (_this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
            var status = destinations && destinations.partnerBids && destinations.partnerBids.length > 0 ? destinations.partnerBids[0].partnerStatus : "NONE";
            if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
              if (_this2.props.activeLanesOnly) {
                if (status === "PARTNER_REJECTED") {
                  continue;
                }
              }
            } else if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
              if (status !== "PARTNER_REJECTED") {
                continue;
              }
            }
          }

          var cont = _this2.props.portData.destinations[i].approxVolume;
          var price = _this2.props.portData.destinations[i].proposedBid || 0;
          total = total + cont * price;
        }
        return total;
      };
      var totalBuss = totalBussiness();
      // totalBuss = totalBuss > 1000000 ? totalBuss / 1000000 + "M" : totalBuss;
      console.log("MarketplacePortalCommon >>> PortOpportunity", this.props);
      var source = this.props.portData && this.props.portData.source && this.props.portData.source.toUpperCase();
      // let portData=this.props.portData  && this.props.portData.source
      console.log("source PortOpportunity", source);
      // console.log("portData PortOpportunity",portData)
      var tab = this.props.tab;
      // if (tab === "Submitted")  {
      //   className = "content-open submitted"
      // }

      var headers = OpportunityOpenedHeaader[this.props.drayageApp][tab];
      var extraHeaders = getExtraHeader({ drayageApp: drayageApp, tab: tab, opportunityState: opportunityState, arWithoutAP: arWithoutAP }); // for adding extra on on some condition add here in this function 
      headers = [].concat(toConsumableArray(headers), toConsumableArray(extraHeaders));
      // let widthContentOPen = getWidthContentOPen(this.props.drayageApp,tab)

      var grandTotalsForPort = getTotals();
      var totalColumnDataLane = new Map();
      totalColumnDataLane.set("ApproxVolume", totalVol);
      totalColumnDataLane.set("ApproxTotalBusiness", totalBuss);
      totalColumnDataLane.set("Total", grandTotalsForPort);

      var isAnyLaneEnabled = function isAnyLaneEnabled() {

        var allLaneData = _this2.props.columnDataPort;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = allLaneData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = slicedToArray(_ref, 2);

            var key = _ref2[0];
            var columnDataLane = _ref2[1];

            var partnerStatus = "PARTNER_STATUS_NONE";
            if (_this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = columnDataLane[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref3 = _step2.value;

                  var _ref4 = slicedToArray(_ref3, 2);

                  var _key = _ref4[0];
                  var value = _ref4[1];

                  if (_key === "PartnerStatus") {
                    partnerStatus = value && value.length > 0 ? value[0] : partnerStatus;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }

            var laneDisabled = false;
            switch (partnerStatus) {
              case "PARTNER_REJECTED":
                if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE) {
                  laneDisabled = true;
                }
                break;

              case "PARTNER_ACTIVE":
                if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED) {
                  laneDisabled = true;
                }
                break;

              default:
                break;
            }

            if (!laneDisabled) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return false;
      };

      if ((this.props.tab === SELECTED_TABS.PARTNER_REJECTED || this.props.activeLanesOnly) && !isAnyLaneEnabled()) {
        return null;
      }
      return React__default.createElement(
        "div",
        { className: "portOpportunityContent", style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { paddingLeft: "1rem", paddingRight: "1rem" } : null },
        React__default.createElement(
          "table",
          {
            //style={{ width: widthContentOPen["width"] }}
            // className="port-content-open"
            className: "portOpportunityTable"
          },
          React__default.createElement(
            "tbody",
            null,
            React__default.createElement(
              "tr",
              null,
              React__default.createElement(
                "td",
                {
                  //  className="data-header-first"
                  style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { width: "25%" } : null
                },
                React__default.createElement(
                  "div",
                  { className: "rowAlignCentered" },
                  React__default.createElement(
                    "div",
                    null,
                    React__default.createElement("img", {
                      className: "anchor-img",
                      src: "images/files/anchor.svg",
                      alt: ""
                    })
                  ),
                  React__default.createElement(
                    "div",
                    null,
                    React__default.createElement(
                      "div",
                      { className: "small-text" },
                      "FROM"
                    ),
                    React__default.createElement(
                      "div",
                      { className: "party-name" },
                      this.splitForTooltip(source)
                    )
                  )
                )
              ),
              headers && headers.map(function (header, idx) {
                return React__default.createElement(
                  "td",
                  { key: idx, className: _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? "opportunityHeader" : "portOpportunityHeader" },
                  React__default.createElement(
                    "div",
                    { className: header.classLevel1 },
                    React__default.createElement(
                      "div",
                      { className: header.classLevel2, style: _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { textAlign: "left" } : null },
                      _this2.props.opp_key === "containerOpportunities" && header.containerUpper ? header.containerUpper : header.upper
                    ),
                    React__default.createElement(
                      "div",
                      { className: header.classLevel3, style: _this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { textAlign: "left" } : null },
                      _this2.props.opp_key === "containerOpportunities" && header.containerLower ? header.containerLower : header.lower
                    )
                  )
                );
              }),
              React__default.createElement("td", null),
              !this.props.expanded ? React__default.createElement(
                React__default.Fragment,
                null,
                this.isExpandableTab() && this.state.partnerBids && this.state.partnerBids.map(function (partner, index) {

                  if (index > 0) return;
                  return React__default.createElement(
                    "td",
                    { key: index },
                    React__default.createElement(
                      "div",
                      { className: "portOpportunityTablePartnerHeaderWrapper" },
                      React__default.createElement(
                        "div",
                        { className: "partner_header portOpportunityTablePartnerHeader" },
                        React__default.createElement(
                          "div",
                          { className: "partner-name" },
                          partner.partnerName
                        ),
                        React__default.createElement(
                          "div",
                          { className: "partner-bid-date" },
                          formatDateTime(partner.submittedDate)
                        )
                      )
                    )
                  );
                }),
                this.isExpandableTab() && this.state.partnerBids.length > 1 && React__default.createElement(
                  "td",
                  { style: { width: '20px' } },
                  React__default.createElement(
                    "div",
                    { className: "expandHorizontally" },
                    React__default.createElement(Icon, { onClick: function onClick() {
                        return _this2.props.setExpanded();
                      }, size: "big", color: "white", name: !this.props.expanded ? 'chevron right' : "chevron left" })
                  )
                )
              ) : null,
              this.props.expanded ? React__default.createElement(
                React__default.Fragment,
                null,
                this.isExpandableTab() && this.state.partnerBids && this.state.partnerBids.map(function (partner, index) {
                  return React__default.createElement(
                    "td",
                    { key: index },
                    React__default.createElement(
                      "div",
                      { className: "portOpportunityTablePartnerHeaderWrapper" },
                      React__default.createElement(
                        "div",
                        { className: "partner_header portOpportunityTablePartnerHeader" },
                        React__default.createElement(
                          "div",
                          { className: "partner-name" },
                          partner.partnerName
                        ),
                        React__default.createElement(
                          "div",
                          { className: "partner-bid-date" },
                          formatDateTime(partner.submittedDate)
                        )
                      )
                    )
                  );
                }),
                React__default.createElement(
                  "td",
                  { style: { width: '20px' } },
                  React__default.createElement(
                    "div",
                    { className: "expandHorizontally" },
                    React__default.createElement(Icon, { onClick: function onClick() {
                        return _this2.props.setExpanded();
                      }, size: "big", color: "white", name: !this.props.expanded ? 'chevron right' : "chevron left" })
                  )
                )
              ) : null
            ),
            this.props.portData.destinations && this.props.portData.destinations.map(function (destinationData) {
              return React__default.createElement(DestinationLane$1, {
                activeLanesOnly: _this2.props.activeLanesOnly,
                opportunityId: _this2.props.opportunityId,
                expanded: _this2.props.expanded,
                destinationData: destinationData,
                opp_key: _this2.props.opp_key,
                columnDataLane: _this2.props.columnDataPort.get(destinationData.laneId),
                tableData: getTableDataForTab(_this2.props.tab, _this2.props.drayageApp, destinationData),
                totalVol: totalVol,
                totalBuss: totalBuss,
                tab: _this2.props.tab,
                drayageApp: _this2.props.drayageApp,
                selectBid: _this2.props.selectBid,
                unSelectBid: _this2.props.unSelectBid,
                setLanePriceSelected: _this2.props.setLanePriceSelected,
                customerId: _this2.props.customerId,
                portId: _this2.props.portId,
                setCustomerLanePriceSelected: _this2.props.setCustomerLanePriceSelected,
                getOpportunityDetailsApi: _this2.props.getOpportunityDetailsApi,
                isTotalRow: false,
                portData: _this2.props.portData,
                opportunityState: opportunityState,
                arWithoutAP: arWithoutAP
              });
            })
          )
        )
      );
    }
  }]);
  return PortOpportunity;
}(Component);

var OpportunityOpenedCommon$1 = function (_Component) {
  inherits(OpportunityOpenedCommon, _Component);

  function OpportunityOpenedCommon(props) {
    classCallCheck(this, OpportunityOpenedCommon);

    var _this = possibleConstructorReturn(this, (OpportunityOpenedCommon.__proto__ || Object.getPrototypeOf(OpportunityOpenedCommon)).call(this, props));

    _this.setOppBodyWidth = function () {
      var tab = _this.props.tab;

      var space = tab === "SALES_REJECTED" ? 2 : 0;
      var opportunityAccordian = _this.props.opportunityRef;
      var oppHeader = opportunityAccordian.current && opportunityAccordian.current.children[0];
      if (!oppHeader) return;
      // const oppBody = opportunityAccordian.current.children[1]
      // console.log({oppBody,oppHeader},'opportunityAccordian')
      var el = _this.openOpportunity.current;
      var width = oppHeader.offsetWidth + space;

      // el.style.width = width + "px"; 
    };

    _this.componentDidMount = function () {
      // this.getOpportunityDetailsData(this.props.opportunity.opportunityId);

      var tab = _this.props.tab;

      if (tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED") {
        _this.setOppBodyWidth();
        //     const opportunityAccordian = this.props.opportunityRef
        //     const oppHeader =  opportunityAccordian.current && opportunityAccordian.current.children[0]

        //     // const oppBody = opportunityAccordian.current.children[1]
        //     // console.log({oppBody,oppHeader},'opportunityAccordian')
        //     let el = this.openOpportunity.current;
        //   let width = oppHeader.offsetWidth;

        //     el.style.width = width + "px";
        // el.style.minWidth = '100%';
      }
    };

    _this.getGrandTotals = function () {
      var totals = [];
      // let thisOpportunityData =   this.props.opportunityData.get(this.props.opportunity.opportunityId)
      var portData = _this.props.opportunityData && _this.props.opportunityData.get(_this.props.opportunity.opportunityId).portData;
      if (portData) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = portData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = slicedToArray(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];
            var destinations = value.destinations;

            var _loop = function _loop(i) {
              var approxVolume = destinations[i].approxVolume;
              // totals[0] += bids[0].bidAmount;

              var partnerBids = lodash_1(destinations[i], 'partnerBids', []);
              partnerBids.forEach(function (bid, j) {
                if (!totals[j]) totals[j] = 0;
                totals[j] += (partnerBids[j].bidAmount || 0) * Number(approxVolume);
              });
            };

            for (var i = 0; i < destinations.length; i++) {
              _loop(i);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return totals;
    };

    _this.isExpandableTab = function () {
      var tab = _this.props.tab;

      return tab === "SALES_PENDING_APPROVAL" || tab === "SALES_ACCEPTED" || tab === "SALES_REJECTED" || tab === "SALES_ARCHIVED";
    };

    _this.state = {
      // showModal: false,
      // showLaneBidCard: false,
      // showAddCard: false,
      // selectedPortCode : "",
      // selectedsource : "",
      // selectedsourceName:"",
      // selectedDestinationName : "",
      // selectedLaneId : "",
      // selectedDestinationLaneData :"",
      // selectedPortId: "",
      // selectedLaneDestination: "",
      // selectedPortName: "",
      // selectedDestination: "",
      // total: "800",

      // isPort: false,
      opportunityDetails: {}

      // opportunityPortsData: [],
      // destinationData: "",
      // showPortWiseBidModal: false,

      /*
       * Opened landBidCard
       */
      // openedLanePortId : "",
      // openedLaneDestination : "",
      // openedLaneData : "",
    };

    _this.openOpportunity = React__default.createRef();
    return _this;
  }

  createClass(OpportunityOpenedCommon, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.expanded !== this.props.expanded) {
        //   const opportunityAccordian = this.props.opportunityRef
        //   const oppHeader = opportunityAccordian.current.children[0]
        //   const oppBody = opportunityAccordian.current.children[1]
        //   console.log({oppBody,oppHeader},'opportunityAccordian')
        //   let el = this.openOpportunity.current;
        //   let width = el
        //     .closest(".opportunity_wrapper")
        //     .querySelector(".opportunity-opened").offsetWidth;

        // el.style.width = width + "px";
        //   oppBody.style.minWidth = '100%';
        // const opportunityAccordian = this.props.opportunityRef
        // const oppHeader = opportunityAccordian.current.children[0]
        // // const oppBody = opportunityAccordian.current.children[1]
        // // console.log({oppBody,oppHeader},'opportunityAccordian')
        // let el = this.openOpportunity.current;
        // let width = oppHeader.offsetWidth;

        // el.style.width = width + "px";
        this.setOppBodyWidth();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          drayageApp = _props.drayageApp,
          opportunity = _props.opportunity;

      var arWithoutAP = !!lodash_1(opportunity, 'arWithoutAP', false);
      var opportunityState = lodash_1(opportunity, 'opportunityState', '');

      var thisOpportunityData = this.props.opportunityData && this.props.opportunityData.get(this.props.opportunity.opportunityId);

      var grandTotalVol = thisOpportunityData && thisOpportunityData.grandTotalVolume;
      var grandTotalAmount = thisOpportunityData && thisOpportunityData.grandTotalAmount;
      var opportunityExpiryDate = thisOpportunityData && thisOpportunityData.opportunityExpiryDate;
      var endDate = parseInt(opportunityExpiryDate);

      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "UTC"
      };
      var expirationDate = moment$1.utc(moment$1(endDate).utc()).toDate(); //converting epoch to date object in UTC
      expirationDate = expirationDate.toLocaleDateString("en-US", options).toUpperCase();

      // grandTotalAmount = grandTotalAmount > 1000000  ? parseFloat(grandTotalAmount / 1000000).toFixed(2) + "M" : grandTotalAmount;
      //  let grandTotalAm
      // if(grandTotalAmount && grandTotalAmount > 1000000){
      //   grandTotalAm = (grandTotalAmount / 1000000)
      //   grandTotalAm = parseFloat(grandTotalAm)
      //   grandTotalAm = grandTotalAm.toFixed(2)+"M"
      //   grandTotalAmount= grandTotalAm
      // }
      // else{
      //   grandTotalAmount=grandTotalAmount
      // }

      // let opportunity = this.props.opportunityData.get(this.props.opportunity.opportunityId)

      var partnerBids = [];

      if (thisOpportunityData && thisOpportunityData.portData && thisOpportunityData.portData.destinations) {
        var portData = thisOpportunityData.portData;
        partnerBids = portData.destinations.values().next().value.partnerBids;
      }

      var widthGrandAction = getWidthGrandAction(this.props.drayageApp, this.props.tab);

      /* Compute total submitted business across all lanes */
      var getTotals = function getTotals(portData) {
        if (!portData) {
          return 0;
        }

        var totals = [];
        var totalVolume = 0;
        var totalProposedBusiness = 0;

        var _loop2 = function _loop2(i) {
          var _portData$destination = portData.destinations[i],
              partnerBids = _portData$destination.partnerBids,
              approxVolume = _portData$destination.approxVolume,
              proposedBid = _portData$destination.proposedBid;

          var rejected = false;

          if (partnerBids) {
            partnerBids.forEach(function (bid, j) {
              if (_this2.props.tab === SELECTED_TABS.PARTNER_ACTIVE && _this2.props.activeLanesOnly && partnerBids[j].partnerStatus === "PARTNER_REJECTED") {
                rejected = true;
              }

              if (_this2.props.tab === SELECTED_TABS.PARTNER_REJECTED && partnerBids[j].partnerStatus !== "PARTNER_REJECTED") {
                rejected = true;
              }

              if (!totals[j]) totals[j] = 0;
              totals[j] += partnerBids[j].bidAmount * Number(approxVolume);
            });
          }

          // totals[0] += bids[0].bidAmount;
          if (!rejected) {
            totalVolume += approxVolume;
            totalProposedBusiness += (proposedBid || 0) * Number(approxVolume);
          }
        };

        for (var i = 0; i < portData.destinations.length; i++) {
          _loop2(i);
        }
        return { totals: totals, totalVolume: totalVolume, totalProposedBusiness: totalProposedBusiness };
      };

      var grandTotal = 0;
      var grandTotalVolume = 0;
      var grandTotalProposedBusiness = 0;
      if (thisOpportunityData && thisOpportunityData.portData) {
        Array.from(thisOpportunityData.portData.keys()).forEach(function (portId) {
          var x = getTotals(thisOpportunityData.portData.get(portId));
          grandTotal += x["totals"][0];
          grandTotalVolume += x["totalVolume"];
          grandTotalProposedBusiness += x["totalProposedBusiness"];
        });
      }

      var grandTotalColumnDataLane = new Map();
      grandTotalColumnDataLane.set("ApproxVolume", grandTotalVolume);
      grandTotalColumnDataLane.set("ApproxTotalBusiness", grandTotalProposedBusiness);
      grandTotalColumnDataLane.set("Total", grandTotal);

      if (this.isExpandableTab()) grandTotalColumnDataLane.set("GrandTotalBids", this.getGrandTotals());
      console.log("MarketplacePortalCommon >>> OpportunityBody >>> ", this.props);
      return React__default.createElement(
        "div",
        { "data-tab": "OPPORTUNITIES_LIST_OPENED", ref: this.openOpportunity },
        React__default.createElement(
          "div",
          null,
          thisOpportunityData && thisOpportunityData.portData && Array.from(thisOpportunityData.portData.keys()).map(function (portId) {
            return React__default.createElement(PortOpportunity$1, {
              opportunityData: _this2.props.opportunityData,
              activeLanesOnly: _this2.props.activeLanesOnly,
              expanded: _this2.props.expanded,
              opportunityId: _this2.props.opportunity.opportunityId,
              portData: thisOpportunityData && thisOpportunityData.portData.get(portId),
              columnDataPort: _this2.props.columnDataOpportunity.get(portId),
              additionalCharges: _this2.props.additionalCharges,
              partnerId: _this2.props.partnerId,
              opp_key: _this2.props.opp_key,
              tab: _this2.props.tab,
              drayageApp: _this2.props.drayageApp,
              selectBid: _this2.props.selectBid,
              unSelectBid: _this2.props.unSelectBid,
              setLanePriceSelected: _this2.props.setLanePriceSelected,
              customerId: _this2.props.customerId,
              portId: portId,
              setCustomerLanePriceSelected: _this2.props.setCustomerLanePriceSelected,
              grandTotalVol: grandTotalVol,
              grandTotalAmount: grandTotalAmount,
              getOpportunityDetailsApi: _this2.props.getOpportunityDetailsApi,
              expirationDate: expirationDate,
              isLane: _this2.props.isLane,
              opportunityState: opportunityState,
              arWithoutAP: arWithoutAP,
              setExpanded: _this2.props.setExpanded
            });
          })
        ),
        this.props.opp_key !== "containerOpportunities" && (drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER && this.props.tab === SELECTED_TABS.PARTNER_NEW || arWithoutAP && opportunityState === OPPORTUNITY_STATE.SALES_AR_PENDING && drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && this.props.tab === 'SALES_PUBLISHED') && React__default.createElement(
          "div",
          {
            style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? { height: "60px" } : { height: "117px", padding: "0 18px" },
            className: ""
          },
          React__default.createElement(
            "div",
            { className: "action-btn" },
            React__default.createElement(
              "div",
              null,
              React__default.createElement(
                "button",
                {
                  className: "bid-btn",
                  onClick: function onClick(e) {
                    _this2.props.handleOpportunityBidClicked(false);
                    _this2.props.handleOpenBidModal(_this2.props.opportunity.opportunityId);
                  }
                },
                drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? 'GENERATE AR' : 'BID'
              )
            )
          )
        )
      );
    }
  }]);
  return OpportunityOpenedCommon;
}(Component);

var OpportunityAccordian = function (_Component) {
  inherits(OpportunityAccordian, _Component);

  function OpportunityAccordian(props) {
    classCallCheck(this, OpportunityAccordian);

    var _this = possibleConstructorReturn(this, (OpportunityAccordian.__proto__ || Object.getPrototypeOf(OpportunityAccordian)).call(this, props));

    _this.state = {
      open: false,
      expanded: false
    };
    _this.opportunityRef = React__default.createRef();
    return _this;
  }

  createClass(OpportunityAccordian, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({
        open: false,
        expanded: false
      });
      // this.props.resetOpportunityDetailData()
    }
    // componentDidUpdate(prevProps, prevState){
    //   // if(prevProps.isOpportunityOpened !== this.props.isOpportunityOpened){
    //   //   this.setState({open : this.state.isOpportunityOpened})
    //   // }
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isOpportunityOpened = _props.isOpportunityOpened,
          tab = _props.tab,
          opportunity = _props.opportunity,
          drayageApp = _props.drayageApp,
          onButtonClick = _props.onButtonClick,
          opportunityData = _props.opportunityData,
          onOpportunitySelect = _props.onOpportunitySelect;

      return React__default.createElement(
        'div',
        { ref: this.opportunityRef, className: this.state.expanded && isOpportunityOpened ? "opportunityAccordian opportunityAccordianExpanded" : 'opportunityAccordian' },
        React__default.createElement(OpportunityHeader, {
          isOpportunityOpened: isOpportunityOpened,
          tab: tab,
          opportunity: opportunity,
          opp_key: this.props.opp_key,
          drayageApp: drayageApp,
          onButtonClick: onButtonClick,
          cancelBid: this.props.cancelBid,
          opportunityData: opportunityData,
          isDoneDisabled: this.props.isDoneDisabled,
          renewOpportunityFunc: this.props.renewOpportunityFunc,
          onOpportunitySelect: this.props.onOpportunitySelect,
          expanded: this.state.expanded,
          setExpanded: function setExpanded() {
            return _this2.setState({ expanded: !_this2.state.expanded });
          },
          isLane: this.props.isLane,
          getOpportunityDetailsApi: this.props.getOpportunityDetailsApi,
          setSalesOpportunityUpdatedData: this.props.setSalesOpportunityUpdatedData,
          handleOpenBidModal: this.props.handleOpenBidModal,
          handleOpportunityBidClicked: this.props.handleOpportunityBidClicked,
          isBiddingFromOppUpdation: this.props.isBiddingFromOppUpdation,
          oppUpdationData: this.props.oppUpdationData,
          handleBidUpdationOpenClose: this.props.handleBidUpdationOpenClose,
          fetchTabDetails: this.props.fetchTabDetails
        }),
        isOpportunityOpened && React__default.createElement(OpportunityOpenedCommon$1, _extends({
          expanded: this.state.expanded,
          opportunityRef: this.opportunityRef,
          setExpanded: function setExpanded() {
            return _this2.setState({ expanded: !_this2.state.expanded });
          }
        }, this.props, {
          isLane: this.props.isLane

        }))
      );
    }
  }]);
  return OpportunityAccordian;
}(Component);

var CustomerOpportunitesCommon = function (_Component) {
  inherits(CustomerOpportunitesCommon, _Component);

  function CustomerOpportunitesCommon(props) {
    classCallCheck(this, CustomerOpportunitesCommon);

    var _this = possibleConstructorReturn(this, (CustomerOpportunitesCommon.__proto__ || Object.getPrototypeOf(CustomerOpportunitesCommon)).call(this, props));

    _this.onButtonClick = function (id, isAlreadyOpened, isEdit) {
      // let isOpenMap = this.state.isOpenMap
      // isOpenMap.set(id, !isOpenMap.get(id))

      //console.log("onButtonClick ::", this.props, isEdit, id)

      _this.props.getOpportunityDetailsApi(id, _this.props.tab, isAlreadyOpened, null, isEdit);
      // this.setState({ isOpenMap: isOpenMap });
      // this.props.handleOpporunityOpenArrow(id)
    };

    _this.loadOpportunityDetails = function (opportinutyId) {
      _this.props.getOpportunityDetailsApi(opportinutyId, _this.props.tab, false);
      _this.setState({ isLanePriceUpdating: false, isLanePriceSelecting: false, isLanePriceUnselecting: false });
    };

    _this.selectAllLanes = function (opportinutyId) {
      _this.props.setCustomerLanePriceSelected(opportinutyId, "", true);
      setTimeout(function () {
        _this.loadOpportunityDetails(opportinutyId);
      }, 1000);
      _this.setState({ isLanePriceUpdating: true, isLanePriceSelecting: true, allLanesSelected: !_this.state.allLanesSelected });

      // this.props.getOpportunityDetailsApi(opportinutyId, this.props.tab)
    };

    _this.unSelectAllLanes = function (opportinutyId) {
      _this.props.setCustomerLanePriceSelected(opportinutyId, "", false);
      setTimeout(function () {
        _this.loadOpportunityDetails(opportinutyId);
      }, 1000);
      _this.setState({ isLanePriceUpdating: true, isLanePriceUnselecting: true, allLanesSelected: !_this.state.allLanesSelected });
    };

    _this.handleActiveLanes = function (e) {
      // this.setState({ activeLanesOnly: e.target.checked });
      _this.props.handleActiveLanes(e);
    };

    _this.changeEditStatus = function () {
      _this.setState({ isEditBidModal: !_this.state.isEditBidModal });
    };

    _this.areAllDestinationSelected = function (opportunity) {
      //if one is slected : allUnselect  false
      //if one is not selected : allSelect false
      var allUnselect = true;
      var allSelect = true;
      console.log("areAllDestinationSelected >>> ", opportunity);

      var portData = lodash_1(opportunity, "portData", {});
      var total = 0;
      var selectedTotal = 0;

      // Object.keys(portData).map((port) => {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = portData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = slicedToArray(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          console.log("areAllDestinationSelected >>> ", key, value);
          var onePortData = value;
          var destinations = lodash_1(onePortData, "destinations", []);
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = destinations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var destination = _step2.value;

              if (destination.isSelected === "YES") {
                selectedTotal += 1;
              }
              total += 1;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      console.log("Selection >>> ", total, selectedTotal);
      allUnselect = total > 0 && selectedTotal === 0;
      allSelect = total > 0 && total === selectedTotal;
      return { allUnselect: allUnselect, allSelect: allSelect };
    };

    var isOpenMap = new Map();
    if (_this.props.customerOpportunity) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = _this.props.customerOpportunity.opportunityList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var oppor = _step3.value;

          isOpenMap.set(oppor.opportunityId, false);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }

    _this.state = {
      isOpenMap: isOpenMap,
      showModal: true,
      partnerId: "123de3",
      // activeLanesOnly: true,
      isLanePriceUpdating: false,
      isLanePriceSelecting: false,
      isLanePriceUnselecting: false,
      isEditBidModal: false,
      allLanesSelected: false

    };
    return _this;
  }

  // opportunityId,
  //   tab,
  //   isAlreadyOpened,
  //   tabType,
  //   isEdit

  // getAdditionalCharges=(partnerId)=>{
  //     getDrayageAdditionalCharges(partnerId).then(res=>{
  //         let additionalCharges = get(res.data,"eventMessage.chargeList")

  //         this.setState({additionalCharges:additionalCharges})

  //     }).catch(err=>{
  //         console.log("getDrayageAdditionalCharges",err)
  //     })

  // }
  // componentDidMount() {
  //     let additionalCharges=  this.getAdditionalCharges(this.state.partnerId)
  // }

  createClass(CustomerOpportunitesCommon, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var customerName = lodash_1(this.props, "customerOpportunity.customer", "").toUpperCase();

      var opportunityList = this.props.customerOpportunity.opportunityList;
      console.log("CustomerOpportunitesCommon:: opportunityList ", opportunityList);
      opportunityList.sort(function (a, b) {
        if (Number(a.endDate) > Number(b.endDate)) return -1;
        if (Number(a.endDate) < Number(b.endDate)) return 1;
        return 0;
      });

      // let customerEmail= customerEmail ? customerEmail.substring(0,customerEmail.lastIndexOf("@")) : ""
      //customerName= customerName.toUpperCase()
      // customerName=customerEmail
      //let customer= customerEmail.substring(customerEmail.lastIndexOf("@")+1)

      //         var email = "john.doe@example.com";
      // var name   = email.substring(0, email.lastIndexOf("@"));
      // var domain = email.substring(email.lastIndexOf("@") +1);

      console.log("MarketplacePortalCommon >>> CustomerOpportunity >>> ", this.props, this.state);
      return React__default.createElement(
        "div",
        { className: "customer-opportunity",
          style: { width: this.props.drayageApp !== DRAYAGE_APP.KLEARDRAY_CUSTOMER ? '100%' : 'auto' }
        },
        this.props.drayageApp !== DRAYAGE_APP.KLEARDRAY_CUSTOMER && React__default.createElement(
          "div",
          { className: "cust-sec-active-lanes" },
          this.props.customerNumber === 0 && this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER && this.props.tab === SELECTED_TABS.PARTNER_ACTIVE && React__default.createElement(
            "div",
            { className: "cust-sec-show-active-only" },
            React__default.createElement(
              "div",
              { style: {}, className: "general-row" },
              React__default.createElement("input", {
                type: "checkbox",
                onChange: this.handleActiveLanes,
                checked: this.props.activeLanesOnly
              }),
              React__default.createElement(
                "div",
                { style: { paddingLeft: "10px", marginTop: "-3px" } },
                " ",
                "Show Active lanes only",
                " "
              )
            )
          )
        ),
        opportunityList.map(function (opportunity) {
          var isOpportunityOpened = getOpenedOpportunityStatus(_this2.props.openedOpportunities, _this2.props.tab, opportunity.opportunityId); // this.props.openedOpportunities.get(opportunity.opportunityId)
          var isAllSelected = false;
          var isAllUnselected = false;
          if (isOpportunityOpened) {
            //{allUnselect, allSelect} 
            var selectedObj = _this2.areAllDestinationSelected(opportunity);
            // isAllUnselected = areAllDestinationUnselected(opportunity)
            isAllSelected = selectedObj["allSelect"];
            isAllUnselected = selectedObj["allUnselect"];
          }
          console.log("Selection >>> ", isAllSelected, isAllUnselected);
          if (_this2.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES) {
            return React__default.createElement(OpportunityAccordian, {
              isOpportunityOpened: isOpportunityOpened,
              changeEditStatus: _this2.changeEditStatus,
              tab: _this2.props.tab,
              opportunity: opportunity,
              opp_key: _this2.props.opp_key,
              drayageApp: _this2.props.drayageApp,
              onButtonClick: _this2.onButtonClick,
              opportunityData: _this2.props.opportunityData,
              onOpportunitySelect: _this2.props.onOpportunitySelect,
              isDoneDisabled: _this2.props.isDoneDisabled,
              customerBidmodalHandler: _this2.props.customerBidmodalHandler,
              renewOpportunityFunc: _this2.props.renewOpportunityFunc,
              activeLanesOnly: _this2.props.activeLanesOnly,
              isOpen: _this2.state.isOpen,
              columnDataOpportunity: _this2.props.columnData.get(opportunity.opportunityId),
              portData: _this2.props.opportunityData && _this2.props.opportunityData.get(opportunity.opportunityId) && _this2.props.opportunityData.get(opportunity.opportunityId).portData
              // onButtonClick={this.onButtonClick}
              , handleOpenBidModal: _this2.props.handleOpenBidModal,
              handleOpportunityBidClicked: _this2.props.handleOpportunityBidClicked,
              selectedTab: _this2.props.selectedTab,
              additionalCharges: _this2.props.standardPartnerAdditionalCharges,
              partnerId: _this2.state.partnerId,
              setAdditionalChargesInStore: _this2.props.setAdditionalChargesInStore,
              selectBid: _this2.props.selectBid,
              unSelectBid: _this2.props.unSelectBid,
              customerId: _this2.props.customerId
              //   standardPartnerAdditionalCharges={this.props.standardPartnerAdditionalCharges}
              , setLaneBidChargesInStore: _this2.props.setLaneBidChargesInStore,
              submitOpportunityBidData: _this2.props.submitOpportunityBidData,
              setLanePriceSelected: _this2.props.setLanePriceSelected,
              setCustomerLanePriceSelected: _this2.props.setCustomerLanePriceSelected,
              getOpportunityDetailsApi: _this2.props.getOpportunityDetailsApi,
              opportunityId: opportunity.opportunityId,
              cancelBid: _this2.props.cancelBid,
              isLane: _this2.props.isLane,
              userType: _this2.props.userType,
              setSalesOpportunityUpdatedData: _this2.props.setSalesOpportunityUpdatedData,
              isBiddingFromOppUpdation: _this2.props.isBiddingFromOppUpdation,
              oppUpdationData: _this2.props.oppUpdationData,
              handleBidUpdationOpenClose: _this2.props.handleBidUpdationOpenClose,
              fetchTabDetails: _this2.props.fetchTabDetails
            });
          }
          return !isOpportunityOpened ? React__default.createElement(OpportunityClosedCommon, {
            tab: _this2.props.tab,
            isEditBidModal: _this2.state.isEditBidModal,
            changeEditStatus: _this2.changeEditStatus,
            opportunity: opportunity,
            drayageApp: _this2.props.drayageApp,
            onButtonClick: function onButtonClick(isEdit) {
              _this2.onButtonClick(opportunity.opportunityId, false, isEdit);
            },
            opportunityData: _this2.props.opportunityData,
            onOpportunitySelect: _this2.props.onOpportunitySelect,
            isDoneDisabled: _this2.props.isDoneDisabled,
            opp_key: _this2.props.opp_key,
            customerBidmodalHandler: _this2.props.customerBidmodalHandler,
            renewOpportunityFunc: _this2.props.renewOpportunityFunc,
            handleOpenBidModal: _this2.props.handleOpenBidModal,
            handleOpportunityBidClicked: _this2.props.handleOpportunityBidClicked,
            handleSetChargeForEdit: _this2.props.handleSetChargeForEdit
          }) : React__default.createElement(
            "div",
            { className: "opportunity_wrapper" },
            React__default.createElement(OpportunityClosedCommon, {
              isOpen: true,
              isEditBidModal: _this2.state.isEditBidModal,
              changeEditStatus: _this2.changeEditStatus,
              opportunity: opportunity,
              opp_key: _this2.props.opp_key,
              tab: _this2.props.tab,
              drayageApp: _this2.props.drayageApp,
              onButtonClick: function onButtonClick(isEdit) {
                _this2.onButtonClick(opportunity.opportunityId, true, isEdit);
              },
              cancelBid: _this2.props.cancelBid,
              opportunityData: _this2.props.opportunityData,
              onOpportunitySelect: _this2.props.onOpportunitySelect,
              isDoneDisabled: _this2.props.isDoneDisabled,
              customerBidmodalHandler: _this2.props.customerBidmodalHandler,
              renewOpportunityFunc: _this2.props.renewOpportunityFunc,
              handleOpenBidModal: _this2.props.handleOpenBidModal,
              handleOpportunityBidClicked: _this2.props.handleOpportunityBidClicked,
              handleSetChargeForEdit: _this2.props.handleSetChargeForEdit

            }),
            React__default.createElement(OpportunityOpenedCommon, {
              activeLanesOnly: _this2.props.activeLanesOnly,
              isEditBidModal: _this2.state.isEditBidModal,
              changeEditStatus: _this2.changeEditStatus,
              tab: _this2.props.tab,
              opp_key: _this2.props.opp_key,
              drayageApp: _this2.props.drayageApp,
              isOpen: _this2.state.isOpen,
              opportunityData: _this2.props.opportunityData,
              columnDataOpportunity: _this2.props.columnData.get(opportunity.opportunityId),
              opportunity: opportunity,

              portData: _this2.props.opportunityData && _this2.props.opportunityData.get(opportunity.opportunityId) && _this2.props.opportunityData.get(opportunity.opportunityId).portData
              // onButtonClick={this.onButtonClick}
              , handleOpenBidModal: _this2.props.handleOpenBidModal,
              handleOpportunityBidClicked: _this2.props.handleOpportunityBidClicked,
              selectedTab: _this2.props.selectedTab,
              additionalCharges: _this2.props.standardPartnerAdditionalCharges,
              partnerId: _this2.state.partnerId,
              setAdditionalChargesInStore: _this2.props.setAdditionalChargesInStore,
              selectBid: _this2.props.selectBid,
              unSelectBid: _this2.props.unSelectBid,
              customerId: _this2.props.customerId
              //   standardPartnerAdditionalCharges={this.props.standardPartnerAdditionalCharges}
              , setLaneBidChargesInStore: _this2.props.setLaneBidChargesInStore,
              submitOpportunityBidData: _this2.props.submitOpportunityBidData,
              setLanePriceSelected: _this2.props.setLanePriceSelected,
              setCustomerLanePriceSelected: _this2.props.setCustomerLanePriceSelected,
              getOpportunityDetailsApi: _this2.props.getOpportunityDetailsApi,
              opportunityId: opportunity.opportunityId,
              isLane: _this2.props.isLane,
              userType: _this2.props.userType,
              isAllLanesSelected: _this2.state.allLanesSelected,
              isAllSelected: isAllSelected,
              selectAllLanes: _this2.selectAllLanes,
              unSelectAllLanes: _this2.unSelectAllLanes,
              customerBidmodalHandler: _this2.props.customerBidmodalHandler,
              isLanePriceSelecting: _this2.state.isLanePriceSelecting,
              isLanePriceUnselecting: _this2.state.isLanePriceUnselecting
            })
          );
        })
      );
    }
  }]);
  return CustomerOpportunitesCommon;
}(Component);

var MapComponentCommon = function (_Component) {
  inherits(MapComponentCommon, _Component);

  function MapComponentCommon() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, MapComponentCommon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = MapComponentCommon.__proto__ || Object.getPrototypeOf(MapComponentCommon)).call.apply(_ref, [this].concat(args))), _this), _this._onGoogleApiLoaded = function (_ref2) {
      var map = _ref2.map,
          maps = _ref2.maps;

      console.log("_onGoogleApiLoaded :: map/maps ", map, maps, map ? map.getCenter() : null);
      _this.setState({ map: map, maps: maps });
      // this.props.mapLoaded({ map, maps });
      // this.renderPolylines(map, maps)
      // this.apiIsLoaded(map, maps)
    }, _this.googleMapConfigOptions = function (maps) {
      return {
        fullscreenControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: 3 // top_right
        },
        gestureHandling: 'cooperative',
        mapTypeControl: true,
        mapTypeControlOptions: {
          mapTypeIds: ['satellite', 'roadmap']
        }
      };
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(MapComponentCommon, [{
    key: "render",
    value: function render() {
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          { style: { height: "100%", display: "flex", flexDirection: "row", zIndex: "-10" } },
          React__default.createElement(GoogleMap, {
            bootstrapURLKeys: { key: this.props.bootstrapURLKeys },
            center: this.props.center,
            defaultZoom: 1
            //   zoom={this.props.zoom}
            // onChildClick={this._onChildClick}
            , onGoogleApiLoaded: this._onGoogleApiLoaded,
            yesIWantToUseGoogleMapApiInternals: true,
            options: this.googleMapConfigOptions()
            // defaultZoom={1}
            // onChange={this.props.onChange}
            // onChildMouseEnter={this._onChildMouseEnter}
            // onChildMouseLeave={this._onChildMouseLeave}
            // onDrag={this.props.onDrag}
            // onGoogleApiLoaded={({ map, maps }) => this.apiIsLoaded(map, maps)}
          })
        )
      );
    }
  }]);
  return MapComponentCommon;
}(Component);

var MarketPlaceMapCommon = function (_Component) {
  inherits(MarketPlaceMapCommon, _Component);

  function MarketPlaceMapCommon() {
    classCallCheck(this, MarketPlaceMapCommon);
    return possibleConstructorReturn(this, (MarketPlaceMapCommon.__proto__ || Object.getPrototypeOf(MarketPlaceMapCommon)).apply(this, arguments));
  }

  createClass(MarketPlaceMapCommon, [{
    key: 'render',
    value: function render() {
      var googleMap = null;
      var GOOGLEMAPKEY = 'AIzaSyCLz2cTUf9oX-8YJySE_DhskzIZgIEADso';
      var center = [48, -150];

      try {
        googleMap = React__default.createElement(MapComponentCommon, {
          bootstrapURLKeys: GOOGLEMAPKEY
          // mapLoaded={this.props.mapLoaded}
          // onChange={this.onChange}
          // onMarkerHover={this.onMarkerHover}
          // onChildClick={this.onChildClick}
          // onDrag={this.onDrag}
          // activeMarker={this.props.activeMarker}
          // selectedShipmentId={this.props.selectedShipmentId}
          , center: center
          // zoom={this.props.zoom}
          // fixed={this.props.fixed}
          // dragging={this.props.dragging}
          // markers={filteredShipments || shipments}
          , map: this.props.map,
          maps: this.props.maps
          // route={this.props.route}
          , hoveredRoute: null
          // markerHover={this.props.markerHover}
          // vesselDetailList={vesselDetailList}
          // portDetailList={portDetailList}
          // updateShipmentFilters={updateShipmentFilters}
          // containerDetailList={containerDetailList}
          // shipmentError={shipmentError}
          // isWhiteLabel ={isWhiteLabel}
          // wlCustomerName={wlCustomerName}
          // flights={flights}
          // addressLocDetails={addressLocDetails}
          // searchTab={this.props.searchTab}
          // airportDetails = {airportDetails}
          // crossBorderDetails = {crossBorderDetails}
          // flightPortDetails = {flightPortDetails}
          // userInitialData={this.props.userInitialData}  

        });
      } catch (error) {
        console.log("Google map error", error);
      }
      // );

      return googleMap;
    }
  }]);
  return MarketPlaceMapCommon;
}(Component);

var BidModalTopLine = function (_Component) {
  inherits(BidModalTopLine, _Component);

  function BidModalTopLine() {
    classCallCheck(this, BidModalTopLine);
    return possibleConstructorReturn(this, (BidModalTopLine.__proto__ || Object.getPrototypeOf(BidModalTopLine)).apply(this, arguments));
  }

  createClass(BidModalTopLine, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      console.log("BidModalTopLine :: ", this.props, this.props.source, this.props.sourceId);
      var splitForTooltipCust = function splitForTooltipCust(name) {
        if (!name) return "TBD";

        var firstPart = name.substring(0, 10);

        console.log("splitForTooltipCust :: ", name, ", firstPart", firstPart);
        return React__default.createElement(
          "div",
          null,
          firstPart,
          name.length > 10 ? React__default.createElement(Popup, { content: name, trigger: React__default.createElement(
              "b",
              null,
              React__default.createElement(
                "a",
                { style: { color: "#0A8B8F", marginTop: "-20px", backgroundColor: "white" } },
                "..."
              )
            ) }) : ""
        );
      };
      var source = splitForTooltipCust(this.props.source);
      return React__default.createElement(
        "div",
        {
          style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? { width: "750px" } : null,
          className: "bid-data-header"
        },
        React__default.createElement(
          "div",
          { style: { paddingTop: "20px", backgroundColor: "white" } },
          React__default.createElement(
            "div",
            { className: "bid-left-header" },
            React__default.createElement(
              "div",
              {
                style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? {
                  marginTop: "-10px"

                } : {
                  marginTop: "-10px",
                  marginLeft: "2px"
                },
                className: "small-text "
              },
              "FROM"
            ),
            React__default.createElement(
              "div",
              { className: "bid-port-header" },
              React__default.createElement(
                "div",
                null,
                React__default.createElement("img", {
                  style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? { marginTop: "0px" } : { width: "20px", marginTop: "1.5px" },
                  className: "anchor-img",
                  src: "images/files/anchor.svg"
                })
              ),
              React__default.createElement(
                "div",
                { className: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? "customer-party-name-bid" : "party-name-bid" },
                source
              ),
              React__default.createElement(
                "div",
                {
                  style: {
                    //marginLeft: "940px",
                    marginBottom: "-30px"
                  },
                  className: "collapsible",
                  onClick: function onClick(e) {
                    _this2.props.onArrowClick(_this2.props.source, _this2.props.sourceId);
                  }
                },
                this.props.isOpen ? React__default.createElement("img", {
                  style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? {
                    marginBottom: "30px",
                    marginTop: "-4px",
                    marginLeft: "240px"
                    //paddingRight:"10px"
                  } : {
                    marginBottom: "30px",
                    marginTop: "-4px",
                    marginLeft: "558px"
                  },
                  className: "arrow-img",
                  src: "images/files/downArrow.svg"
                }) : React__default.createElement("img", {
                  style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? {
                    marginBottom: "30px",
                    marginTop: "-4px",
                    marginLeft: "240px"
                    //paddingRight:"10px"
                  } : {
                    marginBottom: "30px",
                    marginTop: "-4px",
                    marginLeft: "558px"
                  },
                  className: "arrow-img",
                  src: "images/files/sideArrow.svg"
                })
              )
            )
          )
        )
      );
    }
  }]);
  return BidModalTopLine;
}(Component);

var DestinationLane$2 = function (_Component) {
  inherits(DestinationLane, _Component);

  function DestinationLane(props) {
    classCallCheck(this, DestinationLane);

    var _this = possibleConstructorReturn(this, (DestinationLane.__proto__ || Object.getPrototypeOf(DestinationLane)).call(this, props));

    _this.state = {
      bidData: {}
    };
    return _this;
  }

  createClass(DestinationLane, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          handleApCurrencyCodeChange = _props.handleApCurrencyCodeChange,
          currentApCurrencyCode = _props.currentApCurrencyCode,
          destinationData = _props.destinationData;
      var sourceId = destinationData.sourceId,
          sourceName = destinationData.source,
          laneId = destinationData.laneId,
          destinationName = destinationData.destination;

      if (!currentApCurrencyCode) handleApCurrencyCodeChange(lodash_1(destinationData, 'partnerBids[0].apCurrencyCode', 'N/A'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var currentApCurrencyCode = this.props.currentApCurrencyCode;


      console.log("DestinationLane :: props", this.props, _typeof(this.props.destinationData));

      var bidBaseTotal = lodash_1(this.props, "destinationData.destinationBidData.laneAmount", null);

      var _props2 = this.props,
          destinationData = _props2.destinationData,
          drayageApp = _props2.drayageApp;

      var isSales = isSalesApp(drayageApp);
      var destinationName = destinationData.destinationId;
      var destinationApproxVolume = destinationData.approxVolume;
      var destinationProposedBid = destinationData.proposedBid;
      destinationProposedBid = destinationProposedBid ? amountToTwoDecimal(destinationProposedBid, true) : "";
      var portId = destinationData.sourceId;
      var sourceId = destinationData.sourceId;
      var sourceName = destinationData.source;
      var laneId = destinationData.laneId;
      //let sorcePortName=destinationData.sourceName
      var destinationAddressName = destinationData.destination.toUpperCase();
      // destinationAddressName = destinationAddressName
      //   ? destinationAddressName.toUpperCase()
      //   : "TBD";

      var containerLoadType = destinationData.containerLoadType;
      var containerType = destinationData.containerType;
      var warehouseAppointment = destinationData.warehouseAppointment;

      console.log("destinationAddressName", destinationAddressName);
      var totalLaneBidPrice = bidBaseTotal * destinationApproxVolume;
      console.log("totalLaneBidPrice", totalLaneBidPrice);

      var addressInfo = lodash_1(destinationData, "destination", "");

      var addressName = addressInfo;
      console.log("addressName", addressName);

      var totalPriceBidLane = parseFloat(totalLaneBidPrice).toFixed(2);

      var splitForTooltip = function splitForTooltip(name) {
        if (!name) return "TBD";

        var firstPart = name.substring(0, 12);

        return React__default.createElement(
          React__default.Fragment,
          null,
          firstPart,
          name.length > 12 ? React__default.createElement(Popup, {
            content: name,
            trigger: React__default.createElement(
              "b",
              null,
              React__default.createElement(
                "a",
                { style: { color: "#0A8B8F" } },
                "  ",
                " ..."
              )
            )
          }) : ""
        );
      };

      return React__default.createElement(
        "div",
        null,
        !this.props.isOpen ? React__default.createElement(
          "div",
          null,
          React__default.createElement(
            "div",
            { className: "data-wrapper" },
            React__default.createElement(
              "div",
              { className: "first-col" },
              React__default.createElement(
                "div",
                { className: "small-text left" },
                "TO:"
              ),
              React__default.createElement(
                "div",
                null,
                React__default.createElement("img", {
                  style: { marginLeft: "-26px" },
                  className: "warehouse-img",
                  src: "images/files/warehouse.svg"
                })
              ),
              React__default.createElement(
                "div",
                {
                  style: { fontSize: "18px", fontWeight: "bold" },
                  className: "portName-text"
                },
                splitForTooltip(addressName)
              )
            ),
            React__default.createElement(
              "div",
              { className: "sec-col" },
              React__default.createElement(
                "div",
                { className: "cont-num " },
                destinationApproxVolume
              )
            ),
            React__default.createElement(
              "div",
              { className: "third-col" },
              React__default.createElement(
                "div",
                { className: "price-total" },
                destinationProposedBid
              )
            ),
            React__default.createElement(
              "div",
              { className: "fourth-col" },
              React__default.createElement(
                "div",
                { className: "price-total" },
                amountToTwoDecimal(destinationProposedBid, true)
              )
            )
          )
        ) : React__default.createElement(
          "div",
          null,
          React__default.createElement(
            "div",
            {
              className: bidBaseTotal ? "partner-bid-body-header partner-bid-body-data bid-done" : "partner-bid-body-header partner-bid-body-data bid-not-done"
            },
            React__default.createElement(
              "div",
              { className: "partner-bid-empty" },
              this.props.isFromEdit ? React__default.createElement("img", {
                onClick: function onClick() {
                  _this2.props.individualBidClickHandler(portId, sourceId, destinationAddressName, laneId, sourceName, destinationData, "", "", "", addressName);
                },
                src: "images/files/edit.svg",
                className: "partner-warehouse-img"
              }) : React__default.createElement("img", {
                src: "images/files/warehouse.svg",
                className: "partner-warehouse-img"
              })
            ),
            React__default.createElement(
              "div",
              { className: "partner-bid-dest partner-sec-col-header-bid-text-data-row" },
              React__default.createElement(
                "div",
                { className: "portName-text-bid " },
                splitForTooltip(addressName)
              )
            ),
            React__default.createElement(
              "div",
              { className: "partner-approx-bid-two" },
              React__default.createElement(
                "div",
                { className: "partner-sec-col-header-text-bid partner-sec-col-header-bid-text-data-rows", style: { textAlign: 'center' } },
                destinationApproxVolume
              )
            ),
            React__default.createElement(
              "div",
              { className: "partner-approx-bid-three" },
              React__default.createElement(
                "div",
                { className: "partner-sec-col-header-text-bid partner-sec-col-header-bid-text-data-rows" },
                isPartnerApp(drayageApp) || this.props.isBiddingFromOppUpdation ? lodash_1(destinationData, 'partnerBids[0].apCurrencyCode', 'N/A') : destinationData.arCurrencyCode,
                " ",
                destinationProposedBid
              )
            ),
            React__default.createElement(
              "div",
              {
                className: "partner-approx-bid-five partner-approx-bid-five-data",
                style: bidBaseTotal ? { backgroundColor: "#1158BA" } : null
              },
              !bidBaseTotal ? React__default.createElement(
                "button",
                {
                  onClick: function onClick() {
                    _this2.props.individualBidClickHandler(portId, sourceId, destinationAddressName, laneId, sourceName, destinationData, "", "", "", addressName);
                  },
                  className: "partner-bid-price"
                },
                isSales || this.props.isBiddingFromOppUpdation ? 'BID' : 'GENERATE AR'
              ) : React__default.createElement(
                "div",
                {
                  onClick: function onClick() {
                    _this2.props.individualBidClickHandler(portId, sourceId, destinationAddressName, laneId, sourceName, destinationData, "", "", "", addressName);
                  },
                  className: "partner-approx-bid-five-data2"
                },
                isPartnerApp(drayageApp) || this.props.isBiddingFromOppUpdation ? currentApCurrencyCode : destinationData.arCurrencyCode,
                amountToTwoDecimal(bidBaseTotal, true)
              )
            )
          )
        )
      );
    }
  }]);
  return DestinationLane;
}(Component);

var OPPORTUNITY_MODAL_VIEW = {
  None: "None",
  BidModal: "BidModal",
  LaneBidCard: "LaneBidCard",
  AdditionalCharges: "AdditionalCharges",
  PortAdditionalCharges: "PortAdditionalCharges",
  ConfirmationForSubmit: "ConfirmationForSubmit",
  SuccessfulSubmission: "SuccessfulSubmission",
  FailureSubmission: "FailureSubmission"
};

var totalBidAmountForLane = function totalBidAmountForLane(state) {
  var basefee = 0;
  var minDaysReq = 0;
  var chasisRentalPerDay = 0;
  var fuelCharges = 0;
  if (state.baseFees) {
    basefee = parseInt(state.baseFees);
  }
  if (state.minReqDays) {
    minDaysReq = parseInt(state.minReqDays);
  }
  if (state.chasisRentalperday) {
    chasisRentalPerDay = parseInt(state.chasisRentalperday);
  }
  if (state.fuelCharges) {
    fuelCharges = parseFloat(state.fuelCharges);
  }

  console.log("totalBidAmountForLane :: ", state);
  var totalFee = basefee + minDaysReq * chasisRentalPerDay + basefee * fuelCharges / 100;

  var tmp = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = state.additionalchargesForLane[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = slicedToArray(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];

      tmp.push(value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var totalAdditionalchargesForLane = totalAdditionalCharge(tmp);

  totalFee = totalFee + totalAdditionalchargesForLane;
  console.log("additionalchargesForLane :", tmp, totalAdditionalchargesForLane);

  return totalFee;
};

var isViewBidModal = function isViewBidModal(view) {
  return view === OPPORTUNITY_MODAL_VIEW.BidModal;
};

var isViewLaneAdditionalCharges = function isViewLaneAdditionalCharges(view) {
  return view === OPPORTUNITY_MODAL_VIEW.AdditionalCharges;
};

var isViewLaneBid = function isViewLaneBid(view) {
  return view === OPPORTUNITY_MODAL_VIEW.LaneBidCard;
};

var isViewPortAdditionalCharges = function isViewPortAdditionalCharges(view) {
  return view === OPPORTUNITY_MODAL_VIEW.PortAdditionalCharges;
};

var isViewSuccessfulSubmission = function isViewSuccessfulSubmission(view) {
  return view === OPPORTUNITY_MODAL_VIEW.SuccessfulSubmission;
};
var splitForTooltip$1 = function splitForTooltip(name) {
  if (!name) return "TBD";

  var firstPart = name.substring(0, 15);

  console.log("splitForTooltip :: ", name, ", firstPart", firstPart);
  return React__default.createElement(
    "div",
    null,
    firstPart,
    name.length > 15 ? React__default.createElement(Popup, {
      content: name,
      trigger: React__default.createElement(
        "b",
        null,
        React__default.createElement(
          "a",
          { style: { color: "#0A8B8F", marginTop: "-20px" } },
          "..."
        )
      )
    }) : ""
  );
};

var totalAdditionalCharge = function totalAdditionalCharge(additionalCharges) {
  var grandTotal = 0;
  if (!additionalCharges) {
    return 0;
  }
  console.log("totalAdditionalCharge : ", additionalCharges);
  for (var i = 0; i < additionalCharges.length; i++) {
    var total = 0;
    var charge = additionalCharges[i];

    console.log("grandTotal charge :", charge);
    if (charge.reqQuantityUsed) {
      total = parseInt(charge.unitPrice) * parseInt(charge.reqQuantityUsed);
      grandTotal += total;
      console.log("grandTotal util", grandTotal);
    }
  }
  return grandTotal;
};

function WithErrorBoundary(WrappedComponent) {
  return function (_Component) {
    inherits(_class, _Component);

    function _class(props) {
      classCallCheck(this, _class);

      var _this = possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.state = {
        hasError: false
      };
      return _this;
    }

    createClass(_class, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, info) {
        console.error("WithErrorBoundary error", error);
        console.log("WithErrorBoundary info", info);
        this.setState({ hasError: true });
      }
    }, {
      key: "render",
      value: function render() {
        return this.state.hasError ? React__default.createElement(
          "div",
          null,
          React__default.createElement(
            "h3",
            null,
            "Something went wrong"
          )
        ) : React__default.createElement(WrappedComponent, this.props);
      }
    }]);
    return _class;
  }(Component);
}

var PortwiseData = function (_Component) {
  inherits(PortwiseData, _Component);

  function PortwiseData(props) {
    classCallCheck(this, PortwiseData);

    var _this = possibleConstructorReturn(this, (PortwiseData.__proto__ || Object.getPrototypeOf(PortwiseData)).call(this, props));

    _this.state = {
      submitBidConfirmed: false
    };
    return _this;
  }

  createClass(PortwiseData, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var drayageApp = this.props.drayageApp;

      var isPartner = isPartnerApp(drayageApp);
      console.log("PortwiseData :: ", this.props);

      var totalAdditionalCharges = this.props.portData.totalPortAdditionalCharges;
      totalAdditionalCharges = amountToTwoDecimal(totalAdditionalCharges, true);

      var getTotalVolume = function getTotalVolume() {
        var totalVolume = 0;

        for (var i = 0; i < _this2.props.portData.destinations.length; i++) {
          var cont = _this2.props.portData.destinations[i].approxVolume;
          totalVolume += cont;
          console.log("Cont", cont);
        }
        console.log("totalvol", totalVolume);
        return totalVolume;
      };
      var totalVol = getTotalVolume();
      console.log("totalvol", totalVol);
      var totalBussiness = function totalBussiness() {
        var total = 0;

        for (var i = 0; i < _this2.props.portData.destinations.length; i++) {
          var cont = _this2.props.portData.destinations[i].approxVolume;
          var price = _this2.props.portData.destinations[i].proposedBid;

          total = total + cont * price;
        }
        return total;
      };
      var totalBuss = totalBussiness();
      var source = lodash_1(this.props, "portData.source", "").toUpperCase();
      var totalEnteredBusiness = 0;
      return React__default.createElement(
        "div",
        null,
        React__default.createElement(
          "div",
          { className: "partner-m-layout" },
          React__default.createElement(BidModalTopLine, {
            source: source,
            sourceId: this.props.portData.sourceId,
            onArrowClick: this.props.onPortArrowClick,
            isOpen: this.props.isOpen
          }),
          this.props.isOpen && React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "div",
              { className: "partner-bid-body-header partner-bid-body-bottom" },
              React__default.createElement("div", { className: "partner-bid-empty" }),
              React__default.createElement(
                "div",
                { className: "partner-bid-dest" },
                "Destinations"
              ),
              React__default.createElement(
                "div",
                { className: "partner-approx-bid" },
                React__default.createElement(
                  "div",
                  { className: "partner-sec-col-header-bid-text  " },
                  this.props.opp_key !== "containerOpportunities" ? "Approx Volume" : "Volume"
                ),
                React__default.createElement(
                  "div",
                  { className: "partner-lower" },
                  this.props.opp_key !== "containerOpportunities" && "Cont.Per Month"
                )
              ),
              React__default.createElement(
                "div",
                { className: "partner-approx-bid-two" },
                React__default.createElement(
                  "div",
                  { className: "partner-sec-col-header-bid-text  " },
                  "Suggested ",
                  isPartner || this.props.isBiddingFromOppUpdation ? 'Bid' : 'AR'
                ),
                React__default.createElement(
                  "div",
                  { className: "partner-lower" },
                  "Per Cont."
                )
              ),
              React__default.createElement(
                "div",
                { className: "partner-approx-bid-five" },
                React__default.createElement(
                  "div",
                  { className: "partner-bid-best" },
                  "Your Best ",
                  isPartner || this.props.isBiddingFromOppUpdation ? 'Bid' : 'AR'
                ),
                React__default.createElement(
                  "div",
                  {
                    style: { marginTop: "-2px", paddingRight: "60px" },
                    className: "partner-lower"
                  },
                  "Per Cont."
                )
              )
            ),
            React__default.createElement(
              "div",
              { className: "partner-lanes-wrapper" },
              this.props.portData.destinations && this.props.portData.destinations.map(function (destinationData) {
                console.log("destination data from port oppor", destinationData);
                if (destinationData.destinationBidData) {
                  totalEnteredBusiness += parseInt(destinationData.destinationBidData.bidBaseTotal) * parseInt(destinationData.approxVolume);
                }

                return React__default.createElement(DestinationLane$2, {
                  destinationData: destinationData,
                  totalVol: totalVol,
                  isOpen: _this2.props.isOpen,
                  individualBidClickHandler: _this2.props.individualBidClickHandler,
                  additionalCharges: _this2.props.additionalCharges,
                  partnerId: _this2.props.partnerId,
                  opp_key: _this2.props.opp_key,
                  isFromEdit: _this2.props.isFromEdit,
                  isBiddingFromOppUpdation: _this2.props.isBiddingFromOppUpdation,
                  currentApCurrencyCode: _this2.props.currentApCurrencyCode,
                  handleApCurrencyCodeChange: _this2.props.handleApCurrencyCodeChange
                });
              })
            ),
            React__default.createElement(
              "div",
              { className: "partner-pot-add" },
              React__default.createElement(
                "span",
                {
                  style: { padding: 10, fontWeight: 700, fontStyle: "italic" }
                },
                "** Add additional charges as lane charges **"
              )
            )
          )
        )
      );
    }
  }]);
  return PortwiseData;
}(Component);

var PortwiseData$1 = WithErrorBoundary(PortwiseData);

var css_248z$p = ".lcl-text {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 1.14px;\n  line-height: 22px;\n  padding: 2px;\n  padding-top: 3px; }\n\n.drop-pull-text {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 1.14px;\n  line-height: 22px;\n  padding: 2px;\n  padding-top: 3px; }\n\n.warehouse-text {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 1.14px;\n  line-height: 22px;\n  padding: 2px;\n  padding-top: 3px; }\n\n.pot-add-btn {\n  box-sizing: border-box;\n  height: 26px;\n  width: 94px;\n  border: 1px solid #0a53b8;\n  border-radius: 2px;\n  background-color: #ffffff;\n  color: #0a53b8;\n  padding-top: 2px;\n  margin-top: 12px; }\n\n.pot-charge-btn {\n  box-sizing: border-box;\n  height: 47px;\n  border: 1px solid #0a53b8;\n  border-radius: 2px;\n  background-color: #1158ba;\n  color: #ffffff;\n  padding: 12px 20px 0 20px;\n  font-size: 18px; }\n\n.confirmationPageModalPartner {\n  height: 933px;\n  width: 860px;\n  border-radius: 12px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5);\n  margin-left: 20%;\n  margin-top: 5%;\n  padding-bottom: 30px; }\n\n.partner-modal-first {\n  height: 933px;\n  width: 960px;\n  border-radius: 12px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5);\n  margin-left: 20%;\n  margin-top: 5%;\n  padding-bottom: 30px; }\n\n.partner-modal-success {\n  height: 433px !important;\n  width: 960px;\n  border-radius: 12px;\n  background-color: #ffffff;\n  margin-left: 20%;\n  margin-top: 10%;\n  padding-bottom: 30px;\n  border-top: none !important; }\n\n.partner-modal-first-bid-card {\n  width: 800px;\n  border-radius: 12px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5);\n  margin-left: 30%;\n  margin-top: 4%;\n  padding-bottom: 30px;\n  margin-left: calc(50% - 400px); }\n\n.partner-modal-first-confirmation {\n  height: 533px;\n  width: 800px;\n  border-radius: 12px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(146, 146, 146, 0.5);\n  margin-left: 30%;\n  margin-top: 4%;\n  overflow: auto;\n  overflow-x: hidden;\n  padding-bottom: 30px; }\n\n.partner-modal-first-confirmation-contents {\n  margin-left: 200px;\n  margin-top: 20px; }\n\n.partner-bid-modal-header {\n  height: 40px;\n  display: flex;\n  flex-direction: row; }\n\n.partner-m-layout {\n  box-sizing: border-box;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  background-color: #ffffff;\n  margin-top: 40px;\n  margin-left: 30px;\n  margin-right: 40px;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px;\n  background-color: #ffffff; }\n\n.partner-bid-body-header {\n  justify-content: space-between;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 1px;\n  margin-left: 10px;\n  margin-right: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: \"Open Sans\"; }\n\n.partner-bid-body-bottom {\n  border-top: 1px solid #979797; }\n\n.partner-bid-body-data {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  height: 40px; }\n\n.bid-not-done {\n  background-color: #eaeaea; }\n\n.bid-done {\n  background-color: #e0e5ec; }\n\n.partner-bid-empty {\n  width: 2.8%;\n  background-color: white; }\n\n.partner-bid-dest {\n  width: 27.2%;\n  margin-top: 10px;\n  padding-left: 20px; }\n\n.partner-approx-bid {\n  width: 15%;\n  text-align: right; }\n\n.partner-approx-bid-two {\n  width: 15%;\n  text-align: right; }\n\n.partner-approx-bid-three {\n  width: 15%;\n  text-align: right;\n  text-align: right; }\n\n.partner-approx-bid-five {\n  padding-right: 10px;\n  margin-left: 85px; }\n\n.partner-approx-bid-five-data {\n  background-color: #dadada; }\n\n.partner-approx-bid-five-data2 {\n  height: 21px;\n  width: 110px;\n  color: #ffffff;\n  font-family: \"Open Sans\";\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n  margin-left: 8%;\n  padding-top: 10px; }\n\n.partner-sec-col-header-bid-text {\n  font-family: \"Open Sans\";\n  letter-spacing: 0;\n  line-height: 17px;\n  color: black; }\n\n.partner-sec-col-header-bid-text-data-rows {\n  text-align: right;\n  margin-top: 10px;\n  font-size: 18px;\n  font-weight: bold; }\n\n.partner-lower {\n  color: #6c6d6e;\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  letter-spacing: 0;\n  line-height: 17px;\n  text-align: right;\n  font-weight: 100; }\n\n.partner-bid-best-your {\n  width: 18%;\n  padding-right: 20px;\n  text-align: right; }\n\n.partner-indiv-total-wrapper {\n  margin-top: 10px;\n  margin-bottom: 20px;\n  width: max-content; }\n  .partner-indiv-total-wrapper div:nth-child(4) {\n    margin-right: 20px; }\n  .partner-indiv-total-wrapper > div {\n    float: left;\n    height: 43px; }\n\n.partner-indiv-total {\n  margin-left: 320px;\n  color: #bababa;\n  font-family: \"Open Sans\";\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n  font-weight: 500;\n  text-align: right; }\n\n.partner-indiv-total-wrapper-bid {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n  width: 930px;\n  margin-left: -30px; }\n\n.partner-total-cont {\n  margin-top: -1px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: right;\n  width: 12%;\n  margin-top: -1px;\n  font-size: 18px;\n  font-weight: bold;\n  width: 100px;\n  text-align: right; }\n\n.partner-total-indiv-sum {\n  padding-left: 155px;\n  font-weight: bold;\n  font-size: 18px;\n  padding-right: 10px;\n  width: 100px;\n  text-align: right; }\n\n.partner-pot-add {\n  height: 50px;\n  opacity: 0.8;\n  border-radius: 2px;\n  background-color: #e0e5ec;\n  margin-left: 36px;\n  margin-right: 10px;\n  margin-top: 20px;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n  justify-content: space-between; }\n\n.partner-add {\n  margin-left: 356px;\n  text-align: center; }\n\n.partner-pot-text {\n  color: #000000;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n  font-family: \"Open Sans\";\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 21px;\n  margin-left: 10px;\n  margin-top: 15px;\n  letter-spacing: 0; }\n\nicon-text {\n  display: flex;\n  flex-direction: column; }\n\n.partner-data-wrapper-bid {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  opacity: 0.8px;\n  border-radius: 2px;\n  background-color: #ffffff;\n  margin-left: 35px;\n  margin-bottom: 2px;\n  padding-top: 10px;\n  height: 50px;\n  width: 939px;\n  opacity: 0.8;\n  border-radius: 2px;\n  background-color: #eaeaea;\n  margin-bottom: 6px;\n  background-color: #d8dfe8;\n  text-align: right; }\n\n.partner-bid-col-one {\n  width: 30%; }\n\n.partner-bid-col-two {\n  width: 13%; }\n\n.partner-bid-col-third {\n  width: 13%; }\n\n.partner-bid-col-fourth {\n  width: 13%; }\n\n.partner-bid-cont-num {\n  text-align: right;\n  margin-top: 6px;\n  font-size: 18px;\n  font-weight: bold; }\n\n.partner-bid-item-price {\n  width: 13%;\n  text-align: right;\n  font-size: 18px;\n  margin-top: 6px;\n  padding-left: 68px;\n  font-weight: bold; }\n\n.partner-price-total {\n  margin-top: 6px;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: right;\n  color: black;\n  font-weight: bold;\n  padding-left: 6px; }\n\n.partner-bid-price-holder {\n  border-radius: 2px;\n  background-color: #dadada;\n  height: 50px;\n  width: 20%;\n  margin-top: -10px;\n  padding-right: 20px; }\n\n.partner-bid-price {\n  box-sizing: border-box;\n  height: 23px;\n  border: 1px solid #0a53b8;\n  border-radius: 2px;\n  background-color: white !important;\n  z-index: 100;\n  color: #0a53b8;\n  font-weight: bold;\n  font-size: 14px;\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-top: 10px; }\n\n.partner-total-holder {\n  width: 123px;\n  margin-top: -8px;\n  border-radius: 2px;\n  background-color: #1158ba; }\n\n.partner-total-price-bid {\n  font-weight: bold;\n  padding-right: 50px;\n  font-size: 30px;\n  width: 13%;\n  margin-left: -80px; }\n\n.partner-warehouse-img {\n  float: left;\n  border-radius: 55%;\n  padding: 2px;\n  margin-top: 10px;\n  width: 20px; }\n\n.partner-best-box-grand {\n  height: 53px;\n  width: 377px;\n  opacity: 0.8;\n  border-radius: 2px 0 0 2px;\n  background-color: #090707;\n  color: white;\n  margin-left: 30px;\n  clip-path: polygon(0 0, 99% 0, 85% 100%, 0% 100%);\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-align: left;\n  padding-left: 20px;\n  padding-top: 10px;\n  width: 219px;\n  opacity: 0.8;\n  border-radius: 2px 0 0 2px;\n  background-color: #717171;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around; }\n\n.partner-cont-bid-box {\n  height: 53px;\n  border-radius: 2px;\n  background-color: #d9efff;\n  margin-right: 20px;\n  margin-left: -58px;\n  padding-left: 200px;\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row;\n  height: 53px;\n  width: 715px;\n  border-radius: 2px;\n  background-color: #d9efff;\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 30px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 35px; }\n\n.partner-per-cont {\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 30px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 35px;\n  width: 13%; }\n\n.bidcard-wrapper {\n  box-sizing: border-box;\n  height: 528px;\n  width: 741px;\n  border: 1px solid #dcdcdc;\n  border-radius: 0 0 3px 3px;\n  background-color: #ffffff; }\n\n.bidcard-wrapper-bid-card {\n  box-sizing: border-box;\n  height: 578px;\n  width: 741px;\n  border: 1px solid #dcdcdc;\n  border-radius: 0 0 3px 3px;\n  background-color: #ffffff; }\n\n.partner-cont-bid-box {\n  height: 53px;\n  border-radius: 2px;\n  background-color: #d9efff;\n  margin-right: 20px;\n  margin-left: -50px;\n  padding-left: 200px;\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row;\n  height: 53px;\n  width: 715px;\n  border-radius: 2px;\n  background-color: #d9efff; }\n\n.partner-btn-submit {\n  height: 50px;\n  width: 163px;\n  border-radius: 3px;\n  background-color: #008b8f;\n  color: white;\n  margin-left: 10px;\n  border: 1px solid #008b8f;\n  color: white;\n  margin-right: 15px;\n  font-family: \"Open Sans\";\n  margin-bottom: 10px; }\n\n.partners-btn-done {\n  height: 50px;\n  width: 163px;\n  border-radius: 3px;\n  background-color: #008b8f;\n  color: white;\n  border: none;\n  margin-top: 30px;\n  margin-right: 20px;\n  font-size: 14px; }\n\n.bidModalButtonContainer {\n  text-align: center; }\n\n.partner-btn-submit-save {\n  height: 50px;\n  width: 163px;\n  border-radius: 3px;\n  background-color: #008b8f;\n  color: white;\n  border: 1px solid #008b8f;\n  color: white;\n  margin-right: 15px;\n  font-family: \"Open Sans\";\n  margin-bottom: 10px; }\n\n.add-header-wrapper {\n  overflow: auto; }\n\n.partner-lanes-wrapper {\n  height: 200px;\n  border-top: 2px solid lightgray;\n  border-bottom: 2px solid lightgray; }\n\n.grand-total-val {\n  width: 100px;\n  margin-right: 36px;\n  font-size: 22px;\n  margin-top: 2px;\n  font-weight: 900;\n  text-align: right; }\n\n.good-total-value {\n  width: 100px;\n  font-size: 22px;\n  margin-top: 2px;\n  font-weight: 900;\n  text-align: right;\n  padding-right: 10px;\n  padding-top: 10px; }\n\n[data-tab-container=\"DRAYAGE_SUBMITTED\"] .grand-price,\n[data-tab-container=\"DRAYAGE_ACTIVE\"] .grand-price,\n[data-tab-container=\"DRAYAGE_REJECTED\"] .grand-price {\n  margin-right: 90px; }\n\n[data-tab-container=\"DRAYAGE_SUBMITTED\"] .data-header.total-row div:nth-child(3),\n[data-tab-container=\"DRAYAGE_ACTIVE\"] .data-header.total-row div:nth-child(3),\n[data-tab-container=\"DRAYAGE_REJECTED\"] .data-header.total-row div:nth-child(3) {\n  margin-right: 100px; }\n\n@media all and (max-width: 1400px) {\n  .bidcard-wrapper-bid-card {\n    height: 397px; }\n    .bidcard-wrapper-bid-card .internal {\n      height: 195px; }\n    .bidcard-wrapper-bid-card .best-cont {\n      margin-top: 12px; }\n  .bidcard-wrapper {\n    height: 445px !important; } }\n\n@media all and (max-width: 1400px) {\n  .bid-data-header {\n    width: unset; }\n  .partner-m-layout {\n    margin-top: 9px !important; }\n  .partner-lanes-wrapper {\n    height: unset !important; }\n  .partner-bid-modal-header {\n    margin-bottom: -10px; }\n  .best-cont {\n    margin-top: 51px !important; } }\n\n.bidcard-wrapper {\n  overflow-y: auto;\n  overflow-x: hidden; }\n\n.scrollableDiv {\n  max-height: 60vh;\n  overflow-y: scroll;\n  overflow-x: hidden; }\n\n.scrollableDiv::-webkit-scrollbar {\n  width: 10px !important; }\n\n.scrollableDiv::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0); }\n\n.summaryDiv {\n  width: 580px;\n  height: 350px;\n  border: 1px solid black;\n  margin-top: 20px;\n  overflow-x: hidden;\n  overflow-y: scroll; }\n  .summaryDiv::-webkit-scrollbar {\n    width: 8px !important; }\n\n.nameport {\n  margin-top: 20px;\n  margin-left: 20px;\n  font-size: 24px;\n  width: 100%;\n  font-weight: bold;\n  font-family: \"Open Sans\";\n  margin-bottom: 10px; }\n\n.namedest {\n  margin-top: 20px;\n  margin-left: 20px;\n  font-size: 16px;\n  width: 100%;\n  font-weight: bold;\n  font-family: \"Open Sans\";\n  margin-bottom: 10px; }\n\n.basebreakup {\n  margin-top: 20px;\n  margin-left: 40px;\n  font-size: 14px;\n  width: 100%;\n  font-weight: bold;\n  font-family: \"Open Sans\";\n  margin-bottom: 10px; }\n\n.general-row-cont {\n  display: flex;\n  flex-direction: row;\n  justify-content: start; }\n\n.grand-btn-display {\n  width: 200px;\n  height: 50px;\n  background-color: #bababa;\n  color: white;\n  padding: 10px;\n  margin-left: 10px; }\n\n.fuel-charges {\n  height: 49px;\n  width: 37.5rem;\n  border: 1px solid #1765ae;\n  background-color: #ffffff; }\n  .fuel-charges.bid-textarea {\n    border-radius: 0;\n    outline: none;\n    overflow-y: auto;\n    padding: 3px;\n    resize: none; }\n    .fuel-charges.bid-textarea::-webkit-scrollbar {\n      width: auto !important; }\n\n.fees-fuel {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  width: 37.5rem; }\n\n.fuel-inclusion {\n  height: 49px;\n  width: 25.25rem;\n  border: 1px solid #1765ae;\n  border-radius: 0 2px 0 0;\n  background-color: #ffffff; }\n\n.bidcard-header {\n  box-sizing: border-box;\n  height: 87px;\n  width: 740px;\n  border: 1px solid #dcdcdc;\n  border-radius: 3px 3px 0 0;\n  background-color: #eeeeee;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n\n.input-box {\n  margin-bottom: 10px;\n  margin-left: 20px;\n  outline: 1px solid #7a7a7a;\n  padding: 0;\n  width: 70px; }\n\n#my-best-bid {\n  margin-top: 5px; }\n\n.inputInsideRightIconBidModal {\n  position: absolute;\n  right: 0;\n  transition: all 0.05s ease-in-out;\n  font-size: 14px; }\n\n.percent {\n  position: relative;\n  margin-top: -4px; }\n\n.invoice-opportuntity-modal {\n  margin-top: 250px;\n  width: 1000px;\n  margin-left: 200px;\n  border: 2px solid black; }\n";
styleInject(css_248z$p);

var InvoiceOpportunityView = function (_Component) {
    inherits(InvoiceOpportunityView, _Component);

    function InvoiceOpportunityView(props) {
        classCallCheck(this, InvoiceOpportunityView);

        var _this = possibleConstructorReturn(this, (InvoiceOpportunityView.__proto__ || Object.getPrototypeOf(InvoiceOpportunityView)).call(this, props));

        _this.state = {
            opportunityType: "",
            destinationName: "",
            source: "",
            sourceName: "",
            sourceId: "",
            laneId: "",
            portChargesList: new Map(),
            opportunity: {},
            opportunityData: new Map(),
            columnDataOpportunity: new Map(),
            loading: false
        };
        return _this;
    }

    createClass(InvoiceOpportunityView, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            var data = void 0;
            this.setState({ loading: true });
            getDrayageOpportunityDetailsForInvoiceContainer(this.props.containerId).then(function (res) {

                data = lodash_1(res.data, "eventMessage", {});
                var exceptionDetails = lodash_1(data, "exceptionDetails", null);

                console.log("res getOpportunityViewForInvoice>>", data, exceptionDetails);
                if (exceptionDetails) {
                    _this2.setState({ opportunityData: null, opportunity: null, columnDataOpportunity: null, loading: false });
                    return;
                }

                var opportunityData = new Map();
                var portData = new Map();
                // let columnDataMap = new Map()

                var thisOpportunityData = lodash_1(data, "opportunityDetails", {});
                var sourceList = lodash_1(data, "sourceList", []);

                var columnData = extractOpportunityLaneColumns(sourceList);
                console.log("res getOpportunityViewForInvoice>> columnData", columnData);

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = sourceList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var port = _step.value;

                        portData.set(port.sourceId, port);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                thisOpportunityData.portData = portData;

                opportunityData.set(thisOpportunityData.opportunityId, thisOpportunityData);
                // columnDataMap.set(thisOpportunityData.opportunityId,columnData)

                _this2.setState({ opportunityData: opportunityData, opportunity: thisOpportunityData, columnDataOpportunity: columnData, loading: false });
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: "render",
        value: function render() {
            // let opportunity = {}

            if (this.state.opportunity == null) {
                return (
                    // <ReactModal
                    //     isOpen={true}
                    //     contentLabel="onRequestClose Example"
                    //     // onRequestClose={this.props.handleCloseModal}
                    //     className="invoice-opportuntity-modal"
                    //     overlayClassName="Overlay"
                    //     ariaHideApp={false}

                    // >
                    React__default.createElement(
                        "div",
                        { className: "no-opportunities" },
                        "No opportunity found for container"
                    )
                    // </ReactModal>

                );
            }

            var opp_key = "laneOpportunity";
            if (this.state.opportunity.opportunityType === "DRAYAGE_LANE") {
                opp_key = "containerOpportunity";
            }
            return (
                // <ReactModal
                //     isOpen={true}
                //     contentLabel="onRequestClose Example"
                //     // onRequestClose={this.props.handleCloseModal}
                //     className="invoice-opportuntity-modal"
                //     overlayClassName="Overlay"
                //     ariaHideApp={false}

                // >

                React__default.createElement(
                    "div",
                    null,
                    this.state.loading ? React__default.createElement(
                        "div",
                        null,
                        "  Loading ... "
                    ) : "",
                    React__default.createElement(OpportunityClosedCommon, {
                        isOpen: true,
                        isEditBidModal: false,
                        changeEditStatus: function changeEditStatus(e) {},
                        opportunity: this.state.opportunity,
                        opp_key: opp_key,
                        tab: SELECTED_TABS.CUSTOMER_ACTIVE,
                        drayageApp: DRAYAGE_APP.KLEARDRAY_CUSTOMER,
                        onButtonClick: function onButtonClick(e) {},
                        cancelBid: function cancelBid(e) {},
                        opportunityData: this.state.opportunityData,
                        onOpportunitySelect: function onOpportunitySelect(e) {},
                        isDoneDisabled: true,
                        customerBidmodalHandler: function customerBidmodalHandler(e) {},
                        renewOpportunityFunc: function renewOpportunityFunc(e) {},
                        handleOpenBidModal: function handleOpenBidModal$$1(e) {},
                        handleOpportunityBidClicked: function handleOpportunityBidClicked(e) {},
                        handleSetChargeForEdit: function handleSetChargeForEdit$$1(e) {}

                    }),
                    React__default.createElement(OpportunityOpenedCommon, {
                        activeLanesOnly: false,
                        isEditBidModal: false,
                        changeEditStatus: function changeEditStatus(e) {},
                        tab: SELECTED_TABS.CUSTOMER_ACTIVE,
                        opp_key: opp_key // TODO //"laneOpportunity" or "containerOpportunity"
                        , opportunityData: this.state.opportunityData //TODO Key : Opportunity Id , Value : Opportunity brief details
                        , columnDataOpportunity: this.state.columnDataOpportunity // TODO for given port id and lane id, map of column name to its value from opportunity.
                        , opportunity: this.state.opportunity //TODO Details of the opportunity
                        , opportunityId: this.state.opportunity.opportunityId //TODO
                        // portData={
                        //     this.props.opportunityData && this.props.opportunityData.get(opportunity.opportunityId) && this.props.opportunityData.get(opportunity.opportunityId).portData
                        //   } //TODO Port data of the opportunity

                        , drayageApp: DRAYAGE_APP.KLEARDRAY_CUSTOMER,
                        isOpen: true

                        // {this.props.columnData.get(
                        //   opportunity.opportunityId
                        // )}


                        // onButtonClick={this.onButtonClick}
                        , handleOpenBidModal: function handleOpenBidModal$$1(e) {},
                        handleOpportunityBidClicked: function handleOpportunityBidClicked(e) {},
                        selectedTab: SELECTED_TABS.CUSTOMER_ACTIVE,
                        additionalCharges: function additionalCharges(e) {},
                        partnerId: "this.state.partnerId",
                        setAdditionalChargesInStore: function setAdditionalChargesInStore$$1(e) {},
                        selectBid: function selectBid(e) {},
                        unSelectBid: function unSelectBid(e) {},
                        customerId: "this.props.customerId"
                        //   standardPartnerAdditionalCharges={this.props.standardPartnerAdditionalCharges}
                        , setLaneBidChargesInStore: function setLaneBidChargesInStore$$1(e) {},
                        submitOpportunityBidData: function submitOpportunityBidData$$1(e) {},
                        setLanePriceSelected: function setLanePriceSelected$$1(e) {},
                        setCustomerLanePriceSelected: function setCustomerLanePriceSelected$$1(e) {},
                        getOpportunityDetailsApi: function getOpportunityDetailsApi$$1(e) {},

                        isLane: true,
                        userType: ""
                    })
                )
                // </ReactModal>

            );
        }
    }]);
    return InvoiceOpportunityView;
}(Component);

var NewDrayageRequestModal = function (_React$Component) {
    inherits(NewDrayageRequestModal, _React$Component);

    function NewDrayageRequestModal(props) {
        classCallCheck(this, NewDrayageRequestModal);

        var _this = possibleConstructorReturn(this, (NewDrayageRequestModal.__proto__ || Object.getPrototypeOf(NewDrayageRequestModal)).call(this, props));

        _this.state = {
            newRequest: false
        };
        return _this;
    }

    createClass(NewDrayageRequestModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            console.log("NewDrayageRequestModal >>> ", this.props);
            return React__default.createElement(
                ReactModal,
                {
                    isOpen: true,
                    contentLabel: 'onRequestClose Example'
                    // onRequestClose={this.props.handleCloseModal}
                    , className: 'drayagelane--req-modal',
                    overlayClassName: 'Overlay'
                },
                React__default.createElement(
                    'div',
                    { className: 'req-drayage-text' },
                    'REQUEST DRAYAGE'
                ),
                React__default.createElement(
                    'div',
                    { className: 'requestDrayageContainer' },
                    React__default.createElement(
                        'div',
                        { className: 'flitersSection' },
                        React__default.createElement(
                            Dropdown,
                            {
                                id: 'market-place-dropdown',
                                className: 'marketplace-country-dropdown',
                                simple: true,
                                item: true,
                                text: React__default.createElement(
                                    'div',
                                    {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            width: "100%",
                                            fontSize: "12px",
                                            lineHeight: "16px",
                                            color: "#1F1F1F"
                                        }
                                    },
                                    React__default.createElement(
                                        'div',
                                        { style: { fontWeight: "400px", color: "#7A7A7A" } },
                                        'Country (Pickup) '
                                    ),
                                    React__default.createElement(
                                        'div',
                                        {
                                            style: {
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                // width: "200px",
                                                fontWeight: "500"
                                            }
                                        },
                                        this.props.selectedOptionLabel
                                    )
                                )
                            },
                            React__default.createElement(
                                Dropdown.Menu,
                                { style: { width: "100%" } },
                                salesMultiCountryRadio.map(function (option) {
                                    return React__default.createElement(
                                        Dropdown.Item,
                                        { key: option.key },
                                        React__default.createElement(Checkbox, {
                                            className: 'dropdown-checkbox',
                                            label: option.label,
                                            value: option.value,
                                            onChange: _this2.props.toggleSelection,
                                            checked: _this2.props.countrySelected.includes(option.value)
                                        })
                                    );
                                })
                            )
                        ),
                        React__default.createElement(
                            Dropdown,
                            { id: 'market-place-dropdown', className: 'marketplace-country-dropdown', simple: true, item: true,
                                text: this.props.renderDropdownText() },
                            React__default.createElement(
                                Dropdown.Menu,
                                { style: { width: "100%" } },
                                salesMultiMOTRadio.map(function (_ref) {
                                    var key = _ref.key,
                                        label = _ref.label,
                                        value = _ref.value;
                                    return React__default.createElement(
                                        Dropdown.Item,
                                        { key: key },
                                        React__default.createElement(Checkbox, {
                                            className: 'dropdown-checkbox',
                                            label: label,
                                            value: value,
                                            onChange: _this2.props.toggleMotSelection,
                                            checked: _this2.props.motSelected.includes(value)
                                        })
                                    );
                                })
                            )
                        )
                    ),
                    React__default.createElement(SmartAccordian, _extends({ customerData: { kxEmail: this.props.userModalData.userInitialData.userInfo.kxEmail, customerCode: this.props.userModalData.userInitialData.userInfo.customerCode, userType: this.props.userModalData.typeOfUser } }, this.props, { customerSource: "DrayageLaneRequest" }))
                )
            );
        }
    }]);
    return NewDrayageRequestModal;
}(React__default.Component);

var NoResultsScreen = function (_Component) {
    inherits(NoResultsScreen, _Component);

    function NoResultsScreen(props) {
        classCallCheck(this, NoResultsScreen);

        var _this = possibleConstructorReturn(this, (NoResultsScreen.__proto__ || Object.getPrototypeOf(NoResultsScreen)).call(this, props));

        _this.state = {
            showErrorMsg: _this.props.tab === salesPortalTabs.SALES_NEW
        };
        return _this;
    }

    createClass(NoResultsScreen, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.state.showErrorMsg) setTimeout(function () {
                return _this2.setState({ showErrorMsg: false });
            }, 3000);
        }
    }, {
        key: 'render',
        value: function render() {
            return React__default.createElement(
                React__default.Fragment,
                null,
                this.state.showErrorMsg && React__default.createElement(
                    'div',
                    { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', color: 'red', fontSize: 16, marginTop: 5 } },
                    'No result found. Try using different keywords.'
                ),
                this.props.tab !== salesPortalTabs.SALES_NEW && React__default.createElement(
                    'div',
                    { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' } },
                    React__default.createElement(Icon, { name: 'search', size: 'huge', color: 'black' }),
                    React__default.createElement(
                        'span',
                        { style: { color: '#000', fontWeight: 700, margin: '10px 0px', fontSize: 18 } },
                        ' No result found '
                    ),
                    React__default.createElement(
                        'span',
                        null,
                        'We couldn\'t find any matches for your search. Try using different keywords.'
                    )
                )
            );
        }
    }]);
    return NoResultsScreen;
}(Component);

var MarketplacePortalCommon = function (_React$Component) {
  inherits(MarketplacePortalCommon, _React$Component);

  function MarketplacePortalCommon(props) {
    classCallCheck(this, MarketplacePortalCommon);

    var _this = possibleConstructorReturn(this, (MarketplacePortalCommon.__proto__ || Object.getPrototypeOf(MarketplacePortalCommon)).call(this, props));
    // debugger


    _this.cancelHandlerCustomerLaneRequest = function () {
      _this.setState({ newDrayageRequestModal: false });
    };

    _this.customerLanePriceSelectHandler = function (opportunityId, portId, laneId, on) {
      var customerAcceptedLanes = _this.state.customerAcceptedLanes;
      if (customerAcceptedLanes.has(opportunityId)) ;
    };

    _this.selectBid = function (partnerId, laneId, portId, opportunityId, customerId, opp_key, bid) {
      var selectBids = _this.state.selectBids;
      var knFuelPercent = bid.knFuelPercent;

      selectBids.push({ partnerId: partnerId, laneId: laneId, portId: portId, opportunityId: opportunityId, customerId: customerId, opp_key: opp_key, chargeDetails: bid.chargeDetails, knFuelPercent: knFuelPercent });
      _this.setState({ selectBids: selectBids });
    };

    _this.cancelBid = function () {
      _this.setState({ selectBids: [] });
    };

    _this.unSelectBid = function (partnerId, laneId, portId, opportunityId, customerId) {
      var selectBids = _this.state.selectBids;


      selectBids = selectBids.filter(function (bid) {
        return bid.partnerId !== partnerId || bid.laneId !== laneId || bid.portId !== portId || bid.opportunityId !== opportunityId || bid.customerId !== customerId;
      });
      _this.setState({ selectBids: selectBids });
    };

    _this.onOpportunitySelect = function (opportunityId) {
      _this.props.openBidSelection(_this.state.selectBids, opportunityId);
    };

    _this.isDoneDisabled = function (opportunityId) {
      var selectBids = _this.state.selectBids;


      selectBids = selectBids.filter(function (bid) {
        return bid.opportunityId === opportunityId;
      });

      if (selectBids.length > 0) return false;else return true;
    };

    _this.selectTab = function (tab) {
      // let elOpened = document.querySelector(
      //   "[data-tab='OPPORTUNITIES_LIST_OPENED'] > div"
      // );
      // let elClosed = document.querySelector(
      //   "[data-tab='OPPORTUNITIES_LIST_CLOSED'] > div"
      // );
      var _this$props = _this.props,
          countrySelected = _this$props.countrySelected,
          motSelected = _this$props.motSelected;

      var filters = [];

      _this.setState({ selectedTab: tab });

      if (tab === "SALES_NEW" && _this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES) ; else {
        // elOpened ? (elOpened.style.display = "block") : null;
        // elClosed ? (elClosed.style.display = "block") : null;
        if (_this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES) {
          filters.push({
            key: "DRAYAGE_COUNTRY",
            values: countrySelected
          });
          filters.push({ key: "DRAYAGE_MOT", values: motSelected && motSelected.length ? motSelected : ['MOT_OCEAN'] });
        }
        if (_this.props.searchedOpportunityValue && _this.props.selectedOpportunityFilter.value !== 'Select') filters.push({
          key: _this.props.selectedOpportunityFilter.value,
          values: [_this.props.searchedOpportunityValue]
        });
        _this.props.getOpportunityList(tab, filters, _this.state.isKH360AssociatedUser);
      }

      _this.setState({ selectBids: [] });
    };

    _this.renewOpportunityFunc = function (opportunityId) {
      var renew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // debugger
      _this.selectTab("SALES_NEW");
      _this.props.setRenewdata(opportunityId, false, renew);
    };

    _this.newDrayageLaneRequestHandler = function () {

      _this.setState({ newDrayageRequestModal: !_this.state.newDrayageRequestModal });
    };

    _this.handleActiveLanes = function (e) {
      _this.setState({ activeLanesOnly: !_this.state.activeLanesOnly });
    };

    _this.countOpportinitiesByOppGroup = function (group) {
      var total = 0;
      Array.from(group.keys()).map(function (customerId, index) {
        var oppsList = group.get(customerId).opportunityList;
        total = total + oppsList.length;
      });
      return total;
    };

    _this.toggleSelection = function (e, _ref) {
      var value = _ref.value,
          label = _ref.label,
          checked = _ref.checked;
      var _this$props2 = _this.props,
          handleCountryChange = _this$props2.handleCountryChange,
          countrySelected = _this$props2.countrySelected;

      var country = [];
      // If the checkbox is unchecked and there's only one option selected, prevent unchecking it
      if (countrySelected && countrySelected.length === 1 && countrySelected.includes(value)) {
        return;
      }

      // If the checkbox is checked, uncheck all other checkboxes and check this one
      _this.setState({ selectedOptionLabel: [label] }, function () {
        country = [value];
        handleCountryChange(country);
      });
    };

    _this.toggleMotSelection = function (e, _ref2) {
      var value = _ref2.value,
          label = _ref2.label;
      var _this$props3 = _this.props,
          handleMotChange = _this$props3.handleMotChange,
          motSelected = _this$props3.motSelected;

      if (motSelected.length === 1 && motSelected.includes(value)) return;
      _this.setState({ selectedMotLabel: [label] }, function () {
        return handleMotChange([value]);
      });
    };

    _this.setSelectedCountryLabel = function (country) {
      var countryValue = country && country.join(",");
      switch (countryValue) {
        case "US":
          return "USA";
        case "CA":
          return "Canada";
        default:
          return "USA";
      }
    };

    _this.handleOpportunityFilterSelection = function (e, data, filter) {
      e.preventDefault();
      _this.props.handleOnChangeOpportunityFilterSlection(filter, _this.state.selectedTab);
      // if(this.props.searchedOpportunityValue) this.getFilteredOpportunities(this.state.selectedTab) 
    };

    _this.handleOpportunityFilterSearch = function (e, type) {
      if (type === 'clear') {
        _this.props.handleOnChangeOpportunityFilterSearch('', _this.state.selectedTab);
      } else {
        e.preventDefault();
        _this.props.handleOnChangeOpportunityFilterSearch(e.target.value, _this.state.selectedTab);
      }
      // if(this.props.selectedOpportunityFilter.key !== 'Select') this.getFilteredOpportunities(this.state.selectedTab)
    };

    _this.debounce = function (func, delay) {
      var timer = void 0;
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        clearTimeout(timer);
        timer = setTimeout(function () {
          func.apply(null, args);
        }, delay);
      };
    };

    _this.getFilteredOpportunities = _this.debounce(function (value) {
      return _this.selectTab(value);
    }, 1000);

    _this.fetchTabDetails = function (tab) {
      _this.props.getAllTabCountMarket(_this.props.countrySelected, _this.props.motSelected);
      _this.selectTab(tab);
    };

    _this.renderDropdownText = function () {
      return React__default.createElement(
        "div",
        { style: styles.dropdownText },
        React__default.createElement(
          "div",
          { style: styles.label },
          "MOT"
        ),
        React__default.createElement(
          "div",
          { style: styles.selectedOption },
          _this.state.selectedMotLabel
        )
      );
    };

    window.BASE_URL = _this.props.base_url;
    _this.state = {
      selectedTab: _this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? "SALES_NEW" : SELECTED_TABS.PARTNER_NEW,
      customerData: new Map(),
      opportunityData: new Map(),
      selectBids: [],
      isOpen: false,
      showContainOpps: false,
      showLaneOpps: false,

      // For customer app, this keeps track of lanes accepted by customer
      // Key : opportunityId
      // Value : Map
      //         key :  portId
      //         Value : Map()
      //                key : landId
      //                Value : True/False
      customerAcceptedLanes: new Map(),
      userGuid: null,
      partnerId: null,
      activeLanesOnly: true,
      newDrayageRequestModal: false,
      isNewOpen: true,
      selectedOptionLabel: _this.setSelectedCountryLabel(_this.props.countrySelected),
      selectedMotLabel: _this.getSelectedMotLabel(_this.props.motSelected)
    };
    return _this;
  }
  //Handling select/de-select lane price by customer


  createClass(MarketplacePortalCommon, [{
    key: "getSelectedMotLabel",
    value: function getSelectedMotLabel(mot) {
      if (!Array.isArray(mot) || !Array.isArray(salesMultiMOTRadio)) return "";
      var motString = mot.join(",");
      var selected = salesMultiMOTRadio.find(function (item) {
        return item.value === motString;
      });
      return selected ? selected.label : "";
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // this.getTabData(this.state.selectedTab);

      // if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
      //   this.props.getStandardPartnerAdditionalCharges(this.props.partnerId);
      // }

      if (this.props.drayageApp !== DRAYAGE_APP.KLEARDRAY_CUSTOMER) {
        getKxUser().then(function (res) {
          var partnerId = lodash_1(res, "data.eventMessage.userInfo.partnerId", null);
          _this2.props.setPartnerIdInStore(partnerId);

          _this2.setState({
            userGuid: lodash_1(res, "data.eventMessage.userBasicInfo.userGuid", null),
            partnerId: partnerId
          });
        }).catch(function (err) {
          console.log("MarketPlacePortal :: CC componentWillMount getKxUser", err);
        });
      }

      if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER) {
        this.props.getOpportunityList(SELECTED_TABS.PARTNER_NEW);
      } else if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER) {
        getKxUser().then(function (res) {
          _this2.setState({
            userGuid: lodash_1(res, "data.eventMessage.userBasicInfo.userGuid", null),
            isKH360AssociatedUser: lodash_1(res, "data.eventMessage.IsKH360AssociatedUser", false)
          });
          _this2.props.getOpportunityList(SELECTED_TABS.CUSTOMER_NEW, [], _this2.state.isKH360AssociatedUser);
        }).catch(function (err) {
          console.log("MarketPlacePortal :: CC componentWillMount getKxUser", err);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER && prevState.userGuid !== this.state.userGuid) {
        if (this.props.getStandardPartnerAdditionalCharges) {
          this.props.getStandardPartnerAdditionalCharges(this.state.userGuid, this.state.partnerId);
        }
      }

      if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER && prevProps.tab !== this.props.tab) {
        this.setState({ selectedTab: this.props.tab });
      }

      if (!_.isEqual(this.props.countrySelected, prevProps.countrySelected) || !_.isEqual(this.props.motSelected, prevProps.motSelected)) {
        this.selectTab(this.state.selectedTab);
      }

      if (lodash_1(this.props.tabToChangeWithSearch, 'timestamp', false) && this.props.tabToChangeWithSearch.timestamp !== prevProps.tabToChangeWithSearch.timestamp) {
        this.getFilteredOpportunities(lodash_1(this.props.tabToChangeWithSearch, 'tabName', this.state.selectedTab));
      }
    }
  }, {
    key: "render",


    //array of objects
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          header = _state.header,
          data = _state.data,
          partyName = _state.partyName,
          expiryDate = _state.expiryDate,
          customerData = _state.customerData,
          selectedTab = _state.selectedTab;
      var _props = this.props,
          motSelected = _props.motSelected,
          countrySelected = _props.countrySelected,
          handleCountryChange = _props.handleCountryChange;

      //console.log("MarketplacePortalCommon",this.props.userModalData.userInitialData.userInfo.customerCode)
      // console.log("MarketplacePortalCommon",this.props.userModalData.userInitialData.userInfo)


      //let kxEmail= 

      var customerIdList = Array.from(this.state.customerData.keys());

      var containerOpportunities = this.props.containerOpportunities;
      var laneOpportunities = this.props.laneOpportunities;
      var opportunityData = this.props.opportunityData;

      var typeOfUser = lodash_1(this.props.userModalData, "typeOfUser", "");

      // if (this.props.tab === SELECTED_TABS.SUBMITTED) {
      //   // customerOpportunities = this.props.customerOpportunitiesSubmitted
      //   // opportunityData = this.props.opportunityDataSubmitted
      // } else if (this.props.tab === SELECTED_TABS.ACTIVE) {
      //   customerOpportunities = this.props.customerOpportunitiesActive;
      //   opportunityData = this.props.opportunityDataActive;
      // } else if (this.props.tab === SELECTED_TABS.REJECTED) {
      //   customerOpportunities = this.props.customerOpportunitiesRejected;
      //   opportunityData = this.props.opportunityDataRejected;
      // } /*else if (this.props.tab === SELECTED_TABS.SALES_PUBLISHED || this.props.tab === SELECTED_TABS.SALES_PENDING_APPROVAL) {
      //   // return state.customerOpportunityList;
      //   customerOpportunities = this.props.customerOpportunityList;
      //   // opportunityData = this.props.opportunityDataRejected;
      // }*/

      var opportunityCount = this.props.opportunityCount;

      var width = getWidth(this.props.drayageApp, this.props.tab);
      var widthPartnerTopHeader = getWidthPartnerTopHeader(this.props.drayageApp, this.props.tab);
      var widthMarketPlaceWrapper = getWidthMarketPlaceWrapper(this.props.drayageApp, this.props.tab);
      if (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES) ;

      return React__default.createElement(
        "div",
        { className: "page-wrapper" },
        React__default.createElement(
          "div",
          {
            className: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? 'leftSidePartnerCustomer' : 'marketPlaceSalesAndPartner',
            "data-tab-container": this.props.tab,
            style: { width: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? width["leftSideWidth"] : '100%' }
          },
          React__default.createElement(
            "section",
            {
              style: this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER ? {
                marginTop: 60,
                width: '100%',
                height: "auto"
              } : this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER ? { marginTop: "-55px", width: widthPartnerTopHeader["width"] } : this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? { height: "auto" } : { width: "auto", marginTop: "2px" },
              className: "partner-top-header"

            },
            this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES || this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER ? React__default.createElement(
              "div",
              { className: "marketplaceTabHeaderContainer" },
              React__default.createElement(
                "div",
                { className: "title-header" },
                "Marketplace"
              ),
              React__default.createElement(
                "div",
                { className: "filtersContainer" },
                React__default.createElement(
                  "div",
                  { className: "oppSearchContainer" },
                  React__default.createElement(
                    "div",
                    { className: "oppFilterOptionWrapper" },
                    React__default.createElement(
                      "div",
                      { className: "oppFilterInput" },
                      React__default.createElement(Icon, {
                        name: "search",
                        color: "#7A7A7A",
                        size: "small",
                        style: { fontSize: 16 }
                      }),
                      React__default.createElement("input", { placeholder: "Search", value: this.props.searchedOpportunityValue, onChange: this.handleOpportunityFilterSearch }),
                      this.props.searchedOpportunityValue && React__default.createElement(Icon, {
                        name: "close",
                        color: "#7A7A7A",
                        size: "small",
                        style: { fontSize: 16, cursor: "pointer" },
                        onClick: function onClick(e) {
                          return _this3.handleOpportunityFilterSearch(e, 'clear');
                        }
                      })
                    ),
                    React__default.createElement(
                      Dropdown,
                      {
                        className: "oppFilterDropDown",
                        placeholder: "--Select--",
                        value: this.props.selectedOpportunityFilter.text,
                        text: this.props.selectedOpportunityFilter.text
                      },
                      React__default.createElement(
                        Dropdown.Menu,
                        null,
                        (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? salesOpportunityFilters : partnerOpportunityFilters).map(function (filter, key) {
                          return React__default.createElement(
                            Dropdown.Item,
                            {
                              key: filter.key,
                              onClick: function onClick(e, d) {
                                return _this3.handleOpportunityFilterSelection(e, d, filter);
                              }
                            },
                            React__default.createElement(
                              "div",
                              { className: "dropDownItem" },
                              React__default.createElement(
                                "span",
                                { className: "dropDownItemTitle", style: {
                                    color: filter.key === _this3.props.selectedOpportunityFilter.key ? '#005C7B' : '#333333'
                                  } },
                                filter.text
                              ),
                              filter.key === _this3.props.selectedOpportunityFilter.key && React__default.createElement(Icon, {
                                name: "check",
                                color: "teal",
                                size: "small"
                              })
                            )
                          );
                        })
                      )
                    )
                  ),
                  selectedTab === salesPortalTabs.SALES_NEW && this.props.noResultsFound ? React__default.createElement(NoResultsScreen, { tab: salesPortalTabs.SALES_NEW }) : null
                ),
                this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && React__default.createElement(
                  Dropdown,
                  {
                    id: "market-place-dropdown",
                    className: "marketplace-country-dropdown",
                    simple: true,
                    item: true,
                    text: React__default.createElement(
                      "div",
                      {
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          width: "100%",
                          fontSize: "12px",
                          lineHeight: "16px",
                          color: "#1F1F1F"
                        }
                      },
                      React__default.createElement(
                        "div",
                        { style: { fontWeight: "400px", color: "#7A7A7A" } },
                        "Country (Pickup)"
                      ),
                      React__default.createElement(
                        "div",
                        {
                          style: {
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            // width: "200px",
                            fontWeight: "500"
                          }
                        },
                        this.state.selectedOptionLabel
                      )
                    )
                  },
                  React__default.createElement(
                    Dropdown.Menu,
                    { style: { width: "100%" } },
                    salesMultiCountryRadio.map(function (option) {
                      return React__default.createElement(
                        Dropdown.Item,
                        { key: option.key },
                        React__default.createElement(Checkbox, {
                          className: "dropdown-checkbox",
                          label: option.label,
                          value: option.value,
                          onChange: _this3.toggleSelection,
                          checked: countrySelected.includes(option.value)
                        })
                      );
                    })
                  )
                ),
                this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && React__default.createElement(
                  Dropdown,
                  { id: "market-place-dropdown", className: "marketplace-country-dropdown", simple: true, item: true,
                    text: this.renderDropdownText() },
                  React__default.createElement(
                    Dropdown.Menu,
                    { style: { width: "100%" } },
                    salesMultiMOTRadio.map(function (_ref3) {
                      var key = _ref3.key,
                          label = _ref3.label,
                          value = _ref3.value;
                      return React__default.createElement(
                        Dropdown.Item,
                        { key: key },
                        React__default.createElement(Checkbox, {
                          className: "dropdown-checkbox",
                          label: label,
                          value: value,
                          onChange: _this3.toggleMotSelection,
                          checked: motSelected.includes(value)
                        })
                      );
                    })
                  )
                )
              )
            ) : null,
            this.props.portalTabs.map(function (tab) {
              var refinedTab = _this3.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES ? tab.replace("SALES_", "DRAYAGE_") : tab;
              var count = _this3.props.opportunityCount ? _this3.props.opportunityCount[refinedTab] : "";

              var commonStyle = { marginLeft: "38px", width: "70px" };
              var conditionalStyle = _this3.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES || _this3.props.drayageApp === DRAYAGE_APP.KLEARDRAY_PARTNER ? { marginTop: 0 } : {};
              var combinedStyle = _extends({}, commonStyle, conditionalStyle);

              return React__default.createElement(
                "button",
                {
                  style: combinedStyle,
                  className: selectedTab === tab ? "tab-btn selected " : "tab-btn ",
                  onClick: function onClick(e) {
                    _this3.selectTab(tab);
                  }
                },
                tabDisplayName[tab] + (count ? " [" + count + "]" : "")
              );
            })
          ),
          this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && React__default.createElement(
            "button",
            { className: "new-req", onClick: this.newDrayageLaneRequestHandler },
            "NEW  REQUEST"
          ),
          this.state.newDrayageRequestModal && React__default.createElement(NewDrayageRequestModal, _extends({ selectTab: this.selectTab, newDrayageLaneRequestHandler: this.newDrayageLaneRequestHandler, cancelHandlerCustomerLaneRequest: this.cancelHandlerCustomerLaneRequest, isOpen: this.state.newDrayageRequestModal, selectedOptionLabel: this.state.selectedOptionLabel, selectedMotLabel: this.state.selectedMotLabel, toggleSelection: this.toggleSelection, toggleMotSelection: this.toggleMotSelection, renderDropdownText: this.renderDropdownText }, this.props)),
          React__default.createElement(
            "div",
            {
              // style={{ width: widthMarketPlaceWrapper["width"] }}
              className: "marketplace-wrapper"
            },
            this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && this.props.tab === SELECTED_TABS.CUSTOMER_NEW && React__default.createElement(
              "div",
              { className: "general-row" },
              React__default.createElement(
                "div",
                { className: "drayage-text-customer" },
                " ",
                "Select one or more bid to approve. Unselected bids will be rejected automatically.",
                " "
              )
            ),
            selectedTab === "SALES_NEW" && React__default.createElement(
              "div",
              { "data-tab-container": "SALES_NEW" },
              React__default.createElement(
                "div",
                { className: "tab_wrapper" },
                this.props.createOppurtunity({ selectTab: this.selectTab })
              )
            ),
            this.props.loadingData === true && selectedTab !== "SALES_NEW" && React__default.createElement(Loader, {
              active: true,
              inline: "centered",
              style: { position: "relative", top: "50vh" }
            }),
            (this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES || DRAYAGE_APP.KLEARDRAY_PARTNER) && selectedTab !== salesPortalTabs.SALES_NEW && this.props.noResultsFound ? React__default.createElement(NoResultsScreen, null) : selectedTab !== "SALES_NEW" && React__default.createElement(
              React__default.Fragment,
              null,
              React__default.createElement(
                "div",
                { className: this.state.showContainOpps ? "OpoortunityGroup OpoortunityGroupOpen" : "OpoortunityGroup OpoortunityGroupClose" },
                React__default.createElement(
                  "h1",
                  { className: "OpoortunityGroupTitle" },
                  React__default.createElement(Icon, { size: "small", name: this.state.showContainOpps ? "chevron circle down" : "chevron circle right", onClick: function onClick() {
                      return _this3.setState({ showContainOpps: !_this3.state.showContainOpps });
                    } }),
                  "Container Opportunities ",
                  React__default.createElement(
                    "span",
                    null,
                    this.props.loadingData === false && containerOpportunities && "(" + this.countOpportinitiesByOppGroup(containerOpportunities) + ")"
                  )
                ),
                this.state.showContainOpps ? this.props.loadingData === false && containerOpportunities && Array.from(containerOpportunities.keys()).length === 0 && selectedTab !== "SALES_NEW" ? null : selectedTab !== "SALES_NEW" && containerOpportunities && Array.from(containerOpportunities.keys()).map(function (customerId, index) {
                  return React__default.createElement(
                    "div",
                    { className: "customerOpportunitiesGroup",
                      style: { width: _this3.props.drayageApp !== DRAYAGE_APP.KLEARDRAY_CUSTOMER ? '100%' : 'auto' } },
                    _this3.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && React__default.createElement(
                      "h2",
                      { className: "CustomerName" },
                      containerOpportunities.get(customerId).customer
                    ),
                    React__default.createElement(CustomerOpportunitesCommon, {
                      activeLanesOnly: _this3.state.activeLanesOnly,
                      handleActiveLanes: _this3.handleActiveLanes,
                      customerNumber: index,
                      isOpen: _this3.state.isOpen,
                      opp_key: "containerOpportunities",
                      openedOpportunities: _this3.props.openedOpportunities,
                      customerOpportunity: containerOpportunities.get(customerId),
                      customerId: customerId,
                      opportunityData: _this3.props.opportunityData,
                      columnData: _this3.props.opportunityColumnData,
                      handleOpenBidModal: _this3.props.handleOpenBidModal,
                      handleOpportunityBidClicked: _this3.props.handleOpportunityBidClicked,
                      selectedTab: _this3.state.selectedTab,
                      getOpportunityDetailsApi: _this3.props.getOpportunityDetailsApi,
                      opportunityId: _this3.props.opportunuityId,
                      opportunityDetails: _this3.props.opportunityDetails,
                      opportunityPortsData: _this3.props.opportunityPortsData,
                      setAdditionalChargesInStore: _this3.props.setAdditionalChargesInStore,
                      standardPartnerAdditionalCharges: _this3.props.standardPartnerAdditionalCharges,
                      setLaneBidChargesInStore: _this3.props.setLaneBidChargesInStore,
                      handleSetChargeForEdit: _this3.props.handleSetChargeForEdit,
                      tab: _this3.props.tab,
                      submitOpportunityBidData: _this3.props.submitOpportunityBidData,
                      drayageApp: _this3.props.drayageApp,
                      handleOpporunityOpenArrow: _this3.props.handleOpporunityOpenArrow,
                      setLanePriceSelected: _this3.props.setLanePriceSelected,
                      customerBidmodalHandler: _this3.props.customerBidmodalHandler,
                      setCustomerLanePriceSelected: _this3.props.setCustomerLanePriceSelected
                      // handleActiveLanes={this.handleActiveLanes} 
                      , selectBid: _this3.selectBid,
                      unSelectBid: _this3.unSelectBid,
                      cancelBid: _this3.cancelBid,
                      onOpportunitySelect: _this3.onOpportunitySelect,
                      isDoneDisabled: _this3.isDoneDisabled,
                      renewOpportunityFunc: _this3.renewOpportunityFunc,
                      isLane: false,
                      userType: typeOfUser,
                      setSalesOpportunityUpdatedData: _this3.props.setSalesOpportunityUpdatedData,
                      oppUpdationData: _this3.props.oppUpdationData,
                      handleBidUpdationOpenClose: _this3.props.handleBidUpdationOpenClose,
                      fetchTabDetails: _this3.fetchTabDetails // method to refresh a tab
                    })
                  );
                }) : null
              ),
              React__default.createElement(
                "div",
                { className: this.state.showLaneOpps ? "OpoortunityGroup OpoortunityGroupOpen" : "OpoortunityGroup OpoortunityGroupClose" },
                React__default.createElement(
                  "h1",
                  { className: "OpoortunityGroupTitle" },
                  React__default.createElement(Icon, { size: "small", name: this.state.showLaneOpps ? "chevron circle down" : "chevron circle right", onClick: function onClick() {
                      return _this3.setState({ showLaneOpps: !_this3.state.showLaneOpps });
                    } }),
                  "Lane Opportunities ",
                  React__default.createElement(
                    "span",
                    null,
                    this.props.loadingData === false && laneOpportunities && "(" + this.countOpportinitiesByOppGroup(laneOpportunities) + ")"
                  )
                ),
                this.state.showLaneOpps ? this.props.loadingData === false && laneOpportunities && Array.from(laneOpportunities.keys()).length === 0 && selectedTab !== "SALES_NEW" ? null : selectedTab !== "SALES_NEW" && laneOpportunities && Array.from(laneOpportunities.keys()).map(function (customerId, index) {
                  return React__default.createElement(
                    "div",
                    { className: "customerOpportunitiesGroup",
                      style: { width: _this3.props.drayageApp !== DRAYAGE_APP.KLEARDRAY_CUSTOMER ? '100%' : 'auto' }
                    },
                    _this3.props.drayageApp === DRAYAGE_APP.KLEARDRAY_SALES && React__default.createElement(
                      "h2",
                      { className: "CustomerName" },
                      laneOpportunities.get(customerId).customer
                    ),
                    React__default.createElement(CustomerOpportunitesCommon, {
                      activeLanesOnly: _this3.state.activeLanesOnly,
                      handleActiveLanes: _this3.handleActiveLanes,
                      customerNumber: index,
                      opp_key: "laneOpportunities",
                      isOpen: _this3.state.isOpen,
                      openedOpportunities: _this3.props.openedOpportunities,
                      customerOpportunity: laneOpportunities.get(customerId),
                      opportunityData: _this3.props.opportunityData,
                      columnData: _this3.props.opportunityColumnData,
                      handleOpenBidModal: _this3.props.handleOpenBidModal,
                      handleOpportunityBidClicked: _this3.props.handleOpportunityBidClicked,
                      selectedTab: _this3.state.selectedTab,
                      getOpportunityDetailsApi: _this3.props.getOpportunityDetailsApi,
                      opportunityId: _this3.props.opportunuityId,
                      opportunityDetails: _this3.props.opportunityDetails,
                      opportunityPortsData: _this3.props.opportunityPortsData,
                      setAdditionalChargesInStore: _this3.props.setAdditionalChargesInStore,
                      standardPartnerAdditionalCharges: _this3.props.standardPartnerAdditionalCharges,
                      setLaneBidChargesInStore: _this3.props.setLaneBidChargesInStore,
                      tab: _this3.props.tab,
                      submitOpportunityBidData: _this3.props.submitOpportunityBidData,
                      drayageApp: _this3.props.drayageApp,
                      handleOpporunityOpenArrow: _this3.props.handleOpporunityOpenArrow,
                      selectBid: _this3.selectBid,
                      unSelectBid: _this3.unSelectBid,
                      cancelBid: _this3.cancelBid,
                      setLanePriceSelected: _this3.props.setLanePriceSelected,
                      customerBidmodalHandler: _this3.props.customerBidmodalHandler,
                      customerId: customerId,
                      onOpportunitySelect: _this3.onOpportunitySelect,
                      setCustomerLanePriceSelected: _this3.props.setCustomerLanePriceSelected,
                      isDoneDisabled: _this3.isDoneDisabled,
                      renewOpportunityFunc: _this3.renewOpportunityFunc,
                      isLane: true,
                      handleSetChargeForEdit: _this3.props.handleSetChargeForEdit,
                      setSalesOpportunityUpdatedData: _this3.props.setSalesOpportunityUpdatedData,
                      isBiddingFromOppUpdation: _this3.props.isBiddingFromOppUpdation,
                      oppUpdationData: _this3.props.oppUpdationData,
                      handleBidUpdationOpenClose: _this3.props.handleBidUpdationOpenClose,
                      fetchTabDetails: _this3.fetchTabDetails // method to refresh a tab
                    })
                  );
                }) : null
              )
            )
          )
        ),
        " ",
        this.props.drayageApp === DRAYAGE_APP.KLEARDRAY_CUSTOMER && React__default.createElement(
          "div",
          { className: "rightSide", style: { width: width["rightSideWidth"], height: 'calc(100vh - 55px)' } },
          React__default.createElement(MarketPlaceMapCommon, null)
        )
      );
    }
  }]);
  return MarketplacePortalCommon;
}(React__default.Component);

var MarketPlaceCommonOppType = function (_React$Component2) {
  inherits(MarketPlaceCommonOppType, _React$Component2);

  function MarketPlaceCommonOppType(props) {
    classCallCheck(this, MarketPlaceCommonOppType);
    return possibleConstructorReturn(this, (MarketPlaceCommonOppType.__proto__ || Object.getPrototypeOf(MarketPlaceCommonOppType)).call(this, props));
  }

  createClass(MarketPlaceCommonOppType, [{
    key: "render",
    value: function render() {
      var _this5 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "h1",
          { className: "marketplace-wrapper-opportunity-type" },
          toTitleCase(this.props.opp_type_list.length > 1 ? this.props.oppType.name : this.props.oppType.singleName)
        ),
        this.props.opp_type_list.map(function (customerOpportunity, index) {
          return React__default.createElement(CustomerOpportunitesCommon, {
            opportunityGroup: _this5.props.oppType,
            activeLanesOnly: _this5.props.activeLanesOnly,
            handleActiveLanes: _this5.props.handleActiveLanes,
            customerNumber: index,
            isOpen: _this5.props.isOpen,
            openedOpportunities: _this5.props.openedOpportunities,
            customerOpportunity: customerOpportunity,
            opportunityData: _this5.props.opportunityData,
            columnData: _this5.props.opportunityColumnData,
            handleOpenBidModal: _this5.props.handleOpenBidModal,
            handleOpportunityBidClicked: _this5.props.handleOpportunityBidClicked,
            selectedTab: _this5.props.selectedTab,
            getOpportunityDetailsApi: _this5.props.getOpportunityDetailsApi,
            opportunityId: _this5.props.opportunuityId,
            opportunityDetails: _this5.props.opportunityDetails,
            opportunityPortsData: _this5.props.opportunityPortsData,
            setAdditionalChargesInStore: _this5.props.setAdditionalChargesInStore,
            standardPartnerAdditionalCharges: _this5.props.standardPartnerAdditionalCharges,
            setLaneBidChargesInStore: _this5.props.setLaneBidChargesInStore,
            tab: _this5.props.tab,
            submitOpportunityBidData: _this5.props.submitOpportunityBidData,
            drayageApp: _this5.props.drayageApp,
            handleOpporunityOpenArrow: _this5.props.handleOpporunityOpenArrow,
            selectBid: _this5.props.selectBid,
            unSelectBid: _this5.props.unSelectBid,
            cancelBid: _this5.props.cancelBid,
            setLanePriceSelected: _this5.props.setLanePriceSelected,
            customerBidmodalHandler: _this5.props.customerBidmodalHandler,
            customerId: customerOpportunity.customerId,
            onOpportunitySelect: _this5.props.onOpportunitySelect,
            setCustomerLanePriceSelected: _this5.props.setCustomerLanePriceSelected,
            isDoneDisabled: _this5.props.isDoneDisabled,
            renewOpportunityFunc: _this5.props.renewOpportunityFunc,
            handleSetChargeForEdit: _this5.props.handleSetChargeForEdit
          });
        })
      );
    }
  }]);
  return MarketPlaceCommonOppType;
}(React__default.Component);

var LaneAdditionalCharges = function (_React$Component) {
  inherits(LaneAdditionalCharges, _React$Component);

  function LaneAdditionalCharges(props) {
    classCallCheck(this, LaneAdditionalCharges);

    var _this = possibleConstructorReturn(this, (LaneAdditionalCharges.__proto__ || Object.getPrototypeOf(LaneAdditionalCharges)).call(this, props));

    _initialiseProps$2.call(_this);

    var chargesMap = new Map();
    var checkedCharges = {};

    var additionalCharges = _this.props.additionalCharges;
    if (!additionalCharges || additionalCharges.length == 0) {
      additionalCharges = _this.props.standardPartnerAdditionalCharges;
    }

    if (additionalCharges) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = additionalCharges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var charge = _step.value;

          chargesMap.set(charge.glCode, _extends({}, charge));
          checkedCharges[charge.glCode] = charge.reqQuantityUsed && charge.reqQuantityUsed > 0;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    var grandTotal = 0;

    _this.state = {
      showModal: _this.props.showBidCard,
      additionalCharges: additionalCharges,
      chargesMap: chargesMap,
      grandTotal: grandTotal,
      checkedCharges: checkedCharges
    };
    return _this;
  }

  createClass(LaneAdditionalCharges, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var updateCharges = this.props.updateCharges;

      var grandTotal = 0; //totalAdditionalCharge(this.state.additionalCharges);
      grandTotal = grandTotal;

      console.log("charges :", this.state.additionalCharges, this.state.chargesMap); //array of obj

      var additionalCharges = this.props.additionalCharges;
      console.log("additionalCharges", this.state.additionalCharges);
      if (!additionalCharges || additionalCharges.length === 0) {
        additionalCharges = this.props.standardPartnerAdditionalCharges;
      }

      console.log("LaneAdditionalCharges :: ", this.props, this.state);

      var allChecked = true;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.values(this.state.checkedCharges)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var checked = _step2.value;

          if (!checked) {
            allChecked = false;
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return React__default.createElement(
        "div",
        { className: "laneBidChargesContainer" },
        React__default.createElement(
          "div",
          { className: "bidcard-wrapper" },
          React__default.createElement(
            "div",
            { className: "bidcard-header" },
            React__default.createElement(
              "div",
              { style: { marginLeft: "10px", marginTop: "30px" } },
              React__default.createElement("img", {
                style: { marginLeft: "1px" },
                className: "anchor-img",
                src: "images/files/anchor.svg"
              })
            ),
            React__default.createElement(
              "div",
              null,
              this.props.fromLaneBidCard && React__default.createElement(
                "div",
                {
                  style: { marginTop: "10px", paddingLeft: "10px" },
                  className: "small-text  "
                },
                "FROM"
              ),
              React__default.createElement(
                "div",
                {
                  style: this.props.fromLaneBidCard ? { paddingLeft: "10px" } : { marginRight: "570px", marginTop: "27px" },
                  className: "party-name-bid "
                },
                this.props.sourceName && splitForTooltip$1(this.props.sourceName.toUpperCase())
              )
            ),
            this.props.fromLaneBidCard && React__default.createElement(
              "div",
              { className: "general-row" },
              React__default.createElement("div", { className: "line-drayage" }),
              React__default.createElement(
                "div",
                null,
                React__default.createElement("img", {
                  style: { marginTop: "38px", width: "20px " },
                  className: "warehouse-img",
                  src: "images/files/warehouse.svg"
                })
              )
            ),
            this.props.fromLaneBidCard && React__default.createElement(
              "div",
              { className: "general-col" },
              React__default.createElement(
                "div",
                { style: { marginTop: "10px" }, className: "small-text  " },
                "TO"
              ),
              React__default.createElement(
                "div",
                { style: { marginTop: "2.5px" }, className: "party-name-bid" },
                splitForTooltip$1(this.props.selectedAddress)
              )
            )
          ),
          React__default.createElement(
            "div",
            { className: " add-head-text" },
            " ",
            this.props.fromLaneBidCard && "Potential Additional Charges",
            !this.props.fromLaneBidCard && React__default.createElement(
              "div",
              null,
              " POTENTIAL ADDITIONAL CHARGES "
            )
          ),
          React__default.createElement("div", { className: "line-add" }),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "div",
              { className: "add-header" },
              React__default.createElement(
                "div",
                { className: "title-one" },
                React__default.createElement(
                  "label",
                  { className: "container-drayage" },
                  React__default.createElement("input", {
                    className: "checker",
                    type: "checkbox",
                    id: "selectAllBoxes",
                    name: "selectAll",
                    value: "SelectAll",
                    onChange: function onChange(e) {
                      _this2.allCheckboxChangehandler(e);
                    },
                    checked: allChecked
                  }),
                  React__default.createElement(
                    "span",
                    { className: "checkmark-drayage" },
                    " "
                  )
                ),
                React__default.createElement(
                  "label",
                  { className: "select", "for": "select" },
                  "SELECT"
                )
              ),
              React__default.createElement(
                "div",
                { className: "title-two" },
                "PRICE PER UNIT"
              ),
              React__default.createElement(
                "div",
                { className: "title-three" },
                "REQ. PER UNIT"
              ),
              React__default.createElement(
                "div",
                { style: { fontSize: "14px" }, className: "title-four" },
                "TOTAL"
              )
            ),
            React__default.createElement("div", { style: { marginTop: "-10px" }, className: "line-add" }),
            additionalCharges && additionalCharges.map(function (charge) {
              var chargeName = charge.chargeName;
              console.log("chargeName :", chargeName);

              var unitPrice = "$" + charge.unitPrice;
              console.log("unitPrice :", unitPrice);
            }),
            additionalCharges && additionalCharges.map(function (charge) {
              var chargeName = charge.chargeName;
              console.log("charge details :: ", charge.chargeName, charge);
              var unitPrice = "$" + charge.unitPrice;
              var total = 0;
              var currentChargeForGlCode = _this2.state.chargesMap.get(charge.glCode);
              if (currentChargeForGlCode && currentChargeForGlCode.reqQuantityUsed) {
                total = parseInt(currentChargeForGlCode.unitPrice) * parseInt(currentChargeForGlCode.reqQuantityUsed);
                grandTotal += parseInt(total);
              }
              console.log("charge details ::", charge.unitPrice, total, currentChargeForGlCode);
              return React__default.createElement(
                "div",
                null,
                React__default.createElement(
                  "div",
                  { className: "add-header-wrapper" },
                  React__default.createElement(
                    "div",
                    { className: "add-header-row" },
                    React__default.createElement(
                      "div",
                      { className: "first-box" },
                      React__default.createElement(
                        "label",
                        { className: "container-drayage" },
                        React__default.createElement("input", {
                          style: { border: "1px solid teal" }
                          // className="checker"
                          , type: "checkbox",
                          id: "box",
                          onChange: function onChange(e) {
                            _this2.checkboxChangehandler(e, charge.glCode);
                          },
                          checked: _this2.state.checkedCharges[charge.glCode]
                        }),
                        React__default.createElement(
                          "span",
                          { className: "checkmark-drayage" },
                          " "
                        )
                      ),
                      React__default.createElement(
                        "label",
                        { className: "charges-text", "for": "chasis" },
                        React__default.createElement(
                          "div",
                          null,
                          chargeName
                        )
                      )
                    ),
                    React__default.createElement(
                      "div",
                      { className: "general-row second" },
                      React__default.createElement("input", {
                        className: "input-box-small",
                        type: "number",
                        id: charge.glCode,
                        value: currentChargeForGlCode.unitPrice,
                        name: "unitPrice",
                        onChange: _this2.unitPriceChangeHandler
                      }),
                      React__default.createElement(
                        "div",
                        {
                          style: { marginLeft: "10px" },
                          className: "per-day-box"
                        },
                        charge.unitMeasurement
                      )
                    ),
                    React__default.createElement(
                      "div",
                      null,
                      React__default.createElement("input", {
                        stle: !_this2.state.checkedCharges[charge.glCode] ? { border: "none" } : { border: "1px  solid #008B8F" },
                        className: "  input-box-small third ",
                        id: charge.glCode,
                        type: "number",
                        value: parseInt(currentChargeForGlCode.reqQuantityUsed),
                        onChange: _this2.onChange,
                        min: "1",
                        step: "1",
                        disabled: !_this2.state.checkedCharges[charge.glCode]
                      })
                    ),
                    React__default.createElement(
                      "div",
                      { className: "per-day-box fourth" },
                      total
                    )
                  )
                ),
                React__default.createElement("div", { className: "line-add" })
              );
            })
          ),
          React__default.createElement("div", {
            style: { border: "none", marginTop: "-10px" },
            className: "line-two"
          }),
          React__default.createElement(
            "section",
            { className: "best-cont" },
            React__default.createElement(
              "div",
              { className: "best-box-add" },
              "TOTAL ADDITIONAL CHARGES"
            ),
            React__default.createElement(
              "div",
              { className: "cont-bid-box" },
              React__default.createElement(
                "div",
                { className: "total-per-bid" },
                this.props.currencyType,
                " ",
                grandTotal
              ),
              React__default.createElement(
                "div",
                {
                  style: { fontSize: "8px", fonttWeight: "bold" },
                  className: "per-cont"
                },
                "PER CONT.",
                " "
              )
            )
          )
        ),
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            "button",
            {
              style: { marginTop: "10px" },
              className: "partners-btn-done",
              onClick: function onClick(e) {
                // this.props.bidAdditionalChargeHandler();
                _this2.props.additionalChargeDoneHandler(_this2.props.fromLaneBidCard);
                _this2.props.setAdditionalChargesInStore(_this2.props.fromLaneBidCard ? "LANE_ADDITIONAL_CHARGE" : "PORT_ADDITIONAL_CHARGE", _this2.props.opportunityId, _this2.props.source, _this2.props.laneId, _this2.state.chargesMap); //(source, opportunuityId, portId, destinationId, charges)
                updateCharges({
                  charges: _this2.state.chargesMap,
                  source: _this2.props.fromLaneBidCard ? "LANE_ADDITIONAL_CHARGE" : "PORT_ADDITIONAL_CHARGE"
                });
              }
            },
            "DONE"
          ),
          React__default.createElement(
            "button",
            {
              style: { marginTop: "10px" },
              className: "cancel-btn",
              onClick: function onClick(e) {
                _this2.props.additionalChargeCancelHandler(_this2.props.fromLaneBidCard);
              }
            },
            "CANCEL"
          )
        )
      );
    }
  }]);
  return LaneAdditionalCharges;
}(React__default.Component);

var _initialiseProps$2 = function _initialiseProps() {
  var _this3 = this;

  this.handleOpenModal = function () {
    _this3.setState({ showModal: true });
  };

  this.handleCloseModal = function () {
    _this3.setState({ showModal: false });
  };

  this.onChange = function (e) {
    var chargesMap = _this3.state.chargesMap;
    var chargeForGlCode = chargesMap.get(parseInt(e.target.id));
    chargeForGlCode.reqQuantityUsed = e.target.value;
    chargeForGlCode.quantity = e.target.value;
    chargeForGlCode.amount = parseInt(e.target.value) * parseInt(chargeForGlCode.unitPrice);

    _this3.setState({
      chargesMap: chargesMap
    });
  };

  this.unitPriceChangeHandler = function (e) {
    e.preventDefault();
    var chargesMap = _this3.state.chargesMap;
    var chargeForGlCode = chargesMap.get(parseInt(e.target.id));
    chargeForGlCode.unitPrice = e.target.value;
    chargesMap.set(parseInt(e.target.id), chargeForGlCode);

    _this3.setState({ chargesMap: chargesMap });
  };

  this.checkboxChangehandler = function (e, glCode) {
    //this.setState({ this.state.checkedCharges[glCode]})
    var checkedCharges = _this3.state.checkedCharges;
    checkedCharges[glCode] = !checkedCharges[glCode];

    var chargesMap = _this3.state.chargesMap;
    var chargeForGlCode = chargesMap.get(glCode);
    if (chargeForGlCode && !checkedCharges[glCode]) {
      chargeForGlCode.reqQuantityUsed = "";
      e.target.value = "";
    }

    _this3.setState({ checkedCharges: checkedCharges, chargesMap: chargesMap });
  };

  this.updateHandler = function (e, glCode) {
    console.log("updateHandler", glCode);
    e.preventDefault();
    var chargesMap = _this3.state.chargesMap;
    var chargeForGlCode = chargesMap.get(parseInt(e.target.id));
  };

  this.allCheckboxChangehandler = function (e) {
    var checkedCharges = _this3.state.checkedCharges;
    var chargesMap = _this3.state.chargesMap;

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = Object.keys(checkedCharges)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var key = _step3.value;

        console.log("allCheckboxChangehandler :: ", key, e.target.checked, chargesMap);
        if (!e.target.checked) {
          var chargeForGlCode = chargesMap.get(parseInt(key));
          console.log("allCheckboxChangehandler :: chargeForGlCode", chargeForGlCode);
          if (chargeForGlCode) {
            console.log("allCheckboxChangehandler :: set to 0 ");
            chargeForGlCode.reqQuantityUsed = "";
            e.target.value = "";
          }
        }
        checkedCharges[key] = e.target.checked;
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    _this3.setState({ checkedCharges: checkedCharges, chargesMap: chargesMap });
  };
};

var LaneAdditionalCharges$1 = WithErrorBoundary(LaneAdditionalCharges);

var LaneBidCard = function (_Component) {
  inherits(LaneBidCard, _Component);

  function LaneBidCard(props) {
    classCallCheck(this, LaneBidCard);

    var _this = possibleConstructorReturn(this, (LaneBidCard.__proto__ || Object.getPrototypeOf(LaneBidCard)).call(this, props));

    _initialiseProps$3.call(_this);

    var laneData = lodash_1(_this.props, "selectedDestinationLaneData", null);
    var destinationBidData = lodash_1(laneData, "destinationBidData", null);

    if (!destinationBidData) {
      destinationBidData = {};
    }

    var baseFee = destinationBidData.baseFees;
    var chasisRentalperday = destinationBidData.chasisRentalperday;
    var fuelCharges = destinationBidData.fuelCharges;
    var minReqDays = destinationBidData.chasisRentalperday;
    var bidBaseTotal = destinationBidData.bidBaseTotal;
    var yesRadioButton = destinationBidData.yesRadioButton;
    var notes = destinationBidData.notes;
    var capacityPerMonth = destinationBidData.capacityPerMonth;
    var rateValidUntilDate = destinationBidData.rateValidUntilDate;

    var basefeesGlCode = "";
    var fuelChargeGlCode = "";

    console.log("LaneBidCard :  props : constructor called", _this.props, rateValidUntilDate);
    if (!rateValidUntilDate) {
      rateValidUntilDate = _this.getNextExpiryDate(1);
    }

    _this.state = {
      isAdditionalCharge: false,
      additionalchargesForLane: _this.props.additionalCharges ? _this.props.additionalCharges : new Map(),
      baseFees: baseFee,
      fuelCharges: fuelCharges && fuelCharges > 0 ? fuelCharges : "",
      chasisRentalperday: chasisRentalperday,
      minReqDays: minReqDays,
      bidBaseTotal: bidBaseTotal,
      yesRadioButton: yesRadioButton,
      basefeesGlCode: basefeesGlCode,
      fuelChargeGlCode: fuelChargeGlCode,
      notes: notes,
      capacityPerMonth: capacityPerMonth,
      opportunityStartDate: "",
      rateValidUntilDate: rateValidUntilDate,
      opportunityStartDateObj: {},
      formError: {
        fuelChargesError: ""
      }
    };
    return _this;
  }

  createClass(LaneBidCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm({});
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var laneData = lodash_1(this.props, "selectedDestinationLaneData", null);
      var _props = this.props,
          handleApCurrencyCodeChange = _props.handleApCurrencyCodeChange,
          apCurrencyCode = _props.apCurrencyCode;
      //const {rateValidUntilDate}=this.state

      console.log("LaneBidCard :  props", this.props);
      console.log("LaneBidCard :: this.state", this.state);
      var chasisTotal = this.state.chasisRentalperday * this.state.minReqDays;
      console.log(" chasisTotal", chasisTotal);
      var fuel = this.state.baseFees * (this.state.fuelCharges / 100);
      console.log("fuel ", fuel);

      var splitForTooltip = function splitForTooltip(name) {
        if (!name) return "TBD";

        var firstPart = name.substring(0, 15);

        return React__default.createElement(
          React__default.Fragment,
          null,
          firstPart,
          name.length > 15 ? React__default.createElement(Popup, {
            content: name,
            trigger: React__default.createElement(
              "b",
              null,
              React__default.createElement(
                "a",
                { style: { color: "#0A8B8F", marginTop: "-80px" } },
                "  ",
                " ..."
              )
            )
          }) : ""
        );
      };

      var totalFee = Math.round(totalBidAmountForLane(this.state));

      var basefeesGlCode = "";
      var fuelChargeGlCode = "";
      if (this.props.standardPartnerAdditionalCharges) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.props.standardPartnerAdditionalCharges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var charge = _step.value;

            if (charge.chargeName === "BASE CHARGE") {
              basefeesGlCode = charge.glCode;
            }
            if (charge.chargeName == "FUEL CHARGE") {
              fuelChargeGlCode = charge.glCode;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      console.log("basefeesGlCode :", basefeesGlCode, fuelChargeGlCode, this.state.rateValidUntilDate);

      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "UTC"
      };
      var expirationDate = new Date(parseInt(this.props.expirationDate));
      expirationDate = expirationDate.toLocaleDateString("en-US", options).toUpperCase();
      var expPickUpDate = this.props.opp_key && this.props.opp_key === "containerOpportunities" && this.props.selectedDestinationLaneData.eta && parseInt(this.props.selectedDestinationLaneData.eta);
      expPickUpDate = expPickUpDate && moment$1.utc(moment$1(expPickUpDate).utc()).toDate();
      expPickUpDate = expPickUpDate && expPickUpDate.toLocaleDateString("en-US", options).toUpperCase();
      console.log("lanebidcardfuelCharges", this.state.fuelCharges);
      var _state = this.state,
          formError = _state.formError,
          capacityPerMonth = _state.capacityPerMonth,
          baseFees = _state.baseFees;
      var drayageApp = this.props.drayageApp;

      var isPartner = isPartnerApp(drayageApp);
      var isBaseFeeValid = baseFees > 0;
      var isCapacityPerMonthValid = capacityPerMonth > 0;
      var isFuelChargesErrorFree = !formError.fuelChargesError;
      var isValid$$1 = isBaseFeeValid && isFuelChargesErrorFree;
      if (isPartner || this.props.isBiddingFromOppUpdation) {
        isValid$$1 = isValid$$1 && isCapacityPerMonthValid;
      }

      return React__default.createElement(
        "div",
        null,
        React__default.createElement(
          "div",
          { className: "laneBidChargesContainer" },
          React__default.createElement(
            "div",
            { className: "bidcard-wrapper-bid-card" },
            React__default.createElement(
              "div",
              { className: "bidcard-header" },
              React__default.createElement(
                "div",
                { style: { marginLeft: "10px", marginTop: "30px" } },
                React__default.createElement("img", {
                  style: { marginLeft: "10px", marginTop: "5px" },
                  className: "anchor-img",
                  src: "images/files/anchor.svg"
                })
              ),
              React__default.createElement(
                "div",
                null,
                React__default.createElement(
                  "div",
                  {
                    style: { marginTop: "10px", marginLeft: "10px" },
                    className: "small-text "
                  },
                  "FROM"
                ),
                React__default.createElement(
                  "div",
                  { style: { marginLeft: "10px" }, className: "party-name-bid " },
                  splitForTooltip(this.props.sourceName.toUpperCase())
                )
              ),
              React__default.createElement(
                "div",
                { className: "general-row" },
                React__default.createElement("div", { className: "line-drayage" }),
                React__default.createElement(
                  "div",
                  null,
                  React__default.createElement("img", {
                    style: { marginTop: "38px", width: "20px " },
                    className: "warehouse-img",
                    src: "images/files/warehouse.svg"
                  })
                )
              ),
              React__default.createElement(
                "div",
                { className: "general-col" },
                React__default.createElement(
                  "div",
                  { style: { marginTop: "11px" }, className: "small-text  " },
                  "TO"
                ),
                React__default.createElement(
                  "div",
                  {
                    style: { marginRight: "30px", marginTop: "3px" },
                    className: "party-name-bid "
                  },
                  splitForTooltip(this.props.selectedAddress ? this.props.selectedAddress.toUpperCase() : "")
                )
              )
            ),
            React__default.createElement(
              "div",
              { className: "internal" },
              React__default.createElement(
                "section",
                { className: "internal-box" },
                React__default.createElement(
                  "div",
                  null,
                  React__default.createElement(
                    "div",
                    { className: "lfc" },
                    React__default.createElement(
                      "div",
                      { className: "lfc-holder" },
                      React__default.createElement(
                        "div",
                        { className: "name-text" },
                        "LCL/FCl : "
                      ),
                      React__default.createElement(
                        "div",
                        { className: "lcl-text" },
                        this.props.selectedDestinationLaneData.containerLoadType
                      )
                    ),
                    React__default.createElement(
                      "div",
                      { className: "drop-holder" },
                      React__default.createElement(
                        "div",
                        { className: "name-text" },
                        "DROP AND PULL : "
                      ),
                      React__default.createElement(
                        "div",
                        { className: "drop-pull-text" },
                        this.props.selectedDestinationLaneData.dropAndPullTransport
                      )
                    ),
                    React__default.createElement(
                      "div",
                      { className: "warehouse-holder" },
                      React__default.createElement(
                        "div",
                        { className: "name-text" },
                        "WAREHOUSE APPT. MANDATORY :"
                      ),
                      React__default.createElement(
                        "div",
                        { className: "warehouse-text" },
                        this.props.selectedDestinationLaneData.warehouseAppointment
                      )
                    )
                  )
                ),
                React__default.createElement(
                  "div",
                  null,
                  React__default.createElement(
                    "div",
                    { style: { paddingTop: "5px" }, className: "lfc" },
                    React__default.createElement(
                      "div",
                      { className: "lfc-holder" },
                      React__default.createElement(
                        "div",
                        { className: "name-text" },
                        "HAZMAT: "
                      ),
                      React__default.createElement(
                        "div",
                        { className: "lcl-text" },
                        this.props.selectedDestinationLaneData.hazmat
                      )
                    ),
                    React__default.createElement(
                      "div",
                      { className: "drop-holder" },
                      React__default.createElement(
                        "div",
                        { className: "name-text" },
                        "OVERWEIGHT: "
                      ),
                      React__default.createElement(
                        "div",
                        { className: "drop-pull-text" },
                        this.props.selectedDestinationLaneData.overweight
                      )
                    ),
                    React__default.createElement(
                      "div",
                      { className: "warehouse-holder" },
                      React__default.createElement(
                        "div",
                        { className: "name-text" },
                        "CONTAINER TYPE :"
                      ),
                      React__default.createElement(
                        "div",
                        { className: "warehouse-text" },
                        this.props.selectedDestinationLaneData.containerType
                      )
                    )
                  )
                ),
                React__default.createElement(
                  "form",
                  null,
                  React__default.createElement(
                    "div",
                    { className: "fees-fuel" },
                    React__default.createElement(
                      "div",
                      { className: "general-col" },
                      React__default.createElement(
                        "div",
                        { className: "base-fees" },
                        React__default.createElement(
                          "div",
                          { className: "faded-text" },
                          "BASE FEES /LINE HAUL"
                        ),
                        React__default.createElement("input", {
                          className: "input-box",
                          type: "number",
                          name: "baseFees",
                          value: this.state.baseFees && this.state.baseFees > 0 ? parseInt(this.state.baseFees) : "",
                          onChange: this.changeHandler
                        })
                      )
                    ),
                    React__default.createElement(
                      "div",
                      { className: "fuel-inclusion" },
                      React__default.createElement(
                        "div",
                        { className: "faded-text" },
                        "ADDITIONAL FUEL CHARGES REQUIRED ?",
                        React__default.createElement(Popup, {
                          content: " FSC will be based on the United States Department of Energy,  Energy Information Administration (EIA) average price for a gallon of  diesel fuel issued each Monday, and will become applicable on each Monday  following the posting on the Department of Energy website.",
                          trigger: React__default.createElement(Icon, {
                            name: "warning circle ",
                            color: "blue",
                            size: "large"
                          })
                        })
                      ),
                      React__default.createElement(
                        "form",
                        null,
                        React__default.createElement(
                          "div",
                          { className: "yes-no-row" },
                          React__default.createElement(
                            "div",
                            null,
                            React__default.createElement("input", {
                              style: { marginLeft: "17px" },
                              className: "radio",
                              id: "yes",
                              type: "radio",
                              name: "yes-no-row",
                              value: "yes",
                              checked: this.state.yesRadioButton,
                              onClick: this.radioButtonChangeHandler
                            }),
                            React__default.createElement(
                              "label",
                              { className: "yes-no", "for": "yes" },
                              "YES"
                            )
                          ),
                          React__default.createElement("br", null),
                          React__default.createElement(
                            "div",
                            { style: { marginLeft: "15px" } },
                            React__default.createElement("input", {
                              className: "radio",
                              type: "radio",
                              name: "yes-no-row",
                              value: "no",
                              id: "no",
                              checked: !this.state.yesRadioButton,
                              onClick: this.radioButtonChangeHandler
                            }),
                            React__default.createElement(
                              "label",
                              { className: "yes-no", "for": "no" },
                              "NO"
                            )
                          ),
                          React__default.createElement("br", null)
                        )
                      )
                    )
                  ),
                  React__default.createElement(
                    "div",
                    { className: "fuel-charges ", style: { display: "flex", flexDirection: "row" } },
                    React__default.createElement(
                      "div",
                      { style: { display: 'flex', flexDirection: 'column', width: '58%' } },
                      React__default.createElement(
                        "div",
                        { className: "faded-text" },
                        "FUEL CHARGES"
                      ),
                      React__default.createElement(
                        "div",
                        { className: "percent-fuel" },
                        React__default.createElement(
                          "div",
                          { className: "percent" },
                          React__default.createElement("input", {
                            style: {
                              marginLeft: "-1px",
                              paddingTop: "-10px",
                              marginRight: "10px",
                              marginTop: "-2px",
                              border: formError.fuelChargesError ? "1px solid red" : "none"
                            },
                            onKeyDown: function onKeyDown(e) {
                              return ["-", "+"].includes(e.key) && e.preventDefault();
                            },
                            className: "input-box",
                            type: "number",
                            min: "0",
                            name: "fuelCharges",
                            value: this.state.fuelCharges,
                            onChange: this.fuelChargeHandler,
                            disabled: !this.state.yesRadioButton
                          }),
                          formError.fuelChargesError && React__default.createElement(
                            "span",
                            { className: "inputInsideRightIconBidModal" },
                            React__default.createElement(
                              Popup,
                              {
                                style: { color: "red" },
                                trigger: React__default.createElement(Icon, {
                                  className: "exclamation triangle icon",
                                  style: { color: "red" }
                                }),
                                size: "mini",
                                position: "top center"
                              },
                              formError.fuelChargesError
                            )
                          )
                        ),
                        React__default.createElement(
                          "div",
                          null,
                          " % OF BASE PRICE"
                        )
                      )
                    ),
                    isPartner || this.props.isBiddingFromOppUpdation && React__default.createElement(
                      "div",
                      { style: { display: 'flex', flexDirection: 'column', width: '40%', borderLeft: '1px solid #1765AE', padding: '0 1rem' } },
                      React__default.createElement(
                        "div",
                        { className: "faded-text", style: { marginLeft: 0 } },
                        "AP CURRENCY"
                      ),
                      React__default.createElement(Dropdown, {
                        fluid: true,
                        selection: true,
                        options: DRAYAGE_CURRENCY_OPTIONS,
                        defaultValue: apCurrencyCode,
                        onChange: function onChange(e, data) {
                          handleApCurrencyCodeChange(data.value);
                        },
                        style: { minHeight: 24, border: '1px solid #999', borderRadius: 0, paddingBottom: 4, padding: 4 }
                      })
                    )
                  ),
                  (isPartner || this.props.isBiddingFromOppUpdation) && React__default.createElement(
                    "div",
                    null,
                    React__default.createElement(
                      "div",
                      { className: "fuel-charges general-row " },
                      React__default.createElement(
                        "div",
                        {
                          style: { display: "flex", flexDirection: "column" }
                        },
                        React__default.createElement(
                          "div",
                          {
                            style: { paddingRight: "30px" },
                            className: "faded-text"
                          },
                          this.props.opp_key && this.props.opp_key === "containerOpportunities" ? "Capacity" : "CAPACITY/MONTH"
                        ),
                        React__default.createElement(
                          "div",
                          { className: "percent-fuel" },
                          React__default.createElement("input", {
                            style: {
                              marginLeft: "-1px",
                              paddingTop: "-10px",
                              marginRight: "10px",
                              marginTop: "-2px",
                              height: "20px"
                            },
                            className: "input-box",
                            type: "number",
                            name: "capacityPerMonth",
                            value: this.state.capacityPerMonth,
                            onChange: this.changeHandler
                          })
                        )
                      ),
                      React__default.createElement(
                        "div",
                        {
                          style: { paddingLeft: "100px" },
                          className: "genreral-col"
                        },
                        React__default.createElement(
                          "div",
                          {
                            style: { paddingRight: "20px" },
                            className: "faded-text general-col"
                          },
                          this.props.opp_key && this.props.opp_key === "containerOpportunities" ? "ESTIMATED TIME OF ARRIVAL" : "EXPIRATION DATE"
                        ),
                        React__default.createElement(
                          "div",
                          { style: { paddingLeft: "20px" } },
                          this.props.opp_key && this.props.opp_key === "containerOpportunities" ? expPickUpDate : expirationDate
                        )
                      )
                    ),
                    React__default.createElement("textarea", {
                      placeholder: "QUESTIONS ABOUT THE BID",
                      name: "notes",
                      rows: "2",
                      cols: "70",
                      onChange: this.changeHandler,
                      className: "fuel-charges bid-textarea",
                      value: this.state.notes
                    })
                  )
                )
              ),
              React__default.createElement(
                "div",
                { className: "additional" },
                "Potential Additional Charges"
              ),
              Array.from(this.state.additionalchargesForLane.keys()).map(function (key) {
                console.log("chargeForGlCode :", key);
                var charge = _this2.state.additionalchargesForLane.get(key);
                var total = charge.unitPrice * parseInt(charge.reqQuantityUsed);

                if (!charge.reqQuantityUsed) {
                  return null;
                }

                return React__default.createElement(
                  "div",
                  { className: "pot-add-box" },
                  React__default.createElement(
                    "div",
                    { className: "pot-row" },
                    React__default.createElement(
                      "div",
                      { className: "general-col" },
                      React__default.createElement(
                        "div",
                        { className: "first-head" },
                        charge.chargeName
                      ),
                      React__default.createElement(
                        "div",
                        { className: "text-charge" },
                        isPartner || _this2.props.isBiddingFromOppUpdation ? apCurrencyCode : laneData[DRAYAGE_CURRENCY_TYPES.AR_CURRENCY],
                        " ",
                        charge.unitPrice
                      )
                    ),
                    React__default.createElement(
                      "div",
                      { className: "general-col" },
                      React__default.createElement(
                        "div",
                        { className: "sec-head" },
                        "QUANTITY"
                      ),
                      React__default.createElement(
                        "div",
                        { className: "text-charge" },
                        parseInt(charge.reqQuantityUsed)
                      )
                    ),
                    React__default.createElement(
                      "div",
                      { className: "general-col" },
                      React__default.createElement(
                        "div",
                        { className: "third-head" },
                        "TOTAL"
                      ),
                      React__default.createElement(
                        "div",
                        { className: "text-charge" },
                        isPartner || _this2.props.isBiddingFromOppUpdation ? apCurrencyCode : laneData[DRAYAGE_CURRENCY_TYPES.AR_CURRENCY],
                        " ",
                        total
                      )
                    ),
                    React__default.createElement(
                      "div",
                      null,
                      React__default.createElement("img", {
                        onClick: function onClick(e) {
                          _this2.deleteHandler(charge.glCode);
                        },
                        style: { marginTop: "13px" },
                        src: "images/files/delete.svg"
                      })
                    )
                  )
                );
              }),
              React__default.createElement(
                "button",
                {
                  className: "btn-add-bid",
                  onClick: function onClick(e) {
                    _this2.props.setLaneBidChargesInStore(_this2.props.opportunityId, _this2.props.sourceId, _this2.props.laneId, {
                      baseFees: _this2.state.baseFees,
                      basefeesGlCode: _this2.state.basefeesGlCode,
                      fuelChargeGlCode: _this2.state.fuelChargeGlCode,
                      fuelCharges: _this2.state.fuelCharges,
                      chasisRentalperday: _this2.state.chasisRentalperday,
                      minReqDays: _this2.state.minReqDays,
                      bidBaseTotal: totalBidAmountForLane(_this2.state),
                      yesRadioButton: _this2.state.yesRadioButton,
                      notes: _this2.state.notes,
                      capacityPerMonth: _this2.state.capacityPerMonth,
                      rateValidUntilDate: _this2.state.rateValidUntilDate
                    });

                    _this2.props.additionalChargeClickHandler(_this2.props.sourceId, OPPORTUNITY_MODAL_VIEW.AdditionalCharges);
                  }
                },
                "ADD"
              )
            ),
            React__default.createElement(
              "section",
              { id: "my-best-bid", className: "best-cont" },
              React__default.createElement(
                "div",
                { className: "best-box" },
                "MY BEST ",
                isPartner || this.props.isBiddingFromOppUpdation ? 'BID' : 'AR'
              ),
              React__default.createElement(
                "div",
                { className: "cont-bid-box" },
                React__default.createElement(
                  "div",
                  { className: "total-per-bid" },
                  isPartner || this.props.isBiddingFromOppUpdation ? apCurrencyCode : laneData[DRAYAGE_CURRENCY_TYPES.AR_CURRENCY],
                  " ",
                  totalFee
                ),
                React__default.createElement(
                  "div",
                  { className: "per-cont" },
                  "PER CONTAINER APPROX "
                )
              )
            )
          ),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "button",
              {
                className: "partners-btn-done",
                style: isValid$$1 ? { backgroundColor: "#008B8F" } : {
                  backgroundColor: "#008B8F",
                  opacity: "50%"
                },
                disabled: !isValid$$1,
                onClick: function onClick(e) {
                  _this2.props.individualBidDoneHandler();
                  _this2.props.setLaneBidChargesInStore(_this2.props.opportunityId, _this2.props.sourceId, _this2.props.laneId, {
                    baseFees: _this2.state.baseFees,
                    basefeesGlCode: basefeesGlCode,
                    fuelChargeGlCode: fuelChargeGlCode,
                    fuelCharges: _this2.state.fuelCharges,
                    chasisRentalperday: _this2.state.chasisRentalperday,
                    minReqDays: _this2.state.minReqDays,
                    bidBaseTotal: totalFee,
                    yesRadioButton: _this2.state.yesRadioButton,
                    laneAmount: totalFee,
                    notes: _this2.state.notes,
                    capacityPerMonth: _this2.state.capacityPerMonth,
                    rateValidUntilDate: _this2.state.rateValidUntilDate,
                    apCurrencyCode: apCurrencyCode // AP_Currency code for this lane
                  });
                }
              },
              "DONE"
            ),
            React__default.createElement(
              "button",
              {
                className: "cancel-btn",
                onClick: this.props.individualBidCancelHandler
              },
              "CANCEL"
            )
          )
        )
      );
    }
  }]);
  return LaneBidCard;
}(Component);

var _initialiseProps$3 = function _initialiseProps() {
  var _this3 = this;

  this.getNextExpiryDate = function (extraDay) {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 13 + extraDay);
    return currentDate;
  };

  this.additionalChargeDoneHandler = function (chargeForGlCode) {
    console.log("chargeForGlCode : ", chargeForGlCode);
    _this3.setState({
      isAdditionalCharge: false,
      additionalchargesForLane: chargeForGlCode
    });
  };

  this.changeHandler = function (e) {
    console.log("changeHandler :: e", e);
    _this3.setState(defineProperty({}, e.target.name, e.target.value));
  };

  this.baseFeesUpdate = function (e) {
    _this3.props.setLaneBidChargesInStore(_this3.props.opportunityId, _this3.props.sourceId, _this3.props.laneId, {
      baseFees: e.target.value,
      basefeesGlCode: _this3.state.basefeesGlCode,
      fuelChargeGlCode: _this3.state.fuelChargeGlCode,
      fuelCharges: _this3.state.fuelCharges,
      chasisRentalperday: _this3.state.chasisRentalperday,
      minReqDays: _this3.state.minReqDays,
      bidBaseTotal: totalBidAmountForLane(_this3.state),
      notes: _this3.state.notes,
      capacityPerMonth: _this3.state.capacityPerMonth,
      rateValidUntilDate: _this3.state.rateValidUntilDate
    });
  };

  this.fuelChargeHandler = function (e) {
    var value = Number(e.target.value);
    var name = lodash_1(e, 'target.name', '');
    if (!Number.isInteger(value)) {
      x = parseFloat(value.toFixed(2));
    }
    _this3.setState(defineProperty({}, name, value), function () {
      _this3.validateForm({ value: value, name: name });
    });
  };

  this.handelFormErrorChange = function (_ref) {
    var name = _ref.name,
        value = _ref.value;

    _this3.setState(function (preState) {
      return {
        formError: _extends({}, preState.formError, defineProperty({}, name + "Error", value))
      };
    });
  };

  this.fuelChargeValidationRule = function (data) {
    var _state2 = _this3.state,
        fuelCharges = _state2.fuelCharges,
        yesRadioButton = _state2.yesRadioButton;
    var knStandardFuelPercent = _this3.props.knStandardFuelPercent;

    var name = 'fuelCharges';
    var value = lodash_1(data, value, 0);
    value = fuelCharges;
    value = !!value ? value : fuelCharges;
    if (value > knStandardFuelPercent) {
      _this3.handelFormErrorChange({
        name: name,
        value: "This cannot be more than KN Standard Fuel Surcharge which is " + knStandardFuelPercent + "% for today."
      });
      return;
    }

    if (yesRadioButton && value <= 0) {
      _this3.handelFormErrorChange({
        name: name,
        value: "This cannot be less than 0 if additional fuel charge selected to yes"
      });
      return;
    }

    _this3.handelFormErrorChange({ name: name, value: "" });
  };

  this.validateForm = function (_ref2) {
    var value = _ref2.value,
        name = _ref2.name;

    switch (name) {
      case "fuelCharges":
        // call on specfic input change
        _this3.fuelChargeValidationRule({ value: value });
        break;
      default:
        // call on submit form
        _this3.fuelChargeValidationRule();
        break;
    }
  };

  this.oneLaneBidSubmitted = function () {};

  this.deleteHandler = function (glCodeToDelete) {
    //value is an object, key is the glcode
    console.log("deleteHandler chargeForGlCode:", glCodeToDelete);
    var additionalchargesForLane = _this3.state.additionalchargesForLane;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = additionalchargesForLane[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _ref3 = _step2.value;

        var _ref4 = slicedToArray(_ref3, 2);

        var key = _ref4[0];
        var value = _ref4[1];

        if (key === glCodeToDelete) {
          value.reqQuantityUsed = 0;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    _this3.setState({ additionalchargesForLane: additionalchargesForLane });
  };

  this.additionalChargeCancelHandler = function () {
    _this3.setState({ isAdditionalCharge: false });
  };

  this.radioButtonChangeHandler = function (e) {
    if (e.target.value === "yes") {
      _this3.setState({ yesRadioButton: true }, function () {
        _this3.validateForm({ value: 0, name: 'fuelCharges' });
      });
    } else {
      _this3.setState({ yesRadioButton: false }, function () {
        _this3.validateForm({ value: 0, name: 'fuelCharges' });
      });
    }
  };
};

var LaneBidCard$1 = WithErrorBoundary(LaneBidCard);

var confirmImage = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22121px%22%20height%3D%2291px%22%20viewBox%3D%220%200%20121%2091%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3E0CB94897-4344-4A3F-8886-834F42F419AE%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%222a.-Drayage-Marketplace-Confirm%22%20transform%3D%22translate%28-977.000000%2C%20-450.000000%29%22%20fill%3D%22%23FFFFFF%22%20stroke%3D%22%2313C917%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Submit%22%20transform%3D%22translate%28977.000000%2C%20450.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20stroke-width%3D%225%22%20x%3D%222.5%22%20y%3D%222.5%22%20width%3D%22116%22%20height%3D%2228%22%20rx%3D%228%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M56.4349425%2C78.9148058%20L56.4349425%2C89%20L85.5334088%2C89%20L83.5032145%2C78.9148058%20L56.4349425%2C78.9148058%20Z%20M48.3995919%2C68.088723%20C49.1868502%2C70.108598%2056.4349425%2C78.9148756%2056.4349425%2C78.9148756%20L83.5032145%2C78.9148756%20C83.5032145%2C78.9148756%2087%2C71.2160189%2087%2C69.0499362%20L87%2C53.0817819%20C87%2C50.9156991%2085.2326939%2C49.1596688%2083.052529%2C49.1597386%20C80.8724344%2C49.1596688%2079.105058%2C50.9156991%2079.1049877%2C53.0817819%20L79.105058%2C49.2075897%20C79.105058%2C47.0417165%2077.3376113%2C45.2856862%2075.1575167%2C45.285756%20C72.9774924%2C45.2856862%2071.210116%2C47.0416466%2071.2101863%2C49.2075897%20L71.2101863%2C45.6499133%20C71.2101863%2C43.4838305%2069.44281%2C41.7279399%2067.262645%2C41.7279399%20C65.0825504%2C41.7278701%2063.3151037%2C43.4839004%2063.3151037%2C45.6498435%20L63.3151037%2C26.9220433%20C63.3151037%2C24.7558906%2061.5477274%2C23%2059.3675624%2C23%20C57.1873975%2C23%2055.4200914%2C24.7558906%2055.4200914%2C26.9219734%20L55.4201617%2C59.6415031%20C55.4200914%2C59.8537245%2055.4376689%2C60.0617545%2055.4705035%2C60.2648247%20C55.4705035%2C60.2648247%2045.7202277%2C51.0749699%2042.2679483%2C48.0019517%20C41.8853929%2C47.6614755%2041.2206142%2C47.1187672%2040.5185009%2C46.9318336%20C38.6041772%2C46.4221671%2036.6361368%2C47.5509639%2036.1231568%2C49.4530623%20C35.8515502%2C50.4602405%2036.0423006%2C51.4823678%2036.5662489%2C52.2968842%20C36.5943728%2C52.340544%2036.6234107%2C52.383575%2036.6533627%2C52.4259774%20C36.6645419%2C52.4417648%2036.6758618%2C52.4574823%2036.6873223%2C52.4730601%20C37.1536166%2C53.1110514%2046.7199621%2C63.7795399%2048.3995919%2C68.088723%20Z%22%20id%3D%22Stroke-3%22%20stroke-width%3D%224%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var ModalConfirm = function (_Component) {
  inherits(ModalConfirm, _Component);

  function ModalConfirm(props) {
    classCallCheck(this, ModalConfirm);

    var _this = possibleConstructorReturn(this, (ModalConfirm.__proto__ || Object.getPrototypeOf(ModalConfirm)).call(this, props));

    _this.priceDetails = function (destinations) {
      var updatedFeesDetails = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = destinations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var destination = _step.value;

          var desinationBidData = destination.destinationBidData;
          console.log("confirm desinationBidData", desinationBidData);

          var eachFeesDetails = {
            BaseFees: desinationBidData.baseFees,
            fuelCharges: desinationBidData.fuelCharges,
            capacityPerMonth: desinationBidData.capacityPerMonth,
            // AddressName: get(
            //   destination,
            //   "destinationAddress.addressName",
            //   "Unkown"
            // ),
            AddressName: lodash_1(destination, "destination", "Unkown"),
            apCurrencyCode: lodash_1(destination, "apCurrencyCode", "")
          };
          console.log("updatedFeesDetails", eachFeesDetails);
          updatedFeesDetails[destination.laneId] = eachFeesDetails;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return updatedFeesDetails;
    };

    _this.additionalCharges = function (destinations) {
      var additionalChargeList = {};
      var chargeObject = {};

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = destinations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var destination = _step2.value;

          var destinationAdditionalCharges = lodash_1(destination, "destinationAdditionalCharges", null);
          if (!destinationAdditionalCharges) {
            continue;
          }
          additionalChargeList[destination.laneId] = [];
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = destinationAdditionalCharges[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _ref = _step3.value;

              var _ref2 = slicedToArray(_ref, 2);

              var glcode = _ref2[0];
              var charge = _ref2[1];

              var reqQuantityUsed = lodash_1(charge, "reqQuantityUsed", null);
              if (reqQuantityUsed && reqQuantityUsed > 0) {
                chargeObject = {
                  ChargeName: charge["chargeName"],
                  UnitMeasurement: charge["unitMeasurement"],
                  UnitPrice: charge["unitPrice"],
                  RequiredQuantity: charge["reqQuantityUsed"]
                };
                additionalChargeList[destination.laneId].push(chargeObject);
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return additionalChargeList;
    };

    _this.getPortAdditionalCharges = function (portCode) {
      var indivData = _this.props.opportunityData.get(_this.props.opportunityId);

      if (indivData) {
        var portData = indivData.portData;
        var indivPortData = portData.get(portCode);
        var portAdditionalCharges = indivPortData.portAdditionalCharges;
        if (!portAdditionalCharges) {
          return [];
        }

        var portPriceList = [];
        var portChargeObject = {};
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = portAdditionalCharges[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _ref3 = _step4.value;

            var _ref4 = slicedToArray(_ref3, 2);

            var glcode = _ref4[0];
            var charge = _ref4[1];

            var reqQuantityUsed = lodash_1(charge, "reqQuantityUsed", null);
            if (reqQuantityUsed && reqQuantityUsed > 0) {
              portChargeObject = {
                ChargeName: charge["chargeName"],
                UnitMeasurement: charge["unitMeasurement"],
                UnitPrice: charge["unitPrice"],
                RequiredQuantity: charge["reqQuantityUsed"]
              };
              portPriceList.push(portChargeObject);
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        return { portPriceList: portPriceList, PortName: indivPortData.source };
      }
      return [];
    };

    _this.state = {
      feesDetails: []
    };
    return _this;
  }

  createClass(ModalConfirm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var drayageApp = this.props.drayageApp;

      var opportunityId = this.props.opportunityId;
      var opportunityData = this.props.opportunityData;
      var indivData = opportunityData.get(opportunityId);
      var opportunityName = indivData && indivData.opportunityName.toUpperCase();
      var currentCurrencyCode = this.props.currentCurrencyCode;

      var standardPartnerAdditionalCharges = this.props.standardAdditionalCharges ? this.props.standardAdditionalCharges : [];
      var priceList = [];
      var destinationAdditonalChargeMap = {};
      var portAdditonalChargeMap = {};
      var priceListMap = {};
      var portNameMap = {};
      if (indivData) {
        var portData = indivData.portData;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = portData[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _ref5 = _step5.value;

            var _ref6 = slicedToArray(_ref5, 2);

            var portCode = _ref6[0];
            var portDetails = _ref6[1];

            var indivPortData = portData.get(portCode);
            console.log("confirm indivPortData", indivPortData);
            var destinations = indivPortData.destinations;
            priceList = this.priceDetails(destinations);
            priceListMap[portCode] = priceList;
            portNameMap[portCode] = indivPortData.source;

            destinationAdditonalChargeMap[portCode] = this.additionalCharges(destinations);
            var portAdditionalCharges = this.getPortAdditionalCharges(portCode);

            portAdditonalChargeMap[portCode] = portAdditionalCharges;
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }

      var grandTotalPotentialaddcharges = 0;
      var grandTotalPortaddcharges = 0;
      var totalpot = void 0;
      var finalGrandtotal = amountToShortString(this.props.totalEnteredBidAmount, true);
      var isPartner = isPartnerApp(drayageApp);
      return React__default.createElement(
        "div",
        null,
        React__default.createElement(
          "div",
          { style: {
              maxHeight: 450,
              overflowY: 'auto'
            } },
          React__default.createElement(
            "div",
            { className: "partner-modal-first-confirmation-contents" },
            React__default.createElement("img", {
              style: { marginLeft: "225px", marginTop: "-20px" },
              src: confirmImage
            }),
            React__default.createElement(
              "div",
              {
                style: { marginLeft: "150px", fontSize: "24px" },
                className: "text-confirm"
              },
              this.props.isFromEdit ? this.props.bidOperationType === "SAVE" ? "CONFIRM EDITS SUBMISSION" : this.props.bidOperationType === "UPDATE_BID" ? "CONFIRM RE-SUBMISSION" : this.props.bidOperationType === "DISCARD" ? "CONFIRM EDITED DISCARD " : "" : "CONFIRM SUBMISSION"
            ),
            React__default.createElement(
              "div",
              { className: "summaryDiv" },
              React__default.createElement(
                "div",
                {
                  style: { marginTop: "20px", width: "450px" },
                  className: "general-row-cont"
                },
                React__default.createElement(
                  "div",
                  { style: { fontSize: "16px" }, className: "basebreakup" },
                  " ",
                  "OPPORTUNITY:"
                ),
                React__default.createElement(
                  "div",
                  {
                    style: {
                      fontSize: "16px",
                      marginTop: "20px",
                      width: "350px",
                      marginLeft: "-200px",
                      fontWeight: "bold"
                    }
                  },
                  " ",
                  opportunityName.toUpperCase(),
                  " "
                )
              ),
              Object.keys(priceListMap).map(function (portCode) {
                var priceList = priceListMap[portCode];

                var destinationAdditionalPriceList = destinationAdditonalChargeMap[portCode];
                var portDetails = portAdditonalChargeMap[portCode];
                var portAdditionalCharges = lodash_1(portDetails, "portPriceList", []);
                var portName = portDetails["PortName"];
                var laneIds = Object.keys(priceList);
                var laneTotalpotential = {};
                return React__default.createElement(
                  "div",
                  null,
                  React__default.createElement(
                    "div",
                    {
                      style: {
                        fontWeight: "bold",
                        fontSize: "16px",
                        marginTop: "0px",
                        marginBottom: "-10px"
                      },
                      className: "basebreakup"
                    },
                    " ",
                    "PORT: ",
                    portNameMap[portCode].toUpperCase(),
                    " "
                  ),
                  React__default.createElement(
                    "div",
                    null,
                    laneIds.map(function (laneId) {
                      var price = priceList[laneId];
                      return React__default.createElement(
                        "div",
                        null,
                        React__default.createElement(
                          "div",
                          {
                            style: { fontSize: "16px", marginBottom: "15px" },
                            className: "basebreakup"
                          },
                          " ",
                          "DESTINATION:",
                          " ",
                          lodash_1(price, "AddressName", "").toUpperCase()
                        ),
                        React__default.createElement(
                          "div",
                          {
                            style: {
                              fontWeight: "bold",
                              fontSize: "16px",
                              display: "flex",
                              flexDirection: "row"
                            }
                          },
                          React__default.createElement(
                            "div",
                            {
                              style: { marginLeft: "30px" },
                              className: "pot-add-box general-row"
                            },
                            React__default.createElement(
                              "div",
                              {
                                style: { marginLeft: "10px" },
                                className: "basebreakup"
                              },
                              "BASE FEES: ",
                              currentCurrencyCode,
                              " ",
                              price["BaseFees"],
                              " "
                            ),
                            price["fuelCharges"] && price["fuelCharges"] > 0 ? React__default.createElement(
                              "div",
                              { className: "basebreakup" },
                              "FUEL: ",
                              price["fuelCharges"],
                              "% (Base)",
                              " "
                            ) : "",
                            isPartner && React__default.createElement(
                              "div",
                              {
                                style: { marginLeft: "20px" },
                                className: "basebreakup"
                              },
                              "CAPACITY/MONTH: ",
                              price["capacityPerMonth"]
                            )
                          )
                        ),
                        destinationAdditionalPriceList[laneId].length > 0 && React__default.createElement(
                          "div",
                          {
                            style: {
                              marginLeft: "32px",
                              fontWeight: "bold",
                              marginTop: "15px",
                              marginBottom: "-5px"
                            },
                            className: "port-head-text"
                          },
                          "POTENTIAL ADDITIONAL CHARGES:"
                        ),
                        React__default.createElement(
                          "div",
                          null,
                          destinationAdditionalPriceList[laneId].map(function (charge) {
                            var qty = parseInt(charge["RequiredQuantity"]);
                            var unitPrice = parseInt(charge["UnitPrice"]);
                            if (!(laneId in laneTotalpotential)) {
                              laneTotalpotential[laneId] = 0;
                            }
                            totalpot = laneTotalpotential[laneId] += qty * unitPrice;

                            grandTotalPotentialaddcharges += qty * unitPrice;

                            return React__default.createElement(
                              "div",
                              null,
                              React__default.createElement(
                                "div",
                                {
                                  style: {
                                    marginLeft: "30px",
                                    marginTop: "5px",
                                    marginBottom: "10px"
                                  },
                                  className: "pot-add-box "
                                },
                                React__default.createElement(
                                  "div",
                                  { className: "pot-row" },
                                  React__default.createElement(
                                    "div",
                                    { className: "general-col" },
                                    React__default.createElement(
                                      "div",
                                      { className: "first-head" },
                                      charge["ChargeName"]
                                    ),
                                    React__default.createElement(
                                      "div",
                                      { className: "text-charge general-row " },
                                      React__default.createElement(
                                        "div",
                                        null,
                                        currentCurrencyCode,
                                        " ",
                                        charge["UnitPrice"]
                                      ),
                                      React__default.createElement(
                                        "div",
                                        {
                                          style: {
                                            fontSize: "12px",
                                            paddingLeft: "10px"
                                          }
                                        },
                                        " ",
                                        charge["UnitMeasurement"]
                                      )
                                    )
                                  ),
                                  React__default.createElement(
                                    "div",
                                    { className: "general-col" },
                                    React__default.createElement(
                                      "div",
                                      { className: "sec-head" },
                                      "QUANTITY"
                                    ),
                                    React__default.createElement(
                                      "div",
                                      { className: "text-charge" },
                                      parseInt(charge["RequiredQuantity"])
                                    )
                                  ),
                                  React__default.createElement(
                                    "div",
                                    { className: "general-col" },
                                    React__default.createElement(
                                      "div",
                                      { className: "third-head" },
                                      "TOTAL"
                                    ),
                                    React__default.createElement(
                                      "div",
                                      { className: "text-charge" },
                                      parseInt(charge["RequiredQuantity"]) && parseInt(charge["RequiredQuantity"]) > 0 ? currentCurrencyCode + " " + charge["UnitPrice"] * parseInt(charge["RequiredQuantity"]) : ""
                                    )
                                  ),
                                  React__default.createElement("div", null)
                                )
                              )
                            );
                          }),
                          grandTotalPotentialaddcharges > 0 && React__default.createElement(
                            "div",
                            {
                              style: {
                                marginLeft: "30px",
                                fontWeight: "bold",
                                marginBottom: "20px"
                              }
                            },
                            "TOTAL POTENTIAL ADDITIONAL CHARGES :",
                            " ",
                            currentCurrencyCode + " " + totalpot
                          )
                        )
                      );
                    })
                  ),
                  React__default.createElement(
                    "div",
                    null,
                    portAdditionalCharges.length > 0 && React__default.createElement(
                      "div",
                      {
                        style: { marginLeft: "30px", fontWeight: "bold" },
                        className: "port-head-text"
                      },
                      "PORT ADDITIONAL CHARGES:"
                    ),
                    portAdditionalCharges.map(function (charge) {
                      var qty = parseInt(charge["RequiredQuantity"]);
                      var unitPrice = parseInt(charge["UnitPrice"]);
                      console.log("Destination Additional charges : ", qty, unitPrice);

                      grandTotalPortaddcharges += qty * unitPrice;
                      return React__default.createElement(
                        "div",
                        null,
                        React__default.createElement(
                          "div",
                          {
                            style: {
                              marginLeft: "30px",
                              marginTop: "5px",
                              marginBottom: "10px"
                            },
                            className: "pot-add-box"
                          },
                          React__default.createElement(
                            "div",
                            { className: "pot-row" },
                            React__default.createElement(
                              "div",
                              { className: "general-col" },
                              React__default.createElement(
                                "div",
                                { className: "first-head" },
                                charge["ChargeName"]
                              ),
                              React__default.createElement(
                                "div",
                                { className: "text-charge general-row " },
                                React__default.createElement(
                                  "div",
                                  null,
                                  "$ ",
                                  charge["UnitPrice"]
                                ),
                                React__default.createElement(
                                  "div",
                                  {
                                    style: {
                                      fontSize: "12px",
                                      paddingLeft: "10px"
                                    }
                                  },
                                  " ",
                                  charge["UnitMeasurement"]
                                )
                              )
                            ),
                            React__default.createElement(
                              "div",
                              { className: "general-col" },
                              React__default.createElement(
                                "div",
                                { className: "sec-head" },
                                "QUANTITY"
                              ),
                              React__default.createElement(
                                "div",
                                { className: "text-charge" },
                                parseInt(charge["RequiredQuantity"])
                              )
                            ),
                            React__default.createElement(
                              "div",
                              { className: "general-col" },
                              React__default.createElement(
                                "div",
                                { className: "third-head" },
                                "TOTAL"
                              ),
                              React__default.createElement(
                                "div",
                                { className: "text-charge" },
                                parseInt(charge["RequiredQuantity"]) && parseInt(charge["RequiredQuantity"]) > 0 ? "$" + charge["UnitPrice"] * parseInt(charge["RequiredQuantity"]) : ""
                              )
                            ),
                            React__default.createElement("div", null)
                          )
                        )
                      );
                    })
                  ),
                  grandTotalPortaddcharges > 0 && React__default.createElement(
                    "div",
                    {
                      style: {
                        marginLeft: "32px",
                        fontWeight: "bold",
                        marginBottom: "20px"
                      }
                    },
                    "TOTAL POTENTIAL PORT CHARGES:",
                    " ",
                    "$" + grandTotalPortaddcharges
                  )
                );
              }),
              React__default.createElement(
                "div",
                {
                  style: {
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginLeft: "30px"
                  },
                  className: "basebreakup"
                },
                "TOTAL PROPOSED VOLUME: ",
                this.props.totalProposedVolume
              )
            )
          )
        ),
        React__default.createElement(
          "div",
          { style: {
              display: 'flex',
              width: '100%',
              justifyContent: 'center'
            } },
          React__default.createElement(
            "button",
            {
              onClick: function onClick(e) {
                _this2.props.bidSubmissionConfirmed();
              },
              className: "btn-done"
            },
            "YES"
          ),
          React__default.createElement(
            "button",
            {
              onClick: function onClick(e) {
                _this2.props.bidSubmissionCanceled();
              },
              className: "cancel-btn"
            },
            "NO"
          )
        )
      );
    }
  }]);
  return ModalConfirm;
}(Component);

var ModalConfirm$1 = WithErrorBoundary(ModalConfirm);

var successImage = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2291px%22%20height%3D%2291px%22%20viewBox%3D%220%200%2091%2091%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3EA8798653-D061-4D86-9D9B-2767E6E0A978%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%222b.-Drayage-Marketplace-done%22%20transform%3D%22translate%28-995.000000%2C%20-446.000000%29%22%20fill%3D%22%2313C917%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22tick%22%20transform%3D%22translate%28995.000000%2C%20446.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M88.9954239%2C12.999049%20C87.6526353%2C11.6690725%2085.473902%2C11.666781%2084.1311134%2C12.9934083%20L42.8610448%2C53.6915692%20L27.9709243%2C37.7013566%20C26.6842933%2C36.3204373%2024.5089473%2C36.2308909%2023.1100012%2C37.5028737%20C21.7121247%2C38.7750327%2021.6226293%2C40.9269681%2022.9092603%2C42.3091213%20L40.2246724%2C60.902527%20C40.8588066%2C61.5839968%2041.7462736%2C61.9797287%2042.6820539%2C61.9989424%20C42.7071911%2C62%2042.7314369%2C62%2042.7555044%2C62%20C43.6648996%2C62%2044.5397088%2C61.6428718%2045.1841832%2C61.007938%20L88.9886493%2C17.8097034%20C90.3348252%2C16.4832524%2090.3371428%2C14.3290254%2088.9954239%2C12.999049%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M87.5702598%2C42.0702598%20C85.6759668%2C42.0702598%2084.1406973%2C43.6055293%2084.1406973%2C45.5%20C84.1406973%2C66.8073301%2066.8073301%2C84.1406973%2045.5%2C84.1406973%20C24.1939141%2C84.1406973%206.85930273%2C66.8073301%206.85930273%2C45.5%20C6.85930273%2C24.1939141%2024.1939141%2C6.85930273%2045.5%2C6.85930273%20C47.394293%2C6.85930273%2048.9297402%2C5.3240332%2048.9297402%2C3.42974023%20C48.9297402%2C1.53526953%2047.394293%2C0%2045.5%2C0%20C20.4110156%2C0%200%2C20.4110156%200%2C45.5%20C0%2C70.587918%2020.4110156%2C91%2045.5%2C91%20C70.587918%2C91%2091%2C70.587918%2091%2C45.5%20C91%2C43.605707%2089.4647305%2C42.0702598%2087.5702598%2C42.0702598%20Z%22%20id%3D%22Path%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function Success(props) {
  var drayageApp = props.drayageApp;

  var isPartner = isPartnerApp(drayageApp);
  return React__default.createElement(
    "div",
    null,
    React__default.createElement(
      "div",
      { className: "contents" },
      React__default.createElement("img", {
        src: successImage
      }),
      React__default.createElement(
        "div",
        {
          className: "text-success-bid",
          style: props.bidOperationType === "UPDATE_BID" ? { marginLeft: "0px" } : null
        },
        props.isFromEdit ? props.bidOperationType === "SAVE" ? "Your Edits Have Been Saved Successfully." : props.bidOperationType === "UPDATE_BID" ? "Bid Re-Submitted Successfully." : props.bidOperationType === "DISCARD" ? "Your Edits Have Been Discarded Successfully." : "" : isPartner ? "Bid Submitted Successfully." : "AR Submitted Successfully."
      ),
      React__default.createElement(
        "div",
        { className: "email-success" },
        props.bidOperationType === "SAVE" ? "Please remember to RE-SUBMIT your bid in order to send the updated bid for approval" : props.bidOperationType === "UPDATE_BID" ? isPartner ? "Hold tight. We are reviewing your bid. You can view your submitted Bid in the SUBMITTED Tab." : "Hold tight. Customer will review your AR." : props.bidOperationType === "DISCARD" ? "" : isPartner ? "Hold tight. We are reviewing your bid. You can view your submitted Bid in the SUBMITTED Tab." : "Hold tight. Customer will review your AR."
      ),
      React__default.createElement(
        "div",
        null,
        React__default.createElement(
          "button",
          {
            onClick: function onClick() {
              props.bidAfterSubmitDoneHandler();
            },
            className: "btn-done"
          },
          "Done"
        )
      )
    )
  );
}
var Success$1 = WithErrorBoundary(Success);

function Failure(props) {
  return React__default.createElement(
    "div",
    null,
    React__default.createElement(
      ReactModal,
      {
        isOpen: true,
        contentLabel: "onRequestClose Example",
        className: "modal-first",
        overlayClassName: "Overlay"
      },
      React__default.createElement(
        "div",
        { className: "bid-header" },
        React__default.createElement(
          "div",
          { className: "icon-text" },
          React__default.createElement(
            "div",
            {
              style: { marginLeft: "460px", marginTop: "1px" },
              className: "img-bidIcon"
            },
            React__default.createElement("img", { src: "images/files/bid-icon.svg" })
          )
        )
      ),
      React__default.createElement(
        "div",
        { className: "contents" },
        React__default.createElement("img", { style: { marginLeft: "160px" }, src: "images/files/success.svg" }),
        React__default.createElement(
          "div",
          { style: { marginLeft: "0px" }, className: "text-success" },
          "Bid Submission Failed"
        ),
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            "button",
            {
              style: { marginLeft: "130px" },
              onClick: function onClick() {
                props.bidAfterSubmitDoneHandler();
              },
              className: "btn-done"
            },
            "Done"
          )
        )
      )
    )
  );
}
var Failure$1 = WithErrorBoundary(Failure);

function getMasterAccessorialCharges() {
  var data = {
    eventMessage: {
      action: "get",
      table: "ACCESSORIAL_CHARGES",
      pageNumber: "1",
      keyword: ""
    },
    eventType: "GET_EDIT_TABLE_DATA",
    eventTime: Date.now()
  };

  return HttpClient.custom({
    data: data
  });
}

var BidModal = function (_Component) {
  inherits(BidModal, _Component);

  function BidModal(props) {
    classCallCheck(this, BidModal);

    var _this = possibleConstructorReturn(this, (BidModal.__proto__ || Object.getPrototypeOf(BidModal)).call(this, props));

    _initialiseProps$4.call(_this);

    var isOpenPortMap = new Map();

    _this.state = {
      modalView: OPPORTUNITY_MODAL_VIEW.BidModal, //"AdditionalCharges"
      isOpenPortMap: isOpenPortMap,
      isAdditionalCharges: false,
      isConfirmation: false,
      sourceIdForAdditionalCharge: "",
      isSubmit: false,

      destinationName: "",
      source: "",
      sourceName: "",
      sourceId: "",
      laneId: "",

      selectedsourceName: "",
      selectedsourceId: "",
      apCurrencyCode: "",
      selectedLaneId: "",
      selectedContainerLoadType: "",
      selectedContainerType: "",
      selectedwarehouseAppointment: "",
      addressName: "",
      isEditBidModal: true,
      bidOperationType: "",
      additionalAccessorialCharges: new Map(),
      portChargesList: new Map()
    };
    return _this;
  }

  createClass(BidModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var drayageApp = this.props.drayageApp;
      // get additional accessorial charges from master table

      var isSales = isSalesApp(drayageApp);
      isSales && this.getAdditionalAccessorialCharges();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          opportunityId = _props.opportunityId,
          drayageApp = _props.drayageApp;

      var isSales = isSalesApp(drayageApp);
      //console.log("OpportunityModal :: componentDidUpdate ");

      var isOpenPortMap = new Map();

      var thisOpportunityData = this.getOpportunityDataForOpportunityId();
      var opportunityPortsData = thisOpportunityData.portData ? thisOpportunityData.portData : new Map();

      var portDataKeys = Array.from(opportunityPortsData.keys());
      console.log("BidModal :: ", opportunityPortsData);
      console.log("BidModal :: ", "array : ", portDataKeys);
      var isFirst = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = portDataKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var portData = opportunityPortsData.get(key);
          console.log("BidModal  :: port ", portData);
          isOpenPortMap.set(portData.sourceId, isFirst ? true : false);
          isFirst = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      console.log("BidModal :: isOpenPortMap", isOpenPortMap);
      isSales && prevProps.opportunityId !== opportunityId && this.getAdditionalAccessorialCharges();
      if (isSales && this.props.isBiddingFromOppUpdation && prevProps.oppUpdationData.partnerData.partnerId !== this.props.oppUpdationData.partnerData.partnerId) {
        this.getAdditionalAccessorialChargesForPartner();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          additionalAccessorialCharges = _state.additionalAccessorialCharges,
          portChargesList = _state.portChargesList,
          selectedsourceId = _state.selectedsourceId,
          modalView = _state.modalView;
      var drayageApp = this.props.drayageApp;

      var isFromEdit = lodash_1(this.props, "isFromEdit", false);
      var isPartner = isPartnerApp(drayageApp);
      var isSales = isSalesApp(drayageApp);
      /*
       * Find data for opportunity
       */
      var thisOpportunityData = this.getOpportunityDataForOpportunityId();
      var opportunityPortsData = thisOpportunityData.portData ? thisOpportunityData.portData : new Map();
      var opportunityPortsDataArray = Array.from(opportunityPortsData.values());
      var IsInEdit = !!lodash_1(opportunityPortsDataArray, '[0].destinations[0].partnerBids[0].inEdit', 0);

      var allBidsEntered = true;
      var totalProposedVolume = 0;
      var totalProposedAmount = 0;
      var totalEnteredBidAmount = 0;

      if (opportunityPortsData) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = opportunityPortsData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref = _step2.value;

            var _ref2 = slicedToArray(_ref, 2);

            var source = _ref2[0];
            var _portData = _ref2[1];

            var portTotalApproxVolume = 0;

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = _portData.destinations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var destination = _step3.value;

                console.log("BidModal :: destination", destination);
                var isAllBidNotEntered = !destination.destinationBidData || !destination.destinationBidData.baseFees;
                if (isPartner) {
                  isAllBidNotEntered = isAllBidNotEntered || !destination.destinationBidData.capacityPerMonth;
                }
                if (isAllBidNotEntered) {
                  allBidsEntered = false;
                  // break
                } else {
                  totalEnteredBidAmount += parseInt(destination.approxVolume) * parseInt(destination.destinationBidData.bidBaseTotal);
                }
                console.log("BidModal :: totalEnteredBidAmount", destination.approxVolume, destination.proposedBid, destination.destinationBidData.bidBaseTotal, totalEnteredBidAmount);
                totalProposedVolume += parseInt(destination.approxVolume);
                totalProposedAmount += parseInt(destination.proposedBid * parseInt(destination.approxVolume));
                portTotalApproxVolume += parseInt(destination.approxVolume);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            _portData.portTotalApproxVolume = portTotalApproxVolume;
            console.log("BidModal :: totalEnteredBidAmount", portTotalApproxVolume, _portData.portAdditionalCharges);

            var totalPortAdditionalCharges = 0;
            _portData.totalPortAdditionalCharges = 0;
            if (_portData.portAdditionalCharges) {
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = _portData.portAdditionalCharges[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var _ref3 = _step4.value;

                  var _ref4 = slicedToArray(_ref3, 2);

                  var key = _ref4[0];
                  var charge = _ref4[1];

                  if (charge.reqQuantityUsed && charge.reqQuantityUsed > 0) {
                    totalPortAdditionalCharges += charge.unitPrice * parseInt(charge.reqQuantityUsed);
                  }
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }

              _portData.totalPortAdditionalCharges = totalPortAdditionalCharges;
              totalEnteredBidAmount += totalPortAdditionalCharges * portTotalApproxVolume;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      var modalClassName = "partner-modal-first !important";
      if (isViewSuccessfulSubmission(this.state.modalView)) {
        modalClassName = "partner-modal-success !important";
      }
      if (isViewLaneBid(this.state.modalView) || isViewLaneAdditionalCharges(this.state.modalView) || isViewPortAdditionalCharges(this.state.modalView)) {
        modalClassName = "partner-modal-first-bid-card !important";
      }
      var additionalCharges = new Map();
      var portData = opportunityPortsData.get(selectedsourceId);
      if (isViewBidModal(modalView) || isViewPortAdditionalCharges(modalView)) {
        //Read port additional charges for selected port to be shown in bid modal
        if (portData && isPartner) {
          additionalCharges = portData.portAdditionalCharges;
        }
        if (isSales) {
          additionalCharges = portChargesList;
        }
      } else if (isViewLaneBid(this.state.modalView) || isViewLaneAdditionalCharges(this.state.modalView)) {
        //Read port additional charges for selected lane
        if (portData && portData.destinations && isPartner) {
          var destinations = portData.destinations;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = destinations[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var _destination = _step5.value;

              if (_destination.laneId === this.state.selectedLaneId) {
                additionalCharges = _destination.destinationAdditionalCharges;
                break;
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
        if (isSales) {
          additionalCharges = additionalAccessorialCharges;
        }
      }

      console.log("BidModal ::  additionalCharges ", additionalCharges);

      return React__default.createElement(
        "div",
        null,
        React__default.createElement(
          Modal,
          {
            size: "large",
            onClose: function onClose() {
              return _this2.props.handleCloseModal;
            }
            // onOpen={() => this.props.onOpen()}
            , open: this.props.isOpen,
            className: modalClassName
            // contentLabel="onRequestClose Example"
            // onRequestClose={this.props.handleCloseModal}
            // className={modalClassName}
            // overlayClassName="Overlay"
            // ariaHideApp={false}
          },
          React__default.createElement(
            "div",
            { className: "partner-bid-modal-header" },
            React__default.createElement(
              "div",
              { className: "icon-text" },
              React__default.createElement("div", {
                style: this.state.modalView === OPPORTUNITY_MODAL_VIEW.LaneBidCard || this.state.modalView === OPPORTUNITY_MODAL_VIEW.AdditionalCharges || this.state.modalView === OPPORTUNITY_MODAL_VIEW.PortAdditionalCharges ? { marginTop: "1px" } : this.state.modalView === OPPORTUNITY_MODAL_VIEW.ConfirmationForSubmit || this.state.modalView === OPPORTUNITY_MODAL_VIEW.SuccessfulSubmission ? { marginLeft: "450px", marginTop: "1px" } : { marginTop: "1px", marginLeft: "75%" },
                className: "img-bidIcon"
              }),
              isViewBidModal(this.state.modalView) && React__default.createElement(
                "div",
                { style: { marginLeft: "370px" }, className: "bid-text" },
                "SUBMIT YOUR BEST ",
                isPartner || this.props.isBiddingFromOppUpdation ? 'BID' : 'AR'
              )
            )
          ),
          isViewBidModal(this.state.modalView) ? React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "div",
              { className: "scrollableDiv" },
              opportunityPortsData && Array.from(opportunityPortsData.keys()).map(function (portId) {
                // );
                var portData = opportunityPortsData.get(portId);
                return React__default.createElement(
                  "div",
                  null,
                  React__default.createElement(PortwiseData$1, {
                    portData: opportunityPortsData.get(portId),
                    isOpen: _this2.state.isOpenPortMap.get(portData.sourceId),
                    partnerId: _this2.props.partnerId,
                    opp_key: _this2.props.opp_key,
                    additionalCharges: additionalCharges,
                    onPortArrowClick: function onPortArrowClick(e) {
                      _this2.onPortArrowClick(portData.source, portData.sourceId);
                    },
                    individualBidClickHandler: _this2.individualBidClickHandler,
                    additionalChargeClickHandler: _this2.additionalChargeClickHandler,
                    isFromEdit: isFromEdit,
                    isBiddingFromOppUpdation: _this2.props.isBiddingFromOppUpdation,
                    currentApCurrencyCode: _this2.state.apCurrencyCode // AP_Currency code for this lane
                    , handleApCurrencyCodeChange: _this2.handleApCurrencyCodeChange
                  })
                );
              })
            ),
            this.props.isBiddingFromOppUpdation ? React__default.createElement(
              "div",
              { className: "bidModalButtonContainer" },
              React__default.createElement(
                "button",
                {
                  className: "partner-btn-submit-save",
                  onClick: this.bidModalCanceled
                },
                "DONE"
              )
            ) : React__default.createElement(
              "div",
              { className: "bidModalButtonContainer" },
              isFromEdit && React__default.createElement(
                "button",
                {
                  className: "partner-btn-submit-save",
                  onClick: function onClick() {
                    return _this2.bidSubmissionStarted("SAVE");
                  },
                  disabled: !allBidsEntered,
                  style: !allBidsEntered ? { opacity: "50%" } : null
                },
                "SAVE"
              ),
              React__default.createElement(
                "div",
                {
                  style: isFromEdit === false ? { marginLeft: "0px" } : { display: "contents" }
                },
                React__default.createElement(
                  "button",
                  {
                    className: "partner-btn-submit",
                    onClick: function onClick() {
                      return _this2.bidSubmissionStarted("UPDATE_BID");
                    },
                    disabled: !allBidsEntered,
                    style: !allBidsEntered ? { opacity: "50%" } : null
                  },
                  isFromEdit ? "RE-SUBMIT" : "SUBMIT"
                ),
                React__default.createElement(
                  "button",
                  {
                    className: "cancel-btn",
                    onClick: this.bidModalCanceled
                  },
                  "CANCEL"
                )
              ),
              isFromEdit && IsInEdit && React__default.createElement(
                "button",
                {
                  className: "cancel-btn",
                  style: { marginLeft: "20px" },
                  onClick: function onClick() {
                    return _this2.bidSubmissionStarted("DISCARD");
                  }
                },
                "DISCARD CHANGES"
              )
            )
          ) : this.state.modalView === OPPORTUNITY_MODAL_VIEW.PortAdditionalCharges ? React__default.createElement(LaneAdditionalCharges$1
          // **********************   Properties **************************
          , { isOpen: true,
            opportunityId: this.props.opportunityId // Opportunity which has opened for display in this modal
            , partnerId: this.props.partnerId // Drayage partner id for this app
            , source: this.state.sourceIdForAdditionalCharge // Source port which has been selected for additional charge addition
            , destinationName: this.props.destinationName // destination name which has been opened for additional charge addition
            , opportunityPortsData: opportunityPortsData // Ports data for opportunity which contains bid and additional charge info
            , fromLaneBidCard: false,
            sourceName: this.state.selectedsourceName,
            selectedAddress: this.state.addressName,
            standardPartnerAdditionalCharges: this.props.standardPartnerAdditionalCharges // Standard partner additional charges feteched from BE
            , additionalCharges: additionalCharges ? Array.from(additionalCharges.values()) : []
            // **********************   Methods **************************
            , additionalChargeDoneHandler:
            //Handler when additional charge addition is done
            this.additionalChargeDoneHandler,
            setAdditionalChargesInStore:
            //Handler to send additional charge to redux store
            this.props.setAdditionalChargesInStore,
            additionalChargeCancelHandler:
            //Handler when cancel button on additional charge is clicked
            this.additionalChargeCancelHandler,
            updateCharges: this.updateCharges
          }) : // </ReactModal>
          this.state.modalView === OPPORTUNITY_MODAL_VIEW.AdditionalCharges ? React__default.createElement(LaneAdditionalCharges$1
          // **********************   Properties **************************
          , { isOpen: true,
            opportunityId: this.props.opportunityId // Opportunity which has opened for display in this modal
            , partnerId: this.props.partnerId // Drayage partner id for this app
            , source: this.state.sourceIdForAdditionalCharge // Source port which has been selected for additional charge addition
            , sourceName: this.state.selectedsourceName,
            selectedAddress: this.state.addressName,
            laneId: this.state.selectedLaneId,
            destinationName: this.props.destinationName // destination name which has been opened for additional charge addition
            , opportunityPortsData: opportunityPortsData // Ports data for opportunity which contains bid and additional charge info
            , fromLaneBidCard: true,
            additionalCharges: additionalCharges ? Array.from(additionalCharges.values()) : [],
            standardPartnerAdditionalCharges: this.props.standardPartnerAdditionalCharges // Standard partner additional charges feteched from BE
            // **********************   Methods **************************
            , additionalChargeDoneHandler:
            //Handler when additional charge addition is done
            this.additionalChargeDoneHandler,
            setAdditionalChargesInStore:
            //Handler to send additional charge to redux store
            this.props.setAdditionalChargesInStore,
            additionalChargeCancelHandler:
            //Handler when cancel button on additional charge is clicked
            this.additionalChargeCancelHandler,
            updateCharges: this.updateCharges,
            currencyType: this.props.isBiddingFromOppUpdation || isPartner ? this.state.apCurrencyCode : this.state.selectedDestinationLaneData[DRAYAGE_CURRENCY_TYPES.AR_CURRENCY]
          }) : // </ReactModal>
          this.state.modalView === OPPORTUNITY_MODAL_VIEW.LaneBidCard ? React__default.createElement(LaneBidCard$1
          // **********************   Properties **************************
          , { drayageApp: this.props.drayageApp,
            isOpen: true,
            opportunityId: this.props.opportunityId,
            partnerId: this.props.partnerId,
            standardPartnerAdditionalCharges:
            // Standard partnet charges feteched from BE
            this.props.standardPartnerAdditionalCharges,
            opp_key: this.props.opp_key,
            destinationName: this.state.selectedDestinationName // Destination lane name which opened for filling bid info
            , source: this.state.selectedsource // Source port  opened for lane display
            , sourceName: this.state.selectedsourceName // Source port name opened for lane display
            , sourceId: this.state.selectedPortCode // Source port code opened for lane display
            , selectedAddress: this.state.addressName,
            laneId: this.state.selectedLaneId // Destination lane id which opened for filling bid info
            , warehouseAppointment: this.state.selectedwarehouseAppointment // Destination lane id  warehouse appointment status
            , containerLoadType: this.state.selectedContainerLoadType,
            containerType: this.state.selectedContainerType,
            selectedDestinationLaneData: this.state.selectedDestinationLaneData // TBD : Why do we need this?
            , key: this.props.opportunityId,
            additionalCharges: additionalCharges // Additional charge for this lane
            , expirationDate: thisOpportunityData.opportunityExpiryDate,
            knStandardFuelPercent: thisOpportunityData.knFuelPercent
            // **********************   Method **************************

            , setAdditionalChargesInStore:
            // redux action function for setting additional charges in redux store when a set of additional charges are submitted
            // for a given port or lane
            this.props.setAdditionalChargesInStore,
            setLaneBidChargesInStore:
            // redux action for setting all filled bidding charges for a given opportunity in redux store. This is called when DONE button
            // on lane bid card is clicked.
            this.props.setLaneBidChargesInStore,
            individualBidDoneHandler:
            //When DONE for a given bid for given lane is clicked, this is lhe local function to change the view
            this.individualBidDoneHandler,
            individualBidCancelHandler:
            //When CANCEL for a given bid for given lane is clicked, this is lhe local function to change the view
            this.individualBidCancelHandler,
            additionalChargeClickHandler:
            //Local function called when ADD is clicked for additiona charge for a LANE
            this.additionalChargeClickHandler,
            isBiddingFromOppUpdation: this.props.isBiddingFromOppUpdation // if updating bids from sales
            , apCurrencyCode: this.state.apCurrencyCode // AP_Currency code for this lane}
            , handleApCurrencyCodeChange: this.handleApCurrencyCodeChange
          }) : this.state.modalView === OPPORTUNITY_MODAL_VIEW.ConfirmationForSubmit ? React__default.createElement(ModalConfirm$1, _extends({}, this.props, {
            bidSubmissionConfirmed: this.bidSubmissionConfirmed,
            bidSubmissionCanceled: this.bidSubmissionCanceled //
            , opportunityId: this.props.opportunityId,
            selectedsourceId: this.state.selectedPortCode,
            selectedsourceName: this.state.selectedsourceName,
            destinationName: this.state.selectedDestinationName,
            totalEnteredBidAmount: totalEnteredBidAmount,
            totalProposedVolume: totalProposedVolume,
            bidOperationType: this.state.bidOperationType,
            isFromEdit: isFromEdit,
            currentCurrencyCode: this.props.isBiddingFromOppUpdation || isPartner ? this.state.apCurrencyCode : this.state.selectedDestinationLaneData[DRAYAGE_CURRENCY_TYPES.AR_CURRENCY]
          })) : this.state.modalView === OPPORTUNITY_MODAL_VIEW.SuccessfulSubmission ? React__default.createElement(Success$1, {
            bidAfterSubmitDoneHandler: this.bidAfterSubmitDoneHandler,
            style: { marginLeft: "160px" },
            isFromEdit: isFromEdit,
            bidOperationType: this.state.bidOperationType,
            drayageApp: drayageApp
          }) : this.state.modalView === OPPORTUNITY_MODAL_VIEW.FailureSubmission ? React__default.createElement(Failure$1, {
            bidAfterSubmitDoneHandler: this.bidAfterSubmitDoneHandler
          }) : null
        )
      );
    }
  }]);
  return BidModal;
}(Component);

var _initialiseProps$4 = function _initialiseProps() {
  var _this3 = this;

  this.updateCharges = function (_ref5) {
    var charges = _ref5.charges,
        source = _ref5.source;

    var stateName = source === "LANE_ADDITIONAL_CHARGE" ? "additionalAccessorialCharges" : "portChargesList";
    _this3.setState(defineProperty({}, stateName, charges));
  };

  this.additionalChargeClickHandler = function (sourceIdForAdditionalCharge, modalView) {
    _this3.setState({
      isAdditionalCharges: !_this3.state.additionalCharges,
      modalView: modalView,
      sourceIdForAdditionalCharge: sourceIdForAdditionalCharge
    });
  };

  this.additionalChargeDoneHandler = function (fromLaneBidCard) {
    _this3.setState({
      modalView: fromLaneBidCard ? OPPORTUNITY_MODAL_VIEW.LaneBidCard : OPPORTUNITY_MODAL_VIEW.BidModal
    });
  };

  this.onPortArrowClick = function (sourceName, sourceId) {
    var isOpenPortMap = _this3.state.isOpenPortMap;
    var thisPortWasOpened = isOpenPortMap.get(sourceId);
    if (thisPortWasOpened) {
      // case 1
      isOpenPortMap.set(sourceId, !isOpenPortMap.get(sourceId));
      sourceName = "";
      sourceId = "";
    } else {
      // case 2 and 3 - close all ports, and open this one
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = isOpenPortMap[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _ref6 = _step6.value;

          var _ref7 = slicedToArray(_ref6, 2);

          var portCode = _ref7[0];
          var opened = _ref7[1];

          isOpenPortMap.set(portCode, false);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      isOpenPortMap.set(sourceId, true);
    }

    _this3.setState({
      isOpenPortMap: isOpenPortMap,
      selectedsourceName: sourceName,
      selectedsourceId: sourceId
    });
  };

  this.bidSubmissionConfirmed = function () {
    var drayageApp = _this3.props.drayageApp;

    var isFromEdit = lodash_1(_this3.props, "isFromEdit", false);
    console.log("submitOpportunityBidData  :: Call submit api");
    // Call submit api here
    var result = _this3.props.submitOpportunityBidData(_this3.props.opportunityId, _this3.props.opportunityData, _this3.props.partnerId, isFromEdit, _this3.state.bidOperationType, drayageApp);
    result.then(function (res) {
      console.log("bidSubmissionConfirmed : result ", res);
      _this3.setState({
        isConfirmation: false,
        isSubmit: true,
        modalView: res === DRAYAGE_API_RESPONSE.SUCCESS ? OPPORTUNITY_MODAL_VIEW.SuccessfulSubmission : OPPORTUNITY_MODAL_VIEW.FailureSubmission
      });
    }).catch(function (err) {
      _this3.setState({
        isConfirmation: false,
        isSubmit: true,
        modalView: OPPORTUNITY_MODAL_VIEW.FailureSubmission
      });
    });
  };

  this.bidSubmissionCanceled = function () {
    _this3.setState({
      isConfirmation: false,
      modalView: OPPORTUNITY_MODAL_VIEW.BidModal
    });
  };

  this.bidModalCanceled = function () {
    if (_this3.props.isBiddingFromOppUpdation) _this3.setOppBiddingUpdationData();
    _this3.props.handleOpportunityBidModalCanceled();
    // this.bidSubmissionStarted("DISCARD")
  };

  this.bidSubmissionStarted = function (type) {
    _this3.setState({
      isConfirmation: true,
      modalView: OPPORTUNITY_MODAL_VIEW.ConfirmationForSubmit,
      bidOperationType: type
    });
  };

  this.bidAfterSubmitDoneHandler = function () {
    var _props2 = _this3.props,
        drayageApp = _props2.drayageApp,
        countrySelected = _props2.countrySelected,
        motSelected = _props2.motSelected;

    var isPartner = isPartnerApp(drayageApp);
    _this3.props.handleOpportunityBidModalCanceled();
    //call get  oppor api and now the current oppor shounity that we submitted shouldnot appear in new

    var filters = [];

    filters.push({
      key: "DRAYAGE_COUNTRY",
      values: countrySelected
    });

    filters.push({ key: "DRAYAGE_MOT", values: motSelected && motSelected.length ? motSelected : ['MOT_OCEAN'] });

    _this3.setState({ modalView: OPPORTUNITY_MODAL_VIEW.BidModal });
    var tab = "SALES_" + SELECTED_TABS.SALES_PUBLISHED;
    if (isPartner) {
      tab = SELECTED_TABS.PARTNER_SUBMITTED;
    }
    _this3.props.getOpportunityList(tab, filters);
  };

  this.additionalChargeCancelHandler = function (fromLaneBidCard) {
    //console.log("additionalChargeCancelHandler","cancel")
    _this3.setState({
      isAdditionalCharges: false,
      modalView: fromLaneBidCard ? OPPORTUNITY_MODAL_VIEW.LaneBidCard : OPPORTUNITY_MODAL_VIEW.BidModal
    });
  };

  this.individualBidClickHandler = function (portId, source, destinationName, selectedLaneId, sourceName, destinationData, containerLoadType, containerType, warehouseAppointment, addressName) {
    if (_this3.props.opp_key === "containerOpportunities") {
      destinationData.eta = _this3.getOpportunityDataForOpportunityId().eta;
    }
    _this3.setState({
      modalView: OPPORTUNITY_MODAL_VIEW.LaneBidCard,
      selectedPortCode: portId,
      selectedsource: source,
      selectedDestinationName: destinationName,
      selectedLaneId: selectedLaneId,
      selectedsourceName: sourceName,
      selectedDestinationLaneData: destinationData,
      showLaneBidCard: true,
      selectedContainerLoadType: containerLoadType,
      selectedContainerType: containerType,
      selectedwarehouseAppointment: warehouseAppointment,
      addressName: addressName
    });
  };

  this.individualBidDoneHandler = function () {
    _this3.setState({
      modalView: OPPORTUNITY_MODAL_VIEW.BidModal,
      selectedLaneId: ""
    });
  };

  this.individualBidCancelHandler = function () {
    _this3.setState({
      modalView: OPPORTUNITY_MODAL_VIEW.BidModal,
      selectedLaneId: ""
    });
  };

  this.getOpportunityDataForOpportunityId = function () {
    var thisOpportunityData = new Map();
    if (_this3.props.opportunityData && _this3.props.opportunityData.has(_this3.props.opportunityId)) {
      thisOpportunityData = _this3.props.opportunityData.get(_this3.props.opportunityId);
    }
    return thisOpportunityData;
  };

  this.getAdditionalAccessorialCharges = function () {
    if (_this3.props.isBiddingFromOppUpdation) _this3.getAdditionalAccessorialChargesForPartner();else {
      getMasterAccessorialCharges().then(function (res) {
        var entries = lodash_1(res, "data.eventMessage.entries", []);
        var data = new Map(entries.map(function (v) {
          return [parseInt(v.GL_CODE), {
            chargeName: v.CHARGE_NAME,
            glCode: parseInt(v.GL_CODE),
            unitMeasurement: v.UNIT,
            unitPrice: v.KN_STANDARD_CHARGE
          }];
        }));
        _this3.setState({
          additionalAccessorialCharges: data,
          portChargesList: data
        });
      });
    }
  };

  this.getAdditionalAccessorialChargesForPartner = function () {
    getDrayageAdditionalCharges(_this3.props.oppUpdationData.partnerData.partnerId).then(function (res) {
      var entries = lodash_1(res, "data.eventMessage.chargeList", []);
      var data = new Map(entries.map(function (v) {
        return [parseInt(v.glCode), {
          chargeName: v.chargeName,
          glCode: parseInt(v.glCode),
          unitMeasurement: v.unitMeasurement,
          unitPrice: v.unitPrice
        }];
      }));
      _this3.setState({
        additionalAccessorialCharges: data,
        portChargesList: data
      });
    });
  };

  this.setOppBiddingUpdationData = function () {
    var oppUpdationData = _this3.props.oppUpdationData;

    var thisOpportunityData = _this3.getOpportunityDataForOpportunityId();
    var opportunityPortsData = thisOpportunityData.portData ? thisOpportunityData.portData : new Map();

    var sourceList = oppUpdationData.sourceList;
    var portToSet = sourceList && sourceList.get(oppUpdationData.sourceId);

    if (portToSet) {
      var currentPortData = opportunityPortsData.get(oppUpdationData.sourceId);

      var portAdditionalCharges = Array.from(currentPortData.portAdditionalCharges.values()).filter(function (item) {
        return item.quantity !== undefined;
      });

      var destinations = portToSet.destinations;
      var currentDestinationData = currentPortData.destinations.find(function (item) {
        return item.laneId === oppUpdationData.laneId;
      });

      for (var i = 0; i < destinations.length; i++) {
        var destination = destinations[i];
        if (destination.laneId === oppUpdationData.laneId) {
          var partnerBids = destination.partnerBids;

          for (var j = 0; j < partnerBids.length; j++) {
            if (partnerBids[j].partnerId === oppUpdationData.partnerData.partnerId) {
              var chargeDetails = {};
              chargeDetails.laneAdditionalChargeList = Array.from(currentDestinationData.destinationAdditionalCharges.values()).filter(function (item) {
                return item.quantity !== undefined;
              });

              var baseCharge = {
                glCode: 60001,
                chargeName: 'BASE CHARGE',
                unitPrice: currentDestinationData.destinationBidData.baseFees,
                amount: currentDestinationData.destinationBidData.baseFees,
                quantity: 1
              };
              var fsc = {
                glCode: 60002,
                chargeName: "FUEL SURCHARGE",
                unitPrice: currentDestinationData.destinationBidData.fuelCharges,
                amount: parseInt(currentDestinationData.destinationBidData.baseFees) * parseInt(currentDestinationData.destinationBidData.fuelCharges) / 100,
                quantity: 1,
                chargePercent: currentDestinationData.destinationBidData.fuelCharges
              };
              chargeDetails.baseChargeList = [baseCharge, fsc];
              chargeDetails.portChargeList = portAdditionalCharges;
              partnerBids[j].chargeDetails = chargeDetails;
              partnerBids[j].bidAmount = parseInt(currentDestinationData.destinationBidData.bidBaseTotal) + parseInt(currentPortData.totalPortAdditionalCharges);
              partnerBids[j].capacityPerMonth = currentDestinationData.destinationBidData.capacityPerMonth;
              partnerBids[j].notes = currentDestinationData.destinationBidData.notes;
              partnerBids[j].apCurrencyCode = _this3.state.apCurrencyCode;
              break;
            }
          }
          break;
        }
      }
      currentPortData.destinations.forEach(function (item, index) {
        item.destinationAdditionalCharges = new Map();
        item.destinationBidData = new Map();
      });
      currentPortData.portAdditionalCharges = new Map();
      console.log('oppUpdationBiddingDataInBidModal--->', _this3.props.oppUpdationData, sourceList);
      _this3.props.handleBidUpdationOpenClose(false, _extends({}, _this3.props.oppUpdationData, { sourceList: sourceList })); // BiddingStatus, data
    }
  };

  this.handleApCurrencyCodeChange = function (apCurrencyCode) {
    _this3.setState({ apCurrencyCode: apCurrencyCode });
  };
};

var css_248z$q = ".sematic-date-field .ui.input .field {\n  width: 100%; }\n";
styleInject(css_248z$q);

var DateInputField$1 = function (_Component) {
  inherits(DateInputField, _Component);

  function DateInputField() {
    classCallCheck(this, DateInputField);

    var _this = possibleConstructorReturn(this, (DateInputField.__proto__ || Object.getPrototypeOf(DateInputField)).call(this));

    _this.errorPopup = function (errors) {
      var error = errors.map(function (info, index) {
        return React__default.createElement(
          'div',
          { className: 'error', key: index },
          '* ',
          info
        );
      });
      return React__default.createElement(Popup, { trigger: React__default.createElement(Icon, { name: 'warning sign', color: 'red' }), content: error || '' });
    };

    _this.emptyField = function (id) {
      !_this.props.isInteger && _this.props.onChange('');
      var element = document.getElementById(id);
      element.focus();
    };

    _this.state = {};
    return _this;
  }

  createClass(DateInputField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.newValue !== this.state.newValue || nextProps.rbCounterId !== this.state.rbCounterId) {
        this.setState({ newValue: nextProps.newValue, rbCounterId: nextProps.rbCounterId }, function () {
          _this2.props.fieldName === _this2.props.id + _this2.props.shipmentId && _this2.props.onChange(_this2.props.isInteger ? parseFloat(_this2.state.newValue.replace(/[^\d.-]/g, '')).toFixed(2) : _this2.state.newValue);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          iconPosition = _props.iconPosition,
          width = _props.width,
          type = _props.type,
          onChange = _props.onChange,
          onBlur = _props.onBlur,
          disabled = _props.disabled,
          value = _props.value,
          setINPUTID = _props.setINPUTID,
          penClicked = _props.penClicked,
          isInteger = _props.isInteger,
          shipmentId = _props.shipmentId,
          handleFocus = _props.handleFocus,
          label = _props.label,
          numberOnly = _props.numberOnly,
          errors = _props.errors,
          minDate = _props.minDate,
          drayageCal = _props.drayageCal;

      return React__default.createElement(
        Form.Input,
        { width: width, className: 'sematic-date-field' },
        React__default.createElement(
          'label',
          null,
          label
        )
      );
    }
  }]);
  return DateInputField;
}(Component);

var CustomLoader$1 = function (_Component) {
    inherits(CustomLoader, _Component);

    function CustomLoader() {
        classCallCheck(this, CustomLoader);
        return possibleConstructorReturn(this, (CustomLoader.__proto__ || Object.getPrototypeOf(CustomLoader)).apply(this, arguments));
    }

    createClass(CustomLoader, [{
        key: 'render',
        value: function render() {

            var showImage = get(this.props, 'showImage', false);
            showImage = isBoolean(showImage) ? showImage : false;

            return React__default.createElement(
                React__default.Fragment,
                null,
                this.props.loading && React__default.createElement(
                    Segment,
                    { className: 'custom-loader' },
                    React__default.createElement(
                        Dimmer,
                        { active: true },
                        React__default.createElement(
                            Loader,
                            null,
                            'Loading'
                        )
                    ),
                    showImage && React__default.createElement(Image, { src: '/images/short-paragraph.png' })
                )
            );
        }
    }]);
    return CustomLoader;
}(Component);

var getCookie$2 = function getCookie() {
  var cname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "kxSalesToken";

  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

var kxToken$2 = getCookie$2("kxSalesToken");

var getRequestHeaders$2 = function getRequestHeaders() {
  return {
    "Content-Type": "application/json",
    kxToken: kxToken$2
  };
};

var uploadImageToBucket$1 = function uploadImageToBucket(payload, uploadTo) {
  return HttpClient.custom({
    url: window._env_.REACT_APP_MEDIA_URL + "/" + uploadTo,
    headers: {
      "Content-type": "multipart/form-data"
    },
    data: payload,
    method: "post"
  });
};

var getDrayagePartnerDetails$1 = function getDrayagePartnerDetails(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "DRAYAGE_GET_PARTNER_DETAILS",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var saveContainerSalesPending = function saveContainerSalesPending(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "UPSERT_DRAYAGE_CHARGES_LIST",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var deleteChargeAtLineItem$1 = function deleteChargeAtLineItem(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "ARCHIVE_DRAYAGE_CHARGE_LIST",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var createInvoiceFromSalesPending = function createInvoiceFromSalesPending(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GENERATE_INVOICE_FROM_CHARGE_LIST",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayageDocument$1 = function getDrayageDocument(_ref) {
  var chargeNames = _ref.chargeNames,
      containerId = _ref.containerId;

  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: { chargeNames: chargeNames, containerId: containerId },
      eventType: "GET_DRAYAGE_DOCUMENTS",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var insertDrayageDocument$2 = function insertDrayageDocument(formData, uploadTo, setProgress, containerId, docType, actualFileName, displayName) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: {
        containerId: containerId,
        chargeNames: docType,
        actualFileName: actualFileName,
        displayName: displayName
      },
      eventType: "INSERT_DRAYAGE_DOCUMENT",
      eventTime: Date.now()
    }),
    onUploadProgress: function onUploadProgress(data) {
      //Set the progress value to show the progress bar
      setProgress(Math.round(100 * data.loaded / data.total));
    },
    method: "post"
  });
};
var getDrayageSalesPendingInvoices = function getDrayageSalesPendingInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var getDrayagePendingInvoices$1 = function getDrayagePendingInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayageImageURL$1 = function getDrayageImageURL(fileName) {
  var data = {
    eventMessage: fileName,
    eventType: "GET_SIGNED_URLS",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: data
  });
};

var getDrayagePaidInvoices$1 = function getDrayagePaidInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayagePartiallyPaidInvoices$1 = function getDrayagePartiallyPaidInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayageRejectedInvoices$1 = function getDrayageRejectedInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayageDisputedInvoices$1 = function getDrayageDisputedInvoices(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_INVOICES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var archiveDrayageDocument$2 = function archiveDrayageDocument(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "ARCHIVE_DRAYAGE_DOCUMENT",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var drayagePaidInvoice$1 = function drayagePaidInvoice(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "DRAYAGE_PAID_INVOICE",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var getDrayageTabCount$1 = function getDrayageTabCount(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_TAB_COUNT",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var raiseDisputeForInvoice = function raiseDisputeForInvoice(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "APPROVE_DISPUTE_INVOICE",
      eventTime: Date.now()
    }),
    method: "post"
  });
};
var approveInvoice = function approveInvoice(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "INVOICE_APPROVED_BY_SALES",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var getDrayageChangeLog$1 = function getDrayageChangeLog(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "GET_DRAYAGE_CHANGE_LOG",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var drayageChargeDetails = function drayageChargeDetails(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "DRAYAGE_CHARGE_DETAILS",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var referenceNumberUpdate = function referenceNumberUpdate(payload) {
  return HttpClient.custom({
    headers: getRequestHeaders$2(),
    data: JSON.stringify({
      eventMessage: payload,
      eventType: "INVC_UPDATE_DRAYAGE_REFERECE_NUBMER",
      eventTime: Date.now()
    }),
    method: "post"
  });
};

var UploadDocument$1 = function (_Component) {
  inherits(UploadDocument, _Component);

  function UploadDocument(props) {
    var _this2 = this;

    classCallCheck(this, UploadDocument);

    var _this = possibleConstructorReturn(this, (UploadDocument.__proto__ || Object.getPrototypeOf(UploadDocument)).call(this, props));

    _this.get_url_extension = function (url) {
      var ext = url.split(/[#?]/)[0].split(".").pop().trim();
      return ext;
    };

    _this.addTableRows = function () {
      _this.setState({ addNewItem: true, currentSelectedCharge: "" });
    };

    _this.fetchDocument = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$state, useDocument, remaningDocument, chargeDataArray, containerId, getDoc, documents, firstDocumentId, filteredDocumentArray, fileNameArray, imageResults, ImageLinks, remainingDoc, newOption;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state = _this.state, useDocument = _this$state.useDocument, remaningDocument = _this$state.remaningDocument;
              chargeDataArray = _this.props.chargeDesc.filter(function (x) {
                return !["60001", "60002"].includes(x.glCode);
              }).map(function (y) {
                return { glCode: y.glCode, chargeName: y.chargeName };
              });
              containerId = {
                containerId: _this.props.containerId
              };
              _context2.next = 5;
              return getDrayageDocument$1({
                containerId: _this.props.containerId,
                chargeNames: chargeDataArray
              });

            case 5:
              getDoc = _context2.sent;
              documents = get(getDoc, "data.eventMessage.documents", []);
              firstDocumentId = "";

              if (documents[0]) {
                firstDocumentId = documents[0].key;
              }
              filteredDocumentArray = {};

              documents.forEach(function (val) {
                var chargeNames = get(val, "value.chargeNames", []).map(function (valChargeName) {
                  if (filteredDocumentArray["" + valChargeName.chargeName]) {
                    filteredDocumentArray["" + valChargeName.chargeName] = [].concat(toConsumableArray(filteredDocumentArray["" + valChargeName.chargeName]), [{
                      key: val.key,
                      actualFileName: val.value.actualFileName,
                      displayName: val.value.displayName,
                      docId: val.value.docId,
                      glCode: valChargeName.glCode,
                      chargeName: valChargeName.chargeName
                    }]);
                  } else {
                    filteredDocumentArray["" + valChargeName.chargeName] = [{
                      key: val.key,
                      actualFileName: val.value.actualFileName,
                      displayName: val.value.displayName,
                      docId: val.value.docId,
                      glCode: valChargeName.glCode,
                      chargeName: valChargeName.chargeName
                    }];
                  }
                });
              });
              _this.setState({
                imageId: firstDocumentId,
                useDocument: _extends({}, useDocument, { documents: documents }),
                chargeFiles: filteredDocumentArray
              });
              fileNameArray = documents.map(function () {
                var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(d) {
                  var fileLink;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return getDrayageImageURL$1(window._env_.DRAYAGE_BILL_BUCKET + ":" + d.value.actualFileName);

                        case 2:
                          fileLink = _context.sent;
                          _context.next = 5;
                          return fileLink;

                        case 5:
                          return _context.abrupt("return", _context.sent);

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context2.next = 15;
              return Promise.all(fileNameArray);

            case 15:
              imageResults = _context2.sent;
              ImageLinks = {};

              imageResults.forEach(function (e, key) {
                var fileKey = get(documents[key].value, "actualFileName", "");
                if (!isEmpty(get(documents[key].value, "chargeNames", []))) {
                  set(ImageLinks, [fileKey], e.data.eventMessage.urls[0]);
                }
              });
              _this.setState({ imageURLs: ImageLinks }, function () {
                var obj = {};
                var i = 0;
                for (i = 0; i < get(_this, "state.useDocument.documents", []).length; i++) {
                  var _useDocument = get(_this, "state.useDocument.documents", {})[i];
                  console.log("testingkkk", _useDocument, i, get(_this, "state.useDocument.documents", []));
                  if (!isEmpty(get(_useDocument, "value.chargeNames", []))) {
                    obj = _useDocument;
                    break;
                  }
                }
                console.log("testingkkk", obj, i);
                _this.setImageToShow(obj, 0);
              });

              remainingDoc = get(getDoc, "data.eventMessage.remainingDocTypes", []);

              console.log("505050", remainingDoc);
              newOption = remainingDoc && remainingDoc.length > 0 && remainingDoc.map(function (item, index) {
                return { key: item.chargeName, text: item.chargeName, value: item };
              });

              _this.setState({ remaningDocument: _extends({}, remaningDocument, { newOption: newOption }) });

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.handleDropDownSelect = function (event, data) {
      _this.setState({ currentSelectedCharge: data.value });
    };

    _this.setProgresStatus = function (val) {
      _this.setState({ progressStatus: val });
    };

    _this.setNewFile = function (event) {
      var selectedFiles = _this.state.selectedFiles;

      var fileData = selectedFiles;
      if (_this.state.currentSelectedCharge !== "") {
        fileData = _extends({}, fileData, { getelectedCharge: event.target.files[0] });
        _this.setState({ selectedFiles: _extends({}, fileData) });
        var containerId = _this.props.containerId;
        var docType = _this.state.currentSelectedCharge;
        var filename = Date.now() + "_" + event.target.files[0].name;

        var bodyFormData = new FormData();
        bodyFormData.append("files", event.target.files[0], filename);
        var url = window._env_.REACT_APP_MEDIA_URL + "/" + window._env_.DRAYAGE_BILL_BUCKET;

        var bucketName = window._env_.DRAYAGE_BILL_BUCKET;
        uploadImageToBucket$1(bodyFormData, bucketName).then(function (res) {
          var files = get(res, "data.msg", "");
          if (files !== "") {
            files = files.split("[")[1];
            files = files.split("]")[0];
            files = files;
          } else {
            files = "demo";
          }
          insertDrayageDocument$2(bodyFormData, url, _this.setProgresStatus, containerId, docType, files, files).then(function () {
            _this.fetchDocument();
            _this.setState({
              selectedFile: null,
              addNew: false,
              currentSelectedCharge: "",
              progressStatus: "",
              selectedFiles: ""
            });
            _this.fileRef.current.value = null;
          });
        });
      }
    };

    _this.ifChecked = function (value) {
      var selectedFilesKeys = Object.keys(_this.state.selectedFiles);
      if (selectedFilesKeys.includes(value)) {
        return true;
      } else {
        return false;
      }
    };

    _this.setImageToShow = function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, imageIndex) {
        var imageUrls, fileName, fileUrl, extenison, _imageUrls, _fileName, _fileUrl, _extenison;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("setImageToShow", data, imageIndex);
                if (get(data, "actualFileName", false) === false) {
                  imageUrls = _this.state.imageURLs;
                  fileName = get(data, "value.actualFileName", "");
                  fileUrl = get(imageUrls, fileName, "");
                  extenison = _this.get_url_extension(fileUrl);

                  _this.setState({
                    imageShow: fileUrl,
                    fileExtension: extenison,
                    imageId: data.key,
                    fileImageIndex: imageIndex
                  });
                } else {
                  _imageUrls = _this.state.imageURLs;
                  _fileName = get(data, "actualFileName", "");
                  _fileUrl = get(_imageUrls, _fileName, "");
                  _extenison = _this.get_url_extension(_fileUrl);

                  _this.setState({
                    imageShow: _fileUrl,
                    fileExtension: _extenison,
                    imageId: data.key,
                    fileImageIndex: imageIndex
                  });
                }

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.removeDoc = function (id) {
      var files = _this.state.selectedFiles;
      delete files[id];
      archiveDrayageDocument$2({ docId: id }).then(function (res) {
        _this.setState({ selectedFiles: _extends({}, files) });
        _this.fetchDocument();
      });
    };

    _this.openInNewTab = function (url) {
      var newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    };

    _this.state = {
      open: false,
      addNew: false,
      selectedFiles: {},
      currentSelectedCharge: "",
      selectedFile: null,
      progressStatus: "",
      useDocument: [],
      remaningDocument: [],
      addNewItem: false,
      imageShow: "",
      imageId: "",
      imageURLs: {},
      fileExtension: "",
      fileImageIndex: 0,
      chargeFiles: {}
    };
    _this.fileRef = React__default.createRef();
    return _this;
  }

  createClass(UploadDocument, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var imageUrls = this.state.imageURLs;
      var url = imageUrls[Object.keys(imageUrls)[0]];
      this.setState({ imageShow: url });

      // const imageUrls = this.state.imageURLs;
      // let fileName = get(data, "value.actualFileName", "");
      // let fileUrl = get(imageUrls, fileName, "");
      // this.setState({ imageShow: fileUrl, imageId: data.key })
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          containerId = _props.containerId,
          containerNumber = _props.containerNumber,
          _state = this.state,
          open = _state.open,
          selectedFiles = _state.selectedFiles,
          useDocument = _state.useDocument,
          addNewItem = _state.addNewItem,
          remaningDocument = _state.remaningDocument,
          progressStatus = _state.progressStatus,
          imageShow = _state.imageShow,
          imageId = _state.imageId,
          fileExtension = _state.fileExtension,
          currentSelectedCharge = _state.currentSelectedCharge,
          fileImageIndex = _state.fileImageIndex;


      return React__default.createElement(
        Modal,
        {
          closeIcon: true,
          centered: true,
          open: open,
          trigger: React__default.createElement(
            "span",
            { className: "btn-over" },
            !this.props.showOtherTab ? React__default.createElement(
              "svg",
              {
                width: "45",
                height: "38",
                viewBox: "0 0 45 38",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              },
              React__default.createElement("rect", { x: "1", y: "1", width: "43", height: "36", rx: "2" }),
              React__default.createElement("path", {
                d: "M28.0118 13.9492C27.2688 11.0418 24.6007 9.00174 21.539 9C18.4772 8.99826 15.8067 11.0353 15.0602 13.9418C11.5051 14.2684 8.83993 17.2723 9.00748 20.7637C9.17504 24.255 12.1162 27.0011 15.6869 27H18.1937C18.6552 27 19.0293 26.6338 19.0293 26.1821C19.0293 25.7303 18.6552 25.3641 18.1937 25.3641H15.6869C12.918 25.3721 10.6668 23.1813 10.6588 20.4709C10.6507 17.7605 12.8888 15.557 15.6577 15.549C16.1018 15.5818 16.4991 15.2799 16.5768 14.8505C16.9286 12.4359 19.041 10.6421 21.5327 10.6421C24.0244 10.6421 26.1368 12.4359 26.4886 14.8505C26.5787 15.2631 26.9542 15.5556 27.3851 15.549C30.154 15.549 32.3987 17.7462 32.3987 20.4566C32.3987 23.167 30.154 25.3641 27.3851 25.3641H24.8784C24.4169 25.3641 24.0428 25.7303 24.0428 26.1821C24.0428 26.6338 24.4169 27 24.8784 27H27.3851C30.9277 26.9637 33.8262 24.2283 33.9925 20.7642C34.1589 17.3001 31.5353 14.3106 28.0118 13.9492Z",
                fill: "#008B8F"
              }),
              React__default.createElement("path", {
                d: "M25.5848 21.5233C25.9125 21.8354 26.4333 21.8309 26.7554 21.5133C27.0775 21.1956 27.0821 20.682 26.7656 20.3588L22.5904 16.2411C22.2643 15.9196 21.7357 15.9196 21.4096 16.2411L17.2344 20.3588C16.9179 20.682 16.9225 21.1956 17.2446 21.5133C17.5667 21.8309 18.0875 21.8354 18.4152 21.5233L21.165 18.8114V29.1765C21.165 29.6313 21.5388 30 22 30C22.4612 30 22.835 29.6313 22.835 29.1765V18.8114L25.5848 21.5233Z",
                fill: "#008B8F"
              })
            ) : React__default.createElement(
              "svg",
              {
                width: "41",
                height: "38",
                viewBox: "0 0 41 38",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              },
              React__default.createElement("rect", { x: "1", y: "1", width: "39", height: "36", rx: "2" }),
              React__default.createElement("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M16.5882 10.1351C16.2796 10.1351 16.0294 10.3892 16.0294 10.7027V11.8378H23.2941C23.9113 11.8378 24.4118 12.3461 24.4118 12.973V18.7622C24.0231 18.8423 23.649 18.9635 23.2941 19.1209V12.973H12.1176V28.8649H22.176C22.7064 29.2696 23.3102 29.5808 23.9633 29.7741C23.7768 29.9159 23.5451 30 23.2941 30H12.1176C11.5004 30 11 29.4917 11 28.8649V12.973C11 12.3461 11.5004 11.8378 12.1176 11.8378H14.9118V10.7027C14.9118 9.76233 15.6624 9 16.5882 9H26.0882C27.0142 9 27.7647 9.76233 27.7647 10.7027V19.1209C27.4099 18.9635 27.0357 18.8423 26.6471 18.7622V10.7027C26.6471 10.3892 26.3968 10.1351 26.0882 10.1351H16.5882ZM30 24.3243C30 26.832 27.9985 28.8649 25.5294 28.8649C23.164 28.8649 21.2276 26.999 21.0693 24.6372L21.4584 25.0175L21.4594 25.0184L21.461 25.0199L21.4667 25.0255L21.4869 25.0448C21.5042 25.0613 21.529 25.0848 21.5609 25.1144C21.6245 25.1734 21.7161 25.2566 21.8307 25.3561C22.0591 25.5546 22.3816 25.82 22.7565 26.0864C23.1301 26.352 23.5654 26.6256 24.0192 26.8343C24.4678 27.0407 24.9688 27.2 25.4645 27.2C25.9601 27.2 26.4612 27.0407 26.9097 26.8343C27.3635 26.6256 27.7989 26.352 28.1724 26.0864C28.5474 25.82 28.8698 25.5546 29.0983 25.3561C29.2128 25.2566 29.3045 25.1734 29.3681 25.1144C29.3999 25.0848 29.4248 25.0613 29.4421 25.0448L29.4623 25.0255L29.468 25.0199L29.4697 25.0184L29.4706 25.0175L29.8702 24.627L29.4706 24.2366L29.4697 24.2357L29.468 24.234L29.4623 24.2286L29.4421 24.2093C29.4248 24.1928 29.3999 24.1693 29.3681 24.1397C29.3045 24.0807 29.2128 23.9974 29.0983 23.898C28.8698 23.6995 28.5474 23.4341 28.1724 23.1675C27.7989 22.9021 27.3635 22.6285 26.9097 22.4198C26.4612 22.2134 25.9601 22.0541 25.4645 22.0541C24.9688 22.0541 24.4678 22.2134 24.0192 22.4198C23.5654 22.6285 23.1301 22.9021 22.7565 23.1675C22.3816 23.4341 22.0591 23.6995 21.8307 23.898C21.7161 23.9974 21.6245 24.0807 21.5609 24.1397C21.529 24.1693 21.5042 24.1928 21.4869 24.2093L21.4667 24.2286L21.461 24.234L21.4594 24.2357L21.4584 24.2366L21.068 24.618C21.0619 24.521 21.0588 24.423 21.0588 24.3243C21.0588 21.8166 23.0604 19.7838 25.5294 19.7838C27.9985 19.7838 30 21.8166 30 24.3243ZM21.4584 24.2366C21.4584 24.2368 21.4584 24.2366 21.8281 24.627L21.4584 24.2366ZM21.8281 24.627C21.4584 25.0175 21.4584 25.0173 21.4584 25.0175L21.8281 24.627ZM29.4706 24.2366L29.1009 24.627C29.4706 24.2366 29.4707 24.2368 29.4706 24.2366ZM29.1009 24.627L29.4706 25.0175C29.4707 25.0173 29.4706 25.0175 29.1009 24.627ZM22.6339 24.627C22.8319 24.7946 23.0844 24.9971 23.3682 25.1988C23.709 25.4412 24.0854 25.6755 24.4594 25.8475C24.8386 26.022 25.1815 26.1167 25.4645 26.1167C25.7474 26.1167 26.0903 26.022 26.4695 25.8475C26.8435 25.6755 27.2199 25.4412 27.5608 25.1988C27.8447 24.9971 28.0972 24.7946 28.295 24.627C28.0972 24.4594 27.8447 24.2569 27.5608 24.0551C27.2199 23.8129 26.8435 23.5786 26.4695 23.4065C26.0903 23.232 25.7474 23.1374 25.4645 23.1374C25.1815 23.1374 24.8386 23.232 24.4594 23.4065C24.0854 23.5786 23.709 23.8129 23.3682 24.0551C23.0844 24.2569 22.8319 24.4594 22.6339 24.627ZM25.4281 25.8458C26.0909 25.8458 26.6282 25.3002 26.6282 24.627C26.6282 23.9539 26.0909 23.4083 25.4281 23.4083C24.7655 23.4083 24.2281 23.9539 24.2281 24.627C24.2281 25.3002 24.7655 25.8458 25.4281 25.8458ZM13.2353 16.9459C13.2353 16.6325 13.4855 16.3784 13.7941 16.3784H20.5C20.8086 16.3784 21.0588 16.6325 21.0588 16.9459C21.0588 17.2594 20.8086 17.5135 20.5 17.5135H13.7941C13.4855 17.5135 13.2353 17.2594 13.2353 16.9459ZM13.7941 18.6486C13.4855 18.6486 13.2353 18.9028 13.2353 19.2162C13.2353 19.5296 13.4855 19.7838 13.7941 19.7838H21.6176C21.9262 19.7838 22.1765 19.5296 22.1765 19.2162C22.1765 18.9028 21.9262 18.6486 21.6176 18.6486H13.7941ZM13.2353 21.4865C13.2353 21.1731 13.4855 20.9189 13.7941 20.9189H19.3824C19.691 20.9189 19.9412 21.1731 19.9412 21.4865C19.9412 21.7999 19.691 22.0541 19.3824 22.0541H13.7941C13.4855 22.0541 13.2353 21.7999 13.2353 21.4865ZM13.7941 23.1892C13.4855 23.1892 13.2353 23.4433 13.2353 23.7568C13.2353 24.0702 13.4855 24.3243 13.7941 24.3243H19.3824C19.691 24.3243 19.9412 24.0702 19.9412 23.7568C19.9412 23.4433 19.691 23.1892 19.3824 23.1892H13.7941Z",
                fill: "#008B8F"
              })
            )
          ),
          onClose: function onClose() {
            _this3.setState({ open: false, addNewItem: false });
          },
          onOpen: asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this3.fetchDocument();

                  case 2:
                    _this3.setState({ open: true });

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, _this3);
          })),
          className: "upload-document",
          size: "fullscreen"
        },
        React__default.createElement(
          "div",
          { className: "upload-doc-img" },
          React__default.createElement("img", { src: "/images/DOC.svg" })
        ),
        React__default.createElement(
          Modal.Content,
          { scrolling: true },
          React__default.createElement(
            "h3",
            null,
            "Documents for Container ",
            containerNumber
          ),
          React__default.createElement(
            "div",
            { className: "uploadDocument" },
            React__default.createElement(
              "div",
              { className: "documentList" },
              React__default.createElement(
                Table,
                {
                  basic: "very",
                  className: "drayage-line-item-table content-static-card non-edit"
                },
                React__default.createElement(
                  Table.Header,
                  null,
                  React__default.createElement(
                    Table.Row,
                    null,
                    React__default.createElement(
                      Table.HeaderCell,
                      { className: "table-heading-cell" },
                      "Document"
                    ),
                    React__default.createElement(
                      Table.HeaderCell,
                      { className: "table-heading-cell text-align-center" },
                      "Uploaded"
                    )
                  )
                ),
                React__default.createElement(
                  Table.Body,
                  null,
                  React__default.createElement(
                    Form.Field,
                    null,
                    React__default.createElement("input", {
                      ref: this.fileRef,
                      style: { display: "none" },
                      onChange: function onChange(e) {
                        _this3.setNewFile(e);
                      },
                      type: "file",
                      label: "",
                      placeholder: ""
                    })
                  ),
                  Object.keys(get(this, "state.chargeFiles", {})).map(function (val, index) {
                    return React__default.createElement(
                      Table.Row,
                      {
                        key: index,
                        style: {
                          background: fileImageIndex === index ? "rgba(0, 139, 143, 0.2)" : "transparent"
                        }
                      },
                      React__default.createElement(
                        Table.Cell,
                        { className: "table-field-cell", width: "2" },
                        val
                      ),
                      React__default.createElement(
                        Table.Cell,
                        { className: "table-field-cell", width: "2" },
                        get(_this3, "state.chargeFiles[" + val + "]").map(function (mapValue) {
                          return React__default.createElement(
                            "div",
                            { style: { marginBottom: "25px" } },
                            React__default.createElement(
                              "div",
                              {
                                onClick: function onClick() {
                                  return _this3.setImageToShow(mapValue, index);
                                },
                                style: {
                                  display: "inline-block",
                                  cursor: "pointer"
                                }
                              },
                              get(mapValue, "displayName", "")
                            ),
                            !_this3.props.showOtherTab && React__default.createElement(
                              "div",
                              null,
                              React__default.createElement(Icon, {
                                className: "removeIcon",
                                color: "red",
                                name: "close",
                                onClick: function onClick() {
                                  return _this3.removeDoc(get(mapValue, "docId", ""));
                                }
                              })
                            )
                          );
                        })
                      ),
                      React__default.createElement(
                        Table.Cell,
                        { className: "table-field-cell", width: "2" },
                        !_this3.props.showOtherTab && React__default.createElement(
                          "svg",
                          {
                            width: "45",
                            height: "38",
                            viewBox: "0 0 45 38",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            onClick: function onClick(e) {
                              _this3.handleDropDownSelect(e, {
                                value: {
                                  chargeName: get(_this3, "state.chargeFiles[" + val + "][0]", "").chargeName,
                                  glCode: get(_this3, "state.chargeFiles[" + val + "][0]", "").glCode
                                }
                              });
                              _this3.fileRef.current.click();
                            }
                          },
                          React__default.createElement("rect", {
                            x: "1",
                            y: "1",
                            width: "43",
                            height: "36",
                            rx: "2"
                          }),
                          React__default.createElement("path", {
                            d: "M28.0118 13.9492C27.2688 11.0418 24.6007 9.00174 21.539 9C18.4772 8.99826 15.8067 11.0353 15.0602 13.9418C11.5051 14.2684 8.83993 17.2723 9.00748 20.7637C9.17504 24.255 12.1162 27.0011 15.6869 27H18.1937C18.6552 27 19.0293 26.6338 19.0293 26.1821C19.0293 25.7303 18.6552 25.3641 18.1937 25.3641H15.6869C12.918 25.3721 10.6668 23.1813 10.6588 20.4709C10.6507 17.7605 12.8888 15.557 15.6577 15.549C16.1018 15.5818 16.4991 15.2799 16.5768 14.8505C16.9286 12.4359 19.041 10.6421 21.5327 10.6421C24.0244 10.6421 26.1368 12.4359 26.4886 14.8505C26.5787 15.2631 26.9542 15.5556 27.3851 15.549C30.154 15.549 32.3987 17.7462 32.3987 20.4566C32.3987 23.167 30.154 25.3641 27.3851 25.3641H24.8784C24.4169 25.3641 24.0428 25.7303 24.0428 26.1821C24.0428 26.6338 24.4169 27 24.8784 27H27.3851C30.9277 26.9637 33.8262 24.2283 33.9925 20.7642C34.1589 17.3001 31.5353 14.3106 28.0118 13.9492Z",
                            fill: "#008B8F"
                          }),
                          React__default.createElement("path", {
                            d: "M25.5848 21.5233C25.9125 21.8354 26.4333 21.8309 26.7554 21.5133C27.0775 21.1956 27.0821 20.682 26.7656 20.3588L22.5904 16.2411C22.2643 15.9196 21.7357 15.9196 21.4096 16.2411L17.2344 20.3588C16.9179 20.682 16.9225 21.1956 17.2446 21.5133C17.5667 21.8309 18.0875 21.8354 18.4152 21.5233L21.165 18.8114V29.1765C21.165 29.6313 21.5388 30 22 30C22.4612 30 22.835 29.6313 22.835 29.1765V18.8114L25.5848 21.5233Z",
                            fill: "#008B8F"
                          })
                        )
                      )
                    );
                  }),
                  addNewItem && remaningDocument.newOption && React__default.createElement(
                    Table.Row,
                    null,
                    React__default.createElement(
                      Table.Cell,
                      { className: "table-field-cell", width: "1" },
                      React__default.createElement(Dropdown, {
                        value: currentSelectedCharge,
                        multiple: true,
                        clearable: true,
                        options: remaningDocument.newOption,
                        selection: true,
                        onChange: this.handleDropDownSelect
                      })
                    ),
                    React__default.createElement(
                      Table.Cell,
                      { className: "table-field-cell", width: "1" },
                      !progressStatus && get(this.state, "currentSelectedCharge", []).length ? React__default.createElement(
                        "span",
                        {
                          onClick: function onClick(e, data) {
                            // setCurrentSelectedCharge();
                            _this3.fileRef.current.click();
                          }
                        },
                        "UPLOAD"
                      ) : "",
                      get(selectedFiles, "getelectedCharge.name", "") && !progressStatus && React__default.createElement(
                        "div",
                        {
                          style: {
                            display: "inline-block"
                          }
                        },
                        get(selectedFiles, "getelectedCharge.name", "")
                      ),
                      progressStatus && React__default.createElement(
                        React__default.Fragment,
                        null,
                        React__default.createElement(
                          "span",
                          { className: "upload-percentage" },
                          "Uploading (" + progressStatus + "%)"
                        ),
                        React__default.createElement(
                          "div",
                          { className: "progressBar" },
                          React__default.createElement(
                            "div",
                            { id: "myProgress" },
                            React__default.createElement(
                              "div",
                              {
                                id: "myBar",
                                style: { width: progressStatus * 1 + "%" }
                              },
                              " "
                            )
                          ),
                          React__default.createElement("i", {
                            "aria-hidden": "true",
                            className: "green close icon upload-modal-close"
                          })
                        )
                      )
                    )
                  )
                )
              ),
              !addNewItem && remaningDocument.newOption && !this.props.showOtherTab && React__default.createElement(
                "div",
                { className: "addiDocumButton", onClick: this.addTableRows },
                React__default.createElement("i", {
                  "aria-hidden": "true",
                  className: "plus icon add-document"
                }),
                "Add Additional Documents"
              )
            ),
            React__default.createElement(
              "div",
              { className: "showDocument" },
              imageShow && React__default.createElement(
                React__default.Fragment,
                null,
                fileExtension == "pdf" ? React__default.createElement(PDFViewer, { url: imageShow }) : fileExtension == "pptx" || fileExtension == "xls" || fileExtension == "xlsx" || fileExtension == "csv" ? React__default.createElement(
                  Image,
                  { size: "small" },
                  React__default.createElement(Label, {
                    content: "Extension not supported!",
                    icon: "warning",
                    style: {
                      width: "300px",
                      height: "100px",
                      paddingTop: "35px",
                      paddingLeft: "55px"
                    }
                  })
                ) : React__default.createElement(Image, {
                  size: "large",
                  style: {
                    width: "auto",
                    height: "auto"
                  },
                  src: imageShow,
                  alt: "Image not found",
                  wrapped: true
                }),
                React__default.createElement(
                  "div",
                  { style: { height: "20px" } },
                  React__default.createElement(
                    "a",
                    { onClick: function onClick(e) {
                        return _this3.openInNewTab(imageShow);
                      } },
                    React__default.createElement(Icon, { name: "download" })
                  )
                )
              )
            )
          )
        ),
        React__default.createElement(
          Modal.Actions,
          { className: "ModalActionButtons" },
          React__default.createElement(
            Button,
            {
              className: "upload-document-btn",
              onClick: function onClick() {
                _this3.setState({ open: false });
              }
            },
            "DONE"
          )
        )
      );
    }
  }]);
  return UploadDocument;
}(Component);

var ModelContext$1 = createContext();
var CustomModal$1 = function (_React$Component) {
  inherits(CustomModal, _React$Component);

  function CustomModal(props) {
    classCallCheck(this, CustomModal);

    var _this = possibleConstructorReturn(this, (CustomModal.__proto__ || Object.getPrototypeOf(CustomModal)).call(this, props));

    _this.resetModal = function () {
      _this.context.setModalHeaderText("");
      _this.context.setDescriptionText("");
      _this.context.setDescriptionHeaderText("");
      _this.context.setCloseButtonText("");
      _this.context.setActionButtonText("");
      _this.context.setCloseButtonCallBack(function () {
        return function () {};
      });
      _this.context.setActionButtonCallBack(function () {
        return function () {};
      });
      _this.context.setModalSize("small");
      _this.context.setScrolling(false);
      _this.context.setCssClass("");
    };

    _this.state = {
      showModal: false
    };
    return _this;
  }

  createClass(CustomModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this.resetModal();
      // this.setState({ showModal: this.context.showModal });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // console.log("PROPSPROPS", prevProps);
      // if (this.context.showModal !== false) {
      //   this.resetModal();
      // }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        "div",
        null,
        React__default.createElement(
          "style",
          null,
          ".common-modal.ui.fullscreen.modal{\n            left: unset !important;\n          }\n            .common-modal  .close.icon{\n                    top: auto !important;\n                    position: relative !important;\n                    float: right !important;\n                    right: auto !important;\n                    color: #0A8B8F !important;\n                 }",
          " .ui.dimmer .common-modal .content {\n                width:100% !important;\n           }"
        ),
        React__default.createElement(
          Modal,
          {
            closeIcon: true,
            size: this.context.modalSize,
            onClose: function onClose() {
              _this2.context.setShowModal(false);
              _this2.resetModal();
            },
            onOpen: function onOpen() {
              return _this2.context.setShowModal(true);
            },
            open: this.context.showModal,
            className: "common-modal " + this.context.cssClass
          },
          React__default.createElement(
            Modal.Header,
            null,
            this.context.modalHeaderText
          ),
          React__default.createElement(
            Modal.Content,
            { scrolling: this.context.scrolling },
            React__default.createElement(
              Modal.Description,
              null,
              React__default.createElement(
                Header,
                null,
                this.context.descriptionHeaderText
              ),
              this.context.descriptionText
            )
          ),
          React__default.createElement(
            Modal.Actions,
            null,
            !isEmpty(this.context.closeButtonText) && React__default.createElement(
              Button,
              {
                onClick: function onClick() {
                  _this2.context.closeButtonCallBack();
                  _this2.context.setShowModal(false);
                  _this2.resetModal();
                }
              },
              this.context.closeButtonText
            ),
            !isEmpty(this.context.actionButtonText) && React__default.createElement(Button, {
              className: "primary",
              content: this.context.actionButtonText,
              onClick: function onClick() {
                _this2.context.actionButtonCallBack();
                _this2.context.setShowModal(false);
                _this2.resetModal();
              },
              positive: true
            })
          )
        )
      );
    }
  }]);
  return CustomModal;
}(React__default.Component);
CustomModal$1.contextType = ModelContext$1;
var ModalProvider$1 = function (_React$Component2) {
  inherits(ModalProvider, _React$Component2);

  function ModalProvider(props) {
    classCallCheck(this, ModalProvider);

    var _this3 = possibleConstructorReturn(this, (ModalProvider.__proto__ || Object.getPrototypeOf(ModalProvider)).call(this, props));

    _this3.setShowModal = function (value) {
      _this3.setState({ showModal: value, prevShowModel: _this3.state.showModal });
    };

    _this3.setModalHeaderText = function (value) {
      _this3.setState({ modalHeaderText: value });
    };

    _this3.setDescriptionText = function (value) {
      _this3.setState({ descriptionText: value });
    };

    _this3.setDescriptionHeaderText = function (value) {
      _this3.setState({ descriptionHeaderText: value });
    };

    _this3.setCloseButtonText = function (value) {
      _this3.setState({ closeButtonText: value });
    };

    _this3.setActionButtonText = function (value) {
      _this3.setState({ actionButtonText: value });
    };

    _this3.setCloseButtonCallBack = function (value) {
      _this3.setState({ closeButtonCallBack: value });
    };

    _this3.setActionButtonCallBack = function (value) {
      _this3.setState({ actionButtonCallBack: value });
    };

    _this3.setModalSize = function (value) {
      _this3.setState({ modalSize: value });
    };

    _this3.setScrolling = function (value) {
      _this3.setState({ scrolling: value });
    };

    _this3.setCssClass = function (value) {
      _this3.setState({ cssClass: value });
    };

    _this3.state = {
      prevShowModel: false,
      showModal: false,
      modalHeaderText: "",
      descriptionHeaderText: "",
      descriptionText: "",
      closeButtonText: "",
      actionButtonText: "",
      modalSize: "small",
      scrolling: false,
      cssClass: "",
      closeButtonCallBack: function closeButtonCallBack() {},
      actionButtonCallBack: function actionButtonCallBack() {}
    };
    return _this3;
  }

  createClass(ModalProvider, [{
    key: "render",
    value: function render() {
      return React__default.createElement(
        ModelContext$1.Provider,
        {
          value: {
            cssClass: this.state.cssClass,
            scrolling: this.state.scrolling,
            modalSize: this.state.modalSize,
            showModal: this.state.showModal,
            modalHeaderText: this.state.modalHeaderText,
            descriptionText: this.state.descriptionText,
            descriptionHeaderText: this.state.descriptionHeaderText,
            closeButtonText: this.state.closeButtonText,
            actionButtonText: this.state.actionButtonText,
            actionButtonCallBack: this.state.actionButtonCallBack,
            closeButtonCallBack: this.state.closeButtonCallBack,
            setShowModal: this.setShowModal,
            setModalHeaderText: this.setModalHeaderText,
            setDescriptionText: this.setDescriptionText,
            setDescriptionHeaderText: this.setDescriptionHeaderText,
            setCloseButtonText: this.setCloseButtonText,
            setActionButtonText: this.setActionButtonText,
            setCloseButtonCallBack: this.setCloseButtonCallBack,
            setActionButtonCallBack: this.setActionButtonCallBack,
            setModalSize: this.setModalSize,
            setScrolling: this.setScrolling,
            setCssClass: this.setCssClass
          }
        },
        this.props.children
      );
    }
  }]);
  return ModalProvider;
}(React__default.Component);

var DrayageInvoiceChangeLog$1 = function (_React$Component) {
  inherits(DrayageInvoiceChangeLog, _React$Component);

  function DrayageInvoiceChangeLog(props) {
    classCallCheck(this, DrayageInvoiceChangeLog);

    var _this = possibleConstructorReturn(this, (DrayageInvoiceChangeLog.__proto__ || Object.getPrototypeOf(DrayageInvoiceChangeLog)).call(this, props));

    _this.state = {
      containerId: null,
      logData: [],
      loading: false
    };
    return _this;
  }

  createClass(DrayageInvoiceChangeLog, [{
    key: "componentDidMount",
    value: function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var containerId, changeLogData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                containerId = get(this, "props.data.containerId", "");

                this.setState({ containerId: containerId, loading: true });

                if (!containerId) {
                  _context.next = 14;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return getDrayageChangeLog$1({ containerId: containerId });

              case 6:
                changeLogData = _context.sent;


                changeLogData = get(changeLogData, "data.eventMessage.changeLog", []);
                this.setState({ logData: [].concat(toConsumableArray(changeLogData)), loading: false });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);

                this.setState({ logData: [], loading: false });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 11]]);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(prevProps, prevState) {
        var containerId, prevgContainerId, changeLogData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                containerId = get(prevProps, "data.containerId", "");
                prevgContainerId = get(this, "props.data.containerId", "");

                if (!(containerId !== prevgContainerId)) {
                  _context2.next = 15;
                  break;
                }

                this.setState({ containerId: containerId, loading: false });

                _context2.prev = 4;
                _context2.next = 7;
                return getDrayageChangeLog$1({ containerId: containerId });

              case 7:
                changeLogData = _context2.sent;


                changeLogData = get(changeLogData, "data.eventMessage.changeLog", []);
                this.setState({ logData: [].concat(toConsumableArray(changeLogData)), loading: false });
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](4);

                this.setState({ logData: [], loading: false });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 12]]);
      }));

      function componentDidUpdate(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement(
        Table,
        { size: "large", color: "teal" },
        React__default.createElement(
          Table.Header,
          null,
          React__default.createElement(
            Table.Row,
            null,
            React__default.createElement(
              Table.HeaderCell,
              null,
              "Action"
            ),
            React__default.createElement(
              Table.HeaderCell,
              null,
              "Comment"
            ),
            React__default.createElement(
              Table.HeaderCell,
              null,
              "Commented By"
            ),
            React__default.createElement(
              Table.HeaderCell,
              null,
              "Date (MMM DD, YYYY)"
            )
          )
        ),
        React__default.createElement(
          Table.Body,
          null,
          this.state.loading && React__default.createElement(
            Table.Row,
            null,
            React__default.createElement(
              Table.Cell,
              { colSpan: "5" },
              React__default.createElement(
                Segment,
                { style: { marginTop: "50px", marginBottom: "50px" } },
                React__default.createElement(
                  Dimmer,
                  { active: true, inverted: true },
                  React__default.createElement(
                    Loader,
                    { size: "large" },
                    "Loading"
                  )
                )
              )
            )
          ),
          get(this.state, "logData", []).map(function (val) {
            var date = !isEmpty(get(val, "createdDate", "").toString().trim()) ? get(val, "createdDate", 0) : 0;
            return React__default.createElement(
              Table.Row,
              null,
              React__default.createElement(
                Table.Cell,
                null,
                get(val, "action", "").split("_").map(function (val) {
                  return upperFirst(lowerCase(val));
                }).join(" ")
              ),
              React__default.createElement(
                Table.Cell,
                null,
                get(val, "comment", "")
              ),
              React__default.createElement(
                Table.Cell,
                null,
                get(val, "commentedBy", "")
              ),
              React__default.createElement(
                Table.Cell,
                null,
                parseInt(date) > 0 ? moment$1(parseInt(date)).format("MMM DD, YYYY").toUpperCase() : "-"
              )
            );
          })
        )
      );
    }
  }]);
  return DrayageInvoiceChangeLog;
}(React__default.Component);

var getFormatedCurrencyWithoutDivision = function getFormatedCurrencyWithoutDivision(value, country) {
  if (value % 1 === 0) {
    value = value.toFixed(2);
  }
  var currencySymbol = CountryCurrencyMap["" + country] || "";
  return currencySymbol + " " + value;
};

var DrayagePartnerApproved = function (_Component) {
  inherits(DrayagePartnerApproved, _Component);

  function DrayagePartnerApproved(props) {
    var _this2 = this;

    classCallCheck(this, DrayagePartnerApproved);

    var _this = possibleConstructorReturn(this, (DrayagePartnerApproved.__proto__ || Object.getPrototypeOf(DrayagePartnerApproved)).call(this, props));

    _this.handleModal = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var typeOfUser, drayageCharge, totalBaseCharge, approveDate, baseChargeList, laneAdditionalChargeList, portChargeList;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              typeOfUser = 'DRAYAGE_PARTNER_USER';
              _context.next = 3;
              return drayageChargeDetails({ containerId: _this.props.containerId, typeOfUser: typeOfUser });

            case 3:
              drayageCharge = _context.sent;
              totalBaseCharge = lodash_1(drayageCharge, "data.eventMessage", "");
              approveDate = _this.props.getFormatedDate(totalBaseCharge.submittedOn);

              console.log("approveDate", totalBaseCharge.submittedOn);
              _this.setState({ totalBaseCharge: totalBaseCharge.totalBaseCharge, totalLaneAdditionalCharge: totalBaseCharge.totalLaneAdditionalCharge, totalPortCharge: totalBaseCharge.totalPortCharge, approvedBy: totalBaseCharge.submittedBy, approvedOn: approveDate, opportunityName: totalBaseCharge.opportunityDetails.opportunityName, opportunityCountry: totalBaseCharge.opportunityDetails.opportunityCountry });
              baseChargeList = lodash_1(drayageCharge, "data.eventMessage.baseChargeList", "");

              _this.setState({ baseChargeList: baseChargeList });
              laneAdditionalChargeList = lodash_1(drayageCharge, "data.eventMessage.laneAdditionalChargeList", "");

              _this.setState({ laneAdditionalChargeList: laneAdditionalChargeList });

              portChargeList = lodash_1(drayageCharge, "data.eventMessage.portChargeList", "");

              _this.setState({ portChargeList: portChargeList });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.state = {
      baseChargeList: "",
      laneAdditionalChargeList: "",
      totalBaseCharge: "",
      totalLaneAdditionalCharge: "",
      approvedBy: "",
      approvedOn: "",
      opportunityName: "",
      portChargeList: "",
      totalPortCharge: "",
      opportunityCountry: ""
    };
    return _this;
  }

  createClass(DrayagePartnerApproved, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          Open = _props.Open,
          ModalClose = _props.ModalClose;
      var _state = this.state,
          baseChargeList = _state.baseChargeList,
          laneAdditionalChargeList = _state.laneAdditionalChargeList,
          portChargeList = _state.portChargeList,
          totalPortCharge = _state.totalPortCharge,
          totalBaseCharge = _state.totalBaseCharge,
          totalLaneAdditionalCharge = _state.totalLaneAdditionalCharge,
          approvedBy = _state.approvedBy,
          approvedOn = _state.approvedOn,
          opportunityName = _state.opportunityName,
          opportunityCountry = _state.opportunityCountry;


      return React__default.createElement(
        Modal,
        { closeIcon: true,
          open: Open,
          onClose: ModalClose,
          onOpen: Open,
          size: 'tiny',
          className: "sales-visibility",
          closeOnDocumentClick: false,
          closeOnDimmerClick: false,
          trigger: React__default.createElement(
            "span",
            { onClick: this.handleModal },
            "Drayage Partner Approved Rates"
          )
        },
        React__default.createElement(
          Modal.Content,
          { className: "visibility-modal" },
          React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              null,
              React__default.createElement(
                "span",
                null,
                "Opportunity Name:"
              ),
              React__default.createElement(
                "span",
                null,
                opportunityName
              )
            )
          ),
          baseChargeList.length > 0 && React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Base Charges:"
              )
            ),
            baseChargeList.map(function (value) {
              return React__default.createElement(
                "li",
                null,
                React__default.createElement(
                  "span",
                  null,
                  value.chargeName
                ),
                React__default.createElement(
                  "span",
                  null,
                  getFormatedCurrencyWithoutDivision(value.amount, opportunityCountry)
                )
              );
            }),
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Total:"
              ),
              React__default.createElement(
                "span",
                null,
                getFormatedCurrencyWithoutDivision(totalBaseCharge, opportunityCountry)
              )
            )
          ),
          laneAdditionalChargeList.length > 0 && React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Lane Addl. Charges:"
              )
            ),
            laneAdditionalChargeList.map(function (val) {
              return React__default.createElement(
                "li",
                null,
                React__default.createElement(
                  "span",
                  null,
                  val.chargeName
                ),
                React__default.createElement(
                  "span",
                  null,
                  getFormatedCurrencyWithoutDivision(val.amount, opportunityCountry)
                )
              );
            }),
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Total:"
              ),
              React__default.createElement(
                "span",
                null,
                getFormatedCurrencyWithoutDivision(totalLaneAdditionalCharge, opportunityCountry)
              )
            )
          ),
          portChargeList.length > 0 && React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Port Charges:"
              )
            ),
            portChargeList.map(function (val) {
              return React__default.createElement(
                "li",
                null,
                React__default.createElement(
                  "span",
                  null,
                  val.chargeName
                ),
                React__default.createElement(
                  "span",
                  null,
                  getFormatedCurrencyWithoutDivision(val.amount, opportunityCountry)
                )
              );
            }),
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Total:"
              ),
              React__default.createElement(
                "span",
                null,
                getFormatedCurrencyWithoutDivision(totalPortCharge, opportunityCountry)
              )
            )
          ),
          React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              null,
              React__default.createElement(
                "span",
                null,
                "Approved By:"
              ),
              React__default.createElement(
                "span",
                null,
                approvedBy
              )
            ),
            React__default.createElement(
              "li",
              null,
              React__default.createElement(
                "span",
                null,
                "Approval Date:"
              ),
              React__default.createElement(
                "span",
                null,
                approvedOn
              )
            )
          )
        )
      );
    }
  }]);
  return DrayagePartnerApproved;
}(Component);

var DrayageCustomerApproved = function (_Component) {
  inherits(DrayageCustomerApproved, _Component);

  function DrayageCustomerApproved(props) {
    var _this2 = this;

    classCallCheck(this, DrayageCustomerApproved);

    var _this = possibleConstructorReturn(this, (DrayageCustomerApproved.__proto__ || Object.getPrototypeOf(DrayageCustomerApproved)).call(this, props));

    _this.handleModal = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var typeOfUser, drayageCharge, totalBaseCharge, approveDate, baseChargeList, laneAdditionalChargeList, portChargeList;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              typeOfUser = 'CUSTOMER_USER';
              _context.next = 3;
              return drayageChargeDetails({ containerId: _this.props.containerId, typeOfUser: typeOfUser });

            case 3:
              drayageCharge = _context.sent;
              totalBaseCharge = lodash_1(drayageCharge, "data.eventMessage", "");
              approveDate = _this.props.getFormatedDate(totalBaseCharge.approvedOn);

              _this.setState({ totalBaseCharge: totalBaseCharge.totalBaseCharge, totalLaneAdditionalCharge: totalBaseCharge.totalLaneAdditionalCharge, totalPortCharge: totalBaseCharge.totalPortCharge, approvedBy: totalBaseCharge.approvedBy, approvedOn: approveDate, opportunityName: totalBaseCharge.opportunityDetails.opportunityName, opportunityCountry: totalBaseCharge.opportunityDetails.opportunityCountry });
              baseChargeList = lodash_1(drayageCharge, "data.eventMessage.baseChargeList", "");

              _this.setState({ baseChargeList: baseChargeList });
              laneAdditionalChargeList = lodash_1(drayageCharge, "data.eventMessage.laneAdditionalChargeList", "");

              _this.setState({ laneAdditionalChargeList: laneAdditionalChargeList });

              portChargeList = lodash_1(drayageCharge, "data.eventMessage.portChargeList", "");

              _this.setState({ portChargeList: portChargeList });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.state = {
      baseChargeList: "",
      laneAdditionalChargeList: "",
      totalBaseCharge: "",
      totalLaneAdditionalCharge: "",
      approvedBy: "",
      approvedOn: "",
      opportunityName: "",
      portChargeList: "",
      totalPortCharge: "",
      opportunityCountry: ""
    };
    return _this;
  }

  createClass(DrayageCustomerApproved, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          Open = _props.Open,
          ModalClose = _props.ModalClose;
      var _state = this.state,
          baseChargeList = _state.baseChargeList,
          laneAdditionalChargeList = _state.laneAdditionalChargeList,
          portChargeList = _state.portChargeList,
          totalPortCharge = _state.totalPortCharge,
          totalBaseCharge = _state.totalBaseCharge,
          totalLaneAdditionalCharge = _state.totalLaneAdditionalCharge,
          approvedBy = _state.approvedBy,
          approvedOn = _state.approvedOn,
          opportunityName = _state.opportunityName,
          opportunityCountry = _state.opportunityCountry;


      return React__default.createElement(
        Modal,
        { closeIcon: true,
          open: Open,
          onClose: ModalClose,
          onOpen: Open,
          size: 'tiny',
          className: "sales-visibility",
          closeOnDocumentClick: false,
          closeOnDimmerClick: false,
          trigger: React__default.createElement(
            "span",
            { onClick: this.handleModal },
            "Customer Approved Rates"
          )
        },
        React__default.createElement(
          Modal.Content,
          { className: "visibility-modal" },
          React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              null,
              React__default.createElement(
                "span",
                null,
                "Opportunity Name:"
              ),
              React__default.createElement(
                "span",
                null,
                opportunityName
              )
            )
          ),
          baseChargeList.length > 0 && React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Base Charges:"
              )
            ),
            baseChargeList.map(function (value) {
              return React__default.createElement(
                "li",
                null,
                React__default.createElement(
                  "span",
                  null,
                  value.chargeName
                ),
                React__default.createElement(
                  "span",
                  null,
                  getFormatedCurrencyWithoutDivision(value.amount, opportunityCountry)
                )
              );
            }),
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Total:"
              ),
              React__default.createElement(
                "span",
                null,
                getFormatedCurrencyWithoutDivision(totalBaseCharge, opportunityCountry)
              )
            )
          ),
          laneAdditionalChargeList.length > 0 && React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Lane Addl. Charges:"
              )
            ),
            laneAdditionalChargeList.map(function (val) {
              return React__default.createElement(
                "li",
                null,
                React__default.createElement(
                  "span",
                  null,
                  val.chargeName
                ),
                React__default.createElement(
                  "span",
                  null,
                  getFormatedCurrencyWithoutDivision(val.amount, opportunityCountry)
                )
              );
            }),
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Total:"
              ),
              React__default.createElement(
                "span",
                null,
                getFormatedCurrencyWithoutDivision(totalLaneAdditionalCharge, opportunityCountry)
              )
            )
          ),
          portChargeList.length > 0 && React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Port Charges:"
              )
            ),
            portChargeList.map(function (val) {
              return React__default.createElement(
                "li",
                null,
                React__default.createElement(
                  "span",
                  null,
                  val.chargeName
                ),
                React__default.createElement(
                  "span",
                  null,
                  getFormatedCurrencyWithoutDivision(val.amount, opportunityCountry)
                )
              );
            }),
            React__default.createElement(
              "li",
              { className: "visibility-base" },
              React__default.createElement(
                "span",
                null,
                "Total:"
              ),
              React__default.createElement(
                "span",
                null,
                getFormatedCurrencyWithoutDivision(totalPortCharge, opportunityCountry)
              )
            )
          ),
          React__default.createElement(
            "ul",
            null,
            React__default.createElement(
              "li",
              null,
              React__default.createElement(
                "span",
                null,
                "Approved By:"
              ),
              React__default.createElement(
                "span",
                null,
                approvedBy
              )
            ),
            React__default.createElement(
              "li",
              null,
              React__default.createElement(
                "span",
                null,
                "Approval Date:"
              ),
              React__default.createElement(
                "span",
                null,
                approvedOn
              )
            )
          )
        )
      );
    }
  }]);
  return DrayageCustomerApproved;
}(Component);

function Date$7(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var SalesPendingCardHeader = function (_Component) {
  inherits(SalesPendingCardHeader, _Component);

  function SalesPendingCardHeader(props) {
    var _this2 = this;

    classCallCheck(this, SalesPendingCardHeader);

    var _this = possibleConstructorReturn(this, (SalesPendingCardHeader.__proto__ || Object.getPrototypeOf(SalesPendingCardHeader)).call(this, props));

    _this.getFormatedDate = function (date) {
      var dateVal = parseInt(date);
      if (!Number(dateVal) || !dateVal === "") {
        return "";
      }

      var someday = moment$1(dateVal);

      return someday.format("MMMM DD YYYY");
    };

    _this.handleChange = function (e, _ref2) {
      var value = _ref2.value;
      var selectedDropdownData = _this.props.selectedDropdownData;

      var data = _this.props.data.chargeDesc.billingParties.billToList.filter(function (currentBill) {
        if (currentBill.customerName.toLowerCase() === value.toLowerCase()) {
          return currentBill;
        }
      });
      selectedDropdownData(data || {});
    };

    _this.handleClose = function () {
      _this.setState({ modalOpen: false, isOpen: false });
    };

    _this.handleOpen = function () {
      _this.setState({ modalOpen: true, isOpen: true });
    };

    _this.setInfoMessages = function (key, message) {
      _this.setState(defineProperty({}, key, message), function () {
        return setTimeout(function () {
          _this.setState(defineProperty({}, key, ""));
        }, 2000);
      });
    };

    _this.editRefrenceNumber = function (cardIndex) {
      _this.setState({ refrenceNumberInput: true });
      console.log("editRefrenceNumber", cardIndex);
    };

    _this.brokerCodeHandler = function (event, result, index) {
      var brokervalue = event.target.value;
      _this.setState({ salesReferenceNumber: brokervalue });
    };

    _this.cancelRefrenceNumber = function () {
      _this.setState({ refrenceNumberInput: false });
      _this.setState({ salesReferenceNumber: lodash_1(_this.props.data, "referenceNumber", "") });
    };

    _this.onSubmit = function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(index, drayageInvoiceNumber) {
        var salesReferenceNumber, drayagePartnerId, referenceLogData, code, msg, newEntry;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                salesReferenceNumber = _this.state.salesReferenceNumber;
                drayagePartnerId = lodash_1(_this.props, 'data.drayagePartnerId', '');
                _context.prev = 2;

                if (!salesReferenceNumber) {
                  _context.next = 12;
                  break;
                }

                _context.next = 6;
                return referenceNumberUpdate({ referenceNumber: salesReferenceNumber, drayageInvoiceNumber: drayageInvoiceNumber, drayagePartnerId: drayagePartnerId });

              case 6:
                referenceLogData = _context.sent;
                code = lodash_1(referenceLogData, "data.eventMessage.code", "");
                msg = lodash_1(referenceLogData, "data.eventMessage.msg", "");

                if (code === 200) {
                  newEntry = _extends({}, _this.props.data);

                  newEntry.referenceNumber = salesReferenceNumber;
                  _this.props.setRefNum && _this.props.setRefNum(newEntry);
                  _this.setInfoMessages("successMsg", "Reference Number updated successfully.");
                  _this.setState({ refrenceNumberInput: false });
                } else {
                  _this.setInfoMessages("errorMsg", msg);
                }
                _context.next = 13;
                break;

              case 12:
                _this.setInfoMessages("errorMsg", "Account reference number can not be empty.");

              case 13:
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);

                _this.setInfoMessages("errorMsg", "Some error occurred. Unable to save reference number.");
                _this.setState({ refrenceNumberInput: true });

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 15]]);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.state = {
      modalOpen: false,
      isOpen: false,
      refrenceNumberInput: false,
      errorMsg: "",
      successMsg: "",
      salesReferenceNumber: lodash_1(_this.props.data, "referenceNumber", "")
    };
    return _this;
  }

  createClass(SalesPendingCardHeader, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          option = _props.option,
          defaultOption = _props.defaultOption,
          cardIndex = _props.cardIndex,
          data = _props.data;

      var countryName = "";
      var countryImage = "";
      if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "US") {
        countryName = "USA";
        countryImage = "/images/US.jpg";
      } else if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "CANADA" || lodash_1(this.props, "data.chargeDesc.countryCode", "") === "CA") {
        countryName = "CANADA";
        countryImage = "/images/Canda.jpg";
      } else if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "UK") {
        countryName = "UK";
        countryImage = "/images/Uk.jpg";
      } else if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "ES") {
        countryName = "SPAIN";
        countryImage = "/images/spain.jpg";
      } else if (lodash_1(this.props, "data.chargeDesc.countryCode", "") === "NL") {
        countryName = "NL";
        countryImage = "/images/NL.jpg";
      }
      var countryForCurrencyCode = lodash_1(this.props, "data.chargeDesc.chargeDesc[0].countryForCurrency", "");

      return React__default.createElement(
        React__default.Fragment,
        null,
        this.state.successMsg && React__default.createElement(
          "div",
          { className: "isgeneraed-in isgeneraed-in-msg" },
          React__default.createElement(
            Message,
            { positive: true, size: "tiny", className: "info-message" },
            React__default.createElement(
              Message.Header,
              null,
              this.state.successMsg
            )
          )
        ),
        this.state.errorMsg && React__default.createElement(
          Message,
          { negative: true, size: "tiny", className: "info-message" },
          React__default.createElement(
            Message.Header,
            null,
            this.state.errorMsg
          )
        ),
        React__default.createElement(
          Statistic.Group,
          {
            size: "mini",
            className: "pendingList-table",
            style: { marginBottom: "5px" }
          },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "20px"
              }
            },
            cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
              onClick: function onClick(e) {
                return _this3.props.expandCard(_this3.props.cardIndex);
              },
              name: "plus circle",
              className: "card-toggle-icon"
            }),
            cardIndex === this.props.activeCard && React__default.createElement(Icon, {
              onClick: function onClick(e) {
                return _this3.props.expandCard(_this3.props.cardIndex);
              },
              name: "minus circle",
              className: "card-toggle-icon"
            }),
            React__default.createElement(
              Statistic,
              { className: "statistic-country" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "data.drayageInvoiceNumber", "")
              )
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "COUNTRY"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                React__default.createElement("img", { src: countryImage, className: "countryIcon" }),
                countryName
              )
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "SHIPMENT ID#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this, "props.data.chargeDesc.shipmentID", "")
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props.data, "chargeDesc.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props.data, "chargeDesc.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$7, { date: lodash_1(this.props.data, "createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "ACC REF NO"
            ),
            !this.state.refrenceNumberInput && React__default.createElement(
              Statistic.Value,
              { className: "statistic-value", style: { "max-width": "100px", "word-wrap": "break-word", "white-space": "normal" } },
              this.state.salesReferenceNumber,
              React__default.createElement("i", { "class": "edit outline icon btn-over", onClick: function onClick(e) {
                  return _this3.editRefrenceNumber(_this3.props.cardIndex);
                }, style: { "border": "none", "margin-left": "4px" } })
            ),
            this.state.refrenceNumberInput && React__default.createElement(
              Statistic.Value,
              { className: "statistic-value", style: { "text-align": "left" } },
              React__default.createElement(Input$1, {
                name: "brokerReferenceNumber",
                value: this.state.salesReferenceNumber,
                onChange: function onChange(event, result) {
                  return _this3.brokerCodeHandler(event, result, _this3.props.cardIndex);
                },
                style: { "maxWidth": "40%" },
                maxLength: 30
              }),
              React__default.createElement("i", { "class": "save outline icon btn-over", onClick: function onClick(e) {
                  return _this3.onSubmit(_this3.props.cardIndex, lodash_1(_this3.props, "data.drayageInvoiceNumber", ""));
                }, style: { "border": "none", "margin-left": "2px" } }),
              React__default.createElement("i", { "class": "window close outline icon btn-over", onClick: function onClick(e) {
                  return _this3.cancelRefrenceNumber(_this3.props.cardIndex);
                }, style: { "border": "none", "margin-left": "2px" } })
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props.data, "chargeDesc.totalAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "10px"
              }
            },
            React__default.createElement(Popup, {
              closeIcon: true,
              trigger: React__default.createElement("i", {
                // style={getStyleBasedOnNegativeMargin(
                //   get(this, "props.data.chargeDesc.chargeDesc", [])
                // )}
                "class": "info icon visibility-icon btn-over"
              }),
              className: "approved-rate",
              content: React__default.createElement(
                Grid,
                { centered: true, columns: 1 },
                React__default.createElement(
                  Grid.Column,
                  { textAlign: "center" },
                  React__default.createElement(DrayagePartnerApproved, {
                    containerId: lodash_1(this.props.data, "chargeDesc.containerId", ""),
                    ModalClose: this.handleClose,
                    getFormatedDate: this.getFormatedDate,
                    getFormatedCurrency: this.props.getFormatedCurrency
                  })
                ),
                React__default.createElement(
                  Grid.Column,
                  { textAlign: "center" },
                  React__default.createElement(DrayageCustomerApproved, {
                    containerId: lodash_1(this.props.data, "chargeDesc.containerId", ""),
                    ModalClose: this.handleClose,
                    getFormatedDate: this.getFormatedDate,
                    getFormatedCurrency: this.props.getFormatedCurrency
                  })
                ),
                React__default.createElement("i", {
                  "class": "close icon visibility-close",
                  onClick: this.handleClose
                })
              ),
              on: "click",
              open: this.state.isOpen,
              onOpen: this.handleOpen,
              onClose: this.handleClose
            }),
            React__default.createElement(UploadDocument$1, {
              containerId: lodash_1(this.props.data, "chargeDesc.containerId", ""),
              containerNumber: lodash_1(this.props.data, "chargeDesc.containerNumber", ""),
              chargeDesc: lodash_1(this.props.data, "chargeDesc.chargeDesc", ""),
              showOtherTab: true
            }),
            React__default.createElement(
              "span",
              {
                className: "btn-over",
                onClick: function onClick() {
                  var context = _this3.context;
                  context.setModalSize("fullscreen");
                  context.setShowModal(true);
                  context.setModalHeaderText("CHANGE LOG FOR " + lodash_1(_this3.props, "data.containerNumber", ""));
                  context.setDescriptionText(React__default.createElement(DrayageInvoiceChangeLog$1, { data: lodash_1(_this3.props, "data", {}) }));
                  context.setDescriptionHeaderText("");
                  // context.setCloseButtonText("Cancels");
                  // context.setActionButtonText("Raise Dispute");
                }
              },
              React__default.createElement(Icon, {
                style: {
                  padding: "10px 4px",
                  color: "#08adb6",
                  fontSize: "1.4em"
                },
                name: "history"
              })
            )
          )
        )
      );
    }
  }]);
  return SalesPendingCardHeader;
}(Component);

SalesPendingCardHeader.contextType = ModelContext$1;

var UOM$2 = [{ text: "PER DAY", value: "PER DAY", key: "PER DAY" }, { text: "PER UNIT", value: "PER UNIT", key: "PER UNIT" }, { text: "PER HOUR", value: "PER HOUR", key: "PER HOUR" }, { text: "PER STATE", value: "PER STATE", key: "PER STATE" }, { text: "APMT", value: "APMT", key: "APMT" }];

var SalesPendingCardEdit = function (_Component) {
  inherits(SalesPendingCardEdit, _Component);

  function SalesPendingCardEdit(props) {
    classCallCheck(this, SalesPendingCardEdit);

    var _this = possibleConstructorReturn(this, (SalesPendingCardEdit.__proto__ || Object.getPrototypeOf(SalesPendingCardEdit)).call(this, props));

    _this.state = {
      chargeDesc: [],
      saveBtnClicked: false
    };
    return _this;
  }

  createClass(SalesPendingCardEdit, [{
    key: "deepEqual",
    value: function deepEqual(object1, object2) {
      var areObjects = this.isObject(object1) && this.isObject(object2);
      if (areObjects) {
        var keys1 = Object.keys(object1);
        var keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
          return false;
        }
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var val1 = object1[key];
            var val2 = object2[key];
            var _areObjects = this.isObject(val1) && this.isObject(val2);
            if (_areObjects && !this.deepEqual(val1, val2) || !_areObjects && val1 !== val2) {
              return false;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return true;
      }
      return false;
    }
  }, {
    key: "isObject",
    value: function isObject(object) {
      return object !== null && object !== undefined && (typeof object === "undefined" ? "undefined" : _typeof(object)) === "object";
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  chargeDesc: lodash_1(this.props, "data.chargeDesc.chargeDesc", [])
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.deepEqual(lodash_1(prevProps, "data.chargeDesc.chargeDesc", [])) !== this.deepEqual(lodash_1(this.props, "data.chargeDesc.chargeDesc", []))) {
        this.setState({
          chargeDesc: lodash_1(this.props, "data.chargeDesc.chargeDesc", [])
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table edit-card-list non-edit"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "SUB-TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "MARGIN(%)"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "VENDOR INVOICE NO."
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "COMMENT"
                ),
                React__default.createElement(Table.HeaderCell, { className: "table-heading-cell" })
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(SalesPendingRow, {
                  key: index,
                  index: _this2.props.index,
                  rowIndex: index,
                  chargesOptions: _this2.props.chargesOptions,
                  updateSalesPendingLineItem: _this2.props.updateSalesPendingLineItem,
                  deleteChargeLineItem: _this2.props.deleteChargeLineItem,
                  val: val,
                  getFormatedCurrency: _this2.props.getFormatedCurrency,
                  countryCode: _this2.props.data.chargeDesc.countryCode,
                  addChargeToInvoice: _this2.props.addChargeToInvoice,
                  addAllChargeToInvoice: _this2.props.addAllChargeToInvoice,
                  nonEditableGlCodes: _this2.props.nonEditableGlCodes,
                  unitPriceValue: _this2.props.unitPriceValue,
                  selectedCharge: _this2.props.selectedCharge,
                  unitPriceVal: _this2.props.unitPriceVal,
                  uom: _this2.props.uom
                });
              }),
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.Cell,
                  {
                    colSpan: "12",
                    className: "table-field-cell text-align-center"
                  },
                  React__default.createElement(
                    "div",
                    { className: "table-action-btns" },
                    React__default.createElement(
                      "div",
                      null,
                      React__default.createElement(
                        Button,
                        {
                          loading: this.state.saveBtnClicked,
                          className: "save-invoice-btn",
                          onClick: function onClick(e) {
                            if (_this2.state.saveBtnClicked === false) {
                              _this2.setState({ saveBtnClicked: true }, function () {
                                _this2.props.saveSalesPendingData(_this2.props.index).then(function () {
                                  _this2.setState({ saveBtnClicked: false });
                                });
                              });
                            }
                          }
                        },
                        "SAVE"
                      ),
                      React__default.createElement(
                        Button,
                        {
                          className: "create-invoice-btn",
                          onClick: function onClick(e) {
                            _this2.props.cancelSalesPendingEdit(_this2.props.index, _this2.state.chargeDesc);
                          }
                        },
                        "CANCEL"
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return SalesPendingCardEdit;
}(Component);

var SalesPendingRow = function (_Component2) {
  inherits(SalesPendingRow, _Component2);

  function SalesPendingRow(props) {
    var _this4 = this;

    classCallCheck(this, SalesPendingRow);

    var _this3 = possibleConstructorReturn(this, (SalesPendingRow.__proto__ || Object.getPrototypeOf(SalesPendingRow)).call(this, props));

    _this3.showConfirm = function () {
      _this3.setState({ showConfirm: true });
    };

    _this3.handleConfirm = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.props.deleteChargeLineItem(_this3.props.index, _this3.props.rowIndex);

            case 2:
              _this3.setState({ showConfirm: false });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }));

    _this3.handleCancel = function () {
      return _this3.setState({ showConfirm: false });
    };

    _this3.state = {
      quantity: "",
      unitPrice: "",
      showConfirm: false
    };
    return _this3;
  }

  createClass(SalesPendingRow, [{
    key: "componentDidUpdate",
    value: function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(prevProps) {
        var quantity, unitPrice, total, subtotal, subTotal, margin, _unitPrice, calculatedMargin, value;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(lodash_1(this.props.val, "quantity", "") !== lodash_1(prevProps.val, "quantity", "") || lodash_1(this.props.val, "unitPrice", "") !== lodash_1(prevProps.val, "unitPrice", ""))) {
                  _context3.next = 9;
                  break;
                }

                quantity = parseInt(lodash_1(this.props.val, "quantity", 0));
                unitPrice = parseFloat(lodash_1(this.props.val, "unitPrice", 0));

                quantity = isNaN(quantity) ? 0 : quantity;
                unitPrice = isNaN(unitPrice) ? 0 : unitPrice;
                total = parseFloat(quantity * unitPrice) * 100;

                total = isNaN(parseFloat(total)) ? 0.0 : total;

                _context3.next = 9;
                return this.props.updateSalesPendingLineItem(this.props.index, this.props.rowIndex, "subTotal", total);

              case 9:
                subtotal = parseFloat(lodash_1(this.props.val, "subTotal", 0));

                if (!(!isNaN(subtotal) && (lodash_1(this.props.val, "subTotal", "") !== lodash_1(prevProps.val, "subTotal", "") || lodash_1(this.props.val, "markUPAmount", "") !== lodash_1(prevProps.val, "markUPAmount", "")))) {
                  _context3.next = 24;
                  break;
                }

                subTotal = parseFloat(lodash_1(this.props.val, "subTotal", 0));

                subTotal = isNaN(subTotal) ? 0.0 : subTotal / 100;

                margin = parseFloat(lodash_1(this.props.val, "markUPAmount", 0));


                margin = isNaN(margin) ? 0 : margin;

                //if (!isNaN(margin) && margin > 0) {
                _unitPrice = parseFloat(lodash_1(this.props.val, "unitPrice", 0));
                calculatedMargin = parseFloat(1 - parseFloat(margin) / 100);
                value = parseFloat(subTotal / calculatedMargin);

                if (!(calculatedMargin === 0)) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 21;
                return this.props.updateSalesPendingLineItem(this.props.index, this.props.rowIndex, "markUPAmount", 0);

              case 21:
                value = subTotal;

              case 22:
                _context3.next = 24;
                return this.props.updateSalesPendingLineItem(this.props.index, this.props.rowIndex, "totalRate", value.toFixed(2));

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidUpdate(_x) {
        return _ref3.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          index = _props.index,
          rowIndex = _props.rowIndex,
          val = _props.val,
          chargesOptions = _props.chargesOptions,
          updateSalesPendingLineItem = _props.updateSalesPendingLineItem,
          deleteChargeLineItem = _props.deleteChargeLineItem;


      var deleteMessage = "Are you sure you want to remove the line item?";
      deleteMessage = !lodash_2(lodash_1(val, "chargeName", "")) ? "Are you sure you want to remove the charge - " + lodash_1(val, "chargeName", "") + "?" : deleteMessage;
      return React__default.createElement(
        Table.Row,
        { key: "chargelist-" + rowIndex },
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          lodash_1(val, "new", false) === true && React__default.createElement(Form.Field, {
            disabled: lodash_1(val, "new", false) !== true,
            control: Select,
            label: "",
            value: lodash_1(val, "new", false) === true ? lodash_1(val, "glCode", "") : lodash_1(val, "chargeName", ""),
            options: this.props.chargesOptions,
            placeholder: "",
            className: "custom-field",
            icon: "chevron down",
            onChange: function () {
              var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e, data) {
                var value, options, selectedValue;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        value = data.chargeDesc;
                        options = data.options;
                        selectedValue = options.find(function (val) {
                          return val.value === value;
                        });
                        _context4.next = 5;
                        return _this5.props.selectedCharge(selectedValue.unitPrice, selectedValue.uom);

                      case 5:
                        _context4.next = 7;
                        return _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "glCode", value);

                      case 7:
                        _context4.next = 9;
                        return _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "chargeName", selectedValue.text);

                      case 9:
                        _context4.next = 11;
                        return _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "unitOfMeasurement", selectedValue.uom);

                      case 11:
                        _context4.next = 13;
                        return _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "quantity", 1);

                      case 13:
                        _context4.next = 15;
                        return _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "unitPrice", selectedValue.unitPrice);

                      case 15:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this5);
              }));

              return function (_x2, _x3) {
                return _ref4.apply(this, arguments);
              };
            }()
          }),
          lodash_1(val, "new", false) === false && React__default.createElement(Form.Field, {
            disabled: lodash_1(val, "new", false) !== true,
            control: Input$1,
            label: "",
            value: lodash_1(val, "chargeName", ""),
            placeholder: "",
            className: "custom-field"
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          React__default.createElement(Form.Input, {
            disabled: lodash_1(val, "isGenerated", false) === true || this.props.nonEditableGlCodes.includes(val.glCode) === true,
            readOnly: lodash_1(val, "isGenerated", false) === true || this.props.nonEditableGlCodes.includes(val.glCode) === true
            // readOnly={get(val, "isGenerated", false) === true}
            // value={get(val, "quantity", "") ? get(val, "quantity", "") : 1}
            , value: lodash_1(val, "quantity", ""),
            onChange: function onChange(e) {
              e.target.value = e.target.value.trim();
              if (!lodash_2(e.target.value.trim()) && !/^([0-9]*)$/.test(e.target.value)) {
                e.preventDefault();
                return;
              }
              if (!lodash_2(e.target.value.trim())) {
                e.target.value = parseInt(e.target.value);
              }
              if (parseInt(e.target.value) === 0) {
                e.target.value = 1;
              }

              _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "quantity", e.target.value);
            }
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          React__default.createElement(Form.Input, {
            disabled: lodash_1(val, "isGenerated", false) === true || this.props.nonEditableGlCodes.includes(val.glCode) === true,
            readOnly: lodash_1(val, "isGenerated", false) === true || this.props.nonEditableGlCodes.includes(val.glCode) === true
            // readOnly={get(val, "isGenerated", false) === true}
            , value: lodash_1(val, "unitPrice", "") ? lodash_1(val, "unitPrice", "") : this.props.unitPriceVal,
            onChange: function onChange(e) {
              e.target.value = e.target.value.trim();
              if (!lodash_2(e.target.value) && !/^[1-9]\d{0,8}(\.{0,1})(\d{1,4})?$/.test(e.target.value)) {
                e.preventDefault();
                return;
              }
              _this5.props.unitPriceValue();
              _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "unitPrice", e.target.value);
            },
            onBlur: function onBlur(e) {
              e.target.value = parseFloat(e.target.value);
              if (isNaN(e.target.value)) {
                e.target.value = 0.0;
              }

              _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "unitPrice", e.target.value);
            }
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell", width: "1" },
          lodash_1(val, "new", false) === true && React__default.createElement(Form.Field, {
            disabled: true,
            control: Select,
            label: "",
            value: lodash_1(val, "unitOfMeasurement", ""),
            options: UOM$2,
            placeholder: "",
            icon: "chevron down",
            onChange: function () {
              var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(e, data) {
                var value;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        value = data.chargeDesc;
                        _context5.next = 3;
                        return _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "unitOfMeasurement", value);

                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, _this5);
              }));

              return function (_x4, _x5) {
                return _ref5.apply(this, arguments);
              };
            }()
          }),
          lodash_1(val, "new", false) === false && React__default.createElement(Form.Field, {
            disabled: true,
            control: Input$1,
            label: "",
            value: lodash_1(val, "unitOfMeasurement", "")
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center total-value" },
          this.props.getFormatedCurrency(lodash_1(val, "subTotal", ""), lodash_1(val, "countryForCurrency", "")),
          React__default.createElement(Icon, { className: "green-tick", name: "check circle" })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center total-value" },
          React__default.createElement(Form.Input, {
            // readOnly={get(val, "isGenerated", false) === true}
            value: lodash_1(val, "markUPAmount", ""),
            onChange: function onChange(e) {
              var fieldValue = e.target.value.trim();
              if (lodash_2(fieldValue) || fieldValue === "-" || fieldValue === ".") {
                _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "markUPAmount", fieldValue);
                return;
              }

              fieldValue = isNaN(fieldValue) ? 0 : fieldValue;
              var regex = /^[-0-9\.]*$/;
              if (!lodash_2(fieldValue) && !regex.test(fieldValue)) {
                e.preventDefault();
                return;
              }

              _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "markUPAmount", fieldValue);
            },
            onBlur: function onBlur(e) {
              var fieldValue = e.target.value.trim();
              if (isNaN(fieldValue)) {
                fieldValue = 0;
              } else {
                var regex = /^[-]?[0-9]{1}[0-9]*(?:\.[0-9]{1,50})?$/;
                if (!lodash_2(fieldValue) && !regex.test(fieldValue)) {
                  fieldValue = 0;
                }
              }
              _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "markUPAmount", fieldValue);
            }
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center total-value" },
          this.props.getFormatedCurrency(lodash_1(val, "totalRate", 0), lodash_1(val, "countryForCurrency", ""))
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center" },
          lodash_1(val, "status", "")
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center" },
          React__default.createElement(Form.Input, {
            readOnly: true,
            disabled: true,
            value: lodash_1(val, "drayageInvoiceNumber", "")
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-center" },
          React__default.createElement(Popup, {
            trigger: React__default.createElement(Form.Input, {
              disabled: lodash_1(val, "isGenerated", false) === true || this.props.nonEditableGlCodes.includes(val.glCode) === true,
              value: lodash_1(val, "chargeComment", ""),
              onChange: function onChange(e) {
                e.target.value = e.target.value;
                _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "chargeComment", e.target.value);
              },
              onBlur: function onBlur(e) {
                e.target.value = e.target.value;
                _this5.props.updateSalesPendingLineItem(_this5.props.index, rowIndex, "comment", e.target.value);
              }
            }),
            header: "",
            content: lodash_1(val, "chargeComment", ""),
            position: "top center",
            style: { maxWidth: "150px" },
            on: "focus"
          })
        ),
        React__default.createElement(
          Table.Cell,
          { className: "table-field-cell text-align-right" },
          lodash_1(val, "glCode", "") !== "60001" && lodash_1(val, "glCode", "") !== "60002" && lodash_1(val, "isGenerated", false) !== true && React__default.createElement(
            "span",
            {
              onClick: function onClick() {
                _this5.showConfirm();
              }
            },
            React__default.createElement(
              "svg",
              {
                width: "16",
                height: "17",
                viewBox: "0 0 16 17",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              },
              React__default.createElement("path", {
                d: "M4.7339 5.45847L6.07543 5.4079L6.36627 13.5713L5.02475 13.6217L4.7339 5.45847Z",
                fill: "#286084"
              }),
              React__default.createElement("rect", {
                width: "1.34239",
                height: "8.16348",
                transform: "matrix(-1 0 0 1 8.6712 5.43317)",
                fill: "#286084"
              }),
              React__default.createElement("path", {
                d: "M9.63393 13.5711L9.92477 5.40765L11.2663 5.45826L10.9754 13.6217L9.63393 13.5711Z",
                fill: "#286084"
              }),
              React__default.createElement("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M15.9873 3.40954V2.02982H0.0126772V3.40954H1.43407L2.54379 16.3704C2.57398 16.7266 2.86439 17 3.21231 17H12.8103C13.1582 17 13.4484 16.7268 13.4788 16.3706L14.5885 3.40954H15.9873ZM12.1957 15.6203H3.8271L2.78158 3.40954H13.241L12.1957 15.6203Z",
                fill: "#286084"
              }),
              React__default.createElement("path", {
                d: "M6.18242 0H10.8176C11.4696 0 12 0.464058 12 1.03447V3H10.5811V1.24137H6.41891V3H5V1.03447C5 0.464058 5.53043 0 6.18242 0Z",
                fill: "#286084"
              })
            )
          ),
          React__default.createElement(Confirm, {
            className: "delete-charge-confirm",
            header: "Delete Charge",
            content: deleteMessage,
            open: this.state.showConfirm,
            onCancel: this.handleCancel,
            onConfirm: this.handleConfirm,
            size: "large",
            confirmButton: "Delete Charge"
          })
        )
      );
    }
  }]);
  return SalesPendingRow;
}(Component);

var PreviewDocument$2 = function (_Component) {
  inherits(PreviewDocument, _Component);

  function PreviewDocument(props) {
    classCallCheck(this, PreviewDocument);

    var _this = possibleConstructorReturn(this, (PreviewDocument.__proto__ || Object.getPrototypeOf(PreviewDocument)).call(this, props));

    _this.get_url_extension = function (url) {
      var ext = url.split(/[#?]/)[0].split(".").pop().trim();
      return ext;
    };

    _this.openInNewTab = function (url) {
      var newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    };

    _this.state = { options: [] };
    return _this;
  }

  createClass(PreviewDocument, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      console.log("TESTING", this.props.documentName);
      if (this.props.documentName != prevProps.documentName && this.props.documentName) {
        this.setState({
          options: Array.isArray(lodash_1(this, "props.documentName", [])) ? lodash_1(this, "props.documentName", []).map(function (val) {
            return { value: val, key: val, text: val };
          }) : []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Open = _props.Open,
          Close = _props.Close,
          docUrl = _props.docUrl;

      var extenison = this.get_url_extension(docUrl);
      return React__default.createElement(
        Modal,
        {
          closeIcon: true,
          open: Open,
          onClose: Close,
          onOpen: Open,
          size: "small",
          className: "preDocument"
        },
        React__default.createElement(Header, { content: "Preview Document" }),
        React__default.createElement(
          Modal.Content,
          null,
          Array.isArray(lodash_1(this, "props.documentName", [])) && lodash_1(this, "props.documentName", []).map(function (val) {
            return React__default.createElement(
              "div",
              {
                onClick: function onClick() {
                  return _this2.props.handleModal(val);
                },
                style: { color: "navy" }
              },
              val
            );
          }),
          React__default.createElement(
            "div",
            null,
            React__default.createElement(
              "a",
              { onClick: function onClick(e) {
                  return _this2.openInNewTab(docUrl);
                } },
              React__default.createElement(Icon, { name: "download" })
            )
          ),
          extenison == "pdf" ? React__default.createElement(PDFViewer, { url: docUrl }) : extenison == "pptx" || extenison == "xls" || extenison == "xlsx" || extenison == "csv" ? React__default.createElement(
            Image,
            { size: "small" },
            React__default.createElement(Label, {
              content: "Extension not supported!",
              icon: "warning",
              style: {
                width: "300px",
                height: "100px",
                paddingTop: "35px",
                paddingLeft: "55px"
              }
            })
          ) : React__default.createElement(Image, { size: "large", src: docUrl, alt: "Image not found", wrapped: true })
        ),
        React__default.createElement(Modal.Actions, null)
      );
    }
  }]);
  return PreviewDocument;
}(Component);

var REASONS_ARR$1 = [{
  key: "Lack of proof document",
  value: "Lack of proof document",
  text: "Lack of proof document"
}, {
  key: "Invoiced amount not matching quoted amount",
  value: "Invoiced amount not matching quoted amount",
  text: "Invoiced amount not matching quoted amount"
}, {
  key: "Duplicate charges",
  value: "Duplicate charges",
  text: "Duplicate charges"
}, {
  key: "Customer dissatisfaction",
  value: "Customer dissatisfaction",
  text: "Customer dissatisfaction"
}, { key: "Others", value: "Others", text: "Others" }];

var SalesPendingCardContentStatic = function (_Component) {
  inherits(SalesPendingCardContentStatic, _Component);

  function SalesPendingCardContentStatic(props) {
    var _this2 = this;

    classCallCheck(this, SalesPendingCardContentStatic);

    var _this = possibleConstructorReturn(this, (SalesPendingCardContentStatic.__proto__ || Object.getPrototypeOf(SalesPendingCardContentStatic)).call(this, props));

    _this.componentDidUpdate = function (prevProps, prevState) {
      if (prevProps.disputeRaisedError !== _this.props.disputeRaisedError) {
        if (lodash_2(_this.props.disputeRaisedError)) {
          _this.context.setDescriptionHeaderText("");
        } else {
          _this.context.setDescriptionHeaderText(React__default.createElement(
            Message,
            { negative: true },
            React__default.createElement(
              Message.Header,
              null,
              _this.props.disputeRaisedError
            )
          ));
        }
      }
    };

    _this.handleModal = function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(docName) {
        var bucketName, data, url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                bucketName = window._env_.DRAYAGE_BILL_BUCKET;
                _context.next = 3;
                return getDrayageImageURL$1(
                // `${bucketName}:1658330865595_ScreenShot2022-07-12at8.28.49AM.png`
                bucketName + ":" + docName);

              case 3:
                data = _context.sent;
                url = lodash_1(data, "data.eventMessage.urls[0]", "");

                _this.setState({ modalOpen: true, docUrl: url });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleClose = function () {
      _this.setState({ modalOpen: false });
    };

    _this.createInvoice = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this.state.createCall === true)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              _this.setState({ createCall: true }, asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var res;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return _this.props.createInvoice(_this.props.index);

                      case 2:
                        res = _context2.sent;


                        _this.setState({ createCall: false });

                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, _this2);
              })));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.handleAllChecked = function (event) {
      // let fruites = this.props.data.chargeDesc.chargeDesc;
      // fruites.forEach(fruite => (fruite.isChecked = event.target.checked));
      // console.log("fruites",fruites)
    };

    _this.openInNewTab = function () {
      var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(docName) {
        var bucketName, data, url, newWindow;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                bucketName = window._env_.DRAYAGE_BILL_BUCKET;
                _context4.next = 3;
                return getDrayageImageURL$1(
                // `${bucketName}:1658330865595_ScreenShot2022-07-12at8.28.49AM.png`
                bucketName + ":" + docName);

              case 3:
                data = _context4.sent;
                url = lodash_1(data, "data.eventMessage.urls[0]", "");
                newWindow = window.open(url, "_blank", "noopener,noreferrer");

                if (newWindow) newWindow.opener = null;

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.state = {
      createCall: false,
      modalOpen: false,
      docUrl: "",
      approveCall: false,
      documents: []
    };
    return _this;
  }

  createClass(SalesPendingCardContentStatic, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          modalOpen = _state.modalOpen,
          docUrl = _state.docUrl;
      var selectAllInvoice = this.props.selectAllInvoice;


      var addedInvoiceCount = lodash_1(this.props, "data.chargeDesc.chargeDesc", []).filter(function (value) {
        return lodash_1(value, "includeInInvoice", false) === true;
      }).length;
      var isGeneratedCount = lodash_1(this.props, "data.chargeDesc.chargeDesc", []).filter(function (value) {
        return lodash_1(value, "isGenerated", false) === true;
      }).length;
      var allChargesCount = lodash_1(this.props, "data.chargeDesc.chargeDesc", []).length;
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table content-static-card non-edit"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  React__default.createElement("div", {
                    style: {
                      marginLeft: "1rem",
                      display: "flex"
                    }
                  })
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "VENDOR INVOICE NO."
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell text-align-center" },
                  "COMMENT"
                ),
                React__default.createElement(Table.HeaderCell, { className: "table-heading-cell" })
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc.chargeDesc", []).map(function (val, index) {
                var documentName = lodash_1(val, "documentName", []);
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    React__default.createElement(
                      "div",
                      {
                        style: {
                          marginLeft: "1rem",
                          display: "flex",
                          gap: "10px"
                        }
                      },
                      documentName.length ? React__default.createElement(
                        "div",
                        {
                          className: "preview",
                          style: {
                            border: "2px solid #08adb6",
                            width: "30px",
                            borderRadius: "5px"
                          }
                        },
                        React__default.createElement(Icon, {
                          style: {
                            fontSize: "15px",
                            color: "#08adb6",
                            paddingTop: "4px",
                            paddingLeft: "5px"
                          },
                          className: "eye icon"
                          // onClick={() => {this.openInNewTab(documentName)}}
                          , onClick: function onClick() {
                            _this3.setState({ documents: documentName });
                            _this3.handleModal(documentName[0]);
                          }
                        })
                      ) : ""
                    )
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    {
                      className: "table-field-cell",
                      width: "1",
                      style: lodash_1(val, "calculatedUnitCount", "") && lodash_1(val, "quantity", "") !== lodash_1(val, "calculatedUnitCount", "") ? { color: 'red' } : {}
                    },
                    lodash_1(val, "quantity", ""),
                    lodash_1(val, "calculatedUnitCount", "") && lodash_1(val, "calculatedUnitCount", "") != lodash_1(val, "quantity", "") && React__default.createElement(Popup, {
                      trigger: React__default.createElement("i", { "class": "info circle icon black large" }),
                      header: "",
                      content: lodash_1(val, "calculatedUnitCount", "") > 0 ? "" + lodash_1(val, "calculatedUnitCount", "") : 'Gate IN event is not available',
                      position: "top center",
                      style: { maxWidth: "250px", height: "50px", color: '#00b5ad' }
                    })
                  ),
                  React__default.createElement(
                    Table.Cell,
                    {
                      className: "table-field-cell text-align-center",
                      width: "1"
                    },
                    _this3.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center total-value" },
                    _this3.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center" },
                    React__default.createElement(Form.Input, {
                      readOnly: true,
                      disabled: true,
                      value: lodash_1(val, "drayageInvoiceNumber", "")
                    })
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell text-align-center" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        disabled: true,
                        readOnly: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  ),
                  React__default.createElement(Table.Cell, { className: "table-field-cell text-align-right" })
                );
              }),
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.Cell,
                  {
                    colSpan: "12",
                    className: "table-field-cell text-align-center"
                  },
                  React__default.createElement(
                    "div",
                    { className: "table-action-btns" },
                    React__default.createElement(
                      "div",
                      { style: { "margin-left": "auto" } },
                      React__default.createElement(
                        Button,
                        {
                          className: "create-invoice-btn",
                          onClick: function onClick(e) {
                            var context = _this3.context;
                            context.setModalSize("large");
                            context.setShowModal(true);
                            context.setModalHeaderText("RAISE DISPUTE FOR " + lodash_1(_this3.props, "data.containerNumber", ""));
                            context.setDescriptionText(React__default.createElement(RaiseDispute, {
                              disputeRaisedError: _this3.props.disputeRaisedError,
                              setShowModal: context.setShowModal,
                              data: lodash_1(_this3.props, "data", []),
                              callBack: _this3.props.raiseDisputeRequest
                            }));
                            context.setDescriptionHeaderText("");
                            // context.setCloseButtonText("Cancels");
                            // context.setActionButtonText("Raise Dispute");
                          }
                        },
                        "RAISE DISPUTE"
                      ),
                      React__default.createElement(
                        Button,
                        {
                          loading: this.state.approveCall,
                          className: "create-invoice-btn",
                          onClick: function () {
                            var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e) {
                              return regeneratorRuntime.wrap(function _callee6$(_context6) {
                                while (1) {
                                  switch (_context6.prev = _context6.next) {
                                    case 0:
                                      _this3.setState({ approveCall: true }, asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                                        return regeneratorRuntime.wrap(function _callee5$(_context5) {
                                          while (1) {
                                            switch (_context5.prev = _context5.next) {
                                              case 0:
                                                _context5.next = 2;
                                                return _this3.props.approveInvoice(_this3.props.index);

                                              case 2:
                                                _this3.setState({ approveCall: false });

                                              case 3:
                                              case "end":
                                                return _context5.stop();
                                            }
                                          }
                                        }, _callee5, _this3);
                                      })));

                                      // if (
                                      //   isEmpty(
                                      //     getStyleBasedOnNegativeMargin(
                                      //       get(
                                      //         this,
                                      //         "props.data.chargeDesc.chargeDesc",
                                      //         []
                                      //       )
                                      //     )
                                      //   )
                                      // ) {
                                      //   this.setState({ approveCall: true }, async () => {
                                      //     await this.props.approveInvoice(this.props.index);
                                      //     this.setState({ approveCall: false });
                                      //   });
                                      // } else {
                                      //   const callback = () => {
                                      //     this.setState({ approveCall: true }, async () => {
                                      //       await this.props.approveInvoice(
                                      //         this.props.index
                                      //       );
                                      //       this.setState({ approveCall: false });
                                      //     });
                                      //   };
                                      //   this.context.setModalHeaderText("Attention!");
                                      //   this.context.setShowModal(true);
                                      //   this.context.setDescriptionText(
                                      //     "This Invoice includes negative margin or standard charges may not present, Please review standard charges."
                                      //   );
                                      //   this.context.setCloseButtonText("CANCEL");
                                      //   this.context.setActionButtonText("IGNORE");
                                      //   this.context.setActionButtonCallBack(callback);
                                      // }


                                    case 1:
                                    case "end":
                                      return _context6.stop();
                                  }
                                }
                              }, _callee6, _this3);
                            }));

                            return function (_x3) {
                              return _ref5.apply(this, arguments);
                            };
                          }()
                        },
                        "APPROVE INVOICE"
                      )
                    )
                  )
                )
              )
            )
          ),
          React__default.createElement(PreviewDocument$2, {
            Open: this.state.modalOpen,
            Close: this.handleClose,
            docUrl: this.state.docUrl,
            documentName: this.state.documents,
            handleModal: this.handleModal
          })
        )
      );
    }
  }]);
  return SalesPendingCardContentStatic;
}(Component);

SalesPendingCardContentStatic.contextType = ModelContext$1;

var RaiseDispute = function (_React$Component) {
  inherits(RaiseDispute, _React$Component);

  function RaiseDispute(props) {
    var _this5 = this;

    classCallCheck(this, RaiseDispute);

    var _this4 = possibleConstructorReturn(this, (RaiseDispute.__proto__ || Object.getPrototypeOf(RaiseDispute)).call(this, props));

    _this4.callBack = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var _this4$state, disputeReason, disputeComment, hasError, returnResult;

      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this4$state = _this4.state, disputeReason = _this4$state.disputeReason, disputeComment = _this4$state.disputeComment;
              _context7.next = 3;
              return new Promise(function (resolve) {
                _this4.setState({ disputeReasonError: false, disputeCommentError: false }, function () {
                  setTimeout(function () {
                    resolve(true);
                  }, 100);
                });
              });

            case 3:
              hasError = false;

              if (lodash_2(disputeReason.trim())) {
                hasError = true;
                _this4.setState({
                  disputeReasonError: "Please select valid reason"
                });
              }
              if (lodash_2(disputeComment.trim())) {
                hasError = true;
                _this4.setState({
                  disputeCommentError: "Please enter valid comment"
                });
              }

              if (!(hasError === false)) {
                _context7.next = 11;
                break;
              }

              _context7.next = 9;
              return _this4.props.callBack({
                disputeReason: disputeReason,
                disputeComment: disputeComment,
                data: _this4.props.data
              });

            case 9:
              returnResult = _context7.sent;

              if (returnResult) {
                _this4.props.setShowModal(false);
              }

            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this5);
    }));

    _this4.state = {
      disputeReason: "",
      disputeComment: "",
      disputeReasonError: false,
      disputeCommentError: false
    };
    return _this4;
  }

  createClass(RaiseDispute, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      var _state2 = this.state,
          disputeReason = _state2.disputeReason,
          disputeComment = _state2.disputeComment;

      return React__default.createElement(
        "div",
        { className: "raise-dispute-form" },
        React__default.createElement(
          Form,
          null,
          React__default.createElement(
            Form.Field,
            null,
            React__default.createElement(
              "label",
              null,
              "Dispute Reason"
            ),
            React__default.createElement(Select, {
              className: this.state.disputeReasonError ? "raise-dispute-error" : "",
              error: Boolean(this.state.disputeReasonError),
              control: Select,
              onChange: function onChange(e, data) {
                _this6.setState({ disputeReason: data.value });
              },
              value: disputeReason,
              options: REASONS_ARR$1
            }),
            !lodash_2(this.state.disputeReasonError) && React__default.createElement(
              Label,
              { className: "pointing-label", pointing: "above" },
              this.state.disputeReasonError
            )
          ),
          React__default.createElement(
            Form.Field,
            null,
            React__default.createElement(
              "label",
              null,
              "Dispute Comment"
            ),
            React__default.createElement(TextArea, {
              value: disputeComment,
              className: this.state.disputeCommentError ? "raise-dispute-error" : "",
              onChange: function onChange(e, data) {
                _this6.setState({ disputeComment: data.value });
              }
            }),
            !lodash_2(this.state.disputeCommentError) && React__default.createElement(
              Label,
              { className: "pointing-label", pointing: "above" },
              this.state.disputeCommentError
            )
          ),
          React__default.createElement(
            Button,
            {
              type: "submit",
              onClick: this.callBack,
              style: { background: "#04ADB1", color: "#FFF" }
            },
            "Submit"
          )
        )
      );
    }
  }]);
  return RaiseDispute;
}(React__default.Component);

var Pagination$2 = function (_Component) {
  inherits(Pagination, _Component);

  function Pagination(props) {
    classCallCheck(this, Pagination);
    return possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
  }

  createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        "div",
        {
          className: "pagination drayage-sales-invoices"

        },
        React__default.createElement(
          "button",
          { onClick: function onClick() {
              return _this2.props.prevPage();
            } },
          "Prev"
        ),
        this.props.page + " / " + Math.ceil(this.props.totalCount / 25),
        React__default.createElement(
          "button",
          { onClick: function onClick() {
              return _this2.props.nextPage();
            } },
          "Next"
        )
      );
    }
  }]);
  return Pagination;
}(Component);

var SalesPending = function (_Component) {
  inherits(SalesPending, _Component);

  function SalesPending(props) {
    var _this2 = this;

    classCallCheck(this, SalesPending);

    var _this = possibleConstructorReturn(this, (SalesPending.__proto__ || Object.getPrototypeOf(SalesPending)).call(this, props));

    _this.getDefaultOption = function () {
      var billList = _this.state.billList;

      var dataa = billList;

      var defaultIndex = dataa.findIndex(function (item) {
        return item.isDefault;
      });
      _this.setState({ defaultOption: defaultIndex !== -1 ? defaultIndex : "" });
    };

    _this.getCustomerNameList = function () {
      var billList = _this.state.billList;

      if (billList && billList.length > 0) {
        return billList.map(function (item, index) {
          return {
            text: item.customerName,
            value: item.customerName,
            key: item.customerName
          };
        });
      }
    };

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.0;
      }
      return value;
    };

    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context.next = 6;
              return _this.props.getSalesPendingData(currPage);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getSalesPendingData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.state = {
      errorMsg: "",
      successMsg: "",
      options: [],
      defaultOption: "",
      billList: [],
      page: 1
    };
    return _this;
  }

  createClass(SalesPending, [{
    key: "componentDidMount",
    value: function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var salesPending, key, value, getBillingOption, option;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.getSalesPendingData();

              case 2:
                salesPending = this.props.salesPending;
                key = "";
                value = "";
                getBillingOption = [];

                salesPending.map(function (val) {
                  key = lodash_1(val, "key", "");
                  value = lodash_1(val, "value", "");
                  getBillingOption = lodash_1(value, "billingParties.billToList", []);
                });

                this.setState({ billList: getBillingOption });

                if (getBillingOption && getBillingOption.length > 0) {
                  option = this.getCustomerNameList();

                  this.setState({ options: option });
                  this.getDefaultOption();
                }

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _ref3.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          options = _state.options,
          defaultOption = _state.defaultOption;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("div", { style: { display: "flow-root" } }),
        this.props.successMsg && React__default.createElement(
          "div",
          { className: "isgeneraed-in isgeneraed-in-msg" },
          React__default.createElement(
            Message,
            { positive: true, size: "tiny", className: "info-message" },
            React__default.createElement(
              Message.Header,
              null,
              this.props.successMsg
            )
          )
        ),
        this.props.errorMsg && React__default.createElement(
          Message,
          { negative: true, size: "tiny", className: "info-message" },
          React__default.createElement(
            Message.Header,
            null,
            this.props.errorMsg
          )
        ),
        React__default.createElement(CustomLoader$1, { showImage: true, loading: this.props.fetchSalesPending }),
        !this.props.fetchSalesPending && this.props.salesPending.map(function (val, index) {
          if (!lodash_1(val, "edit", false)) {
            return React__default.createElement(
              Accordion,
              { fluid: true, key: index },
              React__default.createElement(
                "div",
                { style: { marginBottom: "15px", background: "white" } },
                React__default.createElement(
                  Accordion.Title,
                  {
                    style: { marginTop: "15px", padding: "1px 15px" },
                    active: _this3.props.activeCard === index,
                    index: 0,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  React__default.createElement(SalesPendingCardHeader, {
                    data: val,
                    activeCard: _this3.props.activeCard,
                    cardIndex: index,
                    expandCard: _this3.props.expandSalesPendingCard,
                    getFormatedDate: _this3.getFormatedDate,
                    selectedBillToParties: _this3.props.selectedBillToParties,
                    option: options,
                    defaultOption: defaultOption,
                    selectedDropdownData: _this3.props.selectedDropdownData,
                    getFormatedCurrency: _this3.props.getFormatedCurrency,
                    setRefNum: _this3.props.setRefNum
                  })
                ),
                React__default.createElement(
                  Accordion.Content,
                  {
                    active: _this3.props.activeCard === index,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  React__default.createElement(SalesPendingCardContentStatic, {
                    data: val,
                    index: index,
                    editSalesPendingCharge: _this3.props.editSalesPendingCharge,
                    formatAmount: _this3.formatAmount,
                    successMsg: _this3.props.successMsg,
                    errorMsg: _this3.props.errorMsg,
                    getFormatedCurrency: _this3.props.getFormatedCurrency,
                    createInvoice: _this3.props.createInvoice,
                    addChargeToInvoice: _this3.props.addChargeToInvoice,
                    addAllChargeToInvoice: _this3.props.addAllChargeToInvoice,
                    nonEditableGlCodes: _this3.props.nonEditableGlCodes,
                    raiseDisputeRequest: _this3.props.raiseDisputeRequest,
                    disputeRaisedError: _this3.props.disputeRaisedError,
                    approveInvoice: _this3.props.approveInvoice
                  })
                )
              )
            );
          } else {
            return React__default.createElement(
              Accordion,
              { fluid: true, key: index },
              React__default.createElement(
                "div",
                { style: { marginBottom: "15px", background: "white" } },
                React__default.createElement(
                  Accordion.Title,
                  {
                    style: { marginTop: "15px", padding: "1px 15px" },
                    active: _this3.props.activeCard === index,
                    index: index,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  "\xA0",
                  React__default.createElement(SalesPendingCardHeader, {
                    data: val,
                    activeCard: _this3.props.activeCard,
                    cardIndex: index,
                    expandCard: _this3.props.expandSalesPendingCard,
                    getFormatedDate: _this3.getFormatedDate,
                    selectedBillToParties: _this3.props.selectedBillToParties,
                    option: options,
                    defaultOption: defaultOption,
                    selectedDropdownData: _this3.props.selectedDropdownData,
                    getFormatedCurrency: _this3.props.getFormatedCurrency
                  })
                ),
                React__default.createElement(
                  Accordion.Content,
                  {
                    active: _this3.props.activeCard === index,
                    className: _this3.props.activeCard === index ? "card-opened" : ""
                  },
                  React__default.createElement(SalesPendingCardEdit, {
                    data: val,
                    index: index,
                    updateSalesPendingLineItem: _this3.props.updateSalesPendingLineItem,
                    addNewCharge: _this3.props.addNewCharge,
                    deleteChargeLineItem: _this3.props.deleteChargeLineItem,
                    cancelSalesPendingEdit: _this3.props.cancelSalesPendingEdit,
                    saveSalesPendingData: _this3.props.saveSalesPendingData,
                    chargesOptions: _this3.props.chargesOptions,
                    successMsg: _this3.props.successMsg,
                    errorMsg: _this3.props.errorMsg,
                    getFormatedCurrency: _this3.props.getFormatedCurrency,
                    nonEditableGlCodes: _this3.props.nonEditableGlCodes,
                    unitPriceValue: _this3.props.unitPriceValue,
                    selectedCharge: _this3.props.selectedCharge,
                    unitPriceVal: _this3.props.unitPriceVal,
                    uom: _this3.props.uom
                  })
                )
              )
            );
          }
        }),
        React__default.createElement(Pagination$2, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return SalesPending;
}(Component);

function Date$8(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var PendingListCardHeader$1 = function (_Component) {
  inherits(PendingListCardHeader, _Component);

  function PendingListCardHeader(props) {
    var _this2 = this;

    classCallCheck(this, PendingListCardHeader);

    var _this = possibleConstructorReturn(this, (PendingListCardHeader.__proto__ || Object.getPrototypeOf(PendingListCardHeader)).call(this, props));

    _this.handlePaidEvent = function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, invo) {
        var setSelectedInvoice;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setSelectedInvoice = _this.props.setSelectedInvoice;

                if (!data.checked) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return setSelectedInvoice(invo, "checked");

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return setSelectedInvoice(invo, "unChecked");

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.state = {
      activeIndex: 1,
      showOtherTab: true
    };
    return _this;
  }

  createClass(PendingListCardHeader, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, "val.countryCode", ""));
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          { size: "mini", className: "pendingList-table", style: { marginBottom: "5px" } },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "20px"
              },
              className: "flex-2"
            },
            React__default.createElement(
              "div",
              { style: { minWidth: "21px" } },
              cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this3.props.expandCard(_this3.props.cardIndex);
                },
                name: "plus circle",
                className: "card-toggle-icon"
              }),
              cardIndex === this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this3.props.expandCard(_this3.props.cardIndex);
                },
                name: "minus circle",
                className: "card-toggle-icon"
              })
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "val.drayageInvoiceNumber", "")
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country flex-1" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              countryData.countryName
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$8, { date: lodash_1(this.props, "val.createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "STATUS"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value reference-no" },
              lodash_1(this.props, "val.status", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.totalAmount", ""), lodash_1(this.props, "val.countryCode", ""))
            )
          ),
          React__default.createElement(
            "div",
            {
              className: "table-action-btns approve-disapprove-btn flex-2",
              style: {
                display: "flex",
                gap: "10px",
                minWidth: "115px"
              }
            },
            this.props.userTypes === "OPS_PARTNER" && React__default.createElement(
              "div",
              null,
              React__default.createElement(
                Button,
                {
                  className: "save-invoice-btn"
                  // onClick={(e) => {
                  //   this.props.editChargeListCharge(this.props.index);
                  // }}
                },
                "APPROVE"
              ),
              React__default.createElement(
                Button,
                {
                  className: "save-invoice-btn"
                  // onClick={(e) => {
                  //   this.props.editChargeListCharge(this.props.index);
                  // }}
                },
                "REJECT"
              )
            ),
            React__default.createElement(UploadDocument$1, {
              containerId: lodash_1(this.props, "val.containerId", ""),
              containerNumber: lodash_1(this.props, "val.containerNumber", ""),
              chargeDesc: lodash_1(this.props, "val.chargeDesc", ""),
              showOtherTab: this.state.showOtherTab
            })
          )
        )
      );
    }
  }]);
  return PendingListCardHeader;
}(Component);

var PendingListCard$1 = function (_Component) {
  inherits(PendingListCard, _Component);

  function PendingListCard(props) {
    classCallCheck(this, PendingListCard);
    return possibleConstructorReturn(this, (PendingListCard.__proto__ || Object.getPrototypeOf(PendingListCard)).call(this, props));
  }

  createClass(PendingListCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            { basic: "very", className: "drayage-line-item-table content-static-card" },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return PendingListCard;
}(Component);

var PendingList$1 = function (_Component) {
  inherits(PendingList, _Component);

  function PendingList(props) {
    var _this2 = this;

    classCallCheck(this, PendingList);

    var _this = possibleConstructorReturn(this, (PendingList.__proto__ || Object.getPrototypeOf(PendingList)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.00;
      }
      return value;
    };

    _this.markPaidInvoice = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var setPaidInvice;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPaidInvice = _this.props.setPaidInvice;
              _context.next = 3;
              return setPaidInvice();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    return _this;
  }

  createClass(PendingList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("div", { style: { display: "flex", flexDirection: "row-reverse" } }),
        React__default.createElement(CustomLoader$1, { showImage: true, loading: this.props.fetchPendingTabInvoices }),
        !this.props.fetchPendingTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              { style: { marginBottom: "15px", background: "white" }, key: "pedning-card-" + index },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this3.props.activeCard === index,
                  index: 0,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PendingListCardHeader$1, {
                  activeCard: _this3.props.activeCard,
                  cardIndex: index,
                  expandCard: _this3.props.expandCard,
                  val: val,
                  getFormatedDate: _this3.props.getFormatedDate,
                  getCountryNameAndImage: _this3.props.getCountryNameAndImage,
                  getFormatedCurrency: _this3.props.getFormatedCurrency,
                  setSelectedInvoice: _this3.props.setSelectedInvoice,
                  userTypes: _this3.props.userTypes
                })
              ),
              React__default.createElement(
                Accordion.Content,
                {
                  active: _this3.props.activeCard === index,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PendingListCard$1, {
                  data: val,
                  index: index,
                  formatAmount: _this3.formatAmount,
                  getFormatedCurrency: _this3.props.getFormatedCurrency
                })
              )
            );
          })
        )
      );
    }
  }]);
  return PendingList;
}(Component);

// import PaymentHistory from "../PaymentHistory";
function Date$9(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var PaidListCardHeader$1 = function (_Component) {
  inherits(PaidListCardHeader, _Component);

  function PaidListCardHeader(props) {
    classCallCheck(this, PaidListCardHeader);

    var _this = possibleConstructorReturn(this, (PaidListCardHeader.__proto__ || Object.getPrototypeOf(PaidListCardHeader)).call(this, props));

    _this.state = {
      activeIndex: 1,
      showOtherTab: true,
      openedPopUp: null
    };
    return _this;
  }

  createClass(PaidListCardHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, "val.countryCode", ""));
      var countryCode = lodash_1(this.props, "val.countryCode", "");
      var invoiceUrl = lodash_1(this.props, "val.invoiceUrl", "") ? lodash_1(this.props, "val.invoiceUrl", "") : "";
      var countryForCurrencyCode = this.props.val && this.props.val.chargeDesc[0] ? lodash_1(this.props, "val.chargeDesc[0].countryForCurrency", "") : countryCode;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          {
            size: "mini",
            className: "pendingList-table flex",
            style: { marginBottom: "5px" }
          },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "10px"
              },
              className: "flex-2"
            },
            React__default.createElement(
              "div",
              { style: { minWidth: "21px" } },
              invoiceUrl === "" && cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this2.props.expandCard(_this2.props.cardIndex);
                },
                name: "plus circle",
                className: "card-toggle-icon"
              }),
              invoiceUrl === "" && cardIndex === this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this2.props.expandCard(_this2.props.cardIndex);
                },
                name: "minus circle",
                className: "card-toggle-icon"
              })
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country invoice-number-container" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "val.drayageInvoiceNumber", "")
              ),
              invoiceUrl !== "" && React__default.createElement(
                "div",
                { className: "statistic-value-tooltip" },
                "SYNCED FROM INTACCT"
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country flex-1" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              countryData.countryName
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "SHIPMENT ID#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this, "props.val.shipmentId", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$9, { date: lodash_1(this.props, "val.createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "ACC REF NO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.referenceNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "PAID AMOUNT"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value reference-no" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.paidAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "PAID DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              this.props.getFormatedPaidDate(lodash_1(this.props, "val.paidDate", ""))
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "MODE OF PAYMENT"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.modeOfPayment", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.totalAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "10px",
                minWidth: "115px"
              },
              className: "flex-2"
            },
            invoiceUrl === "" && React__default.createElement(UploadDocument$1, {
              containerId: lodash_1(this.props, "val.containerId", ""),
              containerNumber: lodash_1(this.props, "val.containerNumber", ""),
              chargeDesc: lodash_1(this.props, "val.chargeDesc", ""),
              showOtherTab: this.state.showOtherTab
            }),
            invoiceUrl === "" && React__default.createElement(
              "span",
              {
                className: "btn-over",
                style: { width: "46px" },
                onClick: function onClick() {
                  var context = _this2.context;
                  context.setModalSize("fullscreen");
                  context.setShowModal(true);
                  context.setModalHeaderText("CHANGE LOG FOR " + lodash_1(_this2.props, "val.containerNumber", ""));
                  context.setDescriptionText(React__default.createElement(DrayageInvoiceChangeLog$1, { data: lodash_1(_this2.props, "val", {}) }));
                  context.setDescriptionHeaderText("");
                  // context.setCloseButtonText("Cancels");
                  // context.setActionButtonText("Raise Dispute");
                }
              },
              React__default.createElement(Icon, {
                style: {
                  margin: "10px 4px",
                  color: "#08adb6",
                  fontSize: "1.2em"
                },
                name: "history"
              })
            )
          )
        )
      );
    }
  }]);
  return PaidListCardHeader;
}(Component);

PaidListCardHeader$1.contextType = ModelContext$1;

var PaidListCardContentStatic$1 = function (_Component) {
  inherits(PaidListCardContentStatic, _Component);

  function PaidListCardContentStatic(props) {
    classCallCheck(this, PaidListCardContentStatic);
    return possibleConstructorReturn(this, (PaidListCardContentStatic.__proto__ || Object.getPrototypeOf(PaidListCardContentStatic)).call(this, props));
  }

  createClass(PaidListCardContentStatic, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            { basic: "very", className: "drayage-line-item-table content-static-card" },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return PaidListCardContentStatic;
}(Component);

var Paid$1 = function (_Component) {
  inherits(Paid, _Component);

  function Paid(props) {
    var _this2 = this;

    classCallCheck(this, Paid);

    var _this = possibleConstructorReturn(this, (Paid.__proto__ || Object.getPrototypeOf(Paid)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.0;
      }
      return value;
    };

    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.state = { page: 1 };
    return _this;
  }
  // setStateObj(state) {
  //   this.setState({ ...state });
  // }
  // expandCard(id) {
  //   this.state.activeCard === id
  //     ? this.setStateObj({
  //         activeCard: null,
  //       })
  //     : this.setStateObj({
  //         activeCard: id,
  //       });
  // }

  createClass(Paid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(CustomLoader$1, {
          showImage: true,
          loading: this.props.fetchPaidTabInvoices
        }),
        !this.props.fetchPaidTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              {
                style: { marginBottom: "15px", background: "white" },
                key: "paid-card-" + index
              },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this3.props.activeCard === index,
                  index: 0,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PaidListCardHeader$1, {
                  activeCard: _this3.props.activeCard,
                  cardIndex: index,
                  expandCard: _this3.props.expandCard,
                  val: val,
                  getFormatedDate: _this3.props.getFormatedDate,
                  getCountryNameAndImage: _this3.props.getCountryNameAndImage,
                  getFormatedCurrency: _this3.props.getFormatedCurrency,
                  getFormatedPaidDate: _this3.props.getFormatedPaidDate,
                  setSelectedInvoice: _this3.props.setSelectedInvoice
                })
              ),
              React__default.createElement(
                Accordion.Content,
                {
                  active: _this3.props.activeCard === index,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PaidListCardContentStatic$1, {
                  data: val,
                  index: index,
                  formatAmount: _this3.formatAmount,
                  getFormatedCurrency: _this3.props.getFormatedCurrency
                })
              )
            );
          })
        ),
        lodash_1(this.props, "totalCount", 0) > 0 && React__default.createElement(Pagination$2, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return Paid;
}(Component);

function Date$a(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var DisputedListCardHeader = function (_Component) {
  inherits(DisputedListCardHeader, _Component);

  function DisputedListCardHeader(props) {
    var _this2 = this;

    classCallCheck(this, DisputedListCardHeader);

    var _this = possibleConstructorReturn(this, (DisputedListCardHeader.__proto__ || Object.getPrototypeOf(DisputedListCardHeader)).call(this, props));

    _this.handlePaidEvent = function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, invo) {
        var setSelectedInvoice;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setSelectedInvoice = _this.props.setSelectedInvoice;

                if (!data.checked) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return setSelectedInvoice(invo, "checked");

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return setSelectedInvoice(invo, "unChecked");

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.getFormatedDate = function (date) {
      var dateVal = parseInt(date);
      if (!Number(dateVal) || !dateVal === "") {
        return "";
      }

      var someday = moment$1(dateVal);
      return someday.format("MMMM DD YYYY");
    };

    _this.handleClose = function () {
      _this.setState({ modalOpen: false, isOpen: false });
    };

    _this.handleOpen = function () {
      _this.setState({ modalOpen: true, isOpen: true });
    };

    _this.state = {
      activeIndex: 1,
      showOtherTab: true,
      modalOpen: false,
      isOpen: false
    };
    return _this;
  }

  createClass(DisputedListCardHeader, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, "val.countryCode", ""));
      var countryForCurrencyCode = lodash_1(this.props, "val.chargeDesc.chargeDesc[0].countryForCurrency", "");

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          {
            size: "mini",
            className: "pendingList-table flex",
            style: { marginBottom: "5px" }
          },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "20px"
              },
              className: "flex-2"
            },
            React__default.createElement(
              "div",
              { style: { minWidth: "21px" } },
              cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this3.props.expandCard(_this3.props.cardIndex);
                },
                name: "plus circle",
                className: "card-toggle-icon"
              }),
              cardIndex === this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this3.props.expandCard(_this3.props.cardIndex);
                },
                name: "minus circle",
                className: "card-toggle-icon"
              })
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "val.drayageInvoiceNumber", "")
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country flex-1" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              countryData.countryName
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "SHIPMENT ID#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this, "props.val.chargeDesc.shipmentID", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$a, { date: lodash_1(this.props, "val.createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "ACC REF NO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value", style: { "max-width": "100px", "word-wrap": "break-word", "white-space": "normal" } },
              lodash_1(this.props, "val.referenceNumber", "-")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.chargeDesc.totalAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            "div",
            {
              //className="table-action-btns approve-disapprove-btn"
              style: {
                display: "flex",
                gap: "10px",
                minWidth: "171px"
              },
              className: "flex-2"
            },
            React__default.createElement(Popup, {
              closeIcon: true,
              trigger: React__default.createElement("i", {
                // style={getStyleBasedOnNegativeMargin(
                //   get(this, "props.val.chargeDesc.chargeDesc", [])
                // )}
                "class": "info icon visibility-icon btn-over"
              }),
              className: "approved-rate",
              content: React__default.createElement(
                Grid,
                { centered: true, columns: 1 },
                React__default.createElement(
                  Grid.Column,
                  { textAlign: "center" },
                  React__default.createElement(DrayagePartnerApproved, {
                    containerId: lodash_1(this.props, "val.containerId", ""),
                    ModalClose: this.handleClose,
                    getFormatedDate: this.getFormatedDate,
                    getFormatedCurrency: this.props.getFormatedCurrency
                  })
                ),
                React__default.createElement(
                  Grid.Column,
                  { textAlign: "center" },
                  React__default.createElement(DrayageCustomerApproved, {
                    containerId: lodash_1(this.props, "val.containerId", ""),
                    ModalClose: this.handleClose,
                    getFormatedDate: this.getFormatedDate,
                    getFormatedCurrency: this.props.getFormatedCurrency
                  })
                ),
                React__default.createElement("i", {
                  "class": "close icon visibility-close",
                  onClick: this.handleClose
                })
              ),
              on: "click",
              open: this.state.isOpen,
              onOpen: this.handleOpen,
              onClose: this.handleClose
            }),
            React__default.createElement(UploadDocument$1, {
              containerId: lodash_1(this.props, "val.containerId", ""),
              containerNumber: lodash_1(this.props, "val.containerNumber", ""),
              chargeDesc: lodash_1(this.props, "val.chargeDesc.chargeDesc", ""),
              showOtherTab: this.state.showOtherTab
            }),
            React__default.createElement(
              "span",
              {
                className: "btn-over",
                onClick: function onClick() {
                  var context = _this3.context;
                  context.setModalSize("fullscreen");
                  context.setShowModal(true);
                  context.setModalHeaderText("CHANGE LOG FOR " + lodash_1(_this3.props, "val.containerNumber", ""));
                  context.setDescriptionText(React__default.createElement(DrayageInvoiceChangeLog$1, { data: lodash_1(_this3.props, "val", {}) }));
                  context.setDescriptionHeaderText("");
                  // context.setCloseButtonText("Cancels");
                  // context.setActionButtonText("Raise Dispute");
                }
              },
              React__default.createElement(Icon, {
                style: {
                  padding: "10px 4px",
                  color: "#08adb6",
                  fontSize: "1.4em"
                },
                name: "history"
              })
            )
          )
        )
      );
    }
  }]);
  return DisputedListCardHeader;
}(Component);

DisputedListCardHeader.contextType = ModelContext$1;

var DisputedListCard = function (_Component) {
  inherits(DisputedListCard, _Component);

  function DisputedListCard(props) {
    classCallCheck(this, DisputedListCard);
    return possibleConstructorReturn(this, (DisputedListCard.__proto__ || Object.getPrototypeOf(DisputedListCard)).call(this, props));
  }

  createClass(DisputedListCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table content-static-card"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "VENDOR INVOICE NO."
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    {
                      className: "table-field-cell",
                      width: "1",
                      style: lodash_1(val, "calculatedUnitCount", "") && lodash_1(val, "quantity", "") !== lodash_1(val, "calculatedUnitCount", "") ? { color: 'red' } : {}
                    },
                    lodash_1(val, "quantity", ""),
                    lodash_1(val, "calculatedUnitCount", "") && lodash_1(val, "calculatedUnitCount", "") != lodash_1(val, "quantity", "") && React__default.createElement(Popup, {
                      trigger: React__default.createElement("i", { "class": "info circle icon black large" }),
                      header: "",
                      content: lodash_1(val, "calculatedUnitCount", "") > 0 ? "" + lodash_1(val, "calculatedUnitCount", "") : 'Gate IN event is not available',
                      position: "top center",
                      style: { maxWidth: "250px", height: "50px", color: '#00b5ad' }
                    })
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    React__default.createElement(Form.Input, {
                      readOnly: true,
                      disabled: true,
                      value: lodash_1(val, "drayageInvoiceNumber", "")
                    })
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        disabled: true,
                        readOnly: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return DisputedListCard;
}(Component);

var DisputedList = function (_Component) {
  inherits(DisputedList, _Component);

  function DisputedList(props) {
    var _this2 = this;

    classCallCheck(this, DisputedList);

    var _this = possibleConstructorReturn(this, (DisputedList.__proto__ || Object.getPrototypeOf(DisputedList)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.00;
      }
      return value;
    };

    _this.markPaidInvoice = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var setPaidInvice;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPaidInvice = _this.props.setPaidInvice;
              _context.next = 3;
              return setPaidInvice();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context3.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.state = { page: 1 };
    return _this;
  }

  createClass(DisputedList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("div", { style: { display: "flex", flexDirection: "row-reverse" } }),
        React__default.createElement(CustomLoader$1, { showImage: true, loading: this.props.fetchDisputedTabInvoices }),
        !this.props.fetchDisputedTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              { style: { marginBottom: "15px", background: "white" }, key: "pedning-card-" + index },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this3.props.activeCard === index,
                  index: 0,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(DisputedListCardHeader, {
                  activeCard: _this3.props.activeCard,
                  cardIndex: index,
                  expandCard: _this3.props.expandCard,
                  val: val,
                  getFormatedDate: _this3.props.getFormatedDate,
                  getCountryNameAndImage: _this3.props.getCountryNameAndImage,
                  getFormatedCurrency: _this3.props.getFormatedCurrency,
                  setSelectedInvoice: _this3.props.setSelectedInvoice,
                  userTypes: _this3.props.userTypes
                })
              ),
              React__default.createElement(
                Accordion.Content,
                {
                  active: _this3.props.activeCard === index,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(DisputedListCard, {
                  data: val,
                  index: index,
                  formatAmount: _this3.formatAmount,
                  getFormatedCurrency: _this3.props.getFormatedCurrency
                })
              )
            );
          })
        ),
        React__default.createElement(Pagination$2, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return DisputedList;
}(Component);

function Date$b(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var ApprovedListCardHeader = function (_Component) {
  inherits(ApprovedListCardHeader, _Component);

  function ApprovedListCardHeader(props) {
    classCallCheck(this, ApprovedListCardHeader);

    var _this = possibleConstructorReturn(this, (ApprovedListCardHeader.__proto__ || Object.getPrototypeOf(ApprovedListCardHeader)).call(this, props));

    _this.getFormatedDate = function (date) {
      var dateVal = parseInt(date);
      if (!Number(dateVal) || !dateVal === "") {
        return "";
      }

      var someday = moment$1(dateVal);
      return someday.format("MMMM DD YYYY");
    };

    _this.handleClose = function () {
      _this.setState({ modalOpen: false, isOpen: false });
    };

    _this.handleOpen = function () {
      _this.setState({ modalOpen: true, isOpen: true });
    };

    _this.state = {
      activeIndex: 1,
      showOtherTab: true,
      modalOpen: false,
      isOpen: false
    };
    return _this;
  }

  createClass(ApprovedListCardHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, "val.countryCode", ""));
      var countryCode = lodash_1(this.props, "val.countryCode", "");
      var invoiceUrl = lodash_1(this.props, "val.invoiceUrl", "") ? lodash_1(this.props, "val.invoiceUrl", "") : "";
      var countryForCurrencyCode = this.props.val && this.props.val.chargeDesc.chargeDesc[0] ? lodash_1(this.props, "val.chargeDesc.chargeDesc[0].countryForCurrency", "") : countryCode;
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          {
            size: "mini",
            className: "pendingList-table flex",
            style: { marginBottom: "5px" }
          },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "20px"
              },
              className: "flex-2"
            },
            React__default.createElement(
              "div",
              { style: { minWidth: "21px" } },
              invoiceUrl === "" && cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this2.props.expandCard(_this2.props.cardIndex);
                },
                name: "plus circle",
                className: "card-toggle-icon"
              }),
              invoiceUrl === "" && cardIndex === this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this2.props.expandCard(_this2.props.cardIndex);
                },
                name: "minus circle",
                className: "card-toggle-icon"
              })
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country invoice-number-container flex-2" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "val.drayageInvoiceNumber", "")
              ),
              invoiceUrl !== "" && React__default.createElement(
                "div",
                { className: "statistic-value-tooltip" },
                "SYNCED FROM INTACCT"
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country flex-1" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              countryData.countryName
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "SHIPMENT ID#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this, "props.val.shipmentId", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$b, { date: lodash_1(this.props, "val.createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "ACC REF NO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value", style: { "max-width": "100px", "word-wrap": "break-word", "white-space": "normal" } },
              lodash_1(this.props, "val.referenceNumber", "-")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.totalAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            "div",
            {
              //className="table-action-btns approve-disapprove-btn"
              style: {
                display: "flex",
                gap: "10px",
                minWidth: "171px"
              },
              className: "flex-2"
            },
            invoiceUrl === "" && React__default.createElement(Popup, {
              closeIcon: true,
              trigger: React__default.createElement("i", {
                // style={getStyleBasedOnNegativeMargin(
                //   get(this, "props.val.chargeDesc.chargeDesc", [])
                // )}
                "class": "info icon visibility-icon btn-over"
              }),
              className: "approved-rate",
              content: React__default.createElement(
                Grid,
                { centered: true, columns: 1 },
                React__default.createElement(
                  Grid.Column,
                  { textAlign: "center" },
                  React__default.createElement(DrayagePartnerApproved, {
                    containerId: lodash_1(this.props, "val.containerId", ""),
                    ModalClose: this.handleClose,
                    getFormatedDate: this.getFormatedDate,
                    getFormatedCurrency: this.props.getFormatedCurrency
                  })
                ),
                React__default.createElement(
                  Grid.Column,
                  { textAlign: "center" },
                  React__default.createElement(DrayageCustomerApproved, {
                    containerId: lodash_1(this.props, "val.containerId", ""),
                    ModalClose: this.handleClose,
                    getFormatedDate: this.getFormatedDate,
                    getFormatedCurrency: this.props.getFormatedCurrency
                  })
                ),
                React__default.createElement("i", {
                  "class": "close icon visibility-close",
                  onClick: this.handleClose
                })
              ),
              on: "click",
              open: this.state.isOpen,
              onOpen: this.handleOpen,
              onClose: this.handleClose
            }),
            invoiceUrl === "" && React__default.createElement(UploadDocument$1, {
              containerId: lodash_1(this.props, "val.containerId", ""),
              containerNumber: lodash_1(this.props, "val.containerNumber", ""),
              chargeDesc: lodash_1(this.props, "val.chargeDesc.chargeDesc", ""),
              showOtherTab: this.state.showOtherTab
            }),
            invoiceUrl === "" && React__default.createElement(
              "span",
              {
                className: "btn-over",
                onClick: function onClick() {
                  var context = _this2.context;
                  context.setModalSize("fullscreen");
                  context.setShowModal(true);
                  context.setModalHeaderText("CHANGE LOG FOR " + lodash_1(_this2.props, "val.containerNumber", ""));
                  context.setDescriptionText(React__default.createElement(DrayageInvoiceChangeLog$1, { data: lodash_1(_this2.props, "val", {}) }));
                  context.setDescriptionHeaderText("");
                  // context.setCloseButtonText("Cancels");
                  // context.setActionButtonText("Raise Dispute");
                }
              },
              React__default.createElement(Icon, {
                style: {
                  padding: "10px 4px",
                  color: "#08adb6",
                  fontSize: "1.4em"
                },
                name: "history"
              })
            )
          )
        )
      );
    }
  }]);
  return ApprovedListCardHeader;
}(Component);

ApprovedListCardHeader.contextType = ModelContext$1;

var ApprovedListCard = function (_Component) {
  inherits(ApprovedListCard, _Component);

  function ApprovedListCard(props) {
    classCallCheck(this, ApprovedListCard);
    return possibleConstructorReturn(this, (ApprovedListCard.__proto__ || Object.getPrototypeOf(ApprovedListCard)).call(this, props));
  }

  createClass(ApprovedListCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            {
              basic: "very",
              className: "drayage-line-item-table content-static-card"
            },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "VENDOR INVOICE NO."
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    {
                      className: "table-field-cell",
                      width: "1"
                      // style={
                      //   get(val, "calculatedUnitCount", "") &&
                      //   (get(val, "quantity", "") !== get(val, "calculatedUnitCount", ""))
                      //     ? { color: 'red' }
                      //     : {}
                      // }
                    },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    React__default.createElement(Form.Input, {
                      readOnly: true,
                      disabled: true,
                      value: lodash_1(val, "drayageInvoiceNumber", "")
                    })
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        disabled: true,
                        readOnly: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return ApprovedListCard;
}(Component);

var ApprovedList = function (_Component) {
  inherits(ApprovedList, _Component);

  function ApprovedList(props) {
    var _this2 = this;

    classCallCheck(this, ApprovedList);

    var _this = possibleConstructorReturn(this, (ApprovedList.__proto__ || Object.getPrototypeOf(ApprovedList)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.00;
      }
      return value;
    };

    _this.markPaidInvoice = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var setPaidInvice;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPaidInvice = _this.props.setPaidInvice;
              _context.next = 3;
              return setPaidInvice();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context3.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.state = { page: 1 };
    return _this;
  }

  createClass(ApprovedList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("div", { style: { display: "flex", flexDirection: "row-reverse" } }),
        React__default.createElement(CustomLoader$1, { showImage: true, loading: this.props.fetchApprovedTabInvoices }),
        !this.props.fetchApprovedTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              { style: { marginBottom: "15px", background: "white" }, key: "pedning-card-" + index },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this3.props.activeCard === index,
                  index: 0,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(ApprovedListCardHeader, {
                  activeCard: _this3.props.activeCard,
                  cardIndex: index,
                  expandCard: _this3.props.expandCard,
                  val: val,
                  getFormatedDate: _this3.props.getFormatedDate,
                  getCountryNameAndImage: _this3.props.getCountryNameAndImage,
                  getFormatedCurrency: _this3.props.getFormatedCurrency,
                  setSelectedInvoice: _this3.props.setSelectedInvoice,
                  userTypes: _this3.props.userTypes
                })
              ),
              React__default.createElement(
                Accordion.Content,
                {
                  active: _this3.props.activeCard === index,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(ApprovedListCard, {
                  data: val,
                  index: index,
                  formatAmount: _this3.formatAmount,
                  getFormatedCurrency: _this3.props.getFormatedCurrency
                })
              )
            );
          })
        ),
        lodash_1(this.props, "totalCount", 0) > 0 && React__default.createElement(Pagination$2, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return ApprovedList;
}(Component);

var Cancelled$1 = function (_Component) {
  inherits(Cancelled, _Component);

  function Cancelled(props) {
    classCallCheck(this, Cancelled);

    var _this = possibleConstructorReturn(this, (Cancelled.__proto__ || Object.getPrototypeOf(Cancelled)).call(this, props));

    _this.state = {
      activeCard: null
    };
    return _this;
  }

  createClass(Cancelled, [{
    key: 'setStateObj',
    value: function setStateObj(state) {
      this.setState(_extends({}, state));
    }
  }, {
    key: 'expandCard',
    value: function expandCard(id) {

      this.state.activeCard === id ? this.setStateObj({
        activeCard: null
      }) : this.setStateObj({
        activeCard: id
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React__default.createElement(
        'div',
        null,
        React__default.createElement(
          'p',
          null,
          'Cancelled'
        )
      );
    }
  }]);
  return Cancelled;
}(Component);

function Date$c(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var RejectedListCardHeader$1 = function (_Component) {
  inherits(RejectedListCardHeader, _Component);

  function RejectedListCardHeader(props) {
    classCallCheck(this, RejectedListCardHeader);

    var _this = possibleConstructorReturn(this, (RejectedListCardHeader.__proto__ || Object.getPrototypeOf(RejectedListCardHeader)).call(this, props));

    _this.state = {
      activeIndex: 1,
      showOtherTab: true
    };
    return _this;
  }

  createClass(RejectedListCardHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, 'val.countryCode', ''));
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          { size: "mini", style: { marginBottom: "5px" } },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "20px"

              }
            },
            React__default.createElement(
              Statistic,
              { className: "statistic-country" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, 'val.drayageInvoiceNumber', '')
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              countryData.countryName
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, 'val.containerNumber', '')
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, 'val.customerName', '')
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$c, { date: lodash_1(this.props, "val.createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            null,
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.totalAmount", ""), lodash_1(this.props, "val.countryCode", ""))
            )
          ),
          React__default.createElement(
            "div",
            {
              className: "table-action-btns approve-disapprove-btn",
              style: {
                display: "flex",
                gap: "10px"
              }
            },
            React__default.createElement(
              "div",
              null,
              React__default.createElement(
                Button,
                {
                  className: "save-invoice-btn",
                  onClick: function onClick(e) {
                    return _this2.props.goToChargelist(lodash_1(_this2.props, 'val.containerNumber', ''));
                  }
                },
                "GO TO CHARGELIST"
              )
            ),
            React__default.createElement(UploadDocument$1, {
              containerId: lodash_1(this.props, "val.containerId", ""),
              containerNumber: lodash_1(this.props.data, "value.containerNumber", ""),
              chargeDesc: lodash_1(this.props, "val.chargeDesc", ""),
              showOtherTab: this.state.showOtherTab
            })
          )
        )
      );
    }
  }]);
  return RejectedListCardHeader;
}(Component);

var RejectedListCardContentStatic$1 = function (_Component) {
  inherits(RejectedListCardContentStatic, _Component);

  function RejectedListCardContentStatic(props) {
    classCallCheck(this, RejectedListCardContentStatic);
    return possibleConstructorReturn(this, (RejectedListCardContentStatic.__proto__ || Object.getPrototypeOf(RejectedListCardContentStatic)).call(this, props));
  }

  createClass(RejectedListCardContentStatic, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            { basic: "very", className: "drayage-line-item-table content-static-card" },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return RejectedListCardContentStatic;
}(Component);

var Rejected$1 = function (_Component) {
  inherits(Rejected, _Component);

  function Rejected(props) {
    classCallCheck(this, Rejected);

    var _this = possibleConstructorReturn(this, (Rejected.__proto__ || Object.getPrototypeOf(Rejected)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.00;
      }
      return value;
    };

    return _this;
  }

  createClass(Rejected, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(CustomLoader$1, { showImage: true, loading: this.props.fetchRejectedTabInvoices }),
        !this.props.fetchRejectedTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              { style: { marginBottom: "15px", background: "white" }, key: "rejected-card-" + index },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this2.props.activeCard === index,
                  index: 0,
                  className: _this2.props.activeCard === index && "card-opened"
                },
                React__default.createElement(RejectedListCardHeader$1, {
                  activeCard: _this2.props.activeCard,
                  cardIndex: index,
                  expandCard: _this2.props.expandCard,
                  val: val,
                  getFormatedDate: _this2.props.getFormatedDate,
                  getCountryNameAndImage: _this2.props.getCountryNameAndImage,
                  getFormatedCurrency: _this2.props.getFormatedCurrency,
                  setSelectedInvoice: _this2.props.setSelectedInvoice,
                  goToChargelist: _this2.props.goToChargelist
                })
              )
            );
          })
        )
      );
    }
  }]);
  return Rejected;
}(Component);

function Date$d(_ref) {
  var date = _ref.date;

  var dateVal = parseInt(date);
  if (isNaN(dateVal) || !Number(dateVal) || dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMM DD, YYYY");
}

var PartiallyPaidListCardHeader$1 = function (_Component) {
  inherits(PartiallyPaidListCardHeader, _Component);

  function PartiallyPaidListCardHeader(props) {
    var _this2 = this;

    classCallCheck(this, PartiallyPaidListCardHeader);

    var _this = possibleConstructorReturn(this, (PartiallyPaidListCardHeader.__proto__ || Object.getPrototypeOf(PartiallyPaidListCardHeader)).call(this, props));

    _this.getFormatedDate = function (date) {
      var dateVal = parseInt(date);
      if (!Number(dateVal) || !dateVal === "") {
        return "";
      }

      var someday = moment$1(dateVal);
      return someday.format("MMMM DD YYYY");
    };

    _this.handleClose = function () {
      _this.setState({ modalOpen: false, isOpen: false });
    };

    _this.handleOpen = function () {
      _this.setState({ modalOpen: true, isOpen: true });
    };

    _this.handlePaidEvent = function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, invo) {
        var setSelectedInvoice;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setSelectedInvoice = _this.props.setSelectedInvoice;

                if (!data.checked) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return setSelectedInvoice(invo, "checked");

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return setSelectedInvoice(invo, "unChecked");

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.state = {
      activeIndex: 1,
      showOtherTab: true,
      modalOpen: false,
      isOpen: false
    };
    return _this;
  }

  createClass(PartiallyPaidListCardHeader, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var cardIndex = this.props.cardIndex;
      var countryData = this.props.getCountryNameAndImage(lodash_1(this.props, "val.countryCode", ""));
      var countryCode = lodash_1(this.props, "val.countryCode", "");
      var invoiceUrl = lodash_1(this.props, "val.invoiceUrl", "") ? lodash_1(this.props, "val.invoiceUrl", "") : "";
      var countryForCurrencyCode = this.props.val && this.props.val.chargeDesc.chargeDesc[0] ? lodash_1(this.props, "val.chargeDesc.chargeDesc[0].countryForCurrency", "") : countryCode;
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          Statistic.Group,
          { size: "mini", style: { marginBottom: "5px" }, className: "flex" },
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start",
                gap: "20px"
              },
              className: "flex-2"
            },
            React__default.createElement(
              "div",
              { style: { minWidth: "21px" } },
              cardIndex !== this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this3.props.expandCard(_this3.props.cardIndex);
                },
                name: "plus circle",
                className: "card-toggle-icon"
              }),
              cardIndex === this.props.activeCard && React__default.createElement(Icon, {
                onClick: function onClick(e) {
                  return _this3.props.expandCard(_this3.props.cardIndex);
                },
                name: "minus circle",
                className: "card-toggle-icon"
              })
            ),
            React__default.createElement(
              Statistic,
              { className: "statistic-country invoice-number-container" },
              React__default.createElement(
                Statistic.Label,
                { className: "statistic-label" },
                "INVOICE#"
              ),
              React__default.createElement(
                Statistic.Value,
                { className: "statistic-value" },
                lodash_1(this.props, "val.drayageInvoiceNumber", "")
              ),
              invoiceUrl !== "" && React__default.createElement(
                "div",
                { className: "statistic-value-tooltip" },
                "SYNCED FROM INTACCT"
              )
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "statistic-country flex-1" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "COUNTRY"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              countryData.countryName
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "SHIPMENT ID#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this, "props.val.shipmentId", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CONTAINER#"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.containerNumber", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CUSTOMER"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, "val.customerName", "")
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "CREATED DATE"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              React__default.createElement(Date$d, { date: lodash_1(this.props, "val.createdDate", "") })
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "BILL TO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              "KLEARNOW"
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "ACC REF NO"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value" },
              lodash_1(this.props, 'val.referenceNumber', '')
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "PAID AMOUNT"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value reference-no" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.paidAmount", ""), lodash_1(this.props, "val.chargeDesc.chargeDesc[0].countryForCurrency", ""))
            )
          ),
          React__default.createElement(
            Statistic,
            { className: "flex-2" },
            React__default.createElement(
              Statistic.Label,
              { className: "statistic-label" },
              "GRAND TOTAL"
            ),
            React__default.createElement(
              Statistic.Value,
              { className: "statistic-value currency" },
              this.props.getFormatedCurrency(lodash_1(this.props, "val.totalAmount", ""), countryForCurrencyCode)
            )
          ),
          React__default.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "10px",
                minWidth: "171px"
              },
              className: "flex-2"
            },
            this.props.userTypes === "OPS_PARTNER" && React__default.createElement(
              "div",
              null,
              React__default.createElement(
                Button,
                {
                  className: "save-invoice-btn"
                  // onClick={(e) => {
                  //   this.props.editChargeListCharge(this.props.index);
                  // }}
                },
                "APPROVE"
              ),
              React__default.createElement(
                Button,
                {
                  className: "save-invoice-btn"
                  // onClick={(e) => {
                  //   this.props.editChargeListCharge(this.props.index);
                  // }}
                },
                "REJECT"
              )
            ),
            invoiceUrl === "" && React__default.createElement(Popup, {
              closeIcon: true,
              trigger: React__default.createElement("i", {
                // style={getStyleBasedOnNegativeMargin(
                //   get(this, "props.val.chargeDesc.chargeDesc", [])
                // )}
                "class": "info icon visibility-icon btn-over"
              }),
              className: "approved-rate",
              content: React__default.createElement(
                Grid,
                { centered: true, columns: 1 },
                React__default.createElement(
                  Grid.Column,
                  { textAlign: "center" },
                  React__default.createElement(DrayagePartnerApproved, {
                    containerId: lodash_1(this.props, "val.containerId", ""),
                    ModalClose: this.handleClose,
                    getFormatedDate: this.getFormatedDate,
                    getFormatedCurrency: this.props.getFormatedCurrency
                  })
                ),
                React__default.createElement(
                  Grid.Column,
                  { textAlign: "center" },
                  React__default.createElement(DrayageCustomerApproved, {
                    containerId: lodash_1(this.props, "val.containerId", ""),
                    ModalClose: this.handleClose,
                    getFormatedDate: this.getFormatedDate,
                    getFormatedCurrency: this.props.getFormatedCurrency
                  })
                ),
                React__default.createElement("i", {
                  "class": "close icon visibility-close",
                  onClick: this.handleClose
                })
              ),
              on: "click",
              open: this.state.isOpen,
              onOpen: this.handleOpen,
              onClose: this.handleClose
            }),
            invoiceUrl === "" && React__default.createElement(UploadDocument$1, {
              containerId: lodash_1(this.props, "val.containerId", ""),
              containerNumber: lodash_1(this.props.data, "value.containerNumber", ""),
              chargeDesc: lodash_1(this.props, "val.chargeDesc.chargeDesc", ""),
              showOtherTab: this.state.showOtherTab
            }),
            invoiceUrl === "" && React__default.createElement(
              "span",
              {
                className: "btn-over",
                onClick: function onClick() {
                  var context = _this3.context;
                  context.setModalSize("fullscreen");
                  context.setShowModal(true);
                  context.setModalHeaderText("CHANGE LOG FOR " + lodash_1(_this3.props, "val.containerNumber", ""));
                  context.setDescriptionText(React__default.createElement(DrayageInvoiceChangeLog$1, { data: lodash_1(_this3.props, "val", {}) }));
                  context.setDescriptionHeaderText("");
                  // context.setCloseButtonText("Cancels");
                  // context.setActionButtonText("Raise Dispute");
                }
              },
              React__default.createElement(Icon, {
                style: {
                  padding: "10px 4px",
                  color: "#08adb6",
                  fontSize: "1.4em"
                },
                name: "history"
              })
            )
          )
        )
      );
    }
  }]);
  return PartiallyPaidListCardHeader;
}(Component);

PartiallyPaidListCardHeader$1.contextType = ModelContext$1;

var PartiallyPaidListCardContentStatic$1 = function (_Component) {
  inherits(PartiallyPaidListCardContentStatic, _Component);

  function PartiallyPaidListCardContentStatic(props) {
    classCallCheck(this, PartiallyPaidListCardContentStatic);
    return possibleConstructorReturn(this, (PartiallyPaidListCardContentStatic.__proto__ || Object.getPrototypeOf(PartiallyPaidListCardContentStatic)).call(this, props));
  }

  createClass(PartiallyPaidListCardContentStatic, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            Table,
            { basic: "very", className: "drayage-line-item-table content-static-card" },
            React__default.createElement(
              Table.Header,
              null,
              React__default.createElement(
                Table.Row,
                null,
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "CHARGES"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UNIT"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "RATE"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "UOM"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "TOTAL"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "STATUS"
                ),
                React__default.createElement(
                  Table.HeaderCell,
                  { className: "table-heading-cell" },
                  "COMMENT"
                )
              )
            ),
            React__default.createElement(
              Table.Body,
              null,
              lodash_1(this.props, "data.chargeDesc.chargeDesc", []).map(function (val, index) {
                return React__default.createElement(
                  Table.Row,
                  { key: "static-charge-" + index },
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "chargeName", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "quantity", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "unitPrice", "") * 100, lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell", width: "1" },
                    lodash_1(val, "unitOfMeasurement", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell total-value" },
                    _this2.props.getFormatedCurrency(lodash_1(val, "totalRate", ""), lodash_1(val, "countryForCurrency", ""))
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    lodash_1(val, "status", "")
                  ),
                  React__default.createElement(
                    Table.Cell,
                    { className: "table-field-cell" },
                    React__default.createElement(Popup, {
                      trigger: React__default.createElement(Form.Input, {
                        readOnly: true,
                        value: lodash_1(val, "chargeComment", ""),
                        onChange: function onChange(e, data) {},
                        onBlur: function onBlur(e) {}
                      }),
                      header: "",
                      content: lodash_1(val, "chargeComment", ""),
                      position: "top center",
                      style: { maxWidth: "150px" },
                      on: "focus"
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return PartiallyPaidListCardContentStatic;
}(Component);

var PartiallyPaidList$1 = function (_Component) {
  inherits(PartiallyPaidList, _Component);

  function PartiallyPaidList(props) {
    var _this2 = this;

    classCallCheck(this, PartiallyPaidList);

    var _this = possibleConstructorReturn(this, (PartiallyPaidList.__proto__ || Object.getPrototypeOf(PartiallyPaidList)).call(this, props));

    _this.formatAmount = function (value) {
      var val = parseFloat(value);
      if (isNaN(val) || val <= 0) {
        return 0.0;
      }
      return value;
    };

    _this.markPaidInvoice = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var setPaidInvice;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPaidInvice = _this.props.setPaidInvice;
              _context.next = 3;
              return setPaidInvice();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.prevPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage - 1;
              if (currPage < 1) {
                currPage = 1;
              }
              _this.setState({ page: currPage });
              _context2.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));
    _this.nextPage = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var currPage;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currPage = _this.state.page;

              currPage = currPage + 1;
              if (Math.ceil(_this.props.totalCount / 25) < currPage) {
                currPage = Math.ceil(_this.props.totalCount / 25);
              }
              _this.setState({ page: currPage });
              _context3.next = 6;
              return _this.props.getTabData(currPage);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.state = { page: 1 };
    return _this;
  }

  createClass(PartiallyPaidList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getTabData(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("div", { style: { display: "flex", flexDirection: "row-reverse" } }),
        React__default.createElement(CustomLoader$1, {
          showImage: true,
          loading: this.props.fetchPartiallyPaidTabInvoices
        }),
        !this.props.fetchPartiallyPaidTabInvoices && React__default.createElement(
          Accordion,
          { fluid: true },
          lodash_1(this.props, "invoices", []).map(function (val, index) {
            return React__default.createElement(
              "div",
              {
                style: { marginBottom: "15px", background: "white" },
                key: "partially-paid-card-" + index
              },
              React__default.createElement(
                Accordion.Title,
                {
                  style: { marginTop: "15px", padding: "1px 15px" },
                  active: _this3.props.activeCard === index,
                  index: 0,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PartiallyPaidListCardHeader$1, {
                  activeCard: _this3.props.activeCard,
                  cardIndex: index,
                  expandCard: _this3.props.expandCard,
                  val: val,
                  getFormatedDate: _this3.props.getFormatedDate,
                  getCountryNameAndImage: _this3.props.getCountryNameAndImage,
                  getFormatedCurrency: _this3.props.getFormatedCurrency,
                  setSelectedInvoice: _this3.props.setSelectedInvoice,
                  userTypes: _this3.props.userTypes
                })
              ),
              React__default.createElement(
                Accordion.Content,
                {
                  active: _this3.props.activeCard === index,
                  className: _this3.props.activeCard === index && "card-opened"
                },
                React__default.createElement(PartiallyPaidListCardContentStatic$1, {
                  data: val,
                  index: index,
                  formatAmount: _this3.formatAmount,
                  getFormatedCurrency: _this3.props.getFormatedCurrency
                })
              )
            );
          })
        ),
        lodash_1(this.props, "totalCount", 0) > 0 && React__default.createElement(Pagination$2, {
          prevPage: this.prevPage,
          nextPage: this.nextPage,
          page: this.state.page,
          totalCount: this.props.totalCount
        })
      );
    }
  }]);
  return PartiallyPaidList;
}(Component);

// export const debounce(fn, delay) {
//     let timer;
//     return (() => {
//       clearTimeout(timer);
//       timer = setTimeout(() => fn(), delay);
//     })();
//   }

var DrayageInvoiceSearchbar$1 = function (_React$Component) {
  inherits(DrayageInvoiceSearchbar, _React$Component);

  function DrayageInvoiceSearchbar(props) {
    classCallCheck(this, DrayageInvoiceSearchbar);

    var _this = possibleConstructorReturn(this, (DrayageInvoiceSearchbar.__proto__ || Object.getPrototypeOf(DrayageInvoiceSearchbar)).call(this, props));

    _this.setKeyword = function (value) {
      _this.setState({ keyWord: value });
      _this.props.sendKeywordFun(value);
    };

    _this.sendBackKeyword = function () {
      var keyWord = _this.state.keyWord;

      if (keyWord.length > 1 || keyWord === "") {
        _this.props.callbackKeyword(keyWord);
      }
    };

    _this.emptySearch = function () {
      _this.setKeyword("");
      _this.props.callbackKeyword("");
    };

    _this.state = {
      keyWord: ""
    };
    _this.sendBackKeyword = debounce(_this.sendBackKeyword, 500);
    return _this;
  }

  createClass(DrayageInvoiceSearchbar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var keyWord = this.state.keyWord; //this.props.sendKeyword

      return React__default.createElement(
        "div",
        { className: "drayage-invoice-searchbar" },
        React__default.createElement("i", { className: "search icon " }),
        React__default.createElement("input", {
          className: "search icon drayage-invoice-input",
          value: this.props.sendKeyword ? this.props.sendKeyword : keyWord,
          placeholder: "Search Invoices",
          onKeyUp: this.sendBackKeyword,
          onChange: function onChange(e) {
            return _this2.setKeyword(e.target.value, e.preventDefault());
          }
        })
      );
    }
  }]);
  return DrayageInvoiceSearchbar;
}(React__default.Component);

var css_248z$r = ".background-col.invoice-admin-bg {\n  background-color: #f5f5f5 !important; }\n\n.ua-container.invoice-admin-ua-container-bg {\n  padding-bottom: 40px;\n  background-color: none; }\n\n.isgeneraed-in {\n  position: fixed;\n  left: 22vw;\n  text-align: center;\n  top: 50vh;\n  z-index: 1; }\n  .isgeneraed-in .ui.message {\n    width: 50%; }\n\n.billing-ui-repo-payment-history-table {\n  width: 300px !important; }\n  .billing-ui-repo-payment-history-table .customized-loader img {\n    width: 100% !important; }\n  .billing-ui-repo-payment-history-table thead tr {\n    display: table;\n    width: 100%;\n    table-layout: fixed; }\n    .billing-ui-repo-payment-history-table thead tr th {\n      font-family: \"Roboto\";\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px !important;\n      line-height: 16px !important;\n      color: #7a7a7a !important;\n      padding: 5px !important; }\n  .billing-ui-repo-payment-history-table tbody {\n    display: block;\n    height: 200px;\n    overflow: auto; }\n    .billing-ui-repo-payment-history-table tbody tr {\n      display: table;\n      width: 100%;\n      table-layout: fixed; }\n      .billing-ui-repo-payment-history-table tbody tr td {\n        font-family: \"Roboto\";\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px !important;\n        line-height: 16px !important;\n        color: #7a7a7a !important;\n        padding: 5px !important;\n        border: 1px solid rgba(34, 36, 38, 0.1) !important; }\n\n.admin-invoice {\n  width: 80vw;\n  margin: 0 auto;\n  position: relative; }\n  @media screen and (max-width: 1400px) {\n    .admin-invoice {\n      width: 96vw; } }\n  .admin-invoice .icon {\n    cursor: pointer; }\n  .admin-invoice .pending-wrap {\n    overflow: hidden;\n    padding-left: 6px;\n    margin-top: 10px; }\n    .admin-invoice .pending-wrap .pending-left {\n      float: left; }\n    .admin-invoice .pending-wrap .pending-right {\n      float: right; }\n  .admin-invoice div, .admin-invoice .detail-button-s, .admin-invoice label, .admin-invoice button, .admin-invoice h4, .admin-invoice h5, .admin-invoice span, .admin-invoice p, .admin-invoice a {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-weight: 200 !important;\n    color: rgba(0, 0, 0, 0.87) !important; }\n  .admin-invoice .admin-invoice-details {\n    position: relative; }\n  .admin-invoice .paid-select-label {\n    color: rgba(0, 0, 0, 0.87);\n    margin: 0 10px; }\n  .admin-invoice .admin-check-box {\n    position: absolute;\n    z-index: 1;\n    top: 20px;\n    left: 5px; }\n  .admin-invoice .inner-loader {\n    position: fixed;\n    left: 48vw;\n    top: 50vh;\n    font-weight: bold;\n    z-index: 1; }\n  .admin-invoice.invoice-right-sec {\n    width: 60vw;\n    float: left;\n    margin: 0; }\n  .admin-invoice .ui.dimmer .content {\n    background-color: transparent; }\n  .admin-invoice .print-sec {\n    min-width: 44px; }\n  .admin-invoice .headerSectionFour .cbpHeaderText {\n    text-align: center; }\n  .admin-invoice .filterChargeList {\n    display: flex; }\n  .admin-invoice .filterChargeList .ui.checkbox label {\n    font-size: 14px !important; }\n  .admin-invoice .chargeListFilter {\n    display: flex;\n    padding: 10px;\n    background: #fff;\n    margin-top: 10px; }\n  .admin-invoice .chargeListFilter .ui.segment {\n    background-color: #fff !important;\n    padding: 10px; }\n  .admin-invoice .chargeListFilter .ui.input > input {\n    padding: 5px;\n    margin-left: 10px;\n    border: 1px solid rgba(34, 36, 38, 0.15);\n    max-width: 137px; }\n  .admin-invoice .filterChargeList .ui.input {\n    font-size: 14px; }\n  .admin-invoice .ui.segment.import-country-list {\n    width: 40px;\n    border: 1px solid;\n    padding: 0 0 0 5px;\n    border: 1px solid #0A8B8F;\n    right: 0;\n    z-index: 1;\n    line-height: 1;\n    height: 45px;\n    margin-top: 7px;\n    border-radius: 4px; }\n    .admin-invoice .ui.segment.import-country-list .ui.dropdown .menu {\n      width: 100%;\n      top: 100%; }\n    .admin-invoice .ui.segment.import-country-list .item.dropdown.icon {\n      position: absolute;\n      left: 0px;\n      width: 100%;\n      padding-left: 10px;\n      z-index: 2;\n      top: 0px;\n      line-height: 3; }\n    .admin-invoice .ui.segment.import-country-list .angle.down.icon {\n      position: absolute;\n      right: 6px;\n      z-index: 1;\n      bottom: -3px; }\n    .admin-invoice .ui.segment.import-country-list .filter-label {\n      margin-bottom: 0; }\n    .admin-invoice .ui.segment.import-country-list .text {\n      font-size: 14px; }\n  .admin-invoice .display-dir {\n    display: flex;\n    display: flex;\n    align-items: center;\n    vertical-align: middle; }\n    .admin-invoice .display-dir .ui.form .field {\n      margin-bottom: 0; }\n    .admin-invoice .display-dir .invoice-charge-list-drop {\n      margin-right: 100px; }\n  .admin-invoice .country-item-list {\n    padding: 8px;\n    line-height: 1; }\n    .admin-invoice .country-item-list label {\n      margin-left: 15px; }\n  .admin-invoice .content {\n    background-color: #fff; }\n    .admin-invoice .content .invoice-container {\n      width: 100%; }\n  .admin-invoice .title {\n    background-color: #fff; }\n  .admin-invoice .ui.segment {\n    background-color: transparent;\n    box-shadow: none;\n    border: none;\n    border-radius: 0;\n    padding: 10px 0 0 0; }\n  .admin-invoice .admin-invoice-container {\n    display: flex;\n    padding-top: 10px; }\n    .admin-invoice .admin-invoice-container .admin-invoice-title {\n      color: #000000;\n      font-size: 20px;\n      min-width: 100px;\n      cursor: pointer; }\n    .admin-invoice .admin-invoice-container .admin-invoice-tab {\n      display: flex; }\n    .admin-invoice .admin-invoice-container .admin-invoice-tab-title {\n      padding: 10px;\n      background: #fff;\n      margin-right: 5px;\n      position: relative;\n      cursor: pointer; }\n      .admin-invoice .admin-invoice-container .admin-invoice-tab-title.active {\n        background: #0A8B8F;\n        color: #fff; }\n      .admin-invoice .admin-invoice-container .admin-invoice-tab-title .admin-invoice-count {\n        background: #52ABF6;\n        padding: 4px 6px;\n        border-radius: 100%;\n        color: #ffff;\n        font-size: 10px;\n        margin-left: 5px; }\n  .admin-invoice .generate-button {\n    background: #04ADB1;\n    color: #fff;\n    font-size: 18px;\n    font-weight: bold;\n    border: 1px solid #04ADB1;\n    min-width: 120px;\n    padding: 10px;\n    margin-top: 10px; }\n    .admin-invoice .generate-button:hover {\n      background: #04adb1c2;\n      color: #ffffffdb; }\n    .admin-invoice .generate-button .ui.button:active {\n      background: #fff; }\n  .admin-invoice .detail-button {\n    margin: 0; }\n  .admin-invoice .detail-button-s {\n    vertical-align: middle;\n    padding: 10px 1em 10px;\n    font-weight: 500;\n    color: #04ADB1;\n    background: #fff;\n    border: 1px solid #008B8F;\n    margin-top: 10px;\n    display: flex;\n    cursor: pointer; }\n    .admin-invoice .detail-button-s .ui.button:active {\n      background: #fff; }\n    .admin-invoice .detail-button-s:hover {\n      background: transparent;\n      color: #04adb1b5; }\n    .admin-invoice .detail-button-s.delete-button {\n      border: none; }\n    .admin-invoice .detail-button-s.isOpen {\n      background-color: #0A8B8F !important;\n      color: white !important;\n      font-weight: 800 !important; }\n  .admin-invoice .loadingggggg {\n    position: fixed;\n    background: rgba(225, 225, 225, 0.9);\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    opacity: 0.8;\n    text-align: center; }\n  .admin-invoice .invoice-row-container {\n    padding: 0 20px; }\n  .admin-invoice .invoice-hear {\n    overflow: hidden;\n    border-bottom: 3px solid #059090;\n    padding: 15px 0 5px;\n    color: #7f7f7f; }\n  .admin-invoice .invoice-left {\n    float: left;\n    width: 50%; }\n  .admin-invoice .invoice-right {\n    float: left;\n    width: 50%; }\n  .admin-invoice .dispute-reason {\n    background: yellow;\n    padding: 0 10px 5px;\n    max-width: 350px;\n    clear: both; }\n    .admin-invoice .dispute-reason p {\n      margin-bottom: 0; }\n    .admin-invoice .dispute-reason h4 {\n      margin-bottom: 0; }\n  .admin-invoice .head-cell {\n    float: left; }\n  .admin-invoice .head-cell-sl {\n    width: 10%;\n    padding-left: 3px;\n    float: left;\n    font-weight: 700;\n    font-size: 20px;\n    margin-top: 10px; }\n  .admin-invoice .head-cell-sl.head-sr {\n    font-size: 12px;\n    font-weight: 500;\n    margin-top: 0px; }\n  .admin-invoice .head-cell-date {\n    width: 25%;\n    float: left; }\n  .admin-invoice .head-cell-shipment {\n    width: 60%;\n    float: left; }\n  .admin-invoice .head-cell-activity {\n    width: 40%;\n    float: left; }\n    .admin-invoice .head-cell-activity.expand-row {\n      width: 38%; }\n    .admin-invoice .head-cell-activity.charge-list {\n      width: 26%; }\n  .admin-invoice .head-cell-unity {\n    width: 7%;\n    float: left;\n    text-align: right; }\n    .admin-invoice .head-cell-unity.charge-list {\n      min-height: 1px; }\n      .admin-invoice .head-cell-unity.charge-list.charge-list-all {\n        width: 12%;\n        min-height: 1px;\n        text-align: left;\n        word-break: break-all; }\n  .admin-invoice .head-cell-rate {\n    width: 20%;\n    float: left;\n    text-align: right; }\n    .admin-invoice .head-cell-rate.charge-list {\n      width: 7%;\n      margin-left: 10px; }\n  .admin-invoice .head-cell-rate.red {\n    color: red; }\n  .admin-invoice .head-cell-total {\n    width: 17%;\n    float: right;\n    text-align: right;\n    padding-right: 4px; }\n    .admin-invoice .head-cell-total.charge-list {\n      width: 13%;\n      float: left; }\n      .admin-invoice .head-cell-total.charge-list.customerInvoiceNumber {\n        width: 18%; }\n  .admin-invoice .invoice-data-row {\n    overflow: hidden;\n    border-bottom: 2px solid #d4d4d4;\n    padding: 10px 0;\n    font-weight: bold; }\n  .admin-invoice .invoice-data-row.last-row {\n    border-bottom: none; }\n  .admin-invoice .invoice-data {\n    overflow: scroll;\n    padding: 10px 0;\n    border-bottom: 1px solid #d4d4d4;\n    color: #000;\n    align-items: center; }\n    .admin-invoice .invoice-data.new-add {\n      overflow: initial; }\n    .admin-invoice .invoice-data input {\n      display: block;\n      width: 100%;\n      border: 1px solid #d4d4d4;\n      text-align: center;\n      text-align: center;\n      height: 40px;\n      margin-bottom: 10px; }\n    .admin-invoice .invoice-data.delete-selected {\n      background-color: #d1d1d1;\n      pointer-events: none; }\n      .admin-invoice .invoice-data.delete-selected input, .admin-invoice .invoice-data.delete-selected button {\n        background-color: #d1d1d1; }\n    .admin-invoice .invoice-data.add-list {\n      display: flex;\n      overflow: hidden; }\n      .admin-invoice .invoice-data.add-list input {\n        height: 35px;\n        margin-bottom: 0;\n        width: 100%; }\n      .admin-invoice .invoice-data.add-list button {\n        margin-top: 0; }\n  .admin-invoice .invoice-date {\n    color: #000;\n    font-size: 14px;\n    margin: 10px 5px 20px 0; }\n  .admin-invoice .invoice-item {\n    color: #615f5f;\n    font-weight: 300;\n    min-width: 110px; }\n  .admin-invoice .invoice-po {\n    color: #615f5f;\n    min-width: 110px; }\n  .admin-invoice .invoice-bill {\n    color: #615f5f;\n    min-width: 110px; }\n  .admin-invoice .invoice-subtotal {\n    overflow: hidden;\n    padding-top: 10px;\n    color: #059090;\n    font-weight: 700; }\n  .admin-invoice .subtotal-label {\n    float: left;\n    width: 80%; }\n  .admin-invoice .subtotal-amount {\n    float: right;\n    width: 20%;\n    text-align: right; }\n  .admin-invoice .invoice-discount {\n    color: #fa021b; }\n  .admin-invoice .head-cell-date {\n    margin-bottom: 10px; }\n  .admin-invoice .head-cell-shipment {\n    margin-bottom: 10px; }\n    .admin-invoice .head-cell-shipment .invoice-date {\n      cursor: pointer; }\n  .admin-invoice .invoice-item p, .admin-invoice .invoice-po, .admin-invoice .invoice-bill {\n    font-weight: 300;\n    margin-bottom: 10px; }\n  .admin-invoice .invoice-total {\n    padding: 7px 0 7px 0;\n    text-align: right;\n    font-size: 14px;\n    font-weight: bold;\n    overflow: hidden;\n    border-top: 3px solid #059090;\n    border-bottom: 3px solid #059090; }\n  .admin-invoice .entry-wrapper {\n    display: flex; }\n\n.cbpHeaderText {\n  word-wrap: break-word; }\n\n.invoice-right-modal {\n  width: 39vw;\n  padding: 20px 10px 10px;\n  border: 1px solid grey;\n  float: left;\n  position: fixed;\n  right: 0;\n  height: calc(100vh - 133px);\n  overflow: scroll;\n  top: 80px; }\n  .invoice-right-modal .invoice-image-cont {\n    overflow-y: scroll; }\n    .invoice-right-modal .invoice-image-cont img {\n      width: 100%;\n      display: block;\n      height: 100%; }\n  .invoice-right-modal .invoice-shipment-doc {\n    overflow: hidden; }\n    .invoice-right-modal .invoice-shipment-doc .invoice-doc-label {\n      border: 1px solid #008b8f;\n      float: left;\n      background-color: #f1f1f1;\n      cursor: pointer;\n      font-weight: 700;\n      margin: 5px;\n      border-radius: 2px;\n      color: #389cff;\n      min-width: 100px;\n      text-align: center;\n      padding: 8px 28px 8px 8px; }\n    .invoice-right-modal .invoice-shipment-doc .invoice-doc-label.active {\n      background: #ebfeff; }\n\n.admin-popup {\n  position: fixed;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  padding: 1em;\n  background-color: rgba(213, 213, 213, 0.5); }\n\n.admin-popup-containt {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  left: 50%;\n  top: 50%;\n  max-height: 88vh;\n  min-width: 30vh;\n  width: 50vw;\n  color: #000;\n  z-index: 999;\n  padding: 70px 150px 80px;\n  border: 1px solid rgba(146, 146, 146, 0.5);\n  border-radius: 5px;\n  background: #fff;\n  overflow: scroll;\n  box-shadow: 1px 3px 3px 0 rgba(0, 0, 0, 0.2), 1px 3px 15px 2px rgba(0, 0, 0, 0.2); }\n  .admin-popup-containt textarea {\n    width: 100%;\n    min-height: 100px;\n    padding: 10px;\n    border-radius: 0px;\n    margin: 0px;\n    border: 1px solid rgba(146, 146, 146, 0.5); }\n    .admin-popup-containt textarea::-webkit-input-placeholder {\n      font-style: normal; }\n    .admin-popup-containt textarea::-moz-placeholder {\n      font-style: normal; }\n  .admin-popup-containt .close-popup {\n    font-size: 29px;\n    color: #008B8F;\n    text-align: right;\n    position: absolute;\n    right: 0;\n    top: 0px;\n    height: 60px;\n    width: 60px;\n    cursor: pointer;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .admin-popup-containt .admin-popup-wrap {\n    color: #000;\n    border: 1px solid #979797;\n    padding: 14px;\n    margin-bottom: 16px;\n    border-radius: 3px; }\n  .admin-popup-containt .popup-title {\n    font-size: 20px; }\n  .admin-popup-containt .admin-popup-card {\n    display: flex;\n    margin-bottom: 16px; }\n  .admin-popup-containt .popup-button {\n    width: 100%;\n    margin-top: 50px;\n    background-color: #008B8F;\n    border: 1px solid #008B8F;\n    border-radius: 2px;\n    padding: 15px;\n    font-weight: bold;\n    color: #fff;\n    font-size: 16px;\n    cursor: pointer; }\n  .admin-popup-containt .left-sec, .admin-popup-containt .right-sec {\n    display: block;\n    width: 50%;\n    float: left;\n    text-align: left; }\n  .admin-popup-containt .left-sec img {\n    width: 100px; }\n  .admin-popup-containt .add-payment {\n    display: flex;\n    color: #1765AE;\n    margin-bottom: 30px; }\n    .admin-popup-containt .add-payment .change-payment, .admin-popup-containt .add-payment .add-new-payment {\n      width: 50%;\n      cursor: pointer; }\n    .admin-popup-containt .add-payment .change-payment {\n      text-align: left; }\n    .admin-popup-containt .add-payment .add-new-payment {\n      text-align: right; }\n\n.term-and-cond-wrap {\n  font-size: 16px;\n  margin-top: 10px; }\n\n.term-and-cond {\n  color: #1765AE;\n  cursor: pointer; }\n\n.pay-label {\n  color: #606060;\n  font-size: 14px;\n  /* margin-bottom: 10px; */ }\n\n.pay-disc {\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #000; }\n\n.admin-bill {\n  text-align: left; }\n\n.admin-radio {\n  width: 100px;\n  position: relative;\n  top: 25px;\n  left: 15px; }\n  .admin-radio label {\n    font-size: 0px !important;\n    padding-left: 1.85714em;\n    display: inline-block;\n    position: absolute;\n    left: 0;\n    z-index: 1; }\n    .admin-radio label:before {\n      content: '';\n      transform: none;\n      border-radius: 500rem;\n      top: 0px;\n      left: 0;\n      border: 2px solid #008B8F;\n      width: 24px;\n      height: 24px;\n      display: inline-block;\n      cursor: pointer; }\n    .admin-radio label:after {\n      content: '';\n      top: 0px;\n      left: 0;\n      width: 24px;\n      height: 24px;\n      border-radius: 500rem;\n      -webkit-transform: scale(0.46667);\n      transform: scale(0.46667);\n      background-color: #fff;\n      display: inline-block;\n      position: absolute; }\n  .admin-radio input[type=radio] {\n    position: absolute;\n    z-index: 2;\n    opacity: 0;\n    height: 25px;\n    width: 24px;\n    border: 1px solid #008B8F;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    outline: 0; }\n\n.admin-card-pay span {\n  width: calc(100% - 50px);\n  text-align: left;\n  display: inline-block;\n  vertical-align: top; }\n\ninput:checked ~ label:after {\n  background-color: #008B8F; }\n\n.react-datepicker-wrapper .today {\n  width: 150px; }\n\n.react-datepicker-wrapper .react-datepicker__input-container input {\n  width: 100%; }\n\n.popup-date-wrap {\n  display: flex; }\n\n.popup-status {\n  color: #000000;\n  font-size: 17px;\n  background: #FFF8B4;\n  padding: 10px; }\n\n.adress-title {\n  color: #169599;\n  font-size: 13px; }\n\n.pay-adress {\n  font-size: 16px;\n  color: #000;\n  font-weight: bold;\n  font-style: normal; }\n\n.popup-done-state img {\n  width: 100px; }\n\n.popup-done-state {\n  border: 1px solid #979797;\n  padding: 30px 0; }\n\n.auth-label, .popup-confirm {\n  font-size: 18px;\n  margin-top: 20px;\n  color: #606060; }\n\n.headerPrint {\n  border: 1px solid #008B8F;\n  padding-left: 10px;\n  height: 36px;\n  width: 40px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  margin-top: 7px;\n  border-radius: 5px;\n  cursor: pointer; }\n  .headerPrint .paymentPrint {\n    color: #008B8F; }\n\n.sub-total {\n  display: flex;\n  line-height: 3; }\n  .sub-total .sub-total-label, .sub-total .sub-total-price {\n    width: 50%; }\n  .sub-total .sub-total-price {\n    text-align: right; }\n\n.theme-color {\n  color: #169599; }\n\n.total-duties {\n  display: flex;\n  text-align: right;\n  line-height: 2;\n  font-weight: bold; }\n  .total-duties .total-duties-label {\n    width: 63%; }\n  .total-duties .total-duties-amt {\n    width: 37%; }\n  .total-duties .grand-total .total-duties-amt {\n    font-size: 18px; }\n\n.detail-button-s, .paid-button-s {\n  vertical-align: middle !important;\n  padding: 12px 1.5em 11px !important;\n  font-weight: 500 !important;\n  color: #04ADB1 !important;\n  background: #fff !important;\n  border: 1px solid #008B8F !important;\n  margin-top: 10px !important;\n  border-radius: 4px !important; }\n  .detail-button-s .ui.button:active, .paid-button-s .ui.button:active {\n    background: #fff; }\n  .detail-button-s:hover, .paid-button-s:hover {\n    background: transparent;\n    color: #04adb1b5; }\n  .detail-button-s.delete-button, .paid-button-s.delete-button {\n    border: none;\n    font-weight: 700; }\n\n.paid-button-s {\n  margin-top: 0 !important; }\n\n.detail-button-s {\n  display: flex;\n  margin-top: 10px; }\n  .detail-button-s.isOpen {\n    background-color: #0A8B8F; }\n\n.payoad {\n  margin-left: 800px; }\n\n.payload_content {\n  padding: 15px; }\n\n.payload_title_main {\n  padding-top: 2px;\n  margin-right: 20px;\n  margin-bottom: 10px; }\n\n.date_range_start {\n  display: flex; }\n\n.payload_title_startdate {\n  padding-top: 10px;\n  margin-right: 20px;\n  margin-bottom: 10px; }\n\n.date_range_start {\n  display: flex;\n  margin-top: 15px; }\n\n.payload_title_enddate {\n  padding-top: 10px;\n  margin-right: 35px;\n  margin-bottom: 10px; }\n\n.download_payload {\n  margin-left: 70%;\n  margin-right: 5px; }\n\n.chargeListFilter {\n  display: flex; }\n\n.oldinvoice {\n  padding: 10px;\n  font-weight: 500;\n  color: #04ADB1;\n  background: #fff;\n  border: 1px solid #008B8F;\n  margin-top: 22px;\n  cursor: pointer; }\n\n.confirm-modal .primary {\n  background-color: #0A8B8F !important; }\n\n.admin-invoice .total-duties.grand-total {\n  width: revert; }\n\n.pagination.customer-invoices {\n  margin: auto !important; }\n\n.payment-dropdown {\n  font-size: 11px !important;\n  border: 1px solid lightgrey !important;\n  padding: 8px !important;\n  border-radius: 4px !important;\n  color: grey !important;\n  height: 30px !important; }\n\n.invoice-payment .row label {\n  font-size: 11px !important; }\n\n.invoice-payment .row div {\n  font-size: 11px !important; }\n\n.invoice-payment .row .input {\n  display: flex;\n  font-size: 11px !important; }\n\n.invoice-payment .row .payment-teaxtarea-reason label {\n  font-size: 11px !important;\n  display: table-cell; }\n\n.invoice-payment .row .payment-teaxtarea-reason textarea {\n  font-size: 11px !important;\n  width: 100%; }\n\n.admin-invoice-tab-right {\n  flex-grow: 100; }\n  .admin-invoice-tab-right button {\n    float: right !important;\n    margin-top: 0 !important;\n    height: 41px; }\n\n.charge-list-check.all-iii label {\n  margin-bottom: 0px;\n  color: rgba(0, 0, 0, 0.87) !important; }\n\n.payment-history-modal {\n  top: 2% !important; }\n\n.tab-panes .tabular.menu {\n  flex-wrap: wrap; }\n\n.drayage-invoices-container {\n  background-color: #fff !important; }\n  .drayage-invoices-container .flex {\n    display: flex !important; }\n  .drayage-invoices-container .flex-1 {\n    flex: 1 !important; }\n  .drayage-invoices-container .flex-2 {\n    flex: 2 !important; }\n  .drayage-invoices-container .text-align-center {\n    text-align: center !important; }\n    @media only screen and (max-width: 768px) {\n      .drayage-invoices-container .text-align-center {\n        text-align: left !important; } }\n  .drayage-invoices-container .text-align-right {\n    text-align: right !important; }\n  .drayage-invoices-container .drayage-line-item-table {\n    margin: auto 20px !important; }\n    .drayage-invoices-container .drayage-line-item-table tr:last-child td.table-field-cell .table-action-btns {\n      border-top: 2px solid #babcbb !important; }\n  .drayage-invoices-container .ui.basic.table {\n    padding-bottom: 15px; }\n  .drayage-invoices-container .btn-over {\n    border: 1px solid #08adb6;\n    border-radius: .28571429rem;\n    cursor: pointer !important; }\n    .drayage-invoices-container .btn-over:hover {\n      background-color: #cacbcd;\n      background-image: none;\n      box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgba(34, 36, 38, 0.15) inset;\n      color: rgba(0, 0, 0, 0.8); }\n  .drayage-invoices-container .table-heading-cell {\n    color: #909490 !important;\n    font-size: 1em !important;\n    border-bottom: 2px solid #babcbb !important; }\n  .drayage-invoices-container .ui.table thead th {\n    color: rgba(0, 0, 0, 0.87);\n    padding: 5px; }\n  .drayage-invoices-container .ui.table td.table-field-cell {\n    border-top: none;\n    font-size: 12px !important;\n    vertical-align: middle; }\n    .drayage-invoices-container .ui.table td.table-field-cell .field .ui.dropdown, .drayage-invoices-container .ui.table td.table-field-cell .field .ui.input {\n      border: 1px solid #04a4aa;\n      border-radius: 0;\n      background-color: #eef2ff !important;\n      color: black !important; }\n      .drayage-invoices-container .ui.table td.table-field-cell .field .ui.dropdown input, .drayage-invoices-container .ui.table td.table-field-cell .field .ui.input input {\n        border: 0;\n        width: 75px;\n        padding: 9px 8px;\n        background-color: #eef2ff !important;\n        color: black !important; }\n  .drayage-invoices-container .table {\n    border-radius: 0px;\n    width: 98%; }\n    @media only screen and (max-width: 1000px) {\n      .drayage-invoices-container .table {\n        width: 98%; } }\n  .drayage-invoices-container .table-action-btns {\n    padding: 10px 0px 25px !important;\n    margin-bottom: 10px !important;\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important; }\n    .drayage-invoices-container .table-action-btns .save-invoice-btn {\n      background: #1565AE;\n      color: white; }\n      .drayage-invoices-container .table-action-btns .save-invoice-btn :hover {\n        background: #1565AE;\n        color: white; }\n    .drayage-invoices-container .table-action-btns .create-invoice-btn {\n      background: white;\n      border: 1px solid #0067B4;\n      color: #0067B4; }\n      .drayage-invoices-container .table-action-btns .create-invoice-btn :hover {\n        background: #1565AE !important;\n        color: white !important; }\n  .drayage-invoices-container .add-line-item-btn {\n    display: flex !important;\n    background: transparent !important;\n    color: #287374 !important;\n    padding: 0px; }\n    .drayage-invoices-container .add-line-item-btn img {\n      margin-right: 5px; }\n  .drayage-invoices-container .tab-pane {\n    background-color: #f9f9f9 !important;\n    border: 1px solid #d4d4d5 !important; }\n  .drayage-invoices-container .ui.attached.tabular.menu {\n    justify-content: center;\n    height: 41px !important;\n    padding: 12px; }\n  .drayage-invoices-container .ui.menu .item {\n    background: #fefefe !important;\n    border: 1px solid #D5D5D5;\n    border-radius: 0px !important;\n    font-size: 10px !important;\n    width: 150px;\n    height: 30px;\n    border-right: hidden;\n    color: #000 !important;\n    z-index: 1;\n    padding: 0.92857143em 1.14285714em !important;\n    text-transform: uppercase; }\n    .drayage-invoices-container .ui.menu .item .label-green {\n      background-color: #78d038 !important; }\n    .drayage-invoices-container .ui.menu .item .label-red {\n      background-color: #ed6659 !important; }\n  .drayage-invoices-container .ui.menu {\n    min-height: 1.857143em !important; }\n  .drayage-invoices-container .ui.menu .active.item {\n    border-color: transparent !important;\n    color: #FFFFFF !important;\n    background: #008B8F !important;\n    z-index: 1;\n    margin: 0 !important; }\n  .drayage-invoices-container .menu {\n    border: 0px !important;\n    box-shadow: none !important; }\n  .drayage-invoices-container .ui.menu .item:after {\n    position: absolute;\n    content: '';\n    top: -2px;\n    z-index: 1 !important;\n    border-color: #281F11 !important;\n    color: #FFFFFF !important;\n    background: #FFFFFF !important;\n    -webkit-transform: skew(27deg, -1deg);\n    transform: skew(14deg, -1deg);\n    width: 15px !important;\n    right: -11px;\n    height: 29px !important;\n    box-shadow: -1px 0px 0px #d5d5d5; }\n  .drayage-invoices-container .ui.menu .item > .label {\n    font-size: 10px;\n    background-color: #59aef5; }\n  .drayage-invoices-container .ui.tabular.menu .active.item {\n    border-radius: 0px !important; }\n  .drayage-invoices-container .btn {\n    vertical-align: middle;\n    padding: 10px 1em 10px;\n    font-weight: 500;\n    color: #08adb6;\n    background: #fff;\n    border: 1px solid #08adb6;\n    display: flex;\n    cursor: pointer; }\n  .drayage-invoices-container .btn-cal {\n    vertical-align: middle;\n    padding: 6px 1em 6px;\n    font-weight: 500;\n    color: #08adb6;\n    background: #fff;\n    border: 1px solid #08adb6;\n    display: flex;\n    cursor: pointer; }\n  .drayage-invoices-container .ui.mini.statistics {\n    justify-content: space-between;\n    margin: 1em 0; }\n    .drayage-invoices-container .ui.mini.statistics .statistic-country {\n      margin-top: 0; }\n    .drayage-invoices-container .ui.mini.statistics .ui.statistic {\n      align-items: flex-start; }\n      .drayage-invoices-container .ui.mini.statistics .ui.statistic .label.statistic-label {\n        color: #909490 !important;\n        font-size: 0.7em !important; }\n      .drayage-invoices-container .ui.mini.statistics .ui.statistic .value.statistic-value {\n        color: #222223 !important;\n        font-size: 1em !important;\n        z-index: auto;\n        white-space: pre-wrap !important;\n        word-break: break-word !important;\n        text-align: left !important;\n        line-height: 21px !important; }\n      .drayage-invoices-container .ui.mini.statistics .ui.statistic .value.statistic-value.currency {\n        color: #222223 !important;\n        font-size: 1.1em !important;\n        font-weight: 700; }\n      .drayage-invoices-container .ui.mini.statistics .ui.statistic .value.statistic-value.reference-no {\n        color: #3C76BD !important;\n        font-weight: 700; }\n    .drayage-invoices-container .ui.mini.statistics:after {\n      content: none; }\n  .drayage-invoices-container .checkbox {\n    color: #287374 !important; }\n  .drayage-invoices-container .ui.checkbox input:checked ~ label:after {\n    color: #287374 !important;\n    background-color: white !important;\n    outline: 1px solid #356968 !important; }\n  .drayage-invoices-container .card-opened {\n    background-color: #F6FFFA !important; }\n  .drayage-invoices-container .value {\n    background: transparent !important; }\n  .drayage-invoices-container .expand-btn {\n    background-color: #04a4aa !important;\n    color: white; }\n  .drayage-invoices-container .drayage-title {\n    position: absolute;\n    left: 0;\n    top: 12px;\n    font-weight: 600;\n    font-size: 20px;\n    margin-left: 20px; }\n  .drayage-invoices-container .drayage-country-date {\n    position: absolute;\n    right: 20px;\n    top: 0;\n    display: flex;\n    z-index: 9; }\n  .drayage-invoices-container .ui.fluid.container {\n    position: relative; }\n  .drayage-invoices-container .drayage-country-date .import-country-list {\n    float: left;\n    margin-right: 10px;\n    padding: 5px 5px 6px;\n    border: 1px solid #08adb6;\n    right: 0;\n    z-index: 1;\n    line-height: 1;\n    border-radius: 4px;\n    min-width: 130px;\n    position: relative; }\n  .drayage-invoices-container .drayage-country-date .import-country-list i.dropdown.icon {\n    display: none; }\n  .drayage-invoices-container .drayage-country-date .import-country-list i.angle {\n    position: absolute;\n    right: 1px;\n    background-color: #08adb6;\n    border-radius: 2px;\n    width: 15px;\n    height: 15px;\n    color: #fff;\n    line-height: 17px; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .ui.dropdown {\n    width: 100%;\n    position: static; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .ui.dropdown .text {\n    position: relative;\n    z-index: 1; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .menu {\n    background: #fff;\n    font-size: 1em;\n    text-shadow: none;\n    text-align: left;\n    min-width: max-content;\n    margin: 0;\n    width: 100%;\n    position: absolute;\n    top: 26px;\n    border: 1px solid #08adb6 !important; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .menu .country-item-list {\n    display: flex;\n    align-items: center;\n    padding: 5px 8px;\n    line-height: 1;\n    white-space: nowrap; }\n  .drayage-invoices-container .drayage-country-date .import-country-list .menu .country-item-list label {\n    margin-bottom: 0;\n    margin-left: 15px;\n    color: rgba(0, 0, 0, 0.87) !important;\n    font-weight: 400 !important;\n    font-family: 'Lato','Helvetica Neue',Arial,Helvetica,sans-serif; }\n  .drayage-invoices-container .drayage-sales-search-box-and-filter-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 30px; }\n  .drayage-invoices-container .drayage-invoice-searchbar {\n    width: 350px;\n    display: flex;\n    border: 1px solid #08adb6;\n    padding: 6px 6px 6px 12px;\n    border-radius: 4px;\n    justify-content: space-between; }\n  .drayage-invoices-container .drayage-invoice-input {\n    border: none;\n    width: 78%; }\n  .drayage-invoices-container .drayage-invoice-searchbar i.angle.down.icon {\n    color: #08adb6; }\n  .drayage-invoices-container .drayage-invoice-searchbar i.search.icon {\n    color: #c2c2c2; }\n  .drayage-invoices-container .drayage-invoice-searchbar input:focus {\n    box-shadow: none;\n    outline: none; }\n  .drayage-invoices-container .drayage-invoice-searchbar .company-slider-arrow-icon {\n    font-size: 1em !important;\n    position: sticky;\n    top: 10vh;\n    bottom: 30vh;\n    color: #008B8F !important; }\n  .drayage-invoices-container .drayage-country-date .ui.icon.input {\n    height: 29px;\n    width: 130px; }\n  .drayage-invoices-container .ui.input > input {\n    border: 1px solid #008B8F; }\n  .drayage-invoices-container i.calendar.outline.icon {\n    color: #008B8F; }\n  .drayage-invoices-container .clndr-calendars-segment.clndr-floating {\n    right: 0;\n    left: auto; }\n  .drayage-invoices-container .ui.icon input::placeholder {\n    color: #008B8F; }\n  .drayage-invoices-container .total-value {\n    font-size: 15px;\n    font-weight: 900; }\n  .drayage-invoices-container .ui.selection.dropdown > .chevron.down.icon {\n    background: white;\n    color: #04a4aa;\n    top: 12px;\n    cursor: pointer;\n    position: absolute;\n    width: auto;\n    height: auto;\n    line-height: 1.21428571em;\n    right: 1em;\n    z-index: 3;\n    margin: -0.78571429em;\n    padding: 2px 13px;\n    opacity: .8;\n    transition: opacity .1s ease; }\n  .drayage-invoices-container .ui.selection.visible.dropdown > .text:not(.default) {\n    color: black !important; }\n  .drayage-invoices-container .visible.menu.transition {\n    border: 1px solid #96c8da !important; }\n  .drayage-invoices-container .ui.selection.dropdown {\n    cursor: pointer;\n    word-wrap: break-word;\n    line-height: 13px;\n    white-space: normal;\n    outline: 0;\n    -webkit-transform: rotateZ(0);\n    transform: rotateZ(0);\n    min-width: 14em;\n    min-height: 11px;\n    background: #fff;\n    display: inline-block;\n    padding: 6px 10px;\n    color: rgba(0, 0, 0, 0.87);\n    box-shadow: none;\n    border: 1pxsolidrgba 34, 36, 38, 0.15;\n    border-radius: 0.28571429rem;\n    transition: box-shadow .1s ease,width .1s ease; }\n  .drayage-invoices-container .ui.input > input {\n    margin: 0;\n    max-width: 100%;\n    flex: 1 0 auto;\n    outline: 0;\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n    text-align: left;\n    line-height: 0.214286em;\n    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;\n    padding: 0.67857143em 1em;\n    background: #fff;\n    border: 1pxsolidrgba 34, 36, 38, 0.15;\n    color: rgba(0, 0, 0, 0.87);\n    border-radius: 0.28571429rem;\n    transition: box-shadow .1s ease,border-color .1s ease;\n    box-shadow: none;\n    height: 25px; }\n  .drayage-invoices-container .custom-field {\n    margin-bottom: 0px; }\n  .drayage-invoices-container .green-tick {\n    color: #3EC70B; }\n  .drayage-invoices-container .red-tick {\n    color: #FF4848; }\n  .drayage-invoices-container .card-toggle-icon {\n    color: #286084;\n    cursor: pointer; }\n  .drayage-invoices-container .account-ref-no {\n    height: 37px;\n    width: 239px;\n    border: 1px solid #8bb2d6;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-left: 20px;\n    margin-bottom: 7px; }\n    .drayage-invoices-container .account-ref-no label {\n      height: 12px;\n      width: 214px;\n      color: #9D9D9D !important;\n      font-family: \"Helvetica Neue\";\n      font-size: 9px !important;\n      font-weight: 500 !important;\n      letter-spacing: 0;\n      line-height: 12px; }\n    .drayage-invoices-container .account-ref-no input {\n      height: 14px !important;\n      width: 214px;\n      background-color: #F0F4FF !important;\n      border: none !important;\n      font-size: 10px !important;\n      border-radius: initial !important; }\n  .drayage-invoices-container .icon-btns i {\n    margin: auto !important;\n    font-size: 14px !important;\n    line-height: 14x !important; }\n  .drayage-invoices-container .table-field-cell .input {\n    width: 100% !important; }\n  .drayage-invoices-container .drayage-line-item-table tr:last-child td {\n    border-bottom: 2px solid #babcbb; }\n  .drayage-invoices-container .drayage-line-item-table.non-edit tr:last-child td {\n    border-bottom: none; }\n  .drayage-invoices-container .expand-icon {\n    color: #008B8F; }\n  .drayage-invoices-container .info-message {\n    width: 50%;\n    margin: 0px auto; }\n  .drayage-invoices-container .comment-expend:focus {\n    height: 100px; }\n  .drayage-invoices-container .ui.button {\n    font-size: 1rem !important; }\n  .drayage-invoices-container .ui.input {\n    height: unset !important;\n    padding-left: unset !important; }\n  .drayage-invoices-container .table-heading-cell {\n    font-size: 12px !important; }\n  .drayage-invoices-container .table-action-btns.approve-disapprove-btn {\n    padding: unset !important;\n    margin-bottom: unset !important; }\n  .drayage-invoices-container .ui.image {\n    margin-top: unset; }\n  .drayage-invoices-container .content-static-card {\n    width: 98% !important; }\n  .drayage-invoices-container .pendingList-table .ui.statistic {\n    width: 114px;\n    white-space: nowrap;\n    text-align: left;\n    /*overflow: hidden;*/ }\n  .drayage-invoices-container .pendingList-table .ui.statistic.statistic-country {\n    width: auto; }\n  .drayage-invoices-container .visibility-icon {\n    border: 1px solid #008B8F;\n    padding: 21px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #008B8F;\n    cursor: pointer !important; }\n  .drayage-invoices-container .ui.accordion .title {\n    cursor: default !important; }\n\n.content-static-card.ui.table td.one.wide, .content-static-card.ui.table th.one.wide {\n  width: auto;\n  vertical-align: middle; }\n\n.drayage-line-item-table.edit-card-list tr td {\n  border-bottom: none;\n  padding: 2px 0px; }\n\n.edit-card-list .custom-field .ui.selection.dropdown {\n  width: 300px; }\n\n.uploadDocument {\n  display: grid;\n  grid-template-columns: 1.2fr 3fr;\n  column-gap: 50px;\n  row-gap: 1em; }\n\n.upload-document .documentList {\n  margin-top: 45px; }\n\n.showDocument {\n  height: 450px;\n  min-width: 340px;\n  width: auto; }\n\n.ui.fullscreen.modal.upload-document {\n  top: 10% !important;\n  left: unset !important; }\n\n.ui.fullscreen.modal.upload-document .ModalActionButtons {\n  text-align: left !important; }\n\n.upload-document .upload-doc-img {\n  position: absolute;\n  top: -40px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  background: #fff;\n  border-radius: 50% !important;\n  width: 80px;\n  height: 80px;\n  padding: 7px;\n  object-fit: cover;\n  overflow: hidden;\n  display: flex; }\n\n.upload-document i.close.icon {\n  color: #008B8F;\n  top: 0;\n  padding-right: 58px; }\n\n.upload-document i.red.close.icon.removeIcon {\n  float: right;\n  padding-right: unset; }\n\n.upload-document.ui.modal > .content {\n  margin-top: 0px;\n  padding: 3.5rem; }\n\n.upload-document .uploadDocument .non-edit tr td {\n  border-top: none;\n  padding: 5px !important; }\n\n.upload-document .uploadDocument .non-edit tr th {\n  padding: 5px !important; }\n\n.upload-document .uploadDocument .non-edit tr:hover td {\n  background-color: rgba(0, 139, 143, 0.2);\n  color: #008B8F; }\n\n.upload-document .uploadDocument .non-edit tr td:first-child, .upload-document .uploadDocument .non-edit tr td:last-child {\n  color: #008B8F; }\n\n.upload-document .uploadDocument .non-edit, .upload-document .uploadDocument .non-edit tr th {\n  border-bottom: 1px solid rgba(34, 36, 38, 0.1); }\n\n.text-green {\n  color: #008B8F; }\n\n.ui.dimmer .upload-document .content {\n  width: 100%; }\n\n.ui.dimmer .upload-document .ui.button {\n  background-color: #008B8F;\n  color: #fff;\n  font-size: 1rem !important; }\n\n.addiDocumButton {\n  color: #008B8F;\n  display: flex;\n  align-items: center;\n  gap: 5px; }\n\n.addiDocumButton i {\n  border: 1px solid #008B8F;\n  border-radius: 3px;\n  padding: 3px;\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n  font-size: 10px;\n  align-items: center;\n  justify-content: center; }\n\n.upload-document .uploadDocument .non-edit .ui.checkbox input:checked ~ label:after {\n  color: #008B8F;\n  background-color: white;\n  border: #008B8F 1px solid;\n  border-radius: 3px; }\n\n.upload-document .uploadDocument .non-edit tr td .field {\n  cursor: pointer; }\n\n.visibility-modal ul li {\n  list-style-type: none;\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 5px; }\n\n.visibility-modal ul {\n  padding-top: 5px;\n  padding-right: 0px;\n  padding-left: 0px;\n  border: 1px solid #f9f9f9;\n  margin: 0; }\n\n.visibility-modal .visibility-base {\n  background-color: #f7f7f7; }\n\n.approved-rate span {\n  font-size: 14px;\n  cursor: pointer; }\n  .approved-rate span:hover {\n    color: #04adb1c2; }\n\n.sales-visibility .close {\n  color: #008B8F !important;\n  top: -4px !important;\n  right: -0.5rem !important; }\n\n.sales-visibility .close:hover {\n  opacity: 1; }\n\ni.close.icon.visibility-close {\n  position: absolute;\n  right: 0px;\n  top: 5px;\n  font-size: 12px;\n  cursor: pointer;\n  color: #008B8F; }\n\n.ui.dimmer .visibility-modal {\n  width: 100% !important; }\n\n#myBar {\n  position: absolute;\n  border-radius: 1.8rem;\n  width: 1%;\n  height: 100%;\n  background-color: #321e8d; }\n\n#myProgress {\n  position: relative;\n  display: block;\n  line-height: 1;\n  width: 100%;\n  height: 6px;\n  background-color: #DAD6D2;\n  border-radius: 1.8rem; }\n\n.preDocument .ui.dimmer .content, .preDocument .ui.large.image {\n  width: 100%; }\n\n.preDocument i.download {\n  font-size: 24px !important;\n  color: #008B8F !important;\n  cursor: pointer;\n  float: right; }\n\n.progressBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 5px; }\n\n.upload-document .progressBar i.close.icon {\n  padding-right: 0;\n  height: auto;\n  font-size: 12px;\n  line-height: 12px;\n  color: #008B8F; }\n\n.upload-percentage {\n  font-size: 10px;\n  color: #DAD6D2;\n  line-height: 12px; }\n\n.uploadDocument .showDocument {\n  display: flex;\n  align-items: flex-start;\n  gap: 5px;\n  justify-content: center; }\n\n.uploadDocument .showDocument i {\n  font-size: 24px;\n  color: #008B8F;\n  cursor: pointer; }\n\n.custom-loader {\n  display: flex-root !important;\n  min-height: 100px; }\n  .custom-loader .ui.dimmer {\n    position: absolute !important;\n    padding: 0 !important; }\n  .custom-loader .ui.dimmer.active {\n    background-color: #fff; }\n  .custom-loader .ui.loader {\n    color: black !important; }\n  .custom-loader .ui.loader:after {\n    border-color: #008b8f transparent transparent !important; }\n\n@media screen and (max-width: 1300px) {\n  .ui.attached.tabular.menu {\n    width: 94%; } }\n\n@media screen and (max-width: 1268px) {\n  .drayage-invoices-container .drayage-title {\n    position: static;\n    text-align: center;\n    margin-bottom: 10px; }\n  .drayage-invoices-container .drayage-country-date {\n    position: static;\n    right: 0;\n    top: 0;\n    margin: 0 auto;\n    width: 242px; }\n  .ui.attached.tabular.menu {\n    width: 94%; }\n  .edit-card-list .custom-field .ui.selection.dropdown {\n    width: unset; } }\n\n.delete-charge-confirm .ui.primary.button {\n  background: #1565AE !important;\n  color: white !important; }\n\n.delete-charge-confirm .content {\n  font-size: 1.7em !important;\n  width: 100% !important; }\n\n.raise-dispute-form .pointing-label {\n  border-color: #b04545 !important;\n  background-color: #fff6f6 !important;\n  color: #b04545 !important;\n  border: 1px solid #b04545 !important; }\n\n.raise-dispute-form .raise-dispute-error {\n  border-color: #e0b4b4 !important;\n  background-color: #fff6f6 !important; }\n\n.pagination.drayage-sales-invoices {\n  text-align: center; }\n  .pagination.drayage-sales-invoices button {\n    background: #295f84;\n    color: #fff;\n    border: 0;\n    padding: 3px 10px;\n    margin-left: 10px;\n    border-radius: 3px;\n    cursor: pointer;\n    font-family: \"Open Sans\", sans-serif !important; }\n\n.drayage-invoices-container.drayage-sales .ui.statistic + .ui.statistic {\n  margin: 0 0 0 0.5em !important; }\n\n.common-modal .ui.button, .common-modal .ui.buttons .button, .common-modal .ui.buttons .or {\n  font-size: 0.9rem !important; }\n\n.common-modal .ui.positive.button {\n  background-color: #1565AE;\n  color: white; }\n  .common-modal .ui.positive.button:hover {\n    background-color: #cacbcd;\n    background-image: none;\n    color: #000000cc; }\n\n.invoice-number-container {\n  position: relative;\n  display: inline-block; }\n\n.invoice-number-container:hover .statistic-value-tooltip {\n  visibility: visible;\n  opacity: 1; }\n\n.statistic-value-tooltip {\n  visibility: hidden;\n  background-color: #1565AE;\n  color: #fff;\n  text-align: center;\n  border-radius: 5px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 100%;\n  /* Position above the statistic value */\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s; }\n";
styleInject(css_248z$r);

var FILTER_CHARGE_TYPE$1 = "Charge Type";
var FILTER_CHARGE_TYPE_OPTION_AIR_DRAYAGE$1 = "Air Drayage";

var ChargeTypeFilter$1 = {
  label: FILTER_CHARGE_TYPE$1,
  Component: Checkbox,
  isCheckBox: true,
  options: [{
    props: {
      label: FILTER_CHARGE_TYPE_OPTION_AIR_DRAYAGE$1,
      value: FILTER_CHARGE_TYPE_OPTION_AIR_DRAYAGE$1
    }
  }]
};

var TabFilters$1 = {
  PENDING: [ChargeTypeFilter$1],
  DISPUTED: [ChargeTypeFilter$1],
  APPROVED: [ChargeTypeFilter$1],
  PAID: [ChargeTypeFilter$1],
  "PARTIALLY PAID": [ChargeTypeFilter$1]
};

var Filters$1 = function (_Component) {
  inherits(Filters, _Component);

  function Filters(props) {
    classCallCheck(this, Filters);
    return possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).call(this, props));
  }

  createClass(Filters, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          activeTab = _props.activeTab,
          selectedFilters = _props.selectedFilters,
          _onChange = _props.onChange;

      var filters = Array.isArray(TabFilters$1[activeTab]) ? TabFilters$1[activeTab] : [];
      return React__default.createElement(
        "div",
        { className: "drayage-sales-filters-container" },
        filters.map(function (value, index) {
          var Component$$1 = lodash_1(value, "Component", Fragment);
          var options = lodash_1(value, "options", null);
          var mainLabel = lodash_1(value, "label", null);
          var isCheckbox = lodash_1(value, "isCheckBox", null);
          var props = lodash_1(value, "props", {});

          return React__default.createElement(
            "div",
            {
              className: "filter-input-container",
              key: "filter-input-container-" + index + "-" + mainLabel
            },
            Component$$1 && Array.isArray(options) && isCheckbox ? options.map(function (option, optionIndex) {
              var props = lodash_1(option, "props", {});

              return React__default.createElement(
                "div",
                {
                  className: " ",
                  key: "option-" + lodash_1(props, "label", "") + "-" + optionIndex + "-" + mainLabel
                },
                React__default.createElement(Component$$1, _extends({}, props, {
                  label: lodash_1(props, "label", ""),
                  checked: lodash_1(props, "label", "") === lodash_1(selectedFilters, "" + mainLabel, false),
                  onChange: function onChange(e, data) {
                    if (data.checked) {
                      _onChange(mainLabel, lodash_1(props, "value", ""));
                    } else {
                      _onChange(mainLabel, "");
                    }
                  }
                }))
              );
            }) : null
          );
        })
      );
    }
  }]);
  return Filters;
}(Component);

var payloadMap$1 = new WeakMap();
var selectedFiltersMap$1 = new WeakMap();

var PayloadFilters$1 = function () {
  function PayloadFilters(selectedFilters) {
    classCallCheck(this, PayloadFilters);

    selectedFiltersMap$1.set(this, selectedFilters);
    payloadMap$1.set(this, {});
  }

  createClass(PayloadFilters, [{
    key: "getChargeTypeFilterPayload",
    value: function getChargeTypeFilterPayload() {
      var chargeType = lodash_1(selectedFiltersMap$1.get(this), "[" + FILTER_CHARGE_TYPE$1 + "]", false);

      payloadMap$1.set(this, _extends({}, payloadMap$1.get(this), {
        isMotAir: chargeType === FILTER_CHARGE_TYPE_OPTION_AIR_DRAYAGE$1
      }));

      return this;
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      this.getChargeTypeFilterPayload();
      return payloadMap$1.get(this);
    }
  }]);
  return PayloadFilters;
}();

/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

var ActiveTabs$1 = {
  "sales-pending": {
    label: "PENDING",
    Component: SalesPending,
    labelClass: [""]
  },
  disputed: { label: "DISPUTED", Component: DisputedList, labelClass: [""] },
  approved: {
    label: "APPROVED",
    Component: ApprovedList,
    labelClass: ["label-green"]
  },
  // pending: { label: "PENDING", Component: Pending, labelClass: [""] },
  paid: { label: "PAID", Component: Paid$1, labelClass: ["label-green"] },
  "partially-paid": {
    label: "PARTIALLY PAID",
    Component: PartiallyPaidList$1,
    labelClass: [""]
    // rejected: {
    //   label: "REJECTED",
    //   Component: Rejected,
    //   labelClass: ["label-red"],
    // },
    //  disputed: {
    //    label: "DISPUTED",
    //    Component: Dispute,
    //    labelClass: ["label-red"],
    //  },
    //  cancelled: {
    //    label: "CANCELLED",
    //    Component: Cancelled,
    //    labelClass: ["label-red"],
    //  },
  } };
var getFormatedDate$1 = function getFormatedDate(date) {
  var dateVal = parseInt(date);
  if (isNaN() || !Number(dateVal) || !dateVal === "") {
    return "";
  }

  var someday = moment$1(dateVal);

  return someday.format("MMMM DD YYYY");
};

var getCountryNameAndImage$1 = function getCountryNameAndImage(countryCode) {
  var countryName = "";
  var countryImage = "";
  if (countryCode === "US") {
    countryName = "USA";
    countryImage = "/images/US.jpg";
  } else if (countryCode === "CANADA" || countryCode === "CA") {
    countryName = "CANADA";
    countryImage = "/images/Canda.jpg";
  } else if (countryCode === "UK") {
    countryName = "UK";
    countryImage = "/images/Uk.jpg";
  } else if (countryCode === "ES") {
    countryName = "SPAIN";
    countryImage = "/images/spain.jpg";
  } else if (countryCode === "NL") {
    countryName = "NL";
    countryImage = "/images/NL.jpg";
  }

  return { countryName: countryName, countryImage: countryImage };
};

var DrayageInvoices$1 = function (_Component) {
  inherits(DrayageInvoices, _Component);

  function DrayageInvoices(props) {
    var _this2 = this;

    classCallCheck(this, DrayageInvoices);

    var _this = possibleConstructorReturn(this, (DrayageInvoices.__proto__ || Object.getPrototypeOf(DrayageInvoices)).call(this, props));

    _this.isDecimal = function (n) {
      var result = n - Math.floor(n) !== 0;
      if (result) {
        return true;
      }
      return false;
    };

    _this.updateState = function (state) {
      return new Promise(function (resolve) {
        _this.setState(_extends({}, state), function () {
          return resolve(true);
        });
      });
    };

    _this.setInfoMessages = function (key, message) {
      _this.setState(defineProperty({}, key, message), function () {
        return setTimeout(function () {
          _this.setState(defineProperty({}, key, ""));
        }, 2000);
      });
    };

    _this.getFormatedCurrency = function (value, country) {
      if (Number.isInteger(value)) {
        value = (parseFloat(value) / 100).toFixed(2);
      }
      value = Number.isNaN(parseFloat(value)) ? 0 : parseFloat(value);

      if (value < 0) {
        value = value * -1;
        var _currencySymbol = lodash_1(CountryCurrencyMap, "" + country, "");
        return "(" + _currencySymbol + " " + value.toFixed(2) + ")";
      }
      var currencySymbol = lodash_1(CountryCurrencyMap, "" + country, "");
      return currencySymbol + " " + value.toFixed(2);
    };

    _this.getFormatedPaidDate = function (date) {
      if (!Number.isInteger(date) && !isNaN(date)) {
        date = date.trim();
      }

      if (date === "") return "-";

      date = new Date(date);
      if (!(date instanceof Date) || String(date) === "Invalid Date") {
        return "-";
      }

      var day = date.getDate();
      var month = date.toLocaleString("en-US", { month: "short" });
      var year = date.getFullYear();

      if (day < 10) {
        day = "0" + day;
      }
      return month + " " + day + ", " + year;
    };

    _this.HandlecallbackKeyword = function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _this$state, isActiveTab, activeIndex;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$state = _this.state, isActiveTab = _this$state.isActiveTab, activeIndex = _this$state.activeIndex;

                _this.setState({ keyword: data, pageNumber: 1 }, function () {
                  if (activeIndex == 1) {
                    _this.getDisputedTabData();
                  } else if (activeIndex == 2) {
                    _this.getApprovedTabData();
                  } else if (activeIndex == 3) {
                    _this.getPaidTabData();
                  } else if (activeIndex == 4) {
                    _this.getPartiallyPaidTabData();
                  } else {
                    _this.getSalesPendingData();
                  }
                  // { isActiveTab === "CHARGE_LIST" ? this.getSalesPendingData() : this.getPendingTabData() }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.goToSalesPending = function () {
      var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.setState({ activeIndex: 0 });
                _this.getSalesPendingData();
                _this.setState({ sendKeyword: data }, function () {
                  _this.HandlecallbackKeyword(data);
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleTabChange = function (e, _ref3) {
      var activeIndex = _ref3.activeIndex;

      _this.setState({ activeIndex: activeIndex });
    };

    _this.sendKeywordFun = function () {
      var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.setState({ sendKeyword: "" });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.selectedCharge = function () {
      var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(unitPrice, uom) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.updateState({ unitPriceVal: unitPrice, uom: uom });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x4, _x5) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.unitPriceValue = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this.updateState({ unitPriceVal: "" });

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this2);
    }));

    _this.approveInvoice = function () {
      var _ref7 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(index) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise(function () {
                  var _ref8 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve) {
                    var charges, chargeForSend, result, code;
                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            charges = JSON.parse(JSON.stringify(_this.state.salesPending));
                            chargeForSend = charges[index];
                            _context6.prev = 2;

                            chargeForSend.chargeDesc.totalAmount = parseFloat(chargeForSend.chargeDesc.totalAmount) * 100;
                            chargeForSend.chargeDesc.chargeDesc = chargeForSend.chargeDesc.chargeDesc.map(function (val) {
                              return _extends({}, val, {
                                unitPrice: parseFloat(val.unitPrice) * 100,
                                totalRate: parseFloat(val.totalRate) * 100
                              });
                            });
                            _context6.next = 7;
                            return approveInvoice(chargeForSend);

                          case 7:
                            result = _context6.sent;
                            code = lodash_1(result, "data.eventMessage.code", "");

                            if (!(parseInt(code) === 200)) {
                              _context6.next = 15;
                              break;
                            }

                            _this.setInfoMessages("successMsg", "Invoice approved by sales.");
                            _this.callGetSalesPendingWithDelay(1);
                            return _context6.abrupt("return", resolve(true));

                          case 15:
                            _this.setInfoMessages("errorMsg", "Invoice not approved by sales.");
                            _this.callGetSalesPendingWithDelay(1);
                            return _context6.abrupt("return", resolve(true));

                          case 18:
                            _context6.next = 25;
                            break;

                          case 20:
                            _context6.prev = 20;
                            _context6.t0 = _context6["catch"](2);

                            _this.setInfoMessages("errorMsg", "Invoice not approved by sales.");
                            _this.callGetSalesPendingWithDelay(1);
                            return _context6.abrupt("return", resolve(true));

                          case 25:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this2, [[2, 20]]);
                  }));

                  return function (_x7) {
                    return _ref8.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this2);
      }));

      return function (_x6) {
        return _ref7.apply(this, arguments);
      };
    }();

    _this.raiseDisputeRequest = function () {
      var _ref9 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(data) {
        var disputeReason, disputeComment, payload, returnResult;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                disputeReason = lodash_1(data, "disputeReason", "");
                disputeComment = lodash_1(data, "disputeComment", "");
                payload = {
                  containerId: lodash_1(data, "data.containerId", ""),
                  action: "DISPUTE_BY_DRAY_SALES",
                  comment: disputeComment,
                  invoiceNumber: lodash_1(data, "data.drayageInvoiceNumber", ""),
                  reason: disputeReason,
                  state: lodash_1(data, "data.drayageInvoiceState", "")
                };
                // const returnResult = await new Promise((resolve, reject) => {
                //   setTimeout(() => {
                //     return resolve(false);
                //   }, 3500);
                // });

                _context9.next = 6;
                return raiseDisputeForInvoice(payload);

              case 6:
                returnResult = _context9.sent;

                if (!returnResult) {
                  _context9.next = 12;
                  break;
                }

                _this.setInfoMessages("successMsg", "Dispute raised successfully.");
                _this.callGetSalesPendingWithDelay(1);
                _context9.next = 15;
                break;

              case 12:
                _context9.next = 14;
                return _this.updateState({ disputeRaisedError: "Some error occurred." });

              case 14:
                setTimeout(asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                  return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          _context8.next = 2;
                          return _this.updateState({ disputeRaisedError: "" });

                        case 2:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8, _this2);
                })), 3500);

              case 15:
                return _context9.abrupt("return", returnResult);

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this2);
      }));

      return function (_x8) {
        return _ref9.apply(this, arguments);
      };
    }();

    _this.getSalesPendingData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref11 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(resolve) {
          var filterPayload, requestPayload, SalesPendingData, totalCount, tabCount, nonEditableGlCodes, SalesPendingDataFiltered;
          return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.prev = 0;
                  filterPayload = new PayloadFilters$1(_this.state.selectedFilters).getPayload();
                  _context10.next = 4;
                  return _this.updateState({
                    fetchSalesPending: true,
                    isActiveTab: "PENDING"
                  });

                case 4:
                  requestPayload = _extends({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_PENDING",
                    isDrayInvoice: true
                  }, filterPayload);
                  _context10.next = 7;
                  return getDrayageSalesPendingInvoices(requestPayload);

                case 7:
                  SalesPendingData = _context10.sent;
                  totalCount = lodash_1(SalesPendingData, "data.eventMessage.totalCount", 0);
                  _context10.next = 11;
                  return getDrayageTabCount$1(requestPayload);

                case 11:
                  tabCount = _context10.sent;
                  _context10.next = 14;
                  return _this.updateState({
                    tabCount: _extends({
                      SalesPendingTabCount: totalCount
                    }, tabCount.data.eventMessage)
                  });

                case 14:
                  nonEditableGlCodes = lodash_1(SalesPendingData, "data.eventMessage.nonEditableGlCodes", []);
                  _context10.next = 17;
                  return _this.updateState({ nonEditableGlCodes: nonEditableGlCodes });

                case 17:
                  SalesPendingDataFiltered = lodash_1(SalesPendingData, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);

                      var objReturn = _extends({}, value, {
                        markUPAmount: isNaN(value.markUPAmount) ? 0 : value.markUPAmount,
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                      return objReturn;
                    });

                    var objReturn = _extends({}, val, {
                      chargeDesc: _extends({}, val.chargeDesc, {
                        chargeDesc: chargeDesc,
                        totalAmount: parseFloat(lodash_1(val, "chargeDesc.totalAmount", 0) / 100).toFixed(2)
                      })
                    });

                    return objReturn;
                  });
                  _context10.next = 21;
                  return _this.updateState({
                    salesPending: SalesPendingDataFiltered,
                    fetchSalesPending: false
                  });

                case 21:
                  resolve(true);
                  _context10.next = 29;
                  break;

                case 24:
                  _context10.prev = 24;
                  _context10.t0 = _context10["catch"](0);
                  _context10.next = 28;
                  return _this.updateState({ salesPending: [], fetchSalesPending: false });

                case 28:
                  resolve(true);

                case 29:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, _this2, [[0, 24]]);
        }));

        return function (_x10) {
          return _ref11.apply(this, arguments);
        };
      }());
    };

    _this.editSalesPendingCharge = function (index) {
      var salesPending = _this.state.salesPending.map(function (val, i) {
        if (index === i) {
          val.edit = true;
        } else {
          val.edit = false;
        }
        return val;
      });
      _this.updateState({ salesPending: [].concat(toConsumableArray(salesPending)) });
    };

    _this.expandSalesPendingCard = function (id) {
      _this.state.activeSalesPendingCard === id ? _this.updateState({
        activeSalesPendingCard: null
      }) : _this.updateState({
        activeSalesPendingCard: id
      });
    };

    _this.updateSalesPendingLineItem = function (SalesPendingIndex, chargeIndex, key, value) {
      var charges = JSON.parse(JSON.stringify(_this.state.salesPending));
      charges[SalesPendingIndex].chargeDesc.chargeDesc[chargeIndex][key] = value;
      return _this.updateState({
        salesPending: JSON.parse(JSON.stringify(charges))
      });
    };

    _this.saveSalesPendingData = function () {
      var _ref12 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(SalesPendingIndex) {
        var charges, chargesClone, totalValue, totalValueClone, apiDataArray, newChargesIndexSaved, currentArrTotal, chargeDesc, chargesToSave, afterCall, result, code, msg;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.salesPending));
                chargesClone = JSON.parse(JSON.stringify(_this.state.salesPending));

                charges[SalesPendingIndex].edit = false;

                totalValue = 0;
                totalValueClone = 0;
                apiDataArray = [];
                newChargesIndexSaved = [];
                currentArrTotal = 0;
                chargeDesc = charges[SalesPendingIndex].chargeDesc.chargeDesc.map(function (val, index) {
                  var valClone = JSON.parse(JSON.stringify(val));
                  if (val.new === true) {
                    newChargesIndexSaved.push(index);
                  }

                  delete val.new;
                  val.markUPAmount = parseInt(val.markUPAmount);
                  val.markUPAmount = isNaN(val.markUPAmount) ? 0 : val.markUPAmount;
                  val.unitPrice = parseFloat(val.unitPrice);
                  val.unitPrice = isNaN(val.unitPrice) ? 0 : val.unitPrice;
                  val.quantity = parseInt(val.quantity);
                  val.quantity = isNaN(val.quantity) ? 1 : val.quantity;
                  currentArrTotal = val.totalRate;

                  val.totalRate = isNaN(val.totalRate) ? 0 : parseFloat(val.totalRate).toFixed(2);

                  totalValue += parseFloat(val.totalRate);

                  /**
                   *
                   *  Computation for Api
                   */
                  if (valClone.new) {
                    delete valClone.chargeId;
                  }
                  delete valClone.new;
                  val.markUPAmount = parseInt(val.markUPAmount);
                  val.markUPAmount = isNaN(val.markUPAmount) ? 0 : val.markUPAmount;
                  valClone.unitPrice = parseFloat(valClone.unitPrice);
                  valClone.unitPrice = isNaN(valClone.unitPrice) ? 0 : valClone.unitPrice * 100;
                  valClone.quantity = parseInt(valClone.quantity);
                  valClone.quantity = isNaN(valClone.quantity) ? 1 : valClone.quantity;
                  valClone.totalRate = isNaN(valClone.totalRate) ? 0 : parseFloat(valClone.totalRate) * 100;

                  valClone.subTotal = isNaN(valClone.subTotal) ? 0 : parseFloat(valClone.subTotal);
                  totalValueClone += valClone.totalRate;
                  apiDataArray.push(valClone);

                  return val;
                });


                charges[SalesPendingIndex].chargeDesc.totalAmount = totalValue * 100;
                charges[SalesPendingIndex].chargeDesc.chargeDesc = [].concat(toConsumableArray(chargeDesc));

                // FOR API CALL
                chargesClone[SalesPendingIndex].chargeDesc.totalAmount = totalValueClone;
                chargesClone[SalesPendingIndex].chargeDesc.chargeDesc = [].concat(apiDataArray);

                chargesToSave = chargesClone[SalesPendingIndex];

                afterCall = function () {
                  var _ref13 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(status) {
                    var totalForChanges, _chargeDesc;

                    return regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _this.callGetSalesPendingWithDelay(1);
                            if (status === false) {
                              totalForChanges = 0;
                              _chargeDesc = charges[SalesPendingIndex].chargeDesc.chargeDesc.filter(function (val, index) {
                                if (!newChargesIndexSaved.includes(index)) {
                                  val.unitPrice = parseFloat(val.unitPrice);
                                  val.unitPrice = isNaN(val.unitPrice) ? 0 : val.unitPrice;
                                  val.quantity = parseInt(val.quantity);
                                  val.quantity = isNaN(val.quantity) ? 1 : val.quantity;
                                  val.totalRate = val.unitPrice * val.quantity;
                                  totalForChanges += val.totalRate;
                                  return true;
                                }
                              });

                              charges[SalesPendingIndex].chargeDesc.totalAmount = totalForChanges * 100;
                              charges[SalesPendingIndex].chargeDesc.chargeDesc = [].concat(toConsumableArray(_chargeDesc));
                            }

                            _context11.next = 4;
                            return _this.updateState({ salesPending: [].concat(toConsumableArray(charges)) });

                          case 4:
                            return _context11.abrupt("return", new Promise(function (resolve) {
                              return resolve(status);
                            }));

                          case 5:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, _this2);
                  }));

                  return function afterCall(_x12) {
                    return _ref13.apply(this, arguments);
                  };
                }();

                _context12.prev = 15;
                _context12.next = 18;
                return saveContainerSalesPending(chargesToSave.chargeDesc);

              case 18:
                result = _context12.sent;
                code = lodash_1(result, "data.eventMessage.code", "");
                msg = lodash_1(result, "data.eventMessage.msg", "");

                if (!(code === 200 && msg === "Updated Successfully")) {
                  _context12.next = 28;
                  break;
                }

                _this.setInfoMessages("successMsg", "Charges saved successfully.");
                _context12.next = 25;
                return afterCall(true);

              case 25:
                return _context12.abrupt("return", _context12.sent);

              case 28:
                _this.setInfoMessages("errorMsg", "Some error occurred. Unable to save charges.");
                _context12.next = 31;
                return afterCall(false);

              case 31:
                return _context12.abrupt("return", _context12.sent);

              case 32:
                _context12.next = 40;
                break;

              case 34:
                _context12.prev = 34;
                _context12.t0 = _context12["catch"](15);

                _this.setInfoMessages("errorMsg", "Some error occurred. Unable to save charges.");
                _context12.next = 39;
                return afterCall(false);

              case 39:
                return _context12.abrupt("return", _context12.sent);

              case 40:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this2, [[15, 34]]);
      }));

      return function (_x11) {
        return _ref12.apply(this, arguments);
      };
    }();

    _this.callGetSalesPendingWithDelay = function () {
      var _ref14 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                setTimeout(function () {
                  _this.getSalesPendingData(page);
                }, 2000);

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this2);
      }));

      return function () {
        return _ref14.apply(this, arguments);
      };
    }();

    _this.cancelSalesPendingEdit = function (SalesPendingIndex, value) {
      var charges = JSON.parse(JSON.stringify(_this.state.salesPending));
      charges[SalesPendingIndex].chargeDesc.chargeDesc = value;
      charges[SalesPendingIndex].edit = false;
      return _this.updateState({ salesPending: [].concat(toConsumableArray(charges)) });
    };

    _this.callDrayageChargeApi = function () {
      var _ref15 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(index) {
        var salesPending, countryCode, newChargeAdded, glCodes, partnerId, partnerCharges, getPartnerCharges, newCharges;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                salesPending = JSON.parse(JSON.stringify(_this.state.salesPending));
                countryCode = lodash_1(salesPending, "[" + index + "]chargeDesc.countryCode", "");
                newChargeAdded = false;
                glCodes = lodash_1(salesPending, "[" + index + "].chargeDesc.chargeDesc", []).map(function (val) {
                  if (newChargeAdded === false && val.new === true) newChargeAdded = true;
                  return val.glCode;
                });
                //  let charges = await getDrayageCharges({
                //    countryCode: countryCode,
                //    glCodes: [...glCodes],
                //  });

                partnerId = _this.state.partnerId;
                _context14.next = 7;
                return getDrayagePartnerDetails$1({
                  partnerId: partnerId
                });

              case 7:
                partnerCharges = _context14.sent;
                getPartnerCharges = lodash_1(partnerCharges, "data.eventMessage.pricing.pricingItems", []);

                //  let additionalCharge = await getDrayageAdditionalCharge();
                //  let getAdditionalCharge = get(
                //   additionalCharge,
                //   `data.eventMessage.drayageAdditionalCharges`,
                //   []
                //  );

                // let newAdditionalCharges = getAdditionalCharge.map((val) => ({
                //   value: val.glCode,
                //   key: val.glCode,
                //   text: val.chargeName,
                // }));

                //usBuildUp

                newCharges = getPartnerCharges.map(function (val) {
                  return {
                    value: val.glCode,
                    key: val.glCode,
                    text: val.chargeName,
                    unitPrice: val.unitPrice,
                    uom: val.unitMeasurement
                  };
                });

                //  charges = get(
                //    charges,
                //    `data.eventMessage[${countryCode.toLowerCase()}BuildUp]`,
                //    []
                //  );
                //  //usBuildUp
                //  let newCharges = charges.map((val) => ({
                //    value: val.glCode,
                //    key: val.glCode,
                //    text: val.chargeType,
                //  }));

                if (!(newChargeAdded === false)) {
                  _context14.next = 13;
                  break;
                }

                _context14.next = 13;
                return _this.updateState({ chargesOptions: [].concat(toConsumableArray(newCharges)) });

              case 13:
                return _context14.abrupt("return", new Promise(function (resolve) {
                  return resolve(newCharges);
                }));

              case 14:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this2);
      }));

      return function (_x14) {
        return _ref15.apply(this, arguments);
      };
    }();

    _this.addNewCharge = function () {
      var _ref16 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(index) {
        var newCharge, charges, returnVal;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return _this.callDrayageChargeApi(index);

              case 2:
                newCharge = false;

                if (!(_this.state.chargesOptions.length > 0)) {
                  _context15.next = 10;
                  break;
                }

                charges = JSON.parse(JSON.stringify(_this.state.salesPending));

                charges[index].chargeDesc.chargeDesc.push({
                  new: true,
                  entityId: lodash_1(charges, "[" + index + "].key", ""),
                  containerNumber: lodash_1(charges, "[" + index + "].value.containerNumber", ""),
                  chargeName: "",
                  glCode: "",
                  quantity: "",
                  unitPrice: "",
                  totalRate: "",
                  createdDate: "",
                  updatedDate: "",
                  chargeId: "",
                  status: "ADMIN GENERATED",
                  paymentTerm: "",
                  unitOfMeasurement: "",
                  markUPAmount: ""
                });
                _context15.next = 8;
                return _this.updateState({ salesPending: [].concat(toConsumableArray(charges)) });

              case 8:
                returnVal = _context15.sent;

                newCharge = true;

              case 10:

                if (newCharge === false) {
                  _this.setInfoMessages("errorMsg", "Unable to fetch more charges.");
                }
                _context15.next = 13;
                return Promise.resolve(newCharge);

              case 13:
                return _context15.abrupt("return", _context15.sent);

              case 14:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this2);
      }));

      return function (_x15) {
        return _ref16.apply(this, arguments);
      };
    }();

    _this.deleteChargeLineItem = function () {
      var _ref17 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(chargeIndex, index) {
        var charges, chargeId, deleteResponse, msg;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.salesPending));
                chargeId = charges[chargeIndex].chargeDesc.chargeDesc[index].chargeId;
                _context16.next = 4;
                return deleteChargeAtLineItem$1({ value: [chargeId] });

              case 4:
                deleteResponse = _context16.sent;
                msg = lodash_1(deleteResponse, "data.eventMessage.msg", "");

                if (msg === "Drayage charge archived successfully") {
                  charges[chargeIndex].chargeDesc.chargeDesc.splice(index, 1);
                  _this.setInfoMessages("successMsg", msg);
                } else {
                  _this.setInfoMessages("errorMsg", "Unable to archive drayage charge");
                }

                _context16.next = 9;
                return _this.updateState({ salesPending: [].concat(toConsumableArray(charges)) });

              case 9:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this2);
      }));

      return function (_x16, _x17) {
        return _ref17.apply(this, arguments);
      };
    }();

    _this.selectedDropdownData = function (data) {
      _this.setState({ selectedDropDownData: data });
    };

    _this.createInvoice = function () {
      var _ref18 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(chargeIndex) {
        var charges, charge, chargeDesc, response, msg, code;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.salesPending));
                charge = charges[chargeIndex].chargeDesc;
                chargeDesc = charge.chargeDesc;

                chargeDesc = chargeDesc.filter(function (val) {
                  return val.isGenerated !== true && val.includeInInvoice === true;
                });

                charge.totalAmount = charge.totalAmount * 100;
                charge.chargeDesc = chargeDesc.map(function (val) {
                  return _extends({}, val, {
                    unitPrice: parseFloat(val.unitPrice) * 100,
                    totalRate: parseFloat(val.totalRate) * 100
                  });
                });
                //  charge.billingParties.billToList = this.state.selectedDropDownData.length > 0 ? this.state.selectedDropDownData : [charge.billingParties.billToList[0]];
                //  console.log('chargecharge',charge)
                _context17.next = 8;
                return createInvoiceFromSalesPending(charge);

              case 8:
                response = _context17.sent;
                msg = lodash_1(response, "data.eventMessage.msg", "");
                code = lodash_1(response, "data.eventMessage.code", 0);

                _this.callGetSalesPendingWithDelay(1);

                if (!(code === 200 && msg === "Invoice generated")) {
                  _context17.next = 18;
                  break;
                }

                _this.setInfoMessages("successMsg", "Invoice created successfully.");
                _this.setState({ selectedDropDownData: [] });
                _context17.next = 17;
                return new Promise(function (resolve) {
                  return resolve(true);
                });

              case 17:
                return _context17.abrupt("return", _context17.sent);

              case 18:
                _this.setInfoMessages("errorMsg", "Unable to create invoice. Some error occurred");
                _context17.next = 21;
                return new Promise(function (resolve) {
                  return resolve(false);
                });

              case 21:
                return _context17.abrupt("return", _context17.sent);

              case 22:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this2);
      }));

      return function (_x18) {
        return _ref18.apply(this, arguments);
      };
    }();

    _this.addChargeToInvoice = function () {
      var _ref19 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(SalesPendingIndex, lineItemIndex) {
        var charges, charge, includeInInvoice;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.salesPending));
                charge = charges[SalesPendingIndex].chargeDesc.chargeDesc[lineItemIndex];
                includeInInvoice = lodash_1(charge, "includeInInvoice", false);

                if (includeInInvoice) {
                  delete charges[SalesPendingIndex].chargeDesc.chargeDesc[lineItemIndex].includeInInvoice;
                } else {
                  charges[SalesPendingIndex].chargeDesc.chargeDesc[lineItemIndex].includeInInvoice = true;
                }
                _context18.next = 6;
                return _this.updateState({ salesPending: [].concat(toConsumableArray(charges)) });

              case 6:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this2);
      }));

      return function (_x19, _x20) {
        return _ref19.apply(this, arguments);
      };
    }();

    _this.addAllChargeToInvoice = function () {
      var _ref20 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(SalesPendingIndex) {
        var charges;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                charges = JSON.parse(JSON.stringify(_this.state.salesPending));

                lodash_1(charges[SalesPendingIndex], "chargeDesc.chargeDesc", []).map(function (v, k) {
                  var includeInInvoice = lodash_1(v, "includeInInvoice", false);
                  if (includeInInvoice) {
                    delete charges[SalesPendingIndex].chargeDesc.chargeDesc[k].includeInInvoice;
                  } else {
                    if (lodash_1(v, "isGenerated", false) === false) {
                      charges[SalesPendingIndex].chargeDesc.chargeDesc[k].includeInInvoice = true;
                    }
                  }
                });
                _context19.next = 4;
                return _this.updateState({ salesPending: [].concat(toConsumableArray(charges)) });

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this2);
      }));

      return function (_x21) {
        return _ref20.apply(this, arguments);
      };
    }();

    _this.setSelectedInvoice = function (params, identfier) {
      var _this$state2 = _this.state,
          selectedData = _this$state2.selectedData,
          paidInvoice = _this$state2.paidInvoice;

      if (identfier === "checked") {
        _this.setState({ selectedData: [].concat(toConsumableArray(selectedData), [params]) });
      } else {
        var copySelected = selectedData;
        var index = copySelected.indexOf(params);
        copySelected.splice(index, 1);
        _this.setState({ selectedData: copySelected });
      }
    };

    _this.setPaidInvice = function () {

      return new Promise(function () {
        var _ref21 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(resolve) {
          var selectedData, pendingInvoices;
          return regeneratorRuntime.wrap(function _callee20$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  _context20.prev = 0;
                  _context20.next = 3;
                  return _this.updateState({ fetchPendingTabInvoices: true });

                case 3:
                  selectedData = _this.state.selectedData;

                  if (!(selectedData.length > 0)) {
                    _context20.next = 8;
                    break;
                  }

                  _context20.next = 7;
                  return drayagePaidInvoice$1({
                    containerId: selectedData,
                    isDrayInvoice: false
                  });

                case 7:
                  pendingInvoices = _context20.sent;

                case 8:
                  _context20.next = 10;
                  return _this.updateState({
                    selectedData: [],
                    fetchPendingTabInvoices: false
                  });

                case 10:
                  _this.getPendingTabData(1);
                  resolve(true);
                  _context20.next = 19;
                  break;

                case 14:
                  _context20.prev = 14;
                  _context20.t0 = _context20["catch"](0);
                  _context20.next = 18;
                  return _this.updateState({
                    selectedData: [],
                    fetchPendingTabInvoices: false
                  });

                case 18:
                  resolve(true);

                case 19:
                case "end":
                  return _context20.stop();
              }
            }
          }, _callee20, _this2, [[0, 14]]);
        }));

        return function (_x23) {
          return _ref21.apply(this, arguments);
        };
      }());
    };

    _this.expandPendingCard = function (id) {
      _this.state.activePendingCard === id ? _this.updateState({
        activePendingCard: null
      }) : _this.updateState({
        activePendingCard: id
      });
    };

    _this.getPendingTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref22 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(resolve) {
          var pendingInvoices, pendingInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  _context21.prev = 0;
                  _context21.next = 3;
                  return _this.updateState({
                    fetchPendingTabInvoices: true,
                    isActiveTab: "PENDING"
                  });

                case 3:
                  _context21.next = 5;
                  return getDrayagePendingInvoices$1({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_PENDING",
                    isDrayInvoice: true
                  });

                case 5:
                  pendingInvoices = _context21.sent;
                  _context21.next = 8;
                  return _this.getSalesPendingData(page);

                case 8:
                  // for tab count
                  pendingInvoicesFiltered = lodash_1(pendingInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(value.markUPAmount) ? 0 : value.markUPAmount,
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    });
                    var chargeDescOriginal = JSON.parse(JSON.stringify(val.chargeDesc));
                    delete chargeDescOriginal.chargeDesc;
                    return _extends({}, val, {
                      chargeDescOriginal: chargeDescOriginal,
                      chargeDesc: chargeDesc,
                      totalAmount: parseFloat(val.totalAmount / 100).toFixed(2)
                    });
                  });
                  _context21.next = 11;
                  return _this.updateState({
                    pendingInvoices: pendingInvoicesFiltered,
                    fetchPendingTabInvoices: false
                  });

                case 11:
                  resolve(true);
                  _context21.next = 19;
                  break;

                case 14:
                  _context21.prev = 14;
                  _context21.t0 = _context21["catch"](0);
                  _context21.next = 18;
                  return _this.updateState({
                    pendingInvoices: [],
                    fetchPendingTabInvoices: false
                  });

                case 18:
                  resolve(true);

                case 19:
                case "end":
                  return _context21.stop();
              }
            }
          }, _callee21, _this2, [[0, 14]]);
        }));

        return function (_x25) {
          return _ref22.apply(this, arguments);
        };
      }());
    };

    _this.expandPaidCard = function (id) {
      _this.state.activePaidCard === id ? _this.updateState({
        activePaidCard: null
      }) : _this.updateState({
        activePaidCard: id
      });
    };

    _this.getPaidTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref23 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(resolve) {
          var filterPayload, requestPayload, paidInvoices, tabCount, paidInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee22$(_context22) {
            while (1) {
              switch (_context22.prev = _context22.next) {
                case 0:
                  _context22.prev = 0;
                  _context22.next = 3;
                  return _this.updateState({
                    fetchPaidTabInvoices: true,
                    isActiveTab: "PAID"
                  });

                case 3:
                  filterPayload = new PayloadFilters$1(_this.state.selectedFilters).getPayload();
                  requestPayload = _extends({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_PAID",
                    isDrayInvoice: true
                  }, filterPayload);
                  _context22.next = 7;
                  return getDrayagePaidInvoices$1(requestPayload);

                case 7:
                  paidInvoices = _context22.sent;
                  _context22.next = 10;
                  return getDrayageTabCount$1(requestPayload);

                case 10:
                  tabCount = _context22.sent;
                  _context22.next = 13;
                  return _this.updateState({
                    tabCount: _extends({}, tabCount.data.eventMessage)
                  });

                case 13:

                  // await this.getSalesPendingData(page); // for tab count

                  paidInvoicesFiltered = lodash_1(paidInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var shipmentID = lodash_1(val, "chargeDesc.shipmentID", "");
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(value.markUPAmount) ? 0 : value.markUPAmount,
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    });
                    return _extends({}, val, {
                      shipmentID: shipmentID,
                      chargeDesc: chargeDesc,
                      totalAmount: parseFloat(val.totalAmount / 100).toFixed(2)
                    });
                  });
                  _context22.next = 16;
                  return _this.updateState({
                    paidInvoices: paidInvoicesFiltered,
                    fetchPaidTabInvoices: false
                  });

                case 16:
                  resolve(true);
                  _context22.next = 24;
                  break;

                case 19:
                  _context22.prev = 19;
                  _context22.t0 = _context22["catch"](0);
                  _context22.next = 23;
                  return _this.updateState({
                    paidInvoices: [],
                    fetchPaidTabInvoices: false
                  });

                case 23:
                  resolve(true);

                case 24:
                case "end":
                  return _context22.stop();
              }
            }
          }, _callee22, _this2, [[0, 19]]);
        }));

        return function (_x27) {
          return _ref23.apply(this, arguments);
        };
      }());
    };

    _this.expandRejectedCard = function (id) {
      _this.state.activeRejectedCard === id ? _this.updateState({
        activeRejectedCard: null
      }) : _this.updateState({
        activeRejectedCard: id
      });
    };

    _this.getRejectedTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref24 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(resolve) {
          var requestPayload, rejectedInvoices, tabCount, rejectedInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee23$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  _context23.prev = 0;
                  _context23.next = 3;
                  return _this.updateState({
                    fetchRejectedTabInvoices: true,
                    isActiveTab: "REJECTED"
                  });

                case 3:
                  requestPayload = {
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_REJECTED",
                    isDrayInvoice: true
                  };
                  _context23.next = 6;
                  return getDrayageRejectedInvoices$1(requestPayload);

                case 6:
                  rejectedInvoices = _context23.sent;
                  _context23.next = 9;
                  return getDrayageTabCount$1(requestPayload);

                case 9:
                  tabCount = _context23.sent;
                  _context23.next = 12;
                  return _this.updateState({
                    tabCount: _extends({}, tabCount.data.eventMessage)
                  });

                case 12:
                  rejectedInvoicesFiltered = lodash_1(rejectedInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(value.markUPAmount) ? 0 : value.markUPAmount,
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    });
                    return _extends({}, val, {
                      chargeDesc: chargeDesc,
                      totalAmount: parseFloat(val.totalAmount / 100).toFixed(2)
                    });
                  });
                  _context23.next = 15;
                  return _this.updateState({
                    rejectedInvoices: rejectedInvoicesFiltered,
                    fetchRejectedTabInvoices: false
                  });

                case 15:
                  resolve(true);
                  _context23.next = 23;
                  break;

                case 18:
                  _context23.prev = 18;
                  _context23.t0 = _context23["catch"](0);
                  _context23.next = 22;
                  return _this.updateState({
                    rejectedInvoices: [],
                    fetchRejectedTabInvoices: false
                  });

                case 22:
                  resolve(true);

                case 23:
                case "end":
                  return _context23.stop();
              }
            }
          }, _callee23, _this2, [[0, 18]]);
        }));

        return function (_x29) {
          return _ref24.apply(this, arguments);
        };
      }());
    };

    _this.expandDisputedCard = function (id) {
      _this.state.activeDisputedCard === id ? _this.updateState({
        activeDisputedCard: null
      }) : _this.updateState({
        activeDisputedCard: id
      });
    };

    _this.getDisputedTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref25 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(resolve) {
          var filterPayload, requestPayload, disputedInvoices, tabCount, disputedInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  _context24.prev = 0;
                  _context24.next = 3;
                  return _this.updateState({
                    fetchDisputedTabInvoices: true,
                    isActiveTab: "DISPUTED"
                  });

                case 3:
                  filterPayload = new PayloadFilters$1(_this.state.selectedFilters).getPayload();
                  requestPayload = _extends({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_DISPUTE",
                    isDrayInvoice: true
                  }, filterPayload);
                  _context24.next = 7;
                  return getDrayageDisputedInvoices$1(requestPayload);

                case 7:
                  disputedInvoices = _context24.sent;
                  _context24.next = 10;
                  return getDrayageTabCount$1(requestPayload);

                case 10:
                  tabCount = _context24.sent;
                  _context24.next = 13;
                  return _this.updateState({
                    tabCount: _extends({}, tabCount.data.eventMessage)
                  });

                case 13:
                  disputedInvoicesFiltered = lodash_1(disputedInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(value.markUPAmount) ? 0 : value.markUPAmount,
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    });
                    // return {
                    //   ...val,
                    //   chargeDesc: chargeDesc,
                    //   totalAmount: parseFloat(val.totalAmount / 100).toFixed(2),
                    // };
                    var objReturn = _extends({}, val, {
                      chargeDesc: _extends({}, val.chargeDesc, {
                        chargeDesc: chargeDesc,
                        totalAmount: parseFloat(lodash_1(val, "chargeDesc.totalAmount", 0) / 100).toFixed(2)
                      })
                    });

                    return objReturn;
                  });
                  _context24.next = 16;
                  return _this.updateState({
                    disputedInvoices: disputedInvoicesFiltered,
                    fetchDisputedTabInvoices: false
                  });

                case 16:
                  resolve(true);
                  _context24.next = 24;
                  break;

                case 19:
                  _context24.prev = 19;
                  _context24.t0 = _context24["catch"](0);
                  _context24.next = 23;
                  return _this.updateState({
                    disputedInvoices: [],
                    fetchDisputedTabInvoices: false
                  });

                case 23:
                  resolve(true);

                case 24:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee24, _this2, [[0, 19]]);
        }));

        return function (_x31) {
          return _ref25.apply(this, arguments);
        };
      }());
    };

    _this.expandApprovedCard = function (id) {
      _this.state.activeApprovedCard === id ? _this.updateState({
        activeApprovedCard: null
      }) : _this.updateState({
        activeApprovedCard: id
      });
    };

    _this.getApprovedTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref26 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(resolve) {
          var filterPayload, requestPayload, approvedInvoices, tabCount, approvedInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  _context25.prev = 0;
                  _context25.next = 3;
                  return _this.updateState({
                    fetchApprovedTabInvoices: true,
                    isActiveTab: "APPROVED"
                  });

                case 3:
                  filterPayload = new PayloadFilters$1(_this.state.selectedFilters).getPayload();
                  requestPayload = _extends({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_SALES_APPROVED",
                    isDrayInvoice: true
                  }, filterPayload);
                  _context25.next = 7;
                  return getDrayageDisputedInvoices$1(requestPayload);

                case 7:
                  approvedInvoices = _context25.sent;
                  _context25.next = 10;
                  return getDrayageTabCount$1(requestPayload);

                case 10:
                  tabCount = _context25.sent;
                  _context25.next = 13;
                  return _this.updateState({
                    tabCount: _extends({}, tabCount.data.eventMessage)
                  });

                case 13:
                  approvedInvoicesFiltered = lodash_1(approvedInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(value.markUPAmount) ? 0 : value.markUPAmount,
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    });
                    // return {
                    //   ...val,
                    //   chargeDesc: chargeDesc,
                    //   totalAmount: parseFloat(val.totalAmount / 100).toFixed(2),
                    // };

                    var objReturn = _extends({}, val, {
                      chargeDesc: _extends({}, val.chargeDesc, {
                        chargeDesc: chargeDesc,
                        totalAmount: parseFloat(lodash_1(val, "chargeDesc.totalAmount", 0) / 100).toFixed(2)
                      })
                    });

                    return objReturn;
                  });
                  _context25.next = 16;
                  return _this.updateState({
                    approvedInvoices: approvedInvoicesFiltered,
                    fetchApprovedTabInvoices: false
                  });

                case 16:
                  resolve(true);
                  _context25.next = 24;
                  break;

                case 19:
                  _context25.prev = 19;
                  _context25.t0 = _context25["catch"](0);
                  _context25.next = 23;
                  return _this.updateState({
                    approvedInvoices: [],
                    fetchApprovedTabInvoices: false
                  });

                case 23:
                  resolve(true);

                case 24:
                case "end":
                  return _context25.stop();
              }
            }
          }, _callee25, _this2, [[0, 19]]);
        }));

        return function (_x33) {
          return _ref26.apply(this, arguments);
        };
      }());
    };

    _this.expandPartiallyPaidCard = function (id) {
      _this.state.activePartiallyPaidCard === id ? _this.updateState({
        activePartiallyPaidCard: null
      }) : _this.updateState({
        activePartiallyPaidCard: id
      });
    };

    _this.getPartiallyPaidTabData = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return new Promise(function () {
        var _ref27 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(resolve) {
          var filterPayload, requestPayload, partiallyPaidInvoices, tabCount, partiallyPaidInvoicesFiltered;
          return regeneratorRuntime.wrap(function _callee26$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  _context26.prev = 0;
                  _context26.next = 3;
                  return _this.updateState({
                    fetchPartiallyPaidTabInvoices: true,
                    isActiveTab: "PARTIALLY PAID"
                  });

                case 3:
                  filterPayload = new PayloadFilters$1(_this.state.selectedFilters).getPayload();
                  requestPayload = _extends({
                    pageNumber: page,
                    keyword: _this.state.keyword,
                    invoiceTab: "DRAYAGE_INVOICE_TAB_PARTIALLY_PAID",
                    isDrayInvoice: true
                  }, filterPayload);
                  _context26.next = 7;
                  return getDrayagePartiallyPaidInvoices$1(requestPayload);

                case 7:
                  partiallyPaidInvoices = _context26.sent;
                  _context26.next = 10;
                  return getDrayageTabCount$1(requestPayload);

                case 10:
                  tabCount = _context26.sent;
                  _context26.next = 13;
                  return _this.updateState({
                    tabCount: _extends({}, tabCount.data.eventMessage)
                  });

                case 13:
                  partiallyPaidInvoicesFiltered = lodash_1(partiallyPaidInvoices, "data.eventMessage.drayageInvoices", []).map(function (val) {
                    var chargeDesc = lodash_1(val, "chargeDesc.chargeDesc", []).map(function (value) {
                      var unitPrice = isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice).toFixed(2);
                      var quantity = isNaN(parseFloat(value.quantity)) ? 0.0 : parseFloat(value.quantity).toFixed(2);
                      return _extends({}, value, {
                        markUPAmount: isNaN(value.markUPAmount) ? 0 : value.markUPAmount,
                        unitPrice: isNaN(parseFloat(value.unitPrice)) ? 0.0 : parseFloat(value.unitPrice / 100).toFixed(2),
                        subTotal: parseFloat(unitPrice * quantity),
                        totalRate: isNaN(parseFloat(value.totalRate)) ? 0.0 : parseFloat(value.totalRate / 100).toFixed(2)
                      });
                    });
                    // return {
                    //   ...val,
                    //   chargeDesc: chargeDesc,
                    //   totalAmount: parseFloat(val.totalAmount / 100).toFixed(2),
                    // };

                    var objReturn = _extends({}, val, {
                      chargeDesc: _extends({}, val.chargeDesc, {
                        chargeDesc: chargeDesc,
                        totalAmount: parseFloat(lodash_1(val, "chargeDesc.totalAmount", 0) / 100).toFixed(2)
                      })
                    });

                    return objReturn;
                  });
                  _context26.next = 16;
                  return _this.updateState({
                    partiallyPaidInvoices: partiallyPaidInvoicesFiltered,
                    fetchPartiallyPaidTabInvoices: false
                  });

                case 16:
                  resolve(true);
                  _context26.next = 24;
                  break;

                case 19:
                  _context26.prev = 19;
                  _context26.t0 = _context26["catch"](0);
                  _context26.next = 23;
                  return _this.updateState({
                    partiallyPaidInvoices: [],
                    fetchPartiallyPaidTabInvoices: false
                  });

                case 23:
                  resolve(true);

                case 24:
                case "end":
                  return _context26.stop();
              }
            }
          }, _callee26, _this2, [[0, 19]]);
        }));

        return function (_x35) {
          return _ref27.apply(this, arguments);
        };
      }());
    };

    _this.setRefNum = function (item) {
      var index = _this.state.salesPending.findIndex(function (el) {
        return el.containerId === item.containerId;
      });
      if (index !== -1) {
        var newSalesData = [].concat(toConsumableArray(_this.state.salesPending));
        newSalesData[index] = item;
        _this.setState({ salesPending: newSalesData });
      }
    };

    _this.handleFilterChange = function (key, value) {
      if (value) {
        _this.setState(function (state) {
          return _extends({}, state, {
            selectedFilters: _extends({}, state.selectedFilters, defineProperty({}, key, value))
          });
        }, function () {
          _this.handleFetchInvoicesForActiveTab();
        });
      } else {
        _this.setState(function (state) {
          if (lodash_1(state, "selectedFilters[" + key + "]", false)) {
            delete state.selectedFilters[key];
          }
          return _extends({}, state);
        }, function () {
          _this.handleFetchInvoicesForActiveTab();
        });
      }
    };

    _this.handleFetchInvoicesForActiveTab = function () {
      var isActiveTab = _this.state.isActiveTab;

      var TAB_CALLBACKS = {
        PENDING: _this.getSalesPendingData,
        DISPUTED: _this.getDisputedTabData,
        APPROVED: _this.getApprovedTabData,
        PAID: _this.getPaidTabData,
        "PARTIALLY PAID": _this.getPartiallyPaidTabData
      };

      var callBack = lodash_1(TAB_CALLBACKS, "" + isActiveTab, false);
      if (callBack) {
        callBack();
      }
    };

    _this.state = {
      salesPending: [],
      fetchSalesPending: false,
      activeSalesPendingCard: null,
      chargesOptions: [],
      errorMsg: "",
      successMsg: "",
      fetchPendingTabInvoices: false,
      fetchPaidTabInvoices: false,
      fetchPartiallyPaidTabInvoices: false,
      fetchRejectedTabInvoices: false,
      fetchDisputedTabInvoices: false,
      pendingInvoices: [],
      paidInvoices: [],
      partiallyPaidInvoices: [],
      rejectedInvoices: [],
      disputedInvoices: [],
      activePendingCard: null,
      activePaidCard: null,
      activePartiallyPaidCard: null,
      activeRejectedCard: null,
      selectedData: [],
      copyData: [],
      selectedBillToParties: {},
      invoiceSalesPendingData: [],
      selectedDropDownData: [],
      isActiveTab: "PENDING",
      pageNumber: 1,
      rejectToSalesPending: false,
      sendKeyword: "",
      activeIndex: 0,
      nonEditableGlCodes: [],
      partnerId: "",
      unitPriceVal: 0,
      uom: "",
      tabCount: {},
      disputeRaisedError: "",
      fetchApprovedTabInvoices: false,
      approvedInvoices: [],
      activeApprovedCard: null,
      selectedFilters: {}
    };
    _this.HandlecallbackKeyword = _this.HandlecallbackKeyword.bind(_this);
    return _this;
  }

  createClass(DrayageInvoices, [{
    key: "componentDidMount",
    value: function () {
      var _ref28 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var getkxUser, partnerId;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return getKxUser();

              case 2:
                getkxUser = _context27.sent;
                partnerId = lodash_1(getkxUser, "data.eventMessage.userInfo.partnerId", "");
                _context27.next = 6;
                return this.updateState({ partnerId: partnerId });

              case 6:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function componentDidMount() {
        return _ref28.apply(this, arguments);
      }

      return componentDidMount;
    }()

    /**
     * SalesPending RELATED CODE BEGINS
     */

    /**
     * SalesPending RELATED CODE ENDS
     */

    /*****************************************
     * PENDING TAB FUNCTION START
     *****************************************/

    /*****************************************
     * PENDING TAB FUNCTION ENDS
     *****************************************/

    /*****************************************
     * PAID TAB FUNCTION
     *****************************************/


    /*****************************************
     * PAID TAB FUNCTION ENDS
     *****************************************/

    /****************************************
     * REJECTED TAB FUNCTION STARS
     ****************************************/

    /****************************************
     * REJECTED TAB FUNCTION ENDS
     ****************************************/
    /****************************************
     * DISPUTED TAB FUNCTION STARS
     ****************************************/

    /****************************************
     * DISPUTED TAB FUNCTION ENDS
     ****************************************/
    /****************************************
     * APPROVED TAB FUNCTION STARS
     ****************************************/

    /****************************************
     * APPROVED TAB FUNCTION ENDS
     ****************************************/
    /****************************************
     * PARTIALLY PAID TAB FUNCTION STARTS
     *************************************/


    /**********************************
     * PARTIALLY PAID TAB FUNCTION ENDS
     ********************************/

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          data = _props.data,
          totalListEl = _props.totalListEl,
          userData = _props.userData;
      var activeIndex = this.state.activeIndex;

      var panes = Object.keys(ActiveTabs$1).map(function (val, index) {
        var Component$$1 = ActiveTabs$1[val].Component;
        if (val === "sales-pending") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index },
              ActiveTabs$1[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs$1[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.pendingTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchSalesPending: _this3.state.fetchSalesPending,
                  salesPending: _this3.state.salesPending,
                  updateState: _this3.updateState,
                  getSalesPendingData: _this3.getSalesPendingData,
                  editSalesPendingCharge: _this3.editSalesPendingCharge,
                  activeCard: _this3.state.activeSalesPendingCard,
                  expandSalesPendingCard: _this3.expandSalesPendingCard,
                  updateSalesPendingLineItem: _this3.updateSalesPendingLineItem,
                  addNewCharge: _this3.addNewCharge,
                  deleteChargeLineItem: _this3.deleteChargeLineItem,
                  cancelSalesPendingEdit: _this3.cancelSalesPendingEdit,
                  saveSalesPendingData: _this3.saveSalesPendingData,
                  chargesOptions: _this3.state.chargesOptions,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  createInvoice: _this3.createInvoice,
                  addChargeToInvoice: _this3.addChargeToInvoice,
                  addAllChargeToInvoice: _this3.addAllChargeToInvoice,
                  selectedBillToParties: _this3.state.selectedBillToParties,
                  invoiceSalesPendingData: _this3.state.invoiceSalesPendingData,
                  selectedDropdownData: _this3.selectedDropdownData,
                  nonEditableGlCodes: _this3.state.nonEditableGlCodes,
                  unitPriceVal: _this3.state.unitPriceVal,
                  uom: _this3.state.uom,
                  selectedCharge: _this3.selectedCharge,
                  unitPriceValue: _this3.unitPriceValue,
                  raiseDisputeRequest: _this3.raiseDisputeRequest,
                  disputeRaisedError: _this3.state.disputeRaisedError,
                  totalCount: lodash_1(_this3.state, "tabCount.pendingTabCount", 0),
                  approveInvoice: _this3.approveInvoice,
                  setRefNum: _this3.setRefNum
                })
              );
            }
          };
        } else if (val === "pending") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index },
              ActiveTabs$1[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs$1[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.pendingTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchPendingTabInvoices: _this3.state.fetchPendingTabInvoices,
                  invoices: _this3.state.pendingInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getPendingTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activePendingCard,
                  expandCard: _this3.expandPendingCard,
                  getFormatedDate: getFormatedDate$1,
                  getCountryNameAndImage: getCountryNameAndImage$1,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  setSelectedInvoice: _this3.setSelectedInvoice,
                  setPaidInvice: _this3.setPaidInvice,
                  userTypes: _this3.props.userType
                })
              );
            }
          };
        } else if (val === "paid") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index },
              ActiveTabs$1[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs$1[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.paidTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchPaidTabInvoices: _this3.state.fetchPaidTabInvoices,
                  invoices: _this3.state.paidInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getPaidTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activePaidCard,
                  expandCard: _this3.expandPaidCard,
                  getFormatedDate: getFormatedDate$1,
                  getCountryNameAndImage: getCountryNameAndImage$1,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  getFormatedPaidDate: _this3.getFormatedPaidDate,
                  totalCount: lodash_1(_this3.state, "tabCount.paidTabCount", 0)
                })
              );
            }
          };
        } else if (val === "disputed") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index },
              ActiveTabs$1[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs$1[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.disputeTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchDisputedTabInvoices: _this3.state.fetchDisputedTabInvoices,
                  invoices: _this3.state.disputedInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getDisputedTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activeDisputedCard,
                  expandCard: _this3.expandDisputedCard,
                  getFormatedDate: getFormatedDate$1,
                  getCountryNameAndImage: getCountryNameAndImage$1,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  totalCount: lodash_1(_this3.state, "tabCount.disputeTabCount", 0)
                })
              );
            }
          };
        } else if (val === "approved") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index },
              ActiveTabs$1[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs$1[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.approvedCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchApprovedTabInvoices: _this3.state.fetchApprovedTabInvoices,
                  invoices: _this3.state.approvedInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getApprovedTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activeApprovedCard,
                  expandCard: _this3.expandApprovedCard,
                  getFormatedDate: getFormatedDate$1,
                  getCountryNameAndImage: getCountryNameAndImage$1,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  totalCount: lodash_1(_this3.state, "tabCount.approvedCount", 0)
                })
              );
            }
          };
        } else if (val === "partially-paid") {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index },
              ActiveTabs$1[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs$1[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.partiallyPaidCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchPartiallyPaidTabInvoices: _this3.state.fetchPartiallyPaidTabInvoices,
                  invoices: _this3.state.partiallyPaidInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getPartiallyPaidTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activePartiallyPaidCard,
                  expandCard: _this3.expandPartiallyPaidCard,
                  getFormatedDate: getFormatedDate$1,
                  getCountryNameAndImage: getCountryNameAndImage$1,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  totalCount: lodash_1(_this3.state, "tabCount.partiallyPaidCount", 0)
                })
              );
            }
          };
        } else {
          return {
            menuItem: React__default.createElement(
              Menu.Item,
              { key: "message-" + index },
              ActiveTabs$1[val].label,
              React__default.createElement(
                Label,
                {
                  className: ActiveTabs$1[val].labelClass.join(" ").toString(),
                  circular: true
                },
                lodash_1(_this3.state, "tabCount.rejectedTabCount", 0)
              )
            ),
            render: function render() {
              return React__default.createElement(
                Tab.Pane,
                { className: "tab-pane" },
                React__default.createElement(Component$$1, {
                  fetchRejectedTabInvoices: _this3.state.fetchRejectedTabInvoices,
                  invoices: _this3.state.rejectedInvoices,
                  updateState: _this3.updateState,
                  getTabData: _this3.getRejectedTabData,
                  successMsg: _this3.state.successMsg,
                  errorMsg: _this3.state.errorMsg,
                  activeCard: _this3.state.activeRejectedCard,
                  expandCard: _this3.expandRejectedCard,
                  getFormatedDate: getFormatedDate$1,
                  getCountryNameAndImage: getCountryNameAndImage$1,
                  getFormatedCurrency: _this3.getFormatedCurrency,
                  goToSalesPending: _this3.goToSalesPending
                })
              );
            }
          };
        }
      });

      return React__default.createElement(
        ModalProvider$1,
        null,
        React__default.createElement(
          "div",
          null,
          React__default.createElement(
            "div",
            {
              className: "drayage-invoices-container drayage-sales",
              style: {
                paddingTop: "90px"
              }
            },
            React__default.createElement(
              "div",
              { className: "drayage-sales-search-box-and-filter-container" },
              React__default.createElement(DrayageInvoiceSearchbar$1, {
                sendKeyword: this.state.sendKeyword,
                sendKeywordFun: this.sendKeywordFun,
                callbackKeyword: this.HandlecallbackKeyword
              }),
              React__default.createElement(Filters$1, {
                activeTab: this.state.isActiveTab,
                onChange: this.handleFilterChange,
                selectedFilters: this.state.selectedFilters
              })
            ),
            React__default.createElement(
              Container,
              { fluid: true },
              React__default.createElement(
                "div",
                { className: "drayage-title" },
                "Invoices"
              ),
              React__default.createElement("div", { className: "drayage-country-date" }),
              React__default.createElement(Tab, {
                className: "drayage-tabs",
                activeIndex: activeIndex,
                onTabChange: this.handleTabChange,
                panes: panes
              })
            )
          )
        ),
        React__default.createElement(CustomModal$1, null)
      );
    }
  }]);
  return DrayageInvoices;
}(Component);

var WithForceLogout = function WithForceLogout(WrappedComponent) {
  return function (_Component) {
    inherits(_class2, _Component);

    function _class2(props) {
      classCallCheck(this, _class2);

      var _this = possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this, props));

      _this.handleActivity = function () {
        var env = window._env_.KX_ENVIRONMENT;
        var isLocalhost = /^(localhost|127\.0\.0\.1)(:\d+)?$/.test(window.location.hostname);
        // Reset the timer on user activity
        clearTimeout(_this.timer);
        _this.timer = setTimeout(function () {
          // Trigger logout after timeoutMinutes minutes of inactivity
          env === 'dev' && !isLocalhost && logout$1();
        }, _this.timeoutMinutes * 60 * 1000); // Convert minutes to milliseconds
      };

      _this.timer = null;
      _this.timeoutMinutes = 5; // Default timeout value, can be changed as needed
      return _this;
    }

    createClass(_class2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Start the timer when the component mounts
        this.handleActivity();
        // Add event listeners for user activity
        window.addEventListener("click", this.handleActivity);
        window.addEventListener("keydown", this.handleActivity);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        // Clean up the timer and event listeners on component unmount
        clearTimeout(this.timer);
        window.removeEventListener("click", this.handleActivity);
        window.removeEventListener("keydown", this.handleActivity);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, this.props);
      }
    }]);
    return _class2;
  }(Component);
};

/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2021 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

var opportunityInitialState = {
    fromCC: "",
    partnerId: "",
    tab: "NEW", //NEW, SUBMITTED, ACTIVE, REJECTED
    standardPartnerAdditionalCharges: null,
    opportunityDetailData: {},
    opportunityCount: {},
    customerOpportunities: new Map(), // key : customer id, value : list of opportunties
    containerOpportunities: new Map(),
    laneOpportunities: new Map(),
    opportunityData: new Map(),
    // key : opportunityId, 
    // value : {
    //     briefData : {} -> high level details of opportunity to display on summary view as feteched from API_GET_OPPORTINITY_LIST
    //     portData : Map { -> Ports within a given opportunity as feteched from API_GET_OPPORTINITY_DETAILS API
    //        key : portId,
    //        value : { 
    //          portBriefData : {}
    //          portAdditionalCharges : Map {key : glCode, value {unit price, req q....}}}  //from AdditionalChargeComponent
    //          destinations : Map {
    //             key : destinationId,
    //             value : {
    //                destinationAdditionalCharges : Map {key : glCode, value {unit price, req q....}}}  // from AdditionalChargeComponent
    //                destinationBriefData : {},
    //                bidData : {} // from LaneBidCard
    //                
    //          },
    //          value : Map { 
    //                    
    //         }  
    //     }  
    //     bidData : bid data filled by user that will be submitted using SET_OPPORTUNITY_BID_DATA
    // }

    opportunityColumnData: new Map(), // Data for destination lane columns of a given opportunity.

    customerOpportunitiesSubmitted: new Map(), // key : customer id, value : list of opportunties
    opportunityDataSubmitted: new Map(),

    customerOpportunitiesPublishedSales: new Map(),

    customerOpportunitiesSales: new Map(),

    customerOpportunitiesActive: new Map(), // key : customer id, value : list of opportunties
    opportunityDataActive: new Map(),

    customerOpportunitiesRejected: new Map(), // key : customer id, value : list of opportunties
    opportunityDataRejected: new Map(),

    /*
     *Running state
     */
    openedOpportunities: new Map(), //Map of which opportunity ids are opened 
    opportunityOpenedForBid: "", // Opportunity which is opened for filling bid data
    opportunityOpenedForBid_opp_type: "", // Opportunity which is opened for filling bid data
    opportunityPortOpenedForBid: null, //Port code within opportunity which opened for filling bid data
    opportunityDestinationOpenedForBid: null, //Destination id within opportunity which opened for filling bid data

    //  let isOpenMap = new Map()
    //  if (this.props.customerOpportunity) {
    //    for (let oppor of this.props.customerOpportunity.opportunityList) {
    //        isOpenMap.set(oppor.opportunityId, false)
    //    }
    //  }
    time: Date.now()
};

// OPPORTUNITY_BID_CLICKED
// OPPORTUNITY_BID_MODAL_BID_CLICKED
// OPPORTUNITY_BID_MODAL_ADDITIONAL_CHARGE_CLICKED
// OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED
// OPPORTUNITY_BID_MODAL_CANCEL_CLICKED
// LANE_BID_DONE_CLICKED
// LANE_BID_CANCEL_CLICKED
// LANE_BID_ADDITIONAL_CHARGE_CLICKED
// ADDITONAL_CHARGE_DONE_CLICKED
// ADDITONAL_CHARGE_CANCEL_CLICKEDo
// API_GET_OPPORTINITY_LIST
// API_GET_OPPORTINITY_DETAILS
// SET_OPPORTUNITY_BID_DATA 

//construct state.customerOpportunities


var getOpportunityDataForTab = function getOpportunityDataForTab(tab, state) {

    console.log("Opportunity:: reducer", state);

    switch (tab) {
        case SELECTED_TABS.PARTNER_NEW:
        case SELECTED_TABS.SALES_NEW:
        case SELECTED_TABS.CUSTOMER_NEW:
            return state.opportunityData;
        case SELECTED_TABS.PARTNER_SUBMITTED:
            return state.opportunityData;
        case "SALES_PUBLISHED":
            return state.customerOpportunitiesPublishedSales;
        case "SALES_CUSTOMER_REQUESTED":
            return state.customerOpportunitiesPublishedSales;
        case "SALES_PENDING_APPROVAL":
        case "SALES_ACCEPTED":
        case "SALES_REJECTED":
        case "SALES_ARCHIVED":
            return state.customerOpportunitiesSales;
        case SELECTED_TABS.PARTNER_ACTIVE:
        case SELECTED_TABS.CUSTOMER_ACTIVE:
            return state.opportunityData;
        case SELECTED_TABS.PARTNER_REJECTED:
        case SELECTED_TABS.CUSTOMER_REJECTED:
            return state.opportunityData;
        case SELECTED_TABS.CUSTOMER_REQUESTED:
            return state.opportunityData;
        case SELECTED_TABS.PARTNER_ARCHIVED:
            return state.opportunityData;
        case SELECTED_TABS.PARTNER_ARCHIVED:
            return state.opportunityData;
    }
    return null;
};

var updateCustomerOpportunityMap = function updateCustomerOpportunityMap(state, data, tab) {
    console.log("OpportunityReducer : CC updateCustomerOpportunityMap ", data, state, tab);
    // let customerOpportunities = new Map()
    var containerOpportunities = new Map();
    var laneOpportunities = new Map();

    // console.log("OpportunityReducer : CC type ", typeof(customerOpportunities))

    // let tab = state.tab
    var opportunityData = getOpportunityDataForTab(tab, state);
    if (!opportunityData) {
        console.log("Can not find opportunity data for tab ", tab);
        return { containerOpportunities: new Map(), laneOpportunities: new Map(), opportunityData: new Map() };
    }

    var containerOpportunitiesList = lodash_1(data, "containerOpportunity", new Map());
    console.log("OpportunityReducer : CC opportunityDataSet", containerOpportunitiesList);
    var laneOpportunitiesList = lodash_1(data, "laneOpportunity", new Map());
    console.log("OpportunityReducer : CC laneOpportunitiesList", laneOpportunitiesList);

    //Handle new customers and opportunities later
    if (!containerOpportunitiesList && !laneOpportunitiesList) {
        console.log("NO OPPORTUNITY LIST FOUND ", customerOpportunityList);
        return { containerOpportunities: new Map(), laneOpportunities: new Map(), opportunityData: opportunityData };
    }
    var openedOpportunities = state.openedOpportunities;
    if (containerOpportunitiesList.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = containerOpportunitiesList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var containerOpportunity = _step.value;

                var customerId = containerOpportunity.customerId;
                var opportunityList = containerOpportunity.opportunityList;

                console.log("opportunityList now:", opportunityList);

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = opportunityList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var opporData = _step2.value;

                        /*
                         * Don't override any opened opportunity. Later we may have to fetch port data for this 
                         * to show updated info
                         */
                        var openedStatus = getIsOpportunityOpenedAnyTab(openedOpportunities, tab, opporData.opportunityId);
                        console.log("opportunityList now: openedStatus", openedStatus);
                        opportunityData.set(opporData.opportunityId, opporData);
                        // if (openedStatus === false) {


                        /*
                         * Add any new opportunity seen
                         */
                        // if (getOpenedOpportunityStatus(openedOpportunities, state.tab, opporData.opportunityId) === false) {
                        setOpenedOpportunityStatus(openedOpportunities, tab, opporData.opportunityId, false);
                        // }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                containerOpportunities.set(containerOpportunity.customerId, containerOpportunity);
                console.log("containerOpportunities :: ", containerOpportunities.keys());
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    if (laneOpportunitiesList.length > 0) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = laneOpportunitiesList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var laneOpportunity = _step3.value;

                var _customerId = laneOpportunity.customerId;
                var _opportunityList = laneOpportunity.opportunityList;

                console.log("opportunityList now:", _opportunityList);

                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = _opportunityList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var _opporData = _step4.value;

                        /*
                         * Don't override any opened opportunity. Later we may have to fetch port data for this 
                         * to show updated info
                         */
                        var _openedStatus = getIsOpportunityOpenedAnyTab(openedOpportunities, tab, _opporData.opportunityId);
                        console.log("opportunityList now: openedStatus", _openedStatus);
                        // if (openedStatus === false) {
                        opportunityData.set(_opporData.opportunityId, _opporData);

                        /*
                         * Add any new opportunity seen
                         */
                        // if (getOpenedOpportunityStatus(openedOpportunities, state.tab, opporData.opportunityId) === false) {
                        setOpenedOpportunityStatus(openedOpportunities, tab, _opporData.opportunityId, false);
                        // }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                laneOpportunities.set(laneOpportunity.customerId, laneOpportunity);
                console.log("laneOpportunities :: ", laneOpportunities.keys());
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    }

    console.log("Container Opportunities :: reducer ", containerOpportunities, laneOpportunities, opportunityData, openedOpportunities);
    return { containerOpportunities: containerOpportunities, laneOpportunities: laneOpportunities,
        opportunityData: opportunityData, opportunityCount: data.opportunityCount };
};

//source, opportunuityId, portId, destinationId, charges
var updateOpportunityAdditionalCharges = function updateOpportunityAdditionalCharges(state, data) {
    console.log("OpportunityReducer : updateOpportunityAdditionalCharges ", data);

    var opporId = data.opportunuityId;
    var opportunityData = state.opportunityData;

    var opporData = opportunityData.get(opporId);
    if (!opporData) {
        console.log("No opportunity found with id", opporId);
        return opportunityData;
    }

    var portData = null;
    portData = opporData.portData.get(data.portId);
    if (portData === null) {
        console.log("No port data found with id", data.portId);
        return opportunityData;
    }

    if (data.source === "PORT_ADDITIONAL_CHARGE") {
        //Find the port, and insert the additional charge
        portData.portAdditionalCharges = data.charges;
    } else if (data.source === "LANE_ADDITIONAL_CHARGE") {
        //Find the lane, and insert the additional charge
        console.log("OpportunityReducer : updateOpportunityAdditionalCharges : Update lane additional charge port data ", portData);
        var destinationData = null;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            for (var _iterator5 = portData.destinations[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var destination = _step5.value;

                if (destination.laneId === data.laneId) {
                    destinationData = destination;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        console.log("OpportunityReducer : updateOpportunityAdditionalCharges : Found destination as ", destinationData);

        if (!destinationData) {
            console.log("OpportunityReducer : updateOpportunityAdditionalCharges : No destination data found with id", data.laneId);
            return opportunityData;
        }
        destinationData.destinationAdditionalCharges = data.charges;
    }
    console.log("OpportunityReducer : updateOpportunityAdditionalCharges after ", opportunityData);
    return opportunityData;
};

// opportunuityId : opportunuityId,
// opportunityDetails : opportunityDetails,
// opportunityPortsData : opportunityPortsData
var updateOpportunityDataMapWithDetails = function updateOpportunityDataMapWithDetails(state, data) {

    console.log("OpportunityReducer : updateOpportunityDataMapWithDetails ", data, state);
    console.log("OpportunityReducer : ", data.opportunityDetails); //object
    console.log("OpportunityReducer : ", data.opportunuityId);
    console.log("OpportunityReducer : opportunityPortsData", data.opportunityPortsData); //map

    var opporId = data.opportunuityId;
    var opportunityData = state.opportunityData;

    var opporData = opportunityData.get(opporId);
    if (!opporData) {
        console.log("No opportunity found with id", opporId);
        return;
    }

    var opportunityColumnData = state.opportunityColumnData;
    opportunityColumnData.set(opporId, data.columnData);

    //Attach port data received from detail API to opportunity data
    opporData.portData = data.opportunityPortsData;
    opporData.knFuelPercent = lodash_1(data, 'opportunityDetailData.sourceList[0].destinations[0].partBids[0].knFuelPercent', 100);

    /*
     * Attach lane additional charges
     */
    var portDataList = lodash_1(data, "chargeResponse.sourceList", []);
    var totalPortCharge = 0;
    console.log("OpportunityReducer :: additionalCharges ::  sourceList : ", portDataList, " opportData : ", opporData);

    var portDestinations = {};
    var portAdditionalCharges = {};
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
        for (var _iterator6 = portDataList[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var portData = _step6.value;


            portDestinations[portData.sourceId] = portData.destinations;
            portAdditionalCharges[portData.sourceId] = lodash_1(portData, "sourceChargeList", []);
            totalPortCharge = portData.totalPortCharge;
            console.log("totalPortCharge Arpita", totalPortCharge);
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
            }
        } finally {
            if (_didIteratorError6) {
                throw _iteratorError6;
            }
        }
    }

    console.log("OpportunityReducer :: additionalCharges :: portDestinations : ", portDestinations, "port additional charges ", portAdditionalCharges);
    var standardPartnerAdditionalCharges = lodash_1(state, "standardPartnerAdditionalCharges", []);
    standardPartnerAdditionalCharges = standardPartnerAdditionalCharges || [];

    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
        for (var _iterator7 = (opporData.portData || [])[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _ref = _step7.value;

            var _ref2 = slicedToArray(_ref, 2);

            var srcPortCode = _ref2[0];
            var _portData = _ref2[1];


            var destionaMap = {};
            if (portDestinations[srcPortCode]) {
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                    for (var _iterator8 = portDestinations[srcPortCode][Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        var destination = _step8.value;

                        destionaMap[destination.laneId] = destination;
                    }
                } catch (err) {
                    _didIteratorError8 = true;
                    _iteratorError8 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                            _iterator8.return();
                        }
                    } finally {
                        if (_didIteratorError8) {
                            throw _iteratorError8;
                        }
                    }
                }
            } else {
                console.log("OpportunityReducer :: additionalCharges ::  no charges for port code : ", srcPortCode);
            }

            console.log("OpportunityReducer :: additionalCharges :: destionaMap : ", destionaMap);

            var portAdditionalChargesList = portAdditionalCharges[srcPortCode] ? portAdditionalCharges[srcPortCode] : [];
            var portChargesExisting = new Map();
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = portAdditionalChargesList[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var charge = _step9.value;

                    portChargesExisting.set(charge.glCode, charge);
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            var portChargesMap = new Map();
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
                for (var _iterator10 = standardPartnerAdditionalCharges[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var _charge = _step10.value;

                    var tmp = _extends({}, _charge);
                    var glCode = tmp.glCode;
                    var existingCharge = portChargesExisting.has(glCode) ? portChargesExisting.get(glCode) : null;
                    if (existingCharge) {
                        tmp.reqQuantityUsed = existingCharge.quantity;
                    }
                    portChargesMap.set(glCode, tmp);
                }
            } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                        _iterator10.return();
                    }
                } finally {
                    if (_didIteratorError10) {
                        throw _iteratorError10;
                    }
                }
            }

            _portData.portAdditionalCharges = portChargesMap;

            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
                for (var _iterator11 = _portData.destinations[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                    var _destination = _step11.value;

                    _destination.destinationAdditionalCharges = lodash_1(destionaMap[_destination.laneId], "chargeDetails.laneAdditionalChargeList", []);
                    var destinationBidData = lodash_1(_destination, "destinationBidData", {});

                    console.log("OpportunityReducer :: additionalCharges :: destinaion lane ", _destination.laneId, destionaMap[_destination.laneId]);
                    var laneBaseCharges = [];
                    var laneAdditionalCharges = [];
                    laneBaseCharges = lodash_1(destionaMap[_destination.laneId], "chargeDetails.baseChargeList", []);
                    laneAdditionalCharges = lodash_1(destionaMap[_destination.laneId], "chargeDetails.laneAdditionalChargeList", []);
                    console.log("OpportunityReducer :: additionalCharges :: base and lane charges ", laneBaseCharges, laneAdditionalCharges);

                    var laneChargesExisting = new Map();
                    var laneAdditionalChargeAmount = 0;
                    var _iteratorNormalCompletion12 = true;
                    var _didIteratorError12 = false;
                    var _iteratorError12 = undefined;

                    try {
                        for (var _iterator12 = laneAdditionalCharges[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                            var _charge2 = _step12.value;

                            laneAdditionalChargeAmount += _charge2.amount;
                            _charge2.reqQuantityUsed = _charge2.quantity;
                            laneChargesExisting.set(_charge2.glCode, _charge2);
                        }
                    } catch (err) {
                        _didIteratorError12 = true;
                        _iteratorError12 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                _iterator12.return();
                            }
                        } finally {
                            if (_didIteratorError12) {
                                throw _iteratorError12;
                            }
                        }
                    }

                    var _iteratorNormalCompletion13 = true;
                    var _didIteratorError13 = false;
                    var _iteratorError13 = undefined;

                    try {
                        for (var _iterator13 = laneBaseCharges[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                            var baseCharge = _step13.value;

                            if (baseCharge.glCode === 60001) {
                                destinationBidData.baseFees = baseCharge.unitPrice;
                            } else if (baseCharge.glCode === 60002) {
                                destinationBidData.fuelCharges = baseCharge.chargePercent;
                                destinationBidData.yesRadioButton = true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError13 = true;
                        _iteratorError13 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion13 && _iterator13.return) {
                                _iterator13.return();
                            }
                        } finally {
                            if (_didIteratorError13) {
                                throw _iteratorError13;
                            }
                        }
                    }

                    var fuelChargePercent = lodash_1(destinationBidData, 'fuelCharges', 0);
                    var baseFees = lodash_1(destinationBidData, 'baseFees', 0);
                    var fuelCharges = fuelChargePercent ? baseFees / 100 * fuelChargePercent : 0;
                    destinationBidData.laneAmount = baseFees + laneAdditionalChargeAmount + fuelCharges;
                    _destination.destinationBidData = destinationBidData;

                    var laneChargesMap = new Map();
                    var _iteratorNormalCompletion14 = true;
                    var _didIteratorError14 = false;
                    var _iteratorError14 = undefined;

                    try {
                        for (var _iterator14 = standardPartnerAdditionalCharges[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                            var _charge3 = _step14.value;

                            var _tmp = _extends({}, _charge3);
                            var _glCode = _tmp.glCode;
                            var _existingCharge = laneChargesExisting.has(_glCode) ? laneChargesExisting.get(_glCode) : null;
                            if (_existingCharge) {
                                _tmp.reqQuantityUsed = _existingCharge.quantity;
                            }
                            laneChargesMap.set(_glCode, _tmp);
                        }
                    } catch (err) {
                        _didIteratorError14 = true;
                        _iteratorError14 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion14 && _iterator14.return) {
                                _iterator14.return();
                            }
                        } finally {
                            if (_didIteratorError14) {
                                throw _iteratorError14;
                            }
                        }
                    }

                    _destination.destinationAdditionalCharges = laneChargesMap;
                }
            } catch (err) {
                _didIteratorError11 = true;
                _iteratorError11 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                        _iterator11.return();
                    }
                } finally {
                    if (_didIteratorError11) {
                        throw _iteratorError11;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
            }
        } finally {
            if (_didIteratorError7) {
                throw _iteratorError7;
            }
        }
    }

    console.log("OpportunityReducer :: additionalCharges :: final charges ", opporData);
    opportunityData.set(opporId, opporData);
    return opportunityData;
};

var updateOpportunityDataMapWithBidDetails = function updateOpportunityDataMapWithBidDetails(state, data) {
    console.log("OpportunityReducer : updateOpportunityDataMapWithBidDetails ", data);
    var opporId = data.opportunuityId;
    var opportunityData = state.opportunityData;
    var opporData = opportunityData.get(opporId);
    console.log("opportunity data >> arpita", opporData, opporData.opportunityId, opporData.portData);
    if (!opporData || !opporData.portData) {
        console.log("opportunity data >> No opportunity found with id", opporId, "Opportunities in store ", state.opportunityData, "opporData : ", opporData);
        return opportunityData;
    }
    var portData = null;
    portData = opporData.portData.get(data.portId);
    if (!portData) {
        console.log("No port data found with id", data.portId);
        return opportunityData;
    }

    var destinationData = null;
    var _iteratorNormalCompletion15 = true;
    var _didIteratorError15 = false;
    var _iteratorError15 = undefined;

    try {
        for (var _iterator15 = portData.destinations[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
            var destination = _step15.value;

            if (destination.laneId === data.laneId) {
                destinationData = destination;
                break;
            }
        }
    } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion15 && _iterator15.return) {
                _iterator15.return();
            }
        } finally {
            if (_didIteratorError15) {
                throw _iteratorError15;
            }
        }
    }

    console.log("OpportunityReducer :updateOpportunityDataMapWithBidDetails : Found destination as ", destinationData, portData);

    if (!destinationData) {
        console.log("OpportunityReducer : updateOpportunityDataMapWithBidDetails  : No destination data found with id", data.laneId);
        return opportunityData;
    }

    destinationData.destinationBidData = data.bidData;
    console.log("OpportunityReducer :updateOpportunityDataMapWithBidDetails opportunityData after update", opportunityData);

    return opportunityData;
};

var updateCustomerLanePriceSelected = function updateCustomerLanePriceSelected(state, payload) {
    //Set isLanePriceSelected in destinationData
    console.log("updateCustomerLanePriceSelected :: ", payload);
    var opportunityId = payload.opportunuityId;
    var portId = payload.portId;
    var laneId = payload.laneId;
    var selected = payload.selected;

    var opportunityData = state.opportunityData;

    var opporData = opportunityData.get(opportunityId);
    if (!opporData) {
        console.log("No opportunity found with id", opportunityId);
        return opportunityData;
    }

    var portData = null;
    portData = opporData.portData.get(portId);
    if (portData === null) {
        console.log("No port data found with id", portId);
        return opportunityData;
    }

    var destinationData = null;
    var _iteratorNormalCompletion16 = true;
    var _didIteratorError16 = false;
    var _iteratorError16 = undefined;

    try {
        for (var _iterator16 = portData.destinations[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
            var destination = _step16.value;

            if (destination.laneId === laneId) {
                destinationData = destination;
                break;
            }
        }
    } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion16 && _iterator16.return) {
                _iterator16.return();
            }
        } finally {
            if (_didIteratorError16) {
                throw _iteratorError16;
            }
        }
    }

    console.log("OpportunityReducer : updateOpportunityAdditionalCharges : Found destination as ", destinationData);

    if (!destinationData) {
        console.log("OpportunityReducer : updateOpportunityAdditionalCharges : No destination data found with id", laneId);
        return opportunityData;
    }
    // destinationData.isLanePriceSelected =  selected
    destinationData.isSelected = selected;

    return opportunityData;
};

var updateSalesOpportunityData = function updateSalesOpportunityData(state, data) {
    console.log("updateSalesOpportunityDataReducer: ", data);
    var oppId = data.opportunityId;
    var bidCloseDate = data.bidCloseDate;
    var opportunityExpiryDate = data.opportunityExpiryDate;
    var customerAcceptanceDeadline = data.customerAcceptanceDeadline;
    if (bidCloseDate) bidCloseDate = convertDateToEpoch(bidCloseDate);
    if (opportunityExpiryDate) opportunityExpiryDate = convertDateToEpoch(opportunityExpiryDate);
    if (customerAcceptanceDeadline) customerAcceptanceDeadline = convertDateToEpoch(customerAcceptanceDeadline);
    var opportunityData = state.opportunityData;
    var opportunity = opportunityData.get(oppId);
    if (opportunity) {
        opportunity.endDate = bidCloseDate;
        opportunity.opportunityExpiryDate = opportunityExpiryDate;
        opportunity.customerAcceptanceDeadline = customerAcceptanceDeadline;
    }
    opportunityData.set(oppId, opportunity);
    return opportunityData;
};

/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

unregister();

export { RepeatingHeaderTable, Accordian, SmallAccordian, SmartAccordian as OpportunityCreationCommon, BlockHeader, FilterDropdown, ContainerTable, ContainerModal, ContainerTrackingApp, OpportunityClosedCommon, OpportunityOpenedCommon, MarketplacePortalCommon, BidModalTopLine, BidModal, BiddingInfo, DrayageInvoices, DrayageInvoices$1 as DrayageSalesInvoices, WithForceLogout, KnLoader, getOpportunityList, getOpportunityDetailsApi, getOpportunityDetailsApiForSales, setAdditionalChargesInStore, getStandardPartnerAdditionalCharges, setLaneBidChargesInStore, submitOpportunityBidData, handleOpenBidModal, handleOpporunityOpenArrow, setLanePriceSelected, setCustomerLanePriceSelected, setPartnerIdInStore, handleSetChargeForEdit, setSalesOpportunityUpdatedData, opportunityInitialState, getOpportunityDataForTab, updateCustomerOpportunityMap, updateOpportunityAdditionalCharges, updateOpportunityDataMapWithDetails, updateOpportunityDataMapWithBidDetails, updateCustomerLanePriceSelected, updateSalesOpportunityData, SELECTED_TABS, DRAYAGE_APP, DRAYAGE_API_RESPONSE, amountToShortString, amountToCommaSeparated, amountToCommaSeparatedBidSelectionModal, amountToTwoDecimal, extractAddressToDisplay, getOpenedOpportunityStatus, setOpenedOpportunityStatus, submitCustomerBidApprovalAPI, InvoiceOpportunityView, createOppurtunity, OPPORTUNITY_BID_CLICKED, OPPORTUNITY_ARROW_CLICKED, OPPORTUNITY_UPDATE_CLICKED, ADDITONAL_CHARGE_DONE_CLICKED, ADDITONAL_CHARGE_CANCEL_CLICKED, OPPORTUNITY_BID_MODAL_BID_CLICKED, OPPORTUNITY_BID_MODAL_PORT_ADDITIONAL_CHARGE_CLICKED, OPPORTUNITY_BID_MODAL_SUBMIT_CLICKED, OPPORTUNITY_BID_MODAL_CANCEL_CLICKED, LANE_BID_DONE_CLICKED, LANE_BID_CANCEL_CLICKED, LANE_BID_ADDITIONAL_CHARGE_CLICKED, PARTNER_STANDARD_ADDITIONAL_CHARGES, API_GET_OPPORTINITY_LIST, API_GET_OPPORTINITY_DETAILS, SET_OPPORTUNITY_BID_DATA, OPPORTUNITY_DATA_UPDATED, opportunity_actions };
//# sourceMappingURL=index.es.js.map
